import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   * 
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   * The `Float` scalar type represents signed double-precision fractional.
   * In query it is displayed as a string.
   */
  CustomFloat: any;
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: any;
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: any;
  /**
   * 
   *     Errors messages and codes mapped to
   *     fields or non fields errors.
   *     Example:
   *     {
   *         field_name: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ],
   *         other_field: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ],
   *         nonFieldErrors: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ]
   *     }
   *     
   */
  ExpectedErrorType: any;
};


export type Query = {
  __typename?: 'Query';
  agreement?: Maybe<AgreementType>;
  /** ERP #110: можно ли «исправить группу» / «отменить зачисление» и что мешает (коды блокеров). */
  agreementCorrectionCheck?: Maybe<AgreementCorrectionCheckType>;
  /** Tasks tied to one agreement (договор). */
  agreementTasks: Array<StaffTaskType>;
  /** AI agents page (spec 0104): agents, month cost, cost by day. Admin only. */
  aiAgentOverview: AiAgentOverviewType;
  /** One run with its steps. */
  aiAgentRun?: Maybe<AiAgentRunType>;
  /** Agent runs, newest first (limit ≤ 200). Admin only. */
  aiAgentRuns: AiAgentRunPageType;
  /** @-suggestions for the composer: entities (rights of the task link registry), chat skills, enabled chat tools incl. mcp__*. Entities need ≥ 2 chars. Admin only. */
  aiChatMentionSearch: Array<AiChatMentionSuggestionType>;
  /** One of my threads with messages; null when it is not mine or does not exist. */
  aiChatThread?: Maybe<AiChatThreadDetailType>;
  /** My AI chat threads: pinned first, then newest. Admin only. */
  aiChatThreads: Array<AiChatThreadType>;
  /** Built-in chat tools: all ERP-MCP tools + platform tools, with the admin switch. Admin only. */
  aiChatToolCatalog: Array<AiBuiltinToolType>;
  /** The N-th lesson of every group of a course. Admin, Methodist, AccountManager, HRManager. */
  aiCourseLessonComparison: AiCourseLessonComparisonType;
  /** The finding behind an AI task (null for other tasks). */
  aiFindingForTask?: Maybe<AiFindingType>;
  /** Slack watcher findings, newest first (limit ≤ 200). Management roles. */
  aiFindings: AiFindingPageType;
  /** One candidate (null when not visible to the viewer). */
  aiKbCandidate?: Maybe<AiKbCandidateType>;
  /** Knowledge base candidates (spec 0118), newest first. Admin — all categories; a reviewer — only assigned categories; no assignment — empty. status="" — any. */
  aiKbCandidates: AiKbCandidatePageType;
  /** Active ERP staff that can be assigned as reviewers. Admin only. */
  aiKbReviewerCandidates: Array<AiKbReviewerUserType>;
  /** Is the viewer a knowledge reviewer: categories and pending count. Any ERP staff member. */
  aiKbReviewerMe: AiKbReviewerMeType;
  /** Reviewers of every category. Admin only. */
  aiKbReviewers: Array<AiKbReviewerCategoryType>;
  /** One knowledge document. Admin only. */
  aiKnowledgeDocument?: Maybe<AiKnowledgeDocumentType>;
  /** Knowledge base documents (spec 0104), category order then title. `q` — substring of title or body. Admin only. */
  aiKnowledgeDocuments: Array<AiKnowledgeDocumentType>;
  /** Body history of a knowledge document, newest first (spec 0118). Admin only. */
  aiKnowledgeRevisions: Array<AiKnowledgeRevisionType>;
  /** Search published chunks exactly as agents do (no LLM). Admin only. */
  aiKnowledgeSearch: Array<AiKnowledgeHitType>;
  /** Published documents, their tokens and the prompt strategy. Admin only. */
  aiKnowledgeStats: AiKnowledgeStatsType;
  /** Latest analysis of each lesson, newest lesson first (limit ≤ 200); reviewStatus=open is the methodist review queue. Admin, Methodist, AccountManager, HRManager. */
  aiLessonAnalyses: AiLessonAnalysisPageType;
  /** Latest AI analysis of a lesson (spec 0104). Admin, Methodist, AccountManager, HRManager. */
  aiLessonAnalysis?: Maybe<AiLessonAnalysisType>;
  /** ТЗ 0116: can a lesson analysis / teacher narrative be started right now (the agent is on: env + «Настройки → ИИ»). Lets roles that cannot read runtime settings (Methodist, AccountManager, HRManager) show the disabled state before the first click. Admin, Methodist, AccountManager, HRManager. */
  aiLessonLaunchEnabled: Scalars['Boolean'];
  /** ТЗ 0116: everything for the lesson window — video / AI summary / timecodes (Zoom roles), surveys of the lesson (survey roles), the latest analysis. Admin, Methodist, AccountManager, HRManager. */
  aiLessonView?: Maybe<AiLessonViewType>;
  /** One external MCP connection. Admin only. */
  aiMcpConnection?: Maybe<AiMcpConnectionType>;
  /** External MCP connections of the chat. Admin only. */
  aiMcpConnections: Array<AiMcpConnectionType>;
  /** Imported plugins (Claude Code layout). Admin only. */
  aiPlugins: Array<AiPluginType>;
  /** Weekly AI reply quality snapshots, newest first (spec 0118 step 2). Admin only. */
  aiReplyQuality: Array<AiReplyQualityWeekType>;
  /** Latest AI reply draft of a conversation (spec 0104), null when there is none. Communicator roles + thread visibility. */
  aiReplySuggestion?: Maybe<AiReplySuggestionType>;
  /** One skill. Admin only. */
  aiSkill?: Maybe<AiAgentSkillType>;
  /** Chat skills (SKILL.md), by name. Admin only. */
  aiSkills: Array<AiAgentSkillType>;
  /** Financial appendix of the AI portrait; null for roles without finance access (Methodist) and when the student has agreements outside the user's legal entity. */
  aiStudentFinancePortrait?: Maybe<AiStudentFinancePortraitType>;
  /** AI student portrait (spec 0104): status none when there is none yet. Admin, AccountManager, SalesManager, FinanceManager, Methodist; the student and all their agreements must be visible to the user (else `not_found`). */
  aiStudentPortrait: AiStudentPortraitType;
  /** Teacher practice portrait from lesson analyses (methodology §32); null without analyses. Admin, Methodist, AccountManager, HRManager. */
  aiTeacherPracticePortrait?: Maybe<AiTeacherPracticePortraitType>;
  allArticles?: Maybe<ArticlesConnection>;
  allCompanies?: Maybe<CompanyConnection>;
  allContributions?: Maybe<ContributionConnection>;
  allCountries?: Maybe<CountryConnection>;
  allCourseCategories?: Maybe<CategoryConnection>;
  allCourses?: Maybe<CourseFilterTypeConnection>;
  allDeferredPayments?: Maybe<DeferredPaymentConnection>;
  allGroupZoomSchedules?: Maybe<GroupZoomScheduleConnection>;
  allGroups?: Maybe<GroupConnection>;
  allGroupsForLms?: Maybe<UnionGroupConnection>;
  allLessonRecordings?: Maybe<LessonRecordingConnection>;
  allNatives?: Maybe<NativeInfoConnection>;
  allStories?: Maybe<AllStoriesConnection>;
  allStudents?: Maybe<StudentConnection>;
  allStudentsAchievement?: Maybe<StudentsAchievementConnection>;
  allSuccessStories?: Maybe<SuccessStoriesConnection>;
  allTeachers?: Maybe<TeacherFilterTypeConnection>;
  allTeachersApplications?: Maybe<ApplicationFilterTypeConnection>;
  allUsersSettings?: Maybe<UsersSettingsConnection>;
  allZoomAccounts?: Maybe<ZoomAccountConnection>;
  allZoomLessons?: Maybe<ZoomLessonConnection>;
  allZoomProcessingLog?: Maybe<ZoomProcessingLogConnection>;
  allZoomRecordings?: Maybe<ZoomRecordingConnection>;
  /** ТЗ 0117: разбор звонка Aplora вживую — только звонка этого лида. null — Aplora выключена; ошибки (код в message и extensions.code): not_found, not_analyzed, aplora_unavailable, aplora_rate_limited */
  aploraCallAnalysis?: Maybe<AploraCallAnalysisType>;
  /** ТЗ 0117: транскрипт звонка вживую (не хранится, не кешировать). Ошибки — как у aploraCallAnalysis */
  aploraCallTranscript?: Maybe<AploraTranscriptType>;
  appState: AppState;
  article?: Maybe<ArticlesType>;
  articleBySlug?: Maybe<ArticlesType>;
  /** ТЗ 0026: то же для ERP. Отдельное поле, а не общий резолвер: `permissions_checker` принимает ровно один scope. */
  attendanceHistory: Array<AttendanceChangeType>;
  authState: AuthState;
  bankAccounts?: Maybe<Array<Maybe<BankAccountType>>>;
  /** Import history, newest first. Previews included — seeing what a file WOULD do is half of what the log is for. */
  bankStatementImports?: Maybe<Array<Maybe<BankStatementImportType>>>;
  bankTransaction?: Maybe<BankTransactionType>;
  /** Documents this row might be explaining. Offered, not applied — the matcher only links when the answer is unambiguous. */
  bankTransactionMatchCandidates?: Maybe<Array<Maybe<MatchCandidateType>>>;
  bankTransactions?: Maybe<BankTransactionPage>;
  blogAllArticles?: Maybe<BlogAllArticlesType>;
  blogGraduateStory?: Maybe<BlogGraduateStoryType>;
  blogNative?: Maybe<BlogNativeType>;
  /** Live progress of a bulk broadcast the acting manager launched: running sent/failed counts + each recipient's outcome. Null if it isn't the manager's own job. */
  broadcastJob?: Maybe<BroadcastJobType>;
  /** ТЗ 0084: может ли сотрудник создавать и править шаблоны темы (Admin, SalesManager, AccountManager; invoice_payment — ещё и FinanceManager) */
  canEditMessageTemplates: Scalars['Boolean'];
  /** Spec 0039. Medal dictionary, read-only: it is edited in Django admin, but not seeing it from the ERP at all means not knowing what students are rewarded for. */
  careerAchievements: Array<AchievementErpType>;
  /** Отклики студента глазами персонала. Личная заметка студента НЕ отдаётся — только компания, позиция, статус и даты. */
  careerApplicationsErp: Array<CareerApplicationType>;
  /** City dictionary for the feed filter. */
  careerCities: Array<CareerCityType>;
  /** Spec 0039. Course list for the skills tab: how many skills each course confers and which directions it feeds. */
  careerCourseSkillSummary: Array<CourseSkillSummaryType>;
  /** Spec 0039. What a course teaches. Without `courseId` — every link, for the editor's overview. */
  careerCourseSkills: Array<CourseSkillType>;
  /** The ERP funnel: members → trained → profile → applied → placed. */
  careerDashboard: CareerDashboardType;
  careerDirections: Array<CareerDirectionType>;
  /** Direction dictionary for the feed filter. The client used to scrape these out of the feed's own rows, which meant an empty first page left it with no filter at all. */
  careerDirectionsLms: Array<CareerDirectionType>;
  /** Spec 0040 phase B. The exercise catalogue: build once, attach to lessons. Carries the edit lock and WHICH lessons already use each one. */
  careerExerciseTemplates: Array<CareerExerciseTemplateType>;
  /** Spec 0039. Field types and resume bindings for the lesson-exercise builder, with the compatibility matrix. Served so the ERP builder cannot drift from the server rules it is validated against. */
  careerExerciseVocabulary: ExerciseVocabularyType;
  /** Кого можно добавить в центр: состав группы или поиск по ФИО. У каждой строки — memberStatus, чтобы уже состоящие были видны ДО нажатия «Добавить». */
  careerGroupRoster: Array<CareerRosterRowType>;
  /** Spec 0041. What THIS group confers. Cloned from the course when the group was created; edited per group ever since, because a course changes and a running group must not change under its students. */
  careerGroupSkills: Array<GroupSkillType>;
  /** Spec 0039. Rule vocabulary for the promo-campaign form. Served so the ERP form cannot offer a rule the server does not know — the same reason the exercise vocabulary is served rather than copied into TypeScript. */
  careerGrowthRules: Array<GrowthRuleType>;
  /** Spec 0039. Career tracks with their target skills and steps, read-only. */
  careerGrowthTracks: Array<GrowthTrackErpType>;
  /** One published career lesson. Locked lessons resolve without a body — same filter as the listing, so a guessed id leaks nothing. */
  careerLesson?: Maybe<CareerLessonType>;
  /** Published career lessons with per-viewer lock state. A locked lesson carries no content/video/attachments. */
  careerLessons: Array<CareerLessonType>;
  /** All career lessons including unpublished ones. Staff author this content, so no lock gate applies. Each row carries a `stats` completion funnel (spec 0020). */
  careerLessonsErp: Array<CareerLessonType>;
  careerMemberDetail?: Maybe<CareerMemberType>;
  /** One member's learning map — opened/completed per lesson (spec 0020). Carries no private note text. */
  careerMemberProgress: Array<CareerMemberLessonProgressType>;
  /** Career-centre participants for the ERP table. */
  careerMembers: Array<CareerMemberType>;
  /** Очередь подтверждения трудоустройства: студент отметил «вышел на работу», школа ещё не записала. Очередь ВЫВОДИТСЯ предикатом, а не хранится флагом — иначе она разъедется с откатом статуса студентом. */
  careerPlacementConfirmations: Array<CareerApplicationType>;
  /** Spec 0039 UX pass. The profession guide — what each job actually does, which skills it needs (flagged against the caller's own), which of OUR courses lead there, and how many live vacancies our board holds. Open to ANY student, like myGrowth: it is a sales surface, and the student still studying is the readiest buyer. */
  careerProfessions: Array<ProfessionType>;
  /** Spec 0039 step 6. Promo campaigns with issued/redeemed counters stamped on the rows. */
  careerPromoCampaigns: Array<PromoCampaignType>;
  /** Spec 0039 step 6. Issued codes, newest first. */
  careerPromoCodes: Array<PromoCodeErpType>;
  /** Spec 0039. Post texts per channel and language, editable from the ERP without a deploy. */
  careerShareTemplates: Array<ShareTemplateType>;
  /** Spec 0040 phase C. The storefront catalogue: what the school SELLS, with the skills each page trades on. Was seed-only, so a price-list edit needed a deploy. */
  careerSiteCourses: Array<SiteCourseErpType>;
  /** Spec 0039 UX pass. One skill on its OWN page: what it is, whether the caller has it and from where, how many live vacancies our board holds, which of OUR courses teach it and which professions need it. The drawer it replaces could not be linked to, opened from elsewhere, or returned to with Back. */
  careerSkillDetail?: Maybe<SkillDetailType>;
  /** Skill dictionary for the profile editor's autocomplete. */
  careerSkills: Array<SkillType>;
  /** Skill dictionary for the ERP vacancy form and the MCP intake tool. The LMS-scoped `careerSkills` is gated on the Student role, so an ERP token cannot read it. `withStats` defaults to false so the vacancy form's multiselect stays one cheap query. */
  careerSkillsErp: Array<SkillType>;
  /** Spec 0039. Per-course verdict for the member card, with the reason — derived, diploma, or a staff decision. */
  careerStudentCompletions: Array<CourseCompletionType>;
  /** Spec 0040. Icon vocabulary for the profession form. Professions have no official logo, so the picker offers a curated set; served rather than copied into TypeScript so the form cannot offer a value upsertTrack rejects. */
  careerTrackIcons: Array<TrackIconType>;
  /** Published vacancies for a career-centre member; empty for non-members. `savedOnly` narrows the feed to what this member saved. */
  careerVacancies: Array<VacancyType>;
  /** Vacancies for the ERP board (all statuses). `applyUrl` matches on the NORMALIZED link, so utm tags and a trailing slash do not defeat it. `freshness` is 'fresh'|'expired'; archived rows are included unless `hideArchived` is set. */
  careerVacanciesErp: Array<VacancyType>;
  /** One published vacancy; same filter as the feed, so a guessed id can't reach a draft. */
  careerVacancy?: Maybe<VacancyType>;
  /** Vacancies for the ERP board, paged. `orderBy` is createdAt|publishedAt|title|status, `orderDir` asc|desc; the queue drains oldest-first. `source` is filtered SERVER-side — a client-side filter would filter within a page once paging exists, which is wrong, not merely slow. */
  careerVacancyBoard: VacancyBoardConnection;
  careerVacancyErp?: Maybe<VacancyType>;
  /** Published vacancies, ranked against the caller. `matchMode` is 'GOAL' (the chosen profession's requirements) or 'PROFILE' (what the student can do today); omitted, it is GOAL only when a profession was EXPLICITLY chosen — a default track never silently reranks the whole feed. `sort` is 'relevance' | 'newest'. `relevanceApplied` is false when there is no signal at all — the feed is then honestly date-ordered and the UI must not claim a match. `matchContext` reports what was ACTUALLY applied, which is what makes the per-vacancy `matchedSkillCount` readable: in GOAL mode it counts the profession's requirements, in PROFILE mode the student's own skills. */
  careerVacancyFeed: VacancyConnection;
  cashBalances?: Maybe<Array<Maybe<CashBalanceSnapshotType>>>;
  cashFlowCategories?: Maybe<Array<Maybe<CashFlowCategoryType>>>;
  cashFlowControl?: Maybe<CashFlowControlType>;
  /** Cash-flow statement. Built from bank transactions only — expenses and invoices enrich a row but are never summed alongside it. */
  cashFlowReport?: Maybe<CashFlowReportType>;
  cashFlowRules?: Maybe<Array<Maybe<CashFlowRuleType>>>;
  cashFlowSettings?: Maybe<CashFlowSettingsType>;
  /** The Slack channel currently linked to a group (or null). */
  channelGroupLink?: Maybe<ChannelGroupLinkType>;
  /** Состояние интеграций переписки по всем группам: что настроено, что синхронизируется и — главное — ПОЧЕМУ по группе не видно данных (поле verdict). Отвечает на вопрос «настроил не так или баг», на который раньше не отвечало ничто (ТЗ 0032). */
  communicationsHealth: CommunicationsHealth;
  company?: Maybe<CompanyType>;
  contactsPage?: Maybe<ContactsPageType>;
  contractAnalytics?: Maybe<ContractAnalyticsType>;
  /** Треды Gmail с подписантом этого договора */
  contractConversations: Array<ConversationType>;
  contractDocument?: Maybe<ContractDocumentType>;
  /** ТЗ 0106: сумма `price` по валютам при тех же фильтрах (плитки над списком и доской) */
  contractDocumentAmounts: Array<ContractAmountType>;
  /** Сколько договоров в каждом статусе при тех же фильтрах, кроме самого статуса — счётчики у чипов списка */
  contractDocumentStatusCounts: Array<ContractStatusCountType>;
  contractDocuments: Array<ContractDocumentType>;
  contractDocumentsTotal: Scalars['Int'];
  contractDraftDefaults?: Maybe<ContractDraftDefaultsType>;
  /** ТЗ 0090: заполнение формы договора студента из лида; null — лида нет (другой источник) или у сотрудника нет юрлица */
  contractDraftFromLead?: Maybe<ContractDraftFromLeadType>;
  /** Группы видимых договоров — для фильтра «Группа» списка. Выбранная (`selectedId`) — всегда в ответе, если её договоры видны */
  contractGroupOptions: Array<ContractGroupOptionType>;
  /** ТЗ 0094: письмо-приглашение так, как оно уйдёт при отправке договора сейчас; null — договор не найден или не ваш */
  contractInvitePreview?: Maybe<ContractInvitePreviewType>;
  contractMailSummaries: Array<ContractMailSummaryType>;
  contractOutreach?: Maybe<ContractOutreachType>;
  contractOutreachSummaries: Array<ContractOutreachSummaryType>;
  contractSellers: Array<ContractSellerType>;
  /** ТЗ 0083: кто отправлял видимые договоры — для фильтра «Отправил» */
  contractSenders: Array<ContractSellerType>;
  /** ТЗ 0107: тело шаблона для визуального редактора (только Admin) */
  contractTemplateEditable?: Maybe<ContractTemplateEditableType>;
  /** HTML образца на вымышленных данных (ТЗ 0078) */
  contractTemplatePreview?: Maybe<Scalars['String']>;
  /** ТЗ 0107: образец несохранённого текста (только Admin) */
  contractTemplatePreviewDraft: ContractTemplatePreviewDraftType;
  contractTemplates: Array<ContractTemplateType>;
  /** Newest-first keyset page of ONE conversation's messages (spec 0008) — the paginated replacement for the deprecated conversationMessages: the panel opens on the newest 30 and pages back to older ones via `after`. */
  conversationThread: MessageConnection;
  /** Dashboard communications browser: keyset-paginated conversations (newest activity first) filterable by group, student, date range (last activity day, both ends inclusive) and text (dialog title + student name; message bodies are deliberately NOT searched — unindexed). unhandledOnly=true (default) keeps only dialogs with an inbound message not yet ticked «обработано» — the amber-dot queue. */
  conversationsBrowser: ConversationConnection;
  course?: Maybe<CourseType>;
  courseBySlug?: Maybe<CourseType>;
  courseCatalogPage?: Maybe<CourseCatalogPageType>;
  /** Цены курса по тарифам (#132): договор на группу курса по тарифу берёт её вместо прайса группы */
  coursePlanPrices: Array<CoursePlanPriceType>;
  /** Spec 0040 revision. The course FRAME — programme title, hours, description and the marketing modules the site page is built from. ERP showed a flat lesson list and said nothing about the frame existing at all. */
  courseProgramFrame: CourseProgramFrameType;
  /** Spec 0040. The course programme's lessons in flat order, so the methodist picks «after lesson N» by NAME instead of remembering a number. */
  courseProgramLessons: Array<CourseProgramLessonType>;
  coursesGraduateFeedback?: Maybe<GraduateFeedbackConnection>;
  crmLead?: Maybe<CrmLeadType>;
  crmLeadStatuses: CrmLeadStatusListType;
  /** Лиды воронки New Leads, свежие изменённые сверху */
  crmLeads: CrmLeadPageType;
  dataProcessingPolicyPage?: Maybe<DataProcessingPolicyType>;
  /** Debtors by the CONTRIBUTION plan: an instalment overdue by more than settings.DEBTOR_OVERDUE_DAYS and not covered, excluding terminated / transferred-out / free / fully-corrected agreements. Optionally scoped to one group. Since ТЗ 0074 it does NOT decide LMS suspension (that is the invoice rule — see lmsSuspensions). Порядок — по `overdueAmount` (сумма всех валют без пересчёта, по убыванию): это не сравнение денег между валютами; суммы для показа — `overdueAmounts`. */
  debtorCandidates: Array<DebtorCandidateType>;
  demoGroupsCount?: Maybe<DemoType>;
  /** Short-lived presigned GET for one diploma. ERP staff only; the student's own path is `myDiplomaDownloadUrl`. */
  diplomaDownloadUrl?: Maybe<DiplomaDownloadUrlType>;
  /** Where this document's money is in the bank. «Не найдено» is a legitimate answer, not an error — most card payments have no document to pair with. */
  documentCashFlow?: Maybe<DocumentCashFlowType>;
  /** ТЗ 0112: поля, которые можно вставить в документ вида */
  documentPalette: Array<ContractTemplateVariableType>;
  /** ТЗ 0112 §4: черновик письма с документом (кому, тема, текст по-польски) — ничего не отправляет */
  documentSendDefaults: DocumentSendDefaultsType;
  /** ТЗ 0112: шаблон документа с историей версий */
  documentTemplate?: Maybe<DocumentTemplateType>;
  /** ТЗ 0112: тело шаблона для редактора (только Admin) */
  documentTemplateEditable?: Maybe<DocumentTemplateEditableType>;
  /** ТЗ 0112: образец несохранённого текста на вымышленных данных (только Admin) */
  documentTemplatePreviewDraft: DocumentPreviewDraftType;
  /** ТЗ 0112: шаблоны документов (общие + юрлица сотрудника) */
  documentTemplates: Array<DocumentTemplateType>;
  esignSettings: EsignSettingsType;
  /** ТЗ 0116: estimate before requestAiLessonAnalyses (≤ 20 lessons): transcripts, already analyzed, approximate cost by S3 sizes, budget. Read-only. Invisible lessons are not counted. Admin, Methodist, AccountManager, HRManager. */
  estimateAiLessonAnalyses: AiLessonEstimateType;
  exchangeRates?: Maybe<Array<Maybe<ExchangeRateType>>>;
  expense?: Maybe<ExpenseType>;
  expenseAggregates?: Maybe<Array<Maybe<ExpenseAggregateRow>>>;
  expenseCategories?: Maybe<Array<Maybe<ExpenseCategoryType>>>;
  expenses?: Maybe<Array<Maybe<ExpenseType>>>;
  /** Progress of a group billing run. Scoped by role, NOT by creator (unlike broadcastJob): the rows carry invoice data every FAKTUROWNIA_ACCESS_ROLES holder can already read via fakturowniaInvoices, and finance genuinely needs to see a colleague's run. */
  fakturowniaBillingJob?: Maybe<FakturowniaBillingJobType>;
  /** Preflight for «Выставить фактуру» — same check the mutation runs, so the UI can grey out the button and say why, and preview exactly what will be sent. */
  fakturowniaContributionBillability: FakturowniaBillabilityType;
  /** Per-agreement preflight for the whole group — the bulk-issue picker. Non-billable rows are RETURNED, not filtered out: «пропущено» has to be visible or the operator believes the whole group was billed. */
  fakturowniaGroupBillingPreview: FakturowniaGroupBillingPreviewType;
  fakturowniaInvoice?: Maybe<FakturowniaInvoiceType>;
  /** Aggregated sums for KPI / charts. Amounts are in each invoice's OWN currency — no FX conversion, so currencies must not be mixed: use `groupBy: currency` or the `currency` filter (without them a bucket sums EUR and PLN together). Quotation-kinds are excluded by default so estimate+advance+final chains aren't double-counted. */
  fakturowniaInvoiceAggregates?: Maybe<Array<Maybe<FakturowniaInvoiceAggregateRow>>>;
  fakturowniaInvoices?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  fakturowniaSyncRuns?: Maybe<Array<Maybe<FakturowniaSyncRunType>>>;
  /** One-shot 'is the mirror fresh?' snapshot for dashboard widgets. Combines the most recent run with the most recent successful run so the UI can show both 'last synced HH:MM' and 'sync failed'. */
  fakturowniaSyncStatus?: Maybe<FakturowniaSyncStatus>;
  fakturowniaUnmatchedCount?: Maybe<Scalars['Int']>;
  financeBudget?: Maybe<Array<Maybe<MonthBudget>>>;
  financeMonthBudget?: Maybe<WeeksBudgetInfo>;
  financePlan?: Maybe<Array<Maybe<MonthBudget>>>;
  financeYears?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Счётчики по колонкам воронки плюс обе очереди разбора. Принимает те же фильтры, что и `fundingCandidates`, КРОМЕ `status`/`statusGroup`: сегмент не считает сам себя, иначе выбор одной группы обнулил бы остальные. */
  fundingBoard: FundingBoardType;
  fundingCandidate?: Maybe<FundingCandidateType>;
  /** Панель дофинансирования на карточке студента. Нужен один из userId / studentId. */
  fundingCandidateForUser?: Maybe<FundingCandidateType>;
  fundingCandidateSms?: Maybe<LeadSmsStateType>;
  /** Срез воронки. Измерения: funnel, operator, geo, outcome_month. Неизвестное — ошибка, а не тихий откат. */
  fundingCandidateStats: FundingStatsType;
  /** Не больше 200 строк за раз — общее число спрашивайте у `fundingCandidatesTotal` с теми же фильтрами. */
  fundingCandidates: Array<FundingCandidateType>;
  /** Все заявки этого человека, если их несколько. */
  fundingCandidatesForUser: Array<FundingCandidateType>;
  fundingCandidatesTotal: Scalars['Int'];
  /** Одна заявка — для окна ручного разбора. Отдельный запрос, потому что окну нужны ТЯЖЁЛЫЕ поля (ответы формы, происхождение оператора), а списку из пятидесяти строк они стоили бы подзапроса на строку. */
  fundingFormSubmission?: Maybe<FormSubmissionType>;
  /** Заявки с публичной формы; `state` = failed|pending|needs_operator|linked|rejected. `needs_operator` — разобрана, но оператор не назначен: это работа, и она не должна теряться среди готовых. Отклонённые как автоматические в остальные состояния НЕ попадают. */
  fundingFormSubmissions: Array<FormSubmissionType>;
  /** Сколько всего заявок под тем же фильтром. Экран писал длину страницы, а форма набирает заявки бесконечно. */
  fundingFormSubmissionsTotal: Scalars['Int'];
  /** Адрес публичной формы заявки — тот, что менеджер даёт человеку, и тот же, что робот подставляет в письмо. Отдаётся с сервера, а не зашит во фронт, чтобы адрес имел ровно одно определение: до ТЗ 0061 он не существовал в коде вовсе и жил вшитой строкой внутри текстов шаблонов SendGrid. */
  fundingFormUrl: Scalars['String'];
  /** Очередь разбора: строки покрытия, которые импорт не смог сопоставить со справочником. */
  fundingGeoAliases: Array<GeoAliasType>;
  /** Один прогон — для карточки. Отдельное поле, а не поиск по загруженной странице: иначе ссылка на прогон, вытесненный из окна списка, открывала бы пустоту. */
  fundingImportRun?: Maybe<ImportRunType>;
  fundingImportRuns: Array<ImportRunType>;
  /** Сколько прогонов всего под теми же фильтрами. Без счётчика экран печатал длину страницы и читался как «прогонов всего 25» — а пачка ручных прогонов выдавила бы из этого окна всю ночную серию. */
  fundingImportRunsTotal: Scalars['Int'];
  /** Одно окно набора. Карточки набора не было вовсе: окно жило строкой в таблице и строкой внутри карточки оператора, а рассылка — третьим местом. */
  fundingIntake?: Maybe<FundingIntakeType>;
  /**
   * Окна набора по всем операторам с фильтрами.
   * 
   * 🔴 Заменило `fundingUpcomingIntakes`, которое было не списком, а ОДНИМ срезом: живые окна в пределах горизонта. Из 123 окон в базе там было видно 18, а 105 не показывались никогда — ни при каком горизонте.
   */
  fundingIntakes: Array<FundingIntakeType>;
  /** Сколько всего окон под теми же фильтрами. */
  fundingIntakesTotal: Scalars['Int'];
  /** ТЗ 0085: письма о наборе на ближайшие дни (по умолчанию 14, не больше 60) — та же выборка, что у задач рассылки. */
  fundingMailCalendar: Array<FundingMailCalendarEntryType>;
  /** ТЗ 0085: правила писем — знакомство, «за N дней», «набор идёт». */
  fundingMailRules: Array<FundingMailRuleType>;
  /** ТЗ 0085: шаблоны SendGrid для выбора в правиле. */
  fundingMailSendgridTemplates: FundingMailSendgridTemplatesType;
  /** ТЗ 0085: общие настройки писем робота. */
  fundingMailSettings: FundingMailSettingsType;
  /** ТЗ 0085: переменные шаблона SendGrid против тех, что передаёт робот. */
  fundingMailTemplateCheck: FundingMailTemplateCheckType;
  /** ТЗ 0085: переменные, которые робот передаёт в шаблон. */
  fundingMailVariables: Array<FundingMailVariableType>;
  /** Журнал писем домена. Без `candidateId` — общий список. */
  fundingNotifications: Array<FundingNotificationType>;
  fundingNotificationsTotal: Scalars['Int'];
  /**
   * ТЗ 0087: синхронизация из Notion на время перехода — можно ли идти в Notion, идёт ли прогон и чем кончился последний. ⚠️ Снята 07.10.2026: `runFundingTask(task: "notion")` отвечает «Неизвестная задача».
   * @deprecated Синхронизация из Notion снята 07.10.2026 (решение владельца): запуска нет, `autoEnabled` всегда false. Поле оставлено, чтобы контракт только расширялся; ERP его больше не читает.
   */
  fundingNotionSync: NotionSyncStatusType;
  fundingOperator?: Maybe<FundingOperatorType>;
  /** Реестр операторов BUR и KFS в одной таблице. `powiatId` учитывает и общепольских операторов. Не больше 200 строк за раз — общее число спрашивайте у `fundingOperatorsTotal` с теми же фильтрами. */
  fundingOperators: Array<FundingOperatorType>;
  /** Сколько всего операторов под теми же фильтрами. Без него экран показывал длину страницы и врал: «Операторы 50» при 124 в базе. */
  fundingOperatorsTotal: Scalars['Int'];
  /** Договоры кандидата или студента для лога участия (ТЗ 0092). */
  fundingParticipationAgreements: Array<ParticipationAgreementType>;
  /** Файл лога участия студента (XLSX или PDF), base64. */
  fundingParticipationReport?: Maybe<ParticipationFileType>;
  /** Сводка участия по договору: занятия окна, заходы Zoom, итог. */
  fundingParticipationSummary?: Maybe<ParticipationSummaryType>;
  fundingPowiats: Array<PowiatType>;
  /** Сколько заявок в каждом состоянии — плитки над списком. Считается ТЕМ ЖЕ фильтром и под теми же остальными условиями, что и сам список: плитка это кнопка, и она обязана приводить ровно к обещанному числу. */
  fundingSubmissionStates: Array<SubmissionStateCountType>;
  /** По строке на задачу робота: когда ходила последний раз и ходит ли по расписанию. Считается ОТДЕЛЬНО от списка прогонов — десяток ручных запусков одной задачи вытеснил бы остальные из окна, и сводка соврала бы. */
  fundingTaskSummary: Array<TaskSummaryType>;
  fundingVoivodeships: Array<VoivodeshipType>;
  /** Что мешает роботу следить: по строке на причину. Живёт ЗДЕСЬ, а не в реестре операторов — поломки убраны с глаз менеджера (ТЗ 0054), но не из системы: без этой сводки оператор без адреса выглядит ровно как спокойный. */
  fundingWatchHealth: Array<WatchHealthType>;
  /** Сколько РАЗНЫХ операторов, у которых слежение не работает. Отдельным числом, потому что строки `fundingWatchHealth` складывать нельзя: причины пересекаются, а имена в них обрезаны потолком. */
  fundingWatchOperatorsBroken: Scalars['Int'];
  gatewaySettlement?: Maybe<GatewaySettlementType>;
  /** Invoices that could be inside this batch, with a greedy pre-selection that lands in the fee band. */
  gatewaySettlementCandidates?: Maybe<Array<Maybe<GatewaySettlementCandidateType>>>;
  gatewaySettlements?: Maybe<Array<Maybe<GatewaySettlementType>>>;
  /** Mailboxes this user may send FROM when composing a new email: shared ones plus their own personal mailbox (Admin — all), own first. Enabled only. */
  gmailMailboxes: Array<GmailMailboxType>;
  group?: Maybe<GroupType>;
  /** Group dashboard — passed/expected lessons rollup plus per-student attendance rate, with a settings-driven threshold flag for the «attention» badge. Replaces the per-lesson fan-out the frontend used to do. See docs/groups/group_dashboard.md §G3. */
  groupAttendanceSummary?: Maybe<GroupAttendanceSummary>;
  /** The communicator middle-column badge aggregate for one group: per-student unread/unhandled splits + the whole-group Slack/mail totals, computed server-side in two set-based queries (spec 0008). Replaces the frontend's multi-page conversationsBrowser drain. */
  groupCommsIndex: GroupCommsIndex;
  /** @deprecated Unbounded (loads every conversation ever). Use groupConversationsPage — the keyset-paginated replacement (spec 0031). */
  groupConversations: Array<ConversationType>;
  /** Conversations whose `group` FK is this group (its Slack channels) — the keyset page replacing groupConversations. NOT the whole communicator population: students' DMs and mail live under conversationsBrowser(groupId:). */
  groupConversationsPage: ConversationConnection;
  /** Diploma roster of the group — one row per student with an ACTIVE agreement, carrying their PL/EN diplomas. Students on a terminated agreement are excluded. */
  groupDiplomas: Array<GroupDiplomaRowType>;
  groupForLms?: Maybe<UnionGroupType>;
  /** ТЗ 0026: матрица «студент × занятие» для журнала ERP — оценка за ДЗ и факт сдачи. Один батч на всю группу. */
  groupHomeworkMarksForErp: Array<StudentLessonHwMarkType>;
  groupHomeworkOverviewForErp: Array<LessonHomeworkStatsType>;
  groupLessonAttachment?: Maybe<LessonAttachmentsType>;
  groupLessonAttachmentForLms?: Maybe<Array<Maybe<LessonAttachmentsForLmsType>>>;
  groupLessonAttendanceForLms?: Maybe<Array<Maybe<LessonAttendancesType>>>;
  /** Recipient picker rows for a group: one per student, with their latest unpaid invoice when there is one. */
  groupMailCandidates: Array<GroupMailCandidateType>;
  /** Newest-first keyset feed of all of a group's Slack messages (every channel + its students' DMs), with search / unread / flagged / unhandled / per-channel filters. */
  groupMessages: MessageConnection;
  groupNotes: Array<StudentNoteType>;
  /** XLSX группы: сводка + лист на каждого дофинансированного студента. */
  groupParticipationReport?: Maybe<ParticipationFileType>;
  /** Per-group marks rollup: weighted average + top/bottom 3 by avg mark. Terminated agreements are excluded. See docs/groups/group_dashboard.md §G4. */
  groupPerformanceSummary?: Maybe<GroupPerformanceSummary>;
  /** Spec 0041. This group's own lessons in flat order, with the date and whether they are already over — the picker for «the skill appears here». */
  groupProgramLessons: Array<GroupProgramLessonType>;
  /** Per-currency revenue rollup over the group's active agreements (budget / paid / debt / agreementsActive / studentsWithDebt). Mirrors KpiStrip.tsx so the frontend can drop the heavy `agreements[].payments[]` payload for big groups. See §G5. */
  groupRevenueAggregates?: Maybe<GroupRevenueAggregates>;
  /** Every Slack channel configured for a group (ChannelGroupLink, discovered via conversations.list), merged with its Conversation mirror — so channels with no ingested messages yet still appear in the inbox. */
  groupSlackChannels: Array<GroupChannelRow>;
  groupSurveyAssignments: Array<SurveyAssignmentType>;
  groupTasks: Array<StaffTaskType>;
  /** ТЗ 0114: the group's teacher applications with their finance terms (rate, unit, net/gross, billing entity, `termsMissing`) for the group card «Финансы». TEACHER_TERMS_ROLES. */
  groupTeacherApplications: Array<ApplicationType>;
  groupWhiteboards: Array<WhiteboardMetaType>;
  /**
   * Account-manager command-center rollup: one row per enrolled group with students count, contribution-based debt (NOT Fakturownia), debtors count, unanswered Slack/email and open/overdue task counts.
   * 
   * `activeWithinDays` (spec 0031) keeps only groups whose LAST lesson is within that many days, plus groups with no lessons yet (a brand-new group must not be invisible until its first lesson happens). Omit it for every group — the command-center KPI totals and the MCP tool depend on the unfiltered set, so it must stay opt-in.
   */
  groupsOverview: Array<GroupOverviewRow>;
  /** Whether the AI review pipeline is switched on (HOMEWORK_AI_ENABLED). The teacher UI hides the AI card and the re-run control when this is false — without it the control is always rendered and always fails with AI_DISABLED. */
  homeworkAiEnabled: Scalars['Boolean'];
  /** One row per eligible student: submission + journal hw_mark. LMS scope: the lesson's teacher or a methodist (read-only). */
  homeworkRoster: Array<HomeworkRosterRowType>;
  /** Short-lived presigned GET for a submission's ZIP. Students get their own file only; teachers — their lessons'; methodists — read-only access. */
  homeworkSubmissionDownloadUrl?: Maybe<Scalars['String']>;
  homeworkSubmissionDownloadUrlForErp?: Maybe<Scalars['String']>;
  /** Synced Zoom recordings offered as a hiring interview. Deliberately does NOT expose `files` — those entries carry raw Zoom download URLs. */
  interviewZoomCandidates: Array<InterviewZoomCandidateType>;
  /** ZOOM_INTERVIEW_ACCOUNT_EMAIL resolved to an account id, or null. A DEFAULT filter for the picker, never a restriction. */
  interviewZoomDefaultAccountId?: Maybe<Scalars['ID']>;
  /** ТЗ 0112: PDF выданного документа (base64, как отчёт участия 0092) — собирается из HTML на момент выпуска */
  issuedDocumentFile?: Maybe<DocumentFileType>;
  /** ТЗ 0112: журнал выпуска по студенту или группе */
  issuedDocuments: Array<IssuedDocumentType>;
  journal?: Maybe<GroupLessonConnection>;
  kommoLead?: Maybe<KommoLeadType>;
  /** Треды Gmail с лидом (этап 3) */
  kommoLeadConversations: Array<ConversationType>;
  kommoLeadEvents: Array<LeadEventType>;
  /** ТЗ 0086: значения фильтров со счётчиками — по всему зеркалу источника, а не по отфильтрованной ленте */
  kommoLeadFacets: KommoLeadFacetsType;
  kommoLeadLadders: Array<LeadLadderRunType>;
  kommoLeadNotes: KommoNotesType;
  /** ТЗ 0106: активные пользователи Kommo — кого можно назначить ответственным */
  kommoLeadResponsibles: Array<KommoResponsibleOptionType>;
  kommoLeadSms?: Maybe<LeadSmsStateType>;
  /** ТЗ 0106: лидов и сумма бюджетов на каждом этапе при тех же фильтрах, что kommoLeads (кроме этапа); все этапы источника, пустые — с нулями. Закрытые 142/143 — только с includeClosed */
  kommoLeadStageCounts: Array<KommoLeadStageCountType>;
  kommoLeadStages: Array<KommoStageType>;
  kommoLeads: KommoLeadPageType;
  /** ТЗ 0106: причины отказа Kommo (для закрытия в 143), кеш на час */
  kommoLossReasons: KommoLossReasonsType;
  kommoSyncStatus: KommoSyncStatusType;
  kommoUsers: Array<KommoUserType>;
  /** ТЗ 0106: путь лида с именем — визиты, страницы, формы, Kommo (создание, этапы, другие воронки, события карточки), договоры, продажа, оплаты — по точному времени. kommoLeadId — id лида в ERP; null — нет лида текущего источника */
  leadJourney?: Maybe<LeadJourney>;
  /** ТЗ 0120: свои сохранённые виды экрана и общие */
  leadSavedViews: Array<LeadSavedViewType>;
  legalEntityPublicOfferPage?: Maybe<LegalEntityPublicOfferPageType>;
  lessonForLms?: Maybe<UnionLessonType>;
  /** The lesson's homework assignment (staff view). LMS scope: the lesson's teacher or a methodist. */
  lessonHomework?: Maybe<HomeworkAssignmentType>;
  lessonHomeworkSubmissionsForErp: Array<HomeworkRosterRowType>;
  /** ERP «Кто заходил»: клики «Присоединиться к занятию» по занятию (spec 0013). */
  lessonJoinClicks?: Maybe<Array<Maybe<LessonJoinClickType>>>;
  /** ТЗ 0026: файлы учебника занятия — то, что студент видит во вкладке «Материалы». Отдельное корневое поле, а не поле на типе задания: `lessonHomework` возвращает null, когда задания нет, а именно в этом случае учебник и нужен обеим сторонам. Ссылок не отдаёт — только id, по которому клиент открывает штатный просмотрщик. */
  lessonTextbookFiles: Array<LessonTextbookFileType>;
  lessonWhiteboard?: Maybe<WhiteboardType>;
  lessonWhiteboardForErp?: Maybe<WhiteboardType>;
  /** ТЗ 0084: адреса ссылок (анкета, LMS, сократитель, Documenso) */
  linkAddresses: LinkAddressesType;
  /** ТЗ 0026: история правок одной отметки — преподавателю своего занятия. Отвечает на «кто снял галочку»: до 0026 ответа не существовало вовсе. */
  lmsAttendanceHistory: Array<AttendanceChangeType>;
  /** ТЗ 0074: the suspension robot's most recent run. */
  lmsBlockRobotLastRun?: Maybe<LmsBlockRunType>;
  /** ТЗ 0074: SendGrid dynamic templates for the settings picker; SendGrid errors as customErrors. */
  lmsBlockSendgridTemplates: LmsBlockSendgridTemplatesType;
  /** ТЗ 0074: LMS suspension settings (robot, threshold, email / Slack, SendGrid templates). */
  lmsBlockSettings: LmsBlockSettingsType;
  /** ТЗ 0074: example dynamic_template_data for kind suspended | restored — the SendGrid «test data». */
  lmsBlockTemplateExample: Scalars['JSONString'];
  /** ТЗ 0074: variables sent to the SendGrid templates (dynamic_template_data), described in Polish and Russian. */
  lmsBlockTemplateVariables: Array<LmsBlockTemplateVariableType>;
  lmsJournal?: Maybe<GroupLessonType>;
  /** Подсказки журнала преподавателя: первый клик каждого студента по занятию (spec 0013). */
  lmsLessonJoinClicks?: Maybe<Array<Maybe<LmsLessonJoinClickType>>>;
  /** ТЗ 0074 «Wstrzymany dostęp»: status = active | history | skipped; search by first/last name or email; offset/limit (≤200) pagination. */
  lmsSuspensions: LmsSuspensionPageType;
  /** One mailing run — poll this for live send progress and per-recipient delivery status. */
  mailJob?: Maybe<MailJobType>;
  /** Mailing history for a group, newest first. */
  mailJobs: Array<MailJobType>;
  mainPageInfo?: Maybe<MainPageInfoType>;
  mainTeachersWeb?: Maybe<MainTeacherWebType>;
  /** «Сегодня»: открытые сигналы и гипотезы бюджета, по важности, виду и оценке в PLN */
  marketingActions: Array<MarketingActionItem>;
  marketingAiReferrals: Array<MarketingAiReferralRow>;
  marketingBreakdown: MarketingBreakdown;
  /** Кампании площадки для «Сопоставить с кампанией»: имя содержит search, первые 50 по расходу за 30 дней */
  marketingCampaignOptions: Array<MarketingOption>;
  marketingChannelOverlap: Array<MarketingOverlapCell>;
  marketingCohorts: Array<MarketingCohortRow>;
  /** Отправленные договоры окна: эпизоды по дню отправки, исходы, время до подписи, ждущие, виды, покрытие атрибуции. Модель атрибуции — всегда последнее касание */
  marketingContracts: MarketingContractsReport;
  marketingCreatives: MarketingCreativesPage;
  marketingDataQuality: MarketingDataQuality;
  marketingDemand: Array<MarketingDemandRow>;
  marketingDigests: Array<MarketingDigestType>;
  marketingEmail: MarketingEmailReport;
  marketingForecast: Array<MarketingForecastRow>;
  marketingJourney: MarketingJourney;
  marketingLandings: Array<MarketingLandingRow>;
  marketingLeadDynamics: MarketingLeadDynamics;
  /** ТЗ 0106: лиды окна с именем (вход в New leads окна под фильтром и ключами строки), этапом, ответственным, договором и продажей; свежие первыми. Admin, Marketing, SalesManager, AccountManager */
  marketingLeads: MarketingLeadsPage;
  /** Матрица двух разных измерений: строки CHANNEL | FAMILY | OFFER | CAMPAIGN | AD, столбцы CHANNEL | FAMILY | OFFER; только непустые ячейки. При participation — «участие», ячейки в итог не складываются */
  marketingMatrix: Array<MarketingMatrixCell>;
  marketingOfflineConversions?: Maybe<MarketingOfflineConversionsType>;
  marketingOverview: MarketingOverview;
  /** Карточка страницы: ряд со сравнением, откуда входят, следующие страницы, запросы GSC */
  marketingPage: MarketingPageCard;
  /** Страницы сайта: GA4, GSC, свой счётчик, CRM-лиды (посадочная / форма / видели до заявки), продажи и конверсии. Каналы фильтра сужают свой счётчик и лиды (GA4 и GSC — null); кампании, офферы и модель на страницы не действуют */
  marketingPages: MarketingPagesPage;
  marketingPathCohorts: Array<MarketingPathCohortRow>;
  marketingSale?: Maybe<MarketingSaleRow>;
  /** Продажи окна. Канал — по модели атрибуции; adIds и adsetIds — как KPI: по касанию модели атрибуции (last — последнему, first — первому, linear — любому, participation — последнему касанию канала), оба на одном касании; группа ассетов PMax — касание с её кампанией */
  marketingSales: MarketingSalesPage;
  marketingSearch: MarketingSearchReport;
  marketingSearchTerms: MarketingSearchTermsPage;
  marketingSeoAi: MarketingSeoAiReport;
  marketingSeoAiAnswers: Array<MarketingSeoAiAnswer>;
  marketingSeoBacklinks: MarketingSeoBacklinks;
  marketingSeoBudget: MarketingSeoBudget;
  marketingSeoCompetitors: MarketingSeoCompetitors;
  marketingSeoFunnel: Array<MarketingSeoFunnelRow>;
  marketingSeoGaps: MarketingSeoGapsPage;
  marketingSeoKeyword: MarketingSeoKeywordCard;
  marketingSeoKeywords: MarketingSeoKeywordsPage;
  marketingSeoOpportunities: Array<MarketingSeoOpportunity>;
  marketingSeoOverview: MarketingSeoOverview;
  marketingSeoSeries: Array<MarketingSeoPoint>;
  /** Недельные снимки выдачи (выбор snap / csnap) */
  marketingSeoWeeks: Array<MarketingSeoWeek>;
  marketingSeries: Array<MarketingSeriesPoint>;
  marketingSignals: Array<MarketingSignalType>;
  marketingSnapshots: Array<MarketingSnapshotType>;
  marketingSources: Array<MarketingSourceStatus>;
  marketingTargets: Array<MarketingTargetType>;
  marketingTaxonomy: MarketingTaxonomy;
  marketingTraffic: Array<MarketingTrafficRow>;
  /** Таймлайн анонимного посетителя: визиты → страницы → лид → договор → подпись; id — из marketingVisitors (16 знаков, не порядковый), кривой — ошибка bad_filter, неизвестный — null */
  marketingVisitor?: Maybe<MarketingVisitorTimeline>;
  /** Визиты, дни и страницы до заявки, первый канал × канал заявки, типичные пути; лиды окна без повторов, каналы и семейства — лида */
  marketingVisitorJourney: MarketingVisitorJourney;
  /** Анонимные примеры путей посетителей */
  marketingVisitors: MarketingVisitorsPage;
  /** Group-scoped study materials list. STUDENT scope callers see only materials in groups where they have an active agreement. */
  materials: Array<Maybe<MaterialType>>;
  me?: Maybe<UserNode>;
  /** Картинки `cid:` письма (то же, что `Message.inlineImages`) — отдельным запросом, без кеша Apollo: адреса живут час. Письма нет или тред скрыт — пусто. */
  messageInlineImages: Array<MessageInlineImageType>;
  messageTemplateVariables: Array<TemplateVariableType>;
  messageTemplates: Array<MessageTemplateType>;
  metaContributions?: Maybe<MetaContribution>;
  metaCourses?: Maybe<MetaCourses>;
  metaDeferredPayments?: Maybe<MetaDeferredPaymentConnection>;
  metaGroups?: Maybe<MetaGroups>;
  metaStudents?: Maybe<MetaStudents>;
  metaTeachers?: Maybe<MetaTeachers>;
  metaTeachersApplications?: Maybe<MetaTeacherApplications>;
  metaUsersSettings?: Maybe<MetaUsersSettings>;
  /** The signed-in student's OWN attendance for one group, lesson by lesson. The teacher has always recorded this (and even sees Zoom join-time chips), but none of it reached the student — they could not answer «сколько я пропустил». Self-scoped: there is no student argument, the row set is derived from the token. */
  myAttendance: Array<MyLessonAttendanceType>;
  /** Собственный журнал поиска работы. Пусто у не-участника и у методиста-смотрящего: это личные данные. */
  myCareerApplications: Array<CareerApplicationType>;
  /** The logged-in student's career-centre membership and training progress; null if not enrolled. LMS scope + Student role only. */
  myCareerCenter?: Maybe<CareerCenterType>;
  /** Дорожная карта: цель, шесть этапов со счётчиками, ОДНО следующее действие, до трёх задач недели, готовность и список закрытых возможностей с кодом причины. Открыто ЛЮБОМУ студенту, не только участнику центра: экран витринный, а закрытое приходит помеченным, а не четырёхсотчетвёртым. */
  myCareerJourney?: Maybe<CareerJourneyType>;
  /** The logged-in student's own structured career profile (created on first read). Any Student, self only. */
  myCareerProfile?: Maybe<CareerProfileType>;
  /** Spec 0070. A profession as a MAP: clusters, skill nodes with a server-computed status, and the dependency edges between them. Without `trackCode` — the caller's goal. `null` means the system has no active professions at all — a profession without data still answers, with `isFallback` set, because an unexplained empty canvas reads as a breakage. */
  myCareerSkillGraph?: Maybe<CareerSkillGraphType>;
  /** Счётчики меню ERP (ТЗ 0096): непрочитанные письма и Slack, диалоги «ждёт ответа» по группам рейки Коммуникатора по умолчанию (activeWithinDays = 30) и просроченные задачи текущего пользователя. */
  myCommsCounters: MyCommsCountersType;
  /** Short-lived presigned GET for one of the student's OWN diplomas. Minted per click, never listed. */
  myDiplomaDownloadUrl?: Maybe<DiplomaDownloadUrlType>;
  /** The logged-in student's own diplomas, newest first. LMS scope + Student role only; takes no arguments. */
  myDiplomas: Array<MyDiplomaType>;
  /** #58 «Napisz do prowadzącego»: преподаватели группы со связкой в Slack-workspace ЭТОЙ группы. Только LMS-токен с активной ролью Student — иначе (ERP-токен, Teacher, Methodist, аноним) ошибка доступа. Пусто — у студента нет действующего (не расторгнутого) договора в этой группе, у группы нет включённого workspace или в нём нет связанных преподавателей. Только Slack, без почты. */
  myGroupTeacherContacts: Array<GroupTeacherContactType>;
  /** Spec 0039. XP, medals and career tracks. 🔴 Open to ANY student, not only career-centre members: it is a sales surface, and the student still studying is the readiest buyer. Medals unreachable outside the centre come back `locked`, never hidden. */
  myGrowth?: Maybe<GrowthOverviewType>;
  /** The logged-in student's own issued Fakturownia invoices (paid + unpaid), in due-date order. LMS scope + Student role only. */
  myInvoices?: Maybe<Array<Maybe<StudentInvoiceType>>>;
  /** The lesson's homework assignment with the logged-in student's own submission and (once graded) mark + teacher comment. Null when the lesson has no assignment yet. LMS scope + Student role only. */
  myLessonHomework?: Maybe<HomeworkAssignmentForStudentType>;
  /** ТЗ 0097: подписи писем текущего сотрудника. */
  myMailSignatures: Array<MailSignatureType>;
  /** MCP-доступ текущего пользователя: включён ли, куда подключаться и какие клиенты подключены сейчас. */
  myMcpAccess: McpAccessType;
  /** Spec 0039 step 6. The caller's own promo codes. Revoked and expired ones are not shown: a code that will be refused at the till is worse than no code. */
  myPromoCodes: Array<PromoCodeType>;
  /** Spec 0039 step 7. Ready-made post text and the share window URL per channel. Instagram comes back with a null shareUrl on purpose: it has no web share endpoint. */
  myShareOptions: Array<ShareOptionType>;
  /** Spec 0039 step 5. What the student has, what the chosen track still needs, and WHICH COURSE teaches it. Demand numbers come from the nightly snapshot and describe OUR board, not the labour market — the UI must say so. */
  mySkillMap?: Maybe<SkillMapType>;
  /** Whether the ACTING manager has saved his personal Slack user token (xoxp) for this group's workspace. The token itself is never returned. */
  mySlackUserToken: SlackUserTokenStatusType;
  /** Surveys this student already answered, with their own answers (spec 0027). Their own data, so returning the answers is safe — but the student is derived from the token and there is deliberately NO studentId argument. */
  mySubmittedSurveys: Array<SubmittedSurveyType>;
  /** The logged-in student's pending (unanswered, open) surveys, questions included. LMS scope + Student role only. */
  mySurveys: Array<PendingSurveyType>;
  /** Tasks assigned to the current user. */
  myTasks: Array<StaffTaskType>;
  /** The logged-in TEACHER's own survey feedback — aggregate only, course-level, k-anonymous, never comment text. Returns null unless SURVEY_TEACHER_SELF_VIEW_ENABLED. */
  myTeachingFeedback?: Maybe<MyTeachingFeedbackType>;
  native?: Maybe<NativeInfoType>;
  nativeBySlug?: Maybe<NativeInfoType>;
  /** Подбор оператора: жёсткие фильтры — география и форма занятости, остальное только оценивает шансы. */
  operatorsForCandidate: Array<FundingOperatorType>;
  pandadocAnalytics?: Maybe<PandaDocAnalyticsType>;
  pandadocDocuments?: Maybe<PandaDocDocumentConnection>;
  pandadocProvisioningFolders?: Maybe<Array<Maybe<ProvisioningFolder>>>;
  pandadocSyncStatus?: Maybe<PandaDocSyncStatusType>;
  paymentCalendar?: Maybe<PaymentCalendarType>;
  paymentCalendarSettings?: Maybe<PaymentCalendarSettingsType>;
  paymentPlans: Array<PaymentPlanType>;
  paymentRulesPage?: Maybe<PaymentRulesPageType>;
  paymentsVerification?: Maybe<Array<Maybe<PaymentsVerificationType>>>;
  plannedPayments?: Maybe<Array<Maybe<PlannedPaymentType>>>;
  /** Готовый файл выгрузки P&L в base64. */
  pnlExportFile?: Maybe<PnlExportFileType>;
  /** Группы юрлица сотрудника для выгрузки P&L (ТЗ 0075). */
  pnlExportGroups?: Maybe<Array<PnlExportGroupType>>;
  /** Последние выгрузки данных для P&L (ТЗ 0075), видимые сотруднику. */
  pnlExportRuns?: Maybe<Array<PnlExportRunType>>;
  previewContractSms?: Maybe<SmsPreviewType>;
  /** ТЗ 0083: массовая SMS — кому уйдёт и почему нет */
  previewContractsSms?: Maybe<ContractsSmsPreviewType>;
  /** ТЗ 0112: HTML документа на данных студента / группы; пустые поля подсвечены и перечислены. Номер не резервируется. */
  previewDocument: DocumentPreviewType;
  previewFundingCandidateSms?: Maybe<SmsPreviewType>;
  previewLeadSms?: Maybe<SmsPreviewType>;
  previewSmsCampaign?: Maybe<SmsCampaignPreviewType>;
  previewSmsReminders: Array<SmsReminderPreviewType>;
  previewStudentSms?: Maybe<SmsPreviewType>;
  previewTeacherSms?: Maybe<SmsPreviewType>;
  privateIndividualPublicOfferPage?: Maybe<PrivateIndividualPublicOfferPageType>;
  /** Справочник повятов для ПУБЛИЧНОЙ формы заявки. */
  publicFundingPowiats: Array<PowiatType>;
  /** Справочник воеводств для ПУБЛИЧНОЙ формы заявки. */
  publicFundingVoivodeships: Array<VoivodeshipType>;
  /** Received Fakturownia cost documents eligible to back an Expense (excludes quotations; by default also excludes invoices already linked to an Expense). */
  receivedInvoicesForExpense?: Maybe<Array<Maybe<ReceivedInvoiceForExpenseType>>>;
  /** Most recently created LessonRecordings (newest first) for the ERP «recently matched» list. `mine` limits to matches made by the current user; `limit` caps the result set (default 20). */
  recentlyMatchedLessonRecordings?: Maybe<Array<Maybe<LessonRecordingType>>>;
  reminderPlans: Array<ReminderPlanType>;
  /** Who a reply to this conversation will be sent as, for the acting manager: him personally (his Slack token), the workspace bot, or the shared mailbox. */
  replyIdentity: ReplyIdentityType;
  robotTxt?: Maybe<RobotTxtType>;
  runtimeSettingChanges: Array<RuntimeSettingChangeType>;
  /** ТЗ 0095: смысловые разделы настроек в порядке чипов. */
  runtimeSettingDomains: Array<RuntimeSettingDomainType>;
  runtimeSettingSections: Array<RuntimeSettingSectionType>;
  /** ТЗ 0093: ключи реестра, видимые по ролям пользователя. */
  runtimeSettings: Array<RuntimeSettingType>;
  scheduledTasks: ScheduledTasksType;
  /** The SendGrid contact list mirroring this group's students, or null if it has not been created yet. */
  sendgridGroupList?: Maybe<SendgridGroupListType>;
  /** Dynamic templates available in SendGrid, for the mailing template picker. Read live from the API. */
  sendgridTemplates: Array<SendgridTemplateType>;
  shortLink?: Maybe<ShortLinkType>;
  shortLinkClicks: Array<ShortLinkClickType>;
  shortLinkDailyClicks: Array<ShortLinkDayType>;
  shortLinkFacets: ShortLinkFacetsType;
  shortLinkSettings: ShortLinkSettingsType;
  shortLinkSummary: ShortLinkSummaryType;
  shortLinks: Array<ShortLinkType>;
  shortLinksTotal: Scalars['Int'];
  /** The exact backend URL to register as each Slack app's OAuth «Redirect URL» (server setting SLACK_OAUTH_REDIRECT_URI). Empty → the one-click «Подключить мой Slack» flow isn't configured server-side. */
  slackOauthRedirectUri?: Maybe<Scalars['String']>;
  /** The Slack user currently linked to a student (or null). */
  slackUserLink?: Maybe<SlackUserLinkType>;
  /** The Slack workspace bound to a group (or null). */
  slackWorkspaceLink?: Maybe<SlackWorkspaceLinkType>;
  /** Human members of the group's Slack workspace (mirrored by sync). By default only those not yet matched to a student — the manual-matching worklist. */
  slackWorkspaceMembers: Array<SlackUserLinkType>;
  smsCampaign?: Maybe<SmsCampaignType>;
  smsCampaignCandidates: Array<SmsCampaignCandidateType>;
  smsCampaigns: Array<SmsCampaignType>;
  smsJournal: SmsJournalPageType;
  smsJournalFacets: SmsJournalFacetsType;
  smsProviderStatus: SmsProviderStatusType;
  smsSettings: SmsSettingsType;
  staffMailboxSettings: StaffMailboxSettingsType;
  staffNotificationSettings?: Maybe<StaffNotificationSettingsType>;
  /** The feed itself. Loaded on opening the popup, never in the poll. */
  staffNotifications?: Maybe<StaffNotificationPageType>;
  /** Bell counter. Polled once per `pollSeconds`; one SELECT. */
  staffNotificationsSummary?: Maybe<StaffNotificationsSummaryType>;
  /** Одна задача целиком — для окна карточки (ТЗ 0064). Отдельно от ленты, потому что здесь выбирают тела реплик, а в ленте это были бы тексты всех реплик по всем задачам. */
  staffTask?: Maybe<StaffTaskType>;
  /** Короткоживущая подписанная ссылка на один файл задачи (ТЗ 0066). Отдельный резолвер, а не поле в типе: так ссылка минтится по клику, не оседает в кеше клиента и каждая выдача попадает в аудит. */
  staffTaskAttachmentUrl?: Maybe<TaskAttachmentUrlType>;
  /** Подписанные inline-ссылки на картинки задач — миниатюры доски и окна (ТЗ 0109). Не больше 50 id за раз. Только картинки задач, которые человек видит; чужое, несуществующее и не-картинки молча пропускаются. */
  staffTaskImageUrls: Array<TaskImageUrlType>;
  /** Flexible task feed for the command center: filter by group / student / agreement / teacher / assignee, by a due-date range (due_from..due_to) and a title/description search; ordered open-first then by due date. */
  staffTasks: Array<StaffTaskType>;
  /** Counts over the SAME selection `staffTasks` returns, for the command-center header. Takes the identical arguments on purpose: a header number computed from a different population than the list under it is worse than no number — the previous one summed a per-GROUP rollup and could not see group-less tasks at all (spec 0063). */
  staffTasksSummary: StaffTasksSummaryType;
  /** Active ERP staff (management roles) — the only valid task assignees. */
  staffUsers: Array<StaffUserType>;
  student?: Maybe<StudentType>;
  /** The stored LMS-access block for a student (null if the student was never blocked). */
  studentAccessBlock?: Maybe<StudentAccessBlockType>;
  /** ТЗ 0074: the student's suspensions and restorations, newest first, with what was sent. */
  studentAccessBlockEvents: Array<LmsBlockEventType>;
  /** @deprecated Unbounded (loads every conversation ever). Use studentConversationsPage — the keyset-paginated replacement (spec 0031). */
  studentConversations: Array<ConversationType>;
  /** A student's dialogs, newest activity first — the keyset page replacing studentConversations. Includes group-DM (mpim) participations, not just dialogs owned by this student. */
  studentConversationsPage: ConversationConnection;
  studentHomeworkForErp: Array<StudentHomeworkRowType>;
  studentMarks?: Maybe<StudentsMarkConnection>;
  /** Aggregated communicator hover-card (spec 0009). `finance` and per-group financing flags are null for viewers without payment roles; the whole result is null when the student does not exist or is not visible in the viewer's legal entity. */
  studentMiniCard?: Maybe<StudentMiniCard>;
  studentNotes: Array<StudentNoteType>;
  studentSms?: Maybe<StudentSmsStateType>;
  /** One student's answers, for their ERP card. The LMS twin `mySubmittedSurveys` deliberately has NO studentId argument — that asymmetry is the anti-IDOR design, not an oversight. Gated tighter than the aggregates: this pairs a named student with their free-text opinion of a named teacher. */
  studentSurveyResponses?: Maybe<StudentSurveyHistoryType>;
  studentTasks: Array<StaffTaskType>;
  studentsCompaniesInfo?: Maybe<StudentAndCompaniesType>;
  studentsForJournal?: Maybe<StudentConnection>;
  studentsMarks?: Maybe<StudentConnection>;
  studentsReviews?: Maybe<StudentsReviewsType>;
  successStoriesBlock?: Maybe<SuccessStoriesBlockType>;
  successStory?: Maybe<SuccessStoriesType>;
  successStoryBySlug?: Maybe<SuccessStoriesType>;
  survey?: Maybe<SurveyType>;
  /** Cross-survey metrics for ONE разрез. dimension: course | group | teacher | lesson_number | month | survey | metric | question_type. The date window applies to the TRIGGER LESSON's date, never to submission time — otherwise responseRate's numerator and denominator would be windowed differently. The teacher dimension uses the lesson's CURRENT teacher (live); teacherSurveyFeedback is snapshotted and remains the authority for anything about a named person. */
  surveyAnalytics: Array<SurveyAnalyticsRowType>;
  surveyAssignmentResults?: Maybe<SurveyAssignmentResultsType>;
  /** The survey's audience, seen FROM the survey — the reverse of groupSurveyAssignments(groupId). Same rows and the same builder as surveySummary.groupBreakdown. */
  surveyAssignments: Array<SurveyGroupBreakdownType>;
  /** The free-text feed with full context. Keyset-paginated: the feed is read newest-first while new responses arrive, and OFFSET paging would repeat or skip rows as the head shifts. */
  surveyComments: SurveyCommentPageType;
  /** AI digests of the scope, newest first (max 50). */
  surveyDigests: Array<SurveyDigestType>;
  /** Per-student rollup over the same assignments as surveyGroupTimeline (roster rule of surveyAssignmentResults). Empty for an unknown group. */
  surveyGroupStudents: Array<SurveyGroupStudentRowType>;
  /** The group's surveys by lesson (only assignments whose trigger lesson is over, archived/deactivated included) plus the per-topic cut over the whole group. Null for an unknown group. */
  surveyGroupTimeline?: Maybe<SurveyGroupTimelineType>;
  /** One question, split by a dimension. Distributions come from the same aggregation as surveySummary, so `total` is guaranteed identical to the matching questionResults entry. Null when the question is not part of the survey. */
  surveyQuestionBreakdown?: Maybe<SurveyQuestionBreakdownType>;
  /** Every question across every survey with its topic and a suggestion — the bulk-tagging screen. Without tagging the topic dimensions answer nothing, and tagging one question at a time inside each constructor is work nobody does. */
  surveyQuestionTags: Array<SurveyQuestionTagRowType>;
  surveyResponseDetail?: Maybe<SurveyResponseDetailType>;
  /** Respondents × questions for one survey — the answer table. Same answers as surveyAssignmentResults, laid out so different people's answers sit side by side instead of one drawer at a time. */
  surveyResponseMatrix?: Maybe<SurveyResponseMatrixType>;
  /** Outliers worth acting on. Unlike teacherSurveyLeaderboard — which RETURNS thin rows flagged enoughData=false, because hiding a teacher would imply they are fine — an under-sampled alert is noise, so rows below minSample are suppressed. sampleSize is reported on every survivor. */
  surveySignals: Array<SurveySignalType>;
  /** Pooled results across ALL of the survey's groups, plus a per-group breakdown. Same per-question aggregation as surveyAssignmentResults, wider pool. */
  surveySummary?: Maybe<SurveySummaryType>;
  /** Candidate groups for the constructor's picker, each with the lesson the trigger resolves to or the reason it would be skipped — so «в группе нет занятия №8» is visible BEFORE saving. */
  surveyTargetGroups: Array<SurveyTargetGroupType>;
  /** The survey's saved targeting rules (spec 0027). The counters are zero here — they describe a save, not a read. */
  surveyTargeting?: Maybe<SurveyTargetingType>;
  /** How many questions still carry no topic. Drives the «N вопросов без темы» prompt. */
  surveyUntaggedCount: Scalars['Int'];
  /** Survey templates. `courseId` narrows to that course's surveys PLUS universal ones (what the attach popup needs); archived rows are hidden unless `includeArchived`. */
  surveys: Array<SurveyType>;
  /** Размер, количество и белый список расширений, которые принимает сервер. Клиент их не повторяет, а читает. */
  taskAttachmentLimits: TaskAttachmentLimitsType;
  /** Виды связей, доступные ЭТОМУ пользователю (ТЗ 0064). Клиент не хардкодит список и не предлагает вид, поиск по которому всё равно вернёт пусто: право на задачи шире, чем право на преподавателей или дофинансирование. */
  taskLinkKinds: Array<TaskLinkKindType>;
  /** Подсказки для пикера связей: ОДИН резолвер на все виды. Ищет по выборке, скоупленной правилами своего домена — прицепить можно только то, что человек и так видит. Неизвестный или запрещённый вид даёт пусто, а не ошибку. */
  taskLinkSearch: Array<TaskLinkType>;
  /** Подсказки связей из текста заголовка (ТЗ 0109): #123 / id 123 → студент, токен с цифрой → группа, «Фамилия Имя» → студент и его сделки/соглашения. До 8; текст режется до 300 символов. Только виды и объекты, которые этот человек может прицепить. */
  taskSmartLinks: Array<TaskSmartLinkType>;
  teacher?: Maybe<TeacherType>;
  /** The merged AI competency profile (spec 0028 C). ADVISORY: render it under a «draft, not a decision» label with `aiModel`/`promptVersion`/`analyzedAt` visible. Returns null until an analysis has run. */
  teacherAiProfile?: Maybe<TeacherAiProfileType>;
  teacherApplication?: Maybe<ApplicationType>;
  /** ТЗ 0114: who invoices us for the teacher (default first). TEACHER_TERMS_ROLES — the teacher-card roles plus FinanceManager. */
  teacherBillingEntities: Array<TeacherBillingEntityType>;
  /** Groups on a course the teacher is qualified for (`coursesCanTeach`) that still have future lessons with no live teacher application. */
  teacherCandidateGroups: Array<TeacherCandidateGroupType>;
  /**
   * A teacher's threads (Slack DM + Gmail) — the teacher analog of studentConversations. Visible in the group context of the communicator; not in the dashboard queue (spec 0033).
   * @deprecated Unbounded (loads every conversation ever). Use teacherConversationsPage — the keyset-paginated replacement (spec 0031).
   */
  teacherConversations: Array<ConversationType>;
  /** A teacher's dialogs, newest activity first — the keyset page replacing teacherConversations. */
  teacherConversationsPage: ConversationConnection;
  /** A short-lived signed GET. Audited on every issue. */
  teacherDocumentDownloadUrl?: Maybe<Scalars['String']>;
  /** The extracted body — exactly what the AI read. Exposed so the assessment is auditable. */
  teacherDocumentText?: Maybe<TeacherDocumentTextType>;
  /** Uploaded candidate documents, newest first. Every kind is VERSIONED — the newest row of a kind carries `isCurrent: true` and older ones are kept on purpose. */
  teacherDocuments: Array<TeacherDocumentType>;
  /** The transcript body — fetched separately because it is large and only the transcript drawer needs it. */
  teacherInterviewTranscript?: Maybe<TeacherInterviewTranscriptType>;
  /** A short-lived signed GET for the stored MP4 (or the bare external URL for a link-interview). Audited on every issue. */
  teacherInterviewVideoUrl?: Maybe<Scalars['String']>;
  teacherInterviews: Array<TeacherInterviewType>;
  /** Forward-looking load: weekly histogram, hours/week, a load band, and a per-application rollup. Counts FUTURE lessons — `lessonsCount - scheduledLessons` is a planning gap, not remaining work. */
  teacherLoad?: Maybe<TeacherLoadType>;
  teacherSms?: Maybe<TeacherSmsStateType>;
  /** One teacher's survey feedback: rating trend, per-course and per-group splits, and the named comment feed. */
  teacherSurveyFeedback?: Maybe<TeacherSurveyFeedbackReportType>;
  /** Every teacher with survey feedback, WEAKEST FIRST. Windowed on purpose — Teacher.studentRating is an all-time all-course number and cannot answer «кто слаб на этом курсе в этом квартале». */
  teacherSurveyLeaderboard: Array<TeacherLeaderboardRowType>;
  teachersPageInfo?: Maybe<TeachersPageInfoType>;
  /** Dialogs holding an INBOUND message no manager has ticked «обработано» yet — the amber-dot work queue. Read state and dialog status play no part. */
  unhandledConversations: Array<ConversationType>;
  user?: Maybe<UserNode>;
  users?: Maybe<UserNodeConnection>;
  verifyStudent?: Maybe<VerifiedStudent>;
  verifyTeacher?: Maybe<VerifiedTeacher>;
  whiteboardLibrary?: Maybe<WhiteboardLibraryType>;
  zoomAccountUsage?: Maybe<ZoomAccountUsageType>;
  zoomAuditLog?: Maybe<ZoomAuditLogConnection>;
  zoomDashboard?: Maybe<ZoomDashboardType>;
  zoomLesson?: Maybe<GroupLessonForLmsType>;
  /** Заходы Zoom по занятию (все его проведения). */
  zoomLessonParticipants: Array<ZoomParticipantSessionType>;
  /** Список занятия — кого можно выбрать при ручной привязке. */
  zoomLessonRoster: Array<ZoomRosterPersonType>;
  /** Покрытие занятий группы данными участников Zoom (ТЗ 0092). */
  zoomParticipantsCoverage: Array<ZoomLessonCoverageType>;
};


export type QueryAgreementArgs = {
  agreementId: Scalars['ID'];
};


export type QueryAgreementCorrectionCheckArgs = {
  agreementId: Scalars['ID'];
  targetGroupId?: Maybe<Scalars['ID']>;
};


export type QueryAgreementTasksArgs = {
  agreementId: Scalars['ID'];
  includeClosed?: Maybe<Scalars['Boolean']>;
};


export type QueryAiAgentRunArgs = {
  id: Scalars['ID'];
};


export type QueryAiAgentRunsArgs = {
  agentKey?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trigger?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryAiChatMentionSearchArgs = {
  query: Scalars['String'];
  kinds?: Maybe<Array<Scalars['String']>>;
};


export type QueryAiChatThreadArgs = {
  id: Scalars['ID'];
};


export type QueryAiChatThreadsArgs = {
  archived?: Maybe<Scalars['Boolean']>;
};


export type QueryAiCourseLessonComparisonArgs = {
  courseId: Scalars['ID'];
  lessonNumber: Scalars['Int'];
};


export type QueryAiFindingForTaskArgs = {
  taskId: Scalars['ID'];
};


export type QueryAiFindingsArgs = {
  kind?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  feedback?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryAiKbCandidateArgs = {
  id: Scalars['ID'];
};


export type QueryAiKbCandidatesArgs = {
  category?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryAiKnowledgeDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryAiKnowledgeDocumentsArgs = {
  category?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};


export type QueryAiKnowledgeRevisionsArgs = {
  documentId: Scalars['ID'];
};


export type QueryAiKnowledgeSearchArgs = {
  query: Scalars['String'];
  category?: Maybe<Scalars['String']>;
};


export type QueryAiLessonAnalysesArgs = {
  groupId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  reviewStatus?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryAiLessonAnalysisArgs = {
  lessonId: Scalars['ID'];
};


export type QueryAiLessonViewArgs = {
  lessonId: Scalars['ID'];
};


export type QueryAiMcpConnectionArgs = {
  id: Scalars['ID'];
};


export type QueryAiReplyQualityArgs = {
  weeks?: Maybe<Scalars['Int']>;
};


export type QueryAiReplySuggestionArgs = {
  conversationId: Scalars['ID'];
};


export type QueryAiSkillArgs = {
  id: Scalars['ID'];
};


export type QueryAiSkillsArgs = {
  status?: Maybe<Scalars['String']>;
};


export type QueryAiStudentFinancePortraitArgs = {
  studentId: Scalars['ID'];
};


export type QueryAiStudentPortraitArgs = {
  studentId: Scalars['ID'];
};


export type QueryAiTeacherPracticePortraitArgs = {
  teacherId: Scalars['ID'];
};


export type QueryAllArticlesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllCompaniesArgs = {
  query?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllContributionsArgs = {
  query?: Maybe<Scalars['String']>;
  contributionNum?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllCountriesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllCourseCategoriesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllCoursesArgs = {
  query?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  readyToPublish?: Maybe<Scalars['Boolean']>;
  educationForm?: Maybe<Scalars['String']>;
  category_Name?: Maybe<Scalars['String']>;
  startDateFilter?: Maybe<Scalars['Boolean']>;
  orderByPublishDateFilter?: Maybe<Scalars['Boolean']>;
};


export type QueryAllDeferredPaymentsArgs = {
  query?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllGroupZoomSchedulesArgs = {
  groupId?: Maybe<Scalars['ID']>;
  weekDay?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllGroupsArgs = {
  query?: Maybe<Scalars['String']>;
  zoomAccountId?: Maybe<Scalars['ID']>;
  hasZoomAccount?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllGroupsForLmsArgs = {
  active?: Maybe<Scalars['Boolean']>;
  finished?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  groupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  lessonDate?: Maybe<Scalars['Date']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllLessonRecordingsArgs = {
  status?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  groupId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  ambiguousOnly?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllNativesArgs = {
  excludedNatives?: Maybe<Array<Maybe<Scalars['String']>>>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllStoriesArgs = {
  excludeArticles?: Maybe<Array<Maybe<Scalars['String']>>>;
  excludeStories?: Maybe<Array<Maybe<Scalars['String']>>>;
  excludedNatives?: Maybe<Array<Maybe<Scalars['String']>>>;
  includeNatives?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllStudentsArgs = {
  query?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllStudentsAchievementArgs = {
  query?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllSuccessStoriesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllTeachersArgs = {
  query?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  siteDisplay?: Maybe<Scalars['Boolean']>;
  hasInterview?: Maybe<Scalars['Boolean']>;
  hasPhoto?: Maybe<Scalars['Boolean']>;
  hasDescription?: Maybe<Scalars['Boolean']>;
  course?: Maybe<Scalars['Decimal']>;
  minRating?: Maybe<Scalars['Decimal']>;
  availability?: Maybe<Scalars['String']>;
};


export type QueryAllTeachersApplicationsArgs = {
  query?: Maybe<Scalars['String']>;
  groupsFilter?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  byGroupId?: Maybe<Scalars['Decimal']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
};


export type QueryAllUsersSettingsArgs = {
  query?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllZoomAccountsArgs = {
  isActive?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllZoomLessonsArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  groupId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllZoomProcessingLogArgs = {
  lessonId?: Maybe<Scalars['ID']>;
  lessonRecordingId?: Maybe<Scalars['ID']>;
  level?: Maybe<Scalars['String']>;
  step?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllZoomRecordingsArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  accountId?: Maybe<Scalars['ID']>;
  orphanOnly?: Maybe<Scalars['Boolean']>;
  tooShort?: Maybe<Scalars['Boolean']>;
  groupId?: Maybe<Scalars['ID']>;
  showDeleted?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAploraCallAnalysisArgs = {
  leadId: Scalars['ID'];
  callId: Scalars['ID'];
};


export type QueryAploraCallTranscriptArgs = {
  leadId: Scalars['ID'];
  callId: Scalars['ID'];
};


export type QueryArticleArgs = {
  articleId?: Maybe<Scalars['ID']>;
};


export type QueryArticleBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryAttendanceHistoryArgs = {
  attendanceId: Scalars['Int'];
};


export type QueryBankAccountsArgs = {
  includeInactive?: Maybe<Scalars['Boolean']>;
};


export type QueryBankStatementImportsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type QueryBankTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryBankTransactionMatchCandidatesArgs = {
  transactionId: Scalars['ID'];
};


export type QueryBankTransactionsArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  accountIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  categorySlugs?: Maybe<Array<Maybe<Scalars['String']>>>;
  direction?: Maybe<Scalars['String']>;
  categorySource?: Maybe<Scalars['String']>;
  isInternalTransfer?: Maybe<Scalars['Boolean']>;
  needsReview?: Maybe<Scalars['Boolean']>;
  uncategorisedOnly?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type QueryBroadcastJobArgs = {
  id: Scalars['ID'];
};


export type QueryCanEditMessageTemplatesArgs = {
  topic?: Maybe<Scalars['String']>;
};


export type QueryCareerApplicationsErpArgs = {
  memberId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
};


export type QueryCareerCitiesArgs = {
  search?: Maybe<Scalars['String']>;
};


export type QueryCareerCourseSkillsArgs = {
  courseId?: Maybe<Scalars['ID']>;
};


export type QueryCareerDirectionsArgs = {
  includeInactive?: Maybe<Scalars['Boolean']>;
};


export type QueryCareerExerciseTemplatesArgs = {
  search?: Maybe<Scalars['String']>;
  includeHidden?: Maybe<Scalars['Boolean']>;
};


export type QueryCareerGroupRosterArgs = {
  groupId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryCareerGroupSkillsArgs = {
  groupId: Scalars['ID'];
};


export type QueryCareerLessonArgs = {
  id: Scalars['ID'];
};


export type QueryCareerMemberDetailArgs = {
  id: Scalars['ID'];
};


export type QueryCareerMemberProgressArgs = {
  memberId: Scalars['ID'];
};


export type QueryCareerMembersArgs = {
  status?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryCareerPromoCampaignsArgs = {
  includeInactive?: Maybe<Scalars['Boolean']>;
};


export type QueryCareerPromoCodesArgs = {
  campaignId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryCareerSiteCoursesArgs = {
  includeHidden?: Maybe<Scalars['Boolean']>;
};


export type QueryCareerSkillDetailArgs = {
  slug: Scalars['String'];
};


export type QueryCareerSkillsArgs = {
  search?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
};


export type QueryCareerSkillsErpArgs = {
  query?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  withStats?: Maybe<Scalars['Boolean']>;
};


export type QueryCareerStudentCompletionsArgs = {
  studentId: Scalars['ID'];
};


export type QueryCareerVacanciesArgs = {
  directionId?: Maybe<Scalars['ID']>;
  skillId?: Maybe<Scalars['ID']>;
  workMode?: Maybe<Scalars['String']>;
  seniority?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  savedOnly?: Maybe<Scalars['Boolean']>;
};


export type QueryCareerVacanciesErpArgs = {
  status?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  applyUrl?: Maybe<Scalars['String']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  freshness?: Maybe<Scalars['String']>;
  hideArchived?: Maybe<Scalars['Boolean']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
};


export type QueryCareerVacancyArgs = {
  id: Scalars['ID'];
};


export type QueryCareerVacancyBoardArgs = {
  status?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  applyUrl?: Maybe<Scalars['String']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  freshness?: Maybe<Scalars['String']>;
  hideArchived?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
  orderBy?: Maybe<Scalars['String']>;
  orderDir?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type QueryCareerVacancyErpArgs = {
  id: Scalars['ID'];
};


export type QueryCareerVacancyFeedArgs = {
  directionId?: Maybe<Scalars['ID']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
  cityId?: Maybe<Scalars['ID']>;
  workMode?: Maybe<Scalars['String']>;
  seniority?: Maybe<Scalars['String']>;
  employmentType?: Maybe<Scalars['String']>;
  salaryFrom?: Maybe<Scalars['Int']>;
  freshness?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  savedOnly?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  matchMode?: Maybe<Scalars['String']>;
  trackCode?: Maybe<Scalars['String']>;
};


export type QueryCashBalancesArgs = {
  legalEntityId?: Maybe<Scalars['ID']>;
};


export type QueryCashFlowCategoriesArgs = {
  includeInactive?: Maybe<Scalars['Boolean']>;
};


export type QueryCashFlowReportArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  grain?: Maybe<Scalars['String']>;
  accountIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  legalEntityId?: Maybe<Scalars['ID']>;
  includeInternal?: Maybe<Scalars['Boolean']>;
};


export type QueryCashFlowRulesArgs = {
  isActive?: Maybe<Scalars['Boolean']>;
  health?: Maybe<Scalars['String']>;
  needsAttention?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type QueryChannelGroupLinkArgs = {
  groupId: Scalars['ID'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryContractAnalyticsArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  course?: Maybe<Scalars['String']>;
  granularity?: Maybe<Scalars['String']>;
};


export type QueryContractConversationsArgs = {
  contractId: Scalars['ID'];
};


export type QueryContractDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryContractDocumentAmountsArgs = {
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  fulfilmentStatus?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  signedFrom?: Maybe<Scalars['Date']>;
  signedTo?: Maybe<Scalars['Date']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  signState?: Maybe<Array<Scalars['String']>>;
  expiringWithinDays?: Maybe<Scalars['Int']>;
  needsAction?: Maybe<Scalars['Boolean']>;
};


export type QueryContractDocumentStatusCountsArgs = {
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  fulfilmentStatus?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  signedFrom?: Maybe<Scalars['Date']>;
  signedTo?: Maybe<Scalars['Date']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  signState?: Maybe<Array<Scalars['String']>>;
  expiringWithinDays?: Maybe<Scalars['Int']>;
  needsAction?: Maybe<Scalars['Boolean']>;
  hotMinWinChance?: Maybe<Scalars['Float']>;
};


export type QueryContractDocumentsArgs = {
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  fulfilmentStatus?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  signedFrom?: Maybe<Scalars['Date']>;
  signedTo?: Maybe<Scalars['Date']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  signState?: Maybe<Array<Scalars['String']>>;
  expiringWithinDays?: Maybe<Scalars['Int']>;
  needsAction?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
};


export type QueryContractDocumentsTotalArgs = {
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  fulfilmentStatus?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  signedFrom?: Maybe<Scalars['Date']>;
  signedTo?: Maybe<Scalars['Date']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  signState?: Maybe<Array<Scalars['String']>>;
  expiringWithinDays?: Maybe<Scalars['Int']>;
  needsAction?: Maybe<Scalars['Boolean']>;
};


export type QueryContractDraftDefaultsArgs = {
  groupId: Scalars['ID'];
  paymentPlanId: Scalars['ID'];
  currency?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  excludeContractId?: Maybe<Scalars['ID']>;
  crmLeadId?: Maybe<Scalars['ID']>;
};


export type QueryContractDraftFromLeadArgs = {
  leadId: Scalars['ID'];
};


export type QueryContractGroupOptionsArgs = {
  query?: Maybe<Scalars['String']>;
  selectedId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryContractInvitePreviewArgs = {
  documentId: Scalars['ID'];
  emailSubject?: Maybe<Scalars['String']>;
  emailBody?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
};


export type QueryContractMailSummariesArgs = {
  contractIds: Array<Scalars['ID']>;
};


export type QueryContractOutreachArgs = {
  contractId: Scalars['ID'];
};


export type QueryContractOutreachSummariesArgs = {
  contractIds: Array<Scalars['ID']>;
};


export type QueryContractSellersArgs = {
  forReassign?: Maybe<Scalars['Boolean']>;
};


export type QueryContractTemplateEditableArgs = {
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
};


export type QueryContractTemplatePreviewArgs = {
  id: Scalars['ID'];
};


export type QueryContractTemplatePreviewDraftArgs = {
  id: Scalars['ID'];
  html: Scalars['String'];
  tokens?: Maybe<Scalars['JSONString']>;
};


export type QueryContractTemplatesArgs = {
  kind?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
};


export type QueryConversationThreadArgs = {
  conversationId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type QueryConversationsBrowserArgs = {
  search?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  unhandledOnly?: Maybe<Scalars['Boolean']>;
  kinds?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type QueryCourseArgs = {
  courseId?: Maybe<Scalars['ID']>;
};


export type QueryCourseBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCoursePlanPricesArgs = {
  courseId: Scalars['ID'];
};


export type QueryCourseProgramFrameArgs = {
  courseId: Scalars['ID'];
};


export type QueryCourseProgramLessonsArgs = {
  courseId: Scalars['ID'];
};


export type QueryCoursesGraduateFeedbackArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCrmLeadArgs = {
  id: Scalars['ID'];
};


export type QueryCrmLeadsArgs = {
  query?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryDebtorCandidatesArgs = {
  groupId?: Maybe<Scalars['ID']>;
};


export type QueryDiplomaDownloadUrlArgs = {
  diplomaId: Scalars['ID'];
};


export type QueryDocumentCashFlowArgs = {
  targetType: Scalars['String'];
  targetId: Scalars['ID'];
};


export type QueryDocumentPaletteArgs = {
  kind: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
};


export type QueryDocumentSendDefaultsArgs = {
  issuedDocumentId: Scalars['ID'];
};


export type QueryDocumentTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryDocumentTemplateEditableArgs = {
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
};


export type QueryDocumentTemplatePreviewDraftArgs = {
  id: Scalars['ID'];
  html: Scalars['String'];
};


export type QueryDocumentTemplatesArgs = {
  kind?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
};


export type QueryEstimateAiLessonAnalysesArgs = {
  lessonIds: Array<Scalars['ID']>;
};


export type QueryExchangeRatesArgs = {
  currency?: Maybe<Scalars['String']>;
};


export type QueryExpenseArgs = {
  id: Scalars['ID'];
};


export type QueryExpenseAggregatesArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  groupBy?: Maybe<Scalars['String']>;
  teacherId?: Maybe<Scalars['ID']>;
};


export type QueryExpensesArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  source?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  recurrence?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  teacherId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type QueryFakturowniaBillingJobArgs = {
  id: Scalars['ID'];
};


export type QueryFakturowniaContributionBillabilityArgs = {
  agreementId: Scalars['ID'];
  contributionId?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
};


export type QueryFakturowniaGroupBillingPreviewArgs = {
  groupId: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
};


export type QueryFakturowniaInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryFakturowniaInvoiceAggregatesArgs = {
  direction?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  groupBy: Scalars['String'];
  includeQuotations?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['String']>;
};


export type QueryFakturowniaInvoicesArgs = {
  direction?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  matchStatus?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  paymentId?: Maybe<Scalars['ID']>;
  unpaidOnly?: Maybe<Scalars['Boolean']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  overdueOnly?: Maybe<Scalars['Boolean']>;
  parentId?: Maybe<Scalars['ID']>;
  needsLinkOnly?: Maybe<Scalars['Boolean']>;
  provisionBlockedOnly?: Maybe<Scalars['Boolean']>;
};


export type QueryFakturowniaSyncRunsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type QueryFinanceBudgetArgs = {
  year: Scalars['Int'];
};


export type QueryFinanceMonthBudgetArgs = {
  year: Scalars['Int'];
  month: Scalars['Int'];
};


export type QueryFinancePlanArgs = {
  year: Scalars['Int'];
};


export type QueryFundingBoardArgs = {
  operatorId?: Maybe<Scalars['ID']>;
  matchStatus?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  assignedToId?: Maybe<Scalars['ID']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  isStudent?: Maybe<Scalars['Boolean']>;
  employmentStatus?: Maybe<Scalars['String']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  needsAttention?: Maybe<Scalars['Boolean']>;
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  needsOperatorReview?: Maybe<Scalars['Boolean']>;
  operatorMatch?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryFundingCandidateArgs = {
  id: Scalars['ID'];
};


export type QueryFundingCandidateForUserArgs = {
  userId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
};


export type QueryFundingCandidateSmsArgs = {
  candidateId: Scalars['ID'];
};


export type QueryFundingCandidateStatsArgs = {
  dimension: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  statusGroup?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  matchStatus?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  isStudent?: Maybe<Scalars['Boolean']>;
  employmentStatus?: Maybe<Scalars['String']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryFundingCandidatesArgs = {
  status?: Maybe<Scalars['String']>;
  statusGroup?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  matchStatus?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  assignedToId?: Maybe<Scalars['ID']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  isStudent?: Maybe<Scalars['Boolean']>;
  employmentStatus?: Maybe<Scalars['String']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  needsAttention?: Maybe<Scalars['Boolean']>;
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  needsOperatorReview?: Maybe<Scalars['Boolean']>;
  operatorMatch?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryFundingCandidatesForUserArgs = {
  userId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
};


export type QueryFundingCandidatesTotalArgs = {
  status?: Maybe<Scalars['String']>;
  statusGroup?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  matchStatus?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  assignedToId?: Maybe<Scalars['ID']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  isStudent?: Maybe<Scalars['Boolean']>;
  employmentStatus?: Maybe<Scalars['String']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  needsAttention?: Maybe<Scalars['Boolean']>;
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  needsOperatorReview?: Maybe<Scalars['Boolean']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  operatorMatch?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryFundingFormSubmissionArgs = {
  id: Scalars['ID'];
};


export type QueryFundingFormSubmissionsArgs = {
  state?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  submittedFrom?: Maybe<Scalars['Date']>;
  submittedTo?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryFundingFormSubmissionsTotalArgs = {
  state?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  submittedFrom?: Maybe<Scalars['Date']>;
  submittedTo?: Maybe<Scalars['Date']>;
};


export type QueryFundingGeoAliasesArgs = {
  status?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryFundingImportRunArgs = {
  id: Scalars['ID'];
};


export type QueryFundingImportRunsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  taskName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  triggerSource?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};


export type QueryFundingImportRunsTotalArgs = {
  taskName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  triggerSource?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};


export type QueryFundingIntakeArgs = {
  id: Scalars['ID'];
};


export type QueryFundingIntakesArgs = {
  operatorId?: Maybe<Scalars['ID']>;
  phase?: Maybe<Array<Scalars['String']>>;
  confirmation?: Maybe<Scalars['String']>;
  startsFrom?: Maybe<Scalars['Date']>;
  startsTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryFundingIntakesTotalArgs = {
  operatorId?: Maybe<Scalars['ID']>;
  phase?: Maybe<Array<Scalars['String']>>;
  confirmation?: Maybe<Scalars['String']>;
  startsFrom?: Maybe<Scalars['Date']>;
  startsTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryFundingMailCalendarArgs = {
  days?: Maybe<Scalars['Int']>;
};


export type QueryFundingMailTemplateCheckArgs = {
  templateId: Scalars['String'];
};


export type QueryFundingNotificationsArgs = {
  candidateId?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  deliveryState?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  intakeId?: Maybe<Scalars['ID']>;
  ruleId?: Maybe<Scalars['ID']>;
  templateId?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryFundingNotificationsTotalArgs = {
  candidateId?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  deliveryState?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  intakeId?: Maybe<Scalars['ID']>;
  ruleId?: Maybe<Scalars['ID']>;
  templateId?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryFundingOperatorArgs = {
  id: Scalars['ID'];
};


export type QueryFundingOperatorsArgs = {
  programType?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  powiatId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
  pageChanged?: Maybe<Scalars['Boolean']>;
  clientType?: Maybe<Scalars['String']>;
  intakePeriod?: Maybe<Scalars['String']>;
  pageSegment?: Maybe<Scalars['String']>;
  intakeConfirmation?: Maybe<Scalars['String']>;
  urlSuspect?: Maybe<Scalars['Boolean']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryFundingOperatorsTotalArgs = {
  programType?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  powiatId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
  pageChanged?: Maybe<Scalars['Boolean']>;
  clientType?: Maybe<Scalars['String']>;
  intakePeriod?: Maybe<Scalars['String']>;
  pageSegment?: Maybe<Scalars['String']>;
  intakeConfirmation?: Maybe<Scalars['String']>;
  urlSuspect?: Maybe<Scalars['Boolean']>;
  ids?: Maybe<Array<Scalars['ID']>>;
};


export type QueryFundingParticipationAgreementsArgs = {
  candidateId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
};


export type QueryFundingParticipationReportArgs = {
  agreementId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  format: ParticipationReportFormat;
  language?: Maybe<Scalars['String']>;
};


export type QueryFundingParticipationSummaryArgs = {
  agreementId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
};


export type QueryFundingPowiatsArgs = {
  voivodeshipId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryFundingSubmissionStatesArgs = {
  search?: Maybe<Scalars['String']>;
  submittedFrom?: Maybe<Scalars['Date']>;
  submittedTo?: Maybe<Scalars['Date']>;
};


export type QueryGatewaySettlementArgs = {
  id: Scalars['ID'];
};


export type QueryGatewaySettlementCandidatesArgs = {
  settlementId: Scalars['ID'];
};


export type QueryGatewaySettlementsArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};


export type QueryGroupArgs = {
  groupId?: Maybe<Scalars['ID']>;
};


export type QueryGroupAttendanceSummaryArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupCommsIndexArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupConversationsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupConversationsPageArgs = {
  kinds?: Maybe<Array<Scalars['String']>>;
  groupId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type QueryGroupDiplomasArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupForLmsArgs = {
  groupId?: Maybe<Scalars['ID']>;
};


export type QueryGroupHomeworkMarksForErpArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupHomeworkOverviewForErpArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupLessonAttachmentArgs = {
  attachmentId?: Maybe<Scalars['ID']>;
  attachmentRole?: Maybe<Scalars['String']>;
};


export type QueryGroupLessonAttachmentForLmsArgs = {
  groupLessonId?: Maybe<Scalars['ID']>;
  attachmentRole?: Maybe<Scalars['String']>;
};


export type QueryGroupLessonAttendanceForLmsArgs = {
  groupLessonId?: Maybe<Scalars['ID']>;
};


export type QueryGroupMailCandidatesArgs = {
  groupId: Scalars['ID'];
  mode?: Maybe<Scalars['String']>;
  includeTerminated?: Maybe<Scalars['Boolean']>;
};


export type QueryGroupMessagesArgs = {
  groupId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  unreadOnly?: Maybe<Scalars['Boolean']>;
  flaggedOnly?: Maybe<Scalars['Boolean']>;
  unhandledOnly?: Maybe<Scalars['Boolean']>;
  channelId?: Maybe<Scalars['ID']>;
};


export type QueryGroupNotesArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupParticipationReportArgs = {
  groupId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryGroupPerformanceSummaryArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupProgramLessonsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupRevenueAggregatesArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupSlackChannelsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupSurveyAssignmentsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupTasksArgs = {
  groupId: Scalars['ID'];
  includeClosed?: Maybe<Scalars['Boolean']>;
};


export type QueryGroupTeacherApplicationsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupWhiteboardsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupsOverviewArgs = {
  search?: Maybe<Scalars['String']>;
  onlyIssues?: Maybe<Scalars['Boolean']>;
  activeWithinDays?: Maybe<Scalars['Int']>;
};


export type QueryHomeworkRosterArgs = {
  lessonId: Scalars['ID'];
};


export type QueryHomeworkSubmissionDownloadUrlArgs = {
  submissionId: Scalars['ID'];
};


export type QueryHomeworkSubmissionDownloadUrlForErpArgs = {
  submissionId: Scalars['ID'];
};


export type QueryInterviewZoomCandidatesArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  accountId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryIssuedDocumentFileArgs = {
  id: Scalars['ID'];
};


export type QueryIssuedDocumentsArgs = {
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
};


export type QueryJournalArgs = {
  groupId: Scalars['ID'];
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryKommoLeadArgs = {
  id: Scalars['ID'];
};


export type QueryKommoLeadConversationsArgs = {
  leadId: Scalars['ID'];
};


export type QueryKommoLeadEventsArgs = {
  leadId: Scalars['ID'];
};


export type QueryKommoLeadFacetsArgs = {
  includeClosed?: Maybe<Scalars['Boolean']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  nextContact?: Maybe<Scalars['String']>;
  aploraCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryKommoLeadLaddersArgs = {
  leadId: Scalars['ID'];
};


export type QueryKommoLeadNotesArgs = {
  leadId: Scalars['ID'];
};


export type QueryKommoLeadSmsArgs = {
  leadId: Scalars['ID'];
};


export type QueryKommoLeadStageCountsArgs = {
  hotMinWinChance?: Maybe<Scalars['Float']>;
  responsible?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  includeClosed?: Maybe<Scalars['Boolean']>;
  ladder?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Array<Scalars['String']>>;
  utmMedium?: Maybe<Array<Scalars['String']>>;
  utmCampaign?: Maybe<Array<Scalars['String']>>;
  fundingStatus?: Maybe<Array<Scalars['String']>>;
  hasFunding?: Maybe<Scalars['Boolean']>;
  hasStudent?: Maybe<Scalars['Boolean']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  nextContact?: Maybe<Scalars['String']>;
  aploraCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryKommoLeadsArgs = {
  statusIds?: Maybe<Array<Scalars['ID']>>;
  responsible?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  includeClosed?: Maybe<Scalars['Boolean']>;
  ladder?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Array<Scalars['String']>>;
  utmMedium?: Maybe<Array<Scalars['String']>>;
  utmCampaign?: Maybe<Array<Scalars['String']>>;
  fundingStatus?: Maybe<Array<Scalars['String']>>;
  hasFunding?: Maybe<Scalars['Boolean']>;
  hasStudent?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<Scalars['String']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  nextContact?: Maybe<Scalars['String']>;
  aploraCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryLeadJourneyArgs = {
  kommoLeadId: Scalars['ID'];
};


export type QueryLeadSavedViewsArgs = {
  scope?: Maybe<Scalars['String']>;
};


export type QueryLessonForLmsArgs = {
  groupLessonId?: Maybe<Scalars['ID']>;
};


export type QueryLessonHomeworkArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonHomeworkSubmissionsForErpArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonJoinClicksArgs = {
  lessonId: Scalars['Int'];
};


export type QueryLessonTextbookFilesArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonWhiteboardForErpArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLmsAttendanceHistoryArgs = {
  attendanceId: Scalars['Int'];
};


export type QueryLmsBlockTemplateExampleArgs = {
  kind: Scalars['String'];
};


export type QueryLmsJournalArgs = {
  groupLessonId: Scalars['ID'];
};


export type QueryLmsLessonJoinClicksArgs = {
  groupLessonId: Scalars['Int'];
};


export type QueryLmsSuspensionsArgs = {
  status?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMailJobArgs = {
  id: Scalars['ID'];
};


export type QueryMailJobsArgs = {
  groupId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMarketingActionsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMarketingAiReferralsArgs = {
  filter: MarketingFilter;
};


export type QueryMarketingBreakdownArgs = {
  filter: MarketingFilter;
  dimension: MarketingDimension;
  parentKey?: Maybe<Scalars['String']>;
  withSeries?: Maybe<Scalars['Boolean']>;
  granularity?: Maybe<MarketingGranularity>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
  compare?: Maybe<MarketingCompare>;
  includeVanished?: Maybe<Scalars['Boolean']>;
  having?: Maybe<Array<MarketingRowPredicate>>;
  minSpendPln?: Maybe<Scalars['Decimal']>;
  minCrmLeads?: Maybe<Scalars['Int']>;
};


export type QueryMarketingCampaignOptionsArgs = {
  platform: Scalars['String'];
  search?: Maybe<Scalars['String']>;
};


export type QueryMarketingChannelOverlapArgs = {
  filter: MarketingFilter;
};


export type QueryMarketingCohortsArgs = {
  filter: MarketingFilter;
  pathKind?: Maybe<Scalars['String']>;
  granularity?: Maybe<MarketingGranularity>;
  splitBy?: Maybe<Scalars['String']>;
};


export type QueryMarketingContractsArgs = {
  filter: MarketingFilter;
  granularity?: Maybe<MarketingGranularity>;
  compare?: Maybe<MarketingCompare>;
};


export type QueryMarketingCreativesArgs = {
  filter: MarketingFilter;
  fatigueOnly?: Maybe<Scalars['Boolean']>;
  format?: Maybe<Scalars['String']>;
  withSeries?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  adIds?: Maybe<Array<Scalars['ID']>>;
  compare?: Maybe<MarketingCompare>;
  having?: Maybe<Array<MarketingRowPredicate>>;
  minSpendPln?: Maybe<Scalars['Decimal']>;
  minCrmLeads?: Maybe<Scalars['Int']>;
  groupBy?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryMarketingDataQualityArgs = {
  filter: MarketingFilter;
};


export type QueryMarketingDemandArgs = {
  filter: MarketingFilter;
};


export type QueryMarketingDigestsArgs = {
  limit?: Maybe<Scalars['Int']>;
  isoWeek?: Maybe<Scalars['String']>;
};


export type QueryMarketingEmailArgs = {
  filter: MarketingFilter;
};


export type QueryMarketingForecastArgs = {
  month?: Maybe<Scalars['Date']>;
  familySlug?: Maybe<Scalars['String']>;
};


export type QueryMarketingJourneyArgs = {
  filter: MarketingFilter;
};


export type QueryMarketingLandingsArgs = {
  filter: MarketingFilter;
  familySlug?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryMarketingLeadDynamicsArgs = {
  filter: MarketingFilter;
  granularity?: Maybe<MarketingGranularity>;
  compare?: Maybe<MarketingCompare>;
  groupBy?: Maybe<Scalars['String']>;
  top?: Maybe<Scalars['Int']>;
};


export type QueryMarketingLeadsArgs = {
  filter: MarketingFilter;
  channel?: Maybe<Scalars['String']>;
  subChannel?: Maybe<Scalars['String']>;
  campaign?: Maybe<Scalars['ID']>;
  family?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  includeRepeats?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryMarketingMatrixArgs = {
  filter: MarketingFilter;
  rows?: Maybe<MarketingDimension>;
  cols?: Maybe<MarketingDimension>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryMarketingOfflineConversionsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMarketingOverviewArgs = {
  filter: MarketingFilter;
  granularity?: Maybe<MarketingGranularity>;
  compare?: Maybe<MarketingCompare>;
};


export type QueryMarketingPageArgs = {
  path: Scalars['String'];
  filter: MarketingFilter;
  compare?: Maybe<MarketingCompare>;
  granularity?: Maybe<MarketingGranularity>;
};


export type QueryMarketingPagesArgs = {
  filter: MarketingFilter;
  compare?: Maybe<MarketingCompare>;
  granularity?: Maybe<MarketingGranularity>;
  pageType?: Maybe<Scalars['String']>;
  pageTypes?: Maybe<Array<Scalars['String']>>;
  familySlug?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryMarketingPathCohortsArgs = {
  filter: MarketingFilter;
  groupBy?: Maybe<Scalars['String']>;
};


export type QueryMarketingSaleArgs = {
  id: Scalars['Int'];
};


export type QueryMarketingSalesArgs = {
  filter: MarketingFilter;
  onlySales?: Maybe<Scalars['Boolean']>;
  coverage?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSearchArgs = {
  filter: MarketingFilter;
  engine?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['Boolean']>;
  zone?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSearchTermsArgs = {
  filter: MarketingFilter;
  familySlug?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSeoAiArgs = {
  week?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
};


export type QueryMarketingSeoAiAnswersArgs = {
  questionId: Scalars['ID'];
  week?: Maybe<Scalars['String']>;
};


export type QueryMarketingSeoBacklinksArgs = {
  month?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSeoCompetitorsArgs = {
  week?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
};


export type QueryMarketingSeoFunnelArgs = {
  filter: MarketingFilter;
};


export type QueryMarketingSeoGapsArgs = {
  month?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  unmapped?: Maybe<Scalars['Boolean']>;
  minVolume?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  includeNavigational?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSeoKeywordArgs = {
  id: Scalars['ID'];
  weeks?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSeoKeywordsArgs = {
  week?: Maybe<Scalars['String']>;
  compareWeek?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['Boolean']>;
  tracked?: Maybe<Scalars['Boolean']>;
  change?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSeoOpportunitiesArgs = {
  kinds?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Array<Scalars['String']>>;
  familySlug?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSeoOverviewArgs = {
  week?: Maybe<Scalars['String']>;
  compareWeek?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['Boolean']>;
};


export type QueryMarketingSeoSeriesArgs = {
  familySlug?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['Boolean']>;
  weeks?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSeoWeeksArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSeriesArgs = {
  filter: MarketingFilter;
  granularity?: Maybe<MarketingGranularity>;
  compare?: Maybe<MarketingCompare>;
};


export type QueryMarketingSignalsArgs = {
  status?: Maybe<Array<Scalars['String']>>;
  kinds?: Maybe<Array<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMarketingSnapshotsArgs = {
  limit?: Maybe<Scalars['Int']>;
  isoWeek?: Maybe<Scalars['String']>;
};


export type QueryMarketingTargetsArgs = {
  month: Scalars['Date'];
};


export type QueryMarketingTrafficArgs = {
  filter: MarketingFilter;
  groupBy?: Maybe<Scalars['String']>;
};


export type QueryMarketingVisitorArgs = {
  id: Scalars['ID'];
};


export type QueryMarketingVisitorJourneyArgs = {
  filter: MarketingFilter;
  compare?: Maybe<MarketingCompare>;
  granularity?: Maybe<MarketingGranularity>;
};


export type QueryMarketingVisitorsArgs = {
  filter: MarketingFilter;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  onlyLinked?: Maybe<Scalars['Boolean']>;
};


export type QueryMaterialsArgs = {
  groupId: Scalars['ID'];
  lessonId?: Maybe<Scalars['ID']>;
  kind?: Maybe<MaterialKindEnum>;
};


export type QueryMessageInlineImagesArgs = {
  messageId: Scalars['ID'];
};


export type QueryMessageTemplateVariablesArgs = {
  topic?: Maybe<Scalars['String']>;
};


export type QueryMessageTemplatesArgs = {
  channel?: Maybe<Scalars['String']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  includeOthers?: Maybe<Scalars['Boolean']>;
  topic?: Maybe<Scalars['String']>;
};


export type QueryMetaContributionsArgs = {
  query?: Maybe<Scalars['String']>;
  contributionNum?: Maybe<Scalars['Int']>;
};


export type QueryMetaCoursesArgs = {
  query?: Maybe<Scalars['String']>;
};


export type QueryMetaDeferredPaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryMetaGroupsArgs = {
  query?: Maybe<Scalars['String']>;
};


export type QueryMetaStudentsArgs = {
  query?: Maybe<Scalars['String']>;
};


export type QueryMetaTeachersArgs = {
  query?: Maybe<Scalars['String']>;
};


export type QueryMetaTeachersApplicationsArgs = {
  query?: Maybe<Scalars['String']>;
};


export type QueryMetaUsersSettingsArgs = {
  query?: Maybe<Scalars['String']>;
};


export type QueryMyAttendanceArgs = {
  groupId: Scalars['ID'];
};


export type QueryMyCareerApplicationsArgs = {
  status?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMyCareerSkillGraphArgs = {
  trackCode?: Maybe<Scalars['String']>;
};


export type QueryMyDiplomaDownloadUrlArgs = {
  diplomaId: Scalars['ID'];
};


export type QueryMyGroupTeacherContactsArgs = {
  groupId: Scalars['ID'];
};


export type QueryMyLessonHomeworkArgs = {
  lessonId: Scalars['ID'];
};


export type QueryMyShareOptionsArgs = {
  language?: Maybe<Scalars['String']>;
};


export type QueryMySlackUserTokenArgs = {
  groupId: Scalars['ID'];
};


export type QueryMyTasksArgs = {
  includeClosed?: Maybe<Scalars['Boolean']>;
};


export type QueryNativeArgs = {
  nativeId?: Maybe<Scalars['ID']>;
};


export type QueryNativeBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryOperatorsForCandidateArgs = {
  candidateId: Scalars['ID'];
};


export type QueryPandadocAnalyticsArgs = {
  granularity?: Maybe<Scalars['String']>;
  course?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  docType?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
};


export type QueryPandadocDocumentsArgs = {
  course?: Maybe<Scalars['String']>;
  docType?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  studentMatches?: Maybe<Scalars['Boolean']>;
  teacherId?: Maybe<Scalars['ID']>;
  teacherMatches?: Maybe<Scalars['Boolean']>;
  unlinked?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryPandadocProvisioningFoldersArgs = {
  course?: Maybe<Scalars['String']>;
};


export type QueryPaymentCalendarArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  legalEntityId?: Maybe<Scalars['ID']>;
};


export type QueryPaymentCalendarSettingsArgs = {
  legalEntityId?: Maybe<Scalars['ID']>;
};


export type QueryPaymentsVerificationArgs = {
  query: Array<Maybe<Scalars['String']>>;
};


export type QueryPlannedPaymentsArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  direction?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['ID']>;
};


export type QueryPnlExportFileArgs = {
  id: Scalars['ID'];
};


export type QueryPnlExportRunsArgs = {
  groupId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryPreviewContractSmsArgs = {
  contractId: Scalars['ID'];
  text: Scalars['String'];
};


export type QueryPreviewContractsSmsArgs = {
  contractIds: Array<Scalars['ID']>;
  text: Scalars['String'];
};


export type QueryPreviewDocumentArgs = {
  templateId: Scalars['ID'];
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  issuePlace?: Maybe<Scalars['String']>;
};


export type QueryPreviewFundingCandidateSmsArgs = {
  candidateId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<LeadSmsLinkInput>;
};


export type QueryPreviewLeadSmsArgs = {
  leadId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<LeadSmsLinkInput>;
};


export type QueryPreviewSmsCampaignArgs = {
  groupId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<SmsLinkInput>;
  mode?: Maybe<Scalars['String']>;
  studentIds?: Maybe<Array<Scalars['ID']>>;
};


export type QueryPreviewSmsRemindersArgs = {
  topic: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
};


export type QueryPreviewStudentSmsArgs = {
  studentId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<SmsLinkInput>;
};


export type QueryPreviewTeacherSmsArgs = {
  teacherId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<TeacherSmsLinkInput>;
};


export type QueryPublicFundingPowiatsArgs = {
  voivodeshipId?: Maybe<Scalars['ID']>;
};


export type QueryReceivedInvoicesForExpenseArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  unlinkedOnly?: Maybe<Scalars['Boolean']>;
};


export type QueryRecentlyMatchedLessonRecordingsArgs = {
  limit?: Maybe<Scalars['Int']>;
  mine?: Maybe<Scalars['Boolean']>;
};


export type QueryReplyIdentityArgs = {
  conversationId: Scalars['ID'];
};


export type QueryRuntimeSettingChangesArgs = {
  key?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryRuntimeSettingsArgs = {
  section?: Maybe<Scalars['String']>;
};


export type QuerySendgridGroupListArgs = {
  groupId: Scalars['ID'];
};


export type QueryShortLinkArgs = {
  id: Scalars['ID'];
};


export type QueryShortLinkClicksArgs = {
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
};


export type QueryShortLinkDailyClicksArgs = {
  id: Scalars['ID'];
  days?: Maybe<Scalars['Int']>;
};


export type QueryShortLinkSummaryArgs = {
  search?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  mine?: Maybe<Scalars['Boolean']>;
  channel?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['ID']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  clicks?: Maybe<Scalars['String']>;
};


export type QueryShortLinksArgs = {
  search?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  mine?: Maybe<Scalars['Boolean']>;
  channel?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['ID']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  clicks?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryShortLinksTotalArgs = {
  search?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  mine?: Maybe<Scalars['Boolean']>;
  channel?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['ID']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  clicks?: Maybe<Scalars['String']>;
};


export type QuerySlackUserLinkArgs = {
  studentId: Scalars['ID'];
};


export type QuerySlackWorkspaceLinkArgs = {
  groupId: Scalars['ID'];
};


export type QuerySlackWorkspaceMembersArgs = {
  groupId: Scalars['ID'];
  unmatchedOnly?: Maybe<Scalars['Boolean']>;
};


export type QuerySmsCampaignArgs = {
  id: Scalars['ID'];
};


export type QuerySmsCampaignCandidatesArgs = {
  groupId: Scalars['ID'];
  mode?: Maybe<Scalars['String']>;
};


export type QuerySmsCampaignsArgs = {
  groupId?: Maybe<Scalars['ID']>;
};


export type QuerySmsJournalArgs = {
  topic?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  dlrStatus?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  contractId?: Maybe<Scalars['ID']>;
  campaignId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  phoneTail?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  leadId?: Maybe<Scalars['ID']>;
  candidateId?: Maybe<Scalars['ID']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySmsProviderStatusArgs = {
  refresh?: Maybe<Scalars['Boolean']>;
};


export type QueryStaffNotificationsArgs = {
  kinds?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxAgeDays?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  unreadOnly?: Maybe<Scalars['Boolean']>;
};


export type QueryStaffNotificationsSummaryArgs = {
  kinds?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxAgeDays?: Maybe<Scalars['Int']>;
};


export type QueryStaffTaskArgs = {
  id: Scalars['ID'];
};


export type QueryStaffTaskAttachmentUrlArgs = {
  attachmentId: Scalars['ID'];
};


export type QueryStaffTaskImageUrlsArgs = {
  attachmentIds: Array<Scalars['ID']>;
};


export type QueryStaffTasksArgs = {
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  assigneeMe?: Maybe<Scalars['Boolean']>;
  assigneeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  statuses?: Maybe<Array<Maybe<Scalars['String']>>>;
  priorities?: Maybe<Array<Maybe<Scalars['String']>>>;
  dueFrom?: Maybe<Scalars['Date']>;
  dueTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
  includeClosed?: Maybe<Scalars['Boolean']>;
  closedWithinDays?: Maybe<Scalars['Int']>;
  links?: Maybe<Array<Maybe<TaskLinkInput>>>;
};


export type QueryStaffTasksSummaryArgs = {
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  assigneeMe?: Maybe<Scalars['Boolean']>;
  assigneeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  statuses?: Maybe<Array<Maybe<Scalars['String']>>>;
  priorities?: Maybe<Array<Maybe<Scalars['String']>>>;
  dueFrom?: Maybe<Scalars['Date']>;
  dueTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
  includeClosed?: Maybe<Scalars['Boolean']>;
  closedWithinDays?: Maybe<Scalars['Int']>;
  links?: Maybe<Array<Maybe<TaskLinkInput>>>;
};


export type QueryStudentArgs = {
  id: Scalars['ID'];
};


export type QueryStudentAccessBlockArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentAccessBlockEventsArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentConversationsArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentConversationsPageArgs = {
  kinds?: Maybe<Array<Scalars['String']>>;
  studentId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type QueryStudentHomeworkForErpArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentMarksArgs = {
  lessonsId: Scalars['ID'];
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryStudentMiniCardArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentNotesArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentSmsArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentSurveyResponsesArgs = {
  studentId: Scalars['ID'];
  surveyId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  includePending?: Maybe<Scalars['Boolean']>;
};


export type QueryStudentTasksArgs = {
  studentId: Scalars['ID'];
  includeClosed?: Maybe<Scalars['Boolean']>;
};


export type QueryStudentsForJournalArgs = {
  lessonsId: Array<Maybe<Scalars['Int']>>;
  groupId: Scalars['Int'];
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryStudentsMarksArgs = {
  lessonsId: Scalars['ID'];
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySuccessStoryArgs = {
  storyId?: Maybe<Scalars['ID']>;
};


export type QuerySuccessStoryBySlugArgs = {
  slug: Scalars['String'];
};


export type QuerySurveyArgs = {
  id: Scalars['ID'];
};


export type QuerySurveyAnalyticsArgs = {
  dimension: Scalars['String'];
  filter?: Maybe<SurveyAnalyticsFilter>;
};


export type QuerySurveyAssignmentResultsArgs = {
  assignmentId: Scalars['ID'];
};


export type QuerySurveyAssignmentsArgs = {
  surveyId: Scalars['ID'];
  groupIds?: Maybe<Array<Scalars['ID']>>;
  planId?: Maybe<Scalars['ID']>;
  onlyActive?: Maybe<Scalars['Boolean']>;
  origin?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};


export type QuerySurveyCommentsArgs = {
  filter?: Maybe<SurveyAnalyticsFilter>;
  search?: Maybe<Scalars['String']>;
  sentiment?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  problemOnly?: Maybe<Scalars['Boolean']>;
};


export type QuerySurveyDigestsArgs = {
  scope: Scalars['String'];
  scopeId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySurveyGroupStudentsArgs = {
  groupId: Scalars['ID'];
};


export type QuerySurveyGroupTimelineArgs = {
  groupId: Scalars['ID'];
};


export type QuerySurveyQuestionBreakdownArgs = {
  surveyId: Scalars['ID'];
  questionId: Scalars['ID'];
  dimension: Scalars['String'];
  filter?: Maybe<SurveyAnalyticsFilter>;
};


export type QuerySurveyQuestionTagsArgs = {
  onlyUntagged?: Maybe<Scalars['Boolean']>;
  courseId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
};


export type QuerySurveyResponseDetailArgs = {
  responseId: Scalars['ID'];
};


export type QuerySurveyResponseMatrixArgs = {
  surveyId: Scalars['ID'];
  groupIds?: Maybe<Array<Scalars['ID']>>;
};


export type QuerySurveySignalsArgs = {
  dimensions?: Maybe<Array<Scalars['String']>>;
  minSample?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  filter?: Maybe<SurveyAnalyticsFilter>;
};


export type QuerySurveySummaryArgs = {
  surveyId: Scalars['ID'];
  groupIds?: Maybe<Array<Scalars['ID']>>;
  planId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
};


export type QuerySurveyTargetGroupsArgs = {
  surveyId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  onlyActive?: Maybe<Scalars['Boolean']>;
  triggerKind?: Maybe<Scalars['String']>;
  triggerLessonNumber?: Maybe<Scalars['Int']>;
};


export type QuerySurveyTargetingArgs = {
  surveyId: Scalars['ID'];
};


export type QuerySurveysArgs = {
  courseId?: Maybe<Scalars['ID']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryTaskLinkSearchArgs = {
  kind: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryTaskSmartLinksArgs = {
  text: Scalars['String'];
};


export type QueryTeacherArgs = {
  teacherId?: Maybe<Scalars['ID']>;
};


export type QueryTeacherAiProfileArgs = {
  teacherId: Scalars['ID'];
};


export type QueryTeacherApplicationArgs = {
  applicationId: Scalars['ID'];
};


export type QueryTeacherBillingEntitiesArgs = {
  teacherId: Scalars['ID'];
  includeInactive?: Maybe<Scalars['Boolean']>;
};


export type QueryTeacherCandidateGroupsArgs = {
  teacherId: Scalars['ID'];
};


export type QueryTeacherConversationsArgs = {
  teacherId: Scalars['ID'];
};


export type QueryTeacherConversationsPageArgs = {
  kinds?: Maybe<Array<Scalars['String']>>;
  teacherId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type QueryTeacherDocumentDownloadUrlArgs = {
  documentId: Scalars['ID'];
};


export type QueryTeacherDocumentTextArgs = {
  documentId: Scalars['ID'];
};


export type QueryTeacherDocumentsArgs = {
  teacherId: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
};


export type QueryTeacherInterviewTranscriptArgs = {
  interviewId: Scalars['ID'];
};


export type QueryTeacherInterviewVideoUrlArgs = {
  interviewId: Scalars['ID'];
};


export type QueryTeacherInterviewsArgs = {
  teacherId: Scalars['ID'];
};


export type QueryTeacherLoadArgs = {
  teacherId: Scalars['ID'];
  horizonDays?: Maybe<Scalars['Int']>;
};


export type QueryTeacherSmsArgs = {
  teacherId: Scalars['ID'];
};


export type QueryTeacherSurveyFeedbackArgs = {
  teacherId: Scalars['ID'];
  courseId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  bucket?: Maybe<Scalars['String']>;
};


export type QueryTeacherSurveyLeaderboardArgs = {
  courseId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  minResponses?: Maybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  search?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  email_Icontains?: Maybe<Scalars['String']>;
  email_Istartswith?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastName_Icontains?: Maybe<Scalars['String']>;
  lastName_Istartswith?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstName_Icontains?: Maybe<Scalars['String']>;
  firstName_Istartswith?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phone_Icontains?: Maybe<Scalars['String']>;
  phone_Istartswith?: Maybe<Scalars['String']>;
};


export type QueryVerifyStudentArgs = {
  email: Scalars['String'];
  phone: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
};


export type QueryVerifyTeacherArgs = {
  teacherInput: BaseTeacherInput;
};


export type QueryZoomAuditLogArgs = {
  userId?: Maybe<Scalars['ID']>;
  action?: Maybe<Scalars['String']>;
  targetKind?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryZoomDashboardArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
};


export type QueryZoomLessonArgs = {
  groupLessonId: Scalars['ID'];
};


export type QueryZoomLessonParticipantsArgs = {
  lessonId: Scalars['ID'];
};


export type QueryZoomLessonRosterArgs = {
  lessonId: Scalars['ID'];
};


export type QueryZoomParticipantsCoverageArgs = {
  groupId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
};

export type DocumentTemplateType = {
  __typename?: 'DocumentTemplateType';
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
  /** completion | participation | attendance | custom */
  kind: Scalars['String'];
  /** student | group */
  scope: Scalars['String'];
  isActive: Scalars['Boolean'];
  legalEntityId?: Maybe<Scalars['ID']>;
  legalEntityName?: Maybe<Scalars['String']>;
  /** Номер текущей версии */
  version?: Maybe<Scalars['Int']>;
  currentVersionId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  updatedByName: Scalars['String'];
  /** История, новые первыми */
  versions: Array<DocumentTemplateVersionType>;
};


export type DocumentTemplateVersionType = {
  __typename?: 'DocumentTemplateVersionType';
  id: Scalars['ID'];
  version: Scalars['Int'];
  /** git | erp */
  origin: Scalars['String'];
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByName: Scalars['String'];
  isCurrent: Scalars['Boolean'];
};

export type DocumentTemplateEditableType = {
  __typename?: 'DocumentTemplateEditableType';
  template: DocumentTemplateType;
  html: Scalars['String'];
  tokens: Array<ContractTemplateTokenType>;
  variables: Array<ContractTemplateVariableType>;
};

/** Чип редактора: `n` — номер в `data-tpl="n"` (или `<!--tpl:n-->`). */
export type ContractTemplateTokenType = {
  __typename?: 'ContractTemplateTokenType';
  n: Scalars['Int'];
  /** var | tag | sign */
  kind: Scalars['String'];
  /** var | logic | comment | struct | sign */
  role: Scalars['String'];
  /** Код шаблона (title) */
  code: Scalars['String'];
  /** Подпись по-русски */
  label: Scalars['String'];
  /** Подпись по-польски */
  labelPl: Scalars['String'];
  /** Переменную и комментарий можно удалить; логику и подписи — нет */
  removable: Scalars['Boolean'];
  /** chip — <span data-tpl>; comment — <!--tpl:n--> между строками таблицы (браузер вынес бы span из таблицы) */
  placement: Scalars['String'];
};

/** Переменная палитры: вставка — `<span data-tpl-new="var:<code>">`. */
export type ContractTemplateVariableType = {
  __typename?: 'ContractTemplateVariableType';
  code: Scalars['String'];
  group: Scalars['String'];
  label: Scalars['String'];
  labelPl: Scalars['String'];
  groupLabel: Scalars['String'];
  groupLabelPl: Scalars['String'];
};

export type DocumentPreviewDraftType = {
  __typename?: 'DocumentPreviewDraftType';
  /** HTML образца; пусто — есть problems */
  html?: Maybe<Scalars['String']>;
  problems: Array<ContractTemplateProblemType>;
};

export type ContractTemplateProblemType = {
  __typename?: 'ContractTemplateProblemType';
  code: Scalars['String'];
  message: Scalars['String'];
  /** Номер чипа, если проблема в нём */
  token?: Maybe<Scalars['Int']>;
};

export type DocumentPreviewType = {
  __typename?: 'DocumentPreviewType';
  /** HTML для iframe; пусто — ошибка */
  html?: Maybe<Scalars['String']>;
  /** Номер будет присвоен при выпуске: ZAS/2026/10/____ */
  numberPreview?: Maybe<Scalars['String']>;
  /** Поля без данных — в html подсвечены */
  missingFields: Array<DocumentMissingFieldType>;
  /** Поля, которые шаблон печатает, но вам их видеть нельзя (PESEL — только управленцам ERP): в html пусто и без подсветки, в missingFields их нет */
  hiddenFields: Array<DocumentMissingFieldType>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type DocumentMissingFieldType = {
  __typename?: 'DocumentMissingFieldType';
  code: Scalars['String'];
  label: Scalars['String'];
  labelPl: Scalars['String'];
};

export type IssuedDocumentType = {
  __typename?: 'IssuedDocumentType';
  id: Scalars['ID'];
  number: Scalars['String'];
  kind: Scalars['String'];
  scope: Scalars['String'];
  templateId: Scalars['ID'];
  templateName: Scalars['String'];
  templateVersion: Scalars['Int'];
  studentId?: Maybe<Scalars['ID']>;
  studentName?: Maybe<Scalars['String']>;
  agreementId?: Maybe<Scalars['ID']>;
  agreementTitle?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  issueDate: Scalars['Date'];
  issuePlace: Scalars['String'];
  issuedAt: Scalars['DateTime'];
  issuedByName: Scalars['String'];
  missingFields: Array<Scalars['String']>;
  /** Коды полей, напечатанных пустыми по правам выдавшего */
  hiddenFields: Array<Scalars['String']>;
  /** PDF сохранён (иначе — собирается из HTML выпуска) */
  hasFile: Scalars['Boolean'];
  /** Отправки письмом, новые первыми */
  sends: Array<IssuedDocumentSendType>;
};


export type IssuedDocumentSendType = {
  __typename?: 'IssuedDocumentSendType';
  id: Scalars['ID'];
  sentAt: Scalars['DateTime'];
  sentTo: Scalars['String'];
  sentByName: Scalars['String'];
  mailboxEmail: Scalars['String'];
  conversationId?: Maybe<Scalars['ID']>;
};

export type DocumentSendDefaultsType = {
  __typename?: 'DocumentSendDefaultsType';
  /** E-mail студента; пусто — нет адреса */
  to: Scalars['String'];
  subject: Scalars['String'];
  /** Черновик по-польски */
  html: Scalars['String'];
  /** Ящик по умолчанию (свой личный — первым); пусто — писать не с чего */
  mailboxEmail?: Maybe<Scalars['String']>;
  /** Ящики, с которых можно писать */
  mailboxes: Array<Scalars['String']>;
};

export type DocumentFileType = {
  __typename?: 'DocumentFileType';
  fileName: Scalars['String'];
  contentType: Scalars['String'];
  contentBase64: Scalars['String'];
};

export type AiBuiltinToolType = {
  __typename?: 'AiBuiltinToolType';
  name: Scalars['String'];
  /** Toolset code: search | student | group | money | comms | work | learning | catalog | school_money | quality | triage | write | cash_flow | cash_flow_write | forecast | funding | marketing | analytics | career | career_vacancy_write | passthrough | mcp_meta | platform */
  group: Scalars['String'];
  /** read | write_confirm | write_direct */
  kind: Scalars['String'];
  /** What the model sees. */
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  defaultEnabled: Scalars['Boolean'];
};

export type AiAgentSkillType = {
  __typename?: 'AiAgentSkillType';
  id: Scalars['ID'];
  /** SKILL.md name; plugin skills are «plugin:skill» */
  slug: Scalars['String'];
  title: Scalars['String'];
  /** When to use (≤ 1024) */
  description: Scalars['String'];
  /** markdown */
  instructions: Scalars['String'];
  /** draft | published | archived */
  status: Scalars['String'];
  /** manual | imported | plugin | builtin */
  source: Scalars['String'];
  version: Scalars['Int'];
  agents: Array<Scalars['String']>;
  files: Array<AiSkillFileType>;
  pluginId?: Maybe<Scalars['ID']>;
  pluginName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  /** Beyond §4: what was not imported (binary files, files over the limits). */
  skipped: Array<Scalars['String']>;
};

export type AiSkillFileType = {
  __typename?: 'AiSkillFileType';
  path: Scalars['String'];
  /** bytes (UTF-8) */
  size: Scalars['Int'];
  /** File text — only in aiSkill(id) (null in lists and mutation results); edit one by one, save all via AiSkillInput.files. */
  text?: Maybe<Scalars['String']>;
};

export type AiMcpConnectionType = {
  __typename?: 'AiMcpConnectionType';
  id: Scalars['ID'];
  /** Chat tool names: mcp__<slug>__<tool> */
  slug: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
  /** streamable_http | sse */
  transport: Scalars['String'];
  /** none | header | oauth */
  authType: Scalars['String'];
  headerName?: Maybe<Scalars['String']>;
  /** A header token is stored. The token itself is write-only. */
  hasSecret: Scalars['Boolean'];
  oauthConnected: Scalars['Boolean'];
  oauthExpiresAt?: Maybe<Scalars['DateTime']>;
  allowPii: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  /** never_checked | ok | error | needs_auth | unsupported */
  status: Scalars['String'];
  lastCheckedAt?: Maybe<Scalars['DateTime']>;
  /** Code: blocked_url | live_disabled | timeout | network | redirect_refused | http_error | auth_required | forbidden | protocol_error | secret_missing | secrets_key_missing | secret_unreadable | oauth_refresh_failed | oauth_not_connected | internal_error (oauth_temporarily_unavailable is never stored: a transient refresh failure keeps the status) */
  lastError?: Maybe<Scalars['String']>;
  serverName?: Maybe<Scalars['String']>;
  serverVersion?: Maybe<Scalars['String']>;
  tools: Array<AiMcpToolType>;
  pluginId?: Maybe<Scalars['ID']>;
  pluginName?: Maybe<Scalars['String']>;
  /** Polish text of the notes (backward compatibility) — translate notes / noteCode instead. */
  note?: Maybe<Scalars['String']>;
  /** Notes as machine codes (all). */
  notes: Array<AiExtNoteType>;
  /** Code of the first note (null — no notes). */
  noteCode?: Maybe<Scalars['String']>;
  /** Params of the first note. */
  noteParams?: Maybe<Scalars['JSONString']>;
};

export type AiMcpToolType = {
  __typename?: 'AiMcpToolType';
  name: Scalars['String'];
  description: Scalars['String'];
  inputSchema?: Maybe<Scalars['JSONString']>;
  enabled: Scalars['Boolean'];
  requiresApproval: Scalars['Boolean'];
  /** Beyond §4: the server did not return this tool at the last check (never offered to the chat). */
  missing: Scalars['Boolean'];
  /** The server changed this tool's description or input schema at the last check: it requires approval again until the admin saves its settings (setAiMcpToolSettings with this tool clears the flag). */
  changed: Scalars['Boolean'];
  /** Why the tool is never offered to the chat (input schema not accepted by LLM providers): schema_not_object | schema_combinator | schema_property_name | schema_too_deep | schema_too_large | name_invalid. null — supported. */
  unsupportedReason?: Maybe<Scalars['String']>;
};


/** Пометка машинным кодом — ERP переводит сама (ru/pl). */
export type AiExtNoteType = {
  __typename?: 'AiExtNoteType';
  /** Connection notes: needs_secret {header, value, var, vars} | header_skipped {header} | oauth_hint. Plugin skipped items: servers_not_object | entry_invalid {server} | stdio_unsupported {server, command} | transport_unsupported {server, type} | url_missing {server} | url_variable {server, url, vars} | url_invalid {server, reason, message} | unsafe_path {path} | outside_plugin {path} | skill_invalid {folder, reason, message} | folder_unsupported {folder, count} | hooks_unsupported */
  code: Scalars['String'];
  /** Code parameters (object). */
  params?: Maybe<Scalars['JSONString']>;
};

export type AiPluginType = {
  __typename?: 'AiPluginType';
  id: Scalars['ID'];
  name: Scalars['String'];
  version?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  skills: Array<AiAgentSkillType>;
  connections: Array<AiMcpConnectionType>;
  /** Polish text (backward compatibility) — translate skippedItems instead. */
  skipped: Array<Scalars['String']>;
  /** What was not imported, as machine codes (e.g. stdio_unsupported). */
  skippedItems: Array<AiExtNoteType>;
  createdAt: Scalars['DateTime'];
};

export type AiChatThreadType = {
  __typename?: 'AiChatThreadType';
  id: Scalars['ID'];
  title: Scalars['String'];
  /** active | archived */
  status: Scalars['String'];
  createdAt: Scalars['DateTime'];
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  /** Set — the thread is pinned. */
  pinnedAt?: Maybe<Scalars['DateTime']>;
};

export type AiChatThreadDetailType = {
  __typename?: 'AiChatThreadDetailType';
  thread: AiChatThreadType;
  /** Oldest first. */
  messages: Array<AiChatMessageType>;
  /** Latest run of the thread while queued | running | waiting_human; poll the thread while it is set. */
  activeRun?: Maybe<AiAgentRunType>;
  /** Latest run of the thread in any status (show a failed turn). */
  lastRun?: Maybe<AiAgentRunType>;
  /** Tool calls of the shown messages, oldest first. */
  toolEvents: Array<AiChatToolEventType>;
};

export type AiChatMessageType = {
  __typename?: 'AiChatMessageType';
  id: Scalars['ID'];
  /** user | assistant | tool (note: an action was approved / rejected) */
  role: Scalars['String'];
  /** Assistant: grows while the run streams (partial text). */
  text?: Maybe<Scalars['String']>;
  /** Assistant: the run failed or was cancelled mid-answer — the text is partial. */
  interrupted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  toolCalls: Array<AiChatToolCallType>;
  pendingActions: Array<AiChatPendingActionType>;
  mentions: Array<AiChatMentionType>;
  /** Widgets: [{kind: table|list|stats|entity_cards|chart, title, data}]; chart data: {type: line|bar|area|pie|donut|scatter|bubble|box|heatmap|combo, labels, series: [{name, values (null = gap), unit?, currency?, axis?, type?, stack?, points?, boxes?}], orientation?, stacked?, rows?, cols?, cells?} */
  blocks: Scalars['JSONString'];
  attachments: Array<AiChatAttachmentType>;
  toolEvents: Array<AiChatToolEventType>;
};

export type AiChatToolCallType = {
  __typename?: 'AiChatToolCallType';
  name: Scalars['String'];
  argsSummary: Scalars['String'];
  /** ok | error | pending_approval */
  status: Scalars['String'];
  resultSummary?: Maybe<Scalars['String']>;
  source?: Maybe<AiToolSourceType>;
};

/**
 * Откуда инструмент (раунд 3, §3.7a): ERP, скил, внешний MCP или
 * платформа (база знаний, запуск агента).
 */
export type AiToolSourceType = {
  __typename?: 'AiToolSourceType';
  /** erp | skill | mcp | platform */
  kind: Scalars['String'];
  /** ERP | skill title | MCP connection title | Baza wiedzy | Agenci AI */
  label: Scalars['String'];
};

export type AiChatPendingActionType = {
  __typename?: 'AiChatPendingActionType';
  id: Scalars['ID'];
  /** ERP write tool (erp_*) or external tool mcp__<connection>__<tool> */
  tool: Scalars['String'];
  /** pl, multi-line */
  willDo: Scalars['String'];
  /** pending | approved | rejected | executed | failed | expired */
  status: Scalars['String'];
  /** pl */
  result?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  source?: Maybe<AiToolSourceType>;
};

export type AiChatMentionType = {
  __typename?: 'AiChatMentionType';
  /** Task link kind (student | teacher | group | course | kommo_lead | lesson | …) or skill | tool */
  kind: Scalars['String'];
  /** Object pk; skill slug; tool name (mcp__<server>__<tool> too) */
  id: Scalars['String'];
  label: Scalars['String'];
};

export type AiChatAttachmentType = {
  __typename?: 'AiChatAttachmentType';
  id: Scalars['ID'];
  /** Presigned GET, ~10 min; re-read the thread for a fresh one. */
  url: Scalars['String'];
  name: Scalars['String'];
  /** image/png | jpeg | webp | gif */
  mime: Scalars['String'];
  size: Scalars['Int'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type AiChatToolEventType = {
  __typename?: 'AiChatToolEventType';
  id: Scalars['ID'];
  /** Assistant message of the turn. */
  messageId: Scalars['ID'];
  seq: Scalars['Int'];
  name: Scalars['String'];
  /** Real (unmasked) arguments. */
  args: Scalars['JSONString'];
  /** running | ok | error | pending_approval */
  status: Scalars['String'];
  /** ≤ 4 KB, real values. */
  resultPreview: Scalars['String'];
  source?: Maybe<AiToolSourceType>;
  startedAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
};

export type AiAgentRunType = {
  __typename?: 'AiAgentRunType';
  id: Scalars['ID'];
  agentKey: Scalars['String'];
  /** beat | signal | manual | chat | backfill | eval */
  trigger: Scalars['String'];
  /** queued | running | waiting_human | done | failed | cancelled | skipped */
  status: Scalars['String'];
  subjectKind?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['ID']>;
  subjectLabel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  startedAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  durationMs?: Maybe<Scalars['Int']>;
  provider?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  inputTokens: Scalars['Int'];
  cachedTokens: Scalars['Int'];
  outputTokens: Scalars['Int'];
  costUsd: Scalars['Float'];
  resultSummary?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  steps: Array<AiAgentRunStepType>;
};

export type AiAgentRunStepType = {
  __typename?: 'AiAgentRunStepType';
  id: Scalars['ID'];
  node: Scalars['String'];
  /** running | done | failed | skipped */
  status: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type AiChatMentionSuggestionType = {
  __typename?: 'AiChatMentionSuggestionType';
  kind: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  sublabel: Scalars['String'];
};

export type AiKbCandidatePageType = {
  __typename?: 'AiKbCandidatePageType';
  items: Array<AiKbCandidateType>;
  total: Scalars['Int'];
};

export type AiKbCandidateType = {
  __typename?: 'AiKbCandidateType';
  id: Scalars['ID'];
  /** new_fact | contradiction | gap */
  kind: Scalars['String'];
  category: Scalars['String'];
  /** Rule, Polish */
  claim: Scalars['String'];
  question: Scalars['String'];
  targetDocumentId?: Maybe<Scalars['ID']>;
  targetDocumentTitle?: Maybe<Scalars['String']>;
  targetHeading: Scalars['String'];
  conflictRefs: Array<Scalars['String']>;
  conflicts: Array<AiKbConflictType>;
  evidence: Array<AiKbEvidenceType>;
  supportCount: Scalars['Int'];
  confidence?: Maybe<Scalars['Float']>;
  /** pending | approved | rejected | duplicate */
  status: Scalars['String'];
  duplicateOfId?: Maybe<Scalars['ID']>;
  rejectReason: Scalars['String'];
  reviewedByName?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  appliedRevisionVersion?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type AiKbConflictType = {
  __typename?: 'AiKbConflictType';
  /** kb:<doc>#<ordinal> */
  ref: Scalars['String'];
  documentId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  headingPath?: Maybe<Scalars['String']>;
  /** Chunk text, read live */
  text?: Maybe<Scalars['String']>;
};

export type AiKbEvidenceType = {
  __typename?: 'AiKbEvidenceType';
  /** gmail | slack | aplora_call | reply_diff | missing_info */
  source: Scalars['String'];
  ref: Scalars['String'];
  at?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['ID']>;
  messageId?: Maybe<Scalars['ID']>;
  /** Aplora call UUID */
  callId?: Maybe<Scalars['String']>;
  suggestionId?: Maybe<Scalars['ID']>;
  /** Group of the conversation (or of the student) for the communicator link — only when the viewer can see the conversation */
  groupId?: Maybe<Scalars['ID']>;
  /** Student of the conversation — only when the viewer can see it */
  studentId?: Maybe<Scalars['ID']>;
  /** Live quote of the message — only when the viewer can see the conversation */
  excerpt?: Maybe<Scalars['String']>;
};

export type AiKbReviewerMeType = {
  __typename?: 'AiKbReviewerMeType';
  isAdmin: Scalars['Boolean'];
  /** Categories the viewer reviews (Admin — all) */
  categories: Array<Scalars['String']>;
  pendingCount: Scalars['Int'];
};

export type AiKbReviewerCategoryType = {
  __typename?: 'AiKbReviewerCategoryType';
  category: Scalars['String'];
  users: Array<AiKbReviewerUserType>;
};

export type AiKbReviewerUserType = {
  __typename?: 'AiKbReviewerUserType';
  id: Scalars['ID'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
};

export type AiKnowledgeDocumentType = {
  __typename?: 'AiKnowledgeDocumentType';
  id: Scalars['ID'];
  title: Scalars['String'];
  /** style | company | funding | payments | operations | lms | lessons | sales | marketing | career | other */
  category: Scalars['String'];
  /** draft | published | archived */
  status: Scalars['String'];
  /** markdown */
  body: Scalars['String'];
  /** Name of the uploaded file the body was extracted from */
  sourceFileName?: Maybe<Scalars['String']>;
  /** Grows with every body change */
  version: Scalars['Int'];
  /** Estimate: characters / 3.6 */
  tokens: Scalars['Int'];
  chunkCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  updatedByName?: Maybe<Scalars['String']>;
  /** Content last confirmed as current (button, body edit, approved candidate); older than AI_KB_STALE_DAYS — reminder task */
  verifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedByName?: Maybe<Scalars['String']>;
  /** Published and not confirmed for longer than AI_KB_STALE_DAYS */
  stale: Scalars['Boolean'];
};

export type AiKnowledgeStatsType = {
  __typename?: 'AiKnowledgeStatsType';
  publishedCount: Scalars['Int'];
  publishedTokens: Scalars['Int'];
  /** prefix (whole base in the prompt) | search (top-k: FTS + vectors) | empty */
  strategy: Scalars['String'];
  /** AI_KB_RETRIEVAL_MODE: search (default) | prefix (fallback) */
  retrievalMode: Scalars['String'];
  /** '' — vector search is on; no_api_key | stand | disabled | no_vector_table — FTS only */
  vectorsOffReason: Scalars['String'];
  /** Chunks of published documents with a vector of the current embedding model */
  vectorCoverage: AiKbVectorCoverageType;
  /** Start of the last nightly embed_sweep run */
  lastSweepAt?: Maybe<Scalars['DateTime']>;
  /** running | success | skipped | failed */
  lastSweepStatus?: Maybe<Scalars['String']>;
  /** Error or skip reason of the last embed_sweep run */
  lastSweepError?: Maybe<Scalars['String']>;
};

export type AiKbVectorCoverageType = {
  __typename?: 'AiKbVectorCoverageType';
  withVector: Scalars['Int'];
  total: Scalars['Int'];
};

/** ТЗ 0118 B1: снимок документа после сохранения, изменившего тело. */
export type AiKnowledgeRevisionType = {
  __typename?: 'AiKnowledgeRevisionType';
  id: Scalars['ID'];
  version: Scalars['Int'];
  title: Scalars['String'];
  category: Scalars['String'];
  /** baseline | create | edit | upload | import | candidate | rollback */
  reason: Scalars['String'];
  authorName?: Maybe<Scalars['String']>;
  candidateId?: Maybe<Scalars['ID']>;
  /** markdown */
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
};

export type AiKnowledgeHitType = {
  __typename?: 'AiKnowledgeHitType';
  documentId: Scalars['ID'];
  title: Scalars['String'];
  headingPath: Scalars['String'];
  text: Scalars['String'];
  rank: Scalars['Float'];
};

export type AiLessonAnalysisType = {
  __typename?: 'AiLessonAnalysisType';
  id: Scalars['ID'];
  lessonId: Scalars['ID'];
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  /** Course of the lesson's group — for aiCourseLessonComparison */
  courseId?: Maybe<Scalars['ID']>;
  /** N of the lesson in its group: regular (not additional) lessons by date and time */
  lessonNumber?: Maybe<Scalars['Int']>;
  lessonStartsAt?: Maybe<Scalars['DateTime']>;
  teacherName?: Maybe<Scalars['String']>;
  /** queued | running | ready | human_review_required | insufficient_data | failed */
  status: Scalars['String'];
  /** strong | generally_effective | needs_targeted_improvement | needs_methodologist_support | insufficient_data | human_review_required */
  lessonStatus?: Maybe<Scalars['String']>;
  /** 0–100, coaching score */
  overallScore?: Maybe<Scalars['Float']>;
  /** Strength of available understanding evidence, 0–100 (not a share of students) */
  understandingScore?: Maybe<Scalars['Float']>;
  /** weak | limited | moderate | strong | very_strong | insufficient_data */
  understandingBand?: Maybe<Scalars['String']>;
  /** pl */
  summary?: Maybe<Scalars['String']>;
  strengths: Array<Scalars['String']>;
  /** pl */
  developmentArea?: Maybe<Scalars['String']>;
  criteria: Array<AiLessonCriterionType>;
  recommendation?: Maybe<AiLessonRecommendationType>;
  alerts: Array<Scalars['String']>;
  /** none | open | reviewed_confirmed | reviewed_not_confirmed */
  reviewStatus: Scalars['String'];
  reviewNote?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Error CODE of a failed analysis: internal_error | no_transcript | budget_exceeded | abandoned | cancelled | ai_disabled */
  error?: Maybe<Scalars['String']>;
  /** Full lesson-analysis-v1.1.0 JSON (speakers as codes T01/S01) */
  report?: Maybe<Scalars['JSONString']>;
  /** Legend of speaker codes used in the texts */
  speakers: Array<AiLessonSpeakerType>;
};

export type AiLessonCriterionType = {
  __typename?: 'AiLessonCriterionType';
  /** Criterion code (practicality …) — not unique across analyses */
  id: Scalars['String'];
  /** pl */
  label: Scalars['String'];
  weight: Scalars['Float'];
  /** scored | insufficient_data | not_applicable | blocked_by_quality | human_review_required */
  status: Scalars['String'];
  /** 0–4 in 0.5 steps */
  score?: Maybe<Scalars['Float']>;
  /** high | medium | low | unknown */
  confidence?: Maybe<Scalars['String']>;
  /** pl */
  whyScore?: Maybe<Scalars['String']>;
  /** pl */
  whyNotHigher?: Maybe<Scalars['String']>;
  /** pl, one requirement per line */
  nextLevel?: Maybe<Scalars['String']>;
};

export type AiLessonRecommendationType = {
  __typename?: 'AiLessonRecommendationType';
  /** R01–R05 */
  ruleId: Scalars['String'];
  /** pl */
  name: Scalars['String'];
  /** pl */
  action: Scalars['String'];
  steps: Array<Scalars['String']>;
  /** pl */
  implementationCheck: Scalars['String'];
  /** pl */
  effectCheck: Scalars['String'];
};

/**
 * Легенда кодов спикеров: тексты разбора говорят `T01`/`S03`, а
 * методисту нужно знать, кто это (подпись участника в Zoom).
 */
export type AiLessonSpeakerType = {
  __typename?: 'AiLessonSpeakerType';
  /** T01 | S01 … */
  code: Scalars['String'];
  /** Zoom speaker label */
  label: Scalars['String'];
  /** teacher | student */
  role: Scalars['String'];
};

export type AiLessonAnalysisPageType = {
  __typename?: 'AiLessonAnalysisPageType';
  rows: Array<AiLessonAnalysisType>;
  total: Scalars['Int'];
  hasMore: Scalars['Boolean'];
};

export type AiTeacherPracticePortraitType = {
  __typename?: 'AiTeacherPracticePortraitType';
  teacherId: Scalars['ID'];
  lessonsAnalyzed: Scalars['Int'];
  /** lesson_only | preliminary | hypotheses | provisional | stable */
  maturity: Scalars['String'];
  criteria: Array<AiPracticeCriterionStatType>;
  /** pl; latest ready AI narrative (generateAiTeacherNarrative), null until generated */
  narrative?: Maybe<Scalars['String']>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  /** When the shown narrative was generated */
  narrativeGeneratedAt?: Maybe<Scalars['DateTime']>;
  /** How many lesson analyses the shown narrative is based on */
  narrativeAnalysesCount?: Maybe<Scalars['Int']>;
  /** Status of the latest generation attempt newer than the shown narrative: queued | running (poll) | failed; null — none */
  narrativeStatus?: Maybe<Scalars['String']>;
  /** Error CODE when narrativeStatus = failed */
  narrativeError?: Maybe<Scalars['String']>;
  /** Analyses needed to generate a narrative (not_enough_data below) */
  narrativeMinAnalyses: Scalars['Int'];
};

export type AiPracticeCriterionStatType = {
  __typename?: 'AiPracticeCriterionStatType';
  /** Criterion code */
  id: Scalars['String'];
  /** pl */
  label: Scalars['String'];
  n: Scalars['Int'];
  median?: Maybe<Scalars['Float']>;
  q1?: Maybe<Scalars['Float']>;
  q3?: Maybe<Scalars['Float']>;
  /** 0–1 */
  coverage: Scalars['Float'];
  /** up | down | flat; null below 4 scores */
  trend?: Maybe<Scalars['String']>;
};

export type AiCourseLessonComparisonType = {
  __typename?: 'AiCourseLessonComparisonType';
  courseId: Scalars['ID'];
  lessonNumber: Scalars['Int'];
  rows: Array<AiCourseLessonRowType>;
};

export type AiCourseLessonRowType = {
  __typename?: 'AiCourseLessonRowType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  lessonId?: Maybe<Scalars['ID']>;
  lessonStartsAt?: Maybe<Scalars['DateTime']>;
  teacherName?: Maybe<Scalars['String']>;
  overallScore?: Maybe<Scalars['Float']>;
  recommendationRule?: Maybe<Scalars['String']>;
  /** {criterionId: score|null} */
  criteria?: Maybe<Scalars['JSONString']>;
};

export type AiLessonEstimateType = {
  __typename?: 'AiLessonEstimateType';
  lessons: Scalars['Int'];
  withTranscript: Scalars['Int'];
  withoutTranscript: Scalars['Int'];
  /** Have a finished analysis — a run without force returns it */
  alreadyAnalyzed: Scalars['Int'];
  running: Scalars['Int'];
  /** Will cost money: transcript, no analysis yet */
  toAnalyze: Scalars['Int'];
  transcriptBytes: Scalars['Float'];
  /** S3 size not readable — estimated by the average */
  unknownSize: Scalars['Int'];
  /** Approximate cost of `toAnalyze` (USD); analysed and running lessons cost 0 */
  estimatedCostUsd: Scalars['Float'];
  /** Approximate cost of queued/running analyses not yet charged — reserved from the budget (0 without a budget limit) */
  inFlightCostUsd: Scalars['Float'];
  /** history (past analyses cost/byte) | formula (tokens × price) */
  costBasis: Scalars['String'];
  /** Admin only; null else */
  budgetSpentUsd?: Maybe<Scalars['Float']>;
  /** Admin only; null else */
  budgetLimitUsd?: Maybe<Scalars['Float']>;
  /** Admin only; null else */
  budgetLeftUsd?: Maybe<Scalars['Float']>;
  /** inFlightCostUsd + estimatedCostUsd fit the remaining monthly budget (the smaller of the global and the agent limit) — the same reservation requestAiLessonAnalyses applies */
  budgetEnough: Scalars['Boolean'];
};

export type AiLessonViewType = {
  __typename?: 'AiLessonViewType';
  lessonId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  isOver: Scalars['Boolean'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
  teacherName?: Maybe<Scalars['String']>;
  hasTranscript: Scalars['Boolean'];
  /** LessonRecording status; null without a recording or without the Zoom roles */
  recordingStatus?: Maybe<Scalars['String']>;
  /** Signed URL — Zoom roles (Admin, AccountManager, Methodist); null otherwise (HR) or without a video */
  videoUrl?: Maybe<Scalars['String']>;
  /** Zoom roles only */
  aiSummary?: Maybe<Scalars['String']>;
  /** Zoom roles only */
  aiTimecodes?: Maybe<Scalars['JSONString']>;
  analysis?: Maybe<AiLessonAnalysisType>;
  /** Surveys triggered by this lesson; survey insight roles */
  surveys: Array<AiLessonSurveyType>;
};

export type AiLessonSurveyType = {
  __typename?: 'AiLessonSurveyType';
  assignmentId: Scalars['ID'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  isActive: Scalars['Boolean'];
  responsesCount: Scalars['Int'];
  eligibleCount: Scalars['Int'];
  questions: Array<AiLessonSurveyQuestionType>;
  /** Text answers, without student names */
  comments: Array<AiLessonSurveyCommentType>;
};

export type AiLessonSurveyQuestionType = {
  __typename?: 'AiLessonSurveyQuestionType';
  questionId: Scalars['ID'];
  question: Scalars['String'];
  questionType: Scalars['String'];
  answersCount: Scalars['Int'];
  /** Scale questions; null otherwise */
  average?: Maybe<Scalars['Float']>;
};

export type AiLessonSurveyCommentType = {
  __typename?: 'AiLessonSurveyCommentType';
  questionId: Scalars['ID'];
  question: Scalars['String'];
  text: Scalars['String'];
  submittedAt?: Maybe<Scalars['DateTime']>;
};

export type AiStudentPortraitType = {
  __typename?: 'AiStudentPortraitType';
  studentId: Scalars['ID'];
  /** none | queued | running | ready | failed */
  status: Scalars['String'];
  /** There are student events newer than the portrait */
  stale: Scalars['Boolean'];
  generatedAt?: Maybe<Scalars['DateTime']>;
  model?: Maybe<Scalars['String']>;
  /** Code of the last failed refresh: budget_exceeded | ai_disabled | not_found | internal_error */
  error?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  learning?: Maybe<Scalars['String']>;
  engagement?: Maybe<Scalars['String']>;
  sentimentTrend?: Maybe<Scalars['String']>;
  communication?: Maybe<Scalars['String']>;
  risks: Array<AiPortraitItemType>;
  openNeeds: Array<AiPortraitItemType>;
  nextActions: Array<AiPortraitItemType>;
  /** Who the student is (v3; v2 — empty) */
  about: Array<AiPortraitFactType>;
  strengths: Array<AiPortraitItemType>;
  concerns: Array<AiPortraitItemType>;
  /** motivation, funding_need, tech_level, engagement, attendance, payment — in this order (v2 — empty); payment is unknown for roles without finance access */
  checkpoints: Array<AiPortraitCheckpointType>;
};

export type AiPortraitItemType = {
  __typename?: 'AiPortraitItemType';
  /** pl */
  text: Scalars['String'];
  /** low | normal | high */
  severity?: Maybe<Scalars['String']>;
  evidence: Array<AiEvidenceRefType>;
};

export type AiEvidenceRefType = {
  __typename?: 'AiEvidenceRefType';
  /** message | attendance | mark | note | task | survey | sms | payment | invoice | funding | agreement | aplora_lead | aplora_call */
  kind: Scalars['String'];
  /** Object id (attendance / mark: group id; funding: candidate id; aplora_lead: Kommo lead id; aplora_call: Aplora call id); null = no object */
  id?: Maybe<Scalars['ID']>;
  /** pl */
  label: Scalars['String'];
  at?: Maybe<Scalars['DateTime']>;
  /** Kommo lead (KommoLead id) of Aplora evidence — only for lead roles (Admin, SalesManager, AccountManager), else null */
  leadId?: Maybe<Scalars['ID']>;
};

export type AiPortraitFactType = {
  __typename?: 'AiPortraitFactType';
  /** snake_case, e.g. work */
  key: Scalars['String'];
  /** pl */
  label: Scalars['String'];
  /** pl */
  value: Scalars['String'];
};

export type AiPortraitCheckpointType = {
  __typename?: 'AiPortraitCheckpointType';
  /** motivation | funding_need | tech_level | engagement | attendance | payment */
  key: Scalars['String'];
  /** ok | warn | bad | unknown */
  status: Scalars['String'];
  /** pl, ≤ 140 chars */
  text: Scalars['String'];
  evidence: Array<AiEvidenceRefType>;
};

export type AiStudentFinancePortraitType = {
  __typename?: 'AiStudentFinancePortraitType';
  studentId: Scalars['ID'];
  /** none | queued | running | ready | failed */
  status: Scalars['String'];
  generatedAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  items: Array<AiPortraitItemType>;
};

export type AiReplyQualityWeekType = {
  __typename?: 'AiReplyQualityWeekType';
  /** YYYY-Www */
  week: Scalars['String'];
  weekStart: Scalars['Date'];
  total?: Maybe<AiReplyQualityRowType>;
  /** Channel × topic slices */
  rows: Array<AiReplyQualityRowType>;
  computedAt?: Maybe<Scalars['DateTime']>;
};

/** ТЗ 0118 шаг 2: срез недели канал × тема (`*` — итог недели). */
export type AiReplyQualityRowType = {
  __typename?: 'AiReplyQualityRowType';
  /** slack_dm | gmail_thread | slack_channel | * (total) */
  channel: Scalars['String'];
  /** topic | * (total) */
  topic: Scalars['String'];
  created: Scalars['Int'];
  sent: Scalars['Int'];
  /** Sent with edit_distance ≤ AI_KB_LEARN_EDIT_THRESHOLD */
  sentUnedited: Scalars['Int'];
  uneditedShare?: Maybe<Scalars['Float']>;
  medianEditDistance?: Maybe<Scalars['Float']>;
  rejected: Scalars['Int'];
  topRejectReasons: Array<AiCountType>;
  /** 10 most frequent normalised items */
  topMissingInfo: Array<AiCountType>;
  /** Share of drafts with kb_strategy=empty */
  kbEmptyShare?: Maybe<Scalars['Float']>;
  /** Total row only */
  candidatesNew?: Maybe<Scalars['Int']>;
  /** Total row only */
  candidatesApproved?: Maybe<Scalars['Int']>;
};

export type AiCountType = {
  __typename?: 'AiCountType';
  label: Scalars['String'];
  count: Scalars['Int'];
};

export type AiReplySuggestionType = {
  __typename?: 'AiReplySuggestionType';
  id: Scalars['ID'];
  conversationId: Scalars['ID'];
  forMessageId?: Maybe<Scalars['ID']>;
  /** queued | running | proposed | no_reply_needed | inserted | sent | rejected | failed */
  status: Scalars['String'];
  /** funding | payments | schedule | homework | lms_access | certificate | contract | other */
  topic?: Maybe<Scalars['String']>;
  /** pl | en | ru | uk | other */
  language?: Maybe<Scalars['String']>;
  /** Draft as plain text (always set for a proposed draft; Slack inserts it as is). */
  text?: Maybe<Scalars['String']>;
  /** Draft as HTML — e-mail threads only (the e-mail editor inserts it). */
  html?: Maybe<Scalars['String']>;
  confidence?: Maybe<Scalars['Float']>;
  citations: Array<AiCitationType>;
  /** What the staff member must check before sending (Polish). */
  missingInfo: Array<Scalars['String']>;
  /** Why the draft failed (a code for non-admins: internal_error | budget_exceeded | ai_disabled | superseded | cancelled | …), or why no reply is needed. */
  error?: Maybe<Scalars['String']>;
  /** The draft was written with the student's finance data and the viewer has no finance access: text, html, citations and missingInfo are withheld — request a draft to get a variant without finance. */
  financeHidden: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type AiCitationType = {
  __typename?: 'AiCitationType';
  /** fact | kb */
  kind: Scalars['String'];
  /** fact:<path in student facts> | kb:<document>#<chunk> */
  ref: Scalars['String'];
  /** Polish label. */
  label: Scalars['String'];
};

export type AiFindingPageType = {
  __typename?: 'AiFindingPageType';
  rows: Array<AiFindingType>;
  total: Scalars['Int'];
  hasMore: Scalars['Boolean'];
};

export type AiFindingType = {
  __typename?: 'AiFindingType';
  id: Scalars['ID'];
  /** lesson_reschedule | lesson_cancel | teacher_late_or_absent | complaint | praise | request | tech_problem | student_absence | homework_issue | other */
  kind: Scalars['String'];
  /** low | normal | high */
  severity: Scalars['String'];
  /** pl */
  summary: Scalars['String'];
  confidence: Scalars['Float'];
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  lessonId?: Maybe<Scalars['ID']>;
  /** Lesson start in the ERP journal (Europe/Warsaw) */
  lessonStartsAt?: Maybe<Scalars['DateTime']>;
  /** New start written in the channel (reschedule) */
  proposedStartsAt?: Maybe<Scalars['DateTime']>;
  /** «W ERP: … — w kanale: …» (pl) */
  scheduleNote?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['ID']>;
  messageIds: Array<Scalars['ID']>;
  excerpts: Array<Scalars['String']>;
  taskId?: Maybe<Scalars['ID']>;
  taskStatus?: Maybe<Scalars['String']>;
  /** none | confirmed | false_positive */
  feedback: Scalars['String'];
  feedbackReason?: Maybe<Scalars['String']>;
  feedbackByName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
};

export type AiAgentOverviewType = {
  __typename?: 'AiAgentOverviewType';
  agents: Array<AiAgentType>;
  monthCostUsd: Scalars['Float'];
  monthBudgetUsd: Scalars['Float'];
  /** Last 30 days */
  costByDay: Array<AiCostDayType>;
  /** DeepSeek peak tariff now */
  peakNow: Scalars['Boolean'];
};

export type AiAgentType = {
  __typename?: 'AiAgentType';
  /** slack_watch | reply_draft | student_portrait | lesson_analysis | chat */
  key: Scalars['String'];
  /** pl */
  label: Scalars['String'];
  /** pl */
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  /** disabled_on_server (server / stand / env) | disabled (switched off in ERP «Settings») */
  offReason?: Maybe<Scalars['String']>;
  /** deepseek | anthropic | replay */
  provider: Scalars['String'];
  model: Scalars['String'];
  version: Scalars['String'];
  monthCostUsd: Scalars['Float'];
  monthBudgetUsd?: Maybe<Scalars['Float']>;
  runsToday: Scalars['Int'];
  runningCount: Scalars['Int'];
  queuedCount: Scalars['Int'];
  lastRunAt?: Maybe<Scalars['DateTime']>;
  lastStatus?: Maybe<Scalars['String']>;
  /** Agent quality metrics (spec 0104 §7), {} when none */
  metrics: Scalars['JSONString'];
  /** May an Admin start a run by hand (`startAiAgentRun`) */
  manualStart: Scalars['Boolean'];
  /** Subject kinds `startAiAgentRun` accepts for this agent; "" = no subject */
  subjectKinds: Array<Scalars['String']>;
};

export type AiCostDayType = {
  __typename?: 'AiCostDayType';
  /** Warsaw calendar day */
  day: Scalars['Date'];
  agentKey: Scalars['String'];
  costUsd: Scalars['Float'];
  calls: Scalars['Int'];
};

export type AiAgentRunPageType = {
  __typename?: 'AiAgentRunPageType';
  rows: Array<AiAgentRunType>;
  total: Scalars['Int'];
  hasMore: Scalars['Boolean'];
};

export type RuntimeSettingType = {
  __typename?: 'RuntimeSettingType';
  key: Scalars['String'];
  section: Scalars['String'];
  /** Смысловой раздел (ТЗ 0095), код из `runtimeSettingDomains`. */
  domain: Scalars['String'];
  /** bool | int | float | str | choice | list */
  type: Scalars['String'];
  /** ceiling | override */
  mode: Scalars['String'];
  /** ceiling с явным включением (агенты ИИ): env только разрешает, включают «Настройки»; без строки — выключено, и «Сбросить» тоже выключает. */
  optIn: Scalars['Boolean'];
  /** '' | live | fiscal | paid */
  danger: Scalars['String'];
  labelRu: Scalars['String'];
  labelPl: Scalars['String'];
  helpRu: Scalars['String'];
  helpPl: Scalars['String'];
  /** Действующее значение (JSON). */
  value?: Maybe<Scalars['JSONString']>;
  /** Значение env (JSON). */
  envValue?: Maybe<Scalars['JSONString']>;
  /** Значение из «Настроек» (JSON); null — строки нет. */
  dbValue?: Maybe<Scalars['JSONString']>;
  hasDbValue: Scalars['Boolean'];
  /** env | db | stand */
  source: Scalars['String'];
  /** ceiling: сервер (стенд или env) запрещает — включить из «Настроек» нельзя. */
  serverForbids: Scalars['Boolean'];
  /** Закрыто потолком стенда (не сервер). */
  standBlocks: Scalars['Boolean'];
  /** Ключ пока только для чтения. */
  readOnly: Scalars['Boolean'];
  choices: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByName?: Maybe<Scalars['String']>;
  beatKeys: Array<Scalars['String']>;
  /** Последний прогон связанных задач (самый свежий из `beatKeys`); null — ключ без задач или прогонов нет. */
  lastRun?: Maybe<ScheduledRunType>;
};

/** Последний прогон записи расписания. */
export type ScheduledRunType = {
  __typename?: 'ScheduledRunType';
  /** Имя записи `_beat`. */
  beatKey: Scalars['String'];
  at?: Maybe<Scalars['DateTime']>;
  /** journal — доменный журнал (итог прогона); periodic_task — только время отправки beat'ом. */
  source: Scalars['String'];
  /** Статус из журнала домена (success / failed / partial / running …); null для periodic_task. */
  status?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  /** beat / erp / cli / manual … — если журнал его хранит. */
  triggerSource?: Maybe<Scalars['String']>;
};

export type RuntimeSettingSectionType = {
  __typename?: 'RuntimeSettingSectionType';
  id: Scalars['String'];
  labelRu: Scalars['String'];
  labelPl: Scalars['String'];
};

/** Смысловой раздел настроек (ТЗ 0095). */
export type RuntimeSettingDomainType = {
  __typename?: 'RuntimeSettingDomainType';
  code: Scalars['String'];
  /** Подпись ru. */
  label: Scalars['String'];
  labelPl: Scalars['String'];
};

export type RuntimeSettingChangeType = {
  __typename?: 'RuntimeSettingChangeType';
  id: Scalars['ID'];
  /** Ключ реестра; `periodic_task` — выключена беспризорная строка планировщика (old/new = {name, task, enabled}). */
  key: Scalars['String'];
  /** Было (JSON); null — env. */
  old?: Maybe<Scalars['JSONString']>;
  /** Стало (JSON); null — снова env. */
  new?: Maybe<Scalars['JSONString']>;
  reason: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
};

export type ScheduledTasksType = {
  __typename?: 'ScheduledTasksType';
  entries: Array<ScheduledTaskEntryType>;
  orphans: Array<OrphanPeriodicTaskType>;
};

export type ScheduledTaskEntryType = {
  __typename?: 'ScheduledTaskEntryType';
  /** Имя записи `_beat`. */
  name: Scalars['String'];
  task: Scalars['String'];
  /** Смысловой раздел (ТЗ 0095): домен ключа `beat_gate`; служебная запись — system. */
  domain: Scalars['String'];
  /** crontab — пять полей «мин час день месяц день_недели» в UTC; интервал — `every N s`. */
  schedule: Scalars['String'];
  /** Runtime-ключи, которые гейтят запись. */
  keys: Array<Scalars['String']>;
  /** Какие из них сейчас выключены. */
  offKeys: Array<Scalars['String']>;
  keyStates: Array<ScheduledKeyStateType>;
  /** Все ключи включены — плановый запуск идёт. */
  effectiveOn: Scalars['Boolean'];
  /** Служебная запись, из «Настроек» не выключается. */
  alwaysOn: Scalars['Boolean'];
  /** Строка PeriodicTask: enabled; null — строки ещё нет (beat не стартовал с этим расписанием). */
  periodicTaskEnabled?: Maybe<Scalars['Boolean']>;
  /** PeriodicTask.last_run_at — когда beat отправил задачу (не итог: задачу мог пропустить гейт, см. `lastSkippedAt`). */
  lastRunAt?: Maybe<Scalars['DateTime']>;
  totalRunCount?: Maybe<Scalars['Int']>;
  lastJournalRun?: Maybe<ScheduledRunType>;
  /** Когда гейт в последний раз пропустил задачу записи (ключ выключен); null — пропусков не было или кэш их не помнит (месяц). Если не раньше `lastRunAt` — последний запуск beat'а был пропуском. */
  lastSkippedAt?: Maybe<Scalars['DateTime']>;
};

/** Ключ записи расписания: действует ли и откуда значение. */
export type ScheduledKeyStateType = {
  __typename?: 'ScheduledKeyStateType';
  key: Scalars['String'];
  on: Scalars['Boolean'];
  /** env | db | stand */
  source: Scalars['String'];
};

export type OrphanPeriodicTaskType = {
  __typename?: 'OrphanPeriodicTaskType';
  name: Scalars['String'];
  task: Scalars['String'];
  enabled: Scalars['Boolean'];
  schedule: Scalars['String'];
  lastRunAt?: Maybe<Scalars['DateTime']>;
  totalRunCount: Scalars['Int'];
};

/** Недельный снимок выдачи (понедельник недели прогона). */
export type MarketingSeoWeek = {
  __typename?: 'MarketingSeoWeek';
  week: Scalars['Date'];
  isoWeek: Scalars['String'];
  checkedAt?: Maybe<Scalars['DateTime']>;
  keywords: Scalars['Int'];
  aiAnswers: Scalars['Int'];
  /** Состояние прогона (done, partial…) */
  state?: Maybe<Scalars['String']>;
  partial: Scalars['Boolean'];
};

/**
 * Обзор SEO за неделю против недели сравнения (KPI — по запросам обеих
 * недель). Клики GSC — 28 дней до последнего собранного дня; без фильтров
 * курса и бренда — полный итог дня, с ними — строки запросов (неполный
 * срез).
 */
export type MarketingSeoOverview = {
  __typename?: 'MarketingSeoOverview';
  week?: Maybe<Scalars['Date']>;
  compareWeek?: Maybe<Scalars['Date']>;
  isoWeek?: Maybe<Scalars['String']>;
  compareIsoWeek?: Maybe<Scalars['String']>;
  ownDomain: Scalars['String'];
  locationCode: Scalars['Int'];
  languageCode: Scalars['String'];
  device: Scalars['String'];
  checkedAt?: Maybe<Scalars['DateTime']>;
  /** Следующий недельный прогон */
  nextRunAt?: Maybe<Scalars['Date']>;
  stale: Scalars['Boolean'];
  keywords: Scalars['Int'];
  comparableKeywords: Scalars['Int'];
  sov?: Maybe<Scalars['Float']>;
  sovPrev?: Maybe<Scalars['Float']>;
  top3?: Maybe<Scalars['Int']>;
  top3Prev?: Maybe<Scalars['Int']>;
  top10?: Maybe<Scalars['Int']>;
  top10Prev?: Maybe<Scalars['Int']>;
  top20?: Maybe<Scalars['Int']>;
  top20Prev?: Maybe<Scalars['Int']>;
  avgPosition?: Maybe<Scalars['Float']>;
  avgPositionPrev?: Maybe<Scalars['Float']>;
  estClicks?: Maybe<Scalars['Float']>;
  estClicksPrev?: Maybe<Scalars['Float']>;
  gscClicks?: Maybe<Scalars['Int']>;
  gscClicksPrev?: Maybe<Scalars['Int']>;
  gscImpressions?: Maybe<Scalars['Int']>;
  gscImpressionsPrev?: Maybe<Scalars['Int']>;
  gscFrom?: Maybe<Scalars['Date']>;
  gscTo?: Maybe<Scalars['Date']>;
  aiAnswers: Scalars['Int'];
  aiMentionShare?: Maybe<Scalars['Float']>;
  aiMentionSharePrev?: Maybe<Scalars['Float']>;
  aiCitationShare?: Maybe<Scalars['Float']>;
  aiSmallSample: Scalars['Boolean'];
  referringDomains?: Maybe<Scalars['Int']>;
  referringDomainsPrev?: Maybe<Scalars['Int']>;
  domains: Array<MarketingSeoDomainVisibility>;
  movers: Array<MarketingSeoMover>;
  moveCounts: MarketingSeoMoveCounts;
  ideas: Array<MarketingSeoOpportunity>;
  /** Код подписи (ctr_estimate — CTR по позиции: оценка, не клики); текст — у ERP */
  ctrNote: Scalars['String'];
};

/**
 * «Мы и конкуренты»: доля видимости домена по набору недели (только
 * запросы обеих недель, если есть сравнение).
 */
export type MarketingSeoDomainVisibility = {
  __typename?: 'MarketingSeoDomainVisibility';
  domain: Scalars['String'];
  label: Scalars['String'];
  isOwn: Scalars['Boolean'];
  /** Доля видимости 0..1 (CTR — оценка) */
  sov?: Maybe<Scalars['Float']>;
  sovPrev?: Maybe<Scalars['Float']>;
  top3?: Maybe<Scalars['Int']>;
  top10?: Maybe<Scalars['Int']>;
  top10Prev?: Maybe<Scalars['Int']>;
  avgPosition?: Maybe<Scalars['Float']>;
  /** Оценка кликов в месяц */
  estClicks?: Maybe<Scalars['Float']>;
};

export type MarketingSeoMover = {
  __typename?: 'MarketingSeoMover';
  keywordId: Scalars['ID'];
  keyword: Scalars['String'];
  familySlug?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  prevPosition?: Maybe<Scalars['Int']>;
  /** Рост позиции (+ — выше) */
  delta?: Maybe<Scalars['Int']>;
  /** new|lost|up|down */
  change: Scalars['String'];
  volume?: Maybe<Scalars['Int']>;
};

export type MarketingSeoMoveCounts = {
  __typename?: 'MarketingSeoMoveCounts';
  new: Scalars['Int'];
  lost: Scalars['Int'];
  up: Scalars['Int'];
  down: Scalars['Int'];
};

/** Возможность SEO (решение человека — «В план», «Сделано», «Скрыть»). */
export type MarketingSeoOpportunity = {
  __typename?: 'MarketingSeoOpportunity';
  id: Scalars['ID'];
  /** gap_keyword | missing_family | striking_distance | click_decline | ai_absent | aio_not_cited | link_gap */
  kind: Scalars['String'];
  /** open | planned | done | dismissed */
  status: Scalars['String'];
  familySlug?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  keywordId?: Maybe<Scalars['ID']>;
  keyword?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  params: Scalars['JSONString'];
  evidence: Scalars['JSONString'];
  score: Scalars['Float'];
  /** Ценность запроса, PLN в месяц (грубая оценка для ранжирования, не отчёт) — одна формула для всех видов: спрос в месяц × доля кликов на целевой 3-й позиции (CTR 10 %, кривая-оценка) × доля заявок (CRM-лиды seo_google ÷ все клики Google за 90 дней) × продажи ÷ лиды курса (seo_google, одно окно ≤ 365 дней с начала истории лидов) × средний чек курса (365 дней). У одного запроса — одна оценка в любом виде, у темы — наибольшая по её запросам; null — запрос без продаваемого курса (нет ни конверсии, ни чека) или без частотности. Падение кликов страницы (click_decline) — потерянные клики × те же доля заявок, продажи ÷ лиды и чек; прочие виды — null */
  valuePlnEst?: Maybe<Scalars['Float']>;
  /** Найдена последним прогоном */
  isCurrent: Scalars['Boolean'];
  firstSeen: Scalars['DateTime'];
  lastSeen: Scalars['DateTime'];
  decidedBy?: Maybe<Scalars['String']>;
  decidedAt?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  /** Адрес ERP */
  link: Scalars['String'];
};

export type MarketingSeoKeywordsPage = {
  __typename?: 'MarketingSeoKeywordsPage';
  week?: Maybe<Scalars['Date']>;
  compareWeek?: Maybe<Scalars['Date']>;
  totalCount: Scalars['Int'];
  rows: Array<MarketingSeoKeywordRow>;
  zoneCounts: Array<MarketingCount>;
  changeCounts: Array<MarketingCount>;
  zonesByWeek: Array<MarketingSeoZoneWeek>;
};

export type MarketingSeoKeywordRow = {
  __typename?: 'MarketingSeoKeywordRow';
  id: Scalars['ID'];
  keyword: Scalars['String'];
  familySlug?: Maybe<Scalars['String']>;
  isBrand: Scalars['Boolean'];
  brandOf?: Maybe<Scalars['String']>;
  /** course | commercial | informational | navigational (seo_intent) */
  intent?: Maybe<Scalars['String']>;
  searchVolume?: Maybe<Scalars['Int']>;
  cpc?: Maybe<Scalars['Float']>;
  difficulty?: Maybe<Scalars['Int']>;
  tracked: Scalars['Boolean'];
  excluded: Scalars['Boolean'];
  trackReason?: Maybe<Scalars['String']>;
  /** serp — недельная выдача, labs — база Labs месяца */
  source?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  prevPosition?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['Int']>;
  change?: Maybe<Scalars['String']>;
  comparable: Scalars['Boolean'];
  zone: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  /** Своя позиция за 8 недель (null — вне глубины или не проверялся) */
  spark: Array<Maybe<Scalars['Int']>>;
  bestCompetitor?: Maybe<Scalars['String']>;
  bestCompetitorPosition?: Maybe<Scalars['Int']>;
  /** serp — недельная выдача; labs — база Labs месяца (выдачи нет или она обрезана — органики меньше 10 — и конкурента в ней нет) */
  bestCompetitorSource?: Maybe<Scalars['String']>;
  /** Органических результатов в недельной выдаче (меньше 10 — выдача обрезана) */
  serpOrganic?: Maybe<Scalars['Int']>;
  domainPosition?: Maybe<Scalars['Int']>;
  gscClicks28d?: Maybe<Scalars['Int']>;
  gscImpressions28d?: Maybe<Scalars['Int']>;
  gscPosition28d?: Maybe<Scalars['Float']>;
  hasAiOverview: Scalars['Boolean'];
  aiOverviewCitesUs: Scalars['Boolean'];
};

/** Значение и сколько раз оно встретилось. */
export type MarketingCount = {
  __typename?: 'MarketingCount';
  value: Scalars['String'];
  count: Scalars['Int'];
};

export type MarketingSeoZoneWeek = {
  __typename?: 'MarketingSeoZoneWeek';
  week: Scalars['Date'];
  isoWeek: Scalars['String'];
  /** Своих запросов в 1–3 */
  top3: Scalars['Int'];
  pos4to10: Scalars['Int'];
  pos11to20: Scalars['Int'];
  /** Нет в глубине выдачи (20) */
  beyond20: Scalars['Int'];
};

export type MarketingSeoKeywordCard = {
  __typename?: 'MarketingSeoKeywordCard';
  keyword: MarketingSeoKeywordRow;
  serpWeek?: Maybe<Scalars['Date']>;
  serp: Array<MarketingSeoSerpItem>;
  features: Array<Scalars['String']>;
  hasAiOverview: Scalars['Boolean'];
  aiOverviewRefs: Array<Scalars['String']>;
  leaderDomain?: Maybe<Scalars['String']>;
  positions: Array<MarketingSeoPositionPoint>;
  gsc: Array<MarketingSeoGscPoint>;
  labs: Array<MarketingSeoLabsRank>;
  monthlySearches: Array<MarketingSeoMonthVolume>;
  opportunities: Array<MarketingSeoOpportunity>;
};

export type MarketingSeoSerpItem = {
  __typename?: 'MarketingSeoSerpItem';
  rank: Scalars['Int'];
  domain: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  isOwn: Scalars['Boolean'];
  isTracked: Scalars['Boolean'];
};

export type MarketingSeoPositionPoint = {
  __typename?: 'MarketingSeoPositionPoint';
  week: Scalars['Date'];
  isoWeek: Scalars['String'];
  own?: Maybe<Scalars['Int']>;
  leader?: Maybe<Scalars['Int']>;
};

export type MarketingSeoGscPoint = {
  __typename?: 'MarketingSeoGscPoint';
  week: Scalars['Date'];
  isoWeek: Scalars['String'];
  clicks: Scalars['Int'];
  impressions: Scalars['Int'];
  position?: Maybe<Scalars['Float']>;
};

export type MarketingSeoLabsRank = {
  __typename?: 'MarketingSeoLabsRank';
  domain: Scalars['String'];
  position: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
  etv?: Maybe<Scalars['Float']>;
  month: Scalars['String'];
};

export type MarketingSeoMonthVolume = {
  __typename?: 'MarketingSeoMonthVolume';
  year: Scalars['Int'];
  month: Scalars['Int'];
  searchVolume: Scalars['Int'];
};

/** Неделя ряда видимости: свои зоны и доли доменов. */
export type MarketingSeoPoint = {
  __typename?: 'MarketingSeoPoint';
  week: Scalars['Date'];
  isoWeek: Scalars['String'];
  ownSov?: Maybe<Scalars['Float']>;
  /** Своих запросов в 1–3 */
  top3: Scalars['Int'];
  pos4to10: Scalars['Int'];
  pos11to20: Scalars['Int'];
  /** Нет в глубине выдачи (20) */
  beyond20: Scalars['Int'];
  domains: Array<MarketingSeoDomainPoint>;
};

export type MarketingSeoDomainPoint = {
  __typename?: 'MarketingSeoDomainPoint';
  domain: Scalars['String'];
  label: Scalars['String'];
  isOwn: Scalars['Boolean'];
  sov?: Maybe<Scalars['Float']>;
  top3?: Maybe<Scalars['Int']>;
  top10?: Maybe<Scalars['Int']>;
  avgPosition?: Maybe<Scalars['Float']>;
  estClicks?: Maybe<Scalars['Float']>;
};

export type MarketingSeoCompetitors = {
  __typename?: 'MarketingSeoCompetitors';
  week?: Maybe<Scalars['Date']>;
  month?: Maybe<Scalars['String']>;
  domains: Array<MarketingSeoCompetitor>;
  matrix: Array<MarketingSeoFamilyCell>;
  aioKeywords: Scalars['Int'];
  aiAnswers: Scalars['Int'];
};

/**
 * Домен в матрице «метрики × домены»: неделя (не бренд), база Labs
 * месяца, ссылки, AI.
 */
export type MarketingSeoCompetitor = {
  __typename?: 'MarketingSeoCompetitor';
  domain: Scalars['String'];
  label: Scalars['String'];
  isOwn: Scalars['Boolean'];
  sov?: Maybe<Scalars['Float']>;
  top3?: Maybe<Scalars['Int']>;
  top10?: Maybe<Scalars['Int']>;
  top20?: Maybe<Scalars['Int']>;
  avgPosition?: Maybe<Scalars['Float']>;
  estClicks?: Maybe<Scalars['Float']>;
  /** Оценка трафика Labs, месяц */
  labsEtv?: Maybe<Scalars['Float']>;
  labsKeywords?: Maybe<Scalars['Int']>;
  labsTop3?: Maybe<Scalars['Int']>;
  labsTop10?: Maybe<Scalars['Int']>;
  /** Зоны базы Labs месяца: 1_3, 4_10, 11_20, 21_50, 51_100 */
  labsZones: Array<MarketingCount>;
  referringDomains?: Maybe<Scalars['Int']>;
  backlinks?: Maybe<Scalars['Float']>;
  backlinksRank?: Maybe<Scalars['Int']>;
  aiMentionShare?: Maybe<Scalars['Float']>;
  aiCitationShare?: Maybe<Scalars['Float']>;
  aioCitationShare?: Maybe<Scalars['Float']>;
};

/** «Кто где сильнее»: курс × домен — доля запросов курса в топ-10. */
export type MarketingSeoFamilyCell = {
  __typename?: 'MarketingSeoFamilyCell';
  familySlug?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  isSold: Scalars['Boolean'];
  domain: Scalars['String'];
  isOwn: Scalars['Boolean'];
  keywords: Scalars['Int'];
  top10: Scalars['Int'];
  top10Share?: Maybe<Scalars['Float']>;
  sov?: Maybe<Scalars['Float']>;
};

export type MarketingSeoGapsPage = {
  __typename?: 'MarketingSeoGapsPage';
  month?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
  rows: Array<MarketingSeoGapRow>;
  topics: Array<MarketingSeoTopic>;
  /** Все строки фильтра по курсу и главному слову */
  clusters: Array<MarketingSeoCluster>;
  kindCounts: Array<MarketingCount>;
  /** Скрыто запросов: navigational (без includeNavigational), excluded (исключённые темы) */
  hiddenCounts: Array<MarketingCount>;
};

export type MarketingSeoGapRow = {
  __typename?: 'MarketingSeoGapRow';
  keywordId: Scalars['ID'];
  keyword: Scalars['String'];
  familySlug?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  isSold: Scalars['Boolean'];
  searchVolume?: Maybe<Scalars['Int']>;
  /** course | commercial | informational | navigational (seo_intent) */
  intent?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['Int']>;
  ownPosition?: Maybe<Scalars['Int']>;
  ownUrl?: Maybe<Scalars['String']>;
  competitors: Array<MarketingSeoDomainRank>;
  /** no_page | weak_page | no_course */
  kind: Scalars['String'];
  isQuestion: Scalars['Boolean'];
  opportunityId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  /** Ценность запроса, PLN в месяц (грубая оценка для ранжирования, не отчёт) — одна формула для всех видов: спрос в месяц × доля кликов на целевой 3-й позиции (CTR 10 %, кривая-оценка) × доля заявок (CRM-лиды seo_google ÷ все клики Google за 90 дней) × продажи ÷ лиды курса (seo_google, одно окно ≤ 365 дней с начала истории лидов) × средний чек курса (365 дней). У одного запроса — одна оценка в любом виде, у темы — наибольшая по её запросам; null — запрос без продаваемого курса (нет ни конверсии, ни чека) или без частотности */
  valuePlnEst?: Maybe<Scalars['Float']>;
};

export type MarketingSeoDomainRank = {
  __typename?: 'MarketingSeoDomainRank';
  domain: Scalars['String'];
  position: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

/** Тема разрывов без продаваемого курса («курсы, которых у нас нет»). */
export type MarketingSeoTopic = {
  __typename?: 'MarketingSeoTopic';
  key: Scalars['String'];
  label: Scalars['String'];
  /** Семейство есть, но не продаётся */
  familySlug?: Maybe<Scalars['String']>;
  hasCourse: Scalars['Boolean'];
  keywords: Scalars['Int'];
  searchVolume: Scalars['Int'];
  topKeywords: Array<Scalars['String']>;
  competitors: Array<MarketingSeoDomainCount>;
  opportunityId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  /** course | commercial | informational | mixed */
  intent: Scalars['String'];
  /** new_course (в темах — только он) */
  suggestedAction: Scalars['String'];
  /** Σ вес намерения × log10(1 + частотность) */
  score: Scalars['Float'];
  /** Частотность запросов обучения */
  courseSearchVolume: Scalars['Int'];
};

export type MarketingSeoDomainCount = {
  __typename?: 'MarketingSeoDomainCount';
  domain: Scalars['String'];
  keywords: Scalars['Int'];
};

/** Карточка «Что написать»: разрывы курса по главному слову. */
export type MarketingSeoCluster = {
  __typename?: 'MarketingSeoCluster';
  key: Scalars['String'];
  label: Scalars['String'];
  familySlug?: Maybe<Scalars['String']>;
  isSold: Scalars['Boolean'];
  keywords: Scalars['Int'];
  searchVolume: Scalars['Int'];
  /** Преобладающий вид строк */
  kind: Scalars['String'];
  /** Прежнее поле: new_page | improve_page | new_course (по suggestedAction) */
  action: Scalars['String'];
  /** course | commercial | informational | mixed (навигационные запросы в карточку не входят) */
  intent: Scalars['String'];
  /** new_course | course_page | article | improve_page */
  suggestedAction: Scalars['String'];
  /** Σ вес намерения (course 1, commercial 0,8, informational 0,3) × log10(1 + частотность); порядок — продаваемые курсы, затем score */
  score: Scalars['Float'];
  /** Частотность запросов обучения */
  courseSearchVolume: Scalars['Int'];
  /** Наша страница (improve_page) */
  ownUrl?: Maybe<Scalars['String']>;
  kindCounts: Array<MarketingCount>;
  topKeywords: Array<Scalars['String']>;
  competitors: Array<MarketingSeoDomainCount>;
  /** Для «В план» пакетом */
  opportunityIds: Array<Scalars['ID']>;
  planned: Scalars['Int'];
  /** Ценность темы — наибольшая ценность её запросов (не сумма: их ищут одни и те же люди). Ценность запроса, PLN в месяц (грубая оценка для ранжирования, не отчёт) — одна формула для всех видов: спрос в месяц × доля кликов на целевой 3-й позиции (CTR 10 %, кривая-оценка) × доля заявок (CRM-лиды seo_google ÷ все клики Google за 90 дней) × продажи ÷ лиды курса (seo_google, одно окно ≤ 365 дней с начала истории лидов) × средний чек курса (365 дней). У одного запроса — одна оценка в любом виде, у темы — наибольшая по её запросам; null — запрос без продаваемого курса (нет ни конверсии, ни чека) или без частотности */
  valuePlnEst?: Maybe<Scalars['Float']>;
};

/**
 * AI-видимость: доли ответов ChatGPT / Gemini с упоминанием / цитатой
 * (по умолчанию — нейтральные вопросы: выбор + условия), с `n` и флагом
 * малой выборки; AI Overview — из недельной выдачи.
 */
export type MarketingSeoAiReport = {
  __typename?: 'MarketingSeoAiReport';
  week?: Maybe<Scalars['Date']>;
  compareWeek?: Maybe<Scalars['Date']>;
  isoWeek?: Maybe<Scalars['String']>;
  /** chatgpt | gemini | aio | all */
  system: Scalars['String'];
  group: Scalars['String'];
  answers: Scalars['Int'];
  answersPrev: Scalars['Int'];
  smallSample: Scalars['Boolean'];
  mentionShare?: Maybe<Scalars['Float']>;
  citationShare?: Maybe<Scalars['Float']>;
  mentionSharePrev?: Maybe<Scalars['Float']>;
  citationSharePrev?: Maybe<Scalars['Float']>;
  domains: Array<MarketingSeoAiDomain>;
  series: Array<MarketingSeoAiPoint>;
  questions: Array<MarketingSeoAiQuestionRow>;
  aioKeywords: Scalars['Int'];
  aioWithOverview: Scalars['Int'];
  aioShare?: Maybe<Scalars['Float']>;
  aioOwnCited: Scalars['Int'];
  aioOwnCitedShare?: Maybe<Scalars['Float']>;
  aioDomains: Array<MarketingSeoAioDomain>;
};

export type MarketingSeoAiDomain = {
  __typename?: 'MarketingSeoAiDomain';
  domain: Scalars['String'];
  label: Scalars['String'];
  isOwn: Scalars['Boolean'];
  mentioned: Scalars['Int'];
  cited: Scalars['Int'];
  mentionShare?: Maybe<Scalars['Float']>;
  citationShare?: Maybe<Scalars['Float']>;
  n: Scalars['Int'];
};

export type MarketingSeoAiPoint = {
  __typename?: 'MarketingSeoAiPoint';
  week: Scalars['Date'];
  isoWeek: Scalars['String'];
  system: Scalars['String'];
  n: Scalars['Int'];
  mentionShare?: Maybe<Scalars['Float']>;
  citationShare?: Maybe<Scalars['Float']>;
};

export type MarketingSeoAiQuestionRow = {
  __typename?: 'MarketingSeoAiQuestionRow';
  id: Scalars['ID'];
  text: Scalars['String'];
  group: Scalars['String'];
  familySlug?: Maybe<Scalars['String']>;
  answers: Scalars['Int'];
  perSystem: Array<MarketingSeoAiSystemCell>;
  competitors: Array<Scalars['String']>;
  citedUrls: Array<Scalars['String']>;
};

export type MarketingSeoAiSystemCell = {
  __typename?: 'MarketingSeoAiSystemCell';
  system: Scalars['String'];
  answers: Scalars['Int'];
  mentioned: Scalars['Int'];
  cited: Scalars['Int'];
};

export type MarketingSeoAioDomain = {
  __typename?: 'MarketingSeoAioDomain';
  domain: Scalars['String'];
  keywords: Scalars['Int'];
  share?: Maybe<Scalars['Float']>;
};

export type MarketingSeoAiAnswer = {
  __typename?: 'MarketingSeoAiAnswer';
  id: Scalars['ID'];
  system: Scalars['String'];
  week: Scalars['Date'];
  repeatNo: Scalars['Int'];
  model?: Maybe<Scalars['String']>;
  /** Текст ответа (стирается через 26 недель) */
  answerText?: Maybe<Scalars['String']>;
  sources: Array<Scalars['String']>;
  fanOut: Array<Scalars['String']>;
  mentions: Array<MarketingSeoAiMention>;
  ownMentioned: Scalars['Boolean'];
  ownCited: Scalars['Boolean'];
  checkedAt?: Maybe<Scalars['DateTime']>;
};

export type MarketingSeoAiMention = {
  __typename?: 'MarketingSeoAiMention';
  domain: Scalars['String'];
  mentioned: Scalars['Boolean'];
  cited: Scalars['Boolean'];
  firstPos?: Maybe<Scalars['Int']>;
};

export type MarketingSeoBacklinks = {
  __typename?: 'MarketingSeoBacklinks';
  month?: Maybe<Scalars['String']>;
  prevMonth?: Maybe<Scalars['String']>;
  domains: Array<MarketingSeoBacklinkDomain>;
  /** Новые ссылающиеся домены за месяц */
  ownNew?: Maybe<Scalars['Int']>;
  /** Потерянные за месяц */
  ownLost?: Maybe<Scalars['Int']>;
  gaps: Array<MarketingSeoLinkGapRow>;
  gapTotal: Scalars['Int'];
};

export type MarketingSeoBacklinkDomain = {
  __typename?: 'MarketingSeoBacklinkDomain';
  domain: Scalars['String'];
  label: Scalars['String'];
  isOwn: Scalars['Boolean'];
  referringDomains?: Maybe<Scalars['Int']>;
  referringDomainsPrev?: Maybe<Scalars['Int']>;
  referringMainDomains?: Maybe<Scalars['Int']>;
  backlinks?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Int']>;
};

export type MarketingSeoLinkGapRow = {
  __typename?: 'MarketingSeoLinkGapRow';
  refDomain: Scalars['String'];
  rank?: Maybe<Scalars['Int']>;
  backlinks?: Maybe<Scalars['Int']>;
  linksTo: Array<Scalars['String']>;
  opportunityId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
};

/**
 * SEO → продажа по курсу. Клики GSC — строки небрендовых запросов
 * (нижняя граница), лиды и продажи — канал seo_google.
 */
export type MarketingSeoFunnelRow = {
  __typename?: 'MarketingSeoFunnelRow';
  familySlug: Scalars['String'];
  familyName: Scalars['String'];
  isSold: Scalars['Boolean'];
  sov?: Maybe<Scalars['Float']>;
  labsEtv?: Maybe<Scalars['Float']>;
  searchVolume?: Maybe<Scalars['Int']>;
  gscClicks?: Maybe<Scalars['Int']>;
  gscImpressions?: Maybe<Scalars['Int']>;
  organicEntrances: Scalars['Int'];
  crmLeads: Scalars['Int'];
  sales: Scalars['Float'];
  revenuePln: Scalars['Decimal'];
};


/**
 * Фильтр всех запросов раздела. Окно ≤ 400 дней; юрлицо сужает только
 * продажи, выручку и деньги (расход и лиды к юрлицу не привязаны).
 */
export type MarketingFilter = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  channels?: Maybe<Array<MarketingChannel>>;
  familySlugs?: Maybe<Array<Scalars['String']>>;
  offers?: Maybe<Array<Scalars['String']>>;
  /** id AdEntity */
  campaignIds?: Maybe<Array<Scalars['ID']>>;
  adsetIds?: Maybe<Array<Scalars['ID']>>;
  /** Юрлицо: сужает продажи, деньги и договоры. Договор без известного юрлица (PandaDoc до подписи, юрлицо не вывелось) при фильтре не считается — в marketingContracts он отдельной строкой unknownLegalEntity */
  legalEntityId?: Maybe<Scalars['ID']>;
  model?: Maybe<MarketingAttributionModel>;
  /** id AdEntity объявлений (и групп ассетов PMax). Разбивка — только AD | FORMAT, матрица — только строки AD, иначе ошибка ad_filter_dimension (расход сводки есть только у кампании) */
  adIds?: Maybe<Array<Scalars['ID']>>;
  /** Только динамика лидов и многоканальные когорты: mobile | desktop | tablet | unknown; другие запросы — ошибка lead_only_filter */
  devices?: Maybe<Array<Scalars['String']>>;
  /** Только динамика лидов и многоканальные когорты: тип посадочной лида (none — не определён) */
  pageTypes?: Maybe<Array<Scalars['String']>>;
  /** Только динамика лидов и многоканальные когорты: single | multi */
  pathKinds?: Maybe<Array<Scalars['String']>>;
};

/** Канал касания / продажи (коды `marketing.constants.Channel`). */
export enum MarketingChannel {
  Meta = 'META',
  GoogleAds = 'GOOGLE_ADS',
  SeoGoogle = 'SEO_GOOGLE',
  SeoBing = 'SEO_BING',
  AiReferral = 'AI_REFERRAL',
  Email = 'EMAIL',
  Direct = 'DIRECT',
  Referral = 'REFERRAL',
  OtherPaid = 'OTHER_PAID',
  Phone = 'PHONE',
  Unknown = 'UNKNOWN'
}

/**
 * Модель атрибуции: last (по умолчанию), first, linear (1/n),
 * participation (канал получает продажу целиком — сумма больше итога).
 */
export enum MarketingAttributionModel {
  Last = 'LAST',
  First = 'FIRST',
  Linear = 'LINEAR',
  Participation = 'PARTICIPATION'
}

/**
 * Бюджет DataForSEO месяца и сметы прогонов (без внешних вызовов:
 * цены — последний живой прайс не старше 30 дней или константы, баланс —
 * последний известный).
 */
export type MarketingSeoBudget = {
  __typename?: 'MarketingSeoBudget';
  month: Scalars['String'];
  capUsd: Scalars['Decimal'];
  envCapUsd: Scalars['Decimal'];
  spentUsd: Scalars['Decimal'];
  reservedUsd: Scalars['Decimal'];
  uncertainUsd: Scalars['Decimal'];
  remainingUsd: Scalars['Decimal'];
  maxRunUsd: Scalars['Decimal'];
  balanceUsd?: Maybe<Scalars['Decimal']>;
  balanceAt?: Maybe<Scalars['DateTime']>;
  pricesSource: Scalars['String'];
  pricesVerifiedOn: Scalars['Date'];
  enabled: Scalars['Boolean'];
  aiEnabled: Scalars['Boolean'];
  offReason?: Maybe<Scalars['String']>;
  aiOffReason?: Maybe<Scalars['String']>;
  mode: Scalars['String'];
  estimates: Array<MarketingSeoEstimate>;
  runs: Array<MarketingSeoRunType>;
  history: Array<MarketingSeoBudgetMonth>;
};

export type MarketingSeoEstimate = {
  __typename?: 'MarketingSeoEstimate';
  kind: Scalars['String'];
  estimateUsd: Scalars['Decimal'];
  keywords?: Maybe<Scalars['Int']>;
  questions?: Maybe<Scalars['Int']>;
  ai?: Maybe<Scalars['Boolean']>;
  /** Набор пуст — смета на потолок набора */
  upperBound?: Maybe<Scalars['Boolean']>;
  items: Array<MarketingSeoEstimateItem>;
  /** cap | max_run | balance | price_stale; null — пройдёт */
  refusal?: Maybe<Scalars['String']>;
};

export type MarketingSeoEstimateItem = {
  __typename?: 'MarketingSeoEstimateItem';
  endpoint: Scalars['String'];
  requests?: Maybe<Scalars['Int']>;
  results?: Maybe<Scalars['Int']>;
  costUsd: Scalars['Decimal'];
};

export type MarketingSeoRunType = {
  __typename?: 'MarketingSeoRunType';
  id: Scalars['ID'];
  kind: Scalars['String'];
  state: Scalars['String'];
  mode: Scalars['String'];
  week?: Maybe<Scalars['Date']>;
  month?: Maybe<Scalars['String']>;
  ai: Scalars['Boolean'];
  estimateUsd: Scalars['Decimal'];
  spentUsd: Scalars['Decimal'];
  createdAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  refusal?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type MarketingSeoBudgetMonth = {
  __typename?: 'MarketingSeoBudgetMonth';
  month: Scalars['String'];
  spentUsd: Scalars['Decimal'];
  reservedUsd: Scalars['Decimal'];
  uncertainUsd: Scalars['Decimal'];
  capUsd: Scalars['Decimal'];
};

export type MarketingOverview = {
  __typename?: 'MarketingOverview';
  current: MarketingMetrics;
  /** Окно той же длины прямо перед текущим */
  previous: MarketingMetrics;
  coverage: MarketingCoverageInfo;
  series: Array<MarketingSeriesPoint>;
  channels: Array<MarketingChannelShare>;
  sources: Array<MarketingSourceStatus>;
  dataVersion: Scalars['Int'];
  /** Только показатели, у которых в месяцах окна есть план */
  planFact: Array<MarketingPlanFact>;
  /** ТЗ 0103: окно сравнения (только при compare; previous тогда — за него) */
  compareInfo?: Maybe<MarketingCompareInfo>;
  /** ТЗ 0103: первый день истории CRM-лидов (входы в New leads) — раньше лиды не собирались; от фильтров не зависит; null — входов ещё нет */
  leadHistoryFrom?: Maybe<Scalars['Date']>;
};

/**
 * Показатели окна. Расход — только уровень кампании, PLN; NULL — день
 * окна не покрыт (≠ 0). Отношения периодные, не когортные.
 */
export type MarketingMetrics = {
  __typename?: 'MarketingMetrics';
  /** null — не покрыт */
  spendPln?: Maybe<Scalars['Decimal']>;
  /** Расход только за собранные дни окна (площадки строки) — для показа, когда spendPln null; CPL, стоимость продажи и ROAS из него не считаются. null — ни одного собранного дня или расхода у строки нет */
  spendCoveredPln?: Maybe<Scalars['Decimal']>;
  /** Последний день, вошедший в spendCoveredPln (при полном покрытии — конец окна, не позже сегодня) */
  spendCoveredThrough?: Maybe<Scalars['Date']>;
  impressions?: Maybe<Scalars['Int']>;
  clicks?: Maybe<Scalars['Int']>;
  /** Доля: clicks / impressions (0.0123 = 1,23 %) */
  ctr?: Maybe<Scalars['Float']>;
  cpc?: Maybe<Scalars['Decimal']>;
  cpm?: Maybe<Scalars['Decimal']>;
  leadsPlatform?: Maybe<Scalars['Int']>;
  /** CRM-лиды: человек на курс — входы в New leads без повторных заявок */
  crmLeads: Scalars['Int'];
  /** Повторные заявки: вход того же человека на то же семейство курса ≤ 30 дней после прошлого. Входы = crmLeads + crmLeadsRepeat */
  crmLeadsRepeat: Scalars['Int'];
  touchesOther: Scalars['Int'];
  /** float: linear даёт дроби */
  sales: Scalars['Float'];
  revenuePln: Scalars['Decimal'];
  cashPln: Scalars['Decimal'];
  /** null, если расход не покрыт, расход 0 или лидов 0 */
  cplPln?: Maybe<Scalars['Decimal']>;
  /** Расход / продажи; null — расход не покрыт, расход 0 или продаж нет */
  costPerSalePln?: Maybe<Scalars['Decimal']>;
  roas?: Maybe<Scalars['Float']>;
  roasCash?: Maybe<Scalars['Float']>;
  /** Отношения *Covered — по собранным дням окна (собраны ВСЕ площадки строки), последний — этот день; дни могут идти не подряд. null — расход окна полный или собранных дней нет */
  ratiosThrough?: Maybe<Scalars['Date']>;
  /** CPL по собранным дням: расход / CRM-лиды тех же дней; null — расход 0 или лидов 0 */
  cplCoveredPln?: Maybe<Scalars['Decimal']>;
  /** Стоимость продажи по собранным дням (те же дни); null — расход 0 или продаж нет */
  costPerSaleCoveredPln?: Maybe<Scalars['Decimal']>;
  /** ROAS по собранным дням: подписано / расход тех же дней */
  roasCovered?: Maybe<Scalars['Float']>;
  /** ROAS по деньгам по собранным дням */
  roasCashCovered?: Maybe<Scalars['Float']>;
  /** Отправленные договоры: эпизоды (повторная отправка тому же человеку на тот же курс ≤ 30 дней — тот же договор) прямых и Dofinansowanie по дню отправки; атрибуция — всегда последнее касание */
  contractsSent: Scalars['Int'];
  /** Из отправленных подписаны (исход эпизода) */
  contractsSigned: Scalars['Int'];
  /** Ждут подписи: отправлено − подписано − потеряно */
  contractsPending: Scalars['Int'];
  /** Потеряны: отклонены, отменены, ссылка истекла, PandaDoc не подписан */
  contractsLost: Scalars['Int'];
  /** Доля: подписано / отправлено; null — договоров нет */
  contractSignRate?: Maybe<Scalars['Float']>;
  /** Расход / отправленные договоры; null — расход не покрыт, расход 0 или договоров нет */
  costPerContractPln?: Maybe<Scalars['Decimal']>;
  /** Доля: продажи / CRM-лиды периода (периодная, не когортная); null — лидов нет */
  leadToSale?: Maybe<Scalars['Float']>;
  /** Доля: отправленные договоры / CRM-лиды периода; null — лидов нет */
  leadToContract?: Maybe<Scalars['Float']>;
};

export type MarketingCoverageInfo = {
  __typename?: 'MarketingCoverageInfo';
  /** Все дни окна покрыты по всем платным источникам */
  spendComplete: Scalars['Boolean'];
  missingSpendDays: Array<Scalars['Date']>;
  /** Дни, которые площадки ещё пересчитывают */
  provisionalFrom?: Maybe<Scalars['Date']>;
};

export type MarketingSeriesPoint = {
  __typename?: 'MarketingSeriesPoint';
  period: Scalars['String'];
  /** Первый день корзины (крайние обрезаны окном) */
  dateFrom?: Maybe<Scalars['Date']>;
  /** Последний день корзины */
  dateTo?: Maybe<Scalars['Date']>;
  metrics: MarketingMetrics;
  /** ТЗ 0103: корзина окна сравнения с тем же НОМЕРОМ (не датой); null — сравнения нет или у корзины нет пары */
  previous?: Maybe<MarketingMetrics>;
  previousPeriod?: Maybe<Scalars['String']>;
  previousDateFrom?: Maybe<Scalars['Date']>;
  previousDateTo?: Maybe<Scalars['Date']>;
};

export type MarketingChannelShare = {
  __typename?: 'MarketingChannelShare';
  channel: MarketingChannel;
  metrics: MarketingMetrics;
};

export type MarketingSourceStatus = {
  __typename?: 'MarketingSourceStatus';
  /** meta | google_ads | kommo | sales | gsc | ga4 | bing | search_terms | sendgrid | site_tracking (ТЗ 0103) */
  source: Scalars['String'];
  mode: MarketingSourceMode;
  coveredFrom?: Maybe<Scalars['Date']>;
  coveredTo?: Maybe<Scalars['Date']>;
  completeThrough?: Maybe<Scalars['Date']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']>;
  lastError?: Maybe<Scalars['String']>;
  running: Scalars['Boolean'];
};

/** Режим источника данных. */
export enum MarketingSourceMode {
  Live = 'LIVE',
  Fake = 'FAKE',
  Disabled = 'DISABLED'
}

/**
 * План-факт показателя за месяцы окна (этап 2). `target` — план
 * (сумма подходящих строк; у CPL и стоимости продажи — среднее), `fact` —
 * факт теми же формулами, что `MarketingMetrics` (null — расход не
 * покрыт), `pace` — прогноз на конец месяца линейно (прошедший месяц —
 * факт, отношения — факт).
 */
export type MarketingPlanFact = {
  __typename?: 'MarketingPlanFact';
  metric: Scalars['String'];
  target?: Maybe<Scalars['Decimal']>;
  fact?: Maybe<Scalars['Decimal']>;
  pace?: Maybe<Scalars['Decimal']>;
};

/** Окно сравнения, которое посчитал сервер. */
export type MarketingCompareInfo = {
  __typename?: 'MarketingCompareInfo';
  /** previous | year | custom */
  mode: Scalars['String'];
  /** Единица сравнения: day | week | month | quarter | year | rolling; у previous и year (custom — null) */
  unit?: Maybe<Scalars['String']>;
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  /** Одинаковое число корзин шага: точки ряда идут парами по номеру корзины; иначе лишние — без пары (previous null) */
  aligned: Scalars['Boolean'];
  /** Окно сравнения собрано не целиком: расход площадки охвата не собран за часть дней или данные начинаются позже его начала — «сравнение неполное» */
  partial: Scalars['Boolean'];
  /** Сравнение обрезано по тот же день: окно ещё не кончилось (toDate) */
  cutToDate: Scalars['Boolean'];
};

/** Шаг ряда: день, ISO-неделя (пн–вс), месяц. */
export enum MarketingGranularity {
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH'
}

/**
 * ТЗ 0103 §A2: сравнение периодов. Окно сравнения — compareInfo ответа
 * (фронт не считает его сам).
 */
export type MarketingCompare = {
  mode: MarketingCompareMode;
  /** PREVIOUS и YEAR: единица по пресету (thisWeek/prevWeek → WEEK, thisMonth/prevMonth → MONTH, quarter → QUARTER, year → YEAR, «Сегодня» / 7d / 30d / 90d / свои даты → ROLLING). У YEAR: MONTH / QUARTER / YEAR — те же даты год назад, DAY / WEEK / ROLLING — 364 дня назад (не зависит от шага ряда) */
  unit?: Maybe<MarketingCompareUnit>;
  /** Только CUSTOM */
  dateFrom?: Maybe<Scalars['Date']>;
  /** Только CUSTOM */
  dateTo?: Maybe<Scalars['Date']>;
  /** Окно ещё не кончилось (доходит до сегодня) — сравнение режется до того же дня; false — прошлая единица целиком */
  toDate?: Maybe<Scalars['Boolean']>;
};

/**
 * ТЗ 0103 §A2: с чем сравнивать окно. PREVIOUS — прошлый период по
 * единице `MarketingCompare.unit` (по умолчанию ROLLING — окно той же
 * длины прямо перед); YEAR — год назад (шаг MONTH — те же даты, DAY /
 * WEEK — 364 дня); CUSTOM — свои даты.
 */
export enum MarketingCompareMode {
  Previous = 'PREVIOUS',
  Year = 'YEAR',
  Custom = 'CUSTOM'
}

/**
 * Ревью 0103 (L1): единица «прошлого периода» (только PREVIOUS) —
 * явно, по пресету ERP; форма дат ничего не угадывает. ROLLING и DAY —
 * окно той же длины прямо перед (1–7 окт → 24–30 сен); WEEK — на 7 × N
 * дней раньше (те же дни недели); MONTH / QUARTER / YEAR — те же числа на
 * 1 / 3 / 12 месяцев раньше (9 окт, MONTH: 1–9 окт → 1–9 сен; QUARTER: →
 * 1–9 июл; январь, YEAR: → январь прошлого года). Окно ещё не кончилось и
 * toDate — сравнение по тот же день.
 */
export enum MarketingCompareUnit {
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR',
  Rolling = 'ROLLING'
}

export type MarketingBreakdown = {
  __typename?: 'MarketingBreakdown';
  dimension: MarketingDimension;
  rows: Array<MarketingBreakdownRow>;
  total: MarketingMetrics;
  totalCount: Scalars['Int'];
  /** Названия рекламных сущностей пути спуска (campaignIds, adsetIds, parentKey-id): кампании, затем группы; неизвестные id пропущены */
  crumbs: Array<MarketingOption>;
  /** ТЗ 0103: числа быстрых фильтров по строкам ДО having (после minSpendPln / minCrmLeads): value ALL — все строки, затем коды MarketingRowPredicate */
  predicateCounts: Array<MarketingCount>;
  compareInfo?: Maybe<MarketingCompareInfo>;
};

/**
 * Измерение разбивки. FORMAT (ТЗ 0103) — объявления, сложенные по
 * формату (`AdEntity.format`).
 */
export enum MarketingDimension {
  Channel = 'CHANNEL',
  Campaign = 'CAMPAIGN',
  Adset = 'ADSET',
  Ad = 'AD',
  Family = 'FAMILY',
  Offer = 'OFFER',
  Format = 'FORMAT'
}

export type MarketingBreakdownRow = {
  __typename?: 'MarketingBreakdownRow';
  /** Код канала | id AdEntity | slug семейства | оффер; нет значения — none */
  key: Scalars['String'];
  label: Scalars['String'];
  platform?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  metrics: MarketingMetrics;
  /** Доля 0..1 продаж строки, известных до этого уровня */
  salesCoverage?: Maybe<Scalars['Float']>;
  /** Только при withSeries: true (≤ 20 строк) */
  series?: Maybe<Array<MarketingSeriesPoint>>;
  /** ТЗ 0103: тот же ключ за окно сравнения (только при compare) */
  previous?: Maybe<MarketingMetrics>;
};

export type MarketingOption = {
  __typename?: 'MarketingOption';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**
 * ТЗ 0103 §A4: быстрый фильтр строк разбивки и креативов (сервер, до
 * страниц). WITH_SALES — продажи > 0; NO_SALES — продаж нет, а расход, лиды
 * или договоры есть; LEADS_NO_SALES — CRM-лиды есть, продаж нет;
 * CONTRACTS_UNSIGNED — договоры отправлены, ни один не подписан;
 * SPEND_NO_LEADS — расход есть, CRM-лидов нет.
 */
export enum MarketingRowPredicate {
  WithSales = 'WITH_SALES',
  NoSales = 'NO_SALES',
  LeadsNoSales = 'LEADS_NO_SALES',
  ContractsUnsigned = 'CONTRACTS_UNSIGNED',
  SpendNoLeads = 'SPEND_NO_LEADS'
}

/**
 * Ячейка матрицы двух измерений (`marketingMatrix`): показатели
 * `DailyFact` пары значений. При `participation` ячейки — «участие» и в
 * итог не складываются (итога у матрицы нет).
 */
export type MarketingMatrixCell = {
  __typename?: 'MarketingMatrixCell';
  /** Код канала | slug семейства | оффер | id AdEntity (строки CAMPAIGN / AD); нет значения — none */
  rowKey: Scalars['String'];
  rowLabel: Scalars['String'];
  colKey: Scalars['String'];
  colLabel: Scalars['String'];
  metrics: MarketingMetrics;
};

export type MarketingSalesPage = {
  __typename?: 'MarketingSalesPage';
  rows: Array<MarketingSaleRow>;
  totalCount: Scalars['Int'];
};

export type MarketingSaleRow = {
  __typename?: 'MarketingSaleRow';
  id: Scalars['ID'];
  /** esign | pandadoc */
  source: Scalars['String'];
  sourceId: Scalars['String'];
  day: Scalars['Date'];
  kind: Scalars['String'];
  isSale: Scalars['Boolean'];
  saleReason: Scalars['String'];
  familySlug?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  pricePln?: Maybe<Scalars['Decimal']>;
  cashPln: Scalars['Decimal'];
  /** Маска a***@d***.pl; у Admin — email как есть */
  emailMasked?: Maybe<Scalars['String']>;
  leadKommoId?: Maybe<Scalars['String']>;
  coverage: Scalars['String'];
  lastChannel?: Maybe<MarketingChannel>;
  lastCampaign?: Maybe<Scalars['String']>;
  lastAd?: Maybe<Scalars['String']>;
  firstChannel?: Maybe<MarketingChannel>;
  leadToSaleDays?: Maybe<Scalars['Int']>;
  touches: Array<MarketingSaleTouch>;
};

export type MarketingSaleTouch = {
  __typename?: 'MarketingSaleTouch';
  at: Scalars['DateTime'];
  pipelineKind: Scalars['String'];
  channel: MarketingChannel;
  campaign?: Maybe<Scalars['String']>;
  ad?: Maybe<Scalars['String']>;
  matchRule: Scalars['String'];
  isFirst: Scalars['Boolean'];
  isLast: Scalars['Boolean'];
};

export type MarketingDataQuality = {
  __typename?: 'MarketingDataQuality';
  /** none/lead/channel/campaign/ad накопительно */
  salesCoverage: Array<MarketingCoverageStep>;
  /** Лиды платформы Meta: события пикселя Lead с ЛЮБОЙ формы сайта (квиз, вебинар, книга, курс), не только New leads */
  metaPlatformLeads?: Maybe<Scalars['Int']>;
  metaCrmLeads: Scalars['Int'];
  /** Касания Kommo с каналом Meta, созданные в окне во ВСЕХ воронках — сравнивать с лидами платформы */
  metaTouchesAll: Scalars['Int'];
  /** Входы в New leads окна по источнику лида Kommo («Zadarma» — звонки; пусто — источник неизвестен) */
  crmLeadsBySource: Array<MarketingCount>;
  crmLeadsWithoutCourse: Scalars['Int'];
  crmLeadsTotal: Scalars['Int'];
  /** Повторные документы человека с неопределённым курсом (не продажи) — завести алиас курса */
  salesUnknownCourseRepeats: Scalars['Int'];
  unmappedSources: Array<MarketingUnmappedValue>;
  unmappedCampaigns: Array<MarketingUnmappedValue>;
  accountReconciliation: Array<MarketingReconRow>;
  sources: Array<MarketingSourceStatus>;
  /** ТЗ 0103: свой счётчик посетителей — приём маячка за 7 дней и доля CRM-лидов окна с найденным посетителем; null — не посчитано */
  siteTracking?: Maybe<MarketingSiteTracking>;
};

export type MarketingCoverageStep = {
  __typename?: 'MarketingCoverageStep';
  level: Scalars['String'];
  count: Scalars['Int'];
};

export type MarketingUnmappedValue = {
  __typename?: 'MarketingUnmappedValue';
  field: Scalars['String'];
  value: Scalars['String'];
  count: Scalars['Int'];
  /** Площадка по каналу касаний с этой меткой (meta | google_ads); null — канал не платный */
  platform?: Maybe<Scalars['String']>;
  /** Семейство курса не определилось — «Создать правило» */
  familyMissing: Scalars['Boolean'];
  /** Кампания кабинета не нашлась при платном канале — «Сопоставить с кампанией» (кампании площадки platform) */
  campaignMissing: Scalars['Boolean'];
};

export type MarketingReconRow = {
  __typename?: 'MarketingReconRow';
  platform: Scalars['String'];
  day: Scalars['Date'];
  campaignSum?: Maybe<Scalars['Decimal']>;
  accountTotal?: Maybe<Scalars['Decimal']>;
  /** В процентах: 1.4 = 1,4 % */
  diffPct?: Maybe<Scalars['Float']>;
};

export type MarketingSiteTracking = {
  __typename?: 'MarketingSiteTracking';
  enabled: Scalars['Boolean'];
  collectingSince?: Maybe<Scalars['Date']>;
  /** Последний принятый маячок (Redis, хранится 9 дней) */
  lastAcceptedAt?: Maybe<Scalars['DateTime']>;
  days: Scalars['Int'];
  /** Принятые маячки за days дней */
  accepted: Scalars['Int'];
  /** Принятые события за days дней */
  events: Scalars['Int'];
  /** Отброшенные маячки по причине: dropped_origin, dropped_bot, dropped_rate, dropped_size, dropped_queue, dropped_invalid */
  dropped: Array<MarketingCount>;
  /** Пачек в очереди; null — Redis недоступен */
  queue?: Maybe<Scalars['Int']>;
  leads: Scalars['Int'];
  linkedLeads: Scalars['Int'];
  linkedLeadShare?: Maybe<Scalars['Float']>;
};

export type MarketingTaxonomy = {
  __typename?: 'MarketingTaxonomy';
  channelRules: Array<MarketingChannelRuleType>;
  families: Array<MarketingCourseFamilyType>;
  offerRules: Array<MarketingOfferRuleType>;
  pipelines: Array<MarketingPipelineType>;
  /** Для фильтра — роль Marketing не видит справочник юрлиц иначе */
  legalEntities: Array<MarketingOption>;
  /** ERP-курсы для алиаса erp_course */
  courses: Array<MarketingOption>;
  /** Ручные сопоставления меток CRM с кампаниями */
  campaignAliases: Array<MarketingCampaignAliasType>;
  /** Бренд в поисковом запросе (regex без учёта регистра) */
  brandRegex: Scalars['String'];
  /** События GA4, которые считаются ключевыми у посадочных */
  ga4KeyEvents: Array<Scalars['String']>;
  /** Хосты своего сайта: страницы GSC других хостов (lms., webinars.) без семейства по пути и вне стыка с посадочными */
  siteHosts: Array<Scalars['String']>;
  /** Какие сигналы заводят задачу и на кого (правка — только Admin) */
  signalRouting: MarketingSignalRoutingType;
  /** Кого можно назначить исполнителем задач сигналов: активные сотрудники, которые видят задачи ERP (управленческие роли); только id и имя */
  staffOptions: Array<MarketingOption>;
  seoDomains: Array<MarketingSeoDomainType>;
  seoQuestions: Array<MarketingSeoQuestionType>;
  seoSettings: MarketingSeoSettingsType;
  /** Типы страниц сайта: первое совпадение пути (regex без учёта регистра), иначе other; правка — saveMarketingPageTypes */
  pageTypeRules: Array<MarketingPageTypeRule>;
  /** Коды типов страниц в порядке правил + other */
  pageTypes: Array<Scalars['String']>;
};

export type MarketingChannelRuleType = {
  __typename?: 'MarketingChannelRuleType';
  id: Scalars['ID'];
  priority: Scalars['Int'];
  field: Scalars['String'];
  match: Scalars['String'];
  pattern: Scalars['String'];
  channel: MarketingChannel;
  subChannel: Scalars['String'];
  isPaid: Scalars['Boolean'];
  active: Scalars['Boolean'];
  note: Scalars['String'];
};

export type MarketingCourseFamilyType = {
  __typename?: 'MarketingCourseFamilyType';
  id: Scalars['ID'];
  slug: Scalars['String'];
  name: Scalars['String'];
  isSold: Scalars['Boolean'];
  sort: Scalars['Int'];
  aliases: Array<MarketingCourseAliasType>;
};

export type MarketingCourseAliasType = {
  __typename?: 'MarketingCourseAliasType';
  id: Scalars['ID'];
  kind: Scalars['String'];
  value: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
  priority: Scalars['Int'];
};

export type MarketingOfferRuleType = {
  __typename?: 'MarketingOfferRuleType';
  id: Scalars['ID'];
  priority: Scalars['Int'];
  field: Scalars['String'];
  regex: Scalars['String'];
  offer: Scalars['String'];
};

export type MarketingPipelineType = {
  __typename?: 'MarketingPipelineType';
  id: Scalars['ID'];
  kommoId: Scalars['String'];
  name: Scalars['String'];
  funnelKind: Scalars['String'];
  funnelKindLocked: Scalars['Boolean'];
};

/** Ручное сопоставление метки CRM с кампанией кабинета. */
export type MarketingCampaignAliasType = {
  __typename?: 'MarketingCampaignAliasType';
  id: Scalars['ID'];
  /** meta | google_ads */
  platform: Scalars['String'];
  /** utm_campaign | utm_id */
  field: Scalars['String'];
  /** Метка без пробелов по краям, в нижнем регистре; сравнивается точно */
  rawValue: Scalars['String'];
  /** id AdEntity кампании */
  entityId: Scalars['ID'];
  entityName: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
};

export type MarketingSignalRoutingType = {
  __typename?: 'MarketingSignalRoutingType';
  kinds: Array<Scalars['String']>;
  /** info | warning | critical */
  minSeverity: Scalars['String'];
  assigneeIds: Array<Scalars['ID']>;
};

export type MarketingSeoDomainType = {
  __typename?: 'MarketingSeoDomainType';
  id: Scalars['ID'];
  domain: Scalars['String'];
  label: Scalars['String'];
  isOwn: Scalars['Boolean'];
  active: Scalars['Boolean'];
  /** seed | suggested | manual */
  source: Scalars['String'];
  brandRegex: Scalars['String'];
  suggestedMetrics: Scalars['JSONString'];
};

export type MarketingSeoQuestionType = {
  __typename?: 'MarketingSeoQuestionType';
  id: Scalars['ID'];
  familySlug?: Maybe<Scalars['String']>;
  group: Scalars['String'];
  textPl: Scalars['String'];
  active: Scalars['Boolean'];
  sort: Scalars['Int'];
  version: Scalars['Int'];
  source: Scalars['String'];
};

export type MarketingSeoSettingsType = {
  __typename?: 'MarketingSeoSettingsType';
  ownDomain: Scalars['String'];
  locationCode: Scalars['Int'];
  languageCode: Scalars['String'];
  device: Scalars['String'];
  depth: Scalars['Int'];
  maxTracked: Scalars['Int'];
  aiRepeats: Scalars['Int'];
  minGapVolume: Scalars['Int'];
  /** Исключённые темы «Что написать» — шаблоны с границами слов */
  excludedTopics: Array<Scalars['String']>;
  trackedCount: Scalars['Int'];
};

export type MarketingPageTypeRule = {
  __typename?: 'MarketingPageTypeRule';
  /** Код типа: [a-z0-9_]{1,16} */
  type: Scalars['String'];
  /** Regex пути страницы (без хоста и запроса), без учёта регистра */
  regex: Scalars['String'];
};

export type MarketingCreativesPage = {
  __typename?: 'MarketingCreativesPage';
  rows: Array<MarketingCreativeRow>;
  /** Строк после быстрых фильтров */
  totalCount: Scalars['Int'];
  /** Формат × семейство × оффер по всем строкам выдачи */
  formats: Array<MarketingFormatStat>;
  /** ТЗ 0103: группы строк выдачи по groupBy (без groupBy — пусто) */
  groups: Array<MarketingCreativeGroup>;
  /** Числа быстрых фильтров по строкам до having (ALL — все) */
  predicateCounts: Array<MarketingCount>;
  compareInfo?: Maybe<MarketingCompareInfo>;
};

export type MarketingCreativeRow = {
  __typename?: 'MarketingCreativeRow';
  /** id AdEntity */
  id: Scalars['ID'];
  platform: Scalars['String'];
  externalId: Scalars['String'];
  name: Scalars['String'];
  campaignId?: Maybe<Scalars['ID']>;
  campaignName?: Maybe<Scalars['String']>;
  adsetName?: Maybe<Scalars['String']>;
  /** video | image | carousel | collection | dynamic | text | pmax | unknown */
  format: Scalars['String'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  firstDay?: Maybe<Scalars['Date']>;
  /** Дней от первого дня с данными */
  ageDays?: Maybe<Scalars['Int']>;
  familySlug?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  metrics: MarketingMetrics;
  /** Частота окна фильтра (AdPeriodReach ровно за это окно: 7 / 28 дней или месяц); иначе null — охват по дням не складывается */
  frequency?: Maybe<Scalars['Float']>;
  /** Охват окна 28 дней, кончающегося ровно в конце окна фильтра (обрезанном до вчера); иначе null */
  reach28d?: Maybe<Scalars['Int']>;
  /** 3-секундные / показы — дни окна, где есть оба числа */
  hookRate?: Maybe<Scalars['Float']>;
  /** ThruPlay / 3-секундные — дни окна, где есть оба числа */
  holdRate?: Maybe<Scalars['Float']>;
  /** Расход / лиды платформы (Meta — пиксель Lead любой формы сайта); null — лидов платформы нет или расход 0 */
  cplPlatformPln?: Maybe<Scalars['Decimal']>;
  fatigue: MarketingFatigue;
  /** ad — объявление | asset_group — группа ассетов PMax */
  level: Scalars['String'];
  /** ad — CRM-лиды и продажи самой строки | campaign — CRM всей родительской кампании (группа ассетов PMax: касания несут только кампанию; у кампании с несколькими группами CRM не делится) */
  crmScope: Scalars['String'];
  /** Конверсии площадки (Google) за окно — НЕ лиды; null — площадка их не отдаёт */
  conversionsPlatform?: Maybe<Scalars['Float']>;
  /** При withSeries (≤ 50 строк) */
  series?: Maybe<Array<MarketingSeriesPoint>>;
  /** ТЗ 0103: показатели того же объявления за окно сравнения (только при compare) */
  previous?: Maybe<MarketingMetrics>;
};

/**
 * Выгорание объявления — критерии сигнала `creative_fatigue`, окна от
 * СЕГОДНЯ (7 дней до вчера). Коды причин: ctr_drop_vs_start |
 * ctr_drop_vs_prev | frequency | cpm_up_ctr_down | cpl_up | hook_drop |
 * hold_drop.
 */
export type MarketingFatigue = {
  __typename?: 'MarketingFatigue';
  flagged: Scalars['Boolean'];
  reasons: Array<Scalars['String']>;
  /** Доля, 7 дней до вчера */
  ctr7d?: Maybe<Scalars['Float']>;
  /** Прежнее поле базы CTR: ctrStart (первые 7 активных дней), если он известен, иначе ctrPrev (прошлые 7 дней). Для подписи «до» — ctrStart / ctrPrev явно */
  ctrBase?: Maybe<Scalars['Float']>;
  /** CTR первых 7 активных дней объявления (null — старт неизвестен: история площадки начинается позже или старт внутри окна 7 дней) */
  ctrStart?: Maybe<Scalars['Float']>;
  /** CTR прошлых 7 дней */
  ctrPrev?: Maybe<Scalars['Float']>;
  /** Периодный охват 28 дней */
  frequency28d?: Maybe<Scalars['Float']>;
  /** CPM 7 дней, PLN */
  cpm7d?: Maybe<Scalars['Float']>;
  /** CPM прошлых 7 дней, PLN */
  cpmPrev?: Maybe<Scalars['Float']>;
  /** В процентах */
  cpmChangePct?: Maybe<Scalars['Float']>;
  /** CPL платформы 7 дней, PLN (при ≥ 5 лидах платформы) */
  cpl7d?: Maybe<Scalars['Float']>;
  /** Медиана дневного CPL платформы за жизнь объявления до окна, PLN */
  cplMedian?: Maybe<Scalars['Float']>;
  /** CPL платформы 7 дней / медиана жизни объявления */
  cplRatio?: Maybe<Scalars['Float']>;
  /** 3-секундные / показы, 7 дней */
  hookRate?: Maybe<Scalars['Float']>;
  /** Hook rate прошлых 7 дней */
  hookPrev?: Maybe<Scalars['Float']>;
  /** ThruPlay / 3-секундные, 7 дней */
  holdRate?: Maybe<Scalars['Float']>;
  /** Hold rate прошлых 7 дней */
  holdPrev?: Maybe<Scalars['Float']>;
};

export type MarketingFormatStat = {
  __typename?: 'MarketingFormatStat';
  format: Scalars['String'];
  familySlug?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  ads: Scalars['Int'];
  metrics: MarketingMetrics;
  hookRate?: Maybe<Scalars['Float']>;
};

/**
 * ТЗ 0103 §A5: группа строк креативов (`groupBy`). CRM кампании PMax —
 * один раз, в группе её главной группы ассетов.
 */
export type MarketingCreativeGroup = {
  __typename?: 'MarketingCreativeGroup';
  /** Код формата | slug | оффер | id кампании / группы | статус; none */
  key: Scalars['String'];
  label: Scalars['String'];
  ads: Scalars['Int'];
  metrics: MarketingMetrics;
};

export type MarketingCohortRow = {
  __typename?: 'MarketingCohortRow';
  /** ISO-неделя YYYY-Www | месяц YYYY-MM (недели — по понедельнику) */
  cohort: Scalars['String'];
  /** Понедельник первой недели */
  dateFrom?: Maybe<Scalars['Date']>;
  /** Воскресенье последней недели */
  dateTo?: Maybe<Scalars['Date']>;
  /** Значение splitBy (код канала | slug | single / multi); null — без разбивки */
  split?: Maybe<Scalars['String']>;
  splitLabel?: Maybe<Scalars['String']>;
  leads: Scalars['Int'];
  sales7: Scalars['Int'];
  sales14: Scalars['Int'];
  sales30: Scalars['Int'];
  sales60: Scalars['Int'];
  sales90: Scalars['Int'];
  revenue90Pln: Scalars['Decimal'];
  mature7: Scalars['Boolean'];
  mature14: Scalars['Boolean'];
  mature30: Scalars['Boolean'];
  mature60: Scalars['Boolean'];
  mature90: Scalars['Boolean'];
};

export type MarketingJourney = {
  __typename?: 'MarketingJourney';
  indirect: Array<MarketingJourneyStep>;
  /** key: 0 | 1 | 2plus */
  withinMain: Array<MarketingJourneyBucket>;
  /**
   * key: 0_7 | 8_14 | 15_30 | 31_60 | 61plus | unknown (people = buyers = продажи)
   * @deprecated Используйте lagSales: здесь people = buyers = число продаж, а не людей
   */
  lag: Array<MarketingJourneyBucket>;
  /** Лаг «лид → продажа»: продажи окна по корзинам дней */
  lagSales: Array<MarketingJourneyLagBucket>;
  /** key: lt1h | 1_4h | 4_24h | gt24h | unknown */
  speedToLead: Array<MarketingJourneyBucket>;
  /** С какой даты есть история этапов */
  historyFrom?: Maybe<Scalars['Date']>;
  /** Устройство заявки: mobile, desktop, tablet, unknown */
  byDevice: Array<MarketingDeviceRow>;
};

export type MarketingJourneyStep = {
  __typename?: 'MarketingJourneyStep';
  pipelineKind: Scalars['String'];
  people: Scalars['Int'];
  reachedMain: Scalars['Int'];
  buyers: Scalars['Int'];
};

export type MarketingJourneyBucket = {
  __typename?: 'MarketingJourneyBucket';
  key: Scalars['String'];
  people: Scalars['Int'];
  buyers: Scalars['Int'];
};

/**
 * Лаг «лид → продажа» (проход 29.09): продажи окна по дням от входа
 * лида-конверсии в New leads до подписи.
 */
export type MarketingJourneyLagBucket = {
  __typename?: 'MarketingJourneyLagBucket';
  /** 0_7 | 8_14 | 15_30 | 31_60 | 61plus | unknown (без лида) */
  key: Scalars['String'];
  /** Число продаж, а не людей */
  sales: Scalars['Int'];
};

/**
 * Устройство заявки (29.09): CRM-лиды окна по устройству входа в New
 * leads, продажи окна по устройству лида-конверсии. Строк всегда четыре:
 * mobile, desktop, tablet, unknown; их сумма = итогу окна.
 */
export type MarketingDeviceRow = {
  __typename?: 'MarketingDeviceRow';
  /** mobile | desktop | tablet | unknown */
  device: Scalars['String'];
  /** CRM-лиды без повторных заявок */
  crmLeads: Scalars['Int'];
  /** Повторные заявки */
  crmLeadsRepeat: Scalars['Int'];
  sales: Scalars['Int'];
  /** Подписано: цена продаж, PLN */
  revenuePln: Scalars['Decimal'];
  /** Доля: продажи / CRM-лиды; null — лидов нет */
  conversion?: Maybe<Scalars['Float']>;
};

export type MarketingTargetType = {
  __typename?: 'MarketingTargetType';
  id: Scalars['ID'];
  month: Scalars['Date'];
  /** Пусто — все каналы */
  channel: Scalars['String'];
  /** null — все семейства */
  familySlug?: Maybe<Scalars['String']>;
  metric: Scalars['String'];
  value: Scalars['Decimal'];
  note: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type MarketingSignalType = {
  __typename?: 'MarketingSignalType';
  id: Scalars['ID'];
  kind: Scalars['String'];
  severity: Scalars['String'];
  status: Scalars['String'];
  entityId?: Maybe<Scalars['ID']>;
  entityName?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  channel?: Maybe<MarketingChannel>;
  windowFrom: Scalars['Date'];
  windowTo: Scalars['Date'];
  /** Числа-доказательства; score — насколько плохо (больше — хуже) */
  metrics: Scalars['JSONString'];
  /** Параметры текста для фронта */
  params: Scalars['JSONString'];
  firstSeen: Scalars['DateTime'];
  lastSeen: Scalars['DateTime'];
  ackBy?: Maybe<Scalars['String']>;
};

/** Отчёт ОДНОГО поисковика: Google (GSC) и Bing не складываются. */
export type MarketingSearchReport = {
  __typename?: 'MarketingSearchReport';
  /** google | bing */
  engine: Scalars['String'];
  /** За окно: итог GSC — единственная полная цифра кликов */
  total: MarketingSearchPoint;
  series: Array<MarketingSearchPoint>;
  /** Доля кликов итога, раскрытых строками запросов (≈ 0.3); у Bing — null */
  namedClicksShare?: Maybe<Scalars['Float']>;
  zones: Array<MarketingSearchZone>;
  rows: Array<MarketingSearchRow>;
  totalCount: Scalars['Int'];
  provisionalFrom?: Maybe<Scalars['Date']>;
  /** Bing: день снимка строк */
  snapshotDate?: Maybe<Scalars['Date']>;
  /** Итог и строки — по всему домену, включая поддомены (ресурс GSC sc-domain:); у Bing — false */
  includesSubdomains: Scalars['Boolean'];
  /** Хосты страниц окна вне siteHosts (lms., webinars.) — входят в итог */
  otherHosts: Array<Scalars['String']>;
};

export type MarketingSearchPoint = {
  __typename?: 'MarketingSearchPoint';
  /** День; у итога окна — первый день окна */
  day: Scalars['Date'];
  clicks: Scalars['Int'];
  impressions: Scalars['Int'];
  position?: Maybe<Scalars['Float']>;
};

export type MarketingSearchZone = {
  __typename?: 'MarketingSearchZone';
  /** 1_3 | 4_10 | 11_20 | 21_50 | 51plus */
  zone: Scalars['String'];
  queries: Scalars['Int'];
  impressions: Scalars['Int'];
  clicks: Scalars['Int'];
};

/**
 * Строка разреза поиска за окно. Позиция — средняя, взвешенная
 * показами; `prev*` — такое же окно прямо перед (null — прошлое окно
 * собрано не целиком; ключа там нет — 0 и позиция null).
 */
export type MarketingSearchRow = {
  __typename?: 'MarketingSearchRow';
  /** Запрос / адрес страницы / страна / устройство */
  key: Scalars['String'];
  /** Страница пары query_page */
  key2?: Maybe<Scalars['String']>;
  /** Хост страницы (page — key, query_page — key2); иначе null */
  host?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  brand: Scalars['Boolean'];
  clicks: Scalars['Int'];
  impressions: Scalars['Int'];
  /** Доля: clicks / impressions */
  ctr?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  prevClicks?: Maybe<Scalars['Int']>;
  prevImpressions?: Maybe<Scalars['Int']>;
  prevPosition?: Maybe<Scalars['Float']>;
};

export type MarketingTrafficRow = {
  __typename?: 'MarketingTrafficRow';
  /** Группа каналов GA4 */
  channelGroup: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  campaign?: Maybe<Scalars['String']>;
  sessions: Scalars['Int'];
  /** Сумма дневных пользователей GA4 — не уникальные люди за период */
  users: Scalars['Int'];
  engaged: Scalars['Int'];
  keyEvents: Scalars['Int'];
};

export type MarketingLandingRow = {
  __typename?: 'MarketingLandingRow';
  /** Путь без хоста, запроса и «/» в конце */
  page: Scalars['String'];
  familySlug?: Maybe<Scalars['String']>;
  sessions: Scalars['Int'];
  engaged: Scalars['Int'];
  /** {событие: число} по ключевым событиям из настроек */
  keyEvents: Scalars['JSONString'];
  /** Клики GSC той же страницы — рядом, не складывать с сессиями; null — GSC за окно не собран */
  gscClicks?: Maybe<Scalars['Int']>;
  gscImpressions?: Maybe<Scalars['Int']>;
};

export type MarketingAiReferralRow = {
  __typename?: 'MarketingAiReferralRow';
  assistant: Scalars['String'];
  landingPage?: Maybe<Scalars['String']>;
  sessions: Scalars['Int'];
  engaged: Scalars['Int'];
};

/**
 * Спрос семейства курса за окно: НЕбрендовые показы и клики запросов GSC
 * (неполный срез — нижняя граница), CRM-лиды с этим курсом, продажи.
 */
export type MarketingDemandRow = {
  __typename?: 'MarketingDemandRow';
  familySlug: Scalars['String'];
  familyName: Scalars['String'];
  isSold: Scalars['Boolean'];
  impressions: Scalars['Int'];
  prevImpressions?: Maybe<Scalars['Int']>;
  clicks: Scalars['Int'];
  topQueries: Array<MarketingSearchRow>;
  crmLeads: Scalars['Int'];
  sales: Scalars['Float'];
  /** Σ частотности небрендовых запросов курса в месяц (DataForSEO); null — нет данных */
  searchVolume?: Maybe<Scalars['Int']>;
  /** Частотность по месяцам (12, от старого к новому) */
  volumeTrend?: Maybe<Array<Scalars['Int']>>;
  /** Месяцы volumeTrend, YYYY-MM */
  volumeMonths?: Maybe<Array<Scalars['String']>>;
};

export type MarketingSearchTermsPage = {
  __typename?: 'MarketingSearchTermsPage';
  rows: Array<MarketingSearchTermRow>;
  totalCount: Scalars['Int'];
  /** Σ расхода запросов / Σ расхода кампаний Search за окно (≈ 0.5: остальное Google не раскрывает); null — расхода кампаний нет */
  coverageShare?: Maybe<Scalars['Float']>;
};

/**
 * Поисковый запрос кампании Google Ads Search за окно (запрос ×
 * кампания × группа). `conversions` — конверсии Google, НЕ лиды.
 */
export type MarketingSearchTermRow = {
  __typename?: 'MarketingSearchTermRow';
  term: Scalars['String'];
  campaign?: Maybe<Scalars['String']>;
  adGroup?: Maybe<Scalars['String']>;
  impressions: Scalars['Int'];
  clicks: Scalars['Int'];
  /** null — нет курса валюты */
  spendPln?: Maybe<Scalars['Decimal']>;
  conversions?: Maybe<Scalars['Float']>;
  familySlug?: Maybe<Scalars['String']>;
};

/**
 * Прогноз продаж месяца по семейству: продажи с 1-го входят целиком,
 * P10 / P50 / P90 — симуляция; малая база (< 30 лидов за 180 дней) —
 * только P50. Прошедший месяц — факт.
 */
export type MarketingForecastRow = {
  __typename?: 'MarketingForecastRow';
  familySlug: Scalars['String'];
  familyName: Scalars['String'];
  month: Scalars['Date'];
  salesMtd: Scalars['Int'];
  p10?: Maybe<Scalars['Float']>;
  p50: Scalars['Float'];
  p90?: Maybe<Scalars['Float']>;
  /** План продаж месяца (все каналы) */
  target?: Maybe<Scalars['Decimal']>;
  smallBase: Scalars['Boolean'];
  openLeads: Array<MarketingForecastStage>;
  expectedNewLeads: Scalars['Float'];
  /** Конверсия новых лидов до конца месяца с учётом лага */
  leadToSale?: Maybe<Scalars['Float']>;
  groups: Array<MarketingGroupFill>;
  /** Дней до конца месяца с сегодня включительно */
  daysLeft?: Maybe<Scalars['Int']>;
  /** Входов в New leads в день, 28 дней */
  pace28d?: Maybe<Scalars['Float']>;
  expectedFromOpenLeads?: Maybe<Scalars['Float']>;
  expectedFromNewLeads?: Maybe<Scalars['Float']>;
};

/**
 * Открытые лиды New leads семейства на одном этапе Kommo и вероятность
 * «этап → продажа до конца месяца».
 */
export type MarketingForecastStage = {
  __typename?: 'MarketingForecastStage';
  /** Имя этапа Kommo; unknown — этап неизвестен */
  stage: Scalars['String'];
  leads: Scalars['Int'];
  /** Доля 0..1 */
  probability?: Maybe<Scalars['Float']>;
  /** stage — по снимкам прошлого этого этапа; overall — наблюдений < 20, взята общая конверсия семейства */
  basis?: Maybe<Scalars['String']>;
  /** Сколько раз этап встречался в снимках прошлого */
  observations?: Maybe<Scalars['Int']>;
};

/**
 * Ближайшая группа семейства (старт в 60 дней): места, зачислено,
 * ожидаемые продажи до старта, заполнение P50, риск недобора (< 60 %).
 */
export type MarketingGroupFill = {
  __typename?: 'MarketingGroupFill';
  groupId: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
  /** 0 — набор закрыт; null — мест не задано */
  seats?: Maybe<Scalars['Int']>;
  enrolled: Scalars['Int'];
  expectedBeforeStart: Scalars['Float'];
  /** Доля мест 0..1; null — мест 0 или не задано */
  fillP50?: Maybe<Scalars['Float']>;
  risk: Scalars['Boolean'];
};

/**
 * Замороженный снимок завершённой ISO-недели (пн–вс по Варшаве):
 * пересчёт площадок его не меняет.
 */
export type MarketingSnapshotType = {
  __typename?: 'MarketingSnapshotType';
  id: Scalars['ID'];
  isoWeek: Scalars['String'];
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  frozenAt: Scalars['DateTime'];
  dataVersion: Scalars['Int'];
  /** Сколько раз пересобран явно (--force) */
  rebuiltCount: Scalars['Int'];
  /** Выжимка: ключевые показатели недели и прошлой, покрытие, число сигналов */
  summary: Scalars['JSONString'];
  /** Снимок целиком (десятки КБ) — спрашивать только для одной недели */
  payload?: Maybe<Scalars['JSONString']>;
};

/**
 * AI-сводка недели. `text` — только опубликованная (статус
 * published); отклонённый проверкой чисел черновик наружу не отдаётся.
 */
export type MarketingDigestType = {
  __typename?: 'MarketingDigestType';
  id: Scalars['ID'];
  isoWeek: Scalars['String'];
  /** queued | running | published | rejected | failed */
  status: Scalars['String'];
  /** Markdown; только у published */
  text?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  /** Сколько чисел текста сверено */
  factsChecked: Scalars['Int'];
  /** Числа текста, которых нет в фактах снимка */
  rejectedNumbers: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Кто поставил; null — расписание */
  createdBy?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  /** Запросов к модели: 2 — была исправляющая попытка */
  attempts: Scalars['Int'];
  inputTokens: Scalars['Int'];
  outputTokens: Scalars['Int'];
};

export type MarketingEmailReport = {
  __typename?: 'MarketingEmailReport';
  sends: Array<MarketingEmailSend>;
  /** Рассылки по дням (UTC SendGrid): clicks = unique_clicks, impressions = delivered */
  series: Array<MarketingSearchPoint>;
  delivered: Scalars['Int'];
  uniqueOpens: Scalars['Int'];
  uniqueClicks: Scalars['Int'];
  /** CRM-лиды с меткой письма, без повторов */
  emailLeads: Scalars['Int'];
  emailSales: Scalars['Float'];
  /** Весь аккаунт — отдельно */
  account: MarketingEmailTotals;
  categories: Array<MarketingEmailCategory>;
};

/**
 * Рассылка SendGrid за окно. Лиды и продажи с меткой письма —
 * совпадение по метке, не причинность (контрольной группы нет).
 */
export type MarketingEmailSend = {
  __typename?: 'MarketingEmailSend';
  id: Scalars['String'];
  name: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  delivered: Scalars['Int'];
  uniqueOpens: Scalars['Int'];
  uniqueClicks: Scalars['Int'];
  unsubscribes: Scalars['Int'];
  bounces: Scalars['Int'];
  emailLeads: Scalars['Int'];
  emailSales: Scalars['Float'];
  categories: Array<Scalars['String']>;
};

/**
 * Весь аккаунт SendGrid (`/v3/stats`: рассылки + автоматизации +
 * транзакционные письма ERP) — с рассылками не складывается.
 */
export type MarketingEmailTotals = {
  __typename?: 'MarketingEmailTotals';
  delivered: Scalars['Int'];
  uniqueOpens: Scalars['Int'];
  uniqueClicks: Scalars['Int'];
  requests: Scalars['Int'];
};

export type MarketingEmailCategory = {
  __typename?: 'MarketingEmailCategory';
  name: Scalars['String'];
  delivered: Scalars['Int'];
  uniqueOpens: Scalars['Int'];
  uniqueClicks: Scalars['Int'];
};

export type MarketingOfflineConversionsType = {
  __typename?: 'MarketingOfflineConversionsType';
  enabled: Scalars['Boolean'];
  googleEnabled: Scalars['Boolean'];
  metaEnabled: Scalars['Boolean'];
  retractEnabled: Scalars['Boolean'];
  /** Дата запуска; null — не задана (не уходит ничего) */
  since?: Maybe<Scalars['Date']>;
  lastRun?: Maybe<MarketingOfflineRunType>;
  counts7d: Array<MarketingOfflineCountType>;
  counts30d: Array<MarketingOfflineCountType>;
  /** Пропуски, отказы и отзывы — новые сверху */
  issues: Array<MarketingOfflineIssueType>;
};

export type MarketingOfflineRunType = {
  __typename?: 'MarketingOfflineRunType';
  /** running | success | failed */
  status: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  /** Коды ошибок площадок, без данных людей */
  errorMessage?: Maybe<Scalars['String']>;
  /** Итог прогона: план по статусам, отправлено, отзыв */
  stats?: Maybe<Scalars['JSONString']>;
};

export type MarketingOfflineCountType = {
  __typename?: 'MarketingOfflineCountType';
  /** google | meta */
  platform: Scalars['String'];
  /** sale | contract_sent */
  event: Scalars['String'];
  /** pending | sent | rejected | skipped_no_consent | skipped_window | skipped_before_launch | retract_pending | retracted */
  status: Scalars['String'];
  count: Scalars['Int'];
};

export type MarketingOfflineIssueType = {
  __typename?: 'MarketingOfflineIssueType';
  id: Scalars['ID'];
  platform: Scalars['String'];
  event: Scalars['String'];
  status: Scalars['String'];
  /** Код площадки или причины (no_match_keys, retract_off, journal_only, stand_guard) */
  errorCode?: Maybe<Scalars['String']>;
  eventTime?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  /** Текущий id продажи (инспектор `insp=sale:<id>`); null — продажи сейчас нет */
  saleId?: Maybe<Scalars['Int']>;
  /** «Договор ERP #123» / «PandaDoc …» — без ПДн */
  documentLabel: Scalars['String'];
  /** esign | pandadoc — подпись документа строит фронт */
  source: Scalars['String'];
  /** Номер документа: pk договора ERP или id PandaDoc */
  sourceId: Scalars['String'];
};

/**
 * Отправленные договоры за окно (ТЗ 0103 §B4) — ТОЛЬКО числа: ни
 * номеров, ни имён, ни email. По кампаниям и объявлениям — поля
 * `contracts*` у `MarketingMetrics` разбивки и креативов.
 */
export type MarketingContractsReport = {
  __typename?: 'MarketingContractsReport';
  totals: MarketingContractsTotals;
  /** Все периоды окна по дню отправки */
  series: Array<MarketingContractsPoint>;
  /** key: lt1d | 1_3d | 3_7d | 7_14d | 14d_plus — от отправки до первой подписи эпизода */
  timeToSign: Array<MarketingContractsBucket>;
  /** Ждущие подписи по дням от отправки до сегодня — key: 0_3d | 4_7d | 8_14d | 15_30d | 31d_plus */
  pendingAge: Array<MarketingContractsBucket>;
  /** Все виды, B2B (company) — только здесь; direct, funding, company — всегда */
  byKind: Array<MarketingContractsKindRow>;
  /** Воронка атрибуции договоров накопительно: none / lead / channel / campaign / ad */
  coverage: Array<MarketingCoverageStep>;
  /** Ревью 0103: только при filter.legalEntityId — договоры «юрлицо неизвестно» (PandaDoc до подписи, когда юрлицо не вывелось из курсов семейства и не единственное в базе) отдельной строкой; в totals и signRate не входят. Без фильтра юрлица — null */
  unknownLegalEntity?: Maybe<MarketingContractsCounts>;
  compareInfo?: Maybe<MarketingCompareInfo>;
};

/**
 * Эпизоды договоров (прямые и Dofinansowanie) с днём отправки в окне;
 * подписан / ждёт / потерян — исход эпизода.
 */
export type MarketingContractsTotals = {
  __typename?: 'MarketingContractsTotals';
  sent: Scalars['Int'];
  /** Хоть один документ эпизода открыт или подписан */
  opened: Scalars['Int'];
  signed: Scalars['Int'];
  pending: Scalars['Int'];
  lost: Scalars['Int'];
  /** Доля: signed / sent */
  signRate?: Maybe<Scalars['Float']>;
  /** Медиана часов от отправки до первой подписи эпизода */
  medianHoursToSign?: Maybe<Scalars['Float']>;
  /** Медиана дней от входа лида-конверсии в New leads (нет его — от первого касания) до отправки */
  medianDaysLeadToContract?: Maybe<Scalars['Float']>;
  /** ТЗ 0103: те же числа за окно сравнения (только при compare) */
  previous?: Maybe<MarketingContractsTotals>;
};

export type MarketingContractsPoint = {
  __typename?: 'MarketingContractsPoint';
  period: Scalars['String'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  sent: Scalars['Int'];
  signed: Scalars['Int'];
  pending: Scalars['Int'];
  lost: Scalars['Int'];
  /** ТЗ 0103: корзина окна сравнения с тем же номером */
  previous?: Maybe<MarketingContractsCounts>;
  previousPeriod?: Maybe<Scalars['String']>;
};

export type MarketingContractsCounts = {
  __typename?: 'MarketingContractsCounts';
  sent: Scalars['Int'];
  signed: Scalars['Int'];
  pending: Scalars['Int'];
  lost: Scalars['Int'];
};

/** Корзина распределения: код корзины (фронт переводит) и число. */
export type MarketingContractsBucket = {
  __typename?: 'MarketingContractsBucket';
  key: Scalars['String'];
  count: Scalars['Int'];
};

export type MarketingContractsKindRow = {
  __typename?: 'MarketingContractsKindRow';
  /** direct | funding | company | … */
  kind: Scalars['String'];
  sent: Scalars['Int'];
  signed: Scalars['Int'];
  pending: Scalars['Int'];
  lost: Scalars['Int'];
};

/**
 * ТЗ 0103 §A6: CRM-лиды по корзинам (`LeadEntry`) + продажи их
 * лидов-конверсий. Σ crmLeads корзин = DailyFact.crm_leads при том же
 * фильтре без лид-измерений.
 */
export type MarketingLeadDynamics = {
  __typename?: 'MarketingLeadDynamics';
  granularity: Scalars['String'];
  groupBy: Scalars['String'];
  points: Array<MarketingLeadDynamicsPoint>;
  /** Легенда: первые top по CRM-лидам + other */
  groups: Array<MarketingLeadGroup>;
  totals: MarketingLeadTotals;
  compareInfo?: Maybe<MarketingCompareInfo>;
};

export type MarketingLeadDynamicsPoint = {
  __typename?: 'MarketingLeadDynamicsPoint';
  period: Scalars['String'];
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  /** CRM-лиды: входы без повторов */
  crmLeads: Scalars['Int'];
  crmLeadsRepeat: Scalars['Int'];
  /** Продажи по дню подписи, чей лид-конверсия — в сегменте */
  sales: Scalars['Int'];
  revenuePln: Scalars['Decimal'];
  /** Все группы легенды (нули тоже) */
  groups: Array<MarketingLeadGroupValue>;
  previousPeriod?: Maybe<Scalars['String']>;
  previousDateFrom?: Maybe<Scalars['Date']>;
  previousDateTo?: Maybe<Scalars['Date']>;
  previousCrmLeads?: Maybe<Scalars['Int']>;
  previousCrmLeadsRepeat?: Maybe<Scalars['Int']>;
  previousSales?: Maybe<Scalars['Int']>;
  previousRevenuePln?: Maybe<Scalars['Decimal']>;
};

export type MarketingLeadGroupValue = {
  __typename?: 'MarketingLeadGroupValue';
  key: Scalars['String'];
  crmLeads: Scalars['Int'];
  crmLeadsRepeat: Scalars['Int'];
  sales: Scalars['Int'];
  revenuePln: Scalars['Decimal'];
};

export type MarketingLeadGroup = {
  __typename?: 'MarketingLeadGroup';
  /** Код / slug / id; none — нет значения; __rest__ — прочее (за пределами top; подпись «Прочее» — фронт) */
  key: Scalars['String'];
  label: Scalars['String'];
  crmLeads: Scalars['Int'];
  crmLeadsRepeat: Scalars['Int'];
  sales: Scalars['Int'];
  revenuePln: Scalars['Decimal'];
};

export type MarketingLeadTotals = {
  __typename?: 'MarketingLeadTotals';
  crmLeads: Scalars['Int'];
  crmLeadsRepeat: Scalars['Int'];
  sales: Scalars['Int'];
  revenuePln: Scalars['Decimal'];
  previous?: Maybe<MarketingLeadTotals>;
};

export type MarketingPathCohortRow = {
  __typename?: 'MarketingPathCohortRow';
  /** path_kind: single | multi; channel_set: meta+seo_google; first_last: seo_google>meta; __rest__ — прочее (подпись «Прочее» — фронт) */
  key: Scalars['String'];
  leads: Scalars['Int'];
  sales7: Scalars['Int'];
  sales14: Scalars['Int'];
  sales30: Scalars['Int'];
  sales60: Scalars['Int'];
  sales90: Scalars['Int'];
  revenue90Pln: Scalars['Decimal'];
  /** Доля: sales90 / leads */
  conversion90?: Maybe<Scalars['Float']>;
  /** Доля лидов старше 90 дней (остальные ещё зреют) */
  matureShare?: Maybe<Scalars['Float']>;
};

export type MarketingOverlapCell = {
  __typename?: 'MarketingOverlapCell';
  row: Scalars['String'];
  col: Scalars['String'];
  /** Лиды, в пути которых оба канала (диагональ — канал в пути) */
  leads: Scalars['Int'];
  sales: Scalars['Int'];
};

/**
 * Действие «Сегодня»: открытый сигнал, гипотеза бюджета или
 * возможность SEO (ТЗ 0103 §E6). Тексты — по titleKey + params на
 * фронте.
 */
export type MarketingActionItem = {
  __typename?: 'MarketingActionItem';
  /** signal:<id> | seo:<id> */
  id: Scalars['ID'];
  /** signal | hypothesis | seo */
  source: Scalars['String'];
  kind: Scalars['String'];
  severity: Scalars['String'];
  titleKey: Scalars['String'];
  params: Scalars['JSONString'];
  /** Числа-доказательства */
  metrics: Scalars['JSONString'];
  /** Грубая оценка денег под действием, PLN; null — нет. Возможность SEO (source=seo): Ценность запроса, PLN в месяц (грубая оценка для ранжирования, не отчёт) — одна формула для всех видов: спрос в месяц × доля кликов на целевой 3-й позиции (CTR 10 %, кривая-оценка) × доля заявок (CRM-лиды seo_google ÷ все клики Google за 90 дней) × продажи ÷ лиды курса (seo_google, одно окно ≤ 365 дней с начала истории лидов) × средний чек курса (365 дней). У одного запроса — одна оценка в любом виде, у темы — наибольшая по её запросам; null — запрос без продаваемого курса (нет ни конверсии, ни чека) или без частотности */
  valuePlnEst?: Maybe<Scalars['Float']>;
  /** Вид денег оценки (складывать разные виды нельзя): lost — расход без результата; potential — возможность SEO, выручка в месяц; pending — договоры ждут подписи; spend — расход под гипотезой бюджета. Код — по виду действия, и у действия без оценки тоже */
  valueKind?: Maybe<Scalars['String']>;
  /** За сколько дней посчитана оценка: 7 — расход без лидов, скачок CPL, обновить креатив, починить разметку; окно сигнала (60) — лиды без продаж; 90 — урезать; 30 — SEO (в месяц); null — у оценки нет окна (договоры) или оценки нет */
  valueWindowDays?: Maybe<Scalars['Int']>;
  familySlug?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['ID']>;
  entityName?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  /** campaign:<id> | adset:<id> | ad:<id> | channel:<код> | family:<slug> | page:<путь> | keyword:<id> | competitor:<домен> */
  inspector?: Maybe<Scalars['String']>;
  /** Адрес ERP (новые вкладки) */
  link: Scalars['String'];
  /** Для «Принято / Скрыть» */
  signalId?: Maybe<Scalars['ID']>;
  windowFrom?: Maybe<Scalars['Date']>;
  windowTo?: Maybe<Scalars['Date']>;
  lastSeen?: Maybe<Scalars['DateTime']>;
  /** Карточка курса «Сегодня» (возможности SEO и seo_gap_new одного курса; кнопка — SEO › «Что написать» по курсу): та же оценка, что у карточки курса там, — наибольшая ценность тем курса (тема — наибольшая по её запросам). null — у элемента нет курса, курса нет в «Что написать» или у его тем нет оценки */
  familyValuePlnEst?: Maybe<Scalars['Float']>;
  /** Карточка курса «Сегодня»: запросов курса в «Что написать» (сумма по темам — то же число, что там); null — у элемента нет курса или курса там нет */
  familyKeywords?: Maybe<Scalars['Int']>;
};

export type MarketingPagesPage = {
  __typename?: 'MarketingPagesPage';
  rows: Array<MarketingPageRow>;
  totalCount: Scalars['Int'];
  /** Итог отфильтрованных строк (лиды и продажи — без двойного счёта) */
  totals: MarketingPageMetrics;
  previousTotals?: Maybe<MarketingPageMetrics>;
  /** Строки по типам страниц ДО фильтра типов (all — все) */
  typeCounts: Array<MarketingCount>;
  denominator?: Maybe<Scalars['String']>;
  /** С какого дня собирает свой счётчик; null — ещё нет */
  collectingSince?: Maybe<Scalars['Date']>;
  compareInfo?: Maybe<MarketingCompareInfo>;
};

export type MarketingPageRow = {
  __typename?: 'MarketingPageRow';
  /** Путь без хоста, запроса и «/» в конце */
  path: Scalars['String'];
  pageType?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  /** Первый день в справочнике страниц (свой счётчик) */
  firstSeen?: Maybe<Scalars['Date']>;
  metrics: MarketingPageMetrics;
  /** Окно сравнения; null — без сравнения */
  previous?: Maybe<MarketingPageMetrics>;
};

/**
 * Показатели страницы за окно. NULL — источник не собран за окно
 * (пропуск ≠ 0): GA4 — с фильтром каналов (группы GA4 на наши каналы не
 * делятся), GSC — не собран или фильтр каналов, свой счётчик — ещё не
 * собирал к концу окна.
 */
export type MarketingPageMetrics = {
  __typename?: 'MarketingPageMetrics';
  /** GA4: сессии посадочной */
  ga4Sessions?: Maybe<Scalars['Int']>;
  /** GA4: вовлечённые сессии */
  ga4Engaged?: Maybe<Scalars['Int']>;
  /** GA4: ключевые события посадочной (события из настроек ga4KeyEvents) */
  ga4KeyEvents?: Maybe<Scalars['Int']>;
  /** GA4: просмотры страницы */
  ga4Views?: Maybe<Scalars['Int']>;
  /** GSC: клики страницы */
  gscClicks?: Maybe<Scalars['Int']>;
  /** GSC: показы страницы */
  gscImpressions?: Maybe<Scalars['Int']>;
  /** Свой счётчик: просмотры */
  fpPageviews?: Maybe<Scalars['Int']>;
  /** Свой счётчик: входы — визиты, начавшиеся со страницы */
  fpEntrances?: Maybe<Scalars['Int']>;
  /** Свой счётчик: визиты, где страницу смотрели */
  fpSessions?: Maybe<Scalars['Int']>;
  /** Свой счётчик: сумма посетителей ДНЯ (между днями не складываются в «людей») */
  fpVisitors?: Maybe<Scalars['Int']>;
  /** Свой счётчик: показы формы */
  fpFormViews?: Maybe<Scalars['Int']>;
  /** Свой счётчик: отправки формы */
  fpFormSubmits?: Maybe<Scalars['Int']>;
  /** CRM-лиды (без повторов), у которых это посадочная заявки */
  crmLeadsLanding: Scalars['Int'];
  /** CRM-лиды, у которых это страница формы */
  crmLeadsForm: Scalars['Int'];
  /** CRM-лиды, которые видели страницу до заявки (только лиды с найденным посетителем) */
  crmLeadsAssisted: Scalars['Int'];
  /** Продажи окна, лид-конверсия которых пришёл с этой посадочной */
  salesLanding: Scalars['Int'];
  /** Продажи окна, лид-конверсия которых видел страницу до заявки */
  salesAssisted: Scalars['Int'];
  /** Доля: лиды посадочной / входы (свой счётчик) или сессии GA4 — см. denominator */
  landingConversion?: Maybe<Scalars['Float']>;
  /** Доля: лиды формы / просмотры (свой счётчик или GA4) */
  formConversion?: Maybe<Scalars['Float']>;
  /** Доля: помогла заявке / все лиды окна с найденным посетителем */
  assistRate?: Maybe<Scalars['Float']>;
  /** own — свой счётчик (собирал с начала окна) | ga4 | null — знаменателя нет */
  denominator?: Maybe<Scalars['String']>;
};

export type MarketingPageCard = {
  __typename?: 'MarketingPageCard';
  path: Scalars['String'];
  pageType?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  firstSeen?: Maybe<Scalars['Date']>;
  /** Страница есть в справочнике (её видел свой счётчик) */
  known: Scalars['Boolean'];
  metrics: MarketingPageMetrics;
  previous?: Maybe<MarketingPageMetrics>;
  series: Array<MarketingPagePoint>;
  entrySources: Array<MarketingPageSource>;
  nextPages: Array<MarketingPageLink>;
  gscQueries: Array<MarketingPageQuery>;
  denominator?: Maybe<Scalars['String']>;
  collectingSince?: Maybe<Scalars['Date']>;
  compareInfo?: Maybe<MarketingCompareInfo>;
};

export type MarketingPagePoint = {
  __typename?: 'MarketingPagePoint';
  period: Scalars['String'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  metrics: MarketingPageMetrics;
  previous?: Maybe<MarketingPageMetrics>;
  previousPeriod?: Maybe<Scalars['String']>;
  previousDateFrom?: Maybe<Scalars['Date']>;
  previousDateTo?: Maybe<Scalars['Date']>;
};

export type MarketingPageSource = {
  __typename?: 'MarketingPageSource';
  /** own — свой счётчик (канал визита) | ga4 — группа каналов GA4 */
  source: Scalars['String'];
  key: Scalars['String'];
  /** own — входы, ga4 — сессии */
  sessions: Scalars['Int'];
  /** Лиды посадочной этого канала (только own) */
  crmLeads?: Maybe<Scalars['Int']>;
  /** Только ga4 */
  keyEvents?: Maybe<Scalars['Int']>;
};

export type MarketingPageLink = {
  __typename?: 'MarketingPageLink';
  /** null — выход с сайта */
  path?: Maybe<Scalars['String']>;
  pageType?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  share: Scalars['Float'];
};

export type MarketingPageQuery = {
  __typename?: 'MarketingPageQuery';
  query: Scalars['String'];
  clicks: Scalars['Int'];
  impressions: Scalars['Int'];
  position?: Maybe<Scalars['Float']>;
};

export type MarketingVisitorJourney = {
  __typename?: 'MarketingVisitorJourney';
  kpis: MarketingVisitorKpis;
  previous?: Maybe<MarketingVisitorKpis>;
  /** 1 · 2 · 3_4 · 5_9 · 10_plus */
  visitsBeforeLead: Array<MarketingVisitorBucket>;
  /** same_visit · lt1 · 1_3 · 4_7 · 8_30 · 31_plus */
  daysToLead: Array<MarketingVisitorBucket>;
  /** 0_1 · 2 · 3_4 · 5_9 · 10_plus */
  pagesBeforeLead: Array<MarketingVisitorBucket>;
  /** Первый канал визита × канал визита с заявкой (none — заявка не из визита: звонок, лид другого устройства человека) */
  channelMatrix: Array<MarketingVisitorMatrixCell>;
  typicalPaths: Array<MarketingTypicalPath>;
  collectingSince?: Maybe<Scalars['Date']>;
  compareInfo?: Maybe<MarketingCompareInfo>;
};

export type MarketingVisitorKpis = {
  __typename?: 'MarketingVisitorKpis';
  /** CRM-лиды окна без повторов */
  leads: Scalars['Int'];
  /** Из них с найденным посетителем и визитами */
  linkedLeads: Scalars['Int'];
  linkedShare?: Maybe<Scalars['Float']>;
  /** Разные посетители с визитами окна */
  visitors: Scalars['Int'];
  sessions: Scalars['Int'];
  /** Визитов до заявки */
  medianVisits?: Maybe<Scalars['Float']>;
  /** Дней от первого визита до заявки */
  medianDays?: Maybe<Scalars['Float']>;
  /** Разных страниц до заявки */
  medianPages?: Maybe<Scalars['Float']>;
  /** Доля заявок в первом же визите */
  firstVisitShare?: Maybe<Scalars['Float']>;
};

export type MarketingVisitorBucket = {
  __typename?: 'MarketingVisitorBucket';
  key: Scalars['String'];
  count: Scalars['Int'];
  share?: Maybe<Scalars['Float']>;
  previous?: Maybe<Scalars['Int']>;
};

export type MarketingVisitorMatrixCell = {
  __typename?: 'MarketingVisitorMatrixCell';
  firstChannel: Scalars['String'];
  leadChannel: Scalars['String'];
  leads: Scalars['Int'];
};

export type MarketingTypicalPath = {
  __typename?: 'MarketingTypicalPath';
  /** Типы страниц до заявки по порядку */
  types: Array<Scalars['String']>;
  count: Scalars['Int'];
  share?: Maybe<Scalars['Float']>;
  medianDays?: Maybe<Scalars['Float']>;
};

export type MarketingVisitorsPage = {
  __typename?: 'MarketingVisitorsPage';
  rows: Array<MarketingVisitorSample>;
  totalCount: Scalars['Int'];
  /** Время лида — начало дня по Варшаве, дни до заявки — целые (все роли, кроме Admin): точное время вместе с курсом склеивало бы посетителя с продажей */
  roundedToDay: Scalars['Boolean'];
};

export type MarketingVisitorSample = {
  __typename?: 'MarketingVisitorSample';
  /** Анонимный посетитель — для marketingVisitor(id): 16 знаков, не порядковый номер */
  id?: Maybe<Scalars['ID']>;
  firstSeenAt?: Maybe<Scalars['DateTime']>;
  firstChannel?: Maybe<Scalars['String']>;
  sessions: Scalars['Int'];
  pageviews?: Maybe<Scalars['Int']>;
  pages?: Maybe<Scalars['Int']>;
  /** Не Admin — начало дня по Варшаве (roundedToDay) */
  leadAt?: Maybe<Scalars['DateTime']>;
  leadChannel?: Maybe<Scalars['String']>;
  /** Не Admin — целые дни (roundedToDay) */
  daysToLead?: Maybe<Scalars['Float']>;
  familySlug?: Maybe<Scalars['String']>;
  /** sale | contract_signed | contract_sent | lead | none */
  outcome: Scalars['String'];
};

export type MarketingLeadsPage = {
  __typename?: 'MarketingLeadsPage';
  items: Array<MarketingLeadRow>;
  total: Scalars['Int'];
};

export type MarketingLeadRow = {
  __typename?: 'MarketingLeadRow';
  /** id лида в ERP — карточка /leads?lead=…; null — лида нет в зеркале New leads */
  kommoLeadId?: Maybe<Scalars['ID']>;
  /** id лида в Kommo */
  kommoId: Scalars['ID'];
  /** Имя (контакт или сделка) */
  personName?: Maybe<Scalars['String']>;
  stage?: Maybe<LeadStageRef>;
  isClosed: Scalars['Boolean'];
  responsibleName?: Maybe<Scalars['String']>;
  /** Канал входа (код MarketingChannel в нижнем регистре) */
  channel: Scalars['String'];
  subChannel?: Maybe<Scalars['String']>;
  /** id AdEntity кампании */
  campaignId?: Maybe<Scalars['ID']>;
  campaignName?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  isRepeat: Scalars['Boolean'];
  /** Вход в New leads (точно) */
  createdAt: Scalars['DateTime'];
  /** Договор отправлен */
  hasContract: Scalars['Boolean'];
  contractSigned: Scalars['Boolean'];
  hasSale: Scalars['Boolean'];
  /** Цена в валюте договора */
  salePrice?: Maybe<Scalars['Float']>;
  saleCurrency?: Maybe<Scalars['String']>;
  salePricePln?: Maybe<Scalars['Float']>;
  /** Визитов на сайт до лида; null — посетитель не найден */
  visitsBefore?: Maybe<Scalars['Int']>;
};

export type LeadStageRef = {
  __typename?: 'LeadStageRef';
  /** id этапа в Kommo */
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Цвет этапа Kommo */
  color: Scalars['String'];
};

export type LeadJourney = {
  __typename?: 'LeadJourney';
  lead: LeadJourneyLead;
  events: Array<LeadJourneyEvent>;
};

export type LeadJourneyLead = {
  __typename?: 'LeadJourneyLead';
  kommoLeadId: Scalars['ID'];
  kommoId: Scalars['ID'];
  personName: Scalars['String'];
  /** Название сделки */
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  stage?: Maybe<LeadStageRef>;
  isClosed: Scalars['Boolean'];
  responsibleName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  courseRaw?: Maybe<Scalars['String']>;
  kommoUrl?: Maybe<Scalars['String']>;
};

export type LeadJourneyEvent = {
  __typename?: 'LeadJourneyEvent';
  /** Точное время (оплата — начало дня, meta.dateOnly) */
  at: Scalars['DateTime'];
  /** visit | page | form | lead_created | stage | touch | card_event | contract_sent | contract_opened | contract_signed | sale | payment */
  kind: Scalars['String'];
  /** Данные, не фраза: путь страницы, имя этапа / воронки, номер договора, сумма, код события карточки */
  title: Scalars['String'];
  /** visit — utm source / medium / campaign или реферер; stage — прежний этап; touch — этап */
  detail?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  /** neutral | info | success | warning | danger */
  tone: Scalars['String'];
  /** Подробности вида (camelCase) */
  meta: Scalars['JSONString'];
};

/**
 * Анонимный посетитель: визиты, страницы, лиды, договоры, продажи —
 * без e-mail, телефона и сырых id.
 */
export type MarketingVisitorTimeline = {
  __typename?: 'MarketingVisitorTimeline';
  id: Scalars['ID'];
  /** Время лида, договора и продажи — начало дня по Варшаве (все роли, кроме Admin); визиты — точно */
  roundedToDay: Scalars['Boolean'];
  firstSeenAt: Scalars['DateTime'];
  lastSeenAt: Scalars['DateTime'];
  sessions: Scalars['Int'];
  pageviews: Scalars['Int'];
  /** Устройств (посетителей), объединённых лидом */
  devices: Scalars['Int'];
  device?: Maybe<Scalars['String']>;
  events: Array<MarketingVisitorEvent>;
};

export type MarketingVisitorEvent = {
  __typename?: 'MarketingVisitorEvent';
  /** visit | lead | contract_sent | contract_signed | sale */
  kind: Scalars['String'];
  /** У lead / contract_* / sale для всех, кроме Admin, — начало дня по Варшаве (roundedToDay таймлайна) */
  at: Scalars['DateTime'];
  channel?: Maybe<Scalars['String']>;
  subChannel?: Maybe<Scalars['String']>;
  landingPath?: Maybe<Scalars['String']>;
  pages?: Maybe<Array<Scalars['String']>>;
  pageviews?: Maybe<Scalars['Int']>;
  durationS?: Maybe<Scalars['Int']>;
  formSubmits?: Maybe<Scalars['Int']>;
  device?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  isRepeat?: Maybe<Scalars['Boolean']>;
  pageType?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
};

export type ParticipationAgreementType = {
  __typename?: 'ParticipationAgreementType';
  id: Scalars['ID'];
  agreementTitle: Scalars['String'];
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  /** Первое занятие окна договора. */
  windowFrom?: Maybe<Scalars['Date']>;
  /** Последнее занятие окна договора. */
  windowTo?: Maybe<Scalars['Date']>;
  /** Основных занятий в окне договора. */
  lessonsCount: Scalars['Int'];
  terminated: Scalars['Boolean'];
  terminatedDate?: Maybe<Scalars['Date']>;
  statePrefinanced: Scalars['Boolean'];
  /** Договор дофинансирован (state_prefinanced, связан с кандидатом или кандидат с положительным решением). */
  cofunded: Scalars['Boolean'];
  /** Договор, привязанный к этому кандидату. */
  isCandidateAgreement: Scalars['Boolean'];
};

export type ParticipationSummaryType = {
  __typename?: 'ParticipationSummaryType';
  agreementId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  generatedAt: Scalars['DateTime'];
  minPercent: Scalars['Int'];
  supportId?: Maybe<Scalars['String']>;
  /** Ведущий оператор кандидата — id для ссылки на его карточку (#128); пусто вместе с `operatorName`. */
  operatorId?: Maybe<Scalars['ID']>;
  operatorName?: Maybe<Scalars['String']>;
  projectNumber?: Maybe<Scalars['String']>;
  lessonsPlanned: Scalars['Int'];
  lessonsHeld: Scalars['Int'];
  lessonsFuture: Scalars['Int'];
  lessonsWithZoomData: Scalars['Int'];
  lessonsAttended: Scalars['Int'];
  lessonsPartial: Scalars['Int'];
  lessonsAbsent: Scalars['Int'];
  additionalLessons: Scalars['Int'];
  additionalAttended: Scalars['Int'];
  minutesInZoom: Scalars['Int'];
  minutesPlanned: Scalars['Int'];
  minutesAttended: Scalars['Int'];
  hoursPercent?: Maybe<Scalars['Float']>;
  journalPresent: Scalars['Int'];
  journalPercent?: Maybe<Scalars['Float']>;
  lessons: Array<ParticipationLessonType>;
  warnings: Array<ParticipationWarningType>;
};

export type ParticipationLessonType = {
  __typename?: 'ParticipationLessonType';
  lessonId: Scalars['ID'];
  number: Scalars['Int'];
  date: Scalars['Date'];
  name?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  additional: Scalars['Boolean'];
  /** attended | partial | absent | no_zoom_data | expired | not_fetched | future | offline */
  status: Scalars['String'];
  /** Статус покрытия Zoom (zoomParticipantsCoverage). */
  zoomState: Scalars['String'];
  minutesPlanned: Scalars['Int'];
  minutesInZoom: Scalars['Int'];
  minutesOverlap: Scalars['Int'];
  percent?: Maybe<Scalars['Float']>;
  /** present | absent | unmarked | none */
  journal: Scalars['String'];
  sessionsCount: Scalars['Int'];
  firstJoin?: Maybe<Scalars['DateTime']>;
  lastLeave?: Maybe<Scalars['DateTime']>;
  sessions: Array<ParticipationSessionType>;
};

export type ParticipationSessionType = {
  __typename?: 'ParticipationSessionType';
  joinedAt?: Maybe<Scalars['DateTime']>;
  leftAt?: Maybe<Scalars['DateTime']>;
  minutes: Scalars['Int'];
  /** email | alias | name | manual */
  rule?: Maybe<Scalars['String']>;
};

export type ParticipationWarningType = {
  __typename?: 'ParticipationWarningType';
  /** not_fetched | no_zoom_data | expired | offline | lesson_ambiguous | zoom_forbidden | unresolved_participants | journal_mismatch | terminated | no_lessons | lesson_time_invalid | no_zoom_source */
  code: Scalars['String'];
  count: Scalars['Int'];
  dates: Array<Scalars['Date']>;
};

export type ParticipationFileType = {
  __typename?: 'ParticipationFileType';
  fileName: Scalars['String'];
  contentType: Scalars['String'];
  contentBase64: Scalars['String'];
};

export enum ParticipationReportFormat {
  Xlsx = 'XLSX',
  Pdf = 'PDF'
}

export type ZoomLessonCoverageType = {
  __typename?: 'ZoomLessonCoverageType';
  lessonId: Scalars['ID'];
  lessonName?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  startsAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  additional: Scalars['Boolean'];
  /** future | ok | pending | error | forbidden | expired | empty | ambiguous | offline | missing | no_source | not_fetched */
  status: Scalars['String'];
  /** manual | recording | join_url | host_time */
  rule?: Maybe<Scalars['String']>;
  instances: Array<ZoomMeetingInstanceType>;
  /** Кандидаты неоднозначного сопоставления (status=ambiguous). */
  candidateInstances: Array<ZoomMeetingInstanceType>;
  sessionsCount: Scalars['Int'];
  matchedCount: Scalars['Int'];
  unmatchedCount: Scalars['Int'];
  suggestedCount: Scalars['Int'];
  staffCount: Scalars['Int'];
  ignoredCount: Scalars['Int'];
};

export type ZoomMeetingInstanceType = {
  __typename?: 'ZoomMeetingInstanceType';
  id: Scalars['ID'];
  uuid: Scalars['String'];
  meetingId?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  participantsCount?: Maybe<Scalars['Int']>;
  lessonId?: Maybe<Scalars['ID']>;
  /** manual | recording | join_url | host_time */
  lessonRule?: Maybe<Scalars['String']>;
  lessonAmbiguous: Scalars['Boolean'];
  lessonLocked: Scalars['Boolean'];
  /** pending | ok | empty | expired | forbidden | error */
  participantsStatus: Scalars['String'];
  participantsFetchedAt?: Maybe<Scalars['DateTime']>;
  participantsError?: Maybe<Scalars['String']>;
};

export type ZoomParticipantSessionType = {
  __typename?: 'ZoomParticipantSessionType';
  id: Scalars['ID'];
  instanceId: Scalars['ID'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  joinTime?: Maybe<Scalars['DateTime']>;
  leaveTime?: Maybe<Scalars['DateTime']>;
  durationSeconds: Scalars['Int'];
  /** Статус Zoom: in_meeting | in_waiting_room */
  status?: Maybe<Scalars['String']>;
  failover: Scalars['Boolean'];
  identityKey: Scalars['String'];
  /** unmatched | auto | suggested | manual | staff | ignored | ambiguous */
  matchStatus: Scalars['String'];
  /** email | alias | name | click | manual | host | teacher */
  matchRule?: Maybe<Scalars['String']>;
  offRoster: Scalars['Boolean'];
  matchedUserId?: Maybe<Scalars['ID']>;
  matchedUserName?: Maybe<Scalars['String']>;
  matchedStudentId?: Maybe<Scalars['ID']>;
  matchedByName?: Maybe<Scalars['String']>;
  matchedAt?: Maybe<Scalars['DateTime']>;
};

export type ZoomRosterPersonType = {
  __typename?: 'ZoomRosterPersonType';
  userId: Scalars['ID'];
  studentId?: Maybe<Scalars['ID']>;
  fullName: Scalars['String'];
};

export type FundingMailSettingsType = {
  __typename?: 'FundingMailSettingsType';
  /** Пауза из ERP: робот не пишет, автоподбор стоит. */
  paused: Scalars['Boolean'];
  /** Сохранено в ERP; пусто — как на сервере. */
  fromEmail?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  /** С какого адреса письмо уйдёт на самом деле. */
  effectiveFromEmail?: Maybe<Scalars['String']>;
  effectiveFromName?: Maybe<Scalars['String']>;
  effectiveReplyTo?: Maybe<Scalars['String']>;
  /** Час писем «за N дней», по Варшаве. */
  soonSendHour: Scalars['Int'];
  /** Час писем «набор идёт», по Варшаве. */
  runningSendHour: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByName?: Maybe<Scalars['String']>;
  /** env DOFIN_MAIL_ENABLED — может ли этот сервер вообще писать людям. */
  serverMailEnabled: Scalars['Boolean'];
  /** env DOFIN_MAIL_TEST_RECIPIENT: все письма уходят на этот адрес, а не людям. */
  testRecipient?: Maybe<Scalars['String']>;
  /** env DOFIN_NOTIFY_ENABLED — письма о наборе в расписании. */
  notifyScheduled: Scalars['Boolean'];
  /** env DOFIN_AUTOMATCH_ENABLED — автоподбор (и письмо-знакомство) в расписании. */
  automatchScheduled: Scalars['Boolean'];
  /** Сократитель ссылок настроен (SHORTLINK_BASE_URL): без него письма со ссылками не уходят. */
  shortenerEnabled: Scalars['Boolean'];
  /** Почему автоподбор оператора сейчас стоит (он и шлёт письмо-знакомство): mail_off | paused | intro_off | shortener_off; пусто — не стоит. Та же проверка, что в задаче автоподбора. */
  automatchBlocked?: Maybe<Scalars['String']>;
  canEdit: Scalars['Boolean'];
};

export type FundingMailRuleType = {
  __typename?: 'FundingMailRuleType';
  id: Scalars['ID'];
  /** Неизменяемый код; у «за N дней» входит в ключ дедупликации писем. */
  code: Scalars['String'];
  /** operator_info | intake_soon | intake_running */
  kind: Scalars['String'];
  /** intake_soon: за сколько дней до старта (0 — в день старта). */
  offsetDays?: Maybe<Scalars['Int']>;
  /** intake_running: не чаще раза в N дней. */
  everyDays?: Maybe<Scalars['Int']>;
  templateId?: Maybe<Scalars['String']>;
  /** Имя шаблона, прочитанное из SendGrid при сохранении; пусто — ещё не сверялось (засеяно из env). */
  templateName?: Maybe<Scalars['String']>;
  templateSubject?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByName?: Maybe<Scalars['String']>;
  /** Удалить можно только «за N дней»; остальные — только выключить. */
  canDelete: Scalars['Boolean'];
  /** Сколько писем ушло по этому правилу. */
  sentCount: Scalars['Int'];
};

export type FundingMailVariableType = {
  __typename?: 'FundingMailVariableType';
  name: Scalars['String'];
  descriptionRu: Scalars['String'];
  descriptionPl: Scalars['String'];
  example: Scalars['String'];
};

export type FundingMailSendgridTemplatesType = {
  __typename?: 'FundingMailSendgridTemplatesType';
  success: Scalars['Boolean'];
  templates: Array<SendgridTemplateType>;
  /** sendgrid_unavailable | sendgrid_forbidden */
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** A dynamic template read live from the SendGrid API (not stored here). */
export type SendgridTemplateType = {
  __typename?: 'SendgridTemplateType';
  id: Scalars['String'];
  name: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  versionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CustomErrorType = {
  __typename?: 'CustomErrorType';
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type FundingMailTemplateCheckType = {
  __typename?: 'FundingMailTemplateCheckType';
  success: Scalars['Boolean'];
  templateId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  hasActiveVersion: Scalars['Boolean'];
  /** Все переменные, которые шаблон использует. */
  usedVariables: Array<Scalars['String']>;
  /** Шаблон их ждёт, а робот их НЕ передаёт — в письме будет пусто. */
  unknownVariables: Array<Scalars['String']>;
  /** Робот их передаёт, а шаблон не использует. */
  unusedVariables: Array<Scalars['String']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type FundingMailCalendarEntryType = {
  __typename?: 'FundingMailCalendarEntryType';
  date: Scalars['Date'];
  kind: Scalars['String'];
  ruleId: Scalars['ID'];
  offsetDays?: Maybe<Scalars['Int']>;
  /** Дней до старта набора. */
  daysLeft: Scalars['Int'];
  intakeId: Scalars['ID'];
  intakeStartsOn?: Maybe<Scalars['Date']>;
  intakeEndsOn?: Maybe<Scalars['Date']>;
  operatorId?: Maybe<Scalars['ID']>;
  operatorName?: Maybe<Scalars['String']>;
  /** Скольким уйдёт (аудитория окна минус те, кому по этому поводу уже писали). */
  recipients: Scalars['Int'];
  /** Скольким по этому поводу уже писали. */
  alreadySent: Scalars['Int'];
  templateId?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  /** Час, по Варшаве. */
  sendHour: Scalars['Int'];
  /** Когда письмо уйдёт на самом деле: будущий день и сегодня до часа — в час отправки, сегодня после часа — в ближайший запуск (в тот же день); пусто — по строке всё уже отправлено. */
  sendAt?: Maybe<Scalars['DateTime']>;
};

export type LeadSmsStateType = {
  __typename?: 'LeadSmsStateType';
  available: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  phoneMasked?: Maybe<Scalars['String']>;
  messages: Array<SmsMessageType>;
};

/**
 * Одна SMS любой темы. Тело — снимок отправленного; до отправки — текст
 * с подстановками (ссылка — `{link}`).
 */
export type SmsMessageType = {
  __typename?: 'SmsMessageType';
  id: Scalars['ID'];
  /** esign_signature | student_sms | group_sms | invoice_payment | lms_access | teacher_sms | lead_sms | lead_reminder | lead_dofin | dofin_candidate_sms */
  topic: Scalars['String'];
  step: Scalars['Int'];
  /** pending | sending | sent | skipped | failed */
  status: Scalars['String'];
  skipReason?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  phoneMasked?: Maybe<Scalars['String']>;
  segments?: Maybe<Scalars['Int']>;
  encoding?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  dlrStatus?: Maybe<Scalars['String']>;
  deliveredAt?: Maybe<Scalars['DateTime']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  scheduledFor?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  studentName?: Maybe<Scalars['String']>;
  teacherId?: Maybe<Scalars['ID']>;
  teacherName?: Maybe<Scalars['String']>;
  signerName?: Maybe<Scalars['String']>;
  leadId?: Maybe<Scalars['ID']>;
  leadName?: Maybe<Scalars['String']>;
  candidateId?: Maybe<Scalars['ID']>;
  candidateName?: Maybe<Scalars['String']>;
  subjectKind: Scalars['String'];
  subjectId: Scalars['ID'];
  subjectLabel?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  shortLinkId?: Maybe<Scalars['ID']>;
  shortLinkUrl?: Maybe<Scalars['String']>;
  targetUrl?: Maybe<Scalars['String']>;
  humanClicks: Scalars['Int'];
  clicks: Scalars['Int'];
  canRetry: Scalars['Boolean'];
  canCancel: Scalars['Boolean'];
};

/** Что уйдёт, если отправить текст сейчас: ссылка — образец той же длины. */
export type SmsPreviewType = {
  __typename?: 'SmsPreviewType';
  body: Scalars['String'];
  encoding: Scalars['String'];
  segments: Scalars['Int'];
  maxSegments: Scalars['Int'];
  tooLong: Scalars['Boolean'];
  withOptOut: Scalars['Boolean'];
  available: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type LeadSmsLinkInput = {
  /** none | url | dofin_form */
  kind: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type LeadSavedViewType = {
  __typename?: 'LeadSavedViewType';
  id: Scalars['ID'];
  name: Scalars['String'];
  filters: Scalars['GenericScalar'];
  /** leads: board | table; contracts: board | list */
  view: Scalars['String'];
  shared: Scalars['Boolean'];
  isMine: Scalars['Boolean'];
  position: Scalars['Int'];
  /** leads | contracts */
  scope: Scalars['String'];
};


export type KommoLeadPageType = {
  __typename?: 'KommoLeadPageType';
  items: Array<KommoLeadType>;
  total: Scalars['Int'];
  /** kommo | fake | disabled */
  source: Scalars['String'];
  /** Последняя синхронизация */
  syncedAt?: Maybe<Scalars['DateTime']>;
};

export type KommoLeadType = {
  __typename?: 'KommoLeadType';
  id: Scalars['ID'];
  kommoId: Scalars['ID'];
  name: Scalars['String'];
  personName: Scalars['String'];
  stage?: Maybe<KommoStageType>;
  isClosed: Scalars['Boolean'];
  inPipeline: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  /** Ответственный в Kommo */
  responsibleName: Scalars['String'];
  /** Сотрудник ERP за ответственным (сопоставление) */
  responsibleUserId?: Maybe<Scalars['ID']>;
  responsibleUserName?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
  phones: Array<Scalars['String']>;
  emails: Array<Scalars['String']>;
  kommoUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  syncedAt?: Maybe<Scalars['DateTime']>;
  lastSmsAt?: Maybe<Scalars['DateTime']>;
  smsCount: Scalars['Int'];
  contracts: Array<LeadContractType>;
  /** ТЗ 0086: все заявки дофинансирования с тем же email или телефоном (9 последних цифр) — варианты для выбора; связь — `fundingCandidate` */
  fundingCandidates: Array<LeadFundingCandidateType>;
  utm: LeadUtmType;
  /** Тот же человек в дофинансировании (хранимая связь) */
  fundingCandidate?: Maybe<LeadFundingLinkType>;
  /** Почему связан: form | email | phone | manual | ambiguous ('' — не нашли) */
  candidateRule: Scalars['String'];
  /** Связь поставлена или снята руками — робот её не трогает */
  candidateLocked: Scalars['Boolean'];
  /** Тот же человек среди аккаунтов (студент — если есть карточка) */
  linkedUser?: Maybe<LeadUserLinkType>;
  /** contract | candidate | email | phone | manual | ambiguous ('' — не нашли) */
  userRule: Scalars['String'];
  userLocked: Scalars['Boolean'];
  /** Аккаунты с тем же email или телефоном — варианты для выбора */
  userOptions: Array<LeadUserLinkType>;
  /** Связь стоит, но контакты лида указывают и на другую живую заявку (например, email — на одну, телефон — на другую): проверить, тот ли это человек */
  candidateConflict: Scalars['Boolean'];
  /** То же для аккаунта: есть другие аккаунты с этими контактами */
  userConflict: Scalars['Boolean'];
  /** Пошлёт ли лесенка каждого вида, если запустить сейчас */
  ladderReadiness: Array<LeadLadderReadinessType>;
  /** Последний запуск каждой лесенки */
  ladders: Array<LeadLadderChipType>;
  /** Бюджет сделки в Kommo (`price`); null — не задан */
  price?: Maybe<Scalars['Float']>;
  /** Поле «курс» лида в Kommo как есть */
  courseRaw: Scalars['String'];
  /** Когда лид попал на текущий этап: последняя смена этапа на него (история Kommo или перенос из ERP), иначе создание лида */
  stageEnteredAt?: Maybe<Scalars['DateTime']>;
  /** Пользователь Kommo-ответственный (id строки, как kommoLeadResponsibles.id) */
  responsibleId?: Maybe<Scalars['ID']>;
  /** Копия карточки сделки Aplora (старше 10 минут — живое чтение). null — Aplora выключена, лид не из Kommo или сделки в Aplora нет. В списке kommoLeads — только копия, без живого чтения */
  aplora?: Maybe<AploraLeadType>;
  /** Шанс покупки из копии Aplora (0…1); null — копии нет */
  aploraWinChance?: Maybe<Scalars['Float']>;
  /** A | B | C | DQ */
  aploraCategory?: Maybe<Scalars['String']>;
  /** HOT | WARM | COLD */
  aploraTemperature?: Maybe<Scalars['String']>;
  /** Следующий контакт по копии Aplora */
  aploraNextContactDate?: Maybe<Scalars['Date']>;
  /** Оценка L.E.A.R.N. из копии Aplora (scoring.learn_score) */
  aploraLearnScore?: Maybe<Scalars['Float']>;
  /** Клиент согласился (consent.highest_level — commitment или order); null — согласие не разобрано или копии нет */
  aploraConsent?: Maybe<Scalars['Boolean']>;
};

export type KommoStageType = {
  __typename?: 'KommoStageType';
  /** id этапа в Kommo */
  id: Scalars['ID'];
  name: Scalars['String'];
  color: Scalars['String'];
  sort: Scalars['Int'];
  isClosed: Scalars['Boolean'];
  /** Открытых лидов на этапе */
  leadsCount?: Maybe<Scalars['Int']>;
};

/** Договор ERP, оформленный из этого лида (0079, `crm_lead_id`). */
export type LeadContractType = {
  __typename?: 'LeadContractType';
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  kind: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  /** ТЗ 0090: лесенка подписи — только у договора студента (kind=student), иначе null */
  signingLadder?: Maybe<LeadContractSigningLadderType>;
};

/**
 * ТЗ 0090: лесенка подписи (`esign_signature`) договора студента —
 * состояние без текстов SMS. Видят все роли лидов, действуют — те, кто
 * ведёт договор (`canManage`).
 */
export type LeadContractSigningLadderType = {
  __typename?: 'LeadContractSigningLadderType';
  /** not_sent (черновик / отправка не удалась) | sending | running | stopped | closed (подписан, отклонён, отменён, истёк или ссылка уже не живая) */
  state: Scalars['String'];
  /** SMS подписанту сейчас возможны (канал, телефон, повод жив); у closed — false */
  available: Scalars['Boolean'];
  /** Почему нет: closed | no_phone | not_allowlisted | foreign_number | … (коды движка SMS) */
  reason?: Maybe<Scalars['String']>;
  /** Робот SMS работает и план подписи включён */
  autoReminders: Scalars['Boolean'];
  /** Когда уйдёт следующее SMS (только running) */
  nextStepAt?: Maybe<Scalars['DateTime']>;
  /** Почему следующего SMS нет: no_template | … */
  nextStepReason?: Maybe<Scalars['String']>;
  /** Когда договор ушёл подписанту */
  sentAt?: Maybe<Scalars['DateTime']>;
  /** ТЗ 0083: смотрящий ведёт договор — ему доступны действия с лесенкой (продавец договора, AM, Admin) */
  canManage: Scalars['Boolean'];
  /** Кто ведёт договор — только когда canManage = false; null — продавца нет (ведут AM и Admin) */
  handlerName?: Maybe<Scalars['String']>;
};

/**
 * Кандидат дофинансирования с тем же телефоном или email — «анкету уже
 * заполнял».
 */
export type LeadFundingCandidateType = {
  __typename?: 'LeadFundingCandidateType';
  id: Scalars['ID'];
  name: Scalars['String'];
  status: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  /** ТЗ 0086: анкета пришла по ссылке этого лида, но с другими email и телефоном (ссылку переслали) — робот такую заявку не связывает */
  formForeign?: Maybe<Scalars['Boolean']>;
};

/** Метки лида из стандартных полей Kommo (tracking_data). */
export type LeadUtmType = {
  __typename?: 'LeadUtmType';
  source: Scalars['String'];
  medium: Scalars['String'];
  campaign: Scalars['String'];
  content: Scalars['String'];
  term: Scalars['String'];
  referrer: Scalars['String'];
  formName: Scalars['String'];
  /** Все метки лида как есть: код поля Kommo → значение (GCLID, FBCLID, …) */
  tracking: Scalars['JSONString'];
};

/** Кандидат дофинансирования — тот же человек, что лид. */
export type LeadFundingLinkType = {
  __typename?: 'LeadFundingLinkType';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Этап воронки дофинансирования */
  status: Scalars['String'];
  isArchived: Scalars['Boolean'];
  /** Активные операторы (по ним уходят письма о наборах) */
  operators: Array<LeadFundingOperatorType>;
  intakeId?: Maybe<Scalars['ID']>;
  intakeStartsOn?: Maybe<Scalars['Date']>;
  intakeEndsOn?: Maybe<Scalars['Date']>;
  /** Последняя анкета с формы */
  lastSubmissionAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type LeadFundingOperatorType = {
  __typename?: 'LeadFundingOperatorType';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Пометка «ведущий» */
  isPrimary: Scalars['Boolean'];
};

/**
 * Аккаунт — тот же человек, что лид. Карточка студента — если он
 * студент.
 */
export type LeadUserLinkType = {
  __typename?: 'LeadUserLinkType';
  userId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** Пусто — аккаунт без карточки студента */
  studentId?: Maybe<Scalars['ID']>;
};

/** ТЗ 0084: пошлёт ли лесенка вида SMS, если запустить её сейчас. */
export type LeadLadderReadinessType = {
  __typename?: 'LeadLadderReadinessType';
  /** reminder | dofin_form */
  kind: Scalars['String'];
  /** Почему не пошлёт: closed | plan_disabled | robot_off | no_phone | not_allowlisted | … (пусто — пошлёт) */
  warning?: Maybe<Scalars['String']>;
  /** Первое SMS лесенки этому лиду, как уйдёт (ссылка — образец той же длины); null — у плана нет шага или шаблон выключен */
  firstSms?: Maybe<Scalars['String']>;
  firstSmsSegments: Scalars['Int'];
};

/** Последний запуск лесенки вида — для списка. */
export type LeadLadderChipType = {
  __typename?: 'LeadLadderChipType';
  /** reminder | dofin_form */
  kind: Scalars['String'];
  /** active | stopped | ended | form_submitted | contract_signed | lead_closed | left_pipeline | lead_deleted | replaced */
  status: Scalars['String'];
};

/**
 * Копия карточки сделки Aplora. `stale` — копия старше 10 минут и
 * живое чтение не удалось или было недавно; `error` — код неудачного
 * живого чтения (aplora_unavailable | aplora_rate_limited | …).
 */
export type AploraLeadType = {
  __typename?: 'AploraLeadType';
  aploraUrl?: Maybe<Scalars['String']>;
  crmUrl?: Maybe<Scalars['String']>;
  changedAt?: Maybe<Scalars['DateTime']>;
  syncedAt?: Maybe<Scalars['DateTime']>;
  stale: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  mergedIntoKommoId?: Maybe<Scalars['String']>;
  /** Статус сделки в Aplora */
  status?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  daysInFunnel?: Maybe<Scalars['Int']>;
  managerName?: Maybe<Scalars['String']>;
  scoring: AploraScoringType;
  /** С **жирным** на ключевых фактах, без HTML */
  summaryMd?: Maybe<Scalars['String']>;
  summaryText?: Maybe<Scalars['String']>;
  outcomeSummaryText?: Maybe<Scalars['String']>;
  lastContactAt?: Maybe<Scalars['DateTime']>;
  nextContactDate?: Maybe<Scalars['Date']>;
  nextContactTip?: Maybe<Scalars['String']>;
  callsTotal?: Maybe<Scalars['Int']>;
  callsAnalyzed?: Maybe<Scalars['Int']>;
  /** {overall_score, calls_analyzed, components, next_steps} */
  learn?: Maybe<Scalars['GenericScalar']>;
  /** [{risk, severity, recommendation}] */
  managerRisks?: Maybe<Scalars['GenericScalar']>;
  /** Аналитический профиль сделки: amount, cycle_days, jtbd_*, segment*, source, touches, missing… (без контакта) */
  profile?: Maybe<Scalars['GenericScalar']>;
  /** {outcome, reason, amount, currency, product, at} */
  outcome?: Maybe<Scalars['GenericScalar']>;
  /** {amount, currency} */
  dealAmount?: Maybe<Scalars['GenericScalar']>;
  /** [{id, slug, name, category, group, competency, influence, is_primary, explanation, detected_by, lead_subtype, notes, pattern_total, pattern_with}] — без цитат звонков */
  lossReasons?: Maybe<Scalars['GenericScalar']>;
  calls: Array<AploraCallBriefType>;
  /** {analysed, highest_level: none|contact|commitment|order, crm_gap, first_turning_point, decisive_call ({call_id, date, level})} — без цитат */
  consent?: Maybe<Scalars['GenericScalar']>;
  /** [{slug, name, is_primary, date, call_id}] — без цитат */
  externalFactors?: Maybe<Scalars['GenericScalar']>;
  acquisitionChannel?: Maybe<Scalars['String']>;
  /** {call_id, started_at, duration_seconds, direction, summary_text, score_band} */
  lastCall?: Maybe<Scalars['GenericScalar']>;
};

export type AploraScoringType = {
  __typename?: 'AploraScoringType';
  /** 0…1; у закрытой сделки 1 (выиграна) или 0 */
  winChance?: Maybe<Scalars['Float']>;
  /** first | second | rest; у закрытой — null */
  winTier?: Maybe<Scalars['String']>;
  /** A | B | C | DQ */
  leadCategory?: Maybe<Scalars['String']>;
  /** HOT | WARM | COLD */
  leadTemperature?: Maybe<Scalars['String']>;
  learnScore?: Maybe<Scalars['Float']>;
  qualificationCompleteness?: Maybe<Scalars['Float']>;
  dealProbability?: Maybe<Scalars['Float']>;
  avgManagerScore?: Maybe<Scalars['Float']>;
};

export type AploraCallBriefType = {
  __typename?: 'AploraCallBriefType';
  callId: Scalars['ID'];
  startedAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  direction?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  analyzed: Scalars['Boolean'];
  baseScore?: Maybe<Scalars['Float']>;
  growthScore?: Maybe<Scalars['Float']>;
  scoreBand?: Maybe<Scalars['String']>;
  summaryText?: Maybe<Scalars['String']>;
};

/** ТЗ 0086: варианты фильтров списка лидов со счётчиками. */
export type KommoLeadFacetsType = {
  __typename?: 'KommoLeadFacetsType';
  utmSource: Array<FacetValueType>;
  utmMedium: Array<FacetValueType>;
  utmCampaign: Array<FacetValueType>;
  fundingStatus: Array<FacetValueType>;
  withFunding: Scalars['Int'];
  withStudent: Scalars['Int'];
};

export type FacetValueType = {
  __typename?: 'FacetValueType';
  /** '' — без значения */
  value: Scalars['String'];
  count: Scalars['Int'];
};

/** ТЗ 0106: колонка доски — лидов на этапе и сумма их бюджетов. */
export type KommoLeadStageCountType = {
  __typename?: 'KommoLeadStageCountType';
  /** id этапа в Kommo */
  statusId: Scalars['ID'];
  count: Scalars['Int'];
  /** Сумма `price` лидов этапа (без бюджета — не в сумме) */
  priceSum: Scalars['Float'];
  /** ТЗ 0120: лидов этапа с шансом Aplora не ниже hotMinWinChance (по умолчанию 0.7) */
  hotCount: Scalars['Int'];
};

export type KommoLossReasonsType = {
  __typename?: 'KommoLossReasonsType';
  items: Array<KommoLossReasonType>;
  /** Kommo не ответил — items пустой */
  error?: Maybe<CrmErrorType>;
};

export type KommoLossReasonType = {
  __typename?: 'KommoLossReasonType';
  /** id причины в Kommo */
  id: Scalars['ID'];
  name: Scalars['String'];
  sort: Scalars['Int'];
};

export type CrmErrorType = {
  __typename?: 'CrmErrorType';
  /** NOT_CONFIGURED | DISABLED | NETWORK | AUTH | RATE_LIMITED | NO_PIPELINE | ERROR */
  code: Scalars['String'];
  message: Scalars['String'];
};

/** ТЗ 0106: кого можно назначить ответственным (без email). */
export type KommoResponsibleOptionType = {
  __typename?: 'KommoResponsibleOptionType';
  /** id строки пользователя Kommo (аргумент userId) */
  id: Scalars['ID'];
  kommoId: Scalars['ID'];
  name: Scalars['String'];
  erpUserId?: Maybe<Scalars['ID']>;
  erpUserName?: Maybe<Scalars['String']>;
};

export type KommoNotesType = {
  __typename?: 'KommoNotesType';
  items: Array<KommoNoteType>;
  error?: Maybe<CrmErrorType>;
};

export type KommoNoteType = {
  __typename?: 'KommoNoteType';
  id: Scalars['ID'];
  /** common | call_in | call_out | sms_in | sms_out | service_message | … */
  noteType: Scalars['String'];
  text: Scalars['String'];
  /** Звонок — длительность, с */
  duration?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  authorName?: Maybe<Scalars['String']>;
  fromErp: Scalars['Boolean'];
  /** Наше примечание, которого в Kommo ещё нет: pending | sending | failed | skipped | fake; пусто — из Kommo */
  erpStatus?: Maybe<Scalars['String']>;
};

export type LeadEventType = {
  __typename?: 'LeadEventType';
  id: Scalars['ID'];
  kind: Scalars['String'];
  actorName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  messageId?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
};

/** Запуск SMS-лесенки лида с состоянием движка (этап 2). */
export type LeadLadderRunType = {
  __typename?: 'LeadLadderRunType';
  id: Scalars['ID'];
  /** reminder | dofin_form */
  kind: Scalars['String'];
  topic: Scalars['String'];
  status: Scalars['String'];
  startedAt: Scalars['DateTime'];
  startedByName?: Maybe<Scalars['String']>;
  days?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  stoppedAt?: Maybe<Scalars['DateTime']>;
  stoppedByName?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  finishReason?: Maybe<Scalars['String']>;
  /** Когда пришла анкета, закрывшая лесенку */
  submissionAt?: Maybe<Scalars['DateTime']>;
  /** Почему сейчас не шлёт: plan_disabled | robot_off | no_template (у следующего шага нет текста) | no_phone | … (пусто — шлёт) */
  warning?: Maybe<Scalars['String']>;
  nextStepAt?: Maybe<Scalars['DateTime']>;
  sent: Scalars['Int'];
  /** Переходы людей по ссылке */
  linkClicks: Scalars['Int'];
};

export type ConversationType = {
  __typename?: 'ConversationType';
  id: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  teamId: Scalars['String'];
  title: Scalars['String'];
  mailboxEmail: Scalars['String'];
  student?: Maybe<StudentType>;
  group?: Maybe<MethodistGroupType>;
  teacher?: Maybe<TeacherFilterType>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  lastInboundAt?: Maybe<Scalars['DateTime']>;
  lastOutboundAt?: Maybe<Scalars['DateTime']>;
  /** Manual handling lifecycle: open / in_progress / done. */
  status?: Maybe<Scalars['String']>;
  /** Human title: stored title (channel name / mail subject / DM counterpart) → linked student's «Фамилия Имя» → the raw external id. */
  displayTitle?: Maybe<Scalars['String']>;
  /** The study group this conversation belongs to: the group FK for channels, else the group owning the conversation's Slack workspace (team_id). Null for Gmail / legacy rows. */
  workspaceGroup?: Maybe<MethodistGroupType>;
  /** At least one INBOUND message here is not yet ticked «обработано» — the amber dot. Never looks at read state or at `status`. */
  hasUnhandled?: Maybe<Scalars['Boolean']>;
  /** How many INBOUND messages are not yet ticked «обработано». 0 = nothing left to triage. */
  unhandledCount?: Maybe<Scalars['Int']>;
  /** Messages in this conversation not yet marked read (team-wide). 0 = fully read. */
  unreadCount?: Maybe<Scalars['Int']>;
};

export type StudentType = Node & {
  __typename?: 'StudentType';
  id: Scalars['ID'];
  user?: Maybe<CustomUserType>;
  crmLink?: Maybe<Scalars['String']>;
  lesson: GroupLessonTypeConnection;
  updatedAt: Scalars['DateTime'];
  agreements: Array<AgreementType>;
  notes: Array<StudentNoteType>;
  attendances: AttendanceTypeConnection;
  marks: StudentsMarkTypeConnection;
  /** DEPRECATED: use invoice.payment.agreement.student. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  conversations: Array<ConversationType>;
  slackLinks: Array<SlackUserLinkType>;
  agreementTitle?: Maybe<AgreementType>;
  accountsPayables?: Maybe<Array<Maybe<AccountsPayableType>>>;
  agreementIsActive?: Maybe<Scalars['Boolean']>;
  groupsCount?: Maybe<Scalars['Int']>;
  /** True while the student's LMS access is suspended (ТЗ 0074: unpaid invoices — by the robot or by hand). Bare boolean by design — block details are ERP-only. */
  isLmsBlocked?: Maybe<Scalars['Boolean']>;
  attendancePercent?: Maybe<Scalars['Float']>;
  averageMark?: Maybe<Scalars['Float']>;
  lessons?: Maybe<StudentLessonConnection>;
  timeline?: Maybe<StudentTimelineConnection>;
  registrationDate?: Maybe<Scalars['Date']>;
  acquisitionSource?: Maybe<Scalars['String']>;
  /** ТЗ 0086: лиды Kommo этого человека — «откуда пришёл». Только ERP и роли экрана «Лиды»; иначе пусто. */
  kommoLeads: Array<PersonKommoLeadType>;
  responsibleManager?: Maybe<ResponsibleManagerType>;
  /** #54: Slack-workspace групп договоров студента (с расторгнутыми), у которых workspace включён, — строка на группу со ссылками: открыть Slack группы, профиль студента, админка участников (деактивация вручную). Только управленцу ERP (как `slackLinks`); иначе пусто. */
  slackWorkspaces: Array<StudentSlackWorkspaceType>;
  /** Группы студента для карточки ERP: строка на группу из всех его договоров (с расторгнутыми), действующие — первыми. Без денег и без договоров. Управленцу ERP и методисту; иначе пусто. */
  educationGroups: Array<StudentEducationGroupType>;
  /** Σ budget / paid / debt / outstanding-invoices, grouped by currency. See docs/fakturownia/student_card.md §7. */
  totals?: Maybe<StudentTotals>;
};


export type StudentTypeLessonArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type StudentTypeAttendancesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type StudentTypeMarksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  taskType?: Maybe<Scalars['String']>;
  lessonId?: Maybe<Scalars['String']>;
};


export type StudentTypeLessonsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type StudentTypeTimelineArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

export type CustomUserType = Node & {
  __typename?: 'CustomUserType';
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** Wymagana. 150 lub mniej znaków. Jedynie litery, cyfry i @/./+/-/_. */
  username: Scalars['String'];
  /** Określa czy użytkownik może zalogować się do panelu administracyjnego. */
  isStaff: Scalars['Boolean'];
  /** Określa czy użytkownika należy uważać za aktywnego. Odznacz zamiast usuwać konto. */
  isActive: Scalars['Boolean'];
  dateJoined: Scalars['DateTime'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  teacher?: Maybe<TeacherFilterType>;
  student?: Maybe<StudentType>;
  /** Oznacza, że ten użytkownik ma wszystkie uprawnienia bez ich jawnego przypisywania. */
  isSuperuser: Scalars['Boolean'];
};

export type TeacherFilterType = Node & {
  __typename?: 'TeacherFilterType';
  id: Scalars['ID'];
  user: CustomUserType;
  siteDisplay: Scalars['Boolean'];
  interviewTitle?: Maybe<Scalars['String']>;
  interview?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  accessToLms: Scalars['Boolean'];
  rating?: Maybe<Scalars['Int']>;
  internalNote: Scalars['String'];
  /** @deprecated Use teacherInterviews (spec 0028 B). */
  interviewRecording?: Maybe<Scalars['String']>;
  studentRating?: Maybe<Scalars['Float']>;
  studentRatingCount: Scalars['Int'];
  coursesCanTeach?: Maybe<Array<TeacherCourseRef>>;
  teacher: TeacherWebTypeConnection;
  applications?: Maybe<ApplicationConnection>;
  /** Billing entities (who invoices us for this teacher), default first. Empty outside TEACHER_TERMS_ROLES. */
  billingEntities: Array<TeacherBillingEntityType>;
  mainTeachers: MainTeacherWebTypeConnection;
  expenses: Array<ExpenseType>;
  individualentrepreneur?: Maybe<IndividualEntrepreneurType>;
  selfemployed?: Maybe<SelfEmployedType>;
  naturalperson?: Maybe<NaturalPersonType>;
  legalentity?: Maybe<LegalEntityType>;
  fullName?: Maybe<Scalars['String']>;
  isDismissed?: Maybe<Scalars['Boolean']>;
  groupsCount?: Maybe<Scalars['Int']>;
  employmentTypes?: Maybe<Array<Maybe<EmploymentType>>>;
  courses?: Maybe<Array<Maybe<Scalars['String']>>>;
  studentComments?: Maybe<Array<TeacherStudentCommentType>>;
  availability?: Maybe<Scalars['String']>;
};


export type TeacherFilterTypeTeacherArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type TeacherFilterTypeApplicationsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type TeacherFilterTypeMainTeachersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Minimal {id, name} of a course a teacher is qualified to teach. */
export type TeacherCourseRef = {
  __typename?: 'TeacherCourseRef';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TeacherWebTypeConnection = {
  __typename?: 'TeacherWebTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherWebTypeEdge>>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
};

/** A Relay edge containing a `TeacherWebType` and its cursor. */
export type TeacherWebTypeEdge = {
  __typename?: 'TeacherWebTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<TeacherWebType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type TeacherWebType = Node & {
  __typename?: 'TeacherWebType';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  teachersPreview: TeacherFilterTypeConnection;
  course?: Maybe<CourseFilterType>;
};


export type TeacherWebTypeTeachersPreviewArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  siteDisplay?: Maybe<Scalars['Boolean']>;
  hasInterview?: Maybe<Scalars['Boolean']>;
  hasPhoto?: Maybe<Scalars['Boolean']>;
  hasDescription?: Maybe<Scalars['Boolean']>;
  course?: Maybe<Scalars['Decimal']>;
  minRating?: Maybe<Scalars['Decimal']>;
  availability?: Maybe<Scalars['String']>;
};

export type TeacherFilterTypeConnection = {
  __typename?: 'TeacherFilterTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherFilterTypeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TeacherFilterType` and its cursor. */
export type TeacherFilterTypeEdge = {
  __typename?: 'TeacherFilterTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<TeacherType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type TeacherType = Node & {
  __typename?: 'TeacherType';
  id: Scalars['ID'];
  user: CustomUserType;
  siteDisplay: Scalars['Boolean'];
  interviewTitle?: Maybe<Scalars['String']>;
  interview?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  accessToLms: Scalars['Boolean'];
  rating?: Maybe<Scalars['Int']>;
  internalNote: Scalars['String'];
  /** @deprecated Use teacherInterviews (spec 0028 B). */
  interviewRecording?: Maybe<Scalars['String']>;
  studentRating?: Maybe<Scalars['Float']>;
  studentRatingCount: Scalars['Int'];
  coursesCanTeach?: Maybe<Array<TeacherCourseRef>>;
  teacher: TeacherWebTypeConnection;
  applications?: Maybe<ApplicationConnection>;
  /** Billing entities (who invoices us for this teacher), default first. Empty outside TEACHER_TERMS_ROLES. */
  billingEntities: Array<TeacherBillingEntityType>;
  mainTeachers: MainTeacherWebTypeConnection;
  expenses: Array<ExpenseType>;
  fullName?: Maybe<Scalars['String']>;
  isDismissed?: Maybe<Scalars['Boolean']>;
  groupsCount?: Maybe<Scalars['Int']>;
  employmentTypes?: Maybe<Array<Maybe<EmploymentType>>>;
  courses?: Maybe<Array<Maybe<Scalars['String']>>>;
  studentComments?: Maybe<Array<TeacherStudentCommentType>>;
  availability?: Maybe<Scalars['String']>;
};


export type TeacherTypeTeacherArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type TeacherTypeApplicationsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type TeacherTypeMainTeachersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ApplicationConnection = {
  __typename?: 'ApplicationConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApplicationEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Application` and its cursor. */
export type ApplicationEdge = {
  __typename?: 'ApplicationEdge';
  /** The item at the end of the edge */
  node?: Maybe<ApplicationType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ApplicationType = Node & {
  __typename?: 'ApplicationType';
  id: Scalars['ID'];
  teacher: TeacherFilterType;
  title: Scalars['String'];
  date: Scalars['Date'];
  group: MethodistGroupType;
  lessonsCount: Scalars['Int'];
  country?: Maybe<CountryType>;
  servicePrice?: Maybe<Scalars['Float']>;
  riaPrice?: Maybe<Scalars['Float']>;
  currency: ApplicationCurrency;
  comment?: Maybe<Scalars['String']>;
  isTerminated: Scalars['Boolean'];
  lastLessonDate?: Maybe<Scalars['Date']>;
  lessons: GroupLessonTypeConnection;
  employmentType?: Maybe<EmploymentType>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  appointedLessonsCount: Scalars['Int'];
  deleteAvailable?: Maybe<ApplicationDeleteAvailable>;
  /** lesson | hour | course — the unit of `servicePrice`; '' outside TEACHER_TERMS_ROLES. */
  rateUnit: Scalars['String'];
  /** true — the rate includes VAT, false — net, null — not set (or no access). */
  rateIsGross?: Maybe<Scalars['Boolean']>;
  /** Who invoices for this application — one of the teacher's billing entities. */
  billingEntity?: Maybe<TeacherBillingEntityType>;
  /** Codes of the missing finance terms: service_price, currency, rate_is_gross, billing_entity, vat_mode. Empty — complete (or no access). */
  termsMissing: Array<Scalars['String']>;
};


export type ApplicationTypeLessonsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
};

export type MethodistGroupType = Node & {
  __typename?: 'MethodistGroupType';
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
  maxStudentsCount: Scalars['Int'];
  course: CourseFilterType;
  publishedLms: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  isFree: Scalars['Boolean'];
  zoomAccount?: Maybe<ZoomAccountType>;
  teacherLeads: ApplicationFilterTypeConnection;
  modules: Array<GroupModuleType>;
  classesDays: Array<DayOfClassType>;
  agreements: Array<AgreementType>;
  notes: Array<StudentNoteType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  conversations: Array<ConversationType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  slackChannels: Array<ChannelGroupLinkType>;
  materials: Array<MaterialType>;
  lessonJoinUrl?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<GroupLessonType>>;
  studentsCount?: Maybe<Scalars['Int']>;
  lessonsCount?: Maybe<Scalars['Int']>;
  passedLessonsCount?: Maybe<Scalars['Int']>;
  freeLessonsCount?: Maybe<Scalars['Int']>;
  statusFinished?: Maybe<Scalars['Boolean']>;
  datetimeNextLesson?: Maybe<Scalars['DateTime']>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  teachers?: Maybe<Array<Maybe<TeacherType>>>;
  freePlaces?: Maybe<Scalars['Int']>;
  daysOfClass: Array<Scalars['Int']>;
  price?: Maybe<Scalars['CustomFloat']>;
  currency?: Maybe<Scalars['String']>;
  contributionsSum?: Maybe<Scalars['CustomFloat']>;
  /** Временная ссылка, действующая сейчас: на дату идущего занятия (у ночного занятия после полуночи — вчерашняя дата), иначе на сегодня по Варшаве. */
  activeLinkOverride?: Maybe<GroupLinkOverrideType>;
  agreementsConnection?: Maybe<AgreementConnection>;
};


export type MethodistGroupTypeTeacherLeadsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  byGroupId?: Maybe<Scalars['Decimal']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
};


export type MethodistGroupTypeZoomSchedulesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MethodistGroupTypeAgreementsConnectionArgs = {
  query?: Maybe<Scalars['String']>;
  status?: Maybe<RosterStatusEnum>;
  hasDebt?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<AgreementOrderByEnum>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type CourseFilterType = Node & {
  __typename?: 'CourseFilterType';
  id: Scalars['ID'];
  category?: Maybe<CategoryType>;
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  courseIcon?: Maybe<Scalars['String']>;
  courseDiscount?: Maybe<Scalars['Int']>;
  duration: Scalars['String'];
  educationForm?: Maybe<Scalars['String']>;
  videoTrailer?: Maybe<VideoTrailerType>;
  futureProfession?: Maybe<FutureProfessionType>;
  futureKnowledge?: Maybe<FutureKnowledgeType>;
  salary?: Maybe<SalaryInfoType>;
  curriculumVitae?: Maybe<StudentCvType>;
  courseBanner?: Maybe<CourseBanner>;
  graduationVideo?: Maybe<GraduationVideoType>;
  graduateFeedbacks: Array<GraduateFeedbackType>;
  teacherWeb?: Maybe<TeacherWebType>;
  courseRequirementsInfo?: Maybe<CourseRequirementsIntoType>;
  ceoInfo?: Maybe<CeoInfoType>;
  readyToPublish: Scalars['Boolean'];
  publishDate: Scalars['Date'];
  educationprogram?: Maybe<EducationProgramType>;
  modules: Array<CourseModuleType>;
  marketingModules: Array<CourseMarketingModuleType>;
  prices: Array<CoursePriceType>;
  contributions: Array<CourseContributionType>;
  groups: MethodistGroupTypeConnection;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  price: Scalars['CustomFloat'];
  currency?: Maybe<Scalars['String']>;
  teachers?: Maybe<TeacherFilterTypeConnection>;
};


export type CourseFilterTypeGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  freePlacesGt?: Maybe<Scalars['Decimal']>;
  hideCompleted?: Maybe<Scalars['Date']>;
};


export type CourseFilterTypeTeachersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  siteDisplay?: Maybe<Scalars['Boolean']>;
  hasInterview?: Maybe<Scalars['Boolean']>;
  hasPhoto?: Maybe<Scalars['Boolean']>;
  hasDescription?: Maybe<Scalars['Boolean']>;
  course?: Maybe<Scalars['Decimal']>;
  minRating?: Maybe<Scalars['Decimal']>;
  availability?: Maybe<Scalars['String']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  id: Scalars['ID'];
  name: Scalars['String'];
  categoryColumn?: Maybe<Scalars['String']>;
  courses: CourseFilterTypeConnection;
};


export type CategoryTypeCoursesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  readyToPublish?: Maybe<Scalars['Boolean']>;
  educationForm?: Maybe<Scalars['String']>;
  category_Name?: Maybe<Scalars['String']>;
  startDateFilter?: Maybe<Scalars['Boolean']>;
  orderByPublishDateFilter?: Maybe<Scalars['Boolean']>;
};

export type CourseFilterTypeConnection = {
  __typename?: 'CourseFilterTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseFilterTypeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CourseFilterType` and its cursor. */
export type CourseFilterTypeEdge = {
  __typename?: 'CourseFilterTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<CourseType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type CourseType = Node & {
  __typename?: 'CourseType';
  id: Scalars['ID'];
  category?: Maybe<CategoryType>;
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  courseIcon?: Maybe<Scalars['String']>;
  courseDiscount?: Maybe<Scalars['Int']>;
  duration: Scalars['String'];
  educationForm?: Maybe<Scalars['String']>;
  videoTrailer?: Maybe<VideoTrailerType>;
  futureProfession?: Maybe<FutureProfessionType>;
  futureKnowledge?: Maybe<FutureKnowledgeType>;
  salary?: Maybe<SalaryInfoType>;
  curriculumVitae?: Maybe<StudentCvType>;
  courseBanner?: Maybe<CourseBanner>;
  graduationVideo?: Maybe<GraduationVideoType>;
  graduateFeedbacks: Array<GraduateFeedbackType>;
  teacherWeb?: Maybe<TeacherWebType>;
  courseRequirementsInfo?: Maybe<CourseRequirementsIntoType>;
  ceoInfo?: Maybe<CeoInfoType>;
  readyToPublish: Scalars['Boolean'];
  publishDate: Scalars['Date'];
  educationprogram?: Maybe<EducationProgramType>;
  modules: Array<CourseModuleType>;
  marketingModules: Array<CourseMarketingModuleType>;
  prices: Array<CoursePriceType>;
  contributions: Array<CourseContributionType>;
  groups: MethodistGroupTypeConnection;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  price: Scalars['CustomFloat'];
  currency?: Maybe<Scalars['String']>;
  teachers?: Maybe<TeacherFilterTypeConnection>;
};


export type CourseTypeGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  freePlacesGt?: Maybe<Scalars['Decimal']>;
  hideCompleted?: Maybe<Scalars['Date']>;
};


export type CourseTypeTeachersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  siteDisplay?: Maybe<Scalars['Boolean']>;
  hasInterview?: Maybe<Scalars['Boolean']>;
  hasPhoto?: Maybe<Scalars['Boolean']>;
  hasDescription?: Maybe<Scalars['Boolean']>;
  course?: Maybe<Scalars['Decimal']>;
  minRating?: Maybe<Scalars['Decimal']>;
  availability?: Maybe<Scalars['String']>;
};

export type VideoTrailerType = {
  __typename?: 'VideoTrailerType';
  id: Scalars['ID'];
  url: Scalars['String'];
  description: Scalars['String'];
  course?: Maybe<CourseFilterType>;
};

export type FutureProfessionType = {
  __typename?: 'FutureProfessionType';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  course?: Maybe<CourseFilterType>;
};

export type FutureKnowledgeType = {
  __typename?: 'FutureKnowledgeType';
  id: Scalars['ID'];
  title: Scalars['String'];
  descriptions: Array<KnowledgeDescriptionType>;
  course?: Maybe<CourseFilterType>;
};

export type KnowledgeDescriptionType = {
  __typename?: 'KnowledgeDescriptionType';
  id: Scalars['ID'];
  futureKnowledge: FutureKnowledgeType;
  description: Scalars['String'];
};

export type SalaryInfoType = {
  __typename?: 'SalaryInfoType';
  id: Scalars['ID'];
  title: Scalars['String'];
  dataSource: Scalars['String'];
  marketInfo: Scalars['String'];
  companyCount: Scalars['String'];
  marketDemand: Scalars['String'];
  minJuniorValue: Scalars['Int'];
  minMiddleValue: Scalars['Int'];
  minSeniorValue: Scalars['Int'];
  maxSeniorValue: Scalars['Int'];
  course?: Maybe<CourseFilterType>;
};

export type StudentCvType = {
  __typename?: 'StudentCVType';
  id: Scalars['ID'];
  title: Scalars['String'];
  studentImage: Scalars['String'];
  workingPosition: Scalars['String'];
  salary: Scalars['String'];
  certificateImage: Scalars['String'];
  professionalSkills: Array<ProfessionalSkillType>;
  course?: Maybe<CourseFilterType>;
};

export type ProfessionalSkillType = {
  __typename?: 'ProfessionalSkillType';
  id: Scalars['ID'];
  studentCv: StudentCvType;
  description: Scalars['String'];
};

export type CourseBanner = {
  __typename?: 'CourseBanner';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  course?: Maybe<CourseFilterType>;
  native: Array<NativeInfoType>;
  successstoriesSet: Array<SuccessStoriesType>;
  articlesSet: Array<ArticlesType>;
};

export type NativeInfoType = {
  __typename?: 'NativeInfoType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  image: Scalars['String'];
  interviewText: Scalars['String'];
  interviewLink: Scalars['String'];
  date: Scalars['Date'];
  seoSlug?: Maybe<Scalars['String']>;
  nativeBanner?: Maybe<CourseBanner>;
  published: Scalars['Boolean'];
  successstoriesSet: Array<SuccessStoriesType>;
  articlesSet: Array<ArticlesType>;
};

export type SuccessStoriesType = {
  __typename?: 'SuccessStoriesType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  nativeTitle?: Maybe<Scalars['String']>;
  native?: Maybe<NativeInfoType>;
  adviceTitle?: Maybe<Scalars['String']>;
  adviceText?: Maybe<Scalars['String']>;
  author: AuthorsType;
  storyTime?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  banner?: Maybe<CourseBanner>;
  previewImage?: Maybe<Scalars['String']>;
  seoSlug?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  title: Scalars['String'];
  studentName?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  interview?: Maybe<Scalars['String']>;
  interviewText?: Maybe<Scalars['String']>;
  storyShortText?: Maybe<Scalars['String']>;
  storyText?: Maybe<Scalars['String']>;
  storyImage?: Maybe<Scalars['String']>;
  studentImage?: Maybe<Scalars['String']>;
  thesis: Array<ThesesType>;
  storyBlock: Array<SuccessStoriesBlockType>;
};

export type AuthorsType = {
  __typename?: 'AuthorsType';
  id: Scalars['ID'];
  authorName: Scalars['String'];
  authorPosition: Scalars['String'];
  authorImage: Scalars['String'];
  successstoriesSet: Array<SuccessStoriesType>;
  articlesSet: Array<ArticlesType>;
};

export type ArticlesType = {
  __typename?: 'ArticlesType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  nativeTitle?: Maybe<Scalars['String']>;
  native?: Maybe<NativeInfoType>;
  adviceTitle?: Maybe<Scalars['String']>;
  adviceText?: Maybe<Scalars['String']>;
  author: AuthorsType;
  storyTime?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  banner?: Maybe<CourseBanner>;
  previewImage?: Maybe<Scalars['String']>;
  seoSlug?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  title: Scalars['String'];
  articleShortText?: Maybe<Scalars['String']>;
  articleImage?: Maybe<Scalars['String']>;
  storyText?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
};

export type ThesesType = {
  __typename?: 'ThesesType';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  successStory?: Maybe<SuccessStoriesType>;
};

export type SuccessStoriesBlockType = {
  __typename?: 'SuccessStoriesBlockType';
  id: Scalars['ID'];
  title: Scalars['String'];
  stories: Array<SuccessStoriesType>;
};

export type GraduationVideoType = {
  __typename?: 'GraduationVideoType';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  url: Scalars['String'];
  course?: Maybe<CourseFilterType>;
};

export type GraduateFeedbackType = {
  __typename?: 'GraduateFeedbackType';
  id: Scalars['ID'];
  feedback: Scalars['String'];
  graduateName: Scalars['String'];
  graduatePhoto?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  resourceIcon: Scalars['String'];
  course: CourseFilterTypeConnection;
};


export type GraduateFeedbackTypeCourseArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  readyToPublish?: Maybe<Scalars['Boolean']>;
  educationForm?: Maybe<Scalars['String']>;
  category_Name?: Maybe<Scalars['String']>;
  startDateFilter?: Maybe<Scalars['Boolean']>;
  orderByPublishDateFilter?: Maybe<Scalars['Boolean']>;
};

export type CourseRequirementsIntoType = {
  __typename?: 'CourseRequirementsIntoType';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  courseRequirements: Array<RequirementsType>;
  course?: Maybe<CourseFilterType>;
};

export type RequirementsType = {
  __typename?: 'RequirementsType';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  courseRequirements: CourseRequirementsIntoType;
};

export type CeoInfoType = {
  __typename?: 'CEOInfoType';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  keywords: Scalars['String'];
  image: Scalars['String'];
  course?: Maybe<CourseFilterType>;
};

export type EducationProgramType = {
  __typename?: 'EducationProgramType';
  id: Scalars['ID'];
  title: Scalars['String'];
  numberOfHours: Scalars['String'];
  description: Scalars['String'];
  course: CourseFilterType;
  lessons: CourseLessonTypeConnection;
};


export type EducationProgramTypeLessonsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export type CourseLessonTypeConnection = {
  __typename?: 'CourseLessonTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseLessonTypeEdge>>;
};

/** A Relay edge containing a `CourseLessonType` and its cursor. */
export type CourseLessonTypeEdge = {
  __typename?: 'CourseLessonTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<CourseLessonType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type CourseLessonType = Node & {
  __typename?: 'CourseLessonType';
  id: Scalars['ID'];
  name: Scalars['String'];
  taskTypes: Array<Scalars['String']>;
  module: CourseModuleType;
  number: Scalars['Int'];
  marketingModule?: Maybe<CourseMarketingModuleType>;
  description?: Maybe<Scalars['String']>;
  lmsDescription: Scalars['String'];
  courseProgram?: Maybe<EducationProgramType>;
  studentAttachments: StudentLessonAttachmentsTypeConnection;
  teacherAttachments: TeacherLessonAttachmentsTypeConnection;
  index?: Maybe<Scalars['Int']>;
};


export type CourseLessonTypeStudentAttachmentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type CourseLessonTypeTeacherAttachmentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type CourseModuleType = {
  __typename?: 'CourseModuleType';
  id: Scalars['ID'];
  name: Scalars['String'];
  course: CourseFilterType;
  number: Scalars['Int'];
  lessons: CourseLessonTypeConnection;
};


export type CourseModuleTypeLessonsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export type CourseMarketingModuleType = {
  __typename?: 'CourseMarketingModuleType';
  id: Scalars['ID'];
  name: Scalars['String'];
  course: CourseFilterType;
  description: Scalars['String'];
  lessons: CourseLessonTypeConnection;
};


export type CourseMarketingModuleTypeLessonsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export type StudentLessonAttachmentsTypeConnection = {
  __typename?: 'StudentLessonAttachmentsTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentLessonAttachmentsTypeEdge>>;
};

/** A Relay edge containing a `StudentLessonAttachmentsType` and its cursor. */
export type StudentLessonAttachmentsTypeEdge = {
  __typename?: 'StudentLessonAttachmentsTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<StudentLessonAttachmentsType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type StudentLessonAttachmentsType = Node & {
  __typename?: 'StudentLessonAttachmentsType';
  id: Scalars['ID'];
  title: Scalars['String'];
  file?: Maybe<Scalars['String']>;
  courseLesson?: Maybe<CourseLessonType>;
};

export type TeacherLessonAttachmentsTypeConnection = {
  __typename?: 'TeacherLessonAttachmentsTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherLessonAttachmentsTypeEdge>>;
};

/** A Relay edge containing a `TeacherLessonAttachmentsType` and its cursor. */
export type TeacherLessonAttachmentsTypeEdge = {
  __typename?: 'TeacherLessonAttachmentsTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<TeacherLessonAttachmentsType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type TeacherLessonAttachmentsType = Node & {
  __typename?: 'TeacherLessonAttachmentsType';
  id: Scalars['ID'];
  title: Scalars['String'];
  file?: Maybe<Scalars['String']>;
  courseLesson?: Maybe<CourseLessonType>;
};

export type CoursePriceType = {
  __typename?: 'CoursePriceType';
  id: Scalars['ID'];
  amount: Scalars['Float'];
  currency?: Maybe<CurrencyType>;
  course: CourseFilterType;
  currencyTicker: Scalars['String'];
};

export type CurrencyType = {
  __typename?: 'CurrencyType';
  id: Scalars['ID'];
  ticker: Scalars['String'];
  coursepriceSet: Array<CoursePriceType>;
  coursecontributionpriceSet: Array<CourseContributionPriceType>;
};

export type CourseContributionPriceType = {
  __typename?: 'CourseContributionPriceType';
  id: Scalars['ID'];
  amount: Scalars['Float'];
  currency?: Maybe<CurrencyType>;
  contribution: CourseContributionType;
  currencyTicker: Scalars['String'];
};

export type CourseContributionType = {
  __typename?: 'CourseContributionType';
  id: Scalars['ID'];
  course: CourseFilterType;
  description: Scalars['String'];
  prices: Array<CourseContributionPriceType>;
};

export type MethodistGroupTypeConnection = {
  __typename?: 'MethodistGroupTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MethodistGroupTypeEdge>>;
};

/** A Relay edge containing a `MethodistGroupType` and its cursor. */
export type MethodistGroupTypeEdge = {
  __typename?: 'MethodistGroupTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<MethodistGroupType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};


export type ZoomAccountType = Node & {
  __typename?: 'ZoomAccountType';
  /** The ID of the object */
  id: Scalars['ID'];
  zoomUserId: Scalars['String'];
  email: Scalars['String'];
  displayName: Scalars['String'];
  isActive: Scalars['Boolean'];
  notes: Scalars['String'];
  syncedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
};

export type ApplicationFilterTypeConnection = {
  __typename?: 'ApplicationFilterTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApplicationFilterTypeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ApplicationFilterType` and its cursor. */
export type ApplicationFilterTypeEdge = {
  __typename?: 'ApplicationFilterTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<ApplicationType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GroupModuleType = {
  __typename?: 'GroupModuleType';
  id: Scalars['ID'];
  name: Scalars['String'];
  group: MethodistGroupType;
  lessons: GroupLessonTypeConnection;
};


export type GroupModuleTypeLessonsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
};

export type GroupLessonTypeConnection = {
  __typename?: 'GroupLessonTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupLessonTypeEdge>>;
};

/** A Relay edge containing a `GroupLessonType` and its cursor. */
export type GroupLessonTypeEdge = {
  __typename?: 'GroupLessonTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<GroupLessonType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GroupLessonType = Node & {
  __typename?: 'GroupLessonType';
  id: Scalars['ID'];
  name: Scalars['String'];
  taskTypes: Array<Scalars['String']>;
  module: GroupModuleType;
  teacherApplication?: Maybe<ApplicationType>;
  number: Scalars['Int'];
  date: Scalars['Date'];
  startTime: Scalars['Time'];
  endTime: Scalars['Time'];
  lmsDescription?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  finished: Scalars['Boolean'];
  additional?: Maybe<Scalars['Boolean']>;
  students: StudentTypeConnection;
  marks: StudentsMarkTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  studentsAttachments: StudentLessonAttachmentTypeConnection;
  teachersAttachments: TeacherLessonAttachmentTypeConnection;
  attendances: AttendanceTypeConnection;
  /** Начало занятия, aware (Europe/Warsaw); null без даты/времени */
  startsAt?: Maybe<Scalars['DateTime']>;
  /** Конец занятия, aware (Europe/Warsaw); через полночь — следующий день; null без даты/времени */
  endsAt?: Maybe<Scalars['DateTime']>;
  index?: Maybe<Scalars['Int']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  needToFinish?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  homeworkStats?: Maybe<LessonHomeworkStatsType>;
};


export type GroupLessonTypeStudentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GroupLessonTypeMarksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  taskType?: Maybe<Scalars['String']>;
  lessonId?: Maybe<Scalars['String']>;
};


export type GroupLessonTypeZoomProcessingLogsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GroupLessonTypeStudentsAttachmentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GroupLessonTypeTeachersAttachmentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GroupLessonTypeAttendancesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type StudentTypeConnection = {
  __typename?: 'StudentTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentTypeEdge>>;
};

/** A Relay edge containing a `StudentType` and its cursor. */
export type StudentTypeEdge = {
  __typename?: 'StudentTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<StudentType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type StudentsMarkTypeConnection = {
  __typename?: 'StudentsMarkTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentsMarkTypeEdge>>;
};

/** A Relay edge containing a `StudentsMarkType` and its cursor. */
export type StudentsMarkTypeEdge = {
  __typename?: 'StudentsMarkTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<StudentsMarkType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type StudentsMarkType = Node & {
  __typename?: 'StudentsMarkType';
  id: Scalars['ID'];
  lesson: GroupLessonType;
  student: StudentType;
  taskType?: Maybe<StudentsMarkTaskType>;
  date: Scalars['Date'];
  /** Od 1 do 10 */
  mark?: Maybe<Scalars['Int']>;
  hwMark?: Maybe<StudentsMarkHwMark>;
};

/** An enumeration. */
export enum StudentsMarkTaskType {
  /** Домашнее задание */
  Homework = 'HOMEWORK',
  /** Курсовая работа */
  Coursework = 'COURSEWORK',
  /** Дипломный проект */
  GraduationProject = 'GRADUATION_PROJECT'
}

/** An enumeration. */
export enum StudentsMarkHwMark {
  /** Выполнено */
  Done = 'DONE',
  /** Содержит ошибки */
  ContainsErrors = 'CONTAINS_ERRORS',
  /** Не выполнено */
  NotDone = 'NOT_DONE'
}

export type LessonRecordingType = Node & {
  __typename?: 'LessonRecordingType';
  /** The ID of the object */
  id: Scalars['ID'];
  zoomRecording?: Maybe<ZoomRecordingType>;
  matchedBy: LessonRecordingMatchedBy;
  matchedByUser?: Maybe<CustomUserType>;
  status: LessonRecordingStatus;
  ambiguous: Scalars['Boolean'];
  transcriptS3Key: Scalars['String'];
  chatS3Key: Scalars['String'];
  audioS3Key: Scalars['String'];
  aiSummary: Scalars['String'];
  aiTimecodes: Scalars['JSONString'];
  aiModel: Scalars['String'];
  errorMessage: Scalars['String'];
  retryCount: Scalars['Int'];
  lastAttemptAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lesson?: Maybe<GroupLessonForLmsType>;
  processingLogs?: Maybe<Array<Maybe<ZoomProcessingLogType>>>;
  /** Processing is stopped (or stalled) and can be resumed. */
  canResume: Scalars['Boolean'];
};

export type ZoomRecordingType = Node & {
  __typename?: 'ZoomRecordingType';
  /** The ID of the object */
  id: Scalars['ID'];
  zoomMeetingUuid: Scalars['String'];
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomAccount: ZoomAccountType;
  topic: Scalars['String'];
  startTime: Scalars['DateTime'];
  durationMinutes: Scalars['Int'];
  totalSizeBytes?: Maybe<Scalars['Float']>;
  files: Scalars['JSONString'];
  deletedFromZoom: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  syncedAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  isOrphan?: Maybe<Scalars['Boolean']>;
  isMatched?: Maybe<Scalars['Boolean']>;
  isTooShort?: Maybe<Scalars['Boolean']>;
  status?: Maybe<ZoomRecordingStatusEnum>;
  failureReason?: Maybe<Scalars['String']>;
  lessonRecordings?: Maybe<Array<Maybe<LessonRecordingType>>>;
};

export enum ZoomRecordingStatusEnum {
  Ready = 'READY',
  Processing = 'PROCESSING',
  Failed = 'FAILED',
  Orphan = 'ORPHAN',
  TooShort = 'TOO_SHORT'
}

/** An enumeration. */
export enum LessonRecordingMatchedBy {
  /** Auto */
  Auto = 'AUTO',
  /** Manual */
  Manual = 'MANUAL'
}

/** An enumeration. */
export enum LessonRecordingStatus {
  /** Matched */
  Matched = 'MATCHED',
  /** Downloading */
  Downloading = 'DOWNLOADING',
  /** Uploaded */
  Uploaded = 'UPLOADED',
  /** AI processing */
  AiProcessing = 'AI_PROCESSING',
  /** AI completed */
  AiCompleted = 'AI_COMPLETED',
  /** Published */
  Published = 'PUBLISHED',
  /** Failed */
  Failed = 'FAILED',
  /** Skipped */
  Skipped = 'SKIPPED'
}

export type GroupLessonForLmsType = Node & {
  __typename?: 'GroupLessonForLMSType';
  id: Scalars['ID'];
  name: Scalars['String'];
  taskTypes: Array<Scalars['String']>;
  module: GroupModuleType;
  teacherApplication?: Maybe<ApplicationType>;
  number: Scalars['Int'];
  date: Scalars['Date'];
  startTime: Scalars['Time'];
  endTime: Scalars['Time'];
  lmsDescription?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  finished: Scalars['Boolean'];
  additional?: Maybe<Scalars['Boolean']>;
  students: StudentTypeConnection;
  marks: StudentsMarkTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  /** Начало занятия, aware (Europe/Warsaw); null без даты/времени */
  startsAt?: Maybe<Scalars['DateTime']>;
  /** Конец занятия, aware (Europe/Warsaw); через полночь — следующий день; null без даты/времени */
  endsAt?: Maybe<Scalars['DateTime']>;
  index?: Maybe<Scalars['Int']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  needToFinish?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  hasStudentAttachment?: Maybe<Scalars['Boolean']>;
  hasTeacherAttachment?: Maybe<Scalars['Boolean']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  homeworkAssignmentId?: Maybe<Scalars['ID']>;
  homeworkAvailable?: Maybe<Scalars['Boolean']>;
  hasJoinLink?: Maybe<Scalars['Boolean']>;
  linkOverrideActive?: Maybe<Scalars['Boolean']>;
};


export type GroupLessonForLmsTypeStudentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GroupLessonForLmsTypeMarksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  taskType?: Maybe<Scalars['String']>;
  lessonId?: Maybe<Scalars['String']>;
};


export type GroupLessonForLmsTypeZoomProcessingLogsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ZoomProcessingLogTypeConnection = {
  __typename?: 'ZoomProcessingLogTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomProcessingLogTypeEdge>>;
};

/** A Relay edge containing a `ZoomProcessingLogType` and its cursor. */
export type ZoomProcessingLogTypeEdge = {
  __typename?: 'ZoomProcessingLogTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<ZoomProcessingLogType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ZoomProcessingLogType = Node & {
  __typename?: 'ZoomProcessingLogType';
  /** The ID of the object */
  id: Scalars['ID'];
  lesson: GroupLessonType;
  lessonRecording?: Maybe<LessonRecordingType>;
  step: ZoomProcessingLogStep;
  level: ZoomProcessingLogLevel;
  message: Scalars['String'];
  details: Scalars['JSONString'];
  createdAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum ZoomProcessingLogStep {
  /** Matched */
  Matched = 'MATCHED',
  /** Status change */
  StatusChange = 'STATUS_CHANGE',
  /** Download video */
  DownloadVideo = 'DOWNLOAD_VIDEO',
  /** Download transcript */
  DownloadTranscript = 'DOWNLOAD_TRANSCRIPT',
  /** Download chat */
  DownloadChat = 'DOWNLOAD_CHAT',
  /** Download audio */
  DownloadAudio = 'DOWNLOAD_AUDIO',
  /** AI started */
  AiStarted = 'AI_STARTED',
  /** AI waiting (lock busy) */
  AiWaiting = 'AI_WAITING',
  /** AI completed */
  AiCompleted = 'AI_COMPLETED',
  /** Published */
  Published = 'PUBLISHED',
  /** Błąd */
  Error = 'ERROR'
}

/** An enumeration. */
export enum ZoomProcessingLogLevel {
  /** Info */
  Info = 'INFO',
  /** Warning */
  Warning = 'WARNING',
  /** Błąd */
  Error = 'ERROR'
}

export type MaterialType = {
  __typename?: 'MaterialType';
  id: Scalars['ID'];
  group: MethodistGroupType;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  lesson?: Maybe<GroupLessonType>;
  title: Scalars['String'];
  description: Scalars['String'];
  /** HOMEWORK only; ignored for other kinds. */
  dueDate?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<CustomUserType>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  kind: MaterialKindEnum;
  attachments: Array<MaterialAttachmentType>;
};

/** An enumeration. */
export enum MaterialKindEnum {
  Homework = 'HOMEWORK',
  Reading = 'READING',
  Video = 'VIDEO',
  Other = 'OTHER'
}

export type MaterialAttachmentType = {
  __typename?: 'MaterialAttachmentType';
  id: Scalars['ID'];
  material: MaterialType;
  originalName: Scalars['String'];
  contentType: Scalars['String'];
  sizeBytes: Scalars['Int'];
  uploadedAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  /** Signed S3 URL with the project's default TTL. The frontend treats this as opaque; the link expires after `LESSON_RECORDING_VIDEO_EXPIRE` (settings). */
  url?: Maybe<Scalars['String']>;
};

export type StudentLessonAttachmentTypeConnection = {
  __typename?: 'StudentLessonAttachmentTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentLessonAttachmentTypeEdge>>;
};

/** A Relay edge containing a `StudentLessonAttachmentType` and its cursor. */
export type StudentLessonAttachmentTypeEdge = {
  __typename?: 'StudentLessonAttachmentTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<StudentLessonAttachmentType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type StudentLessonAttachmentType = Node & {
  __typename?: 'StudentLessonAttachmentType';
  id: Scalars['ID'];
  title: Scalars['String'];
  file: Scalars['String'];
  lesson?: Maybe<GroupLessonType>;
};

export type TeacherLessonAttachmentTypeConnection = {
  __typename?: 'TeacherLessonAttachmentTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherLessonAttachmentTypeEdge>>;
};

/** A Relay edge containing a `TeacherLessonAttachmentType` and its cursor. */
export type TeacherLessonAttachmentTypeEdge = {
  __typename?: 'TeacherLessonAttachmentTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<TeacherLessonAttachmentType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type TeacherLessonAttachmentType = Node & {
  __typename?: 'TeacherLessonAttachmentType';
  id: Scalars['ID'];
  title: Scalars['String'];
  file: Scalars['String'];
  lesson?: Maybe<GroupLessonType>;
};

export type AttendanceTypeConnection = {
  __typename?: 'AttendanceTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AttendanceTypeEdge>>;
};

/** A Relay edge containing a `AttendanceType` and its cursor. */
export type AttendanceTypeEdge = {
  __typename?: 'AttendanceTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<AttendanceType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type AttendanceType = Node & {
  __typename?: 'AttendanceType';
  id: Scalars['ID'];
  lesson: GroupLessonType;
  student: StudentType;
  attendance?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  markedAt?: Maybe<Scalars['DateTime']>;
  markedByName?: Maybe<Scalars['String']>;
};

/**
 * Parent is the stats dict from services.eligibility
 * (homework_stats_for_lessons) — dict keys match the snake_case field
 * names, so graphene's default resolver handles them.
 */
export type LessonHomeworkStatsType = {
  __typename?: 'LessonHomeworkStatsType';
  lessonId: Scalars['ID'];
  hasAssignment: Scalars['Boolean'];
  /** teacher_text | teacher_ref | textbook | none. `none` = задания нет И учебник не прикреплён — единственное значение, требующее действия. */
  assignmentSource: Scalars['String'];
  /** Строка преподавателя «глава 7, задачи 1–4», если есть. */
  assignmentRef?: Maybe<Scalars['String']>;
  textbookFileCount: Scalars['Int'];
  textbookFileName?: Maybe<Scalars['String']>;
  totalStudents: Scalars['Int'];
  submittedCount: Scalars['Int'];
  gradedCount: Scalars['Int'];
  aiDoneCount: Scalars['Int'];
  suspiciousCount: Scalars['Int'];
};

export type DayOfClassType = {
  __typename?: 'DayOfClassType';
  id: Scalars['ID'];
  group: MethodistGroupType;
  weekDay: Scalars['Int'];
  startTime: Scalars['Time'];
  endTime: Scalars['Time'];
};

export type AgreementType = {
  __typename?: 'AgreementType';
  id: Scalars['ID'];
  agreementTitle: Scalars['String'];
  currency: AgreementCurrency;
  student: StudentType;
  group: MethodistGroupType;
  country?: Maybe<CountryType>;
  partialAttendance: Scalars['Boolean'];
  firstLesson?: Maybe<GroupLessonType>;
  lastLesson?: Maybe<GroupLessonType>;
  terminated: Scalars['Boolean'];
  paymentByCompany: Scalars['Boolean'];
  resident: Scalars['Boolean'];
  vat: Scalars['Boolean'];
  company?: Maybe<CompanyType>;
  date: Scalars['Date'];
  terminatedDate?: Maybe<Scalars['Date']>;
  transferOut: Scalars['Boolean'];
  freeOfCharge: Scalars['Boolean'];
  statePrefinanced: Scalars['Boolean'];
  promocode?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  /** Contract signed in ERP (ТЗ 0076) that governs this agreement. Copied on group transfer. Null for agreements made before e-signing or by hand. */
  contractDocument?: Maybe<ContractSummaryType>;
  transferOutPaidAmount: Scalars['Float'];
  contributions: ContributionTypeConnection;
  payments?: Maybe<Array<Maybe<PaymentType>>>;
  chargeback?: Maybe<ChargebackType>;
  accountsPayable: Array<AccountsPayableType>;
  startAccountsPayable?: Maybe<AccountsPayableType>;
  corrections?: Maybe<Array<Maybe<PaymentCorrectionType>>>;
  /** PandaDoc contract this agreement was provisioned from (1:1), if any. */
  pandadocDocument?: Maybe<PandaDocDocumentType>;
  budgetAmount?: Maybe<Scalars['CustomFloat']>;
  /** Σ money received against this contract's instalments (ТЗ 0029 coverage: invoice net_paid + manual payments). */
  paidAmount?: Maybe<Scalars['CustomFloat']>;
  /** Σ unpaid remainder of the instalments that are ALREADY DUE (date < today) — THE debt number (ТЗ 0036). An instalment whose date has not arrived is a schedule, not a debt: see `upcomingAmount`. Do not recompute it as budget − paid on the client: an overpaid instalment must not settle the next one. */
  debtAmount?: Maybe<Scalars['CustomFloat']>;
  /** Σ unpaid remainder of the instalments NOT yet due (date >= today) — «Предстоит». Complement of `debtAmount`; both have any plan write-down netted off, earliest instalment first. As a rule of thumb budget = paidAmount + debtAmount + upcomingAmount, but do NOT rely on it: `paidAmount` is real money received and is deliberately left un-clamped, so it exceeds the budget when a plan write-down was booked before the money arrived, and it also nets refunds that resolve to no instalment. */
  upcomingAmount?: Maybe<Scalars['CustomFloat']>;
  attendancesInfo?: Maybe<Scalars['Float']>;
  courseWorksAverage?: Maybe<Scalars['Float']>;
  hwSummary?: Maybe<Scalars['Float']>;
  graduationProjectMark?: Maybe<Scalars['Float']>;
  /** Buyer's legal name (as it appears on the invoice). From the signed contract (ERP e-sign, else PandaDoc). */
  legalName?: Maybe<Scalars['String']>;
  /** Buyer's NIP / VAT-ID / УНП. From the signed contract. */
  taxId?: Maybe<Scalars['String']>;
  /** From the signed contract. */
  street?: Maybe<Scalars['String']>;
  /** From the signed contract. */
  city?: Maybe<Scalars['String']>;
  /** From the signed contract. */
  zipCode?: Maybe<Scalars['String']>;
  /** One-line `street, city zip_code` composed from the individual fields. Convenience for compact UIs. */
  address?: Maybe<Scalars['String']>;
  contributionsCount?: Maybe<Scalars['Int']>;
  paidContributionsCount?: Maybe<Scalars['Int']>;
  /** The agreement's instalments ordered by date, then id — a plain list for the group roster (ERP #104). Batched per request; status / coveredAmount / debt / hasVatInvoice cost no query per instalment. Empty for a caller without an ERP token and a management role. `invoices` inside it is empty for roles that do not read Fakturownia (HR); use `hasVatInvoice` for the «invoice issued?» mark instead. */
  scheduleContributions: Array<ContributionType>;
};


export type AgreementTypeContributionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  orderByDateFilter?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum AgreementCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

export type CountryType = {
  __typename?: 'CountryType';
  id: Scalars['ID'];
  title: Scalars['String'];
  agreements: Array<AgreementType>;
};

export type CompanyType = Node & {
  __typename?: 'CompanyType';
  id: Scalars['ID'];
  name: Scalars['String'];
  responsiblePerson: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  registrationNumber: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  agreements: Array<AgreementType>;
};

/** Коротко — для `AgreementType.contractDocument` и строки состава. */
export type ContractSummaryType = {
  __typename?: 'ContractSummaryType';
  id: Scalars['ID'];
  number: Scalars['String'];
  status: Scalars['String'];
  fulfilmentStatus: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
};

export type ContributionTypeConnection = {
  __typename?: 'ContributionTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContributionTypeEdge>>;
};

/** A Relay edge containing a `ContributionType` and its cursor. */
export type ContributionTypeEdge = {
  __typename?: 'ContributionTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<ContributionType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ContributionType = Node & {
  __typename?: 'ContributionType';
  id: Scalars['ID'];
  agreement: AgreementType;
  date: Scalars['Date'];
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  amountByn?: Maybe<Scalars['CustomFloat']>;
  /** Покрыт ПОЛНОСТЬЮ (remainder ≈ 0). До ТЗ 0029 означало «есть хоть какое-то покрытие» — платёж на 1 PLN закрывал взнос на 2000. */
  complete: Scalars['Boolean'];
  remainder?: Maybe<Scalars['CustomFloat']>;
  /** Money actually received against this installment (net invoice paid totals + manual payment, deduped). */
  coveredAmount?: Maybe<Scalars['Float']>;
  /** Деньги, полученные вне Fakturownia, в валюте договора. */
  manualPaidAmount: Scalars['Float'];
  manualPaidDate?: Maybe<Scalars['Date']>;
  /** Провенанс: «отмечено вручную» / «перенесено из legacy-платежа #123». */
  manualPaidNote: Scalars['String'];
  /** LMS Payment that closed this scheduled installment. Null while unpaid. */
  payment?: Maybe<PaymentType>;
  /** Указан — возврат денег по этому взносу (отток), уменьшает покрытие. Пусто — списание плана по договору. */
  corrections: Array<PaymentCorrectionType>;
  /** Fakturownia documents charging this installment (advance+final chains give several). */
  invoices?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  /** Proformas pinned to this installment (ТЗ 0101), newest first. Empty for roles without Fakturownia access. */
  proformas?: Maybe<Array<FakturowniaInvoiceType>>;
  group?: Maybe<GroupsType>;
  delay?: Maybe<Scalars['Int']>;
  agreementTitle?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  /** future | awaiting | invoiced | overdue | partial | paid | paid_manual — derived on read from the linked Fakturownia invoices + the manual payment edge. */
  status?: Maybe<Scalars['String']>;
  /** max(0, amount − coveredAmount) in agreement currency. */
  debt?: Maybe<Scalars['Float']>;
  /** True when fully covered exclusively by a manual «отметить оплаченным» payment (no invoice money). */
  paidManually?: Maybe<Scalars['Boolean']>;
  /** True when a real invoice bills this installment: an issued document that is not a quotation (estimate / client_order / proforma), not a correction and not rejected — the same rule as the billing preflight (`fakturownia.services.billability.is_billing_document`). Unlike `status == invoiced`, a lone proforma does NOT count (ERP #104). A document in another currency than the agreement's does not count either (it bills nothing — see `currencyMismatchInvoices`). */
  hasVatInvoice: Scalars['Boolean'];
  /** Документы, привязанные к взносу (счёт через `contribution` или проформа, ждущая VAT, через `proformaForContribution`), валюта которых не совпадает с валютой договора (пустая валюта документа = валюта договора). Не учтены в покрытии и статусе взноса — отвяжите или перевыставьте. Сначала ранние по дате выставления. Пусто для ролей без доступа к Fakturownia. */
  currencyMismatchInvoices: Array<FakturowniaInvoiceType>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  id: Scalars['ID'];
  date: Scalars['Date'];
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  currency: PaymentCurrency;
  agreement: AgreementType;
  amountAgreement: Scalars['Float'];
  source: PaymentSource;
  /** Scheduled contribution this payment satisfies. Null for orphan payments (returns, advances, top-ups, payments on agreements without a schedule). */
  contribution?: Maybe<ContributionType>;
  /** DEPRECATED (ТЗ 0029): раньше корректировка возврата цеплялась за скрытый платёж. Теперь — за взнос (`contribution`). Поле живёт до сноса таблицы платежей. */
  corrections: Array<PaymentCorrectionType>;
  /** Linked Fakturownia invoice (1:1), if any. */
  fakturowniaInvoice?: Maybe<FakturowniaInvoiceType>;
};

/** An enumeration. */
export enum PaymentCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

/** An enumeration. */
export enum PaymentSource {
  /** Создан оператором (legacy) */
  Operator = 'OPERATOR',
  /** Авто из оплаченной фактуры */
  InvoiceAuto = 'INVOICE_AUTO',
  /** Ручная отметка «оплачен» */
  ManualPaid = 'MANUAL_PAID'
}

/**
 * A correction line (корректировка) — amount is the positive magnitude;
 * `payment` is the target payment (null → whole-agreement / plan correction).
 */
export type PaymentCorrectionType = {
  __typename?: 'PaymentCorrectionType';
  id: Scalars['ID'];
  date: Scalars['Date'];
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  currency: PaymentCorrectionCurrency;
  agreement: AgreementType;
  /** Целевой платёж (разворот полученного); null — ко всему договору/плану. */
  payment?: Maybe<PaymentType>;
  /** Указан — возврат денег по этому взносу (отток), уменьшает покрытие. Пусто — списание плана по договору. */
  contribution?: Maybe<ContributionType>;
  /** True — возврат (уменьшает полученное). False — списание плана по договору (уменьшает бюджет). */
  isRefund: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  createdBy?: Maybe<CustomUserType>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum PaymentCorrectionCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

export type FakturowniaInvoiceType = {
  __typename?: 'FakturowniaInvoiceType';
  id: Scalars['ID'];
  fakturowniaId: Scalars['Int'];
  number: Scalars['String'];
  /** vat / proforma / correction / bill / receipt / advance / final / ... */
  kind: Scalars['String'];
  direction: FakturowniaInvoiceDirection;
  status?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['Date']>;
  sellDate?: Maybe<Scalars['Date']>;
  paymentTo?: Maybe<Scalars['Date']>;
  /** When the money actually arrived, per Fakturownia. Not the same as `issue_date` — measured on the history they differ for 82 % of paid invoices. It was always present in `raw_payload`; the separate `/payments.json` mirror returns nothing for this account, so this is the only receipt date we have. */
  paidDate?: Maybe<Scalars['Date']>;
  currency: Scalars['String'];
  /** On issued invoices = the student / customer. On received invoices buyer/seller swap visually but stay stable in JSON — here `buyer_*` carries the supplier. */
  buyerEmail: Scalars['String'];
  buyerName: Scalars['String'];
  buyerTaxNo: Scalars['String'];
  sellerName: Scalars['String'];
  /** Points to the Fakturownia document this one references. Set for kind=correction (→ amended doc), for kind=advance/final (→ parent estimate) and for a VAT issued from a proforma (→ the proforma, ТЗ 0101). */
  parentInvoice?: Maybe<FakturowniaInvoiceType>;
  correctionReason: Scalars['String'];
  /** Fakturownia's `accounting_kind` — purchases / media / salary / fuel / fixed_assets / expenses / ... */
  accountingKind: Scalars['String'];
  /** DEPRECATED: use invoice.payment.agreement.student. */
  linkedStudent?: Maybe<StudentType>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  linkedGroup?: Maybe<MethodistGroupType>;
  groupMatchSource: FakturowniaInvoiceGroupMatchSource;
  linkedAt?: Maybe<Scalars['DateTime']>;
  matchStatus: FakturowniaInvoiceMatchStatus;
  fakturowniaUpdatedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  priceNet?: Maybe<Scalars['Float']>;
  priceGross?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  outstanding?: Maybe<Scalars['Float']>;
  rawPayload?: Maybe<Scalars['JSONString']>;
  /** Public preview URL of the document in Fakturownia. */
  viewUrl?: Maybe<Scalars['String']>;
  /** Online-payment URL, when the document has one. Often null — only ~16% of issued invoices carry it. */
  paymentUrl?: Maybe<Scalars['String']>;
  /** Shortcut for kind=='correction'. Frontend uses this to tag the row as «correction to FV/N» visually. */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** kind=='advance' — partial-payment tax invoice that's part of an estimate chain. */
  isAdvance?: Maybe<Scalars['Boolean']>;
  /** kind=='final' — closing tax invoice that pairs with advance(s) under the same estimate. */
  isFinal?: Maybe<Scalars['Boolean']>;
  /** kind in (estimate, client_order) — the chain root / order document. Informational, not summed in aggregates. */
  isEstimate?: Maybe<Scalars['Boolean']>;
  /** True for estimate / client_order / proforma — informational documents excluded from revenue sums. */
  isQuotation?: Maybe<Scalars['Boolean']>;
  /** Reverse relation — correction invoices amending this one (children with kind='correction'). */
  corrections?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  /** Reverse relation — advance invoices under this estimate (children with kind='advance'). */
  advances?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  /** Reverse relation — the closing 'final' invoice under this estimate, if it has been issued (first child with kind='final'). */
  finalInvoice?: Maybe<FakturowniaInvoiceType>;
  /** 1:1 link to the LMS students.Payment that this invoice settles. Null when the invoice hasn't been reconciled yet — operators close that gap via the createPaymentForFakturowniaInvoice / linkFakturowniaInvoiceToPayment mutations. */
  payment?: Maybe<PaymentType>;
  /** Convenience shortcut for `payment.agreement` — the договор this invoice is part of. Null when payment is null. Use this for grouping invoices on a student's card without resolving Payment first. */
  agreement?: Maybe<AgreementType>;
  /** Mirror of Fakturownia's /payments.json rows for this invoice. Fakturownia can split a single invoice across several receipt records (deposit + balance, etc.); they all show up here. */
  fakturowniaPayments?: Maybe<Array<Maybe<FakturowniaPaymentType>>>;
  /** Which chain links this invoice to a group. CANONICAL = payment.agreement.group; LEGACY_LINKED_GROUP = only the deprecated linked_group FK. Frontend uses this to badge rows still backed by the legacy mirror during the Phase-13 rollout (see §G7). */
  groupFilterSource?: Maybe<GroupFilterSourceEnum>;
  /** The installment this document charges (N:1). Set by the sync auto-matcher or the linkInvoiceToContribution mutation. */
  contribution?: Maybe<ContributionType>;
  /** none | auto | manual — manual pins the link, the auto-matcher never re-points it. */
  contributionMatchSource?: Maybe<Scalars['String']>;
  /** Why the auto-provisioner refused to create the hidden Payment for this paid invoice (CURRENCY_MISMATCH / NO_PAYMENT_DATE). Empty when not blocked — surfaces as «требует внимания» in the ERP. */
  provisionBlockedReason?: Maybe<Scalars['String']>;
  /** kind=='proforma'. */
  isProforma?: Maybe<Scalars['Boolean']>;
  /** Only for a proforma: the installment it is pinned to (linkProformaToContribution / issued from ERP). Null when not pinned. */
  proformaForContributionId?: Maybe<Scalars['ID']>;
  /** A proforma still expecting money: not paid, not rejected and no VAT issued from it. An open proforma counts as the student's debt (LMS, «Moje faktury», payment calendar); a closed one counts nowhere. */
  isOpenProforma?: Maybe<Scalars['Boolean']>;
  /** Only for a proforma: the VAT (billing document) issued from it — by the ERP, by hand in Fakturownia or by auto-conversion (recognised by `from_invoice_id`). Null while none exists. */
  vatChild?: Maybe<FakturowniaInvoiceType>;
  /** price_gross after netting child correction invoices. */
  netGross?: Maybe<Scalars['Float']>;
  /** paid after netting refunds on child corrections. */
  netPaid?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum FakturowniaInvoiceDirection {
  /** Issued (we billed) */
  Issued = 'ISSUED',
  /** Received (we were billed) */
  Received = 'RECEIVED'
}

/** An enumeration. */
export enum FakturowniaInvoiceGroupMatchSource {
  /** Brak */
  None = 'NONE',
  /** Auto */
  Auto = 'AUTO',
  /** Manual */
  Manual = 'MANUAL'
}

/** An enumeration. */
export enum FakturowniaInvoiceMatchStatus {
  /** Unmatched */
  Unmatched = 'UNMATCHED',
  /** Auto matched */
  Auto = 'AUTO',
  /** Manually matched */
  Manual = 'MANUAL',
  /** Not applicable */
  NotApplicable = 'NOT_APPLICABLE'
}

/** Mirror of one row in Fakturownia's `/payments.json`. N:1 to invoice. */
export type FakturowniaPaymentType = {
  __typename?: 'FakturowniaPaymentType';
  id: Scalars['ID'];
  fakturowniaId: Scalars['Int'];
  /** N:1 to FakturowniaInvoice — Fakturownia may split one invoice across several payment records. */
  invoice: FakturowniaInvoiceType;
  paidDate?: Maybe<Scalars['Date']>;
  currency: Scalars['String'];
  /** Fakturownia payment kind — cash / transfer / card / ... */
  kind: Scalars['String'];
  fakturowniaUpdatedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  rawPayload?: Maybe<Scalars['JSONString']>;
};

/**
 * Which path linked this invoice to the group it was filtered by.
 * 
 * Used by `fakturowniaInvoices(group_id)` during the Phase-13 rollout
 * (docs/groups/group_dashboard.md §G7) so the frontend can show a
 * "legacy" badge on rows that only matched because the canonical
 * `payment → agreement → group` chain hadn't reached them yet.
 * Distinct from the existing `group_match_source` field, which records
 * how the legacy `linked_group` FK itself was assigned.
 */
export enum GroupFilterSourceEnum {
  Canonical = 'CANONICAL',
  LegacyLinkedGroup = 'LEGACY_LINKED_GROUP'
}

export type GroupsType = {
  __typename?: 'GroupsType';
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
  maxStudentsCount: Scalars['Int'];
  course: CourseFilterType;
  publishedLms: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  isFree: Scalars['Boolean'];
  zoomAccount?: Maybe<ZoomAccountType>;
  teacherLeads: ApplicationFilterTypeConnection;
  modules: Array<GroupModuleType>;
  classesDays: Array<DayOfClassType>;
  agreements: Array<AgreementType>;
  notes: Array<StudentNoteType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  conversations: Array<ConversationType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  slackChannels: Array<ChannelGroupLinkType>;
  materials: Array<MaterialType>;
};


export type GroupsTypeTeacherLeadsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  byGroupId?: Maybe<Scalars['Decimal']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
};


export type GroupsTypeZoomSchedulesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type StudentNoteType = {
  __typename?: 'StudentNoteType';
  id: Scalars['ID'];
  student?: Maybe<StudentType>;
  group?: Maybe<MethodistGroupType>;
  body: Scalars['String'];
  sentiment?: Maybe<Scalars['String']>;
  pinned: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  authorName?: Maybe<Scalars['String']>;
};

export type GroupZoomScheduleTypeConnection = {
  __typename?: 'GroupZoomScheduleTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupZoomScheduleTypeEdge>>;
};

/** A Relay edge containing a `GroupZoomScheduleType` and its cursor. */
export type GroupZoomScheduleTypeEdge = {
  __typename?: 'GroupZoomScheduleTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<GroupZoomScheduleType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GroupZoomScheduleType = Node & {
  __typename?: 'GroupZoomScheduleType';
  /** The ID of the object */
  id: Scalars['ID'];
  group: MethodistGroupType;
  weekDay: GroupZoomScheduleWeekDay;
  runTime: Scalars['Time'];
  isActive: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  weekDayDisplay?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum GroupZoomScheduleWeekDay {
  /** Monday */
  A_0 = 'A_0',
  /** Tuesday */
  A_1 = 'A_1',
  /** Wednesday */
  A_2 = 'A_2',
  /** Thursday */
  A_3 = 'A_3',
  /** Friday */
  A_4 = 'A_4',
  /** Saturday */
  A_5 = 'A_5',
  /** Sunday */
  A_6 = 'A_6'
}

export type ExpenseType = {
  __typename?: 'ExpenseType';
  id: Scalars['ID'];
  /** Document/issue date */
  date: Scalars['Date'];
  currency: ExpenseCurrency;
  description: Scalars['String'];
  category?: Maybe<ExpenseCategoryType>;
  /** Supplier / recipient name (free-text) */
  counterpartyName: Scalars['String'];
  /** NIP / УНП / VAT — optional */
  counterpartyTaxNo: Scalars['String'];
  relatedTeacher?: Maybe<TeacherFilterType>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  relatedGroup?: Maybe<MethodistGroupType>;
  /** Set for rows mirrored from a Fakturownia cost document. Acts as the idempotency key for the bridge. */
  relatedFakturowniaInvoice?: Maybe<FakturowniaInvoiceType>;
  source: ExpenseSource;
  /** When the money actually left our account (may differ from `date`). */
  paidAt?: Maybe<Scalars['Date']>;
  /** none = one-off; weekly steps +7 days from `date`; monthly repeats on `recurrence_day`. */
  recurrence: ExpenseRecurrence;
  /** 1–31 for monthly recurrence; clamped to the last day of short months. Ignored for weekly (uses `date.day`). */
  recurrenceDay?: Maybe<Scalars['Int']>;
  /** Inclusive end; empty means open-ended (until changed). */
  recurrenceUntil?: Maybe<Scalars['Date']>;
  /** Lifecycle status, for parity with the payment calendar. */
  status: ExpenseStatus;
  notes: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  /** FX cache of `amount` converted to PLN at `date`. Null when no ExchangeRate exists for the currency. */
  amountPln?: Maybe<Scalars['Float']>;
  documentUrl?: Maybe<Scalars['String']>;
  /** True when this expense mirrors a Fakturownia corrective invoice (kind='correction'). The amount is signed (usually negative) so the original and its correction net out; a metadata-only correction carries amount 0. */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** The linked Fakturownia corrective invoice's `correction_reason`, when this is a correction. */
  correctionReason?: Maybe<Scalars['String']>;
  /** When this bill is due — the linked cost invoice's `payment_to`. Null for a manual expense: no document, no deadline to promise. */
  dueAt?: Maybe<Scalars['Date']>;
  /** Due date passed and still not paid. Computed here rather than in the browser so «overdue» means the same thing to every viewer regardless of their clock or timezone. */
  isOverdue?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ExpenseCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

export type ExpenseCategoryType = {
  __typename?: 'ExpenseCategoryType';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  isActive: Scalars['Boolean'];
  pk?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum ExpenseSource {
  /** Fakturownia */
  Fakturownia = 'FAKTUROWNIA',
  /** Manual */
  Manual = 'MANUAL'
}

/** An enumeration. */
export enum ExpenseRecurrence {
  /** Brak */
  None = 'NONE',
  /** Weekly */
  Weekly = 'WEEKLY',
  /** Monthly */
  Monthly = 'MONTHLY'
}

/** An enumeration. */
export enum ExpenseStatus {
  /** Planned */
  Planned = 'PLANNED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Paid */
  Paid = 'PAID',
  /** Cancelled */
  Cancelled = 'CANCELLED'
}

export type SlackWorkspaceLinkType = {
  __typename?: 'SlackWorkspaceLinkType';
  id: Scalars['ID'];
  teamId: Scalars['String'];
  workspaceName: Scalars['String'];
  /** Адрес workspace из auth.test, например https://learnit-py01.slack.com/. Пусто — ещё не определён. */
  workspaceUrl: Scalars['String'];
  enabled: Scalars['Boolean'];
  channelCount?: Maybe<Scalars['Int']>;
  oauthConfigured?: Maybe<Scalars['Boolean']>;
};

export type ChannelGroupLinkType = {
  __typename?: 'ChannelGroupLinkType';
  id: Scalars['ID'];
  slackChannelId: Scalars['String'];
  channelName: Scalars['String'];
  archived: Scalars['Boolean'];
};

export type Person = {
  __typename?: 'Person';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
};

export type ChargebackType = {
  __typename?: 'ChargebackType';
  id: Scalars['ID'];
  date: Scalars['Date'];
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  currency: ChargebackCurrency;
  agreement: AgreementType;
};

/** An enumeration. */
export enum ChargebackCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

export type AccountsPayableType = {
  __typename?: 'AccountsPayableType';
  id: Scalars['ID'];
  date: Scalars['Date'];
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  currency: AccountsPayableCurrency;
  agreement?: Maybe<AgreementType>;
  startedAgreement: AgreementType;
  repaid: Scalars['Boolean'];
};

/** An enumeration. */
export enum AccountsPayableCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

export type PandaDocDocumentType = Node & {
  __typename?: 'PandaDocDocumentType';
  /** The ID of the object */
  id: Scalars['ID'];
  pandadocId: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateModified?: Maybe<Scalars['DateTime']>;
  dateSent?: Maybe<Scalars['DateTime']>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
  docType: PandaDocDocumentDocType;
  course: Scalars['String'];
  outcome: PandaDocDocumentOutcome;
  ttsHours?: Maybe<Scalars['Float']>;
  folderName: Scalars['String'];
  recipientEmail: Scalars['String'];
  recipientPhone: Scalars['String'];
  contractUrl: Scalars['String'];
  detailsFetched: Scalars['Boolean'];
  unavailable: Scalars['Boolean'];
  syncedAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  /** LMS Agreement (договор) that was created from this signed document. Null until the document is provisioned via the `provisionStudents` mutation. */
  agreement?: Maybe<AgreementType>;
  /** Timestamp the document was turned into a Student + Agreement. Null while the document is still pending or has been signed but not yet provisioned. */
  provisionedAt?: Maybe<Scalars['DateTime']>;
  /** provisioned | linked | candidate — link state of the document relative to an LMS agreement (student) or a Teacher. */
  matchType?: Maybe<Scalars['String']>;
  /** Teacher this trainer document is linked to (teacher card). Null for student / unlinked documents. */
  teacher?: Maybe<TeacherType>;
};

/** An enumeration. */
export enum PandaDocDocumentDocType {
  /** Student agreement */
  Student = 'STUDENT',
  /** Trainer agreement */
  Trainer = 'TRAINER',
  /** Co-financing */
  Dofin = 'DOFIN',
  /** Other */
  Other = 'OTHER'
}

/** An enumeration. */
export enum PandaDocDocumentOutcome {
  /** Signed */
  Signed = 'SIGNED',
  /** In progress */
  Active = 'ACTIVE',
  /** Not signed */
  Lost = 'LOST'
}

/**
 * Временная ссылка на день (spec 0013). Плоский ObjectType поверх модели
 * (НЕ DjangoObjectType — чтобы ничего не авто-протекло в другие типы);
 * отдаётся только role-gated резолвером на GroupType.
 */
export type GroupLinkOverrideType = {
  __typename?: 'GroupLinkOverrideType';
  id: Scalars['ID'];
  date: Scalars['Date'];
  joinUrl: Scalars['String'];
  setVia?: Maybe<Scalars['String']>;
  setByName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Roster-side connection over agreements — see docs/groups/groups_upgrade.md §B2.
 * 
 * `total_count` is filled by the resolver before instantiating the
 * connection so the COUNT(*) is run once over the filtered queryset
 * (instead of `len(self.iterable)` re-counting the page slice).
 */
export type AgreementConnection = {
  __typename?: 'AgreementConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgreementEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Agreement` and its cursor. */
export type AgreementEdge = {
  __typename?: 'AgreementEdge';
  /** The item at the end of the edge */
  node?: Maybe<AgreementType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Roster status filter — see docs/groups/groups_upgrade.md §B2. */
export enum RosterStatusEnum {
  All = 'ALL',
  Active = 'ACTIVE',
  Terminated = 'TERMINATED'
}

/**
 * Sort options for `GroupType.agreementsConnection`. Names match the
 * UI sort keys (`debt`, `percentPaid`, `name`, `status`) plus direction.
 */
export enum AgreementOrderByEnum {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  DebtDesc = 'DEBT_DESC',
  DebtAsc = 'DEBT_ASC',
  PercentPaidAsc = 'PERCENT_PAID_ASC',
  PercentPaidDesc = 'PERCENT_PAID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** An enumeration. */
export enum ApplicationCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

export type EmploymentType = IndividualEntrepreneurType | LegalEntityType | SelfEmployedType | NaturalPersonType;

export type IndividualEntrepreneurType = Node & {
  __typename?: 'IndividualEntrepreneurType';
  id: Scalars['ID'];
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  inn: Scalars['String'];
};

export type LegalEntityType = Node & {
  __typename?: 'LegalEntityType';
  id: Scalars['ID'];
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  tittle: Scalars['String'];
  inn: Scalars['String'];
};

export type SelfEmployedType = Node & {
  __typename?: 'SelfEmployedType';
  id: Scalars['ID'];
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  nationality: CountryType;
  passportNumber: Scalars['String'];
  inn: Scalars['String'];
};

export type NaturalPersonType = Node & {
  __typename?: 'NaturalPersonType';
  id: Scalars['ID'];
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  nationality: CountryType;
  passportNumber: Scalars['String'];
};

/** An enumeration. */
export enum ApplicationDeleteAvailable {
  DeleteAvailable = 'delete_available',
  DeleteNotAvailable = 'delete_not_available',
  DeleteWithTeacher = 'delete_with_teacher'
}

export type TeacherBillingEntityType = {
  __typename?: 'TeacherBillingEntityType';
  id: Scalars['ID'];
  teacherId: Scalars['ID'];
  /** jdg | company | private */
  kind: Scalars['String'];
  legalName: Scalars['String'];
  /** 10 digits; empty for `private`. */
  nip: Scalars['String'];
  /** standard | exempt | not_vat_payer | '' (not set) */
  vatMode: Scalars['String'];
  /** 23 / 8 / 5 / 0 for `standard`; null otherwise. */
  vatRate?: Maybe<Scalars['Float']>;
  isDefault: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type MainTeacherWebTypeConnection = {
  __typename?: 'MainTeacherWebTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MainTeacherWebTypeEdge>>;
};

/** A Relay edge containing a `MainTeacherWebType` and its cursor. */
export type MainTeacherWebTypeEdge = {
  __typename?: 'MainTeacherWebTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<MainTeacherWebType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type MainTeacherWebType = Node & {
  __typename?: 'MainTeacherWebType';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  mainTeachers: TeacherFilterTypeConnection;
};


export type MainTeacherWebTypeMainTeachersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  siteDisplay?: Maybe<Scalars['Boolean']>;
  hasInterview?: Maybe<Scalars['Boolean']>;
  hasPhoto?: Maybe<Scalars['Boolean']>;
  hasDescription?: Maybe<Scalars['Boolean']>;
  course?: Maybe<Scalars['Decimal']>;
  minRating?: Maybe<Scalars['Decimal']>;
  availability?: Maybe<Scalars['String']>;
};

/**
 * One named student comment about the teacher, from a survey
 * `teacher_comment` answer (spec 0011 extension). ERP-staff only.
 */
export type TeacherStudentCommentType = {
  __typename?: 'TeacherStudentCommentType';
  studentName: Scalars['String'];
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  courseName?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
};

export type SlackUserLinkType = {
  __typename?: 'SlackUserLinkType';
  id: Scalars['ID'];
  slackUserId: Scalars['String'];
  student?: Maybe<StudentType>;
  email: Scalars['String'];
  displayName: Scalars['String'];
  teamId: Scalars['String'];
};

export type StudentLessonConnection = {
  __typename?: 'StudentLessonConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentLessonEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentLesson` and its cursor. */
export type StudentLessonEdge = {
  __typename?: 'StudentLessonEdge';
  /** The item at the end of the edge */
  node?: Maybe<StudentLessonNodeType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/**
 * TZ-1 — one row of the student's lessons feed.
 * 
 * `attended` and `mark` come from per-student records (StudentAttendance /
 * StudentsMark) attached as queryset annotations by
 * `students.services.academic.annotate_student_lessons`. Built as a
 * graphene.ObjectType (not DjangoObjectType) because these fields are
 * student-scoped, not lesson-intrinsic.
 */
export type StudentLessonNodeType = Node & {
  __typename?: 'StudentLessonNodeType';
  /** The ID of the object */
  id: Scalars['ID'];
  date?: Maybe<Scalars['Date']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  attended?: Maybe<Scalars['Boolean']>;
  mark?: Maybe<Scalars['Float']>;
};

export type StudentTimelineConnection = {
  __typename?: 'StudentTimelineConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentTimelineEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentTimeline` and its cursor. */
export type StudentTimelineEdge = {
  __typename?: 'StudentTimelineEdge';
  /** The item at the end of the edge */
  node?: Maybe<StudentTimelineEventType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type StudentTimelineEventType = Node & {
  __typename?: 'StudentTimelineEventType';
  /** The ID of the object */
  id: Scalars['ID'];
  type: TimelineEventTypeEnum;
  date: Scalars['Date'];
  label?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['GenericScalar']>;
};

export enum TimelineEventTypeEnum {
  Signed = 'SIGNED',
  Paid = 'PAID',
  Moved = 'MOVED',
  Terminated = 'TERMINATED',
  InvoiceIssued = 'INVOICE_ISSUED',
  InvoiceLinked = 'INVOICE_LINKED',
  Note = 'NOTE',
  TaskCreated = 'TASK_CREATED',
  TaskDone = 'TASK_DONE',
  Sms = 'SMS',
  GroupCorrected = 'GROUP_CORRECTED',
  EnrollmentUndone = 'ENROLLMENT_UNDONE'
}

/** Лид Kommo в карточке кандидата или студента — «откуда пришёл». */
export type PersonKommoLeadType = {
  __typename?: 'PersonKommoLeadType';
  id: Scalars['ID'];
  kommoId: Scalars['ID'];
  /** Название сделки */
  name: Scalars['String'];
  /** ТЗ 0090: имя человека (контакт лида; нет — название сделки) */
  personName?: Maybe<Scalars['String']>;
  stageName?: Maybe<Scalars['String']>;
  stageColor?: Maybe<Scalars['String']>;
  responsibleName?: Maybe<Scalars['String']>;
  isClosed: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  utm: LeadUtmType;
  /** По какому правилу связан: form | email | phone | contract | candidate | manual */
  linkRule: Scalars['String'];
  kommoUrl?: Maybe<Scalars['String']>;
};

/**
 * TZ-2 — ответственный менеджер студента.
 * 
 * Per-student связь сейчас не существует ни в БД, ни в CRM-интеграции
 * (`CRMUser` — singleton, общий на всю систему). Резолвер на `StudentType`
 * возвращает `None` до отдельного продуктового решения. Тип нужен,
 * чтобы фронт мог писать запрос без падения на компиляции схемы.
 * См. docs/student_card/update_card.md TZ-2.
 */
export type ResponsibleManagerType = {
  __typename?: 'ResponsibleManagerType';
  id: Scalars['ID'];
  fullName?: Maybe<Scalars['String']>;
};

/** Slack-workspace группы студента и ссылки в него (#54). */
export type StudentSlackWorkspaceType = {
  __typename?: 'StudentSlackWorkspaceType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  /** Team id workspace (T…). */
  teamId: Scalars['String'];
  workspaceName: Scalars['String'];
  /** Адрес workspace (`https://<поддомен>.slack.com/`); null — ещё не определён (команда `slack_backfill_workspace_urls`). */
  workspaceUrl?: Maybe<Scalars['String']>;
  /** Аккаунт студента в этом workspace (U…); null — студент в Slack группы не найден. */
  slackUserId?: Maybe<Scalars['String']>;
  /** Отображаемое имя студента в Slack. */
  displayName?: Maybe<Scalars['String']>;
  /** Все договоры студента в этой группе расторгнуты. */
  agreementTerminated: Scalars['Boolean'];
  /** Открыть Slack группы в браузере (`https://app.slack.com/client/<T>`). */
  openWorkspaceUrl: Scalars['String'];
  /** Профиль студента в браузере (`<адрес>team/<U>`); null без адреса workspace или аккаунта студента. */
  profileUrl?: Maybe<Scalars['String']>;
  /** Профиль студента в приложении Slack (`slack://user?team=<T>&id=<U>`); null без аккаунта. */
  appProfileUrl?: Maybe<Scalars['String']>;
  /** Админка участников workspace (`<адрес>admin`): найти студента → Deactivate account. Деактивирует администратор workspace вручную. Null без адреса. */
  adminUrl?: Maybe<Scalars['String']>;
};

export type StudentEducationGroupType = {
  __typename?: 'StudentEducationGroupType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  /** Группа закончилась: занятия есть, и ни одного впереди (конец занятия — по Варшаве). */
  finished: Scalars['Boolean'];
  /** Все договоры студента в этой группе расторгнуты (в т.ч. переводом); false — хоть один действует. */
  agreementTerminated: Scalars['Boolean'];
};

/**
 * Wrapper so the field can grow extra aggregates later without a
 * breaking schema change (e.g. `top_level_currency`, `as_of`).
 */
export type StudentTotals = {
  __typename?: 'StudentTotals';
  byCurrency: Array<StudentTotalsRow>;
};

/**
 * One row per currency, over the active debt-bearing agreements.
 * 
 * `total_debt` is Σ «взнос» debt of the instalments ALREADY DUE (ТЗ 0036:
 * date < today), with any plan write-down netted off earliest-first; the rest
 * of the unpaid plan is `total_upcoming`. `total_paid` is Σ instalment
 * coverage clamped per instalment — NOT `budget − debt` (that formula would
 * book the whole future plan as paid once the date gate landed).
 * `totalBudget = totalPaid + totalDebt + totalUpcoming` holds except when a
 * plan write-down was booked before the money arrived: the write-down lowers
 * the budget while the money received stays visible in full.
 * `outstanding_invoices` is the Fakturownia outstanding on `issued` invoices
 * reached dual-chain, in the INVOICE's own currency — a currency met only on
 * invoices gets a row of its own with a zero plan.
 */
export type StudentTotalsRow = {
  __typename?: 'StudentTotalsRow';
  currency: Scalars['String'];
  totalBudget: Scalars['Float'];
  totalPaid: Scalars['Float'];
  totalDebt: Scalars['Float'];
  totalUpcoming: Scalars['Float'];
  /** Остаток выставленных счетов в валюте строки — по валюте самого счёта (счёт без кода — по валюте договора). Счёт в EUR на взносе PLN-договора — в строке EUR, а не PLN. */
  outstandingInvoices: Scalars['Float'];
  agreementsActive: Scalars['Int'];
  agreementsTerminated: Scalars['Int'];
};

export type KommoUserType = {
  __typename?: 'KommoUserType';
  id: Scalars['ID'];
  kommoId: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
  isActive: Scalars['Boolean'];
  erpUserId?: Maybe<Scalars['ID']>;
  erpUserName?: Maybe<Scalars['String']>;
  /** email | mailbox | manual | ambiguous | '' */
  matchSource: Scalars['String'];
  locked: Scalars['Boolean'];
  leadsCount: Scalars['Int'];
};

export type KommoSyncStatusType = {
  __typename?: 'KommoSyncStatusType';
  source: Scalars['String'];
  syncEnabled: Scalars['Boolean'];
  notesEnabled: Scalars['Boolean'];
  lastIncrementalAt?: Maybe<Scalars['DateTime']>;
  lastFullAt?: Maybe<Scalars['DateTime']>;
  lastStatus?: Maybe<Scalars['String']>;
  lastError?: Maybe<Scalars['String']>;
  leads: Scalars['Int'];
  unmappedResponsibles: Scalars['Int'];
  notesPending: Scalars['Int'];
  notesFailed: Scalars['Int'];
  runs: Array<KommoSyncRunType>;
};

export type KommoSyncRunType = {
  __typename?: 'KommoSyncRunType';
  id: Scalars['ID'];
  full: Scalars['Boolean'];
  triggerSource: Scalars['String'];
  startedByName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  created: Scalars['Int'];
  updated: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
};

/** Полный разбор звонка — вживую, не хранится. */
export type AploraCallAnalysisType = {
  __typename?: 'AploraCallAnalysisType';
  callId: Scalars['ID'];
  aploraUrl?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  managerName?: Maybe<Scalars['String']>;
  baseScore?: Maybe<Scalars['Float']>;
  growthScore?: Maybe<Scalars['Float']>;
  scoreBand?: Maybe<Scalars['String']>;
  summaryMd?: Maybe<Scalars['String']>;
  summaryText?: Maybe<Scalars['String']>;
  managerFeedback?: Maybe<Scalars['String']>;
  managerSummary?: Maybe<Scalars['String']>;
  didWell?: Maybe<Scalars['GenericScalar']>;
  mistakes?: Maybe<Scalars['GenericScalar']>;
  growthPoints?: Maybe<Scalars['GenericScalar']>;
  nextCallRecommendations?: Maybe<Scalars['GenericScalar']>;
  redFlags?: Maybe<Scalars['GenericScalar']>;
  leadEvaluation?: Maybe<Scalars['GenericScalar']>;
  stageOutcome?: Maybe<Scalars['GenericScalar']>;
};

/** Транскрипт звонка — вживую, нигде не сохраняется. */
export type AploraTranscriptType = {
  __typename?: 'AploraTranscriptType';
  callId: Scalars['ID'];
  transcript?: Maybe<Scalars['GenericScalar']>;
};

/**
 * ТЗ 0090: чем заполнить форму договора студента из карточки лида.
 * Подсказка: черновик создаёт `createStudentContractDraft` со всеми
 * проверками.
 */
export type ContractDraftFromLeadType = {
  __typename?: 'ContractDraftFromLeadType';
  /** Строка лида в ERP */
  leadId: Scalars['ID'];
  /** Название сделки */
  leadName: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  /** Номер лида Kommo для связи (`crmLeadId` черновика); null — связать нельзя, см. crmLeadBlocked */
  crmLeadId?: Maybe<Scalars['ID']>;
  /** Почему связи нет: LEAD_LEFT_PIPELINE | LEAD_DELETED | SOURCE_DISABLED */
  crmLeadBlocked?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  /** Откуда курс: funding_candidate | kommo_course */
  courseSource?: Maybe<Scalars['String']>;
  /** Поле «курс» лида в Kommo как есть */
  courseRaw: Scalars['String'];
  /** До 5 ближайших групп курса (старт ≥ сегодня, курс юрлица сотрудника) */
  groups: Array<ContractDraftGroupType>;
  /** Первая группа со стартом не раньше желаемого месяца заявки дофинансирования, иначе первая */
  suggestedGroupId?: Maybe<Scalars['ID']>;
  /** Тариф «дофинансирование» — если у лида живая заявка */
  paymentPlanId?: Maybe<Scalars['ID']>;
  /** funding_candidate */
  paymentPlanReason?: Maybe<Scalars['String']>;
  fundingCandidate?: Maybe<LeadFundingLinkType>;
  /** Договоры, уже оформленные из этого лида */
  existingContracts: Array<LeadContractType>;
};

/** ТЗ 0090: ближайшая группа курса — чип в форме договора. */
export type ContractDraftGroupType = {
  __typename?: 'ContractDraftGroupType';
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
};

export type TeacherSmsStateType = {
  __typename?: 'TeacherSmsStateType';
  available: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  phoneMasked?: Maybe<Scalars['String']>;
  messages: Array<SmsMessageType>;
  documents: Array<TeacherSignDocumentType>;
};

/**
 * Документ, который ждёт подписи преподавателя — цель ссылки «на
 * подпись».
 */
export type TeacherSignDocumentType = {
  __typename?: 'TeacherSignDocumentType';
  id: Scalars['ID'];
  number: Scalars['String'];
  /** teacher_framework | teacher_annex */
  kind: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
};

export type TeacherSmsLinkInput = {
  /** none | sign | lms | url */
  kind: Scalars['String'];
  /** Документ на подпись (для sign) */
  contractId?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type SmsJournalPageType = {
  __typename?: 'SmsJournalPageType';
  items: Array<SmsMessageType>;
  total: Scalars['Int'];
  totalCost: Scalars['Float'];
  totalSegments: Scalars['Int'];
};

export type SmsJournalFacetsType = {
  __typename?: 'SmsJournalFacetsType';
  topics: Array<Scalars['String']>;
  authors: Array<SmsAuthorType>;
  campaigns: Array<SmsCampaignRefType>;
};

export type SmsAuthorType = {
  __typename?: 'SmsAuthorType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SmsCampaignRefType = {
  __typename?: 'SmsCampaignRefType';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type StudentSmsStateType = {
  __typename?: 'StudentSmsStateType';
  available: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  phoneMasked?: Maybe<Scalars['String']>;
  messages: Array<SmsMessageType>;
  invoices: Array<SmsInvoiceOptionType>;
};

export type SmsInvoiceOptionType = {
  __typename?: 'SmsInvoiceOptionType';
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  daysOverdue: Scalars['Int'];
  hasPayUrl: Scalars['Boolean'];
};

export type SmsLinkInput = {
  /** none | invoice | lms | lms_invoices | url */
  kind: Scalars['String'];
  invoiceId?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type SmsCampaignCandidateType = {
  __typename?: 'SmsCampaignCandidateType';
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  phoneMasked?: Maybe<Scalars['String']>;
  /** Почему SMS не уйдёт (пусто — уйдёт) */
  reason?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['ID']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
};

export type SmsCampaignPreviewType = {
  __typename?: 'SmsCampaignPreviewType';
  sample?: Maybe<SmsPreviewType>;
  recipients: Scalars['Int'];
  excluded: Scalars['Int'];
  total: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type SmsCampaignType = {
  __typename?: 'SmsCampaignType';
  id: Scalars['ID'];
  title: Scalars['String'];
  body: Scalars['String'];
  /** all | unpaid | overdue */
  mode: Scalars['String'];
  linkKind: Scalars['String'];
  linkUrl?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  counts: SmsCampaignCountsType;
};

export type SmsCampaignCountsType = {
  __typename?: 'SmsCampaignCountsType';
  total: Scalars['Int'];
  pending: Scalars['Int'];
  sent: Scalars['Int'];
  failed: Scalars['Int'];
  skipped: Scalars['Int'];
  delivered: Scalars['Int'];
  retryable: Scalars['Int'];
  cost: Scalars['Float'];
  finished: Scalars['Boolean'];
};

/**
 * ТЗ 0084: куда ведут ссылки. Анкету и LMS правят Admin и продавцы;
 * сократитель и Documenso — только чтение (инфраструктура: их смена
 * ломает уже выданные ссылки).
 */
export type LinkAddressesType = {
  __typename?: 'LinkAddressesType';
  /** Действующий адрес анкеты дофинансирования (ERP, иначе env) */
  dofinFormUrl: Scalars['String'];
  /** Из env DOFIN_FORM_URL — действует, когда в ERP пусто */
  dofinFormUrlDefault: Scalars['String'];
  /** Адрес задан в ERP */
  dofinFormUrlSaved: Scalars['Boolean'];
  /** Действующий адрес LMS */
  lmsBaseUrl: Scalars['String'];
  /** Из env LMS_BASE_URL */
  lmsBaseUrlDefault: Scalars['String'];
  lmsBaseUrlSaved: Scalars['Boolean'];
  /** Страница «Мои фактуры» в LMS */
  lmsInvoicesUrl: Scalars['String'];
  /** SHORTLINK_BASE_URL (env, только чтение) */
  shortlinkBaseUrl?: Maybe<Scalars['String']>;
  /** DOCUMENSO_BASE_URL (env, только чтение) */
  documensoBaseUrl?: Maybe<Scalars['String']>;
  canEdit: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByName?: Maybe<Scalars['String']>;
};

export type SmsSettingsType = {
  __typename?: 'SmsSettingsType';
  enabled: Scalars['Boolean'];
  remindersEnabled: Scalars['Boolean'];
  senderName: Scalars['String'];
  /** ЧЧ:ММ, Варшава */
  quietStart: Scalars['String'];
  quietEnd: Scalars['String'];
  dailyCapPerPhone: Scalars['Int'];
  allowUnicode: Scalars['Boolean'];
  allowForeignNumbers: Scalars['Boolean'];
  maxSegments: Scalars['Int'];
  lowBalancePoints?: Maybe<Scalars['Float']>;
  legalEntityIds: Array<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByName?: Maybe<Scalars['String']>;
  serverSmsAllowed: Scalars['Boolean'];
  serverRemindersAllowed: Scalars['Boolean'];
  /** console | smsapi */
  provider: Scalars['String'];
  tokenConfigured: Scalars['Boolean'];
  webhookConfigured: Scalars['Boolean'];
  /** Куда SMSAPI шлёт отчёты; секрет скрыт */
  webhookUrlMasked?: Maybe<Scalars['String']>;
  shortlinkBaseUrl?: Maybe<Scalars['String']>;
  /** Приёмочный список SMS_ONLY_TO (номера замаскированы) */
  onlyTo: Array<Scalars['String']>;
  canEdit: Scalars['Boolean'];
  /** Хвост отписки первой SMS рассылки по группе; обязательно с {link}/stop (STOP_LINK_REQUIRED) */
  optOutSuffix: Scalars['String'];
  defaultOptOutSuffix: Scalars['String'];
  /** Может править хвост отписки (saveSmsTexts): Admin, SalesManager, AccountManager */
  canEditTexts: Scalars['Boolean'];
};

export type SmsProviderStatusType = {
  __typename?: 'SmsProviderStatusType';
  provider: Scalars['String'];
  tokenConfigured: Scalars['Boolean'];
  checkedAt?: Maybe<Scalars['DateTime']>;
  ok: Scalars['Boolean'];
  /** Баланс SMSAPI (пункты) */
  points?: Maybe<Scalars['Float']>;
  /** prepaid | postpaid */
  paymentType?: Maybe<Scalars['String']>;
  lowBalance: Scalars['Boolean'];
  lowBalancePoints?: Maybe<Scalars['Float']>;
  senderName: Scalars['String'];
  /** ACTIVE | PENDING | INACTIVE | REJECTED | DELETED | NOT_FOUND | CONSOLE */
  senderStatus?: Maybe<Scalars['String']>;
  senderActive: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
};

export type ReminderPlanType = {
  __typename?: 'ReminderPlanType';
  topic: Scalars['String'];
  enabled: Scalars['Boolean'];
  steps: Array<ReminderStepType>;
  templates: Array<ReminderTemplateOptionType>;
  states: Array<Scalars['String']>;
  anchors: Array<Scalars['String']>;
  /** «якорь:условие», которые не сойдутся никогда */
  impossibleSteps: Array<Scalars['String']>;
  canEdit: Scalars['Boolean'];
  /** Робот работает: env и настройки SMS */
  active: Scalars['Boolean'];
};

export type ReminderStepType = {
  __typename?: 'ReminderStepType';
  id: Scalars['ID'];
  step: Scalars['Int'];
  /** Якорь темы: start | deadline | clicked | opened */
  anchor: Scalars['String'];
  offsetMinutes: Scalars['Int'];
  /** Состояние повода; пусто — любое */
  condition: Scalars['String'];
  templateCode: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type ReminderTemplateOptionType = {
  __typename?: 'ReminderTemplateOptionType';
  code: Scalars['String'];
  name: Scalars['String'];
  namePl: Scalars['String'];
  body: Scalars['String'];
};

export type SmsReminderPreviewType = {
  __typename?: 'SmsReminderPreviewType';
  topic: Scalars['String'];
  subjectId: Scalars['ID'];
  subjectLabel?: Maybe<Scalars['String']>;
  step: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['DateTime']>;
  dueNow: Scalars['Boolean'];
  phoneMasked?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  segments: Scalars['Int'];
};

export type ShortLinkSettingsType = {
  __typename?: 'ShortLinkSettingsType';
  /** SHORTLINK_BASE_URL задан на сервере */
  enabled: Scalars['Boolean'];
  /** Начало короткой ссылки */
  baseUrl?: Maybe<Scalars['String']>;
};

export type ShortLinkType = {
  __typename?: 'ShortLinkType';
  id: Scalars['ID'];
  /** manual | contract | sms | email | other */
  kind: Scalars['String'];
  title: Scalars['String'];
  /** Тип (канал): код из списка ERP или свой текст; пусто — не указан */
  channel: Scalars['String'];
  tags: Array<Scalars['String']>;
  code: Scalars['String'];
  /** Короткая ссылка; null — сократитель не настроен */
  url?: Maybe<Scalars['String']>;
  /** Куда ведёт */
  targetUrl: Scalars['String'];
  /** Домен цели */
  targetHost?: Maybe<Scalars['String']>;
  subjectKind?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['ID']>;
  /** Номер договора */
  subjectLabel?: Maybe<Scalars['String']>;
  /** ТЗ 0084: лид Kommo, которому ушла SMS с этой ссылкой (карточка /leads) */
  leadId?: Maybe<Scalars['ID']>;
  /** ТЗ 0084: кандидат дофинансирования */
  candidateId?: Maybe<Scalars['ID']>;
  clickCount: Scalars['Int'];
  humanClickCount: Scalars['Int'];
  firstHumanClickedAt?: Maybe<Scalars['DateTime']>;
  lastClickedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  /** live | revoked | expired */
  state: Scalars['String'];
  canEdit: Scalars['Boolean'];
  canRevoke: Scalars['Boolean'];
};

export type ShortLinkSummaryType = {
  __typename?: 'ShortLinkSummaryType';
  total: Scalars['Int'];
  live: Scalars['Int'];
  humanClicks: Scalars['Int'];
  clicks: Scalars['Int'];
};

/** Что уже встречается в ссылках юрлица: для выпадашек и подсказок. */
export type ShortLinkFacetsType = {
  __typename?: 'ShortLinkFacetsType';
  channels: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  authors: Array<ShortLinkAuthorType>;
};

export type ShortLinkAuthorType = {
  __typename?: 'ShortLinkAuthorType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShortLinkDayType = {
  __typename?: 'ShortLinkDayType';
  date: Scalars['Date'];
  /** Засчитанные переходы людей */
  human: Scalars['Int'];
  /** Все переходы */
  total: Scalars['Int'];
};

/**
 * Переход без IP (он и так хранится только хешем) и без полного
 * User-Agent: экрану хватает «человек / робот» и источника.
 */
export type ShortLinkClickType = {
  __typename?: 'ShortLinkClickType';
  id: Scalars['ID'];
  clickedAt: Scalars['DateTime'];
  /** Браузер подтвердил переход */
  human: Scalars['Boolean'];
  /** Засчитан (не повтор с того же адреса) */
  counted: Scalars['Boolean'];
  isBot: Scalars['Boolean'];
  /** Домен, откуда пришли */
  source?: Maybe<Scalars['String']>;
};

export type ContractTemplateEditableType = {
  __typename?: 'ContractTemplateEditableType';
  template: ContractTemplateType;
  html: Scalars['String'];
  tokens: Array<ContractTemplateTokenType>;
  variables: Array<ContractTemplateVariableType>;
};

/** Шаблон договора (ТЗ 0078): выбор при создании и справочник. */
export type ContractTemplateType = {
  __typename?: 'ContractTemplateType';
  id: Scalars['ID'];
  code: Scalars['String'];
  version: Scalars['Int'];
  kind: Scalars['String'];
  name: Scalars['String'];
  language: Scalars['String'];
  /** none | group_change | dofinansowanie */
  appendix: Scalars['String'];
  description: Scalars['String'];
  isActive: Scalars['Boolean'];
  /** git | erp */
  origin: Scalars['String'];
  /** Автор версии из ERP */
  createdByName?: Maybe<Scalars['String']>;
  /** Когда заведена версия (у версий до 0107 — пусто) */
  createdAt?: Maybe<Scalars['DateTime']>;
  comment: Scalars['String'];
  basedOnId?: Maybe<Scalars['ID']>;
  basedOnCode?: Maybe<Scalars['String']>;
  basedOnVersion?: Maybe<Scalars['Int']>;
  /** Действует версия из ERP, а выкат принёс новый текст из кода — он заведён неактивной версией (pendingGitVersion) */
  hasPendingGit: Scalars['Boolean'];
  /** Номер неактивной версии из кода, которую можно включить */
  pendingGitVersion?: Maybe<Scalars['Int']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  legalEntityName?: Maybe<Scalars['String']>;
  /** Код из git (CONTRACT_TEMPLATES): выключить целиком нельзя — выкат включит снова */
  isGitCode: Scalars['Boolean'];
};

export type ContractTemplatePreviewDraftType = {
  __typename?: 'ContractTemplatePreviewDraftType';
  /** HTML образца; пусто — есть problems */
  html?: Maybe<Scalars['String']>;
  problems: Array<ContractTemplateProblemType>;
};

export type ContractInvitePreviewType = {
  __typename?: 'ContractInvitePreviewType';
  /** Тема с подстановками; пусто — текста нет (SendGrid, нет шаблона) */
  subject?: Maybe<Scalars['String']>;
  /** Текст с подстановками; ссылка — образец той же длины */
  body?: Maybe<Scalars['String']>;
  /** Тема шаблона как есть, с {…} — исходник для разовой правки (emailSubject в sendContract) */
  rawSubject?: Maybe<Scalars['String']>;
  /** Текст шаблона как есть, с {…} — исходник для разовой правки (emailBody в sendContract) */
  rawBody?: Maybe<Scalars['String']>;
  /** С какого ящика уйдёт */
  fromEmail?: Maybe<Scalars['String']>;
  /** Имя в подписи (владелец ящика); общий ящик — пусто */
  fromName?: Maybe<Scalars['String']>;
  /** Куда уйдёт: подписант или тестовый адрес стенда */
  toEmail?: Maybe<Scalars['String']>;
  /** invite | invite_company | invite_teacher_framework | invite_teacher_annex */
  templateCode: Scalars['String'];
  /** ERP #133: какой шаблон взят (выбранный или по правилам 0094); пусто — текста нет */
  templateId?: Maybe<Scalars['ID']>;
  /** ERP #133: из чего выбрать — общий шаблон этого договора и ваши личные письма темы со ссылкой {link} (своя версия — первой); через SendGrid — пусто */
  templates: Array<ContractInviteTemplateOptionType>;
  /** ERP #133: у вас есть личная версия письма этого договора (включённая или нет) — «Изменить свой шаблон» вместо «Создать» */
  hasOwnCopy: Scalars['Boolean'];
  /** ERP #133: id этой личной версии */
  ownCopyId?: Maybe<Scalars['ID']>;
  templateName?: Maybe<Scalars['String']>;
  /** Название шаблона для польского интерфейса (пусто в базе — русское) */
  templateNamePl?: Maybe<Scalars['String']>;
  /** Взята личная версия владельца ящика */
  isPersonal: Scalars['Boolean'];
  /** mailbox | sendgrid */
  via: Scalars['String'];
  /** Текст можно поправить перед отправкой */
  editable: Scalars['Boolean'];
  /** Письмо уйдёт, если отправить сейчас */
  canSend: Scalars['Boolean'];
  /** Почему письмо не уйдёт: wrong_status | mail_disabled | shortlink_disabled | no_mailbox | no_template */
  skipReason?: Maybe<Scalars['String']>;
  /** Разовая правка или выбор шаблона не пройдут: UNKNOWN_PLACEHOLDER | LINK_REQUIRED | LINK_IN_SUBJECT | TOO_LONG | NOT_FOUND | TEMPLATE_FORBIDDEN | … */
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  /** К какому полю ошибка: emailSubject | emailBody | templateId */
  errorField?: Maybe<Scalars['String']>;
};

/**
 * ERP #133: шаблон, которым можно отправить приглашение: общий этого
 * договора или личный того, кто смотрит (чужих личных здесь нет).
 */
export type ContractInviteTemplateOptionType = {
  __typename?: 'ContractInviteTemplateOptionType';
  /** id MessageTemplate — templateId для отправки */
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
  /** Название для польского интерфейса (пусто в базе — русское) */
  namePl?: Maybe<Scalars['String']>;
  /** Ваш личный шаблон */
  isPersonal: Scalars['Boolean'];
};

export type CrmLeadPageType = {
  __typename?: 'CrmLeadPageType';
  items: Array<CrmLeadType>;
  hasMore: Scalars['Boolean'];
  error?: Maybe<CrmErrorType>;
};

export type CrmLeadType = {
  __typename?: 'CrmLeadType';
  id: Scalars['ID'];
  name: Scalars['String'];
  statusId?: Maybe<Scalars['ID']>;
  statusName: Scalars['String'];
  statusColor: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  responsibleName: Scalars['String'];
  contactId?: Maybe<Scalars['ID']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type CrmLeadStatusListType = {
  __typename?: 'CrmLeadStatusListType';
  items: Array<CrmLeadStatusType>;
  error?: Maybe<CrmErrorType>;
};

export type CrmLeadStatusType = {
  __typename?: 'CrmLeadStatusType';
  id: Scalars['ID'];
  name: Scalars['String'];
  color: Scalars['String'];
};

export type ContractAnalyticsType = {
  __typename?: 'ContractAnalyticsType';
  funnel: FunnelType;
  statuses: Array<StatusCountType>;
  tts: TimeToSignType;
  sellers: Array<SellerStatType>;
  courses: Array<CourseStatType>;
  series: Array<SeriesPointType>;
  sms: SmsStatType;
  amountsVisible: Scalars['Boolean'];
};

export type FunnelType = {
  __typename?: 'FunnelType';
  created: Scalars['Int'];
  sent: Scalars['Int'];
  opened: Scalars['Int'];
  signed: Scalars['Int'];
  enrolled: Scalars['Int'];
};

export type StatusCountType = {
  __typename?: 'StatusCountType';
  status: Scalars['String'];
  count: Scalars['Int'];
};

export type TimeToSignType = {
  __typename?: 'TimeToSignType';
  signedCount: Scalars['Int'];
  medianHours?: Maybe<Scalars['Float']>;
  avgHours?: Maybe<Scalars['Float']>;
  within24hPct?: Maybe<Scalars['Int']>;
  within72hPct?: Maybe<Scalars['Int']>;
};

export type SellerStatType = {
  __typename?: 'SellerStatType';
  sellerId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  created: Scalars['Int'];
  sent: Scalars['Int'];
  /** Подписано из созданных в периоде */
  signed: Scalars['Int'];
  /** Подписано в периоде (любые договоры) — база для премий, как и суммы */
  signedInPeriod: Scalars['Int'];
  /** Подписано из созданных / отправлено из созданных */
  conversionPct?: Maybe<Scalars['Int']>;
  medianHours?: Maybe<Scalars['Float']>;
  /** Суммы подписанных в периоде; null — нет права видеть */
  amounts?: Maybe<Array<MoneyType>>;
};

export type MoneyType = {
  __typename?: 'MoneyType';
  currency: Scalars['String'];
  amount: Scalars['String'];
};

export type CourseStatType = {
  __typename?: 'CourseStatType';
  course: Scalars['String'];
  created: Scalars['Int'];
  sent: Scalars['Int'];
  signed: Scalars['Int'];
  conversionPct?: Maybe<Scalars['Int']>;
};

export type SeriesPointType = {
  __typename?: 'SeriesPointType';
  period: Scalars['String'];
  created: Scalars['Int'];
  sent: Scalars['Int'];
  signed: Scalars['Int'];
};

export type SmsStatType = {
  __typename?: 'SmsStatType';
  sent: Scalars['Int'];
  delivered: Scalars['Int'];
  failed: Scalars['Int'];
  humanClicks: Scalars['Int'];
  contractsClicked: Scalars['Int'];
};

export type ContractMailSummaryType = {
  __typename?: 'ContractMailSummaryType';
  contractId: Scalars['ID'];
  threads: Scalars['Int'];
  /** Входящие письма, ещё не обработанные */
  unhandled: Scalars['Int'];
  lastInboundAt?: Maybe<Scalars['DateTime']>;
};

export type ContractOutreachType = {
  __typename?: 'ContractOutreachType';
  /** Канал включён и договору можно слать */
  available: Scalars['Boolean'];
  /** Почему нельзя: disabled_on_server | disabled | entity_not_allowed | no_phone | not_allowlisted | foreign_number | opted_out | closed */
  reason?: Maybe<Scalars['String']>;
  stopped: Scalars['Boolean'];
  /** Робот лестницы работает (env и ERP); false — только ручные напоминания */
  autoReminders: Scalars['Boolean'];
  /** Когда уйдёт следующее SMS лестницы; пусто — шагов не осталось или у следующего шага нет текста (nextStepReason) */
  nextStepAt?: Maybe<Scalars['DateTime']>;
  /** Почему следующее SMS не уйдёт: no_template — шаблон его шага выключен или удалён («Настройки → Шаблоны сообщений»); пусто — уйдёт в nextStepAt */
  nextStepReason?: Maybe<Scalars['String']>;
  /** ТЗ 0082: для какого состояния следующий шаг; пусто — для любого */
  nextStepCondition?: Maybe<Scalars['String']>;
  /** ТЗ 0082: состояние договора сейчас — not_opened | clicked | opened */
  state?: Maybe<Scalars['String']>;
  messages: Array<OutreachMessageType>;
  link?: Maybe<ShortLinkStatsType>;
};

export type OutreachMessageType = {
  __typename?: 'OutreachMessageType';
  id: Scalars['ID'];
  step: Scalars['Int'];
  /** initial | nudge_N | last_call | manual */
  stepLabel: Scalars['String'];
  status: Scalars['String'];
  skipReason?: Maybe<Scalars['String']>;
  scheduledFor?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  sentAt?: Maybe<Scalars['DateTime']>;
  deliveredAt?: Maybe<Scalars['DateTime']>;
  dlrStatus?: Maybe<Scalars['String']>;
  segments?: Maybe<Scalars['Int']>;
  phoneMasked?: Maybe<Scalars['String']>;
  /** ТЗ 0082: для какого состояния шаг лестницы (not_opened | clicked | opened); пусто — для любого */
  condition?: Maybe<Scalars['String']>;
  /** Снимок отправленного; до отправки — текст с подстановками ({link}…): сотрудника или шаблона шага */
  body: Scalars['String'];
  templateCode?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  templateNamePl?: Maybe<Scalars['String']>;
  /** Кто написал или нажал «Напомнить»; пусто — робот */
  createdByName?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type ShortLinkStatsType = {
  __typename?: 'ShortLinkStatsType';
  clickCount: Scalars['Int'];
  humanClickCount: Scalars['Int'];
  firstHumanClickedAt?: Maybe<Scalars['DateTime']>;
  lastClickedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  revoked: Scalars['Boolean'];
};

export type ContractOutreachSummaryType = {
  __typename?: 'ContractOutreachSummaryType';
  contractId: Scalars['ID'];
  smsSent: Scalars['Int'];
  lastSmsAt?: Maybe<Scalars['DateTime']>;
  humanClicks: Scalars['Int'];
};

/**
 * Шаблон SMS или письма сотрудника (ТЗ 0078). Тело — с подстановками
 * `{first_name}`…; значения подставляет сервер при отправке.
 */
export type MessageTemplateType = {
  __typename?: 'MessageTemplateType';
  id: Scalars['ID'];
  /** sms | email */
  channel: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  /** Для польского интерфейса; пусто — показывать `name` */
  namePl: Scalars['String'];
  subject: Scalars['String'];
  body: Scalars['String'];
  isSystem: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  updatedByName?: Maybe<Scalars['String']>;
  /** ТЗ 0084: где код называет этот шаблон («Подпись договора, шаг 2»), по-русски. Непусто — выключить и удалить нельзя (TEMPLATE_IN_USE) */
  usedIn: Array<Scalars['String']>;
  /** То же по-польски */
  usedInPl: Array<Scalars['String']>;
  /** ТЗ 0094: личная версия сотрудника (ownerId), а не общий шаблон. Личная копия кода приглашения / первого SMS / «Напомнить сейчас» заменяет общий текст в его отправках; прочие личные — его ручные заготовки */
  isPersonal: Scalars['Boolean'];
  /** ТЗ 0094: чей личный; пусто — общий */
  ownerId?: Maybe<Scalars['ID']>;
  /** ТЗ 0094: имя владельца личного шаблона */
  ownerName?: Maybe<Scalars['String']>;
  /** ТЗ 0094: может ли вызывающий править этот шаблон (общий — редакторы темы; личный — только владелец) */
  canEdit: Scalars['Boolean'];
  /** ТЗ 0094: может ли удалить: свой личный — всегда; общий — редактор, если не системный и не используется */
  canDelete: Scalars['Boolean'];
};

/**
 * ТЗ 0084: подстановка — что это, откуда берётся, пример. Язык
 * интерфейса знает браузер, а не сервер: русские и польские поля оба.
 */
export type TemplateVariableType = {
  __typename?: 'TemplateVariableType';
  name: Scalars['String'];
  /** Что это, по-русски (как раньше) */
  description: Scalars['String'];
  descriptionRu: Scalars['String'];
  descriptionPl: Scalars['String'];
  /** Откуда берётся значение, по-русски; у {link} — куда ведёт ссылка в этой теме */
  source: Scalars['String'];
  sourceRu: Scalars['String'];
  sourcePl: Scalars['String'];
  example: Scalars['String'];
};

export type ContractsSmsPreviewType = {
  __typename?: 'ContractsSmsPreviewType';
  rows: Array<ContractSmsBulkRowType>;
  willSend: Scalars['Int'];
  skipped: Scalars['Int'];
  /** Сколько сегментов уйдёт всего — цена */
  segmentsTotal: Scalars['Int'];
  /** Текст на первом договоре, которому SMS уйдёт; нет таких — пусто */
  sample?: Maybe<SmsPreviewType>;
};

/** ТЗ 0083: один договор в массовой SMS — уйдёт или почему нет. */
export type ContractSmsBulkRowType = {
  __typename?: 'ContractSmsBulkRowType';
  contractId: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  signerName?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  /** OK | NOT_FOUND | NOT_STUDENT | NOT_YOUR_CONTRACT | NOT_SENT | SIGNED | CANCELLED | EXPIRED | NO_PHONE | FOREIGN_NUMBER | OPTED_OUT | STOPPED | DAILY_CAP | COOLDOWN | TOO_LONG | DISABLED_ON_SERVER | DISABLED | ENTITY_NOT_ALLOWED | NOT_ALLOWLISTED | ALREADY_SENT | WRONG_STATUS | … */
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  segments: Scalars['Int'];
};

/**
 * Что включено на сервере — ERP по этому прячет кнопки (ТЗ 0076).
 * 
 * Переходный период: код выкатывается с выключенными флагами, и ERP обязан
 * выглядеть как раньше (работает только PandaDoc). Флаг `ESIGN_ENABLED`
 * закрывает НОВЫЕ договоры и отправку; уже отправленные дойдут до подписи
 * и зачисления — вебхуки и сверка флаг не смотрят.
 */
export type EsignSettingsType = {
  __typename?: 'EsignSettingsType';
  /** Можно создавать и отправлять договоры (ESIGN_ENABLED) */
  enabled: Scalars['Boolean'];
  /** Письмо со ссылкой уходит — подписанту или на тестовый адрес (настроен шаблон) */
  mailEnabled: Scalars['Boolean'];
  /** Письмо уходит НЕ подписанту, а на ESIGN_MAIL_TEST_RECIPIENT (почта выключена) */
  mailRedirected: Scalars['Boolean'];
  /** mailbox (Gmail продавца) | sendgrid (аварийный откат) */
  inviteVia: Scalars['String'];
  /** Сократитель настроен (SHORTLINK_BASE_URL) — есть короткая ссылка договора */
  shortLinksEnabled: Scalars['Boolean'];
};

/** ТЗ 0106: сумма договоров одной валюты (валюты не складываются). */
export type ContractAmountType = {
  __typename?: 'ContractAmountType';
  currency: Scalars['String'];
  amount: Scalars['Float'];
  count: Scalars['Int'];
};

export type ContractDocumentType = {
  __typename?: 'ContractDocumentType';
  id: Scalars['ID'];
  uuid: Scalars['String'];
  kind: Scalars['String'];
  number: Scalars['String'];
  status: Scalars['String'];
  fulfilmentStatus: Scalars['String'];
  fulfilmentError?: Maybe<Scalars['GenericScalar']>;
  fulfilmentCandidates: Array<FulfilmentCandidateType>;
  cancelConflict: Scalars['Boolean'];
  /** Шаблон содержит заготовку юридического текста — отправка заблокирована до его переноса. */
  textPending: Scalars['Boolean'];
  signerFirstName: Scalars['String'];
  signerLastName: Scalars['String'];
  signerEmail: Scalars['String'];
  signerPhone?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  paymentPlan?: Maybe<PaymentPlanType>;
  currency?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  schedule: Array<ContractInstallmentType>;
  /** Только у договора с фирмой (kind=company) */
  company?: Maybe<CompanyContractInfoType>;
  teacherId?: Maybe<Scalars['ID']>;
  applicationId?: Maybe<Scalars['ID']>;
  applicationTitle?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  teacherAgreementId?: Maybe<Scalars['ID']>;
  existingUserId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  createdByName?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  /** Код шаблона — ERP называет шаблон по нему на языке интерфейса; `templateName` — польское юридическое имя */
  templateCode?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  templateAppendix?: Maybe<Scalars['String']>;
  /** Продавец договора (ТЗ 0078) */
  sellerId?: Maybe<Scalars['ID']>;
  sellerName?: Maybe<Scalars['String']>;
  /** ТЗ 0083: кто нажал «Отправить» (может не быть продавцом) */
  sentById?: Maybe<Scalars['ID']>;
  sentByName?: Maybe<Scalars['String']>;
  /** Договор подписан или закрыт — продавец закреплён и не меняется (решение владельца 2026-09-21) */
  sellerLocked: Scalars['Boolean'];
  /** ТЗ 0083: видит и ведёт переписку (письма и SMS подписанту) — продавец договора, аккаунт-менеджеры и Admin */
  canSeeCorrespondence: Scalars['Boolean'];
  /** ТЗ 0083: ведёт договор — отправить и править черновик, повторить письмо, отменить, скопировать ссылку. У договора продаж — продавец, аккаунт-менеджеры, Admin; документы преподавателей — по роли, как раньше */
  canManage: Scalars['Boolean'];
  /** С какого ящика ушло последнее приглашение; пусто — через SendGrid или письма ещё не было */
  emailFrom?: Maybe<Scalars['String']>;
  /** С какого ящика уйдёт приглашение, если отправит СМОТРЯЩИЙ: его рабочая почта или общий запасной ящик (ТЗ 0078, с 0083 — ящик того, кто нажал «Отправить») */
  inviteMailbox?: Maybe<Scalars['String']>;
  /** ТЗ 0083: чей это ящик для смотрящего — personal (его рабочая почта) | shared (общий запасной) */
  inviteMailboxKind?: Maybe<Scalars['String']>;
  /** Почему приглашение смотрящего не уйдёт: no_mailbox | shortlink_disabled (ТЗ 0084: ссылка в письме только короткая) */
  inviteBlockedReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  sentAt?: Maybe<Scalars['DateTime']>;
  emailSentAt?: Maybe<Scalars['DateTime']>;
  emailDeliveredAt?: Maybe<Scalars['DateTime']>;
  emailOpenedAt?: Maybe<Scalars['DateTime']>;
  emailBouncedAt?: Maybe<Scalars['DateTime']>;
  emailSendCount: Scalars['Int'];
  /** Последнее приглашение не ушло — почему; null — ушло или не просили */
  emailError?: Maybe<ContractEmailErrorType>;
  openedAt?: Maybe<Scalars['DateTime']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  rejectedAt?: Maybe<Scalars['DateTime']>;
  rejectionReason?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  cancelReason?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  sendError?: Maybe<Scalars['String']>;
  signerLegalName?: Maybe<Scalars['String']>;
  signerTaxId?: Maybe<Scalars['String']>;
  signerAddress?: Maybe<Scalars['String']>;
  /** PESEL или номер паспорта — вводит подписант (ТЗ 0079) */
  signerPesel?: Maybe<Scalars['String']>;
  /** Лид Kommo (воронка New Leads) */
  crmLeadId?: Maybe<Scalars['ID']>;
  crmLeadUrl?: Maybe<Scalars['String']>;
  /** ТЗ 0090: лид договора в зеркале Kommo (тот же источник). Только ERP и роли экрана «Лиды»; иначе и без лида — null. Запрашивать в карточке, не в списке */
  crmLead?: Maybe<PersonKommoLeadType>;
  /** ТЗ 0120: шанс покупки лида договора из копии Aplora (0…1). Только роли лидов; иначе и без копии — null */
  aploraWinChance?: Maybe<Scalars['Float']>;
  /** ТЗ 0120: клиент согласился (consent.highest_level — commitment или order). Только роли лидов */
  aploraConsent?: Maybe<Scalars['Boolean']>;
  /** ТЗ 0120: следующий контакт по копии Aplora. Только роли лидов */
  aploraNextContactDate?: Maybe<Scalars['Date']>;
  /** ТЗ 0120: not_sent | not_opened | clicked | opened | signed | closed — правило лестницы SMS плюс статус */
  signState: Scalars['String'];
  /** ТЗ 0120: суток по Варшаве до истечения живой ссылки (0 — сегодня); нет живой ссылки — null */
  expiresInDays?: Maybe<Scalars['Int']>;
  requisiteWarnings: Array<Scalars['String']>;
  consents?: Maybe<Scalars['GenericScalar']>;
  /** Документы преподавателя: всё, что он ввёл при подписи (PESEL, NFZ, галочки анкеты…), в порядке шаблона; у договора студента — пусто (ТЗ 0079) */
  signerFields: Array<ContractSignerFieldType>;
  /** Presigned-ссылка на PDF для подписи, 5 минут */
  previewPdfUrl?: Maybe<Scalars['String']>;
  /** Presigned-ссылка на подписанный PDF, 5 минут */
  signedPdfUrl?: Maybe<Scalars['String']>;
  events: Array<ContractEventType>;
};

/**
 * Кандидат при неоднозначном совпадении человека (ТЗ 0076).
 * 
 * Это аккаунты, совпавшие с email/телефоном ПОДПИСАНТА, — контакт продажник
 * уже знает. Email и телефон не отдаём: имя и «учится ли у нас» достаточно,
 * чтобы выбрать, а чужое юрлицо не превращается в справочник.
 */
export type FulfilmentCandidateType = {
  __typename?: 'FulfilmentCandidateType';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Уже учился в юрлице этого договора */
  isStudentHere: Scalars['Boolean'];
};

export type PaymentPlanType = {
  __typename?: 'PaymentPlanType';
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
  installments: Scalars['Int'];
  firstDueKind: Scalars['String'];
  firstDueDays: Scalars['Int'];
  marksStatePrefinanced: Scalars['Boolean'];
  /** Рассрочка банка: студент платит банку столько взносов, школа получает сумму одним платежом (0 — нет) */
  bankInstallments: Scalars['Int'];
};

export type ContractInstallmentType = {
  __typename?: 'ContractInstallmentType';
  n: Scalars['Int'];
  /** Decimal строкой */
  amount: Scalars['String'];
  /** Правило срока по-польски — как в тексте договора */
  rule: Scalars['String'];
  /** Код правила (ТЗ 0078): group_start | day_of_month_first | days_after_signing | day_of_month_next | day_of_month_every | months_after_first — ERP переводит его сам */
  ruleKind?: Maybe<Scalars['String']>;
  /** date / day / days / months */
  ruleParams?: Maybe<Scalars['GenericScalar']>;
};

/**
 * Договор с фирмой (B2B): реквизиты, участники, условия оплаты — из
 * снимка контекста, то есть ровно то, что напечатано в PDF.
 */
export type CompanyContractInfoType = {
  __typename?: 'CompanyContractInfoType';
  name: Scalars['String'];
  taxId: Scalars['String'];
  regon?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  /** prepayment | postpayment */
  paymentModel: Scalars['String'];
  /** customer | funder — на кого фактура при postpłacie */
  invoiceTo: Scalars['String'];
  participants: Array<CompanyParticipantType>;
  /** Decimal строкой */
  pricePerPerson?: Maybe<Scalars['String']>;
  /** Decimal строкой */
  totalPrice?: Maybe<Scalars['String']>;
};

export type CompanyParticipantType = {
  __typename?: 'CompanyParticipantType';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

/** Последнее приглашение не ушло (ТЗ 0078): причина и когда. */
export type ContractEmailErrorType = {
  __typename?: 'ContractEmailErrorType';
  /** mail_disabled | no_mailbox | no_signing_url | no_template_configured | failed */
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  occurredAt: Scalars['DateTime'];
};

/**
 * Поле, которое подписант заполнил в Documenso (ТЗ 0079): подпись —
 * та, что он видел (польская), значение — как ввёл.
 */
export type ContractSignerFieldType = {
  __typename?: 'ContractSignerFieldType';
  /** Ключ хранения поля */
  key: Scalars['String'];
  label: Scalars['String'];
  /** Текст поля; у галочки — null (см. `checked`) */
  value?: Maybe<Scalars['String']>;
  /** Только у галочки */
  checked?: Maybe<Scalars['Boolean']>;
};

export type ContractEventType = {
  __typename?: 'ContractEventType';
  id: Scalars['ID'];
  source: Scalars['String'];
  event: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  actorName?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['GenericScalar']>;
};

export type ContractStatusCountType = {
  __typename?: 'ContractStatusCountType';
  status: Scalars['String'];
  count: Scalars['Int'];
  /** ТЗ 0120: из них с шансом лида ≥ hotMinWinChance (копия Aplora). Не роли лидов — 0 */
  hotCount: Scalars['Int'];
};

/** Цена курса по тарифу (#132). */
export type CoursePlanPriceType = {
  __typename?: 'CoursePlanPriceType';
  id: Scalars['ID'];
  courseId: Scalars['ID'];
  planId: Scalars['ID'];
  planName: Scalars['String'];
  planIsActive: Scalars['Boolean'];
  currency: Scalars['String'];
  /** Decimal строкой */
  amount: Scalars['String'];
};

/** Сотрудник как продавец договоров — для фильтра и смены продавца. */
export type ContractSellerType = {
  __typename?: 'ContractSellerType';
  id: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
};

/**
 * Группа видимых договоров — вариант фильтра «Группа» списка договоров.
 * Свой источник, а не `allGroups`: список читает и FinanceManager, а
 * `allGroups` ему закрыт (ошибка прав на каждой загрузке страницы).
 */
export type ContractGroupOptionType = {
  __typename?: 'ContractGroupOptionType';
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  courseName: Scalars['String'];
};

export type ContractDraftDefaultsType = {
  __typename?: 'ContractDraftDefaultsType';
  listPrice?: Maybe<Scalars['String']>;
  /** Откуда цена прайса (#132): plan — цена курса для тарифа, group — прайс группы, null — цены нет */
  listPriceSource?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  schedule: Array<ContractInstallmentType>;
  nextNumberPreview?: Maybe<Scalars['String']>;
  matchedUserId?: Maybe<Scalars['ID']>;
  matchedUserName?: Maybe<Scalars['String']>;
  warnings: Array<Scalars['String']>;
};

/**
 * Счётчик колокольчика. Его и опрашивает клиент раз в минуту.
 * 
 * Отдельно от ленты, потому что тянуть список в каждом опросе дорого, а
 * расходиться с ним нельзя: обе выборки строит одна функция с одинаковыми
 * аргументами (`services/feed.py::scoped_notifications`), и `unreadCount`
 * приходит ТАКЖЕ в ответе ленты — то есть в момент открытия попапа число и
 * список взяты из одного запроса.
 */
export type StaffNotificationsSummaryType = {
  __typename?: 'StaffNotificationsSummaryType';
  unreadCount: Scalars['Int'];
  /** Capped at 1000: an exact COUNT would be paid on every poll for a number nobody reads. */
  totalCount: Scalars['Int'];
  latestId?: Maybe<Scalars['ID']>;
  latestCreatedAt?: Maybe<Scalars['DateTime']>;
  soundAlarm: SoundAlarmType;
  /** How often the client should poll. The SERVER dictates the pace so it can be raised by a setting instead of a frontend release. */
  pollSeconds: Scalars['Int'];
};

/**
 * Из-за чего звенит браузер.
 * 
 * Предикат («моя открытая задача со сроком сегодня или раньше», любой
 * приоритет — ТЗ 0109) живёт ТОЛЬКО на
 * сервере: копия на клиенте была бы вторым определением того же правила и
 * неизбежно разошлась бы с этим.
 */
export type SoundAlarmType = {
  __typename?: 'SoundAlarmType';
  active: Scalars['Boolean'];
  taskId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type StaffNotificationPageType = {
  __typename?: 'StaffNotificationPageType';
  edges: Array<StaffNotificationEdgeType>;
  hasNextPage: Scalars['Boolean'];
  endCursor?: Maybe<Scalars['String']>;
  unreadCount: Scalars['Int'];
};

export type StaffNotificationEdgeType = {
  __typename?: 'StaffNotificationEdgeType';
  cursor: Scalars['String'];
  node: StaffNotificationType;
};

export type StaffNotificationType = {
  __typename?: 'StaffNotificationType';
  id: Scalars['ID'];
  /** Kind key from the server-side registry. Deliberately a String, not an Enum: kinds are added without a migration and an Enum would make every addition a breaking schema change for the clients. */
  kind: Scalars['String'];
  title: Scalars['String'];
  body: Scalars['String'];
  taskId: Scalars['ID'];
  priority: Scalars['String'];
  dueDate?: Maybe<Scalars['Date']>;
  /** Who triggered it. NULL means the robot did. */
  actorName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** NULL means unread. A timestamp, not a flag: «read at 12:40» answers the question a reader actually has. */
  readAt?: Maybe<Scalars['DateTime']>;
};

export type StaffNotificationSettingsType = {
  __typename?: 'StaffNotificationSettingsType';
  enabledKinds: Array<Scalars['String']>;
  availableKinds: Array<StaffNotificationKindType>;
  soundEnabled: Scalars['Boolean'];
  pollSeconds: Scalars['Int'];
  repeatAfterMinutes: Scalars['Int'];
  quietFrom?: Maybe<Scalars['Time']>;
  quietTo?: Maybe<Scalars['Time']>;
  telegramEnabled: Scalars['Boolean'];
  telegramLinked: Scalars['Boolean'];
  telegramUsername: Scalars['String'];
  telegramLinkedAt?: Maybe<Scalars['DateTime']>;
  /** Set when the person blocked the bot. Shown in the UI: otherwise they believe they are subscribed while the channel is silently dead. */
  telegramBlockedAt?: Maybe<Scalars['DateTime']>;
  /** False when the bot is not configured server-side — the UI must say so instead of offering a dead button. */
  telegramAvailable: Scalars['Boolean'];
  robotRules: Array<Scalars['String']>;
  availableRobotRules: Array<StaffRobotRuleType>;
};

export type StaffNotificationKindType = {
  __typename?: 'StaffNotificationKindType';
  key: Scalars['String'];
  label: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type StaffRobotRuleType = {
  __typename?: 'StaffRobotRuleType';
  key: Scalars['String'];
  label: Scalars['String'];
  /** Whether I am subscribed to this rule. */
  enabled: Scalars['Boolean'];
  /** Whether the rule is switched on server-side at all. Subscribing to a rule nobody runs must not look like a working setting. */
  available: Scalars['Boolean'];
};

export type FundingOperatorType = {
  __typename?: 'FundingOperatorType';
  id: Scalars['ID'];
  name: Scalars['String'];
  programType: Scalars['String'];
  programName?: Maybe<Scalars['String']>;
  /** Nr projektu (FEDS.07.04-IP.02-0004/23). С него начинается ID wsparcia участников; хранится нормализованным (без лишних пробелов, заглавными). Пустая строка — номер не внесён. */
  projectNumber?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  voivodeship?: Maybe<VoivodeshipType>;
  coverageScope: Scalars['String'];
  powiats: Array<PowiatType>;
  /** Строки покрытия есть, но ни одна не разобрана — такой оператор не подберётся никому. */
  coverageIncomplete: Scalars['Boolean'];
  /** Отдельная ссылка оператора — раньше молча терялась. */
  operatorInstructionUrl?: Maybe<Scalars['String']>;
  /** Строки покрытия, которые не удалось сопоставить со справочником — видны, чтобы пробел не был тихим. */
  powiatsUnresolved: Array<Scalars['String']>;
  acceptsUnemployed: Scalars['Boolean'];
  acceptsEmployerApplications: Scalars['Boolean'];
  supportsDisabled: Scalars['Boolean'];
  supportsAge50Plus: Scalars['Boolean'];
  greenCompetences: Scalars['Boolean'];
  rollingIntake: Scalars['Boolean'];
  servedStatuses: Array<Scalars['String']>;
  maxAmount?: Maybe<Scalars['Float']>;
  maxAmountCurrency?: Maybe<Scalars['String']>;
  ownContributionPercent?: Maybe<Scalars['Float']>;
  paymentMethod?: Maybe<Scalars['String']>;
  decisionDays?: Maybe<Scalars['Int']>;
  implementationStart?: Maybe<Scalars['Date']>;
  implementationEnd?: Maybe<Scalars['Date']>;
  /** Инструкция, которая уходит студенту по почте. */
  instructionUrl?: Maybe<Scalars['String']>;
  instructionReady: Scalars['Boolean'];
  projectUrl?: Maybe<Scalars['String']>;
  /** Страница «aktualności» — за ней следит робот. */
  newsUrl?: Maybe<Scalars['String']>;
  /** Лента RSS/Atom страницы новостей (#129а): найдена роботом (`<link rel=alternate>` или `/feed/` WordPress) или вписана человеком. Пустая строка — ленты нет / ещё не найдена. Новая запись в ленте — причина `feed`. */
  feedUrl?: Maybe<Scalars['String']>;
  documentsUrl?: Maybe<Scalars['String']>;
  documentsNote?: Maybe<Scalars['String']>;
  /** Что робот видит на странице: changed | quiet | never. Три значения и один вопрос — «обновилась или нет, и когда проверяли». Поломки слежения сюда НЕ попадают: у оператора без единой удачной проверки это `never`, а почему именно — знает журнал прогонов. Считается сервером, чтобы фильтр, счётчик и подпись в строке не разошлись. */
  pageState?: Maybe<Scalars['String']>;
  /** Что появилось и что исчезло на странице с тех пор, как человек её разбирал. Считается на чтение из двух подписей — хранимый диф пришлось бы кому-то склеивать. */
  pageDiff?: Maybe<PageDiffType>;
  /** Адрес слежения выглядит не страницей новостей: search / analytics / epoch / homepage. Пусто — вопросов нет. Робот такое НЕ чинит: правильный листинг не угадывается, адрес меняет человек. */
  urlSuspect?: Maybe<Scalars['String']>;
  /** Сколько ссылок робот нашёл при последней проверке. Ноль означает, что фингерпринтить нечего: страница открылась, но робот на ней слеп. */
  pageLinksCount?: Maybe<Scalars['Int']>;
  pageChanged: Scalars['Boolean'];
  pageChangedAt?: Maybe<Scalars['DateTime']>;
  /** Есть ли подпись по тексту. Отдаём признак, а не хэш: наружу нужен ответ «следим ли», а не сами байты. */
  pageTextWatched: Scalars['Boolean'];
  /** Чем замечено изменение: `feed` — новая запись в ленте RSS/Atom (старший сигнал, #129а), `links` — сдвинулся список ссылок, `text` — только текст страницы (слабый). `pageDiff` показывает разницу того слоя, что назван здесь. */
  pageChangedReason?: Maybe<Scalars['String']>;
  /** Когда робот последний раз ПОШЁЛ на страницу — ставится и при ошибке. «Проверено» на экране — это `pageCheckedOkAt`. */
  pageHashCheckedAt?: Maybe<Scalars['DateTime']>;
  /** Когда робот последний раз ПРОЧИТАЛ страницу (#129а). Не двигается при ошибке захода, в отличие от `pageHashCheckedAt`. Пусто — удачной проверки не было. */
  pageCheckedOkAt?: Maybe<Scalars['DateTime']>;
  automationStatus: Scalars['String'];
  /** Почему последняя проверка страницы не удалась — или (`[FEED_…]`) почему у слепой страницы не прочиталась заданная лента. Пусто — удалась. */
  automationError?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  /** Есть ли у оператора подтверждённое живое окно — то есть пишет ли робот его кандидатам. Разрешение живёт на самом наборе (`FundingIntakeType.confirmedAt`); здесь только сводка для строки списка. */
  hasConfirmedIntake?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
  intakes: Array<FundingIntakeType>;
  /** С кем работает оператор: `b2b` (заявку подаёт работодатель) или `b2c` (человек подаёт сам). Считает СЕРВЕР из колонки Notion `Dla pracodawcy`, чтобы фильтр и подпись в строке не разошлись. У KFS всегда `b2b` — это свойство инструмента, а не оператора. */
  clientType?: Maybe<Scalars['String']>;
  /** Период набора: `running` / `soon` / `rolling` / `none`. */
  intakePeriod?: Maybe<Scalars['String']>;
  /** В названии стоит FIRMY/przedsiębiorstwa. ⚠️ Значение `clientType` этим НЕ переопределяется — владелец выбрал колонку источника. Но у шести операторов название и галка расходятся, и такую строку стоит поправить руками. */
  nameSaysB2b: Scalars['Boolean'];
  /** «Ближайший набор» — одно правило на сервере (#129б), по той же фазе, что `FundingIntakeType.phase`: идущее окно (из нескольких — последнее стартовавшее; бессрочное — не дольше 30 дней от старта); иначе самое РАННЕЕ из будущих; иначе давно идущее бессрочное; иначе окно-черновик без даты. Закрытое (статусом или по датам/часу) и отменённое — никогда; нет подходящего — null. Считается по префетченным окнам, без запросов. */
  currentIntake?: Maybe<FundingIntakeType>;
  candidatesCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type VoivodeshipType = {
  __typename?: 'VoivodeshipType';
  id: Scalars['ID'];
  code: Scalars['String'];
  slug: Scalars['String'];
  name: Scalars['String'];
};

export type PowiatType = {
  __typename?: 'PowiatType';
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
  kind: Scalars['String'];
  voivodeshipId?: Maybe<Scalars['ID']>;
  voivodeshipName?: Maybe<Scalars['String']>;
  /** Чем строка совпала с запросом, если совпала НЕ именем: гминой, прежним названием или упразднённым. Без этого `karkonoski` в ответ на «kow» (гмина Kowary) выглядит ошибкой поиска. Заполняется только при поиске. */
  matchedAlias?: Maybe<Scalars['String']>;
};

/**
 * Разница между тем, что на странице сейчас, и тем, что видел человек.
 * 
 * Списки обрезаны, числа — нет: у оператора с месячным архивом в подписи
 * сотня строк, и вываливать её в карточку бессмысленно, а «появилось 174»
 * говорит о масштабе честнее любого списка.
 */
export type PageDiffType = {
  __typename?: 'PageDiffType';
  /** Есть ли с чем сравнивать. `false` — изменение заметили до того, как робот начал сохранять подпись. */
  comparable: Scalars['Boolean'];
  added: Array<Scalars['String']>;
  removed: Array<Scalars['String']>;
  addedTotal: Scalars['Int'];
  removedTotal: Scalars['Int'];
};

export type FundingIntakeType = {
  __typename?: 'FundingIntakeType';
  id: Scalars['ID'];
  operatorId: Scalars['ID'];
  operatorName?: Maybe<Scalars['String']>;
  operatorProgramType?: Maybe<Scalars['String']>;
  /** С кем работает оператор набора: b2b | b2c. Третьим рядом с именем и программой — признак показывается ВЕЗДЕ, где оператора называют, а не только там, где его выбирают (ТЗ 0053). */
  operatorClientType?: Maybe<Scalars['String']>;
  candidatesCount: Scalars['Int'];
  waitingCandidatesCount: Scalars['Int'];
  startsOn?: Maybe<Scalars['Date']>;
  endsOn?: Maybe<Scalars['Date']>;
  /** Час открытия набора по Варшаве, если оператор его назвал. Уточняет дату (#121): до этого часа в день старта окно ещё не открылось — так считают `phase`, `daysLeft`, живость окна и письма. Ограничение «один набор на дату», фильтры по датам и подстановки в письмах — по голой дате. */
  startsAtTime?: Maybe<Scalars['Time']>;
  /** Час закрытия набора по Варшаве, если оператор его назвал: с этого часа в последний день окно закрыто (`phase`, письма, ночное закрытие). 00:00 — это конец ДНЯ («do północy»), а не его начало: окно живо до конца своего последнего дня. */
  endsAtTime?: Maybe<Scalars['Time']>;
  announcedAt?: Maybe<Scalars['Date']>;
  status: Scalars['String'];
  /** Что видно в колонке «Состояние»: upcoming | running | ended | cancelled | unknown. Считается на сервере — тем же выражением, что и фильтр, иначе колонка и фильтр отвечали бы на разные вопросы. Порядок: отменён → закрыт статусом (вручную «Закрыт» или ночной задачей) = ended → нет даты = unknown → ещё не открылся (старт позже сегодня или сегодня до часа старта) → закрылся (конец раньше сегодня или сегодня после часа конца) → идёт. «Сегодня» и час — по Варшаве. */
  phase?: Maybe<Scalars['String']>;
  /** Сколько дней осталось до конца (у идущего) или до открытия (у будущего); 0 — сегодня. Пусто — у бессрочного окна (конца нет), а также у закрывшегося, отменённого и закрытого: фаза та же, что у `phase`. */
  daysLeft?: Maybe<Scalars['Int']>;
  sourceUrl?: Maybe<Scalars['String']>;
  /** Что уже сделала рассылка по ЭТОМУ окну: сколько ушло, сколько отбито дедупликацией, сколько с ошибкой, и когда уйдёт следующее письмо. Одним полем, а не тремя запросами `fundingNotificationsTotal` со статусами: три отдельных счётчика к одному вопросу — это три запроса и три места, где можно забыть фильтр. */
  mail: IntakeMailType;
  /** Когда человек подтвердил набор. Заполнено — робот рассылает по этому окну; пусто — молчит, сколько бы лет окно ни висело. Единственное разрешение на рассылку в домене (ТЗ 0054). */
  confirmedAt?: Maybe<Scalars['DateTime']>;
  /** Кто подтвердил. Имя, а не id: экран показывает его человеку, а карточки пользователя отсюда не открывают. */
  confirmedByName?: Maybe<Scalars['String']>;
  notifiedAt?: Maybe<Scalars['DateTime']>;
  notifiedCount: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  /**
   * Когда уйдёт ПЕРВОЕ письмо по этому окну, или пусто, если не уйдёт. То же правило, что у `mail.firstPlannedOn`, — считает одна функция.
   * 
   * Отдельным полем, потому что список окон спрашивает только дату: сводка целиком стоит двух запросов на окно, а на странице их пятьдесят.
   */
  firstPlannedOn?: Maybe<Scalars['Date']>;
};

/**
 * Что рассылка уже сделала по одному окну набора (спека 0055).
 * 
 * ⚠️ `pending` здесь НЕ «в очереди на отправку». Очереди у домена нет:
 * задача пишет строку и тут же пытается отправить. `pending` означает, что
 * попытка не завершилась — процесс умер между записью и отправкой.
 */
export type IntakeMailType = {
  __typename?: 'IntakeMailType';
  sent: Scalars['Int'];
  failed: Scalars['Int'];
  pending: Scalars['Int'];
  waiting: Scalars['Int'];
  /** Когда уйдёт ПЕРВОЕ письмо: за семь дней до открытия. Пусто — если окно не подтверждено, уже началось или закрыто: рассылать по нему нечего или уже поздно. */
  firstPlannedOn?: Maybe<Scalars['Date']>;
  /** Ближайший запуск задачи рассылки. Считается из расписания beat, а не из данных: «письмо запланировано» без времени читается как «когда-нибудь». */
  nextRunAt?: Maybe<Scalars['DateTime']>;
};

/**
 * One person in the funnel — one row, per the owner's decision.
 * 
 * `events` is what makes that shape survivable: an operator change or a
 * status move is recorded there, so "BUR refused, we moved to KFS" stays
 * reconstructable even though the current state is single-valued.
 */
export type FundingCandidateType = {
  __typename?: 'FundingCandidateType';
  id: Scalars['ID'];
  /** ТЗ 0086: лиды Kommo — тот же человек (хранимая связь). Видят продавцы (роли экрана «Лиды»); остальным — пусто. */
  kommoLeads: Array<PersonKommoLeadType>;
  fullName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  voivodeship?: Maybe<VoivodeshipType>;
  powiat?: Maybe<PowiatType>;
  powiatRaw?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  employerVoivodeship?: Maybe<VoivodeshipType>;
  employerPowiat?: Maybe<PowiatType>;
  employerName?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<Scalars['String']>;
  isUnemployed?: Maybe<Scalars['Boolean']>;
  isAdult?: Maybe<Scalars['Boolean']>;
  is50Plus?: Maybe<Scalars['Boolean']>;
  /** Есть работодатель — значит KFS в принципе применим. */
  hasEmployer: Scalars['Boolean'];
  /** ТЗ 0108 (#141): на чём основан подбор KFS — employer | residence_fallback (работодатель не указан, подобрано по месту жительства) | unknown | not_applicable */
  kfsGeoBasis: Scalars['String'];
  hasDisabilityCertificate?: Maybe<Scalars['Boolean']>;
  inFinancialHardship?: Maybe<Scalars['Boolean']>;
  usedFundingBefore?: Maybe<Scalars['Boolean']>;
  employerCanApply?: Maybe<Scalars['Boolean']>;
  jdgSuspended?: Maybe<Scalars['Boolean']>;
  employerSameVoivodeship?: Maybe<Scalars['String']>;
  preferredTracks: Array<Scalars['String']>;
  status: Scalars['String'];
  statusChangedAt: Scalars['DateTime'];
  outcome?: Maybe<Scalars['String']>;
  declineReason?: Maybe<Scalars['String']>;
  /** Пометка «ведущий оператор». С ТЗ 0067 она никого не глушит и может быть пустой у человека с работающими операторами — аудиторию рассылок задают активные связи. */
  primaryOperator?: Maybe<FundingOperatorType>;
  /** АКТИВНЫЕ операторы кандидата: человеку идут письма о наборах у КАЖДОГО из них. Несколько — норма, а не повод для разбора. */
  operators: Array<FundingOperatorType>;
  /** Все связи, включая выключенные, — журнал «кого рассматривали» с причинами. */
  operatorLinks: Array<CandidateOperatorLinkType>;
  activeOperatorsCount: Scalars['Int'];
  disabledOperatorsCount: Scalars['Int'];
  intake?: Maybe<FundingIntakeType>;
  appliedAt?: Maybe<Scalars['Date']>;
  decisionAt?: Maybe<Scalars['Date']>;
  approvedAmount?: Maybe<Scalars['Float']>;
  ownContributionAmount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  /** ID wsparcia (FEDS.07.04-IP.02-0004/23_121/7.4B/2026/USZ). Часть до первого «_» — номер проекта оператора; хранится нормализованным. Пустая строка — не внесён. */
  supportId?: Maybe<Scalars['String']>;
  isDeposit: Scalars['Boolean'];
  testDrive: Scalars['Boolean'];
  reminderAt?: Maybe<Scalars['DateTime']>;
  taskNote?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  desiredStartMonth?: Maybe<Scalars['Date']>;
  assignedToName?: Maybe<Scalars['String']>;
  assignedToId?: Maybe<Scalars['ID']>;
  /** Отметка «повышенное внимание»: перед стартом окна набора робот заводит задачу проконтролировать человека. Ставится `setFundingCandidateAttention`. */
  needsAttention: Scalars['Boolean'];
  /** Заметка к отметке (до 300 символов); пусто, когда отметки нет. */
  attentionNote?: Maybe<Scalars['String']>;
  /** Кто последним ставил или снимал отметку. */
  attentionSetByName?: Maybe<Scalars['String']>;
  /** Когда отметку последний раз ставили или снимали. */
  attentionSetAt?: Maybe<Scalars['DateTime']>;
  /** Ближайший старт среди ЖИВЫХ окон АКТИВНЫХ операторов кандидата (не `intake` — тот называет окно последнего письма). Будущее окно выигрывает у идущего; идущее — только если будущих нет. Пусто: живых окон нет или операторы с постоянным набором. */
  nextIntake?: Maybe<FundingIntakeType>;
  /** Задача, заведённая роботом «повышенного внимания» по последнему окну (id `StaffTask`); пусто — не заводилась или удалена. */
  attentionTaskId?: Maybe<Scalars['ID']>;
  matchStatus: Scalars['String'];
  matchRule: Scalars['String'];
  userLocked: Scalars['Boolean'];
  linkedUserId?: Maybe<Scalars['ID']>;
  linkedUserName?: Maybe<Scalars['String']>;
  linkedUserEmail?: Maybe<Scalars['String']>;
  /** Кандидат уже учится у нас. Считается на лету — студентов заводят четыре независимых пути, и сохранённый флаг протух бы на первом же из них. */
  isStudent: Scalars['Boolean'];
  studentId?: Maybe<Scalars['ID']>;
  agreementTitle?: Maybe<Scalars['String']>;
  /** ТЗ 0111 (#151): другие ОТКРЫТЫЕ заявки того же человека (та же почта или телефон), без этой. Считается на лету, запросом на кандидата — для карточки, не для списка. */
  duplicateCandidates: Array<DuplicateCandidateType>;
  source: Scalars['String'];
  isArchived: Scalars['Boolean'];
  legalEntityName?: Maybe<Scalars['String']>;
  events: Array<CandidateEventType>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

/**
 * Одна связь «кандидат ↔ оператор» (ТЗ 0067).
 * 
 * Активные — это те, по кому человеку идут письма о наборах; выключенные
 * остаются в журнале вместе с причиной, автором и датой. Экран обязан
 * показывать и те, и другие: «почему мы больше не ходим к этому оператору»
 * — вопрос, на который карточка должна отвечать без похода в журнал.
 */
export type CandidateOperatorLinkType = {
  __typename?: 'CandidateOperatorLinkType';
  id: Scalars['ID'];
  operator: FundingOperatorType;
  isActive: Scalars['Boolean'];
  /** Пометка «ведущий». НИКОГО не глушит: письма идут по всем активным операторам. */
  isPrimary: Scalars['Boolean'];
  /** auto | manual | import */
  source: Scalars['String'];
  addedAt: Scalars['DateTime'];
  addedByName?: Maybe<Scalars['String']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  deactivatedByName?: Maybe<Scalars['String']>;
  /** operator_declined | person_declined | signed_elsewhere | transferred | other */
  deactivationReason?: Maybe<Scalars['String']>;
  /** Причина по-русски — отдельного справочника причин на фронте держать не нужно. */
  deactivationReasonLabel?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

/** ТЗ 0111 (#151): другая открытая заявка того же человека. */
export type DuplicateCandidateType = {
  __typename?: 'DuplicateCandidateType';
  id: Scalars['ID'];
  fullName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  createdAt: Scalars['DateTime'];
};

export type CandidateEventType = {
  __typename?: 'CandidateEventType';
  id: Scalars['ID'];
  fromStatus?: Maybe<Scalars['String']>;
  toStatus: Scalars['String'];
  /** Оператор «был» — id для ссылки на карточку (#128). */
  fromOperatorId?: Maybe<Scalars['ID']>;
  fromOperatorName?: Maybe<Scalars['String']>;
  /** Оператор «стал» — id для ссылки на карточку (#128). */
  toOperatorId?: Maybe<Scalars['ID']>;
  toOperatorName?: Maybe<Scalars['String']>;
  changedByName?: Maybe<Scalars['String']>;
  changedAt: Scalars['DateTime'];
  note?: Maybe<Scalars['String']>;
};

/** Column counts for the funnel board, plus the two review queues. */
export type FundingBoardType = {
  __typename?: 'FundingBoardType';
  groups: Array<StatusGroupType>;
  /** Второй вид доски (ТЗ 0058): те же 15 статусов, сгруппированные в 4 категории владельца — новая заявка / в работе / успех / выбыл. */
  stages: Array<StatusGroupType>;
  buckets: Array<StatusBucketType>;
  total: Scalars['Int'];
  ambiguousMatches: Scalars['Int'];
  /** ТЗ 0111 (#151): открытые заявки, у которых при приёме нашлись другие живые заявки того же человека — очередь на разбор (архивировать лишние). Глобальная, без фильтров; список — `fundingCandidates(hasDuplicates: true)`. */
  duplicateSubmissions: Scalars['Int'];
  unresolvedPlaces: Scalars['Int'];
  depositWaiting: Scalars['Int'];
  operatorsWithoutCoverage: Scalars['Int'];
  /** Сколько операторов ждут, чтобы человек посмотрел изменившуюся страницу. */
  pageChangedOperators: Scalars['Int'];
  /** Сколько адресов слежения выглядят не страницей новостей. Очередь на разбор человеком — как неразобранная география: робот только называет подозрение, адрес меняет человек. */
  suspiciousUrls: Scalars['Int'];
  /**
   * Кандидаты без оператора — вся очередь подбора целиком.
   * 
   * 🔴 Заменило пару `operatorNone` / `operatorSeveral`. Оба считались по M2M `candidate.operators` — журналу «кого рассматривали», который заполняют импорт из Notion и ручное назначение. Правила подбора живут в `candidates.operators_for` и в этот журнал не пишут никогда: на 200 свежих кандидатах два числа не совпали НИ РАЗУ. Хуже всего было у «не подошёл никто»: по правилам из 136 кандидатов без оператора пустой список не получается НИ У КОГО (медиана 6), то есть очередь называла самым тяжёлым случаем то, чего не существует.
   */
  operatorMissing: Scalars['Int'];
  /** Заявки с публичной формы, разобранные, но без назначенного оператора. Это работа, а не готовое. */
  submissionsNeedOperator: Scalars['Int'];
  /** Кого ведёт робот «повышенного внимания»: отметка стоит, статус открытый, не в архиве. Равный счётчику список — `fundingCandidates(needsAttention: true, statusGroup: "open")`; просто `needsAttention: true` шире — там и закрытые. */
  needsAttention: Scalars['Int'];
};

export type StatusGroupType = {
  __typename?: 'StatusGroupType';
  key: Scalars['String'];
  title: Scalars['String'];
  statuses: Array<Scalars['String']>;
  count: Scalars['Int'];
};

export type StatusBucketType = {
  __typename?: 'StatusBucketType';
  status: Scalars['String'];
  count: Scalars['Int'];
};

/** A raw place string awaiting (or holding) a human decision. */
export type GeoAliasType = {
  __typename?: 'GeoAliasType';
  id: Scalars['ID'];
  rawValue: Scalars['String'];
  normalized?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  hits: Scalars['Int'];
  powiat?: Maybe<PowiatType>;
  voivodeship?: Maybe<VoivodeshipType>;
  contextVoivodeship?: Maybe<VoivodeshipType>;
  wholeVoivodeship: Scalars['Boolean'];
  suggestedPowiat?: Maybe<PowiatType>;
  suggestionScore?: Maybe<Scalars['Float']>;
  candidatePowiats: Array<PowiatType>;
  note?: Maybe<Scalars['String']>;
};

export type ImportRunType = {
  __typename?: 'ImportRunType';
  id: Scalars['ID'];
  taskName: Scalars['String'];
  /** beat | cli | erp — по расписанию, из терминала или кнопкой в ERP. */
  triggerSource: Scalars['String'];
  /** Кто запустил. Пусто у прогонов по расписанию и у запусков из терминала — там пользователя нет. */
  startedByName?: Maybe<Scalars['String']>;
  dryRun: Scalars['Boolean'];
  status: Scalars['String'];
  startedAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  durationSeconds?: Maybe<Scalars['Float']>;
  stats?: Maybe<Scalars['JSONString']>;
  errorMessage?: Maybe<Scalars['String']>;
  /** Когда снята выгрузка, которую разложил прогон. */
  sourceExportedAt?: Maybe<Scalars['DateTime']>;
};

/** Строка сводки «ходит ли робот»: одна задача, её последний прогон. */
export type TaskSummaryType = {
  __typename?: 'TaskSummaryType';
  /** Короткое имя: watch | match | … */
  task: Scalars['String'];
  /** Полное имя, оно же ключ в журнале. */
  taskName: Scalars['String'];
  /** Ходит ли по расписанию. Все три флага по умолчанию выключены, и без этого «последний прогон вчера» читается как поломка, хотя задача просто не включена. */
  scheduled: Scalars['Boolean'];
  /** Имя переменной окружения — чтобы человек знал, что именно включать. */
  scheduleFlag: Scalars['String'];
  lastRun?: Maybe<ImportRunType>;
};

/**
 * Состояние синхронизации из Notion — для кнопки в шапке (ТЗ 0087).
 * 
 * Всё, что кнопке нужно знать ДО нажатия: можно ли вообще идти в Notion,
 * идёт ли уже прогон, ходит ли расписание, и чем кончился последний раз.
 */
export type NotionSyncStatusType = {
  __typename?: 'NotionSyncStatusType';
  /** Задан ли на сервере ключ Notion. Нет — кнопке некуда идти, и экран говорит это вместо кнопки. */
  keyConfigured: Scalars['Boolean'];
  /** Окружение не ходит в настоящий Notion (ноутбук без разрешения) — чтобы не принести в локальную базу настоящие e-mail и телефоны. */
  liveBlocked: Scalars['Boolean'];
  /** Ходит ли синхронизация сама раз в час. С 07.10.2026 всегда false: расписание и ключ сняты. */
  autoEnabled: Scalars['Boolean'];
  /** Прогон идёт прямо сейчас. */
  isRunning: Scalars['Boolean'];
  /** Включённые флаги робота рассылок ERP. Непусто — ручной прогон пишет (ERP предупреждает: выключите рассылки N8N, иначе письма уйдут дважды), плановый — пропускается. */
  robotMailFlags: Array<Scalars['String']>;
  /** Последний прогон — любой: сухой, упавший, пропущенный. */
  lastRun?: Maybe<ImportRunType>;
  /** Последний УСПЕШНЫЙ прогон с записью — «когда данные действительно забраны». */
  lastSuccess?: Maybe<ImportRunType>;
};

/**
 * Строка сводки «что мешает роботу следить» (ТЗ 0054).
 * 
 * 🔴 Живёт в журнале прогонов, а НЕ в реестре операторов. Владелец: «никаких
 * ошибок в интерфейсе видеть не хочу» — поломки убраны с экрана менеджера,
 * но не из системы: без них четырнадцать операторов из ста двадцати семи
 * выглядели бы спокойными, хотя робот к ним не ходит вовсе.
 */
export type WatchHealthType = {
  __typename?: 'WatchHealthType';
  /** Чинится по-разному, поэтому причины разные: no_url (адрес не задан) / error (последний заход не удался) / blind (страница открылась, но следить не за чем) / never (адрес есть, робот ни разу не дошёл) / url_suspect (адрес похож не на страницу новостей) / stale (страница читается, но не менялась 45 дней — проверьте адрес; #129а). */
  problem: Scalars['String'];
  count: Scalars['Int'];
  /** Имена операторов — строку читают глазами. Не больше 50. Те же операторы в том же порядке, что `operatorRefs`. */
  operators: Array<Scalars['String']>;
  /** Те же операторы парами «id + имя» (#128): имя открывает карточку оператора. Не больше 50. */
  operatorRefs: Array<FundingOperatorRefType>;
};

/**
 * Оператор одной парой «id + имя» (#128): там, где экран называет
 * оператора, имя теперь открывает его карточку, а не просто текст.
 * 
 * Лёгкая пара, а не `FundingOperatorType`: ссылке нужны два поля, а не
 * подписи страниц и окна.
 */
export type FundingOperatorRefType = {
  __typename?: 'FundingOperatorRefType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**
 * Одно письмо робота — то, что менеджер видит в карточке кандидата.
 * 
 * ТЗ 0085: наружу отданы шаблон, правило, переменные «как ушли» и ключ
 * дедупликации — владелец спросил «как быть уверенным, что мы всё
 * правильно настроили», и ответ на это — видеть, ЧТО именно ушло.
 */
export type FundingNotificationType = {
  __typename?: 'FundingNotificationType';
  id: Scalars['ID'];
  kind: Scalars['String'];
  status: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  operatorId?: Maybe<Scalars['ID']>;
  operatorName?: Maybe<Scalars['String']>;
  /** С кем работает оператор письма: b2b | b2c (ТЗ 0053). */
  operatorClientType?: Maybe<Scalars['String']>;
  intakeId?: Maybe<Scalars['ID']>;
  intakeStartsOn?: Maybe<Scalars['Date']>;
  intakeEndsOn?: Maybe<Scalars['Date']>;
  templateId?: Maybe<Scalars['String']>;
  /** Имя шаблона SendGrid в момент отправки (снимок). */
  templateName?: Maybe<Scalars['String']>;
  /** Правило письма; пусто — правило удалено. */
  ruleId?: Maybe<Scalars['ID']>;
  /** «За N дней»: срок правила сейчас. */
  ruleOffsetDays?: Maybe<Scalars['Int']>;
  ruleEveryDays?: Maybe<Scalars['Int']>;
  /** Переменные шаблона: у отправленного — как ушли (ссылки короткие), у ждущего — как будут. */
  dynamicData?: Maybe<Scalars['JSONString']>;
  /** Ключ повода: второй раз по нему письмо не уйдёт. */
  dedupKey?: Maybe<Scalars['String']>;
  sgMessageId?: Maybe<Scalars['String']>;
  /** Прогон робота, отправивший письмо. */
  runId?: Maybe<Scalars['ID']>;
  candidateId: Scalars['ID'];
  candidateName?: Maybe<Scalars['String']>;
  deliveredAt?: Maybe<Scalars['DateTime']>;
  firstOpenedAt?: Maybe<Scalars['DateTime']>;
  openCount: Scalars['Int'];
  bouncedAt?: Maybe<Scalars['DateTime']>;
  bounceReason?: Maybe<Scalars['String']>;
  droppedAt?: Maybe<Scalars['DateTime']>;
  dropReason?: Maybe<Scalars['String']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  /** Итог доставки одним словом: bounced | dropped | unsubscribed | opened | delivered | sent | pending | failed. */
  deliveryState: Scalars['String'];
};

/**
 * Заявка с публичной формы — сырое, что пришло, и что с ним стало.
 * 
 * До ТЗ 0046 у этой таблицы не было ни типа, ни запроса: она жила только в
 * Django-админке, где нет даже фильтра «не разобрано». Триаж идёт в
 * try/except, и упавшая заявка оставалась с пустым `processed_at` и текстом
 * ошибки, которого никто никогда не видел.
 * 
 * `payload` наружу НЕ отдаём: это сырой ввод анонимного человека, и место
 * ему в карточке кандидата, куда триаж его уже разложил, а не в списке.
 */
export type FormSubmissionType = {
  __typename?: 'FormSubmissionType';
  id: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  submittedAt: Scalars['DateTime'];
  processedAt?: Maybe<Scalars['DateTime']>;
  processError?: Maybe<Scalars['String']>;
  candidateId?: Maybe<Scalars['ID']>;
  candidateName?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  /** too_fast — отклонена как автоматическая. `honeypot` здесь только у заявок до 07.10.2026: с тех пор ловушка не отклоняет (см. `botSignal`). */
  rejectedReason?: Maybe<Scalars['String']>;
  /** honeypot — сработала ловушка (заполнено скрытое поле, обычно автозаполнением браузера). Только пометка: заявка принята и разобрана как обычная, `state` от неё не зависит. Пусто — сигнала не было. */
  botSignal?: Maybe<Scalars['String']>;
  /** failed | pending | needs_operator | linked | rejected. 🔴 `linked` разделено надвое: «разобрана» означало лишь «строка кандидата создана» и молчала о том, движется ли человек. */
  state: Scalars['String'];
  /** Гео-идентификаторы, которых нет в нашем справочнике. Пусто, пока сайт соблюдает контракт. Непустое означает ровно одно: человек уехал в ручной разбор не потому, что не заполнил географию, а потому что прислал не наш идентификатор. */
  geoRejected: Array<GeoRejectionType>;
  /** Этап воронки, на котором человек сейчас. */
  candidateStatus?: Maybe<Scalars['String']>;
  candidateOperatorId?: Maybe<Scalars['ID']>;
  /** ID всех АКТИВНЫХ операторов кандидата. Окно разбора сверяет состав по ним: имена склеены через запятую, а запятая встречается и внутри названия оператора. */
  candidateOperatorIds: Array<Scalars['ID']>;
  candidateOperatorName?: Maybe<Scalars['String']>;
  /** Все АКТИВНЫЕ операторы кандидата парами «id + имя», по имени (#128). `candidateOperatorName` склеен запятой, а `candidateOperatorIds` — без имён: сопоставить их нельзя, запятая бывает и внутри названия. */
  candidateOperators: Array<FundingOperatorRefType>;
  candidateVoivodeship?: Maybe<Scalars['String']>;
  /** Чтобы поиск оператора в окне разбора стартовал сузённым по региону человека, а не по всем 127. */
  candidateVoivodeshipId?: Maybe<Scalars['ID']>;
  candidateEmploymentStatus?: Maybe<Scalars['String']>;
  candidateEmployerName?: Maybe<Scalars['String']>;
  /** Что именно прислала форма — известные поля в устойчивом порядке, служебные ключи выброшены. 🔴 Карточка кандидата показывает ВЫВЕДЕННЫЕ значения, и вопрос «что реально прислал человек» ими не отвечается: ровно на этой разнице жил дефект `phoneRaw`, когда сырая заявка телефон хранила, а карточка нет. */
  payloadAnswers: Array<FormAnswerType>;
  /** Откуда у кандидата оператор: robot (подобрал автоподбор) / manual (назначил человек) / import (приехало из Notion) / пусто. Прямой ответ на «что такое разобрано автоматически»: на 27.08.2026 это `import` у ВСЕХ 673 кандидатов с оператором — автоподбор не отработал ни разу, журнал воронки пуст. */
  candidateOperatorSource?: Maybe<Scalars['String']>;
  /** Кто назначил, когда это сделал человек. Пусто у робота и у импорта. */
  candidateOperatorSetBy?: Maybe<Scalars['String']>;
  candidateOperatorSetAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Гео-значение, которое форма прислала, а справочник не признал.
 * 
 * Сторож, а не запрет: заявка принимается, отправителю ничего не отвечают
 * (см. `intake_form.geo_rejections`), но менеджер видит разницу между
 * «человек не заполнил повят» и «сайт прислал повят, которого нет».
 */
export type GeoRejectionType = {
  __typename?: 'GeoRejectionType';
  /** voivodeshipId | powiatId | employerVoivodeshipId | employerPowiatId */
  key: Scalars['String'];
  /** Как прислали. */
  value: Scalars['String'];
};

/**
 * Одна строка анкеты как её прислала форма.
 * 
 * Пара, а не словарь: порядок вопросов несущий, а `JSONString` на экране —
 * это фигурные скобки, которые человек читать не должен.
 */
export type FormAnswerType = {
  __typename?: 'FormAnswerType';
  /** Имя поля в camelCase — им же подписан ключ локали `pages.dofinansowanie.fields.<field>`. */
  field: Scalars['String'];
  value: Scalars['String'];
};

/**
 * Одна плитка над списком заявок: состояние и сколько их.
 * 
 * Отдельный список, а не пять полей: состояния — открытый ряд, и новое
 * пришлось бы добавлять в трёх местах вместо одного.
 */
export type SubmissionStateCountType = {
  __typename?: 'SubmissionStateCountType';
  state: Scalars['String'];
  count: Scalars['Int'];
};

export type FundingStatsType = {
  __typename?: 'FundingStatsType';
  dimension: Scalars['String'];
  buckets: Array<StatsBucketType>;
  total: Scalars['Int'];
  medianDecisionDays?: Maybe<Scalars['Float']>;
  depositWaiting: Scalars['Int'];
};

/** Одна точка среза аналитики. */
export type StatsBucketType = {
  __typename?: 'StatsBucketType';
  key: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['Int'];
  share?: Maybe<Scalars['Float']>;
};

/**
 * Весь маршрут одним запросом.
 * 
 * Раньше этот экран собирался из шести запросов (`myCareerCenter`,
 * `myGrowth`, `mySkillMap`, `myCareerProfile`, `careerLessons`,
 * `careerVacancyFeed`) — около 68 SQL и шесть round-trip, и ни один из них
 * не отвечал на вопрос «что делать следующим».
 */
export type CareerJourneyType = {
  __typename?: 'CareerJourneyType';
  isMember: Scalars['Boolean'];
  isPreview: Scalars['Boolean'];
  memberStatus?: Maybe<Scalars['String']>;
  goal?: Maybe<CareerGoalType>;
  stages: Array<JourneyStageType>;
  nextAction?: Maybe<JourneyActionType>;
  primaryAction?: Maybe<JourneyActionType>;
  secondaryActions: Array<JourneyActionType>;
  hasGoal: Scalars['Boolean'];
  weeklyTasks: Array<JourneyTaskType>;
  readiness: Array<JourneyReadinessType>;
  locked: Array<JourneyLockedType>;
  cvChecklist: Array<JourneyCheckType>;
  applications: JourneyApplicationsType;
  phase: Scalars['String'];
  alignment: CareerProfileAlignmentType;
  sections: Array<CareerJourneySectionType>;
  metrics: Array<JourneyMetricType>;
};

/**
 * Выбранная карьерная цель — это `GrowthTrack`, а не новая сущность.
 * 
 * Заводить рядом с треком отдельную «цель» значило бы немедленно получить
 * экран, где выбрана профессия A, а целью названа B.
 */
export type CareerGoalType = {
  __typename?: 'CareerGoalType';
  trackCode: Scalars['String'];
  title: Scalars['String'];
  icon: Scalars['String'];
  isChosen: Scalars['Boolean'];
  targetSkillsMine: Scalars['Int'];
  targetSkillsTotal: Scalars['Int'];
  skillProgress?: Maybe<CareerSkillProgressType>;
  salaryFrom?: Maybe<Scalars['Int']>;
  salaryTo?: Maybe<Scalars['Int']>;
  salaryCurrency: Scalars['String'];
};

/**
 * Пять независимых чисел из `career.services.skill_progress.progress`.
 * 
 * 🔴 Клиент НЕ складывает их в проценты и не выводит одно из другого: у
 * «подтверждено школой» и «соответствует» разные смыслы, и сумма
 * «соответствует + подтверждено» — ровно та вторая правда, ради снятия
 * которой заведён этот тип.
 */
export type CareerSkillProgressType = {
  __typename?: 'CareerSkillProgressType';
  requiredCount: Scalars['Int'];
  meetsRequiredLevelCount: Scalars['Int'];
  needsImprovementCount: Scalars['Int'];
  missingCount: Scalars['Int'];
  verifiedMeetsRequiredLevelCount: Scalars['Int'];
};

/**
 * Один этап маршрута.
 * 
 * 🔴 `done`/`total` — ШТУКИ, не проценты. Требование владельца прямое:
 * «7 из 18 карьерных шагов» человеку говорит, что делать, «39%» не говорит
 * ничего. Каждое число берётся из функции, которая обслуживает экран, куда
 * ведёт `route`, — счётчик и кнопка обязаны считать одним предикатом.
 * 
 * `isDone` отдаётся сервером, а не выводится клиентом из `done >= total`:
 * при `total == 0` этап НЕ выполнен («учиться нечему» ≠ «отучился»), и
 * клиентская формула ошиблась бы ровно здесь.
 */
export type JourneyStageType = {
  __typename?: 'JourneyStageType';
  key: Scalars['String'];
  done: Scalars['Int'];
  total: Scalars['Int'];
  isDone: Scalars['Boolean'];
  isBlocked: Scalars['Boolean'];
  blockReason?: Maybe<Scalars['String']>;
  route: Scalars['String'];
  targetId?: Maybe<Scalars['ID']>;
};

/**
 * ЕДИНСТВЕННОЕ следующее действие.
 * 
 * 🔴 Никогда не указывает на заблокированный этап: CTA, который сервер
 * откажет, — худший вид интерфейса, потому что виноватым выглядит человек.
 */
export type JourneyActionType = {
  __typename?: 'JourneyActionType';
  kind: Scalars['String'];
  stageKey?: Maybe<Scalars['String']>;
  route: Scalars['String'];
  targetId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  reasonCode: Scalars['String'];
  subjectTitle: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  positionTotal?: Maybe<Scalars['Int']>;
  expectedOutcome: Scalars['String'];
  estimatedMinutes?: Maybe<Scalars['Int']>;
  dueDate?: Maybe<Scalars['Date']>;
};

/**
 * Задача недели. Их не больше трёх, и они НЕ ХРАНЯТСЯ.
 * 
 * Хранимая задача потребовала бы срока жизни, ночной уборки и состояния
 * «отклонена». Следствие названо вслух: задачу нельзя отложить, её можно
 * только выполнить.
 */
export type JourneyTaskType = {
  __typename?: 'JourneyTaskType';
  key: Scalars['String'];
  route: Scalars['String'];
  targetId?: Maybe<Scalars['ID']>;
  subject: Scalars['String'];
  dueDate?: Maybe<Scalars['Date']>;
};

/** Готовность по направлению — ПРОЕКЦИЯ этапов, не второй расчёт. */
export type JourneyReadinessType = {
  __typename?: 'JourneyReadinessType';
  key: Scalars['String'];
  value: Scalars['Int'];
  target: Scalars['Int'];
  level: Scalars['String'];
};

/**
 * Возможность, закрытая этому зрителю, и КОД причины.
 * 
 * 🔴 Приходит с сервера. Раньше не-участника выбрасывал 404, и продающий
 * раздел приходилось держать на отдельном корне; теперь он остаётся на
 * странице и читает объяснение с одним CTA. Вычислять блокировку на клиенте
 * нельзя — правило разъедется с серверным.
 */
export type JourneyLockedType = {
  __typename?: 'JourneyLockedType';
  key: Scalars['String'];
  reasonCode: Scalars['String'];
};

/**
 * Одна проверка полноты резюме.
 * 
 * Ключ машинный (`has_name`, `has_skills`, …), подпись подбирает локаль:
 * сервер говорит по-русски, интерфейс — по-польски.
 */
export type JourneyCheckType = {
  __typename?: 'JourneyCheckType';
  key: Scalars['String'];
  isDone: Scalars['Boolean'];
};

/** Сводка по откликам для дорожной карты. */
export type JourneyApplicationsType = {
  __typename?: 'JourneyApplicationsType';
  total: Scalars['Int'];
  active: Scalars['Int'];
  applied: Scalars['Int'];
  interview: Scalars['Int'];
  offer: Scalars['Int'];
  rejected: Scalars['Int'];
  hired: Scalars['Int'];
  nextFollowUp?: Maybe<CareerApplicationType>;
  recent: Array<CareerApplicationType>;
};

/**
 * Отклик студента.
 * 
 * 🔴 `note` — ЛИЧНОЕ. Резолвер отдаёт его только когда строка помечена
 * `_own_view`, а метку ставит исключительно LMS-резолвер. Компания, позиция,
 * статус и даты — операционные данные, HR обязан их видеть; «на интервью
 * хамили» — нет. Зеркало приёма `_engagement` / `myNotes` у урока.
 */
export type CareerApplicationType = {
  __typename?: 'CareerApplicationType';
  id: Scalars['ID'];
  vacancyId?: Maybe<Scalars['ID']>;
  companyName: Scalars['String'];
  position: Scalars['String'];
  applyUrl: Scalars['String'];
  status: Scalars['String'];
  appliedAt?: Maybe<Scalars['Date']>;
  nextActionAt?: Maybe<Scalars['Date']>;
  note: Scalars['String'];
  source: Scalars['String'];
  isPlacementConfirmed: Scalars['Boolean'];
  studentId?: Maybe<Scalars['ID']>;
  studentName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

/**
 * Спорит ли резюме с выбранной целью (ТЗ 0070).
 * 
 * ⚠️ `profileDirection` — КОНТЕКСТ, а не часть оценки: связи «направление ↔
 * профессия» в модели нет, и выводить её эвристикой значило бы завести второе
 * определение цели.
 */
export type CareerProfileAlignmentType = {
  __typename?: 'CareerProfileAlignmentType';
  status: Scalars['String'];
  goalTrackCode?: Maybe<Scalars['String']>;
  goalTitle?: Maybe<Scalars['String']>;
  profileHeadline: Scalars['String'];
  profileDirection: Scalars['String'];
  suggestedHeadline?: Maybe<Scalars['String']>;
};

/**
 * Фаза пути — проекция этапов на четыре крупные карточки (ТЗ 0070).
 * 
 * 🔴 У фазы НЕТ собственных `done`/`total`. Сложить уроки, проекты и галочки
 * резюме в одно число — это и есть непрозрачный «18 / 20», ради снятия
 * которого писалось 0070. Метрики остаются раздельными именно поэтому.
 */
export type CareerJourneySectionType = {
  __typename?: 'CareerJourneySectionType';
  key: Scalars['String'];
  state: Scalars['String'];
  isCurrent: Scalars['Boolean'];
  route: Scalars['String'];
  isBlocked: Scalars['Boolean'];
  blockReason?: Maybe<Scalars['String']>;
  metrics: Array<JourneyMetricType>;
};

/**
 * Одно ЧИСЛО маршрута. `target` пуст там, где цели нет вовсе (откликов не
 * бывает «сколько положено»).
 */
export type JourneyMetricType = {
  __typename?: 'JourneyMetricType';
  key: Scalars['String'];
  value: Scalars['Int'];
  target?: Maybe<Scalars['Int']>;
  route?: Maybe<Scalars['String']>;
  isDone?: Maybe<Scalars['Boolean']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
};

/**
 * The LMS landing payload: am I a member, and how far along am I.
 * 
 * ТЗ 0039 доводка: тот же payload обслуживает предпросмотр методиста, у
 * которого участия нет вовсе. Поэтому `memberId` и `enrolledAt` стали
 * NULLABLE — выдуманный id был бы хуже честной пустоты: по нему фронт
 * однажды сходил бы за данными несуществующего участника.
 */
export type CareerCenterType = {
  __typename?: 'CareerCenterType';
  isPreview: Scalars['Boolean'];
  memberId?: Maybe<Scalars['ID']>;
  status: Scalars['String'];
  directionTitle?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['ID']>;
  directionSource?: Maybe<Scalars['String']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  lessonsCompleted: Scalars['Int'];
  lessonsTotal: Scalars['Int'];
};

/**
 * Parent is a CareerLesson annotated by the resolver with
 * `_is_unlocked` and `_is_completed` for the calling viewer.
 * 
 * ERP staff read the same type with both flags forced True — they author
 * the content, so there is nothing to gate.
 * 
 * The engagement fields (`is_opened`, `my_notes`, `is_bookmarked`, …) read a
 * per-viewer `_engagement` row that ONLY the LMS `_decorate` attaches — so on
 * the ERP side they default to empty/false and `my_notes` can never leak a
 * student's private note to staff. `stats` is the mirror image: attached only
 * by the ERP query, null on the LMS.
 */
export type CareerLessonType = {
  __typename?: 'CareerLessonType';
  id: Scalars['ID'];
  order: Scalars['Int'];
  title: Scalars['String'];
  summary: Scalars['String'];
  durationMin?: Maybe<Scalars['Int']>;
  completionKind: Scalars['String'];
  artifactHint: Scalars['String'];
  outcomeKind: Scalars['String'];
  outcomeLabel: Scalars['String'];
  materialLanguage: Scalars['String'];
  state: Scalars['String'];
  unlockAfter?: Maybe<CareerLessonUnlockType>;
  hasVideo: Scalars['Boolean'];
  attachmentsCount: Scalars['Int'];
  quizQuestionsCount: Scalars['Int'];
  hasExercise: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isUnlocked: Scalars['Boolean'];
  isCompleted: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  isOpened: Scalars['Boolean'];
  openedAt?: Maybe<Scalars['DateTime']>;
  openCount: Scalars['Int'];
  myNotes: Scalars['String'];
  isBookmarked: Scalars['Boolean'];
  stats?: Maybe<CareerLessonStatsType>;
  peersCompleted?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  attachments: Array<CareerLessonAttachmentType>;
  quizQuestions: Array<CareerQuizQuestionType>;
  exercise?: Maybe<CareerLessonExerciseType>;
};

/**
 * Что откроет закрытый урок: пройти предыдущий (ТЗ 0071).
 * 
 * Номер и название — данные, фразу собирает фронт: «Otworzy się po lekcji 5».
 */
export type CareerLessonUnlockType = {
  __typename?: 'CareerLessonUnlockType';
  lessonId: Scalars['ID'];
  order: Scalars['Int'];
  title: Scalars['String'];
};

/**
 * ERP-only completion funnel for one lesson (spec 0020). Parent is the
 * dict `services.engagement.lesson_funnel` produces per lesson.
 */
export type CareerLessonStatsType = {
  __typename?: 'CareerLessonStatsType';
  openedCount: Scalars['Int'];
  completedCount: Scalars['Int'];
  membersTotal: Scalars['Int'];
};

export type CareerLessonAttachmentType = {
  __typename?: 'CareerLessonAttachmentType';
  id: Scalars['ID'];
  originalName: Scalars['String'];
  contentType: Scalars['String'];
  sizeBytes: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

/**
 * A self-check question (spec 0020). `correct_indexes` is revealed ONLY to
 * the ERP author — the `_reveal` flag is attached by `careerLessonsErp`; on
 * the LMS answer flow it is always empty, so the answer key can't be read off
 * the question list before submitting.
 */
export type CareerQuizQuestionType = {
  __typename?: 'CareerQuizQuestionType';
  id: Scalars['ID'];
  order: Scalars['Int'];
  text: Scalars['String'];
  options: Array<Scalars['String']>;
  correctIndexes: Array<Scalars['Int']>;
};

export type CareerLessonExerciseType = {
  __typename?: 'CareerLessonExerciseType';
  id: Scalars['ID'];
  intro: Scalars['String'];
  outro: Scalars['String'];
  fields: Array<CareerExerciseFieldType>;
  templateId: Scalars['ID'];
  templateTitle: Scalars['String'];
  hasSubmissions: Scalars['Boolean'];
  mySubmission?: Maybe<CareerExerciseSubmissionType>;
};

/** Поле анкеты урока (ТЗ 0039). */
export type CareerExerciseFieldType = {
  __typename?: 'CareerExerciseFieldType';
  id: Scalars['ID'];
  number: Scalars['Int'];
  label: Scalars['String'];
  helpText: Scalars['String'];
  placeholder: Scalars['String'];
  fieldType: Scalars['String'];
  required: Scalars['Boolean'];
  options: Array<Scalars['String']>;
  maxLength?: Maybe<Scalars['Int']>;
  binding: Scalars['String'];
  bindingLanguage?: Maybe<Scalars['String']>;
  prefill?: Maybe<Scalars['JSONString']>;
};

export type CareerExerciseSubmissionType = {
  __typename?: 'CareerExerciseSubmissionType';
  id: Scalars['ID'];
  submittedAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  answers: Array<CareerExerciseAnswerType>;
};

export type CareerExerciseAnswerType = {
  __typename?: 'CareerExerciseAnswerType';
  fieldId: Scalars['ID'];
  value?: Maybe<Scalars['JSONString']>;
};

/**
 * The student's structured profile — canonical source of the CV.
 * 
 * `is_searchable`/`contacts_visible` are the student's own opt-in flags,
 * returned only on their own profile.
 */
export type CareerProfileType = {
  __typename?: 'CareerProfileType';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  relocationReady: Scalars['Boolean'];
  workMode: Scalars['String'];
  workPermit: Scalars['String'];
  availableFrom?: Maybe<Scalars['Date']>;
  seniority: Scalars['String'];
  desiredPosition: Scalars['String'];
  desiredSalary: Scalars['String'];
  githubUrl: Scalars['String'];
  linkedinUrl: Scalars['String'];
  portfolioUrl: Scalars['String'];
  customSkills: Array<Scalars['String']>;
  isSearchable: Scalars['Boolean'];
  contactsVisible: Scalars['Boolean'];
  completeness: Scalars['Int'];
  skills: Array<StudentSkillType>;
  projects: Array<PortfolioProjectType>;
  experience: Array<WorkExperienceType>;
  education: Array<EducationType>;
  languages: Array<LanguageSkillType>;
  certificates: Array<CertificateType>;
  locales: Array<CvLocaleType>;
  cvSkillSuggestions: Array<CvSkillSuggestionType>;
};

export type StudentSkillType = {
  __typename?: 'StudentSkillType';
  skillId: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  level: Scalars['Int'];
  years?: Maybe<Scalars['Float']>;
  source: Scalars['String'];
  isHidden: Scalars['Boolean'];
  grantedCourseName?: Maybe<Scalars['String']>;
  grantedLessonNumber?: Maybe<Scalars['Int']>;
  grantedAt?: Maybe<Scalars['DateTime']>;
};

export type PortfolioProjectType = {
  __typename?: 'PortfolioProjectType';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  role: Scalars['String'];
  repoUrl: Scalars['String'];
  demoUrl: Scalars['String'];
  technologyIds: Array<Scalars['ID']>;
  technologyNames: Array<Scalars['String']>;
  technologies: Array<SkillType>;
};

/**
 * A dictionary skill — used by the profile editor's autocomplete and, via
 * `careerSkillsErp`, by the MCP vacancy-intake tool.
 */
export type SkillType = {
  __typename?: 'SkillType';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  category: Scalars['String'];
  aliases: Array<Scalars['String']>;
  description: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  levelCriteria: Array<SkillLevelCriteriaType>;
  holderCount?: Maybe<Scalars['Int']>;
  courseCount?: Maybe<Scalars['Int']>;
  demandVacancies?: Maybe<Scalars['Int']>;
  demandComputedAt?: Maybe<Scalars['DateTime']>;
  demandBand?: Maybe<Scalars['Int']>;
  unlockLevel?: Maybe<Scalars['Int']>;
  courseLevel?: Maybe<Scalars['Int']>;
};

/** «Что нужно уметь на уровне N» — пункты методиста (ТЗ 0072). */
export type SkillLevelCriteriaType = {
  __typename?: 'SkillLevelCriteriaType';
  level: Scalars['Int'];
  points: Array<Scalars['String']>;
  example: Scalars['String'];
};

export type WorkExperienceType = {
  __typename?: 'WorkExperienceType';
  id: Scalars['ID'];
  company: Scalars['String'];
  position: Scalars['String'];
  description: Scalars['String'];
  startYear?: Maybe<Scalars['Int']>;
  startMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  endMonth?: Maybe<Scalars['Int']>;
  isCurrent: Scalars['Boolean'];
};

export type EducationType = {
  __typename?: 'EducationType';
  id: Scalars['ID'];
  institution: Scalars['String'];
  degree: Scalars['String'];
  specialization: Scalars['String'];
  startYear?: Maybe<Scalars['Int']>;
  startMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  endMonth?: Maybe<Scalars['Int']>;
};

export type LanguageSkillType = {
  __typename?: 'LanguageSkillType';
  id: Scalars['ID'];
  language: Scalars['String'];
  level: Scalars['String'];
};

export type CertificateType = {
  __typename?: 'CertificateType';
  id: Scalars['ID'];
  title: Scalars['String'];
  issuer: Scalars['String'];
  issuedAt?: Maybe<Scalars['Date']>;
  url: Scalars['String'];
  fileUrl?: Maybe<Scalars['String']>;
};

export type CvLocaleType = {
  __typename?: 'CvLocaleType';
  language: Scalars['String'];
  jobTitle: Scalars['String'];
  about: Scalars['String'];
};

/** Навык словаря, упомянутый в CV, но не оценённый студентом (0072). */
export type CvSkillSuggestionType = {
  __typename?: 'CvSkillSuggestionType';
  skill: SkillType;
  mentionedAs: Scalars['String'];
};

/**
 * A curated job opening. `my_interaction` is set only on the LMS feed
 * (the calling member's SAVED/APPLIED state); it's None on the ERP side.
 * Direction/skill refs are flat light lists.
 */
export type VacancyType = {
  __typename?: 'VacancyType';
  id: Scalars['ID'];
  title: Scalars['String'];
  companyName: Scalars['String'];
  applyUrl: Scalars['String'];
  location: Scalars['String'];
  workMode: Scalars['String'];
  seniority: Scalars['String'];
  employmentType: Scalars['String'];
  salaryMin?: Maybe<Scalars['Int']>;
  salaryMax?: Maybe<Scalars['Int']>;
  salaryCurrency: Scalars['String'];
  description: Scalars['String'];
  status: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['DateTime'];
  directionIds: Array<Scalars['ID']>;
  directionTitles: Array<Scalars['String']>;
  skillIds: Array<Scalars['ID']>;
  skillNames: Array<Scalars['String']>;
  skills: Array<SkillType>;
  myInteraction?: Maybe<Scalars['String']>;
  appliedCount?: Maybe<Scalars['Int']>;
  descriptionShort: Scalars['String'];
  cityId?: Maybe<Scalars['ID']>;
  cityName?: Maybe<Scalars['String']>;
  skillMatch?: Maybe<VacancySkillMatchType>;
  matchedSkillCount: Scalars['Int'];
  matchedSkillNames: Array<Scalars['String']>;
  missingSkillCount: Scalars['Int'];
  missingSkillNames: Array<Scalars['String']>;
  missingSkills: Array<SkillType>;
  matchApplied: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  reviewedAt?: Maybe<Scalars['DateTime']>;
  createdByName?: Maybe<Scalars['String']>;
  reviewedByName?: Maybe<Scalars['String']>;
  duplicateOf: Array<VacancyDuplicateHintType>;
};

/**
 * Соответствие навыков студента требованиям вакансии (ТЗ 0073).
 * 
 * Один результат на все экраны: карточка, панель деталей, подсветка и
 * «чего не хватает» читают ИМЕННО его. Считается по навыкам студента
 * независимо от режима подбора — режим GOAL решает, какие вакансии
 * показать, но не объявляет навык профессии навыком студента. Счётчики
 * выводятся из списков, а не считаются отдельно.
 */
export type VacancySkillMatchType = {
  __typename?: 'VacancySkillMatchType';
  /** 'ok' | 'no_skills' — у студента нет ни одного оценённого навыка; тогда `missingSkills` пуст (мы не знаем, чего не хватает). */
  status: Scalars['String'];
  matchedSkills: Array<SkillType>;
  missingSkills: Array<SkillType>;
  /** Упомянуты в CV, но не оценены: не засчитаны и не недостающие. */
  unratedSkills: Array<SkillType>;
  matchedCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/**
 * Подозрение, что это та же вакансия с другой площадки (ТЗ 0035).
 * 
 * Именно ПОДОЗРЕНИЕ: решает человек. Формулировка в интерфейсе — «похоже
 * на №…», никогда не «дубль».
 */
export type VacancyDuplicateHintType = {
  __typename?: 'VacancyDuplicateHintType';
  vacancyId: Scalars['ID'];
  title: Scalars['String'];
  companyName: Scalars['String'];
  status: Scalars['String'];
  score: Scalars['Int'];
};

/**
 * Keyset `(score, sort_at, id)` connection — correct under head inserts,
 * unlike an offset cursor, which skips and duplicates exactly when a nightly
 * agent files rows into the top of the order while someone is paging.
 */
export type VacancyConnection = {
  __typename?: 'VacancyConnection';
  edges: Array<VacancyEdge>;
  pageInfo: VacancyPageInfo;
  totalCount: Scalars['Int'];
  totalCountCapped: Scalars['Boolean'];
  relevanceApplied: Scalars['Boolean'];
  matchContext: VacancyMatchContextType;
  totalAvailable: Scalars['Int'];
};

export type VacancyEdge = {
  __typename?: 'VacancyEdge';
  node: VacancyType;
  cursor: Scalars['String'];
};

export type VacancyPageInfo = {
  __typename?: 'VacancyPageInfo';
  hasNextPage: Scalars['Boolean'];
  endCursor?: Maybe<Scalars['String']>;
};

/**
 * Чем именно подобрана эта лента (ТЗ 0070).
 * 
 * ⚠️ Не украшение. В режиме GOAL `matchedSkillCount` на карточке значит
 * «совпало 3 ТРЕБОВАНИЯ профессии», а в PROFILE — «совпало 3 МОИХ навыка».
 * Одно поле, два смысла; контекст — единственное, что делает число читаемым.
 * 
 * 🔴 Отдаём то, что ПРИМЕНИЛИ, а не то, что просили: правило `relevanceApplied`
 * («интерфейс не имеет права заявить подбор, которого не было») здесь ровно
 * то же.
 */
export type VacancyMatchContextType = {
  __typename?: 'VacancyMatchContextType';
  matchMode: Scalars['String'];
  requestedMatchMode: Scalars['String'];
  trackCode: Scalars['String'];
  trackTitle: Scalars['String'];
  relevanceApplied: Scalars['Boolean'];
  fallbackReason: Scalars['String'];
};

/** A canonical city — the option list behind the feed's city filter. */
export type CareerCityType = {
  __typename?: 'CareerCityType';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  country: Scalars['String'];
};

/**
 * Один канал: готовый текст и ссылка окна шеринга.
 * 
 * 🔴 `shareUrl` у Instagram приходит `null` — и это НЕ забытая ссылка:
 * веб-эндпоинта шеринга у него не существует. Фронт по этому признаку рисует
 * «скопировать текст» вместо «поделиться».
 * 
 * Текст передаётся отдельно, потому что положить его в окно шеринга нельзя
 * ни в одном канале: LinkedIn принимает только `url`, Facebook — только `u`.
 */
export type ShareOptionType = {
  __typename?: 'ShareOptionType';
  channel: Scalars['String'];
  text: Scalars['String'];
  targetUrl: Scalars['String'];
  shareUrl?: Maybe<Scalars['String']>;
  bonusAvailable: Scalars['Boolean'];
  bonusPoints: Scalars['Int'];
  bonusPromo: Scalars['Boolean'];
};

/** Код глазами студента: что даёт, до какого числа, использован ли. */
export type PromoCodeType = {
  __typename?: 'PromoCodeType';
  id: Scalars['ID'];
  code: Scalars['String'];
  status: Scalars['String'];
  expiresAt?: Maybe<Scalars['Date']>;
  campaignTitle: Scalars['String'];
  campaignDescription: Scalars['String'];
  discountKind: Scalars['String'];
  discountValue: Scalars['Float'];
  currency: Scalars['String'];
};

/** Карта навыков целиком. */
export type SkillMapType = {
  __typename?: 'SkillMapType';
  trackCode?: Maybe<Scalars['String']>;
  trackTitle?: Maybe<Scalars['String']>;
  mine: Array<MySkillType>;
  missing: Array<MissingSkillType>;
  demandComputedAt?: Maybe<Scalars['DateTime']>;
  trackIsDefault: Scalars['Boolean'];
  nextCourses: Array<NextCourseType>;
};

/** Навык студента с пометкой, кто его подтвердил. */
export type MySkillType = {
  __typename?: 'MySkillType';
  skill: SkillType;
  level: Scalars['Int'];
  source: Scalars['String'];
  isHidden: Scalars['Boolean'];
  grantedCourseName?: Maybe<Scalars['String']>;
  grantedLessonNumber?: Maybe<Scalars['Int']>;
  demand?: Maybe<SkillDemandType>;
  providers: Array<SkillProviderType>;
};

/**
 * Востребованность навыка ПО НАШЕЙ ДОСКЕ (ТЗ 0039).
 * 
 * ⚠️ `computedAt` отдаётся не для красоты: счётчик без даты выглядит живым
 * даже тогда, когда ночная задача не отрабатывала неделю. И формулировка на
 * экране обязана быть «в нашей ленте», а не «на рынке»: доска, набитая
 * питоновскими вакансиями, по построению объявит Python самым востребованным.
 */
export type SkillDemandType = {
  __typename?: 'SkillDemandType';
  liveVacancies: Scalars['Int'];
  rank: Scalars['Int'];
  band: Scalars['Int'];
  computedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Курс, который даёт навык, — ответ на «а где это взять».
 * 
 * 🔴 `courseUrl` ведёт на МАРКЕТИНГОВЫЙ САЙТ, а не внутрь ЛМС: витрины
 * курсов в ЛМС нет вовсе, и без этой ссылки продающая петля обрывалась —
 * экран говорил «не хватает Kubernetes, его даёт курс DevOps», и идти было
 * некуда.
 */
export type SkillProviderType = {
  __typename?: 'SkillProviderType';
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  courseUrl: Scalars['String'];
  level: Scalars['Int'];
  completed: Scalars['Boolean'];
};

/** Чего не хватает до трека и какой курс это даёт. */
export type MissingSkillType = {
  __typename?: 'MissingSkillType';
  skill: SkillType;
  demand?: Maybe<SkillDemandType>;
  providers: Array<SkillProviderType>;
  upcoming?: Maybe<UpcomingUnlockType>;
};

/**
 * Когда навык откроется на курсе, где студент УЖЕ учится (ТЗ 0040, доводка).
 * 
 * Без этого карта навыков умела отвечать только «купите курс» — то есть
 * предлагала купить то, на что человек ходит, вместо того чтобы сказать,
 * когда это придёт.
 */
export type UpcomingUnlockType = {
  __typename?: 'UpcomingUnlockType';
  lessonNumber: Scalars['Int'];
  lessonsLeft: Scalars['Int'];
};

/**
 * Следующий курс для выпускника (ТЗ 0039, доводка).
 * 
 * Перепродажа между главными курсами школы: считается из нехватки по треку,
 * а не из отдельного списка «кто кому продаёт» — такой список разъехался бы
 * с программами курсов в первый же месяц.
 */
export type NextCourseType = {
  __typename?: 'NextCourseType';
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  courseUrl: Scalars['String'];
  adds: Array<Scalars['String']>;
  covered: Scalars['Int'];
  totalMissing: Scalars['Int'];
};

/**
 * Карта навыков выбранной профессии целиком.
 * 
 * Один запрос на весь граф: дерево собирает клиент из плоского списка узлов.
 * Экран, делающий по запросу на узел, при шестидесяти навыках отвечал бы
 * минуту.
 */
export type CareerSkillGraphType = {
  __typename?: 'CareerSkillGraphType';
  trackCode: Scalars['String'];
  trackTitle: Scalars['String'];
  trackIcon: Scalars['String'];
  clusters: Array<CareerSkillClusterType>;
  nodes: Array<CareerSkillNodeType>;
  edges: Array<CareerSkillEdgeType>;
  recommendedCourses: Array<CareerCourseRecommendationType>;
  skillProgress: CareerSkillProgressType;
  computedAt?: Maybe<Scalars['DateTime']>;
  isFallback: Scalars['Boolean'];
  fallbackReason: Scalars['String'];
  trackIsDefault: Scalars['Boolean'];
  isChosenGoal: Scalars['Boolean'];
};

/** Колонка карты — группа навыков внутри профессии. */
export type CareerSkillClusterType = {
  __typename?: 'CareerSkillClusterType';
  code: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  order: Scalars['Int'];
};

/** Узел карты: навык профессии и положение студента относительно него. */
export type CareerSkillNodeType = {
  __typename?: 'CareerSkillNodeType';
  id: Scalars['ID'];
  slug: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  skill: SkillType;
  clusterCode: Scalars['String'];
  requiredLevel: Scalars['Int'];
  priority: Scalars['String'];
  status: Scalars['String'];
  requirementStatus: Scalars['String'];
  myLevel?: Maybe<Scalars['Int']>;
  source: Scalars['String'];
  demand?: Maybe<SkillDemandType>;
  upcoming?: Maybe<UpcomingUnlockType>;
  providers: Array<SkillProviderType>;
};

/**
 * Связь карты: 'hierarchy' — колонка и её навык, 'required' —
 * обязательная предпосылка, 'recommended' — рекомендуемый порядок.
 */
export type CareerSkillEdgeType = {
  __typename?: 'CareerSkillEdgeType';
  from: Scalars['ID'];
  to: Scalars['ID'];
  kind: Scalars['String'];
};

/**
 * Курс, закрывающий пробелы карты. Одна основная и максимум две
 * альтернативы — список из десяти курсов не рекомендация, а каталог.
 */
export type CareerCourseRecommendationType = {
  __typename?: 'CareerCourseRecommendationType';
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  courseUrl: Scalars['String'];
  closesNodes: Array<Scalars['String']>;
  criticalGaps: Scalars['Int'];
  importantGaps: Scalars['Int'];
  careerOutcome: Scalars['String'];
  durationLabel: Scalars['String'];
  status: Scalars['String'];
  access: Scalars['String'];
  closesSkillNames: Array<Scalars['String']>;
  reasonCode: Scalars['String'];
};

/** Экран «Мой рост» целиком. */
export type GrowthOverviewType = {
  __typename?: 'GrowthOverviewType';
  xp: Scalars['Int'];
  level: Scalars['Int'];
  levelTitle: Scalars['String'];
  levelFloorXp: Scalars['Int'];
  levels: Array<GrowthLevelType>;
  nextLevelXp?: Maybe<Scalars['Int']>;
  availableTotal: Scalars['Int'];
  lockedTotal: Scalars['Int'];
  isCareerMember: Scalars['Boolean'];
  achievements: Array<GrowthAchievementType>;
  tracks: Array<GrowthTrackType>;
};

/**
 * Ступень лестницы уровней (ТЗ 0039, доводка UX).
 * 
 * Пороги живут кортежем `GROWTH_LEVELS` в константах и меняются выкатом;
 * дублировать их на фронте значило бы завести вторую правду о том же.
 */
export type GrowthLevelType = {
  __typename?: 'GrowthLevelType';
  index: Scalars['Int'];
  title: Scalars['String'];
  threshold: Scalars['Int'];
  reached: Scalars['Boolean'];
};

/** Медаль глазами студента: получена или на каком расстоянии. */
export type GrowthAchievementType = {
  __typename?: 'GrowthAchievementType';
  code: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  category: Scalars['String'];
  points: Scalars['Int'];
  earned: Scalars['Boolean'];
  earnedAt?: Maybe<Scalars['DateTime']>;
  current: Scalars['Int'];
  target: Scalars['Int'];
  locked: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
  progressKind: Scalars['String'];
};

export type GrowthTrackType = {
  __typename?: 'GrowthTrackType';
  code: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  chosen: Scalars['Boolean'];
  steps: Array<GrowthTrackStepType>;
  stepsDone: Scalars['Int'];
  stepsTotal: Scalars['Int'];
  missingSkills: Array<SkillType>;
  recommendedCourses: Array<GrowthCourseType>;
};

export type GrowthTrackStepType = {
  __typename?: 'GrowthTrackStepType';
  title: Scalars['String'];
  description: Scalars['String'];
  satisfied: Scalars['Boolean'];
  current: Scalars['Int'];
  target: Scalars['Int'];
  progressKind: Scalars['String'];
};

/**
 * Курс в рекомендации трека — чип с названием, без ссылки.
 * 
 * Не `CourseType`: тот объявлен `DjangoObjectType` без `fields`/`exclude`,
 * то есть выкладывает наружу ВСЮ модель курса. Тащить его в студенческий
 * контур ради названия — это отдать заодно всё, что к курсу когда-либо
 * припишут.
 * 
 * 🔴 Имя строится `links.public_name`, а НЕ дефолтным резолвером. Раньше
 * здесь отдавалось сырое `Course.name` — внутреннее имя ERP со служебными
 * пометками («DEMO · … — выпуск»), — и это не всплывало только потому, что
 * блок «рекомендуем» был ПУСТ у каждого студента: `recommended_courses`
 * ходил через скоупнутый `Course.objects`. Как только скоуп обошли
 * (`services/course_scope.py`), блок наполнился, и внутреннее имя поехало на
 * экран. Ровно то, что вычищено в карте навыков и в «что дальше».
 * 
 * Источник — ВИТРИНА САЙТА (`SiteCourse`): фильтровать нечего, в ней по
 * построению лежит только продаваемое, а слаг уникален. Прежде здесь стоял
 * курс из ERP, и приходилось и обходить скоуп юрлица, и вычищать служебные
 * пометки из внутреннего имени.
 * 
 * ТЗ 0039, доводка UX: `url` добавлен по претензии владельца — курсы в треке
 * были жёлтыми пилюлями, на которые нельзя нажать. Название курса без
 * перехода на него в продающем разделе — это тупик ровно там, где начинается
 * продажа.
 */
export type GrowthCourseType = {
  __typename?: 'GrowthCourseType';
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};

/**
 * Навык целиком — для его СОБСТВЕННОЙ страницы (ТЗ 0039, доводка UX).
 * 
 * Шторку нельзя ни дать ссылкой, ни открыть с другого экрана, ни вернуть
 * кнопкой «назад». Владелец: «открывается справа поп-ап — не очевидно».
 * Поэтому у навыка появился адрес, а у адреса — этот тип.
 */
export type SkillDetailType = {
  __typename?: 'SkillDetailType';
  skill: SkillType;
  myLevel?: Maybe<Scalars['Int']>;
  mySource?: Maybe<Scalars['String']>;
  mentionedInCv: Scalars['Boolean'];
  grantedCourseName?: Maybe<Scalars['String']>;
  grantedLessonNumber?: Maybe<Scalars['Int']>;
  demand?: Maybe<SkillDemandType>;
  providers: Array<SkillProviderType>;
  professions: Array<SkillProfessionType>;
};

/** Профессия, которой нужен этот навык, — обратный взгляд на цели трека. */
export type SkillProfessionType = {
  __typename?: 'SkillProfessionType';
  code: Scalars['String'];
  title: Scalars['String'];
  icon: Scalars['String'];
  summary: Scalars['String'];
  haveCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  skillProgress: CareerSkillProgressType;
  usageNote: Scalars['String'];
};

/**
 * Карточка профессии (ТЗ 0039, доводка UX).
 * 
 * Это тот же `GrowthTrack`, показанный как рассказ о работе, а не как цель
 * в списке. Отдельного типа профессии нет намеренно: две сущности про одно
 * разошлись бы через месяц.
 */
export type ProfessionType = {
  __typename?: 'ProfessionType';
  code: Scalars['String'];
  title: Scalars['String'];
  summary: Scalars['String'];
  about: Scalars['String'];
  salaryFrom?: Maybe<Scalars['Int']>;
  salaryTo?: Maybe<Scalars['Int']>;
  salaryCurrency: Scalars['String'];
  icon: Scalars['String'];
  skills: Array<ProfessionSkillType>;
  haveCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  skillProgress: CareerSkillProgressType;
  topGaps: Array<CareerSkillGapType>;
  courses: Array<ProfessionCourseType>;
  nextCourse?: Maybe<CareerCourseRecommendationType>;
  liveVacancies: Scalars['Int'];
  isChosen: Scalars['Boolean'];
  hasRequirements: Scalars['Boolean'];
  steps: Array<GrowthTrackStepType>;
  stepsDone: Scalars['Int'];
  stepsTotal: Scalars['Int'];
};

/** Целевой навык профессии с пометкой «у меня уже есть». */
export type ProfessionSkillType = {
  __typename?: 'ProfessionSkillType';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  category: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  have: Scalars['Boolean'];
  requirementStatus: Scalars['String'];
  priority: Scalars['String'];
  requiredLevel: Scalars['Int'];
  myLevel?: Maybe<Scalars['Int']>;
};

/** Один незакрытый обязательный навык — для «трёх ближайших пробелов». */
export type CareerSkillGapType = {
  __typename?: 'CareerSkillGapType';
  slug: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  priority: Scalars['String'];
  requiredLevel: Scalars['Int'];
  myLevel?: Maybe<Scalars['Int']>;
};

/** Наш курс, ведущий в профессию, — со ссылкой на страницу курса. */
export type ProfessionCourseType = {
  __typename?: 'ProfessionCourseType';
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  courseUrl: Scalars['String'];
  completed: Scalars['Boolean'];
};

export type CareerDirectionType = {
  __typename?: 'CareerDirectionType';
  id: Scalars['ID'];
  slug: Scalars['String'];
  title: Scalars['String'];
  order: Scalars['Int'];
  isActive: Scalars['Boolean'];
};

/**
 * Строка диалога добавления: кого можно зачислить и кто уже внутри.
 * 
 * 🔴 `memberStatus` приходит С СЕРВЕРА, а не вычисляется в интерфейсе. Без
 * него оператор узнавал правду только из `skipped` в тосте — то есть уже
 * после того, как нажал «Добавить» и ничего не произошло.
 */
export type CareerRosterRowType = {
  __typename?: 'CareerRosterRowType';
  studentId: Scalars['ID'];
  fullName: Scalars['String'];
  email: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  memberStatus?: Maybe<Scalars['String']>;
};

/** ERP row. Student/group refs are flat light fields on purpose. */
export type CareerMemberType = {
  __typename?: 'CareerMemberType';
  id: Scalars['ID'];
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  studentEmail?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['ID']>;
  directionTitle?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  enrolledAt: Scalars['DateTime'];
  notes: Scalars['String'];
  lessonsCompleted: Scalars['Int'];
  lessonsTotal: Scalars['Int'];
  growth?: Maybe<MemberGrowthType>;
  profile?: Maybe<CareerProfileType>;
};

/**
 * Рост и бонусы студента глазами менеджера (ТЗ 0039, доводка).
 * 
 * 🔴 Ради этого блока всё и затевалось с точки зрения продаж: следующий курс
 * оформляет живой человек, а он про промокод студента не знал ничего —
 * коды лежали в отдельной вкладке, найти их можно было только поиском по
 * фамилии, то есть в момент разговора — никогда.
 */
export type MemberGrowthType = {
  __typename?: 'MemberGrowthType';
  xp: Scalars['Int'];
  level: Scalars['Int'];
  levelTitle: Scalars['String'];
  medalsEarned: Scalars['Int'];
  medalsTotal: Scalars['Int'];
  trackTitle?: Maybe<Scalars['String']>;
  trackIsDefault: Scalars['Boolean'];
  codes: Array<PromoCodeType>;
  nextCourses: Array<NextCourseType>;
};

/**
 * One row of a member's learning map for the ERP per-member drawer
 * (spec 0020). Parent is a dict from `services.engagement.member_progress`.
 * Carries NO note text — staff see whether/when, never what.
 */
export type CareerMemberLessonProgressType = {
  __typename?: 'CareerMemberLessonProgressType';
  lessonId: Scalars['ID'];
  order: Scalars['Int'];
  title: Scalars['String'];
  isOpened: Scalars['Boolean'];
  openedAt?: Maybe<Scalars['DateTime']>;
  openCount: Scalars['Int'];
  isCompleted: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Текст поста для экрана в ERP (ТЗ 0039, доводка).
 * 
 * Мутация правки была с самого начала, а экрана не было — то есть обещание
 * «менять формулировку без выката» выполнялось только через Django-admin,
 * куда владелец не ходит.
 */
export type ShareTemplateType = {
  __typename?: 'ShareTemplateType';
  channel: Scalars['String'];
  language: Scalars['String'];
  text: Scalars['String'];
  targetUrl: Scalars['String'];
  isActive: Scalars['Boolean'];
};

/**
 * Медаль в ERP.
 * 
 * ТЗ 0040 фаза C: стала правимой. Прежний довод «править их в админке
 * методист умеет» перестал работать ровно там, где владелец сказал, что
 * редактирование должно быть в одном месте и по одному образцу.
 */
export type AchievementErpType = {
  __typename?: 'AchievementErpType';
  id: Scalars['ID'];
  code: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  category: Scalars['String'];
  points: Scalars['Int'];
  ruleKind: Scalars['String'];
  ruleParams?: Maybe<Scalars['JSONString']>;
  isSecret: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  order: Scalars['Int'];
  grantedCount?: Maybe<Scalars['Int']>;
};

/**
 * Курс витрины: то, что школа ПРОДАЁТ (ТЗ 0040 фаза C).
 * 
 * Заводился сидом, то есть правка прайс-листа требовала выката.
 */
export type SiteCourseErpType = {
  __typename?: 'SiteCourseErpType';
  id: Scalars['ID'];
  slug: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
  isActive: Scalars['Boolean'];
  erpCourseId?: Maybe<Scalars['ID']>;
  erpCourseName?: Maybe<Scalars['String']>;
  careerOutcome: Scalars['String'];
  durationLabel: Scalars['String'];
  skills: Array<SiteCourseSkillErpType>;
};

export type SiteCourseSkillErpType = {
  __typename?: 'SiteCourseSkillErpType';
  skillId: Scalars['ID'];
  skillName: Scalars['String'];
  level: Scalars['Int'];
};

/** Трек в ERP — только чтение, с составом целей. */
export type GrowthTrackErpType = {
  __typename?: 'GrowthTrackErpType';
  id: Scalars['ID'];
  code: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  longDescription: Scalars['String'];
  salaryFrom?: Maybe<Scalars['Int']>;
  salaryTo?: Maybe<Scalars['Int']>;
  salaryCurrency: Scalars['String'];
  icon: Scalars['String'];
  isActive: Scalars['Boolean'];
  order: Scalars['Int'];
  targetSkills: Array<Scalars['String']>;
  targetSkillIds: Array<Scalars['ID']>;
  siteCourseIds: Array<Scalars['ID']>;
  steps: Array<Scalars['String']>;
  stepRows: Array<GrowthStepErpType>;
  chosenCount?: Maybe<Scalars['Int']>;
};

/** Шаг профессии — то, что редактор правит построчно. */
export type GrowthStepErpType = {
  __typename?: 'GrowthStepErpType';
  title: Scalars['String'];
  description: Scalars['String'];
  ruleKind: Scalars['String'];
  ruleParams?: Maybe<Scalars['JSONString']>;
};

/**
 * Правило выдачи для формы акции (ТЗ 0039, доводка).
 * 
 * Отдаётся сервером по той же причине, что и словарь конструктора анкет:
 * копия списка в TypeScript однажды разойдётся с реестром, и форма предложит
 * правило, которого сервер не знает.
 */
export type GrowthRuleType = {
  __typename?: 'GrowthRuleType';
  value: Scalars['String'];
  label: Scalars['String'];
  paramKey: Scalars['String'];
  progressKind: Scalars['String'];
};

/**
 * Значок профессии для пикера в ERP (ТЗ 0040, доводка).
 * 
 * Отдаётся сервером по той же причине, что и реестр правил рядом: список,
 * скопированный в TypeScript, однажды разойдётся с тем, что принимает
 * `upsert_track`, и оператор получит отказ на значок, который ему же и
 * предложили. Рисунок при этом остаётся на фронтенде — это SVG, не данные.
 */
export type TrackIconType = {
  __typename?: 'TrackIconType';
  value: Scalars['String'];
  label: Scalars['String'];
};

/** Акция в ERP. Счётчики штампуются на строки, не аннотируются. */
export type PromoCampaignType = {
  __typename?: 'PromoCampaignType';
  id: Scalars['ID'];
  code: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  prefix: Scalars['String'];
  discountKind: Scalars['String'];
  discountValue: Scalars['Float'];
  currency: Scalars['String'];
  ttlDays: Scalars['Int'];
  hardExpiresAt?: Maybe<Scalars['Date']>;
  maxCodes: Scalars['Int'];
  ruleKind: Scalars['String'];
  ruleParams?: Maybe<Scalars['JSONString']>;
  isActive: Scalars['Boolean'];
  issuedCount?: Maybe<Scalars['Int']>;
  redeemedCount?: Maybe<Scalars['Int']>;
};

/** Строка списка кодов для оператора. */
export type PromoCodeErpType = {
  __typename?: 'PromoCodeErpType';
  id: Scalars['ID'];
  code: Scalars['String'];
  status: Scalars['String'];
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  campaignCode: Scalars['String'];
  expiresAt?: Maybe<Scalars['Date']>;
  redeemedAt?: Maybe<Scalars['DateTime']>;
  agreementId?: Maybe<Scalars['ID']>;
  agreementTitle?: Maybe<Scalars['String']>;
  isAmbiguous: Scalars['Boolean'];
  revokeReason: Scalars['String'];
};

/**
 * Словарь конструктора анкет (ТЗ 0039).
 * 
 * 🔴 Существует ради ОДНОГО: чтобы матрица «какой тип поля какая привязка
 * принимает» жила в одном месте. Скопируй её в ERP руками — и через месяц
 * конструктор начнёт предлагать привязку, которую сервер отбивает, причём
 * молча для того, кто её выбрал.
 */
export type ExerciseVocabularyType = {
  __typename?: 'ExerciseVocabularyType';
  fieldTypes: Array<ExerciseFieldKindType>;
  bindings: Array<ExerciseBindingType>;
  maxFields: Scalars['Int'];
  maxOptions: Scalars['Int'];
};

/** Один тип поля из словаря конструктора (ТЗ 0039). */
export type ExerciseFieldKindType = {
  __typename?: 'ExerciseFieldKindType';
  value: Scalars['String'];
  label: Scalars['String'];
  hasOptions: Scalars['Boolean'];
};

/** Одна цель записи в резюме и типы полей, которые она принимает. */
export type ExerciseBindingType = {
  __typename?: 'ExerciseBindingType';
  value: Scalars['String'];
  label: Scalars['String'];
  fieldTypes: Array<Scalars['String']>;
  isCollection: Scalars['Boolean'];
  needsLanguage: Scalars['Boolean'];
  subFields: Array<Scalars['String']>;
};

/**
 * Анкета в справочнике (ТЗ 0040 фаза B).
 * 
 * `lessonTitles`, а не только счётчик: перед правкой методисту нужно знать
 * не «сколько», а «каких именно» уроков это коснётся — иначе он правит
 * вслепую, а замок объясняет отказ уже постфактум.
 */
export type CareerExerciseTemplateType = {
  __typename?: 'CareerExerciseTemplateType';
  id: Scalars['ID'];
  title: Scalars['String'];
  intro: Scalars['String'];
  outro: Scalars['String'];
  isActive: Scalars['Boolean'];
  fields: Array<CareerExerciseFieldType>;
  hasSubmissions: Scalars['Boolean'];
  submissionsCount: Scalars['Int'];
  lessonTitles: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Строка «этот курс даёт этот навык на таком уровне» (ТЗ 0039). */
export type CourseSkillType = {
  __typename?: 'CourseSkillType';
  id: Scalars['ID'];
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  skillId: Scalars['ID'];
  skillName: Scalars['String'];
  skillCategory: Scalars['String'];
  level: Scalars['Int'];
  unlockLessonNumber?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  isActive: Scalars['Boolean'];
};

/**
 * Занятие программы курса со сквозным номером (ТЗ 0040).
 * 
 * Номер считается на лету, а не хранится: он и есть позиция в программе, и
 * отдельное поле разъезжалось бы с ней при каждой вставке занятия.
 */
export type CourseProgramLessonType = {
  __typename?: 'CourseProgramLessonType';
  number: Scalars['Int'];
  name: Scalars['String'];
  moduleName: Scalars['String'];
  lessonId: Scalars['ID'];
  moduleId: Scalars['ID'];
  marketingModuleId?: Maybe<Scalars['ID']>;
  lmsDescription: Scalars['String'];
  taskTypes: Array<Scalars['String']>;
};

/**
 * Рама курса — то, из чего построена его страница на сайте (ТЗ 0040).
 * 
 * `exists=false` значит, что программы у курса нет вовсе: тогда экран должен
 * сказать это словами, а не показать три пустых поля.
 */
export type CourseProgramFrameType = {
  __typename?: 'CourseProgramFrameType';
  title: Scalars['String'];
  hours: Scalars['String'];
  description: Scalars['String'];
  exists: Scalars['Boolean'];
  marketingModules: Array<MarketingModuleType>;
};

export type MarketingModuleType = {
  __typename?: 'MarketingModuleType';
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
};

/**
 * Строка «эта ГРУППА даёт этот навык на таком уровне» (ТЗ 0041).
 * 
 * Занятие приходит и ссылкой, и номером. Ссылка — то, что хранится и чем
 * живёт начисление; номер считается на лету как позиция в расписании и нужен
 * ровно для подписи «№12», которую методист привык видеть.
 * 
 * `unlockLessonId` пустое означает «навык придёт по завершении курса». В
 * отличие от прежнего предпросмотра, случая «правило указывает в пустоту»
 * здесь не бывает вовсе: связать можно только с занятием этой же группы.
 */
export type GroupSkillType = {
  __typename?: 'GroupSkillType';
  id: Scalars['ID'];
  groupId: Scalars['ID'];
  skillId: Scalars['ID'];
  skillName: Scalars['String'];
  skillCategory: Scalars['String'];
  level: Scalars['Int'];
  unlockLessonId?: Maybe<Scalars['ID']>;
  unlockLessonNumber?: Maybe<Scalars['Int']>;
  unlockLessonName?: Maybe<Scalars['String']>;
  unlockLessonDate?: Maybe<Scalars['Date']>;
  unlockLessonIsOver: Scalars['Boolean'];
  order: Scalars['Int'];
  isActive: Scalars['Boolean'];
};

/**
 * Занятие группы для выбора «навык появляется здесь» (ТЗ 0041).
 * 
 * Дата и `isOver` не украшение: правило, поставленное на уже прошедшее
 * занятие, начислит навык той же ночью, и методист обязан видеть это ДО
 * сохранения, а не узнавать по факту.
 */
export type GroupProgramLessonType = {
  __typename?: 'GroupProgramLessonType';
  lessonId: Scalars['ID'];
  number: Scalars['Int'];
  name: Scalars['String'];
  moduleName: Scalars['String'];
  date?: Maybe<Scalars['Date']>;
  isOver: Scalars['Boolean'];
};

/** Строка списка курсов во вкладке «Навыки»: сколько чему учит. */
export type CourseSkillSummaryType = {
  __typename?: 'CourseSkillSummaryType';
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  skillCount: Scalars['Int'];
  directionTitles: Array<Scalars['String']>;
};

/**
 * Разбор «прошёл / не засчитано» по одному курсу — карточка участника.
 * 
 * Отдаёт и ПРИЧИНУ, а не только вердикт: оператору нужно видеть, что данные
 * говорят «прошёл», а решение сотрудника это перебивает, — иначе кнопка
 * «не засчитывать» выглядит как действие в пустоту.
 */
export type CourseCompletionType = {
  __typename?: 'CourseCompletionType';
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  groupName: Scalars['String'];
  completed: Scalars['Boolean'];
  derived: Scalars['Boolean'];
  hasDiploma: Scalars['Boolean'];
  manualStatus: Scalars['String'];
};

/**
 * Страница ERP-доски (ТЗ 0035).
 * 
 * Отдельный тип от `VacancyConnection`: у ленты есть `relevanceApplied`, а на
 * доске модерации это поле — бессмысленный шум. Курсор кейсетный по той же
 * причине, что и у ленты: агент вставляет строки в голову сортировки ровно
 * тогда, когда модератор листает очередь.
 */
export type VacancyBoardConnection = {
  __typename?: 'VacancyBoardConnection';
  edges: Array<VacancyEdge>;
  pageInfo: VacancyPageInfo;
  totalCount: Scalars['Int'];
  totalCountCapped: Scalars['Boolean'];
};

/** Parent is the dict from `services.dashboard.funnel()`. */
export type CareerDashboardType = {
  __typename?: 'CareerDashboardType';
  members: Scalars['Int'];
  trained: Scalars['Int'];
  profileReady: Scalars['Int'];
  applied: Scalars['Int'];
  placed: Scalars['Int'];
  vacanciesPublished: Scalars['Int'];
  vacanciesDraft: Scalars['Int'];
  vacanciesDraftFromAgent: Scalars['Int'];
  oldestDraftDays: Scalars['Int'];
};

/** Состояние MCP-доступа текущего пользователя. */
export type McpAccessType = {
  __typename?: 'McpAccessType';
  /** Можно ли этому пользователю подключить ИИ ПРЯМО СЕЙЧАС: проверены все условия входа, а не только рубильник. */
  enabled: Scalars['Boolean'];
  /** Адрес, который вводят в клиенте. Пуст, если MCP выключен или не настроен MCP_PUBLIC_URL. */
  endpoint?: Maybe<Scalars['String']>;
  /** Почему подключиться нельзя, если `enabled` = false. Пусто, когда всё в порядке. Без этого поля страница показывала зелёный статус пользователю без юрлица, а клиент получал отказ на первом же вызове. */
  blockedReason?: Maybe<Scalars['String']>;
  connections: Array<McpConnectionType>;
  callsLast30Days: Scalars['Int'];
};

/**
 * Живое подключение внешнего ИИ.
 * 
 * Подключение — это REFRESH-токен, а не access. Access живёт 8 часов и
 * пересоздаётся при каждом обновлении, refresh — 30 дней; список, собранный
 * по access-токенам, показывал «Пока никто не подключён» уже наутро после
 * подключения, хотя клиент был жив и восстанавливался сам. Кнопки «Отозвать»
 * в этот момент просто не существовало.
 */
export type McpConnectionType = {
  __typename?: 'McpConnectionType';
  /** Непрозрачный идентификатор подключения. Передаётся в `revokeMcpConnection` как есть; разбирать его не нужно. */
  id: Scalars['ID'];
  /** Название клиента, который подключился (Claude и т.п.) */
  application?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  /** Когда подключение последний раз обновлялось. НЕ время первого подключения: токены ротируются, и при каждом обновлении дата сдвигается. */
  created?: Maybe<Scalars['DateTime']>;
  /** Когда истекает текущий короткий токен доступа. Само подключение переживает эту дату — клиент обновит токен молча. Пусто, если активного токена сейчас нет. */
  expires?: Maybe<Scalars['DateTime']>;
  /** Последний вызов инструмента этим пользователем — берётся из журнала MCP, а не из самого токена. */
  lastUsed?: Maybe<Scalars['DateTime']>;
};

/**
 * LMS student-self view. Reachable ONLY from `myDiplomas`.
 * 
 * Carries `group_name`/`course_name` because a student who studied in two
 * groups would otherwise see two indistinguishable «Diploma (PL)» rows.
 */
export type MyDiplomaType = {
  __typename?: 'MyDiplomaType';
  id: Scalars['ID'];
  language: DiplomaLanguageEnum;
  groupName?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  sizeBytes?: Maybe<Scalars['Int']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum DiplomaLanguageEnum {
  Pl = 'PL',
  En = 'EN'
}

export type DiplomaDownloadUrlType = {
  __typename?: 'DiplomaDownloadUrlType';
  url: Scalars['String'];
  expiresAt: Scalars['DateTime'];
};

/**
 * One roster row: the student plus whichever languages are attached.
 * 
 * Shaped per-student rather than per-file so the ERP table renders directly
 * (student | PL | EN | actions) without a client-side group-by.
 */
export type GroupDiplomaRowType = {
  __typename?: 'GroupDiplomaRowType';
  student: DiplomaStudentType;
  agreementTitle?: Maybe<Scalars['String']>;
  pl?: Maybe<DiplomaType>;
  en?: Maybe<DiplomaType>;
  /** Mark for the graduation project (StudentsMark with task_type='graduation_project' on a lesson of this group); null — not graded yet. */
  graduationProjectMark?: Maybe<Scalars['Float']>;
  /** The group has a lesson with the «Dipl. project» task type — same value on every row of the group. False ⇒ there is nowhere in LMS to put the mark. */
  hasGraduationProjectLesson: Scalars['Boolean'];
};

/** Minimal student identity for the ERP diplomas table. */
export type DiplomaStudentType = {
  __typename?: 'DiplomaStudentType';
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

/** ERP view of one attached diploma. No file URL — see module docstring. */
export type DiplomaType = {
  __typename?: 'DiplomaType';
  id: Scalars['ID'];
  pk?: Maybe<Scalars['Int']>;
  language: DiplomaLanguageEnum;
  source?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  sizeBytes?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
  uploadedAt?: Maybe<Scalars['DateTime']>;
  uploadedByName?: Maybe<Scalars['String']>;
};

/** The SendGrid Marketing list mirroring a group's students. */
export type SendgridGroupListType = {
  __typename?: 'SendgridGroupListType';
  id: Scalars['ID'];
  sendgridListId: Scalars['String'];
  name: Scalars['String'];
  /** Contacts confirmed by the last finished import — not necessarily the current roster size. */
  contactCount: Scalars['Int'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  errorMessage: Scalars['String'];
  lastSyncStatus?: Maybe<Scalars['String']>;
};

/**
 * One row of the ERP recipient picker: a student plus, when relevant, the
 * most recent unpaid invoice we would reference in the email.
 */
export type GroupMailCandidateType = {
  __typename?: 'GroupMailCandidateType';
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  agreementTitle?: Maybe<Scalars['String']>;
  /** True when every agreement of the student in this group is terminated. Only ever true when the query was asked with includeTerminated. */
  agreementTerminated: Scalars['Boolean'];
  invoiceId?: Maybe<Scalars['ID']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceIssueDate?: Maybe<Scalars['Date']>;
  invoiceDueDate?: Maybe<Scalars['Date']>;
  invoiceOutstanding?: Maybe<Scalars['Float']>;
  invoiceCurrency?: Maybe<Scalars['String']>;
  invoiceUrl?: Maybe<Scalars['String']>;
  isOverdue: Scalars['Boolean'];
  daysOverdue: Scalars['Int'];
  lastMailedAt?: Maybe<Scalars['DateTime']>;
};

/** A mailing run: live send progress plus aggregate delivery telemetry. */
export type MailJobType = {
  __typename?: 'MailJobType';
  id: Scalars['ID'];
  templateId: Scalars['String'];
  templateName: Scalars['String'];
  fromEmail: Scalars['String'];
  /** Blank ⇒ the template's own subject is used. */
  subjectOverride: Scalars['String'];
  total: Scalars['Int'];
  sentCount: Scalars['Int'];
  failedCount: Scalars['Int'];
  errorMessage: Scalars['String'];
  createdAt: Scalars['DateTime'];
  startedAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  recipients: Array<MailRecipientType>;
  deliveredCount: Scalars['Int'];
  openedCount: Scalars['Int'];
  clickedCount: Scalars['Int'];
  bouncedCount: Scalars['Int'];
};

/** Per-recipient outcome: whether we sent it, and what SendGrid reported. */
export type MailRecipientType = {
  __typename?: 'MailRecipientType';
  id: Scalars['ID'];
  /** Snapshot of the address used — the account email may change later. */
  email: Scalars['String'];
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  deliveredAt?: Maybe<Scalars['DateTime']>;
  firstOpenedAt?: Maybe<Scalars['DateTime']>;
  openCount: Scalars['Int'];
  firstClickedAt?: Maybe<Scalars['DateTime']>;
  clickCount: Scalars['Int'];
  lastClickUrl: Scalars['String'];
  bouncedAt?: Maybe<Scalars['DateTime']>;
  bounceReason: Scalars['String'];
  droppedAt?: Maybe<Scalars['DateTime']>;
  dropReason: Scalars['String'];
  spamAt?: Maybe<Scalars['DateTime']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceOutstanding?: Maybe<Scalars['Float']>;
  invoiceCurrency?: Maybe<Scalars['String']>;
};

/**
 * Parent is {'lesson': GroupLesson, 'assignment': Material|None,
 * 'has_teacher_assignment': bool, 'submission': ..., 'hw_mark': ...,
 * 'can_submit': bool} from services.roster.my_lesson_homework.
 * 
 * The assignment is optional (rev.3): when the teacher created nothing,
 * `has_teacher_assignment` is False, `title`/`text` are null, and the LMS
 * shows a "see the lesson materials" note over an open submit form.
 */
export type HomeworkAssignmentForStudentType = {
  __typename?: 'HomeworkAssignmentForStudentType';
  id: Scalars['ID'];
  lessonId: Scalars['ID'];
  hasTeacherAssignment: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textbookRef?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  mySubmission?: Maybe<MyHomeworkSubmissionType>;
  canSubmit: Scalars['Boolean'];
};

/** Parent is {'submission': HomeworkSubmission, 'hw_mark': str|None}. */
export type MyHomeworkSubmissionType = {
  __typename?: 'MyHomeworkSubmissionType';
  id: Scalars['ID'];
  githubUrl?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  attempt: Scalars['Int'];
  submittedAt: Scalars['DateTime'];
  hwMark?: Maybe<Scalars['String']>;
  teacherComment?: Maybe<Scalars['String']>;
};

/** Parent is a materials.Material (kind=HOMEWORK). Staff-facing. */
export type HomeworkAssignmentType = {
  __typename?: 'HomeworkAssignmentType';
  id: Scalars['ID'];
  lessonId: Scalars['ID'];
  title: Scalars['String'];
  text: Scalars['String'];
  textbookRef: Scalars['String'];
  dueDate?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['DateTime'];
};

/**
 * Parent is {'student': Student, 'submission': HomeworkSubmission|None,
 * 'hw_mark': str|None} from services.roster.
 */
export type HomeworkRosterRowType = {
  __typename?: 'HomeworkRosterRowType';
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  hwMark?: Maybe<Scalars['String']>;
  submission?: Maybe<HomeworkSubmissionType>;
};

/**
 * Parent is a HomeworkSubmission (ai_review/graded_by select_related
 * by the services). Staff-facing.
 */
export type HomeworkSubmissionType = {
  __typename?: 'HomeworkSubmissionType';
  id: Scalars['ID'];
  githubUrl?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  attempt: Scalars['Int'];
  submittedAt: Scalars['DateTime'];
  teacherComment?: Maybe<Scalars['String']>;
  gradedAt?: Maybe<Scalars['DateTime']>;
  gradedByName?: Maybe<Scalars['String']>;
  aiReview?: Maybe<HomeworkAiReviewType>;
};

/**
 * Parent is a HomeworkAiReview. Staff-facing ONLY — never reachable
 * from the student types below.
 */
export type HomeworkAiReviewType = {
  __typename?: 'HomeworkAiReviewType';
  status: Scalars['String'];
  aiScore?: Maybe<Scalars['Int']>;
  aiSummary?: Maybe<Scalars['String']>;
  aiJustification?: Maybe<Scalars['String']>;
  suspiciousContent: Scalars['Boolean'];
  suspicionNotes?: Maybe<Scalars['String']>;
  aiModel?: Maybe<Scalars['String']>;
  promptVersion?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  analyzedAt?: Maybe<Scalars['DateTime']>;
  truncatedBasis?: Maybe<Scalars['Boolean']>;
  filesUsedCount?: Maybe<Scalars['Int']>;
  assignmentSource?: Maybe<Scalars['String']>;
};

/**
 * Файл учебника занятия — `groups.StudentAttachment` (ТЗ 0026).
 * 
 * ⚠️ Ссылки здесь НЕТ намеренно. `LessonAttachmentsType.resolve_file`
 * минтит presigned-URL с TTL 20 секунд; положив его в карточку ДЗ, мы бы
 * отдали студенту заведомо протухшую ссылку. Клиент получает `id` и
 * открывает файл существующим просмотрщиком, который минтит URL в момент
 * клика.
 */
export type LessonTextbookFileType = {
  __typename?: 'LessonTextbookFileType';
  id: Scalars['ID'];
  title: Scalars['String'];
  fileName: Scalars['String'];
  isPdf: Scalars['Boolean'];
};

/** Parent is a history dict from services.roster (ERP student card). */
export type StudentHomeworkRowType = {
  __typename?: 'StudentHomeworkRowType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  assignmentTitle: Scalars['String'];
  hwMark?: Maybe<Scalars['String']>;
  submission?: Maybe<HomeworkSubmissionType>;
};

/**
 * Одна ячейка «студент × занятие» для журнала ERP (ТЗ 0026).
 * 
 * Оценка за домашку не была видна в журнале ВООБЩЕ — только в двух вкладках
 * ДЗ. Матрица считается одним батчем на группу: журнал самая горячая таблица
 * ERP, и поштучный запрос на сорок занятий там недопустим.
 */
export type StudentLessonHwMarkType = {
  __typename?: 'StudentLessonHwMarkType';
  lessonId: Scalars['ID'];
  studentId: Scalars['ID'];
  hwMark?: Maybe<Scalars['String']>;
  submitted: Scalars['Boolean'];
};

/**
 * Parent is a SurveyAssignment from the pending service (survey +
 * group + trigger lesson select_related, questions prefetched) — the full
 * payload the fill page needs, no second query.
 */
export type PendingSurveyType = {
  __typename?: 'PendingSurveyType';
  assignmentId: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  groupName: Scalars['String'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  /** Who the teacher_rating / teacher_comment questions are about — the trigger lesson's teacher. Null when the lesson has none; the client then omits the attribution line rather than asking to rate an unnamed person. */
  teacherName?: Maybe<Scalars['String']>;
  questions: Array<SurveyQuestionForStudentType>;
};

/** Parent is a SurveyQuestion instance. */
export type SurveyQuestionForStudentType = {
  __typename?: 'SurveyQuestionForStudentType';
  id: Scalars['ID'];
  number: Scalars['Int'];
  text: Scalars['String'];
  questionType: Scalars['String'];
  required: Scalars['Boolean'];
  options: Array<Scalars['String']>;
};

/**
 * Parent is a SurveyResponse of the logged-in student (spec 0027).
 * 
 * Includes the student's own answers — their own data. The resolver derives
 * the student from the token and takes no `studentId`, which is exactly what
 * made the original `pendingSurveysCount` an IDOR.
 */
export type SubmittedSurveyType = {
  __typename?: 'SubmittedSurveyType';
  responseId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  groupName: Scalars['String'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  submittedAt: Scalars['DateTime'];
  questions: Array<SurveyQuestionForStudentType>;
  answers: Array<SurveyAnswerViewType>;
};

/** Parent is a SurveyAnswer. */
export type SurveyAnswerViewType = {
  __typename?: 'SurveyAnswerViewType';
  questionId: Scalars['ID'];
  value: Scalars['JSONString'];
};

/**
 * A teacher's own aggregate view (LMS scope, behind
 * SURVEY_TEACHER_SELF_VIEW_ENABLED).
 * 
 * There is deliberately NO comments field: surveys are именные, and a field
 * that sometimes returns comment text is a field someone eventually fills.
 * No per-group split either — a group is too small to be anonymous.
 */
export type MyTeachingFeedbackType = {
  __typename?: 'MyTeachingFeedbackType';
  ratingsCount: Scalars['Int'];
  /** Null until at least SURVEY_TEACHER_SELF_VIEW_MIN_RATINGS ratings exist (k-anonymity). `ratingsCount` is reported honestly so the teacher can see why. */
  average?: Maybe<Scalars['Float']>;
  byCourse: Array<TeacherRatingBucketType>;
};

/** A per-course or per-group split: {'id', 'name', 'average', 'count'}. */
export type TeacherRatingBucketType = {
  __typename?: 'TeacherRatingBucketType';
  id: Scalars['ID'];
  name: Scalars['String'];
  average?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
};

/**
 * Parent is a Survey instance (course select_related, questions
 * prefetched by the queries).
 */
export type SurveyType = {
  __typename?: 'SurveyType';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  defaultLessonNumber?: Maybe<Scalars['Int']>;
  isArchived: Scalars['Boolean'];
  hasResponses: Scalars['Boolean'];
  questionsCount: Scalars['Int'];
  assignmentsCount: Scalars['Int'];
  /** Spec 0038 — names of the groups this survey is attached to (capped). The list used to show only a count, which answered «сколько» but never «какие». */
  groupNames: Array<Scalars['String']>;
  questions: Array<SurveyQuestionType>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

/** Parent is a SurveyQuestion instance. */
export type SurveyQuestionType = {
  __typename?: 'SurveyQuestionType';
  id: Scalars['ID'];
  number: Scalars['Int'];
  text: Scalars['String'];
  questionType: Scalars['String'];
  /** Spec 0038 — what the question measures, independent of how it is asked: lesson | teacher | materials | homework | platform | support | nps, or '' when untagged. This is what makes pooling one metric across DIFFERENT surveys meaningful. Editable even after the survey has answers. */
  metric: Scalars['String'];
  required: Scalars['Boolean'];
  options: Array<Scalars['String']>;
};

/**
 * Parent is a SurveyAssignment (survey/group/trigger_lesson+module
 * select_related by the queries).
 */
export type SurveyAssignmentType = {
  __typename?: 'SurveyAssignmentType';
  id: Scalars['ID'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  lessonDate?: Maybe<Scalars['Date']>;
  isActive: Scalars['Boolean'];
  /** 'manual' | 'plan' (spec 0027). Survives the rule's deletion, so the UI can still say «создано правилом». */
  origin: Scalars['String'];
  /** The targeting rule that owns this row; null for a manual attach, and for a rule-made row whose rule was deleted. */
  planId?: Maybe<Scalars['ID']>;
  respondedCount: Scalars['Int'];
  eligibleCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
};

/** Parent is the dict built by services.results.assignment_results. */
export type SurveyAssignmentResultsType = {
  __typename?: 'SurveyAssignmentResultsType';
  assignment: SurveyAssignmentType;
  respondents: Array<SurveyRespondentStatusType>;
  questionResults: Array<SurveyQuestionResultType>;
};

/** Parent is {'student': Student, 'response': SurveyResponse|None}. */
export type SurveyRespondentStatusType = {
  __typename?: 'SurveyRespondentStatusType';
  studentId: Scalars['ID'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  responded: Scalars['Boolean'];
  submittedAt?: Maybe<Scalars['DateTime']>;
  responseId?: Maybe<Scalars['ID']>;
};

/** Parent is the dict built by services.results._aggregate. */
export type SurveyQuestionResultType = {
  __typename?: 'SurveyQuestionResultType';
  question: SurveyQuestionType;
  answersCount: Scalars['Int'];
  average?: Maybe<Scalars['Float']>;
  distribution: Array<SurveyDistributionBucketType>;
};

/** Parent is {'key', 'label', 'count'}. */
export type SurveyDistributionBucketType = {
  __typename?: 'SurveyDistributionBucketType';
  key: Scalars['String'];
  label: Scalars['String'];
  count: Scalars['Int'];
};

/** Parent is {'response': SurveyResponse, 'answers': [SurveyAnswer]}. */
export type SurveyResponseDetailType = {
  __typename?: 'SurveyResponseDetailType';
  responseId: Scalars['ID'];
  studentId: Scalars['ID'];
  fullName: Scalars['String'];
  submittedAt: Scalars['DateTime'];
  answers: Array<SurveyAnswerViewType>;
};

/**
 * Parent is the dict built by services.results.survey_summary (0027).
 * 
 * The per-question maths is the SAME `_aggregate` the per-assignment screen
 * uses, on a wider value pool — so the two screens can never disagree about
 * the same answers.
 */
export type SurveySummaryType = {
  __typename?: 'SurveySummaryType';
  survey: SurveyType;
  assignmentsCount: Scalars['Int'];
  groupsCount: Scalars['Int'];
  respondedCount: Scalars['Int'];
  eligibleCount: Scalars['Int'];
  responseRate?: Maybe<Scalars['Float']>;
  questionResults: Array<SurveyQuestionResultType>;
  groupBreakdown: Array<SurveyGroupBreakdownType>;
};

/**
 * One attachment of a survey to a group.
 * 
 * Parent is a row of `services.assignments.survey_assignment_rows`, shared
 * verbatim by `surveySummary.groupBreakdown` and by `surveyAssignments`
 * (spec 0038) — the two directions of the same fact, so they must not be
 * built twice.
 * 
 * The name reads oddly for the survey-side query: it is kept because
 * renaming would change the generated TS type and break the ERP's existing
 * summary consumers for no functional gain. Additive fields are free.
 */
export type SurveyGroupBreakdownType = {
  __typename?: 'SurveyGroupBreakdownType';
  assignmentId: Scalars['ID'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  lessonDate?: Maybe<Scalars['Date']>;
  teacherId?: Maybe<Scalars['ID']>;
  teacherName?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  origin: Scalars['String'];
  planId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  respondedCount: Scalars['Int'];
  eligibleCount: Scalars['Int'];
  /** Percent, or null when nobody is eligible — «никого не спрашивали» is not the same fact as 0%. */
  responseRate?: Maybe<Scalars['Float']>;
  averageRating?: Maybe<Scalars['Float']>;
  /** Spec 0038 — mean of the 0–100 normalized scale answers. */
  avgScore?: Maybe<Scalars['Float']>;
  /** Spec 0038 — percent of responses containing at least one bad answer. Counted off the WORST answer, not the mean: 5★ everywhere and 1★ to the teacher is a negative response. */
  negativeShare?: Maybe<Scalars['Float']>;
};

/** Parent is the report dict from services.plans / builder. */
export type SurveyTargetingType = {
  __typename?: 'SurveyTargetingType';
  plans: Array<SurveyPlanType>;
  assignmentsCreated: Scalars['Int'];
  assignmentsAdopted: Scalars['Int'];
  assignmentsDeactivated: Scalars['Int'];
  assignmentsDeleted: Scalars['Int'];
  skipped: Array<SurveyTargetingSkipType>;
};

/** Parent is a SurveyPlan instance. */
export type SurveyPlanType = {
  __typename?: 'SurveyPlanType';
  id: Scalars['ID'];
  scope: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  onlyActiveGroups: Scalars['Boolean'];
  triggerKind: Scalars['String'];
  triggerLessonNumber?: Maybe<Scalars['Int']>;
  skipPastLessons: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  /** The groups the rule points at RIGHT NOW — the frozen list for scope=groups, the derived one for scope=course (so a group created after the rule shows up here). */
  groups: Array<SurveyPlanGroupRefType>;
  assignmentsCount: Scalars['Int'];
  respondedCount: Scalars['Int'];
  /** Once true, the rule's trigger is frozen (PLAN_LOCKED) — add a second rule instead of moving it. */
  hasResponses: Scalars['Boolean'];
};

/** Parent is a Group the rule currently points at. */
export type SurveyPlanGroupRefType = {
  __typename?: 'SurveyPlanGroupRefType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
};

/**
 * Parent is a dict from services.plans (`skipped[]`).
 * 
 * A populated list alongside `success: true` is the NORMAL outcome — the
 * rule saved, some groups just have no lesson N.
 */
export type SurveyTargetingSkipType = {
  __typename?: 'SurveyTargetingSkipType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  reason: Scalars['String'];
};

/**
 * Parent is the dict from services.teacher_insight.
 * `comments` reuses the existing TeacherStudentCommentType so the ERP renders
 * the same shape it already renders on the teacher profile.
 */
export type TeacherSurveyFeedbackReportType = {
  __typename?: 'TeacherSurveyFeedbackReportType';
  teacherId: Scalars['ID'];
  teacherName: Scalars['String'];
  average?: Maybe<Scalars['Float']>;
  ratingsCount: Scalars['Int'];
  commentsCount: Scalars['Int'];
  trend: Array<TeacherRatingPointType>;
  byCourse: Array<TeacherRatingBucketType>;
  byGroup: Array<TeacherRatingBucketType>;
  comments: Array<TeacherStudentCommentType>;
};

/** One trend bucket: {'period': 'YYYY-MM'|'YYYY-Qn', 'average', 'count'}. */
export type TeacherRatingPointType = {
  __typename?: 'TeacherRatingPointType';
  period: Scalars['String'];
  average?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
};

/** Parent is a row of services.teacher_insight.teacher_leaderboard. */
export type TeacherLeaderboardRowType = {
  __typename?: 'TeacherLeaderboardRowType';
  teacherId: Scalars['ID'];
  teacherName: Scalars['String'];
  average?: Maybe<Scalars['Float']>;
  ratingsCount: Scalars['Int'];
  commentsCount: Scalars['Int'];
  coursesCount: Scalars['Int'];
  /** False when the teacher has fewer than `minResponses` ratings. The row is still returned — «данных мало» is a finding, and hiding it would imply there is no problem. */
  enoughData: Scalars['Boolean'];
};

/**
 * Parent is the dict built by services.targeting_preview.
 * 
 * The point of this type is that «в группе нет занятия №8» becomes a greyed
 * row with a reason BEFORE the manager saves, instead of an entry in the
 * skip report afterwards.
 */
export type SurveyTargetGroupType = {
  __typename?: 'SurveyTargetGroupType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  lessonsCount: Scalars['Int'];
  isActive: Scalars['Boolean'];
  resolvedLessonId?: Maybe<Scalars['ID']>;
  resolvedLessonName?: Maybe<Scalars['String']>;
  resolvedLessonNumber?: Maybe<Scalars['Int']>;
  resolvedLessonDate?: Maybe<Scalars['Date']>;
  resolvedLessonIsOver: Scalars['Boolean'];
  /** NO_LESSON | LESSON_OVER | COURSE_MISMATCH, or null when the group would be attached cleanly. */
  skipReason?: Maybe<Scalars['String']>;
  alreadyAttached: Scalars['Boolean'];
};

/** One bucket of the chosen dimension. */
export type SurveyAnalyticsRowType = {
  __typename?: 'SurveyAnalyticsRowType';
  /** null = the «—» bucket (e.g. a lesson with no teacher). The row is still returned. */
  key?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  sortKey: Scalars['String'];
  /** null for the question-level dimensions (metric, question_type): a roster cannot be attributed to a topic. */
  assignmentsCount?: Maybe<Scalars['Int']>;
  /** How many DIFFERENT surveys this bucket pools. avgScore is only comparable within one survey, so the UI greys it out when this is > 1. */
  surveysCount: Scalars['Int'];
  responsesCount: Scalars['Int'];
  studentsCount: Scalars['Int'];
  answersCount: Scalars['Int'];
  eligibleCount?: Maybe<Scalars['Int']>;
  responseRate?: Maybe<Scalars['Float']>;
  avgScore?: Maybe<Scalars['Float']>;
  /** Percent of RESPONSES with at least one bad answer. Null for question-level dimensions — there the answer-level `lowAnswersShare` is the meaningful one. */
  negativeShare?: Maybe<Scalars['Float']>;
  /** 1–5, pooling `rating` + `teacher_rating` exactly as surveySummary does. */
  avgRating?: Maybe<Scalars['Float']>;
  /** 1–10 */
  avgNps?: Maybe<Scalars['Float']>;
  /** 1–5, teacher_rating only */
  avgTeacherRating?: Maybe<Scalars['Float']>;
  yesShare?: Maybe<Scalars['Float']>;
  /** Percent of SCALE ANSWERS at or below the bad-answer cutoff. Defined for every dimension, unlike negativeShare which is response-level. */
  lowAnswersShare?: Maybe<Scalars['Float']>;
};

/**
 * The shared filter for every analytics query.
 * 
 * An InputObjectType on a QUERY deviates from the house style (every other
 * query here takes flat kwargs). It earns the deviation: the same twelve
 * fields feed `surveyAnalytics`, `surveyQuestionBreakdown`, `surveyComments`
 * and `surveySignals` — flat kwargs would be four copies kept in sync by
 * hand, and codegen gives the ERP ONE TS type it can hold as filter-panel
 * state and pass to all of them.
 */
export type SurveyAnalyticsFilter = {
  surveyIds?: Maybe<Array<Scalars['ID']>>;
  courseIds?: Maybe<Array<Scalars['ID']>>;
  groupIds?: Maybe<Array<Scalars['ID']>>;
  teacherIds?: Maybe<Array<Scalars['ID']>>;
  /** Question topics: lesson | teacher | materials | homework | platform | support | nps. Selects QUESTIONS, not attachments — this is what makes «средняя оценка учебника по курсу» meaningful across DIFFERENT surveys. While it is set, avgScore / negativeShare / eligible / responseRate come back null: those are computed across ALL of a response's questions and would otherwise silently answer a different question than the one on screen. */
  metrics?: Maybe<Array<Scalars['String']>>;
  planId?: Maybe<Scalars['ID']>;
  /** Filters the TRIGGER LESSON's date, NOT the submission time. `eligibleCount` is a property of the roster and has no submission date — windowing the numerator while the denominator stays open is what made responseRate wrong before spec 0038. */
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  lessonNumberFrom?: Maybe<Scalars['Int']>;
  lessonNumberTo?: Maybe<Scalars['Int']>;
  /** manual | plan */
  origin?: Maybe<Scalars['String']>;
  onlyActive?: Maybe<Scalars['Boolean']>;
  includeArchivedSurveys?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
};

/**
 * One question, split by a dimension.
 * 
 * Every distribution is produced by the SAME `results._aggregate` the other
 * two result screens use, fed raw `value`s per slice — not re-derived from
 * `numeric_value`. That is the only way `total` can be guaranteed identical
 * to the matching `surveySummary.questionResults` entry, which a parity
 * test asserts field for field.
 */
export type SurveyQuestionBreakdownType = {
  __typename?: 'SurveyQuestionBreakdownType';
  question: SurveyQuestionType;
  dimension: Scalars['String'];
  total: SurveyQuestionResultType;
  slices: Array<SurveyQuestionSliceType>;
};

/** One slice of a single question's answers. */
export type SurveyQuestionSliceType = {
  __typename?: 'SurveyQuestionSliceType';
  key?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  sortKey: Scalars['String'];
  responsesCount: Scalars['Int'];
  result: SurveyQuestionResultType;
};

/** Keyset page over the comment feed. */
export type SurveyCommentPageType = {
  __typename?: 'SurveyCommentPageType';
  items: Array<SurveyCommentType>;
  hasNext: Scalars['Boolean'];
  /** Pass back as `after` for the next page. Null when the feed is exhausted. */
  cursor?: Maybe<Scalars['String']>;
};

/** A free-text answer with everything needed to act on it. */
export type SurveyCommentType = {
  __typename?: 'SurveyCommentType';
  answerId: Scalars['ID'];
  responseId: Scalars['ID'];
  questionId: Scalars['ID'];
  questionText: Scalars['String'];
  metric: Scalars['String'];
  text: Scalars['String'];
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  lessonDate?: Maybe<Scalars['Date']>;
  teacherId?: Maybe<Scalars['ID']>;
  teacherName?: Maybe<Scalars['String']>;
  submittedAt: Scalars['DateTime'];
  score?: Maybe<Scalars['Float']>;
  sentiment: Scalars['String'];
  /** Spec 0098: translation + tags; null until the answer is enriched (or when the AI call failed). */
  insight?: Maybe<SurveyAnswerInsightType>;
};

/**
 * Spec 0098 — the AI reading of one free-text answer. Codes, not
 * captions: `lang` ru|pl|uk|en|other, `sentiment` positive|neutral|
 * negative, `topic` a METRIC slug or `other` — the ERP translates them.
 */
export type SurveyAnswerInsightType = {
  __typename?: 'SurveyAnswerInsightType';
  lang?: Maybe<Scalars['String']>;
  textRu?: Maybe<Scalars['String']>;
  textPl?: Maybe<Scalars['String']>;
  sentiment?: Maybe<Scalars['String']>;
  isProblem: Scalars['Boolean'];
  topic?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
};

/**
 * Respondents × questions for one survey (spec 0038 revision).
 * 
 * The per-assignment screen shows one group's roster and opens ONE student
 * at a time in a drawer; «как отвечают разные люди на один и тот же опрос»
 * meant opening it N times.
 */
export type SurveyResponseMatrixType = {
  __typename?: 'SurveyResponseMatrixType';
  survey: SurveyType;
  questions: Array<SurveyQuestionType>;
  rows: Array<SurveyMatrixRowType>;
};

/** One respondent's row in the answer table. */
export type SurveyMatrixRowType = {
  __typename?: 'SurveyMatrixRowType';
  responseId: Scalars['ID'];
  studentId: Scalars['ID'];
  fullName: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  submittedAt: Scalars['DateTime'];
  score?: Maybe<Scalars['Float']>;
  sentiment: Scalars['String'];
  answers: Array<SurveyMatrixAnswerType>;
};

/**
 * One cell of the answer table.
 * 
 * Its own type rather than a reuse of `SurveyAnswerViewType`: that one
 * resolves attributes off a SurveyAnswer MODEL, and the matrix builds plain
 * dicts (it never loads the objects). Reusing it produced a resolver error
 * at exactly one path in the response — invisible to a service-level test,
 * caught only by opening the screen.
 */
export type SurveyMatrixAnswerType = {
  __typename?: 'SurveyMatrixAnswerType';
  questionId: Scalars['ID'];
  value: Scalars['JSONString'];
};

/** One question on the bulk-tagging screen (spec 0038). */
export type SurveyQuestionTagRowType = {
  __typename?: 'SurveyQuestionTagRowType';
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  text: Scalars['String'];
  questionType: Scalars['String'];
  metric: Scalars['String'];
  /** Keyword guess for an untagged question, '' when unsure. A human confirms every row — a wrong guess costs one click, a missing one costs reading the question. */
  suggestedMetric: Scalars['String'];
};

/** Everything the student card's «Опросы» tab shows. */
export type StudentSurveyHistoryType = {
  __typename?: 'StudentSurveyHistoryType';
  studentId: Scalars['ID'];
  fullName: Scalars['String'];
  respondedCount: Scalars['Int'];
  pendingCount: Scalars['Int'];
  avgScore?: Maybe<Scalars['Float']>;
  negativeCount: Scalars['Int'];
  responses: Array<StudentSurveyResponseRowType>;
  pending: Array<StudentSurveyPendingRowType>;
};

/** One answered survey on the student's card. */
export type StudentSurveyResponseRowType = {
  __typename?: 'StudentSurveyResponseRowType';
  responseId: Scalars['ID'];
  assignmentId: Scalars['ID'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  lessonDate?: Maybe<Scalars['Date']>;
  teacherId?: Maybe<Scalars['ID']>;
  teacherName?: Maybe<Scalars['String']>;
  submittedAt: Scalars['DateTime'];
  score?: Maybe<Scalars['Float']>;
  minScore?: Maybe<Scalars['Float']>;
  scoredAnswersCount: Scalars['Int'];
  sentiment: Scalars['String'];
  excerpt?: Maybe<Scalars['String']>;
  questions: Array<SurveyQuestionType>;
  answers: Array<SurveyAnswerViewType>;
};

/** A survey the student was asked but has not answered. */
export type StudentSurveyPendingRowType = {
  __typename?: 'StudentSurveyPendingRowType';
  assignmentId: Scalars['ID'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  lessonDate?: Maybe<Scalars['Date']>;
  teacherName?: Maybe<Scalars['String']>;
};

/** An outlier worth acting on. */
export type SurveySignalType = {
  __typename?: 'SurveySignalType';
  /** low_rating | low_response_rate | high_negative_share | rating_drop | no_responses */
  kind: Scalars['String'];
  dimension: Scalars['String'];
  key?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  value: Scalars['Float'];
  previousValue?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  /** Rows below minSample are suppressed (an under-sampled alert is noise) — but N is always reported for the ones that survive. */
  sampleSize: Scalars['Int'];
  /** warning | critical */
  severity: Scalars['String'];
};

export type SurveyGroupTimelineType = {
  __typename?: 'SurveyGroupTimelineType';
  rows: Array<SurveyTimelineRowType>;
  metrics: Array<SurveyMetricRowType>;
};

/** One assignment of the group (its trigger lesson is over). */
export type SurveyTimelineRowType = {
  __typename?: 'SurveyTimelineRowType';
  assignmentId: Scalars['ID'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  lessonDate?: Maybe<Scalars['Date']>;
  eligible: Scalars['Int'];
  responded: Scalars['Int'];
  /** 0..100, mean of response scores. */
  avgScore?: Maybe<Scalars['Float']>;
  /** % of SCORED responses that are negative. */
  negativeShare?: Maybe<Scalars['Float']>;
  avgRating?: Maybe<Scalars['Float']>;
  avgNps?: Maybe<Scalars['Float']>;
};

/** One topic (METRIC slug; '' = без темы) over the whole group. */
export type SurveyMetricRowType = {
  __typename?: 'SurveyMetricRowType';
  metric: Scalars['String'];
  /** 0..100 — mean of the normalized scale answers. */
  avgScore?: Maybe<Scalars['Float']>;
  answers: Scalars['Int'];
};

/**
 * One student of the group over its surveys (`surveyGroupStudents`).
 * Same roster as `surveyAssignmentResults`, rolled up server-side.
 */
export type SurveyGroupStudentRowType = {
  __typename?: 'SurveyGroupStudentRowType';
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  /** Attachments the student was on the roster of (eligible, or answered and left since). */
  eligible: Scalars['Int'];
  responded: Scalars['Int'];
  /** 0..100, mean of the scored responses; null when none. */
  avgScore?: Maybe<Scalars['Float']>;
  negativeCount: Scalars['Int'];
  lastAnsweredAt?: Maybe<Scalars['DateTime']>;
  /** Newest free-text answer, cut to 300 characters. */
  lastComment?: Maybe<Scalars['String']>;
  lastCommentAt?: Maybe<Scalars['DateTime']>;
  /** AI reading of lastComment; null until enriched. */
  lastCommentInsight?: Maybe<SurveyAnswerInsightType>;
};

/**
 * Spec 0098 AI digest. `status` queued|running|done|failed; the texts
 * are returned only when `done`. `error` starts with a code
 * (`digest_disabled`, `numbers_not_in_facts`, `bad_output`,
 * `model_error`, `stale`).
 */
export type SurveyDigestType = {
  __typename?: 'SurveyDigestType';
  id: Scalars['ID'];
  scope: Scalars['String'];
  scopeId: Scalars['ID'];
  status: Scalars['String'];
  textRu?: Maybe<Scalars['String']>;
  textPl?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  byName?: Maybe<Scalars['String']>;
};

/** Full shape — the serialized scene plus its S3-hosted images. */
export type WhiteboardType = {
  __typename?: 'WhiteboardType';
  id: Scalars['ID'];
  name: Scalars['String'];
  sceneVersion: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  lessons: Array<WhiteboardLessonRefType>;
  sceneJson: Scalars['String'];
  createdAt: Scalars['DateTime'];
  files: Array<WhiteboardFileType>;
};

/**
 * A linked lesson, as shown in the continue-picker. Parent is a
 * GroupLesson instance.
 */
export type WhiteboardLessonRefType = {
  __typename?: 'WhiteboardLessonRefType';
  lessonId: Scalars['ID'];
  lessonName?: Maybe<Scalars['String']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  lessonDate?: Maybe<Scalars['Date']>;
};

/**
 * One image of a board, living on the private bucket rather than inside
 * the scene JSON. `url` is a short-TTL presigned link the client fetches and
 * feeds back to excalidraw via addFiles.
 */
export type WhiteboardFileType = {
  __typename?: 'WhiteboardFileType';
  fileId: Scalars['String'];
  mimeType?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/** Light shape for lists (continue picker) — no scene payload. */
export type WhiteboardMetaType = {
  __typename?: 'WhiteboardMetaType';
  id: Scalars['ID'];
  name: Scalars['String'];
  sceneVersion: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  lessons: Array<WhiteboardLessonRefType>;
};

/**
 * The school-wide component library (spec 0010 rev.2). `itemsJson` is
 * the LibraryItems ARRAY serialized as a string — same size-guard-before-
 * parse rationale as WhiteboardType.sceneJson.
 */
export type WhiteboardLibraryType = {
  __typename?: 'WhiteboardLibraryType';
  itemsJson: Scalars['String'];
  version: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

/**
 * Keyset connection over conversations — the dashboard browser and the
 * student / group / teacher correspondence panels (spec 0031).
 * 
 * The sort key is `COALESCE(last_message_at, epoch)`: a conversation
 * mirrored before its first message has no `last_message_at`, and a cursor
 * over a NULL column cannot page such rows at all. Coalescing keeps them
 * pageable AND keeps them last, exactly where `nulls_last` used to put
 * them.
 */
export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  edges?: Maybe<Array<ConversationEdge>>;
  pageInfo?: Maybe<MessagePageInfo>;
  /** Filtered total, independent of the cursor — the section header's counter. Counted up to a cap; see totalCountCapped. */
  totalCount: Scalars['Int'];
  /** True → there are MORE than totalCount rows and the count stopped at the cap (render «1000+»). A full COUNT over the whole conversation population would be paid on every page. */
  totalCountCapped?: Maybe<Scalars['Boolean']>;
};

export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  node?: Maybe<ConversationType>;
  cursor?: Maybe<Scalars['String']>;
};

export type MessagePageInfo = {
  __typename?: 'MessagePageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  endCursor?: Maybe<Scalars['String']>;
};

/**
 * A group's Slack channel for the whole-group inbox: the configured
 * channel (`ChannelGroupLink`, discovered via `conversations.list`) merged
 * with its `Conversation` mirror when one exists — so channels that haven't
 * received a message yet still appear (fixes the «нет каналов» blank list).
 */
export type GroupChannelRow = {
  __typename?: 'GroupChannelRow';
  slackChannelId: Scalars['String'];
  channelName: Scalars['String'];
  teamId: Scalars['String'];
  conversationId?: Maybe<Scalars['ID']>;
  unreadCount: Scalars['Int'];
  hasUnhandled: Scalars['Boolean'];
  lastMessageAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Keyset (sent_at, id) connection — correct under head inserts, unlike an
 * offset cursor that would skip/dup as new messages arrive.
 */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges?: Maybe<Array<MessageEdge>>;
  pageInfo?: Maybe<MessagePageInfo>;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  node?: Maybe<MessageType>;
  cursor?: Maybe<Scalars['String']>;
};

export type MessageType = {
  __typename?: 'MessageType';
  id: Scalars['ID'];
  externalId: Scalars['String'];
  direction?: Maybe<Scalars['String']>;
  authorExternalId: Scalars['String'];
  authorName: Scalars['String'];
  body: Scalars['String'];
  sentAt: Scalars['DateTime'];
  isRead: Scalars['Boolean'];
  isFlagged: Scalars['Boolean'];
  isHandled: Scalars['Boolean'];
  /** ТЗ 0097: санитизированный HTML письма (пусто — только `body`). Показывать в sandbox-iframe. */
  bodyHtml?: Maybe<Scalars['String']>;
  attachments: Array<MessageAttachmentType>;
  /** Картинки `cid:`, на которые ссылается bodyHtml (только png/jpeg/gif/webp, ≤ 30): адрес на час — подставлять в HTML перед показом, в кеш Apollo не класть. Тред скрыт или нет прав — пусто. Может сходить в Gmail — запрашивать отдельно (`messageInlineImages`). */
  inlineImages: Array<MessageInlineImageType>;
  conversationId?: Maybe<Scalars['ID']>;
  channelName?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  /** Human name of the author: stored author_name (Gmail / reply mirrors) → workspace member name from SlackUserLink (linked student «Фамилия Имя», otherwise Slack display name) → the raw external id. */
  authorDisplay?: Maybe<Scalars['String']>;
  linkedTask?: Maybe<StaffTaskType>;
};

/**
 * ТЗ 0097: вложение письма. Скачивание — `emailAttachmentLink(messageId,
 * index)`.
 */
export type MessageAttachmentType = {
  __typename?: 'MessageAttachmentType';
  index: Scalars['Int'];
  name: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  mime?: Maybe<Scalars['String']>;
  /** `Content-ID` части (без <>, нижний регистр): на неё ссылается HTML письма как `cid:`. */
  contentId?: Maybe<Scalars['String']>;
  /** Часть встроена в письмо (Content-ID или disposition inline). ERP прячет из списка вложений те inline, на которые ссылается HTML. */
  inline: Scalars['Boolean'];
};

/**
 * Картинка `cid:` из HTML письма: подписанная ссылка на час (приватный
 * S3), `Content-Disposition: inline`.
 */
export type MessageInlineImageType = {
  __typename?: 'MessageInlineImageType';
  cid: Scalars['String'];
  url: Scalars['String'];
};

export type StaffTaskType = {
  __typename?: 'StaffTaskType';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  dueDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  assigneeId?: Maybe<Scalars['ID']>;
  assigneeName?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  fromMessage?: Maybe<Scalars['Boolean']>;
  links: Array<TaskLinkType>;
  comments: Array<StaffTaskCommentType>;
  commentsCount: Scalars['Int'];
  attachments: Array<StaffTaskAttachmentType>;
  attachmentsCount: Scalars['Int'];
  /** Первая (по времени загрузки) картинка самой задачи, не реплики — обложка карточки доски (ТЗ 0109). Ссылку на неё даёт `staffTaskImageUrls`. */
  coverAttachmentId?: Maybe<Scalars['ID']>;
};

/**
 * Одна связь задачи — ПЛОСКОЙ записью, а не union'ом из двенадцати типов.
 * 
 * Union заставил бы клиента писать двенадцать инлайн-фрагментов и тянуть
 * тяжёлые типы (`StudentType` со всеми его обходами) ради строки-подписи; к
 * тому же три дофин-типа — вовсе не `DjangoObjectType`. Здесь ровно то, что
 * рисует строка списка: чем является объект, как он называется и жив ли он.
 */
export type TaskLinkType = {
  __typename?: 'TaskLinkType';
  id: Scalars['ID'];
  kind: Scalars['String'];
  objectId: Scalars['ID'];
  /** Подпись объекта. У удалённого объекта — служебная метка; смотрите `missing`. */
  name: Scalars['String'];
  /** Приписка: курс у группы, дата у занятия, e-mail у человека. */
  hint: Scalars['String'];
  /** Объекта больше нет в базе. Связь НЕ прячется: задача без неё теряет причину своего существования — покажите её как «объект удалён» и дайте снять. */
  missing: Scalars['Boolean'];
  /** Когда связь завели. Пусто у подсказок поиска — там связи ещё нет. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Кто завёл связь. Это ВСЯ активность по связям, которую мы честно знаем: снятие нигде не журналируется, строка просто исчезает. */
  createdByName?: Maybe<Scalars['String']>;
  /** Адрес в ERP, если по виду и id его не построить (сигнал маркетинга ведёт в раздел с фильтром сигнала, ТЗ 0088). null — адрес строит фронт по виду и id, как раньше; у удалённого объекта — тоже null. */
  href?: Maybe<Scalars['String']>;
};

/**
 * Реплика в обсуждении задачи (ТЗ 0064).
 * 
 * `authorId` — плоский скаляр, а не объект пользователя, ровно по той же
 * причине, что и у `StaffTaskType.assignee_id`: FK развернулся бы в тип, у
 * которого наружу торчат телефон, роли и обходы на студента с преподавателем.
 * Наружу уходят только id и отображаемое имя.
 */
export type StaffTaskCommentType = {
  __typename?: 'StaffTaskCommentType';
  id: Scalars['ID'];
  body: Scalars['String'];
  authorId?: Maybe<Scalars['ID']>;
  authorName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Когда правили. NULL — не правили ни разу. */
  editedAt?: Maybe<Scalars['DateTime']>;
  attachments: Array<StaffTaskAttachmentType>;
  /** Может ли ЭТОТ пользователь править и удалять реплику. Считает сервер тем же правилом, что и мутации: клиент, сравнивающий id автора сам, заводит вторую копию правила — и она уже разошлась (`UserNode.id` это relay-строка, а `authorId` — сырой ключ). */
  canEdit: Scalars['Boolean'];
};

/**
 * Файл, приложенный к задаче или к реплике (ТЗ 0066).
 * 
 * 🔴 Поля `url` здесь НЕТ и быть не должно. Ссылку минтит отдельный
 * корневой резолвер `staffTaskAttachmentUrl` — по клику. Иначе подписанная
 * ссылка (а это bearer-токен) уезжает в каждый ответ ленты, оседает в
 * Apollo-кеше и в breadcrumbs Sentry, а её TTL начинает тикать в момент
 * показа списка, а не в момент, когда файл понадобился. Правило ТЗ 0016.
 */
export type StaffTaskAttachmentType = {
  __typename?: 'StaffTaskAttachmentType';
  id: Scalars['ID'];
  originalName: Scalars['String'];
  contentType: Scalars['String'];
  sizeBytes: Scalars['Int'];
  /** Считает сервер по СВОЕМУ типу (выведенному из сигнатуры содержимого), а не по расширению имени. */
  isImage: Scalars['Boolean'];
  /** Непусто — файл приложен к реплике обсуждения, а не к самой задаче. */
  commentId?: Maybe<Scalars['ID']>;
  uploadedByName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Может ли ЭТОТ пользователь удалить файл. Считает сервер той же функцией, что охраняет мутацию: клиентская копия правила в этом же окне уже однажды разошлась с серверной. */
  canDelete: Scalars['Boolean'];
};

/**
 * ТЗ 0083: рабочие домены Google Workspace — ERP подсказывает адрес
 * сотрудника по логину, если домен рабочий.
 */
export type StaffMailboxSettingsType = {
  __typename?: 'StaffMailboxSettingsType';
  domains: Array<Scalars['String']>;
};

/**
 * A mailbox available to send FROM (compose a new email).
 * 
 * ТЗ 0078: общий (info@) или личный ящик продавца. Владелец отдаётся только
 * именем — окну «От» нужно подписать ящик, а не раскрыть пользователя.
 */
export type GmailMailboxType = {
  __typename?: 'GmailMailboxType';
  id: Scalars['ID'];
  email: Scalars['String'];
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  isPersonal: Scalars['Boolean'];
  isMine: Scalars['Boolean'];
  ownerName?: Maybe<Scalars['String']>;
};

/**
 * Live progress of a manager-initiated bulk broadcast: the running
 * sent/failed counts plus each recipient's outcome (who it didn't reach and
 * why).
 */
export type BroadcastJobType = {
  __typename?: 'BroadcastJobType';
  id: Scalars['ID'];
  mailboxEmail: Scalars['String'];
  subject: Scalars['String'];
  total: Scalars['Int'];
  sentCount: Scalars['Int'];
  failedCount: Scalars['Int'];
  errorMessage: Scalars['String'];
  createdAt: Scalars['DateTime'];
  startedAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  recipients: Array<BroadcastRecipientType>;
};

/** One student targeted by a bulk broadcast + the delivery outcome. */
export type BroadcastRecipientType = {
  __typename?: 'BroadcastRecipientType';
  id: Scalars['ID'];
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  studentName: Scalars['String'];
};

/**
 * Whether the ACTING manager has an xoxp token for a workspace. The token
 * itself is write-only (never leaves the server).
 */
export type SlackUserTokenStatusType = {
  __typename?: 'SlackUserTokenStatusType';
  hasToken: Scalars['Boolean'];
  slackUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Who a reply to this conversation will be sent as, for the ACTING
 * manager — mirrors services/reply._token_for WITHOUT network healing
 * (read path).
 */
export type ReplyIdentityType = {
  __typename?: 'ReplyIdentityType';
  /** 'manager' | 'bot' | 'mailbox' */
  via: Scalars['String'];
  /** Human name; '' → the frontend renders its localized fallback (e.g. «Slack-бот»). */
  name: Scalars['String'];
};

/**
 * The communicator middle-column badge aggregate for one group —
 * computed server-side in two set-based queries (spec 0008). Replaces the
 * frontend's ~10-page conversationsBrowser drain.
 */
export type GroupCommsIndex = {
  __typename?: 'GroupCommsIndex';
  groupId: Scalars['ID'];
  students: Array<StudentCommsBadgeRow>;
  /** Преподаватели, ведущие группу, с теми же счётчиками (ТЗ 0032). Массовая кнопка «обслужить группу» их НЕ трогает — решение владельца. */
  teachers: Array<TeacherCommsBadgeRow>;
  channelsUnread: Scalars['Int'];
  channelsUnhandled: Scalars['Boolean'];
  slackUnreadTotal: Scalars['Int'];
  mailUnreadTotal: Scalars['Int'];
  slackUnhandled: Scalars['Boolean'];
  mailUnhandled: Scalars['Boolean'];
  pendingConversations: Scalars['Int'];
};

/**
 * Per-student communicator badges: one row per roster student (zeroed
 * when they have no conversations) plus `in_roster=False` rows for
 * workspace-DM counterparts outside the roster.
 */
export type StudentCommsBadgeRow = {
  __typename?: 'StudentCommsBadgeRow';
  studentId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  inRoster: Scalars['Boolean'];
  /** True when EVERY agreement of the student in this group is terminated (the frontend hides such a row unless it still has unread messages). */
  terminated: Scalars['Boolean'];
  unread: Scalars['Int'];
  unreadSlack: Scalars['Int'];
  unreadMail: Scalars['Int'];
  /** The student still has at least one INBOUND message no manager has ticked «обработано» — the amber dot. Independent of read state and of dialog status. */
  unhandled: Scalars['Boolean'];
  unhandledSlack: Scalars['Boolean'];
  unhandledMail: Scalars['Boolean'];
};

/**
 * Строка преподавателя в средней колонке коммуникатора (ТЗ 0032).
 * 
 * Та же форма, что у студенческой, минус `in_roster`/`terminated`: у
 * преподавателя нет договора со студенческой семантикой, а «ведёт группу или
 * нет» уже решено самим попаданием в список.
 */
export type TeacherCommsBadgeRow = {
  __typename?: 'TeacherCommsBadgeRow';
  teacherId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  unread: Scalars['Int'];
  unreadSlack: Scalars['Int'];
  unreadMail: Scalars['Int'];
  unhandled: Scalars['Boolean'];
  unhandledSlack: Scalars['Boolean'];
  unhandledMail: Scalars['Boolean'];
};

/** Состояние интеграций переписки: глобальный блок + строка на группу. */
export type CommunicationsHealth = {
  __typename?: 'CommunicationsHealth';
  /** Флаг SLACK_SYNC_ENABLED. Выключен → ежечасного прогона нет вовсе, работают только ручные кнопки. */
  slackSyncEnabled: Scalars['Boolean'];
  gmailSyncEnabled: Scalars['Boolean'];
  lastSlackRun?: Maybe<CommsSyncRunType>;
  lastGmailRun?: Maybe<CommsSyncRunType>;
  mailboxesEnabled: Scalars['Int'];
  groups: Array<CommsGroupHealthRow>;
};

/**
 * Один прогон синхронизации переписки — «когда в последний раз и чем
 * кончилось» (ТЗ 0032).
 */
export type CommsSyncRunType = {
  __typename?: 'CommsSyncRunType';
  id: Scalars['ID'];
  taskName: Scalars['String'];
  status: CommsSyncRunStatus;
  startedAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  errorMessage: Scalars['String'];
  stats?: Maybe<Scalars['JSONString']>;
};

/** An enumeration. */
export enum CommsSyncRunStatus {
  /** Running */
  Running = 'RUNNING',
  /** Success */
  Success = 'SUCCESS',
  /** Failed */
  Failed = 'FAILED',
  /** Retry */
  Retry = 'RETRY',
  /** Partial */
  Partial = 'PARTIAL'
}

/**
 * Состояние интеграции переписки по ОДНОЙ группе (ТЗ 0032).
 * 
 * Главное поле — `verdict`: конкретная причина, по которой данных не видно,
 * а не набор цифр, из которых её надо выводить самому.
 */
export type CommsGroupHealthRow = {
  __typename?: 'CommsGroupHealthRow';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  studentsCount: Scalars['Int'];
  workspaceLinked: Scalars['Boolean'];
  teamId: Scalars['String'];
  workspaceEnabled: Scalars['Boolean'];
  hasBotToken: Scalars['Boolean'];
  /** Задан signing secret — события Slack приходят мгновенно. Без него синхронизация всё равно работает (ежечасно и по кнопке), но вебхук отбивается 403. */
  realtimeConfigured: Scalars['Boolean'];
  /** У ТЕКУЩЕГО менеджера сохранён личный xoxp-токен для этого воркспейса. Без него его личные переписки со студентами не зеркалятся: бот их видеть не может. */
  hasMyManagerToken: Scalars['Boolean'];
  /** Группа попадает в ежечасный прогон (последнее занятие не старше 30 дней либо занятий ещё нет). Вне окна остаётся только ручная кнопка «Обновить сообщения». */
  inSyncWindow: Scalars['Boolean'];
  channelsLinked: Scalars['Int'];
  /** Из привязанных каналов — сколько реально отдали историю. Меньше `channelsLinked` = в остальные бот не приглашён. */
  channelsMirrored: Scalars['Int'];
  membersTotal: Scalars['Int'];
  /** Участников воркспейса, за которыми стоит студент ИЛИ преподаватель. Ноль при ненулевом `membersTotal` — вся переписка считается исходящей и прочитанной, бейджи пусты. */
  membersMatched: Scalars['Int'];
  slackMessages: Scalars['Int'];
  mailThreads: Scalars['Int'];
  lastInboundAt?: Maybe<Scalars['DateTime']>;
  lastSyncAt?: Maybe<Scalars['DateTime']>;
  /** ok / no_workspace / workspace_disabled / no_bot_token / out_of_sync_window / no_channels / bot_not_in_channels / no_matched_members. */
  verdict: Scalars['String'];
};

export type MailSignatureType = {
  __typename?: 'MailSignatureType';
  id: Scalars['ID'];
  /** Пусто — подпись по умолчанию (для любого ящика). */
  mailboxEmail?: Maybe<Scalars['String']>;
  html: Scalars['String'];
  /** "manual" | "gmail" */
  source: Scalars['String'];
  importedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

/**
 * Преподаватель группы, которому можно написать в Slack группы (#58).
 * Только Slack: почты и телефона здесь нет.
 */
export type GroupTeacherContactType = {
  __typename?: 'GroupTeacherContactType';
  teacherId: Scalars['ID'];
  /** Imię i nazwisko. */
  fullName: Scalars['String'];
  /** Фото преподавателя; null — нет. */
  photo?: Maybe<Scalars['String']>;
  /** Личка в приложении Slack (`slack://user?team=<T>&id=<U>`). */
  slackAppUrl: Scalars['String'];
  /** Профиль в браузере (`<адрес workspace>team/<U>`) — запасной вариант без приложения; null, пока адрес workspace не определён. */
  slackWebUrl?: Maybe<Scalars['String']>;
};

export type PaymentCalendarType = {
  __typename?: 'PaymentCalendarType';
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  openingBalancePln?: Maybe<Scalars['Float']>;
  days?: Maybe<Array<Maybe<PaymentCalendarDayType>>>;
  totalIncomePln?: Maybe<Scalars['Float']>;
  totalExpensePln?: Maybe<Scalars['Float']>;
  totalReceivedPln?: Maybe<Scalars['Float']>;
  totalAwaitedPln?: Maybe<Scalars['Float']>;
  totalOverduePln?: Maybe<Scalars['Float']>;
  totalToPayPln?: Maybe<Scalars['Float']>;
  minBalancePln?: Maybe<Scalars['Float']>;
  hasShortfall?: Maybe<Scalars['Boolean']>;
  hasRateMissing?: Maybe<Scalars['Boolean']>;
};

export type PaymentCalendarDayType = {
  __typename?: 'PaymentCalendarDayType';
  date?: Maybe<Scalars['Date']>;
  incomeRows?: Maybe<Array<Maybe<PaymentCalendarRowType>>>;
  expenseRows?: Maybe<Array<Maybe<PaymentCalendarRowType>>>;
  receivedRows?: Maybe<Array<Maybe<PaymentCalendarRowType>>>;
  incomeTotalPln?: Maybe<Scalars['Float']>;
  expenseTotalPln?: Maybe<Scalars['Float']>;
  receivedTotalPln?: Maybe<Scalars['Float']>;
  openingBalancePln?: Maybe<Scalars['Float']>;
  endBalancePln?: Maybe<Scalars['Float']>;
  tone?: Maybe<Scalars['String']>;
  hasRateMissing?: Maybe<Scalars['Boolean']>;
};

export type PaymentCalendarRowType = {
  __typename?: 'PaymentCalendarRowType';
  direction?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  incomeState?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  amountPln?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  rateMissing?: Maybe<Scalars['Boolean']>;
  sourceRef?: Maybe<Scalars['String']>;
  plannedPaymentId?: Maybe<Scalars['Int']>;
  relatedGroupId?: Maybe<Scalars['Int']>;
  relatedTeacherId?: Maybe<Scalars['Int']>;
  balanceAfterPln?: Maybe<Scalars['Float']>;
  toneAfter?: Maybe<Scalars['String']>;
  counterpartyName?: Maybe<Scalars['String']>;
  /** Internal FakturowniaInvoice pk — ERP invoice detail page. */
  invoiceId?: Maybe<Scalars['Int']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Fakturownia UI view_url from the mirrored payload; empty when the document has none. */
  invoiceExternalUrl?: Maybe<Scalars['String']>;
  expenseId?: Maybe<Scalars['Int']>;
  contributionId?: Maybe<Scalars['Int']>;
};

export type PlannedPaymentType = {
  __typename?: 'PlannedPaymentType';
  id: Scalars['ID'];
  direction: PlannedPaymentDirection;
  kind: PlannedPaymentKind;
  /** Short label shown in the day cell / row. */
  title: Scalars['String'];
  /** Predicted payment date (user-editable). For recurring templates this is the first occurrence. */
  date: Scalars['Date'];
  currency: PlannedPaymentCurrency;
  comment: Scalars['String'];
  status: PlannedPaymentStatus;
  periodYear?: Maybe<Scalars['Int']>;
  periodMonth?: Maybe<Scalars['Int']>;
  recurrence: PlannedPaymentRecurrence;
  /** 1–31; clamped to the last day of short months. */
  recurrenceDay?: Maybe<Scalars['Int']>;
  /** Inclusive end; empty means open-ended (until changed). */
  recurrenceUntil?: Maybe<Scalars['Date']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  amountPln?: Maybe<Scalars['Float']>;
  categorySlug?: Maybe<Scalars['String']>;
  relatedTeacherId?: Maybe<Scalars['Int']>;
  relatedGroupId?: Maybe<Scalars['Int']>;
  legalEntityId?: Maybe<Scalars['Int']>;
  relatedContributionId?: Maybe<Scalars['Int']>;
  relatedFakturowniaInvoiceId?: Maybe<Scalars['Int']>;
  relatedApplicationId?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PlannedPaymentDirection {
  /** Income */
  Income = 'INCOME',
  /** Expense */
  Expense = 'EXPENSE'
}

/** An enumeration. */
export enum PlannedPaymentKind {
  /** Manual one-off */
  Manual = 'MANUAL',
  /** Recurring template */
  Recurring = 'RECURRING',
  /** Teacher payout override */
  TeacherPayoutOverride = 'TEACHER_PAYOUT_OVERRIDE',
  /** Income override */
  IncomeOverride = 'INCOME_OVERRIDE',
  /** Expense occurrence override */
  ExpenseOccurrenceOverride = 'EXPENSE_OCCURRENCE_OVERRIDE'
}

/** An enumeration. */
export enum PlannedPaymentCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

/** An enumeration. */
export enum PlannedPaymentStatus {
  /** Planned */
  Planned = 'PLANNED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Paid */
  Paid = 'PAID',
  /** Cancelled */
  Cancelled = 'CANCELLED'
}

/** An enumeration. */
export enum PlannedPaymentRecurrence {
  /** Brak */
  None = 'NONE',
  /** Monthly */
  Monthly = 'MONTHLY'
}

export type ExchangeRateType = {
  __typename?: 'ExchangeRateType';
  id: Scalars['ID'];
  currency: ExchangeRateCurrency;
  effectiveFrom: Scalars['Date'];
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  rateToPln?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum ExchangeRateCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

export type CashBalanceSnapshotType = {
  __typename?: 'CashBalanceSnapshotType';
  id: Scalars['ID'];
  asOfDate: Scalars['Date'];
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
  amountPln?: Maybe<Scalars['Float']>;
  legalEntityId?: Maybe<Scalars['Int']>;
};

export type PaymentCalendarSettingsType = {
  __typename?: 'PaymentCalendarSettingsType';
  id: Scalars['ID'];
  /** Day of month M+1 on which month M's lessons are paid. */
  teacherPayoutDay: Scalars['Int'];
  /** Money is expected this many days after invoice/installment date. */
  incomeOffsetDays: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  legalEntityId?: Maybe<Scalars['Int']>;
};

export type CashFlowReportType = {
  __typename?: 'CashFlowReportType';
  grain?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  openingCash?: Maybe<Scalars['Float']>;
  closingCash?: Maybe<Scalars['Float']>;
  /** The day `closingCash` is true as of — the last booked date in the window. Null when the window holds no rows. Show it: the balance is as fresh as the last statement uploaded, which is not the same as today. */
  asOf?: Maybe<Scalars['Date']>;
  /** Does the ledger reach the end of the LAST column shown? False means that column is a part-period drawn like a whole one — mark it. Deliberately a statement about the DATA, not the calendar: July had ended by the wall clock while the statements only reached the 7th, so «Зарплаты, июль = 0» read as «зарплат не платили» rather than as «ещё не загружено». The row count cannot substitute: those seven days carried 30 operations, comfortably above any thin-period threshold. */
  lastPeriodComplete?: Maybe<Scalars['Boolean']>;
  periods?: Maybe<Array<Maybe<CashFlowPeriodType>>>;
  rows?: Maybe<Array<Maybe<CashFlowRowType>>>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalReturns?: Maybe<Scalars['Float']>;
  totalOutflow?: Maybe<Scalars['Float']>;
  totalOperatingCashFlow?: Maybe<Scalars['Float']>;
  totalFunding?: Maybe<Scalars['Float']>;
  /** Сумм без курса в PLN, не вошедших в итоги: банковские операции не в PLN и стартовые остатки (`opening_balance`) счетов не в PLN. Валюта счёта как злотые не складывается. */
  rateMissingCount?: Maybe<Scalars['Int']>;
  internalExcludedCount?: Maybe<Scalars['Int']>;
  /** Average monthly OPERATING outflow over the trailing complete months. Null when operations are not consuming cash. Owner funding is excluded — money put in is not the business paying for itself. */
  monthlyBurnPln?: Maybe<Scalars['Float']>;
  /** Months the current cash covers at that burn. Null means not burning, not «infinite». */
  runwayMonths?: Maybe<Scalars['Float']>;
  /** Invoiced beside received, for the same window. */
  accrual?: Maybe<AccrualComparisonType>;
};

export type CashFlowPeriodType = {
  __typename?: 'CashFlowPeriodType';
  /** 2026-03 | 2026 Q1 | 2026 — never a localised label: the server does not know the viewer's language. */
  key?: Maybe<Scalars['String']>;
  /** Money in, income categories only. */
  revenue?: Maybe<Scalars['Float']>;
  /** Money in that landed in a NON-income category — a supplier refund, a tax rebate. Positive. Without it `revenue - outflow` does not equal `net`. */
  returns?: Maybe<Scalars['Float']>;
  /** Positive number. */
  outflow?: Maybe<Scalars['Float']>;
  operatingCashFlow?: Maybe<Scalars['Float']>;
  /** Signed: an owner withdrawal stays on the financing line rather than becoming an operating expense. */
  funding?: Maybe<Scalars['Float']>;
  /** revenue + returns + funding - outflow, exactly. */
  net?: Maybe<Scalars['Float']>;
  /** Running balance over the WHOLE history, not the window. */
  cash?: Maybe<Scalars['Float']>;
  /** Operations behind the column. A month built from three rows draws exactly like a month built from a hundred. */
  rows?: Maybe<Scalars['Int']>;
};

export type CashFlowRowType = {
  __typename?: 'CashFlowRowType';
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  /** 0 = group, 1 = category. */
  level?: Maybe<Scalars['Int']>;
  parentKey?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  hasChildren?: Maybe<Scalars['Boolean']>;
  /** Positional, aligned to `periods`, explicit zeros. */
  values?: Maybe<Array<Maybe<Scalars['Float']>>>;
  total?: Maybe<Scalars['Float']>;
};

/**
 * Invoiced against received. A reading, never a check.
 * 
 * The two are supposed to differ — timing, the gateway's fee, receipts with no
 * invoice — so a gate on them could never go green. Shown side by side so the
 * size of the gap is visible, and named so it is not mistaken for a defect.
 */
export type AccrualComparisonType = {
  __typename?: 'AccrualComparisonType';
  /** Gross of PLN invoices ISSUED in the window. */
  invoiced?: Maybe<Scalars['Float']>;
  /** Cash actually received in the window (the revenue line). */
  received?: Maybe<Scalars['Float']>;
  /** received − invoiced. */
  difference?: Maybe<Scalars['Float']>;
  invoiceCount?: Maybe<Scalars['Int']>;
};

export type BankTransactionPage = {
  __typename?: 'BankTransactionPage';
  items?: Maybe<Array<Maybe<BankTransactionType>>>;
  totalCount?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  summary?: Maybe<BankTransactionSummary>;
};

export type BankTransactionType = {
  __typename?: 'BankTransactionType';
  pk?: Maybe<Scalars['Int']>;
  accountId?: Maybe<Scalars['Int']>;
  accountName?: Maybe<Scalars['String']>;
  bookedAt?: Maybe<Scalars['Date']>;
  /** Signed: outflow is negative, as in the statement. */
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  amountPln?: Maybe<Scalars['Float']>;
  balanceAfter?: Maybe<Scalars['Float']>;
  direction?: Maybe<Scalars['String']>;
  rawType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  counterpartyName?: Maybe<Scalars['String']>;
  counterpartyIban?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  invoiceNumberHint?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  categoryGroup?: Maybe<Scalars['String']>;
  categorySource?: Maybe<Scalars['String']>;
  appliedRuleId?: Maybe<Scalars['Int']>;
  isInternalTransfer?: Maybe<Scalars['Boolean']>;
  internalSource?: Maybe<Scalars['String']>;
  internalReviewReason?: Maybe<Scalars['String']>;
  dedupBasis?: Maybe<Scalars['String']>;
  needsReview?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<BankTransactionLinkType>>>;
};

/**
 * What explains a transaction.
 * 
 * A link never contributes to the report — the statement is summed from bank
 * rows alone — so it can be added or removed without moving a number.
 */
export type BankTransactionLinkType = {
  __typename?: 'BankTransactionLinkType';
  pk?: Maybe<Scalars['Int']>;
  /** expense | invoice | payment | correction */
  targetType?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['Int']>;
  targetLabel?: Maybe<Scalars['String']>;
  amountPln?: Maybe<Scalars['Float']>;
  matchSource?: Maybe<Scalars['String']>;
  strategy?: Maybe<Scalars['String']>;
  confidence?: Maybe<Scalars['Int']>;
};

export type BankTransactionSummary = {
  __typename?: 'BankTransactionSummary';
  count?: Maybe<Scalars['Int']>;
  inflowPln?: Maybe<Scalars['Float']>;
  outflowPln?: Maybe<Scalars['Float']>;
};

export type BankAccountType = {
  __typename?: 'BankAccountType';
  pk?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  isOwn?: Maybe<Scalars['Boolean']>;
  requiresBalance?: Maybe<Scalars['Boolean']>;
  includeInConsolidated?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  transactionsCount?: Maybe<Scalars['Int']>;
  netAmountPln?: Maybe<Scalars['Float']>;
};

export type CashFlowCategoryType = {
  __typename?: 'CashFlowCategoryType';
  pk?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  learningPolicy?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type CashFlowRuleType = {
  __typename?: 'CashFlowRuleType';
  pk?: Maybe<Scalars['Int']>;
  keyKind?: Maybe<Scalars['String']>;
  keyValue?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  health?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  hitsCount?: Maybe<Scalars['Int']>;
  overridesCount?: Maybe<Scalars['Int']>;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
};

export type CashFlowControlType = {
  __typename?: 'CashFlowControlType';
  transactionsCount?: Maybe<Scalars['Int']>;
  uncategorisedCount?: Maybe<Scalars['Int']>;
  internalCount?: Maybe<Scalars['Int']>;
  internalUnpairedCount?: Maybe<Scalars['Int']>;
  needsReviewCount?: Maybe<Scalars['Int']>;
  heuristicDedupCount?: Maybe<Scalars['Int']>;
  rulesTotal?: Maybe<Scalars['Int']>;
  rulesNeedingAttention?: Maybe<Scalars['Int']>;
  accounts?: Maybe<Array<Maybe<BankAccountType>>>;
  checks?: Maybe<Array<Maybe<CashFlowCheckType>>>;
};

export type CashFlowCheckType = {
  __typename?: 'CashFlowCheckType';
  code?: Maybe<Scalars['String']>;
  /** PASS | REVIEW */
  status?: Maybe<Scalars['String']>;
  /** Russian prose. A fallback and what the logs show — the client builds its own sentence from `code` and `count` so the page is not half-translated. */
  detail?: Maybe<Scalars['String']>;
  /** The specifics, as DATA rather than prose: account names, dates and amounts. Safe to append to a translated sentence, which `detail` is not. */
  subject?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

/** One import run — preview or commit. */
export type BankStatementImportType = {
  __typename?: 'BankStatementImportType';
  pk?: Maybe<Scalars['Int']>;
  fileName?: Maybe<Scalars['String']>;
  fileHash?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  periodFrom?: Maybe<Scalars['Date']>;
  periodTo?: Maybe<Scalars['Date']>;
  rowsTotal?: Maybe<Scalars['Int']>;
  createdCount?: Maybe<Scalars['Int']>;
  duplicateCount?: Maybe<Scalars['Int']>;
  failedCount?: Maybe<Scalars['Int']>;
  balanceGapCount?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['String']>;
  report?: Maybe<Scalars['JSONString']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  createdByName?: Maybe<Scalars['String']>;
};

/**
 * The knobs an operator must be able to turn without a deploy.
 * 
 * `ownPartyNames` is the one the feature cannot start without: until our own
 * names are listed, internal-transfer detection has nothing to match on, and
 * on the history that is 14 transfers showing up as both an expense and
 * revenue.
 */
export type CashFlowSettingsType = {
  __typename?: 'CashFlowSettingsType';
  pk?: Maybe<Scalars['Int']>;
  ownPartyNames?: Maybe<Scalars['String']>;
  internalTransferAutodetect?: Maybe<Scalars['Boolean']>;
  internalTransferWindowDays?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * «Где эти деньги в банке» for one invoice / expense / payment.
 * 
 * A root query rather than a field on `FakturowniaInvoiceType` and friends:
 * those types are shared by both frontends and several features, and widening
 * them for this would churn their generated hooks for consumers that never
 * asked. This is additive and reachable from any card.
 * 
 * `status` is the honest three-way answer, because «пары в банке нет» is a
 * legitimate outcome — 61 % of the expense side is card payments with no
 * document at all, and pretending otherwise would make every SaaS charge look
 * like a problem.
 */
export type DocumentCashFlowType = {
  __typename?: 'DocumentCashFlowType';
  /** linked — есть банковские строки; in_settlement — пришло в составе расчёта шлюза; none — пары в банке не найдено. */
  status?: Maybe<Scalars['String']>;
  totalPln?: Maybe<Scalars['Float']>;
  rows?: Maybe<Array<Maybe<DocumentCashFlowRowType>>>;
  settlementProvider?: Maybe<Scalars['String']>;
  settlementRef?: Maybe<Scalars['String']>;
  settlementBookedAt?: Maybe<Scalars['Date']>;
};

/** One bank row that explains a document. */
export type DocumentCashFlowRowType = {
  __typename?: 'DocumentCashFlowRowType';
  pk?: Maybe<Scalars['Int']>;
  bookedAt?: Maybe<Scalars['Date']>;
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  counterpartyName?: Maybe<Scalars['String']>;
  matchSource?: Maybe<Scalars['String']>;
  confidence?: Maybe<Scalars['Int']>;
};

/**
 * A document this row might be explaining.
 * 
 * Offered rather than applied whenever the answer is not unambiguous: a wrong
 * link is worse than none, because it looks reconciled.
 */
export type MatchCandidateType = {
  __typename?: 'MatchCandidateType';
  targetType?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  confidence?: Maybe<Scalars['Int']>;
  strategy?: Maybe<Scalars['String']>;
};

export type GatewaySettlementType = {
  __typename?: 'GatewaySettlementType';
  pk?: Maybe<Scalars['Int']>;
  provider?: Maybe<Scalars['String']>;
  merchantCode?: Maybe<Scalars['String']>;
  /** The gateway BATCH number. */
  externalRef?: Maybe<Scalars['String']>;
  bookedAt?: Maybe<Scalars['Date']>;
  /** Net of the gateway's fee. */
  amountBank?: Maybe<Scalars['Float']>;
  itemsTotal?: Maybe<Scalars['Float']>;
  /** Σ composition − received. Analytical only — never a row in the cash-flow report. */
  feeAmount?: Maybe<Scalars['Float']>;
  feeSource?: Maybe<Scalars['String']>;
  unallocated?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  bankTransactionId?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<GatewaySettlementItemType>>>;
};

export type GatewaySettlementItemType = {
  __typename?: 'GatewaySettlementItemType';
  pk?: Maybe<Scalars['Int']>;
  invoiceId?: Maybe<Scalars['Int']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  matchSource?: Maybe<Scalars['String']>;
};

/**
 * An invoice that could be inside this batch.
 * 
 * `preselected` marks a greedy set that lands inside the fee band, so the
 * operator starts from a plausible answer instead of an empty list.
 */
export type GatewaySettlementCandidateType = {
  __typename?: 'GatewaySettlementCandidateType';
  invoiceId?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['Date']>;
  amount?: Maybe<Scalars['Float']>;
  preselected?: Maybe<Scalars['Boolean']>;
  alreadyInSettlementId?: Maybe<Scalars['Int']>;
};

/**
 * A received Fakturownia invoice as a candidate for linking to an
 * Expense (the picker in the expense form). A trimmed projection of
 * `FakturowniaInvoice` — only the fields the picker needs to display and to
 * prefill the expense on selection.
 */
export type ReceivedInvoiceForExpenseType = {
  __typename?: 'ReceivedInvoiceForExpenseType';
  pk?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['Date']>;
  paymentTo?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  priceGross?: Maybe<Scalars['Float']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerTaxNo?: Maybe<Scalars['String']>;
  accountingKind?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  /** Invoice status (issued/sent/paid/partial/rejected) — lets the form auto-set the expense to 'paid' when a paid invoice is linked. */
  status?: Maybe<Scalars['String']>;
};

/**
 * One row of an `expense_aggregates` response.
 * 
 * `group` carries the bucket key — a category slug, an ISO month
 * (`YYYY-MM`) or a legal-entity id — depending on the query's
 * `group_by` parameter. `total` is the PLN sum of `amount_pln` (the FX
 * cache) in that bucket, so multi-currency rows aggregate correctly.
 */
export type ExpenseAggregateRow = {
  __typename?: 'ExpenseAggregateRow';
  group?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
};

/**
 * PUBLIC student-facing subset of FakturowniaInvoice for `myInvoices`.
 * 
 * Hand-built (NOT a DjangoObjectType) so nothing can leak — only the
 * whitelisted fields below exist. Fed FakturowniaInvoice instances by
 * `student_invoices_qs`; scalar fields auto-resolve off the model, the rest
 * are cast/computed here. `is_overdue`/`days_overdue` use the standard
 * overdue definition (payment_to < today AND status != 'paid') PLUS a
 * student-facing `outstanding > 0` guard so a fully-covered invoice never
 * reads as overdue with a zero balance.
 * `view_url`/`payment_url` are read from the stored Fakturownia JSON so the
 * student can open (and, where enabled, pay) the invoice on Fakturownia's
 * hosted page — no extra sync/migration needed.
 */
export type StudentInvoiceType = {
  __typename?: 'StudentInvoiceType';
  fakturowniaId?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['Date']>;
  paymentTo?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  priceGross?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  outstanding?: Maybe<Scalars['Float']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  daysOverdue?: Maybe<Scalars['Int']>;
  viewUrl?: Maybe<Scalars['String']>;
  paymentUrl?: Maybe<Scalars['String']>;
  /** This invoice has been amended by at least one correction document; the amounts below are already netted. */
  isCorrected?: Maybe<Scalars['Boolean']>;
  /** Reason taken from the correction document(s), if given. */
  correctionReason?: Maybe<Scalars['String']>;
  /** The document is a proforma (pro-forma, not a tax invoice). The VAT invoice follows after payment. */
  isProforma: Scalars['Boolean'];
  /** Unpaid and past the suspension threshold per the ТЗ 0074 rule, or tied to the student's active suspension. */
  isBlocking: Scalars['Boolean'];
};

/**
 * One bucket of `fakturownia_invoice_aggregates`.
 * 
 * Amounts are summed in each invoice's OWN currency — there is no FX
 * conversion, so a bucket mixes EUR and PLN unless the query splits them
 * (`groupBy: currency`) or filters one (`currency`). `total_outstanding`
 * excludes paid invoices (status='paid' → 0).
 */
export type FakturowniaInvoiceAggregateRow = {
  __typename?: 'FakturowniaInvoiceAggregateRow';
  /** Bucket key — format depends on group_by */
  group?: Maybe<Scalars['String']>;
  totalGross?: Maybe<Scalars['Float']>;
  totalPaid?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
  /** «Ожидаем» — как во вкладке списка счетов ERP: по каждому счёту бакета, кроме корректировок и quotation, его остаток (у оплаченного — 0) плюс остатки ВСЕХ его корректировок (независимо от их даты), не ниже 0. В отличие от `totalOutstanding`, корректировки сами не суммируются: возврат по оплаченному счёту не уменьшает ожидаемые деньги, а корректировка вне периода всё равно уменьшает долг своего счёта. */
  totalExpected?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
};

export type FakturowniaSyncRunType = {
  __typename?: 'FakturowniaSyncRunType';
  id: Scalars['ID'];
  taskName: Scalars['String'];
  status: FakturowniaSyncRunStatus;
  startedAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  errorMessage: Scalars['String'];
  celeryTaskId: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  durationSeconds?: Maybe<Scalars['Float']>;
  /** Счётчики прогона. Ключи `received_*` / `expenses_*` (полученные документы и расходы) — только ролям расходов (Admin, FinanceManager); остальным они не приходят. */
  stats?: Maybe<Scalars['JSONString']>;
};

/** An enumeration. */
export enum FakturowniaSyncRunStatus {
  /** Running */
  Running = 'RUNNING',
  /** Success */
  Success = 'SUCCESS',
  /** Failed */
  Failed = 'FAILED'
}

/**
 * Compact "is the mirror up-to-date?" snapshot for dashboard widgets.
 * 
 * A single object the frontend can poll on a tick: when did the last
 * successful sync finish, how many invoices it touched, and whether a
 * new run is currently in flight (so the spinner stays on).
 */
export type FakturowniaSyncStatus = {
  __typename?: 'FakturowniaSyncStatus';
  /** True while a run is in progress. */
  isRunning?: Maybe<Scalars['Boolean']>;
  /** The most recent run, regardless of outcome. */
  lastRun?: Maybe<FakturowniaSyncRunType>;
  /** The most recent run that finished with status='success'. Use this for 'last synced at HH:MM' captions; `last_run` may carry a fresher 'failed' that hasn't been retried yet. */
  lastSuccess?: Maybe<FakturowniaSyncRunType>;
  /** Invoice-issuing attempts whose outcome is UNKNOWN — a document may exist in Fakturownia that we have no record of. Each one also blocks its installment from being billed again. Non-zero needs attention: an invisible orphan blocks that взнос forever. */
  orphanSuspectedCount?: Maybe<Scalars['Int']>;
};

/**
 * Preflight verdict — «can we issue for this installment, and if not why».
 * 
 * Backed by the SAME `services.billability.check_billability` the mutation
 * and the group job call, so the greyed-out button and the server's answer
 * can never disagree.
 */
export type FakturowniaBillabilityType = {
  __typename?: 'FakturowniaBillabilityType';
  billable: Scalars['Boolean'];
  /** Machine code, empty when billable. */
  reason?: Maybe<Scalars['String']>;
  /** ТЗ 0101: the document kind this verdict is for — 'vat' or 'proforma'. */
  kind?: Maybe<Scalars['String']>;
  agreementId?: Maybe<Scalars['Int']>;
  contributionId?: Maybe<Scalars['Int']>;
  studentName?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  paymentTo?: Maybe<Scalars['Date']>;
  /** Rendered line-item preview — exactly what will be printed on the document. */
  positionName?: Maybe<Scalars['String']>;
  /** The VAT rate that WILL be sent, from settings — e.g. '23' or 'zw'. Lets the UI show the real rate instead of a hardcoded chip. */
  taxRate?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerTaxNo?: Maybe<Scalars['String']>;
  buyerAddress?: Maybe<Scalars['String']>;
  /** Which buyer fields are blank, for MISSING_BUYER_*. */
  missingFields?: Maybe<Array<Scalars['String']>>;
};

export type FakturowniaBillingJobType = {
  __typename?: 'FakturowniaBillingJobType';
  id: Scalars['ID'];
  group: MethodistGroupType;
  createdBy?: Maybe<CustomUserType>;
  status?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  issuedCount: Scalars['Int'];
  skippedCount: Scalars['Int'];
  failedCount: Scalars['Int'];
  documentKind: Scalars['String'];
  paymentTo?: Maybe<Scalars['Date']>;
  celeryTaskId: Scalars['String'];
  errorMessage: Scalars['String'];
  createdAt: Scalars['DateTime'];
  startedAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  rows?: Maybe<Array<FakturowniaBillingJobRowType>>;
  pk?: Maybe<Scalars['Int']>;
};

export type FakturowniaBillingJobRowType = {
  __typename?: 'FakturowniaBillingJobRowType';
  id: Scalars['ID'];
  job: FakturowniaBillingJobType;
  agreement: AgreementType;
  contribution?: Maybe<ContributionType>;
  invoice?: Maybe<FakturowniaInvoiceType>;
  status?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  issuedAt?: Maybe<Scalars['DateTime']>;
  pk?: Maybe<Scalars['Int']>;
  studentName?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  viewUrl?: Maybe<Scalars['String']>;
};

export type FakturowniaGroupBillingPreviewType = {
  __typename?: 'FakturowniaGroupBillingPreviewType';
  total: Scalars['Int'];
  billableCount: Scalars['Int'];
  skippedCount: Scalars['Int'];
  rows: Array<FakturowniaBillabilityType>;
};

/** Everything the standalone dashboard renders, computed server-side. */
export type PandaDocAnalyticsType = {
  __typename?: 'PandaDocAnalyticsType';
  granularity?: Maybe<Scalars['String']>;
  course?: Maybe<Scalars['String']>;
  window?: Maybe<PandaDocWindow>;
  volumeKpi?: Maybe<PandaDocVolumeKpi>;
  ttsKpi?: Maybe<PandaDocTtsKpi>;
  conversionKpi?: Maybe<PandaDocConversionKpi>;
  volumeSeries?: Maybe<PandaDocVolumeSeries>;
  ttsHistogram?: Maybe<PandaDocHistogram>;
  ttsByCourse?: Maybe<Array<Maybe<PandaDocCourseTts>>>;
  ttsMedianSeries?: Maybe<PandaDocTtsMedianSeries>;
  conversionByCourse?: Maybe<Array<Maybe<PandaDocCourseConversion>>>;
  conversionSeries?: Maybe<PandaDocConversionSeriesGroup>;
};

export type PandaDocWindow = {
  __typename?: 'PandaDocWindow';
  docsLoaded?: Maybe<Scalars['Int']>;
  totalInDb?: Maybe<Scalars['Int']>;
  signedCount?: Maybe<Scalars['Int']>;
  minDate?: Maybe<Scalars['Date']>;
  maxDate?: Maybe<Scalars['Date']>;
};

export type PandaDocVolumeKpi = {
  __typename?: 'PandaDocVolumeKpi';
  total?: Maybe<Scalars['Int']>;
  students?: Maybe<Scalars['Int']>;
  trainers?: Maybe<Scalars['Int']>;
  dofin?: Maybe<Scalars['Int']>;
  last30?: Maybe<Scalars['Int']>;
};

export type PandaDocTtsKpi = {
  __typename?: 'PandaDocTTSKpi';
  medianHours?: Maybe<Scalars['Float']>;
  meanHours?: Maybe<Scalars['Float']>;
  pct24h?: Maybe<Scalars['Int']>;
  pct3d?: Maybe<Scalars['Int']>;
  sample?: Maybe<Scalars['Int']>;
};

export type PandaDocConversionKpi = {
  __typename?: 'PandaDocConversionKpi';
  sent?: Maybe<Scalars['Int']>;
  signed?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Int']>;
  lost?: Maybe<Scalars['Int']>;
  signedPct?: Maybe<Scalars['Int']>;
  activePct?: Maybe<Scalars['Int']>;
  lostPct?: Maybe<Scalars['Int']>;
  ratePct?: Maybe<Scalars['Int']>;
};

export type PandaDocVolumeSeries = {
  __typename?: 'PandaDocVolumeSeries';
  students?: Maybe<PandaDocCountSeries>;
  trainers?: Maybe<PandaDocCountSeries>;
  dofin?: Maybe<PandaDocCountSeries>;
};

/** Volume series: a count per timeline bucket. */
export type PandaDocCountSeries = {
  __typename?: 'PandaDocCountSeries';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PandaDocHistogram = {
  __typename?: 'PandaDocHistogram';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PandaDocCourseTts = {
  __typename?: 'PandaDocCourseTTS';
  course?: Maybe<Scalars['String']>;
  avgDays?: Maybe<Scalars['Float']>;
  sample?: Maybe<Scalars['Int']>;
};

export type PandaDocTtsMedianSeries = {
  __typename?: 'PandaDocTTSMedianSeries';
  students?: Maybe<PandaDocTtsSeries>;
  trainers?: Maybe<PandaDocTtsSeries>;
  dofin?: Maybe<PandaDocTtsSeries>;
};

/** Median time-to-sign (days) per bucket; null where the bucket is empty. */
export type PandaDocTtsSeries = {
  __typename?: 'PandaDocTTSSeries';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type PandaDocCourseConversion = {
  __typename?: 'PandaDocCourseConversion';
  course?: Maybe<Scalars['String']>;
  signed?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Int']>;
  lost?: Maybe<Scalars['Int']>;
};

export type PandaDocConversionSeriesGroup = {
  __typename?: 'PandaDocConversionSeriesGroup';
  students?: Maybe<PandaDocConversionSeries>;
  dofin?: Maybe<PandaDocConversionSeries>;
};

/** Sent→signed conversion stacked per bucket. */
export type PandaDocConversionSeries = {
  __typename?: 'PandaDocConversionSeries';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  signed?: Maybe<Array<Maybe<Scalars['Int']>>>;
  active?: Maybe<Array<Maybe<Scalars['Int']>>>;
  lost?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PandaDocDocumentConnection = {
  __typename?: 'PandaDocDocumentConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PandaDocDocumentEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PandaDocDocument` and its cursor. */
export type PandaDocDocumentEdge = {
  __typename?: 'PandaDocDocumentEdge';
  /** The item at the end of the edge */
  node?: Maybe<PandaDocDocumentType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Sync-health snapshot, sourced from `PandaDocSyncState` (req 3). */
export type PandaDocSyncStatusType = {
  __typename?: 'PandaDocSyncStatusType';
  documentsCount?: Maybe<Scalars['Int']>;
  detailsPending?: Maybe<Scalars['Int']>;
  lastListSyncAt?: Maybe<Scalars['DateTime']>;
  lastDetailsSyncAt?: Maybe<Scalars['DateTime']>;
  lastDocumentsPulled?: Maybe<Scalars['Int']>;
  newestDocDate?: Maybe<Scalars['DateTime']>;
  lastRunStatus?: Maybe<Scalars['String']>;
  lastError?: Maybe<Scalars['String']>;
  syncRunning?: Maybe<Scalars['Boolean']>;
};

/** A PandaDoc folder == a study group; groups its signed contracts. */
export type ProvisioningFolder = {
  __typename?: 'ProvisioningFolder';
  folderUuid?: Maybe<Scalars['String']>;
  folderName?: Maybe<Scalars['String']>;
  detectedCourseId?: Maybe<Scalars['ID']>;
  detectedCourseName?: Maybe<Scalars['String']>;
  existingGroupId?: Maybe<Scalars['ID']>;
  existingGroupName?: Maybe<Scalars['String']>;
  studentDocs?: Maybe<Array<Maybe<ProvisioningStudentDoc>>>;
};

/** A signed student contract, ready to be turned into a Student. */
export type ProvisioningStudentDoc = {
  __typename?: 'ProvisioningStudentDoc';
  pandadocId?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  contractUrl?: Maybe<Scalars['String']>;
  phoneMissing?: Maybe<Scalars['Boolean']>;
  userExists?: Maybe<Scalars['Boolean']>;
  studentExists?: Maybe<Scalars['Boolean']>;
  existingUserId?: Maybe<Scalars['ID']>;
  alreadyProvisioned?: Maybe<Scalars['Boolean']>;
};

export type ZoomAccountConnection = {
  __typename?: 'ZoomAccountConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomAccountEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomAccount` and its cursor. */
export type ZoomAccountEdge = {
  __typename?: 'ZoomAccountEdge';
  /** The item at the end of the edge */
  node?: Maybe<ZoomAccountType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ZoomRecordingConnection = {
  __typename?: 'ZoomRecordingConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomRecordingEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomRecording` and its cursor. */
export type ZoomRecordingEdge = {
  __typename?: 'ZoomRecordingEdge';
  /** The item at the end of the edge */
  node?: Maybe<ZoomRecordingType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type LessonRecordingConnection = {
  __typename?: 'LessonRecordingConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LessonRecordingEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `LessonRecording` and its cursor. */
export type LessonRecordingEdge = {
  __typename?: 'LessonRecordingEdge';
  /** The item at the end of the edge */
  node?: Maybe<LessonRecordingType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ZoomLessonConnection = {
  __typename?: 'ZoomLessonConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomLessonEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomLesson` and its cursor. */
export type ZoomLessonEdge = {
  __typename?: 'ZoomLessonEdge';
  /** The item at the end of the edge */
  node?: Maybe<GroupLessonForLmsType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GroupZoomScheduleConnection = {
  __typename?: 'GroupZoomScheduleConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupZoomScheduleEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `GroupZoomSchedule` and its cursor. */
export type GroupZoomScheduleEdge = {
  __typename?: 'GroupZoomScheduleEdge';
  /** The item at the end of the edge */
  node?: Maybe<GroupZoomScheduleType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ZoomProcessingLogConnection = {
  __typename?: 'ZoomProcessingLogConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomProcessingLogEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomProcessingLog` and its cursor. */
export type ZoomProcessingLogEdge = {
  __typename?: 'ZoomProcessingLogEdge';
  /** The item at the end of the edge */
  node?: Maybe<ZoomProcessingLogType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ZoomDashboardType = {
  __typename?: 'ZoomDashboardType';
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  lessonsTotal?: Maybe<Scalars['Int']>;
  lessonsMatched?: Maybe<Scalars['Int']>;
  lessonsMissing?: Maybe<Scalars['Int']>;
  lessonsSkipped?: Maybe<Scalars['Int']>;
  recordingsTotal?: Maybe<Scalars['Int']>;
  recordingsOrphan?: Maybe<Scalars['Int']>;
  pipeline?: Maybe<ZoomDashboardPipelineCounts>;
};

export type ZoomDashboardPipelineCounts = {
  __typename?: 'ZoomDashboardPipelineCounts';
  downloading?: Maybe<Scalars['Int']>;
  uploaded?: Maybe<Scalars['Int']>;
  aiProcessing?: Maybe<Scalars['Int']>;
  aiCompleted?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  failed?: Maybe<Scalars['Int']>;
};

export type ZoomAuditLogConnection = {
  __typename?: 'ZoomAuditLogConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomAuditLogEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomAuditLog` and its cursor. */
export type ZoomAuditLogEdge = {
  __typename?: 'ZoomAuditLogEdge';
  /** The item at the end of the edge */
  node?: Maybe<ZoomAuditLogType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ZoomAuditLogType = Node & {
  __typename?: 'ZoomAuditLogType';
  /** The ID of the object */
  id: Scalars['ID'];
  user?: Maybe<CustomUserType>;
  action: Scalars['String'];
  targetKind: Scalars['String'];
  targetId: Scalars['Int'];
  details: Scalars['JSONString'];
  createdAt: Scalars['DateTime'];
};

export type ZoomAccountUsageType = Node & {
  __typename?: 'ZoomAccountUsageType';
  /** The ID of the object */
  id: Scalars['ID'];
  usersCount: Scalars['Int'];
  recordingsCount: Scalars['Int'];
  filesCount: Scalars['Int'];
  planRecordingType: Scalars['String'];
  planUsageAvailable: Scalars['Boolean'];
  syncedAt: Scalars['DateTime'];
  recordingsSizeBytes?: Maybe<Scalars['Float']>;
  planStorageTotalBytes?: Maybe<Scalars['Float']>;
  planStorageUsedBytes?: Maybe<Scalars['Float']>;
  planStorageFreeBytes?: Maybe<Scalars['Float']>;
  storageUsedPercent?: Maybe<Scalars['Float']>;
};

export type BlogAllArticlesType = {
  __typename?: 'BlogAllArticlesType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
};

export type ArticlesConnection = {
  __typename?: 'ArticlesConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArticlesEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Articles` and its cursor. */
export type ArticlesEdge = {
  __typename?: 'ArticlesEdge';
  /** The item at the end of the edge */
  node?: Maybe<ArticlesType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type SuccessStoriesConnection = {
  __typename?: 'SuccessStoriesConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SuccessStoriesEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SuccessStories` and its cursor. */
export type SuccessStoriesEdge = {
  __typename?: 'SuccessStoriesEdge';
  /** The item at the end of the edge */
  node?: Maybe<SuccessStoriesType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type BlogNativeType = {
  __typename?: 'BlogNativeType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
};

export type NativeInfoConnection = {
  __typename?: 'NativeInfoConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NativeInfoEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `NativeInfo` and its cursor. */
export type NativeInfoEdge = {
  __typename?: 'NativeInfoEdge';
  /** The item at the end of the edge */
  node?: Maybe<NativeInfoType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type CourseCatalogPageType = {
  __typename?: 'CourseCatalogPageType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
};

export type StudentAndCompaniesType = {
  __typename?: 'StudentAndCompaniesType';
  id: Scalars['ID'];
  studentsCount: Scalars['Int'];
  studentsDescription: Scalars['String'];
  companiesDescription: Scalars['String'];
  companyImages: Array<CompanyImageType>;
};

export type CompanyImageType = {
  __typename?: 'CompanyImageType';
  id: Scalars['ID'];
  studentAndCompanies: StudentAndCompaniesType;
  image: Scalars['String'];
};

export type MainPageInfoType = {
  __typename?: 'MainPageInfoType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  image: Scalars['String'];
};

export type StudentsReviewsType = {
  __typename?: 'StudentsReviewsType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  marks: Scalars['Float'];
  marksCount: Scalars['Int'];
  markText: Scalars['String'];
  markCountText: Scalars['String'];
};

export type TeachersPageInfoType = {
  __typename?: 'TeachersPageInfoType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
};

export type BlogGraduateStoryType = {
  __typename?: 'BlogGraduateStoryType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  image: Scalars['String'];
};

export type ContactsPageType = {
  __typename?: 'ContactsPageType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  address: Scalars['String'];
  registrationData: Scalars['String'];
  mainEmail?: Maybe<ContactEmailType>;
  paymentsLogo: Array<PaymentLogoType>;
  emails: Array<ContactEmailType>;
  phones: Array<ContactPhoneType>;
};

export type ContactEmailType = {
  __typename?: 'ContactEmailType';
  id: Scalars['ID'];
  contactsPage: ContactsPageType;
  title: Scalars['String'];
  email: Scalars['String'];
  contactspage?: Maybe<ContactsPageType>;
};

export type PaymentLogoType = {
  __typename?: 'PaymentLogoType';
  id: Scalars['ID'];
  contactsPage: ContactsPageType;
  logo: Scalars['String'];
};

export type ContactPhoneType = {
  __typename?: 'ContactPhoneType';
  id: Scalars['ID'];
  contactsPage: ContactsPageType;
  title: Scalars['String'];
  phone: Scalars['String'];
};

export type PaymentRulesPageType = {
  __typename?: 'PaymentRulesPageType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  rules: Scalars['String'];
};

export type DataProcessingPolicyType = {
  __typename?: 'DataProcessingPolicyType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  publicOfferAgreements: DataProcessingPolicyAgreementTypeConnection;
  actualPublicOfferAgreement?: Maybe<DataProcessingPolicyAgreementType>;
};


export type DataProcessingPolicyTypePublicOfferAgreementsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type DataProcessingPolicyAgreementTypeConnection = {
  __typename?: 'DataProcessingPolicyAgreementTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DataProcessingPolicyAgreementTypeEdge>>;
};

/** A Relay edge containing a `DataProcessingPolicyAgreementType` and its cursor. */
export type DataProcessingPolicyAgreementTypeEdge = {
  __typename?: 'DataProcessingPolicyAgreementTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<DataProcessingPolicyAgreementType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type DataProcessingPolicyAgreementType = Node & {
  __typename?: 'DataProcessingPolicyAgreementType';
  /** The ID of the object */
  id: Scalars['ID'];
  agreementDate: Scalars['Date'];
  content: Scalars['String'];
  file: Scalars['String'];
  displayPage: DataProcessingPolicyType;
};

export type PrivateIndividualPublicOfferPageType = {
  __typename?: 'PrivateIndividualPublicOfferPageType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  publicOfferAgreements: PrivateIndividualPublicOfferAgreementTypeConnection;
  actualPublicOfferAgreement?: Maybe<PrivateIndividualPublicOfferAgreementType>;
};


export type PrivateIndividualPublicOfferPageTypePublicOfferAgreementsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PrivateIndividualPublicOfferAgreementTypeConnection = {
  __typename?: 'PrivateIndividualPublicOfferAgreementTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PrivateIndividualPublicOfferAgreementTypeEdge>>;
};

/** A Relay edge containing a `PrivateIndividualPublicOfferAgreementType` and its cursor. */
export type PrivateIndividualPublicOfferAgreementTypeEdge = {
  __typename?: 'PrivateIndividualPublicOfferAgreementTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<PrivateIndividualPublicOfferAgreementType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type PrivateIndividualPublicOfferAgreementType = Node & {
  __typename?: 'PrivateIndividualPublicOfferAgreementType';
  /** The ID of the object */
  id: Scalars['ID'];
  agreementDate: Scalars['Date'];
  content: Scalars['String'];
  file: Scalars['String'];
  displayPage: PrivateIndividualPublicOfferPageType;
};

export type LegalEntityPublicOfferPageType = {
  __typename?: 'LegalEntityPublicOfferPageType';
  id: Scalars['ID'];
  seoTitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoImage: Scalars['String'];
  title: Scalars['String'];
  publicOfferAgreements: LegalEntityPublicOfferAgreementTypeConnection;
  actualPublicOfferAgreement?: Maybe<LegalEntityPublicOfferAgreementType>;
};


export type LegalEntityPublicOfferPageTypePublicOfferAgreementsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type LegalEntityPublicOfferAgreementTypeConnection = {
  __typename?: 'LegalEntityPublicOfferAgreementTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LegalEntityPublicOfferAgreementTypeEdge>>;
};

/** A Relay edge containing a `LegalEntityPublicOfferAgreementType` and its cursor. */
export type LegalEntityPublicOfferAgreementTypeEdge = {
  __typename?: 'LegalEntityPublicOfferAgreementTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<LegalEntityPublicOfferAgreementType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type LegalEntityPublicOfferAgreementType = Node & {
  __typename?: 'LegalEntityPublicOfferAgreementType';
  /** The ID of the object */
  id: Scalars['ID'];
  agreementDate: Scalars['Date'];
  content: Scalars['String'];
  file: Scalars['String'];
  displayPage: LegalEntityPublicOfferPageType;
};

export type AllStoriesConnection = {
  __typename?: 'AllStoriesConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AllStoriesEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AllStories` and its cursor. */
export type AllStoriesEdge = {
  __typename?: 'AllStoriesEdge';
  /** The item at the end of the edge */
  node?: Maybe<AllStoriesType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type AllStoriesType = ArticlesType | SuccessStoriesType | NativeInfoType;

export type RobotTxtType = {
  __typename?: 'RobotTxtType';
  id: Scalars['ID'];
  robotContent: Scalars['String'];
};

export type UsersSettingsConnection = {
  __typename?: 'UsersSettingsConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UsersSettingsEdge>>;
};

/** A Relay edge containing a `UsersSettings` and its cursor. */
export type UsersSettingsEdge = {
  __typename?: 'UsersSettingsEdge';
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/**
 * Тип пользователя (ТЗ 0021, стадия 4 — база больше не `graphql_auth.schema.UserNode`).
 * 
 * Четыре поля пакета (`pk`, `archived`, `verified`, `secondary_email`) и его
 * `get_queryset` перенесены сюда ВЕРБАТИМНО и объявлены ПЕРВЫМИ: graphene 2
 * складывает поля обходом reversed-MRO, и в текущем SDL они идут именно перед
 * проектными `activeRole`/`methodistGroupsCount`/… — порядок менять нельзя.
 */
export type UserNode = Node & {
  __typename?: 'UserNode';
  /** The ID of the object */
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** Wymagana. 150 lub mniej znaków. Jedynie litery, cyfry i @/./+/-/_. */
  username: Scalars['String'];
  /** Określa czy użytkownik może zalogować się do panelu administracyjnego. */
  isStaff: Scalars['Boolean'];
  /** Określa czy użytkownika należy uważać za aktywnego. Odznacz zamiast usuwać konto. */
  isActive: Scalars['Boolean'];
  dateJoined: Scalars['DateTime'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  teacher?: Maybe<TeacherFilterType>;
  student?: Maybe<StudentType>;
  pk?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  verified?: Maybe<Scalars['Boolean']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  activeRole?: Maybe<Scalars['String']>;
  methodistGroupsCount?: Maybe<Scalars['Int']>;
  lmsAccessBlock?: Maybe<LmsAccessBlockType>;
  pendingSurveysCount?: Maybe<Scalars['Int']>;
  /** Unpaid invoices in «Moje faktury» (LMS token acting as Student, own node only; 0 otherwise). */
  unpaidInvoicesCount: Scalars['Int'];
  /** Of them, past their payment date (LMS token acting as Student, own node only; 0 otherwise). */
  overdueInvoicesCount: Scalars['Int'];
  /** Рабочая почта сотрудника (сам сотрудник и Admin; остальным null) */
  workspaceMailbox?: Maybe<StaffMailboxType>;
};

/**
 * Read-only public subset of `students.StudentAccessBlock` for the LMS.
 * 
 * Only the fields the LMS banner needs — never the operator/audit fields.
 * Resolves to None unless the student is actually blocked, so `me
 * { lmsAccessBlock }` is null for everyone with access.
 * 
 * `reason` holds the operator's internal note and MUST NOT reach the
 * student, so it always resolves to null (see resolve_lms_access_block).
 * The field is kept on the type only so the LMS `UserFields` fragment that
 * still selects `reason` stays valid.
 * 
 * ТЗ 0074: `blocked_at` + `amounts_due` — what the student still owes on the
 * invoices the suspension is tied to, PER CURRENCY (never added up).
 * `overdue_amount` is the pre-0074 single-number snapshot.
 */
export type LmsAccessBlockType = {
  __typename?: 'LmsAccessBlockType';
  isBlocked: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  /** Снимок до ТЗ 0074: сумма, только если все счета в одной валюте, иначе 0. Для показа — `amountsDue`. */
  overdueAmount?: Maybe<Scalars['Float']>;
  blockedAt?: Maybe<Scalars['DateTime']>;
  amountsDue: Array<LmsAmountDueType>;
};

/** An amount in ONE currency (ТЗ 0074) — currencies are never summed. */
export type LmsAmountDueType = {
  __typename?: 'LmsAmountDueType';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

/**
 * ТЗ 0083: рабочая почта сотрудника — с неё он пишет от своего имени,
 * её переписку видит он и Admin.
 */
export type StaffMailboxType = {
  __typename?: 'StaffMailboxType';
  email: Scalars['String'];
  /** Имя отправителя в письме */
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  /** all — переписка со студентами, преподавателями и по договорам; contracts — только по договорам */
  scope: Scalars['String'];
};

export type MetaUsersSettings = {
  __typename?: 'MetaUsersSettings';
  totalCount?: Maybe<Scalars['Int']>;
};

export type UserNodeConnection = {
  __typename?: 'UserNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNodeEdge>>;
};

/** A Relay edge containing a `UserNode` and its cursor. */
export type UserNodeEdge = {
  __typename?: 'UserNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/**
 * Группа для выбора в выгрузке P&L. Отдельное поле, а не `groups`:
 * FinanceManager нет в правах на запросы групп, а выбирать группу ему нужно.
 */
export type PnlExportGroupType = {
  __typename?: 'PnlExportGroupType';
  id: Scalars['ID'];
  name: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
};

/**
 * Заказ выгрузки. Байтов файла здесь нет — они отдаются `pnlExportFile`.
 * 
 * `status` / `fileFormat` — строки, а не Enum: graphene отдал бы их
 * UPPERCASE, и сравнение на фронте молча не сработало бы.
 */
export type PnlExportRunType = {
  __typename?: 'PnlExportRunType';
  id: Scalars['ID'];
  status: Scalars['String'];
  fileFormat: Scalars['String'];
  language: Scalars['String'];
  monthFrom: Scalars['String'];
  monthTo: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  stats?: Maybe<Scalars['JSONString']>;
  error?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  isDownloadable: Scalars['Boolean'];
  isFilePurged: Scalars['Boolean'];
};

export type PnlExportFileType = {
  __typename?: 'PnlExportFileType';
  fileName: Scalars['String'];
  contentType: Scalars['String'];
  contentBase64: Scalars['String'];
};

export type MonthBudget = {
  __typename?: 'MonthBudget';
  USD?: Maybe<Scalars['CustomFloat']>;
  EUR?: Maybe<Scalars['CustomFloat']>;
  BYN?: Maybe<Scalars['CustomFloat']>;
  RUB?: Maybe<Scalars['CustomFloat']>;
  PLN?: Maybe<Scalars['CustomFloat']>;
  month?: Maybe<Scalars['Int']>;
};

export type WeeksBudgetInfo = {
  __typename?: 'WeeksBudgetInfo';
  budget?: Maybe<Array<Maybe<WeeksBudget>>>;
  month: Scalars['Int'];
  plan?: Maybe<Array<Maybe<WeeksBudget>>>;
  year: Scalars['Int'];
};

export type WeeksBudget = {
  __typename?: 'WeeksBudget';
  USD?: Maybe<Scalars['CustomFloat']>;
  EUR?: Maybe<Scalars['CustomFloat']>;
  BYN?: Maybe<Scalars['CustomFloat']>;
  RUB?: Maybe<Scalars['CustomFloat']>;
  PLN?: Maybe<Scalars['CustomFloat']>;
  week?: Maybe<Scalars['Int']>;
};

export type StudentMiniCard = {
  __typename?: 'StudentMiniCard';
  studentId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  isLmsBlocked: Scalars['Boolean'];
  groups: Array<StudentMiniCardGroupRow>;
  finance?: Maybe<StudentMiniCardFinance>;
  openTasksCount: Scalars['Int'];
  recentTasks: Array<StaffTaskType>;
  notesCount: Scalars['Int'];
  recentNotes: Array<StudentNoteType>;
  /** Spec 0038. Null for viewers outside SURVEY_INSIGHT_READ_ROLES (survey managers + HR) — the block carries a teacher's name and a verbatim quote, unlike the counts around it. `null` means «hidden from this viewer», not «no surveys». */
  surveys?: Maybe<StudentMiniCardSurveys>;
};

/**
 * One agreement = one group membership row. A retake student can have
 * two rows with the same group — disambiguated by `agreement_title`.
 */
export type StudentMiniCardGroupRow = {
  __typename?: 'StudentMiniCardGroupRow';
  agreementId: Scalars['ID'];
  agreementTitle: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  terminatedDate?: Maybe<Scalars['Date']>;
  freeOfCharge?: Maybe<Scalars['Boolean']>;
  statePrefinanced?: Maybe<Scalars['Boolean']>;
  paymentByCompany?: Maybe<Scalars['Boolean']>;
};

export type StudentMiniCardFinance = {
  __typename?: 'StudentMiniCardFinance';
  isDebtor: Scalars['Boolean'];
  /** Сумма просроченных остатков по ВСЕМ валютам договоров без пересчёта — не для показа как денег; для показа — `overdueAmounts`. */
  overdueAmount: Scalars['Float'];
  /** Просроченные остатки по валютам договоров (то же правило долга, что у `overdueAmount`): PLN первой, затем по сумме по убыванию. */
  overdueAmounts: Array<LmsAmountDueType>;
  overdueInvoiceCount: Scalars['Int'];
  maxOverdueDays: Scalars['Int'];
  overdueSince?: Maybe<Scalars['Date']>;
  isBlocked: Scalars['Boolean'];
  blockReason?: Maybe<Scalars['String']>;
  totals: StudentTotals;
};

/**
 * Spec 0038 — what the student has been saying about the course.
 * 
 * Every field resolves on its own rather than being built eagerly:
 * `pendingCount` costs two queries and most hover renders never ask for it.
 */
export type StudentMiniCardSurveys = {
  __typename?: 'StudentMiniCardSurveys';
  respondedCount: Scalars['Int'];
  pendingCount: Scalars['Int'];
  avgScore?: Maybe<Scalars['Float']>;
  negativeCount: Scalars['Int'];
  lastSubmittedAt?: Maybe<Scalars['DateTime']>;
  recentSignals: Array<StudentMiniCardSurveySignal>;
};

/** One recent survey answer, as the manager needs to read it at a glance. */
export type StudentMiniCardSurveySignal = {
  __typename?: 'StudentMiniCardSurveySignal';
  responseId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  groupName: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  teacherName?: Maybe<Scalars['String']>;
  submittedAt: Scalars['DateTime'];
  score?: Maybe<Scalars['Float']>;
  sentiment: Scalars['String'];
  /** The freshest thing the student actually wrote, trimmed. Null when they only gave ratings. */
  excerpt?: Maybe<Scalars['String']>;
};

/**
 * Ссылка на объект: вид + его pk. Одна форма и для фильтра, и для записи.
 * 
 * `id` — сырой pk, а не relay-id: половина связуемых типов (дофинансирование,
 * опросы) вообще не relay-ноды, и общего кодирования у них нет. `to_pk`
 * переварит оба варианта.
 */
export type TaskLinkInput = {
  kind: Scalars['String'];
  id: Scalars['ID'];
};

/**
 * Счётчики по ТОЙ ЖЕ выборке, что отдаёт `staffTasks`.
 * 
 * Существуют, чтобы число в шапке и список под ним нельзя было развести:
 * оба считаются `_scoped_staff_tasks` с одними аргументами. «Просрочено» и
 * «на сегодня» берутся только среди ОТКРЫТЫХ — закрытая задача со вчерашним
 * сроком не долг, а история.
 */
export type StaffTasksSummaryType = {
  __typename?: 'StaffTasksSummaryType';
  openCount: Scalars['Int'];
  overdueCount: Scalars['Int'];
  todayCount: Scalars['Int'];
};

/**
 * Lightweight ERP-staff row for assignee dropdowns (plain ObjectType so
 * it doesn't fight users' relay UserNode over the model registry).
 */
export type StaffUserType = {
  __typename?: 'StaffUserType';
  id: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
  roles: Array<Scalars['String']>;
};

/** Вид связи, доступный ЭТОМУ пользователю (`taskLinkKinds`). */
export type TaskLinkKindType = {
  __typename?: 'TaskLinkKindType';
  key: Scalars['String'];
  label: Scalars['String'];
};

/** Короткоживущая подписанная ссылка. Клиент НЕ кеширует её. */
export type TaskAttachmentUrlType = {
  __typename?: 'TaskAttachmentUrlType';
  url: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  originalName: Scalars['String'];
};

/**
 * Подписанная ссылка на картинку задачи для показа на месте (ТЗ 0109).
 * Клиент НЕ кеширует её дольше `expiresAt`.
 */
export type TaskImageUrlType = {
  __typename?: 'TaskImageUrlType';
  /** id вложения. */
  id: Scalars['ID'];
  url: Scalars['String'];
  expiresAt: Scalars['DateTime'];
};

/** Подсказка связи из текста заголовка (ТЗ 0109, `taskSmartLinks`). */
export type TaskSmartLinkType = {
  __typename?: 'TaskSmartLinkType';
  /** Вид связи реестра 0064. */
  kind: Scalars['String'];
  /** id объекта (не связи). */
  id: Scalars['ID'];
  label: Scalars['String'];
  hint: Scalars['String'];
  /** Почему предложено: student_id | student_name | group_number | student_deal | student_agreement. */
  reason: Scalars['String'];
  /** false — токен совпал с несколькими объектами; клиент не заводит связь сам, а предлагает выбрать. */
  confident: Scalars['Boolean'];
};

/**
 * Что сервер принимает — чтобы у клиента не завелась вторая копия списка.
 * 
 * Тот же приём, что у `taskLinkKinds`: правило живёт на сервере в одном
 * экземпляре, клиент его читает, а не повторяет.
 */
export type TaskAttachmentLimitsType = {
  __typename?: 'TaskAttachmentLimitsType';
  maxBytes: Scalars['Int'];
  maxPerTask: Scalars['Int'];
  allowedExtensions: Array<Scalars['String']>;
  /** Готовая строка для атрибута `accept` поля выбора файла. */
  acceptAttribute: Scalars['String'];
};

export type LmsBlockSettingsType = {
  __typename?: 'LmsBlockSettingsType';
  /** ERP switch; effective only together with serverRobotAllowed. */
  robotEnabled: Scalars['Boolean'];
  /** Days past payment_to before an invoice suspends access (1..90). */
  overdueDays: Scalars['Int'];
  mailEnabled: Scalars['Boolean'];
  slackEnabled: Scalars['Boolean'];
  /** ТЗ 0081: SMS студенту о приостановке и возврате (канал SMS — общий). */
  smsEnabled: Scalars['Boolean'];
  suspendedTemplateId?: Maybe<Scalars['String']>;
  suspendedTemplateName?: Maybe<Scalars['String']>;
  restoredTemplateId?: Maybe<Scalars['String']>;
  restoredTemplateName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByName?: Maybe<Scalars['String']>;
  /** env LMS_BLOCK_ROBOT_ENABLED — master switch; false → the robot never runs. */
  serverRobotAllowed: Scalars['Boolean'];
  /** env LMS_BLOCK_MAIL_ENABLED — master switch for emails and the test email. */
  serverMailAllowed: Scalars['Boolean'];
  /** env LMS_BLOCK_SLACK_ENABLED. */
  serverSlackAllowed: Scalars['Boolean'];
  /** env SMS_ENABLED — канал SMS на сервере. */
  serverSmsAllowed: Scalars['Boolean'];
  /** Admin / FinanceManager — may call saveLmsBlockSettings and sendLmsBlockTestEmail. */
  canEdit: Scalars['Boolean'];
};

export type LmsBlockTemplateVariableType = {
  __typename?: 'LmsBlockTemplateVariableType';
  name: Scalars['String'];
  /** string | number | list */
  type: Scalars['String'];
  descriptionPl: Scalars['String'];
  descriptionRu: Scalars['String'];
  /** Value in lmsBlockTemplateExample(kind: "suspended"). */
  example?: Maybe<Scalars['JSONString']>;
  /** Element fields of a list variable; empty for scalars. */
  fields: Array<LmsBlockTemplateVariableFieldType>;
};

/** A field of one element of a list variable (`invoices[]`, `totals[]`). */
export type LmsBlockTemplateVariableFieldType = {
  __typename?: 'LmsBlockTemplateVariableFieldType';
  name: Scalars['String'];
  /** string | number */
  type: Scalars['String'];
  descriptionPl: Scalars['String'];
  descriptionRu: Scalars['String'];
  /** Value in the example data (first list element). */
  example?: Maybe<Scalars['JSONString']>;
};

export type LmsBlockSendgridTemplatesType = {
  __typename?: 'LmsBlockSendgridTemplatesType';
  success: Scalars['Boolean'];
  templates: Array<SendgridTemplateType>;
  /** sendgrid_unavailable | sendgrid_forbidden */
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * One student with at least one overdue unpaid instalment (corrections /
 * transfer-aware). `currently_blocked` lets the ERP render the toggle state
 * without a second query.
 */
export type DebtorCandidateType = {
  __typename?: 'DebtorCandidateType';
  student: StudentType;
  /** Сумма просроченных остатков по ВСЕМ валютам договоров без пересчёта (PLN + EUR одним числом) — не для показа как денег; для показа — `overdueAmounts`. */
  overdueAmount: Scalars['Float'];
  /** Просроченные остатки по валютам договоров (то же правило долга, что у `overdueAmount`): PLN первой, затем по сумме по убыванию. */
  overdueAmounts: Array<LmsAmountDueType>;
  overdueInvoiceCount: Scalars['Int'];
  maxOverdueDays: Scalars['Int'];
  currentlyBlocked: Scalars['Boolean'];
};

export type StudentAccessBlockType = {
  __typename?: 'StudentAccessBlockType';
  id: Scalars['ID'];
  isBlocked: Scalars['Boolean'];
  reason: Scalars['String'];
  /** Снимок до ТЗ 0074: сумма просрочки, только если все счета блокировки в ОДНОЙ валюте; при разных валютах — 0 (валюты не складываются). Для показа — `amountsDue`. */
  overdueAmount?: Maybe<Scalars['Float']>;
  overdueInvoiceCount: Scalars['Int'];
  maxOverdueDays: Scalars['Int'];
  blockedAt?: Maybe<Scalars['DateTime']>;
  unblockedAt?: Maybe<Scalars['DateTime']>;
  manualOverride: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** robot | manual */
  source?: Maybe<Scalars['String']>;
  blockedByName?: Maybe<Scalars['String']>;
  unblockedByName?: Maybe<Scalars['String']>;
  /** Invoices the active suspension is tied to (empty when not blocked). */
  blockingInvoices: Array<LmsBlockInvoiceType>;
  /** Still owed on blocking_invoices, per currency. */
  amountsDue: Array<LmsAmountDueType>;
  lastEvent?: Maybe<LmsBlockEventType>;
};

/**
 * An invoice a suspension is (or was) tied to. Live rows carry the
 * current outstanding; history rows the snapshot taken at the event.
 */
export type LmsBlockInvoiceType = {
  __typename?: 'LmsBlockInvoiceType';
  invoiceId?: Maybe<Scalars['ID']>;
  fakturowniaId?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  /** Still owed (net of corrections). */
  amount?: Maybe<Scalars['Float']>;
  gross?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  paymentTo?: Maybe<Scalars['Date']>;
  daysOverdue: Scalars['Int'];
  paymentUrl?: Maybe<Scalars['String']>;
  viewUrl?: Maybe<Scalars['String']>;
  isPaid?: Maybe<Scalars['Boolean']>;
};

export type LmsBlockEventType = {
  __typename?: 'LmsBlockEventType';
  id: Scalars['ID'];
  /** suspended | restored */
  action: Scalars['String'];
  /** robot | manual */
  source: Scalars['String'];
  /** Null for the robot. */
  actorName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  reason?: Maybe<Scalars['String']>;
  notifyStudent: Scalars['Boolean'];
  invoices: Array<LmsBlockInvoiceType>;
  amountsDue: Array<LmsAmountDueType>;
  notifications: Array<LmsBlockNotificationType>;
};

export type LmsBlockNotificationType = {
  __typename?: 'LmsBlockNotificationType';
  id: Scalars['ID'];
  /** email | slack | sms (ТЗ 0081) */
  channel: Scalars['String'];
  /** suspended | restored */
  kind: Scalars['String'];
  /** pending | sending | sent | skipped | failed */
  status: Scalars['String'];
  skipReason?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type LmsSuspensionPageType = {
  __typename?: 'LmsSuspensionPageType';
  total: Scalars['Int'];
  items: Array<LmsSuspensionRowType>;
};

/**
 * One row of the «Wstrzymany dostęp» tab.
 * 
 * * `active` — a current suspension: live `invoices`, notifications of the
 *   suspension event;
 * * `history` — one restoration: `blockedAt/By/source` from the suspension
 *   it ended, `restoredAt/By/Source` from the restoration, invoices as
 *   snapshotted at suspension, notifications of BOTH events (see `kind`);
 * * `skipped` — not suspended although an invoice is past the threshold:
 *   `skipReason` (`waiting_dofinansowanie` | `waived`), live invoices.
 */
export type LmsSuspensionRowType = {
  __typename?: 'LmsSuspensionRowType';
  status: Scalars['String'];
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  studentEmail?: Maybe<Scalars['String']>;
  groups: Array<LmsSuspensionGroupType>;
  source?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  blockedAt?: Maybe<Scalars['DateTime']>;
  blockedByName?: Maybe<Scalars['String']>;
  restoredAt?: Maybe<Scalars['DateTime']>;
  restoredByName?: Maybe<Scalars['String']>;
  restoredSource?: Maybe<Scalars['String']>;
  skipReason?: Maybe<Scalars['String']>;
  invoices: Array<LmsBlockInvoiceType>;
  amountsDue: Array<LmsAmountDueType>;
  notifications: Array<LmsBlockNotificationType>;
};

export type LmsSuspensionGroupType = {
  __typename?: 'LmsSuspensionGroupType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LmsBlockRunType = {
  __typename?: 'LmsBlockRunType';
  id: Scalars['ID'];
  taskName: Scalars['String'];
  /** running | success | failed */
  status: Scalars['String'];
  triggerSource?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  stats?: Maybe<Scalars['JSONString']>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ContributionConnection = {
  __typename?: 'ContributionConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContributionEdge>>;
};

/** A Relay edge containing a `Contribution` and its cursor. */
export type ContributionEdge = {
  __typename?: 'ContributionEdge';
  /** The item at the end of the edge */
  node?: Maybe<ContributionType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type MetaContribution = {
  __typename?: 'MetaContribution';
  contributionsNums: Array<Maybe<Scalars['Int']>>;
  /** Deprecated from 1.3.0 version. */
  contributionsCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaymentsVerificationType = {
  __typename?: 'PaymentsVerificationType';
  agreement_id?: Maybe<Scalars['ID']>;
  agreementTitle?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  fullname?: Maybe<Scalars['String']>;
};

export type DeferredPaymentConnection = {
  __typename?: 'DeferredPaymentConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeferredPaymentEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DeferredPayment` and its cursor. */
export type DeferredPaymentEdge = {
  __typename?: 'DeferredPaymentEdge';
  /** The item at the end of the edge */
  node?: Maybe<DeferredPaymentType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type DeferredPaymentType = Node & {
  __typename?: 'DeferredPaymentType';
  id: Scalars['ID'];
  userInput: Scalars['String'];
  agreementTitle?: Maybe<Scalars['String']>;
  sum?: Maybe<Scalars['CustomFloat']>;
  currency?: Maybe<DeferredPaymentCurrency>;
  studentFullname?: Maybe<Scalars['String']>;
  agreementId?: Maybe<Scalars['Int']>;
  date: Scalars['Date'];
  agreementCurrency?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum DeferredPaymentCurrency {
  /** USD */
  Usd = 'USD',
  /** BYN */
  Byn = 'BYN',
  /** RUB */
  Rub = 'RUB',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN'
}

export type MetaDeferredPaymentConnection = {
  __typename?: 'MetaDeferredPaymentConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetaDeferredPaymentEdge>>;
};

/** A Relay edge containing a `MetaDeferredPayment` and its cursor. */
export type MetaDeferredPaymentEdge = {
  __typename?: 'MetaDeferredPaymentEdge';
  /** The item at the end of the edge */
  node?: Maybe<MetaDeferredPayment>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type MetaDeferredPayment = Node & {
  __typename?: 'MetaDeferredPayment';
  /** The ID of the object */
  id: Scalars['ID'];
  deferredPaymentsDate?: Maybe<Scalars['Date']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StudentConnection = {
  __typename?: 'StudentConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Student` and its cursor. */
export type StudentEdge = {
  __typename?: 'StudentEdge';
  /** The item at the end of the edge */
  node?: Maybe<StudentType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type MetaStudents = {
  __typename?: 'MetaStudents';
  totalCount?: Maybe<Scalars['Int']>;
  agreementsCount?: Maybe<Scalars['Int']>;
};

export type VerifiedStudent = {
  __typename?: 'VerifiedStudent';
  student?: Maybe<StudentType>;
  user?: Maybe<CustomUserType>;
  message?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type MetaTeachers = {
  __typename?: 'MetaTeachers';
  /** Returns teachers count */
  totalCount?: Maybe<Scalars['Int']>;
  /** Returns applications count */
  applicationsCount?: Maybe<Scalars['Int']>;
};

export type VerifiedTeacher = {
  __typename?: 'VerifiedTeacher';
  teacher?: Maybe<TeacherType>;
  user?: Maybe<CustomUserType>;
  message?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type BaseTeacherInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type MetaTeacherApplications = {
  __typename?: 'MetaTeacherApplications';
  totalCount?: Maybe<Scalars['Int']>;
};

export type CountryConnection = {
  __typename?: 'CountryConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CountryEdge>>;
};

/** A Relay edge containing a `Country` and its cursor. */
export type CountryEdge = {
  __typename?: 'CountryEdge';
  /** The item at the end of the edge */
  node?: Maybe<CountryType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Parent is the dict from services.load_service.teacher_load. */
export type TeacherLoadType = {
  __typename?: 'TeacherLoadType';
  activeGroups: Scalars['Int'];
  activeApplications: Scalars['Int'];
  nextLessonDate?: Maybe<Scalars['Date']>;
  lessonsNext30Days: Scalars['Int'];
  hoursNext30Days: Scalars['Float'];
  hoursPerWeek: Scalars['Float'];
  /** 'free' | 'light' | 'normal' | 'loaded', from the TEACHER_LOAD_*_HOURS_PER_WEEK settings. Separate from TeacherType.availability, which stays two-valued. */
  loadBand: Scalars['String'];
  horizonDays: Scalars['Int'];
  weeks: Array<TeacherLoadWeekType>;
  applications: Array<TeacherLoadApplicationType>;
};

/** One bucket of the forward histogram. */
export type TeacherLoadWeekType = {
  __typename?: 'TeacherLoadWeekType';
  weekStart: Scalars['Date'];
  lessons: Scalars['Int'];
  /** Clamped to [0, one week]: a lesson running past midnight yields a negative interval in Postgres. */
  minutes: Scalars['Int'];
  groups: Scalars['Int'];
};

/** Per-application rollup. Note the two DIFFERENT «remaining» numbers. */
export type TeacherLoadApplicationType = {
  __typename?: 'TeacherLoadApplicationType';
  applicationId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  contractedLessons: Scalars['Int'];
  scheduledLessons: Scalars['Int'];
  /** Contracted minus scheduled — a PLANNING GAP (lessons agreed but not yet on the calendar), NOT remaining work. */
  unscheduledLessons: Scalars['Int'];
  /** Scheduled AND still in the future — the real remaining load. */
  remainingLessons: Scalars['Int'];
  lastLessonDate?: Maybe<Scalars['Date']>;
};

/** A group the teacher is qualified for that still needs staffing. */
export type TeacherCandidateGroupType = {
  __typename?: 'TeacherCandidateGroupType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  /** Future lessons with no teacher application, or with a terminated one. */
  openLessons: Scalars['Int'];
  nextOpenDate?: Maybe<Scalars['Date']>;
};

/** Parent is a TeacherInterview instance. */
export type TeacherInterviewType = {
  __typename?: 'TeacherInterviewType';
  id: Scalars['ID'];
  teacherId: Scalars['ID'];
  source: Scalars['String'];
  title: Scalars['String'];
  recordedAt?: Maybe<Scalars['DateTime']>;
  durationMinutes: Scalars['Int'];
  status: Scalars['String'];
  errorMessage: Scalars['String'];
  retryCount: Scalars['Int'];
  /** Set for source='link' (including the legacy Teacher.interviewRecording import). */
  externalUrl?: Maybe<Scalars['String']>;
  /** A stored MP4 exists in private S3. Fetch the playable URL through `teacherInterviewVideoUrl` — it is signed, short-lived and audited on every issue. */
  hasVideo: Scalars['Boolean'];
  sizeBytes?: Maybe<Scalars['Float']>;
  hasTranscript: Scalars['Boolean'];
  transcriptSource: Scalars['String'];
  transcriptChars: Scalars['Int'];
  zoomRecordingId?: Maybe<Scalars['ID']>;
  zoomTopic?: Maybe<Scalars['String']>;
  zoomAccountEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
};

/**
 * The transcript body, fetched separately — it is large and only the
 * «посмотреть/править расшифровку» drawer needs it.
 */
export type TeacherInterviewTranscriptType = {
  __typename?: 'TeacherInterviewTranscriptType';
  interviewId: Scalars['ID'];
  transcriptSource: Scalars['String'];
  text: Scalars['String'];
};

/**
 * A synced `ZoomRecording` offered in the picker.
 * 
 * ⚠️ Deliberately does NOT expose `files`. `allZoomRecordings` returns it as
 * `files: JSONString!`, and those entries carry raw Zoom `download_url`s —
 * this narrow type is a security improvement over reusing that query, not just
 * a role workaround.
 */
export type InterviewZoomCandidateType = {
  __typename?: 'InterviewZoomCandidateType';
  id: Scalars['ID'];
  topic: Scalars['String'];
  startTime?: Maybe<Scalars['DateTime']>;
  durationMinutes: Scalars['Int'];
  totalSizeBytes?: Maybe<Scalars['Float']>;
  accountId?: Maybe<Scalars['ID']>;
  accountEmail?: Maybe<Scalars['String']>;
  hasVideo: Scalars['Boolean'];
  /** Zoom produced a TRANSCRIPT/CC file. False means the interview will be video-only until someone pastes a transcript — Zoom only transcribes when *Audio transcript* is enabled on that account, and never retroactively. */
  hasTranscript: Scalars['Boolean'];
  isAlreadyAttached: Scalars['Boolean'];
  /** Older than ZOOM_INTERVIEW_RETENTION_WARN_DAYS: Zoom may have expired the download URLs, and a re-sync cannot repair them. */
  retentionWarning: Scalars['Boolean'];
};

/** Parent is a TeacherAiProfile instance. */
export type TeacherAiProfileType = {
  __typename?: 'TeacherAiProfileType';
  teacherId: Scalars['ID'];
  status: Scalars['String'];
  summary: Array<AiSourceTextType>;
  communication: Array<AiSourceTextType>;
  teachingExperience: Array<AiSourceTextType>;
  yearsExperienceTotal?: Maybe<Scalars['Int']>;
  yearsExperienceTeaching?: Maybe<Scalars['Int']>;
  communicationScore?: Maybe<Scalars['Int']>;
  teachingScore?: Maybe<Scalars['Int']>;
  skills: Array<AiSkillType>;
  languages: Array<AiLanguageType>;
  strengths: Array<Scalars['String']>;
  redFlags: Array<Scalars['String']>;
  provenance: Array<AiFieldProvenanceType>;
  suspicious: Scalars['Boolean'];
  suspicionNotes: Scalars['String'];
  aiModel: Scalars['String'];
  promptVersion: Scalars['String'];
  errorMessage: Scalars['String'];
  analyzedAt?: Maybe<Scalars['DateTime']>;
  suggestions: Array<TeacherCourseSuggestionType>;
  runs: Array<TeacherAiRunType>;
};

/**
 * One source's take on a free-text field. BOTH are kept — fusing two
 * summaries with a second LLM pass would be a new hallucination surface for no
 * operator value.
 */
export type AiSourceTextType = {
  __typename?: 'AiSourceTextType';
  sourceKind: Scalars['String'];
  text: Scalars['String'];
};

export type AiSkillType = {
  __typename?: 'AiSkillType';
  name: Scalars['String'];
  category: Scalars['String'];
  /** What the source CLAIMS: ''|none|basic|intermediate|advanced|expert. */
  claimedLevel: Scalars['String'];
  /** What the source actually EVIDENCES. For a CV these two usually match; for an interview transcript they can differ sharply, and that gap is the point. */
  assessedLevel: Scalars['String'];
  evidence: Scalars['String'];
  sourceKinds: Array<Scalars['String']>;
};

export type AiLanguageType = {
  __typename?: 'AiLanguageType';
  language: Scalars['String'];
  level: Scalars['String'];
  basis: Scalars['String'];
};

export type AiFieldProvenanceType = {
  __typename?: 'AiFieldProvenanceType';
  field: Scalars['String'];
  runId?: Maybe<Scalars['ID']>;
  sourceKind?: Maybe<Scalars['String']>;
};

/**
 * A PROPOSAL. Accepting it is what writes `coursesCanTeach`; nothing here
 * is applied automatically.
 */
export type TeacherCourseSuggestionType = {
  __typename?: 'TeacherCourseSuggestionType';
  id: Scalars['ID'];
  courseId: Scalars['ID'];
  courseName?: Maybe<Scalars['String']>;
  confidence: Scalars['Float'];
  rationale: Scalars['String'];
  sourceKind: Scalars['String'];
  status: Scalars['String'];
  decidedByName?: Maybe<Scalars['String']>;
  decidedAt?: Maybe<Scalars['DateTime']>;
  /** The course is ALREADY in coursesCanTeach — accepting adds nothing new. */
  alreadyQualified: Scalars['Boolean'];
};

export type TeacherAiRunType = {
  __typename?: 'TeacherAiRunType';
  id: Scalars['ID'];
  sourceKind: Scalars['String'];
  status: Scalars['String'];
  interviewId?: Maybe<Scalars['ID']>;
  documentId?: Maybe<Scalars['ID']>;
  aiModel: Scalars['String'];
  promptVersion: Scalars['String'];
  errorMessage: Scalars['String'];
  /** Course ids the model invented that were dropped server-side. Surfaced rather than swallowed so systematic hallucination is visible in the data. */
  droppedCourseIds: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  analyzedAt?: Maybe<Scalars['DateTime']>;
};

/** Parent is a TeacherDocument instance. */
export type TeacherDocumentType = {
  __typename?: 'TeacherDocumentType';
  id: Scalars['ID'];
  teacherId: Scalars['ID'];
  kind: Scalars['String'];
  version: Scalars['Int'];
  originalName: Scalars['String'];
  contentType: Scalars['String'];
  sizeBytes?: Maybe<Scalars['Float']>;
  /** pending|done|failed|unsupported. `failed` on a PDF means it has no text layer (a scan) — the file is fine, and `setTeacherDocumentText` is the recovery path. */
  extractionStatus: Scalars['String'];
  hasText: Scalars['Boolean'];
  textChars: Scalars['Int'];
  /** The newest version of this kind. Older ones are kept deliberately — «что он заявлял в 2024?» is a real hiring question. */
  isCurrent: Scalars['Boolean'];
  uploadedAt: Scalars['DateTime'];
  uploadedByName?: Maybe<Scalars['String']>;
};

/**
 * The extracted body, fetched separately — it is large, and only the
 * «посмотреть текст» drawer needs it.
 * 
 * Exposed on purpose: the operator must be able to read EXACTLY what the model
 * read, otherwise the AI assessment is unauditable.
 */
export type TeacherDocumentTextType = {
  __typename?: 'TeacherDocumentTextType';
  documentId: Scalars['ID'];
  extractionStatus: Scalars['String'];
  text: Scalars['String'];
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyEdge>>;
};

/** A Relay edge containing a `Company` and its cursor. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** The item at the end of the edge */
  node?: Maybe<CompanyType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/**
 * Можно ли «исправить группу» / «отменить зачисление» и что мешает.
 * 
 * Те же коды, которыми откажут мутации, — одна функция на обе стороны
 * (`agreement_correction.correction_blockers`). Без `targetGroupId`
 * `correctBlockers` — только то, что не зависит от выбора группы.
 */
export type AgreementCorrectionCheckType = {
  __typename?: 'AgreementCorrectionCheckType';
  canCorrect: Scalars['Boolean'];
  canUndo: Scalars['Boolean'];
  correctBlockers: Array<Scalars['String']>;
  undoBlockers: Array<Scalars['String']>;
  warnings: Array<Scalars['String']>;
  /** До какого момента доступна отмена зачисления (создание + AGREEMENT_UNDO_WINDOW_DAYS). Null — договор заведён до учёта даты создания, окна нет. */
  undoDeadline?: Maybe<Scalars['DateTime']>;
};

export type GroupLessonConnection = {
  __typename?: 'GroupLessonConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupLessonEdge>>;
  id?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
};

/** A Relay edge containing a `GroupLesson` and its cursor. */
export type GroupLessonEdge = {
  __typename?: 'GroupLessonEdge';
  /** The item at the end of the edge */
  node?: Maybe<GroupLessonType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type StudentsMarkConnection = {
  __typename?: 'StudentsMarkConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentsMarkEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentsMark` and its cursor. */
export type StudentsMarkEdge = {
  __typename?: 'StudentsMarkEdge';
  /** The item at the end of the edge */
  node?: Maybe<StudentsMarkType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type StudentsAchievementConnection = {
  __typename?: 'StudentsAchievementConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentsAchievementEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentsAchievement` and its cursor. */
export type StudentsAchievementEdge = {
  __typename?: 'StudentsAchievementEdge';
  /** The item at the end of the edge */
  node?: Maybe<AgreementType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/**
 * One row of the signed-in student's OWN attendance record (spec 0013
 * follow-up). Parent is a `journals.StudentAttendance`.
 * 
 * Deliberately a hand-built ObjectType rather than a DjangoObjectType on
 * StudentAttendance: that model hangs off Student/GroupLesson, and exposing
 * it as a Django type would let the LMS schema walk back to other students'
 * rows. Everything here is the requester's own by construction.
 */
export type MyLessonAttendanceType = {
  __typename?: 'MyLessonAttendanceType';
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  date?: Maybe<Scalars['Date']>;
  attendance?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  markedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Одна правка отметки (ТЗ 0026).
 * 
 * Плоский ObjectType, а не DjangoObjectType — ровно по той же причине, что и
 * у `MyLessonAttendanceType` ниже: модель ссылается на пользователя, и
 * автогенерация типа утащила бы его целиком.
 */
export type AttendanceChangeType = {
  __typename?: 'AttendanceChangeType';
  id: Scalars['ID'];
  oldValue?: Maybe<Scalars['Boolean']>;
  newValue?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  changedByName?: Maybe<Scalars['String']>;
  changedVia?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
};

export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoryEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Category` and its cursor. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** The item at the end of the edge */
  node?: Maybe<CategoryType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type MetaCourses = {
  __typename?: 'MetaCourses';
  totalCount?: Maybe<Scalars['Int']>;
};

export type GraduateFeedbackConnection = {
  __typename?: 'GraduateFeedbackConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GraduateFeedbackEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `GraduateFeedback` and its cursor. */
export type GraduateFeedbackEdge = {
  __typename?: 'GraduateFeedbackEdge';
  /** The item at the end of the edge */
  node?: Maybe<GraduateFeedbackType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type DemoType = {
  __typename?: 'DemoType';
  totalCount?: Maybe<Scalars['Int']>;
};

export type GroupConnection = {
  __typename?: 'GroupConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Group` and its cursor. */
export type GroupEdge = {
  __typename?: 'GroupEdge';
  /** The item at the end of the edge */
  node?: Maybe<GroupType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GroupType = Node & {
  __typename?: 'GroupType';
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
  maxStudentsCount: Scalars['Int'];
  course: CourseFilterType;
  publishedLms: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  isFree: Scalars['Boolean'];
  zoomAccount?: Maybe<ZoomAccountType>;
  teacherLeads: ApplicationFilterTypeConnection;
  modules: Array<GroupModuleType>;
  classesDays: Array<DayOfClassType>;
  agreements: Array<AgreementType>;
  notes: Array<StudentNoteType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  conversations: Array<ConversationType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  slackChannels: Array<ChannelGroupLinkType>;
  materials: Array<MaterialType>;
  lessonJoinUrl?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<GroupLessonType>>;
  studentsCount?: Maybe<Scalars['Int']>;
  lessonsCount?: Maybe<Scalars['Int']>;
  passedLessonsCount?: Maybe<Scalars['Int']>;
  freeLessonsCount?: Maybe<Scalars['Int']>;
  statusFinished?: Maybe<Scalars['Boolean']>;
  datetimeNextLesson?: Maybe<Scalars['DateTime']>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  teachers?: Maybe<Array<Maybe<TeacherType>>>;
  freePlaces?: Maybe<Scalars['Int']>;
  daysOfClass: Array<Scalars['Int']>;
  price?: Maybe<Scalars['CustomFloat']>;
  currency?: Maybe<Scalars['String']>;
  contributionsSum?: Maybe<Scalars['CustomFloat']>;
  /** Временная ссылка, действующая сейчас: на дату идущего занятия (у ночного занятия после полуночи — вчерашняя дата), иначе на сегодня по Варшаве. */
  activeLinkOverride?: Maybe<GroupLinkOverrideType>;
  agreementsConnection?: Maybe<AgreementConnection>;
};


export type GroupTypeTeacherLeadsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  byGroupId?: Maybe<Scalars['Decimal']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
};


export type GroupTypeZoomSchedulesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GroupTypeAgreementsConnectionArgs = {
  query?: Maybe<Scalars['String']>;
  status?: Maybe<RosterStatusEnum>;
  hasDebt?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<AgreementOrderByEnum>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type UnionGroupConnection = {
  __typename?: 'UnionGroupConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UnionGroupEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `UnionGroup` and its cursor. */
export type UnionGroupEdge = {
  __typename?: 'UnionGroupEdge';
  /** The item at the end of the edge */
  node?: Maybe<UnionGroupType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type UnionGroupType = GroupType | StudentGroupType | MethodistGroupType;

/**
 * Группа глазами СТУДЕНТА.
 * 
 * ТЗ 0040 доводка: сюда, а не в `GroupType`, кладётся план навыков. Тип —
 * потомок, поэтому поле достаётся только студенческому контуру; общий и
 * методистский остаются без него, и «что я получу» не превращается в лишнее
 * поле на экранах персонала.
 */
export type StudentGroupType = Node & {
  __typename?: 'StudentGroupType';
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
  maxStudentsCount: Scalars['Int'];
  course: CourseFilterType;
  publishedLms: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  isFree: Scalars['Boolean'];
  zoomAccount?: Maybe<ZoomAccountType>;
  teacherLeads: ApplicationFilterTypeConnection;
  modules: Array<GroupModuleType>;
  classesDays: Array<DayOfClassType>;
  agreements: Array<AgreementType>;
  notes: Array<StudentNoteType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  conversations: Array<ConversationType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  slackChannels: Array<ChannelGroupLinkType>;
  materials: Array<MaterialType>;
  lessonJoinUrl?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<GroupLessonType>>;
  studentsCount?: Maybe<Scalars['Int']>;
  lessonsCount?: Maybe<Scalars['Int']>;
  passedLessonsCount?: Maybe<Scalars['Int']>;
  freeLessonsCount?: Maybe<Scalars['Int']>;
  statusFinished?: Maybe<Scalars['Boolean']>;
  datetimeNextLesson?: Maybe<Scalars['DateTime']>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  teachers?: Maybe<Array<Maybe<TeacherType>>>;
  freePlaces?: Maybe<Scalars['Int']>;
  daysOfClass: Array<Scalars['Int']>;
  price?: Maybe<Scalars['CustomFloat']>;
  currency?: Maybe<Scalars['String']>;
  contributionsSum?: Maybe<Scalars['CustomFloat']>;
  /** Временная ссылка, действующая сейчас: на дату идущего занятия (у ночного занятия после полуночи — вчерашняя дата), иначе на сегодня по Варшаве. */
  activeLinkOverride?: Maybe<GroupLinkOverrideType>;
  agreementsConnection?: Maybe<AgreementConnection>;
  skillPlan: Array<LessonSkillUnlockType>;
};


/**
 * Группа глазами СТУДЕНТА.
 * 
 * ТЗ 0040 доводка: сюда, а не в `GroupType`, кладётся план навыков. Тип —
 * потомок, поэтому поле достаётся только студенческому контуру; общий и
 * методистский остаются без него, и «что я получу» не превращается в лишнее
 * поле на экранах персонала.
 */
export type StudentGroupTypeTeacherLeadsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  byGroupId?: Maybe<Scalars['Decimal']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
};


/**
 * Группа глазами СТУДЕНТА.
 * 
 * ТЗ 0040 доводка: сюда, а не в `GroupType`, кладётся план навыков. Тип —
 * потомок, поэтому поле достаётся только студенческому контуру; общий и
 * методистский остаются без него, и «что я получу» не превращается в лишнее
 * поле на экранах персонала.
 */
export type StudentGroupTypeZoomSchedulesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/**
 * Группа глазами СТУДЕНТА.
 * 
 * ТЗ 0040 доводка: сюда, а не в `GroupType`, кладётся план навыков. Тип —
 * потомок, поэтому поле достаётся только студенческому контуру; общий и
 * методистский остаются без него, и «что я получу» не превращается в лишнее
 * поле на экранах персонала.
 */
export type StudentGroupTypeAgreementsConnectionArgs = {
  query?: Maybe<Scalars['String']>;
  status?: Maybe<RosterStatusEnum>;
  hasDebt?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<AgreementOrderByEnum>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/**
 * Что даёт занятие — глазами студента (ТЗ 0040, доводка).
 * 
 * Живёт в карьерном домене, а отдаётся студенческим типом группы: связка
 * «курс → навык → занятие» принадлежит карьере, а спрашивают её с расписания.
 */
export type LessonSkillUnlockType = {
  __typename?: 'LessonSkillUnlockType';
  lessonNumber: Scalars['Int'];
  lessonId?: Maybe<Scalars['ID']>;
  skills: Array<SkillType>;
  isOver: Scalars['Boolean'];
};

export type MetaGroups = {
  __typename?: 'MetaGroups';
  totalCount?: Maybe<Scalars['Int']>;
};

/**
 * Group-level attendance rollup for the dashboard KpiStrip + ScheduleTab.
 * 
 * Replaces the per-lesson fan-out the frontend used to do
 * (`journal(groupId)` + `attendances` per lesson) with a single resolver
 * pass. Threshold value comes from `settings.GROUP_ATTENDANCE_THRESHOLD`
 * so it can be tuned without a release.
 */
export type GroupAttendanceSummary = {
  __typename?: 'GroupAttendanceSummary';
  groupId: Scalars['ID'];
  /** The 0..100 cutoff used to compute below_threshold per student. */
  threshold: Scalars['Float'];
  totalLessons: Scalars['Int'];
  /** GroupLesson.finished=True — the denominator for expected_lessons before per-student clipping. */
  passedLessons: Scalars['Int'];
  /** ТЗ 0026: прошедшие занятия с finished=False. Разрыв между «посещаемость проставлена» и «занятие закрыто»: такое занятие не попадает в passed_lessons и не идёт в выплату преподавателю. */
  unclosedLessons: Scalars['Int'];
  /** Mean attendance_rate over students who had at least one expected lesson. Students with 0 expected lessons are skipped from the average but still flagged below. */
  averageAttendance: Scalars['Float'];
  studentsBelowThresholdCount: Scalars['Int'];
  students: Array<GroupAttendanceStudentRow>;
};

/** Per-student attendance row inside `groupAttendanceSummary`. */
export type GroupAttendanceStudentRow = {
  __typename?: 'GroupAttendanceStudentRow';
  studentId: Scalars['ID'];
  fullName: Scalars['String'];
  /** Passed lessons the student was expected to attend (clipped by agreement.terminated_date when set). */
  expectedLessons: Scalars['Int'];
  /** StudentAttendance rows with attendance=True for the expected lessons. */
  attended: Scalars['Int'];
  /** expected_lessons − attended (skipped + not marked). */
  missed: Scalars['Int'];
  /** attended / expected_lessons × 100. 0 when expected_lessons is 0. */
  attendanceRate: Scalars['Float'];
  /** True when attendance_rate < threshold OR the student has no expected lessons yet — the UI treats both as «needs attention». */
  belowThreshold: Scalars['Boolean'];
};

/**
 * Per-currency revenue rollup for the group dashboard KpiStrip
 * (docs/groups/group_dashboard.md §G5). Lets the frontend drop the
 * heavy `agreements[].payments[]` payload on big groups.
 */
export type GroupRevenueAggregates = {
  __typename?: 'GroupRevenueAggregates';
  groupId: Scalars['ID'];
  rows: Array<GroupRevenueRow>;
};

/**
 * One currency bucket of `groupRevenueAggregates` (§G5).
 * 
 * Mirrors the client-side aggregation in `KpiStrip.tsx`: Number-coerce
 * decimals, clamp debt at 0.
 * 
 * ТЗ 0036: `debt` is the OVERDUE plan only (instalment date < today) and
 * `upcoming` is the rest, so `budget = paid + debt + upcoming`. Do not
 * recompute either as `budget − paid` on the client — that collapses the two
 * back into one and re-introduces the future plan as debt.
 */
export type GroupRevenueRow = {
  __typename?: 'GroupRevenueRow';
  currency: Scalars['String'];
  budget: Scalars['Float'];
  paid: Scalars['Float'];
  debt: Scalars['Float'];
  upcoming: Scalars['Float'];
  agreementsActive: Scalars['Int'];
  studentsWithDebt: Scalars['Int'];
};

/**
 * Group-level marks rollup — §G4. `average_mark` is a weighted mean
 * across students who have at least one mark; null when the journal is
 * empty.
 */
export type GroupPerformanceSummary = {
  __typename?: 'GroupPerformanceSummary';
  groupId: Scalars['ID'];
  averageMark?: Maybe<Scalars['Float']>;
  top: Array<StudentPerfRow>;
  bottom: Array<StudentPerfRow>;
  studentsWithoutMarks: Scalars['Int'];
};

/** One row of `groupPerformanceSummary.top`/`bottom`/`students`. */
export type StudentPerfRow = {
  __typename?: 'StudentPerfRow';
  studentId: Scalars['ID'];
  fullName: Scalars['String'];
  averageMark: Scalars['Float'];
  marksCount: Scalars['Int'];
};

/**
 * One group's at-a-glance signals for the account-manager command-center
 * dashboard (spec 0003 redesign): enrolment, contribution-based debt (NOT
 * Fakturownia), unanswered Slack/email, and open/overdue tasks. `debtTotal`
 * is the largest single-currency debt (with its `debtCurrency`); the full
 * per-currency debt / upcoming is `debtAmounts` / `upcomingAmounts`
 * (currencies are never added up — no FX for contracts).
 * 
 * ТЗ 0036: `debtTotal` / `debtorsCount` count only the OVERDUE plan
 * (instalment date < today). `upcomingTotal` is the not-yet-due plan in the
 * same currency — kept off the debt figure so the board ranks groups by real
 * exposure rather than by how far ahead their payment plans run.
 */
export type GroupOverviewRow = {
  __typename?: 'GroupOverviewRow';
  groupId: Scalars['ID'];
  name: Scalars['String'];
  course: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  /** Дата ПОСЛЕДНЕГО занятия группы (MAX по modules→lessons), включая будущие — то же выражение, которым фильтрует `activeWithinDays`. NULL у группы, у которой занятий ещё нет: это нормальное состояние новой группы, а не сбой, и клиент обязан считать такую группу ИДУЩЕЙ. */
  lastLessonDate?: Maybe<Scalars['Date']>;
  studentsCount: Scalars['Int'];
  /** Просроченный долг ОДНОЙ корзины валют — той, где сырое число больше (суммы разных валют сравниваются без пересчёта); долг группы в других валютах здесь не виден. Для показа — `debtAmounts`. */
  debtTotal: Scalars['Float'];
  /** Валюта `debtTotal` (пусто без долга). */
  debtCurrency: Scalars['String'];
  /** «Предстоит» в валюте `debtCurrency` — только этой корзины. Для показа — `upcomingAmounts`. */
  upcomingTotal: Scalars['Float'];
  /** Просроченный долг группы по валютам договоров (то же правило долга, что у `debtTotal`, ТЗ 0036): PLN первой, затем по сумме по убыванию; без долга — пусто. */
  debtAmounts: Array<LmsAmountDueType>;
  /** «Предстоит» (срок взноса ещё не наступил) по валютам договоров, тот же порядок, что у `debtAmounts`. */
  upcomingAmounts: Array<LmsAmountDueType>;
  debtorsCount: Scalars['Int'];
  /** Число студентов группы, у которых есть хотя бы одно НЕОБРАБОТАННОЕ входящее сообщение (Message.is_handled=False, direction=inbound) — оранжевая точка. Считает уникальных студентов, а не сообщения: студент, написавший и в Slack, и на почту, — один. Канал группы (без студента) добавляет +1 за себя. Прочитанность и статус диалога не учитываются. */
  unhandledStudentsCount: Scalars['Int'];
  /** Число студентов группы, у которых есть хотя бы одно непрочитанное сообщение (Message.is_read=False). Считает уникальных студентов, а не сообщения/диалоги; каналы (без студента) в счётчик не входят. */
  unreadStudentsCount: Scalars['Int'];
  /** Число НЕПРОЧИТАННЫХ сообщений (Message.is_read=False) по диалогам группы: её каналы плюс личные диалоги её АКТИВНЫХ студентов (Slack DM / Gmail) — та же популяция и способ атрибуции, что и unhandledStudentsCount. Каждое непрочитанное сообщение считается один раз (per-conversation unreadCount). Обычно совпадает с суммой бейджей внутри группы, но может немного отличаться: средняя колонка коммуникатора дополнительно показывает отчисленных студентов с непрочитанным и внероестерных собеседников из DM, которых этот счётчик по активным студентам не учитывает. */
  unreadMessagesCount: Scalars['Int'];
  /** ТЗ 0096: часть `unreadMessagesCount` из Slack (каналы, ЛС, групповые ЛС). Всегда unreadSlackCount + unreadMailCount == unreadMessagesCount. */
  unreadSlackCount: Scalars['Int'];
  /** ТЗ 0096: часть `unreadMessagesCount` из почты (треды Gmail студентов и преподавателей группы). */
  unreadMailCount: Scalars['Int'];
  /** ТЗ 0096: число ДИАЛОГОВ Slack группы (каналы + ЛС её активных студентов), где есть необработанное входящее. Считает диалоги, а не студентов — в отличие от `unhandledStudentsCount`. Преподаватели не входят. */
  unhandledSlackCount: Scalars['Int'];
  /** ТЗ 0096: число почтовых тредов активных студентов группы с необработанным входящим. */
  unhandledMailCount: Scalars['Int'];
  openTasksCount: Scalars['Int'];
  overdueTasksCount: Scalars['Int'];
};

/**
 * Счётчики меню ERP для текущего пользователя (ТЗ 0096).
 * 
 * Переписка считается по группам рейки Коммуникатора по умолчанию
 * (`groupsOverview(activeWithinDays: 30)`), каждый диалог один раз — студент
 * двух групп не удваивается. Видимость — как в рейке (чужой личный ящик не
 * считается).
 */
export type MyCommsCountersType = {
  __typename?: 'MyCommsCountersType';
  /** Непрочитанные письма (Message.is_read=False) в группах рейки. */
  mailUnread: Scalars['Int'];
  /** Непрочитанные сообщения Slack в группах рейки. */
  slackUnread: Scalars['Int'];
  /** Диалоги (Slack + почта), где есть необработанное входящее — «ждёт ответа». Преподаватели не входят. */
  unhandled: Scalars['Int'];
  /** Открытые задачи пользователя (assignee = я) со сроком раньше сегодня — то же, что `staffTasksSummary(assigneeMe: true).overdueCount`. */
  overdueTasks: Scalars['Int'];
};

export type UnionLessonType = GroupLessonForLmsType | StudentLessonType | MethodistLessonType;

export type StudentLessonType = Node & {
  __typename?: 'StudentLessonType';
  id: Scalars['ID'];
  name: Scalars['String'];
  taskTypes: Array<Scalars['String']>;
  module: GroupModuleType;
  teacherApplication?: Maybe<ApplicationType>;
  number: Scalars['Int'];
  date: Scalars['Date'];
  startTime: Scalars['Time'];
  endTime: Scalars['Time'];
  lmsDescription?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  finished: Scalars['Boolean'];
  additional?: Maybe<Scalars['Boolean']>;
  students: StudentTypeConnection;
  marks: StudentsMarkTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  studentsAttachments: StudentLessonAttachmentTypeConnection;
  teachersAttachments: TeacherLessonAttachmentTypeConnection;
  firstLessonAgreements: Array<AgreementType>;
  lastLessonAgreements: Array<AgreementType>;
  attendances: AttendanceTypeConnection;
  /** Начало занятия, aware (Europe/Warsaw); null без даты/времени */
  startsAt?: Maybe<Scalars['DateTime']>;
  /** Конец занятия, aware (Europe/Warsaw); через полночь — следующий день; null без даты/времени */
  endsAt?: Maybe<Scalars['DateTime']>;
  index?: Maybe<Scalars['Int']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  needToFinish?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  hasStudentAttachment?: Maybe<Scalars['Boolean']>;
  hasTeacherAttachment?: Maybe<Scalars['Boolean']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  homeworkAssignmentId?: Maybe<Scalars['ID']>;
  homeworkAvailable?: Maybe<Scalars['Boolean']>;
  hasJoinLink?: Maybe<Scalars['Boolean']>;
  linkOverrideActive?: Maybe<Scalars['Boolean']>;
};


export type StudentLessonTypeStudentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type StudentLessonTypeMarksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  taskType?: Maybe<Scalars['String']>;
  lessonId?: Maybe<Scalars['String']>;
};


export type StudentLessonTypeZoomProcessingLogsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type StudentLessonTypeStudentsAttachmentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type StudentLessonTypeTeachersAttachmentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type StudentLessonTypeAttendancesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type MethodistLessonType = Node & {
  __typename?: 'MethodistLessonType';
  id: Scalars['ID'];
  name: Scalars['String'];
  taskTypes: Array<Scalars['String']>;
  module: GroupModuleType;
  teacherApplication?: Maybe<ApplicationType>;
  number: Scalars['Int'];
  date: Scalars['Date'];
  startTime: Scalars['Time'];
  endTime: Scalars['Time'];
  lmsDescription?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  finished: Scalars['Boolean'];
  additional?: Maybe<Scalars['Boolean']>;
  students: StudentTypeConnection;
  marks: StudentsMarkTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  studentsAttachments: StudentLessonAttachmentTypeConnection;
  teachersAttachments: TeacherLessonAttachmentTypeConnection;
  firstLessonAgreements: Array<AgreementType>;
  lastLessonAgreements: Array<AgreementType>;
  attendances: AttendanceTypeConnection;
  /** Начало занятия, aware (Europe/Warsaw); null без даты/времени */
  startsAt?: Maybe<Scalars['DateTime']>;
  /** Конец занятия, aware (Europe/Warsaw); через полночь — следующий день; null без даты/времени */
  endsAt?: Maybe<Scalars['DateTime']>;
  index?: Maybe<Scalars['Int']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  needToFinish?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  hasStudentAttachment?: Maybe<Scalars['Boolean']>;
  hasTeacherAttachment?: Maybe<Scalars['Boolean']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  homeworkAssignmentId?: Maybe<Scalars['ID']>;
  homeworkAvailable?: Maybe<Scalars['Boolean']>;
  hasJoinLink?: Maybe<Scalars['Boolean']>;
  linkOverrideActive?: Maybe<Scalars['Boolean']>;
};


export type MethodistLessonTypeStudentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MethodistLessonTypeMarksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  taskType?: Maybe<Scalars['String']>;
  lessonId?: Maybe<Scalars['String']>;
};


export type MethodistLessonTypeZoomProcessingLogsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MethodistLessonTypeStudentsAttachmentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MethodistLessonTypeTeachersAttachmentsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MethodistLessonTypeAttendancesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type LessonAttachmentsType = {
  __typename?: 'LessonAttachmentsType';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
};

export type LessonAttachmentsForLmsType = {
  __typename?: 'LessonAttachmentsForLMSType';
  id: Scalars['ID'];
  title: Scalars['String'];
  file: Scalars['String'];
};

export type LessonAttendancesType = Node & {
  __typename?: 'LessonAttendancesType';
  id: Scalars['ID'];
  lesson: GroupLessonType;
  student: StudentType;
  attendance?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  markedAt?: Maybe<Scalars['DateTime']>;
  markedByName?: Maybe<Scalars['String']>;
};

/**
 * ERP «Кто заходил» по занятию (spec 0013, уточнён ТЗ 0026).
 * 
 * Строка = ЧЕЛОВЕК, а не клик: до 0026 тип резолвился из сырых
 * `LessonJoinClick`, и счётчик в заголовке поповера считал нажатия, а не
 * людей. Теперь резолвится из dict-ов `clicks_with_attendance`, `clickedAt`
 * — время первого входа, а `attendanceState` показывает расхождение между
 * «заходил» и тем, что стоит в журнале.
 */
export type LessonJoinClickType = {
  __typename?: 'LessonJoinClickType';
  id: Scalars['ID'];
  userName: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  clickedAt: Scalars['DateTime'];
  clicksCount: Scalars['Int'];
  /** present | absent | unmarked | none */
  attendanceState: Scalars['String'];
};

/**
 * Подсказка журнала преподавателя: первый клик студента (spec 0013).
 * Резолвится из dict-ов сервиса first_clicks_per_student.
 */
export type LmsLessonJoinClickType = {
  __typename?: 'LmsLessonJoinClickType';
  studentId: Scalars['Int'];
  studentName: Scalars['String'];
  clickedAt: Scalars['DateTime'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** С нуля (текст по умолчанию вида × области) или копией `basedOnId`. */
  createDocumentTemplate?: Maybe<CreateDocumentTemplate>;
  /** Название и/или новый текст (версия +1, она же текущая). */
  saveDocumentTemplate?: Maybe<SaveDocumentTemplate>;
  setDocumentTemplateActive?: Maybe<SetDocumentTemplateActive>;
  /** Откат: сделать текущей одну из прежних версий шаблона. */
  activateDocumentTemplateVersion?: Maybe<ActivateDocumentTemplateVersion>;
  /** Выпуск: номер, запись журнала и PDF (base64, файл не хранится). */
  issueDocument?: Maybe<IssueDocument>;
  /**
   * ТЗ 0112 §4: письмо с PDF выданного документа — ТОЛЬКО по явному
   * нажатию «Отправить» (выпуск сам ничего не шлёт). Путь «нового письма»
   * коммуникатора: ящик школы, письмо в переписке студента.
   */
  sendIssuedDocument?: Maybe<SendIssuedDocument>;
  /**
   * Включить / выключить встроенный инструмент чата (новые записи — тоже
   * только через карточку «Zatwierdź»).
   */
  setAiChatToolEnabled: AiBuiltinToolType;
  /**
   * Создать (черновиком) или изменить скил; `files: null` — файлы не
   * трогать. Встроенный — `forbidden`. `expectedVersion` не совпал с
   * сохранённой версией — `conflict` (двое правили одновременно).
   */
  saveAiSkill: AiAgentSkillType;
  /**
   * SKILL.md или .zip (SKILL.md в корне или в одной папке + текстовые
   * файлы ≤ 1 МБ, всего ≤ 5 МБ; загрузка ≤ 10 МБ) → черновик; скил с тем же
   * именем (ручной / импортированный) обновляется.
   */
  importAiSkill: AiAgentSkillType;
  /** draft | published | archived (встроенный — тоже можно). */
  setAiSkillStatus: AiAgentSkillType;
  /** Удалить скил и его файлы. Встроенный — `forbidden` (архив). */
  deleteAiSkill: Scalars['Boolean'];
  /**
   * Создать или изменить подключение. `secret` только на запись: null —
   * не менять, "" — снять. Адрес — только https на публичный хост.
   * Смена цели (адрес, транспорт, вид входа, заголовок) снимает секрет,
   * OAuth, согласие на ПДн, включение и одобрения инструментов — в ответе
   * `enabled=false`, `allowPii=false`, `status=never_checked`.
   */
  saveAiMcpConnection: AiMcpConnectionType;
  /**
   * «Testuj połączenie»: обнаружение инструментов (синхронно, до 8 с).
   * Итог — в `status` / `lastError` подключения, не ошибкой GraphQL.
   */
  testAiMcpConnection: AiMcpConnectionType;
  /**
   * Адрес входа OAuth у провайдера (PKCE, обнаружение метаданных,
   * динамическая регистрация). После входа провайдер возвращает на
   * `/ai/mcp/oauth/callback`, тот — в ERP
   * `/ai-agent?tab=tools&section=mcp&conn=<id>&oauth=ok|error[&code=…]`.
   */
  startAiMcpOAuth: Scalars['String'];
  /**
   * Включён / требует подтверждения — по инструментам подключения.
   * Меняются только присланные инструменты (ERP шлёт один изменённый);
   * у присланного снимается `changed`.
   */
  setAiMcpToolSettings: AiMcpConnectionType;
  /** Удалить подключение (секреты, токены, инструменты). */
  deleteAiMcpConnection: Scalars['Boolean'];
  /**
   * .zip в раскладке Claude Code (загрузка ≤ 10 МБ) → плагин (выключен),
   * его скилы (черновики) и подключения (выключены); повторный импорт
   * того же `name` — обновление на месте.
   */
  importAiPlugin: AiPluginType;
  /** Пакетом: скилы → published / draft, подключения → enabled. */
  setAiPluginEnabled: AiPluginType;
  /** Удалить плагин вместе с его скилами и подключениями. */
  deleteAiPlugin: Scalars['Boolean'];
  /**
   * Сообщение агенту: новый тред (`threadId` пуст, заголовок — первые 60
   * символов) или продолжение своего. Ответ сразу — тред с `activeRun`;
   * экран поллит `aiChatThread`, пока прогон жив.
   */
  sendAiChatMessage: AiChatThreadDetailType;
  /**
   * «Zatwierdź» (`approve: true`) исполняет предложенную запись с
   * сохранёнными аргументами — без LLM; «Odrzuć» — отклоняет. Затем
   * ассистент коротко подтверждает итог новым ходом (если чат включён).
   */
  resolveAiChatAction: AiChatPendingActionType;
  /**
   * Удалить свой тред (сообщения, предложения, карту псевдонимов);
   * живой прогон треда отменяется.
   */
  deleteAiChatThread: Scalars['Boolean'];
  /**
   * Картинка к будущему сообщению (PNG / JPEG / WEBP / GIF ≤ 5 МБ,
   * сигнатура по первым байтам). Черновик живёт 24 ч; id — в
   * `sendAiChatMessage(attachmentIds)`.
   */
  uploadAiChatAttachment: AiChatAttachmentType;
  pinAiChatThread: AiChatThreadType;
  renameAiChatThread: AiChatThreadType;
  archiveAiChatThread: AiChatThreadType;
  /**
   * Одобрить: строка `- <правило> [src: kbc <id>]` под заголовком
   * документа категории, ревизия и переиндексация (без LLM).
   */
  approveAiKbCandidate: AiKbCandidateType;
  rejectAiKbCandidate: AiKbCandidateType;
  /**
   * Дубль: свои доказательства и поддержку отдаёт `duplicateOfId`, если
   * тот ещё ждёт разбора.
   */
  markAiKbCandidateDuplicate: AiKbCandidateType;
  /**
   * Поправить правило, вопрос, категорию (рецензент — только в свою),
   * целевой документ и заголовок.
   */
  updateAiKbCandidate: AiKbCandidateType;
  /** Назначить рецензентов категории (заменяет список целиком). */
  setAiKbReviewers: AiKbReviewerCategoryType;
  /**
   * ТЗ 0118 шаг 2: «Potwierdź aktualność» — `verifiedAt = now`, открытая
   * задача-напоминание закрывается. Admin или рецензент категории
   * документа.
   */
  verifyAiKnowledgeDocument: AiKnowledgeDocumentType;
  /**
   * Создать (черновиком) или изменить документ. Чанки и `tokens`
   * пересчитываются, `version` растёт, если изменился текст.
   */
  saveAiKnowledgeDocument: AiKnowledgeDocumentType;
  /**
   * ТЗ 0118 B1: вернуть тело, заголовок и категорию ревизии `version`
   * новой версией документа (`reason=rollback`).
   */
  rollbackAiKnowledgeDocument: AiKnowledgeDocumentType;
  /**
   * Файл md/txt/pdf/docx (до 10 MB) → черновик с извлечённым текстом;
   * сам файл — в приватный бакет.
   */
  uploadAiKnowledgeDocument: AiKnowledgeDocumentType;
  /** draft | published | archived. Агенты видят только published. */
  setAiKnowledgeDocumentStatus: AiKnowledgeDocumentType;
  /** Удалить документ, его чанки и исходный файл. */
  deleteAiKnowledgeDocument: Scalars['Boolean'];
  /**
   * Запросить анализ занятия. Тот же ключ (транскрипт, метаданные,
   * версии, модель) → сохранённый разбор без вызова модели; `force` — новый
   * разбор со ссылкой `supersedes`. Ответ сразу (`queued`), фронт поллит
   * `aiLessonAnalysis`.
   */
  requestAiLessonAnalysis: AiLessonAnalysisType;
  /**
   * ТЗ 0116: разбор нескольких прошедших занятий (≤ 20) — каждое через
   * тот же путь, что `requestAiLessonAnalysis`: отказ одного занятия не
   * мешает другим, кончился бюджет — остальные `budget_exceeded`. Аудит —
   * на каждое занятие.
   */
  requestAiLessonAnalyses: AiLessonBatchResultType;
  /**
   * ТЗ 0116: итог ИИ по преподавателю — один вызов модели над готовыми
   * разборами его занятий в видимых группах (без расшифровок). Ответ сразу
   * (`queued`), фронт поллит `aiTeacherPracticePortrait.narrativeStatus`.
   * Мало разборов — `not_enough_data`; уже идёт — та же генерация.
   */
  generateAiTeacherNarrative: AiTeacherNarrativeType;
  /**
   * Решение проверяющего (Admin, Methodist, AccountManager, HRManager)
   * по разбору: подтвердить / не подтвердить.
   */
  reviewAiLessonAnalysis: AiLessonAnalysisType;
  /**
   * «Odśwież portret» (spec 0104): queues a portrait run and returns the
   * portrait with status `queued` — poll `aiStudentPortrait`. Errors:
   * ai_disabled, already_running, budget_exceeded, not_found.
   */
  refreshAiStudentPortrait: AiStudentPortraitType;
  /**
   * «Zaproponuj odpowiedź»: черновик на последнее сообщение студента.
   * Живой черновик того же варианта (с деньгами — финансовым ролям, без
   * денег — остальным) на то же сообщение возвращается как есть; иначе —
   * новый `queued` (клиент поллит `aiReplySuggestion`). Факты — в юрлицах
   * сотрудника.
   */
  requestAiReplySuggestion: AiReplySuggestionType;
  /**
   * Отметка сотрудника: `inserted` (вставил в редактор) или `rejected`
   * (с причиной). `sent` ставит сервер сам по исходящему после вставки.
   */
  markAiReplySuggestion: AiReplySuggestionType;
  /**
   * «Nie to» — a false positive: the open task is cancelled, feedback
   * `false_positive` with the reason and the author.
   */
  rejectAiFinding: AiFindingType;
  /**
   * The finding is right (`confirmed`, counts in precision); the task is
   * left as is.
   */
  confirmAiFinding: AiFindingType;
  /**
   * Ручной запуск агента из ERP (только агенты с `manual_start`).
   * Ответ сразу — прогон `queued`; экран поллит `aiAgentRun`. По субъекту
   * уже идёт прогон — он и возвращается (второй оплаченный не ставится);
   * невидимый пользователю субъект — `not_found`.
   */
  startAiAgentRun: AiAgentRunType;
  /**
   * Отменить прогон: в очереди — сразу, идущий — на ближайшем шаге
   * графа. Завершённый возвращается как есть.
   */
  cancelAiAgentRun: AiAgentRunType;
  /**
   * Записать значение ключа. Значение совпадает с текущим — `changed:
   * false`, журнал не пишется.
   */
  setRuntimeSetting?: Maybe<SetRuntimeSetting>;
  /** Снять значение «Настроек» — снова действует env. */
  clearRuntimeSetting?: Maybe<ClearRuntimeSetting>;
  /** Выключить беспризорную строку `PeriodicTask` (нет в `beat_schedule`). */
  disableOrphanPeriodicTask?: Maybe<DisableOrphanPeriodicTask>;
  /**
   * Рынок (локация, язык, устройство, глубина, набор, повторы AI, порог
   * разрыва) и домены (свой — `ownDomain`).
   */
  saveMarketingSeoSettings?: Maybe<OutputMarketingSeoSettings>;
  /**
   * Исключить запрос (из набора и разрывов) или вернуть / добавить в
   * недельный набор.
   */
  saveMarketingSeoKeyword?: Maybe<OutputMarketingSeoKeyword>;
  /** Ручные запросы (до 200 за раз); в набор — пока есть место. */
  addMarketingSeoKeywords?: Maybe<OutputMarketingSeoKeywordsAdded>;
  /**
   * Вопрос AI (польский): новый или правка (правка текста или группы —
   * новая версия: ответы старой не сравниваются).
   */
  saveMarketingSeoQuestion?: Maybe<OutputMarketingSeoQuestion>;
  /**
   * Удалить вопрос; если ответы уже есть — выключить (история
   * остаётся).
   */
  deleteMarketingSeoQuestion?: Maybe<OutputMarketingSeoQuestionDeleted>;
  /** Решение по возможностям пакетом («В план» — `planned`). */
  setMarketingSeoOpportunityStatus?: Maybe<OutputMarketingSeoOpportunities>;
  /**
   * Смета (`dryRun=true`, по умолчанию) или запуск прогона DataForSEO
   * (Admin; платно; `MARKETING_SEO_ENABLED` проверяется здесь и в задаче).
   * Отказы: `seo_disabled` (ключ выключен), `seo_budget` (смета не
   * проходит: потолок / лимит прогона / цены), `bad_kind`.
   */
  runMarketingSeo?: Maybe<OutputMarketingSeoRun>;
  refreshMarketingSources?: Maybe<OutputMarketingRefresh>;
  saveMarketingChannelRule?: Maybe<OutputMarketingChannelRule>;
  deleteMarketingChannelRule?: Maybe<OutputMarketingOk>;
  saveMarketingCourseFamily?: Maybe<OutputMarketingCourseFamily>;
  saveMarketingCourseAlias?: Maybe<OutputMarketingCourseAlias>;
  deleteMarketingCourseAlias?: Maybe<OutputMarketingOk>;
  saveMarketingOfferRule?: Maybe<OutputMarketingOfferRule>;
  deleteMarketingOfferRule?: Maybe<OutputMarketingOk>;
  setMarketingPipelineKind?: Maybe<OutputMarketingOk>;
  overrideMarketingAdEntity?: Maybe<OutputMarketingOk>;
  overrideMarketingSale?: Maybe<OutputMarketingOk>;
  setMarketingTarget?: Maybe<OutputMarketingOk>;
  ackMarketingSignal?: Maybe<OutputMarketingOk>;
  saveMarketingCampaignAlias?: Maybe<OutputMarketingCampaignAlias>;
  deleteMarketingCampaignAlias?: Maybe<OutputMarketingOk>;
  /**
   * Регулярка бренда поиска и ключевые события GA4. Не переданное поле
   * не меняется. Смена бренда переразмечает собранную историю поиска
   * (задача `marketing.reclassify_ads`); ключевые события действуют на
   * новые сборы GA4.
   */
  saveMarketingSearchSettings?: Maybe<OutputMarketingSearchSettings>;
  /**
   * «Пересобрать» AI-сводку недели (по умолчанию — последней
   * завершённой): заводит строку `queued` и ставит задачу; ответ — сразу.
   * Сводка за эту неделю уже готовится — отказ `digest_running`; флаг
   * `MARKETING_DIGEST_ENABLED` выключен — `digest_disabled`; платный вызов
   * ограничен: та же неделя — не раньше 30 минут после прошлой сводки
   * (`digest_cooldown`), не больше 5 сводок в день (`digest_daily_cap`).
   */
  generateMarketingDigest?: Maybe<OutputMarketingOk>;
  /**
   * Правило «сигнал → задача» (только Admin): виды, важность не ниже,
   * исполнители — только те, кто видит задачи ERP.
   */
  saveMarketingSignalRouting?: Maybe<OutputMarketingOk>;
  /**
   * Правила типов страниц сайта `[{type, regex}]` целиком (порядок —
   * приоритет; пустой список — правила по умолчанию). Сохранение
   * переразмечает справочник страниц и заказывает пересборку
   * (`LeadEntry.page_type`).
   */
  saveMarketingPageTypes?: Maybe<OutputMarketingPageTypes>;
  /** Заказать выгрузку данных для P&L. Файл собирается в фоне. */
  requestPnlExport?: Maybe<RequestPnlExportMutation>;
  /** Поставить в очередь забор участников группы за окно дат. */
  requestZoomParticipantsSync?: Maybe<RequestZoomParticipantsSyncMutation>;
  /**
   * Ручное решение по участнику: привязать к человеку, игнорировать или
   * сбросить. Применяется ко всем заходам той же личности в проведении.
   */
  matchZoomParticipant?: Maybe<MatchZoomParticipantMutation>;
  /**
   * Закрепить проведение за занятием (решение оператора).
   * 
   * `instanceUuid` — конкретное проведение (из кандидатов или из Zoom);
   * `meetingId` — все проведения встречи в окне занятия.
   */
  linkZoomInstanceToLesson?: Maybe<LinkZoomInstanceToLessonMutation>;
  /**
   * Отвязать проведение от занятия. Оно закрепляется как «ничьё»:
   * авто-сопоставление его больше не привяжет.
   */
  unlinkZoomInstance?: Maybe<UnlinkZoomInstanceMutation>;
  /**
   * Сохранить общие настройки писем. Часы — 0…23 (`invalid_hour`), адреса
   * — корректный email или пусто (`invalid_email`). Строка перечитывается под
   * `select_for_update`: параллельное сохранение других полей не затирается.
   */
  saveFundingMailSettings?: Maybe<SaveFundingMailSettingsMutation>;
  /**
   * Создать правило «за N дней» или изменить любое.
   * 
   * Проверки: срок 0…90 и не занят другим правилом (`invalid_offset`,
   * `offset_taken`); «набор идёт» — раз в 1…30 дней (`invalid_every`);
   * включить можно только с шаблоном (`template_required`); новый шаблон
   * обязан существовать в SendGrid (`template_not_found`), его имя и тема
   * копируются оттуда; SendGrid недоступен — ничего не сохраняется.
   * 
   * 🔴 Код правила не меняется никогда: смена срока «7 → 5» не шлёт повторно
   * тем, кому уже писали «за 7».
   */
  saveFundingMailRule?: Maybe<SaveFundingMailRuleMutation>;
  /**
   * Удалить правило «за N дней» (`cannot_delete` для остальных — их только
   * выключают). Журнал писем остаётся: у строк правило обнуляется, шаблон и
   * переменные сохранены снимком.
   */
  deleteFundingMailRule?: Maybe<DeleteFundingMailRuleMutation>;
  /**
   * Отправить шаблон правила на адрес вызывающего сотрудника (или на
   * DOFIN_MAIL_TEST_RECIPIENT). Данные — выбранного окна набора, без окна —
   * пример из справочника переменных. Ссылки уходят как есть, без
   * сокращения. Нужен DOFIN_MAIL_ENABLED (`disabled_on_server`); пауза ERP
   * тесту не мешает. Строки в журнале писем не пишет.
   */
  sendFundingMailTest?: Maybe<SendFundingMailTestMutation>;
  /**
   * SMS кандидату дофинансирования — свой текст или шаблон, любая ссылка.
   * Повтор того же `requestKey` — та же SMS.
   */
  sendFundingCandidateSms?: Maybe<SendFundingCandidateSms>;
  /**
   * ИИ-письмо лиду по всему, что о нём знаем (ТЗ 0120). Ошибки:
   * ai_disabled, budget_exceeded, bad_input, no_contract (contract без
   * договора, ждущего подписи), WRONG_STATUS / FORBIDDEN / SHORTLINK_DISABLED
   * (ссылка договора), in_progress, internal_error, LEAD_NOT_FOUND.
   */
  draftLeadEmail?: Maybe<DraftLeadEmail>;
  /**
   * Создать (без id) или изменить сохранённый вид списка (`scope`).
   * Общий (`shared`) — только Admin. Ошибки: required / too_long (name),
   * invalid (view, scope), invalid / unknown_filter / too_large (filters),
   * forbidden (shared), not_found (id).
   */
  saveLeadSavedView?: Maybe<SaveLeadSavedView>;
  /** Удалить свой вид экрана `scope`; общий — только Admin. */
  deleteLeadSavedView?: Maybe<DeleteLeadSavedView>;
  /**
   * ТЗ 0106: перенести лида на этап его воронки — запись в Kommo, потом
   * зеркало. Ошибка Kommo — customErrors с кодом клиента (AUTH, NETWORK,
   * RATE_LIMITED, TIMEOUT, ERROR, DISABLED), зеркало не меняется. Отказы
   * проверки: LEAD_NOT_FOUND, LEAD_DELETED, STAGE_NOT_FOUND,
   * STAGE_OTHER_PIPELINE, LOSS_REASON_NOT_FOUND, SOURCE_MISMATCH.
   */
  moveKommoLead?: Maybe<MoveKommoLead>;
  /**
   * ТЗ 0106: сменить ответственного лида в Kommo (и в зеркале). `userId`
   * — id строки из kommoLeadResponsibles. Ошибки — как у moveKommoLead, плюс
   * USER_NOT_FOUND.
   */
  setKommoLeadResponsible?: Maybe<SetKommoLeadResponsible>;
  /**
   * ТЗ 0086: связать лида вручную с заявкой дофинансирования или
   * студентом — или отвязать (`targetId: null`). Ручная связь запирается:
   * робот её больше не переписывает (вернуть роботу — `resetKommoLeadLink`).
   * 
   * `what`: `candidate` (targetId — id заявки дофинансирования) |
   * `student` (targetId — id студента).
   */
  linkKommoLead?: Maybe<LinkKommoLead>;
  /**
   * ТЗ 0086: вернуть связь роботу — снять ручной замок и пересверить по
   * email и телефону.
   */
  resetKommoLeadLink?: Maybe<ResetKommoLeadLink>;
  /**
   * SMS лиду от «LearnIT» — свой текст или шаблон, любая ссылка или анкета
   * дофинансирования (короткая, со счётчиком переходов). Ставится в очередь;
   * шлёт воркер. Повтор того же `requestKey` — та же SMS.
   */
  sendLeadSms?: Maybe<SendLeadSms>;
  /** Перечитать лида из Kommo сейчас (не чаще раза в минуту). */
  refreshKommoLead?: Maybe<RefreshKommoLead>;
  /**
   * Admin: синхронизировать лидов сейчас (в фоне). Работает и без
   * `KOMMO_SYNC_ENABLED` — флаг управляет только расписанием.
   */
  syncKommoLeads?: Maybe<SyncKommoLeads>;
  /**
   * Admin: сотрудник ERP за пользователем Kommo. `locked=false` — вернуть
   * автоматике (по email).
   */
  setKommoUserMapping?: Maybe<SetKommoUserMapping>;
  /** Admin: повторить примечания, которые Kommo не принял. */
  retryKommoNotes?: Maybe<RetryKommoNotes>;
  /**
   * Поставить лида на SMS-лесенку. `dofin_form` — «пока не заполнит
   * анкету» (SMS раз в день `days` дней); `reminder` — напоминания по плану.
   * Активный запуск того же вида заменяется. `warning` — почему сейчас не
   * шлёт (план выключен, нет телефона…): запуск всё равно создан.
   */
  startLeadLadder?: Maybe<StartLeadLadder>;
  stopLeadLadder?: Maybe<StopLeadLadder>;
  resumeLeadLadder?: Maybe<ResumeLeadLadder>;
  /**
   * Письмо лиду со своей рабочей почты (или общего ящика). `{link}` в
   * тексте — ссылка на анкету дофинансирования. Ответ приходит в тот же ящик
   * и появляется в карточке после синхронизации Gmail.
   */
  sendLeadEmail?: Maybe<SendLeadEmail>;
  /**
   * «Пригласить к анкете» одной кнопкой: письмо со ссылкой на анкету
   * дофинансирования и — `startLadder` (по умолчанию да) — лесенка «SMS раз
   * в день `days` дней, пока не заполнит». Письмо не ушло — лесенки нет;
   * SMS сейчас не могут — письмо ушло, причина в `ladderWarning`.
   */
  inviteLeadToFundingForm?: Maybe<InviteLeadToFundingForm>;
  /**
   * ТЗ 0117: AI-черновик письма лиду по разобранному звонку Aplora —
   * только текст (тема и тело); отправка — штатная sendLeadEmail. Повтор
   * того же `requestKey` — тот же ответ (24 ч), `regenerate` — новый
   * черновик. Ошибки: aplora_disabled, not_found (лид, звонок не этого
   * лида), not_analyzed, aplora_rate_limited, aplora_unavailable.
   */
  aploraFollowupDraft?: Maybe<AploraFollowupDraftMutation>;
  /**
   * SMS преподавателю от «LearnIT» — свой текст или шаблон, ссылка на
   * подпись его документа, LMS или любой адрес. Ставится в очередь; шлёт
   * воркер. Повтор того же `requestKey` — та же SMS.
   */
  sendTeacherSms?: Maybe<SendTeacherSms>;
  /**
   * SMS студенту от «LearnIT» — свой текст или шаблон, ссылка на оплату его
   * фактуры, LMS или любой адрес. Ставится в очередь; шлёт воркер.
   */
  sendStudentSms?: Maybe<SendStudentSms>;
  /**
   * Рассылка по группе: у каждого студента своя SMS и своя ссылка.
   * Повтор того же `requestKey` — та же рассылка, без второй волны SMS.
   */
  sendGroupSms?: Maybe<SendGroupSms>;
  /**
   * Повторить рассылку тем, у кого SMS упала или пропущена по устранимой
   * причине (канал был выключен, не было телефона). Отправленным — никогда.
   */
  resendSmsCampaign?: Maybe<ResendSmsCampaign>;
  retrySmsMessage?: Maybe<RetrySmsMessage>;
  cancelSmsMessage?: Maybe<CancelSmsMessage>;
  saveSmsSettings?: Maybe<SaveSmsSettings>;
  /**
   * ТЗ 0084: тексты канала, которые правят Admin и продавцы (настройки
   * самого канала — `saveSmsSettings`, только Admin). Сейчас — хвост
   * отписки рассылки по группе; пусто — вернуть текст по умолчанию.
   * 
   * В хвосте обязательно `{link}/stop` (`STOP_LINK_REQUIRED`): страница
   * отписки — это `/stop` короткой ссылки сообщения, а голая `{link}` вела бы
   * человека на саму рассылку, и отписаться ему было бы негде.
   */
  saveSmsTexts?: Maybe<SaveSmsTexts>;
  /**
   * ТЗ 0084: адрес анкеты дофинансирования и LMS. Не передано — не
   * меняется; пустая строка — вернуть значение из env. Только http(s).
   */
  saveLinkAddresses?: Maybe<SaveLinkAddresses>;
  /**
   * Лестница целиком: включена ли и шаги (номер, якорь, через сколько,
   * условие, шаблон). Шаги, которых нет во входе, удаляются — но уже
   * созданные SMS остаются.
   */
  saveReminderPlan?: Maybe<SaveReminderPlan>;
  /**
   * `test=1` в SMSAPI: токен, имя отправителя и номер — без отправки и без
   * списания. Заодно обновляет баланс и статус имени.
   */
  checkSmsConnection?: Maybe<CheckSmsConnection>;
  /**
   * Настоящая тестовая SMS на указанный номер — ОТПРАВЛЯЕТСЯ и стоит денег.
   * Нужен включённый на сервере канал (env SMS_ENABLED) — это не проверка, а
   * отправка; «Проверить подключение» — для проверки.
   */
  sendSmsTest?: Maybe<SendSmsTest>;
  createShortLink?: Maybe<CreateShortLink>;
  updateShortLink?: Maybe<UpdateShortLink>;
  revokeShortLink?: Maybe<RevokeShortLink>;
  /**
   * Погасить выбранные. Каждая — по своим правам: чужие, уже погашенные
   * и те, что гасить нельзя, пропускаются, а не валят всю пачку.
   */
  revokeShortLinks?: Maybe<RevokeShortLinks>;
  /**
   * Новая версия max+1 того же кода из текста редактора: действующая,
   * прежняя выключена, неотправленные черновики кода перерисованы.
   */
  saveContractTemplateVersion?: Maybe<SaveContractTemplateVersion>;
  /** Новый шаблон (код) копией снимка базовой версии; вид — базовой. */
  createContractTemplate?: Maybe<CreateContractTemplate>;
  /**
   * Откат / включение версии (в т. ч. версии из кода, заведённой выкатом
   * неактивной). Черновики кода перерисовываются.
   */
  activateContractTemplateVersion?: Maybe<ActivateContractTemplateVersion>;
  /**
   * Выключить шаблон из ERP целиком (кроме последнего действующего кода
   * вида) или включить снова.
   */
  setContractTemplateActive?: Maybe<SetContractTemplateActive>;
  /**
   * Новое письмо подписанту из ящика продавца (или общего). Ответ приходит
   * в тот же ящик и появляется в карточке после синхронизации.
   */
  sendContractEmail?: Maybe<SendContractEmail>;
  /**
   * ТЗ 0120 (этап 2): ИИ-письмо по договору продаж. Виды: invite (тело
   * приглашения для sendContract / resendContractEmail — `{link}`
   * обязателен), reminder, expiring (нужна живая ссылка; `{link}`
   * подставит sendContractEmail), followup, after_signing (без ссылки).
   * Ошибки: NOT_FOUND / WRONG_STATUS / NOT_HANDLER… (contract — права и
   * вид договора), bad_input (kind), ai_disabled, budget_exceeded,
   * LINK_NOT_READY, NO_EXPIRY, SHORTLINK_DISABLED, NOT_SIGNED,
   * WRONG_STATUS (invite), in_progress, internal_error.
   */
  draftContractEmail?: Maybe<DraftContractEmail>;
  /** Ставит ручной шаг в очередь; шлёт воркер, а не эта мутация. */
  sendContractReminderNow?: Maybe<SendContractReminderNow>;
  stopContractReminders?: Maybe<StopContractReminders>;
  resumeContractReminders?: Maybe<ResumeContractReminders>;
  /**
   * ТЗ 0078: короткая ссылка договора — чтобы продавец отправил её сам
   * (SMS со своего телефона, мессенджер). Та же ссылка, что уходит в SMS и
   * в письме: переходы по ней считаются в карточке. Как и ссылка на подпись,
   * это bearer-секрет — выдаётся только так и пишется в журнал договора.
   */
  revealContractShortLink?: Maybe<RevealContractShortLink>;
  /**
   * ТЗ 0078: SMS подписанту со своим текстом (обычно из шаблона). Все
   * защиты доставки те же, что у напоминаний: отписка, тихие часы, дневной
   * лимит, только +48, приёмочный список; кулдаун общий с «Напомнить».
   */
  sendContractSms?: Maybe<SendContractSms>;
  /**
   * ТЗ 0083: одна SMS многим подписантам из списка договоров. Уходит
   * только отправленным и не подписанным договорам, чью переписку ведёт
   * сотрудник; остальные — строкой с причиной. `requestKey` — повтор того же
   * запроса (сеть, двойной клик) не шлёт второй раз.
   */
  sendContractsSms?: Maybe<SendContractsSms>;
  /**
   * Справочник шаблонов (ТЗ 0078): создать или изменить — Admin и
   * продавцы; шаблоны оплаты фактур — ещё и финансы (ТЗ 0084,
   * `can_edit_templates`).
   */
  saveMessageTemplate?: Maybe<SaveMessageTemplate>;
  /**
   * Удалить шаблон — те же, кто его правит (`can_edit_templates`);
   * системный можно лишь выключить. ТЗ 0094: свою личную версию — всегда
   * (отправка вернётся к общему тексту), чужую — никто.
   */
  deleteMessageTemplate?: Maybe<DeleteMessageTemplate>;
  createStudentContractDraft?: Maybe<CreateStudentContractDraft>;
  updateContractDraft?: Maybe<UpdateContractDraft>;
  createCompanyContractDraft?: Maybe<CreateCompanyContractDraft>;
  updateCompanyContractDraft?: Maybe<UpdateCompanyContractDraft>;
  sendContract?: Maybe<SendContract>;
  resendContractEmail?: Maybe<ResendContractEmail>;
  /**
   * Ссылка на подпись — bearer-секрет: выдаётся только так и попадает
   * в журнал договора (кто и когда её взял).
   */
  revealContractSigningLink?: Maybe<RevealContractSigningLink>;
  /**
   * ТЗ 0078: передать договор другому продавцу — только Admin, с причиной;
   * смена пишется в журнал договора.
   */
  reassignContractSeller?: Maybe<ReassignContractSeller>;
  cancelContract?: Maybe<CancelContract>;
  retryContractFulfilment?: Maybe<RetryContractFulfilment>;
  createTeacherFrameworkDraft?: Maybe<CreateTeacherFrameworkDraft>;
  createTeacherAnnexDraft?: Maybe<CreateTeacherAnnexDraft>;
  /** Цена курса для тарифа в валюте (#132): создать или заменить. */
  setCoursePlanPrice?: Maybe<SetCoursePlanPrice>;
  deleteCoursePlanPrice?: Maybe<DeleteCoursePlanPrice>;
  /** Отметить конкретные строки прочитанными. */
  markStaffNotificationsRead?: Maybe<MarkStaffNotificationsRead>;
  /** «Прочитать всё». */
  markAllStaffNotificationsRead?: Maybe<MarkAllStaffNotificationsRead>;
  updateStaffNotificationSettings?: Maybe<UpdateStaffNotificationSettings>;
  /** Выдать одноразовую ссылку привязки. */
  startTelegramLink?: Maybe<StartTelegramLink>;
  unlinkTelegram?: Maybe<UnlinkTelegram>;
  /**
   * Create or update an operator, then re-expand its coverage index.
   * 
   * Coverage is DERIVED — `services.geo.rebuild_coverage` runs on every save,
   * so the (operator × powiat) matching index can never drift away from the
   * declared scope.
   */
  saveFundingOperator?: Maybe<SaveFundingOperator>;
  /**
   * Набор заводит и правит человек — робот только двигает статус (ТЗ 0048).
   * 
   * Мутация написана в ТЗ 0046 и до ТЗ 0048 **не вызывалась ни одним
   * экраном**: формы набора не существовало. Три дефекта, разобранные в
   * `save_intake`, прожили в ней ровно поэтому — их некому было предъявить.
   */
  saveFundingIntake?: Maybe<SaveFundingIntake>;
  deleteFundingIntake?: Maybe<DeleteFundingIntake>;
  /**
   * Публичная форма приёма заявок. ЕДИНСТВЕННАЯ анонимная запись в домене.
   * 
   * Три правила, каждое из которых существует из-за конкретного риска:
   * 
   * * **ответ одинаков для знакомого и незнакомого e-mail** — иначе форма
   *   становится оракулом перебора адресов, и её ответ собирается скриптом.
   *   По той же причине здесь нет ни «вы уже подавали заявку», ни возврата
   *   идентификатора кандидата;
   * * **`CustomUser` не создаётся никогда** — e-mail и телефон у пользователя
   *   уникальны, и анонимная запись заняла бы адрес, на который потом
   *   резолвится реальный подписанный договор;
   * * **сначала сохраняется сырая заявка, потом отдельно триаж** — лид не
   *   должен теряться из-за того, что упала дедупликация.
   * 
   * Ошибка триажа НЕ отменяет приём: заявка уже в базе, менеджер разберёт её
   * из админки, а причина остаётся в `process_error`.
   */
  submitFundingForm?: Maybe<SubmitFundingForm>;
  /**
   * Create or edit a candidate.
   * 
   * Note what is NOT here: `status` and `primary_operator`. Both move through
   * their own mutations so every transition is written to
   * `FundingCandidateEvent` — under one-row-per-person that log is the only
   * history there is.
   */
  saveFundingCandidate?: Maybe<SaveFundingCandidate>;
  /**
   * Удалить заявку-дубль или тестовую (задача #95).
   * 
   * Отказывает (`candidate_in_use`), если человеку уже писали или строка
   * пришла из Notion, — тогда архив: `saveFundingCandidate(id, input:
   * {isArchived: true})` меняет только этот флаг. Правила — в
   * `services.candidates.delete_candidate`.
   */
  deleteFundingCandidate?: Maybe<DeleteFundingCandidate>;
  changeCandidateStatus?: Maybe<ChangeCandidateStatus>;
  /**
   * Добавить кандидату операторов — сразу нескольких.
   * 
   * Заменила `setCandidateOperator` (ТЗ 0067): «выбранный» перестал быть
   * одним, и мутация «поставь одного вместо всех» описывала правило, которого
   * больше нет. Выключенного оператора НЕ воскрешает — для этого есть явная
   * `reactivateCandidateOperator`.
   */
  addCandidateOperators?: Maybe<AddCandidateOperators>;
  /**
   * Выключить оператора у кандидата. Причина обязательна.
   * 
   * Единственное, что прекращает письма конкретного оператора (кроме
   * терминального статуса кандидата). Строку связи не удаляет — она остаётся
   * журналом и объясняет, почему к оператору больше не ходят.
   */
  deactivateCandidateOperator?: Maybe<DeactivateCandidateOperator>;
  /** Вернуть выключенного оператора в работу — решение человека. */
  reactivateCandidateOperator?: Maybe<ReactivateCandidateOperator>;
  /**
   * Пометить ведущего оператора (или снять пометку).
   * 
   * ⚠️ Пометка НИКОГО НЕ ГЛУШИТ: письма продолжают уходить от всех активных
   * операторов. До ТЗ 0067 эта же запись означала «перевод, старый
   * замолкает» — теперь замолкание делается явно и с причиной.
   */
  setCandidatePrimaryOperator?: Maybe<SetCandidatePrimaryOperator>;
  /**
   * Поставить или снять отметку «повышенное внимание» (задача ERP #105).
   * 
   * Перед стартом ближайшего живого окна активного оператора кандидата робот
   * `attention_intake_tasks` заведёт задачу тому, кто поставил отметку.
   * Переход пишется в журнал событий кандидата; `erp_edited_at` НЕ ставится —
   * это не правка строки, и импорт из Notion не должен из-за неё вставать.
   */
  setFundingCandidateAttention?: Maybe<SetFundingCandidateAttention>;
  /**
   * Pin a funnel person to an account by hand.
   * 
   * The manual decision is durable: `user_locked` stops the automatic
   * re-matcher from ever re-pointing this row.
   */
  linkCandidateToUser?: Maybe<LinkCandidateToUser>;
  unlinkCandidateFromUser?: Maybe<UnlinkCandidateFromUser>;
  /**
   * Settle one raw place string.
   * 
   * Either outcome PINS the row — the auto-resolver never re-points a
   * manually settled string on any later import.
   */
  resolveGeoAlias?: Maybe<ResolveGeoAlias>;
  /**
   * «Посмотрел» — человек разобрал изменение на странице оператора.
   * 
   * Ровно один поступок и ровно один эффект: снять флаг «страница обновилась».
   * Владелец описал цикл так: «мы следим за страницей только лишь в том смысле,
   * поменялась она или нет. Если да — руками смотрим, что конкретно поменялось,
   * и снова меняем статус руками, что не поменялось».
   * 
   * 🔴 Раньше сюда приходил `automation_status`, и мутация одновременно
   * снимала флаг И выдавала разрешение на рассылку. Отсюда росли четыре
   * кнопки — «есть набор», «набора нет», «надо править карточку», — про
   * которые владелец сказал: «что это за хуйню, не понимаю, что это». Два
   * разных решения в одной мутации требовали от человека принять их сразу,
   * хотя второе относится к НАБОРУ, а не к странице. Разрешение переехало на
   * окно (`FundingIntake.confirmed_at`), и здесь остался только флаг.
   * 
   * Флаг снимает ТОЛЬКО эта мутация: робот его лишь поднимает. Иначе
   * «заметили» и «разобрали» слились бы в один факт, и второе изменение
   * подряд съело бы первое.
   * 
   * 🔴 `intake` — «посмотрел, и там объявлен вот такой набор» (ТЗ 0048).
   * Аргумент остаётся: «разобрал» и «записал увиденный набор» — один поход
   * менеджера, и одна транзакция здесь честнее двух запросов с фронта, между
   * которыми помещается отказ. Подтверждение приходит внутри `intake`
   * (`confirmed: true`) — там же, где живёт.
   */
  reviewOperatorPage?: Maybe<ReviewOperatorPage>;
  /**
   * Подтвердить набор — или снять подтверждение.
   * 
   * 🔴 Единственное разрешение на рассылку в домене (ТЗ 0054). Владелец:
   * «у набора должен быть статус, что он активный… она руками его делает,
   * что он активный. Это означает, что можно сделать рассылку… то есть набор
   * подтверждён».
   * 
   * Отдельная мутация, а не поле в `saveFundingIntake`, по той же причине, по
   * которой подтверждение не поле в `_apply_patch`: это поступок, у него один
   * аргумент, и жать его будут из строки таблицы, где формы нет. Форма умеет
   * то же самое через `FundingIntakeInput.confirmed` — обе дороги ведут в
   * `services.intakes.confirm_intake`, второго правила не заводится.
   */
  confirmFundingIntake?: Maybe<ConfirmFundingIntake>;
  /**
   * Разобрать заявку с формы заново (ТЗ 0046).
   * 
   * Триаж идёт автоматически и в `try/except`: заявка пишется одной
   * транзакцией, а разбор — отдельно и после, чтобы падение разбора не теряло
   * лид. Цена в том, что упавшая заявка молча остаётся с пустым
   * `processed_at`, и до этой мутации починить её из интерфейса было нельзя —
   * только руками в БД.
   * 
   * Идемпотентна: повторный разбор уже подшитой заявки найдёт того же
   * кандидата и заполнит те же пустые поля.
   * 
   * Она же — способ отменить ложное срабатывание ловушки (ТЗ 0047). Заявку,
   * отклонённую как автоматическую, менеджер разбирает этой же кнопкой, и
   * удачный разбор снимает пометку: человек посмотрел и решил, а его решение
   * старше эвристики.
   */
  retryFormSubmission?: Maybe<RetryFormSubmission>;
  /**
   * Запустить фоновую задачу робота по кнопке.
   * 
   * Все три флага расписания по умолчанию выключены, и до этой мутации
   * единственным способом что-то прогнать был терминал сервера.
   * 
   * 🔴 Ставим в ОЧЕРЕДЬ, а не выполняем синхронно: обход ста с лишним
   * страниц операторов идёт с паузой между запросами и в HTTP-таймаут не
   * уложится. Результат появится строкой в журнале прогонов.
   * 
   * `dry_run` едет в очередь вместе с задачей: сухость живёт в самой задаче
   * (`services/dry_run.py`), значит воркер выполнит сухой прогон сухим — ни
   * записей, ни писем. Что он собирался сделать, видно заметками в строке
   * журнала.
   * 
   * По умолчанию — СУХОЙ. Кнопок пять, они стоят в ряд, и промах по одной из
   * них не имеет права разослать сотни писем.
   */
  runFundingTask?: Maybe<RunFundingTask>;
  /** Add students and/or a whole graduating group to the centre. */
  enrollCareerMembers?: Maybe<EnrollCareerMembers>;
  /**
   * Убрать из карьерного центра или вернуть обратно.
   * 
   * 🔴 Это НЕ удаление. Пропадает только доступ: строка участника, прогресс по
   * урокам, отклики и запись о трудоустройстве остаются нетронутыми, и вернуть
   * человека можно тем же действием. Так решено владельцем.
   * 
   * Массовая с самого начала — оператор чистит ошибочно добавленную группу
   * целиком. Отдельная мутация «на одного» была бы тем же кодом, а триста
   * вызовов подряд — тремястами перезагрузками списка (тот же довод, что у
   * `bulkSetVacancyStatus`).
   */
  setCareerMembersAccess?: Maybe<SetCareerMembersAccess>;
  updateCareerMember?: Maybe<UpdateCareerMember>;
  upsertCareerLesson?: Maybe<UpsertCareerLesson>;
  /**
   * ERP: upload a lesson video (multipart, server-side write to the private
   * bucket — the same path as attachments, diplomas and the Django-admin file
   * widget, so no bucket CORS is required).
   */
  uploadCareerLessonVideo?: Maybe<UploadCareerLessonVideo>;
  clearCareerLessonVideo?: Maybe<ClearCareerLessonVideo>;
  /** ERP: attach one downloadable file (multipart Upload) to a lesson. */
  addCareerLessonAttachment?: Maybe<AddCareerLessonAttachment>;
  removeCareerLessonAttachment?: Maybe<RemoveCareerLessonAttachment>;
  /** LMS: the student marks a lesson done, unlocking the next one. */
  completeCareerLesson?: Maybe<CompleteCareerLesson>;
  /** LMS: record that the student opened a lesson — viewed, NOT completed. */
  markCareerLessonOpened?: Maybe<MarkCareerLessonOpened>;
  /** LMS: the student's PRIVATE note on a lesson (never shown to staff). */
  saveCareerLessonNotes?: Maybe<SaveCareerLessonNotes>;
  /** LMS: toggle a lesson bookmark for the calling student. */
  setCareerLessonBookmark?: Maybe<SetCareerLessonBookmark>;
  /** ERP: replace a lesson's self-check quiz (delete-and-recreate). */
  setCareerLessonQuiz?: Maybe<SetCareerLessonQuiz>;
  /**
   * LMS: score the student's answers and record an attempt (self-check —
   * never gates the lesson).
   */
  submitCareerQuiz?: Maybe<SubmitCareerQuiz>;
  saveCareerProfile?: Maybe<SaveCareerProfile>;
  /** Upsert the per-language prose overlay (title + about) for the CV. */
  saveCvText?: Maybe<SaveCvText>;
  /** The student's own opt-in to partner search (Ф3) + contact visibility. */
  setProfileSearchable?: Maybe<SetProfileSearchable>;
  /**
   * Студент сам оценил уровень навыка (0072): из паспорта навыка или из
   * подсказки «Wspomniano w CV». Подтверждённый школой уровень не понижается.
   */
  setMySkillLevel?: Maybe<SetMySkillLevel>;
  upsertVacancy?: Maybe<UpsertVacancy>;
  /**
   * Hard-delete a draft/rejected vacancy. Anything further along refuses
   * with `vacancy_locked` and points at the archive — see
   * `services.vacancies.delete_vacancy` for why the fence is this narrow.
   */
  deleteVacancy?: Maybe<DeleteVacancy>;
  setVacancyStatus?: Maybe<SetVacancyStatus>;
  /**
   * Move many vacancies at once — the queue-draining action (spec 0035).
   * 
   * `bulkPublishVacancies` only ever published; rejecting a night's drafts
   * meant one mutation per row, each triggering a full table reload. This is
   * set-based on the server and covers every status.
   */
  bulkSetVacancyStatus?: Maybe<BulkSetVacancyStatus>;
  bulkPublishVacancies?: Maybe<BulkPublishVacancies>;
  recordPlacement?: Maybe<RecordPlacement>;
  /** LMS: a member saves a vacancy or marks that they applied. */
  markVacancyInteraction?: Maybe<MarkVacancyInteraction>;
  /**
   * LMS: завести отклик.
   * 
   * `duplicate` — ШТАТНЫЙ ответ, а не ошибка: повтор на ту же вакансию, пока
   * прежний отклик ещё в работе, возвращает существующую строку. Прецедент
   * домена — `erp_create_vacancy_draft`; штатная ситуация, отданная
   * исключением, читается вызывающим как сбой.
   */
  createCareerApplication?: Maybe<CreateCareerApplication>;
  updateCareerApplication?: Maybe<UpdateCareerApplication>;
  /**
   * LMS: сменить статус отклика.
   * 
   * 🔴 `hired` НЕ создаёт `PlacementRecord`, НЕ переводит участника в `placed`
   * и НЕ выдаёт медаль. Самозаявленное трудоустройство не может стать KPI
   * школы, а на архивном участнике автоперевод в `placed` (статус АКТИВНЫЙ)
   * молча вернул бы доступ в центр мимо явной разархивации. Строка лишь встаёт
   * в очередь подтверждения сотруднику.
   */
  setCareerApplicationStatus?: Maybe<SetCareerApplicationStatus>;
  deleteCareerApplication?: Maybe<DeleteCareerApplication>;
  /** Завести или поправить навык справочника. */
  upsertCareerSkill?: Maybe<UpsertCareerSkill>;
  /**
   * Спрятать навык из автокомплита или вернуть обратно.
   * 
   * Мутации удаления НЕТ намеренно: `Skill.delete()` каскадит `StudentSkill`,
   * то есть стирает навык из резюме всех владельцев, и вычищает теги вакансий.
   */
  setCareerSkillActive?: Maybe<SetCareerSkillActive>;
  /** Слить дубль справочника в целевой навык («React» и «ReactJS»). */
  mergeCareerSkills?: Maybe<MergeCareerSkills>;
  /**
   * Загрузить свою картинку навыка или убрать её (ТЗ 0039, доводка UX).
   * 
   * Иконка НЕОБЯЗАТЕЛЬНА: без неё фронт рисует встроенный логотип по `slug`, а
   * если и его нет — буквенную плашку по категории. Поэтому «убрать» здесь не
   * оставляет пустое место, а возвращает автоподбор, и оператору не приходится
   * держать картинку только для того, чтобы строка не выглядела сломанной.
   * 
   * Загрузка идёт мультипартом и пишется сервером — тем же путём, что видео
   * урока и вложения; настраивать CORS бакета не нужно.
   */
  setCareerSkillIcon?: Maybe<SetCareerSkillIcon>;
  /**
   * Задать набор навыков курса целиком — ШАБЛОН для будущих групп.
   * 
   * 🔴 Пересчёта начислений здесь больше нет (ТЗ 0041). Набор курса перестал
   * быть действующим правилом: начисление читает набор ГРУППЫ, снятый с курса
   * в момент её создания. Правка шаблона по решению владельца не догоняет уже
   * идущие группы — иначе студент старой группы получал бы навык не на том
   * занятии, ради чего перенос и делался. Пересчёт ставит `SetGroupSkills`.
   */
  setCourseSkills?: Maybe<SetCourseSkills>;
  /**
   * Задать набор навыков ГРУППЫ целиком (ТЗ 0041).
   * 
   * Пересчёт начислений НЕ делается здесь: группа с тремя десятками студентов
   * и дюжиной навыков — это сотни записей внутри GraphQL-запроса. Ставим
   * задачу; при недоступном брокере считаем синхронно, но не молча.
   */
  setGroupSkills?: Maybe<SetGroupSkills>;
  /** Ручное «зачтено / не засчитывать» по паре студент-курс. */
  setCourseCompletion?: Maybe<SetCourseCompletion>;
  /**
   * Кнопка «Пересчитать навыки» на карточке участника.
   * 
   * 🔴 Поля обязаны покрывать ВСЮ сводку `skill_grant.grant_for_student`:
   * ответ собирается как `cls(**stats)`, и лишний ключ — это `TypeError`, то
   * есть пятисотка на кнопку. Так и было с `reattributed`: сводка его отдавала
   * с самого начала, а поля для него не завели, и кнопка падала на любом
   * студенте (ТЗ 0040, попутная находка). Тест `test_sync_button_returns_full_stats`
   * держит два списка вместе.
   */
  syncStudentCourseSkills?: Maybe<SyncStudentCourseSkills>;
  /**
   * Завести или поправить профессию (ТЗ 0040 фаза C).
   * 
   * Удаления нет: у трека висит `StudentTrackChoice` — выбор студента, и
   * удалить трек значит молча отобрать у человека цель, которую он себе
   * поставил. Есть скрытие.
   */
  saveGrowthTrack?: Maybe<SaveGrowthTrack>;
  toggleGrowthTrack?: Maybe<ToggleGrowthTrack>;
  /**
   * Завести или поправить медаль.
   * 
   * Удаления нет: `AchievementGrant` — append-only журнал выданного, и
   * `CASCADE` снёс бы вместе с медалью историю начислений и очки, которые
   * студент уже видел.
   */
  saveAchievement?: Maybe<SaveAchievement>;
  toggleAchievement?: Maybe<ToggleAchievement>;
  /** Завести или поправить курс витрины (что школа продаёт). */
  saveSiteCourse?: Maybe<SaveSiteCourse>;
  toggleSiteCourse?: Maybe<ToggleSiteCourse>;
  /**
   * Переписать программу курса (ТЗ 0040 фаза C).
   * 
   * До этого программу можно было только загрузить Excel-импортом из
   * Django-админки: опечатка чинилась перезаливкой файла целиком.
   */
  setCourseProgram?: Maybe<SetCourseProgram>;
  /**
   * Завести или переписать анкету в справочнике (ТЗ 0040 фаза B).
   * 
   * Раньше это была `SetCareerLessonExercise`: анкета собиралась ВНУТРИ урока
   * и жила только в нём. Владелец попросил обратного — «создавать на отдельной
   * странице, потом прикреплять к урокам», — и мутация переехала на шаблон.
   */
  saveCareerExerciseTemplate?: Maybe<SaveCareerExerciseTemplate>;
  /**
   * Скрыть или вернуть анкету. Удаления нет: оно снесло бы сдачи вместе с
   * журналом того, что уехало студентам в резюме.
   */
  toggleCareerExerciseTemplate?: Maybe<ToggleCareerExerciseTemplate>;
  /** Прикрепить анкету из справочника к уроку. */
  attachCareerExerciseTemplate?: Maybe<AttachCareerExerciseTemplate>;
  /** Снять анкету с урока. */
  detachCareerExerciseTemplate?: Maybe<DetachCareerExerciseTemplate>;
  /**
   * Аварийный выход: снять сдачи, чтобы можно было переделать анкету.
   * 
   * 🔴 Снимает сдачи по ВСЕМ урокам, куда анкета прикреплена, — замок общий,
   * и половинчатый сброс оставил бы его запертым без объяснения. НЕ удаляет
   * `CareerLessonProgress` (иначе одна опечатка методиста перезакрыла бы урок
   * всему потоку) и НЕ откатывает записанное в резюме: эти данные уже
   * принадлежат студенту. Асимметрию надо писать в подтверждении прямым
   * текстом.
   */
  resetCareerExerciseTemplate?: Maybe<ResetCareerExerciseTemplate>;
  /** Сдача анкеты студентом (LMS). */
  submitCareerLessonExercise?: Maybe<SubmitCareerLessonExercise>;
  /**
   * LMS: студент выбирает трек целью (ТЗ 0039).
   * 
   * Открыто ЛЮБОМУ студенту, а не только участнику карьерного центра: трек —
   * продающая поверхность, и требовать членства значит показать её только тем,
   * кто уже выпустился.
   */
  chooseGrowthTrack?: Maybe<ChooseGrowthTrack>;
  /** Завести или поправить акцию (ТЗ 0039, шаг 6). */
  upsertPromoCampaign?: Maybe<UpsertPromoCampaign>;
  /** Включить или выключить акцию. Удаления нет: коды уже у людей на руках. */
  setPromoCampaignActive?: Maybe<SetPromoCampaignActive>;
  /** Выдать код конкретному студенту руками — в обход правила. */
  issuePromoCode?: Maybe<IssuePromoCode>;
  /** Отозвать код. Студенту он перестаёт показываться. */
  revokePromoCode?: Maybe<RevokePromoCode>;
  /**
   * Кнопка «Проверить сейчас».
   * 
   * То же, что делает ночная задача. Сверка НЕ трогает деньги: ни договор, ни
   * взносы, ни фактуры — она лишь помечает коды использованными.
   */
  reconcilePromoCodes?: Maybe<ReconcilePromoCodes>;
  /**
   * LMS: студент нажал «Поделиться» (ТЗ 0039, шаг 7).
   * 
   * 🔴 Повторное нажатие возвращает `counted=false`, а НЕ ошибку: бонус за этот
   * канал уже выдан, но делиться можно сколько угодно, и ошибка на кнопке
   * «Поделиться» читается как поломка.
   * 
   * ⚠️ Мутация фиксирует нажатие НАШЕЙ кнопки, а не публикацию: проверить
   * публикацию у LinkedIn и Facebook невозможно без OAuth от имени студента.
   * 
   * Медали и коды возвращаются СРАЗУ, чтобы фронт показал награду без
   * перезапроса — иначе связь между действием и наградой теряется.
   */
  registerShare?: Maybe<RegisterShare>;
  /** ERP: текст поста правится БЕЗ выката — это маркетинг, а не интерфейс. */
  upsertShareTemplate?: Maybe<UpsertShareTemplate>;
  /** Отозвать выданный токен: клиент отключится немедленно. */
  revokeMcpConnection?: Maybe<RevokeMcpConnectionMutation>;
  /** Attach or replace one student's diploma in one language. */
  uploadStudentDiploma?: Maybe<UploadStudentDiplomaMutation>;
  /**
   * Detach a diploma. The S3 object is left in place deliberately — a
   * student may hold a live signed URL, and a leaked object beats a document
   * that vanished mid-download. The orphaned key goes to the audit log.
   */
  deleteStudentDiploma?: Maybe<DeleteStudentDiplomaMutation>;
  /**
   * Dry-run: propose a (student, language) for each file NAME.
   * 
   * A mutation rather than a query only because clients treat it as an action;
   * it performs no writes.
   */
  matchDiplomaFiles?: Maybe<MatchDiplomaFilesMutation>;
  /**
   * Create (if needed) and RECONCILE the group's SendGrid contact list.
   * 
   * Idempotent — contacts are upserted by email, so re-running re-syncs rather
   * than duplicating; members who are no longer active students of the group
   * are taken out of the list (ТЗ 0112 #153). SendGrid processes the upload asynchronously, so the
   * contact count updates a few seconds later.
   */
  syncGroupSendgridList?: Maybe<SyncGroupSendgridList>;
  /**
   * Send a dynamic-template email to selected students of a group.
   * 
   * Each recipient gets their OWN message with their own name, amount and pay
   * link — never a shared blast. Returns the job id to poll (`mailJob`) for live
   * progress and per-recipient delivery status.
   */
  sendGroupTemplateEmail?: Maybe<SendGroupTemplateEmail>;
  /**
   * Student submits (or replaces) their homework: a GitHub link AND/OR a
   * ZIP archive (at least one, both allowed together). Re-submitting after
   * grading resets the grade. No teacher assignment is required (rev.3).
   */
  submitHomework?: Maybe<SubmitHomeworkMutation>;
  /**
   * Teacher creates or edits the lesson's homework assignment (backed by
   * materials.Material kind=HOMEWORK; ≤1 per lesson via this path).
   */
  upsertHomeworkAssignment?: Maybe<UpsertHomeworkAssignmentMutation>;
  /**
   * Teacher grades a student's homework — with or without a submission
   * (non-submitters get `not_done`). Writes through to
   * journals.StudentsMark.hw_mark; the comment lives on the submission.
   */
  gradeHomework?: Maybe<GradeHomeworkMutation>;
  /**
   * Teacher re-queues the AI analysis of a submission («Перепроверить»).
   * Answers AI_DISABLED while the HOMEWORK_AI_ENABLED flag is off.
   */
  rerunHomeworkAiReview?: Maybe<RerunHomeworkAiReviewMutation>;
  createSurvey?: Maybe<CreateSurveyMutation>;
  updateSurvey?: Maybe<UpdateSurveyMutation>;
  archiveSurvey?: Maybe<ArchiveSurveyMutation>;
  duplicateSurvey?: Maybe<DuplicateSurveyMutation>;
  assignSurveyToGroup?: Maybe<AssignSurveyToGroupMutation>;
  /**
   * Bulk MANUAL attach (spec 0038) — the plural of assignSurveyToGroup.
   * 
   * Not built on setSurveyTargeting: that replaces the whole targeting block,
   * so «add these groups» would become read-modify-write, where one dropped
   * field silently destroys a rule and its assignments. The rows created here
   * are ordinary manual ones that rule resolution never touches.
   * 
   * `success: true` WITH a populated `skipped[]` is the normal outcome, same
   * contract as setSurveyTargeting — a group without lesson N must not fail
   * the other twenty.
   */
  assignSurveyToGroups?: Maybe<AssignSurveyToGroupsMutation>;
  /**
   * Bulk-assign question topics (spec 0038).
   * 
   * Deliberately NOT routed through `updateSurvey`: that takes a whole survey
   * payload and would make retagging 40 questions across 12 surveys twelve
   * read-modify-write round trips. A topic is a label, not part of the answer
   * contract, so it stays editable even on a survey that already has answers —
   * that is precisely how historical surveys enter the analytics.
   */
  setQuestionMetrics?: Maybe<SetQuestionMetricsMutation>;
  updateSurveyAssignment?: Maybe<UpdateSurveyAssignmentMutation>;
  deleteSurveyAssignment?: Maybe<DeleteSurveyAssignmentMutation>;
  /**
   * Replace the survey's whole «Аудитория и триггер» block.
   * 
   * One bulk call, not N `assignSurveyToGroup`s: dropping a group from a rule
   * needs a diff against the previous state, which only the server holds.
   * 
   * `success: true` WITH a populated `targeting.skipped[]` is the normal
   * outcome — the rules saved and some groups simply have no lesson N. Only
   * rule-level problems (INVALID_PLAN / COURSE_MISMATCH / PLAN_LOCKED /
   * ARCHIVED / NOT_FOUND) come back as customErrors with success=False.
   */
  setSurveyTargeting?: Maybe<SetSurveyTargetingMutation>;
  submitSurveyResponse?: Maybe<SubmitSurveyResponseMutation>;
  /**
   * Spec 0098 «Сгенерировать сводку»: a `queued` digest + the task; the
   * answer is immediate, the ERP polls `surveyDigests`. Refusals are
   * GraphQL errors whose `extensions.code` the ERP translates:
   * `digest_disabled`, `bad_scope`, `not_found`, `digest_running`,
   * `digest_cooldown` (10 min per scope after the last done one),
   * `digest_daily_cap` (20 per Warsaw day).
   */
  generateSurveyDigest?: Maybe<SurveyDigestType>;
  createLessonWhiteboard?: Maybe<CreateLessonWhiteboardMutation>;
  linkLessonWhiteboard?: Maybe<LinkLessonWhiteboardMutation>;
  saveWhiteboardScene?: Maybe<SaveWhiteboardSceneMutation>;
  /** Full-list save of the school-wide component library (spec 0010 rev.2). */
  saveWhiteboardLibrary?: Maybe<SaveWhiteboardLibraryMutation>;
  /**
   * Pastes an image onto a board (spec 0010 rev.3): the bytes go to the
   * private bucket, the scene keeps only the fileId reference.
   */
  uploadWhiteboardFile?: Maybe<UploadWhiteboardFileMutation>;
  renameWhiteboard?: Maybe<RenameWhiteboardMutation>;
  unlinkLessonWhiteboard?: Maybe<UnlinkLessonWhiteboardMutation>;
  createMaterial?: Maybe<CreateMaterialMutation>;
  updateMaterial?: Maybe<UpdateMaterialMutation>;
  deleteMaterial?: Maybe<DeleteMaterialMutation>;
  /** Своя подпись: без mailboxEmail — по умолчанию, иначе для ящика, с которого можно писать. Пустой html удаляет подпись (→ null). */
  saveMailSignature?: Maybe<MailSignatureType>;
  /** Подтянуть подпись ящика из Gmail (sendAs). */
  importGmailSignature?: Maybe<MailSignatureType>;
  /** Черновик вложения письма (24 ч). Id — в attachmentIds мутаций отправки. */
  uploadEmailAttachment?: Maybe<EmailAttachmentDraftType>;
  /** Подписанная ссылка на вложение письма (300 с). Права — как у чтения беседы. */
  emailAttachmentLink?: Maybe<Scalars['String']>;
  /**
   * On-demand «обновить сообщения»: enqueue a Slack backfill PLUS a Gmail
   * backfill of the latest mail (metadata-first, so it's cheap). Without
   * group_id it syncs every ENABLED workspace of an ACTIVE group (last lesson
   * within SYNC_ACTIVE_DAYS, or no lessons yet — spec 0032; the old predicate
   * demanded a FUTURE lesson and on real data matched nothing) plus legacy
   * channel links; with group_id it
   * syncs that group's workspace regardless of activity — the group-card
   * button keeps working for finished groups. Async via Celery — the button
   * returns immediately; new messages appear once the worker finishes.
   */
  syncCommunicationsNow?: Maybe<SyncCommunicationsNowMutation>;
  /**
   * On-demand 'refresh mail' button: enqueue a Gmail backfill of the latest
   * ~100 messages per mailbox. Runs async via Celery so the request returns
   * immediately; the new mail appears once the worker finishes.
   */
  syncGmailNow?: Maybe<SyncGmailNowMutation>;
  /**
   * Reply into a Slack conversation; mirrors the sent message locally.
   * 
   * После успешной отправки входящее, которое менеджер видел
   * (`seenMessageId`; `null` — ничего; не передан — всё до ответа), —
   * прочитано и обработано (`mark_answered`); ошибка Slack — ничего не
   * помечается.
   */
  sendSlackMessage?: Maybe<SendSlackMessageMutation>;
  /**
   * Post a message into one of a group's Slack channels — including the
   * FIRST one, before any Conversation mirror exists. Lets a manager start a
   * channel thread instead of only replying into an existing dialog.
   */
  sendSlackChannelMessage?: Maybe<SendSlackChannelMessage>;
  /**
   * Open a Slack DM with a student OR a teacher and post the first message,
   * before any Conversation exists — so a manager can write first. Sent AS the
   * manager (his xoxp user token; a bot can't hold a 1:1 DM).
   */
  startSlackDm?: Maybe<StartSlackDm>;
  /**
   * Reply into a Gmail thread; mirrors the sent message locally.
   * 
   * После успешной отправки входящее, которое менеджер видел
   * (`seenMessageId`; `null` — ничего; не передан — всё до ответа), —
   * прочитано и обработано (`mark_answered`); ошибка Gmail — ничего не
   * помечается.
   */
  sendGmailReply?: Maybe<SendGmailReplyMutation>;
  /**
   * Compose and send a BRAND-NEW email from a chosen shared mailbox (not a
   * reply). Mirrors it locally as a new gmail-thread conversation.
   */
  sendNewEmail?: Maybe<SendNewEmailMutation>;
  /**
   * Send ONE message to many students of a group INDIVIDUALLY — a private
   * Slack DM or a single email each (never a group blast). Runs as a paced
   * background task; returns the broadcast job id the client polls (`broadcast
   * Job`) for live progress and the per-recipient outcome.
   */
  broadcastGroupMessage?: Maybe<BroadcastGroupMessage>;
  /**
   * Map a Slack user id to a Student OR a Teacher (for DM mirroring). The
   * manual fallback for auto-matching by email — a person may sit in Slack
   * under an email we don't know.
   */
  linkSlackUser?: Maybe<LinkSlackUserMutation>;
  /** Map a Slack channel id to a Group. */
  linkChannelGroup?: Maybe<LinkChannelGroupMutation>;
  /** Mark one message read/unread (team-wide global state). */
  markMessageRead?: Maybe<MarkMessageReadMutation>;
  /** Flag/unflag one message (team-wide global state). */
  flagMessage?: Maybe<FlagMessageMutation>;
  /**
   * Mark one message handled/unhandled — обработано (team-wide global).
   * 
   * With `cascade` (spec 0030) the tick also closes everything ABOVE it in
   * the same dialog: reading and handling a later message means the earlier
   * ones were dealt with too, which is how a human actually works a thread.
   * Un-ticking never cascades — see the branch below.
   */
  setMessageHandled?: Maybe<SetMessageHandledMutation>;
  /**
   * Set the read flag on every message of a conversation.
   * 
   * `read=false` is «Вернуть в работу»: it clears `is_handled` on the inbound
   * messages too (spec 0030 round 2). Clearing only `is_read` produced an
   * unread-but-handled dialog, which is EXCLUDED from the `unhandledOnly`
   * queue — so the manager's "I'll come back to this" gesture removed the
   * dialog from the very list they come back through. It is also the only
   * thread-level way back from a cascade or a bulk clear.
   */
  markConversationRead?: Maybe<MarkConversationReadMutation>;
  /**
   * Bulk «Прочитано и обработано» over a scope (spec 0030).
   * 
   * The whole point of the communicator rework: closing an inbox used to cost
   * one click per message per student per channel. This sets both flags over
   * a whole dialog, student, group, or the entire filtered browser list, in a
   * constant number of statements.
   * 
   * Reversible, not one-directional (round 2): the payload carries the exact
   * ids it flipped so `revertMessagesTriage` can put them back. Both UPDATEs
   * only ever go False → True, so reverting those very rows to False restores
   * the prior state exactly — no "was it already read?" guessing.
   */
  markConversationsHandled?: Maybe<MarkConversationsHandledMutation>;
  /**
   * Undo for a triage action — put exactly these rows back (spec 0030 r2).
   * 
   * Both the bulk clear and the per-message cascade only ever flip
   * False → True, so clearing the very ids they reported restores the prior
   * state exactly. That is why undo takes explicit ids rather than a scope:
   * re-deriving the set would also catch rows that were already read before,
   * and un-read them.
   * 
   * Deliberately no separate permission tier: whoever may clear may un-clear.
   */
  revertMessagesTriage?: Maybe<RevertMessagesTriageMutation>;
  /** Set a conversation's handling status (open / in_progress / done). */
  setConversationStatus?: Maybe<SetConversationStatusMutation>;
  /**
   * Bind (or update) the Slack workspace for a group. Only the bot token is
   * really needed (no OAuth flow): a blank team id is resolved via auth.test.
   * `team_id` stays as an advanced override; `signing_secret` matters only for
   * the optional realtime webhook.
   */
  setSlackWorkspace?: Maybe<SetSlackWorkspaceMutation>;
  /**
   * Save the ACTING manager's personal Slack user token (xoxp) for a
   * group's workspace — DM replies to students then go out as the manager
   * himself, and his person-to-person DMs become pullable by sync. The token
   * is validated via auth.test and must belong to the group's workspace.
   * Write-only: no query ever returns it.
   */
  setMySlackUserToken?: Maybe<SetMySlackUserTokenMutation>;
  /**
   * Return a signed Slack authorize URL so the ACTING manager can grant his
   * personal xoxp user token for a group's workspace in one click — no
   * api.slack.com, no copy-paste. The browser then navigates to Slack; on
   * "Allow" Slack redirects to `slack_oauth_callback`, which stores the token.
   * 
   * Identity + group are captured HERE (under the JWT this mutation runs behind)
   * and sealed into a short-lived signed `state` (django.core.signing), because
   * the callback is a plain browser redirect that carries no JWT.
   */
  startSlackUserOauth?: Maybe<StartSlackUserOauthMutation>;
  /**
   * Spin a staff task off a student's message («создать задачу из вопроса»).
   * 
   * The task inherits the conversation's student/group; the assignee defaults
   * to the acting manager and must always be ERP staff. Side effects record
   * the reaction: the message is marked handled + linked to the task, and an
   * `open` conversation moves to `in_progress`. One task per message — a
   * retry / second manager gets `already_linked` instead of a duplicate.
   */
  createTaskFromMessage?: Maybe<CreateTaskFromMessageMutation>;
  /**
   * ТЗ 0083: привязать сотруднику рабочую почту Google Workspace (пустой
   * адрес — отвязать). Только Admin: указавший адрес получает доступ к
   * письмам этого ящика в ERP.
   */
  setStaffMailbox?: Maybe<SetStaffMailboxMutation>;
  /**
   * ТЗ 0083: проба доступа к рабочей почте через Google. Без `userId` —
   * своя почта (любой сотрудник); чужая — только Admin.
   */
  checkStaffMailbox?: Maybe<CheckStaffMailboxMutation>;
  createPlannedPayment?: Maybe<PlannedPaymentMutationOutput>;
  updatePlannedPayment?: Maybe<PlannedPaymentMutationOutput>;
  deletePlannedPayment?: Maybe<DeletePlannedPaymentOutput>;
  setCashBalance?: Maybe<CashBalanceMutationOutput>;
  setExchangeRate?: Maybe<ExchangeRateMutationOutput>;
  setPaymentCalendarSettings?: Maybe<CalendarSettingsMutationOutput>;
  /**
   * Load a statement from the browser — the entry point of the whole loop.
   * 
   * Defaults to a preview: the operator sees how many rows are new, how many
   * are duplicates, which accounts and categories the file names that we do not
   * know, where the running balance disagrees, and twenty repaired descriptions
   * to eyeball the encoding. Only then do they commit.
   * 
   * Re-uploading a file that was already committed is the commonest operator
   * mistake, so it is answered from `file_hash` before the file is even parsed.
   * Import is idempotent regardless — this just makes the answer immediate and
   * legible instead of "0 created, 1262 duplicates".
   * 
   * The format is recognised from the first bytes, never from a dropdown: PKO
   * calls both its XLSX dashboard export and its legacy BIFF workbook «Excel»,
   * and a wrong pick would not fail — it would mis-parse.
   */
  uploadBankStatement?: Maybe<BankStatementUploadOutput>;
  /**
   * Undo one committed import — the only way out was the Django admin.
   * 
   * Refuses rather than destroys. A row that has been touched since the import
   * carries a decision somebody made: a category set by hand, a link to a
   * document, a verdict about an internal transfer. Deleting those to undo a
   * misfiled statement would be trading one mistake for a worse one, so the
   * mutation stops and names the rows.
   * 
   * `dryRun` says what WOULD go, because «удалить 1262 операции» is not a
   * sentence anyone should read for the first time in the past tense.
   */
  rollbackBankStatementImport?: Maybe<CashFlowRunOutput>;
  /**
   * Edit the global settings row.
   * 
   * Exposed because internal-transfer detection is inert until `ownPartyNames`
   * is filled in, and on production there was no way to fill it in at all — the
   * model was in neither the admin nor the schema.
   */
  updateCashFlowSettings?: Maybe<CashFlowSettingsOutput>;
  /**
   * The operator answering «запомнить это правило?» with yes.
   * 
   * No proposal is stored server-side and none needs to be: the suggestion is a
   * pure function of (row, category), so confirming it just recomputes the same
   * signal and commits. That keeps the answer idempotent and avoids a table
   * whose rows would go stale the moment either side changed.
   * 
   * `retroactive` decides whether the rule also repaints the rows it matches
   * that are not already classified by hand. Off by default — applying a new
   * rule backwards changes closed months, and that must be a decision, not a
   * side effect.
   */
  confirmCashFlowRule?: Maybe<SetCategoryOutput>;
  /**
   * Settle «этот признак уже ведёт в другую категорию».
   * 
   * `REPLACE` closes the old rule at today's date and opens the new one from
   * it, so rows booked earlier keep the category they already had. That is what
   * `valid_from` / `valid_to` / `superseded_by` were declared for — until now
   * nothing wrote them, and a supplier changing category in July would have
   * repainted a closed March.
   */
  resolveCashFlowRuleConflict?: Maybe<SetCategoryOutput>;
  /**
   * Turn a rule off, re-prioritise it, or point it at another category.
   * 
   * Disabling does not roll back what the rule already classified: those rows
   * keep their category and are re-flagged `orphaned` on the next run, so a
   * closed month cannot move because someone switched a rule off.
   */
  updateCashFlowRule?: Maybe<SetCategoryOutput>;
  /**
   * Remove a rule outright.
   * 
   * Rows it classified keep their category — deletion is about the rule, not
   * about rewriting the ledger behind it.
   */
  deleteCashFlowRule?: Maybe<CashFlowRunOutput>;
  setBankTransactionCategory?: Maybe<SetCategoryOutput>;
  /**
   * Classify a selection of rows in one decision.
   * 
   * Learning is collapsed by signal: twenty rows of one contractor teach ONE
   * rule, not twenty. Done as N single calls the operator would get twenty
   * answers to one decision, nineteen of them «правило уже было».
   */
  setBankTransactionCategoryBulk?: Maybe<CashFlowRunOutput>;
  setBankTransactionInternal?: Maybe<BankTransactionOutput>;
  /**
   * Take the review flag off a row somebody has looked at.
   * 
   * `needs_review` had exactly one way out — marking the row an internal
   * transfer — so a row flagged for a weak dedup key or for an orphaned rule
   * stayed flagged forever and the counter only ever grew. A number that cannot
   * go down stops being a signal and becomes decoration.
   */
  clearBankTransactionReview?: Maybe<BankTransactionOutput>;
  /**
   * «Обработать загруженное» — четыре шага одной кнопкой.
   * 
   * Загрузка файла вносит строки и на этом останавливается: категорию из
   * выписки взять неоткуда (в ней есть дата, сумма, сальдо и назначение — но не
   * категория), а парность, выплаты шлюза и документы никто не считает сам.
   * Раньше это были четыре отдельных нажатия, и **порядок между двумя из них
   * обязателен**: распознавание выплат шлюза должно идти до сопоставления
   * документов, иначе выплата получит случайно равную ей фактуру.
   * 
   * Порядок теперь свойство кода (`services/pipeline.STEP_ORDER`), а не памяти
   * оператора. Один шаг упал — конвейер останавливается и говорит, на каком:
   * наполовину обработанный реестр, о котором не сказали, хуже отказа.
   */
  processUploadedStatement?: Maybe<CashFlowRunOutput>;
  runCashFlowCategorization?: Maybe<CashFlowRunOutput>;
  runInternalTransferDetection?: Maybe<CashFlowRunOutput>;
  seedCashFlowRules?: Maybe<CashFlowRunOutput>;
  /**
   * Attach a document to a bank row by hand.
   * 
   * Needed wherever the matcher honestly cannot decide — which is most of the
   * expense side, since card payments for SaaS have no document at all.
   */
  linkBankTransaction?: Maybe<BankTransactionOutput>;
  unlinkBankTransaction?: Maybe<BankTransactionOutput>;
  runCashFlowMatching?: Maybe<CashFlowRunOutput>;
  /**
   * Put an invoice into a batch by hand.
   * 
   * The primary path, not a fallback: automatic composition is anchored on
   * invoice issue dates because receipt-level records do not exist here, and it
   * composes only a handful of batches unambiguously. The operator finishing the
   * job is the expected workflow.
   */
  addGatewaySettlementItem?: Maybe<GatewaySettlementOutput>;
  removeGatewaySettlementItem?: Maybe<GatewaySettlementOutput>;
  /** Pin the fee by hand when the composition cannot explain the remainder. */
  setGatewaySettlementFee?: Maybe<GatewaySettlementOutput>;
  markGatewaySettlementReconciled?: Maybe<GatewaySettlementOutput>;
  detectGatewaySettlements?: Maybe<CashFlowRunOutput>;
  reconcileGatewaySettlements?: Maybe<CashFlowRunOutput>;
  createExpense?: Maybe<ExpenseMutationOutput>;
  updateExpense?: Maybe<ExpenseMutationOutput>;
  /**
   * One-click status change (planned / confirmed / paid / cancelled).
   * 
   * Lighter than `updateExpense`: the register, the calendar and the
   * teacher-payout list flip a status inline without rebuilding the whole
   * input. `apply_status_transition` derives `paid_at` from the target status
   * (paid → stamp today unless already set / supplied; non-paid → clear).
   * Allowed on `source='fakturownia'` rows too — status is a manual field,
   * not part of the money lock the bridge owns.
   */
  setExpenseStatus?: Maybe<ExpenseMutationOutput>;
  deleteExpense?: Maybe<DeleteExpenseMutation>;
  createExpenseCategory?: Maybe<CreateExpenseCategoryMutation>;
  /**
   * Create a REAL invoice in Fakturownia for one installment.
   * 
   * The unit of work is the **agreement**, not the student: a student may
   * hold several agreements, and this also makes the group job's per-row unit
   * identical to this mutation's, so both share one service.
   * 
   * Everything hard lives in `services.issuing` — five layers of duplicate
   * protection around a vendor that has no idempotency key and whose
   * documents cannot be deleted from here. This class is only the GraphQL
   * skin: gate, resolve ids, translate the outcome.
   */
  issueInvoiceForContribution?: Maybe<FakturowniaMutationOutput>;
  /**
   * Enqueue a background run that issues invoices for a whole group.
   * 
   * Returns immediately with the job; the frontend polls
   * `fakturowniaBillingJob(id)`. It has to be a job, not a synchronous loop:
   * every non-BYN row costs an invoice POST plus up to two live FX lookups
   * from `Contribution.save()`, so a 200-row group runs for 7-13 minutes.
   */
  issueInvoicesForGroup?: Maybe<FakturowniaBillingJobEnqueueOutput>;
  /**
   * ТЗ 0101 — create the VAT invoice FROM a proforma in Fakturownia.
   * 
   * Two-phase: `dryRun: true` runs every check and creates nothing in
   * Fakturownia (success → the button may be offered, `invoice` = the
   * proforma); like the real call, it first reads the proforma fresh and may
   * bring the mirror forward — the proforma's row and a VAT Fakturownia
   * already made from it, linked to the installment, as the next sync would
   * (then it refuses with VAT_ALREADY_ISSUED). The real call
   * creates a REAL fiscal document, links it to the proforma's installment
   * (`contribution`) and to the proforma (`parent_invoice`). Refused with
   * VAT_ALREADY_ISSUED when a VAT from this proforma already exists —
   * including one the sync brought in (auto-conversion / issued by hand in
   * Fakturownia); `invoice` then carries that VAT. Refused with
   * CURRENCY_MISMATCH when the proforma is not in its installment's agreement
   * currency (the VAT copies it and could not be linked). Gated by
   * FAKTUROWNIA_ISSUE_ENABLED like issueInvoiceForContribution.
   */
  issueVatFromProforma?: Maybe<FakturowniaMutationOutput>;
  /**
   * ТЗ 0101 — pin an existing (synced) proforma to an installment.
   * 
   * The proforma is attached through `proforma_for_contribution`, never
   * `contribution`. Until a VAT is issued from it, it behaves like an invoice
   * of that installment (its paid amount covers it; LMS debt, «Moje faktury»,
   * calendar while open); then the VAT carries the money. Refused with
   * STUDENT_MISMATCH when the proforma is attributed to another student,
   * CONTRIBUTION_ALREADY_INVOICED when a billing document already bills the
   * installment, CONTRIBUTION_HAS_OPEN_PROFORMA when another proforma of it
   * still waits for its VAT, CURRENCY_MISMATCH when the proforma is not in
   * the agreement's currency (it would cover nothing). Same role gate as
   * linkInvoiceToContribution.
   */
  linkProformaToContribution?: Maybe<FakturowniaMutationOutput>;
  /** ТЗ 0101 — drop the proforma → installment pin (idempotent). */
  unlinkProformaFromContribution?: Maybe<FakturowniaMutationOutput>;
  /**
   * ТЗ 0004 — pin an issued invoice to the installment it charges.
   * 
   * The PRIMARY business link of the unified «взнос» model. Manual link sets
   * `contribution_match_source='manual'` so the sync auto-matcher never
   * re-points it. If the invoice is already fully paid, the hidden Payment is
   * provisioned immediately (no waiting for the next sync).
   * 
   * Refused with errorCode CURRENCY_MISMATCH when the document's currency is
   * not the agreement's (an empty one is the agreement's): such a document
   * would cover nothing (`fakturownia.documents`). The message names both
   * codes.
   */
  linkInvoiceToContribution?: Maybe<FakturowniaMutationOutput>;
  /**
   * Drop the invoice → contribution link and re-derive the installment's
   * coverage. The invoice's Payment (if provisioned) stays attached to the
   * invoice — real received money is never destroyed here.
   */
  unlinkInvoiceFromContribution?: Maybe<FakturowniaMutationOutput>;
  /**
   * Force the auto-matcher to run again on a specific invoice — useful
   * when buyer_email changed, the student was just created, or a new
   * Payment row was just imported and we want to recheck the link.
   */
  rerunFakturowniaMatcher?: Maybe<FakturowniaMutationOutput>;
  /**
   * Fire-and-forget: enqueue a Fakturownia sync via Celery.
   * 
   * The frontend pattern is: call this mutation → poll
   * `fakturownia_sync_status` until `is_running` flips back to false →
   * read `last_run.stats` to render "synced N invoices". The returned
   * `last_run` is the state *before* the new task starts so the UI can
   * show "synced 14:23 (… enqueueing new run …)" instantly.
   */
  triggerFakturowniaSync?: Maybe<TriggerFakturowniaSyncMutation>;
  /**
   * Group-scoped Fakturownia sync — docs/groups/group_dashboard.md §G10.
   * 
   * Same Celery task as `triggerFakturowniaSync`, but the dedup lock is
   * scoped per `(group_id, period)` so a busy operator can fire syncs
   * for several groups without the global trigger getting in the way.
   * The payer-email UNION (agreement.buyer_email + student.email) is
   * recorded in the audit log and the returned `message`; narrowing the
   * actual Fakturownia API call by that list is intentionally deferred —
   * the mirror only ever grows, and the new canonical `groupId` filter
   * (§G7) will surface the new rows on the group's FinancesTab as soon
   * as the sync completes.
   */
  triggerFakturowniaGroupSync?: Maybe<TriggerFakturowniaGroupSyncMutation>;
  /**
   * Attach an existing `students.Payment` to a Fakturownia invoice 1:1.
   * 
   * Use when an operator has identified the LMS payment that corresponds to
   * this invoice (e.g. they already imported it from a bank statement).
   * The Payment is OneToOne — if it's already linked to a different
   * invoice the call fails with `Payment already linked`.
   * @deprecated Legacy payment-first link (ТЗ 0004). Use linkInvoiceToContribution; the hidden Payment is provisioned automatically.
   */
  linkFakturowniaInvoiceToPayment?: Maybe<FakturowniaMutationOutput>;
  /**
   * Create a `students.Payment` on `agreement_id` from the invoice's
   * amount/currency/date and link it 1:1 to the invoice.
   * 
   * The amount is taken from `invoice.paid` (the Fakturownia "paid" total).
   * Currency must match between agreement and invoice — we don't auto-FX
   * here because finance wants explicit conversions.
   * @deprecated Legacy: Payment is a hidden system record (ТЗ 0004). Use linkInvoiceToContribution / markContributionPaidManually.
   */
  createPaymentForFakturowniaInvoice?: Maybe<FakturowniaMutationOutput>;
  /**
   * Drop both `payment` and the legacy `linked_*` columns, returning the
   * invoice to `unmatched`. The Payment row itself is left intact — finance
   * may still want it for the agreement's ledger; only the bridge is removed.
   * @deprecated Legacy payment-first unlink (ТЗ 0004). Use unlinkInvoiceFromContribution.
   */
  unlinkFakturowniaInvoice?: Maybe<FakturowniaMutationOutput>;
  /**
   * DEPRECATED. Pin invoice to a Student/Group without touching Payment.
   * 
   * Kept so the old frontend keeps working during the migration. New code
   * should call `linkFakturowniaInvoiceToPayment` or
   * `createPaymentForFakturowniaInvoice` instead.
   * @deprecated Legacy (ТЗ 0004). Use linkInvoiceToContribution instead.
   */
  matchFakturowniaInvoice?: Maybe<FakturowniaMutationOutput>;
  /**
   * DEPRECATED. Change just the legacy `linked_group` column.
   * Use `linkFakturowniaInvoiceToPayment` to set the canonical chain.
   * @deprecated The group is now reached as invoice.contribution.agreement.group (ТЗ 0004).
   */
  setFakturowniaInvoiceGroup?: Maybe<FakturowniaMutationOutput>;
  /** Create students + agreements + first contribution from PandaDoc docs. */
  provisionStudents?: Maybe<ProvisionStudentsMutation>;
  /**
   * Enqueue a full PandaDoc re-sync (list + details, with student folder
   * backfill). Powers the dashboard 'refresh everything' button — the Celery
   * task self-chains until the whole details backlog is drained.
   */
  triggerPandadocSync?: Maybe<TriggerPandadocSyncMutation>;
  /**
   * Re-extract signer contact data (email/phone/name) on already-synced
   * documents and re-pull the details of rows a local re-parse can't fix.
   * 
   * The repair button for «у студента нет договоров» / «новая папка не
   * появилась»: it applies the current parser to the whole cached inventory
   * instead of waiting for each document to change in PandaDoc.
   * 
   * Admin-only (unlike the plain sync): a run can queue the entire inventory
   * for a `/details` re-fetch, which costs hours of the PandaDoc rate-limit
   * budget.
   */
  reparsePandadocRecipients?: Maybe<ReparsePandadocRecipientsMutation>;
  /**
   * Attach a PandaDoc document to an existing agreement (manual link from
   * the student card). Does not create a Student/Agreement and does not touch
   * `provisioned_at`.
   */
  linkPandadocDocument?: Maybe<LinkPandadocDocumentMutation>;
  /** Detach a manually-linked PandaDoc document from its agreement. */
  unlinkPandadocDocument?: Maybe<UnlinkPandadocDocumentMutation>;
  /**
   * Attach a `trainer` PandaDoc document to a Teacher (from the teacher
   * card). The teacher analog of LinkPandadocDocumentMutation.
   */
  linkPandadocTeacher?: Maybe<LinkPandadocTeacherMutation>;
  /** Detach a PandaDoc document from its teacher. */
  unlinkPandadocTeacher?: Maybe<UnlinkPandadocTeacherMutation>;
  syncZoomAccounts?: Maybe<SyncZoomAccountsMutation>;
  syncZoomRecordings?: Maybe<SyncZoomRecordingsMutation>;
  /** Sync accounts + every cloud recording in Zoom for a date range. */
  syncAllZoomRecordings?: Maybe<SyncAllZoomRecordingsMutation>;
  /** Refresh the Zoom account usage summary (storage quota + counts). */
  syncZoomUsage?: Maybe<SyncZoomUsageMutation>;
  /** One-call refresh: accounts + all recordings + account usage. */
  refreshAllZoomData?: Maybe<RefreshAllZoomDataMutation>;
  runAutoMatching?: Maybe<RunAutoMatchingMutation>;
  /**
   * Manual Zoom sync scoped to one group — docs/groups/group_dashboard.md
   * §G9. Re-runs `sync_recordings` for the window and the matcher against
   * the group's lessons. 60-sec dedup lock per group so a frantic operator
   * doesn't queue ten copies.
   */
  triggerZoomGroupProcess?: Maybe<TriggerZoomGroupProcessMutation>;
  setGroupZoomAccount?: Maybe<SetGroupZoomAccountMutation>;
  /** Set a group's Zoom account and fully replace its processing slots. */
  setGroupZoomSchedule?: Maybe<SetGroupZoomScheduleMutation>;
  createManualLessonRecording?: Maybe<CreateManualLessonRecordingMutation>;
  unlinkLessonRecording?: Maybe<UnlinkLessonRecordingMutation>;
  markLessonMissingRecording?: Maybe<MarkLessonMissingRecordingMutation>;
  retryLessonRecording?: Maybe<RetryLessonRecordingMutation>;
  reprocessAi?: Maybe<ReprocessAiMutation>;
  deleteZoomRecording?: Maybe<DeleteZoomRecordingMutation>;
  /**
   * Удалить пачку записей одним подтверждением (ТЗ 0043).
   * 
   * До этого удаление было поштучным и требовало НАБРАТЬ РУКАМИ строку
   * «DELETE <pk>» на каждую запись. Чистка десятка видео превращалась в десять
   * диалогов с печатью идентификатора, и ей просто не пользовались.
   * 
   * Пакет не падает целиком из-за одной проблемной строки: каждая получает свой
   * исход, и оператор видит, что именно не ушло и почему.
   */
  deleteZoomRecordings?: Maybe<DeleteZoomRecordingsMutation>;
  /**
   * Отправить утренний отчёт в Telegram сейчас. Выключен потолком/env
   * (`disabled_on_server`) или в «Настройках» (`disabled`) — отказ, задача
   * не ставится (и сама задача перепроверяет ключ при отправке).
   */
  sendMorningReport?: Maybe<SendMorningReportMutation>;
  createGroup?: Maybe<CreateGroupMutation>;
  updateGroup?: Maybe<UpdateGroupMutation>;
  deleteGroup?: Maybe<DeleteGroupMutation>;
  publishGroup?: Maybe<PublishGroupToLms>;
  changeLessonDates?: Maybe<ChangeLessonDate>;
  uploadLessonVideo?: Maybe<UploadLessonVideo>;
  cancelVideoUpload?: Maybe<CancelVideoUpload>;
  setGroupLessonLink?: Maybe<SetGroupLessonLink>;
  setGroupLessonLinkOverride?: Maybe<SetGroupLessonLinkOverride>;
  clearGroupLessonLinkOverride?: Maybe<ClearGroupLessonLinkOverride>;
  lmsJoinLesson?: Maybe<LmsJoinLesson>;
  lmsSetTodayLessonLink?: Maybe<LmsSetTodayLessonLink>;
  lmsClearTodayLessonLink?: Maybe<LmsClearTodayLessonLink>;
  createLead?: Maybe<CreateLeadMutation>;
  createBlackFridayLead?: Maybe<CreateBlackFridayLeadMutation>;
  createNewYearLead?: Maybe<CreateNewYearLeadMutation>;
  updateJournal?: Maybe<UpdateJournalsMutation>;
  updateAttendance?: Maybe<UpdateAttendanceMutation>;
  /**
   * Поштучная отметка преподавателем из LMS (ТЗ 0026).
   * 
   * Заменяет пакетное сохранение внутри `finishLmsLesson`. Возвращает ту же
   * сущность `LessonAttendancesType`, что отдаёт `groupLessonAttendanceForLms`
   * — Apollo нормализует её по `id`, поэтому оптимистичное обновление на
   * фронте работает без ручного `cache.modify`.
   */
  lmsSetAttendance?: Maybe<LmsSetAttendanceMutation>;
  /**
   * «Занятие проведено» + комментарий.
   * 
   * ТЗ 0026 забрал отсюда посещаемость: она сохраняется поштучно через
   * `lmsSetAttendance`. Аргумент `attendances` стал НЕобязательным — снятие
   * `required` обратно совместимо, поэтому старый бандл, оставшийся в кэше
   * браузера преподавателя после выката бэкенда, продолжит работать как
   * раньше. Удалять аргумент — следующим релизом.
   */
  finishLmsLesson?: Maybe<FinishLmsLessonMutation>;
  setStudentsMarks?: Maybe<SetStudentsMarksMutation>;
  createCourse?: Maybe<CreateCourseMutation>;
  updateCourse?: Maybe<UpdateCourseMutation>;
  deleteCourse?: Maybe<DeleteCourseMutation>;
  createTeacherBillingEntity?: Maybe<CreateTeacherBillingEntity>;
  updateTeacherBillingEntity?: Maybe<UpdateTeacherBillingEntity>;
  setDefaultTeacherBillingEntity?: Maybe<SetDefaultTeacherBillingEntity>;
  /** Узкая правка финансовых условий заявки: только переданные поля. */
  setApplicationFinanceTerms?: Maybe<SetApplicationFinanceTerms>;
  /**
   * Upload a CV (or certificate / portfolio) and extract its text.
   * 
   * Extraction runs INLINE, not in Celery: `pypdf` on a resume is milliseconds,
   * and a background hop would make the client poll for a status that is already
   * known by the time this response is written.
   * 
   * Versioned, never replaced — a re-sent CV becomes v2 and v1 stays readable.
   */
  uploadTeacherDocument?: Maybe<UploadTeacherDocument>;
  /**
   * Paste the text of a document whose extraction failed.
   * 
   * The recovery path for a SCANNED CV: the PDF is perfectly valid, it simply
   * has no text layer, and there is no OCR in this system. Mirrors
   * `setTeacherInterviewTranscript` so the AI layer keeps reading one field and
   * never learns where the text came from.
   */
  setTeacherDocumentText?: Maybe<SetTeacherDocumentText>;
  /** Remove the row AND the S3 object — this is the right-to-erasure path. */
  deleteTeacherDocument?: Maybe<DeleteTeacherDocument>;
  /**
   * Queue a competency analysis of a document's extracted text.
   * 
   * The result merges with any interview run into ONE profile: the CV carries
   * self-declared CLAIMS, the transcript carries observed behaviour, and
   * `profile_merge` keeps both tagged by source rather than fusing them.
   * 
   * `NO_DOCUMENT_TEXT` is a precondition, not a failure — no run row is created,
   * exactly as with a missing transcript.
   */
  runTeacherDocumentAnalysis?: Maybe<RunTeacherDocumentAnalysis>;
  /**
   * Queue a competency analysis of one interview's transcript.
   * 
   * Two non-failures answered as customErrors rather than a failed run row:
   * · `AI_DISABLED` — the kill switch is off; the panel stays visible with a
   *   disabled button so «why is there no AI?» is answerable.
   * · `NO_TRANSCRIPT` — a PRECONDITION. It must not create a `failed` row,
   *   because «нет входа» is not an analysis that went wrong: it must not burn a
   *   retry or paint the panel red. The UI offers «вставить расшифровку».
   */
  runTeacherInterviewAnalysis?: Maybe<RunTeacherInterviewAnalysis>;
  /**
   * Rebuild the merged profile from the existing good runs — no new AI call.
   * 
   * Idempotent by construction (`merge_profiles` is pure and ordered), so this is
   * safe to press twice; it exists for the case where a run landed while the
   * merge shape changed.
   */
  recomputeTeacherAiProfile?: Maybe<RecomputeTeacherAiProfile>;
  /**
   * Accept or reject course proposals.
   * 
   * Accepting is the ONLY path that writes `Teacher.courses_can_teach`, and it
   * uses `.add()` — never `.set()`, which would wipe a list the operator curated
   * by hand. Rejecting writes no M2M at all.
   */
  applyTeacherCourseSuggestions?: Maybe<ApplyTeacherCourseSuggestions>;
  /**
   * Link a synced Zoom recording; artifacts are pulled on commit.
   * 
   * Eagerly, not lazily: Zoom's cloud retention expires `files[].download_url`
   * and a re-sync does not repair it, so a link we merely stored would rot.
   */
  attachTeacherInterviewZoom?: Maybe<AttachTeacherInterviewZoom>;
  /**
   * A bare URL — nothing stored, nothing analysable until a transcript is
   * pasted. Also the shape the legacy `Teacher.interviewRecording` migrated into.
   */
  attachTeacherInterviewLink?: Maybe<AttachTeacherInterviewLink>;
  /**
   * Multipart upload for an interview recorded outside Zoom.
   * 
   * One mutation per file, the diploma rule. Capped at
   * MAX_TEACHER_INTERVIEW_VIDEO_BYTES: a full 90-minute 1080p recording is
   * 1-2 GB, and raising nginx `client_max_body_size` to match would affect every
   * endpoint and pin one sync gunicorn worker for the whole transfer — such
   * recordings belong on the Zoom path, which streams server-to-server.
   */
  uploadTeacherInterviewVideo?: Maybe<UploadTeacherInterviewVideo>;
  /**
   * Paste a transcript or interview notes.
   * 
   * In v1 this is the PRIMARY route to an analysable interview: Zoom only emits
   * a transcript when *Audio transcript* is enabled on that account (and never
   * retroactively), and this system has no speech-to-text of its own.
   */
  setTeacherInterviewTranscript?: Maybe<SetTeacherInterviewTranscript>;
  /**
   * Re-queue the artifact pull — the recovery path when Zoom's transcript
   * landed after the video, or a worker died mid-download.
   */
  retryTeacherInterviewDownload?: Maybe<RetryTeacherInterviewDownload>;
  /**
   * Remove the row AND the S3 objects.
   * 
   * Deliberately unlike the diploma rule (which leaves the object because a
   * student may hold a live signed URL): this is candidate personal data under a
   * retention policy, so erasure is the point.
   */
  deleteTeacherInterview?: Maybe<DeleteTeacherInterview>;
  /**
   * Pull a date window straight from Zoom, synchronously.
   * 
   * Load-bearing, not a nicety: with production defaults the only scheduled sync
   * is `zoom_hourly_dispatch`, which early-returns unless a `GroupZoomSchedule`
   * slot falls in the current 15-minute bucket, so an interview recorded at a
   * quiet hour may never appear on its own.
   */
  refreshInterviewZoomRecordings?: Maybe<RefreshInterviewZoomRecordings>;
  createUniqueTeacher?: Maybe<CreateUniqueTeacher>;
  addTeacherRole?: Maybe<AddNewRoleTeacher>;
  addTeacherExist?: Maybe<AddTeacherExist>;
  addTeacherApplication?: Maybe<AddTeacherApplication>;
  updateTeacherApplication?: Maybe<UpdateTeacherApplication>;
  deleteTeacherApplication?: Maybe<DeleteTeacherApplication>;
  updateTeacherWithType?: Maybe<UpdateTeacherWithTypeMutation>;
  /**
   * Update the control-panel profile fields — rating, internal note,
   * interview-recording link, and the courses-can-teach list. Only the fields
   * actually passed are changed; `rating=0` clears the rating.
   */
  setTeacherProfile?: Maybe<SetTeacherProfile>;
  /**
   * Create a STANDALONE teacher WITHOUT any application/group assignment —
   * add «свободных» преподавателей на будущее (собеседование/курсы/рейтинг
   * заполняются на карточке). Distinct from `createUniqueTeacher`, which
   * requires an application.
   */
  createTeacher?: Maybe<CreateTeacher>;
  createStaffTask?: Maybe<CreateStaffTaskMutation>;
  updateStaffTask?: Maybe<UpdateStaffTaskMutation>;
  /** Move a task between statuses; stamps/clears `completed_at` on done. */
  updateTaskStatus?: Maybe<UpdateTaskStatusMutation>;
  deleteStaffTask?: Maybe<DeleteStaffTaskMutation>;
  /**
   * Drag-and-drop a task on the command-center board: optionally change its
   * column (status or due date) and reposition it between two neighbours — all
   * atomically.
   */
  moveStaffTask?: Maybe<MoveStaffTaskMutation>;
  /**
   * Прицепить к задаче объекты (ТЗ 0064).
   * 
   * Добавление, а не «пришлите весь список»: две вкладки, открытые рядом,
   * затирали бы правки друг друга, и снятая в одной связь молча возвращалась
   * бы из второй. Повтор уже существующей связи — не ошибка: `ignore_conflicts`
   * делает вызов идемпотентным, а человек, дважды выбравший одного студента,
   * хотел одного студента.
   */
  addStaffTaskLinks?: Maybe<AddStaffTaskLinksMutation>;
  /**
   * Снять одну связь — по id СТРОКИ связи.
   * 
   * Не по паре «вид + объект»: строка снимается и тогда, когда объекта уже нет
   * в базе, а пары для него не построишь — именно ради этого случая связь и
   * показывается как «объект удалён», а не прячется.
   */
  removeStaffTaskLink?: Maybe<RemoveStaffTaskLinkMutation>;
  addStaffTaskComment?: Maybe<AddStaffTaskCommentMutation>;
  /**
   * Приложить ОДИН файл к существующей задаче (ТЗ 0066).
   * 
   * Один файл на вызов — как у дипломов: multipart с несколькими файлами
   * отказывает целиком, и пользователь не понимает, какой из них виноват.
   * Клиент шлёт их подряд.
   */
  addStaffTaskAttachment?: Maybe<AddStaffTaskAttachmentMutation>;
  removeStaffTaskAttachment?: Maybe<RemoveStaffTaskAttachmentMutation>;
  editStaffTaskComment?: Maybe<EditStaffTaskCommentMutation>;
  deleteStaffTaskComment?: Maybe<DeleteStaffTaskCommentMutation>;
  createStudentNote?: Maybe<CreateStudentNoteMutation>;
  updateStudentNote?: Maybe<UpdateStudentNoteMutation>;
  deleteStudentNote?: Maybe<DeleteStudentNoteMutation>;
  /**
   * Save the LMS suspension settings. Validation: overdueDays 1..90
   * (`invalid_overdue_days`); mail may be enabled only with BOTH templates
   * (`template_required`); a new template id (or one never checked) must
   * exist in SendGrid (`template_not_found`) and its name is copied from
   * SendGrid; SendGrid unreachable → `sendgrid_unavailable` /
   * `sendgrid_forbidden`, nothing saved. Audited (from → to).
   * 
   * The SendGrid check (network) runs against an unlocked read, BEFORE the
   * transaction; the final validation runs again INSIDE it, on the row
   * re-read under `select_for_update` with this call's partial input laid
   * over it — a concurrent save (e.g. clearing a template while this call
   * enables mail) cannot produce a row that breaks the rules.
   */
  saveLmsBlockSettings?: Maybe<SaveLmsBlockSettingsMutation>;
  /**
   * Send a suspension / restoration template with the EXAMPLE data to the
   * calling staff member (or LMS_BLOCK_MAIL_TEST_RECIPIENT when set). Needs env
   * LMS_BLOCK_MAIL_ENABLED (`disabled_on_server`), not the ERP mail switch.
   * Writes no AccessBlockNotification.
   */
  sendLmsBlockTestEmail?: Maybe<SendLmsBlockTestEmailMutation>;
  /**
   * Suspend a student's LMS access by hand (ТЗ 0074 §3.4). The suspension
   * is tied to ALL the student's current unpaid invoices; no overdue invoice
   * is required. Idempotent for an already-suspended student.
   */
  blockStudentLmsAccess?: Maybe<BlockStudentLmsAccessMutation>;
  /**
   * Restore a student's LMS access by hand (ТЗ 0074 §3.4). The already
   * overdue invoices the suspension was tied to are forgiven (`waived`) — a
   * NEW overdue invoice (or a tied one that was not due yet) suspends again.
   */
  unblockStudentLmsAccess?: Maybe<UnblockStudentLmsAccessMutation>;
  /**
   * Create a free-standing Payment on an agreement (no Fakturownia link).
   * 
   * Mirrors `createPaymentForFakturowniaInvoice` but starts from the
   * agreement instead of an invoice — finance often records a payment
   * before any invoice exists. Link to an invoice later via
   * `linkFakturowniaInvoiceToPayment`.
   * @deprecated Legacy: Payment is a hidden system record (ТЗ 0004). Use linkInvoiceToContribution / markContributionPaidManually.
   */
  createPayment?: Maybe<CreatePaymentMutation>;
  /**
   * Patch a Payment's amount and/or date.
   * 
   * Re-derives `amount_byn` / `amount_foreign` via `PaymentBase.save()` —
   * that's how the existing forms-based path keeps the chargeback / debt
   * tables consistent.
   * @deprecated Legacy: Payments are system-provisioned (ТЗ 0004) and not edited by operators.
   */
  updatePayment?: Maybe<UpdatePaymentMutation>;
  /**
   * Delete a Payment. Refuses if a FakturowniaInvoice is still linked —
   * the operator must call `unlinkFakturowniaInvoice` first so the invoice
   * isn't left orphaned with `payment_id → DELETED`.
   * @deprecated Legacy: kept only to drain orphan Payments (ТЗ 0004).
   */
  deletePayment?: Maybe<DeletePaymentMutation>;
  /**
   * Attach an existing Payment to an existing Contribution (1:1).
   * 
   * Used by the frontend "Перепривязать" / "Привязать существующий платёж"
   * action on the schedule row. The happy path also flips
   * `contribution.complete=True` and recomputes `remainder` via
   * `Contribution.save()` (§9.5).
   * @deprecated Legacy: kept only to drain orphan Payments (ТЗ 0004). Use linkInvoiceToContribution.
   */
  linkContributionToPayment?: Maybe<LinkContributionToPaymentMutation>;
  /**
   * Detach the Payment from a Contribution. The Payment stays alive as
   * an orphan (visible in the "вне графика" block); the Contribution
   * flips back to `complete=False, remainder=amount_foreign`.
   * @deprecated Legacy: use unlinkInvoiceFromContribution (ТЗ 0004).
   */
  unlinkContribution?: Maybe<UnlinkContributionMutation>;
  /**
   * Zero an UNPAID contribution's amount on a transfer-out agreement.
   * 
   * `Contribution.save()` re-derives `remainder = amount_foreign` for any
   * unpaid row, so "set remainder=0" is impossible — the legitimate way to
   * drop a contribution to zero is to set its AMOUNT to 0. This is strictly
   * gated:
   * 
   * * the agreement must be `terminated` AND `transfer_out` — i.e. wound down
   *   via `ChangeAgreementGroup`, which clones the schedule onto the NEW group,
   *   so the obligation is re-attributed there, not erased; and
   * * the contribution must NOT have a linked Payment — real received money is
   *   never destroyed here. To move already-received cash out of the old group,
   *   use a Chargeback / AccountsPayable carry-out (capped at `paid_amount`),
   *   not this mutation.
   * 
   * Every call is audited. The old terminated contract is already excluded from
   * debtors / finance / the calendar by the `terminated_date` cutoff; zeroing
   * additionally makes the old agreement read literally zero, which is what the
   * "обнулить старую группу" workflow asks for.
   */
  zeroOutContribution?: Maybe<ZeroOutContributionMutation>;
  /**
   * Record an off-invoice payment against an installment.
   * 
   * ТЗ 0029: writes `manual_paid_amount` / `manual_paid_date` on the instalment
   * itself — no hidden ledger row. Amount defaults to the remainder. The row
   * then reads «оплачен вручную» (fully covered with zero invoice money).
   */
  markContributionPaidManually?: Maybe<MarkContributionPaidManuallyMutation>;
  /**
   * Undo a manual «оплачен вручную» mark.
   * 
   * ТЗ 0029: clears `manual_paid_*` on the instalment. Money that came through
   * an invoice is untouched — that is corrected with a corrective invoice or a
   * `PaymentCorrection`, not here.
   */
  revertManualContributionPayment?: Maybe<RevertManualContributionPaymentMutation>;
  createPaymentCorrection?: Maybe<CreatePaymentCorrectionMutation>;
  updatePaymentCorrection?: Maybe<UpdatePaymentCorrectionMutation>;
  deletePaymentCorrection?: Maybe<DeletePaymentCorrectionMutation>;
  /** @deprecated Legacy bulk Payment entry (ТЗ 0004). Use linkInvoiceToContribution / markContributionPaidManually. */
  createPayments?: Maybe<CreatePaymentsMutation>;
  /** @deprecated Legacy deferred-Payment entry (ТЗ 0004); the flow is retired. */
  createDeferredPayments?: Maybe<CreateDeferredPaymentsMutation>;
  checkStudentDebt?: Maybe<CheckStudentsDebtMutation>;
  remindDebtors?: Maybe<RemindDebtorsMutation>;
  updateStudentWithAgreement?: Maybe<StudentWithAgreementUpdateMutation>;
  createStudentWithAgreement?: Maybe<StudentWithAgreementCreateMutation>;
  appendStudentRoleAndAgreement?: Maybe<AddRoleStudentAndAgreement>;
  /**
   * Single-shot «+Студент в группу» from the group dashboard
   * (docs/groups/group_dashboard.md §G8, Variant B).
   * 
   * The student already exists (search picker on the frontend); the
   * agreement carries the target `groupId` inside `agreement_input`.
   * Delegates to the existing `add_agreement_to_student` service so all
   * currency / contribution / attendance plumbing is shared with the rest
   * of the agreement-create flow — no duplicate validation paths.
   */
  appendStudentToGroup?: Maybe<AppendStudentToGroupMutation>;
  lmsStudentSignUp?: Maybe<StudentSignUpLmsMutation>;
  createAgreement?: Maybe<CreateAgreementMutation>;
  createCompany?: Maybe<CreateCompanyMutation>;
  updateCompany?: Maybe<UpdateCompanyMutation>;
  /**
   * Move a student from one group to another atomically.
   * 
   * Created to back the "Перевести в другую группу" single-click action on
   * the new student card (`docs/fakturownia/student_card.md §6`). Replaces
   * the manual sequence of `editStudentWithAgreement` + chargeback +
   * new-agreement that finance currently has to chain by hand.
   */
  changeAgreementGroup?: Maybe<ChangeAgreementGroupMutation>;
  /**
   * Safe one-click agreement termination — see docs/groups/groups_upgrade.md §B3.
   * 
   * Replaces the chained `updateStudentWithAgreement` workaround that
   * re-sent the student's PII just to flip `terminated=True`. This mutation
   * touches only the agreement and writes an audit log entry; contributions
   * and deferred payments are deliberately left alone.
   */
  terminateAgreement?: Maybe<TerminateAgreementMutation>;
  /**
   * Вернуть студенту доступ к занятиям курса — ремонт, а не смена договора.
   * 
   * Только строки посещаемости (= доступ в LMS) и запись в аудит: деньги,
   * взносы и `terminated` не трогаются. Аддитивна — может лишь добавить
   * студенту занятия, которых у него нет, поэтому безопасна к повторному
   * нажатию и возвращает `restoredLessons = 0`, когда возвращать нечего.
   */
  restoreCourseAccess?: Maybe<RestoreCourseAccessMutation>;
  /**
   * Manually flag/unflag an agreement as «переведён из этой группы».
   * 
   * The flag relaxes the FULL-zeroing limit on corrections (partials work
   * without it) and the carry-out money guards (still capped at `paid_amount`).
   * Restricted to Admin/FinanceManager and audited — it must not be settable by
   * a rank-and-file operator, and never via a self-declared termination reason.
   */
  setAgreementTransferOut?: Maybe<SetAgreementTransferOutMutation>;
  /**
   * Manually flag/unflag a contract as «бесплатный договор».
   * 
   * Excludes the contract from ALL debt/overdue detection (student-card totals,
   * LMS-block candidates, debtors list, payment calendar) while leaving it
   * active — so the student keeps LMS access to the group. Like `transfer_out`
   * it also relaxes the FULL-zeroing correction guard, so the paid invoice can
   * be corrected to zero without pretending the contract was transferred.
   * Restricted to Admin/FinanceManager and audited — it silences a real debt, so
   * a rank-and-file operator must not be able to set it.
   */
  setAgreementFreeOfCharge?: Maybe<SetAgreementFreeOfChargeMutation>;
  /**
   * Manually flag/unflag a contract as «финансирование государством».
   * 
   * The student is pre-financed by the state: intermediate documents
   * (proforma/advance/VAT) are not a debt — only an unpaid overdue FINAL
   * invoice is — and the plan/contributions owe nothing until then. Debt gates
   * honor this across totals, LMS block, debtors list and calendar. Restricted
   * to Admin/FinanceManager and audited.
   */
  setAgreementStatePrefinanced?: Maybe<SetAgreementStatePrefinancedMutation>;
  /**
   * «Исправить группу» — правка ошибки, а не перевод: то же соглашение,
   * новая группа, доступ в LMS переезжает, номер `{группа}-{N}` пересчитан
   * (кроме номера из подписанного договора ERP). Не ставит `transfer_out` /
   * `terminated`, не создаёт двойника и не пишет `change_agreement_group`.
   */
  correctAgreementGroup?: Maybe<CorrectAgreementGroupMutation>;
  /**
   * «Отменить зачисление» — удалить ошибочно заведённое соглашение со
   * взносами (окно `AGREEMENT_UNDO_WINDOW_DAYS`, строгие проверки), вернуть
   * взятые им AccountsPayable и снять доступ в LMS. Студент и пользователь
   * остаются; в аудите — снимок удалённого.
   */
  undoEnrollment?: Maybe<UndoEnrollmentMutation>;
  /**
   * SDL: {success, errors, customErrors}.
   * 
   * ТЗ 0021, стадия 4 — вместо `graphql_auth.mutations.Register`. Полей
   * token/refreshToken тут нет и быть не должно: пакет доливал их только при
   * `ALLOW_LOGIN_NOT_VERIFIED=True`, а в проекте настройка False.
   */
  createUser?: Maybe<RegisterMutation>;
  /** SDL: {success, errors, customErrors}. */
  sendPasswordResetEmail?: Maybe<CustomSendPasswordResetEmail>;
  sendLmsAuthEmail?: Maybe<SendAuthenticationCode>;
  /** Сброс пароля по токену из письма. SDL: {success, errors}. */
  passwordReset?: Maybe<PasswordReset>;
  /** Установка первого пароля по токену из письма. SDL: {success, errors}. */
  passwordSet?: Maybe<PasswordSet>;
  /** SDL: {token, success, errors, user, unarchiving, customErrors, refreshToken}. */
  customLogin?: Maybe<CustomObtainJsonWebToken>;
  /** SDL: {payload: GenericScalar, success, errors}. */
  verifyToken?: Maybe<VerifyToken>;
  /** То же, что в `graphql_jwt`, но с нашей формой ответа (success/errors). */
  refreshToken?: Maybe<CustomRefreshToken>;
  /** SDL: {revoked: Int, success, errors}. */
  revokeToken?: Maybe<RevokeToken>;
  /** SDL: {token, success, errors, user, unarchiving, customErrors, refreshToken}. */
  demoCustomLogin?: Maybe<CustomObtainJsonWebToken>;
  updateUserSettings?: Maybe<UserSettingsUpdateMutation>;
  deleteUserSettings?: Maybe<UserSettingsDeleteMutation>;
  appendRolesUserSettings?: Maybe<UserSettingsRolesAddMutation>;
};


export type MutationCreateDocumentTemplateArgs = {
  basedOnId?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
};


export type MutationSaveDocumentTemplateArgs = {
  comment?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};


export type MutationSetDocumentTemplateActiveArgs = {
  active: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationActivateDocumentTemplateVersionArgs = {
  versionId: Scalars['ID'];
};


export type MutationIssueDocumentArgs = {
  agreementId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  issuePlace?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  templateId: Scalars['ID'];
};


export type MutationSendIssuedDocumentArgs = {
  html?: Maybe<Scalars['String']>;
  issuedDocumentId: Scalars['ID'];
  mailboxEmail?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};


export type MutationSetAiChatToolEnabledArgs = {
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationSaveAiSkillArgs = {
  input: AiSkillInput;
};


export type MutationImportAiSkillArgs = {
  file: Scalars['Upload'];
};


export type MutationSetAiSkillStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationDeleteAiSkillArgs = {
  id: Scalars['ID'];
};


export type MutationSaveAiMcpConnectionArgs = {
  input: AiMcpConnectionInput;
};


export type MutationTestAiMcpConnectionArgs = {
  id: Scalars['ID'];
};


export type MutationStartAiMcpOAuthArgs = {
  id: Scalars['ID'];
};


export type MutationSetAiMcpToolSettingsArgs = {
  id: Scalars['ID'];
  tools: Array<AiMcpToolSettingInput>;
};


export type MutationDeleteAiMcpConnectionArgs = {
  id: Scalars['ID'];
};


export type MutationImportAiPluginArgs = {
  file: Scalars['Upload'];
};


export type MutationSetAiPluginEnabledArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationDeleteAiPluginArgs = {
  id: Scalars['ID'];
};


export type MutationSendAiChatMessageArgs = {
  attachmentIds?: Maybe<Array<Scalars['ID']>>;
  mentions?: Maybe<Array<AiChatMentionInput>>;
  text: Scalars['String'];
  threadId?: Maybe<Scalars['ID']>;
};


export type MutationResolveAiChatActionArgs = {
  approve: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationDeleteAiChatThreadArgs = {
  id: Scalars['ID'];
};


export type MutationUploadAiChatAttachmentArgs = {
  file: Scalars['Upload'];
};


export type MutationPinAiChatThreadArgs = {
  id: Scalars['ID'];
  pinned: Scalars['Boolean'];
};


export type MutationRenameAiChatThreadArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationArchiveAiChatThreadArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationApproveAiKbCandidateArgs = {
  answer?: Maybe<Scalars['String']>;
  claim?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mode?: Maybe<Scalars['String']>;
  replaceLine?: Maybe<Scalars['String']>;
  targetDocumentId?: Maybe<Scalars['ID']>;
  targetHeading?: Maybe<Scalars['String']>;
};


export type MutationRejectAiKbCandidateArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationMarkAiKbCandidateDuplicateArgs = {
  duplicateOfId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationUpdateAiKbCandidateArgs = {
  category?: Maybe<Scalars['String']>;
  claim?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  targetDocumentId?: Maybe<Scalars['ID']>;
  targetHeading?: Maybe<Scalars['String']>;
};


export type MutationSetAiKbReviewersArgs = {
  category: Scalars['String'];
  userIds: Array<Scalars['ID']>;
};


export type MutationVerifyAiKnowledgeDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationSaveAiKnowledgeDocumentArgs = {
  body: Scalars['String'];
  category: Scalars['String'];
  expectedVersion?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
};


export type MutationRollbackAiKnowledgeDocumentArgs = {
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationUploadAiKnowledgeDocumentArgs = {
  category: Scalars['String'];
  file: Scalars['Upload'];
  title?: Maybe<Scalars['String']>;
};


export type MutationSetAiKnowledgeDocumentStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationDeleteAiKnowledgeDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationRequestAiLessonAnalysisArgs = {
  force?: Maybe<Scalars['Boolean']>;
  lessonId: Scalars['ID'];
};


export type MutationRequestAiLessonAnalysesArgs = {
  force?: Maybe<Scalars['Boolean']>;
  lessonIds: Array<Scalars['ID']>;
};


export type MutationGenerateAiTeacherNarrativeArgs = {
  teacherId: Scalars['ID'];
};


export type MutationReviewAiLessonAnalysisArgs = {
  decision: Scalars['String'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
};


export type MutationRefreshAiStudentPortraitArgs = {
  studentId: Scalars['ID'];
};


export type MutationRequestAiReplySuggestionArgs = {
  conversationId: Scalars['ID'];
};


export type MutationMarkAiReplySuggestionArgs = {
  action: Scalars['String'];
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};


export type MutationRejectAiFindingArgs = {
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};


export type MutationConfirmAiFindingArgs = {
  id: Scalars['ID'];
};


export type MutationStartAiAgentRunArgs = {
  agentKey: Scalars['String'];
  subjectId?: Maybe<Scalars['ID']>;
  subjectKind?: Maybe<Scalars['String']>;
};


export type MutationCancelAiAgentRunArgs = {
  id: Scalars['ID'];
};


export type MutationSetRuntimeSettingArgs = {
  key: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  value: Scalars['JSONString'];
};


export type MutationClearRuntimeSettingArgs = {
  key: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
};


export type MutationDisableOrphanPeriodicTaskArgs = {
  name: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
};


export type MutationSaveMarketingSeoSettingsArgs = {
  input: MarketingSeoSettingsInput;
};


export type MutationSaveMarketingSeoKeywordArgs = {
  excluded?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  tracked?: Maybe<Scalars['Boolean']>;
};


export type MutationAddMarketingSeoKeywordsArgs = {
  familySlug?: Maybe<Scalars['String']>;
  keywords: Array<Scalars['String']>;
};


export type MutationSaveMarketingSeoQuestionArgs = {
  input: MarketingSeoQuestionInput;
};


export type MutationDeleteMarketingSeoQuestionArgs = {
  id: Scalars['ID'];
};


export type MutationSetMarketingSeoOpportunityStatusArgs = {
  ids: Array<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};


export type MutationRunMarketingSeoArgs = {
  dryRun?: Maybe<Scalars['Boolean']>;
  kind: Scalars['String'];
};


export type MutationRefreshMarketingSourcesArgs = {
  sources?: Maybe<Array<Scalars['String']>>;
};


export type MutationSaveMarketingChannelRuleArgs = {
  input: MarketingChannelRuleInput;
};


export type MutationDeleteMarketingChannelRuleArgs = {
  id: Scalars['ID'];
};


export type MutationSaveMarketingCourseFamilyArgs = {
  input: MarketingCourseFamilyInput;
};


export type MutationSaveMarketingCourseAliasArgs = {
  input: MarketingCourseAliasInput;
};


export type MutationDeleteMarketingCourseAliasArgs = {
  id: Scalars['ID'];
};


export type MutationSaveMarketingOfferRuleArgs = {
  input: MarketingOfferRuleInput;
};


export type MutationDeleteMarketingOfferRuleArgs = {
  id: Scalars['ID'];
};


export type MutationSetMarketingPipelineKindArgs = {
  funnelKind: Scalars['String'];
  id: Scalars['ID'];
  locked: Scalars['Boolean'];
};


export type MutationOverrideMarketingAdEntityArgs = {
  familySlug?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locked: Scalars['Boolean'];
  offer?: Maybe<Scalars['String']>;
};


export type MutationOverrideMarketingSaleArgs = {
  input: MarketingSaleOverrideInput;
};


export type MutationSetMarketingTargetArgs = {
  input: MarketingTargetInput;
};


export type MutationAckMarketingSignalArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationSaveMarketingCampaignAliasArgs = {
  input: MarketingCampaignAliasInput;
};


export type MutationDeleteMarketingCampaignAliasArgs = {
  id: Scalars['ID'];
};


export type MutationSaveMarketingSearchSettingsArgs = {
  brandRegex?: Maybe<Scalars['String']>;
  ga4KeyEvents?: Maybe<Array<Scalars['String']>>;
  siteHosts?: Maybe<Array<Scalars['String']>>;
};


export type MutationGenerateMarketingDigestArgs = {
  isoWeek?: Maybe<Scalars['String']>;
};


export type MutationSaveMarketingSignalRoutingArgs = {
  input: MarketingSignalRoutingInput;
};


export type MutationSaveMarketingPageTypesArgs = {
  rules: Array<MarketingPageTypeRuleInput>;
};


export type MutationRequestPnlExportArgs = {
  fileFormat: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  language?: Maybe<Scalars['String']>;
  monthFrom: Scalars['String'];
  monthTo: Scalars['String'];
};


export type MutationRequestZoomParticipantsSyncArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  force?: Maybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
};


export type MutationMatchZoomParticipantArgs = {
  ignore?: Maybe<Scalars['Boolean']>;
  remember?: Maybe<Scalars['Boolean']>;
  sessionId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};


export type MutationLinkZoomInstanceToLessonArgs = {
  instanceUuid?: Maybe<Scalars['String']>;
  lessonId: Scalars['ID'];
  meetingId?: Maybe<Scalars['String']>;
};


export type MutationUnlinkZoomInstanceArgs = {
  instanceId: Scalars['ID'];
};


export type MutationSaveFundingMailSettingsArgs = {
  input: FundingMailSettingsInput;
};


export type MutationSaveFundingMailRuleArgs = {
  input: FundingMailRuleInput;
};


export type MutationDeleteFundingMailRuleArgs = {
  id: Scalars['ID'];
};


export type MutationSendFundingMailTestArgs = {
  intakeId?: Maybe<Scalars['ID']>;
  ruleId: Scalars['ID'];
  templateId?: Maybe<Scalars['String']>;
};


export type MutationSendFundingCandidateSmsArgs = {
  candidateId: Scalars['ID'];
  link?: Maybe<LeadSmsLinkInput>;
  requestKey?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationDraftLeadEmailArgs = {
  contractId?: Maybe<Scalars['ID']>;
  hint?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  leadId: Scalars['ID'];
  regenerate?: Maybe<Scalars['Boolean']>;
  requestKey?: Maybe<Scalars['String']>;
};


export type MutationSaveLeadSavedViewArgs = {
  filters: Scalars['GenericScalar'];
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
  shared?: Maybe<Scalars['Boolean']>;
  view: Scalars['String'];
};


export type MutationDeleteLeadSavedViewArgs = {
  id: Scalars['ID'];
  scope?: Maybe<Scalars['String']>;
};


export type MutationMoveKommoLeadArgs = {
  id: Scalars['ID'];
  lossReasonId?: Maybe<Scalars['ID']>;
  statusId: Scalars['ID'];
};


export type MutationSetKommoLeadResponsibleArgs = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationLinkKommoLeadArgs = {
  leadId: Scalars['ID'];
  targetId?: Maybe<Scalars['ID']>;
  what: Scalars['String'];
};


export type MutationResetKommoLeadLinkArgs = {
  leadId: Scalars['ID'];
  what: Scalars['String'];
};


export type MutationSendLeadSmsArgs = {
  leadId: Scalars['ID'];
  link?: Maybe<LeadSmsLinkInput>;
  requestKey?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationRefreshKommoLeadArgs = {
  id: Scalars['ID'];
};


export type MutationSyncKommoLeadsArgs = {
  full?: Maybe<Scalars['Boolean']>;
};


export type MutationSetKommoUserMappingArgs = {
  kommoUserId: Scalars['ID'];
  locked?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['ID']>;
};


export type MutationStartLeadLadderArgs = {
  days?: Maybe<Scalars['Int']>;
  kind: Scalars['String'];
  leadId: Scalars['ID'];
  requestKey?: Maybe<Scalars['String']>;
};


export type MutationStopLeadLadderArgs = {
  runId: Scalars['ID'];
};


export type MutationResumeLeadLadderArgs = {
  runId: Scalars['ID'];
};


export type MutationSendLeadEmailArgs = {
  aiDraftId?: Maybe<Scalars['ID']>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  html?: Maybe<Scalars['String']>;
  leadId: Scalars['ID'];
  mailboxEmail: Scalars['String'];
  requestKey?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  templateId?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
};


export type MutationInviteLeadToFundingFormArgs = {
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  days?: Maybe<Scalars['Int']>;
  html?: Maybe<Scalars['String']>;
  leadId: Scalars['ID'];
  mailboxEmail: Scalars['String'];
  requestKey?: Maybe<Scalars['String']>;
  startLadder?: Maybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  templateId?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
};


export type MutationAploraFollowupDraftArgs = {
  callId: Scalars['ID'];
  leadId: Scalars['ID'];
  regenerate?: Maybe<Scalars['Boolean']>;
  requestKey?: Maybe<Scalars['String']>;
};


export type MutationSendTeacherSmsArgs = {
  link?: Maybe<TeacherSmsLinkInput>;
  requestKey?: Maybe<Scalars['String']>;
  teacherId: Scalars['ID'];
  templateId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationSendStudentSmsArgs = {
  link?: Maybe<SmsLinkInput>;
  requestKey?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
  templateId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationSendGroupSmsArgs = {
  groupId: Scalars['ID'];
  link?: Maybe<SmsLinkInput>;
  mode?: Maybe<Scalars['String']>;
  requestKey?: Maybe<Scalars['String']>;
  studentIds?: Maybe<Array<Scalars['ID']>>;
  templateId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};


export type MutationResendSmsCampaignArgs = {
  campaignId: Scalars['ID'];
};


export type MutationRetrySmsMessageArgs = {
  messageId: Scalars['ID'];
};


export type MutationCancelSmsMessageArgs = {
  messageId: Scalars['ID'];
};


export type MutationSaveSmsSettingsArgs = {
  input: SmsSettingsInput;
};


export type MutationSaveSmsTextsArgs = {
  optOutSuffix: Scalars['String'];
};


export type MutationSaveLinkAddressesArgs = {
  dofinFormUrl?: Maybe<Scalars['String']>;
  lmsBaseUrl?: Maybe<Scalars['String']>;
};


export type MutationSaveReminderPlanArgs = {
  enabled: Scalars['Boolean'];
  steps: Array<ReminderStepInput>;
  topic: Scalars['String'];
};


export type MutationCheckSmsConnectionArgs = {
  to: Scalars['String'];
};


export type MutationSendSmsTestArgs = {
  text?: Maybe<Scalars['String']>;
  to: Scalars['String'];
};


export type MutationCreateShortLinkArgs = {
  channel?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Scalars['String']>>;
  targetUrl: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateShortLinkArgs = {
  channel?: Maybe<Scalars['String']>;
  clearExpiry?: Maybe<Scalars['Boolean']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};


export type MutationRevokeShortLinkArgs = {
  id: Scalars['ID'];
};


export type MutationRevokeShortLinksArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationSaveContractTemplateVersionArgs = {
  comment?: Maybe<Scalars['String']>;
  html: Scalars['String'];
  id: Scalars['ID'];
  tokens?: Maybe<Scalars['JSONString']>;
};


export type MutationCreateContractTemplateArgs = {
  appendix?: Maybe<Scalars['String']>;
  basedOnId: Scalars['ID'];
  code?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};


export type MutationActivateContractTemplateVersionArgs = {
  id: Scalars['ID'];
};


export type MutationSetContractTemplateActiveArgs = {
  active: Scalars['Boolean'];
  code: Scalars['String'];
};


export type MutationSendContractEmailArgs = {
  aiDraftId?: Maybe<Scalars['ID']>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  contractId: Scalars['ID'];
  html?: Maybe<Scalars['String']>;
  mailboxEmail: Scalars['String'];
  subject: Scalars['String'];
  templateId?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
};


export type MutationDraftContractEmailArgs = {
  contractId: Scalars['ID'];
  hint?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  regenerate?: Maybe<Scalars['Boolean']>;
  requestKey?: Maybe<Scalars['String']>;
};


export type MutationSendContractReminderNowArgs = {
  contractId: Scalars['ID'];
};


export type MutationStopContractRemindersArgs = {
  contractId: Scalars['ID'];
};


export type MutationResumeContractRemindersArgs = {
  contractId: Scalars['ID'];
};


export type MutationRevealContractShortLinkArgs = {
  contractId: Scalars['ID'];
};


export type MutationSendContractSmsArgs = {
  contractId: Scalars['ID'];
  templateId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationSendContractsSmsArgs = {
  contractIds: Array<Scalars['ID']>;
  requestKey: Scalars['String'];
  templateId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationSaveMessageTemplateArgs = {
  body: Scalars['String'];
  channel: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  namePl?: Maybe<Scalars['String']>;
  personal?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};


export type MutationDeleteMessageTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationCreateStudentContractDraftArgs = {
  input: StudentContractDraftInput;
};


export type MutationUpdateContractDraftArgs = {
  id: Scalars['ID'];
  input: StudentContractDraftInput;
};


export type MutationCreateCompanyContractDraftArgs = {
  input: CompanyContractDraftInput;
};


export type MutationUpdateCompanyContractDraftArgs = {
  id: Scalars['ID'];
  input: CompanyContractDraftInput;
};


export type MutationSendContractArgs = {
  aiDraftId?: Maybe<Scalars['ID']>;
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  sendEmail: Scalars['Boolean'];
  templateId?: Maybe<Scalars['ID']>;
};


export type MutationResendContractEmailArgs = {
  aiDraftId?: Maybe<Scalars['ID']>;
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  templateId?: Maybe<Scalars['ID']>;
};


export type MutationRevealContractSigningLinkArgs = {
  id: Scalars['ID'];
};


export type MutationReassignContractSellerArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
  sellerId: Scalars['ID'];
};


export type MutationCancelContractArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationRetryContractFulfilmentArgs = {
  existingUserId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationCreateTeacherFrameworkDraftArgs = {
  courseIds?: Maybe<Array<Scalars['ID']>>;
  teacherId: Scalars['ID'];
  templateCode?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
};


export type MutationCreateTeacherAnnexDraftArgs = {
  applicationId: Scalars['ID'];
  templateId?: Maybe<Scalars['ID']>;
};


export type MutationSetCoursePlanPriceArgs = {
  amount: Scalars['String'];
  courseId: Scalars['ID'];
  currency: Scalars['String'];
  planId: Scalars['ID'];
};


export type MutationDeleteCoursePlanPriceArgs = {
  id: Scalars['ID'];
};


export type MutationMarkStaffNotificationsReadArgs = {
  ids: Array<Scalars['ID']>;
  kinds?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxAgeDays?: Maybe<Scalars['Int']>;
};


export type MutationMarkAllStaffNotificationsReadArgs = {
  before?: Maybe<Scalars['DateTime']>;
  kinds?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxAgeDays?: Maybe<Scalars['Int']>;
};


export type MutationUpdateStaffNotificationSettingsArgs = {
  input: StaffNotificationSettingsInput;
};


export type MutationSaveFundingOperatorArgs = {
  id?: Maybe<Scalars['ID']>;
  input: FundingOperatorInput;
};


export type MutationSaveFundingIntakeArgs = {
  announcedAt?: Maybe<Scalars['Date']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  endsAtTime?: Maybe<Scalars['Time']>;
  endsOn?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  operatorId: Scalars['ID'];
  sourceUrl?: Maybe<Scalars['String']>;
  startsAtTime?: Maybe<Scalars['Time']>;
  startsOn?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
};


export type MutationDeleteFundingIntakeArgs = {
  id: Scalars['ID'];
};


export type MutationSubmitFundingFormArgs = {
  payload: Scalars['JSONString'];
  recaptchaToken?: Maybe<Scalars['String']>;
  utm?: Maybe<Scalars['JSONString']>;
};


export type MutationSaveFundingCandidateArgs = {
  id?: Maybe<Scalars['ID']>;
  input: FundingCandidateInput;
};


export type MutationDeleteFundingCandidateArgs = {
  id: Scalars['ID'];
};


export type MutationChangeCandidateStatusArgs = {
  candidateId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};


export type MutationAddCandidateOperatorsArgs = {
  candidateId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  operatorIds: Array<Scalars['ID']>;
};


export type MutationDeactivateCandidateOperatorArgs = {
  candidateId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  operatorId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationReactivateCandidateOperatorArgs = {
  candidateId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  operatorId: Scalars['ID'];
};


export type MutationSetCandidatePrimaryOperatorArgs = {
  candidateId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
};


export type MutationSetFundingCandidateAttentionArgs = {
  candidateId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  on: Scalars['Boolean'];
};


export type MutationLinkCandidateToUserArgs = {
  candidateId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUnlinkCandidateFromUserArgs = {
  candidateId: Scalars['ID'];
};


export type MutationResolveGeoAliasArgs = {
  id: Scalars['ID'];
  ignore?: Maybe<Scalars['Boolean']>;
  powiatId?: Maybe<Scalars['ID']>;
};


export type MutationReviewOperatorPageArgs = {
  intake?: Maybe<FundingIntakeInput>;
  operatorId: Scalars['ID'];
};


export type MutationConfirmFundingIntakeArgs = {
  confirmed: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationRetryFormSubmissionArgs = {
  id: Scalars['ID'];
};


export type MutationRunFundingTaskArgs = {
  dryRun?: Maybe<Scalars['Boolean']>;
  task: Scalars['String'];
};


export type MutationEnrollCareerMembersArgs = {
  directionId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  studentIds?: Maybe<Array<Scalars['ID']>>;
};


export type MutationSetCareerMembersAccessArgs = {
  memberIds: Array<Scalars['ID']>;
  removed: Scalars['Boolean'];
};


export type MutationUpdateCareerMemberArgs = {
  id: Scalars['ID'];
  input: CareerMemberInput;
};


export type MutationUpsertCareerLessonArgs = {
  id?: Maybe<Scalars['ID']>;
  input: CareerLessonInput;
};


export type MutationUploadCareerLessonVideoArgs = {
  lessonId: Scalars['ID'];
  video: Scalars['Upload'];
};


export type MutationClearCareerLessonVideoArgs = {
  lessonId: Scalars['ID'];
};


export type MutationAddCareerLessonAttachmentArgs = {
  file: Scalars['Upload'];
  lessonId: Scalars['ID'];
};


export type MutationRemoveCareerLessonAttachmentArgs = {
  attachmentId: Scalars['ID'];
};


export type MutationCompleteCareerLessonArgs = {
  artifactUrl?: Maybe<Scalars['String']>;
  lessonId: Scalars['ID'];
};


export type MutationMarkCareerLessonOpenedArgs = {
  lessonId: Scalars['ID'];
};


export type MutationSaveCareerLessonNotesArgs = {
  lessonId: Scalars['ID'];
  notes: Scalars['String'];
};


export type MutationSetCareerLessonBookmarkArgs = {
  isBookmarked: Scalars['Boolean'];
  lessonId: Scalars['ID'];
};


export type MutationSetCareerLessonQuizArgs = {
  lessonId: Scalars['ID'];
  questions: Array<CareerQuizQuestionInput>;
};


export type MutationSubmitCareerQuizArgs = {
  answers: Array<CareerQuizAnswerInput>;
  lessonId: Scalars['ID'];
};


export type MutationSaveCareerProfileArgs = {
  clearPhoto?: Maybe<Scalars['Boolean']>;
  input: CareerProfileInput;
  photo?: Maybe<Scalars['Upload']>;
};


export type MutationSaveCvTextArgs = {
  about?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  language: Scalars['String'];
};


export type MutationSetProfileSearchableArgs = {
  contactsVisible?: Maybe<Scalars['Boolean']>;
  isSearchable: Scalars['Boolean'];
};


export type MutationSetMySkillLevelArgs = {
  level: Scalars['Int'];
  skillId: Scalars['ID'];
};


export type MutationUpsertVacancyArgs = {
  id?: Maybe<Scalars['ID']>;
  input: VacancyInput;
};


export type MutationDeleteVacancyArgs = {
  id: Scalars['ID'];
};


export type MutationSetVacancyStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationBulkSetVacancyStatusArgs = {
  ids: Array<Scalars['ID']>;
  status: Scalars['String'];
};


export type MutationBulkPublishVacanciesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRecordPlacementArgs = {
  input: PlacementInput;
  memberId: Scalars['ID'];
};


export type MutationMarkVacancyInteractionArgs = {
  kind: Scalars['String'];
  vacancyId: Scalars['ID'];
};


export type MutationCreateCareerApplicationArgs = {
  input: CareerApplicationInput;
};


export type MutationUpdateCareerApplicationArgs = {
  id: Scalars['ID'];
  input: CareerApplicationInput;
};


export type MutationSetCareerApplicationStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationDeleteCareerApplicationArgs = {
  id: Scalars['ID'];
};


export type MutationUpsertCareerSkillArgs = {
  input: CareerSkillInput;
};


export type MutationSetCareerSkillActiveArgs = {
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
};


export type MutationMergeCareerSkillsArgs = {
  sourceId: Scalars['ID'];
  targetId: Scalars['ID'];
};


export type MutationSetCareerSkillIconArgs = {
  clear?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['Upload']>;
  id: Scalars['ID'];
};


export type MutationSetCourseSkillsArgs = {
  courseId: Scalars['ID'];
  rows: Array<CourseSkillInput>;
};


export type MutationSetGroupSkillsArgs = {
  groupId: Scalars['ID'];
  rows: Array<GroupSkillInput>;
};


export type MutationSetCourseCompletionArgs = {
  courseId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  studentId: Scalars['ID'];
};


export type MutationSyncStudentCourseSkillsArgs = {
  studentId: Scalars['ID'];
};


export type MutationSaveGrowthTrackArgs = {
  input: GrowthTrackInput;
};


export type MutationToggleGrowthTrackArgs = {
  isActive: Scalars['Boolean'];
  trackId: Scalars['ID'];
};


export type MutationSaveAchievementArgs = {
  input: AchievementInput;
};


export type MutationToggleAchievementArgs = {
  achievementId: Scalars['ID'];
  isActive: Scalars['Boolean'];
};


export type MutationSaveSiteCourseArgs = {
  input: SiteCourseInput;
};


export type MutationToggleSiteCourseArgs = {
  isActive: Scalars['Boolean'];
  siteCourseId: Scalars['ID'];
};


export type MutationSetCourseProgramArgs = {
  courseId: Scalars['ID'];
  modules: Array<ProgramModuleInput>;
};


export type MutationSaveCareerExerciseTemplateArgs = {
  fields: Array<CareerExerciseFieldInput>;
  intro?: Maybe<Scalars['String']>;
  outro?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
};


export type MutationToggleCareerExerciseTemplateArgs = {
  isActive: Scalars['Boolean'];
  templateId: Scalars['ID'];
};


export type MutationAttachCareerExerciseTemplateArgs = {
  lessonId: Scalars['ID'];
  templateId: Scalars['ID'];
};


export type MutationDetachCareerExerciseTemplateArgs = {
  lessonId: Scalars['ID'];
};


export type MutationResetCareerExerciseTemplateArgs = {
  confirm: Scalars['Boolean'];
  templateId: Scalars['ID'];
};


export type MutationSubmitCareerLessonExerciseArgs = {
  answers: Array<CareerExerciseAnswerInput>;
  lessonId: Scalars['ID'];
};


export type MutationChooseGrowthTrackArgs = {
  trackCode: Scalars['String'];
};


export type MutationUpsertPromoCampaignArgs = {
  input: PromoCampaignInput;
};


export type MutationSetPromoCampaignActiveArgs = {
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
};


export type MutationIssuePromoCodeArgs = {
  campaignId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationRevokePromoCodeArgs = {
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};


export type MutationRegisterShareArgs = {
  channel: Scalars['String'];
};


export type MutationUpsertShareTemplateArgs = {
  input: ShareTemplateInput;
};


export type MutationRevokeMcpConnectionArgs = {
  id: Scalars['ID'];
};


export type MutationUploadStudentDiplomaArgs = {
  file: Scalars['Upload'];
  groupId: Scalars['ID'];
  language: DiplomaLanguageEnum;
  replaceExisting?: Maybe<Scalars['Boolean']>;
  studentId: Scalars['ID'];
};


export type MutationDeleteStudentDiplomaArgs = {
  diplomaId: Scalars['ID'];
};


export type MutationMatchDiplomaFilesArgs = {
  fileNames: Array<Scalars['String']>;
  groupId: Scalars['ID'];
};


export type MutationSyncGroupSendgridListArgs = {
  groupId: Scalars['ID'];
};


export type MutationSendGroupTemplateEmailArgs = {
  groupId: Scalars['ID'];
  recipients: Array<MailRecipientInput>;
  subjectOverride?: Maybe<Scalars['String']>;
  templateId: Scalars['String'];
  templateName?: Maybe<Scalars['String']>;
};


export type MutationSubmitHomeworkArgs = {
  file?: Maybe<Scalars['Upload']>;
  githubUrl?: Maybe<Scalars['String']>;
  lessonId: Scalars['ID'];
};


export type MutationUpsertHomeworkAssignmentArgs = {
  dueDate?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  textbookRef?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type MutationGradeHomeworkArgs = {
  attempt?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  hwMark: Scalars['String'];
  lessonId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationRerunHomeworkAiReviewArgs = {
  submissionId: Scalars['ID'];
};


export type MutationCreateSurveyArgs = {
  input: SurveyInput;
};


export type MutationUpdateSurveyArgs = {
  id: Scalars['ID'];
  input: SurveyInput;
};


export type MutationArchiveSurveyArgs = {
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
};


export type MutationDuplicateSurveyArgs = {
  id: Scalars['ID'];
};


export type MutationAssignSurveyToGroupArgs = {
  groupId: Scalars['ID'];
  surveyId: Scalars['ID'];
  triggerLessonId: Scalars['ID'];
};


export type MutationAssignSurveyToGroupsArgs = {
  groupIds: Array<Scalars['ID']>;
  surveyId: Scalars['ID'];
  triggerKind: Scalars['String'];
  triggerLessonNumber?: Maybe<Scalars['Int']>;
};


export type MutationSetQuestionMetricsArgs = {
  items: Array<QuestionMetricInput>;
};


export type MutationUpdateSurveyAssignmentArgs = {
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  triggerLessonId?: Maybe<Scalars['ID']>;
};


export type MutationDeleteSurveyAssignmentArgs = {
  id: Scalars['ID'];
};


export type MutationSetSurveyTargetingArgs = {
  plans: Array<SurveyPlanInput>;
  surveyId: Scalars['ID'];
};


export type MutationSubmitSurveyResponseArgs = {
  answers: Array<SurveyAnswerInput>;
  assignmentId: Scalars['ID'];
};


export type MutationGenerateSurveyDigestArgs = {
  scope: Scalars['String'];
  scopeId: Scalars['ID'];
};


export type MutationCreateLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};


export type MutationLinkLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
  whiteboardId: Scalars['ID'];
};


export type MutationSaveWhiteboardSceneArgs = {
  expectedVersion: Scalars['Int'];
  sceneJson: Scalars['String'];
  whiteboardId: Scalars['ID'];
};


export type MutationSaveWhiteboardLibraryArgs = {
  expectedVersion: Scalars['Int'];
  itemsJson: Scalars['String'];
};


export type MutationUploadWhiteboardFileArgs = {
  file: Scalars['Upload'];
  fileId: Scalars['String'];
  mimeType?: Maybe<Scalars['String']>;
  whiteboardId: Scalars['ID'];
};


export type MutationRenameWhiteboardArgs = {
  name: Scalars['String'];
  whiteboardId: Scalars['ID'];
};


export type MutationUnlinkLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
};


export type MutationCreateMaterialArgs = {
  input: CreateMaterialInput;
};


export type MutationUpdateMaterialArgs = {
  id: Scalars['ID'];
  input: UpdateMaterialInput;
};


export type MutationDeleteMaterialArgs = {
  id: Scalars['ID'];
};


export type MutationSaveMailSignatureArgs = {
  mailboxEmail?: Maybe<Scalars['String']>;
  html: Scalars['String'];
};


export type MutationImportGmailSignatureArgs = {
  mailboxEmail: Scalars['String'];
};


export type MutationUploadEmailAttachmentArgs = {
  file: Scalars['Upload'];
};


export type MutationEmailAttachmentLinkArgs = {
  messageId: Scalars['ID'];
  index: Scalars['Int'];
};


export type MutationSyncCommunicationsNowArgs = {
  groupId?: Maybe<Scalars['ID']>;
};


export type MutationSendSlackMessageArgs = {
  conversationId: Scalars['ID'];
  seenMessageId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationSendSlackChannelMessageArgs = {
  groupId: Scalars['ID'];
  slackChannelId: Scalars['String'];
  text: Scalars['String'];
};


export type MutationStartSlackDmArgs = {
  groupId: Scalars['ID'];
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationSendGmailReplyArgs = {
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  conversationId: Scalars['ID'];
  html?: Maybe<Scalars['String']>;
  seenMessageId?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
};


export type MutationSendNewEmailArgs = {
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  html?: Maybe<Scalars['String']>;
  mailboxEmail: Scalars['String'];
  studentId?: Maybe<Scalars['ID']>;
  subject?: Maybe<Scalars['String']>;
  teacherId?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
  toEmail: Scalars['String'];
};


export type MutationBroadcastGroupMessageArgs = {
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  channel: Scalars['String'];
  groupId: Scalars['ID'];
  html?: Maybe<Scalars['String']>;
  mailboxEmail?: Maybe<Scalars['String']>;
  studentIds: Array<Scalars['ID']>;
  subject?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};


export type MutationLinkSlackUserArgs = {
  email?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  slackUserId: Scalars['String'];
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
};


export type MutationLinkChannelGroupArgs = {
  channelName?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  slackChannelId: Scalars['String'];
};


export type MutationMarkMessageReadArgs = {
  messageId: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
};


export type MutationFlagMessageArgs = {
  flagged?: Maybe<Scalars['Boolean']>;
  messageId: Scalars['ID'];
};


export type MutationSetMessageHandledArgs = {
  cascade?: Maybe<Scalars['Boolean']>;
  handled?: Maybe<Scalars['Boolean']>;
  messageId: Scalars['ID'];
};


export type MutationMarkConversationReadArgs = {
  conversationId: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
};


export type MutationMarkConversationsHandledArgs = {
  conversationId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  groupId?: Maybe<Scalars['ID']>;
  kinds?: Maybe<Array<Scalars['String']>>;
  scope: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  unhandledOnly?: Maybe<Scalars['Boolean']>;
};


export type MutationRevertMessagesTriageArgs = {
  handledMessageIds?: Maybe<Array<Scalars['ID']>>;
  readMessageIds?: Maybe<Array<Scalars['ID']>>;
};


export type MutationSetConversationStatusArgs = {
  conversationId: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationSetSlackWorkspaceArgs = {
  botToken?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  oauthClientId?: Maybe<Scalars['String']>;
  oauthClientSecret?: Maybe<Scalars['String']>;
  signingSecret?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  workspaceName?: Maybe<Scalars['String']>;
};


export type MutationSetMySlackUserTokenArgs = {
  groupId: Scalars['ID'];
  userToken: Scalars['String'];
};


export type MutationStartSlackUserOauthArgs = {
  groupId: Scalars['ID'];
};


export type MutationCreateTaskFromMessageArgs = {
  assigneeId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  groupId?: Maybe<Scalars['ID']>;
  messageId: Scalars['ID'];
  priority?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type MutationSetStaffMailboxArgs = {
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationCheckStaffMailboxArgs = {
  userId?: Maybe<Scalars['ID']>;
};


export type MutationCreatePlannedPaymentArgs = {
  input: PlannedPaymentInput;
};


export type MutationUpdatePlannedPaymentArgs = {
  input: UpdatePlannedPaymentInput;
};


export type MutationDeletePlannedPaymentArgs = {
  id: Scalars['ID'];
};


export type MutationSetCashBalanceArgs = {
  amountPln: Scalars['Float'];
  asOfDate: Scalars['Date'];
  comment?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['ID']>;
};


export type MutationSetExchangeRateArgs = {
  comment?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  effectiveFrom: Scalars['Date'];
  rateToPln: Scalars['Float'];
};


export type MutationSetPaymentCalendarSettingsArgs = {
  incomeOffsetDays?: Maybe<Scalars['Int']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  teacherPayoutDay?: Maybe<Scalars['Int']>;
};


export type MutationUploadBankStatementArgs = {
  accountSlug?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
  process?: Maybe<Scalars['Boolean']>;
  sheetName?: Maybe<Scalars['String']>;
};


export type MutationRollbackBankStatementImportArgs = {
  dryRun?: Maybe<Scalars['Boolean']>;
  importId: Scalars['ID'];
};


export type MutationUpdateCashFlowSettingsArgs = {
  internalTransferAutodetect?: Maybe<Scalars['Boolean']>;
  internalTransferWindowDays?: Maybe<Scalars['Int']>;
  ownPartyNames?: Maybe<Scalars['String']>;
};


export type MutationConfirmCashFlowRuleArgs = {
  categorySlug: Scalars['String'];
  retroactive?: Maybe<Scalars['Boolean']>;
  transactionId: Scalars['ID'];
};


export type MutationResolveCashFlowRuleConflictArgs = {
  categorySlug: Scalars['String'];
  strategy: Scalars['String'];
  transactionId: Scalars['ID'];
};


export type MutationUpdateCashFlowRuleArgs = {
  categorySlug?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  priority?: Maybe<Scalars['Int']>;
  resetHealth?: Maybe<Scalars['Boolean']>;
};


export type MutationDeleteCashFlowRuleArgs = {
  id: Scalars['ID'];
};


export type MutationSetBankTransactionCategoryArgs = {
  categorySlug?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  learn?: Maybe<Scalars['Boolean']>;
};


export type MutationSetBankTransactionCategoryBulkArgs = {
  categorySlug?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  learn?: Maybe<Scalars['Boolean']>;
};


export type MutationSetBankTransactionInternalArgs = {
  id: Scalars['ID'];
  isInternal: Scalars['Boolean'];
};


export type MutationClearBankTransactionReviewArgs = {
  id: Scalars['ID'];
};


export type MutationProcessUploadedStatementArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};


export type MutationRunCashFlowCategorizationArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};


export type MutationRunInternalTransferDetectionArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};


export type MutationSeedCashFlowRulesArgs = {
  dryRun?: Maybe<Scalars['Boolean']>;
};


export type MutationLinkBankTransactionArgs = {
  targetId: Scalars['ID'];
  targetType: Scalars['String'];
  transactionId: Scalars['ID'];
};


export type MutationUnlinkBankTransactionArgs = {
  linkId: Scalars['ID'];
};


export type MutationRunCashFlowMatchingArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};


export type MutationAddGatewaySettlementItemArgs = {
  invoiceId: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
  settlementId: Scalars['ID'];
};


export type MutationRemoveGatewaySettlementItemArgs = {
  itemId: Scalars['ID'];
};


export type MutationSetGatewaySettlementFeeArgs = {
  feeAmount: Scalars['Float'];
  settlementId: Scalars['ID'];
};


export type MutationMarkGatewaySettlementReconciledArgs = {
  notes: Scalars['String'];
  settlementId: Scalars['ID'];
};


export type MutationDetectGatewaySettlementsArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};


export type MutationReconcileGatewaySettlementsArgs = {
  dryRun?: Maybe<Scalars['Boolean']>;
  settlementIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


export type MutationCreateExpenseArgs = {
  input: ExpenseInput;
};


export type MutationUpdateExpenseArgs = {
  input: UpdateExpenseInput;
};


export type MutationSetExpenseStatusArgs = {
  id: Scalars['ID'];
  paidAt?: Maybe<Scalars['Date']>;
  status: Scalars['String'];
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['ID'];
};


export type MutationCreateExpenseCategoryArgs = {
  name: Scalars['String'];
  slug: Scalars['String'];
};


export type MutationIssueInvoiceForContributionArgs = {
  agreementId: Scalars['ID'];
  allowReissue?: Maybe<Scalars['Boolean']>;
  contributionId?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
  paymentTo?: Maybe<Scalars['Date']>;
};


export type MutationIssueInvoicesForGroupArgs = {
  agreementIds?: Maybe<Array<Scalars['ID']>>;
  expectedBillableCount?: Maybe<Scalars['Int']>;
  groupId: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
  paymentTo?: Maybe<Scalars['Date']>;
};


export type MutationIssueVatFromProformaArgs = {
  dryRun?: Maybe<Scalars['Boolean']>;
  invoiceId: Scalars['ID'];
};


export type MutationLinkProformaToContributionArgs = {
  contributionId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type MutationUnlinkProformaFromContributionArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationLinkInvoiceToContributionArgs = {
  contributionId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type MutationUnlinkInvoiceFromContributionArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationRerunFakturowniaMatcherArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationTriggerFakturowniaSyncArgs = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  period?: Maybe<Scalars['String']>;
};


export type MutationTriggerFakturowniaGroupSyncArgs = {
  groupId: Scalars['ID'];
  period?: Maybe<Scalars['String']>;
};


export type MutationLinkFakturowniaInvoiceToPaymentArgs = {
  invoiceId: Scalars['ID'];
  paymentId: Scalars['ID'];
};


export type MutationCreatePaymentForFakturowniaInvoiceArgs = {
  agreementId: Scalars['ID'];
  invoiceId: Scalars['ID'];
  paymentDate?: Maybe<Scalars['Date']>;
};


export type MutationUnlinkFakturowniaInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationMatchFakturowniaInvoiceArgs = {
  groupId?: Maybe<Scalars['ID']>;
  invoiceId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationSetFakturowniaInvoiceGroupArgs = {
  groupId?: Maybe<Scalars['ID']>;
  invoiceId: Scalars['ID'];
};


export type MutationProvisionStudentsArgs = {
  contributionAmount: Scalars['Float'];
  currency: Scalars['String'];
  documents: Array<ProvisionDocOverrideInput>;
  groupId: Scalars['ID'];
};


export type MutationReparsePandadocRecipientsArgs = {
  markRefetch?: Maybe<Scalars['Boolean']>;
};


export type MutationLinkPandadocDocumentArgs = {
  agreementId: Scalars['ID'];
  pandadocId: Scalars['String'];
};


export type MutationUnlinkPandadocDocumentArgs = {
  pandadocId: Scalars['String'];
};


export type MutationLinkPandadocTeacherArgs = {
  pandadocId: Scalars['String'];
  teacherId: Scalars['ID'];
};


export type MutationUnlinkPandadocTeacherArgs = {
  pandadocId: Scalars['String'];
};


export type MutationSyncZoomRecordingsArgs = {
  date: Scalars['Date'];
};


export type MutationSyncAllZoomRecordingsArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
};


export type MutationRefreshAllZoomDataArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
};


export type MutationRunAutoMatchingArgs = {
  date: Scalars['Date'];
};


export type MutationTriggerZoomGroupProcessArgs = {
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  groupId: Scalars['ID'];
};


export type MutationSetGroupZoomAccountArgs = {
  groupId: Scalars['ID'];
  zoomAccountId?: Maybe<Scalars['ID']>;
};


export type MutationSetGroupZoomScheduleArgs = {
  groupId: Scalars['ID'];
  slots: Array<GroupZoomScheduleSlotInput>;
  zoomAccountId?: Maybe<Scalars['ID']>;
};


export type MutationCreateManualLessonRecordingArgs = {
  lessonId: Scalars['ID'];
  zoomRecordingId: Scalars['ID'];
};


export type MutationUnlinkLessonRecordingArgs = {
  id: Scalars['ID'];
};


export type MutationMarkLessonMissingRecordingArgs = {
  lessonId: Scalars['ID'];
};


export type MutationRetryLessonRecordingArgs = {
  id: Scalars['ID'];
};


export type MutationReprocessAiArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteZoomRecordingArgs = {
  confirm: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationDeleteZoomRecordingsArgs = {
  confirm: Scalars['Boolean'];
  ids: Array<Scalars['ID']>;
};


export type MutationSendMorningReportArgs = {
  date?: Maybe<Scalars['Date']>;
};


export type MutationCreateGroupArgs = {
  groupInput: GroupInput;
  moduleInput: Array<Maybe<ModuleInput>>;
};


export type MutationUpdateGroupArgs = {
  groupId: Scalars['Int'];
  groupInput: UpdateGroupInput;
};


export type MutationDeleteGroupArgs = {
  groupId: Scalars['Int'];
};


export type MutationPublishGroupArgs = {
  groupId: Scalars['ID'];
  publishedForTeachers?: Maybe<Scalars['Boolean']>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist?: Maybe<Scalars['Boolean']>;
};


export type MutationChangeLessonDatesArgs = {
  groupId: Scalars['Int'];
  newDate: Scalars['Date'];
  oldDate: Scalars['Date'];
};


export type MutationUploadLessonVideoArgs = {
  lessonId: Scalars['Int'];
  videoUrl: Scalars['String'];
};


export type MutationCancelVideoUploadArgs = {
  lessonId: Scalars['Int'];
};


export type MutationSetGroupLessonLinkArgs = {
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
};


export type MutationSetGroupLessonLinkOverrideArgs = {
  date?: Maybe<Scalars['Date']>;
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
};


export type MutationClearGroupLessonLinkOverrideArgs = {
  date: Scalars['Date'];
  groupId: Scalars['Int'];
};


export type MutationLmsJoinLessonArgs = {
  groupLessonId: Scalars['Int'];
};


export type MutationLmsSetTodayLessonLinkArgs = {
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
};


export type MutationLmsClearTodayLessonLinkArgs = {
  groupId: Scalars['Int'];
};


export type MutationCreateLeadArgs = {
  leadInput: LeadInput;
};


export type MutationCreateBlackFridayLeadArgs = {
  bfLeadInput: BlackFridayLeadInput;
};


export type MutationCreateNewYearLeadArgs = {
  nyLeadInput: NewYearLeadInput;
};


export type MutationUpdateJournalArgs = {
  comment: Scalars['String'];
  daysOfClass: Array<DayOfClassInput>;
  groupId: Scalars['Int'];
  modules: Array<Maybe<UpdateModuleInput>>;
};


export type MutationUpdateAttendanceArgs = {
  attendance: Scalars['Boolean'];
  attendanceId: Scalars['Int'];
};


export type MutationLmsSetAttendanceArgs = {
  attendance: Scalars['Boolean'];
  attendanceId: Scalars['Int'];
};


export type MutationFinishLmsLessonArgs = {
  attendances?: Maybe<Array<LmsAttendanceType>>;
  comment: Scalars['String'];
  groupLessonId: Scalars['Int'];
};


export type MutationSetStudentsMarksArgs = {
  date: Scalars['Date'];
  lessonId: Scalars['Int'];
  studentsMarks: Array<Maybe<LessonMarkInput>>;
  taskType: LessonTaskTypeEnum;
};


export type MutationCreateCourseArgs = {
  name?: Maybe<Scalars['String']>;
};


export type MutationUpdateCourseArgs = {
  courseId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};


export type MutationDeleteCourseArgs = {
  courseId?: Maybe<Scalars['ID']>;
};


export type MutationCreateTeacherBillingEntityArgs = {
  input: TeacherBillingEntityInput;
  teacherId: Scalars['ID'];
};


export type MutationUpdateTeacherBillingEntityArgs = {
  id: Scalars['ID'];
  input: TeacherBillingEntityInput;
};


export type MutationSetDefaultTeacherBillingEntityArgs = {
  id: Scalars['ID'];
};


export type MutationSetApplicationFinanceTermsArgs = {
  applicationId: Scalars['ID'];
  billingEntityId?: Maybe<Scalars['ID']>;
  clearBillingEntity?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['String']>;
  rateIsGross?: Maybe<Scalars['Boolean']>;
  rateUnit?: Maybe<Scalars['String']>;
  servicePrice?: Maybe<Scalars['Float']>;
};


export type MutationUploadTeacherDocumentArgs = {
  file: Scalars['Upload'];
  kind?: Maybe<Scalars['String']>;
  teacherId: Scalars['ID'];
};


export type MutationSetTeacherDocumentTextArgs = {
  documentId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationDeleteTeacherDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationRunTeacherDocumentAnalysisArgs = {
  documentId: Scalars['ID'];
};


export type MutationRunTeacherInterviewAnalysisArgs = {
  interviewId: Scalars['ID'];
};


export type MutationRecomputeTeacherAiProfileArgs = {
  teacherId: Scalars['ID'];
};


export type MutationApplyTeacherCourseSuggestionsArgs = {
  action: Scalars['String'];
  suggestionIds: Array<Scalars['ID']>;
  teacherId: Scalars['ID'];
};


export type MutationAttachTeacherInterviewZoomArgs = {
  teacherId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  zoomRecordingId: Scalars['ID'];
};


export type MutationAttachTeacherInterviewLinkArgs = {
  recordedAt?: Maybe<Scalars['DateTime']>;
  teacherId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};


export type MutationUploadTeacherInterviewVideoArgs = {
  file: Scalars['Upload'];
  recordedAt?: Maybe<Scalars['DateTime']>;
  teacherId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};


export type MutationSetTeacherInterviewTranscriptArgs = {
  interviewId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationRetryTeacherInterviewDownloadArgs = {
  interviewId: Scalars['ID'];
};


export type MutationDeleteTeacherInterviewArgs = {
  interviewId: Scalars['ID'];
};


export type MutationRefreshInterviewZoomRecordingsArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
};


export type MutationCreateUniqueTeacherArgs = {
  application: ApplicationInputType;
  employmentTypes: EmploymentInputType;
  teacher: NewTeacherInput;
};


export type MutationAddTeacherRoleArgs = {
  application: ApplicationInputType;
  employmentTypes: EmploymentInputType;
  siteDisplay?: Maybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};


export type MutationAddTeacherExistArgs = {
  application: ApplicationInputType;
  employmentTypes: ExistEmploymentInputType;
  teacherId: Scalars['ID'];
};


export type MutationAddTeacherApplicationArgs = {
  application: ApplicationInputType;
  teacherId: Scalars['ID'];
};


export type MutationUpdateTeacherApplicationArgs = {
  application: UpdateApplicationInputType;
};


export type MutationDeleteTeacherApplicationArgs = {
  applicationId: Scalars['ID'];
};


export type MutationUpdateTeacherWithTypeArgs = {
  employmentInput: ExistEmploymentInputType;
  teacherId?: Maybe<Scalars['ID']>;
  teacherInput: TeacherWithTypeInput;
};


export type MutationSetTeacherProfileArgs = {
  coursesCanTeachIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  internalNote?: Maybe<Scalars['String']>;
  interviewRecording?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  teacherId: Scalars['ID'];
};


export type MutationCreateTeacherArgs = {
  teacher: NewTeacherInput;
};


export type MutationCreateStaffTaskArgs = {
  files?: Maybe<Array<Maybe<Scalars['Upload']>>>;
  input: CreateStaffTaskInput;
};


export type MutationUpdateStaffTaskArgs = {
  input: UpdateStaffTaskInput;
};


export type MutationUpdateTaskStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationDeleteStaffTaskArgs = {
  id: Scalars['ID'];
};


export type MutationMoveStaffTaskArgs = {
  input: MoveStaffTaskInput;
};


export type MutationAddStaffTaskLinksArgs = {
  links: Array<TaskLinkInput>;
  taskId: Scalars['ID'];
};


export type MutationRemoveStaffTaskLinkArgs = {
  linkId: Scalars['ID'];
};


export type MutationAddStaffTaskCommentArgs = {
  body?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Maybe<Scalars['Upload']>>>;
  taskId: Scalars['ID'];
};


export type MutationAddStaffTaskAttachmentArgs = {
  commentId?: Maybe<Scalars['ID']>;
  file: Scalars['Upload'];
  taskId: Scalars['ID'];
};


export type MutationRemoveStaffTaskAttachmentArgs = {
  attachmentId: Scalars['ID'];
};


export type MutationEditStaffTaskCommentArgs = {
  body: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationDeleteStaffTaskCommentArgs = {
  id: Scalars['ID'];
};


export type MutationCreateStudentNoteArgs = {
  input: CreateStudentNoteInput;
};


export type MutationUpdateStudentNoteArgs = {
  input: UpdateStudentNoteInput;
};


export type MutationDeleteStudentNoteArgs = {
  id: Scalars['ID'];
};


export type MutationSaveLmsBlockSettingsArgs = {
  input: LmsBlockSettingsInput;
};


export type MutationSendLmsBlockTestEmailArgs = {
  kind: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
};


export type MutationBlockStudentLmsAccessArgs = {
  notifyStudent?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
};


export type MutationUnblockStudentLmsAccessArgs = {
  notifyStudent?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationDeletePaymentArgs = {
  id: Scalars['ID'];
};


export type MutationLinkContributionToPaymentArgs = {
  input: LinkContributionInput;
};


export type MutationUnlinkContributionArgs = {
  contributionId: Scalars['ID'];
};


export type MutationZeroOutContributionArgs = {
  contributionId: Scalars['ID'];
};


export type MutationMarkContributionPaidManuallyArgs = {
  amount?: Maybe<Scalars['Float']>;
  contributionId: Scalars['ID'];
  date: Scalars['Date'];
  note?: Maybe<Scalars['String']>;
};


export type MutationRevertManualContributionPaymentArgs = {
  contributionId: Scalars['ID'];
};


export type MutationCreatePaymentCorrectionArgs = {
  input: CreatePaymentCorrectionInput;
};


export type MutationUpdatePaymentCorrectionArgs = {
  input: UpdatePaymentCorrectionInput;
};


export type MutationDeletePaymentCorrectionArgs = {
  id: Scalars['ID'];
};


export type MutationCreatePaymentsArgs = {
  paymentsInput?: Maybe<Array<Maybe<PaymentInput>>>;
};


export type MutationCreateDeferredPaymentsArgs = {
  deferredPaymentsInput?: Maybe<Array<Maybe<DeferredPaymentInput>>>;
};


export type MutationCheckStudentDebtArgs = {
  agreementsInput: Array<Maybe<Scalars['String']>>;
};


export type MutationRemindDebtorsArgs = {
  agreementTitles: Array<Scalars['String']>;
};


export type MutationUpdateStudentWithAgreementArgs = {
  agreementId?: Maybe<Scalars['ID']>;
  updateStudentInput: UpdateStudentInput;
};


export type MutationCreateStudentWithAgreementArgs = {
  agreementInput: CreateAgreementInputBase;
  studentInput: StudentInput;
};


export type MutationAppendStudentRoleAndAgreementArgs = {
  agreementInput: CreateAgreementInputBase;
  userId: Scalars['ID'];
};


export type MutationAppendStudentToGroupArgs = {
  agreementInput: CreateAgreementInputBase;
  studentId: Scalars['ID'];
};


export type MutationLmsStudentSignUpArgs = {
  studentInput: StudentSignUpInput;
};


export type MutationCreateAgreementArgs = {
  agreementInput: CreateAgreementInput;
};


export type MutationCreateCompanyArgs = {
  companyInput: CompanyInput;
};


export type MutationUpdateCompanyArgs = {
  companyId: Scalars['ID'];
  companyInput: UpdateCompanyInput;
};


export type MutationChangeAgreementGroupArgs = {
  input: ChangeAgreementGroupInput;
};


export type MutationTerminateAgreementArgs = {
  agreementId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  terminatedDate?: Maybe<Scalars['Date']>;
  terminatedReason?: Maybe<TerminatedReasonEnum>;
};


export type MutationRestoreCourseAccessArgs = {
  agreementId: Scalars['ID'];
};


export type MutationSetAgreementTransferOutArgs = {
  agreementId: Scalars['ID'];
  transferOut: Scalars['Boolean'];
};


export type MutationSetAgreementFreeOfChargeArgs = {
  agreementId: Scalars['ID'];
  freeOfCharge: Scalars['Boolean'];
};


export type MutationSetAgreementStatePrefinancedArgs = {
  agreementId: Scalars['ID'];
  statePrefinanced: Scalars['Boolean'];
};


export type MutationCorrectAgreementGroupArgs = {
  agreementId: Scalars['ID'];
  groupId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationUndoEnrollmentArgs = {
  agreementId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationCreateUserArgs = {
  middleName?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  roles: Scalars['String'];
  phone: Scalars['String'];
  workspaceEmail?: Maybe<Scalars['String']>;
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendLmsAuthEmailArgs = {
  authenticationInput: LmsAuthenticationInput;
};


export type MutationPasswordResetArgs = {
  token: Scalars['String'];
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
};


export type MutationPasswordSetArgs = {
  token: Scalars['String'];
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
};


export type MutationCustomLoginArgs = {
  password?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  scope: Scalars['String'];
  authenticationCode?: Maybe<Scalars['String']>;
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String'];
};


export type MutationRefreshTokenArgs = {
  activeRole?: Maybe<LmsRoles>;
  refreshToken: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
};


export type MutationRevokeTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationDemoCustomLoginArgs = {
  password?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  scope: Scalars['String'];
  authenticationCode?: Maybe<Scalars['String']>;
};


export type MutationUpdateUserSettingsArgs = {
  userId?: Maybe<Scalars['ID']>;
  userSettingsInput: CustomUserInput;
};


export type MutationDeleteUserSettingsArgs = {
  userId?: Maybe<Scalars['ID']>;
};


export type MutationAppendRolesUserSettingsArgs = {
  roles: Scalars['String'];
  userId: Scalars['ID'];
};

/** С нуля (текст по умолчанию вида × области) или копией `basedOnId`. */
export type CreateDocumentTemplate = {
  __typename?: 'CreateDocumentTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<DocumentTemplateType>;
  problems: Array<ContractTemplateProblemType>;
};

/** Название и/или новый текст (версия +1, она же текущая). */
export type SaveDocumentTemplate = {
  __typename?: 'SaveDocumentTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<DocumentTemplateType>;
  problems: Array<ContractTemplateProblemType>;
};

export type SetDocumentTemplateActive = {
  __typename?: 'SetDocumentTemplateActive';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<DocumentTemplateType>;
  problems: Array<ContractTemplateProblemType>;
};

/** Откат: сделать текущей одну из прежних версий шаблона. */
export type ActivateDocumentTemplateVersion = {
  __typename?: 'ActivateDocumentTemplateVersion';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<DocumentTemplateType>;
  problems: Array<ContractTemplateProblemType>;
};

/** Выпуск: номер, запись журнала и PDF (base64, файл не хранится). */
export type IssueDocument = {
  __typename?: 'IssueDocument';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  issuedDocument?: Maybe<IssuedDocumentType>;
  file?: Maybe<DocumentFileType>;
  missingFields: Array<DocumentMissingFieldType>;
  /** Напечатаны пустыми: вам их видеть нельзя (PESEL) */
  hiddenFields: Array<DocumentMissingFieldType>;
};

/**
 * ТЗ 0112 §4: письмо с PDF выданного документа — ТОЛЬКО по явному
 * нажатию «Отправить» (выпуск сам ничего не шлёт). Путь «нового письма»
 * коммуникатора: ящик школы, письмо в переписке студента.
 */
export type SendIssuedDocument = {
  __typename?: 'SendIssuedDocument';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  issuedDocument?: Maybe<IssuedDocumentType>;
  send?: Maybe<IssuedDocumentSendType>;
  conversationId?: Maybe<Scalars['ID']>;
};

export type AiSkillInput = {
  id?: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  instructions: Scalars['String'];
  /** null — keep the files; a list — replace them all */
  files?: Maybe<Array<AiSkillFileInput>>;
  /** Optimistic concurrency: the version the editor loaded. Stored version differs — refusal `conflict` (reload and merge). null — no check. */
  expectedVersion?: Maybe<Scalars['Int']>;
};

export type AiSkillFileInput = {
  path: Scalars['String'];
  text: Scalars['String'];
};


export type AiMcpConnectionInput = {
  id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  /** https on a public host; no user:pass@. The URL is shown on screen and in the audit log — never put a token into its path or query (use authType=header + secret). Any change of the target (URL, transport, authType, headerName) clears the secret, OAuth, allowPii, enabled and tool approvals. */
  url: Scalars['String'];
  transport: Scalars['String'];
  authType: Scalars['String'];
  headerName?: Maybe<Scalars['String']>;
  /** Write-only: null — keep, "" — clear, text — replace */
  secret?: Maybe<Scalars['String']>;
  allowPii: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
};

export type AiMcpToolSettingInput = {
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
  requiresApproval: Scalars['Boolean'];
};

export type AiChatMentionInput = {
  kind: Scalars['String'];
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
};

export type AiLessonBatchResultType = {
  __typename?: 'AiLessonBatchResultType';
  /** In request order */
  items: Array<AiLessonBatchItemType>;
  /** New runs created by this request (outcome=started) */
  started: Scalars['Int'];
  refused: Scalars['Int'];
};

export type AiLessonBatchItemType = {
  __typename?: 'AiLessonBatchItemType';
  lessonId: Scalars['ID'];
  /** Queued / running / cached analysis; null on refusal */
  analysis?: Maybe<AiLessonAnalysisType>;
  /** Refusal code: not_found | no_transcript | already_running | budget_exceeded | ai_disabled | internal_error */
  refusal?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  /** started (new run) | cached (finished analysis returned, no run) | running (live analysis returned) | refused */
  outcome: Scalars['String'];
  /** The existing finished analysis was returned — no model call */
  cached: Scalars['Boolean'];
};

export type AiTeacherNarrativeType = {
  __typename?: 'AiTeacherNarrativeType';
  id: Scalars['ID'];
  teacherId: Scalars['ID'];
  /** queued | running | ready | failed */
  status: Scalars['String'];
  /** pl; null until ready */
  text?: Maybe<Scalars['String']>;
  analysesCount: Scalars['Int'];
  model?: Maybe<Scalars['String']>;
  /** Admin only; null else */
  costUsd?: Maybe<Scalars['Float']>;
  /** Error CODE of a failed narrative */
  error?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  /** The latest ready narrative already covers exactly these analyses — returned as is, no model call */
  unchanged: Scalars['Boolean'];
};

/**
 * Записать значение ключа. Значение совпадает с текущим — `changed:
 * false`, журнал не пишется.
 */
export type SetRuntimeSetting = {
  __typename?: 'SetRuntimeSetting';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  setting?: Maybe<RuntimeSettingType>;
  changed?: Maybe<Scalars['Boolean']>;
};

/** Снять значение «Настроек» — снова действует env. */
export type ClearRuntimeSetting = {
  __typename?: 'ClearRuntimeSetting';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  setting?: Maybe<RuntimeSettingType>;
  changed?: Maybe<Scalars['Boolean']>;
};

/** Выключить беспризорную строку `PeriodicTask` (нет в `beat_schedule`). */
export type DisableOrphanPeriodicTask = {
  __typename?: 'DisableOrphanPeriodicTask';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  orphan?: Maybe<OrphanPeriodicTaskType>;
  changed?: Maybe<Scalars['Boolean']>;
};

export type OutputMarketingSeoSettings = {
  __typename?: 'OutputMarketingSeoSettings';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  settings?: Maybe<MarketingSeoSettingsType>;
  domains?: Maybe<Array<MarketingSeoDomainType>>;
};

export type MarketingSeoSettingsInput = {
  ownDomain?: Maybe<Scalars['String']>;
  locationCode?: Maybe<Scalars['Int']>;
  languageCode?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  serpDepth?: Maybe<Scalars['Int']>;
  maxTracked?: Maybe<Scalars['Int']>;
  aiRepeats?: Maybe<Scalars['Int']>;
  minGapVolume?: Maybe<Scalars['Int']>;
  /** Целиком (заменяет список): регулярка или слово; пустые строки отбрасываются */
  excludedTopics?: Maybe<Array<Scalars['String']>>;
  /** Целиком не нужен: строки без id — новые или по имени домена */
  domains?: Maybe<Array<MarketingSeoDomainInput>>;
};

export type MarketingSeoDomainInput = {
  id?: Maybe<Scalars['ID']>;
  domain: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  brandRegex?: Maybe<Scalars['String']>;
  /** Удалить (свой — нельзя) */
  delete?: Maybe<Scalars['Boolean']>;
};

export type OutputMarketingSeoKeyword = {
  __typename?: 'OutputMarketingSeoKeyword';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  id?: Maybe<Scalars['ID']>;
  tracked?: Maybe<Scalars['Boolean']>;
  excluded?: Maybe<Scalars['Boolean']>;
};

export type OutputMarketingSeoKeywordsAdded = {
  __typename?: 'OutputMarketingSeoKeywordsAdded';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  added?: Maybe<Scalars['Int']>;
  existing?: Maybe<Scalars['Int']>;
  tracked?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Array<Scalars['String']>>;
};

export type OutputMarketingSeoQuestion = {
  __typename?: 'OutputMarketingSeoQuestion';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  question?: Maybe<MarketingSeoQuestionType>;
};

export type MarketingSeoQuestionInput = {
  id?: Maybe<Scalars['ID']>;
  familySlug?: Maybe<Scalars['String']>;
  group: Scalars['String'];
  textPl: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<Scalars['Int']>;
};

export type OutputMarketingSeoQuestionDeleted = {
  __typename?: 'OutputMarketingSeoQuestionDeleted';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  /** false — у вопроса есть ответы, он выключен */
  deleted?: Maybe<Scalars['Boolean']>;
};

export type OutputMarketingSeoOpportunities = {
  __typename?: 'OutputMarketingSeoOpportunities';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  updated?: Maybe<Scalars['Int']>;
  opportunities?: Maybe<Array<MarketingSeoOpportunity>>;
};

export type OutputMarketingSeoRun = {
  __typename?: 'OutputMarketingSeoRun';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  estimate?: Maybe<MarketingSeoEstimate>;
  queued?: Maybe<Scalars['Boolean']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};

export type OutputMarketingRefresh = {
  __typename?: 'OutputMarketingRefresh';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  /** Источники, чей сбор поставлен */
  queued: Array<Scalars['String']>;
  skipped: Array<MarketingRefreshSkip>;
  /** Пересборка продаж и сводок поставлена */
  rebuildQueued: Scalars['Boolean'];
};

export type MarketingRefreshSkip = {
  __typename?: 'MarketingRefreshSkip';
  source: Scalars['String'];
  /** running — сбор уже идёт | disabled — источник выключен (MARKETING_SOURCE_MODE) */
  reason: Scalars['String'];
};

export type OutputMarketingChannelRule = {
  __typename?: 'OutputMarketingChannelRule';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  rule?: Maybe<MarketingChannelRuleType>;
};

export type MarketingChannelRuleInput = {
  id?: Maybe<Scalars['ID']>;
  priority: Scalars['Int'];
  field: Scalars['String'];
  match: Scalars['String'];
  pattern: Scalars['String'];
  channel: MarketingChannel;
  subChannel: Scalars['String'];
  isPaid: Scalars['Boolean'];
  active: Scalars['Boolean'];
  note: Scalars['String'];
};

/** `success` + `customErrors { field code message }`. */
export type OutputMarketingOk = {
  __typename?: 'OutputMarketingOk';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type OutputMarketingCourseFamily = {
  __typename?: 'OutputMarketingCourseFamily';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  family?: Maybe<MarketingCourseFamilyType>;
};

export type MarketingCourseFamilyInput = {
  id?: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
  name: Scalars['String'];
  isSold: Scalars['Boolean'];
  sort: Scalars['Int'];
};

export type OutputMarketingCourseAlias = {
  __typename?: 'OutputMarketingCourseAlias';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  alias?: Maybe<MarketingCourseAliasType>;
};

export type MarketingCourseAliasInput = {
  id?: Maybe<Scalars['ID']>;
  familyId: Scalars['ID'];
  kind: Scalars['String'];
  value: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
  priority: Scalars['Int'];
};

export type OutputMarketingOfferRule = {
  __typename?: 'OutputMarketingOfferRule';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  rule?: Maybe<MarketingOfferRuleType>;
};

export type MarketingOfferRuleInput = {
  id?: Maybe<Scalars['ID']>;
  priority: Scalars['Int'];
  field: Scalars['String'];
  regex: Scalars['String'];
  offer: Scalars['String'];
};

/**
 * Ручная правка продажи (только Admin). Пустое поле — «не править»;
 * `clear: true` снимает правку целиком.
 */
export type MarketingSaleOverrideInput = {
  source: Scalars['String'];
  sourceId: Scalars['String'];
  isSale?: Maybe<Scalars['Boolean']>;
  familySlug?: Maybe<Scalars['String']>;
  pricePln?: Maybe<Scalars['Decimal']>;
  kind?: Maybe<Scalars['String']>;
  note: Scalars['String'];
  clear?: Maybe<Scalars['Boolean']>;
};

/**
 * Строка плана: месяц × канал (пусто — все) × семейство (пусто — все)
 * × показатель. `clear: true` удаляет строку.
 */
export type MarketingTargetInput = {
  month: Scalars['Date'];
  channel?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  /** crm_leads | sales | revenue_pln | spend_pln | cpl_pln | cost_per_sale_pln */
  metric: Scalars['String'];
  value?: Maybe<Scalars['Decimal']>;
  note?: Maybe<Scalars['String']>;
  clear?: Maybe<Scalars['Boolean']>;
};

export type OutputMarketingCampaignAlias = {
  __typename?: 'OutputMarketingCampaignAlias';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  alias?: Maybe<MarketingCampaignAliasType>;
};

/** Ручное сопоставление метки CRM с кампанией площадки (точное). */
export type MarketingCampaignAliasInput = {
  id?: Maybe<Scalars['ID']>;
  /** meta | google_ads */
  platform: Scalars['String'];
  /** utm_campaign | utm_id */
  field: Scalars['String'];
  rawValue: Scalars['String'];
  /** id AdEntity кампании */
  entityId: Scalars['ID'];
};

export type OutputMarketingSearchSettings = {
  __typename?: 'OutputMarketingSearchSettings';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  brandRegex?: Maybe<Scalars['String']>;
  ga4KeyEvents?: Maybe<Array<Scalars['String']>>;
  siteHosts?: Maybe<Array<Scalars['String']>>;
};

/**
 * Правило «сигнал → задача»: виды, важность не ниже, исполнители (по
 * кругу; только те, кто видит задачи ERP). Пустые виды или люди —
 * маршрут выключен.
 */
export type MarketingSignalRoutingInput = {
  kinds: Array<Scalars['String']>;
  minSeverity: Scalars['String'];
  assigneeIds: Array<Scalars['ID']>;
};

export type OutputMarketingPageTypes = {
  __typename?: 'OutputMarketingPageTypes';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  rules?: Maybe<Array<MarketingPageTypeRule>>;
  changed?: Maybe<Scalars['Boolean']>;
};

export type MarketingPageTypeRuleInput = {
  type: Scalars['String'];
  regex: Scalars['String'];
};

/** Заказать выгрузку данных для P&L. Файл собирается в фоне. */
export type RequestPnlExportMutation = {
  __typename?: 'RequestPnlExportMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  run?: Maybe<PnlExportRunType>;
};

/** Поставить в очередь забор участников группы за окно дат. */
export type RequestZoomParticipantsSyncMutation = {
  __typename?: 'RequestZoomParticipantsSyncMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued?: Maybe<Scalars['Boolean']>;
};

/**
 * Ручное решение по участнику: привязать к человеку, игнорировать или
 * сбросить. Применяется ко всем заходам той же личности в проведении.
 */
export type MatchZoomParticipantMutation = {
  __typename?: 'MatchZoomParticipantMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  sessions?: Maybe<Array<ZoomParticipantSessionType>>;
  aliasCreated?: Maybe<Scalars['Boolean']>;
};

/**
 * Закрепить проведение за занятием (решение оператора).
 * 
 * `instanceUuid` — конкретное проведение (из кандидатов или из Zoom);
 * `meetingId` — все проведения встречи в окне занятия.
 */
export type LinkZoomInstanceToLessonMutation = {
  __typename?: 'LinkZoomInstanceToLessonMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  instances?: Maybe<Array<ZoomMeetingInstanceType>>;
  queued?: Maybe<Scalars['Boolean']>;
};

/**
 * Отвязать проведение от занятия. Оно закрепляется как «ничьё»:
 * авто-сопоставление его больше не привяжет.
 */
export type UnlinkZoomInstanceMutation = {
  __typename?: 'UnlinkZoomInstanceMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Сохранить общие настройки писем. Часы — 0…23 (`invalid_hour`), адреса
 * — корректный email или пусто (`invalid_email`). Строка перечитывается под
 * `select_for_update`: параллельное сохранение других полей не затирается.
 */
export type SaveFundingMailSettingsMutation = {
  __typename?: 'SaveFundingMailSettingsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  mailSettings?: Maybe<FundingMailSettingsType>;
};

/**
 * Частичное сохранение: не переданное поле не меняется. Пустая строка в
 * адресе или имени — «как на сервере».
 */
export type FundingMailSettingsInput = {
  paused?: Maybe<Scalars['Boolean']>;
  fromEmail?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Scalars['String']>;
  soonSendHour?: Maybe<Scalars['Int']>;
  runningSendHour?: Maybe<Scalars['Int']>;
};

/**
 * Создать правило «за N дней» или изменить любое.
 * 
 * Проверки: срок 0…90 и не занят другим правилом (`invalid_offset`,
 * `offset_taken`); «набор идёт» — раз в 1…30 дней (`invalid_every`);
 * включить можно только с шаблоном (`template_required`); новый шаблон
 * обязан существовать в SendGrid (`template_not_found`), его имя и тема
 * копируются оттуда; SendGrid недоступен — ничего не сохраняется.
 * 
 * 🔴 Код правила не меняется никогда: смена срока «7 → 5» не шлёт повторно
 * тем, кому уже писали «за 7».
 */
export type SaveFundingMailRuleMutation = {
  __typename?: 'SaveFundingMailRuleMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  rule?: Maybe<FundingMailRuleType>;
};

/**
 * Без `id` — новое правило; завести можно только «за N дней»
 * (`kind: intake_soon` + `offsetDays`). Имя шаблона не принимается — оно
 * читается из SendGrid. `templateId: ""` снимает шаблон (и выключает
 * правило).
 */
export type FundingMailRuleInput = {
  id?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
  offsetDays?: Maybe<Scalars['Int']>;
  everyDays?: Maybe<Scalars['Int']>;
  templateId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
};

/**
 * Удалить правило «за N дней» (`cannot_delete` для остальных — их только
 * выключают). Журнал писем остаётся: у строк правило обнуляется, шаблон и
 * переменные сохранены снимком.
 */
export type DeleteFundingMailRuleMutation = {
  __typename?: 'DeleteFundingMailRuleMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deletedId?: Maybe<Scalars['ID']>;
};

/**
 * Отправить шаблон правила на адрес вызывающего сотрудника (или на
 * DOFIN_MAIL_TEST_RECIPIENT). Данные — выбранного окна набора, без окна —
 * пример из справочника переменных. Ссылки уходят как есть, без
 * сокращения. Нужен DOFIN_MAIL_ENABLED (`disabled_on_server`); пауза ERP
 * тесту не мешает. Строки в журнале писем не пишет.
 */
export type SendFundingMailTestMutation = {
  __typename?: 'SendFundingMailTestMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  sentTo?: Maybe<Scalars['String']>;
};

/**
 * SMS кандидату дофинансирования — свой текст или шаблон, любая ссылка.
 * Повтор того же `requestKey` — та же SMS.
 */
export type SendFundingCandidateSms = {
  __typename?: 'SendFundingCandidateSms';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<SmsMessageType>;
  state?: Maybe<LeadSmsStateType>;
};

/**
 * ИИ-письмо лиду по всему, что о нём знаем (ТЗ 0120). Ошибки:
 * ai_disabled, budget_exceeded, bad_input, no_contract (contract без
 * договора, ждущего подписи), WRONG_STATUS / FORBIDDEN / SHORTLINK_DISABLED
 * (ссылка договора), in_progress, internal_error, LEAD_NOT_FOUND.
 */
export type DraftLeadEmail = {
  __typename?: 'DraftLeadEmail';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  draft?: Maybe<LeadEmailDraftType>;
};

export type LeadEmailDraftType = {
  __typename?: 'LeadEmailDraftType';
  id: Scalars['ID'];
  /** Лид: survey | contract | followup. Договор (этап 2): invite | reminder | expiring | followup | after_signing */
  kind: Scalars['String'];
  subject: Scalars['String'];
  /** Экранированный HTML; у survey в нём `{link}` — подставит sendLeadEmail; у договора (invite, reminder, expiring) — подставит sendContractEmail / sendContract */
  html: Scalars['String'];
  text: Scalars['String'];
  /** Сохранённый черновик (без вызова ИИ) */
  cached: Scalars['Boolean'];
  contractId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
};

/**
 * Создать (без id) или изменить сохранённый вид списка (`scope`).
 * Общий (`shared`) — только Admin. Ошибки: required / too_long (name),
 * invalid (view, scope), invalid / unknown_filter / too_large (filters),
 * forbidden (shared), not_found (id).
 */
export type SaveLeadSavedView = {
  __typename?: 'SaveLeadSavedView';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  view?: Maybe<LeadSavedViewType>;
};

/** Удалить свой вид экрана `scope`; общий — только Admin. */
export type DeleteLeadSavedView = {
  __typename?: 'DeleteLeadSavedView';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * ТЗ 0106: перенести лида на этап его воронки — запись в Kommo, потом
 * зеркало. Ошибка Kommo — customErrors с кодом клиента (AUTH, NETWORK,
 * RATE_LIMITED, TIMEOUT, ERROR, DISABLED), зеркало не меняется. Отказы
 * проверки: LEAD_NOT_FOUND, LEAD_DELETED, STAGE_NOT_FOUND,
 * STAGE_OTHER_PIPELINE, LOSS_REASON_NOT_FOUND, SOURCE_MISMATCH.
 */
export type MoveKommoLead = {
  __typename?: 'MoveKommoLead';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lead?: Maybe<KommoLeadType>;
  /** false — лид уже на этом этапе */
  changed?: Maybe<Scalars['Boolean']>;
};

/**
 * ТЗ 0106: сменить ответственного лида в Kommo (и в зеркале). `userId`
 * — id строки из kommoLeadResponsibles. Ошибки — как у moveKommoLead, плюс
 * USER_NOT_FOUND.
 */
export type SetKommoLeadResponsible = {
  __typename?: 'SetKommoLeadResponsible';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lead?: Maybe<KommoLeadType>;
  changed?: Maybe<Scalars['Boolean']>;
};

/**
 * ТЗ 0086: связать лида вручную с заявкой дофинансирования или
 * студентом — или отвязать (`targetId: null`). Ручная связь запирается:
 * робот её больше не переписывает (вернуть роботу — `resetKommoLeadLink`).
 * 
 * `what`: `candidate` (targetId — id заявки дофинансирования) |
 * `student` (targetId — id студента).
 */
export type LinkKommoLead = {
  __typename?: 'LinkKommoLead';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lead?: Maybe<KommoLeadType>;
};

/**
 * ТЗ 0086: вернуть связь роботу — снять ручной замок и пересверить по
 * email и телефону.
 */
export type ResetKommoLeadLink = {
  __typename?: 'ResetKommoLeadLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lead?: Maybe<KommoLeadType>;
};

/**
 * SMS лиду от «LearnIT» — свой текст или шаблон, любая ссылка или анкета
 * дофинансирования (короткая, со счётчиком переходов). Ставится в очередь;
 * шлёт воркер. Повтор того же `requestKey` — та же SMS.
 */
export type SendLeadSms = {
  __typename?: 'SendLeadSms';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<SmsMessageType>;
  state?: Maybe<LeadSmsStateType>;
};

/** Перечитать лида из Kommo сейчас (не чаще раза в минуту). */
export type RefreshKommoLead = {
  __typename?: 'RefreshKommoLead';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lead?: Maybe<KommoLeadType>;
  refreshed?: Maybe<Scalars['Boolean']>;
};

/**
 * Admin: синхронизировать лидов сейчас (в фоне). Работает и без
 * `KOMMO_SYNC_ENABLED` — флаг управляет только расписанием.
 */
export type SyncKommoLeads = {
  __typename?: 'SyncKommoLeads';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued?: Maybe<Scalars['Boolean']>;
};

/**
 * Admin: сотрудник ERP за пользователем Kommo. `locked=false` — вернуть
 * автоматике (по email).
 */
export type SetKommoUserMapping = {
  __typename?: 'SetKommoUserMapping';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  user?: Maybe<KommoUserType>;
};

/** Admin: повторить примечания, которые Kommo не принял. */
export type RetryKommoNotes = {
  __typename?: 'RetryKommoNotes';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  count?: Maybe<Scalars['Int']>;
};

/**
 * Поставить лида на SMS-лесенку. `dofin_form` — «пока не заполнит
 * анкету» (SMS раз в день `days` дней); `reminder` — напоминания по плану.
 * Активный запуск того же вида заменяется. `warning` — почему сейчас не
 * шлёт (план выключен, нет телефона…): запуск всё равно создан.
 */
export type StartLeadLadder = {
  __typename?: 'StartLeadLadder';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ladder?: Maybe<LeadLadderRunType>;
  warning?: Maybe<Scalars['String']>;
};

export type StopLeadLadder = {
  __typename?: 'StopLeadLadder';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ladder?: Maybe<LeadLadderRunType>;
};

export type ResumeLeadLadder = {
  __typename?: 'ResumeLeadLadder';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ladder?: Maybe<LeadLadderRunType>;
};

/**
 * Письмо лиду со своей рабочей почты (или общего ящика). `{link}` в
 * тексте — ссылка на анкету дофинансирования. Ответ приходит в тот же ящик
 * и появляется в карточке после синхронизации Gmail.
 */
export type SendLeadEmail = {
  __typename?: 'SendLeadEmail';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  conversationId?: Maybe<Scalars['ID']>;
};

/**
 * «Пригласить к анкете» одной кнопкой: письмо со ссылкой на анкету
 * дофинансирования и — `startLadder` (по умолчанию да) — лесенка «SMS раз
 * в день `days` дней, пока не заполнит». Письмо не ушло — лесенки нет;
 * SMS сейчас не могут — письмо ушло, причина в `ladderWarning`.
 */
export type InviteLeadToFundingForm = {
  __typename?: 'InviteLeadToFundingForm';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  conversationId?: Maybe<Scalars['ID']>;
  ladder?: Maybe<LeadLadderRunType>;
  ladderWarning?: Maybe<Scalars['String']>;
};

/**
 * ТЗ 0117: AI-черновик письма лиду по разобранному звонку Aplora —
 * только текст (тема и тело); отправка — штатная sendLeadEmail. Повтор
 * того же `requestKey` — тот же ответ (24 ч), `regenerate` — новый
 * черновик. Ошибки: aplora_disabled, not_found (лид, звонок не этого
 * лида), not_analyzed, aplora_rate_limited, aplora_unavailable.
 */
export type AploraFollowupDraftMutation = {
  __typename?: 'AploraFollowupDraftMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  draft?: Maybe<AploraFollowupDraftType>;
};

export type AploraFollowupDraftType = {
  __typename?: 'AploraFollowupDraftType';
  emailSubject: Scalars['String'];
  emailBody: Scalars['String'];
  messengerText?: Maybe<Scalars['String']>;
  /** Сохранённый черновик (бесплатно) */
  cached: Scalars['Boolean'];
};

/**
 * SMS преподавателю от «LearnIT» — свой текст или шаблон, ссылка на
 * подпись его документа, LMS или любой адрес. Ставится в очередь; шлёт
 * воркер. Повтор того же `requestKey` — та же SMS.
 */
export type SendTeacherSms = {
  __typename?: 'SendTeacherSms';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<SmsMessageType>;
  state?: Maybe<TeacherSmsStateType>;
};

/**
 * SMS студенту от «LearnIT» — свой текст или шаблон, ссылка на оплату его
 * фактуры, LMS или любой адрес. Ставится в очередь; шлёт воркер.
 */
export type SendStudentSms = {
  __typename?: 'SendStudentSms';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<SmsMessageType>;
  state?: Maybe<StudentSmsStateType>;
};

/**
 * Рассылка по группе: у каждого студента своя SMS и своя ссылка.
 * Повтор того же `requestKey` — та же рассылка, без второй волны SMS.
 */
export type SendGroupSms = {
  __typename?: 'SendGroupSms';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  campaign?: Maybe<SmsCampaignType>;
};

/**
 * Повторить рассылку тем, у кого SMS упала или пропущена по устранимой
 * причине (канал был выключен, не было телефона). Отправленным — никогда.
 */
export type ResendSmsCampaign = {
  __typename?: 'ResendSmsCampaign';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  campaign?: Maybe<SmsCampaignType>;
  created?: Maybe<Scalars['Int']>;
};

export type RetrySmsMessage = {
  __typename?: 'RetrySmsMessage';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<SmsMessageType>;
};

export type CancelSmsMessage = {
  __typename?: 'CancelSmsMessage';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<SmsMessageType>;
};

export type SaveSmsSettings = {
  __typename?: 'SaveSmsSettings';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  smsSettings?: Maybe<SmsSettingsType>;
};

export type SmsSettingsInput = {
  enabled?: Maybe<Scalars['Boolean']>;
  remindersEnabled?: Maybe<Scalars['Boolean']>;
  senderName?: Maybe<Scalars['String']>;
  /** ЧЧ:ММ */
  quietStart?: Maybe<Scalars['String']>;
  quietEnd?: Maybe<Scalars['String']>;
  dailyCapPerPhone?: Maybe<Scalars['Int']>;
  allowUnicode?: Maybe<Scalars['Boolean']>;
  allowForeignNumbers?: Maybe<Scalars['Boolean']>;
  maxSegments?: Maybe<Scalars['Int']>;
  lowBalancePoints?: Maybe<Scalars['Float']>;
  clearLowBalance?: Maybe<Scalars['Boolean']>;
  legalEntityIds?: Maybe<Array<Scalars['ID']>>;
};

/**
 * ТЗ 0084: тексты канала, которые правят Admin и продавцы (настройки
 * самого канала — `saveSmsSettings`, только Admin). Сейчас — хвост
 * отписки рассылки по группе; пусто — вернуть текст по умолчанию.
 * 
 * В хвосте обязательно `{link}/stop` (`STOP_LINK_REQUIRED`): страница
 * отписки — это `/stop` короткой ссылки сообщения, а голая `{link}` вела бы
 * человека на саму рассылку, и отписаться ему было бы негде.
 */
export type SaveSmsTexts = {
  __typename?: 'SaveSmsTexts';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  smsSettings?: Maybe<SmsSettingsType>;
};

/**
 * ТЗ 0084: адрес анкеты дофинансирования и LMS. Не передано — не
 * меняется; пустая строка — вернуть значение из env. Только http(s).
 */
export type SaveLinkAddresses = {
  __typename?: 'SaveLinkAddresses';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  linkAddresses?: Maybe<LinkAddressesType>;
};

/**
 * Лестница целиком: включена ли и шаги (номер, якорь, через сколько,
 * условие, шаблон). Шаги, которых нет во входе, удаляются — но уже
 * созданные SMS остаются.
 */
export type SaveReminderPlan = {
  __typename?: 'SaveReminderPlan';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  plan?: Maybe<ReminderPlanType>;
};

export type ReminderStepInput = {
  step: Scalars['Int'];
  anchor: Scalars['String'];
  offsetMinutes: Scalars['Int'];
  condition?: Maybe<Scalars['String']>;
  templateCode: Scalars['String'];
  enabled?: Maybe<Scalars['Boolean']>;
};

/**
 * `test=1` в SMSAPI: токен, имя отправителя и номер — без отправки и без
 * списания. Заодно обновляет баланс и статус имени.
 */
export type CheckSmsConnection = {
  __typename?: 'CheckSmsConnection';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  result?: Maybe<SmsConnectionCheckType>;
  status?: Maybe<SmsProviderStatusType>;
};

export type SmsConnectionCheckType = {
  __typename?: 'SmsConnectionCheckType';
  ok: Scalars['Boolean'];
  provider?: Maybe<Scalars['String']>;
  /** Цена по ответу провайдера (пункты) */
  cost?: Maybe<Scalars['Float']>;
  parts?: Maybe<Scalars['Int']>;
  segments?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
};

/**
 * Настоящая тестовая SMS на указанный номер — ОТПРАВЛЯЕТСЯ и стоит денег.
 * Нужен включённый на сервере канал (env SMS_ENABLED) — это не проверка, а
 * отправка; «Проверить подключение» — для проверки.
 */
export type SendSmsTest = {
  __typename?: 'SendSmsTest';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  result?: Maybe<SmsConnectionCheckType>;
};

export type CreateShortLink = {
  __typename?: 'CreateShortLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  link?: Maybe<ShortLinkType>;
};

export type UpdateShortLink = {
  __typename?: 'UpdateShortLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  link?: Maybe<ShortLinkType>;
};

export type RevokeShortLink = {
  __typename?: 'RevokeShortLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  link?: Maybe<ShortLinkType>;
};

/**
 * Погасить выбранные. Каждая — по своим правам: чужие, уже погашенные
 * и те, что гасить нельзя, пропускаются, а не валят всю пачку.
 */
export type RevokeShortLinks = {
  __typename?: 'RevokeShortLinks';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  revokedIds: Array<Scalars['ID']>;
  skipped: Scalars['Int'];
};

/**
 * Новая версия max+1 того же кода из текста редактора: действующая,
 * прежняя выключена, неотправленные черновики кода перерисованы.
 */
export type SaveContractTemplateVersion = {
  __typename?: 'SaveContractTemplateVersion';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<ContractTemplateType>;
  problems: Array<ContractTemplateProblemType>;
  rerenderedDrafts: Scalars['Int'];
};

/** Новый шаблон (код) копией снимка базовой версии; вид — базовой. */
export type CreateContractTemplate = {
  __typename?: 'CreateContractTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<ContractTemplateType>;
  problems: Array<ContractTemplateProblemType>;
};

/**
 * Откат / включение версии (в т. ч. версии из кода, заведённой выкатом
 * неактивной). Черновики кода перерисовываются.
 */
export type ActivateContractTemplateVersion = {
  __typename?: 'ActivateContractTemplateVersion';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<ContractTemplateType>;
  problems: Array<ContractTemplateProblemType>;
  rerenderedDrafts: Scalars['Int'];
};

/**
 * Выключить шаблон из ERP целиком (кроме последнего действующего кода
 * вида) или включить снова.
 */
export type SetContractTemplateActive = {
  __typename?: 'SetContractTemplateActive';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<ContractTemplateType>;
  problems: Array<ContractTemplateProblemType>;
};

/**
 * Новое письмо подписанту из ящика продавца (или общего). Ответ приходит
 * в тот же ящик и появляется в карточке после синхронизации.
 */
export type SendContractEmail = {
  __typename?: 'SendContractEmail';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  conversationId?: Maybe<Scalars['ID']>;
};

/**
 * ТЗ 0120 (этап 2): ИИ-письмо по договору продаж. Виды: invite (тело
 * приглашения для sendContract / resendContractEmail — `{link}`
 * обязателен), reminder, expiring (нужна живая ссылка; `{link}`
 * подставит sendContractEmail), followup, after_signing (без ссылки).
 * Ошибки: NOT_FOUND / WRONG_STATUS / NOT_HANDLER… (contract — права и
 * вид договора), bad_input (kind), ai_disabled, budget_exceeded,
 * LINK_NOT_READY, NO_EXPIRY, SHORTLINK_DISABLED, NOT_SIGNED,
 * WRONG_STATUS (invite), in_progress, internal_error.
 */
export type DraftContractEmail = {
  __typename?: 'DraftContractEmail';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  draft?: Maybe<LeadEmailDraftType>;
};

/** Ставит ручной шаг в очередь; шлёт воркер, а не эта мутация. */
export type SendContractReminderNow = {
  __typename?: 'SendContractReminderNow';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  outreach?: Maybe<ContractOutreachType>;
};

export type StopContractReminders = {
  __typename?: 'StopContractReminders';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  outreach?: Maybe<ContractOutreachType>;
};

export type ResumeContractReminders = {
  __typename?: 'ResumeContractReminders';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  outreach?: Maybe<ContractOutreachType>;
};

/**
 * ТЗ 0078: короткая ссылка договора — чтобы продавец отправил её сам
 * (SMS со своего телефона, мессенджер). Та же ссылка, что уходит в SMS и
 * в письме: переходы по ней считаются в карточке. Как и ссылка на подпись,
 * это bearer-секрет — выдаётся только так и пишется в журнал договора.
 */
export type RevealContractShortLink = {
  __typename?: 'RevealContractShortLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  url?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
};

/**
 * ТЗ 0078: SMS подписанту со своим текстом (обычно из шаблона). Все
 * защиты доставки те же, что у напоминаний: отписка, тихие часы, дневной
 * лимит, только +48, приёмочный список; кулдаун общий с «Напомнить».
 */
export type SendContractSms = {
  __typename?: 'SendContractSms';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  outreach?: Maybe<ContractOutreachType>;
};

/**
 * ТЗ 0083: одна SMS многим подписантам из списка договоров. Уходит
 * только отправленным и не подписанным договорам, чью переписку ведёт
 * сотрудник; остальные — строкой с причиной. `requestKey` — повтор того же
 * запроса (сеть, двойной клик) не шлёт второй раз.
 */
export type SendContractsSms = {
  __typename?: 'SendContractsSms';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  rows?: Maybe<Array<ContractSmsBulkRowType>>;
  sent?: Maybe<Scalars['Int']>;
  skipped?: Maybe<Scalars['Int']>;
};

/**
 * Справочник шаблонов (ТЗ 0078): создать или изменить — Admin и
 * продавцы; шаблоны оплаты фактур — ещё и финансы (ТЗ 0084,
 * `can_edit_templates`).
 */
export type SaveMessageTemplate = {
  __typename?: 'SaveMessageTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<MessageTemplateType>;
};

/**
 * Удалить шаблон — те же, кто его правит (`can_edit_templates`);
 * системный можно лишь выключить. ТЗ 0094: свою личную версию — всегда
 * (отправка вернётся к общему тексту), чужую — никто.
 */
export type DeleteMessageTemplate = {
  __typename?: 'DeleteMessageTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deletedId?: Maybe<Scalars['ID']>;
};

export type CreateStudentContractDraft = {
  __typename?: 'CreateStudentContractDraft';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

export type StudentContractDraftInput = {
  groupId: Scalars['ID'];
  paymentPlanId: Scalars['ID'];
  currency: Scalars['String'];
  /** Сумма строкой, напр. «6500.00» */
  price: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  existingUserId?: Maybe<Scalars['ID']>;
  /** ТЗ 0078: шаблон договора; пусто — по тарифу */
  templateId?: Maybe<Scalars['ID']>;
  /** ТЗ 0079: лид Kommo (New Leads); пусто — без связи */
  crmLeadId?: Maybe<Scalars['ID']>;
  crmContactId?: Maybe<Scalars['ID']>;
};

export type UpdateContractDraft = {
  __typename?: 'UpdateContractDraft';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

export type CreateCompanyContractDraft = {
  __typename?: 'CreateCompanyContractDraft';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

/**
 * Договор с фирмой (B2B). Подписант — представитель фирмы; участники —
 * её сотрудники, в договоре они только списком (не подписывают и не
 * зачисляются автоматически).
 */
export type CompanyContractDraftInput = {
  companyName: Scalars['String'];
  /** NIP фирмы */
  taxId: Scalars['String'];
  regon?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  currency: Scalars['String'];
  /** Цена за участника строкой */
  price: Scalars['String'];
  /** prepayment | postpayment */
  paymentModel: Scalars['String'];
  /** customer | funder */
  invoiceTo?: Maybe<Scalars['String']>;
  participants: Array<CompanyParticipantInput>;
  /** ТЗ 0107: шаблон договора с фирмой (действующая версия вида company); пусто — company_b2b (при правке — шаблон черновика) */
  templateId?: Maybe<Scalars['ID']>;
};

export type CompanyParticipantInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type UpdateCompanyContractDraft = {
  __typename?: 'UpdateCompanyContractDraft';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

export type SendContract = {
  __typename?: 'SendContract';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

export type ResendContractEmail = {
  __typename?: 'ResendContractEmail';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

/**
 * Ссылка на подпись — bearer-секрет: выдаётся только так и попадает
 * в журнал договора (кто и когда её взял).
 */
export type RevealContractSigningLink = {
  __typename?: 'RevealContractSigningLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  url?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
};

/**
 * ТЗ 0078: передать договор другому продавцу — только Admin, с причиной;
 * смена пишется в журнал договора.
 */
export type ReassignContractSeller = {
  __typename?: 'ReassignContractSeller';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

export type CancelContract = {
  __typename?: 'CancelContract';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

export type RetryContractFulfilment = {
  __typename?: 'RetryContractFulfilment';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

export type CreateTeacherFrameworkDraft = {
  __typename?: 'CreateTeacherFrameworkDraft';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

export type CreateTeacherAnnexDraft = {
  __typename?: 'CreateTeacherAnnexDraft';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contract?: Maybe<ContractDocumentType>;
};

/** Цена курса для тарифа в валюте (#132): создать или заменить. */
export type SetCoursePlanPrice = {
  __typename?: 'SetCoursePlanPrice';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  price?: Maybe<CoursePlanPriceType>;
};

export type DeleteCoursePlanPrice = {
  __typename?: 'DeleteCoursePlanPrice';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** Отметить конкретные строки прочитанными. */
export type MarkStaffNotificationsRead = {
  __typename?: 'MarkStaffNotificationsRead';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  summary?: Maybe<StaffNotificationsSummaryType>;
};

/** «Прочитать всё». */
export type MarkAllStaffNotificationsRead = {
  __typename?: 'MarkAllStaffNotificationsRead';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  summary?: Maybe<StaffNotificationsSummaryType>;
};

export type UpdateStaffNotificationSettings = {
  __typename?: 'UpdateStaffNotificationSettings';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  settings?: Maybe<StaffNotificationSettingsType>;
};

/**
 * Все поля необязательны: экран сохраняет по одному контролу.
 * 
 * `clear_quiet_hours` отдельным флагом, а не «пустым значением»: в GraphQL
 * «не прислали» и «прислали null» на входе неразличимы, и без флага сбросить
 * тихие часы было бы нечем.
 */
export type StaffNotificationSettingsInput = {
  enabledKinds?: Maybe<Array<Scalars['String']>>;
  soundEnabled?: Maybe<Scalars['Boolean']>;
  pollSeconds?: Maybe<Scalars['Int']>;
  repeatAfterMinutes?: Maybe<Scalars['Int']>;
  quietFrom?: Maybe<Scalars['Time']>;
  quietTo?: Maybe<Scalars['Time']>;
  clearQuietHours?: Maybe<Scalars['Boolean']>;
  telegramEnabled?: Maybe<Scalars['Boolean']>;
  robotRules?: Maybe<Array<Scalars['String']>>;
};

/** Выдать одноразовую ссылку привязки. */
export type StartTelegramLink = {
  __typename?: 'StartTelegramLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  link?: Maybe<TelegramLinkType>;
};

export type TelegramLinkType = {
  __typename?: 'TelegramLinkType';
  deepLink: Scalars['String'];
  expiresAt: Scalars['DateTime'];
};

export type UnlinkTelegram = {
  __typename?: 'UnlinkTelegram';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  settings?: Maybe<StaffNotificationSettingsType>;
};

/**
 * Create or update an operator, then re-expand its coverage index.
 * 
 * Coverage is DERIVED — `services.geo.rebuild_coverage` runs on every save,
 * so the (operator × powiat) matching index can never drift away from the
 * declared scope.
 */
export type SaveFundingOperator = {
  __typename?: 'SaveFundingOperator';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  operator?: Maybe<FundingOperatorType>;
  /** Исход привязки кандидатов по номеру проекта (задача #96): linked — выполнена (сколько — в `linkedCandidatesCount`, может быть 0); ambiguous — этот номер стоит ещё у одного АКТИВНОГО оператора, и НИКТО не привязан; no_operator — сам оператор выключен, кандидатов не цепляет; no_prefix — номера нет. */
  projectNumberLink?: Maybe<Scalars['String']>;
  /** Сколько кандидатов привязано этим сохранением. Уже связанные (и выключенные человеком) не считаются. */
  linkedCandidatesCount?: Maybe<Scalars['Int']>;
};

export type FundingOperatorInput = {
  name: Scalars['String'];
  programType: Scalars['String'];
  programName?: Maybe<Scalars['String']>;
  /** Nr projektu. Нормализуется при сохранении (пробелы, регистр); сохранение привязывает кандидатов, чей ID wsparcia начинается с этого номера и «_». */
  projectNumber?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  coverageScope?: Maybe<Scalars['String']>;
  powiatIds?: Maybe<Array<Scalars['ID']>>;
  servedStatuses?: Maybe<Array<Scalars['String']>>;
  acceptsUnemployed?: Maybe<Scalars['Boolean']>;
  acceptsEmployerApplications?: Maybe<Scalars['Boolean']>;
  supportsDisabled?: Maybe<Scalars['Boolean']>;
  supportsAge50Plus?: Maybe<Scalars['Boolean']>;
  greenCompetences?: Maybe<Scalars['Boolean']>;
  rollingIntake?: Maybe<Scalars['Boolean']>;
  maxAmount?: Maybe<Scalars['Float']>;
  maxAmountCurrency?: Maybe<Scalars['String']>;
  ownContributionPercent?: Maybe<Scalars['Float']>;
  paymentMethod?: Maybe<Scalars['String']>;
  decisionDays?: Maybe<Scalars['Int']>;
  implementationStart?: Maybe<Scalars['Date']>;
  implementationEnd?: Maybe<Scalars['Date']>;
  instructionUrl?: Maybe<Scalars['String']>;
  operatorInstructionUrl?: Maybe<Scalars['String']>;
  instructionReady?: Maybe<Scalars['Boolean']>;
  projectUrl?: Maybe<Scalars['String']>;
  newsUrl?: Maybe<Scalars['String']>;
  /** Лента RSS/Atom страницы новостей (#129а). Пустая строка — «ищи сам»: робот найдёт ленту на странице или у WordPress и запишет сюда. Смена адреса ленты сбрасывает её базу: первое чтение новой — без флага. */
  feedUrl?: Maybe<Scalars['String']>;
  documentsUrl?: Maybe<Scalars['String']>;
  documentsNote?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  internalNote?: Maybe<Scalars['String']>;
};

/**
 * Набор заводит и правит человек — робот только двигает статус (ТЗ 0048).
 * 
 * Мутация написана в ТЗ 0046 и до ТЗ 0048 **не вызывалась ни одним
 * экраном**: формы набора не существовало. Три дефекта, разобранные в
 * `save_intake`, прожили в ней ровно поэтому — их некому было предъявить.
 */
export type SaveFundingIntake = {
  __typename?: 'SaveFundingIntake';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  intake?: Maybe<FundingIntakeType>;
};

export type DeleteFundingIntake = {
  __typename?: 'DeleteFundingIntake';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Публичная форма приёма заявок. ЕДИНСТВЕННАЯ анонимная запись в домене.
 * 
 * Три правила, каждое из которых существует из-за конкретного риска:
 * 
 * * **ответ одинаков для знакомого и незнакомого e-mail** — иначе форма
 *   становится оракулом перебора адресов, и её ответ собирается скриптом.
 *   По той же причине здесь нет ни «вы уже подавали заявку», ни возврата
 *   идентификатора кандидата;
 * * **`CustomUser` не создаётся никогда** — e-mail и телефон у пользователя
 *   уникальны, и анонимная запись заняла бы адрес, на который потом
 *   резолвится реальный подписанный договор;
 * * **сначала сохраняется сырая заявка, потом отдельно триаж** — лид не
 *   должен теряться из-за того, что упала дедупликация.
 * 
 * Ошибка триажа НЕ отменяет приём: заявка уже в базе, менеджер разберёт её
 * из админки, а причина остаётся в `process_error`.
 */
export type SubmitFundingForm = {
  __typename?: 'SubmitFundingForm';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Create or edit a candidate.
 * 
 * Note what is NOT here: `status` and `primary_operator`. Both move through
 * their own mutations so every transition is written to
 * `FundingCandidateEvent` — under one-row-per-person that log is the only
 * history there is.
 */
export type SaveFundingCandidate = {
  __typename?: 'SaveFundingCandidate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  candidate?: Maybe<FundingCandidateType>;
  /** Исход привязки оператора по ID wsparcia (задача #96). Пусто — `supportId` не передан или пуст. linked — связь добавлена; already_linked — уже в работе; switched_off — связь выключена человеком и НЕ оживлена; no_prefix — в ID нет «_»; no_operator — АКТИВНОГО оператора с таким номером нет (выключенный не цепляется); ambiguous — номер у нескольких активных операторов, привязка пропущена. */
  supportIdLink?: Maybe<Scalars['String']>;
};

export type FundingCandidateInput = {
  fullName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  powiatId?: Maybe<Scalars['ID']>;
  city?: Maybe<Scalars['String']>;
  employerVoivodeshipId?: Maybe<Scalars['ID']>;
  employerPowiatId?: Maybe<Scalars['ID']>;
  employerName?: Maybe<Scalars['String']>;
  employerSameVoivodeship?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  desiredStartMonth?: Maybe<Scalars['Date']>;
  isUnemployed?: Maybe<Scalars['Boolean']>;
  isAdult?: Maybe<Scalars['Boolean']>;
  is50Plus?: Maybe<Scalars['Boolean']>;
  hasDisabilityCertificate?: Maybe<Scalars['Boolean']>;
  inFinancialHardship?: Maybe<Scalars['Boolean']>;
  usedFundingBefore?: Maybe<Scalars['Boolean']>;
  employerCanApply?: Maybe<Scalars['Boolean']>;
  jdgSuspended?: Maybe<Scalars['Boolean']>;
  preferredTracks?: Maybe<Array<Scalars['String']>>;
  employmentStatus?: Maybe<Scalars['String']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  testDrive?: Maybe<Scalars['Boolean']>;
  reminderAt?: Maybe<Scalars['DateTime']>;
  taskNote?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  declineReason?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  appliedAt?: Maybe<Scalars['Date']>;
  decisionAt?: Maybe<Scalars['Date']>;
  approvedAmount?: Maybe<Scalars['Float']>;
  assignedToId?: Maybe<Scalars['ID']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  /** ID wsparcia. Нормализуется при сохранении; префикс до первого «_» привязывает оператора с таким номером проекта (только добавляет связь). */
  supportId?: Maybe<Scalars['String']>;
  /** Только при СОЗДАНИИ (id = null, задача #134): операторы, с которыми кандидат заводится в той же транзакции — автоподбор не увидит его «без оператора». Связь — как у ручного добавления (source manual); письмо-знакомство отправит добор. Каждый оператор должен существовать и быть активным (иначе customErrors по operatorIds, кандидат не создаётся). При правке непустой список — ошибка: операторов добавляет addCandidateOperators. */
  operatorIds?: Maybe<Array<Scalars['ID']>>;
};

/**
 * Удалить заявку-дубль или тестовую (задача #95).
 * 
 * Отказывает (`candidate_in_use`), если человеку уже писали или строка
 * пришла из Notion, — тогда архив: `saveFundingCandidate(id, input:
 * {isArchived: true})` меняет только этот флаг. Правила — в
 * `services.candidates.delete_candidate`.
 */
export type DeleteFundingCandidate = {
  __typename?: 'DeleteFundingCandidate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deletedId?: Maybe<Scalars['ID']>;
};

export type ChangeCandidateStatus = {
  __typename?: 'ChangeCandidateStatus';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  candidate?: Maybe<FundingCandidateType>;
};

/**
 * Добавить кандидату операторов — сразу нескольких.
 * 
 * Заменила `setCandidateOperator` (ТЗ 0067): «выбранный» перестал быть
 * одним, и мутация «поставь одного вместо всех» описывала правило, которого
 * больше нет. Выключенного оператора НЕ воскрешает — для этого есть явная
 * `reactivateCandidateOperator`.
 */
export type AddCandidateOperators = {
  __typename?: 'AddCandidateOperators';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  candidate?: Maybe<FundingCandidateType>;
  /** Сколько операторов РЕАЛЬНО добавлено. Может быть меньше запрошенного и даже нулём: уже активный пропускается молча, а выключенного человеком повторное добавление не воскрешает (правило липкости). Экран обязан говорить это число, а не длину своего запроса. */
  addedCount?: Maybe<Scalars['Int']>;
};

/**
 * Выключить оператора у кандидата. Причина обязательна.
 * 
 * Единственное, что прекращает письма конкретного оператора (кроме
 * терминального статуса кандидата). Строку связи не удаляет — она остаётся
 * журналом и объясняет, почему к оператору больше не ходят.
 */
export type DeactivateCandidateOperator = {
  __typename?: 'DeactivateCandidateOperator';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  candidate?: Maybe<FundingCandidateType>;
};

/** Вернуть выключенного оператора в работу — решение человека. */
export type ReactivateCandidateOperator = {
  __typename?: 'ReactivateCandidateOperator';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  candidate?: Maybe<FundingCandidateType>;
};

/**
 * Пометить ведущего оператора (или снять пометку).
 * 
 * ⚠️ Пометка НИКОГО НЕ ГЛУШИТ: письма продолжают уходить от всех активных
 * операторов. До ТЗ 0067 эта же запись означала «перевод, старый
 * замолкает» — теперь замолкание делается явно и с причиной.
 */
export type SetCandidatePrimaryOperator = {
  __typename?: 'SetCandidatePrimaryOperator';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  candidate?: Maybe<FundingCandidateType>;
};

/**
 * Поставить или снять отметку «повышенное внимание» (задача ERP #105).
 * 
 * Перед стартом ближайшего живого окна активного оператора кандидата робот
 * `attention_intake_tasks` заведёт задачу тому, кто поставил отметку.
 * Переход пишется в журнал событий кандидата; `erp_edited_at` НЕ ставится —
 * это не правка строки, и импорт из Notion не должен из-за неё вставать.
 */
export type SetFundingCandidateAttention = {
  __typename?: 'SetFundingCandidateAttention';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  candidate?: Maybe<FundingCandidateType>;
};

/**
 * Pin a funnel person to an account by hand.
 * 
 * The manual decision is durable: `user_locked` stops the automatic
 * re-matcher from ever re-pointing this row.
 */
export type LinkCandidateToUser = {
  __typename?: 'LinkCandidateToUser';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  candidate?: Maybe<FundingCandidateType>;
};

export type UnlinkCandidateFromUser = {
  __typename?: 'UnlinkCandidateFromUser';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  candidate?: Maybe<FundingCandidateType>;
};

/**
 * Settle one raw place string.
 * 
 * Either outcome PINS the row — the auto-resolver never re-points a
 * manually settled string on any later import.
 */
export type ResolveGeoAlias = {
  __typename?: 'ResolveGeoAlias';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  alias?: Maybe<GeoAliasType>;
};

/**
 * «Посмотрел» — человек разобрал изменение на странице оператора.
 * 
 * Ровно один поступок и ровно один эффект: снять флаг «страница обновилась».
 * Владелец описал цикл так: «мы следим за страницей только лишь в том смысле,
 * поменялась она или нет. Если да — руками смотрим, что конкретно поменялось,
 * и снова меняем статус руками, что не поменялось».
 * 
 * 🔴 Раньше сюда приходил `automation_status`, и мутация одновременно
 * снимала флаг И выдавала разрешение на рассылку. Отсюда росли четыре
 * кнопки — «есть набор», «набора нет», «надо править карточку», — про
 * которые владелец сказал: «что это за хуйню, не понимаю, что это». Два
 * разных решения в одной мутации требовали от человека принять их сразу,
 * хотя второе относится к НАБОРУ, а не к странице. Разрешение переехало на
 * окно (`FundingIntake.confirmed_at`), и здесь остался только флаг.
 * 
 * Флаг снимает ТОЛЬКО эта мутация: робот его лишь поднимает. Иначе
 * «заметили» и «разобрали» слились бы в один факт, и второе изменение
 * подряд съело бы первое.
 * 
 * 🔴 `intake` — «посмотрел, и там объявлен вот такой набор» (ТЗ 0048).
 * Аргумент остаётся: «разобрал» и «записал увиденный набор» — один поход
 * менеджера, и одна транзакция здесь честнее двух запросов с фронта, между
 * которыми помещается отказ. Подтверждение приходит внутри `intake`
 * (`confirmed: true`) — там же, где живёт.
 */
export type ReviewOperatorPage = {
  __typename?: 'ReviewOperatorPage';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  operator?: Maybe<FundingOperatorType>;
};

/** Набор внутри другого запроса — им пользуется «посмотрел и завёл». */
export type FundingIntakeInput = {
  id?: Maybe<Scalars['ID']>;
  startsOn?: Maybe<Scalars['Date']>;
  endsOn?: Maybe<Scalars['Date']>;
  startsAtTime?: Maybe<Scalars['Time']>;
  endsAtTime?: Maybe<Scalars['Time']>;
  announcedAt?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
};

/**
 * Подтвердить набор — или снять подтверждение.
 * 
 * 🔴 Единственное разрешение на рассылку в домене (ТЗ 0054). Владелец:
 * «у набора должен быть статус, что он активный… она руками его делает,
 * что он активный. Это означает, что можно сделать рассылку… то есть набор
 * подтверждён».
 * 
 * Отдельная мутация, а не поле в `saveFundingIntake`, по той же причине, по
 * которой подтверждение не поле в `_apply_patch`: это поступок, у него один
 * аргумент, и жать его будут из строки таблицы, где формы нет. Форма умеет
 * то же самое через `FundingIntakeInput.confirmed` — обе дороги ведут в
 * `services.intakes.confirm_intake`, второго правила не заводится.
 */
export type ConfirmFundingIntake = {
  __typename?: 'ConfirmFundingIntake';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  intake?: Maybe<FundingIntakeType>;
};

/**
 * Разобрать заявку с формы заново (ТЗ 0046).
 * 
 * Триаж идёт автоматически и в `try/except`: заявка пишется одной
 * транзакцией, а разбор — отдельно и после, чтобы падение разбора не теряло
 * лид. Цена в том, что упавшая заявка молча остаётся с пустым
 * `processed_at`, и до этой мутации починить её из интерфейса было нельзя —
 * только руками в БД.
 * 
 * Идемпотентна: повторный разбор уже подшитой заявки найдёт того же
 * кандидата и заполнит те же пустые поля.
 * 
 * Она же — способ отменить ложное срабатывание ловушки (ТЗ 0047). Заявку,
 * отклонённую как автоматическую, менеджер разбирает этой же кнопкой, и
 * удачный разбор снимает пометку: человек посмотрел и решил, а его решение
 * старше эвристики.
 */
export type RetryFormSubmission = {
  __typename?: 'RetryFormSubmission';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  submission?: Maybe<FormSubmissionType>;
};

/**
 * Запустить фоновую задачу робота по кнопке.
 * 
 * Все три флага расписания по умолчанию выключены, и до этой мутации
 * единственным способом что-то прогнать был терминал сервера.
 * 
 * 🔴 Ставим в ОЧЕРЕДЬ, а не выполняем синхронно: обход ста с лишним
 * страниц операторов идёт с паузой между запросами и в HTTP-таймаут не
 * уложится. Результат появится строкой в журнале прогонов.
 * 
 * `dry_run` едет в очередь вместе с задачей: сухость живёт в самой задаче
 * (`services/dry_run.py`), значит воркер выполнит сухой прогон сухим — ни
 * записей, ни писем. Что он собирался сделать, видно заметками в строке
 * журнала.
 * 
 * По умолчанию — СУХОЙ. Кнопок пять, они стоят в ряд, и промах по одной из
 * них не имеет права разослать сотни писем.
 */
export type RunFundingTask = {
  __typename?: 'RunFundingTask';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  /** Идентификатор задачи в celery. */
  taskId?: Maybe<Scalars['String']>;
  /** Ответил ли хоть один воркер. `false` означает, что задача легла в очередь, а брать её некому. */
  workerOnline?: Maybe<Scalars['Boolean']>;
};

/** Add students and/or a whole graduating group to the centre. */
export type EnrollCareerMembers = {
  __typename?: 'EnrollCareerMembers';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  created?: Maybe<Scalars['Int']>;
  reactivated?: Maybe<Scalars['Int']>;
  skipped?: Maybe<Scalars['Int']>;
};

/**
 * Убрать из карьерного центра или вернуть обратно.
 * 
 * 🔴 Это НЕ удаление. Пропадает только доступ: строка участника, прогресс по
 * урокам, отклики и запись о трудоустройстве остаются нетронутыми, и вернуть
 * человека можно тем же действием. Так решено владельцем.
 * 
 * Массовая с самого начала — оператор чистит ошибочно добавленную группу
 * целиком. Отдельная мутация «на одного» была бы тем же кодом, а триста
 * вызовов подряд — тремястами перезагрузками списка (тот же довод, что у
 * `bulkSetVacancyStatus`).
 */
export type SetCareerMembersAccess = {
  __typename?: 'SetCareerMembersAccess';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  changed?: Maybe<Scalars['Int']>;
  unchanged?: Maybe<Scalars['Int']>;
  missing?: Maybe<Scalars['Int']>;
};

export type UpdateCareerMember = {
  __typename?: 'UpdateCareerMember';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  member?: Maybe<CareerMemberType>;
};

export type CareerMemberInput = {
  status?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
};

export type UpsertCareerLesson = {
  __typename?: 'UpsertCareerLesson';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
};

export type CareerLessonInput = {
  order: Scalars['Int'];
  title: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  durationMin?: Maybe<Scalars['Int']>;
  completionKind?: Maybe<Scalars['String']>;
  artifactHint?: Maybe<Scalars['String']>;
  outcomeKind?: Maybe<Scalars['String']>;
  outcomeLabel?: Maybe<Scalars['String']>;
  materialLanguage?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
};

/**
 * ERP: upload a lesson video (multipart, server-side write to the private
 * bucket — the same path as attachments, diplomas and the Django-admin file
 * widget, so no bucket CORS is required).
 */
export type UploadCareerLessonVideo = {
  __typename?: 'UploadCareerLessonVideo';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
};

export type ClearCareerLessonVideo = {
  __typename?: 'ClearCareerLessonVideo';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
};

/** ERP: attach one downloadable file (multipart Upload) to a lesson. */
export type AddCareerLessonAttachment = {
  __typename?: 'AddCareerLessonAttachment';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  attachment?: Maybe<CareerLessonAttachmentType>;
};

export type RemoveCareerLessonAttachment = {
  __typename?: 'RemoveCareerLessonAttachment';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

/** LMS: the student marks a lesson done, unlocking the next one. */
export type CompleteCareerLesson = {
  __typename?: 'CompleteCareerLesson';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonsCompleted?: Maybe<Scalars['Int']>;
  lessonsTotal?: Maybe<Scalars['Int']>;
  reward?: Maybe<GrowthRewardType>;
};

/**
 * Что выдано ИМЕННО ЭТИМ действием (ТЗ 0039, доводка).
 * 
 * Возвращается из завершения урока, сдачи анкеты и репоста, чтобы интерфейс
 * показал награду в момент действия. Пустые списки — норма: значит на этот
 * раз ничего нового не заработано, и уведомление показывать не нужно.
 */
export type GrowthRewardType = {
  __typename?: 'GrowthRewardType';
  grantedTitles: Array<Scalars['String']>;
  promoCodes: Array<Scalars['String']>;
};

/** LMS: record that the student opened a lesson — viewed, NOT completed. */
export type MarkCareerLessonOpened = {
  __typename?: 'MarkCareerLessonOpened';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  openCount?: Maybe<Scalars['Int']>;
};

/** LMS: the student's PRIVATE note on a lesson (never shown to staff). */
export type SaveCareerLessonNotes = {
  __typename?: 'SaveCareerLessonNotes';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  notes?: Maybe<Scalars['String']>;
};

/** LMS: toggle a lesson bookmark for the calling student. */
export type SetCareerLessonBookmark = {
  __typename?: 'SetCareerLessonBookmark';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  isBookmarked?: Maybe<Scalars['Boolean']>;
};

/** ERP: replace a lesson's self-check quiz (delete-and-recreate). */
export type SetCareerLessonQuiz = {
  __typename?: 'SetCareerLessonQuiz';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
};

export type CareerQuizQuestionInput = {
  text: Scalars['String'];
  options: Array<Scalars['String']>;
  correctIndexes: Array<Scalars['Int']>;
};

/**
 * LMS: score the student's answers and record an attempt (self-check —
 * never gates the lesson).
 */
export type SubmitCareerQuiz = {
  __typename?: 'SubmitCareerQuiz';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  score?: Maybe<Scalars['Int']>;
  maxScore?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<CareerQuizResultType>>;
};

/**
 * One graded question after submit — parent is a dict from
 * `services.quiz.submit_quiz`. The key is returned here because the answer is
 * already given (post-submit feedback).
 */
export type CareerQuizResultType = {
  __typename?: 'CareerQuizResultType';
  questionId: Scalars['ID'];
  correct: Scalars['Boolean'];
  correctIndexes: Array<Scalars['Int']>;
};

export type CareerQuizAnswerInput = {
  questionId: Scalars['ID'];
  selectedIndexes: Array<Scalars['Int']>;
};

export type SaveCareerProfile = {
  __typename?: 'SaveCareerProfile';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
};

export type CareerProfileInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  relocationReady?: Maybe<Scalars['Boolean']>;
  workMode?: Maybe<Scalars['String']>;
  workPermit?: Maybe<Scalars['String']>;
  availableFrom?: Maybe<Scalars['Date']>;
  seniority?: Maybe<Scalars['String']>;
  desiredPosition?: Maybe<Scalars['String']>;
  desiredSalary?: Maybe<Scalars['String']>;
  githubUrl?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  portfolioUrl?: Maybe<Scalars['String']>;
  customSkills?: Maybe<Array<Scalars['String']>>;
  skills?: Maybe<Array<ProfileSkillInput>>;
  projects?: Maybe<Array<ProfileProjectInput>>;
  experience?: Maybe<Array<ProfileExperienceInput>>;
  education?: Maybe<Array<ProfileEducationInput>>;
  languages?: Maybe<Array<ProfileLanguageInput>>;
  certificates?: Maybe<Array<ProfileCertificateInput>>;
  cvLocales?: Maybe<Array<CvLocaleInput>>;
};

export type ProfileSkillInput = {
  skillId: Scalars['ID'];
  level?: Maybe<Scalars['Int']>;
  years?: Maybe<Scalars['Float']>;
  isHidden?: Maybe<Scalars['Boolean']>;
};

export type ProfileProjectInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  repoUrl?: Maybe<Scalars['String']>;
  demoUrl?: Maybe<Scalars['String']>;
  technologyIds?: Maybe<Array<Scalars['ID']>>;
};

export type ProfileExperienceInput = {
  company?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  startYear?: Maybe<Scalars['Int']>;
  startMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  endMonth?: Maybe<Scalars['Int']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
};

export type ProfileEducationInput = {
  institution?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  specialization?: Maybe<Scalars['String']>;
  startYear?: Maybe<Scalars['Int']>;
  startMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  endMonth?: Maybe<Scalars['Int']>;
};

export type ProfileLanguageInput = {
  language: Scalars['String'];
  level?: Maybe<Scalars['String']>;
};

export type ProfileCertificateInput = {
  id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  issuer?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['Date']>;
  url?: Maybe<Scalars['String']>;
};

/** Языковая версия текста CV — едет вместе с профилем (0072). */
export type CvLocaleInput = {
  language: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
};

/** Upsert the per-language prose overlay (title + about) for the CV. */
export type SaveCvText = {
  __typename?: 'SaveCvText';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
};

/** The student's own opt-in to partner search (Ф3) + contact visibility. */
export type SetProfileSearchable = {
  __typename?: 'SetProfileSearchable';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
};

/**
 * Студент сам оценил уровень навыка (0072): из паспорта навыка или из
 * подсказки «Wspomniano w CV». Подтверждённый школой уровень не понижается.
 */
export type SetMySkillLevel = {
  __typename?: 'SetMySkillLevel';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
  skill?: Maybe<StudentSkillType>;
};

export type UpsertVacancy = {
  __typename?: 'UpsertVacancy';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  vacancy?: Maybe<VacancyType>;
};

export type VacancyInput = {
  title: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  applyUrl: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  workMode?: Maybe<Scalars['String']>;
  seniority?: Maybe<Scalars['String']>;
  employmentType?: Maybe<Scalars['String']>;
  salaryMin?: Maybe<Scalars['Int']>;
  salaryMax?: Maybe<Scalars['Int']>;
  salaryCurrency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['Date']>;
  directionIds?: Maybe<Array<Scalars['ID']>>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
};

/**
 * Hard-delete a draft/rejected vacancy. Anything further along refuses
 * with `vacancy_locked` and points at the archive — see
 * `services.vacancies.delete_vacancy` for why the fence is this narrow.
 */
export type DeleteVacancy = {
  __typename?: 'DeleteVacancy';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  deletedInteractions?: Maybe<Scalars['Int']>;
};

export type SetVacancyStatus = {
  __typename?: 'SetVacancyStatus';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  vacancy?: Maybe<VacancyType>;
};

/**
 * Move many vacancies at once — the queue-draining action (spec 0035).
 * 
 * `bulkPublishVacancies` only ever published; rejecting a night's drafts
 * meant one mutation per row, each triggering a full table reload. This is
 * set-based on the server and covers every status.
 */
export type BulkSetVacancyStatus = {
  __typename?: 'BulkSetVacancyStatus';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  moved?: Maybe<Scalars['Int']>;
};

export type BulkPublishVacancies = {
  __typename?: 'BulkPublishVacancies';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  published?: Maybe<Scalars['Int']>;
};

export type RecordPlacement = {
  __typename?: 'RecordPlacement';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  placement?: Maybe<PlacementRecordType>;
};

export type PlacementRecordType = {
  __typename?: 'PlacementRecordType';
  id: Scalars['ID'];
  memberId: Scalars['ID'];
  studentName: Scalars['String'];
  companyName: Scalars['String'];
  position: Scalars['String'];
  startedAt?: Maybe<Scalars['Date']>;
  confirmedAt: Scalars['DateTime'];
};

export type PlacementInput = {
  companyName: Scalars['String'];
  position?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Date']>;
  salary?: Maybe<Scalars['Int']>;
  salaryCurrency?: Maybe<Scalars['String']>;
  vacancyId?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  applicationId?: Maybe<Scalars['ID']>;
};

/** LMS: a member saves a vacancy or marks that they applied. */
export type MarkVacancyInteraction = {
  __typename?: 'MarkVacancyInteraction';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  vacancy?: Maybe<VacancyType>;
};

/**
 * LMS: завести отклик.
 * 
 * `duplicate` — ШТАТНЫЙ ответ, а не ошибка: повтор на ту же вакансию, пока
 * прежний отклик ещё в работе, возвращает существующую строку. Прецедент
 * домена — `erp_create_vacancy_draft`; штатная ситуация, отданная
 * исключением, читается вызывающим как сбой.
 */
export type CreateCareerApplication = {
  __typename?: 'CreateCareerApplication';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  application?: Maybe<CareerApplicationType>;
  duplicate?: Maybe<Scalars['Boolean']>;
};

export type CareerApplicationInput = {
  vacancyId?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  applyUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  appliedAt?: Maybe<Scalars['Date']>;
  nextActionAt?: Maybe<Scalars['Date']>;
  note?: Maybe<Scalars['String']>;
};

export type UpdateCareerApplication = {
  __typename?: 'UpdateCareerApplication';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  application?: Maybe<CareerApplicationType>;
};

/**
 * LMS: сменить статус отклика.
 * 
 * 🔴 `hired` НЕ создаёт `PlacementRecord`, НЕ переводит участника в `placed`
 * и НЕ выдаёт медаль. Самозаявленное трудоустройство не может стать KPI
 * школы, а на архивном участнике автоперевод в `placed` (статус АКТИВНЫЙ)
 * молча вернул бы доступ в центр мимо явной разархивации. Строка лишь встаёт
 * в очередь подтверждения сотруднику.
 */
export type SetCareerApplicationStatus = {
  __typename?: 'SetCareerApplicationStatus';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  application?: Maybe<CareerApplicationType>;
};

export type DeleteCareerApplication = {
  __typename?: 'DeleteCareerApplication';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deleted?: Maybe<Scalars['Boolean']>;
};

/** Завести или поправить навык справочника. */
export type UpsertCareerSkill = {
  __typename?: 'UpsertCareerSkill';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  skill?: Maybe<SkillType>;
};

export type CareerSkillInput = {
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  category: Scalars['String'];
  aliases?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  levelCriteria?: Maybe<Array<SkillLevelCriteriaInput>>;
};

export type SkillLevelCriteriaInput = {
  level: Scalars['Int'];
  points: Array<Scalars['String']>;
  example?: Maybe<Scalars['String']>;
};

/**
 * Спрятать навык из автокомплита или вернуть обратно.
 * 
 * Мутации удаления НЕТ намеренно: `Skill.delete()` каскадит `StudentSkill`,
 * то есть стирает навык из резюме всех владельцев, и вычищает теги вакансий.
 */
export type SetCareerSkillActive = {
  __typename?: 'SetCareerSkillActive';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  skill?: Maybe<SkillType>;
};

/** Слить дубль справочника в целевой навык («React» и «ReactJS»). */
export type MergeCareerSkills = {
  __typename?: 'MergeCareerSkills';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  skill?: Maybe<SkillType>;
  movedStudentSkills?: Maybe<Scalars['Int']>;
  movedVacancies?: Maybe<Scalars['Int']>;
  movedProjects?: Maybe<Scalars['Int']>;
  movedCourseSkills?: Maybe<Scalars['Int']>;
};

/**
 * Загрузить свою картинку навыка или убрать её (ТЗ 0039, доводка UX).
 * 
 * Иконка НЕОБЯЗАТЕЛЬНА: без неё фронт рисует встроенный логотип по `slug`, а
 * если и его нет — буквенную плашку по категории. Поэтому «убрать» здесь не
 * оставляет пустое место, а возвращает автоподбор, и оператору не приходится
 * держать картинку только для того, чтобы строка не выглядела сломанной.
 * 
 * Загрузка идёт мультипартом и пишется сервером — тем же путём, что видео
 * урока и вложения; настраивать CORS бакета не нужно.
 */
export type SetCareerSkillIcon = {
  __typename?: 'SetCareerSkillIcon';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  skill?: Maybe<SkillType>;
};

/**
 * Задать набор навыков курса целиком — ШАБЛОН для будущих групп.
 * 
 * 🔴 Пересчёта начислений здесь больше нет (ТЗ 0041). Набор курса перестал
 * быть действующим правилом: начисление читает набор ГРУППЫ, снятый с курса
 * в момент её создания. Правка шаблона по решению владельца не догоняет уже
 * идущие группы — иначе студент старой группы получал бы навык не на том
 * занятии, ради чего перенос и делался. Пересчёт ставит `SetGroupSkills`.
 */
export type SetCourseSkills = {
  __typename?: 'SetCourseSkills';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  added?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Int']>;
  deactivated?: Maybe<Scalars['Int']>;
};

export type CourseSkillInput = {
  skillId: Scalars['ID'];
  level?: Maybe<Scalars['Int']>;
  unlockLessonNumber?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/**
 * Задать набор навыков ГРУППЫ целиком (ТЗ 0041).
 * 
 * Пересчёт начислений НЕ делается здесь: группа с тремя десятками студентов
 * и дюжиной навыков — это сотни записей внутри GraphQL-запроса. Ставим
 * задачу; при недоступном брокере считаем синхронно, но не молча.
 */
export type SetGroupSkills = {
  __typename?: 'SetGroupSkills';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  added?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Int']>;
  deactivated?: Maybe<Scalars['Int']>;
};

/**
 * Строка набора навыков группы (ТЗ 0041).
 * 
 * Занятие — ССЫЛКА, а не номер: у группы оно существует строкой в базе, и
 * ссылка переживает перенос, переименование и вставку соседнего занятия.
 * Пусто — навык приходит по завершении курса. Чужое занятие сервер отвергает
 * ошибкой: «навык не пришёл» и «навык привязан к занятию соседней группы»
 * выглядят на экране одинаково, и второе не должно сохраняться молча.
 */
export type GroupSkillInput = {
  skillId: Scalars['ID'];
  level?: Maybe<Scalars['Int']>;
  unlockLessonId?: Maybe<Scalars['ID']>;
  order?: Maybe<Scalars['Int']>;
};

/** Ручное «зачтено / не засчитывать» по паре студент-курс. */
export type SetCourseCompletion = {
  __typename?: 'SetCourseCompletion';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  completedCourseIds?: Maybe<Array<Scalars['ID']>>;
};

/**
 * Кнопка «Пересчитать навыки» на карточке участника.
 * 
 * 🔴 Поля обязаны покрывать ВСЮ сводку `skill_grant.grant_for_student`:
 * ответ собирается как `cls(**stats)`, и лишний ключ — это `TypeError`, то
 * есть пятисотка на кнопку. Так и было с `reattributed`: сводка его отдавала
 * с самого начала, а поля для него не завели, и кнопка падала на любом
 * студенте (ТЗ 0040, попутная находка). Тест `test_sync_button_returns_full_stats`
 * держит два списка вместе.
 */
export type SyncStudentCourseSkills = {
  __typename?: 'SyncStudentCourseSkills';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  granted?: Maybe<Scalars['Int']>;
  promoted?: Maybe<Scalars['Int']>;
  raised?: Maybe<Scalars['Int']>;
  demoted?: Maybe<Scalars['Int']>;
  reattributed?: Maybe<Scalars['Int']>;
  unchanged?: Maybe<Scalars['Int']>;
};

/**
 * Завести или поправить профессию (ТЗ 0040 фаза C).
 * 
 * Удаления нет: у трека висит `StudentTrackChoice` — выбор студента, и
 * удалить трек значит молча отобрать у человека цель, которую он себе
 * поставил. Есть скрытие.
 */
export type SaveGrowthTrack = {
  __typename?: 'SaveGrowthTrack';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  track?: Maybe<GrowthTrackErpType>;
};

export type GrowthTrackInput = {
  id?: Maybe<Scalars['ID']>;
  code: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  salaryFrom?: Maybe<Scalars['Int']>;
  salaryTo?: Maybe<Scalars['Int']>;
  salaryCurrency?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
  siteCourseIds?: Maybe<Array<Scalars['ID']>>;
  steps?: Maybe<Array<GrowthStepInput>>;
};

export type GrowthStepInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  ruleKind: Scalars['String'];
  ruleParams?: Maybe<Scalars['JSONString']>;
};

export type ToggleGrowthTrack = {
  __typename?: 'ToggleGrowthTrack';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  track?: Maybe<GrowthTrackErpType>;
};

/**
 * Завести или поправить медаль.
 * 
 * Удаления нет: `AchievementGrant` — append-only журнал выданного, и
 * `CASCADE` снёс бы вместе с медалью историю начислений и очки, которые
 * студент уже видел.
 */
export type SaveAchievement = {
  __typename?: 'SaveAchievement';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  achievement?: Maybe<AchievementErpType>;
};

export type AchievementInput = {
  id?: Maybe<Scalars['ID']>;
  code: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  points?: Maybe<Scalars['Int']>;
  ruleKind: Scalars['String'];
  ruleParams?: Maybe<Scalars['JSONString']>;
  isSecret?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
};

export type ToggleAchievement = {
  __typename?: 'ToggleAchievement';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  achievement?: Maybe<AchievementErpType>;
};

/** Завести или поправить курс витрины (что школа продаёт). */
export type SaveSiteCourse = {
  __typename?: 'SaveSiteCourse';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  siteCourse?: Maybe<SiteCourseErpType>;
};

export type SiteCourseInput = {
  id?: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  erpCourseId?: Maybe<Scalars['ID']>;
  careerOutcome?: Maybe<Scalars['String']>;
  durationLabel?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<SiteCourseSkillInput>>;
};

export type SiteCourseSkillInput = {
  skillId: Scalars['ID'];
  level?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

export type ToggleSiteCourse = {
  __typename?: 'ToggleSiteCourse';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  siteCourse?: Maybe<SiteCourseErpType>;
};

/**
 * Переписать программу курса (ТЗ 0040 фаза C).
 * 
 * До этого программу можно было только загрузить Excel-импортом из
 * Django-админки: опечатка чинилась перезаливкой файла целиком.
 */
export type SetCourseProgram = {
  __typename?: 'SetCourseProgram';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  modules?: Maybe<Scalars['Int']>;
  lessons?: Maybe<Scalars['Int']>;
  lessonsRemoved?: Maybe<Scalars['Int']>;
  lessonsWithoutMarketing?: Maybe<Scalars['Int']>;
};

export type ProgramModuleInput = {
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  lessons?: Maybe<Array<ProgramLessonInput>>;
};

export type ProgramLessonInput = {
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  taskTypes?: Maybe<Array<Scalars['String']>>;
  lmsDescription?: Maybe<Scalars['String']>;
  marketingModuleId?: Maybe<Scalars['ID']>;
};

/**
 * Завести или переписать анкету в справочнике (ТЗ 0040 фаза B).
 * 
 * Раньше это была `SetCareerLessonExercise`: анкета собиралась ВНУТРИ урока
 * и жила только в нём. Владелец попросил обратного — «создавать на отдельной
 * странице, потом прикреплять к урокам», — и мутация переехала на шаблон.
 */
export type SaveCareerExerciseTemplate = {
  __typename?: 'SaveCareerExerciseTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<CareerExerciseTemplateType>;
};

export type CareerExerciseFieldInput = {
  id?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  helpText?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  fieldType: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Scalars['String']>>;
  maxLength?: Maybe<Scalars['Int']>;
  binding?: Maybe<Scalars['String']>;
  bindingLanguage?: Maybe<Scalars['String']>;
};

/**
 * Скрыть или вернуть анкету. Удаления нет: оно снесло бы сдачи вместе с
 * журналом того, что уехало студентам в резюме.
 */
export type ToggleCareerExerciseTemplate = {
  __typename?: 'ToggleCareerExerciseTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  template?: Maybe<CareerExerciseTemplateType>;
};

/** Прикрепить анкету из справочника к уроку. */
export type AttachCareerExerciseTemplate = {
  __typename?: 'AttachCareerExerciseTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
};

/** Снять анкету с урока. */
export type DetachCareerExerciseTemplate = {
  __typename?: 'DetachCareerExerciseTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
};

/**
 * Аварийный выход: снять сдачи, чтобы можно было переделать анкету.
 * 
 * 🔴 Снимает сдачи по ВСЕМ урокам, куда анкета прикреплена, — замок общий,
 * и половинчатый сброс оставил бы его запертым без объяснения. НЕ удаляет
 * `CareerLessonProgress` (иначе одна опечатка методиста перезакрыла бы урок
 * всему потоку) и НЕ откатывает записанное в резюме: эти данные уже
 * принадлежат студенту. Асимметрию надо писать в подтверждении прямым
 * текстом.
 */
export type ResetCareerExerciseTemplate = {
  __typename?: 'ResetCareerExerciseTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deletedSubmissions?: Maybe<Scalars['Int']>;
};

/** Сдача анкеты студентом (LMS). */
export type SubmitCareerLessonExercise = {
  __typename?: 'SubmitCareerLessonExercise';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonsCompleted?: Maybe<Scalars['Int']>;
  lessonsTotal?: Maybe<Scalars['Int']>;
  submission?: Maybe<CareerExerciseSubmissionType>;
  applyReport?: Maybe<CareerExerciseApplyReportType>;
  reward?: Maybe<GrowthRewardType>;
};

/** Что попало в резюме, а что пропущено и почему (ТЗ 0039). */
export type CareerExerciseApplyReportType = {
  __typename?: 'CareerExerciseApplyReportType';
  writtenTargets: Array<Scalars['String']>;
  skippedTargets: Array<Scalars['String']>;
  profileCompleteness: Scalars['Int'];
};

export type CareerExerciseAnswerInput = {
  fieldId: Scalars['ID'];
  value?: Maybe<Scalars['JSONString']>;
};

/**
 * LMS: студент выбирает трек целью (ТЗ 0039).
 * 
 * Открыто ЛЮБОМУ студенту, а не только участнику карьерного центра: трек —
 * продающая поверхность, и требовать членства значит показать её только тем,
 * кто уже выпустился.
 */
export type ChooseGrowthTrack = {
  __typename?: 'ChooseGrowthTrack';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  trackCode?: Maybe<Scalars['String']>;
};

/** Завести или поправить акцию (ТЗ 0039, шаг 6). */
export type UpsertPromoCampaign = {
  __typename?: 'UpsertPromoCampaign';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  campaignId?: Maybe<Scalars['ID']>;
};

export type PromoCampaignInput = {
  id?: Maybe<Scalars['ID']>;
  code: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  discountKind?: Maybe<Scalars['String']>;
  discountValue?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  ttlDays?: Maybe<Scalars['Int']>;
  hardExpiresAt?: Maybe<Scalars['Date']>;
  maxCodes?: Maybe<Scalars['Int']>;
  ruleKind?: Maybe<Scalars['String']>;
  ruleParams?: Maybe<Scalars['JSONString']>;
};

/** Включить или выключить акцию. Удаления нет: коды уже у людей на руках. */
export type SetPromoCampaignActive = {
  __typename?: 'SetPromoCampaignActive';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** Выдать код конкретному студенту руками — в обход правила. */
export type IssuePromoCode = {
  __typename?: 'IssuePromoCode';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  code?: Maybe<Scalars['String']>;
};

/** Отозвать код. Студенту он перестаёт показываться. */
export type RevokePromoCode = {
  __typename?: 'RevokePromoCode';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Кнопка «Проверить сейчас».
 * 
 * То же, что делает ночная задача. Сверка НЕ трогает деньги: ни договор, ни
 * взносы, ни фактуры — она лишь помечает коды использованными.
 */
export type ReconcilePromoCodes = {
  __typename?: 'ReconcilePromoCodes';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  checked?: Maybe<Scalars['Int']>;
  redeemed?: Maybe<Scalars['Int']>;
  ambiguous?: Maybe<Scalars['Int']>;
  expired?: Maybe<Scalars['Int']>;
};

/**
 * LMS: студент нажал «Поделиться» (ТЗ 0039, шаг 7).
 * 
 * 🔴 Повторное нажатие возвращает `counted=false`, а НЕ ошибку: бонус за этот
 * канал уже выдан, но делиться можно сколько угодно, и ошибка на кнопке
 * «Поделиться» читается как поломка.
 * 
 * ⚠️ Мутация фиксирует нажатие НАШЕЙ кнопки, а не публикацию: проверить
 * публикацию у LinkedIn и Facebook невозможно без OAuth от имени студента.
 * 
 * Медали и коды возвращаются СРАЗУ, чтобы фронт показал награду без
 * перезапроса — иначе связь между действием и наградой теряется.
 */
export type RegisterShare = {
  __typename?: 'RegisterShare';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  result?: Maybe<ShareResultType>;
};

/** Итог нажатия: засчитано ли и что за это дали. */
export type ShareResultType = {
  __typename?: 'ShareResultType';
  counted: Scalars['Boolean'];
  grantedTitles: Array<Scalars['String']>;
  promoCodes: Array<Scalars['String']>;
};

/** ERP: текст поста правится БЕЗ выката — это маркетинг, а не интерфейс. */
export type UpsertShareTemplate = {
  __typename?: 'UpsertShareTemplate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type ShareTemplateInput = {
  channel: Scalars['String'];
  language: Scalars['String'];
  text: Scalars['String'];
  targetUrl?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
};

/** Отозвать выданный токен: клиент отключится немедленно. */
export type RevokeMcpConnectionMutation = {
  __typename?: 'RevokeMcpConnectionMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** Attach or replace one student's diploma in one language. */
export type UploadStudentDiplomaMutation = {
  __typename?: 'UploadStudentDiplomaMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  diploma?: Maybe<DiplomaType>;
};

/**
 * Detach a diploma. The S3 object is left in place deliberately — a
 * student may hold a live signed URL, and a leaked object beats a document
 * that vanished mid-download. The orphaned key goes to the audit log.
 */
export type DeleteStudentDiplomaMutation = {
  __typename?: 'DeleteStudentDiplomaMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

/**
 * Dry-run: propose a (student, language) for each file NAME.
 * 
 * A mutation rather than a query only because clients treat it as an action;
 * it performs no writes.
 */
export type MatchDiplomaFilesMutation = {
  __typename?: 'MatchDiplomaFilesMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  preview?: Maybe<DiplomaMatchPreviewType>;
};

export type DiplomaMatchPreviewType = {
  __typename?: 'DiplomaMatchPreviewType';
  rows: Array<DiplomaMatchRowType>;
  unmatchedStudents: Array<UnmatchedStudentType>;
  summary: DiplomaMatchSummaryType;
};

/**
 * One dry-run match result. `file_name` is the join key back to the
 * client's File objects — the commit sends explicit ids, never a match.
 */
export type DiplomaMatchRowType = {
  __typename?: 'DiplomaMatchRowType';
  fileName: Scalars['String'];
  status: Scalars['String'];
  language?: Maybe<DiplomaLanguageEnum>;
  matchedBy?: Maybe<Scalars['String']>;
  confidence?: Maybe<Scalars['Float']>;
  student?: Maybe<DiplomaStudentType>;
  candidates: Array<DiplomaCandidateType>;
  /** Non-null ⇒ committing this row OVERWRITES an existing diploma. The commit refuses unless the operator confirmed that specific row. */
  wouldReplace?: Maybe<DiplomaType>;
};

export type DiplomaCandidateType = {
  __typename?: 'DiplomaCandidateType';
  student: DiplomaStudentType;
  fullName?: Maybe<Scalars['String']>;
};

/**
 * The inverse view — answers «did I miss anyone?», which the operator
 * needs more than the per-file errors.
 */
export type UnmatchedStudentType = {
  __typename?: 'UnmatchedStudentType';
  student: DiplomaStudentType;
  fullName?: Maybe<Scalars['String']>;
  missingLanguages: Array<Scalars['String']>;
};

export type DiplomaMatchSummaryType = {
  __typename?: 'DiplomaMatchSummaryType';
  total: Scalars['Int'];
  matched: Scalars['Int'];
  ambiguous: Scalars['Int'];
  noMatch: Scalars['Int'];
  duplicates: Scalars['Int'];
  willReplace: Scalars['Int'];
};

/**
 * Create (if needed) and RECONCILE the group's SendGrid contact list.
 * 
 * Idempotent — contacts are upserted by email, so re-running re-syncs rather
 * than duplicating; members who are no longer active students of the group
 * are taken out of the list (ТЗ 0112 #153). SendGrid processes the upload asynchronously, so the
 * contact count updates a few seconds later.
 */
export type SyncGroupSendgridList = {
  __typename?: 'SyncGroupSendgridList';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  list?: Maybe<SendgridGroupListType>;
};

/**
 * Send a dynamic-template email to selected students of a group.
 * 
 * Each recipient gets their OWN message with their own name, amount and pay
 * link — never a shared blast. Returns the job id to poll (`mailJob`) for live
 * progress and per-recipient delivery status.
 */
export type SendGroupTemplateEmail = {
  __typename?: 'SendGroupTemplateEmail';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  mailJobId?: Maybe<Scalars['ID']>;
  total?: Maybe<Scalars['Int']>;
};

export type MailRecipientInput = {
  studentId: Scalars['ID'];
  /** Invoice to reference in the email. Omit for templates that don't mention one (e.g. 'course starts soon'). */
  invoiceId?: Maybe<Scalars['ID']>;
};

/**
 * Student submits (or replaces) their homework: a GitHub link AND/OR a
 * ZIP archive (at least one, both allowed together). Re-submitting after
 * grading resets the grade. No teacher assignment is required (rev.3).
 */
export type SubmitHomeworkMutation = {
  __typename?: 'SubmitHomeworkMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  submission?: Maybe<MyHomeworkSubmissionType>;
};

/**
 * Teacher creates or edits the lesson's homework assignment (backed by
 * materials.Material kind=HOMEWORK; ≤1 per lesson via this path).
 */
export type UpsertHomeworkAssignmentMutation = {
  __typename?: 'UpsertHomeworkAssignmentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  assignment?: Maybe<HomeworkAssignmentType>;
};

/**
 * Teacher grades a student's homework — with or without a submission
 * (non-submitters get `not_done`). Writes through to
 * journals.StudentsMark.hw_mark; the comment lives on the submission.
 */
export type GradeHomeworkMutation = {
  __typename?: 'GradeHomeworkMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  row?: Maybe<HomeworkRosterRowType>;
};

/**
 * Teacher re-queues the AI analysis of a submission («Перепроверить»).
 * Answers AI_DISABLED while the HOMEWORK_AI_ENABLED flag is off.
 */
export type RerunHomeworkAiReviewMutation = {
  __typename?: 'RerunHomeworkAiReviewMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  aiReviewStatus?: Maybe<Scalars['String']>;
};

export type CreateSurveyMutation = {
  __typename?: 'CreateSurveyMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  survey?: Maybe<SurveyType>;
};

export type SurveyInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  defaultLessonNumber?: Maybe<Scalars['Int']>;
  questions: Array<SurveyQuestionInput>;
};

export type SurveyQuestionInput = {
  id?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
  questionType: Scalars['String'];
  metric?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  options?: Maybe<Array<Scalars['String']>>;
};

export type UpdateSurveyMutation = {
  __typename?: 'UpdateSurveyMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  survey?: Maybe<SurveyType>;
};

export type ArchiveSurveyMutation = {
  __typename?: 'ArchiveSurveyMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  survey?: Maybe<SurveyType>;
};

export type DuplicateSurveyMutation = {
  __typename?: 'DuplicateSurveyMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  survey?: Maybe<SurveyType>;
};

export type AssignSurveyToGroupMutation = {
  __typename?: 'AssignSurveyToGroupMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  assignment?: Maybe<SurveyAssignmentType>;
};

/**
 * Bulk MANUAL attach (spec 0038) — the plural of assignSurveyToGroup.
 * 
 * Not built on setSurveyTargeting: that replaces the whole targeting block,
 * so «add these groups» would become read-modify-write, where one dropped
 * field silently destroys a rule and its assignments. The rows created here
 * are ordinary manual ones that rule resolution never touches.
 * 
 * `success: true` WITH a populated `skipped[]` is the normal outcome, same
 * contract as setSurveyTargeting — a group without lesson N must not fail
 * the other twenty.
 */
export type AssignSurveyToGroupsMutation = {
  __typename?: 'AssignSurveyToGroupsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  createdCount?: Maybe<Scalars['Int']>;
  assignments?: Maybe<Array<SurveyAssignmentType>>;
  skipped?: Maybe<Array<SurveyTargetingSkipType>>;
};

/**
 * Bulk-assign question topics (spec 0038).
 * 
 * Deliberately NOT routed through `updateSurvey`: that takes a whole survey
 * payload and would make retagging 40 questions across 12 surveys twelve
 * read-modify-write round trips. A topic is a label, not part of the answer
 * contract, so it stays editable even on a survey that already has answers —
 * that is precisely how historical surveys enter the analytics.
 */
export type SetQuestionMetricsMutation = {
  __typename?: 'SetQuestionMetricsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  changedCount?: Maybe<Scalars['Int']>;
};

export type QuestionMetricInput = {
  questionId: Scalars['ID'];
  metric: Scalars['String'];
};

export type UpdateSurveyAssignmentMutation = {
  __typename?: 'UpdateSurveyAssignmentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  assignment?: Maybe<SurveyAssignmentType>;
};

export type DeleteSurveyAssignmentMutation = {
  __typename?: 'DeleteSurveyAssignmentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Replace the survey's whole «Аудитория и триггер» block.
 * 
 * One bulk call, not N `assignSurveyToGroup`s: dropping a group from a rule
 * needs a diff against the previous state, which only the server holds.
 * 
 * `success: true` WITH a populated `targeting.skipped[]` is the normal
 * outcome — the rules saved and some groups simply have no lesson N. Only
 * rule-level problems (INVALID_PLAN / COURSE_MISMATCH / PLAN_LOCKED /
 * ARCHIVED / NOT_FOUND) come back as customErrors with success=False.
 */
export type SetSurveyTargetingMutation = {
  __typename?: 'SetSurveyTargetingMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  targeting?: Maybe<SurveyTargetingType>;
};

/**
 * One targeting rule (spec 0027). `id` present = update that rule,
 * absent = create; a saved rule the client omits is deleted.
 */
export type SurveyPlanInput = {
  id?: Maybe<Scalars['ID']>;
  /** 'groups' (frozen list) | 'course' (live rule, picks up future groups too). */
  scope: Scalars['String'];
  /** Required for scope='course' unless the survey is already course-bound. */
  courseId?: Maybe<Scalars['ID']>;
  onlyActiveGroups?: Maybe<Scalars['Boolean']>;
  /** 'lesson_number' | 'last_lesson'. Both resolve to a concrete lesson — that is what keeps the student's agreement bounds and the teacher attribution working. */
  triggerKind: Scalars['String'];
  triggerLessonNumber?: Maybe<Scalars['Int']>;
  skipPastLessons?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  groupIds?: Maybe<Array<Scalars['ID']>>;
};

export type SubmitSurveyResponseMutation = {
  __typename?: 'SubmitSurveyResponseMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type SurveyAnswerInput = {
  questionId: Scalars['ID'];
  value: Scalars['JSONString'];
};

export type CreateLessonWhiteboardMutation = {
  __typename?: 'CreateLessonWhiteboardMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  whiteboard?: Maybe<WhiteboardType>;
};

export type LinkLessonWhiteboardMutation = {
  __typename?: 'LinkLessonWhiteboardMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  whiteboard?: Maybe<WhiteboardType>;
};

export type SaveWhiteboardSceneMutation = {
  __typename?: 'SaveWhiteboardSceneMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  whiteboard?: Maybe<WhiteboardType>;
  sceneVersion?: Maybe<Scalars['Int']>;
};

/** Full-list save of the school-wide component library (spec 0010 rev.2). */
export type SaveWhiteboardLibraryMutation = {
  __typename?: 'SaveWhiteboardLibraryMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  library?: Maybe<WhiteboardLibraryType>;
  version?: Maybe<Scalars['Int']>;
};

/**
 * Pastes an image onto a board (spec 0010 rev.3): the bytes go to the
 * private bucket, the scene keeps only the fileId reference.
 */
export type UploadWhiteboardFileMutation = {
  __typename?: 'UploadWhiteboardFileMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  file?: Maybe<WhiteboardFileType>;
};

export type RenameWhiteboardMutation = {
  __typename?: 'RenameWhiteboardMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  whiteboard?: Maybe<WhiteboardType>;
};

export type UnlinkLessonWhiteboardMutation = {
  __typename?: 'UnlinkLessonWhiteboardMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  whiteboard?: Maybe<WhiteboardType>;
};

export type CreateMaterialMutation = {
  __typename?: 'CreateMaterialMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  material?: Maybe<MaterialType>;
};

export type CreateMaterialInput = {
  groupId: Scalars['ID'];
  lessonId?: Maybe<Scalars['ID']>;
  kind: MaterialKindEnum;
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
};

export type UpdateMaterialMutation = {
  __typename?: 'UpdateMaterialMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  material?: Maybe<MaterialType>;
};

export type UpdateMaterialInput = {
  kind?: Maybe<MaterialKindEnum>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  lessonId?: Maybe<Scalars['ID']>;
};

export type DeleteMaterialMutation = {
  __typename?: 'DeleteMaterialMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type EmailAttachmentDraftType = {
  __typename?: 'EmailAttachmentDraftType';
  id: Scalars['ID'];
  name: Scalars['String'];
  size: Scalars['Int'];
  mime: Scalars['String'];
};

/**
 * On-demand «обновить сообщения»: enqueue a Slack backfill PLUS a Gmail
 * backfill of the latest mail (metadata-first, so it's cheap). Without
 * group_id it syncs every ENABLED workspace of an ACTIVE group (last lesson
 * within SYNC_ACTIVE_DAYS, or no lessons yet — spec 0032; the old predicate
 * demanded a FUTURE lesson and on real data matched nothing) plus legacy
 * channel links; with group_id it
 * syncs that group's workspace regardless of activity — the group-card
 * button keeps working for finished groups. Async via Celery — the button
 * returns immediately; new messages appear once the worker finishes.
 */
export type SyncCommunicationsNowMutation = {
  __typename?: 'SyncCommunicationsNowMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued?: Maybe<Scalars['Boolean']>;
};

/**
 * On-demand 'refresh mail' button: enqueue a Gmail backfill of the latest
 * ~100 messages per mailbox. Runs async via Celery so the request returns
 * immediately; the new mail appears once the worker finishes.
 */
export type SyncGmailNowMutation = {
  __typename?: 'SyncGmailNowMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued?: Maybe<Scalars['Boolean']>;
};

/**
 * Reply into a Slack conversation; mirrors the sent message locally.
 * 
 * После успешной отправки входящее, которое менеджер видел
 * (`seenMessageId`; `null` — ничего; не передан — всё до ответа), —
 * прочитано и обработано (`mark_answered`); ошибка Slack — ничего не
 * помечается.
 */
export type SendSlackMessageMutation = {
  __typename?: 'SendSlackMessageMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  /** Диалог после ответа: входящее, которое менеджер видел (`seenMessageId`; `null` — ничего; не передан — всё до ответа), прочитано и обработано. */
  conversation?: Maybe<ConversationType>;
  /** Сообщения, которые ответ сделал прочитанными. */
  readMessageIds?: Maybe<Array<Scalars['ID']>>;
  /** Входящие, которые ответ сделал обработанными. */
  handledMessageIds?: Maybe<Array<Scalars['ID']>>;
  /** Списки id неполные — тред нужно перечитать. */
  truncated?: Maybe<Scalars['Boolean']>;
  message?: Maybe<MessageType>;
};

/**
 * Post a message into one of a group's Slack channels — including the
 * FIRST one, before any Conversation mirror exists. Lets a manager start a
 * channel thread instead of only replying into an existing dialog.
 */
export type SendSlackChannelMessage = {
  __typename?: 'SendSlackChannelMessage';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  conversationId?: Maybe<Scalars['ID']>;
};

/**
 * Open a Slack DM with a student OR a teacher and post the first message,
 * before any Conversation exists — so a manager can write first. Sent AS the
 * manager (his xoxp user token; a bot can't hold a 1:1 DM).
 */
export type StartSlackDm = {
  __typename?: 'StartSlackDm';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  conversationId?: Maybe<Scalars['ID']>;
};

/**
 * Reply into a Gmail thread; mirrors the sent message locally.
 * 
 * После успешной отправки входящее, которое менеджер видел
 * (`seenMessageId`; `null` — ничего; не передан — всё до ответа), —
 * прочитано и обработано (`mark_answered`); ошибка Gmail — ничего не
 * помечается.
 */
export type SendGmailReplyMutation = {
  __typename?: 'SendGmailReplyMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  /** Диалог после ответа: входящее, которое менеджер видел (`seenMessageId`; `null` — ничего; не передан — всё до ответа), прочитано и обработано. */
  conversation?: Maybe<ConversationType>;
  /** Сообщения, которые ответ сделал прочитанными. */
  readMessageIds?: Maybe<Array<Scalars['ID']>>;
  /** Входящие, которые ответ сделал обработанными. */
  handledMessageIds?: Maybe<Array<Scalars['ID']>>;
  /** Списки id неполные — тред нужно перечитать. */
  truncated?: Maybe<Scalars['Boolean']>;
  message?: Maybe<MessageType>;
};

/**
 * Compose and send a BRAND-NEW email from a chosen shared mailbox (not a
 * reply). Mirrors it locally as a new gmail-thread conversation.
 */
export type SendNewEmailMutation = {
  __typename?: 'SendNewEmailMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  conversationId?: Maybe<Scalars['ID']>;
};

/**
 * Send ONE message to many students of a group INDIVIDUALLY — a private
 * Slack DM or a single email each (never a group blast). Runs as a paced
 * background task; returns the broadcast job id the client polls (`broadcast
 * Job`) for live progress and the per-recipient outcome.
 */
export type BroadcastGroupMessage = {
  __typename?: 'BroadcastGroupMessage';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  broadcastJobId?: Maybe<Scalars['ID']>;
  total?: Maybe<Scalars['Int']>;
};

/**
 * Map a Slack user id to a Student OR a Teacher (for DM mirroring). The
 * manual fallback for auto-matching by email — a person may sit in Slack
 * under an email we don't know.
 */
export type LinkSlackUserMutation = {
  __typename?: 'LinkSlackUserMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** Map a Slack channel id to a Group. */
export type LinkChannelGroupMutation = {
  __typename?: 'LinkChannelGroupMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** Mark one message read/unread (team-wide global state). */
export type MarkMessageReadMutation = {
  __typename?: 'MarkMessageReadMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
};

/** Flag/unflag one message (team-wide global state). */
export type FlagMessageMutation = {
  __typename?: 'FlagMessageMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
};

/**
 * Mark one message handled/unhandled — обработано (team-wide global).
 * 
 * With `cascade` (spec 0030) the tick also closes everything ABOVE it in
 * the same dialog: reading and handling a later message means the earlier
 * ones were dealt with too, which is how a human actually works a thread.
 * Un-ticking never cascades — see the branch below.
 */
export type SetMessageHandledMutation = {
  __typename?: 'SetMessageHandledMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  conversation?: Maybe<ConversationType>;
  readMessageIds?: Maybe<Array<Scalars['ID']>>;
  handledMessageIds?: Maybe<Array<Scalars['ID']>>;
  truncated?: Maybe<Scalars['Boolean']>;
};

/**
 * Set the read flag on every message of a conversation.
 * 
 * `read=false` is «Вернуть в работу»: it clears `is_handled` on the inbound
 * messages too (spec 0030 round 2). Clearing only `is_read` produced an
 * unread-but-handled dialog, which is EXCLUDED from the `unhandledOnly`
 * queue — so the manager's "I'll come back to this" gesture removed the
 * dialog from the very list they come back through. It is also the only
 * thread-level way back from a cascade or a bulk clear.
 */
export type MarkConversationReadMutation = {
  __typename?: 'MarkConversationReadMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  updated?: Maybe<Scalars['Int']>;
  conversation?: Maybe<ConversationType>;
};

/**
 * Bulk «Прочитано и обработано» over a scope (spec 0030).
 * 
 * The whole point of the communicator rework: closing an inbox used to cost
 * one click per message per student per channel. This sets both flags over
 * a whole dialog, student, group, or the entire filtered browser list, in a
 * constant number of statements.
 * 
 * Reversible, not one-directional (round 2): the payload carries the exact
 * ids it flipped so `revertMessagesTriage` can put them back. Both UPDATEs
 * only ever go False → True, so reverting those very rows to False restores
 * the prior state exactly — no "was it already read?" guessing.
 */
export type MarkConversationsHandledMutation = {
  __typename?: 'MarkConversationsHandledMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  messagesRead?: Maybe<Scalars['Int']>;
  messagesHandled?: Maybe<Scalars['Int']>;
  messagesAffected?: Maybe<Scalars['Int']>;
  conversationsAffected?: Maybe<Scalars['Int']>;
  truncated?: Maybe<Scalars['Boolean']>;
  conversations?: Maybe<Array<ConversationType>>;
  readMessageIds?: Maybe<Array<Scalars['ID']>>;
  handledMessageIds?: Maybe<Array<Scalars['ID']>>;
  undoable?: Maybe<Scalars['Boolean']>;
};

/**
 * Undo for a triage action — put exactly these rows back (spec 0030 r2).
 * 
 * Both the bulk clear and the per-message cascade only ever flip
 * False → True, so clearing the very ids they reported restores the prior
 * state exactly. That is why undo takes explicit ids rather than a scope:
 * re-deriving the set would also catch rows that were already read before,
 * and un-read them.
 * 
 * Deliberately no separate permission tier: whoever may clear may un-clear.
 */
export type RevertMessagesTriageMutation = {
  __typename?: 'RevertMessagesTriageMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  messagesReverted?: Maybe<Scalars['Int']>;
  conversations?: Maybe<Array<ConversationType>>;
};

/** Set a conversation's handling status (open / in_progress / done). */
export type SetConversationStatusMutation = {
  __typename?: 'SetConversationStatusMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  conversation?: Maybe<ConversationType>;
};

/**
 * Bind (or update) the Slack workspace for a group. Only the bot token is
 * really needed (no OAuth flow): a blank team id is resolved via auth.test.
 * `team_id` stays as an advanced override; `signing_secret` matters only for
 * the optional realtime webhook.
 */
export type SetSlackWorkspaceMutation = {
  __typename?: 'SetSlackWorkspaceMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Save the ACTING manager's personal Slack user token (xoxp) for a
 * group's workspace — DM replies to students then go out as the manager
 * himself, and his person-to-person DMs become pullable by sync. The token
 * is validated via auth.test and must belong to the group's workspace.
 * Write-only: no query ever returns it.
 */
export type SetMySlackUserTokenMutation = {
  __typename?: 'SetMySlackUserTokenMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Return a signed Slack authorize URL so the ACTING manager can grant his
 * personal xoxp user token for a group's workspace in one click — no
 * api.slack.com, no copy-paste. The browser then navigates to Slack; on
 * "Allow" Slack redirects to `slack_oauth_callback`, which stores the token.
 * 
 * Identity + group are captured HERE (under the JWT this mutation runs behind)
 * and sealed into a short-lived signed `state` (django.core.signing), because
 * the callback is a plain browser redirect that carries no JWT.
 */
export type StartSlackUserOauthMutation = {
  __typename?: 'StartSlackUserOauthMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  authorizeUrl?: Maybe<Scalars['String']>;
};

/**
 * Spin a staff task off a student's message («создать задачу из вопроса»).
 * 
 * The task inherits the conversation's student/group; the assignee defaults
 * to the acting manager and must always be ERP staff. Side effects record
 * the reaction: the message is marked handled + linked to the task, and an
 * `open` conversation moves to `in_progress`. One task per message — a
 * retry / second manager gets `already_linked` instead of a duplicate.
 */
export type CreateTaskFromMessageMutation = {
  __typename?: 'CreateTaskFromMessageMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  task?: Maybe<StaffTaskType>;
  message?: Maybe<MessageType>;
  conversation?: Maybe<ConversationType>;
};

/**
 * ТЗ 0083: привязать сотруднику рабочую почту Google Workspace (пустой
 * адрес — отвязать). Только Admin: указавший адрес получает доступ к
 * письмам этого ящика в ERP.
 */
export type SetStaffMailboxMutation = {
  __typename?: 'SetStaffMailboxMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  mailbox?: Maybe<StaffMailboxType>;
};

/**
 * ТЗ 0083: проба доступа к рабочей почте через Google. Без `userId` —
 * своя почта (любой сотрудник); чужая — только Admin.
 */
export type CheckStaffMailboxMutation = {
  __typename?: 'CheckStaffMailboxMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  /** null — проверка не выполнялась (локальный стенд) */
  ok?: Maybe<Scalars['Boolean']>;
  /** OK | NO_ACCESS | NO_MAILBOX | local */
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type PlannedPaymentMutationOutput = {
  __typename?: 'PlannedPaymentMutationOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  plannedPayment?: Maybe<PlannedPaymentType>;
};

export type PlannedPaymentInput = {
  direction: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  amount: Scalars['Float'];
  currency?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  relatedTeacherId?: Maybe<Scalars['ID']>;
  relatedGroupId?: Maybe<Scalars['ID']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  relatedContributionId?: Maybe<Scalars['ID']>;
  relatedFakturowniaInvoiceId?: Maybe<Scalars['ID']>;
  relatedApplicationId?: Maybe<Scalars['ID']>;
  periodYear?: Maybe<Scalars['Int']>;
  periodMonth?: Maybe<Scalars['Int']>;
  relatedExpenseId?: Maybe<Scalars['ID']>;
  periodDate?: Maybe<Scalars['Date']>;
  recurrence?: Maybe<Scalars['String']>;
  recurrenceDay?: Maybe<Scalars['Int']>;
  recurrenceUntil?: Maybe<Scalars['Date']>;
};

export type UpdatePlannedPaymentInput = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  relatedTeacherId?: Maybe<Scalars['ID']>;
  relatedGroupId?: Maybe<Scalars['ID']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  recurrence?: Maybe<Scalars['String']>;
  recurrenceDay?: Maybe<Scalars['Int']>;
  recurrenceUntil?: Maybe<Scalars['Date']>;
};

export type DeletePlannedPaymentOutput = {
  __typename?: 'DeletePlannedPaymentOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CashBalanceMutationOutput = {
  __typename?: 'CashBalanceMutationOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  cashBalance?: Maybe<CashBalanceSnapshotType>;
};

export type ExchangeRateMutationOutput = {
  __typename?: 'ExchangeRateMutationOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  exchangeRate?: Maybe<ExchangeRateType>;
};

export type CalendarSettingsMutationOutput = {
  __typename?: 'CalendarSettingsMutationOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  calendarSettings?: Maybe<PaymentCalendarSettingsType>;
};

/**
 * A preview the operator looks at before committing, or the commit itself.
 * 
 * `alreadyImported` is the guard against the commonest operator mistake —
 * re-uploading last month's file. It is answered from `file_hash` BEFORE
 * parsing, so the answer costs nothing.
 * 
 * `accountName` is the guard against the *expensive* one. When an account has
 * no IBAN on file yet there is nothing to contradict the operator's choice,
 * so a wrong pick would land a whole statement on the wrong account. Naming
 * the resolved account in the preview is what makes that visible while it is
 * still a preview.
 */
export type BankStatementUploadOutput = {
  __typename?: 'BankStatementUploadOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Счёт, на который лягут строки — по номеру из файла либо по явно выбранному. */
  accountName?: Maybe<Scalars['String']>;
  /** Файл сообщил счёту его номер: дальше выбирать не нужно. */
  accountIbanLearned?: Maybe<Scalars['Boolean']>;
  /** Итог четырёх шагов, отработавших сразу за импортом: что разнесено, спарено, распознано как выплата шлюза и привязано к документам. `null`, если это предпросмотр или обработку выключили аргументом `process`. */
  processingStats?: Maybe<Scalars['JSONString']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  alreadyImported?: Maybe<Scalars['Boolean']>;
  run?: Maybe<BankStatementImportType>;
};

export type CashFlowRunOutput = {
  __typename?: 'CashFlowRunOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  dryRun?: Maybe<Scalars['Boolean']>;
  stats?: Maybe<Scalars['JSONString']>;
};

export type CashFlowSettingsOutput = {
  __typename?: 'CashFlowSettingsOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  settings?: Maybe<CashFlowSettingsType>;
};

export type SetCategoryOutput = {
  __typename?: 'SetCategoryOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  transaction?: Maybe<BankTransactionType>;
  ruleOutcome?: Maybe<Scalars['String']>;
  ruleReason?: Maybe<Scalars['String']>;
  rule?: Maybe<CashFlowRuleType>;
  conflictingRule?: Maybe<CashFlowRuleType>;
  preview?: Maybe<RulePreviewType>;
};

/**
 * What learning a rule from this row would mean.
 * 
 * `wouldAffect` counts only rows automation is allowed to touch — promising to
 * reclassify something a human already decided would be a lie.
 */
export type RulePreviewType = {
  __typename?: 'RulePreviewType';
  keyKind?: Maybe<Scalars['String']>;
  keyValue?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  wouldAffect?: Maybe<Scalars['Int']>;
  samples?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BankTransactionOutput = {
  __typename?: 'BankTransactionOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  transaction?: Maybe<BankTransactionType>;
};

export type GatewaySettlementOutput = {
  __typename?: 'GatewaySettlementOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  settlement?: Maybe<GatewaySettlementType>;
};

export type ExpenseMutationOutput = {
  __typename?: 'ExpenseMutationOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  expense?: Maybe<ExpenseType>;
};

export type ExpenseInput = {
  date: Scalars['Date'];
  amount: Scalars['Float'];
  currency: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  counterpartyName?: Maybe<Scalars['String']>;
  counterpartyTaxNo?: Maybe<Scalars['String']>;
  relatedTeacherId?: Maybe<Scalars['ID']>;
  relatedGroupId?: Maybe<Scalars['ID']>;
  /** Link a received Fakturownia invoice — prefills and locks amount/currency/date/counterparty from it, sets source='fakturownia'. */
  relatedFakturowniaInvoiceId?: Maybe<Scalars['ID']>;
  documentUrl?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['Date']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  /** none | weekly | monthly (default none). */
  recurrence?: Maybe<Scalars['String']>;
  /** 1–31 for monthly recurrence. */
  recurrenceDay?: Maybe<Scalars['Int']>;
  recurrenceUntil?: Maybe<Scalars['Date']>;
  /** planned | confirmed | paid | cancelled (default planned). */
  status?: Maybe<Scalars['String']>;
};

export type UpdateExpenseInput = {
  id: Scalars['ID'];
  date?: Maybe<Scalars['Date']>;
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  counterpartyName?: Maybe<Scalars['String']>;
  counterpartyTaxNo?: Maybe<Scalars['String']>;
  relatedTeacherId?: Maybe<Scalars['ID']>;
  relatedGroupId?: Maybe<Scalars['ID']>;
  /** Link a received Fakturownia invoice — prefills and locks amount/currency/date/counterparty from it, sets source='fakturownia'. */
  relatedFakturowniaInvoiceId?: Maybe<Scalars['ID']>;
  documentUrl?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['Date']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  recurrence?: Maybe<Scalars['String']>;
  recurrenceDay?: Maybe<Scalars['Int']>;
  recurrenceUntil?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
};

export type DeleteExpenseMutation = {
  __typename?: 'DeleteExpenseMutation';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CreateExpenseCategoryMutation = {
  __typename?: 'CreateExpenseCategoryMutation';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  category?: Maybe<ExpenseCategoryType>;
};

export type FakturowniaMutationOutput = {
  __typename?: 'FakturowniaMutationOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  invoice?: Maybe<FakturowniaInvoiceType>;
  /** Machine code for the failure, e.g. AGREEMENT_STATE_PREFINANCED, MISSING_BUYER_ADDRESS, ISSUE_IN_FLIGHT. Null on success. */
  errorCode?: Maybe<Scalars['String']>;
  /** True when a document DEFINITELY exists in Fakturownia despite success=false. Not the whole at-risk set — errorCode=FAKTUROWNIA_AMBIGUOUS also means a document may exist. Check both before deciding not to warn. */
  documentCreated?: Maybe<Scalars['Boolean']>;
};

export type FakturowniaBillingJobEnqueueOutput = {
  __typename?: 'FakturowniaBillingJobEnqueueOutput';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  errorCode?: Maybe<Scalars['String']>;
  job?: Maybe<FakturowniaBillingJobType>;
  total?: Maybe<Scalars['Int']>;
  billableCount?: Maybe<Scalars['Int']>;
  skippedCount?: Maybe<Scalars['Int']>;
};

/**
 * Fire-and-forget: enqueue a Fakturownia sync via Celery.
 * 
 * The frontend pattern is: call this mutation → poll
 * `fakturownia_sync_status` until `is_running` flips back to false →
 * read `last_run.stats` to render "synced N invoices". The returned
 * `last_run` is the state *before* the new task starts so the UI can
 * show "synced 14:23 (… enqueueing new run …)" instantly.
 */
export type TriggerFakturowniaSyncMutation = {
  __typename?: 'TriggerFakturowniaSyncMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  /** Latest run *before* this trigger fired. Poll `fakturownia_sync_status` afterwards to see the new run. */
  lastRun?: Maybe<FakturowniaSyncRunType>;
};

/**
 * Group-scoped Fakturownia sync — docs/groups/group_dashboard.md §G10.
 * 
 * Same Celery task as `triggerFakturowniaSync`, but the dedup lock is
 * scoped per `(group_id, period)` so a busy operator can fire syncs
 * for several groups without the global trigger getting in the way.
 * The payer-email UNION (agreement.buyer_email + student.email) is
 * recorded in the audit log and the returned `message`; narrowing the
 * actual Fakturownia API call by that list is intentionally deferred —
 * the mirror only ever grows, and the new canonical `groupId` filter
 * (§G7) will surface the new rows on the group's FinancesTab as soon
 * as the sync completes.
 */
export type TriggerFakturowniaGroupSyncMutation = {
  __typename?: 'TriggerFakturowniaGroupSyncMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  /** Count of unique payer emails on the group's agreements + students. Recorded for audit; the API query itself is not narrowed yet. */
  emailsTargeted?: Maybe<Scalars['Int']>;
  lastRun?: Maybe<FakturowniaSyncRunType>;
};

/** Create students + agreements + first contribution from PandaDoc docs. */
export type ProvisionStudentsMutation = {
  __typename?: 'ProvisionStudentsMutation';
  results?: Maybe<Array<Maybe<ProvisionResultItem>>>;
  errors?: Maybe<Scalars['JSONString']>;
};

/** Per-document outcome of a provisioning run. */
export type ProvisionResultItem = {
  __typename?: 'ProvisionResultItem';
  pandadocId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  skipped?: Maybe<Scalars['Boolean']>;
  agreementId?: Maybe<Scalars['ID']>;
  error?: Maybe<Scalars['JSONString']>;
};

/**
 * One selected PandaDoc document, with optional manager corrections.
 * 
 * A document is provisioned only if it appears in this list — deselected
 * documents are simply omitted. Any non-null field overrides the value
 * parsed from PandaDoc (used mainly to supply a missing phone).
 */
export type ProvisionDocOverrideInput = {
  pandadocId: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  existingUserId?: Maybe<Scalars['ID']>;
};

/**
 * Enqueue a full PandaDoc re-sync (list + details, with student folder
 * backfill). Powers the dashboard 'refresh everything' button — the Celery
 * task self-chains until the whole details backlog is drained.
 */
export type TriggerPandadocSyncMutation = {
  __typename?: 'TriggerPandadocSyncMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<PandaDocSyncStatusType>;
};

/**
 * Re-extract signer contact data (email/phone/name) on already-synced
 * documents and re-pull the details of rows a local re-parse can't fix.
 * 
 * The repair button for «у студента нет договоров» / «новая папка не
 * появилась»: it applies the current parser to the whole cached inventory
 * instead of waiting for each document to change in PandaDoc.
 * 
 * Admin-only (unlike the plain sync): a run can queue the entire inventory
 * for a `/details` re-fetch, which costs hours of the PandaDoc rate-limit
 * budget.
 */
export type ReparsePandadocRecipientsMutation = {
  __typename?: 'ReparsePandadocRecipientsMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<PandaDocSyncStatusType>;
};

/**
 * Attach a PandaDoc document to an existing agreement (manual link from
 * the student card). Does not create a Student/Agreement and does not touch
 * `provisioned_at`.
 */
export type LinkPandadocDocumentMutation = {
  __typename?: 'LinkPandadocDocumentMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/** Detach a manually-linked PandaDoc document from its agreement. */
export type UnlinkPandadocDocumentMutation = {
  __typename?: 'UnlinkPandadocDocumentMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/**
 * Attach a `trainer` PandaDoc document to a Teacher (from the teacher
 * card). The teacher analog of LinkPandadocDocumentMutation.
 */
export type LinkPandadocTeacherMutation = {
  __typename?: 'LinkPandadocTeacherMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/** Detach a PandaDoc document from its teacher. */
export type UnlinkPandadocTeacherMutation = {
  __typename?: 'UnlinkPandadocTeacherMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

export type SyncZoomAccountsMutation = {
  __typename?: 'SyncZoomAccountsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type SyncZoomRecordingsMutation = {
  __typename?: 'SyncZoomRecordingsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** Sync accounts + every cloud recording in Zoom for a date range. */
export type SyncAllZoomRecordingsMutation = {
  __typename?: 'SyncAllZoomRecordingsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** Refresh the Zoom account usage summary (storage quota + counts). */
export type SyncZoomUsageMutation = {
  __typename?: 'SyncZoomUsageMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** One-call refresh: accounts + all recordings + account usage. */
export type RefreshAllZoomDataMutation = {
  __typename?: 'RefreshAllZoomDataMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type RunAutoMatchingMutation = {
  __typename?: 'RunAutoMatchingMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Manual Zoom sync scoped to one group — docs/groups/group_dashboard.md
 * §G9. Re-runs `sync_recordings` for the window and the matcher against
 * the group's lessons. 60-sec dedup lock per group so a frantic operator
 * doesn't queue ten copies.
 */
export type TriggerZoomGroupProcessMutation = {
  __typename?: 'TriggerZoomGroupProcessMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  enqueued?: Maybe<Scalars['Boolean']>;
  queuedCount?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type SetGroupZoomAccountMutation = {
  __typename?: 'SetGroupZoomAccountMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** Set a group's Zoom account and fully replace its processing slots. */
export type SetGroupZoomScheduleMutation = {
  __typename?: 'SetGroupZoomScheduleMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  schedules?: Maybe<Array<Maybe<GroupZoomScheduleType>>>;
};

export type GroupZoomScheduleSlotInput = {
  weekDay: Scalars['Int'];
  runTime: Scalars['Time'];
  isActive?: Maybe<Scalars['Boolean']>;
};

export type CreateManualLessonRecordingMutation = {
  __typename?: 'CreateManualLessonRecordingMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
};

export type UnlinkLessonRecordingMutation = {
  __typename?: 'UnlinkLessonRecordingMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type MarkLessonMissingRecordingMutation = {
  __typename?: 'MarkLessonMissingRecordingMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
};

export type RetryLessonRecordingMutation = {
  __typename?: 'RetryLessonRecordingMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
};

export type ReprocessAiMutation = {
  __typename?: 'ReprocessAiMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
};

export type DeleteZoomRecordingMutation = {
  __typename?: 'DeleteZoomRecordingMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  zoomRecording?: Maybe<ZoomRecordingType>;
};

/**
 * Удалить пачку записей одним подтверждением (ТЗ 0043).
 * 
 * До этого удаление было поштучным и требовало НАБРАТЬ РУКАМИ строку
 * «DELETE <pk>» на каждую запись. Чистка десятка видео превращалась в десять
 * диалогов с печатью идентификатора, и ей просто не пользовались.
 * 
 * Пакет не падает целиком из-за одной проблемной строки: каждая получает свой
 * исход, и оператор видит, что именно не ушло и почему.
 */
export type DeleteZoomRecordingsMutation = {
  __typename?: 'DeleteZoomRecordingsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued: Scalars['Int'];
  skipped: Scalars['Int'];
  rows: Array<ZoomBulkDeleteRowType>;
};

/** Исход по одной записи в пакетном удалении. */
export type ZoomBulkDeleteRowType = {
  __typename?: 'ZoomBulkDeleteRowType';
  id: Scalars['ID'];
  queued: Scalars['Boolean'];
  /** Почему запись пропущена; пусто, если поставлена в очередь. */
  reason?: Maybe<Scalars['String']>;
};

/**
 * Отправить утренний отчёт в Telegram сейчас. Выключен потолком/env
 * (`disabled_on_server`) или в «Настройках» (`disabled`) — отказ, задача
 * не ставится (и сама задача перепроверяет ключ при отправке).
 */
export type SendMorningReportMutation = {
  __typename?: 'SendMorningReportMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type CreateGroupMutation = {
  __typename?: 'CreateGroupMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};


export type GroupInput = {
  name: Scalars['String'];
  price: Scalars['Float'];
  currency: Scalars['String'];
  startDate: Scalars['Date'];
  course_id: Scalars['Int'];
  daysOfClass: Array<DayOfClassInput>;
};

export type DayOfClassInput = {
  weekDay: Scalars['Int'];
  startTime?: Maybe<Scalars['Time']>;
  endTime?: Maybe<Scalars['Time']>;
};

export type ModuleInput = {
  name: Scalars['String'];
  lessons: Array<Maybe<LessonInput>>;
};

export type LessonInput = {
  name: Scalars['String'];
  lmsDescription?: Maybe<Scalars['String']>;
  studentsAttachments?: Maybe<Array<Scalars['Int']>>;
  teachersAttachments?: Maybe<Array<Scalars['Int']>>;
  taskTypes?: Maybe<Array<Scalars['String']>>;
  additional?: Maybe<Scalars['Boolean']>;
};

export type UpdateGroupMutation = {
  __typename?: 'UpdateGroupMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type UpdateGroupInput = {
  name: Scalars['String'];
  price: Scalars['Float'];
  currency: Scalars['String'];
  startDate: Scalars['Date'];
  course_id: Scalars['Int'];
  daysOfClass: Array<DayOfClassInput>;
  modules: Array<Maybe<UpdateModuleInput>>;
};

export type UpdateModuleInput = {
  module_id: Scalars['Int'];
  lessons: Array<Maybe<UpdateLessonInput>>;
};

export type UpdateLessonInput = {
  lesson_id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['Int']>;
  application_id?: Maybe<Scalars['ID']>;
  additional?: Maybe<Scalars['Boolean']>;
};

export type DeleteGroupMutation = {
  __typename?: 'DeleteGroupMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type PublishGroupToLms = {
  __typename?: 'PublishGroupToLMS';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type ChangeLessonDate = {
  __typename?: 'ChangeLessonDate';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type UploadLessonVideo = {
  __typename?: 'UploadLessonVideo';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type CancelVideoUpload = {
  __typename?: 'CancelVideoUpload';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type SetGroupLessonLink = {
  __typename?: 'SetGroupLessonLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
};

export type SetGroupLessonLinkOverride = {
  __typename?: 'SetGroupLessonLinkOverride';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
};

export type ClearGroupLessonLinkOverride = {
  __typename?: 'ClearGroupLessonLinkOverride';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
};

export type LmsJoinLesson = {
  __typename?: 'LmsJoinLesson';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  redirectUrl?: Maybe<Scalars['String']>;
};

export type LmsSetTodayLessonLink = {
  __typename?: 'LmsSetTodayLessonLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type LmsClearTodayLessonLink = {
  __typename?: 'LmsClearTodayLessonLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type CreateLeadMutation = {
  __typename?: 'CreateLeadMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type LeadInput = {
  phone: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  course_id?: Maybe<Scalars['Int']>;
  tittle: Scalars['String'];
  referer?: Maybe<Scalars['String']>;
  formName: Scalars['String'];
  utmSource?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
  roistatId: Scalars['String'];
  promocode?: Maybe<Scalars['String']>;
  utmId?: Maybe<Scalars['String']>;
  gclid?: Maybe<Scalars['String']>;
  gbraid?: Maybe<Scalars['String']>;
  wbraid?: Maybe<Scalars['String']>;
  fbclid?: Maybe<Scalars['String']>;
  fbc?: Maybe<Scalars['String']>;
  fbp?: Maybe<Scalars['String']>;
  gaClientId?: Maybe<Scalars['String']>;
  pageUrl?: Maybe<Scalars['String']>;
  landingUrl?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  firstTouch?: Maybe<Scalars['JSONString']>;
  device?: Maybe<Scalars['String']>;
  adUserData?: Maybe<Scalars['String']>;
  adPersonalization?: Maybe<Scalars['String']>;
  visitorId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  leadType?: Maybe<Scalars['String']>;
  courseSlug?: Maybe<Scalars['String']>;
  materialSlug?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  interest?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type CreateBlackFridayLeadMutation = {
  __typename?: 'CreateBlackFridayLeadMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type BlackFridayLeadInput = {
  phone: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  course_id?: Maybe<Scalars['Int']>;
  tittle: Scalars['String'];
  referer?: Maybe<Scalars['String']>;
  formName: Scalars['String'];
  utmSource?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
  roistatId: Scalars['String'];
  promocode?: Maybe<Scalars['String']>;
};

export type CreateNewYearLeadMutation = {
  __typename?: 'CreateNewYearLeadMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type NewYearLeadInput = {
  phone: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  course_id?: Maybe<Scalars['Int']>;
  tittle: Scalars['String'];
  referer?: Maybe<Scalars['String']>;
  formName: Scalars['String'];
  utmSource?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
  roistatId: Scalars['String'];
  promocode?: Maybe<Scalars['String']>;
  age: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  message: Scalars['String'];
};

export type UpdateJournalsMutation = {
  __typename?: 'UpdateJournalsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type UpdateAttendanceMutation = {
  __typename?: 'UpdateAttendanceMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  attendance?: Maybe<AttendanceType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Поштучная отметка преподавателем из LMS (ТЗ 0026).
 * 
 * Заменяет пакетное сохранение внутри `finishLmsLesson`. Возвращает ту же
 * сущность `LessonAttendancesType`, что отдаёт `groupLessonAttendanceForLms`
 * — Apollo нормализует её по `id`, поэтому оптимистичное обновление на
 * фронте работает без ручного `cache.modify`.
 */
export type LmsSetAttendanceMutation = {
  __typename?: 'LmsSetAttendanceMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  attendance?: Maybe<LessonAttendancesType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * «Занятие проведено» + комментарий.
 * 
 * ТЗ 0026 забрал отсюда посещаемость: она сохраняется поштучно через
 * `lmsSetAttendance`. Аргумент `attendances` стал НЕобязательным — снятие
 * `required` обратно совместимо, поэтому старый бандл, оставшийся в кэше
 * браузера преподавателя после выката бэкенда, продолжит работать как
 * раньше. Удалять аргумент — следующим релизом.
 */
export type FinishLmsLessonMutation = {
  __typename?: 'FinishLmsLessonMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type LmsAttendanceType = {
  id: Scalars['Int'];
  attendance: Scalars['Boolean'];
};

export type SetStudentsMarksMutation = {
  __typename?: 'SetStudentsMarksMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  studentsMarks?: Maybe<StudentsMarkConnection>;
};


export type SetStudentsMarksMutationStudentsMarksArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type LessonMarkInput = {
  student_id: Scalars['Int'];
  mark?: Maybe<Scalars['Int']>;
  hwMark?: Maybe<StudentHwTypeEnum>;
};

/** An enumeration. */
export enum StudentHwTypeEnum {
  Done = 'DONE',
  ContainsErrors = 'CONTAINS_ERRORS',
  NotDone = 'NOT_DONE'
}

/** An enumeration. */
export enum LessonTaskTypeEnum {
  /** homework */
  Homework = 'homework',
  /** coursework */
  Coursework = 'coursework',
  /** graduation_project */
  GraduationProject = 'graduation_project'
}

export type CreateCourseMutation = {
  __typename?: 'CreateCourseMutation';
  course?: Maybe<CourseType>;
};

export type UpdateCourseMutation = {
  __typename?: 'UpdateCourseMutation';
  course?: Maybe<CourseType>;
};

export type DeleteCourseMutation = {
  __typename?: 'DeleteCourseMutation';
  course?: Maybe<CourseType>;
};

export type CreateTeacherBillingEntity = {
  __typename?: 'CreateTeacherBillingEntity';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  billingEntity?: Maybe<TeacherBillingEntityType>;
};

export type TeacherBillingEntityInput = {
  /** jdg | company | private */
  kind?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  nip?: Maybe<Scalars['String']>;
  /** standard | exempt | not_vat_payer | '' (not set) */
  vatMode?: Maybe<Scalars['String']>;
  /** 23 / 8 / 5 / 0 (standard only) */
  vatRate?: Maybe<Scalars['Float']>;
  /** Create only. */
  isDefault?: Maybe<Scalars['Boolean']>;
  /** Update only. */
  isActive?: Maybe<Scalars['Boolean']>;
};

export type UpdateTeacherBillingEntity = {
  __typename?: 'UpdateTeacherBillingEntity';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  billingEntity?: Maybe<TeacherBillingEntityType>;
};

export type SetDefaultTeacherBillingEntity = {
  __typename?: 'SetDefaultTeacherBillingEntity';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  billingEntity?: Maybe<TeacherBillingEntityType>;
};

/** Узкая правка финансовых условий заявки: только переданные поля. */
export type SetApplicationFinanceTerms = {
  __typename?: 'SetApplicationFinanceTerms';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  application?: Maybe<ApplicationType>;
};

/**
 * Upload a CV (or certificate / portfolio) and extract its text.
 * 
 * Extraction runs INLINE, not in Celery: `pypdf` on a resume is milliseconds,
 * and a background hop would make the client poll for a status that is already
 * known by the time this response is written.
 * 
 * Versioned, never replaced — a re-sent CV becomes v2 and v1 stays readable.
 */
export type UploadTeacherDocument = {
  __typename?: 'UploadTeacherDocument';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  document?: Maybe<TeacherDocumentType>;
};

/**
 * Paste the text of a document whose extraction failed.
 * 
 * The recovery path for a SCANNED CV: the PDF is perfectly valid, it simply
 * has no text layer, and there is no OCR in this system. Mirrors
 * `setTeacherInterviewTranscript` so the AI layer keeps reading one field and
 * never learns where the text came from.
 */
export type SetTeacherDocumentText = {
  __typename?: 'SetTeacherDocumentText';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  document?: Maybe<TeacherDocumentType>;
};

/** Remove the row AND the S3 object — this is the right-to-erasure path. */
export type DeleteTeacherDocument = {
  __typename?: 'DeleteTeacherDocument';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  teacherId?: Maybe<Scalars['ID']>;
};

/**
 * Queue a competency analysis of a document's extracted text.
 * 
 * The result merges with any interview run into ONE profile: the CV carries
 * self-declared CLAIMS, the transcript carries observed behaviour, and
 * `profile_merge` keeps both tagged by source rather than fusing them.
 * 
 * `NO_DOCUMENT_TEXT` is a precondition, not a failure — no run row is created,
 * exactly as with a missing transcript.
 */
export type RunTeacherDocumentAnalysis = {
  __typename?: 'RunTeacherDocumentAnalysis';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  run?: Maybe<TeacherAiRunType>;
};

/**
 * Queue a competency analysis of one interview's transcript.
 * 
 * Two non-failures answered as customErrors rather than a failed run row:
 * · `AI_DISABLED` — the kill switch is off; the panel stays visible with a
 *   disabled button so «why is there no AI?» is answerable.
 * · `NO_TRANSCRIPT` — a PRECONDITION. It must not create a `failed` row,
 *   because «нет входа» is not an analysis that went wrong: it must not burn a
 *   retry or paint the panel red. The UI offers «вставить расшифровку».
 */
export type RunTeacherInterviewAnalysis = {
  __typename?: 'RunTeacherInterviewAnalysis';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  run?: Maybe<TeacherAiRunType>;
};

/**
 * Rebuild the merged profile from the existing good runs — no new AI call.
 * 
 * Idempotent by construction (`merge_profiles` is pure and ordered), so this is
 * safe to press twice; it exists for the case where a run landed while the
 * merge shape changed.
 */
export type RecomputeTeacherAiProfile = {
  __typename?: 'RecomputeTeacherAiProfile';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<TeacherAiProfileType>;
};

/**
 * Accept or reject course proposals.
 * 
 * Accepting is the ONLY path that writes `Teacher.courses_can_teach`, and it
 * uses `.add()` — never `.set()`, which would wipe a list the operator curated
 * by hand. Rejecting writes no M2M at all.
 */
export type ApplyTeacherCourseSuggestions = {
  __typename?: 'ApplyTeacherCourseSuggestions';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  result?: Maybe<ApplySuggestionsResultType>;
};

export type ApplySuggestionsResultType = {
  __typename?: 'ApplySuggestionsResultType';
  accepted: Scalars['Int'];
  rejected: Scalars['Int'];
};

/**
 * Link a synced Zoom recording; artifacts are pulled on commit.
 * 
 * Eagerly, not lazily: Zoom's cloud retention expires `files[].download_url`
 * and a re-sync does not repair it, so a link we merely stored would rot.
 */
export type AttachTeacherInterviewZoom = {
  __typename?: 'AttachTeacherInterviewZoom';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
};

/**
 * A bare URL — nothing stored, nothing analysable until a transcript is
 * pasted. Also the shape the legacy `Teacher.interviewRecording` migrated into.
 */
export type AttachTeacherInterviewLink = {
  __typename?: 'AttachTeacherInterviewLink';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
};

/**
 * Multipart upload for an interview recorded outside Zoom.
 * 
 * One mutation per file, the diploma rule. Capped at
 * MAX_TEACHER_INTERVIEW_VIDEO_BYTES: a full 90-minute 1080p recording is
 * 1-2 GB, and raising nginx `client_max_body_size` to match would affect every
 * endpoint and pin one sync gunicorn worker for the whole transfer — such
 * recordings belong on the Zoom path, which streams server-to-server.
 */
export type UploadTeacherInterviewVideo = {
  __typename?: 'UploadTeacherInterviewVideo';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
};

/**
 * Paste a transcript or interview notes.
 * 
 * In v1 this is the PRIMARY route to an analysable interview: Zoom only emits
 * a transcript when *Audio transcript* is enabled on that account (and never
 * retroactively), and this system has no speech-to-text of its own.
 */
export type SetTeacherInterviewTranscript = {
  __typename?: 'SetTeacherInterviewTranscript';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
};

/**
 * Re-queue the artifact pull — the recovery path when Zoom's transcript
 * landed after the video, or a worker died mid-download.
 */
export type RetryTeacherInterviewDownload = {
  __typename?: 'RetryTeacherInterviewDownload';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
};

/**
 * Remove the row AND the S3 objects.
 * 
 * Deliberately unlike the diploma rule (which leaves the object because a
 * student may hold a live signed URL): this is candidate personal data under a
 * retention policy, so erasure is the point.
 */
export type DeleteTeacherInterview = {
  __typename?: 'DeleteTeacherInterview';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  teacherId?: Maybe<Scalars['ID']>;
};

/**
 * Pull a date window straight from Zoom, synchronously.
 * 
 * Load-bearing, not a nicety: with production defaults the only scheduled sync
 * is `zoom_hourly_dispatch`, which early-returns unless a `GroupZoomSchedule`
 * slot falls in the current 15-minute bucket, so an interview recorded at a
 * quiet hour may never appear on its own.
 */
export type RefreshInterviewZoomRecordings = {
  __typename?: 'RefreshInterviewZoomRecordings';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  result?: Maybe<InterviewZoomRefreshType>;
};

/** What a manual «Обновить из Zoom» actually did. */
export type InterviewZoomRefreshType = {
  __typename?: 'InterviewZoomRefreshType';
  created: Scalars['Int'];
  updated: Scalars['Int'];
  skippedNoAccount: Scalars['Int'];
  skippedProcessing: Scalars['Int'];
  accountsSynced: Scalars['Int'];
  /** True when the 60s double-click guard swallowed the call; the counters are then all zero and nothing was fetched. */
  cooldown: Scalars['Boolean'];
};

export type CreateUniqueTeacher = {
  __typename?: 'CreateUniqueTeacher';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  teacher?: Maybe<TeacherType>;
};

export type ApplicationInputType = {
  teacherType: EmploymentTypes;
  title: Scalars['String'];
  date: Scalars['Date'];
  group: Scalars['ID'];
  lessonsCount: Scalars['Int'];
  country?: Maybe<Scalars['ID']>;
  servicePrice: Scalars['Float'];
  riaPrice?: Maybe<Scalars['Float']>;
  currency: Currencies;
  comment?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum EmploymentTypes {
  /** individual_entrepreneur */
  Ie = 'IE',
  /** self_employed */
  Se = 'SE',
  /** natural_person */
  Np = 'NP',
  /** legal_entity */
  Le = 'LE'
}

/** An enumeration. */
export enum Currencies {
  Byn = 'BYN',
  Usd = 'USD',
  Eur = 'EUR',
  Rub = 'RUB',
  Pln = 'PLN'
}

export type EmploymentInputType = {
  individualEntrepreneur?: Maybe<IndividualEntrepreneurInput>;
  selfEmployed?: Maybe<SelfEmployedInput>;
  naturalPerson?: Maybe<NaturalPersonInput>;
  legalEntity?: Maybe<LegalEntityInput>;
};

export type IndividualEntrepreneurInput = {
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  inn: Scalars['String'];
};

export type SelfEmployedInput = {
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  inn: Scalars['String'];
};

export type NaturalPersonInput = {
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
};

export type LegalEntityInput = {
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  tittle: Scalars['String'];
  inn: Scalars['String'];
};

export type NewTeacherInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
  siteDisplay?: Maybe<Scalars['Boolean']>;
};

export type AddNewRoleTeacher = {
  __typename?: 'AddNewRoleTeacher';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  teacher?: Maybe<TeacherType>;
};

export type AddTeacherExist = {
  __typename?: 'AddTeacherExist';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  application?: Maybe<ApplicationType>;
};

export type ExistEmploymentInputType = {
  individualEntrepreneur?: Maybe<ExistIndividualEntrepreneurInput>;
  selfEmployed?: Maybe<ExistSelfEmployedInput>;
  naturalPerson?: Maybe<ExistNaturalPersonInput>;
  legalEntity?: Maybe<ExistLegalEntityInput>;
};

export type ExistIndividualEntrepreneurInput = {
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  inn: Scalars['String'];
  existId?: Maybe<Scalars['ID']>;
};

export type ExistSelfEmployedInput = {
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  inn: Scalars['String'];
  existId?: Maybe<Scalars['ID']>;
};

export type ExistNaturalPersonInput = {
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  existId?: Maybe<Scalars['ID']>;
};

export type ExistLegalEntityInput = {
  registrationAddress: Scalars['String'];
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  tittle: Scalars['String'];
  inn: Scalars['String'];
  existId?: Maybe<Scalars['ID']>;
};

export type AddTeacherApplication = {
  __typename?: 'AddTeacherApplication';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  application?: Maybe<ApplicationType>;
};

export type UpdateTeacherApplication = {
  __typename?: 'UpdateTeacherApplication';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  application?: Maybe<ApplicationType>;
};

export type UpdateApplicationInputType = {
  teacherType: EmploymentTypes;
  title: Scalars['String'];
  date: Scalars['Date'];
  group: Scalars['ID'];
  lessonsCount: Scalars['Int'];
  country?: Maybe<Scalars['ID']>;
  servicePrice: Scalars['Float'];
  riaPrice?: Maybe<Scalars['Float']>;
  currency: Currencies;
  comment?: Maybe<Scalars['String']>;
  applicationId: Scalars['ID'];
  isTerminated: Scalars['Boolean'];
  lastLessonDate?: Maybe<Scalars['Date']>;
};

export type DeleteTeacherApplication = {
  __typename?: 'DeleteTeacherApplication';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type UpdateTeacherWithTypeMutation = {
  __typename?: 'UpdateTeacherWithTypeMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  teacher?: Maybe<TeacherType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type TeacherWithTypeInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
  siteDisplay?: Maybe<Scalars['Boolean']>;
  accessToLms?: Maybe<Scalars['Boolean']>;
};

/**
 * Update the control-panel profile fields — rating, internal note,
 * interview-recording link, and the courses-can-teach list. Only the fields
 * actually passed are changed; `rating=0` clears the rating.
 */
export type SetTeacherProfile = {
  __typename?: 'SetTeacherProfile';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  teacher?: Maybe<TeacherType>;
};

/**
 * Create a STANDALONE teacher WITHOUT any application/group assignment —
 * add «свободных» преподавателей на будущее (собеседование/курсы/рейтинг
 * заполняются на карточке). Distinct from `createUniqueTeacher`, which
 * requires an application.
 */
export type CreateTeacher = {
  __typename?: 'CreateTeacher';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  teacher?: Maybe<TeacherType>;
};

export type CreateStaffTaskMutation = {
  __typename?: 'CreateStaffTaskMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  task?: Maybe<StaffTaskType>;
};

export type CreateStaffTaskInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  subject?: Maybe<TaskSubjectInput>;
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  assigneeId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  dueDate?: Maybe<Scalars['Date']>;
  priority?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<TaskLinkInput>>>;
};

/**
 * Старый язык предмета задачи (ТЗ 0014), сохранённый ради совместимости.
 * 
 * До 0064 предмет был один, и применение `subject` переписывало все четыре
 * взаимоисключающих FK разом. Колонок больше нет: теперь это «заменить связи
 * ЭТИХ видов на такие-то» (`SUBJECT_LINK_KINDS`). Им ходят MCP и клиенты,
 * написанные до 0064; новый код пишет `links`.
 */
export type TaskSubjectInput = {
  /** One of "student" | "group" | "teacher" | "none". "none" is a personal to-do with no subject. */
  kind: Scalars['String'];
  /** PK of the subject. Required unless kind is "none". */
  id?: Maybe<Scalars['ID']>;
  /** kind="student" only — the roster row (договор) the task is filed against. */
  agreementId?: Maybe<Scalars['ID']>;
  /** kind="student" only — the group the student was picked from (context shown on the card). */
  groupId?: Maybe<Scalars['ID']>;
};

export type UpdateStaffTaskMutation = {
  __typename?: 'UpdateStaffTaskMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  task?: Maybe<StaffTaskType>;
};

export type UpdateStaffTaskInput = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  clearDueDate?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['Date']>;
  clearStartDate?: Maybe<Scalars['Boolean']>;
  priority?: Maybe<Scalars['String']>;
  assigneeId?: Maybe<Scalars['ID']>;
  subject?: Maybe<TaskSubjectInput>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  clearTargets?: Maybe<Scalars['Boolean']>;
};

/** Move a task between statuses; stamps/clears `completed_at` on done. */
export type UpdateTaskStatusMutation = {
  __typename?: 'UpdateTaskStatusMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  task?: Maybe<StaffTaskType>;
};

export type DeleteStaffTaskMutation = {
  __typename?: 'DeleteStaffTaskMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Drag-and-drop a task on the command-center board: optionally change its
 * column (status or due date) and reposition it between two neighbours — all
 * atomically.
 */
export type MoveStaffTaskMutation = {
  __typename?: 'MoveStaffTaskMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  task?: Maybe<StaffTaskType>;
};

export type MoveStaffTaskInput = {
  id: Scalars['ID'];
  beforeId?: Maybe<Scalars['ID']>;
  afterId?: Maybe<Scalars['ID']>;
  targetStatus?: Maybe<Scalars['String']>;
  targetDueDate?: Maybe<Scalars['Date']>;
  clearDueDate?: Maybe<Scalars['Boolean']>;
};

/**
 * Прицепить к задаче объекты (ТЗ 0064).
 * 
 * Добавление, а не «пришлите весь список»: две вкладки, открытые рядом,
 * затирали бы правки друг друга, и снятая в одной связь молча возвращалась
 * бы из второй. Повтор уже существующей связи — не ошибка: `ignore_conflicts`
 * делает вызов идемпотентным, а человек, дважды выбравший одного студента,
 * хотел одного студента.
 */
export type AddStaffTaskLinksMutation = {
  __typename?: 'AddStaffTaskLinksMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  task?: Maybe<StaffTaskType>;
};

/**
 * Снять одну связь — по id СТРОКИ связи.
 * 
 * Не по паре «вид + объект»: строка снимается и тогда, когда объекта уже нет
 * в базе, а пары для него не построишь — именно ради этого случая связь и
 * показывается как «объект удалён», а не прячется.
 */
export type RemoveStaffTaskLinkMutation = {
  __typename?: 'RemoveStaffTaskLinkMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  task?: Maybe<StaffTaskType>;
};

export type AddStaffTaskCommentMutation = {
  __typename?: 'AddStaffTaskCommentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  comment?: Maybe<StaffTaskCommentType>;
  task?: Maybe<StaffTaskType>;
};

/**
 * Приложить ОДИН файл к существующей задаче (ТЗ 0066).
 * 
 * Один файл на вызов — как у дипломов: multipart с несколькими файлами
 * отказывает целиком, и пользователь не понимает, какой из них виноват.
 * Клиент шлёт их подряд.
 */
export type AddStaffTaskAttachmentMutation = {
  __typename?: 'AddStaffTaskAttachmentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  attachment?: Maybe<StaffTaskAttachmentType>;
  task?: Maybe<StaffTaskType>;
};

export type RemoveStaffTaskAttachmentMutation = {
  __typename?: 'RemoveStaffTaskAttachmentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  task?: Maybe<StaffTaskType>;
};

export type EditStaffTaskCommentMutation = {
  __typename?: 'EditStaffTaskCommentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  comment?: Maybe<StaffTaskCommentType>;
};

export type DeleteStaffTaskCommentMutation = {
  __typename?: 'DeleteStaffTaskCommentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  task?: Maybe<StaffTaskType>;
};

export type CreateStudentNoteMutation = {
  __typename?: 'CreateStudentNoteMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  note?: Maybe<StudentNoteType>;
};

export type CreateStudentNoteInput = {
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  body: Scalars['String'];
  /** neutral | positive | negative */
  sentiment?: Maybe<Scalars['String']>;
  pinned?: Maybe<Scalars['Boolean']>;
};

export type UpdateStudentNoteMutation = {
  __typename?: 'UpdateStudentNoteMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  note?: Maybe<StudentNoteType>;
};

export type UpdateStudentNoteInput = {
  id: Scalars['ID'];
  body?: Maybe<Scalars['String']>;
  sentiment?: Maybe<Scalars['String']>;
  pinned?: Maybe<Scalars['Boolean']>;
};

export type DeleteStudentNoteMutation = {
  __typename?: 'DeleteStudentNoteMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Save the LMS suspension settings. Validation: overdueDays 1..90
 * (`invalid_overdue_days`); mail may be enabled only with BOTH templates
 * (`template_required`); a new template id (or one never checked) must
 * exist in SendGrid (`template_not_found`) and its name is copied from
 * SendGrid; SendGrid unreachable → `sendgrid_unavailable` /
 * `sendgrid_forbidden`, nothing saved. Audited (from → to).
 * 
 * The SendGrid check (network) runs against an unlocked read, BEFORE the
 * transaction; the final validation runs again INSIDE it, on the row
 * re-read under `select_for_update` with this call's partial input laid
 * over it — a concurrent save (e.g. clearing a template while this call
 * enables mail) cannot produce a row that breaks the rules.
 */
export type SaveLmsBlockSettingsMutation = {
  __typename?: 'SaveLmsBlockSettingsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  settings?: Maybe<LmsBlockSettingsType>;
};

/**
 * Partial update: an omitted / null field keeps its value. A template id
 * `""` clears the template. Template NAMES are not accepted — they are read
 * from SendGrid.
 */
export type LmsBlockSettingsInput = {
  robotEnabled?: Maybe<Scalars['Boolean']>;
  overdueDays?: Maybe<Scalars['Int']>;
  mailEnabled?: Maybe<Scalars['Boolean']>;
  slackEnabled?: Maybe<Scalars['Boolean']>;
  smsEnabled?: Maybe<Scalars['Boolean']>;
  suspendedTemplateId?: Maybe<Scalars['String']>;
  restoredTemplateId?: Maybe<Scalars['String']>;
};

/**
 * Send a suspension / restoration template with the EXAMPLE data to the
 * calling staff member (or LMS_BLOCK_MAIL_TEST_RECIPIENT when set). Needs env
 * LMS_BLOCK_MAIL_ENABLED (`disabled_on_server`), not the ERP mail switch.
 * Writes no AccessBlockNotification.
 */
export type SendLmsBlockTestEmailMutation = {
  __typename?: 'SendLmsBlockTestEmailMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  sentTo?: Maybe<Scalars['String']>;
};

/**
 * Suspend a student's LMS access by hand (ТЗ 0074 §3.4). The suspension
 * is tied to ALL the student's current unpaid invoices; no overdue invoice
 * is required. Idempotent for an already-suspended student.
 */
export type BlockStudentLmsAccessMutation = {
  __typename?: 'BlockStudentLmsAccessMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  accessBlock?: Maybe<StudentAccessBlockType>;
};

/**
 * Restore a student's LMS access by hand (ТЗ 0074 §3.4). The already
 * overdue invoices the suspension was tied to are forgiven (`waived`) — a
 * NEW overdue invoice (or a tied one that was not due yet) suspends again.
 */
export type UnblockStudentLmsAccessMutation = {
  __typename?: 'UnblockStudentLmsAccessMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  accessBlock?: Maybe<StudentAccessBlockType>;
};

/**
 * Create a free-standing Payment on an agreement (no Fakturownia link).
 * 
 * Mirrors `createPaymentForFakturowniaInvoice` but starts from the
 * agreement instead of an invoice — finance often records a payment
 * before any invoice exists. Link to an invoice later via
 * `linkFakturowniaInvoiceToPayment`.
 */
export type CreatePaymentMutation = {
  __typename?: 'CreatePaymentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
};

export type CreatePaymentInput = {
  agreementId: Scalars['ID'];
  /** Amount in the agreement's currency. amount_byn / amount_foreign are derived from this (CurrencyService). */
  amountAgreement: Scalars['Float'];
  date: Scalars['Date'];
  /** Must equal the agreement's currency, otherwise CURRENCY_MISMATCH. */
  currency: Scalars['String'];
  /** If provided, atomically link the new payment to this Contribution (the scheduled installment). Both must belong to the same agreement; the contribution must be unlinked. */
  contributionId?: Maybe<Scalars['ID']>;
};

/**
 * Patch a Payment's amount and/or date.
 * 
 * Re-derives `amount_byn` / `amount_foreign` via `PaymentBase.save()` —
 * that's how the existing forms-based path keeps the chargeback / debt
 * tables consistent.
 */
export type UpdatePaymentMutation = {
  __typename?: 'UpdatePaymentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
};

export type UpdatePaymentInput = {
  id: Scalars['ID'];
  amountAgreement?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
};

/**
 * Delete a Payment. Refuses if a FakturowniaInvoice is still linked —
 * the operator must call `unlinkFakturowniaInvoice` first so the invoice
 * isn't left orphaned with `payment_id → DELETED`.
 */
export type DeletePaymentMutation = {
  __typename?: 'DeletePaymentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/**
 * Attach an existing Payment to an existing Contribution (1:1).
 * 
 * Used by the frontend "Перепривязать" / "Привязать существующий платёж"
 * action on the schedule row. The happy path also flips
 * `contribution.complete=True` and recomputes `remainder` via
 * `Contribution.save()` (§9.5).
 */
export type LinkContributionToPaymentMutation = {
  __typename?: 'LinkContributionToPaymentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contribution?: Maybe<ContributionType>;
  payment?: Maybe<PaymentType>;
};

export type LinkContributionInput = {
  contributionId: Scalars['ID'];
  paymentId: Scalars['ID'];
};

/**
 * Detach the Payment from a Contribution. The Payment stays alive as
 * an orphan (visible in the "вне графика" block); the Contribution
 * flips back to `complete=False, remainder=amount_foreign`.
 */
export type UnlinkContributionMutation = {
  __typename?: 'UnlinkContributionMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contribution?: Maybe<ContributionType>;
  payment?: Maybe<PaymentType>;
};

/**
 * Zero an UNPAID contribution's amount on a transfer-out agreement.
 * 
 * `Contribution.save()` re-derives `remainder = amount_foreign` for any
 * unpaid row, so "set remainder=0" is impossible — the legitimate way to
 * drop a contribution to zero is to set its AMOUNT to 0. This is strictly
 * gated:
 * 
 * * the agreement must be `terminated` AND `transfer_out` — i.e. wound down
 *   via `ChangeAgreementGroup`, which clones the schedule onto the NEW group,
 *   so the obligation is re-attributed there, not erased; and
 * * the contribution must NOT have a linked Payment — real received money is
 *   never destroyed here. To move already-received cash out of the old group,
 *   use a Chargeback / AccountsPayable carry-out (capped at `paid_amount`),
 *   not this mutation.
 * 
 * Every call is audited. The old terminated contract is already excluded from
 * debtors / finance / the calendar by the `terminated_date` cutoff; zeroing
 * additionally makes the old agreement read literally zero, which is what the
 * "обнулить старую группу" workflow asks for.
 */
export type ZeroOutContributionMutation = {
  __typename?: 'ZeroOutContributionMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contribution?: Maybe<ContributionType>;
};

/**
 * Record an off-invoice payment against an installment.
 * 
 * ТЗ 0029: writes `manual_paid_amount` / `manual_paid_date` on the instalment
 * itself — no hidden ledger row. Amount defaults to the remainder. The row
 * then reads «оплачен вручную» (fully covered with zero invoice money).
 */
export type MarkContributionPaidManuallyMutation = {
  __typename?: 'MarkContributionPaidManuallyMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contribution?: Maybe<ContributionType>;
};

/**
 * Undo a manual «оплачен вручную» mark.
 * 
 * ТЗ 0029: clears `manual_paid_*` on the instalment. Money that came through
 * an invoice is untouched — that is corrected with a corrective invoice or a
 * `PaymentCorrection`, not here.
 */
export type RevertManualContributionPaymentMutation = {
  __typename?: 'RevertManualContributionPaymentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  contribution?: Maybe<ContributionType>;
};

export type CreatePaymentCorrectionMutation = {
  __typename?: 'CreatePaymentCorrectionMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  correction?: Maybe<PaymentCorrectionType>;
};

export type CreatePaymentCorrectionInput = {
  agreementId: Scalars['ID'];
  /** Target one payment (reverse received money). Omit to correct the whole agreement / plan. */
  paymentId?: Maybe<Scalars['ID']>;
  /** Positive magnitude. */
  amount: Scalars['Float'];
  currency: Scalars['String'];
  date: Scalars['Date'];
  reason: Scalars['String'];
};

export type UpdatePaymentCorrectionMutation = {
  __typename?: 'UpdatePaymentCorrectionMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  correction?: Maybe<PaymentCorrectionType>;
};

export type UpdatePaymentCorrectionInput = {
  id: Scalars['ID'];
  amount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
  reason?: Maybe<Scalars['String']>;
};

export type DeletePaymentCorrectionMutation = {
  __typename?: 'DeletePaymentCorrectionMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type CreatePaymentsMutation = {
  __typename?: 'CreatePaymentsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payments?: Maybe<Array<Maybe<PaymentType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type PaymentInput = {
  date: Scalars['Date'];
  sum: Scalars['Float'];
  currency: Scalars['String'];
  agreement_id: Scalars['ID'];
  deferredPaymentId?: Maybe<Scalars['ID']>;
};

export type CreateDeferredPaymentsMutation = {
  __typename?: 'CreateDeferredPaymentsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deferredPayments?: Maybe<Array<Maybe<DeferredPaymentType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type DeferredPaymentInput = {
  userInput: Scalars['String'];
  agreementTitle?: Maybe<Scalars['String']>;
  sum?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  studentFullname?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  deferredPaymentId?: Maybe<Scalars['ID']>;
};

export type CheckStudentsDebtMutation = {
  __typename?: 'CheckStudentsDebtMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type RemindDebtorsMutation = {
  __typename?: 'RemindDebtorsMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type StudentWithAgreementUpdateMutation = {
  __typename?: 'StudentWithAgreementUpdateMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  student?: Maybe<StudentType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type UpdateStudentInput = {
  student: StudentInput;
  agreement: AgreementInput;
  company?: Maybe<SetCompanyInput>;
  contributions?: Maybe<Array<Maybe<ContributionInput>>>;
  chargeback?: Maybe<ChargebackInput>;
  accountsPayable?: Maybe<AccountsPayableInput>;
  usedPayables?: Maybe<Array<Scalars['ID']>>;
  studentLessons?: Maybe<AgreementLessonsInput>;
};

export type StudentInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type AgreementInput = {
  agreementTitle: Scalars['String'];
  currency: Scalars['String'];
  paymentByCompany?: Maybe<Scalars['Boolean']>;
  partialAttendance?: Maybe<Scalars['Boolean']>;
  startAgreementBudget?: Maybe<Scalars['Float']>;
  countryId?: Maybe<Scalars['ID']>;
  promocode?: Maybe<Scalars['String']>;
  group_id: Scalars['ID'];
  vat?: Maybe<Scalars['Boolean']>;
  resident?: Maybe<Scalars['Boolean']>;
  terminated?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['Date']>;
  comment?: Maybe<Scalars['String']>;
  terminatedDate?: Maybe<Scalars['Date']>;
};

export type SetCompanyInput = {
  companyId?: Maybe<Scalars['ID']>;
  companyComment?: Maybe<Scalars['String']>;
};

export type ContributionInput = {
  /** Existing contribution of THIS agreement to update in place (pk or relay id). Omit for a new row. On updateStudentWithAgreement, existing rows whose id is absent from the list are deleted. Ignored on create. */
  id?: Maybe<Scalars['ID']>;
  date: Scalars['Date'];
  sum: Scalars['Float'];
};

export type ChargebackInput = {
  date: Scalars['Date'];
  sum: Scalars['Float'];
  currency: Scalars['String'];
};

export type AccountsPayableInput = {
  date: Scalars['Date'];
  accountsPayable?: Maybe<Scalars['Float']>;
};

export type AgreementLessonsInput = {
  startLessonId: Scalars['Int'];
  lastLessonId: Scalars['Int'];
};

export type StudentWithAgreementCreateMutation = {
  __typename?: 'StudentWithAgreementCreateMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type CreateAgreementInputBase = {
  agreementTitle: Scalars['String'];
  currency: Scalars['String'];
  paymentByCompany?: Maybe<Scalars['Boolean']>;
  partialAttendance?: Maybe<Scalars['Boolean']>;
  startAgreementBudget?: Maybe<Scalars['Float']>;
  countryId?: Maybe<Scalars['ID']>;
  promocode?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  groupId: Scalars['ID'];
  vat?: Maybe<Scalars['Boolean']>;
  resident?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['ID']>;
  companyComment?: Maybe<Scalars['String']>;
  contributions?: Maybe<Array<Maybe<ContributionInput>>>;
  firstLesson?: Maybe<Scalars['ID']>;
  lastLesson?: Maybe<Scalars['ID']>;
  usedPayables?: Maybe<Array<Scalars['ID']>>;
};

export type AddRoleStudentAndAgreement = {
  __typename?: 'AddRoleStudentAndAgreement';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Single-shot «+Студент в группу» from the group dashboard
 * (docs/groups/group_dashboard.md §G8, Variant B).
 * 
 * The student already exists (search picker on the frontend); the
 * agreement carries the target `groupId` inside `agreement_input`.
 * Delegates to the existing `add_agreement_to_student` service so all
 * currency / contribution / attendance plumbing is shared with the rest
 * of the agreement-create flow — no duplicate validation paths.
 */
export type AppendStudentToGroupMutation = {
  __typename?: 'AppendStudentToGroupMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type StudentSignUpLmsMutation = {
  __typename?: 'StudentSignUpLMSMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  student?: Maybe<StudentType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type StudentSignUpInput = {
  firstName: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
  recaptchaToken: Scalars['String'];
};

export type CreateAgreementMutation = {
  __typename?: 'CreateAgreementMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type CreateAgreementInput = {
  agreementTitle: Scalars['String'];
  currency: Scalars['String'];
  paymentByCompany?: Maybe<Scalars['Boolean']>;
  partialAttendance?: Maybe<Scalars['Boolean']>;
  startAgreementBudget?: Maybe<Scalars['Float']>;
  countryId?: Maybe<Scalars['ID']>;
  promocode?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  groupId: Scalars['ID'];
  vat?: Maybe<Scalars['Boolean']>;
  resident?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['ID']>;
  companyComment?: Maybe<Scalars['String']>;
  contributions?: Maybe<Array<Maybe<ContributionInput>>>;
  firstLesson?: Maybe<Scalars['ID']>;
  lastLesson?: Maybe<Scalars['ID']>;
  usedPayables?: Maybe<Array<Scalars['ID']>>;
  studentId: Scalars['ID'];
};

export type CreateCompanyMutation = {
  __typename?: 'CreateCompanyMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  company?: Maybe<CompanyType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type CompanyInput = {
  name: Scalars['String'];
  responsiblePerson: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  registrationNumber: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
};

export type UpdateCompanyMutation = {
  __typename?: 'UpdateCompanyMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  company?: Maybe<CompanyType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type UpdateCompanyInput = {
  name: Scalars['String'];
  responsiblePerson: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  comment: Scalars['String'];
};

/**
 * Move a student from one group to another atomically.
 * 
 * Created to back the "Перевести в другую группу" single-click action on
 * the new student card (`docs/fakturownia/student_card.md §6`). Replaces
 * the manual sequence of `editStudentWithAgreement` + chargeback +
 * new-agreement that finance currently has to chain by hand.
 */
export type ChangeAgreementGroupMutation = {
  __typename?: 'ChangeAgreementGroupMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  oldAgreement?: Maybe<AgreementType>;
  newAgreement?: Maybe<AgreementType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type ChangeAgreementGroupInput = {
  agreementId: Scalars['ID'];
  newGroupId: Scalars['ID'];
  /** Date the move takes effect. Payments before this date stay on the old agreement; the old agreement is terminated with `terminated_date = effective_date`. */
  effectiveDate: Scalars['Date'];
  /** Move payments dated >= effective_date to the new agreement. Linked Fakturownia invoices follow their Payment (1:1) — the bridge is not touched. */
  copyPayments?: Maybe<Scalars['Boolean']>;
  /** Clone the contribution schedule onto the new agreement. */
  copyContributions?: Maybe<Scalars['Boolean']>;
};

/**
 * Safe one-click agreement termination — see docs/groups/groups_upgrade.md §B3.
 * 
 * Replaces the chained `updateStudentWithAgreement` workaround that
 * re-sent the student's PII just to flip `terminated=True`. This mutation
 * touches only the agreement and writes an audit log entry; contributions
 * and deferred payments are deliberately left alone.
 */
export type TerminateAgreementMutation = {
  __typename?: 'TerminateAgreementMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export enum TerminatedReasonEnum {
  StudentRequest = 'STUDENT_REQUEST',
  NonPayment = 'NON_PAYMENT',
  Transfer = 'TRANSFER',
  Other = 'OTHER'
}

/**
 * Вернуть студенту доступ к занятиям курса — ремонт, а не смена договора.
 * 
 * Только строки посещаемости (= доступ в LMS) и запись в аудит: деньги,
 * взносы и `terminated` не трогаются. Аддитивна — может лишь добавить
 * студенту занятия, которых у него нет, поэтому безопасна к повторному
 * нажатию и возвращает `restoredLessons = 0`, когда возвращать нечего.
 */
export type RestoreCourseAccessMutation = {
  __typename?: 'RestoreCourseAccessMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  restoredLessons?: Maybe<Scalars['Int']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Manually flag/unflag an agreement as «переведён из этой группы».
 * 
 * The flag relaxes the FULL-zeroing limit on corrections (partials work
 * without it) and the carry-out money guards (still capped at `paid_amount`).
 * Restricted to Admin/FinanceManager and audited — it must not be settable by
 * a rank-and-file operator, and never via a self-declared termination reason.
 */
export type SetAgreementTransferOutMutation = {
  __typename?: 'SetAgreementTransferOutMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Manually flag/unflag a contract as «бесплатный договор».
 * 
 * Excludes the contract from ALL debt/overdue detection (student-card totals,
 * LMS-block candidates, debtors list, payment calendar) while leaving it
 * active — so the student keeps LMS access to the group. Like `transfer_out`
 * it also relaxes the FULL-zeroing correction guard, so the paid invoice can
 * be corrected to zero without pretending the contract was transferred.
 * Restricted to Admin/FinanceManager and audited — it silences a real debt, so
 * a rank-and-file operator must not be able to set it.
 */
export type SetAgreementFreeOfChargeMutation = {
  __typename?: 'SetAgreementFreeOfChargeMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Manually flag/unflag a contract as «финансирование государством».
 * 
 * The student is pre-financed by the state: intermediate documents
 * (proforma/advance/VAT) are not a debt — only an unpaid overdue FINAL
 * invoice is — and the plan/contributions owe nothing until then. Debt gates
 * honor this across totals, LMS block, debtors list and calendar. Restricted
 * to Admin/FinanceManager and audited.
 */
export type SetAgreementStatePrefinancedMutation = {
  __typename?: 'SetAgreementStatePrefinancedMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * «Исправить группу» — правка ошибки, а не перевод: то же соглашение,
 * новая группа, доступ в LMS переезжает, номер `{группа}-{N}` пересчитан
 * (кроме номера из подписанного договора ERP). Не ставит `transfer_out` /
 * `terminated`, не создаёт двойника и не пишет `change_agreement_group`.
 */
export type CorrectAgreementGroupMutation = {
  __typename?: 'CorrectAgreementGroupMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  agreement?: Maybe<AgreementType>;
  /** Номер договора до правки. */
  oldTitle?: Maybe<Scalars['String']>;
  /** Номер договора после правки. */
  newTitle?: Maybe<Scalars['String']>;
  /** Номер изменился: студент мог получить старый, и банковский перевод со старым номером не привяжется автоматически. */
  titleChanged?: Maybe<Scalars['Boolean']>;
  /** Почему номер остался прежним (иначе null): SIGNED_DOCUMENT — напечатан в подписанном договоре ERP; MANUAL_TITLE — номер не по схеме {группа}-{N}; NAME_TOO_LONG — имя новой группы не помещается в номер. */
  titleKeptReason?: Maybe<Scalars['String']>;
};

/**
 * «Отменить зачисление» — удалить ошибочно заведённое соглашение со
 * взносами (окно `AGREEMENT_UNDO_WINDOW_DAYS`, строгие проверки), вернуть
 * взятые им AccountsPayable и снять доступ в LMS. Студент и пользователь
 * остаются; в аудите — снимок удалённого.
 */
export type UndoEnrollmentMutation = {
  __typename?: 'UndoEnrollmentMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  /** pk студента, у которого отменено зачисление. */
  studentId?: Maybe<Scalars['ID']>;
  /** Видна ли карточка студента вызывающему после отмены. Студенты скоуплены по договорам юрлица: без договоров студент пропадает из списков и карточки ERP (строки Student/User остаются) — тогда уводить не на карточку, а в список. */
  studentVisible?: Maybe<Scalars['Boolean']>;
};

/**
 * SDL: {success, errors, customErrors}.
 * 
 * ТЗ 0021, стадия 4 — вместо `graphql_auth.mutations.Register`. Полей
 * token/refreshToken тут нет и быть не должно: пакет доливал их только при
 * `ALLOW_LOGIN_NOT_VERIFIED=True`, а в проекте настройка False.
 */
export type RegisterMutation = {
  __typename?: 'RegisterMutation';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

/** SDL: {success, errors, customErrors}. */
export type CustomSendPasswordResetEmail = {
  __typename?: 'CustomSendPasswordResetEmail';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
};

export type SendAuthenticationCode = {
  __typename?: 'SendAuthenticationCode';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type LmsAuthenticationInput = {
  email: Scalars['String'];
  scope: Scalars['String'];
};

/** Сброс пароля по токену из письма. SDL: {success, errors}. */
export type PasswordReset = {
  __typename?: 'PasswordReset';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/** Установка первого пароля по токену из письма. SDL: {success, errors}. */
export type PasswordSet = {
  __typename?: 'PasswordSet';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/** SDL: {token, success, errors, user, unarchiving, customErrors, refreshToken}. */
export type CustomObtainJsonWebToken = {
  __typename?: 'CustomObtainJSONWebToken';
  token?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  user?: Maybe<UserNode>;
  unarchiving?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  refreshToken?: Maybe<Scalars['String']>;
};

/** SDL: {payload: GenericScalar, success, errors}. */
export type VerifyToken = {
  __typename?: 'VerifyToken';
  payload?: Maybe<Scalars['GenericScalar']>;
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/** То же, что в `graphql_jwt`, но с нашей формой ответа (success/errors). */
export type CustomRefreshToken = {
  __typename?: 'CustomRefreshToken';
  token?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['GenericScalar']>;
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  refreshToken?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum LmsRoles {
  /** Teacher */
  Teacher = 'TEACHER',
  /** Student */
  Student = 'STUDENT',
  /** Methodist */
  Methodist = 'METHODIST'
}

/** SDL: {revoked: Int, success, errors}. */
export type RevokeToken = {
  __typename?: 'RevokeToken';
  revoked?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type UserSettingsUpdateMutation = {
  __typename?: 'UserSettingsUpdateMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  user?: Maybe<UserNode>;
};

export type CustomUserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
  roles: Scalars['String'];
};

export type UserSettingsDeleteMutation = {
  __typename?: 'UserSettingsDeleteMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type UserSettingsRolesAddMutation = {
  __typename?: 'UserSettingsRolesAddMutation';
  success?: Maybe<Scalars['Boolean']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  user?: Maybe<CustomUserType>;
};

export type AppState = {
  __typename?: 'appState';
  bootstrapped: Scalars['Boolean'];
};

export type AuthState = {
  __typename?: 'authState';
  isLoggedIn: Scalars['Boolean'];
  access_token: Scalars['String'];
};

export type AttentionProbeFragment = (
  { __typename?: 'FundingCandidateType' }
  & Pick<FundingCandidateType, 'id' | 'needsAttention' | 'attentionNote'>
);

export type AttentionCardProbeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AttentionCardProbeQuery = (
  { __typename?: 'Query' }
  & { fundingCandidate?: Maybe<(
    { __typename?: 'FundingCandidateType' }
    & Pick<FundingCandidateType, 'id' | 'needsAttention' | 'attentionNote' | 'attentionSetByName' | 'attentionSetAt' | 'attentionTaskId' | 'isArchived' | 'status'>
    & { nextIntake?: Maybe<(
      { __typename?: 'FundingIntakeType' }
      & Pick<FundingIntakeType, 'id' | 'startsOn' | 'operatorName'>
    )> }
  )> }
);

export type InvoicesProbeQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['Date']>;
}>;


export type InvoicesProbeQuery = (
  { __typename?: 'Query' }
  & { fakturowniaInvoices?: Maybe<Array<Maybe<(
    { __typename?: 'FakturowniaInvoiceType' }
    & Pick<FakturowniaInvoiceType, 'id'>
  )>>> }
);

export type ExpensesProbeQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  recurrence?: Maybe<Scalars['String']>;
}>;


export type ExpensesProbeQuery = (
  { __typename?: 'Query' }
  & { expenses?: Maybe<Array<Maybe<(
    { __typename?: 'ExpenseType' }
    & Pick<ExpenseType, 'id'>
  )>>> }
);

export type BrowserProbeQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
  unhandledOnly?: Maybe<Scalars['Boolean']>;
}>;


export type BrowserProbeQuery = (
  { __typename?: 'Query' }
  & { conversationsBrowser: (
    { __typename?: 'ConversationConnection' }
    & Pick<ConversationConnection, 'totalCount'>
    & { edges?: Maybe<Array<(
      { __typename?: 'ConversationEdge' }
      & { node?: Maybe<(
        { __typename?: 'ConversationType' }
        & Pick<ConversationType, 'id'>
      )> }
    )>> }
  ) }
);

export type ZoomLessonsProbeQueryVariables = Exact<{
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  groupId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type ZoomLessonsProbeQuery = (
  { __typename?: 'Query' }
  & { allZoomLessons?: Maybe<(
    { __typename?: 'ZoomLessonConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'ZoomLessonEdge' }
      & Pick<ZoomLessonEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'GroupLessonForLMSType' }
        & Pick<GroupLessonForLmsType, 'id'>
      )> }
    )>> }
  )> }
);

export type CreativesProbeQueryVariables = Exact<{
  from: Scalars['Date'];
}>;


export type CreativesProbeQuery = (
  { __typename?: 'Query' }
  & { marketingCreatives: (
    { __typename?: 'MarketingCreativesPage' }
    & { rows: Array<(
      { __typename?: 'MarketingCreativeRow' }
      & Pick<MarketingCreativeRow, 'id' | 'name'>
      & { series?: Maybe<Array<(
        { __typename?: 'MarketingSeriesPoint' }
        & Pick<MarketingSeriesPoint, 'period'>
      )>> }
    )> }
  ) }
);

export type EmailProbeQueryVariables = Exact<{
  from: Scalars['Date'];
}>;


export type EmailProbeQuery = (
  { __typename?: 'Query' }
  & { marketingEmail: (
    { __typename?: 'MarketingEmailReport' }
    & { sends: Array<(
      { __typename?: 'MarketingEmailSend' }
      & Pick<MarketingEmailSend, 'id' | 'name' | 'emailLeads'>
    )> }
  ) }
);

export type ListQueryVariables = Exact<{
  needsAttention?: Maybe<Scalars['Boolean']>;
  statusGroup?: Maybe<Scalars['String']>;
}>;


export type ListQuery = (
  { __typename?: 'Query' }
  & { fundingCandidates: Array<(
    { __typename?: 'FundingCandidateType' }
    & Pick<FundingCandidateType, 'id' | 'needsAttention'>
  )> }
);

export type BoardQueryVariables = Exact<{
  isDeposit?: Maybe<Scalars['Boolean']>;
}>;


export type BoardQuery = (
  { __typename?: 'Query' }
  & { fundingBoard: (
    { __typename?: 'FundingBoardType' }
    & Pick<FundingBoardType, 'total' | 'needsAttention'>
  ) }
);

export type TotalQueryVariables = Exact<{
  needsAttention?: Maybe<Scalars['Boolean']>;
}>;


export type TotalQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fundingCandidatesTotal'>
);

export type ErpAiKbCandidateFieldsFragment = (
  { __typename?: 'AiKbCandidateType' }
  & Pick<AiKbCandidateType, 'id' | 'kind' | 'category' | 'claim' | 'question' | 'targetDocumentId' | 'targetDocumentTitle' | 'targetHeading' | 'conflictRefs' | 'supportCount' | 'confidence' | 'status' | 'duplicateOfId' | 'rejectReason' | 'reviewedByName' | 'reviewedAt' | 'appliedRevisionVersion' | 'createdAt' | 'updatedAt'>
  & { conflicts: Array<(
    { __typename?: 'AiKbConflictType' }
    & Pick<AiKbConflictType, 'ref' | 'documentId' | 'title' | 'headingPath' | 'text'>
  )>, evidence: Array<(
    { __typename?: 'AiKbEvidenceType' }
    & Pick<AiKbEvidenceType, 'source' | 'ref' | 'at' | 'conversationId' | 'messageId' | 'callId' | 'suggestionId' | 'groupId' | 'studentId' | 'excerpt'>
  )> }
);

export type UserFieldsFragment = (
  { __typename?: 'UserNode' }
  & Pick<UserNode, 'id' | 'username' | 'isActive' | 'firstName' | 'middleName' | 'lastName' | 'email' | 'roles' | 'verified' | 'isStaff' | 'dateJoined' | 'pk' | 'archived' | 'secondaryEmail' | 'lastLogin' | 'phone'>
);

export type KommoStageFieldsFragment = (
  { __typename?: 'KommoStageType' }
  & Pick<KommoStageType, 'id' | 'name' | 'color' | 'sort' | 'isClosed'>
);

export type LeadUtmFieldsFragment = (
  { __typename?: 'LeadUtmType' }
  & Pick<LeadUtmType, 'source' | 'medium' | 'campaign' | 'content' | 'term' | 'referrer' | 'formName' | 'tracking'>
);

export type LeadUserLinkFieldsFragment = (
  { __typename?: 'LeadUserLinkType' }
  & Pick<LeadUserLinkType, 'userId' | 'name' | 'email' | 'studentId'>
);

export type PersonKommoLeadFieldsFragment = (
  { __typename?: 'PersonKommoLeadType' }
  & Pick<PersonKommoLeadType, 'id' | 'kommoId' | 'name' | 'stageName' | 'stageColor' | 'responsibleName' | 'isClosed' | 'createdAt' | 'linkRule' | 'kommoUrl'>
  & { utm: (
    { __typename?: 'LeadUtmType' }
    & LeadUtmFieldsFragment
  ) }
);

export type KommoLeadRowFieldsFragment = (
  { __typename?: 'KommoLeadType' }
  & Pick<KommoLeadType, 'id' | 'kommoId' | 'name' | 'personName' | 'isClosed' | 'inPipeline' | 'isDeleted' | 'responsibleName' | 'responsibleUserId' | 'responsibleUserName' | 'firstName' | 'lastName' | 'phone' | 'email' | 'phones' | 'emails' | 'kommoUrl' | 'createdAt' | 'updatedAt' | 'closedAt' | 'syncedAt' | 'lastSmsAt' | 'smsCount' | 'candidateRule' | 'userRule' | 'aploraWinChance' | 'aploraCategory' | 'aploraTemperature' | 'aploraNextContactDate' | 'aploraLearnScore' | 'aploraConsent'>
  & { stage?: Maybe<(
    { __typename?: 'KommoStageType' }
    & KommoStageFieldsFragment
  )>, ladders: Array<(
    { __typename?: 'LeadLadderChipType' }
    & Pick<LeadLadderChipType, 'kind' | 'status'>
  )>, utm: (
    { __typename?: 'LeadUtmType' }
    & LeadUtmFieldsFragment
  ), fundingCandidate?: Maybe<(
    { __typename?: 'LeadFundingLinkType' }
    & Pick<LeadFundingLinkType, 'id' | 'name' | 'status' | 'isArchived'>
  )>, linkedUser?: Maybe<(
    { __typename?: 'LeadUserLinkType' }
    & LeadUserLinkFieldsFragment
  )> }
);

export type KommoLeadCardFieldsFragment = (
  { __typename?: 'KommoLeadType' }
  & Pick<KommoLeadType, 'candidateConflict' | 'userConflict' | 'candidateLocked' | 'userLocked'>
  & { contracts: Array<(
    { __typename?: 'LeadContractType' }
    & Pick<LeadContractType, 'id' | 'number' | 'status' | 'kind' | 'createdAt'>
    & { signingLadder?: Maybe<(
      { __typename?: 'LeadContractSigningLadderType' }
      & Pick<LeadContractSigningLadderType, 'state' | 'available' | 'reason' | 'autoReminders' | 'nextStepAt' | 'nextStepReason' | 'sentAt' | 'canManage' | 'handlerName'>
    )> }
  )>, fundingCandidates: Array<(
    { __typename?: 'LeadFundingCandidateType' }
    & Pick<LeadFundingCandidateType, 'id' | 'name' | 'status' | 'createdAt' | 'formForeign'>
  )>, fundingCandidate?: Maybe<(
    { __typename?: 'LeadFundingLinkType' }
    & Pick<LeadFundingLinkType, 'id' | 'name' | 'status' | 'isArchived' | 'intakeId' | 'intakeStartsOn' | 'intakeEndsOn' | 'lastSubmissionAt' | 'createdAt'>
    & { operators: Array<(
      { __typename?: 'LeadFundingOperatorType' }
      & Pick<LeadFundingOperatorType, 'id' | 'name' | 'isPrimary'>
    )> }
  )>, userOptions: Array<(
    { __typename?: 'LeadUserLinkType' }
    & LeadUserLinkFieldsFragment
  )>, ladderReadiness: Array<(
    { __typename?: 'LeadLadderReadinessType' }
    & Pick<LeadLadderReadinessType, 'kind' | 'warning' | 'firstSms' | 'firstSmsSegments'>
  )> }
  & KommoLeadRowFieldsFragment
);

export type KommoNoteFieldsFragment = (
  { __typename?: 'KommoNoteType' }
  & Pick<KommoNoteType, 'id' | 'noteType' | 'text' | 'duration' | 'createdAt' | 'authorName' | 'fromErp' | 'erpStatus'>
);

export type LeadSmsStateFieldsFragment = (
  { __typename?: 'LeadSmsStateType' }
  & Pick<LeadSmsStateType, 'available' | 'reason' | 'phoneMasked'>
  & { messages: Array<(
    { __typename?: 'SmsMessageType' }
    & SmsMessageFieldsFragment
  )> }
);

export type LeadLadderRunFieldsFragment = (
  { __typename?: 'LeadLadderRunType' }
  & Pick<LeadLadderRunType, 'id' | 'kind' | 'topic' | 'status' | 'startedAt' | 'startedByName' | 'days' | 'endsAt' | 'stoppedAt' | 'stoppedByName' | 'finishedAt' | 'finishReason' | 'submissionAt' | 'warning' | 'nextStepAt' | 'sent' | 'linkClicks'>
);

export type LeadConversationFieldsFragment = (
  { __typename?: 'ConversationType' }
  & Pick<ConversationType, 'id' | 'kind' | 'title' | 'displayTitle' | 'externalId' | 'mailboxEmail' | 'unreadCount' | 'unhandledCount' | 'status' | 'hasUnhandled' | 'lastMessageAt'>
);

export type KommoUserFieldsFragment = (
  { __typename?: 'KommoUserType' }
  & Pick<KommoUserType, 'id' | 'kommoId' | 'name' | 'email' | 'isActive' | 'erpUserId' | 'erpUserName' | 'matchSource' | 'locked' | 'leadsCount'>
);

export type KommoSyncStatusFieldsFragment = (
  { __typename?: 'KommoSyncStatusType' }
  & Pick<KommoSyncStatusType, 'source' | 'syncEnabled' | 'notesEnabled' | 'lastIncrementalAt' | 'lastFullAt' | 'lastStatus' | 'lastError' | 'leads' | 'unmappedResponsibles' | 'notesPending' | 'notesFailed'>
  & { runs: Array<(
    { __typename?: 'KommoSyncRunType' }
    & Pick<KommoSyncRunType, 'id' | 'full' | 'triggerSource' | 'startedByName' | 'status' | 'created' | 'updated' | 'error' | 'startedAt' | 'finishedAt'>
  )> }
);

export type KommoLeadBoardFieldsFragment = (
  { __typename?: 'KommoLeadType' }
  & Pick<KommoLeadType, 'price' | 'courseRaw' | 'stageEnteredAt' | 'responsibleId'>
  & { contracts: Array<(
    { __typename?: 'LeadContractType' }
    & Pick<LeadContractType, 'id' | 'status'>
  )> }
  & KommoLeadRowFieldsFragment
);

export type KommoLeadMovedFieldsFragment = (
  { __typename?: 'KommoLeadType' }
  & Pick<KommoLeadType, 'price' | 'courseRaw' | 'stageEnteredAt' | 'responsibleId'>
  & KommoLeadRowFieldsFragment
);

export type EsignContractCardFieldsFragment = (
  { __typename?: 'ContractDocumentType' }
  & Pick<ContractDocumentType, 'id' | 'uuid' | 'kind' | 'number' | 'status' | 'fulfilmentStatus' | 'fulfilmentError' | 'cancelConflict' | 'textPending' | 'signerFirstName' | 'signerLastName' | 'signerEmail' | 'signerPhone' | 'groupId' | 'groupName' | 'courseName' | 'currency' | 'listPrice' | 'price' | 'teacherId' | 'applicationId' | 'applicationTitle' | 'studentId' | 'agreementId' | 'teacherAgreementId' | 'existingUserId' | 'createdById' | 'createdByName' | 'templateId' | 'templateCode' | 'templateName' | 'templateAppendix' | 'sellerId' | 'sellerName' | 'sellerLocked' | 'sentById' | 'sentByName' | 'canSeeCorrespondence' | 'canManage' | 'emailFrom' | 'inviteMailbox' | 'inviteMailboxKind' | 'inviteBlockedReason' | 'createdAt' | 'sentAt' | 'emailSentAt' | 'emailDeliveredAt' | 'emailOpenedAt' | 'emailBouncedAt' | 'emailSendCount' | 'openedAt' | 'signedAt' | 'completedAt' | 'rejectedAt' | 'rejectionReason' | 'cancelledAt' | 'cancelReason' | 'expiresAt' | 'sendError' | 'signerLegalName' | 'signerTaxId' | 'signerAddress' | 'signerPesel' | 'crmLeadId' | 'crmLeadUrl' | 'signState' | 'expiresInDays' | 'aploraWinChance' | 'aploraConsent' | 'aploraNextContactDate' | 'requisiteWarnings' | 'consents'>
  & { fulfilmentCandidates: Array<(
    { __typename?: 'FulfilmentCandidateType' }
    & Pick<FulfilmentCandidateType, 'id' | 'name' | 'isStudentHere'>
  )>, paymentPlan?: Maybe<(
    { __typename?: 'PaymentPlanType' }
    & Pick<PaymentPlanType, 'id' | 'code' | 'name' | 'installments' | 'firstDueKind' | 'firstDueDays' | 'marksStatePrefinanced'>
  )>, schedule: Array<(
    { __typename?: 'ContractInstallmentType' }
    & Pick<ContractInstallmentType, 'n' | 'amount' | 'rule' | 'ruleKind' | 'ruleParams'>
  )>, company?: Maybe<(
    { __typename?: 'CompanyContractInfoType' }
    & Pick<CompanyContractInfoType, 'name' | 'taxId' | 'regon' | 'address' | 'paymentModel' | 'invoiceTo' | 'pricePerPerson' | 'totalPrice'>
    & { participants: Array<(
      { __typename?: 'CompanyParticipantType' }
      & Pick<CompanyParticipantType, 'firstName' | 'lastName' | 'email' | 'phone'>
    )> }
  )>, emailError?: Maybe<(
    { __typename?: 'ContractEmailErrorType' }
    & Pick<ContractEmailErrorType, 'code' | 'message' | 'occurredAt'>
  )>, crmLead?: Maybe<(
    { __typename?: 'PersonKommoLeadType' }
    & Pick<PersonKommoLeadType, 'id' | 'kommoId' | 'personName' | 'name' | 'isClosed' | 'kommoUrl'>
  )>, signerFields: Array<(
    { __typename?: 'ContractSignerFieldType' }
    & Pick<ContractSignerFieldType, 'key' | 'label' | 'value' | 'checked'>
  )>, events: Array<(
    { __typename?: 'ContractEventType' }
    & Pick<ContractEventType, 'id' | 'source' | 'event' | 'occurredAt' | 'actorName' | 'details'>
  )> }
);

export type EsignOutreachFieldsFragment = (
  { __typename?: 'ContractOutreachType' }
  & Pick<ContractOutreachType, 'available' | 'reason' | 'stopped' | 'autoReminders' | 'nextStepAt' | 'nextStepCondition' | 'nextStepReason' | 'state'>
  & { messages: Array<(
    { __typename?: 'OutreachMessageType' }
    & Pick<OutreachMessageType, 'id' | 'step' | 'stepLabel' | 'condition' | 'status' | 'skipReason' | 'scheduledFor' | 'createdAt' | 'sentAt' | 'deliveredAt' | 'dlrStatus' | 'segments' | 'phoneMasked' | 'body' | 'templateCode' | 'templateName' | 'templateNamePl' | 'createdByName' | 'error'>
  )>, link?: Maybe<(
    { __typename?: 'ShortLinkStatsType' }
    & Pick<ShortLinkStatsType, 'clickCount' | 'humanClickCount' | 'firstHumanClickedAt' | 'lastClickedAt' | 'expiresAt' | 'revoked'>
  )> }
);

export type EsignMessageTemplateFieldsFragment = (
  { __typename?: 'MessageTemplateType' }
  & Pick<MessageTemplateType, 'id' | 'channel' | 'code' | 'name' | 'namePl' | 'subject' | 'body' | 'isSystem' | 'isActive' | 'updatedAt' | 'updatedByName' | 'usedIn' | 'usedInPl' | 'isPersonal' | 'ownerId' | 'ownerName' | 'canEdit' | 'canDelete'>
);

export type EsignContractTemplateFieldsFragment = (
  { __typename?: 'ContractTemplateType' }
  & Pick<ContractTemplateType, 'id' | 'code' | 'version' | 'kind' | 'name' | 'language' | 'appendix' | 'description' | 'isActive' | 'origin' | 'createdByName' | 'createdAt' | 'comment' | 'basedOnId' | 'basedOnCode' | 'basedOnVersion' | 'hasPendingGit' | 'pendingGitVersion' | 'legalEntityId' | 'legalEntityName' | 'isGitCode'>
);

export type GroupJoinLinkFieldsFragment = (
  { __typename?: 'GroupType' }
  & Pick<GroupType, 'id' | 'lessonJoinUrl'>
  & { activeLinkOverride?: Maybe<(
    { __typename?: 'GroupLinkOverrideType' }
    & Pick<GroupLinkOverrideType, 'id' | 'date' | 'joinUrl' | 'setVia' | 'setByName' | 'createdAt'>
  )> }
);

export type HomeworkSubmissionFieldsFragment = (
  { __typename?: 'HomeworkSubmissionType' }
  & Pick<HomeworkSubmissionType, 'id' | 'githubUrl' | 'fileName' | 'fileSizeBytes' | 'status' | 'attempt' | 'submittedAt' | 'teacherComment' | 'gradedAt' | 'gradedByName'>
  & { aiReview?: Maybe<(
    { __typename?: 'HomeworkAiReviewType' }
    & Pick<HomeworkAiReviewType, 'status' | 'aiScore' | 'aiSummary' | 'aiJustification' | 'suspiciousContent' | 'suspicionNotes' | 'errorMessage' | 'analyzedAt'>
  )> }
);

export type MarketingMetricsFieldsFragment = (
  { __typename?: 'MarketingMetrics' }
  & Pick<MarketingMetrics, 'spendPln' | 'spendCoveredPln' | 'spendCoveredThrough' | 'impressions' | 'clicks' | 'ctr' | 'cpc' | 'cpm' | 'leadsPlatform' | 'crmLeads' | 'crmLeadsRepeat' | 'touchesOther' | 'sales' | 'revenuePln' | 'cashPln' | 'cplPln' | 'costPerSalePln' | 'roas' | 'roasCash' | 'ratiosThrough' | 'cplCoveredPln' | 'costPerSaleCoveredPln' | 'roasCovered' | 'roasCashCovered' | 'contractsSent' | 'contractsSigned' | 'contractsPending' | 'contractsLost' | 'contractSignRate' | 'costPerContractPln' | 'leadToSale' | 'leadToContract'>
);

export type MarketingCompareInfoFieldsFragment = (
  { __typename?: 'MarketingCompareInfo' }
  & Pick<MarketingCompareInfo, 'mode' | 'unit' | 'dateFrom' | 'dateTo' | 'aligned' | 'partial' | 'cutToDate'>
);

export type MarketingSourceStatusFieldsFragment = (
  { __typename?: 'MarketingSourceStatus' }
  & Pick<MarketingSourceStatus, 'source' | 'mode' | 'coveredFrom' | 'coveredTo' | 'completeThrough' | 'lastSuccessAt' | 'lastError' | 'running'>
);

export type MarketingChannelRuleFieldsFragment = (
  { __typename?: 'MarketingChannelRuleType' }
  & Pick<MarketingChannelRuleType, 'id' | 'priority' | 'field' | 'match' | 'pattern' | 'channel' | 'subChannel' | 'isPaid' | 'active' | 'note'>
);

export type MarketingCourseAliasFieldsFragment = (
  { __typename?: 'MarketingCourseAliasType' }
  & Pick<MarketingCourseAliasType, 'id' | 'kind' | 'value' | 'courseId' | 'priority'>
);

export type MarketingOfferRuleFieldsFragment = (
  { __typename?: 'MarketingOfferRuleType' }
  & Pick<MarketingOfferRuleType, 'id' | 'priority' | 'field' | 'regex' | 'offer'>
);

export type MarketingPipelineFieldsFragment = (
  { __typename?: 'MarketingPipelineType' }
  & Pick<MarketingPipelineType, 'id' | 'kommoId' | 'name' | 'funnelKind' | 'funnelKindLocked'>
);

export type MarketingTargetFieldsFragment = (
  { __typename?: 'MarketingTargetType' }
  & Pick<MarketingTargetType, 'id' | 'month' | 'channel' | 'familySlug' | 'metric' | 'value' | 'note' | 'updatedAt'>
);

export type MarketingSignalFieldsFragment = (
  { __typename?: 'MarketingSignalType' }
  & Pick<MarketingSignalType, 'id' | 'kind' | 'severity' | 'status' | 'entityId' | 'entityName' | 'familySlug' | 'channel' | 'windowFrom' | 'windowTo' | 'metrics' | 'params' | 'firstSeen' | 'lastSeen' | 'ackBy'>
);

export type MarketingCampaignAliasFieldsFragment = (
  { __typename?: 'MarketingCampaignAliasType' }
  & Pick<MarketingCampaignAliasType, 'id' | 'platform' | 'field' | 'rawValue' | 'entityId' | 'entityName' | 'createdBy' | 'createdAt'>
);

export type MarketingSearchRowFieldsFragment = (
  { __typename?: 'MarketingSearchRow' }
  & Pick<MarketingSearchRow, 'key' | 'key2' | 'host' | 'familySlug' | 'brand' | 'clicks' | 'impressions' | 'ctr' | 'position' | 'prevClicks' | 'prevImpressions' | 'prevPosition'>
);

export type MarketingPageMetricsFieldsFragment = (
  { __typename?: 'MarketingPageMetrics' }
  & Pick<MarketingPageMetrics, 'ga4Sessions' | 'ga4Engaged' | 'ga4KeyEvents' | 'ga4Views' | 'gscClicks' | 'gscImpressions' | 'fpPageviews' | 'fpEntrances' | 'fpSessions' | 'fpVisitors' | 'fpFormViews' | 'fpFormSubmits' | 'crmLeadsLanding' | 'crmLeadsForm' | 'crmLeadsAssisted' | 'salesLanding' | 'salesAssisted' | 'landingConversion' | 'formConversion' | 'assistRate' | 'denominator'>
);

export type MarketingSeoOpportunityFieldsFragment = (
  { __typename?: 'MarketingSeoOpportunity' }
  & Pick<MarketingSeoOpportunity, 'id' | 'kind' | 'status' | 'familySlug' | 'familyName' | 'keywordId' | 'keyword' | 'url' | 'params' | 'evidence' | 'score' | 'valuePlnEst' | 'isCurrent' | 'firstSeen' | 'lastSeen' | 'decidedBy' | 'decidedAt' | 'note' | 'link'>
);

export type MarketingSeoKeywordRowFieldsFragment = (
  { __typename?: 'MarketingSeoKeywordRow' }
  & Pick<MarketingSeoKeywordRow, 'id' | 'keyword' | 'familySlug' | 'isBrand' | 'brandOf' | 'intent' | 'searchVolume' | 'cpc' | 'difficulty' | 'tracked' | 'excluded' | 'trackReason' | 'source' | 'position' | 'prevPosition' | 'delta' | 'change' | 'comparable' | 'zone' | 'url' | 'spark' | 'bestCompetitor' | 'bestCompetitorPosition' | 'bestCompetitorSource' | 'serpOrganic' | 'domainPosition' | 'gscClicks28d' | 'gscImpressions28d' | 'gscPosition28d' | 'hasAiOverview' | 'aiOverviewCitesUs'>
);

export type ScheduledRunFieldsFragment = (
  { __typename?: 'ScheduledRunType' }
  & Pick<ScheduledRunType, 'beatKey' | 'at' | 'source' | 'status' | 'error' | 'triggerSource'>
);

export type RuntimeSettingFieldsFragment = (
  { __typename?: 'RuntimeSettingType' }
  & Pick<RuntimeSettingType, 'key' | 'section' | 'domain' | 'type' | 'mode' | 'optIn' | 'danger' | 'labelRu' | 'labelPl' | 'helpRu' | 'helpPl' | 'value' | 'envValue' | 'dbValue' | 'hasDbValue' | 'source' | 'serverForbids' | 'standBlocks' | 'readOnly' | 'choices' | 'updatedAt' | 'updatedByName' | 'beatKeys'>
  & { lastRun?: Maybe<(
    { __typename?: 'ScheduledRunType' }
    & ScheduledRunFieldsFragment
  )> }
);

export type ShortLinkFieldsFragment = (
  { __typename?: 'ShortLinkType' }
  & Pick<ShortLinkType, 'id' | 'kind' | 'title' | 'channel' | 'tags' | 'code' | 'url' | 'targetUrl' | 'targetHost' | 'subjectKind' | 'subjectId' | 'subjectLabel' | 'leadId' | 'candidateId' | 'clickCount' | 'humanClickCount' | 'firstHumanClickedAt' | 'lastClickedAt' | 'expiresAt' | 'revokedAt' | 'createdAt' | 'createdByName' | 'state' | 'canEdit' | 'canRevoke'>
);

export type SmsMessageFieldsFragment = (
  { __typename?: 'SmsMessageType' }
  & Pick<SmsMessageType, 'id' | 'topic' | 'step' | 'status' | 'skipReason' | 'error' | 'body' | 'phoneMasked' | 'segments' | 'encoding' | 'cost' | 'dlrStatus' | 'deliveredAt' | 'sentAt' | 'scheduledFor' | 'createdAt' | 'createdByName' | 'studentId' | 'studentName' | 'teacherId' | 'teacherName' | 'signerName' | 'leadId' | 'leadName' | 'candidateId' | 'candidateName' | 'subjectKind' | 'subjectId' | 'subjectLabel' | 'campaignId' | 'shortLinkId' | 'shortLinkUrl' | 'targetUrl' | 'humanClicks' | 'clicks' | 'canRetry' | 'canCancel'>
);

export type SmsPreviewFieldsFragment = (
  { __typename?: 'SmsPreviewType' }
  & Pick<SmsPreviewType, 'body' | 'encoding' | 'segments' | 'maxSegments' | 'tooLong' | 'withOptOut' | 'available' | 'reason' | 'message'>
);

export type StudentSmsStateFieldsFragment = (
  { __typename?: 'StudentSmsStateType' }
  & Pick<StudentSmsStateType, 'available' | 'reason' | 'phoneMasked'>
  & { messages: Array<(
    { __typename?: 'SmsMessageType' }
    & SmsMessageFieldsFragment
  )>, invoices: Array<(
    { __typename?: 'SmsInvoiceOptionType' }
    & Pick<SmsInvoiceOptionType, 'id' | 'number' | 'amount' | 'currency' | 'dueDate' | 'daysOverdue' | 'hasPayUrl'>
  )> }
);

export type TeacherSmsStateFieldsFragment = (
  { __typename?: 'TeacherSmsStateType' }
  & Pick<TeacherSmsStateType, 'available' | 'reason' | 'phoneMasked'>
  & { messages: Array<(
    { __typename?: 'SmsMessageType' }
    & SmsMessageFieldsFragment
  )>, documents: Array<(
    { __typename?: 'TeacherSignDocumentType' }
    & Pick<TeacherSignDocumentType, 'id' | 'number' | 'kind' | 'expiresAt'>
  )> }
);

export type SmsCampaignFieldsFragment = (
  { __typename?: 'SmsCampaignType' }
  & Pick<SmsCampaignType, 'id' | 'title' | 'body' | 'mode' | 'linkKind' | 'linkUrl' | 'groupId' | 'groupName' | 'createdAt' | 'createdByName' | 'cancelledAt'>
  & { counts: (
    { __typename?: 'SmsCampaignCountsType' }
    & Pick<SmsCampaignCountsType, 'total' | 'pending' | 'sent' | 'failed' | 'skipped' | 'delivered' | 'retryable' | 'cost' | 'finished'>
  ) }
);

export type SmsSettingsFieldsFragment = (
  { __typename?: 'SmsSettingsType' }
  & Pick<SmsSettingsType, 'enabled' | 'remindersEnabled' | 'senderName' | 'quietStart' | 'quietEnd' | 'dailyCapPerPhone' | 'allowUnicode' | 'allowForeignNumbers' | 'maxSegments' | 'lowBalancePoints' | 'legalEntityIds' | 'updatedAt' | 'updatedByName' | 'serverSmsAllowed' | 'serverRemindersAllowed' | 'provider' | 'tokenConfigured' | 'webhookConfigured' | 'webhookUrlMasked' | 'shortlinkBaseUrl' | 'onlyTo' | 'canEdit' | 'optOutSuffix' | 'defaultOptOutSuffix' | 'canEditTexts'>
);

export type LinkAddressesFieldsFragment = (
  { __typename?: 'LinkAddressesType' }
  & Pick<LinkAddressesType, 'dofinFormUrl' | 'dofinFormUrlDefault' | 'dofinFormUrlSaved' | 'lmsBaseUrl' | 'lmsBaseUrlDefault' | 'lmsBaseUrlSaved' | 'lmsInvoicesUrl' | 'shortlinkBaseUrl' | 'documensoBaseUrl' | 'canEdit' | 'updatedAt' | 'updatedByName'>
);

export type SmsProviderStatusFieldsFragment = (
  { __typename?: 'SmsProviderStatusType' }
  & Pick<SmsProviderStatusType, 'provider' | 'tokenConfigured' | 'checkedAt' | 'ok' | 'points' | 'paymentType' | 'lowBalance' | 'lowBalancePoints' | 'senderName' | 'senderStatus' | 'senderActive' | 'error' | 'errorCode'>
);

export type SmsConnectionCheckFieldsFragment = (
  { __typename?: 'SmsConnectionCheckType' }
  & Pick<SmsConnectionCheckType, 'ok' | 'provider' | 'cost' | 'parts' | 'segments' | 'error' | 'errorCode'>
);

export type SmsReminderPlanFieldsFragment = (
  { __typename?: 'ReminderPlanType' }
  & Pick<ReminderPlanType, 'topic' | 'enabled' | 'canEdit' | 'active' | 'states' | 'anchors' | 'impossibleSteps'>
  & { steps: Array<(
    { __typename?: 'ReminderStepType' }
    & Pick<ReminderStepType, 'id' | 'step' | 'anchor' | 'offsetMinutes' | 'condition' | 'templateCode' | 'enabled'>
  )>, templates: Array<(
    { __typename?: 'ReminderTemplateOptionType' }
    & Pick<ReminderTemplateOptionType, 'code' | 'name' | 'namePl' | 'body'>
  )> }
);

export type ZoomAccountFieldsFragment = (
  { __typename?: 'ZoomAccountType' }
  & Pick<ZoomAccountType, 'id' | 'zoomUserId' | 'email' | 'displayName' | 'isActive' | 'notes' | 'syncedAt' | 'createdAt'>
);

export type ZoomRecordingFieldsFragment = (
  { __typename?: 'ZoomRecordingType' }
  & Pick<ZoomRecordingType, 'id' | 'pk' | 'zoomMeetingUuid' | 'zoomMeetingId' | 'topic' | 'startTime' | 'durationMinutes' | 'totalSizeBytes' | 'files' | 'deletedFromZoom' | 'deletedAt' | 'syncedAt' | 'isOrphan' | 'isMatched' | 'isTooShort' | 'status' | 'failureReason'>
  & { zoomAccount: (
    { __typename?: 'ZoomAccountType' }
    & ZoomAccountFieldsFragment
  ) }
);

export type ZoomAccountUsageFieldsFragment = (
  { __typename?: 'ZoomAccountUsageType' }
  & Pick<ZoomAccountUsageType, 'id' | 'usersCount' | 'recordingsCount' | 'filesCount' | 'recordingsSizeBytes' | 'planStorageTotalBytes' | 'planStorageUsedBytes' | 'planStorageFreeBytes' | 'storageUsedPercent' | 'planRecordingType' | 'planUsageAvailable' | 'syncedAt'>
);

export type GroupLessonForZoomFieldsFragment = (
  { __typename?: 'GroupLessonForLMSType' }
  & Pick<GroupLessonForLmsType, 'id' | 'name' | 'number' | 'date' | 'startTime' | 'endTime' | 'video' | 'lmsDescription' | 'finished'>
  & { module: (
    { __typename?: 'GroupModuleType' }
    & Pick<GroupModuleType, 'id'>
    & { group: (
      { __typename?: 'MethodistGroupType' }
      & Pick<MethodistGroupType, 'id' | 'name'>
      & { zoomAccount?: Maybe<(
        { __typename?: 'ZoomAccountType' }
        & Pick<ZoomAccountType, 'id' | 'displayName'>
      )>, course: (
        { __typename?: 'CourseFilterType' }
        & Pick<CourseFilterType, 'id' | 'name'>
      ) }
    ) }
  ) }
);

export type LessonRecordingFieldsFragment = (
  { __typename?: 'LessonRecordingType' }
  & Pick<LessonRecordingType, 'id' | 'status' | 'matchedBy' | 'ambiguous' | 'transcriptS3Key' | 'chatS3Key' | 'audioS3Key' | 'aiSummary' | 'aiTimecodes' | 'aiModel' | 'errorMessage' | 'retryCount' | 'lastAttemptAt' | 'canResume' | 'createdAt' | 'updatedAt'>
  & { matchedByUser?: Maybe<(
    { __typename?: 'CustomUserType' }
    & Pick<CustomUserType, 'id' | 'email' | 'firstName' | 'lastName'>
  )>, lesson?: Maybe<(
    { __typename?: 'GroupLessonForLMSType' }
    & GroupLessonForZoomFieldsFragment
  )>, zoomRecording?: Maybe<(
    { __typename?: 'ZoomRecordingType' }
    & ZoomRecordingFieldsFragment
  )> }
);

export type ZoomLessonFieldsFragment = (
  { __typename?: 'GroupLessonForLMSType' }
  & { zoomRecordingMeta?: Maybe<(
    { __typename?: 'LessonRecordingType' }
    & LessonRecordingFieldsFragment
  )> }
  & GroupLessonForZoomFieldsFragment
);

export type ZoomProcessingLogFieldsFragment = (
  { __typename?: 'ZoomProcessingLogType' }
  & Pick<ZoomProcessingLogType, 'id' | 'step' | 'level' | 'message' | 'details' | 'createdAt'>
  & { lessonRecording?: Maybe<(
    { __typename?: 'LessonRecordingType' }
    & Pick<LessonRecordingType, 'id' | 'status'>
  )> }
);

export type GroupZoomScheduleFieldsFragment = (
  { __typename?: 'GroupZoomScheduleType' }
  & Pick<GroupZoomScheduleType, 'id' | 'weekDay' | 'runTime' | 'isActive'>
  & { group: (
    { __typename?: 'MethodistGroupType' }
    & Pick<MethodistGroupType, 'id' | 'name'>
  ) }
);

export type ZoomAuditEntryFieldsFragment = (
  { __typename?: 'ZoomAuditLogType' }
  & Pick<ZoomAuditLogType, 'id' | 'action' | 'targetKind' | 'targetId' | 'details' | 'createdAt'>
  & { user?: Maybe<(
    { __typename?: 'CustomUserType' }
    & Pick<CustomUserType, 'id' | 'email' | 'firstName' | 'lastName'>
  )> }
);

export type CorrectAgreementGroupActionMutationVariables = Exact<{
  agreementId: Scalars['ID'];
  groupId: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type CorrectAgreementGroupActionMutation = (
  { __typename?: 'Mutation' }
  & { correctAgreementGroup?: Maybe<(
    { __typename?: 'CorrectAgreementGroupMutation' }
    & Pick<CorrectAgreementGroupMutation, 'success' | 'oldTitle' | 'newTitle' | 'titleChanged' | 'titleKeptReason'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, agreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'agreementTitle'>
    )> }
  )> }
);

export type UndoEnrollmentActionMutationVariables = Exact<{
  agreementId: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type UndoEnrollmentActionMutation = (
  { __typename?: 'Mutation' }
  & { undoEnrollment?: Maybe<(
    { __typename?: 'UndoEnrollmentMutation' }
    & Pick<UndoEnrollmentMutation, 'success' | 'studentId' | 'studentVisible'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type ErpStartAiAgentRunMutationVariables = Exact<{
  agentKey: Scalars['String'];
  subjectKind?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['ID']>;
}>;


export type ErpStartAiAgentRunMutation = (
  { __typename?: 'Mutation' }
  & { startAiAgentRun: (
    { __typename?: 'AiAgentRunType' }
    & Pick<AiAgentRunType, 'id' | 'agentKey' | 'trigger' | 'status' | 'subjectKind' | 'subjectId' | 'subjectLabel' | 'createdAt' | 'startedAt' | 'finishedAt' | 'durationMs' | 'provider' | 'model' | 'inputTokens' | 'cachedTokens' | 'outputTokens' | 'costUsd' | 'resultSummary' | 'error' | 'createdByName'>
  ) }
);

export type ErpCancelAiAgentRunMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpCancelAiAgentRunMutation = (
  { __typename?: 'Mutation' }
  & { cancelAiAgentRun: (
    { __typename?: 'AiAgentRunType' }
    & Pick<AiAgentRunType, 'id' | 'agentKey' | 'trigger' | 'status' | 'startedAt' | 'finishedAt' | 'durationMs' | 'inputTokens' | 'cachedTokens' | 'outputTokens' | 'costUsd' | 'resultSummary' | 'error'>
  ) }
);

export type ErpSendAiChatMessageMutationVariables = Exact<{
  threadId?: Maybe<Scalars['ID']>;
  text: Scalars['String'];
  mentions?: Maybe<Array<AiChatMentionInput>>;
  attachmentIds?: Maybe<Array<Scalars['ID']>>;
}>;


export type ErpSendAiChatMessageMutation = (
  { __typename?: 'Mutation' }
  & { sendAiChatMessage: (
    { __typename?: 'AiChatThreadDetailType' }
    & { thread: (
      { __typename?: 'AiChatThreadType' }
      & Pick<AiChatThreadType, 'id' | 'title' | 'status' | 'createdAt' | 'lastMessageAt' | 'pinnedAt'>
    ), messages: Array<(
      { __typename?: 'AiChatMessageType' }
      & Pick<AiChatMessageType, 'id' | 'role' | 'text' | 'createdAt' | 'blocks' | 'interrupted'>
      & { mentions: Array<(
        { __typename?: 'AiChatMentionType' }
        & Pick<AiChatMentionType, 'kind' | 'id' | 'label'>
      )>, attachments: Array<(
        { __typename?: 'AiChatAttachmentType' }
        & Pick<AiChatAttachmentType, 'id' | 'url' | 'name' | 'mime' | 'size' | 'width' | 'height'>
      )>, toolCalls: Array<(
        { __typename?: 'AiChatToolCallType' }
        & Pick<AiChatToolCallType, 'name' | 'argsSummary' | 'status' | 'resultSummary'>
        & { source?: Maybe<(
          { __typename?: 'AiToolSourceType' }
          & Pick<AiToolSourceType, 'kind' | 'label'>
        )> }
      )>, pendingActions: Array<(
        { __typename?: 'AiChatPendingActionType' }
        & Pick<AiChatPendingActionType, 'id' | 'tool' | 'willDo' | 'status' | 'result' | 'createdAt'>
        & { source?: Maybe<(
          { __typename?: 'AiToolSourceType' }
          & Pick<AiToolSourceType, 'kind' | 'label'>
        )> }
      )> }
    )>, toolEvents: Array<(
      { __typename?: 'AiChatToolEventType' }
      & Pick<AiChatToolEventType, 'id' | 'messageId' | 'seq' | 'name' | 'args' | 'status' | 'resultPreview' | 'startedAt' | 'finishedAt'>
      & { source?: Maybe<(
        { __typename?: 'AiToolSourceType' }
        & Pick<AiToolSourceType, 'kind' | 'label'>
      )> }
    )>, activeRun?: Maybe<(
      { __typename?: 'AiAgentRunType' }
      & Pick<AiAgentRunType, 'id' | 'agentKey' | 'status' | 'model' | 'createdAt' | 'startedAt' | 'finishedAt' | 'error'>
      & { steps: Array<(
        { __typename?: 'AiAgentRunStepType' }
        & Pick<AiAgentRunStepType, 'id' | 'node' | 'status' | 'startedAt' | 'finishedAt' | 'summary' | 'error'>
      )> }
    )>, lastRun?: Maybe<(
      { __typename?: 'AiAgentRunType' }
      & Pick<AiAgentRunType, 'id' | 'agentKey' | 'status' | 'model' | 'createdAt' | 'startedAt' | 'finishedAt' | 'error'>
    )> }
  ) }
);

export type ErpResolveAiChatActionMutationVariables = Exact<{
  id: Scalars['ID'];
  approve: Scalars['Boolean'];
}>;


export type ErpResolveAiChatActionMutation = (
  { __typename?: 'Mutation' }
  & { resolveAiChatAction: (
    { __typename?: 'AiChatPendingActionType' }
    & Pick<AiChatPendingActionType, 'id' | 'tool' | 'willDo' | 'status' | 'result' | 'createdAt'>
    & { source?: Maybe<(
      { __typename?: 'AiToolSourceType' }
      & Pick<AiToolSourceType, 'kind' | 'label'>
    )> }
  ) }
);

export type ErpDeleteAiChatThreadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpDeleteAiChatThreadMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAiChatThread'>
);

export type ErpUploadAiChatAttachmentMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ErpUploadAiChatAttachmentMutation = (
  { __typename?: 'Mutation' }
  & { uploadAiChatAttachment: (
    { __typename?: 'AiChatAttachmentType' }
    & Pick<AiChatAttachmentType, 'id' | 'url' | 'name' | 'mime' | 'size' | 'width' | 'height'>
  ) }
);

export type ErpPinAiChatThreadMutationVariables = Exact<{
  id: Scalars['ID'];
  pinned: Scalars['Boolean'];
}>;


export type ErpPinAiChatThreadMutation = (
  { __typename?: 'Mutation' }
  & { pinAiChatThread: (
    { __typename?: 'AiChatThreadType' }
    & Pick<AiChatThreadType, 'id' | 'title' | 'status' | 'createdAt' | 'lastMessageAt' | 'pinnedAt'>
  ) }
);

export type ErpRenameAiChatThreadMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
}>;


export type ErpRenameAiChatThreadMutation = (
  { __typename?: 'Mutation' }
  & { renameAiChatThread: (
    { __typename?: 'AiChatThreadType' }
    & Pick<AiChatThreadType, 'id' | 'title' | 'status' | 'createdAt' | 'lastMessageAt' | 'pinnedAt'>
  ) }
);

export type ErpArchiveAiChatThreadMutationVariables = Exact<{
  id: Scalars['ID'];
  archived: Scalars['Boolean'];
}>;


export type ErpArchiveAiChatThreadMutation = (
  { __typename?: 'Mutation' }
  & { archiveAiChatThread: (
    { __typename?: 'AiChatThreadType' }
    & Pick<AiChatThreadType, 'id' | 'title' | 'status' | 'createdAt' | 'lastMessageAt' | 'pinnedAt'>
  ) }
);

export type ErpRejectAiFindingMutationVariables = Exact<{
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
}>;


export type ErpRejectAiFindingMutation = (
  { __typename?: 'Mutation' }
  & { rejectAiFinding: (
    { __typename?: 'AiFindingType' }
    & Pick<AiFindingType, 'id' | 'kind' | 'severity' | 'summary' | 'confidence' | 'groupId' | 'groupName' | 'lessonId' | 'lessonStartsAt' | 'proposedStartsAt' | 'scheduleNote' | 'conversationId' | 'messageIds' | 'excerpts' | 'taskId' | 'taskStatus' | 'feedback' | 'feedbackReason' | 'feedbackByName' | 'createdAt'>
  ) }
);

export type ErpConfirmAiFindingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpConfirmAiFindingMutation = (
  { __typename?: 'Mutation' }
  & { confirmAiFinding: (
    { __typename?: 'AiFindingType' }
    & Pick<AiFindingType, 'id' | 'kind' | 'severity' | 'summary' | 'confidence' | 'groupId' | 'groupName' | 'lessonId' | 'lessonStartsAt' | 'proposedStartsAt' | 'scheduleNote' | 'conversationId' | 'messageIds' | 'excerpts' | 'taskId' | 'taskStatus' | 'feedback' | 'feedbackReason' | 'feedbackByName' | 'createdAt'>
  ) }
);

export type ErpSaveAiKnowledgeDocumentMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  category: Scalars['String'];
  body: Scalars['String'];
  expectedVersion?: Maybe<Scalars['Int']>;
}>;


export type ErpSaveAiKnowledgeDocumentMutation = (
  { __typename?: 'Mutation' }
  & { saveAiKnowledgeDocument: (
    { __typename?: 'AiKnowledgeDocumentType' }
    & Pick<AiKnowledgeDocumentType, 'id' | 'title' | 'category' | 'status' | 'body' | 'sourceFileName' | 'version' | 'tokens' | 'chunkCount' | 'updatedAt' | 'updatedByName' | 'verifiedAt' | 'verifiedByName' | 'stale'>
  ) }
);

export type ErpUploadAiKnowledgeDocumentMutationVariables = Exact<{
  file: Scalars['Upload'];
  category: Scalars['String'];
  title?: Maybe<Scalars['String']>;
}>;


export type ErpUploadAiKnowledgeDocumentMutation = (
  { __typename?: 'Mutation' }
  & { uploadAiKnowledgeDocument: (
    { __typename?: 'AiKnowledgeDocumentType' }
    & Pick<AiKnowledgeDocumentType, 'id' | 'title' | 'category' | 'status' | 'body' | 'sourceFileName' | 'version' | 'tokens' | 'chunkCount' | 'updatedAt' | 'updatedByName' | 'verifiedAt' | 'verifiedByName' | 'stale'>
  ) }
);

export type ErpSetAiKnowledgeDocumentStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type ErpSetAiKnowledgeDocumentStatusMutation = (
  { __typename?: 'Mutation' }
  & { setAiKnowledgeDocumentStatus: (
    { __typename?: 'AiKnowledgeDocumentType' }
    & Pick<AiKnowledgeDocumentType, 'id' | 'title' | 'category' | 'status' | 'body' | 'sourceFileName' | 'version' | 'tokens' | 'chunkCount' | 'updatedAt' | 'updatedByName' | 'verifiedAt' | 'verifiedByName' | 'stale'>
  ) }
);

export type ErpDeleteAiKnowledgeDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpDeleteAiKnowledgeDocumentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAiKnowledgeDocument'>
);

export type ErpApproveAiKbCandidateMutationVariables = Exact<{
  id: Scalars['ID'];
  claim?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  replaceLine?: Maybe<Scalars['String']>;
  targetDocumentId?: Maybe<Scalars['ID']>;
  targetHeading?: Maybe<Scalars['String']>;
}>;


export type ErpApproveAiKbCandidateMutation = (
  { __typename?: 'Mutation' }
  & { approveAiKbCandidate: (
    { __typename?: 'AiKbCandidateType' }
    & ErpAiKbCandidateFieldsFragment
  ) }
);

export type ErpRejectAiKbCandidateMutationVariables = Exact<{
  id: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type ErpRejectAiKbCandidateMutation = (
  { __typename?: 'Mutation' }
  & { rejectAiKbCandidate: (
    { __typename?: 'AiKbCandidateType' }
    & ErpAiKbCandidateFieldsFragment
  ) }
);

export type ErpMarkAiKbCandidateDuplicateMutationVariables = Exact<{
  id: Scalars['ID'];
  duplicateOfId?: Maybe<Scalars['ID']>;
}>;


export type ErpMarkAiKbCandidateDuplicateMutation = (
  { __typename?: 'Mutation' }
  & { markAiKbCandidateDuplicate: (
    { __typename?: 'AiKbCandidateType' }
    & ErpAiKbCandidateFieldsFragment
  ) }
);

export type ErpUpdateAiKbCandidateMutationVariables = Exact<{
  id: Scalars['ID'];
  claim?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  targetDocumentId?: Maybe<Scalars['ID']>;
  targetHeading?: Maybe<Scalars['String']>;
}>;


export type ErpUpdateAiKbCandidateMutation = (
  { __typename?: 'Mutation' }
  & { updateAiKbCandidate: (
    { __typename?: 'AiKbCandidateType' }
    & ErpAiKbCandidateFieldsFragment
  ) }
);

export type ErpSetAiKbReviewersMutationVariables = Exact<{
  category: Scalars['String'];
  userIds: Array<Scalars['ID']>;
}>;


export type ErpSetAiKbReviewersMutation = (
  { __typename?: 'Mutation' }
  & { setAiKbReviewers: (
    { __typename?: 'AiKbReviewerCategoryType' }
    & Pick<AiKbReviewerCategoryType, 'category'>
    & { users: Array<(
      { __typename?: 'AiKbReviewerUserType' }
      & Pick<AiKbReviewerUserType, 'id' | 'name' | 'email'>
    )> }
  ) }
);

export type ErpRollbackAiKnowledgeDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
}>;


export type ErpRollbackAiKnowledgeDocumentMutation = (
  { __typename?: 'Mutation' }
  & { rollbackAiKnowledgeDocument: (
    { __typename?: 'AiKnowledgeDocumentType' }
    & Pick<AiKnowledgeDocumentType, 'id' | 'title' | 'category' | 'status' | 'body' | 'sourceFileName' | 'version' | 'tokens' | 'chunkCount' | 'updatedAt' | 'updatedByName' | 'verifiedAt' | 'verifiedByName' | 'stale'>
  ) }
);

export type ErpVerifyAiKnowledgeDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpVerifyAiKnowledgeDocumentMutation = (
  { __typename?: 'Mutation' }
  & { verifyAiKnowledgeDocument: (
    { __typename?: 'AiKnowledgeDocumentType' }
    & Pick<AiKnowledgeDocumentType, 'id' | 'title' | 'category' | 'status' | 'body' | 'sourceFileName' | 'version' | 'tokens' | 'chunkCount' | 'updatedAt' | 'updatedByName' | 'verifiedAt' | 'verifiedByName' | 'stale'>
  ) }
);

export type ErpRequestAiLessonAnalysisMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  force?: Maybe<Scalars['Boolean']>;
}>;


export type ErpRequestAiLessonAnalysisMutation = (
  { __typename?: 'Mutation' }
  & { requestAiLessonAnalysis: (
    { __typename?: 'AiLessonAnalysisType' }
    & Pick<AiLessonAnalysisType, 'id' | 'lessonId' | 'groupId' | 'groupName' | 'courseId' | 'lessonNumber' | 'lessonStartsAt' | 'teacherName' | 'status' | 'lessonStatus' | 'overallScore' | 'understandingScore' | 'understandingBand' | 'summary' | 'strengths' | 'developmentArea' | 'alerts' | 'reviewStatus' | 'reviewNote' | 'model' | 'createdAt' | 'error'>
    & { criteria: Array<(
      { __typename?: 'AiLessonCriterionType' }
      & Pick<AiLessonCriterionType, 'id' | 'label' | 'weight' | 'status' | 'score' | 'confidence' | 'whyScore' | 'whyNotHigher' | 'nextLevel'>
    )>, recommendation?: Maybe<(
      { __typename?: 'AiLessonRecommendationType' }
      & Pick<AiLessonRecommendationType, 'ruleId' | 'name' | 'action' | 'steps' | 'implementationCheck' | 'effectCheck'>
    )>, speakers: Array<(
      { __typename?: 'AiLessonSpeakerType' }
      & Pick<AiLessonSpeakerType, 'code' | 'label' | 'role'>
    )> }
  ) }
);

export type ErpReviewAiLessonAnalysisMutationVariables = Exact<{
  id: Scalars['ID'];
  decision: Scalars['String'];
  note?: Maybe<Scalars['String']>;
}>;


export type ErpReviewAiLessonAnalysisMutation = (
  { __typename?: 'Mutation' }
  & { reviewAiLessonAnalysis: (
    { __typename?: 'AiLessonAnalysisType' }
    & Pick<AiLessonAnalysisType, 'id' | 'status' | 'lessonStatus' | 'reviewStatus' | 'reviewNote'>
  ) }
);

export type ErpRequestAiLessonBatchMutationVariables = Exact<{
  lessonIds: Array<Scalars['ID']>;
  force?: Maybe<Scalars['Boolean']>;
}>;


export type ErpRequestAiLessonBatchMutation = (
  { __typename?: 'Mutation' }
  & { requestAiLessonAnalyses: (
    { __typename?: 'AiLessonBatchResultType' }
    & Pick<AiLessonBatchResultType, 'started' | 'refused'>
    & { items: Array<(
      { __typename?: 'AiLessonBatchItemType' }
      & Pick<AiLessonBatchItemType, 'lessonId' | 'outcome' | 'cached' | 'refusal' | 'message'>
      & { analysis?: Maybe<(
        { __typename?: 'AiLessonAnalysisType' }
        & Pick<AiLessonAnalysisType, 'id' | 'lessonId' | 'groupId' | 'groupName' | 'courseId' | 'lessonNumber' | 'lessonStartsAt' | 'teacherName' | 'status' | 'lessonStatus' | 'overallScore' | 'understandingScore' | 'understandingBand' | 'reviewStatus' | 'createdAt'>
        & { recommendation?: Maybe<(
          { __typename?: 'AiLessonRecommendationType' }
          & Pick<AiLessonRecommendationType, 'ruleId' | 'name' | 'action' | 'steps' | 'implementationCheck' | 'effectCheck'>
        )> }
      )> }
    )> }
  ) }
);

export type ErpGenerateTeacherNarrativeMutationVariables = Exact<{
  teacherId: Scalars['ID'];
}>;


export type ErpGenerateTeacherNarrativeMutation = (
  { __typename?: 'Mutation' }
  & { generateAiTeacherNarrative: (
    { __typename?: 'AiTeacherNarrativeType' }
    & Pick<AiTeacherNarrativeType, 'id' | 'teacherId' | 'status' | 'text' | 'analysesCount' | 'model' | 'error' | 'createdAt' | 'finishedAt' | 'unchanged'>
  ) }
);

export type ErpRefreshAiStudentPortraitMutationVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type ErpRefreshAiStudentPortraitMutation = (
  { __typename?: 'Mutation' }
  & { refreshAiStudentPortrait: (
    { __typename?: 'AiStudentPortraitType' }
    & Pick<AiStudentPortraitType, 'studentId' | 'status' | 'stale' | 'generatedAt' | 'model' | 'error' | 'summary' | 'learning' | 'engagement' | 'sentimentTrend' | 'communication'>
    & { risks: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, openNeeds: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, nextActions: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, about: Array<(
      { __typename?: 'AiPortraitFactType' }
      & Pick<AiPortraitFactType, 'key' | 'label' | 'value'>
    )>, strengths: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, concerns: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, checkpoints: Array<(
      { __typename?: 'AiPortraitCheckpointType' }
      & Pick<AiPortraitCheckpointType, 'key' | 'status' | 'text'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )> }
  ) }
);

export type ErpRequestAiReplySuggestionMutationVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type ErpRequestAiReplySuggestionMutation = (
  { __typename?: 'Mutation' }
  & { requestAiReplySuggestion: (
    { __typename?: 'AiReplySuggestionType' }
    & Pick<AiReplySuggestionType, 'id' | 'conversationId' | 'forMessageId' | 'status' | 'topic' | 'language' | 'text' | 'html' | 'confidence' | 'missingInfo' | 'error' | 'financeHidden' | 'createdAt' | 'updatedAt'>
    & { citations: Array<(
      { __typename?: 'AiCitationType' }
      & Pick<AiCitationType, 'kind' | 'ref' | 'label'>
    )> }
  ) }
);

export type ErpMarkAiReplySuggestionMutationVariables = Exact<{
  id: Scalars['ID'];
  action: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
}>;


export type ErpMarkAiReplySuggestionMutation = (
  { __typename?: 'Mutation' }
  & { markAiReplySuggestion: (
    { __typename?: 'AiReplySuggestionType' }
    & Pick<AiReplySuggestionType, 'id' | 'conversationId' | 'forMessageId' | 'status' | 'topic' | 'language' | 'text' | 'html' | 'confidence' | 'missingInfo' | 'error' | 'financeHidden' | 'createdAt' | 'updatedAt'>
    & { citations: Array<(
      { __typename?: 'AiCitationType' }
      & Pick<AiCitationType, 'kind' | 'ref' | 'label'>
    )> }
  ) }
);

export type ErpSetAiChatToolEnabledMutationVariables = Exact<{
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type ErpSetAiChatToolEnabledMutation = (
  { __typename?: 'Mutation' }
  & { setAiChatToolEnabled: (
    { __typename?: 'AiBuiltinToolType' }
    & Pick<AiBuiltinToolType, 'name' | 'group' | 'kind' | 'description' | 'enabled' | 'defaultEnabled'>
  ) }
);

export type ErpSaveAiSkillMutationVariables = Exact<{
  input: AiSkillInput;
}>;


export type ErpSaveAiSkillMutation = (
  { __typename?: 'Mutation' }
  & { saveAiSkill: (
    { __typename?: 'AiAgentSkillType' }
    & Pick<AiAgentSkillType, 'id' | 'slug' | 'title' | 'description' | 'instructions' | 'status' | 'source' | 'version' | 'agents' | 'pluginId' | 'pluginName' | 'updatedAt' | 'createdByName' | 'skipped'>
    & { files: Array<(
      { __typename?: 'AiSkillFileType' }
      & Pick<AiSkillFileType, 'path' | 'size'>
    )> }
  ) }
);

export type ErpImportAiSkillMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ErpImportAiSkillMutation = (
  { __typename?: 'Mutation' }
  & { importAiSkill: (
    { __typename?: 'AiAgentSkillType' }
    & Pick<AiAgentSkillType, 'id' | 'slug' | 'title' | 'description' | 'instructions' | 'status' | 'source' | 'version' | 'agents' | 'pluginId' | 'pluginName' | 'updatedAt' | 'createdByName' | 'skipped'>
    & { files: Array<(
      { __typename?: 'AiSkillFileType' }
      & Pick<AiSkillFileType, 'path' | 'size'>
    )> }
  ) }
);

export type ErpSetAiSkillStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type ErpSetAiSkillStatusMutation = (
  { __typename?: 'Mutation' }
  & { setAiSkillStatus: (
    { __typename?: 'AiAgentSkillType' }
    & Pick<AiAgentSkillType, 'id' | 'slug' | 'title' | 'description' | 'instructions' | 'status' | 'source' | 'version' | 'agents' | 'pluginId' | 'pluginName' | 'updatedAt' | 'createdByName' | 'skipped'>
    & { files: Array<(
      { __typename?: 'AiSkillFileType' }
      & Pick<AiSkillFileType, 'path' | 'size'>
    )> }
  ) }
);

export type ErpDeleteAiSkillMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpDeleteAiSkillMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAiSkill'>
);

export type ErpSaveAiMcpConnectionMutationVariables = Exact<{
  input: AiMcpConnectionInput;
}>;


export type ErpSaveAiMcpConnectionMutation = (
  { __typename?: 'Mutation' }
  & { saveAiMcpConnection: (
    { __typename?: 'AiMcpConnectionType' }
    & Pick<AiMcpConnectionType, 'id' | 'slug' | 'title' | 'url' | 'transport' | 'authType' | 'headerName' | 'hasSecret' | 'oauthConnected' | 'oauthExpiresAt' | 'allowPii' | 'enabled' | 'status' | 'lastCheckedAt' | 'lastError' | 'serverName' | 'serverVersion' | 'pluginId' | 'pluginName' | 'note'>
    & { tools: Array<(
      { __typename?: 'AiMcpToolType' }
      & Pick<AiMcpToolType, 'name' | 'description' | 'inputSchema' | 'enabled' | 'requiresApproval' | 'missing' | 'changed' | 'unsupportedReason'>
    )>, notes: Array<(
      { __typename?: 'AiExtNoteType' }
      & Pick<AiExtNoteType, 'code' | 'params'>
    )> }
  ) }
);

export type ErpTestAiMcpConnectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpTestAiMcpConnectionMutation = (
  { __typename?: 'Mutation' }
  & { testAiMcpConnection: (
    { __typename?: 'AiMcpConnectionType' }
    & Pick<AiMcpConnectionType, 'id' | 'slug' | 'title' | 'url' | 'transport' | 'authType' | 'headerName' | 'hasSecret' | 'oauthConnected' | 'oauthExpiresAt' | 'allowPii' | 'enabled' | 'status' | 'lastCheckedAt' | 'lastError' | 'serverName' | 'serverVersion' | 'pluginId' | 'pluginName' | 'note'>
    & { tools: Array<(
      { __typename?: 'AiMcpToolType' }
      & Pick<AiMcpToolType, 'name' | 'description' | 'inputSchema' | 'enabled' | 'requiresApproval' | 'missing' | 'changed' | 'unsupportedReason'>
    )>, notes: Array<(
      { __typename?: 'AiExtNoteType' }
      & Pick<AiExtNoteType, 'code' | 'params'>
    )> }
  ) }
);

export type ErpStartAiMcpOAuthMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpStartAiMcpOAuthMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'startAiMcpOAuth'>
);

export type ErpSetAiMcpToolSettingsMutationVariables = Exact<{
  id: Scalars['ID'];
  tools: Array<AiMcpToolSettingInput>;
}>;


export type ErpSetAiMcpToolSettingsMutation = (
  { __typename?: 'Mutation' }
  & { setAiMcpToolSettings: (
    { __typename?: 'AiMcpConnectionType' }
    & Pick<AiMcpConnectionType, 'id' | 'slug' | 'title' | 'url' | 'transport' | 'authType' | 'headerName' | 'hasSecret' | 'oauthConnected' | 'oauthExpiresAt' | 'allowPii' | 'enabled' | 'status' | 'lastCheckedAt' | 'lastError' | 'serverName' | 'serverVersion' | 'pluginId' | 'pluginName' | 'note'>
    & { tools: Array<(
      { __typename?: 'AiMcpToolType' }
      & Pick<AiMcpToolType, 'name' | 'description' | 'inputSchema' | 'enabled' | 'requiresApproval' | 'missing' | 'changed' | 'unsupportedReason'>
    )>, notes: Array<(
      { __typename?: 'AiExtNoteType' }
      & Pick<AiExtNoteType, 'code' | 'params'>
    )> }
  ) }
);

export type ErpDeleteAiMcpConnectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpDeleteAiMcpConnectionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAiMcpConnection'>
);

export type ErpImportAiPluginMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ErpImportAiPluginMutation = (
  { __typename?: 'Mutation' }
  & { importAiPlugin: (
    { __typename?: 'AiPluginType' }
    & Pick<AiPluginType, 'id' | 'name' | 'version' | 'description' | 'enabled' | 'skipped' | 'createdAt'>
    & { skippedItems: Array<(
      { __typename?: 'AiExtNoteType' }
      & Pick<AiExtNoteType, 'code' | 'params'>
    )>, skills: Array<(
      { __typename?: 'AiAgentSkillType' }
      & Pick<AiAgentSkillType, 'id' | 'slug' | 'title' | 'status' | 'source' | 'version'>
    )>, connections: Array<(
      { __typename?: 'AiMcpConnectionType' }
      & Pick<AiMcpConnectionType, 'id' | 'slug' | 'title' | 'url' | 'authType' | 'hasSecret' | 'oauthConnected' | 'enabled' | 'status' | 'note'>
    )> }
  ) }
);

export type ErpSetAiPluginEnabledMutationVariables = Exact<{
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type ErpSetAiPluginEnabledMutation = (
  { __typename?: 'Mutation' }
  & { setAiPluginEnabled: (
    { __typename?: 'AiPluginType' }
    & Pick<AiPluginType, 'id' | 'name' | 'version' | 'description' | 'enabled' | 'skipped' | 'createdAt'>
    & { skippedItems: Array<(
      { __typename?: 'AiExtNoteType' }
      & Pick<AiExtNoteType, 'code' | 'params'>
    )>, skills: Array<(
      { __typename?: 'AiAgentSkillType' }
      & Pick<AiAgentSkillType, 'id' | 'slug' | 'title' | 'status' | 'source' | 'version'>
    )>, connections: Array<(
      { __typename?: 'AiMcpConnectionType' }
      & Pick<AiMcpConnectionType, 'id' | 'slug' | 'title' | 'url' | 'authType' | 'hasSecret' | 'oauthConnected' | 'enabled' | 'status' | 'note'>
    )> }
  ) }
);

export type ErpDeleteAiPluginMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpDeleteAiPluginMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAiPlugin'>
);

export type AppendTeacherApplicationMutationVariables = Exact<{
  application: ApplicationInputType;
  teacherId: Scalars['ID'];
}>;


export type AppendTeacherApplicationMutation = (
  { __typename?: 'Mutation' }
  & { addTeacherApplication?: Maybe<(
    { __typename?: 'AddTeacherApplication' }
    & Pick<AddTeacherApplication, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, application?: Maybe<(
      { __typename?: 'ApplicationType' }
      & Pick<ApplicationType, 'id'>
    )> }
  )> }
);

export type UpdateTeacherApplicationMutationVariables = Exact<{
  application: UpdateApplicationInputType;
}>;


export type UpdateTeacherApplicationMutation = (
  { __typename?: 'Mutation' }
  & { updateTeacherApplication?: Maybe<(
    { __typename?: 'UpdateTeacherApplication' }
    & Pick<UpdateTeacherApplication, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type RemoveApplicationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveApplicationMutation = (
  { __typename?: 'Mutation' }
  & { deleteTeacherApplication?: Maybe<(
    { __typename?: 'DeleteTeacherApplication' }
    & Pick<DeleteTeacherApplication, 'success' | 'errors'>
  )> }
);

export type RefreshTokenMutationVariables = Exact<{
  refresh_token: Scalars['String'];
  scope: Scalars['String'];
}>;


export type RefreshTokenMutation = (
  { __typename?: 'Mutation' }
  & { refreshToken?: Maybe<(
    { __typename?: 'CustomRefreshToken' }
    & Pick<CustomRefreshToken, 'token' | 'refreshToken' | 'payload'>
  )> }
);

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendPasswordResetEmailMutation = (
  { __typename?: 'Mutation' }
  & { sendPasswordResetEmail?: Maybe<(
    { __typename?: 'CustomSendPasswordResetEmail' }
    & Pick<CustomSendPasswordResetEmail, 'success' | 'errors'>
  )> }
);

export type PasswordSetMutationVariables = Exact<{
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
  token: Scalars['String'];
}>;


export type PasswordSetMutation = (
  { __typename?: 'Mutation' }
  & { passwordSet?: Maybe<(
    { __typename?: 'PasswordSet' }
    & Pick<PasswordSet, 'success' | 'errors'>
  )> }
);

export type PasswordResetMutationVariables = Exact<{
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
  token: Scalars['String'];
}>;


export type PasswordResetMutation = (
  { __typename?: 'Mutation' }
  & { passwordReset?: Maybe<(
    { __typename?: 'PasswordReset' }
    & Pick<PasswordReset, 'success' | 'errors'>
  )> }
);

export type VerifyTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyTokenMutation = (
  { __typename?: 'Mutation' }
  & { verifyToken?: Maybe<(
    { __typename?: 'VerifyToken' }
    & Pick<VerifyToken, 'success' | 'errors'>
  )> }
);

export type LoginMutationVariables = Exact<{
  password: Scalars['String'];
  email: Scalars['String'];
  scope: Scalars['String'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { customLogin?: Maybe<(
    { __typename?: 'CustomObtainJSONWebToken' }
    & Pick<CustomObtainJsonWebToken, 'success' | 'errors' | 'token' | 'refreshToken'>
    & { user?: Maybe<(
      { __typename?: 'UserNode' }
      & UserFieldsFragment
    )> }
  )> }
);

export type EnrollToCareerCenterMutationVariables = Exact<{
  studentIds?: Maybe<Array<Scalars['ID']>>;
  groupId?: Maybe<Scalars['ID']>;
  directionId?: Maybe<Scalars['ID']>;
}>;


export type EnrollToCareerCenterMutation = (
  { __typename?: 'Mutation' }
  & { enrollCareerMembers?: Maybe<(
    { __typename?: 'EnrollCareerMembers' }
    & Pick<EnrollCareerMembers, 'success' | 'created' | 'reactivated' | 'skipped'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type SetCareerMembersAccessMutationVariables = Exact<{
  memberIds: Array<Scalars['ID']>;
  removed: Scalars['Boolean'];
}>;


export type SetCareerMembersAccessMutation = (
  { __typename?: 'Mutation' }
  & { setCareerMembersAccess?: Maybe<(
    { __typename?: 'SetCareerMembersAccess' }
    & Pick<SetCareerMembersAccess, 'success' | 'changed' | 'unchanged' | 'missing'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveCareerMemberMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CareerMemberInput;
}>;


export type SaveCareerMemberMutation = (
  { __typename?: 'Mutation' }
  & { updateCareerMember?: Maybe<(
    { __typename?: 'UpdateCareerMember' }
    & Pick<UpdateCareerMember, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, member?: Maybe<(
      { __typename?: 'CareerMemberType' }
      & Pick<CareerMemberType, 'id' | 'studentId' | 'studentName' | 'studentEmail' | 'groupId' | 'groupName' | 'directionId' | 'directionTitle' | 'status' | 'enrolledAt' | 'notes' | 'lessonsCompleted' | 'lessonsTotal'>
    )> }
  )> }
);

export type SaveCareerLessonMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: CareerLessonInput;
}>;


export type SaveCareerLessonMutation = (
  { __typename?: 'Mutation' }
  & { upsertCareerLesson?: Maybe<(
    { __typename?: 'UpsertCareerLesson' }
    & Pick<UpsertCareerLesson, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, lesson?: Maybe<(
      { __typename?: 'CareerLessonType' }
      & Pick<CareerLessonType, 'id' | 'order' | 'title' | 'summary' | 'content' | 'durationMin' | 'completionKind' | 'artifactHint' | 'outcomeKind' | 'outcomeLabel' | 'materialLanguage' | 'isPublished' | 'videoUrl'>
      & { attachments: Array<(
        { __typename?: 'CareerLessonAttachmentType' }
        & Pick<CareerLessonAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'url'>
      )>, stats?: Maybe<(
        { __typename?: 'CareerLessonStatsType' }
        & Pick<CareerLessonStatsType, 'openedCount' | 'completedCount' | 'membersTotal'>
      )>, quizQuestions: Array<(
        { __typename?: 'CareerQuizQuestionType' }
        & Pick<CareerQuizQuestionType, 'id' | 'order' | 'text' | 'options' | 'correctIndexes'>
      )> }
    )> }
  )> }
);

export type AttachCareerLessonVideoMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  video: Scalars['Upload'];
}>;


export type AttachCareerLessonVideoMutation = (
  { __typename?: 'Mutation' }
  & { uploadCareerLessonVideo?: Maybe<(
    { __typename?: 'UploadCareerLessonVideo' }
    & Pick<UploadCareerLessonVideo, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, lesson?: Maybe<(
      { __typename?: 'CareerLessonType' }
      & Pick<CareerLessonType, 'id' | 'videoUrl'>
      & { attachments: Array<(
        { __typename?: 'CareerLessonAttachmentType' }
        & Pick<CareerLessonAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'url'>
      )> }
    )> }
  )> }
);

export type RemoveCareerLessonVideoMutationVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type RemoveCareerLessonVideoMutation = (
  { __typename?: 'Mutation' }
  & { clearCareerLessonVideo?: Maybe<(
    { __typename?: 'ClearCareerLessonVideo' }
    & Pick<ClearCareerLessonVideo, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, lesson?: Maybe<(
      { __typename?: 'CareerLessonType' }
      & Pick<CareerLessonType, 'id' | 'videoUrl'>
      & { attachments: Array<(
        { __typename?: 'CareerLessonAttachmentType' }
        & Pick<CareerLessonAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'url'>
      )> }
    )> }
  )> }
);

export type AttachCareerLessonFileMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type AttachCareerLessonFileMutation = (
  { __typename?: 'Mutation' }
  & { addCareerLessonAttachment?: Maybe<(
    { __typename?: 'AddCareerLessonAttachment' }
    & Pick<AddCareerLessonAttachment, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, attachment?: Maybe<(
      { __typename?: 'CareerLessonAttachmentType' }
      & Pick<CareerLessonAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'url'>
    )>, lesson?: Maybe<(
      { __typename?: 'CareerLessonType' }
      & Pick<CareerLessonType, 'id' | 'videoUrl'>
      & { attachments: Array<(
        { __typename?: 'CareerLessonAttachmentType' }
        & Pick<CareerLessonAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'url'>
      )> }
    )> }
  )> }
);

export type DetachCareerLessonFileMutationVariables = Exact<{
  attachmentId: Scalars['ID'];
}>;


export type DetachCareerLessonFileMutation = (
  { __typename?: 'Mutation' }
  & { removeCareerLessonAttachment?: Maybe<(
    { __typename?: 'RemoveCareerLessonAttachment' }
    & Pick<RemoveCareerLessonAttachment, 'success' | 'ok'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type SaveCareerLessonQuizMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  questions: Array<CareerQuizQuestionInput>;
}>;


export type SaveCareerLessonQuizMutation = (
  { __typename?: 'Mutation' }
  & { setCareerLessonQuiz?: Maybe<(
    { __typename?: 'SetCareerLessonQuiz' }
    & Pick<SetCareerLessonQuiz, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, lesson?: Maybe<(
      { __typename?: 'CareerLessonType' }
      & Pick<CareerLessonType, 'id'>
      & { quizQuestions: Array<(
        { __typename?: 'CareerQuizQuestionType' }
        & Pick<CareerQuizQuestionType, 'id' | 'order' | 'text' | 'options' | 'correctIndexes'>
      )> }
    )> }
  )> }
);

export type ErpVacancyFieldsFragment = (
  { __typename?: 'VacancyType' }
  & Pick<VacancyType, 'id' | 'title' | 'companyName' | 'applyUrl' | 'location' | 'workMode' | 'seniority' | 'employmentType' | 'salaryMin' | 'salaryMax' | 'salaryCurrency' | 'description' | 'status' | 'publishedAt' | 'expiresAt' | 'createdAt' | 'directionIds' | 'directionTitles' | 'skillIds' | 'skillNames' | 'appliedCount' | 'source' | 'createdByName' | 'reviewedByName' | 'reviewedAt' | 'updatedAt'>
  & { duplicateOf: Array<(
    { __typename?: 'VacancyDuplicateHintType' }
    & Pick<VacancyDuplicateHintType, 'vacancyId' | 'title' | 'companyName' | 'status' | 'score'>
  )> }
);

export type UpsertVacancyMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: VacancyInput;
}>;


export type UpsertVacancyMutation = (
  { __typename?: 'Mutation' }
  & { upsertVacancy?: Maybe<(
    { __typename?: 'UpsertVacancy' }
    & Pick<UpsertVacancy, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, vacancy?: Maybe<(
      { __typename?: 'VacancyType' }
      & ErpVacancyFieldsFragment
    )> }
  )> }
);

export type DeleteVacancyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteVacancyMutation = (
  { __typename?: 'Mutation' }
  & { deleteVacancy?: Maybe<(
    { __typename?: 'DeleteVacancy' }
    & Pick<DeleteVacancy, 'success' | 'ok' | 'deletedInteractions'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type SetVacancyStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type SetVacancyStatusMutation = (
  { __typename?: 'Mutation' }
  & { setVacancyStatus?: Maybe<(
    { __typename?: 'SetVacancyStatus' }
    & Pick<SetVacancyStatus, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, vacancy?: Maybe<(
      { __typename?: 'VacancyType' }
      & ErpVacancyFieldsFragment
    )> }
  )> }
);

export type BulkPublishVacanciesMutationVariables = Exact<{
  ids: Array<Scalars['ID']>;
}>;


export type BulkPublishVacanciesMutation = (
  { __typename?: 'Mutation' }
  & { bulkPublishVacancies?: Maybe<(
    { __typename?: 'BulkPublishVacancies' }
    & Pick<BulkPublishVacancies, 'success' | 'published'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type RecordPlacementMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: PlacementInput;
}>;


export type RecordPlacementMutation = (
  { __typename?: 'Mutation' }
  & { recordPlacement?: Maybe<(
    { __typename?: 'RecordPlacement' }
    & Pick<RecordPlacement, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, placement?: Maybe<(
      { __typename?: 'PlacementRecordType' }
      & Pick<PlacementRecordType, 'id' | 'memberId' | 'studentName' | 'companyName' | 'position' | 'startedAt' | 'confirmedAt'>
    )> }
  )> }
);

export type BulkSetVacancyStatusMutationVariables = Exact<{
  ids: Array<Scalars['ID']>;
  status: Scalars['String'];
}>;


export type BulkSetVacancyStatusMutation = (
  { __typename?: 'Mutation' }
  & { bulkSetVacancyStatus?: Maybe<(
    { __typename?: 'BulkSetVacancyStatus' }
    & Pick<BulkSetVacancyStatus, 'success' | 'moved'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type SaveCareerSkillMutationVariables = Exact<{
  input: CareerSkillInput;
}>;


export type SaveCareerSkillMutation = (
  { __typename?: 'Mutation' }
  & { upsertCareerSkill?: Maybe<(
    { __typename?: 'UpsertCareerSkill' }
    & Pick<UpsertCareerSkill, 'success'>
    & { skill?: Maybe<(
      { __typename?: 'SkillType' }
      & Pick<SkillType, 'id' | 'name' | 'slug' | 'category' | 'description' | 'isActive'>
      & { levelCriteria: Array<(
        { __typename?: 'SkillLevelCriteriaType' }
        & Pick<SkillLevelCriteriaType, 'level' | 'points' | 'example'>
      )> }
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type ToggleCareerSkillMutationVariables = Exact<{
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
}>;


export type ToggleCareerSkillMutation = (
  { __typename?: 'Mutation' }
  & { setCareerSkillActive?: Maybe<(
    { __typename?: 'SetCareerSkillActive' }
    & Pick<SetCareerSkillActive, 'success'>
    & { skill?: Maybe<(
      { __typename?: 'SkillType' }
      & Pick<SkillType, 'id' | 'isActive'>
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveCareerSkillIconMutationVariables = Exact<{
  id: Scalars['ID'];
  icon?: Maybe<Scalars['Upload']>;
  clear?: Maybe<Scalars['Boolean']>;
}>;


export type SaveCareerSkillIconMutation = (
  { __typename?: 'Mutation' }
  & { setCareerSkillIcon?: Maybe<(
    { __typename?: 'SetCareerSkillIcon' }
    & Pick<SetCareerSkillIcon, 'success'>
    & { skill?: Maybe<(
      { __typename?: 'SkillType' }
      & Pick<SkillType, 'id' | 'iconUrl'>
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type JoinCareerSkillsMutationVariables = Exact<{
  sourceId: Scalars['ID'];
  targetId: Scalars['ID'];
}>;


export type JoinCareerSkillsMutation = (
  { __typename?: 'Mutation' }
  & { mergeCareerSkills?: Maybe<(
    { __typename?: 'MergeCareerSkills' }
    & Pick<MergeCareerSkills, 'success' | 'movedStudentSkills' | 'movedVacancies' | 'movedProjects' | 'movedCourseSkills'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveGroupSkillsMutationVariables = Exact<{
  groupId: Scalars['ID'];
  rows: Array<GroupSkillInput>;
}>;


export type SaveGroupSkillsMutation = (
  { __typename?: 'Mutation' }
  & { setGroupSkills?: Maybe<(
    { __typename?: 'SetGroupSkills' }
    & Pick<SetGroupSkills, 'success' | 'added' | 'updated' | 'deactivated'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveCourseSkillsMutationVariables = Exact<{
  courseId: Scalars['ID'];
  rows: Array<CourseSkillInput>;
}>;


export type SaveCourseSkillsMutation = (
  { __typename?: 'Mutation' }
  & { setCourseSkills?: Maybe<(
    { __typename?: 'SetCourseSkills' }
    & Pick<SetCourseSkills, 'success' | 'added' | 'updated' | 'deactivated'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveCourseCompletionMutationVariables = Exact<{
  studentId: Scalars['ID'];
  courseId: Scalars['ID'];
  status: Scalars['String'];
  note?: Maybe<Scalars['String']>;
}>;


export type SaveCourseCompletionMutation = (
  { __typename?: 'Mutation' }
  & { setCourseCompletion?: Maybe<(
    { __typename?: 'SetCourseCompletion' }
    & Pick<SetCourseCompletion, 'success' | 'completedCourseIds'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type RecalcStudentCourseSkillsMutationVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type RecalcStudentCourseSkillsMutation = (
  { __typename?: 'Mutation' }
  & { syncStudentCourseSkills?: Maybe<(
    { __typename?: 'SyncStudentCourseSkills' }
    & Pick<SyncStudentCourseSkills, 'success' | 'granted' | 'promoted' | 'demoted' | 'unchanged'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveCareerExerciseTemplateMutationVariables = Exact<{
  templateId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  intro?: Maybe<Scalars['String']>;
  outro?: Maybe<Scalars['String']>;
  fields: Array<CareerExerciseFieldInput>;
}>;


export type SaveCareerExerciseTemplateMutation = (
  { __typename?: 'Mutation' }
  & { saveCareerExerciseTemplate?: Maybe<(
    { __typename?: 'SaveCareerExerciseTemplate' }
    & Pick<SaveCareerExerciseTemplate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type ToggleCareerExerciseTemplateMutationVariables = Exact<{
  templateId: Scalars['ID'];
  isActive: Scalars['Boolean'];
}>;


export type ToggleCareerExerciseTemplateMutation = (
  { __typename?: 'Mutation' }
  & { toggleCareerExerciseTemplate?: Maybe<(
    { __typename?: 'ToggleCareerExerciseTemplate' }
    & Pick<ToggleCareerExerciseTemplate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type AttachCareerExerciseTemplateMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  templateId: Scalars['ID'];
}>;


export type AttachCareerExerciseTemplateMutation = (
  { __typename?: 'Mutation' }
  & { attachCareerExerciseTemplate?: Maybe<(
    { __typename?: 'AttachCareerExerciseTemplate' }
    & Pick<AttachCareerExerciseTemplate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type DetachCareerExerciseTemplateMutationVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type DetachCareerExerciseTemplateMutation = (
  { __typename?: 'Mutation' }
  & { detachCareerExerciseTemplate?: Maybe<(
    { __typename?: 'DetachCareerExerciseTemplate' }
    & Pick<DetachCareerExerciseTemplate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type DropCareerExerciseSubmissionsMutationVariables = Exact<{
  templateId: Scalars['ID'];
  confirm: Scalars['Boolean'];
}>;


export type DropCareerExerciseSubmissionsMutation = (
  { __typename?: 'Mutation' }
  & { resetCareerExerciseTemplate?: Maybe<(
    { __typename?: 'ResetCareerExerciseTemplate' }
    & Pick<ResetCareerExerciseTemplate, 'success' | 'deletedSubmissions'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SavePromoCampaignMutationVariables = Exact<{
  input: PromoCampaignInput;
}>;


export type SavePromoCampaignMutation = (
  { __typename?: 'Mutation' }
  & { upsertPromoCampaign?: Maybe<(
    { __typename?: 'UpsertPromoCampaign' }
    & Pick<UpsertPromoCampaign, 'success' | 'campaignId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type TogglePromoCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
}>;


export type TogglePromoCampaignMutation = (
  { __typename?: 'Mutation' }
  & { setPromoCampaignActive?: Maybe<(
    { __typename?: 'SetPromoCampaignActive' }
    & Pick<SetPromoCampaignActive, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type GivePromoCodeMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  studentId: Scalars['ID'];
}>;


export type GivePromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { issuePromoCode?: Maybe<(
    { __typename?: 'IssuePromoCode' }
    & Pick<IssuePromoCode, 'success' | 'code'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type DropPromoCodeMutationVariables = Exact<{
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
}>;


export type DropPromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { revokePromoCode?: Maybe<(
    { __typename?: 'RevokePromoCode' }
    & Pick<RevokePromoCode, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type CheckPromoCodesMutationVariables = Exact<{ [key: string]: never; }>;


export type CheckPromoCodesMutation = (
  { __typename?: 'Mutation' }
  & { reconcilePromoCodes?: Maybe<(
    { __typename?: 'ReconcilePromoCodes' }
    & Pick<ReconcilePromoCodes, 'success' | 'checked' | 'redeemed' | 'ambiguous' | 'expired'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveShareTemplateMutationVariables = Exact<{
  input: ShareTemplateInput;
}>;


export type SaveShareTemplateMutation = (
  { __typename?: 'Mutation' }
  & { upsertShareTemplate?: Maybe<(
    { __typename?: 'UpsertShareTemplate' }
    & Pick<UpsertShareTemplate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveGrowthTrackMutationVariables = Exact<{
  input: GrowthTrackInput;
}>;


export type SaveGrowthTrackMutation = (
  { __typename?: 'Mutation' }
  & { saveGrowthTrack?: Maybe<(
    { __typename?: 'SaveGrowthTrack' }
    & Pick<SaveGrowthTrack, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type ToggleGrowthTrackMutationVariables = Exact<{
  trackId: Scalars['ID'];
  isActive: Scalars['Boolean'];
}>;


export type ToggleGrowthTrackMutation = (
  { __typename?: 'Mutation' }
  & { toggleGrowthTrack?: Maybe<(
    { __typename?: 'ToggleGrowthTrack' }
    & Pick<ToggleGrowthTrack, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveAchievementMutationVariables = Exact<{
  input: AchievementInput;
}>;


export type SaveAchievementMutation = (
  { __typename?: 'Mutation' }
  & { saveAchievement?: Maybe<(
    { __typename?: 'SaveAchievement' }
    & Pick<SaveAchievement, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type ToggleAchievementMutationVariables = Exact<{
  achievementId: Scalars['ID'];
  isActive: Scalars['Boolean'];
}>;


export type ToggleAchievementMutation = (
  { __typename?: 'Mutation' }
  & { toggleAchievement?: Maybe<(
    { __typename?: 'ToggleAchievement' }
    & Pick<ToggleAchievement, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveSiteCourseMutationVariables = Exact<{
  input: SiteCourseInput;
}>;


export type SaveSiteCourseMutation = (
  { __typename?: 'Mutation' }
  & { saveSiteCourse?: Maybe<(
    { __typename?: 'SaveSiteCourse' }
    & Pick<SaveSiteCourse, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type ToggleSiteCourseMutationVariables = Exact<{
  siteCourseId: Scalars['ID'];
  isActive: Scalars['Boolean'];
}>;


export type ToggleSiteCourseMutation = (
  { __typename?: 'Mutation' }
  & { toggleSiteCourse?: Maybe<(
    { __typename?: 'ToggleSiteCourse' }
    & Pick<ToggleSiteCourse, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SetCourseProgramMutationVariables = Exact<{
  courseId: Scalars['ID'];
  modules: Array<ProgramModuleInput>;
}>;


export type SetCourseProgramMutation = (
  { __typename?: 'Mutation' }
  & { setCourseProgram?: Maybe<(
    { __typename?: 'SetCourseProgram' }
    & Pick<SetCourseProgram, 'success' | 'modules' | 'lessons' | 'lessonsRemoved' | 'lessonsWithoutMarketing'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type UploadBankStatementMutationVariables = Exact<{
  file: Scalars['Upload'];
  dryRun?: Maybe<Scalars['Boolean']>;
  accountSlug?: Maybe<Scalars['String']>;
}>;


export type UploadBankStatementMutation = (
  { __typename?: 'Mutation' }
  & { uploadBankStatement?: Maybe<(
    { __typename?: 'BankStatementUploadOutput' }
    & Pick<BankStatementUploadOutput, 'success' | 'errors' | 'dryRun' | 'alreadyImported' | 'accountName' | 'accountIbanLearned' | 'processingStats'>
    & { run?: Maybe<(
      { __typename?: 'BankStatementImportType' }
      & Pick<BankStatementImportType, 'pk' | 'fileName' | 'status' | 'rowsTotal' | 'createdCount' | 'duplicateCount' | 'failedCount' | 'balanceGapCount' | 'periodFrom' | 'periodTo' | 'report'>
    )> }
  )> }
);

export type ConfirmCashFlowRuleMutationVariables = Exact<{
  transactionId: Scalars['ID'];
  categorySlug: Scalars['String'];
  retroactive?: Maybe<Scalars['Boolean']>;
}>;


export type ConfirmCashFlowRuleMutation = (
  { __typename?: 'Mutation' }
  & { confirmCashFlowRule?: Maybe<(
    { __typename?: 'SetCategoryOutput' }
    & Pick<SetCategoryOutput, 'success' | 'errors' | 'ruleOutcome' | 'ruleReason'>
    & { rule?: Maybe<(
      { __typename?: 'CashFlowRuleType' }
      & Pick<CashFlowRuleType, 'pk' | 'keyKind' | 'keyValue' | 'categoryName' | 'validFrom'>
    )> }
  )> }
);

export type ResolveCashFlowRuleConflictMutationVariables = Exact<{
  transactionId: Scalars['ID'];
  categorySlug: Scalars['String'];
  strategy: Scalars['String'];
}>;


export type ResolveCashFlowRuleConflictMutation = (
  { __typename?: 'Mutation' }
  & { resolveCashFlowRuleConflict?: Maybe<(
    { __typename?: 'SetCategoryOutput' }
    & Pick<SetCategoryOutput, 'success' | 'errors' | 'ruleOutcome' | 'ruleReason'>
    & { rule?: Maybe<(
      { __typename?: 'CashFlowRuleType' }
      & Pick<CashFlowRuleType, 'pk' | 'categoryName' | 'validFrom' | 'validTo'>
    )> }
  )> }
);

export type UpdateCashFlowRuleMutationVariables = Exact<{
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  priority?: Maybe<Scalars['Int']>;
  categorySlug?: Maybe<Scalars['String']>;
  resetHealth?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateCashFlowRuleMutation = (
  { __typename?: 'Mutation' }
  & { updateCashFlowRule?: Maybe<(
    { __typename?: 'SetCategoryOutput' }
    & Pick<SetCategoryOutput, 'success' | 'errors'>
    & { rule?: Maybe<(
      { __typename?: 'CashFlowRuleType' }
      & Pick<CashFlowRuleType, 'pk' | 'isActive' | 'priority' | 'categorySlug' | 'categoryName' | 'health' | 'overridesCount'>
    )> }
  )> }
);

export type DeleteCashFlowRuleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCashFlowRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteCashFlowRule?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'stats'>
  )> }
);

export type UpdateCashFlowSettingsMutationVariables = Exact<{
  ownPartyNames?: Maybe<Scalars['String']>;
  internalTransferAutodetect?: Maybe<Scalars['Boolean']>;
  internalTransferWindowDays?: Maybe<Scalars['Int']>;
}>;


export type UpdateCashFlowSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateCashFlowSettings?: Maybe<(
    { __typename?: 'CashFlowSettingsOutput' }
    & Pick<CashFlowSettingsOutput, 'success' | 'errors'>
    & { settings?: Maybe<(
      { __typename?: 'CashFlowSettingsType' }
      & Pick<CashFlowSettingsType, 'ownPartyNames' | 'internalTransferAutodetect' | 'internalTransferWindowDays'>
    )> }
  )> }
);

export type SetBankTransactionCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  categorySlug?: Maybe<Scalars['String']>;
  learn?: Maybe<Scalars['Boolean']>;
}>;


export type SetBankTransactionCategoryMutation = (
  { __typename?: 'Mutation' }
  & { setBankTransactionCategory?: Maybe<(
    { __typename?: 'SetCategoryOutput' }
    & Pick<SetCategoryOutput, 'success' | 'errors' | 'ruleOutcome' | 'ruleReason'>
    & { rule?: Maybe<(
      { __typename?: 'CashFlowRuleType' }
      & Pick<CashFlowRuleType, 'pk' | 'keyKind' | 'keyValue' | 'categoryName'>
    )>, conflictingRule?: Maybe<(
      { __typename?: 'CashFlowRuleType' }
      & Pick<CashFlowRuleType, 'pk' | 'categoryName'>
    )>, preview?: Maybe<(
      { __typename?: 'RulePreviewType' }
      & Pick<RulePreviewType, 'keyKind' | 'keyValue' | 'direction' | 'wouldAffect' | 'samples'>
    )>, transaction?: Maybe<(
      { __typename?: 'BankTransactionType' }
      & Pick<BankTransactionType, 'pk' | 'categorySlug' | 'categoryName' | 'categorySource'>
    )> }
  )> }
);

export type SetBankTransactionInternalMutationVariables = Exact<{
  id: Scalars['ID'];
  isInternal: Scalars['Boolean'];
}>;


export type SetBankTransactionInternalMutation = (
  { __typename?: 'Mutation' }
  & { setBankTransactionInternal?: Maybe<(
    { __typename?: 'BankTransactionOutput' }
    & Pick<BankTransactionOutput, 'success' | 'errors'>
    & { transaction?: Maybe<(
      { __typename?: 'BankTransactionType' }
      & Pick<BankTransactionType, 'pk' | 'isInternalTransfer' | 'internalSource' | 'needsReview'>
    )> }
  )> }
);

export type ProcessUploadedStatementMutationVariables = Exact<{
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type ProcessUploadedStatementMutation = (
  { __typename?: 'Mutation' }
  & { processUploadedStatement?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'dryRun' | 'stats'>
  )> }
);

export type RunCashFlowCategorizationMutationVariables = Exact<{
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type RunCashFlowCategorizationMutation = (
  { __typename?: 'Mutation' }
  & { runCashFlowCategorization?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'dryRun' | 'stats'>
  )> }
);

export type RunInternalTransferDetectionMutationVariables = Exact<{
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type RunInternalTransferDetectionMutation = (
  { __typename?: 'Mutation' }
  & { runInternalTransferDetection?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'dryRun' | 'stats'>
  )> }
);

export type RunCashFlowMatchingMutationVariables = Exact<{
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type RunCashFlowMatchingMutation = (
  { __typename?: 'Mutation' }
  & { runCashFlowMatching?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'dryRun' | 'stats'>
  )> }
);

export type SeedCashFlowRulesMutationVariables = Exact<{
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type SeedCashFlowRulesMutation = (
  { __typename?: 'Mutation' }
  & { seedCashFlowRules?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'dryRun' | 'stats'>
  )> }
);

export type DetectGatewaySettlementsMutationVariables = Exact<{
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type DetectGatewaySettlementsMutation = (
  { __typename?: 'Mutation' }
  & { detectGatewaySettlements?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'dryRun' | 'stats'>
  )> }
);

export type AddGatewaySettlementItemMutationVariables = Exact<{
  settlementId: Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type AddGatewaySettlementItemMutation = (
  { __typename?: 'Mutation' }
  & { addGatewaySettlementItem?: Maybe<(
    { __typename?: 'GatewaySettlementOutput' }
    & Pick<GatewaySettlementOutput, 'success' | 'errors'>
    & { settlement?: Maybe<(
      { __typename?: 'GatewaySettlementType' }
      & Pick<GatewaySettlementType, 'pk' | 'itemsTotal' | 'feeAmount' | 'unallocated' | 'status'>
      & { items?: Maybe<Array<Maybe<(
        { __typename?: 'GatewaySettlementItemType' }
        & Pick<GatewaySettlementItemType, 'pk' | 'invoiceId' | 'invoiceNumber' | 'amount' | 'matchSource'>
      )>>> }
    )> }
  )> }
);

export type RemoveGatewaySettlementItemMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type RemoveGatewaySettlementItemMutation = (
  { __typename?: 'Mutation' }
  & { removeGatewaySettlementItem?: Maybe<(
    { __typename?: 'GatewaySettlementOutput' }
    & Pick<GatewaySettlementOutput, 'success' | 'errors'>
    & { settlement?: Maybe<(
      { __typename?: 'GatewaySettlementType' }
      & Pick<GatewaySettlementType, 'pk' | 'itemsTotal' | 'feeAmount' | 'unallocated' | 'status'>
      & { items?: Maybe<Array<Maybe<(
        { __typename?: 'GatewaySettlementItemType' }
        & Pick<GatewaySettlementItemType, 'pk' | 'invoiceId' | 'invoiceNumber' | 'amount' | 'matchSource'>
      )>>> }
    )> }
  )> }
);

export type MarkGatewaySettlementReconciledMutationVariables = Exact<{
  settlementId: Scalars['ID'];
  notes: Scalars['String'];
}>;


export type MarkGatewaySettlementReconciledMutation = (
  { __typename?: 'Mutation' }
  & { markGatewaySettlementReconciled?: Maybe<(
    { __typename?: 'GatewaySettlementOutput' }
    & Pick<GatewaySettlementOutput, 'success' | 'errors'>
    & { settlement?: Maybe<(
      { __typename?: 'GatewaySettlementType' }
      & Pick<GatewaySettlementType, 'pk' | 'status' | 'notes'>
    )> }
  )> }
);

export type LinkBankTransactionMutationVariables = Exact<{
  transactionId: Scalars['ID'];
  targetType: Scalars['String'];
  targetId: Scalars['ID'];
}>;


export type LinkBankTransactionMutation = (
  { __typename?: 'Mutation' }
  & { linkBankTransaction?: Maybe<(
    { __typename?: 'BankTransactionOutput' }
    & Pick<BankTransactionOutput, 'success' | 'errors'>
    & { transaction?: Maybe<(
      { __typename?: 'BankTransactionType' }
      & Pick<BankTransactionType, 'pk'>
      & { links?: Maybe<Array<Maybe<(
        { __typename?: 'BankTransactionLinkType' }
        & Pick<BankTransactionLinkType, 'pk' | 'targetType' | 'targetId' | 'targetLabel' | 'matchSource'>
      )>>> }
    )> }
  )> }
);

export type UnlinkBankTransactionMutationVariables = Exact<{
  linkId: Scalars['ID'];
}>;


export type UnlinkBankTransactionMutation = (
  { __typename?: 'Mutation' }
  & { unlinkBankTransaction?: Maybe<(
    { __typename?: 'BankTransactionOutput' }
    & Pick<BankTransactionOutput, 'success' | 'errors'>
    & { transaction?: Maybe<(
      { __typename?: 'BankTransactionType' }
      & Pick<BankTransactionType, 'pk'>
      & { links?: Maybe<Array<Maybe<(
        { __typename?: 'BankTransactionLinkType' }
        & Pick<BankTransactionLinkType, 'pk' | 'targetType' | 'targetId' | 'targetLabel' | 'matchSource'>
      )>>> }
    )> }
  )> }
);

export type SetBankTransactionCategoryBulkMutationVariables = Exact<{
  ids: Array<Scalars['ID']>;
  categorySlug?: Maybe<Scalars['String']>;
  learn?: Maybe<Scalars['Boolean']>;
}>;


export type SetBankTransactionCategoryBulkMutation = (
  { __typename?: 'Mutation' }
  & { setBankTransactionCategoryBulk?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'stats'>
  )> }
);

export type SetGatewaySettlementFeeMutationVariables = Exact<{
  settlementId: Scalars['ID'];
  feeAmount: Scalars['Float'];
}>;


export type SetGatewaySettlementFeeMutation = (
  { __typename?: 'Mutation' }
  & { setGatewaySettlementFee?: Maybe<(
    { __typename?: 'GatewaySettlementOutput' }
    & Pick<GatewaySettlementOutput, 'success' | 'errors'>
    & { settlement?: Maybe<(
      { __typename?: 'GatewaySettlementType' }
      & Pick<GatewaySettlementType, 'pk' | 'feeAmount' | 'feeSource' | 'unallocated' | 'status'>
    )> }
  )> }
);

export type ReconcileGatewaySettlementsMutationVariables = Exact<{
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type ReconcileGatewaySettlementsMutation = (
  { __typename?: 'Mutation' }
  & { reconcileGatewaySettlements?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'dryRun' | 'stats'>
  )> }
);

export type RollbackBankStatementImportMutationVariables = Exact<{
  importId: Scalars['ID'];
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type RollbackBankStatementImportMutation = (
  { __typename?: 'Mutation' }
  & { rollbackBankStatementImport?: Maybe<(
    { __typename?: 'CashFlowRunOutput' }
    & Pick<CashFlowRunOutput, 'success' | 'errors' | 'dryRun' | 'stats'>
  )> }
);

export type ClearBankTransactionReviewMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClearBankTransactionReviewMutation = (
  { __typename?: 'Mutation' }
  & { clearBankTransactionReview?: Maybe<(
    { __typename?: 'BankTransactionOutput' }
    & Pick<BankTransactionOutput, 'success' | 'errors'>
    & { transaction?: Maybe<(
      { __typename?: 'BankTransactionType' }
      & Pick<BankTransactionType, 'pk' | 'needsReview'>
    )> }
  )> }
);

export type PostSlackReplyMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  text: Scalars['String'];
  seenMessageId?: Maybe<Scalars['ID']>;
}>;


export type PostSlackReplyMutation = (
  { __typename?: 'Mutation' }
  & { sendSlackMessage?: Maybe<(
    { __typename?: 'SendSlackMessageMutation' }
    & Pick<SendSlackMessageMutation, 'success' | 'readMessageIds' | 'handledMessageIds' | 'truncated'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, message?: Maybe<(
      { __typename?: 'MessageType' }
      & Pick<MessageType, 'id' | 'direction' | 'authorName' | 'authorDisplay' | 'authorExternalId' | 'body' | 'bodyHtml' | 'sentAt' | 'isHandled'>
      & { attachments: Array<(
        { __typename?: 'MessageAttachmentType' }
        & Pick<MessageAttachmentType, 'index' | 'name' | 'size' | 'mime' | 'contentId' | 'inline'>
      )>, linkedTask?: Maybe<(
        { __typename?: 'StaffTaskType' }
        & Pick<StaffTaskType, 'id' | 'title' | 'status'>
      )> }
    )>, conversation?: Maybe<(
      { __typename?: 'ConversationType' }
      & Pick<ConversationType, 'id' | 'hasUnhandled' | 'unhandledCount' | 'unreadCount'>
    )> }
  )> }
);

export type SendSlackChannelMsgMutationVariables = Exact<{
  groupId: Scalars['ID'];
  slackChannelId: Scalars['String'];
  text: Scalars['String'];
}>;


export type SendSlackChannelMsgMutation = (
  { __typename?: 'Mutation' }
  & { sendSlackChannelMessage?: Maybe<(
    { __typename?: 'SendSlackChannelMessage' }
    & Pick<SendSlackChannelMessage, 'success' | 'conversationId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, message?: Maybe<(
      { __typename?: 'MessageType' }
      & Pick<MessageType, 'id' | 'direction' | 'authorName' | 'body' | 'sentAt'>
    )> }
  )> }
);

export type StartSlackDialogMutationVariables = Exact<{
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  groupId: Scalars['ID'];
  text: Scalars['String'];
}>;


export type StartSlackDialogMutation = (
  { __typename?: 'Mutation' }
  & { startSlackDm?: Maybe<(
    { __typename?: 'StartSlackDm' }
    & Pick<StartSlackDm, 'success' | 'conversationId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, message?: Maybe<(
      { __typename?: 'MessageType' }
      & Pick<MessageType, 'id' | 'direction' | 'authorName' | 'body' | 'sentAt'>
    )> }
  )> }
);

export type SendNewEmailMsgMutationVariables = Exact<{
  mailboxEmail: Scalars['String'];
  toEmail: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
}>;


export type SendNewEmailMsgMutation = (
  { __typename?: 'Mutation' }
  & { sendNewEmail?: Maybe<(
    { __typename?: 'SendNewEmailMutation' }
    & Pick<SendNewEmailMutation, 'success' | 'conversationId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, message?: Maybe<(
      { __typename?: 'MessageType' }
      & Pick<MessageType, 'id' | 'direction' | 'authorName' | 'body' | 'sentAt'>
    )> }
  )> }
);

export type SendGroupBroadcastMutationVariables = Exact<{
  groupId: Scalars['ID'];
  studentIds: Array<Scalars['ID']>;
  channel: Scalars['String'];
  mailboxEmail?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
}>;


export type SendGroupBroadcastMutation = (
  { __typename?: 'Mutation' }
  & { broadcastGroupMessage?: Maybe<(
    { __typename?: 'BroadcastGroupMessage' }
    & Pick<BroadcastGroupMessage, 'success' | 'broadcastJobId' | 'total'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type PostGmailReplyMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  seenMessageId?: Maybe<Scalars['ID']>;
}>;


export type PostGmailReplyMutation = (
  { __typename?: 'Mutation' }
  & { sendGmailReply?: Maybe<(
    { __typename?: 'SendGmailReplyMutation' }
    & Pick<SendGmailReplyMutation, 'success' | 'readMessageIds' | 'handledMessageIds' | 'truncated'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, message?: Maybe<(
      { __typename?: 'MessageType' }
      & Pick<MessageType, 'id' | 'direction' | 'authorName' | 'authorDisplay' | 'authorExternalId' | 'body' | 'bodyHtml' | 'sentAt' | 'isHandled'>
      & { attachments: Array<(
        { __typename?: 'MessageAttachmentType' }
        & Pick<MessageAttachmentType, 'index' | 'name' | 'size' | 'mime' | 'contentId' | 'inline'>
      )>, linkedTask?: Maybe<(
        { __typename?: 'StaffTaskType' }
        & Pick<StaffTaskType, 'id' | 'title' | 'status'>
      )> }
    )>, conversation?: Maybe<(
      { __typename?: 'ConversationType' }
      & Pick<ConversationType, 'id' | 'hasUnhandled' | 'unhandledCount' | 'unreadCount'>
    )> }
  )> }
);

export type MapSlackUserMutationVariables = Exact<{
  slackUserId: Scalars['String'];
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
}>;


export type MapSlackUserMutation = (
  { __typename?: 'Mutation' }
  & { linkSlackUser?: Maybe<(
    { __typename?: 'LinkSlackUserMutation' }
    & Pick<LinkSlackUserMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type MarkMsgReadMutationVariables = Exact<{
  messageId: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
}>;


export type MarkMsgReadMutation = (
  { __typename?: 'Mutation' }
  & { markMessageRead?: Maybe<(
    { __typename?: 'MarkMessageReadMutation' }
    & Pick<MarkMessageReadMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, message?: Maybe<(
      { __typename?: 'MessageType' }
      & Pick<MessageType, 'id' | 'isRead'>
    )> }
  )> }
);

export type FlagMsgMutationVariables = Exact<{
  messageId: Scalars['ID'];
  flagged?: Maybe<Scalars['Boolean']>;
}>;


export type FlagMsgMutation = (
  { __typename?: 'Mutation' }
  & { flagMessage?: Maybe<(
    { __typename?: 'FlagMessageMutation' }
    & Pick<FlagMessageMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, message?: Maybe<(
      { __typename?: 'MessageType' }
      & Pick<MessageType, 'id' | 'isFlagged'>
    )> }
  )> }
);

export type SetMsgHandledMutationVariables = Exact<{
  messageId: Scalars['ID'];
  handled?: Maybe<Scalars['Boolean']>;
  cascade?: Maybe<Scalars['Boolean']>;
}>;


export type SetMsgHandledMutation = (
  { __typename?: 'Mutation' }
  & { setMessageHandled?: Maybe<(
    { __typename?: 'SetMessageHandledMutation' }
    & Pick<SetMessageHandledMutation, 'success' | 'readMessageIds' | 'handledMessageIds' | 'truncated'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, message?: Maybe<(
      { __typename?: 'MessageType' }
      & Pick<MessageType, 'id' | 'isHandled' | 'isRead'>
    )>, conversation?: Maybe<(
      { __typename?: 'ConversationType' }
      & Pick<ConversationType, 'id' | 'hasUnhandled' | 'unhandledCount' | 'unreadCount'>
    )> }
  )> }
);

export type MarkConvsHandledMutationVariables = Exact<{
  scope: Scalars['String'];
  conversationId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  kinds?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  unhandledOnly?: Maybe<Scalars['Boolean']>;
}>;


export type MarkConvsHandledMutation = (
  { __typename?: 'Mutation' }
  & { markConversationsHandled?: Maybe<(
    { __typename?: 'MarkConversationsHandledMutation' }
    & Pick<MarkConversationsHandledMutation, 'success' | 'messagesAffected' | 'conversationsAffected' | 'truncated' | 'undoable' | 'readMessageIds' | 'handledMessageIds'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, conversations?: Maybe<Array<(
      { __typename?: 'ConversationType' }
      & Pick<ConversationType, 'id' | 'unreadCount' | 'unhandledCount' | 'hasUnhandled'>
    )>> }
  )> }
);

export type MarkConvReadMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
}>;


export type MarkConvReadMutation = (
  { __typename?: 'Mutation' }
  & { markConversationRead?: Maybe<(
    { __typename?: 'MarkConversationReadMutation' }
    & Pick<MarkConversationReadMutation, 'success' | 'updated'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, conversation?: Maybe<(
      { __typename?: 'ConversationType' }
      & Pick<ConversationType, 'id' | 'unreadCount' | 'hasUnhandled'>
    )> }
  )> }
);

export type SetConvStatusMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  status: Scalars['String'];
}>;


export type SetConvStatusMutation = (
  { __typename?: 'Mutation' }
  & { setConversationStatus?: Maybe<(
    { __typename?: 'SetConversationStatusMutation' }
    & Pick<SetConversationStatusMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, conversation?: Maybe<(
      { __typename?: 'ConversationType' }
      & Pick<ConversationType, 'id' | 'status'>
    )> }
  )> }
);

export type CreateTaskFromMsgMutationVariables = Exact<{
  messageId: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  assigneeId?: Maybe<Scalars['ID']>;
  priority?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
}>;


export type CreateTaskFromMsgMutation = (
  { __typename?: 'Mutation' }
  & { createTaskFromMessage?: Maybe<(
    { __typename?: 'CreateTaskFromMessageMutation' }
    & Pick<CreateTaskFromMessageMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'title' | 'status'>
    )>, message?: Maybe<(
      { __typename?: 'MessageType' }
      & Pick<MessageType, 'id' | 'isHandled'>
      & { linkedTask?: Maybe<(
        { __typename?: 'StaffTaskType' }
        & Pick<StaffTaskType, 'id' | 'title' | 'status'>
      )> }
    )>, conversation?: Maybe<(
      { __typename?: 'ConversationType' }
      & Pick<ConversationType, 'id' | 'status' | 'hasUnhandled' | 'unhandledCount'>
    )> }
  )> }
);

export type TriggerGmailSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerGmailSyncMutation = (
  { __typename?: 'Mutation' }
  & { syncGmailNow?: Maybe<(
    { __typename?: 'SyncGmailNowMutation' }
    & Pick<SyncGmailNowMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type TriggerCommsSyncMutationVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
}>;


export type TriggerCommsSyncMutation = (
  { __typename?: 'Mutation' }
  & { syncCommunicationsNow?: Maybe<(
    { __typename?: 'SyncCommunicationsNowMutation' }
    & Pick<SyncCommunicationsNowMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type SaveSlackWorkspaceMutationVariables = Exact<{
  groupId: Scalars['ID'];
  botToken?: Maybe<Scalars['String']>;
  signingSecret?: Maybe<Scalars['String']>;
  workspaceName?: Maybe<Scalars['String']>;
  oauthClientId?: Maybe<Scalars['String']>;
  oauthClientSecret?: Maybe<Scalars['String']>;
}>;


export type SaveSlackWorkspaceMutation = (
  { __typename?: 'Mutation' }
  & { setSlackWorkspace?: Maybe<(
    { __typename?: 'SetSlackWorkspaceMutation' }
    & Pick<SetSlackWorkspaceMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type SaveMySlackUserTokenMutationVariables = Exact<{
  groupId: Scalars['ID'];
  userToken: Scalars['String'];
}>;


export type SaveMySlackUserTokenMutation = (
  { __typename?: 'Mutation' }
  & { setMySlackUserToken?: Maybe<(
    { __typename?: 'SetMySlackUserTokenMutation' }
    & Pick<SetMySlackUserTokenMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type BeginSlackUserOauthMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type BeginSlackUserOauthMutation = (
  { __typename?: 'Mutation' }
  & { startSlackUserOauth?: Maybe<(
    { __typename?: 'StartSlackUserOauthMutation' }
    & Pick<StartSlackUserOauthMutation, 'success' | 'authorizeUrl'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type RevertMsgTriageMutationVariables = Exact<{
  read?: Maybe<Array<Scalars['ID']>>;
  handled?: Maybe<Array<Scalars['ID']>>;
}>;


export type RevertMsgTriageMutation = (
  { __typename?: 'Mutation' }
  & { revertMessagesTriage?: Maybe<(
    { __typename?: 'RevertMessagesTriageMutation' }
    & Pick<RevertMessagesTriageMutation, 'success' | 'messagesReverted'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, conversations?: Maybe<Array<(
      { __typename?: 'ConversationType' }
      & Pick<ConversationType, 'id' | 'unreadCount' | 'unhandledCount' | 'hasUnhandled'>
    )>> }
  )> }
);

export type AddCompanyMutationVariables = Exact<{
  companyInput: CompanyInput;
}>;


export type AddCompanyMutation = (
  { __typename?: 'Mutation' }
  & { createCompany?: Maybe<(
    { __typename?: 'CreateCompanyMutation' }
    & Pick<CreateCompanyMutation, 'success' | 'errors'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type EditCompanyMutationVariables = Exact<{
  companyId: Scalars['ID'];
  companyInput: UpdateCompanyInput;
}>;


export type EditCompanyMutation = (
  { __typename?: 'Mutation' }
  & { updateCompany?: Maybe<(
    { __typename?: 'UpdateCompanyMutation' }
    & Pick<UpdateCompanyMutation, 'success'>
    & { company?: Maybe<(
      { __typename?: 'CompanyType' }
      & Pick<CompanyType, 'id' | 'name' | 'responsiblePerson' | 'email' | 'phone' | 'registrationNumber' | 'comment'>
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type SaveCourseTariffPriceMutationVariables = Exact<{
  courseId: Scalars['ID'];
  planId: Scalars['ID'];
  currency: Scalars['String'];
  amount: Scalars['String'];
}>;


export type SaveCourseTariffPriceMutation = (
  { __typename?: 'Mutation' }
  & { setCoursePlanPrice?: Maybe<(
    { __typename?: 'SetCoursePlanPrice' }
    & Pick<SetCoursePlanPrice, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, price?: Maybe<(
      { __typename?: 'CoursePlanPriceType' }
      & Pick<CoursePlanPriceType, 'id' | 'courseId' | 'planId' | 'planName' | 'planIsActive' | 'currency' | 'amount'>
    )> }
  )> }
);

export type RemoveCourseTariffPriceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveCourseTariffPriceMutation = (
  { __typename?: 'Mutation' }
  & { deleteCoursePlanPrice?: Maybe<(
    { __typename?: 'DeleteCoursePlanPrice' }
    & Pick<DeleteCoursePlanPrice, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type WriteLeadSmsMutationVariables = Exact<{
  leadId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<LeadSmsLinkInput>;
  templateId?: Maybe<Scalars['ID']>;
  requestKey?: Maybe<Scalars['String']>;
}>;


export type WriteLeadSmsMutation = (
  { __typename?: 'Mutation' }
  & { sendLeadSms?: Maybe<(
    { __typename?: 'SendLeadSms' }
    & Pick<SendLeadSms, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, message?: Maybe<(
      { __typename?: 'SmsMessageType' }
      & SmsMessageFieldsFragment
    )>, state?: Maybe<(
      { __typename?: 'LeadSmsStateType' }
      & LeadSmsStateFieldsFragment
    )> }
  )> }
);

export type RefreshLeadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefreshLeadMutation = (
  { __typename?: 'Mutation' }
  & { refreshKommoLead?: Maybe<(
    { __typename?: 'RefreshKommoLead' }
    & Pick<RefreshKommoLead, 'success' | 'refreshed'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, lead?: Maybe<(
      { __typename?: 'KommoLeadType' }
      & KommoLeadCardFieldsFragment
    )> }
  )> }
);

export type SyncLeadsNowMutationVariables = Exact<{
  full?: Maybe<Scalars['Boolean']>;
}>;


export type SyncLeadsNowMutation = (
  { __typename?: 'Mutation' }
  & { syncKommoLeads?: Maybe<(
    { __typename?: 'SyncKommoLeads' }
    & Pick<SyncKommoLeads, 'success' | 'queued'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type SaveKommoUserMappingMutationVariables = Exact<{
  kommoUserId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
  locked?: Maybe<Scalars['Boolean']>;
}>;


export type SaveKommoUserMappingMutation = (
  { __typename?: 'Mutation' }
  & { setKommoUserMapping?: Maybe<(
    { __typename?: 'SetKommoUserMapping' }
    & Pick<SetKommoUserMapping, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, user?: Maybe<(
      { __typename?: 'KommoUserType' }
      & KommoUserFieldsFragment
    )> }
  )> }
);

export type RetryLeadNotesMutationVariables = Exact<{ [key: string]: never; }>;


export type RetryLeadNotesMutation = (
  { __typename?: 'Mutation' }
  & { retryKommoNotes?: Maybe<(
    { __typename?: 'RetryKommoNotes' }
    & Pick<RetryKommoNotes, 'success' | 'count'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type WriteCandidateSmsMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<LeadSmsLinkInput>;
  templateId?: Maybe<Scalars['ID']>;
  requestKey?: Maybe<Scalars['String']>;
}>;


export type WriteCandidateSmsMutation = (
  { __typename?: 'Mutation' }
  & { sendFundingCandidateSms?: Maybe<(
    { __typename?: 'SendFundingCandidateSms' }
    & Pick<SendFundingCandidateSms, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, message?: Maybe<(
      { __typename?: 'SmsMessageType' }
      & SmsMessageFieldsFragment
    )>, state?: Maybe<(
      { __typename?: 'LeadSmsStateType' }
      & LeadSmsStateFieldsFragment
    )> }
  )> }
);

export type StartLadderForLeadMutationVariables = Exact<{
  leadId: Scalars['ID'];
  kind: Scalars['String'];
  days?: Maybe<Scalars['Int']>;
  requestKey?: Maybe<Scalars['String']>;
}>;


export type StartLadderForLeadMutation = (
  { __typename?: 'Mutation' }
  & { startLeadLadder?: Maybe<(
    { __typename?: 'StartLeadLadder' }
    & Pick<StartLeadLadder, 'success' | 'warning'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, ladder?: Maybe<(
      { __typename?: 'LeadLadderRunType' }
      & LeadLadderRunFieldsFragment
    )> }
  )> }
);

export type StopLeadLadderRunMutationVariables = Exact<{
  runId: Scalars['ID'];
}>;


export type StopLeadLadderRunMutation = (
  { __typename?: 'Mutation' }
  & { stopLeadLadder?: Maybe<(
    { __typename?: 'StopLeadLadder' }
    & Pick<StopLeadLadder, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, ladder?: Maybe<(
      { __typename?: 'LeadLadderRunType' }
      & LeadLadderRunFieldsFragment
    )> }
  )> }
);

export type ResumeLeadLadderRunMutationVariables = Exact<{
  runId: Scalars['ID'];
}>;


export type ResumeLeadLadderRunMutation = (
  { __typename?: 'Mutation' }
  & { resumeLeadLadder?: Maybe<(
    { __typename?: 'ResumeLeadLadder' }
    & Pick<ResumeLeadLadder, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, ladder?: Maybe<(
      { __typename?: 'LeadLadderRunType' }
      & LeadLadderRunFieldsFragment
    )> }
  )> }
);

export type WriteLeadEmailMutationVariables = Exact<{
  leadId: Scalars['ID'];
  mailboxEmail: Scalars['String'];
  subject: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  templateId?: Maybe<Scalars['ID']>;
  requestKey?: Maybe<Scalars['String']>;
  aiDraftId?: Maybe<Scalars['ID']>;
}>;


export type WriteLeadEmailMutation = (
  { __typename?: 'Mutation' }
  & { sendLeadEmail?: Maybe<(
    { __typename?: 'SendLeadEmail' }
    & Pick<SendLeadEmail, 'success' | 'conversationId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type InviteLeadToFormMutationVariables = Exact<{
  leadId: Scalars['ID'];
  mailboxEmail: Scalars['String'];
  subject: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  templateId?: Maybe<Scalars['ID']>;
  startLadder?: Maybe<Scalars['Boolean']>;
  days?: Maybe<Scalars['Int']>;
  requestKey?: Maybe<Scalars['String']>;
}>;


export type InviteLeadToFormMutation = (
  { __typename?: 'Mutation' }
  & { inviteLeadToFundingForm?: Maybe<(
    { __typename?: 'InviteLeadToFundingForm' }
    & Pick<InviteLeadToFundingForm, 'success' | 'conversationId' | 'ladderWarning'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, ladder?: Maybe<(
      { __typename?: 'LeadLadderRunType' }
      & LeadLadderRunFieldsFragment
    )> }
  )> }
);

export type ErpLinkKommoLeadMutationVariables = Exact<{
  leadId: Scalars['ID'];
  what: Scalars['String'];
  targetId?: Maybe<Scalars['ID']>;
}>;


export type ErpLinkKommoLeadMutation = (
  { __typename?: 'Mutation' }
  & { linkKommoLead?: Maybe<(
    { __typename?: 'LinkKommoLead' }
    & Pick<LinkKommoLead, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, lead?: Maybe<(
      { __typename?: 'KommoLeadType' }
      & KommoLeadCardFieldsFragment
    )> }
  )> }
);

export type ErpResetKommoLeadLinkMutationVariables = Exact<{
  leadId: Scalars['ID'];
  what: Scalars['String'];
}>;


export type ErpResetKommoLeadLinkMutation = (
  { __typename?: 'Mutation' }
  & { resetKommoLeadLink?: Maybe<(
    { __typename?: 'ResetKommoLeadLink' }
    & Pick<ResetKommoLeadLink, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, lead?: Maybe<(
      { __typename?: 'KommoLeadType' }
      & KommoLeadCardFieldsFragment
    )> }
  )> }
);

export type MoveKommoLeadStageMutationVariables = Exact<{
  id: Scalars['ID'];
  statusId: Scalars['ID'];
  lossReasonId?: Maybe<Scalars['ID']>;
}>;


export type MoveKommoLeadStageMutation = (
  { __typename?: 'Mutation' }
  & { moveKommoLead?: Maybe<(
    { __typename?: 'MoveKommoLead' }
    & Pick<MoveKommoLead, 'success' | 'changed'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, lead?: Maybe<(
      { __typename?: 'KommoLeadType' }
      & KommoLeadMovedFieldsFragment
    )> }
  )> }
);

export type AssignKommoLeadResponsibleMutationVariables = Exact<{
  id: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type AssignKommoLeadResponsibleMutation = (
  { __typename?: 'Mutation' }
  & { setKommoLeadResponsible?: Maybe<(
    { __typename?: 'SetKommoLeadResponsible' }
    & Pick<SetKommoLeadResponsible, 'success' | 'changed'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, lead?: Maybe<(
      { __typename?: 'KommoLeadType' }
      & KommoLeadMovedFieldsFragment
    )> }
  )> }
);

export type DraftLeadAploraFollowupMutationVariables = Exact<{
  leadId: Scalars['ID'];
  callId: Scalars['ID'];
  regenerate?: Maybe<Scalars['Boolean']>;
  requestKey?: Maybe<Scalars['String']>;
}>;


export type DraftLeadAploraFollowupMutation = (
  { __typename?: 'Mutation' }
  & { aploraFollowupDraft?: Maybe<(
    { __typename?: 'AploraFollowupDraftMutation' }
    & Pick<AploraFollowupDraftMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, draft?: Maybe<(
      { __typename?: 'AploraFollowupDraftType' }
      & Pick<AploraFollowupDraftType, 'emailSubject' | 'emailBody' | 'messengerText' | 'cached'>
    )> }
  )> }
);

export type DraftLeadEmailMutationVariables = Exact<{
  leadId: Scalars['ID'];
  kind: Scalars['String'];
  contractId?: Maybe<Scalars['ID']>;
  hint?: Maybe<Scalars['String']>;
  regenerate?: Maybe<Scalars['Boolean']>;
  requestKey?: Maybe<Scalars['String']>;
}>;


export type DraftLeadEmailMutation = (
  { __typename?: 'Mutation' }
  & { draftLeadEmail?: Maybe<(
    { __typename?: 'DraftLeadEmail' }
    & Pick<DraftLeadEmail, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, draft?: Maybe<(
      { __typename?: 'LeadEmailDraftType' }
      & Pick<LeadEmailDraftType, 'id' | 'kind' | 'subject' | 'html' | 'text' | 'cached' | 'contractId' | 'createdAt'>
    )> }
  )> }
);

export type SaveLeadSavedViewMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  filters: Scalars['GenericScalar'];
  view: Scalars['String'];
  shared?: Maybe<Scalars['Boolean']>;
  scope?: Maybe<Scalars['String']>;
}>;


export type SaveLeadSavedViewMutation = (
  { __typename?: 'Mutation' }
  & { saveLeadSavedView?: Maybe<(
    { __typename?: 'SaveLeadSavedView' }
    & Pick<SaveLeadSavedView, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, view?: Maybe<(
      { __typename?: 'LeadSavedViewType' }
      & Pick<LeadSavedViewType, 'id' | 'name' | 'filters' | 'view' | 'shared' | 'isMine' | 'position' | 'scope'>
    )> }
  )> }
);

export type DeleteLeadSavedViewMutationVariables = Exact<{
  id: Scalars['ID'];
  scope?: Maybe<Scalars['String']>;
}>;


export type DeleteLeadSavedViewMutation = (
  { __typename?: 'Mutation' }
  & { deleteLeadSavedView?: Maybe<(
    { __typename?: 'DeleteLeadSavedView' }
    & Pick<DeleteLeadSavedView, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type CheckPaymentsDebtMutationVariables = Exact<{
  agreements: Array<Maybe<Scalars['String']>>;
}>;


export type CheckPaymentsDebtMutation = (
  { __typename?: 'Mutation' }
  & { checkStudentDebt?: Maybe<(
    { __typename?: 'CheckStudentsDebtMutation' }
    & Pick<CheckStudentsDebtMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type UploadDiplomaFileMutationVariables = Exact<{
  studentId: Scalars['ID'];
  groupId: Scalars['ID'];
  language: DiplomaLanguageEnum;
  file: Scalars['Upload'];
  replaceExisting?: Maybe<Scalars['Boolean']>;
}>;


export type UploadDiplomaFileMutation = (
  { __typename?: 'Mutation' }
  & { uploadStudentDiploma?: Maybe<(
    { __typename?: 'UploadStudentDiplomaMutation' }
    & Pick<UploadStudentDiplomaMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, diploma?: Maybe<(
      { __typename?: 'DiplomaType' }
      & Pick<DiplomaType, 'id' | 'pk' | 'language' | 'source' | 'originalName' | 'contentType' | 'sizeBytes' | 'version' | 'uploadedAt' | 'uploadedByName'>
    )> }
  )> }
);

export type RemoveDiplomaFileMutationVariables = Exact<{
  diplomaId: Scalars['ID'];
}>;


export type RemoveDiplomaFileMutation = (
  { __typename?: 'Mutation' }
  & { deleteStudentDiploma?: Maybe<(
    { __typename?: 'DeleteStudentDiplomaMutation' }
    & Pick<DeleteStudentDiplomaMutation, 'success' | 'ok'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type PreviewDiplomaMatchMutationVariables = Exact<{
  groupId: Scalars['ID'];
  fileNames: Array<Scalars['String']>;
}>;


export type PreviewDiplomaMatchMutation = (
  { __typename?: 'Mutation' }
  & { matchDiplomaFiles?: Maybe<(
    { __typename?: 'MatchDiplomaFilesMutation' }
    & Pick<MatchDiplomaFilesMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, preview?: Maybe<(
      { __typename?: 'DiplomaMatchPreviewType' }
      & { summary: (
        { __typename?: 'DiplomaMatchSummaryType' }
        & Pick<DiplomaMatchSummaryType, 'total' | 'matched' | 'ambiguous' | 'noMatch' | 'duplicates' | 'willReplace'>
      ), rows: Array<(
        { __typename?: 'DiplomaMatchRowType' }
        & Pick<DiplomaMatchRowType, 'fileName' | 'status' | 'language' | 'matchedBy' | 'confidence'>
        & { student?: Maybe<(
          { __typename?: 'DiplomaStudentType' }
          & Pick<DiplomaStudentType, 'id' | 'firstName' | 'lastName' | 'fullName' | 'email'>
        )>, candidates: Array<(
          { __typename?: 'DiplomaCandidateType' }
          & Pick<DiplomaCandidateType, 'fullName'>
          & { student: (
            { __typename?: 'DiplomaStudentType' }
            & Pick<DiplomaStudentType, 'id' | 'firstName' | 'lastName' | 'fullName' | 'email'>
          ) }
        )>, wouldReplace?: Maybe<(
          { __typename?: 'DiplomaType' }
          & Pick<DiplomaType, 'id' | 'language' | 'originalName' | 'version' | 'uploadedAt'>
        )> }
      )>, unmatchedStudents: Array<(
        { __typename?: 'UnmatchedStudentType' }
        & Pick<UnmatchedStudentType, 'fullName' | 'missingLanguages'>
        & { student: (
          { __typename?: 'DiplomaStudentType' }
          & Pick<DiplomaStudentType, 'id' | 'firstName' | 'lastName' | 'fullName' | 'email'>
        ) }
      )> }
    )> }
  )> }
);

export type CreateDocTemplateMutationVariables = Exact<{
  name: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  basedOnId?: Maybe<Scalars['ID']>;
  legalEntityId?: Maybe<Scalars['ID']>;
}>;


export type CreateDocTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createDocumentTemplate?: Maybe<(
    { __typename?: 'CreateDocumentTemplate' }
    & Pick<CreateDocumentTemplate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, problems: Array<(
      { __typename?: 'ContractTemplateProblemType' }
      & Pick<ContractTemplateProblemType, 'code' | 'message' | 'token'>
    )>, template?: Maybe<(
      { __typename?: 'DocumentTemplateType' }
      & Pick<DocumentTemplateType, 'id' | 'code' | 'name' | 'kind' | 'scope' | 'isActive' | 'legalEntityId' | 'legalEntityName' | 'version' | 'currentVersionId' | 'createdAt' | 'updatedAt' | 'updatedByName'>
      & { versions: Array<(
        { __typename?: 'DocumentTemplateVersionType' }
        & Pick<DocumentTemplateVersionType, 'id' | 'version' | 'origin' | 'comment' | 'createdAt' | 'createdByName' | 'isCurrent'>
      )> }
    )> }
  )> }
);

export type StoreDocTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  html?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
}>;


export type StoreDocTemplateMutation = (
  { __typename?: 'Mutation' }
  & { saveDocumentTemplate?: Maybe<(
    { __typename?: 'SaveDocumentTemplate' }
    & Pick<SaveDocumentTemplate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, problems: Array<(
      { __typename?: 'ContractTemplateProblemType' }
      & Pick<ContractTemplateProblemType, 'code' | 'message' | 'token'>
    )>, template?: Maybe<(
      { __typename?: 'DocumentTemplateType' }
      & Pick<DocumentTemplateType, 'id' | 'code' | 'name' | 'kind' | 'scope' | 'isActive' | 'legalEntityId' | 'legalEntityName' | 'version' | 'currentVersionId' | 'createdAt' | 'updatedAt' | 'updatedByName'>
      & { versions: Array<(
        { __typename?: 'DocumentTemplateVersionType' }
        & Pick<DocumentTemplateVersionType, 'id' | 'version' | 'origin' | 'comment' | 'createdAt' | 'createdByName' | 'isCurrent'>
      )> }
    )> }
  )> }
);

export type ToggleDocTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  active: Scalars['Boolean'];
}>;


export type ToggleDocTemplateMutation = (
  { __typename?: 'Mutation' }
  & { setDocumentTemplateActive?: Maybe<(
    { __typename?: 'SetDocumentTemplateActive' }
    & Pick<SetDocumentTemplateActive, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, template?: Maybe<(
      { __typename?: 'DocumentTemplateType' }
      & Pick<DocumentTemplateType, 'id' | 'code' | 'name' | 'kind' | 'scope' | 'isActive' | 'legalEntityId' | 'legalEntityName' | 'version' | 'currentVersionId' | 'createdAt' | 'updatedAt' | 'updatedByName'>
      & { versions: Array<(
        { __typename?: 'DocumentTemplateVersionType' }
        & Pick<DocumentTemplateVersionType, 'id' | 'version' | 'origin' | 'comment' | 'createdAt' | 'createdByName' | 'isCurrent'>
      )> }
    )> }
  )> }
);

export type SwitchDocTemplateVersionMutationVariables = Exact<{
  versionId: Scalars['ID'];
}>;


export type SwitchDocTemplateVersionMutation = (
  { __typename?: 'Mutation' }
  & { activateDocumentTemplateVersion?: Maybe<(
    { __typename?: 'ActivateDocumentTemplateVersion' }
    & Pick<ActivateDocumentTemplateVersion, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, template?: Maybe<(
      { __typename?: 'DocumentTemplateType' }
      & Pick<DocumentTemplateType, 'id' | 'code' | 'name' | 'kind' | 'scope' | 'isActive' | 'legalEntityId' | 'legalEntityName' | 'version' | 'currentVersionId' | 'createdAt' | 'updatedAt' | 'updatedByName'>
      & { versions: Array<(
        { __typename?: 'DocumentTemplateVersionType' }
        & Pick<DocumentTemplateVersionType, 'id' | 'version' | 'origin' | 'comment' | 'createdAt' | 'createdByName' | 'isCurrent'>
      )> }
    )> }
  )> }
);

export type IssueDocPdfMutationVariables = Exact<{
  templateId: Scalars['ID'];
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  issuePlace?: Maybe<Scalars['String']>;
}>;


export type IssueDocPdfMutation = (
  { __typename?: 'Mutation' }
  & { issueDocument?: Maybe<(
    { __typename?: 'IssueDocument' }
    & Pick<IssueDocument, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, issuedDocument?: Maybe<(
      { __typename?: 'IssuedDocumentType' }
      & Pick<IssuedDocumentType, 'id' | 'number' | 'kind' | 'scope' | 'templateId' | 'templateName' | 'templateVersion' | 'studentId' | 'studentName' | 'agreementId' | 'agreementTitle' | 'groupId' | 'groupName' | 'issueDate' | 'issuePlace' | 'issuedAt' | 'issuedByName' | 'missingFields' | 'hiddenFields' | 'hasFile'>
      & { sends: Array<(
        { __typename?: 'IssuedDocumentSendType' }
        & Pick<IssuedDocumentSendType, 'id' | 'sentAt' | 'sentTo' | 'sentByName' | 'mailboxEmail' | 'conversationId'>
      )> }
    )>, file?: Maybe<(
      { __typename?: 'DocumentFileType' }
      & Pick<DocumentFileType, 'fileName' | 'contentType' | 'contentBase64'>
    )>, missingFields: Array<(
      { __typename?: 'DocumentMissingFieldType' }
      & Pick<DocumentMissingFieldType, 'code' | 'label' | 'labelPl'>
    )>, hiddenFields: Array<(
      { __typename?: 'DocumentMissingFieldType' }
      & Pick<DocumentMissingFieldType, 'code' | 'label' | 'labelPl'>
    )> }
  )> }
);

export type SendIssuedDocPdfMutationVariables = Exact<{
  issuedDocumentId: Scalars['ID'];
  to?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  mailboxEmail?: Maybe<Scalars['String']>;
}>;


export type SendIssuedDocPdfMutation = (
  { __typename?: 'Mutation' }
  & { sendIssuedDocument?: Maybe<(
    { __typename?: 'SendIssuedDocument' }
    & Pick<SendIssuedDocument, 'success' | 'conversationId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, send?: Maybe<(
      { __typename?: 'IssuedDocumentSendType' }
      & Pick<IssuedDocumentSendType, 'id' | 'sentAt' | 'sentTo' | 'sentByName' | 'mailboxEmail' | 'conversationId'>
    )>, issuedDocument?: Maybe<(
      { __typename?: 'IssuedDocumentType' }
      & Pick<IssuedDocumentType, 'id' | 'hasFile'>
      & { sends: Array<(
        { __typename?: 'IssuedDocumentSendType' }
        & Pick<IssuedDocumentSendType, 'id' | 'sentAt' | 'sentTo' | 'sentByName' | 'mailboxEmail' | 'conversationId'>
      )> }
    )> }
  )> }
);

export type ErpChangeCandidateStatusMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  status: Scalars['String'];
  note?: Maybe<Scalars['String']>;
}>;


export type ErpChangeCandidateStatusMutation = (
  { __typename?: 'Mutation' }
  & { changeCandidateStatus?: Maybe<(
    { __typename?: 'ChangeCandidateStatus' }
    & Pick<ChangeCandidateStatus, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, candidate?: Maybe<(
      { __typename?: 'FundingCandidateType' }
      & Pick<FundingCandidateType, 'id' | 'status' | 'statusChangedAt'>
    )> }
  )> }
);

export type ErpAddCandidateOperatorsMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  operatorIds: Array<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
}>;


export type ErpAddCandidateOperatorsMutation = (
  { __typename?: 'Mutation' }
  & { addCandidateOperators?: Maybe<(
    { __typename?: 'AddCandidateOperators' }
    & Pick<AddCandidateOperators, 'success' | 'addedCount'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, candidate?: Maybe<(
      { __typename?: 'FundingCandidateType' }
      & Pick<FundingCandidateType, 'id' | 'activeOperatorsCount' | 'disabledOperatorsCount'>
      & { primaryOperator?: Maybe<(
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
      )>, operators: Array<(
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
      )>, operatorLinks: Array<(
        { __typename?: 'CandidateOperatorLinkType' }
        & Pick<CandidateOperatorLinkType, 'id' | 'isActive' | 'isPrimary' | 'source' | 'addedAt' | 'addedByName' | 'deactivatedAt' | 'deactivatedByName' | 'deactivationReason' | 'deactivationReasonLabel' | 'note'>
        & { operator: (
          { __typename?: 'FundingOperatorType' }
          & Pick<FundingOperatorType, 'id' | 'name' | 'programName' | 'programType' | 'clientType' | 'ownContributionPercent' | 'decisionDays' | 'coverageScope' | 'rollingIntake' | 'instructionUrl' | 'instructionReady'>
          & { voivodeship?: Maybe<(
            { __typename?: 'VoivodeshipType' }
            & Pick<VoivodeshipType, 'id' | 'name'>
          )>, powiats: Array<(
            { __typename?: 'PowiatType' }
            & Pick<PowiatType, 'id' | 'name'>
          )>, currentIntake?: Maybe<(
            { __typename?: 'FundingIntakeType' }
            & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
          )> }
        ) }
      )> }
    )> }
  )> }
);

export type ErpDeactivateCandidateOperatorMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  operatorId: Scalars['ID'];
  reason: Scalars['String'];
  note?: Maybe<Scalars['String']>;
}>;


export type ErpDeactivateCandidateOperatorMutation = (
  { __typename?: 'Mutation' }
  & { deactivateCandidateOperator?: Maybe<(
    { __typename?: 'DeactivateCandidateOperator' }
    & Pick<DeactivateCandidateOperator, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, candidate?: Maybe<(
      { __typename?: 'FundingCandidateType' }
      & Pick<FundingCandidateType, 'id' | 'activeOperatorsCount' | 'disabledOperatorsCount'>
      & { primaryOperator?: Maybe<(
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
      )>, operators: Array<(
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
      )>, operatorLinks: Array<(
        { __typename?: 'CandidateOperatorLinkType' }
        & Pick<CandidateOperatorLinkType, 'id' | 'isActive' | 'isPrimary' | 'source' | 'addedAt' | 'addedByName' | 'deactivatedAt' | 'deactivatedByName' | 'deactivationReason' | 'deactivationReasonLabel' | 'note'>
        & { operator: (
          { __typename?: 'FundingOperatorType' }
          & Pick<FundingOperatorType, 'id' | 'name' | 'programName' | 'programType' | 'clientType' | 'ownContributionPercent' | 'decisionDays' | 'coverageScope' | 'rollingIntake' | 'instructionUrl' | 'instructionReady'>
          & { voivodeship?: Maybe<(
            { __typename?: 'VoivodeshipType' }
            & Pick<VoivodeshipType, 'id' | 'name'>
          )>, powiats: Array<(
            { __typename?: 'PowiatType' }
            & Pick<PowiatType, 'id' | 'name'>
          )>, currentIntake?: Maybe<(
            { __typename?: 'FundingIntakeType' }
            & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
          )> }
        ) }
      )> }
    )> }
  )> }
);

export type ErpReactivateCandidateOperatorMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  operatorId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
}>;


export type ErpReactivateCandidateOperatorMutation = (
  { __typename?: 'Mutation' }
  & { reactivateCandidateOperator?: Maybe<(
    { __typename?: 'ReactivateCandidateOperator' }
    & Pick<ReactivateCandidateOperator, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, candidate?: Maybe<(
      { __typename?: 'FundingCandidateType' }
      & Pick<FundingCandidateType, 'id' | 'activeOperatorsCount' | 'disabledOperatorsCount'>
      & { primaryOperator?: Maybe<(
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
      )>, operators: Array<(
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
      )>, operatorLinks: Array<(
        { __typename?: 'CandidateOperatorLinkType' }
        & Pick<CandidateOperatorLinkType, 'id' | 'isActive' | 'isPrimary' | 'source' | 'addedAt' | 'addedByName' | 'deactivatedAt' | 'deactivatedByName' | 'deactivationReason' | 'deactivationReasonLabel' | 'note'>
        & { operator: (
          { __typename?: 'FundingOperatorType' }
          & Pick<FundingOperatorType, 'id' | 'name' | 'programName' | 'programType' | 'clientType' | 'ownContributionPercent' | 'decisionDays' | 'coverageScope' | 'rollingIntake' | 'instructionUrl' | 'instructionReady'>
          & { voivodeship?: Maybe<(
            { __typename?: 'VoivodeshipType' }
            & Pick<VoivodeshipType, 'id' | 'name'>
          )>, powiats: Array<(
            { __typename?: 'PowiatType' }
            & Pick<PowiatType, 'id' | 'name'>
          )>, currentIntake?: Maybe<(
            { __typename?: 'FundingIntakeType' }
            & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
          )> }
        ) }
      )> }
    )> }
  )> }
);

export type ErpSetCandidatePrimaryOperatorMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  operatorId?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
}>;


export type ErpSetCandidatePrimaryOperatorMutation = (
  { __typename?: 'Mutation' }
  & { setCandidatePrimaryOperator?: Maybe<(
    { __typename?: 'SetCandidatePrimaryOperator' }
    & Pick<SetCandidatePrimaryOperator, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, candidate?: Maybe<(
      { __typename?: 'FundingCandidateType' }
      & Pick<FundingCandidateType, 'id' | 'activeOperatorsCount' | 'disabledOperatorsCount'>
      & { primaryOperator?: Maybe<(
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
      )>, operators: Array<(
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
      )>, operatorLinks: Array<(
        { __typename?: 'CandidateOperatorLinkType' }
        & Pick<CandidateOperatorLinkType, 'id' | 'isActive' | 'isPrimary' | 'source' | 'addedAt' | 'addedByName' | 'deactivatedAt' | 'deactivatedByName' | 'deactivationReason' | 'deactivationReasonLabel' | 'note'>
        & { operator: (
          { __typename?: 'FundingOperatorType' }
          & Pick<FundingOperatorType, 'id' | 'name' | 'programName' | 'programType' | 'clientType' | 'ownContributionPercent' | 'decisionDays' | 'coverageScope' | 'rollingIntake' | 'instructionUrl' | 'instructionReady'>
          & { voivodeship?: Maybe<(
            { __typename?: 'VoivodeshipType' }
            & Pick<VoivodeshipType, 'id' | 'name'>
          )>, powiats: Array<(
            { __typename?: 'PowiatType' }
            & Pick<PowiatType, 'id' | 'name'>
          )>, currentIntake?: Maybe<(
            { __typename?: 'FundingIntakeType' }
            & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
          )> }
        ) }
      )> }
    )> }
  )> }
);

export type ErpSetCandidateAttentionMutationVariables = Exact<{
  id: Scalars['ID'];
  on: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
}>;


export type ErpSetCandidateAttentionMutation = (
  { __typename?: 'Mutation' }
  & { setFundingCandidateAttention?: Maybe<(
    { __typename?: 'SetFundingCandidateAttention' }
    & Pick<SetFundingCandidateAttention, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, candidate?: Maybe<(
      { __typename?: 'FundingCandidateType' }
      & Pick<FundingCandidateType, 'id' | 'needsAttention' | 'attentionNote' | 'attentionSetByName' | 'attentionSetAt'>
      & { nextIntake?: Maybe<(
        { __typename?: 'FundingIntakeType' }
        & Pick<FundingIntakeType, 'id' | 'startsOn' | 'operatorId' | 'operatorName'>
      )>, events: Array<(
        { __typename?: 'CandidateEventType' }
        & Pick<CandidateEventType, 'id' | 'fromStatus' | 'toStatus' | 'fromOperatorId' | 'fromOperatorName' | 'toOperatorId' | 'toOperatorName' | 'changedByName' | 'changedAt' | 'note'>
      )> }
    )> }
  )> }
);

export type ErpLinkCandidateToUserMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type ErpLinkCandidateToUserMutation = (
  { __typename?: 'Mutation' }
  & { linkCandidateToUser?: Maybe<(
    { __typename?: 'LinkCandidateToUser' }
    & Pick<LinkCandidateToUser, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, candidate?: Maybe<(
      { __typename?: 'FundingCandidateType' }
      & Pick<FundingCandidateType, 'id' | 'matchStatus' | 'userLocked' | 'linkedUserId' | 'linkedUserName' | 'isStudent' | 'studentId'>
    )> }
  )> }
);

export type ErpUnlinkCandidateFromUserMutationVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type ErpUnlinkCandidateFromUserMutation = (
  { __typename?: 'Mutation' }
  & { unlinkCandidateFromUser?: Maybe<(
    { __typename?: 'UnlinkCandidateFromUser' }
    & Pick<UnlinkCandidateFromUser, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, candidate?: Maybe<(
      { __typename?: 'FundingCandidateType' }
      & Pick<FundingCandidateType, 'id' | 'matchStatus' | 'userLocked' | 'linkedUserId' | 'linkedUserName' | 'isStudent'>
    )> }
  )> }
);

export type ErpSaveFundingCandidateMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: FundingCandidateInput;
}>;


export type ErpSaveFundingCandidateMutation = (
  { __typename?: 'Mutation' }
  & { saveFundingCandidate?: Maybe<(
    { __typename?: 'SaveFundingCandidate' }
    & Pick<SaveFundingCandidate, 'success' | 'supportIdLink'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, candidate?: Maybe<(
      { __typename?: 'FundingCandidateType' }
      & Pick<FundingCandidateType, 'id' | 'fullName' | 'email' | 'phone' | 'city' | 'employmentStatus' | 'employerName' | 'kfsGeoBasis' | 'isAdult' | 'is50Plus' | 'isUnemployed' | 'jdgSuspended' | 'hasDisabilityCertificate' | 'inFinancialHardship' | 'usedFundingBefore' | 'employerCanApply' | 'outcome' | 'notes' | 'taskNote' | 'approvedAmount' | 'currency' | 'supportId' | 'isArchived' | 'activeOperatorsCount'>
      & { employerVoivodeship?: Maybe<(
        { __typename?: 'VoivodeshipType' }
        & Pick<VoivodeshipType, 'id' | 'name'>
      )>, employerPowiat?: Maybe<(
        { __typename?: 'PowiatType' }
        & Pick<PowiatType, 'id' | 'name'>
      )>, operators: Array<(
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
      )> }
    )> }
  )> }
);

export type ErpDeleteFundingCandidateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpDeleteFundingCandidateMutation = (
  { __typename?: 'Mutation' }
  & { deleteFundingCandidate?: Maybe<(
    { __typename?: 'DeleteFundingCandidate' }
    & Pick<DeleteFundingCandidate, 'success' | 'deletedId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type ErpSaveFundingOperatorMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: FundingOperatorInput;
}>;


export type ErpSaveFundingOperatorMutation = (
  { __typename?: 'Mutation' }
  & { saveFundingOperator?: Maybe<(
    { __typename?: 'SaveFundingOperator' }
    & Pick<SaveFundingOperator, 'success' | 'projectNumberLink' | 'linkedCandidatesCount'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, operator?: Maybe<(
      { __typename?: 'FundingOperatorType' }
      & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'projectNumber' | 'isActive' | 'coverageScope' | 'instructionUrl' | 'instructionReady' | 'newsUrl' | 'feedUrl' | 'maxAmount' | 'paymentMethod' | 'comment'>
    )> }
  )> }
);

export type ErpSaveFundingIntakeMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  operatorId: Scalars['ID'];
  startsOn?: Maybe<Scalars['Date']>;
  endsOn?: Maybe<Scalars['Date']>;
  startsAtTime?: Maybe<Scalars['Time']>;
  endsAtTime?: Maybe<Scalars['Time']>;
  announcedAt?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
}>;


export type ErpSaveFundingIntakeMutation = (
  { __typename?: 'Mutation' }
  & { saveFundingIntake?: Maybe<(
    { __typename?: 'SaveFundingIntake' }
    & Pick<SaveFundingIntake, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, intake?: Maybe<(
      { __typename?: 'FundingIntakeType' }
      & Pick<FundingIntakeType, 'id' | 'operatorId' | 'operatorName' | 'startsOn' | 'endsOn' | 'startsAtTime' | 'endsAtTime' | 'announcedAt' | 'status' | 'sourceUrl' | 'note' | 'confirmedAt' | 'confirmedByName'>
    )> }
  )> }
);

export type ErpResolveGeoAliasMutationVariables = Exact<{
  id: Scalars['ID'];
  powiatId?: Maybe<Scalars['ID']>;
  ignore?: Maybe<Scalars['Boolean']>;
}>;


export type ErpResolveGeoAliasMutation = (
  { __typename?: 'Mutation' }
  & { resolveGeoAlias?: Maybe<(
    { __typename?: 'ResolveGeoAlias' }
    & Pick<ResolveGeoAlias, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, alias?: Maybe<(
      { __typename?: 'GeoAliasType' }
      & Pick<GeoAliasType, 'id' | 'rawValue' | 'status'>
      & { powiat?: Maybe<(
        { __typename?: 'PowiatType' }
        & Pick<PowiatType, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type ErpDeleteFundingIntakeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpDeleteFundingIntakeMutation = (
  { __typename?: 'Mutation' }
  & { deleteFundingIntake?: Maybe<(
    { __typename?: 'DeleteFundingIntake' }
    & Pick<DeleteFundingIntake, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ErpSubmitFundingFormMutationVariables = Exact<{
  payload: Scalars['JSONString'];
  recaptchaToken?: Maybe<Scalars['String']>;
  utm?: Maybe<Scalars['JSONString']>;
}>;


export type ErpSubmitFundingFormMutation = (
  { __typename?: 'Mutation' }
  & { submitFundingForm?: Maybe<(
    { __typename?: 'SubmitFundingForm' }
    & Pick<SubmitFundingForm, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ErpReviewOperatorPageMutationVariables = Exact<{
  operatorId: Scalars['ID'];
  intake?: Maybe<FundingIntakeInput>;
}>;


export type ErpReviewOperatorPageMutation = (
  { __typename?: 'Mutation' }
  & { reviewOperatorPage?: Maybe<(
    { __typename?: 'ReviewOperatorPage' }
    & Pick<ReviewOperatorPage, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, operator?: Maybe<(
      { __typename?: 'FundingOperatorType' }
      & Pick<FundingOperatorType, 'id' | 'pageState' | 'hasConfirmedIntake' | 'pageChanged' | 'pageChangedAt' | 'pageHashCheckedAt' | 'pageCheckedOkAt'>
      & { intakes: Array<(
        { __typename?: 'FundingIntakeType' }
        & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'startsAtTime' | 'endsAtTime' | 'announcedAt' | 'status' | 'phase' | 'daysLeft' | 'confirmedAt' | 'confirmedByName' | 'notifiedAt' | 'notifiedCount' | 'candidatesCount' | 'sourceUrl' | 'note'>
      )> }
    )> }
  )> }
);

export type ErpConfirmFundingIntakeMutationVariables = Exact<{
  id: Scalars['ID'];
  confirmed: Scalars['Boolean'];
}>;


export type ErpConfirmFundingIntakeMutation = (
  { __typename?: 'Mutation' }
  & { confirmFundingIntake?: Maybe<(
    { __typename?: 'ConfirmFundingIntake' }
    & Pick<ConfirmFundingIntake, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, intake?: Maybe<(
      { __typename?: 'FundingIntakeType' }
      & Pick<FundingIntakeType, 'id' | 'confirmedAt' | 'confirmedByName'>
    )> }
  )> }
);

export type ErpRetryFormSubmissionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpRetryFormSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { retryFormSubmission?: Maybe<(
    { __typename?: 'RetryFormSubmission' }
    & Pick<RetryFormSubmission, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, submission?: Maybe<(
      { __typename?: 'FormSubmissionType' }
      & Pick<FormSubmissionType, 'id' | 'state' | 'processError' | 'candidateId' | 'candidateName'>
    )> }
  )> }
);

export type ErpRunFundingTaskMutationVariables = Exact<{
  task: Scalars['String'];
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type ErpRunFundingTaskMutation = (
  { __typename?: 'Mutation' }
  & { runFundingTask?: Maybe<(
    { __typename?: 'RunFundingTask' }
    & Pick<RunFundingTask, 'success' | 'taskId' | 'workerOnline'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type ErpSaveFundingMailSettingsMutationVariables = Exact<{
  input: FundingMailSettingsInput;
}>;


export type ErpSaveFundingMailSettingsMutation = (
  { __typename?: 'Mutation' }
  & { saveFundingMailSettings?: Maybe<(
    { __typename?: 'SaveFundingMailSettingsMutation' }
    & Pick<SaveFundingMailSettingsMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, mailSettings?: Maybe<(
      { __typename?: 'FundingMailSettingsType' }
      & Pick<FundingMailSettingsType, 'paused' | 'fromEmail' | 'fromName' | 'replyTo' | 'effectiveFromEmail' | 'effectiveFromName' | 'effectiveReplyTo' | 'soonSendHour' | 'runningSendHour' | 'updatedAt' | 'updatedByName' | 'serverMailEnabled' | 'testRecipient' | 'notifyScheduled' | 'automatchScheduled' | 'shortenerEnabled' | 'canEdit' | 'automatchBlocked'>
    )> }
  )> }
);

export type ErpSaveFundingMailRuleMutationVariables = Exact<{
  input: FundingMailRuleInput;
}>;


export type ErpSaveFundingMailRuleMutation = (
  { __typename?: 'Mutation' }
  & { saveFundingMailRule?: Maybe<(
    { __typename?: 'SaveFundingMailRuleMutation' }
    & Pick<SaveFundingMailRuleMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, rule?: Maybe<(
      { __typename?: 'FundingMailRuleType' }
      & Pick<FundingMailRuleType, 'id' | 'code' | 'kind' | 'offsetDays' | 'everyDays' | 'templateId' | 'templateName' | 'templateSubject' | 'isActive' | 'updatedAt' | 'updatedByName' | 'canDelete' | 'sentCount'>
    )> }
  )> }
);

export type ErpDeleteFundingMailRuleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpDeleteFundingMailRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteFundingMailRule?: Maybe<(
    { __typename?: 'DeleteFundingMailRuleMutation' }
    & Pick<DeleteFundingMailRuleMutation, 'success' | 'deletedId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type ErpSendFundingMailTestMutationVariables = Exact<{
  ruleId: Scalars['ID'];
  intakeId?: Maybe<Scalars['ID']>;
  templateId?: Maybe<Scalars['String']>;
}>;


export type ErpSendFundingMailTestMutation = (
  { __typename?: 'Mutation' }
  & { sendFundingMailTest?: Maybe<(
    { __typename?: 'SendFundingMailTestMutation' }
    & Pick<SendFundingMailTestMutation, 'success' | 'sentTo'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type CreateStudentContractMutationVariables = Exact<{
  input: StudentContractDraftInput;
}>;


export type CreateStudentContractMutation = (
  { __typename?: 'Mutation' }
  & { createStudentContractDraft?: Maybe<(
    { __typename?: 'CreateStudentContractDraft' }
    & Pick<CreateStudentContractDraft, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type UpdateStudentContractMutationVariables = Exact<{
  id: Scalars['ID'];
  input: StudentContractDraftInput;
}>;


export type UpdateStudentContractMutation = (
  { __typename?: 'Mutation' }
  & { updateContractDraft?: Maybe<(
    { __typename?: 'UpdateContractDraft' }
    & Pick<UpdateContractDraft, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type CreateCompanyContractMutationVariables = Exact<{
  input: CompanyContractDraftInput;
}>;


export type CreateCompanyContractMutation = (
  { __typename?: 'Mutation' }
  & { createCompanyContractDraft?: Maybe<(
    { __typename?: 'CreateCompanyContractDraft' }
    & Pick<CreateCompanyContractDraft, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type UpdateCompanyContractMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CompanyContractDraftInput;
}>;


export type UpdateCompanyContractMutation = (
  { __typename?: 'Mutation' }
  & { updateCompanyContractDraft?: Maybe<(
    { __typename?: 'UpdateCompanyContractDraft' }
    & Pick<UpdateCompanyContractDraft, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type SendEsignContractMutationVariables = Exact<{
  id: Scalars['ID'];
  sendEmail: Scalars['Boolean'];
  emailSubject?: Maybe<Scalars['String']>;
  emailBody?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  aiDraftId?: Maybe<Scalars['ID']>;
}>;


export type SendEsignContractMutation = (
  { __typename?: 'Mutation' }
  & { sendContract?: Maybe<(
    { __typename?: 'SendContract' }
    & Pick<SendContract, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type ResendEsignEmailMutationVariables = Exact<{
  id: Scalars['ID'];
  emailSubject?: Maybe<Scalars['String']>;
  emailBody?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  aiDraftId?: Maybe<Scalars['ID']>;
}>;


export type ResendEsignEmailMutation = (
  { __typename?: 'Mutation' }
  & { resendContractEmail?: Maybe<(
    { __typename?: 'ResendContractEmail' }
    & Pick<ResendContractEmail, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type RevealEsignLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RevealEsignLinkMutation = (
  { __typename?: 'Mutation' }
  & { revealContractSigningLink?: Maybe<(
    { __typename?: 'RevealContractSigningLink' }
    & Pick<RevealContractSigningLink, 'success' | 'url' | 'expiresAt'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type CancelEsignContractMutationVariables = Exact<{
  id: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type CancelEsignContractMutation = (
  { __typename?: 'Mutation' }
  & { cancelContract?: Maybe<(
    { __typename?: 'CancelContract' }
    & Pick<CancelContract, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type RetryEsignFulfilmentMutationVariables = Exact<{
  id: Scalars['ID'];
  existingUserId?: Maybe<Scalars['ID']>;
}>;


export type RetryEsignFulfilmentMutation = (
  { __typename?: 'Mutation' }
  & { retryContractFulfilment?: Maybe<(
    { __typename?: 'RetryContractFulfilment' }
    & Pick<RetryContractFulfilment, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type CreateTeacherFrameworkMutationVariables = Exact<{
  teacherId: Scalars['ID'];
  templateCode?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  courseIds?: Maybe<Array<Scalars['ID']>>;
}>;


export type CreateTeacherFrameworkMutation = (
  { __typename?: 'Mutation' }
  & { createTeacherFrameworkDraft?: Maybe<(
    { __typename?: 'CreateTeacherFrameworkDraft' }
    & Pick<CreateTeacherFrameworkDraft, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type CreateTeacherAnnexMutationVariables = Exact<{
  applicationId: Scalars['ID'];
  templateId?: Maybe<Scalars['ID']>;
}>;


export type CreateTeacherAnnexMutation = (
  { __typename?: 'Mutation' }
  & { createTeacherAnnexDraft?: Maybe<(
    { __typename?: 'CreateTeacherAnnexDraft' }
    & Pick<CreateTeacherAnnexDraft, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type RequestContractReminderMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type RequestContractReminderMutation = (
  { __typename?: 'Mutation' }
  & { sendContractReminderNow?: Maybe<(
    { __typename?: 'SendContractReminderNow' }
    & Pick<SendContractReminderNow, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, outreach?: Maybe<(
      { __typename?: 'ContractOutreachType' }
      & EsignOutreachFieldsFragment
    )> }
  )> }
);

export type PauseContractRemindersMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type PauseContractRemindersMutation = (
  { __typename?: 'Mutation' }
  & { stopContractReminders?: Maybe<(
    { __typename?: 'StopContractReminders' }
    & Pick<StopContractReminders, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, outreach?: Maybe<(
      { __typename?: 'ContractOutreachType' }
      & EsignOutreachFieldsFragment
    )> }
  )> }
);

export type ContinueContractRemindersMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type ContinueContractRemindersMutation = (
  { __typename?: 'Mutation' }
  & { resumeContractReminders?: Maybe<(
    { __typename?: 'ResumeContractReminders' }
    & Pick<ResumeContractReminders, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, outreach?: Maybe<(
      { __typename?: 'ContractOutreachType' }
      & EsignOutreachFieldsFragment
    )> }
  )> }
);

export type ReassignEsignSellerMutationVariables = Exact<{
  id: Scalars['ID'];
  sellerId: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type ReassignEsignSellerMutation = (
  { __typename?: 'Mutation' }
  & { reassignContractSeller?: Maybe<(
    { __typename?: 'ReassignContractSeller' }
    & Pick<ReassignContractSeller, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, contract?: Maybe<(
      { __typename?: 'ContractDocumentType' }
      & EsignContractCardFieldsFragment
    )> }
  )> }
);

export type RevealEsignShortLinkMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type RevealEsignShortLinkMutation = (
  { __typename?: 'Mutation' }
  & { revealContractShortLink?: Maybe<(
    { __typename?: 'RevealContractShortLink' }
    & Pick<RevealContractShortLink, 'success' | 'url' | 'expiresAt'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type WriteContractEmailMutationVariables = Exact<{
  contractId: Scalars['ID'];
  mailboxEmail: Scalars['String'];
  subject: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  templateId?: Maybe<Scalars['ID']>;
  aiDraftId?: Maybe<Scalars['ID']>;
}>;


export type WriteContractEmailMutation = (
  { __typename?: 'Mutation' }
  & { sendContractEmail?: Maybe<(
    { __typename?: 'SendContractEmail' }
    & Pick<SendContractEmail, 'success' | 'conversationId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type SendContractSmsTextMutationVariables = Exact<{
  contractId: Scalars['ID'];
  text: Scalars['String'];
  templateId?: Maybe<Scalars['ID']>;
}>;


export type SendContractSmsTextMutation = (
  { __typename?: 'Mutation' }
  & { sendContractSms?: Maybe<(
    { __typename?: 'SendContractSms' }
    & Pick<SendContractSms, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, outreach?: Maybe<(
      { __typename?: 'ContractOutreachType' }
      & EsignOutreachFieldsFragment
    )> }
  )> }
);

export type SendContractsSmsBulkMutationVariables = Exact<{
  contractIds: Array<Scalars['ID']>;
  text: Scalars['String'];
  templateId?: Maybe<Scalars['ID']>;
  requestKey: Scalars['String'];
}>;


export type SendContractsSmsBulkMutation = (
  { __typename?: 'Mutation' }
  & { sendContractsSms?: Maybe<(
    { __typename?: 'SendContractsSms' }
    & Pick<SendContractsSms, 'success' | 'sent' | 'skipped'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, rows?: Maybe<Array<(
      { __typename?: 'ContractSmsBulkRowType' }
      & Pick<ContractSmsBulkRowType, 'contractId' | 'number' | 'signerName' | 'ok' | 'code' | 'message' | 'segments'>
    )>> }
  )> }
);

export type SaveContractMessageTemplateMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  channel: Scalars['String'];
  name: Scalars['String'];
  namePl?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  topic?: Maybe<Scalars['String']>;
  personal?: Maybe<Scalars['Boolean']>;
}>;


export type SaveContractMessageTemplateMutation = (
  { __typename?: 'Mutation' }
  & { saveMessageTemplate?: Maybe<(
    { __typename?: 'SaveMessageTemplate' }
    & Pick<SaveMessageTemplate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, template?: Maybe<(
      { __typename?: 'MessageTemplateType' }
      & EsignMessageTemplateFieldsFragment
    )> }
  )> }
);

export type DeleteContractMessageTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteContractMessageTemplateMutation = (
  { __typename?: 'Mutation' }
  & { deleteMessageTemplate?: Maybe<(
    { __typename?: 'DeleteMessageTemplate' }
    & Pick<DeleteMessageTemplate, 'success' | 'deletedId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type StoreContractTemplateVersionMutationVariables = Exact<{
  id: Scalars['ID'];
  html: Scalars['String'];
  tokens?: Maybe<Scalars['JSONString']>;
  comment?: Maybe<Scalars['String']>;
}>;


export type StoreContractTemplateVersionMutation = (
  { __typename?: 'Mutation' }
  & { saveContractTemplateVersion?: Maybe<(
    { __typename?: 'SaveContractTemplateVersion' }
    & Pick<SaveContractTemplateVersion, 'success' | 'rerenderedDrafts'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, problems: Array<(
      { __typename?: 'ContractTemplateProblemType' }
      & Pick<ContractTemplateProblemType, 'code' | 'message' | 'token'>
    )>, template?: Maybe<(
      { __typename?: 'ContractTemplateType' }
      & EsignContractTemplateFieldsFragment
    )> }
  )> }
);

export type CopyContractTemplateMutationVariables = Exact<{
  basedOnId: Scalars['ID'];
  name: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  appendix?: Maybe<Scalars['String']>;
}>;


export type CopyContractTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createContractTemplate?: Maybe<(
    { __typename?: 'CreateContractTemplate' }
    & Pick<CreateContractTemplate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, problems: Array<(
      { __typename?: 'ContractTemplateProblemType' }
      & Pick<ContractTemplateProblemType, 'code' | 'message' | 'token'>
    )>, template?: Maybe<(
      { __typename?: 'ContractTemplateType' }
      & EsignContractTemplateFieldsFragment
    )> }
  )> }
);

export type SwitchContractTemplateVersionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SwitchContractTemplateVersionMutation = (
  { __typename?: 'Mutation' }
  & { activateContractTemplateVersion?: Maybe<(
    { __typename?: 'ActivateContractTemplateVersion' }
    & Pick<ActivateContractTemplateVersion, 'success' | 'rerenderedDrafts'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, problems: Array<(
      { __typename?: 'ContractTemplateProblemType' }
      & Pick<ContractTemplateProblemType, 'code' | 'message' | 'token'>
    )>, template?: Maybe<(
      { __typename?: 'ContractTemplateType' }
      & EsignContractTemplateFieldsFragment
    )> }
  )> }
);

export type ToggleContractTemplateCodeMutationVariables = Exact<{
  code: Scalars['String'];
  active: Scalars['Boolean'];
}>;


export type ToggleContractTemplateCodeMutation = (
  { __typename?: 'Mutation' }
  & { setContractTemplateActive?: Maybe<(
    { __typename?: 'SetContractTemplateActive' }
    & Pick<SetContractTemplateActive, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, problems: Array<(
      { __typename?: 'ContractTemplateProblemType' }
      & Pick<ContractTemplateProblemType, 'code' | 'message' | 'token'>
    )>, template?: Maybe<(
      { __typename?: 'ContractTemplateType' }
      & EsignContractTemplateFieldsFragment
    )> }
  )> }
);

export type DraftContractEmailMutationVariables = Exact<{
  contractId: Scalars['ID'];
  kind: Scalars['String'];
  hint?: Maybe<Scalars['String']>;
  regenerate?: Maybe<Scalars['Boolean']>;
  requestKey?: Maybe<Scalars['String']>;
}>;


export type DraftContractEmailMutation = (
  { __typename?: 'Mutation' }
  & { draftContractEmail?: Maybe<(
    { __typename?: 'DraftContractEmail' }
    & Pick<DraftContractEmail, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, draft?: Maybe<(
      { __typename?: 'LeadEmailDraftType' }
      & Pick<LeadEmailDraftType, 'id' | 'kind' | 'subject' | 'html' | 'text' | 'cached' | 'contractId' | 'createdAt'>
    )> }
  )> }
);

export type RunFakturowniaSyncMutationVariables = Exact<{
  period?: Maybe<Scalars['String']>;
}>;


export type RunFakturowniaSyncMutation = (
  { __typename?: 'Mutation' }
  & { triggerFakturowniaSync?: Maybe<(
    { __typename?: 'TriggerFakturowniaSyncMutation' }
    & Pick<TriggerFakturowniaSyncMutation, 'enqueued' | 'message'>
    & { lastRun?: Maybe<(
      { __typename?: 'FakturowniaSyncRunType' }
      & Pick<FakturowniaSyncRunType, 'startedAt' | 'finishedAt' | 'status'>
    )> }
  )> }
);

export type RunFakturowniaGroupSyncMutationVariables = Exact<{
  groupId: Scalars['ID'];
  period?: Maybe<Scalars['String']>;
}>;


export type RunFakturowniaGroupSyncMutation = (
  { __typename?: 'Mutation' }
  & { triggerFakturowniaGroupSync?: Maybe<(
    { __typename?: 'TriggerFakturowniaGroupSyncMutation' }
    & Pick<TriggerFakturowniaGroupSyncMutation, 'enqueued' | 'message' | 'emailsTargeted'>
    & { lastRun?: Maybe<(
      { __typename?: 'FakturowniaSyncRunType' }
      & Pick<FakturowniaSyncRunType, 'startedAt' | 'finishedAt' | 'status'>
    )> }
  )> }
);

export type MatchFakturowniaInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  studentId: Scalars['ID'];
  groupId?: Maybe<Scalars['ID']>;
}>;


export type MatchFakturowniaInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { matchFakturowniaInvoice?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'matchStatus' | 'groupMatchSource' | 'linkedAt' | 'isCorrection' | 'isAdvance' | 'isFinal' | 'isEstimate' | 'isQuotation'>
      & { linkedStudent?: Maybe<(
        { __typename?: 'StudentType' }
        & Pick<StudentType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'CustomUserType' }
          & Pick<CustomUserType, 'id' | 'email' | 'firstName' | 'lastName'>
        )> }
      )>, linkedGroup?: Maybe<(
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type SetFakturowniaInvoiceGroupMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  groupId?: Maybe<Scalars['ID']>;
}>;


export type SetFakturowniaInvoiceGroupMutation = (
  { __typename?: 'Mutation' }
  & { setFakturowniaInvoiceGroup?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'groupMatchSource' | 'isCorrection' | 'isAdvance' | 'isFinal' | 'isEstimate' | 'isQuotation'>
      & { linkedGroup?: Maybe<(
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type UnlinkFakturowniaInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type UnlinkFakturowniaInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { unlinkFakturowniaInvoice?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'matchStatus'>
      & { payment?: Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<PaymentType, 'id'>
      )>, agreement?: Maybe<(
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id'>
      )> }
    )> }
  )> }
);

export type PinInvoiceToContributionMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  contributionId: Scalars['ID'];
}>;


export type PinInvoiceToContributionMutation = (
  { __typename?: 'Mutation' }
  & { linkInvoiceToContribution?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors' | 'errorCode'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'contributionMatchSource' | 'provisionBlockedReason'>
      & { contribution?: Maybe<(
        { __typename?: 'ContributionType' }
        & Pick<ContributionType, 'id' | 'date' | 'amountForeign' | 'status' | 'coveredAmount' | 'debt' | 'paidManually'>
      )>, payment?: Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<PaymentType, 'id'>
      )> }
    )> }
  )> }
);

export type UnpinInvoiceFromContributionMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type UnpinInvoiceFromContributionMutation = (
  { __typename?: 'Mutation' }
  & { unlinkInvoiceFromContribution?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'contributionMatchSource' | 'provisionBlockedReason'>
      & { contribution?: Maybe<(
        { __typename?: 'ContributionType' }
        & Pick<ContributionType, 'id'>
      )> }
    )> }
  )> }
);

export type RerunFakturowniaMatcherMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type RerunFakturowniaMatcherMutation = (
  { __typename?: 'Mutation' }
  & { rerunFakturowniaMatcher?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'matchStatus' | 'groupMatchSource' | 'isCorrection' | 'isAdvance' | 'isFinal' | 'isEstimate' | 'isQuotation'>
      & { linkedStudent?: Maybe<(
        { __typename?: 'StudentType' }
        & Pick<StudentType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'CustomUserType' }
          & Pick<CustomUserType, 'id' | 'email'>
        )> }
      )>, linkedGroup?: Maybe<(
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type CreateExpenseMutationVariables = Exact<{
  input: ExpenseInput;
}>;


export type CreateExpenseMutation = (
  { __typename?: 'Mutation' }
  & { createExpense?: Maybe<(
    { __typename?: 'ExpenseMutationOutput' }
    & Pick<ExpenseMutationOutput, 'success' | 'errors'>
    & { expense?: Maybe<(
      { __typename?: 'ExpenseType' }
      & Pick<ExpenseType, 'id' | 'pk' | 'date' | 'amount' | 'amountPln' | 'currency' | 'recurrence' | 'recurrenceDay' | 'recurrenceUntil' | 'status'>
    )> }
  )> }
);

export type UpdateExpenseMutationVariables = Exact<{
  input: UpdateExpenseInput;
}>;


export type UpdateExpenseMutation = (
  { __typename?: 'Mutation' }
  & { updateExpense?: Maybe<(
    { __typename?: 'ExpenseMutationOutput' }
    & Pick<ExpenseMutationOutput, 'success' | 'errors'>
    & { expense?: Maybe<(
      { __typename?: 'ExpenseType' }
      & Pick<ExpenseType, 'id' | 'pk' | 'amount' | 'amountPln' | 'currency' | 'notes' | 'documentUrl' | 'paidAt' | 'description' | 'counterpartyName' | 'counterpartyTaxNo' | 'recurrence' | 'recurrenceDay' | 'recurrenceUntil' | 'status'>
      & { category?: Maybe<(
        { __typename?: 'ExpenseCategoryType' }
        & Pick<ExpenseCategoryType, 'id' | 'slug' | 'name'>
      )>, relatedTeacher?: Maybe<(
        { __typename?: 'TeacherFilterType' }
        & Pick<TeacherFilterType, 'id'>
      )>, relatedGroup?: Maybe<(
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name'>
      )>, relatedFakturowniaInvoice?: Maybe<(
        { __typename?: 'FakturowniaInvoiceType' }
        & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number'>
      )> }
    )> }
  )> }
);

export type SetExpenseStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
  paidAt?: Maybe<Scalars['Date']>;
}>;


export type SetExpenseStatusMutation = (
  { __typename?: 'Mutation' }
  & { setExpenseStatus?: Maybe<(
    { __typename?: 'ExpenseMutationOutput' }
    & Pick<ExpenseMutationOutput, 'success' | 'errors'>
    & { expense?: Maybe<(
      { __typename?: 'ExpenseType' }
      & Pick<ExpenseType, 'id' | 'pk' | 'status' | 'paidAt'>
    )> }
  )> }
);

export type RemoveExpenseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveExpenseMutation = (
  { __typename?: 'Mutation' }
  & { deleteExpense?: Maybe<(
    { __typename?: 'DeleteExpenseMutation' }
    & Pick<DeleteExpenseMutation, 'success' | 'errors'>
  )> }
);

export type AddExpenseCategoryMutationVariables = Exact<{
  name: Scalars['String'];
  slug: Scalars['String'];
}>;


export type AddExpenseCategoryMutation = (
  { __typename?: 'Mutation' }
  & { createExpenseCategory?: Maybe<(
    { __typename?: 'CreateExpenseCategoryMutation' }
    & Pick<CreateExpenseCategoryMutation, 'success' | 'errors'>
    & { category?: Maybe<(
      { __typename?: 'ExpenseCategoryType' }
      & Pick<ExpenseCategoryType, 'id' | 'pk' | 'name' | 'slug' | 'isActive'>
    )> }
  )> }
);

export type IssueVatInvoiceForContributionMutationVariables = Exact<{
  agreementId: Scalars['ID'];
  contributionId?: Maybe<Scalars['ID']>;
  paymentTo?: Maybe<Scalars['Date']>;
  allowReissue?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
}>;


export type IssueVatInvoiceForContributionMutation = (
  { __typename?: 'Mutation' }
  & { issueInvoiceForContribution?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors' | 'errorCode' | 'documentCreated'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'status' | 'kind' | 'issueDate' | 'paymentTo' | 'currency' | 'priceGross' | 'outstanding' | 'viewUrl' | 'paymentUrl' | 'isProforma' | 'proformaForContributionId'>
      & { contribution?: Maybe<(
        { __typename?: 'ContributionType' }
        & Pick<ContributionType, 'id' | 'date' | 'amountForeign' | 'status' | 'coveredAmount' | 'debt'>
      )> }
    )> }
  )> }
);

export type EnqueueBulkInvoiceIssueMutationVariables = Exact<{
  groupId: Scalars['ID'];
  agreementIds?: Maybe<Array<Scalars['ID']>>;
  paymentTo?: Maybe<Scalars['Date']>;
  expectedBillableCount?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
}>;


export type EnqueueBulkInvoiceIssueMutation = (
  { __typename?: 'Mutation' }
  & { issueInvoicesForGroup?: Maybe<(
    { __typename?: 'FakturowniaBillingJobEnqueueOutput' }
    & Pick<FakturowniaBillingJobEnqueueOutput, 'success' | 'errors' | 'errorCode' | 'total' | 'billableCount' | 'skippedCount'>
    & { job?: Maybe<(
      { __typename?: 'FakturowniaBillingJobType' }
      & Pick<FakturowniaBillingJobType, 'id' | 'pk' | 'status' | 'total' | 'issuedCount' | 'skippedCount' | 'failedCount' | 'documentKind'>
    )> }
  )> }
);

export type ConvertProformaToVatMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type ConvertProformaToVatMutation = (
  { __typename?: 'Mutation' }
  & { issueVatFromProforma?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors' | 'errorCode' | 'documentCreated'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'kind' | 'status' | 'issueDate' | 'paymentTo' | 'currency' | 'priceGross' | 'paid' | 'outstanding' | 'viewUrl' | 'isProforma' | 'isOpenProforma' | 'proformaForContributionId'>
      & { vatChild?: Maybe<(
        { __typename?: 'FakturowniaInvoiceType' }
        & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'viewUrl'>
      )> }
    )> }
  )> }
);

export type PinProformaToContributionMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  contributionId: Scalars['ID'];
}>;


export type PinProformaToContributionMutation = (
  { __typename?: 'Mutation' }
  & { linkProformaToContribution?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors' | 'errorCode'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'isOpenProforma' | 'proformaForContributionId'>
    )> }
  )> }
);

export type UnpinProformaFromContributionMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type UnpinProformaFromContributionMutation = (
  { __typename?: 'Mutation' }
  & { unlinkProformaFromContribution?: Maybe<(
    { __typename?: 'FakturowniaMutationOutput' }
    & Pick<FakturowniaMutationOutput, 'success' | 'errors' | 'errorCode'>
    & { invoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'isOpenProforma' | 'proformaForContributionId'>
    )> }
  )> }
);

export type SaveGroupLessonLinkMutationVariables = Exact<{
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
}>;


export type SaveGroupLessonLinkMutation = (
  { __typename?: 'Mutation' }
  & { setGroupLessonLink?: Maybe<(
    { __typename?: 'SetGroupLessonLink' }
    & Pick<SetGroupLessonLink, 'success'>
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & GroupJoinLinkFieldsFragment
    )> }
  )> }
);

export type PutGroupLinkOverrideMutationVariables = Exact<{
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
  date?: Maybe<Scalars['Date']>;
}>;


export type PutGroupLinkOverrideMutation = (
  { __typename?: 'Mutation' }
  & { setGroupLessonLinkOverride?: Maybe<(
    { __typename?: 'SetGroupLessonLinkOverride' }
    & Pick<SetGroupLessonLinkOverride, 'success'>
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & GroupJoinLinkFieldsFragment
    )> }
  )> }
);

export type DropGroupLinkOverrideMutationVariables = Exact<{
  groupId: Scalars['Int'];
  date: Scalars['Date'];
}>;


export type DropGroupLinkOverrideMutation = (
  { __typename?: 'Mutation' }
  & { clearGroupLessonLinkOverride?: Maybe<(
    { __typename?: 'ClearGroupLessonLinkOverride' }
    & Pick<ClearGroupLessonLinkOverride, 'success'>
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & GroupJoinLinkFieldsFragment
    )> }
  )> }
);

export type RemoveGroupMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type RemoveGroupMutation = (
  { __typename?: 'Mutation' }
  & { deleteGroup?: Maybe<(
    { __typename?: 'DeleteGroupMutation' }
    & Pick<DeleteGroupMutation, 'success' | 'errors'>
  )> }
);

export type PublishToLmsMutationVariables = Exact<{
  groupId: Scalars['ID'];
  publishedLms: Scalars['Boolean'];
  publishedForTeachers?: Maybe<Scalars['Boolean']>;
  publishedLmsForMethodist?: Maybe<Scalars['Boolean']>;
}>;


export type PublishToLmsMutation = (
  { __typename?: 'Mutation' }
  & { publishGroup?: Maybe<(
    { __typename?: 'PublishGroupToLMS' }
    & Pick<PublishGroupToLms, 'success' | 'errors'>
  )> }
);

export type AddGroupMutationVariables = Exact<{
  groupInput: GroupInput;
  moduleInput: Array<Maybe<ModuleInput>>;
}>;


export type AddGroupMutation = (
  { __typename?: 'Mutation' }
  & { createGroup?: Maybe<(
    { __typename?: 'CreateGroupMutation' }
    & Pick<CreateGroupMutation, 'success' | 'errors'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ChangeGroupMutationVariables = Exact<{
  groupId: Scalars['Int'];
  groupInput: UpdateGroupInput;
}>;


export type ChangeGroupMutation = (
  { __typename?: 'Mutation' }
  & { updateGroup?: Maybe<(
    { __typename?: 'UpdateGroupMutation' }
    & Pick<UpdateGroupMutation, 'success' | 'errors'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type GroupAppendStudentMutationVariables = Exact<{
  studentId: Scalars['ID'];
  agreementInput: CreateAgreementInputBase;
}>;


export type GroupAppendStudentMutation = (
  { __typename?: 'Mutation' }
  & { appendStudentToGroup?: Maybe<(
    { __typename?: 'AppendStudentToGroupMutation' }
    & Pick<AppendStudentToGroupMutation, 'success' | 'errors'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, agreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'agreementTitle' | 'currency' | 'budgetAmount' | 'paidAmount' | 'terminated' | 'date'>
    )> }
  )> }
);

export type GroupTerminateAgreementMutationVariables = Exact<{
  agreementId: Scalars['ID'];
  terminatedDate?: Maybe<Scalars['Date']>;
  terminatedReason?: Maybe<TerminatedReasonEnum>;
  comment?: Maybe<Scalars['String']>;
}>;


export type GroupTerminateAgreementMutation = (
  { __typename?: 'Mutation' }
  & { terminateAgreement?: Maybe<(
    { __typename?: 'TerminateAgreementMutation' }
    & Pick<TerminateAgreementMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, agreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'terminated' | 'terminatedDate'>
    )> }
  )> }
);

export type GroupRestoreCourseAccessMutationVariables = Exact<{
  agreementId: Scalars['ID'];
}>;


export type GroupRestoreCourseAccessMutation = (
  { __typename?: 'Mutation' }
  & { restoreCourseAccess?: Maybe<(
    { __typename?: 'RestoreCourseAccessMutation' }
    & Pick<RestoreCourseAccessMutation, 'success' | 'restoredLessons'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, agreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'terminated'>
    )> }
  )> }
);

export type ChangeAttendanceMutationVariables = Exact<{
  attendanceId: Scalars['Int'];
  attendance: Scalars['Boolean'];
}>;


export type ChangeAttendanceMutation = (
  { __typename?: 'Mutation' }
  & { updateAttendance?: Maybe<(
    { __typename?: 'UpdateAttendanceMutation' }
    & Pick<UpdateAttendanceMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, attendance?: Maybe<(
      { __typename?: 'AttendanceType' }
      & Pick<AttendanceType, 'id' | 'attendance' | 'source' | 'markedAt' | 'markedByName'>
    )> }
  )> }
);

export type ChangeDateOfLessonMutationVariables = Exact<{
  groupId: Scalars['Int'];
  newDate: Scalars['Date'];
  oldDate: Scalars['Date'];
}>;


export type ChangeDateOfLessonMutation = (
  { __typename?: 'Mutation' }
  & { changeLessonDates?: Maybe<(
    { __typename?: 'ChangeLessonDate' }
    & Pick<ChangeLessonDate, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ChangeJournalMutationVariables = Exact<{
  groupId: Scalars['Int'];
  daysOfClass: Array<DayOfClassInput>;
  modules: Array<Maybe<UpdateModuleInput>>;
  comment: Scalars['String'];
}>;


export type ChangeJournalMutation = (
  { __typename?: 'Mutation' }
  & { updateJournal?: Maybe<(
    { __typename?: 'UpdateJournalsMutation' }
    & Pick<UpdateJournalsMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type StoreLmsBlockSettingsMutationVariables = Exact<{
  input: LmsBlockSettingsInput;
}>;


export type StoreLmsBlockSettingsMutation = (
  { __typename?: 'Mutation' }
  & { saveLmsBlockSettings?: Maybe<(
    { __typename?: 'SaveLmsBlockSettingsMutation' }
    & Pick<SaveLmsBlockSettingsMutation, 'success'>
    & { settings?: Maybe<(
      { __typename?: 'LmsBlockSettingsType' }
      & Pick<LmsBlockSettingsType, 'robotEnabled' | 'overdueDays' | 'mailEnabled' | 'slackEnabled' | 'smsEnabled' | 'suspendedTemplateId' | 'suspendedTemplateName' | 'restoredTemplateId' | 'restoredTemplateName' | 'updatedAt' | 'updatedByName' | 'serverRobotAllowed' | 'serverMailAllowed' | 'serverSlackAllowed' | 'serverSmsAllowed' | 'canEdit'>
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type TryLmsBlockTemplateMutationVariables = Exact<{
  kind: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
}>;


export type TryLmsBlockTemplateMutation = (
  { __typename?: 'Mutation' }
  & { sendLmsBlockTestEmail?: Maybe<(
    { __typename?: 'SendLmsBlockTestEmailMutation' }
    & Pick<SendLmsBlockTestEmailMutation, 'success' | 'sentTo'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type RefreshMarketingSourcesNowMutationVariables = Exact<{
  sources?: Maybe<Array<Scalars['String']>>;
}>;


export type RefreshMarketingSourcesNowMutation = (
  { __typename?: 'Mutation' }
  & { refreshMarketingSources?: Maybe<(
    { __typename?: 'OutputMarketingRefresh' }
    & Pick<OutputMarketingRefresh, 'success' | 'queued' | 'rebuildQueued'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, skipped: Array<(
      { __typename?: 'MarketingRefreshSkip' }
      & Pick<MarketingRefreshSkip, 'source' | 'reason'>
    )> }
  )> }
);

export type StoreMarketingChannelRuleMutationVariables = Exact<{
  input: MarketingChannelRuleInput;
}>;


export type StoreMarketingChannelRuleMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingChannelRule?: Maybe<(
    { __typename?: 'OutputMarketingChannelRule' }
    & Pick<OutputMarketingChannelRule, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, rule?: Maybe<(
      { __typename?: 'MarketingChannelRuleType' }
      & MarketingChannelRuleFieldsFragment
    )> }
  )> }
);

export type RemoveMarketingChannelRuleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveMarketingChannelRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteMarketingChannelRule?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type StoreMarketingCourseFamilyMutationVariables = Exact<{
  input: MarketingCourseFamilyInput;
}>;


export type StoreMarketingCourseFamilyMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingCourseFamily?: Maybe<(
    { __typename?: 'OutputMarketingCourseFamily' }
    & Pick<OutputMarketingCourseFamily, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, family?: Maybe<(
      { __typename?: 'MarketingCourseFamilyType' }
      & Pick<MarketingCourseFamilyType, 'id' | 'slug' | 'name' | 'isSold' | 'sort'>
      & { aliases: Array<(
        { __typename?: 'MarketingCourseAliasType' }
        & MarketingCourseAliasFieldsFragment
      )> }
    )> }
  )> }
);

export type StoreMarketingCourseAliasMutationVariables = Exact<{
  input: MarketingCourseAliasInput;
}>;


export type StoreMarketingCourseAliasMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingCourseAlias?: Maybe<(
    { __typename?: 'OutputMarketingCourseAlias' }
    & Pick<OutputMarketingCourseAlias, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, alias?: Maybe<(
      { __typename?: 'MarketingCourseAliasType' }
      & MarketingCourseAliasFieldsFragment
    )> }
  )> }
);

export type RemoveMarketingCourseAliasMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveMarketingCourseAliasMutation = (
  { __typename?: 'Mutation' }
  & { deleteMarketingCourseAlias?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type StoreMarketingOfferRuleMutationVariables = Exact<{
  input: MarketingOfferRuleInput;
}>;


export type StoreMarketingOfferRuleMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingOfferRule?: Maybe<(
    { __typename?: 'OutputMarketingOfferRule' }
    & Pick<OutputMarketingOfferRule, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, rule?: Maybe<(
      { __typename?: 'MarketingOfferRuleType' }
      & MarketingOfferRuleFieldsFragment
    )> }
  )> }
);

export type RemoveMarketingOfferRuleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveMarketingOfferRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteMarketingOfferRule?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type ChangeMarketingPipelineKindMutationVariables = Exact<{
  id: Scalars['ID'];
  funnelKind: Scalars['String'];
  locked: Scalars['Boolean'];
}>;


export type ChangeMarketingPipelineKindMutation = (
  { __typename?: 'Mutation' }
  & { setMarketingPipelineKind?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type PinMarketingAdEntityMutationVariables = Exact<{
  id: Scalars['ID'];
  familySlug?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  locked: Scalars['Boolean'];
}>;


export type PinMarketingAdEntityMutation = (
  { __typename?: 'Mutation' }
  & { overrideMarketingAdEntity?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type CorrectMarketingSaleMutationVariables = Exact<{
  input: MarketingSaleOverrideInput;
}>;


export type CorrectMarketingSaleMutation = (
  { __typename?: 'Mutation' }
  & { overrideMarketingSale?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type SetMarketingPlanTargetMutationVariables = Exact<{
  input: MarketingTargetInput;
}>;


export type SetMarketingPlanTargetMutation = (
  { __typename?: 'Mutation' }
  & { setMarketingTarget?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type DecideMarketingSignalMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type DecideMarketingSignalMutation = (
  { __typename?: 'Mutation' }
  & { ackMarketingSignal?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type StoreMarketingCampaignAliasMutationVariables = Exact<{
  input: MarketingCampaignAliasInput;
}>;


export type StoreMarketingCampaignAliasMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingCampaignAlias?: Maybe<(
    { __typename?: 'OutputMarketingCampaignAlias' }
    & Pick<OutputMarketingCampaignAlias, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, alias?: Maybe<(
      { __typename?: 'MarketingCampaignAliasType' }
      & MarketingCampaignAliasFieldsFragment
    )> }
  )> }
);

export type RemoveMarketingCampaignAliasMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveMarketingCampaignAliasMutation = (
  { __typename?: 'Mutation' }
  & { deleteMarketingCampaignAlias?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type StoreMarketingSearchSettingsMutationVariables = Exact<{
  brandRegex?: Maybe<Scalars['String']>;
  ga4KeyEvents?: Maybe<Array<Scalars['String']>>;
  siteHosts?: Maybe<Array<Scalars['String']>>;
}>;


export type StoreMarketingSearchSettingsMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingSearchSettings?: Maybe<(
    { __typename?: 'OutputMarketingSearchSettings' }
    & Pick<OutputMarketingSearchSettings, 'success' | 'brandRegex' | 'ga4KeyEvents' | 'siteHosts'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type QueueMarketingDigestRebuildMutationVariables = Exact<{
  isoWeek?: Maybe<Scalars['String']>;
}>;


export type QueueMarketingDigestRebuildMutation = (
  { __typename?: 'Mutation' }
  & { generateMarketingDigest?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type StoreMarketingSignalRoutingMutationVariables = Exact<{
  input: MarketingSignalRoutingInput;
}>;


export type StoreMarketingSignalRoutingMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingSignalRouting?: Maybe<(
    { __typename?: 'OutputMarketingOk' }
    & Pick<OutputMarketingOk, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type SaveMarketingPageTypesFormMutationVariables = Exact<{
  rules: Array<MarketingPageTypeRuleInput>;
}>;


export type SaveMarketingPageTypesFormMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingPageTypes?: Maybe<(
    { __typename?: 'OutputMarketingPageTypes' }
    & Pick<OutputMarketingPageTypes, 'success' | 'changed'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, rules?: Maybe<Array<(
      { __typename?: 'MarketingPageTypeRule' }
      & Pick<MarketingPageTypeRule, 'type' | 'regex'>
    )>> }
  )> }
);

export type SaveMarketingSeoSettingsFormMutationVariables = Exact<{
  input: MarketingSeoSettingsInput;
}>;


export type SaveMarketingSeoSettingsFormMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingSeoSettings?: Maybe<(
    { __typename?: 'OutputMarketingSeoSettings' }
    & Pick<OutputMarketingSeoSettings, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, settings?: Maybe<(
      { __typename?: 'MarketingSeoSettingsType' }
      & Pick<MarketingSeoSettingsType, 'ownDomain' | 'locationCode' | 'languageCode' | 'device' | 'depth' | 'maxTracked' | 'aiRepeats' | 'minGapVolume' | 'excludedTopics' | 'trackedCount'>
    )>, domains?: Maybe<Array<(
      { __typename?: 'MarketingSeoDomainType' }
      & Pick<MarketingSeoDomainType, 'id' | 'domain' | 'label' | 'isOwn' | 'active' | 'source' | 'brandRegex' | 'suggestedMetrics'>
    )>> }
  )> }
);

export type SaveMarketingSeoKeywordFlagsMutationVariables = Exact<{
  id: Scalars['ID'];
  excluded?: Maybe<Scalars['Boolean']>;
  tracked?: Maybe<Scalars['Boolean']>;
}>;


export type SaveMarketingSeoKeywordFlagsMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingSeoKeyword?: Maybe<(
    { __typename?: 'OutputMarketingSeoKeyword' }
    & Pick<OutputMarketingSeoKeyword, 'success' | 'id' | 'tracked' | 'excluded'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type AddMarketingSeoKeywordsFormMutationVariables = Exact<{
  keywords: Array<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
}>;


export type AddMarketingSeoKeywordsFormMutation = (
  { __typename?: 'Mutation' }
  & { addMarketingSeoKeywords?: Maybe<(
    { __typename?: 'OutputMarketingSeoKeywordsAdded' }
    & Pick<OutputMarketingSeoKeywordsAdded, 'success' | 'added' | 'existing' | 'tracked' | 'rejected'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type SaveMarketingSeoQuestionFormMutationVariables = Exact<{
  input: MarketingSeoQuestionInput;
}>;


export type SaveMarketingSeoQuestionFormMutation = (
  { __typename?: 'Mutation' }
  & { saveMarketingSeoQuestion?: Maybe<(
    { __typename?: 'OutputMarketingSeoQuestion' }
    & Pick<OutputMarketingSeoQuestion, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, question?: Maybe<(
      { __typename?: 'MarketingSeoQuestionType' }
      & Pick<MarketingSeoQuestionType, 'id' | 'familySlug' | 'group' | 'textPl' | 'active' | 'sort' | 'version' | 'source'>
    )> }
  )> }
);

export type RemoveMarketingSeoQuestionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveMarketingSeoQuestionMutation = (
  { __typename?: 'Mutation' }
  & { deleteMarketingSeoQuestion?: Maybe<(
    { __typename?: 'OutputMarketingSeoQuestionDeleted' }
    & Pick<OutputMarketingSeoQuestionDeleted, 'success' | 'deleted'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type DecideMarketingSeoOpportunitiesMutationVariables = Exact<{
  ids: Array<Scalars['ID']>;
  status: Scalars['String'];
  note?: Maybe<Scalars['String']>;
}>;


export type DecideMarketingSeoOpportunitiesMutation = (
  { __typename?: 'Mutation' }
  & { setMarketingSeoOpportunityStatus?: Maybe<(
    { __typename?: 'OutputMarketingSeoOpportunities' }
    & Pick<OutputMarketingSeoOpportunities, 'success' | 'updated'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, opportunities?: Maybe<Array<(
      { __typename?: 'MarketingSeoOpportunity' }
      & MarketingSeoOpportunityFieldsFragment
    )>> }
  )> }
);

export type RunMarketingSeoJobMutationVariables = Exact<{
  kind: Scalars['String'];
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type RunMarketingSeoJobMutation = (
  { __typename?: 'Mutation' }
  & { runMarketingSeo?: Maybe<(
    { __typename?: 'OutputMarketingSeoRun' }
    & Pick<OutputMarketingSeoRun, 'success' | 'queued' | 'dryRun'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, estimate?: Maybe<(
      { __typename?: 'MarketingSeoEstimate' }
      & Pick<MarketingSeoEstimate, 'kind' | 'estimateUsd' | 'keywords' | 'questions' | 'ai' | 'upperBound' | 'refusal'>
      & { items: Array<(
        { __typename?: 'MarketingSeoEstimateItem' }
        & Pick<MarketingSeoEstimateItem, 'endpoint' | 'requests' | 'results' | 'costUsd'>
      )> }
    )> }
  )> }
);

export type MaterialCreateMutationVariables = Exact<{
  input: CreateMaterialInput;
}>;


export type MaterialCreateMutation = (
  { __typename?: 'Mutation' }
  & { createMaterial?: Maybe<(
    { __typename?: 'CreateMaterialMutation' }
    & Pick<CreateMaterialMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, material?: Maybe<(
      { __typename?: 'MaterialType' }
      & Pick<MaterialType, 'id' | 'pk' | 'kind' | 'title' | 'description' | 'dueDate' | 'createdAt'>
      & { lesson?: Maybe<(
        { __typename?: 'GroupLessonType' }
        & Pick<GroupLessonType, 'id' | 'name' | 'number'>
      )> }
    )> }
  )> }
);

export type MaterialUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateMaterialInput;
}>;


export type MaterialUpdateMutation = (
  { __typename?: 'Mutation' }
  & { updateMaterial?: Maybe<(
    { __typename?: 'UpdateMaterialMutation' }
    & Pick<UpdateMaterialMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, material?: Maybe<(
      { __typename?: 'MaterialType' }
      & Pick<MaterialType, 'id' | 'pk' | 'kind' | 'title' | 'description' | 'dueDate' | 'updatedAt'>
    )> }
  )> }
);

export type MaterialDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MaterialDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteMaterial?: Maybe<(
    { __typename?: 'DeleteMaterialMutation' }
    & Pick<DeleteMaterialMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type McpRevokeConnectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type McpRevokeConnectionMutation = (
  { __typename?: 'Mutation' }
  & { revokeMcpConnection?: Maybe<(
    { __typename?: 'RevokeMcpConnectionMutation' }
    & Pick<RevokeMcpConnectionMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type MarkNotificationsReadMutationVariables = Exact<{
  ids: Array<Scalars['ID']>;
}>;


export type MarkNotificationsReadMutation = (
  { __typename?: 'Mutation' }
  & { markStaffNotificationsRead?: Maybe<(
    { __typename?: 'MarkStaffNotificationsRead' }
    & Pick<MarkStaffNotificationsRead, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, summary?: Maybe<(
      { __typename?: 'StaffNotificationsSummaryType' }
      & Pick<StaffNotificationsSummaryType, 'unreadCount' | 'totalCount'>
      & { soundAlarm: (
        { __typename?: 'SoundAlarmType' }
        & Pick<SoundAlarmType, 'active' | 'taskId' | 'title'>
      ) }
    )> }
  )> }
);

export type MarkAllNotificationsReadMutationVariables = Exact<{
  before?: Maybe<Scalars['DateTime']>;
}>;


export type MarkAllNotificationsReadMutation = (
  { __typename?: 'Mutation' }
  & { markAllStaffNotificationsRead?: Maybe<(
    { __typename?: 'MarkAllStaffNotificationsRead' }
    & Pick<MarkAllStaffNotificationsRead, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, summary?: Maybe<(
      { __typename?: 'StaffNotificationsSummaryType' }
      & Pick<StaffNotificationsSummaryType, 'unreadCount' | 'totalCount'>
      & { soundAlarm: (
        { __typename?: 'SoundAlarmType' }
        & Pick<SoundAlarmType, 'active' | 'taskId' | 'title'>
      ) }
    )> }
  )> }
);

export type SaveNotificationPrefsMutationVariables = Exact<{
  input: StaffNotificationSettingsInput;
}>;


export type SaveNotificationPrefsMutation = (
  { __typename?: 'Mutation' }
  & { updateStaffNotificationSettings?: Maybe<(
    { __typename?: 'UpdateStaffNotificationSettings' }
    & Pick<UpdateStaffNotificationSettings, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, settings?: Maybe<(
      { __typename?: 'StaffNotificationSettingsType' }
      & Pick<StaffNotificationSettingsType, 'soundEnabled' | 'pollSeconds' | 'repeatAfterMinutes' | 'quietFrom' | 'quietTo' | 'enabledKinds' | 'telegramEnabled' | 'telegramLinked' | 'telegramUsername' | 'telegramLinkedAt' | 'telegramBlockedAt' | 'telegramAvailable' | 'robotRules'>
      & { availableKinds: Array<(
        { __typename?: 'StaffNotificationKindType' }
        & Pick<StaffNotificationKindType, 'key' | 'label' | 'enabled'>
      )>, availableRobotRules: Array<(
        { __typename?: 'StaffRobotRuleType' }
        & Pick<StaffRobotRuleType, 'key' | 'label' | 'enabled' | 'available'>
      )> }
    )> }
  )> }
);

export type StartTelegramLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type StartTelegramLinkMutation = (
  { __typename?: 'Mutation' }
  & { startTelegramLink?: Maybe<(
    { __typename?: 'StartTelegramLink' }
    & Pick<StartTelegramLink, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, link?: Maybe<(
      { __typename?: 'TelegramLinkType' }
      & Pick<TelegramLinkType, 'deepLink' | 'expiresAt'>
    )> }
  )> }
);

export type DropTelegramLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type DropTelegramLinkMutation = (
  { __typename?: 'Mutation' }
  & { unlinkTelegram?: Maybe<(
    { __typename?: 'UnlinkTelegram' }
    & Pick<UnlinkTelegram, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, settings?: Maybe<(
      { __typename?: 'StaffNotificationSettingsType' }
      & Pick<StaffNotificationSettingsType, 'telegramEnabled' | 'telegramLinked' | 'telegramUsername' | 'telegramLinkedAt' | 'telegramBlockedAt' | 'telegramAvailable'>
    )> }
  )> }
);

export type ProvisionPandaDocStudentsMutationVariables = Exact<{
  groupId: Scalars['ID'];
  contributionAmount: Scalars['Float'];
  currency: Scalars['String'];
  documents: Array<ProvisionDocOverrideInput>;
}>;


export type ProvisionPandaDocStudentsMutation = (
  { __typename?: 'Mutation' }
  & { provisionStudents?: Maybe<(
    { __typename?: 'ProvisionStudentsMutation' }
    & Pick<ProvisionStudentsMutation, 'errors'>
    & { results?: Maybe<Array<Maybe<(
      { __typename?: 'ProvisionResultItem' }
      & Pick<ProvisionResultItem, 'pandadocId' | 'success' | 'skipped' | 'agreementId' | 'error'>
    )>>> }
  )> }
);

export type RunPandaDocSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type RunPandaDocSyncMutation = (
  { __typename?: 'Mutation' }
  & { triggerPandadocSync?: Maybe<(
    { __typename?: 'TriggerPandadocSyncMutation' }
    & Pick<TriggerPandadocSyncMutation, 'enqueued' | 'message'>
    & { syncStatus?: Maybe<(
      { __typename?: 'PandaDocSyncStatusType' }
      & Pick<PandaDocSyncStatusType, 'documentsCount' | 'detailsPending' | 'lastListSyncAt' | 'lastDetailsSyncAt' | 'newestDocDate' | 'lastDocumentsPulled' | 'lastRunStatus' | 'lastError'>
    )> }
  )> }
);

export type RunPandaDocReparseMutationVariables = Exact<{
  markRefetch?: Maybe<Scalars['Boolean']>;
}>;


export type RunPandaDocReparseMutation = (
  { __typename?: 'Mutation' }
  & { reparsePandadocRecipients?: Maybe<(
    { __typename?: 'ReparsePandadocRecipientsMutation' }
    & Pick<ReparsePandadocRecipientsMutation, 'enqueued' | 'message'>
    & { syncStatus?: Maybe<(
      { __typename?: 'PandaDocSyncStatusType' }
      & Pick<PandaDocSyncStatusType, 'documentsCount' | 'detailsPending' | 'lastRunStatus' | 'lastError' | 'syncRunning'>
    )> }
  )> }
);

export type LinkPandaDocDocumentMutationVariables = Exact<{
  pandadocId: Scalars['String'];
  agreementId: Scalars['ID'];
}>;


export type LinkPandaDocDocumentMutation = (
  { __typename?: 'Mutation' }
  & { linkPandadocDocument?: Maybe<(
    { __typename?: 'LinkPandadocDocumentMutation' }
    & Pick<LinkPandadocDocumentMutation, 'errors'>
    & { document?: Maybe<(
      { __typename?: 'PandaDocDocumentType' }
      & Pick<PandaDocDocumentType, 'id' | 'pandadocId' | 'matchType'>
      & { agreement?: Maybe<(
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id' | 'agreementTitle'>
      )> }
    )> }
  )> }
);

export type UnlinkPandaDocDocumentMutationVariables = Exact<{
  pandadocId: Scalars['String'];
}>;


export type UnlinkPandaDocDocumentMutation = (
  { __typename?: 'Mutation' }
  & { unlinkPandadocDocument?: Maybe<(
    { __typename?: 'UnlinkPandadocDocumentMutation' }
    & Pick<UnlinkPandadocDocumentMutation, 'errors'>
    & { document?: Maybe<(
      { __typename?: 'PandaDocDocumentType' }
      & Pick<PandaDocDocumentType, 'id' | 'pandadocId' | 'matchType'>
      & { agreement?: Maybe<(
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id' | 'agreementTitle'>
      )> }
    )> }
  )> }
);

export type AttachPandadocTeacherMutationVariables = Exact<{
  pandadocId: Scalars['String'];
  teacherId: Scalars['ID'];
}>;


export type AttachPandadocTeacherMutation = (
  { __typename?: 'Mutation' }
  & { linkPandadocTeacher?: Maybe<(
    { __typename?: 'LinkPandadocTeacherMutation' }
    & Pick<LinkPandadocTeacherMutation, 'errors'>
    & { document?: Maybe<(
      { __typename?: 'PandaDocDocumentType' }
      & Pick<PandaDocDocumentType, 'id' | 'pandadocId' | 'matchType'>
      & { teacher?: Maybe<(
        { __typename?: 'TeacherType' }
        & Pick<TeacherType, 'id'>
      )> }
    )> }
  )> }
);

export type DetachPandadocTeacherMutationVariables = Exact<{
  pandadocId: Scalars['String'];
}>;


export type DetachPandadocTeacherMutation = (
  { __typename?: 'Mutation' }
  & { unlinkPandadocTeacher?: Maybe<(
    { __typename?: 'UnlinkPandadocTeacherMutation' }
    & Pick<UnlinkPandadocTeacherMutation, 'errors'>
    & { document?: Maybe<(
      { __typename?: 'PandaDocDocumentType' }
      & Pick<PandaDocDocumentType, 'id' | 'pandadocId' | 'matchType'>
      & { teacher?: Maybe<(
        { __typename?: 'TeacherType' }
        & Pick<TeacherType, 'id'>
      )> }
    )> }
  )> }
);

export type CreatePlannedPaymentMutationVariables = Exact<{
  input: PlannedPaymentInput;
}>;


export type CreatePlannedPaymentMutation = (
  { __typename?: 'Mutation' }
  & { createPlannedPayment?: Maybe<(
    { __typename?: 'PlannedPaymentMutationOutput' }
    & Pick<PlannedPaymentMutationOutput, 'success' | 'errors'>
    & { plannedPayment?: Maybe<(
      { __typename?: 'PlannedPaymentType' }
      & Pick<PlannedPaymentType, 'pk' | 'direction' | 'kind' | 'date' | 'amount' | 'currency' | 'comment' | 'status'>
    )> }
  )> }
);

export type UpdatePlannedPaymentMutationVariables = Exact<{
  input: UpdatePlannedPaymentInput;
}>;


export type UpdatePlannedPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updatePlannedPayment?: Maybe<(
    { __typename?: 'PlannedPaymentMutationOutput' }
    & Pick<PlannedPaymentMutationOutput, 'success' | 'errors'>
    & { plannedPayment?: Maybe<(
      { __typename?: 'PlannedPaymentType' }
      & Pick<PlannedPaymentType, 'pk' | 'date' | 'amount' | 'currency' | 'comment' | 'status'>
    )> }
  )> }
);

export type DeletePlannedPaymentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePlannedPaymentMutation = (
  { __typename?: 'Mutation' }
  & { deletePlannedPayment?: Maybe<(
    { __typename?: 'DeletePlannedPaymentOutput' }
    & Pick<DeletePlannedPaymentOutput, 'success' | 'errors'>
  )> }
);

export type SetCashBalanceMutationVariables = Exact<{
  amountPln: Scalars['Float'];
  asOfDate: Scalars['Date'];
  legalEntityId?: Maybe<Scalars['ID']>;
  comment?: Maybe<Scalars['String']>;
}>;


export type SetCashBalanceMutation = (
  { __typename?: 'Mutation' }
  & { setCashBalance?: Maybe<(
    { __typename?: 'CashBalanceMutationOutput' }
    & Pick<CashBalanceMutationOutput, 'success' | 'errors'>
    & { cashBalance?: Maybe<(
      { __typename?: 'CashBalanceSnapshotType' }
      & Pick<CashBalanceSnapshotType, 'pk' | 'asOfDate' | 'amountPln'>
    )> }
  )> }
);

export type SetExchangeRateMutationVariables = Exact<{
  currency: Scalars['String'];
  rateToPln: Scalars['Float'];
  effectiveFrom: Scalars['Date'];
  comment?: Maybe<Scalars['String']>;
}>;


export type SetExchangeRateMutation = (
  { __typename?: 'Mutation' }
  & { setExchangeRate?: Maybe<(
    { __typename?: 'ExchangeRateMutationOutput' }
    & Pick<ExchangeRateMutationOutput, 'success' | 'errors'>
    & { exchangeRate?: Maybe<(
      { __typename?: 'ExchangeRateType' }
      & Pick<ExchangeRateType, 'pk' | 'currency' | 'rateToPln' | 'effectiveFrom'>
    )> }
  )> }
);

export type SetPaymentCalendarSettingsMutationVariables = Exact<{
  teacherPayoutDay?: Maybe<Scalars['Int']>;
  incomeOffsetDays?: Maybe<Scalars['Int']>;
  legalEntityId?: Maybe<Scalars['ID']>;
}>;


export type SetPaymentCalendarSettingsMutation = (
  { __typename?: 'Mutation' }
  & { setPaymentCalendarSettings?: Maybe<(
    { __typename?: 'CalendarSettingsMutationOutput' }
    & Pick<CalendarSettingsMutationOutput, 'success' | 'errors'>
    & { calendarSettings?: Maybe<(
      { __typename?: 'PaymentCalendarSettingsType' }
      & Pick<PaymentCalendarSettingsType, 'teacherPayoutDay' | 'incomeOffsetDays' | 'legalEntityId'>
    )> }
  )> }
);

export type OrderPnlExportMutationVariables = Exact<{
  monthFrom: Scalars['String'];
  monthTo: Scalars['String'];
  fileFormat: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
}>;


export type OrderPnlExportMutation = (
  { __typename?: 'Mutation' }
  & { requestPnlExport?: Maybe<(
    { __typename?: 'RequestPnlExportMutation' }
    & Pick<RequestPnlExportMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, run?: Maybe<(
      { __typename?: 'PnlExportRunType' }
      & Pick<PnlExportRunType, 'id' | 'status' | 'fileFormat' | 'language' | 'monthFrom' | 'monthTo' | 'groupId' | 'groupName' | 'fileName' | 'size' | 'stats' | 'error' | 'createdByName' | 'createdAt' | 'finishedAt' | 'isDownloadable' | 'isFilePurged'>
    )> }
  )> }
);

export type StoreMailSignatureMutationVariables = Exact<{
  mailboxEmail?: Maybe<Scalars['String']>;
  html: Scalars['String'];
}>;


export type StoreMailSignatureMutation = (
  { __typename?: 'Mutation' }
  & { saveMailSignature?: Maybe<(
    { __typename?: 'MailSignatureType' }
    & Pick<MailSignatureType, 'id' | 'mailboxEmail' | 'html' | 'source' | 'importedAt' | 'updatedAt'>
  )> }
);

export type PullGmailSignatureMutationVariables = Exact<{
  mailboxEmail: Scalars['String'];
}>;


export type PullGmailSignatureMutation = (
  { __typename?: 'Mutation' }
  & { importGmailSignature?: Maybe<(
    { __typename?: 'MailSignatureType' }
    & Pick<MailSignatureType, 'id' | 'mailboxEmail' | 'html' | 'source' | 'importedAt' | 'updatedAt'>
  )> }
);

export type AddEmailAttachmentDraftMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type AddEmailAttachmentDraftMutation = (
  { __typename?: 'Mutation' }
  & { uploadEmailAttachment?: Maybe<(
    { __typename?: 'EmailAttachmentDraftType' }
    & Pick<EmailAttachmentDraftType, 'id' | 'name' | 'size' | 'mime'>
  )> }
);

export type OpenEmailAttachmentMutationVariables = Exact<{
  messageId: Scalars['ID'];
  index: Scalars['Int'];
}>;


export type OpenEmailAttachmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'emailAttachmentLink'>
);

export type SetRuntimeSettingValueMutationVariables = Exact<{
  key: Scalars['String'];
  value: Scalars['JSONString'];
  reason?: Maybe<Scalars['String']>;
}>;


export type SetRuntimeSettingValueMutation = (
  { __typename?: 'Mutation' }
  & { setRuntimeSetting?: Maybe<(
    { __typename?: 'SetRuntimeSetting' }
    & Pick<SetRuntimeSetting, 'success' | 'changed'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, setting?: Maybe<(
      { __typename?: 'RuntimeSettingType' }
      & RuntimeSettingFieldsFragment
    )> }
  )> }
);

export type ClearRuntimeSettingValueMutationVariables = Exact<{
  key: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
}>;


export type ClearRuntimeSettingValueMutation = (
  { __typename?: 'Mutation' }
  & { clearRuntimeSetting?: Maybe<(
    { __typename?: 'ClearRuntimeSetting' }
    & Pick<ClearRuntimeSetting, 'success' | 'changed'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, setting?: Maybe<(
      { __typename?: 'RuntimeSettingType' }
      & RuntimeSettingFieldsFragment
    )> }
  )> }
);

export type DisableOrphanPeriodicTaskActionMutationVariables = Exact<{
  name: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
}>;


export type DisableOrphanPeriodicTaskActionMutation = (
  { __typename?: 'Mutation' }
  & { disableOrphanPeriodicTask?: Maybe<(
    { __typename?: 'DisableOrphanPeriodicTask' }
    & Pick<DisableOrphanPeriodicTask, 'success' | 'changed'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, orphan?: Maybe<(
      { __typename?: 'OrphanPeriodicTaskType' }
      & Pick<OrphanPeriodicTaskType, 'name' | 'task' | 'enabled' | 'schedule' | 'lastRunAt' | 'totalRunCount'>
    )> }
  )> }
);

export type MailSyncContactListMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type MailSyncContactListMutation = (
  { __typename?: 'Mutation' }
  & { syncGroupSendgridList?: Maybe<(
    { __typename?: 'SyncGroupSendgridList' }
    & Pick<SyncGroupSendgridList, 'success'>
    & { list?: Maybe<(
      { __typename?: 'SendgridGroupListType' }
      & Pick<SendgridGroupListType, 'id' | 'sendgridListId' | 'name' | 'contactCount' | 'lastSyncStatus' | 'lastSyncedAt' | 'errorMessage'>
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type MailSendToGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  templateId: Scalars['String'];
  templateName?: Maybe<Scalars['String']>;
  recipients: Array<MailRecipientInput>;
  subjectOverride?: Maybe<Scalars['String']>;
}>;


export type MailSendToGroupMutation = (
  { __typename?: 'Mutation' }
  & { sendGroupTemplateEmail?: Maybe<(
    { __typename?: 'SendGroupTemplateEmail' }
    & Pick<SendGroupTemplateEmail, 'success' | 'mailJobId' | 'total'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type CreateManualShortLinkMutationVariables = Exact<{
  targetUrl: Scalars['String'];
  title: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
}>;


export type CreateManualShortLinkMutation = (
  { __typename?: 'Mutation' }
  & { createShortLink?: Maybe<(
    { __typename?: 'CreateShortLink' }
    & Pick<CreateShortLink, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, link?: Maybe<(
      { __typename?: 'ShortLinkType' }
      & ShortLinkFieldsFragment
    )> }
  )> }
);

export type UpdateManualShortLinkMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  clearExpiry?: Maybe<Scalars['Boolean']>;
  channel?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
}>;


export type UpdateManualShortLinkMutation = (
  { __typename?: 'Mutation' }
  & { updateShortLink?: Maybe<(
    { __typename?: 'UpdateShortLink' }
    & Pick<UpdateShortLink, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, link?: Maybe<(
      { __typename?: 'ShortLinkType' }
      & ShortLinkFieldsFragment
    )> }
  )> }
);

export type RevokeManualShortLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RevokeManualShortLinkMutation = (
  { __typename?: 'Mutation' }
  & { revokeShortLink?: Maybe<(
    { __typename?: 'RevokeShortLink' }
    & Pick<RevokeShortLink, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, link?: Maybe<(
      { __typename?: 'ShortLinkType' }
      & ShortLinkFieldsFragment
    )> }
  )> }
);

export type RevokeManyShortLinksMutationVariables = Exact<{
  ids: Array<Scalars['ID']>;
}>;


export type RevokeManyShortLinksMutation = (
  { __typename?: 'Mutation' }
  & { revokeShortLinks?: Maybe<(
    { __typename?: 'RevokeShortLinks' }
    & Pick<RevokeShortLinks, 'success' | 'revokedIds' | 'skipped'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type QueueStudentSmsMutationVariables = Exact<{
  studentId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<SmsLinkInput>;
  templateId?: Maybe<Scalars['ID']>;
  requestKey?: Maybe<Scalars['String']>;
}>;


export type QueueStudentSmsMutation = (
  { __typename?: 'Mutation' }
  & { sendStudentSms?: Maybe<(
    { __typename?: 'SendStudentSms' }
    & Pick<SendStudentSms, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, message?: Maybe<(
      { __typename?: 'SmsMessageType' }
      & SmsMessageFieldsFragment
    )>, state?: Maybe<(
      { __typename?: 'StudentSmsStateType' }
      & StudentSmsStateFieldsFragment
    )> }
  )> }
);

export type QueueTeacherSmsMutationVariables = Exact<{
  teacherId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<TeacherSmsLinkInput>;
  templateId?: Maybe<Scalars['ID']>;
  requestKey?: Maybe<Scalars['String']>;
}>;


export type QueueTeacherSmsMutation = (
  { __typename?: 'Mutation' }
  & { sendTeacherSms?: Maybe<(
    { __typename?: 'SendTeacherSms' }
    & Pick<SendTeacherSms, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, message?: Maybe<(
      { __typename?: 'SmsMessageType' }
      & SmsMessageFieldsFragment
    )>, state?: Maybe<(
      { __typename?: 'TeacherSmsStateType' }
      & TeacherSmsStateFieldsFragment
    )> }
  )> }
);

export type LaunchGroupSmsMutationVariables = Exact<{
  groupId: Scalars['ID'];
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SmsLinkInput>;
  mode?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  requestKey?: Maybe<Scalars['String']>;
  studentIds?: Maybe<Array<Scalars['ID']>>;
}>;


export type LaunchGroupSmsMutation = (
  { __typename?: 'Mutation' }
  & { sendGroupSms?: Maybe<(
    { __typename?: 'SendGroupSms' }
    & Pick<SendGroupSms, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, campaign?: Maybe<(
      { __typename?: 'SmsCampaignType' }
      & SmsCampaignFieldsFragment
    )> }
  )> }
);

export type RepeatSmsCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type RepeatSmsCampaignMutation = (
  { __typename?: 'Mutation' }
  & { resendSmsCampaign?: Maybe<(
    { __typename?: 'ResendSmsCampaign' }
    & Pick<ResendSmsCampaign, 'success' | 'created'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, campaign?: Maybe<(
      { __typename?: 'SmsCampaignType' }
      & SmsCampaignFieldsFragment
    )> }
  )> }
);

export type RequeueSmsMessageMutationVariables = Exact<{
  messageId: Scalars['ID'];
}>;


export type RequeueSmsMessageMutation = (
  { __typename?: 'Mutation' }
  & { retrySmsMessage?: Maybe<(
    { __typename?: 'RetrySmsMessage' }
    & Pick<RetrySmsMessage, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, message?: Maybe<(
      { __typename?: 'SmsMessageType' }
      & SmsMessageFieldsFragment
    )> }
  )> }
);

export type WithdrawSmsMessageMutationVariables = Exact<{
  messageId: Scalars['ID'];
}>;


export type WithdrawSmsMessageMutation = (
  { __typename?: 'Mutation' }
  & { cancelSmsMessage?: Maybe<(
    { __typename?: 'CancelSmsMessage' }
    & Pick<CancelSmsMessage, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, message?: Maybe<(
      { __typename?: 'SmsMessageType' }
      & SmsMessageFieldsFragment
    )> }
  )> }
);

export type StoreSmsSettingsMutationVariables = Exact<{
  input: SmsSettingsInput;
}>;


export type StoreSmsSettingsMutation = (
  { __typename?: 'Mutation' }
  & { saveSmsSettings?: Maybe<(
    { __typename?: 'SaveSmsSettings' }
    & Pick<SaveSmsSettings, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, smsSettings?: Maybe<(
      { __typename?: 'SmsSettingsType' }
      & SmsSettingsFieldsFragment
    )> }
  )> }
);

export type StoreSmsTextsMutationVariables = Exact<{
  optOutSuffix: Scalars['String'];
}>;


export type StoreSmsTextsMutation = (
  { __typename?: 'Mutation' }
  & { saveSmsTexts?: Maybe<(
    { __typename?: 'SaveSmsTexts' }
    & Pick<SaveSmsTexts, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, smsSettings?: Maybe<(
      { __typename?: 'SmsSettingsType' }
      & SmsSettingsFieldsFragment
    )> }
  )> }
);

export type StoreLinkAddressesMutationVariables = Exact<{
  dofinFormUrl?: Maybe<Scalars['String']>;
  lmsBaseUrl?: Maybe<Scalars['String']>;
}>;


export type StoreLinkAddressesMutation = (
  { __typename?: 'Mutation' }
  & { saveLinkAddresses?: Maybe<(
    { __typename?: 'SaveLinkAddresses' }
    & Pick<SaveLinkAddresses, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, linkAddresses?: Maybe<(
      { __typename?: 'LinkAddressesType' }
      & LinkAddressesFieldsFragment
    )> }
  )> }
);

export type StoreSmsReminderPlanMutationVariables = Exact<{
  topic: Scalars['String'];
  enabled: Scalars['Boolean'];
  steps: Array<ReminderStepInput>;
}>;


export type StoreSmsReminderPlanMutation = (
  { __typename?: 'Mutation' }
  & { saveReminderPlan?: Maybe<(
    { __typename?: 'SaveReminderPlan' }
    & Pick<SaveReminderPlan, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, plan?: Maybe<(
      { __typename?: 'ReminderPlanType' }
      & SmsReminderPlanFieldsFragment
    )> }
  )> }
);

export type ProbeSmsConnectionMutationVariables = Exact<{
  to: Scalars['String'];
}>;


export type ProbeSmsConnectionMutation = (
  { __typename?: 'Mutation' }
  & { checkSmsConnection?: Maybe<(
    { __typename?: 'CheckSmsConnection' }
    & Pick<CheckSmsConnection, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, result?: Maybe<(
      { __typename?: 'SmsConnectionCheckType' }
      & SmsConnectionCheckFieldsFragment
    )>, status?: Maybe<(
      { __typename?: 'SmsProviderStatusType' }
      & SmsProviderStatusFieldsFragment
    )> }
  )> }
);

export type DispatchSmsTestMutationVariables = Exact<{
  to: Scalars['String'];
  text?: Maybe<Scalars['String']>;
}>;


export type DispatchSmsTestMutation = (
  { __typename?: 'Mutation' }
  & { sendSmsTest?: Maybe<(
    { __typename?: 'SendSmsTest' }
    & Pick<SendSmsTest, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, result?: Maybe<(
      { __typename?: 'SmsConnectionCheckType' }
      & SmsConnectionCheckFieldsFragment
    )> }
  )> }
);

export type AddAgreementMutationVariables = Exact<{
  agreementInput: CreateAgreementInput;
}>;


export type AddAgreementMutation = (
  { __typename?: 'Mutation' }
  & { createAgreement?: Maybe<(
    { __typename?: 'CreateAgreementMutation' }
    & Pick<CreateAgreementMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type EditStudentWithAgreementMutationVariables = Exact<{
  agreementId: Scalars['ID'];
  updateStudentInput: UpdateStudentInput;
}>;


export type EditStudentWithAgreementMutation = (
  { __typename?: 'Mutation' }
  & { updateStudentWithAgreement?: Maybe<(
    { __typename?: 'StudentWithAgreementUpdateMutation' }
    & Pick<StudentWithAgreementUpdateMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type AddRoleAndAgreementMutationVariables = Exact<{
  agreementInput: CreateAgreementInputBase;
  userId: Scalars['ID'];
}>;


export type AddRoleAndAgreementMutation = (
  { __typename?: 'Mutation' }
  & { appendStudentRoleAndAgreement?: Maybe<(
    { __typename?: 'AddRoleStudentAndAgreement' }
    & Pick<AddRoleStudentAndAgreement, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type AddStudentWithAgreementMutationVariables = Exact<{
  agreementInput: CreateAgreementInputBase;
  studentInput: StudentInput;
}>;


export type AddStudentWithAgreementMutation = (
  { __typename?: 'Mutation' }
  & { createStudentWithAgreement?: Maybe<(
    { __typename?: 'StudentWithAgreementCreateMutation' }
    & Pick<StudentWithAgreementCreateMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type RemovePaymentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemovePaymentMutation = (
  { __typename?: 'Mutation' }
  & { deletePayment?: Maybe<(
    { __typename?: 'DeletePaymentMutation' }
    & Pick<DeletePaymentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type MoveAgreementToGroupMutationVariables = Exact<{
  input: ChangeAgreementGroupInput;
}>;


export type MoveAgreementToGroupMutation = (
  { __typename?: 'Mutation' }
  & { changeAgreementGroup?: Maybe<(
    { __typename?: 'ChangeAgreementGroupMutation' }
    & Pick<ChangeAgreementGroupMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, oldAgreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'terminated' | 'terminatedDate'>
    )>, newAgreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'agreementTitle'>
      & { group: (
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name'>
      ) }
    )> }
  )> }
);

export type AttachContributionToPaymentMutationVariables = Exact<{
  input: LinkContributionInput;
}>;


export type AttachContributionToPaymentMutation = (
  { __typename?: 'Mutation' }
  & { linkContributionToPayment?: Maybe<(
    { __typename?: 'LinkContributionToPaymentMutation' }
    & Pick<LinkContributionToPaymentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, contribution?: Maybe<(
      { __typename?: 'ContributionType' }
      & Pick<ContributionType, 'id' | 'complete' | 'remainder'>
      & { payment?: Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<PaymentType, 'id' | 'date' | 'amountAgreement' | 'currency'>
        & { fakturowniaInvoice?: Maybe<(
          { __typename?: 'FakturowniaInvoiceType' }
          & Pick<FakturowniaInvoiceType, 'id' | 'number' | 'status'>
        )> }
      )> }
    )>, payment?: Maybe<(
      { __typename?: 'PaymentType' }
      & Pick<PaymentType, 'id'>
      & { contribution?: Maybe<(
        { __typename?: 'ContributionType' }
        & Pick<ContributionType, 'id'>
      )>, agreement: (
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id' | 'paidAmount'>
      ) }
    )> }
  )> }
);

export type ZeroContributionMutationVariables = Exact<{
  contributionId: Scalars['ID'];
}>;


export type ZeroContributionMutation = (
  { __typename?: 'Mutation' }
  & { zeroOutContribution?: Maybe<(
    { __typename?: 'ZeroOutContributionMutation' }
    & Pick<ZeroOutContributionMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, contribution?: Maybe<(
      { __typename?: 'ContributionType' }
      & Pick<ContributionType, 'id' | 'complete' | 'remainder'>
    )> }
  )> }
);

export type IssuePaymentCorrectionMutationVariables = Exact<{
  input: CreatePaymentCorrectionInput;
}>;


export type IssuePaymentCorrectionMutation = (
  { __typename?: 'Mutation' }
  & { createPaymentCorrection?: Maybe<(
    { __typename?: 'CreatePaymentCorrectionMutation' }
    & Pick<CreatePaymentCorrectionMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, correction?: Maybe<(
      { __typename?: 'PaymentCorrectionType' }
      & Pick<PaymentCorrectionType, 'id' | 'date' | 'amountForeign' | 'amountByn' | 'currency' | 'reason'>
      & { payment?: Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<PaymentType, 'id'>
      )> }
    )> }
  )> }
);

export type EditPaymentCorrectionMutationVariables = Exact<{
  input: UpdatePaymentCorrectionInput;
}>;


export type EditPaymentCorrectionMutation = (
  { __typename?: 'Mutation' }
  & { updatePaymentCorrection?: Maybe<(
    { __typename?: 'UpdatePaymentCorrectionMutation' }
    & Pick<UpdatePaymentCorrectionMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, correction?: Maybe<(
      { __typename?: 'PaymentCorrectionType' }
      & Pick<PaymentCorrectionType, 'id'>
    )> }
  )> }
);

export type RemovePaymentCorrectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemovePaymentCorrectionMutation = (
  { __typename?: 'Mutation' }
  & { deletePaymentCorrection?: Maybe<(
    { __typename?: 'DeletePaymentCorrectionMutation' }
    & Pick<DeletePaymentCorrectionMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type MarkAgreementTransferOutMutationVariables = Exact<{
  agreementId: Scalars['ID'];
  transferOut: Scalars['Boolean'];
}>;


export type MarkAgreementTransferOutMutation = (
  { __typename?: 'Mutation' }
  & { setAgreementTransferOut?: Maybe<(
    { __typename?: 'SetAgreementTransferOutMutation' }
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, agreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'transferOut'>
    )> }
  )> }
);

export type MarkAgreementFreeOfChargeMutationVariables = Exact<{
  agreementId: Scalars['ID'];
  freeOfCharge: Scalars['Boolean'];
}>;


export type MarkAgreementFreeOfChargeMutation = (
  { __typename?: 'Mutation' }
  & { setAgreementFreeOfCharge?: Maybe<(
    { __typename?: 'SetAgreementFreeOfChargeMutation' }
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, agreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'freeOfCharge' | 'statePrefinanced'>
    )> }
  )> }
);

export type MarkAgreementStatePrefinancedMutationVariables = Exact<{
  agreementId: Scalars['ID'];
  statePrefinanced: Scalars['Boolean'];
}>;


export type MarkAgreementStatePrefinancedMutation = (
  { __typename?: 'Mutation' }
  & { setAgreementStatePrefinanced?: Maybe<(
    { __typename?: 'SetAgreementStatePrefinancedMutation' }
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, agreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'freeOfCharge' | 'statePrefinanced'>
    )> }
  )> }
);

export type IssueLmsBlockMutationVariables = Exact<{
  studentId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  notifyStudent?: Maybe<Scalars['Boolean']>;
}>;


export type IssueLmsBlockMutation = (
  { __typename?: 'Mutation' }
  & { blockStudentLmsAccess?: Maybe<(
    { __typename?: 'BlockStudentLmsAccessMutation' }
    & Pick<BlockStudentLmsAccessMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, accessBlock?: Maybe<(
      { __typename?: 'StudentAccessBlockType' }
      & Pick<StudentAccessBlockType, 'id' | 'isBlocked' | 'reason' | 'overdueInvoiceCount' | 'maxOverdueDays' | 'source' | 'blockedAt' | 'blockedByName'>
    )> }
  )> }
);

export type LiftLmsBlockMutationVariables = Exact<{
  studentId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  notifyStudent?: Maybe<Scalars['Boolean']>;
}>;


export type LiftLmsBlockMutation = (
  { __typename?: 'Mutation' }
  & { unblockStudentLmsAccess?: Maybe<(
    { __typename?: 'UnblockStudentLmsAccessMutation' }
    & Pick<UnblockStudentLmsAccessMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, accessBlock?: Maybe<(
      { __typename?: 'StudentAccessBlockType' }
      & Pick<StudentAccessBlockType, 'id' | 'isBlocked' | 'manualOverride' | 'unblockedAt' | 'unblockedByName'>
    )> }
  )> }
);

export type AddNoteMutationVariables = Exact<{
  input: CreateStudentNoteInput;
}>;


export type AddNoteMutation = (
  { __typename?: 'Mutation' }
  & { createStudentNote?: Maybe<(
    { __typename?: 'CreateStudentNoteMutation' }
    & Pick<CreateStudentNoteMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, note?: Maybe<(
      { __typename?: 'StudentNoteType' }
      & Pick<StudentNoteType, 'id' | 'body' | 'sentiment' | 'pinned' | 'createdAt' | 'authorName'>
    )> }
  )> }
);

export type EditNoteMutationVariables = Exact<{
  input: UpdateStudentNoteInput;
}>;


export type EditNoteMutation = (
  { __typename?: 'Mutation' }
  & { updateStudentNote?: Maybe<(
    { __typename?: 'UpdateStudentNoteMutation' }
    & Pick<UpdateStudentNoteMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, note?: Maybe<(
      { __typename?: 'StudentNoteType' }
      & Pick<StudentNoteType, 'id' | 'body' | 'sentiment' | 'pinned'>
    )> }
  )> }
);

export type RemoveNoteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveNoteMutation = (
  { __typename?: 'Mutation' }
  & { deleteStudentNote?: Maybe<(
    { __typename?: 'DeleteStudentNoteMutation' }
    & Pick<DeleteStudentNoteMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'message'>
    )>>> }
  )> }
);

export type AddTaskMutationVariables = Exact<{
  input: CreateStaffTaskInput;
  files?: Maybe<Array<Maybe<Scalars['Upload']>>>;
}>;


export type AddTaskMutation = (
  { __typename?: 'Mutation' }
  & { createStaffTask?: Maybe<(
    { __typename?: 'CreateStaffTaskMutation' }
    & Pick<CreateStaffTaskMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'title' | 'description' | 'status' | 'priority' | 'startDate' | 'dueDate' | 'completedAt' | 'createdAt' | 'assigneeId' | 'assigneeName'>
    )> }
  )> }
);

export type EditTaskMutationVariables = Exact<{
  input: UpdateStaffTaskInput;
}>;


export type EditTaskMutation = (
  { __typename?: 'Mutation' }
  & { updateStaffTask?: Maybe<(
    { __typename?: 'UpdateStaffTaskMutation' }
    & Pick<UpdateStaffTaskMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'title' | 'description' | 'priority' | 'startDate' | 'dueDate' | 'updatedAt' | 'assigneeId' | 'assigneeName'>
      & { links: Array<(
        { __typename?: 'TaskLinkType' }
        & Pick<TaskLinkType, 'id' | 'kind' | 'objectId' | 'name' | 'hint' | 'missing' | 'href'>
      )> }
    )> }
  )> }
);

export type ChangeTaskStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type ChangeTaskStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateTaskStatus?: Maybe<(
    { __typename?: 'UpdateTaskStatusMutation' }
    & Pick<UpdateTaskStatusMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'status' | 'completedAt' | 'updatedAt'>
    )> }
  )> }
);

export type RemoveTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveTaskMutation = (
  { __typename?: 'Mutation' }
  & { deleteStaffTask?: Maybe<(
    { __typename?: 'DeleteStaffTaskMutation' }
    & Pick<DeleteStaffTaskMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'message'>
    )>>> }
  )> }
);

export type MoveTaskMutationVariables = Exact<{
  input: MoveStaffTaskInput;
}>;


export type MoveTaskMutation = (
  { __typename?: 'Mutation' }
  & { moveStaffTask?: Maybe<(
    { __typename?: 'MoveStaffTaskMutation' }
    & Pick<MoveStaffTaskMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'status' | 'startDate' | 'dueDate' | 'position' | 'completedAt' | 'updatedAt'>
    )> }
  )> }
);

export type MarkInstallmentPaidManuallyMutationVariables = Exact<{
  contributionId: Scalars['ID'];
  date: Scalars['Date'];
  amount?: Maybe<Scalars['Float']>;
}>;


export type MarkInstallmentPaidManuallyMutation = (
  { __typename?: 'Mutation' }
  & { markContributionPaidManually?: Maybe<(
    { __typename?: 'MarkContributionPaidManuallyMutation' }
    & Pick<MarkContributionPaidManuallyMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, contribution?: Maybe<(
      { __typename?: 'ContributionType' }
      & Pick<ContributionType, 'id' | 'status' | 'coveredAmount' | 'debt' | 'paidManually' | 'complete' | 'remainder'>
      & { payment?: Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<PaymentType, 'id' | 'date' | 'amountAgreement' | 'currency'>
      )> }
    )> }
  )> }
);

export type RevertInstallmentManualPaymentMutationVariables = Exact<{
  contributionId: Scalars['ID'];
}>;


export type RevertInstallmentManualPaymentMutation = (
  { __typename?: 'Mutation' }
  & { revertManualContributionPayment?: Maybe<(
    { __typename?: 'RevertManualContributionPaymentMutation' }
    & Pick<RevertManualContributionPaymentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, contribution?: Maybe<(
      { __typename?: 'ContributionType' }
      & Pick<ContributionType, 'id' | 'status' | 'coveredAmount' | 'debt' | 'paidManually' | 'complete' | 'remainder'>
      & { payment?: Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<PaymentType, 'id'>
      )> }
    )> }
  )> }
);

export type AddTaskLinksMutationVariables = Exact<{
  taskId: Scalars['ID'];
  links: Array<TaskLinkInput>;
}>;


export type AddTaskLinksMutation = (
  { __typename?: 'Mutation' }
  & { addStaffTaskLinks?: Maybe<(
    { __typename?: 'AddStaffTaskLinksMutation' }
    & Pick<AddStaffTaskLinksMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id'>
      & { links: Array<(
        { __typename?: 'TaskLinkType' }
        & Pick<TaskLinkType, 'id' | 'kind' | 'objectId' | 'name' | 'hint' | 'missing' | 'href'>
      )> }
    )> }
  )> }
);

export type RemoveTaskLinkMutationVariables = Exact<{
  linkId: Scalars['ID'];
}>;


export type RemoveTaskLinkMutation = (
  { __typename?: 'Mutation' }
  & { removeStaffTaskLink?: Maybe<(
    { __typename?: 'RemoveStaffTaskLinkMutation' }
    & Pick<RemoveStaffTaskLinkMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id'>
      & { links: Array<(
        { __typename?: 'TaskLinkType' }
        & Pick<TaskLinkType, 'id' | 'kind' | 'objectId' | 'name' | 'hint' | 'missing' | 'href'>
      )> }
    )> }
  )> }
);

export type AddTaskCommentMutationVariables = Exact<{
  taskId: Scalars['ID'];
  body?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Maybe<Scalars['Upload']>>>;
}>;


export type AddTaskCommentMutation = (
  { __typename?: 'Mutation' }
  & { addStaffTaskComment?: Maybe<(
    { __typename?: 'AddStaffTaskCommentMutation' }
    & Pick<AddStaffTaskCommentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, comment?: Maybe<(
      { __typename?: 'StaffTaskCommentType' }
      & Pick<StaffTaskCommentType, 'id' | 'body' | 'authorName' | 'createdAt' | 'editedAt' | 'canEdit'>
      & { attachments: Array<(
        { __typename?: 'StaffTaskAttachmentType' }
        & Pick<StaffTaskAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'isImage' | 'commentId' | 'uploadedByName' | 'createdAt' | 'canDelete'>
      )> }
    )>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'commentsCount' | 'attachmentsCount' | 'coverAttachmentId'>
      & { attachments: Array<(
        { __typename?: 'StaffTaskAttachmentType' }
        & Pick<StaffTaskAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'isImage' | 'commentId' | 'uploadedByName' | 'createdAt' | 'canDelete'>
      )> }
    )> }
  )> }
);

export type EditTaskCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  body: Scalars['String'];
}>;


export type EditTaskCommentMutation = (
  { __typename?: 'Mutation' }
  & { editStaffTaskComment?: Maybe<(
    { __typename?: 'EditStaffTaskCommentMutation' }
    & Pick<EditStaffTaskCommentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, comment?: Maybe<(
      { __typename?: 'StaffTaskCommentType' }
      & Pick<StaffTaskCommentType, 'id' | 'body' | 'authorName' | 'createdAt' | 'editedAt' | 'canEdit'>
    )> }
  )> }
);

export type RemoveTaskCommentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveTaskCommentMutation = (
  { __typename?: 'Mutation' }
  & { deleteStaffTaskComment?: Maybe<(
    { __typename?: 'DeleteStaffTaskCommentMutation' }
    & Pick<DeleteStaffTaskCommentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'commentsCount'>
    )> }
  )> }
);

export type AttachTaskFileMutationVariables = Exact<{
  taskId: Scalars['ID'];
  file: Scalars['Upload'];
  commentId?: Maybe<Scalars['ID']>;
}>;


export type AttachTaskFileMutation = (
  { __typename?: 'Mutation' }
  & { addStaffTaskAttachment?: Maybe<(
    { __typename?: 'AddStaffTaskAttachmentMutation' }
    & Pick<AddStaffTaskAttachmentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, attachment?: Maybe<(
      { __typename?: 'StaffTaskAttachmentType' }
      & Pick<StaffTaskAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'isImage' | 'commentId' | 'uploadedByName' | 'createdAt' | 'canDelete'>
    )>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'attachmentsCount' | 'coverAttachmentId'>
      & { attachments: Array<(
        { __typename?: 'StaffTaskAttachmentType' }
        & Pick<StaffTaskAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'isImage' | 'commentId' | 'uploadedByName' | 'createdAt' | 'canDelete'>
      )> }
    )> }
  )> }
);

export type DetachTaskFileMutationVariables = Exact<{
  attachmentId: Scalars['ID'];
}>;


export type DetachTaskFileMutation = (
  { __typename?: 'Mutation' }
  & { removeStaffTaskAttachment?: Maybe<(
    { __typename?: 'RemoveStaffTaskAttachmentMutation' }
    & Pick<RemoveStaffTaskAttachmentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, task?: Maybe<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'attachmentsCount' | 'coverAttachmentId'>
      & { attachments: Array<(
        { __typename?: 'StaffTaskAttachmentType' }
        & Pick<StaffTaskAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'isImage' | 'commentId' | 'uploadedByName' | 'createdAt' | 'canDelete'>
      )> }
    )> }
  )> }
);

export type SaveNewSurveyMutationVariables = Exact<{
  input: SurveyInput;
}>;


export type SaveNewSurveyMutation = (
  { __typename?: 'Mutation' }
  & { createSurvey?: Maybe<(
    { __typename?: 'CreateSurveyMutation' }
    & Pick<CreateSurveyMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, survey?: Maybe<(
      { __typename?: 'SurveyType' }
      & Pick<SurveyType, 'id'>
    )> }
  )> }
);

export type SaveExistingSurveyMutationVariables = Exact<{
  id: Scalars['ID'];
  input: SurveyInput;
}>;


export type SaveExistingSurveyMutation = (
  { __typename?: 'Mutation' }
  & { updateSurvey?: Maybe<(
    { __typename?: 'UpdateSurveyMutation' }
    & Pick<UpdateSurveyMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, survey?: Maybe<(
      { __typename?: 'SurveyType' }
      & Pick<SurveyType, 'id'>
    )> }
  )> }
);

export type ToggleSurveyArchiveMutationVariables = Exact<{
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
}>;


export type ToggleSurveyArchiveMutation = (
  { __typename?: 'Mutation' }
  & { archiveSurvey?: Maybe<(
    { __typename?: 'ArchiveSurveyMutation' }
    & Pick<ArchiveSurveyMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, survey?: Maybe<(
      { __typename?: 'SurveyType' }
      & Pick<SurveyType, 'id' | 'isArchived'>
    )> }
  )> }
);

export type CloneSurveyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CloneSurveyMutation = (
  { __typename?: 'Mutation' }
  & { duplicateSurvey?: Maybe<(
    { __typename?: 'DuplicateSurveyMutation' }
    & Pick<DuplicateSurveyMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, survey?: Maybe<(
      { __typename?: 'SurveyType' }
      & Pick<SurveyType, 'id'>
    )> }
  )> }
);

export type AttachSurveyToGroupMutationVariables = Exact<{
  surveyId: Scalars['ID'];
  groupId: Scalars['ID'];
  triggerLessonId: Scalars['ID'];
}>;


export type AttachSurveyToGroupMutation = (
  { __typename?: 'Mutation' }
  & { assignSurveyToGroup?: Maybe<(
    { __typename?: 'AssignSurveyToGroupMutation' }
    & Pick<AssignSurveyToGroupMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, assignment?: Maybe<(
      { __typename?: 'SurveyAssignmentType' }
      & Pick<SurveyAssignmentType, 'id'>
    )> }
  )> }
);

export type EditSurveyAssignmentMutationVariables = Exact<{
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  triggerLessonId?: Maybe<Scalars['ID']>;
}>;


export type EditSurveyAssignmentMutation = (
  { __typename?: 'Mutation' }
  & { updateSurveyAssignment?: Maybe<(
    { __typename?: 'UpdateSurveyAssignmentMutation' }
    & Pick<UpdateSurveyAssignmentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, assignment?: Maybe<(
      { __typename?: 'SurveyAssignmentType' }
      & Pick<SurveyAssignmentType, 'id' | 'isActive'>
    )> }
  )> }
);

export type RemoveSurveyAssignmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveSurveyAssignmentMutation = (
  { __typename?: 'Mutation' }
  & { deleteSurveyAssignment?: Maybe<(
    { __typename?: 'DeleteSurveyAssignmentMutation' }
    & Pick<DeleteSurveyAssignmentMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type SaveSurveyTargetingMutationVariables = Exact<{
  surveyId: Scalars['ID'];
  plans: Array<SurveyPlanInput>;
}>;


export type SaveSurveyTargetingMutation = (
  { __typename?: 'Mutation' }
  & { setSurveyTargeting?: Maybe<(
    { __typename?: 'SetSurveyTargetingMutation' }
    & Pick<SetSurveyTargetingMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, targeting?: Maybe<(
      { __typename?: 'SurveyTargetingType' }
      & Pick<SurveyTargetingType, 'assignmentsCreated' | 'assignmentsAdopted' | 'assignmentsDeactivated' | 'assignmentsDeleted'>
      & { skipped: Array<(
        { __typename?: 'SurveyTargetingSkipType' }
        & Pick<SurveyTargetingSkipType, 'groupId' | 'groupName' | 'reason'>
      )>, plans: Array<(
        { __typename?: 'SurveyPlanType' }
        & Pick<SurveyPlanType, 'id' | 'scope' | 'courseId' | 'courseName' | 'onlyActiveGroups' | 'triggerKind' | 'triggerLessonNumber' | 'skipPastLessons' | 'isActive' | 'assignmentsCount' | 'respondedCount' | 'hasResponses'>
        & { groups: Array<(
          { __typename?: 'SurveyPlanGroupRefType' }
          & Pick<SurveyPlanGroupRefType, 'groupId' | 'groupName'>
        )> }
      )> }
    )> }
  )> }
);

export type AttachSurveyToGroupsMutationVariables = Exact<{
  surveyId: Scalars['ID'];
  groupIds: Array<Scalars['ID']>;
  triggerKind: Scalars['String'];
  triggerLessonNumber?: Maybe<Scalars['Int']>;
}>;


export type AttachSurveyToGroupsMutation = (
  { __typename?: 'Mutation' }
  & { assignSurveyToGroups?: Maybe<(
    { __typename?: 'AssignSurveyToGroupsMutation' }
    & Pick<AssignSurveyToGroupsMutation, 'success' | 'createdCount'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, skipped?: Maybe<Array<(
      { __typename?: 'SurveyTargetingSkipType' }
      & Pick<SurveyTargetingSkipType, 'groupId' | 'groupName' | 'reason'>
    )>> }
  )> }
);

export type SaveQuestionMetricsMutationVariables = Exact<{
  items: Array<QuestionMetricInput>;
}>;


export type SaveQuestionMetricsMutation = (
  { __typename?: 'Mutation' }
  & { setQuestionMetrics?: Maybe<(
    { __typename?: 'SetQuestionMetricsMutation' }
    & Pick<SetQuestionMetricsMutation, 'success' | 'changedCount'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type RequestSurveyDigestMutationVariables = Exact<{
  scope: Scalars['String'];
  scopeId: Scalars['ID'];
}>;


export type RequestSurveyDigestMutation = (
  { __typename?: 'Mutation' }
  & { generateSurveyDigest?: Maybe<(
    { __typename?: 'SurveyDigestType' }
    & Pick<SurveyDigestType, 'id' | 'scope' | 'scopeId' | 'status' | 'textRu' | 'textPl' | 'model' | 'error' | 'createdAt' | 'finishedAt' | 'byName'>
  )> }
);

export type RunInterviewAnalysisMutationVariables = Exact<{
  interviewId: Scalars['ID'];
}>;


export type RunInterviewAnalysisMutation = (
  { __typename?: 'Mutation' }
  & { runTeacherInterviewAnalysis?: Maybe<(
    { __typename?: 'RunTeacherInterviewAnalysis' }
    & Pick<RunTeacherInterviewAnalysis, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, run?: Maybe<(
      { __typename?: 'TeacherAiRunType' }
      & Pick<TeacherAiRunType, 'id' | 'sourceKind' | 'status'>
    )> }
  )> }
);

export type RecomputeAiProfileMutationVariables = Exact<{
  teacherId: Scalars['ID'];
}>;


export type RecomputeAiProfileMutation = (
  { __typename?: 'Mutation' }
  & { recomputeTeacherAiProfile?: Maybe<(
    { __typename?: 'RecomputeTeacherAiProfile' }
    & Pick<RecomputeTeacherAiProfile, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, profile?: Maybe<(
      { __typename?: 'TeacherAiProfileType' }
      & Pick<TeacherAiProfileType, 'teacherId' | 'status'>
    )> }
  )> }
);

export type ApplyCourseSuggestionsMutationVariables = Exact<{
  teacherId: Scalars['ID'];
  suggestionIds: Array<Scalars['ID']>;
  action: Scalars['String'];
}>;


export type ApplyCourseSuggestionsMutation = (
  { __typename?: 'Mutation' }
  & { applyTeacherCourseSuggestions?: Maybe<(
    { __typename?: 'ApplyTeacherCourseSuggestions' }
    & Pick<ApplyTeacherCourseSuggestions, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, result?: Maybe<(
      { __typename?: 'ApplySuggestionsResultType' }
      & Pick<ApplySuggestionsResultType, 'accepted' | 'rejected'>
    )> }
  )> }
);

export type AddTeacherBillingEntityMutationVariables = Exact<{
  teacherId: Scalars['ID'];
  input: TeacherBillingEntityInput;
}>;


export type AddTeacherBillingEntityMutation = (
  { __typename?: 'Mutation' }
  & { createTeacherBillingEntity?: Maybe<(
    { __typename?: 'CreateTeacherBillingEntity' }
    & Pick<CreateTeacherBillingEntity, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, billingEntity?: Maybe<(
      { __typename?: 'TeacherBillingEntityType' }
      & Pick<TeacherBillingEntityType, 'id' | 'teacherId' | 'kind' | 'legalName' | 'nip' | 'vatMode' | 'vatRate' | 'isDefault' | 'isActive' | 'createdAt' | 'updatedAt'>
    )> }
  )> }
);

export type EditTeacherBillingEntityMutationVariables = Exact<{
  id: Scalars['ID'];
  input: TeacherBillingEntityInput;
}>;


export type EditTeacherBillingEntityMutation = (
  { __typename?: 'Mutation' }
  & { updateTeacherBillingEntity?: Maybe<(
    { __typename?: 'UpdateTeacherBillingEntity' }
    & Pick<UpdateTeacherBillingEntity, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, billingEntity?: Maybe<(
      { __typename?: 'TeacherBillingEntityType' }
      & Pick<TeacherBillingEntityType, 'id' | 'teacherId' | 'kind' | 'legalName' | 'nip' | 'vatMode' | 'vatRate' | 'isDefault' | 'isActive' | 'createdAt' | 'updatedAt'>
    )> }
  )> }
);

export type MakeDefaultTeacherBillingEntityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MakeDefaultTeacherBillingEntityMutation = (
  { __typename?: 'Mutation' }
  & { setDefaultTeacherBillingEntity?: Maybe<(
    { __typename?: 'SetDefaultTeacherBillingEntity' }
    & Pick<SetDefaultTeacherBillingEntity, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, billingEntity?: Maybe<(
      { __typename?: 'TeacherBillingEntityType' }
      & Pick<TeacherBillingEntityType, 'id' | 'isDefault'>
    )> }
  )> }
);

export type StoreApplicationFinanceTermsMutationVariables = Exact<{
  applicationId: Scalars['ID'];
  rateUnit?: Maybe<Scalars['String']>;
  rateIsGross?: Maybe<Scalars['Boolean']>;
  billingEntityId?: Maybe<Scalars['ID']>;
  clearBillingEntity?: Maybe<Scalars['Boolean']>;
  servicePrice?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
}>;


export type StoreApplicationFinanceTermsMutation = (
  { __typename?: 'Mutation' }
  & { setApplicationFinanceTerms?: Maybe<(
    { __typename?: 'SetApplicationFinanceTerms' }
    & Pick<SetApplicationFinanceTerms, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, application?: Maybe<(
      { __typename?: 'ApplicationType' }
      & Pick<ApplicationType, 'id' | 'servicePrice' | 'currency' | 'rateUnit' | 'rateIsGross' | 'termsMissing'>
      & { billingEntity?: Maybe<(
        { __typename?: 'TeacherBillingEntityType' }
        & Pick<TeacherBillingEntityType, 'id' | 'teacherId' | 'kind' | 'legalName' | 'nip' | 'vatMode' | 'vatRate' | 'isDefault' | 'isActive' | 'createdAt' | 'updatedAt'>
      )> }
    )> }
  )> }
);

export type DocumentFieldsFragment = (
  { __typename?: 'TeacherDocumentType' }
  & Pick<TeacherDocumentType, 'id' | 'kind' | 'version' | 'originalName' | 'contentType' | 'sizeBytes' | 'extractionStatus' | 'hasText' | 'textChars' | 'isCurrent' | 'uploadedAt'>
);

export type UploadTeacherDocumentMutationVariables = Exact<{
  teacherId: Scalars['ID'];
  file: Scalars['Upload'];
  kind?: Maybe<Scalars['String']>;
}>;


export type UploadTeacherDocumentMutation = (
  { __typename?: 'Mutation' }
  & { uploadTeacherDocument?: Maybe<(
    { __typename?: 'UploadTeacherDocument' }
    & Pick<UploadTeacherDocument, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, document?: Maybe<(
      { __typename?: 'TeacherDocumentType' }
      & DocumentFieldsFragment
    )> }
  )> }
);

export type SaveDocumentTextMutationVariables = Exact<{
  documentId: Scalars['ID'];
  text: Scalars['String'];
}>;


export type SaveDocumentTextMutation = (
  { __typename?: 'Mutation' }
  & { setTeacherDocumentText?: Maybe<(
    { __typename?: 'SetTeacherDocumentText' }
    & Pick<SetTeacherDocumentText, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, document?: Maybe<(
      { __typename?: 'TeacherDocumentType' }
      & DocumentFieldsFragment
    )> }
  )> }
);

export type RemoveTeacherDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type RemoveTeacherDocumentMutation = (
  { __typename?: 'Mutation' }
  & { deleteTeacherDocument?: Maybe<(
    { __typename?: 'DeleteTeacherDocument' }
    & Pick<DeleteTeacherDocument, 'success' | 'teacherId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type RunDocumentAnalysisMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type RunDocumentAnalysisMutation = (
  { __typename?: 'Mutation' }
  & { runTeacherDocumentAnalysis?: Maybe<(
    { __typename?: 'RunTeacherDocumentAnalysis' }
    & Pick<RunTeacherDocumentAnalysis, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, run?: Maybe<(
      { __typename?: 'TeacherAiRunType' }
      & Pick<TeacherAiRunType, 'id' | 'sourceKind' | 'status' | 'documentId'>
    )> }
  )> }
);

export type InterviewFieldsFragment = (
  { __typename?: 'TeacherInterviewType' }
  & Pick<TeacherInterviewType, 'id' | 'source' | 'title' | 'recordedAt' | 'durationMinutes' | 'status' | 'errorMessage' | 'externalUrl' | 'hasVideo' | 'sizeBytes' | 'hasTranscript' | 'transcriptSource' | 'transcriptChars' | 'zoomRecordingId' | 'zoomTopic'>
);

export type AttachInterviewFromZoomMutationVariables = Exact<{
  teacherId: Scalars['ID'];
  zoomRecordingId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
}>;


export type AttachInterviewFromZoomMutation = (
  { __typename?: 'Mutation' }
  & { attachTeacherInterviewZoom?: Maybe<(
    { __typename?: 'AttachTeacherInterviewZoom' }
    & Pick<AttachTeacherInterviewZoom, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, interview?: Maybe<(
      { __typename?: 'TeacherInterviewType' }
      & InterviewFieldsFragment
    )> }
  )> }
);

export type AttachInterviewLinkMutationVariables = Exact<{
  teacherId: Scalars['ID'];
  url: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  recordedAt?: Maybe<Scalars['DateTime']>;
}>;


export type AttachInterviewLinkMutation = (
  { __typename?: 'Mutation' }
  & { attachTeacherInterviewLink?: Maybe<(
    { __typename?: 'AttachTeacherInterviewLink' }
    & Pick<AttachTeacherInterviewLink, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, interview?: Maybe<(
      { __typename?: 'TeacherInterviewType' }
      & InterviewFieldsFragment
    )> }
  )> }
);

export type UploadInterviewVideoMutationVariables = Exact<{
  teacherId: Scalars['ID'];
  file: Scalars['Upload'];
  title?: Maybe<Scalars['String']>;
  recordedAt?: Maybe<Scalars['DateTime']>;
}>;


export type UploadInterviewVideoMutation = (
  { __typename?: 'Mutation' }
  & { uploadTeacherInterviewVideo?: Maybe<(
    { __typename?: 'UploadTeacherInterviewVideo' }
    & Pick<UploadTeacherInterviewVideo, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, interview?: Maybe<(
      { __typename?: 'TeacherInterviewType' }
      & InterviewFieldsFragment
    )> }
  )> }
);

export type SaveInterviewTranscriptMutationVariables = Exact<{
  interviewId: Scalars['ID'];
  text: Scalars['String'];
}>;


export type SaveInterviewTranscriptMutation = (
  { __typename?: 'Mutation' }
  & { setTeacherInterviewTranscript?: Maybe<(
    { __typename?: 'SetTeacherInterviewTranscript' }
    & Pick<SetTeacherInterviewTranscript, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, interview?: Maybe<(
      { __typename?: 'TeacherInterviewType' }
      & InterviewFieldsFragment
    )> }
  )> }
);

export type RetryInterviewDownloadMutationVariables = Exact<{
  interviewId: Scalars['ID'];
}>;


export type RetryInterviewDownloadMutation = (
  { __typename?: 'Mutation' }
  & { retryTeacherInterviewDownload?: Maybe<(
    { __typename?: 'RetryTeacherInterviewDownload' }
    & Pick<RetryTeacherInterviewDownload, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, interview?: Maybe<(
      { __typename?: 'TeacherInterviewType' }
      & InterviewFieldsFragment
    )> }
  )> }
);

export type RemoveInterviewMutationVariables = Exact<{
  interviewId: Scalars['ID'];
}>;


export type RemoveInterviewMutation = (
  { __typename?: 'Mutation' }
  & { deleteTeacherInterview?: Maybe<(
    { __typename?: 'DeleteTeacherInterview' }
    & Pick<DeleteTeacherInterview, 'success' | 'teacherId'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>> }
  )> }
);

export type RefreshInterviewZoomMutationVariables = Exact<{
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
}>;


export type RefreshInterviewZoomMutation = (
  { __typename?: 'Mutation' }
  & { refreshInterviewZoomRecordings?: Maybe<(
    { __typename?: 'RefreshInterviewZoomRecordings' }
    & Pick<RefreshInterviewZoomRecordings, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'code' | 'field' | 'message'>
    )>>>, result?: Maybe<(
      { __typename?: 'InterviewZoomRefreshType' }
      & Pick<InterviewZoomRefreshType, 'created' | 'updated' | 'skippedNoAccount' | 'skippedProcessing' | 'accountsSynced' | 'cooldown'>
    )> }
  )> }
);

export type AddUniqueTeacherMutationVariables = Exact<{
  application: ApplicationInputType;
  employmentTypes: EmploymentInputType;
  teacher: NewTeacherInput;
}>;


export type AddUniqueTeacherMutation = (
  { __typename?: 'Mutation' }
  & { createUniqueTeacher?: Maybe<(
    { __typename?: 'CreateUniqueTeacher' }
    & Pick<CreateUniqueTeacher, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type AddTeacherStandaloneMutationVariables = Exact<{
  teacher: NewTeacherInput;
}>;


export type AddTeacherStandaloneMutation = (
  { __typename?: 'Mutation' }
  & { createTeacher?: Maybe<(
    { __typename?: 'CreateTeacher' }
    & Pick<CreateTeacher, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, teacher?: Maybe<(
      { __typename?: 'TeacherType' }
      & Pick<TeacherType, 'id' | 'fullName'>
    )> }
  )> }
);

export type AddNewTeacherRoleMutationVariables = Exact<{
  application: ApplicationInputType;
  employmentTypes: EmploymentInputType;
  siteDisplay?: Maybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
}>;


export type AddNewTeacherRoleMutation = (
  { __typename?: 'Mutation' }
  & { addTeacherRole?: Maybe<(
    { __typename?: 'AddNewRoleTeacher' }
    & Pick<AddNewRoleTeacher, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type AddTeacherExistMutationVariables = Exact<{
  application: ApplicationInputType;
  employmentTypes: ExistEmploymentInputType;
  teacherId: Scalars['ID'];
}>;


export type AddTeacherExistMutation = (
  { __typename?: 'Mutation' }
  & { addTeacherExist?: Maybe<(
    { __typename?: 'AddTeacherExist' }
    & Pick<AddTeacherExist, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, application?: Maybe<(
      { __typename?: 'ApplicationType' }
      & Pick<ApplicationType, 'id'>
    )> }
  )> }
);

export type EditTeacherWithTypeMutationVariables = Exact<{
  employmentInput: ExistEmploymentInputType;
  teacherId?: Maybe<Scalars['ID']>;
  teacherInput: TeacherWithTypeInput;
}>;


export type EditTeacherWithTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateTeacherWithType?: Maybe<(
    { __typename?: 'UpdateTeacherWithTypeMutation' }
    & Pick<UpdateTeacherWithTypeMutation, 'success' | 'errors'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type SaveTeacherProfileMutationVariables = Exact<{
  teacherId: Scalars['ID'];
  rating?: Maybe<Scalars['Int']>;
  internalNote?: Maybe<Scalars['String']>;
  interviewRecording?: Maybe<Scalars['String']>;
  coursesCanTeachIds?: Maybe<Array<Scalars['ID']>>;
}>;


export type SaveTeacherProfileMutation = (
  { __typename?: 'Mutation' }
  & { setTeacherProfile?: Maybe<(
    { __typename?: 'SetTeacherProfile' }
    & Pick<SetTeacherProfile, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, teacher?: Maybe<(
      { __typename?: 'TeacherType' }
      & Pick<TeacherType, 'id' | 'rating' | 'internalNote' | 'interviewRecording'>
      & { coursesCanTeach?: Maybe<Array<(
        { __typename?: 'TeacherCourseRef' }
        & Pick<TeacherCourseRef, 'id' | 'name'>
      )>> }
    )> }
  )> }
);

export type CreateUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName: Scalars['String'];
  email: Scalars['String'];
  roles: Scalars['String'];
  phone: Scalars['String'];
  workspaceEmail?: Maybe<Scalars['String']>;
}>;


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createUser?: Maybe<(
    { __typename?: 'RegisterMutation' }
    & Pick<RegisterMutation, 'success' | 'errors'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type UpdateUserSettingsMutationVariables = Exact<{
  pk: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName: Scalars['String'];
  email: Scalars['String'];
  roles: Scalars['String'];
  phone: Scalars['String'];
}>;


export type UpdateUserSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateUserSettings?: Maybe<(
    { __typename?: 'UserSettingsUpdateMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserNode' }
      & Pick<UserNode, 'id'>
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type DeleteUserMutationVariables = Exact<{
  pk: Scalars['ID'];
}>;


export type DeleteUserMutation = (
  { __typename?: 'Mutation' }
  & { deleteUserSettings?: Maybe<(
    { __typename?: 'UserSettingsDeleteMutation' }
    & Pick<UserSettingsDeleteMutation, 'success' | 'errors'>
  )> }
);

export type AddUserRolesMutationVariables = Exact<{
  roles: Scalars['String'];
  userId: Scalars['ID'];
}>;


export type AddUserRolesMutation = (
  { __typename?: 'Mutation' }
  & { appendRolesUserSettings?: Maybe<(
    { __typename?: 'UserSettingsRolesAddMutation' }
    & { user?: Maybe<(
      { __typename?: 'CustomUserType' }
      & Pick<CustomUserType, 'id'>
    )> }
  )> }
);

export type LinkStaffMailboxMutationVariables = Exact<{
  userId: Scalars['ID'];
  email: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
}>;


export type LinkStaffMailboxMutation = (
  { __typename?: 'Mutation' }
  & { setStaffMailbox?: Maybe<(
    { __typename?: 'SetStaffMailboxMutation' }
    & Pick<SetStaffMailboxMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, mailbox?: Maybe<(
      { __typename?: 'StaffMailboxType' }
      & Pick<StaffMailboxType, 'email' | 'displayName' | 'enabled' | 'scope'>
    )> }
  )> }
);

export type ProbeStaffMailboxMutationVariables = Exact<{
  userId?: Maybe<Scalars['ID']>;
}>;


export type ProbeStaffMailboxMutation = (
  { __typename?: 'Mutation' }
  & { checkStaffMailbox?: Maybe<(
    { __typename?: 'CheckStaffMailboxMutation' }
    & Pick<CheckStaffMailboxMutation, 'success' | 'ok' | 'code' | 'message'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type ZoomSyncAccountsMutationVariables = Exact<{ [key: string]: never; }>;


export type ZoomSyncAccountsMutation = (
  { __typename?: 'Mutation' }
  & { syncZoomAccounts?: Maybe<(
    { __typename?: 'SyncZoomAccountsMutation' }
    & Pick<SyncZoomAccountsMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomSyncRecordingsMutationVariables = Exact<{
  date: Scalars['Date'];
}>;


export type ZoomSyncRecordingsMutation = (
  { __typename?: 'Mutation' }
  & { syncZoomRecordings?: Maybe<(
    { __typename?: 'SyncZoomRecordingsMutation' }
    & Pick<SyncZoomRecordingsMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomRefreshAllMutationVariables = Exact<{
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
}>;


export type ZoomRefreshAllMutation = (
  { __typename?: 'Mutation' }
  & { refreshAllZoomData?: Maybe<(
    { __typename?: 'RefreshAllZoomDataMutation' }
    & Pick<RefreshAllZoomDataMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomSyncAllRecordingsMutationVariables = Exact<{
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
}>;


export type ZoomSyncAllRecordingsMutation = (
  { __typename?: 'Mutation' }
  & { syncAllZoomRecordings?: Maybe<(
    { __typename?: 'SyncAllZoomRecordingsMutation' }
    & Pick<SyncAllZoomRecordingsMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomSyncUsageMutationVariables = Exact<{ [key: string]: never; }>;


export type ZoomSyncUsageMutation = (
  { __typename?: 'Mutation' }
  & { syncZoomUsage?: Maybe<(
    { __typename?: 'SyncZoomUsageMutation' }
    & Pick<SyncZoomUsageMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomRunAutoMatchingMutationVariables = Exact<{
  date: Scalars['Date'];
}>;


export type ZoomRunAutoMatchingMutation = (
  { __typename?: 'Mutation' }
  & { runAutoMatching?: Maybe<(
    { __typename?: 'RunAutoMatchingMutation' }
    & Pick<RunAutoMatchingMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomSetGroupAccountMutationVariables = Exact<{
  groupId: Scalars['ID'];
  zoomAccountId?: Maybe<Scalars['ID']>;
}>;


export type ZoomSetGroupAccountMutation = (
  { __typename?: 'Mutation' }
  & { setGroupZoomAccount?: Maybe<(
    { __typename?: 'SetGroupZoomAccountMutation' }
    & Pick<SetGroupZoomAccountMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomSetGroupScheduleMutationVariables = Exact<{
  groupId: Scalars['ID'];
  zoomAccountId?: Maybe<Scalars['ID']>;
  slots: Array<GroupZoomScheduleSlotInput>;
}>;


export type ZoomSetGroupScheduleMutation = (
  { __typename?: 'Mutation' }
  & { setGroupZoomSchedule?: Maybe<(
    { __typename?: 'SetGroupZoomScheduleMutation' }
    & Pick<SetGroupZoomScheduleMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, schedules?: Maybe<Array<Maybe<(
      { __typename?: 'GroupZoomScheduleType' }
      & GroupZoomScheduleFieldsFragment
    )>>> }
  )> }
);

export type ZoomCreateManualMatchMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  zoomRecordingId: Scalars['ID'];
}>;


export type ZoomCreateManualMatchMutation = (
  { __typename?: 'Mutation' }
  & { createManualLessonRecording?: Maybe<(
    { __typename?: 'CreateManualLessonRecordingMutation' }
    & Pick<CreateManualLessonRecordingMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, lessonRecording?: Maybe<(
      { __typename?: 'LessonRecordingType' }
      & Pick<LessonRecordingType, 'id' | 'status'>
    )> }
  )> }
);

export type ZoomUnlinkRecordingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ZoomUnlinkRecordingMutation = (
  { __typename?: 'Mutation' }
  & { unlinkLessonRecording?: Maybe<(
    { __typename?: 'UnlinkLessonRecordingMutation' }
    & Pick<UnlinkLessonRecordingMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomMarkMissingMutationVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type ZoomMarkMissingMutation = (
  { __typename?: 'Mutation' }
  & { markLessonMissingRecording?: Maybe<(
    { __typename?: 'MarkLessonMissingRecordingMutation' }
    & Pick<MarkLessonMissingRecordingMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomRetryRecordingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ZoomRetryRecordingMutation = (
  { __typename?: 'Mutation' }
  & { retryLessonRecording?: Maybe<(
    { __typename?: 'RetryLessonRecordingMutation' }
    & Pick<RetryLessonRecordingMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomReprocessAiMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ZoomReprocessAiMutation = (
  { __typename?: 'Mutation' }
  & { reprocessAi?: Maybe<(
    { __typename?: 'ReprocessAiMutation' }
    & Pick<ReprocessAiMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomDeleteRecordingMutationVariables = Exact<{
  id: Scalars['ID'];
  confirm: Scalars['String'];
}>;


export type ZoomDeleteRecordingMutation = (
  { __typename?: 'Mutation' }
  & { deleteZoomRecording?: Maybe<(
    { __typename?: 'DeleteZoomRecordingMutation' }
    & Pick<DeleteZoomRecordingMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, zoomRecording?: Maybe<(
      { __typename?: 'ZoomRecordingType' }
      & Pick<ZoomRecordingType, 'id' | 'pk' | 'deletedFromZoom' | 'deletedAt'>
    )> }
  )> }
);

export type ZoomDeleteRecordingsMutationVariables = Exact<{
  ids: Array<Scalars['ID']>;
  confirm: Scalars['Boolean'];
}>;


export type ZoomDeleteRecordingsMutation = (
  { __typename?: 'Mutation' }
  & { deleteZoomRecordings?: Maybe<(
    { __typename?: 'DeleteZoomRecordingsMutation' }
    & Pick<DeleteZoomRecordingsMutation, 'success' | 'queued' | 'skipped'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, rows: Array<(
      { __typename?: 'ZoomBulkDeleteRowType' }
      & Pick<ZoomBulkDeleteRowType, 'id' | 'queued' | 'reason'>
    )> }
  )> }
);

export type ZoomTriggerGroupProcessMutationVariables = Exact<{
  groupId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
}>;


export type ZoomTriggerGroupProcessMutation = (
  { __typename?: 'Mutation' }
  & { triggerZoomGroupProcess?: Maybe<(
    { __typename?: 'TriggerZoomGroupProcessMutation' }
    & Pick<TriggerZoomGroupProcessMutation, 'success' | 'enqueued' | 'queuedCount' | 'message'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type ZoomSendMorningReportMutationVariables = Exact<{
  date?: Maybe<Scalars['Date']>;
}>;


export type ZoomSendMorningReportMutation = (
  { __typename?: 'Mutation' }
  & { sendMorningReport?: Maybe<(
    { __typename?: 'SendMorningReportMutation' }
    & Pick<SendMorningReportMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type QueueZoomParticipantsSyncMutationVariables = Exact<{
  groupId: Scalars['ID'];
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  force?: Maybe<Scalars['Boolean']>;
}>;


export type QueueZoomParticipantsSyncMutation = (
  { __typename?: 'Mutation' }
  & { requestZoomParticipantsSync?: Maybe<(
    { __typename?: 'RequestZoomParticipantsSyncMutation' }
    & Pick<RequestZoomParticipantsSyncMutation, 'success' | 'queued'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type ResolveZoomParticipantMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
  ignore?: Maybe<Scalars['Boolean']>;
  remember?: Maybe<Scalars['Boolean']>;
}>;


export type ResolveZoomParticipantMutation = (
  { __typename?: 'Mutation' }
  & { matchZoomParticipant?: Maybe<(
    { __typename?: 'MatchZoomParticipantMutation' }
    & Pick<MatchZoomParticipantMutation, 'success' | 'aliasCreated'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, sessions?: Maybe<Array<(
      { __typename?: 'ZoomParticipantSessionType' }
      & Pick<ZoomParticipantSessionType, 'id' | 'instanceId' | 'name' | 'email' | 'joinTime' | 'leaveTime' | 'durationSeconds' | 'status' | 'failover' | 'identityKey' | 'matchStatus' | 'matchRule' | 'offRoster' | 'matchedUserId' | 'matchedUserName' | 'matchedStudentId' | 'matchedByName' | 'matchedAt'>
    )>> }
  )> }
);

export type AttachZoomInstanceToLessonMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  instanceUuid?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['String']>;
}>;


export type AttachZoomInstanceToLessonMutation = (
  { __typename?: 'Mutation' }
  & { linkZoomInstanceToLesson?: Maybe<(
    { __typename?: 'LinkZoomInstanceToLessonMutation' }
    & Pick<LinkZoomInstanceToLessonMutation, 'success' | 'queued'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>>, instances?: Maybe<Array<(
      { __typename?: 'ZoomMeetingInstanceType' }
      & Pick<ZoomMeetingInstanceType, 'id' | 'uuid' | 'meetingId' | 'topic' | 'startTime' | 'endTime' | 'durationMinutes' | 'participantsCount' | 'lessonId' | 'lessonRule' | 'lessonAmbiguous' | 'lessonLocked' | 'participantsStatus' | 'participantsFetchedAt' | 'participantsError'>
    )>> }
  )> }
);

export type DetachZoomInstanceMutationVariables = Exact<{
  instanceId: Scalars['ID'];
}>;


export type DetachZoomInstanceMutation = (
  { __typename?: 'Mutation' }
  & { unlinkZoomInstance?: Maybe<(
    { __typename?: 'UnlinkZoomInstanceMutation' }
    & Pick<UnlinkZoomInstanceMutation, 'success'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  )> }
);

export type AgreementCorrectionPrecheckQueryVariables = Exact<{
  agreementId: Scalars['ID'];
  targetGroupId?: Maybe<Scalars['ID']>;
}>;


export type AgreementCorrectionPrecheckQuery = (
  { __typename?: 'Query' }
  & { agreementCorrectionCheck?: Maybe<(
    { __typename?: 'AgreementCorrectionCheckType' }
    & Pick<AgreementCorrectionCheckType, 'canCorrect' | 'canUndo' | 'correctBlockers' | 'undoBlockers' | 'warnings' | 'undoDeadline'>
  )> }
);

export type ErpAiAgentOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpAiAgentOverviewQuery = (
  { __typename?: 'Query' }
  & { aiAgentOverview: (
    { __typename?: 'AiAgentOverviewType' }
    & Pick<AiAgentOverviewType, 'monthCostUsd' | 'monthBudgetUsd' | 'peakNow'>
    & { agents: Array<(
      { __typename?: 'AiAgentType' }
      & Pick<AiAgentType, 'key' | 'label' | 'description' | 'enabled' | 'offReason' | 'provider' | 'model' | 'version' | 'monthCostUsd' | 'monthBudgetUsd' | 'runsToday' | 'runningCount' | 'queuedCount' | 'lastRunAt' | 'lastStatus' | 'metrics' | 'manualStart' | 'subjectKinds'>
    )>, costByDay: Array<(
      { __typename?: 'AiCostDayType' }
      & Pick<AiCostDayType, 'day' | 'agentKey' | 'costUsd' | 'calls'>
    )> }
  ) }
);

export type ErpAiAgentRunsQueryVariables = Exact<{
  agentKey?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trigger?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type ErpAiAgentRunsQuery = (
  { __typename?: 'Query' }
  & { aiAgentRuns: (
    { __typename?: 'AiAgentRunPageType' }
    & Pick<AiAgentRunPageType, 'total' | 'hasMore'>
    & { rows: Array<(
      { __typename?: 'AiAgentRunType' }
      & Pick<AiAgentRunType, 'id' | 'agentKey' | 'trigger' | 'status' | 'subjectKind' | 'subjectId' | 'subjectLabel' | 'createdAt' | 'startedAt' | 'finishedAt' | 'durationMs' | 'provider' | 'model' | 'inputTokens' | 'cachedTokens' | 'outputTokens' | 'costUsd' | 'resultSummary' | 'error' | 'createdByName'>
    )> }
  ) }
);

export type ErpAiAgentRunQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpAiAgentRunQuery = (
  { __typename?: 'Query' }
  & { aiAgentRun?: Maybe<(
    { __typename?: 'AiAgentRunType' }
    & Pick<AiAgentRunType, 'id' | 'agentKey' | 'trigger' | 'status' | 'subjectKind' | 'subjectId' | 'subjectLabel' | 'createdAt' | 'startedAt' | 'finishedAt' | 'durationMs' | 'provider' | 'model' | 'inputTokens' | 'cachedTokens' | 'outputTokens' | 'costUsd' | 'resultSummary' | 'error' | 'createdByName'>
    & { steps: Array<(
      { __typename?: 'AiAgentRunStepType' }
      & Pick<AiAgentRunStepType, 'id' | 'node' | 'status' | 'startedAt' | 'finishedAt' | 'summary' | 'error'>
    )> }
  )> }
);

export type ErpAiChatThreadsQueryVariables = Exact<{
  archived?: Maybe<Scalars['Boolean']>;
}>;


export type ErpAiChatThreadsQuery = (
  { __typename?: 'Query' }
  & { aiChatThreads: Array<(
    { __typename?: 'AiChatThreadType' }
    & Pick<AiChatThreadType, 'id' | 'title' | 'status' | 'createdAt' | 'lastMessageAt' | 'pinnedAt'>
  )> }
);

export type ErpAiChatThreadQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpAiChatThreadQuery = (
  { __typename?: 'Query' }
  & { aiChatThread?: Maybe<(
    { __typename?: 'AiChatThreadDetailType' }
    & { thread: (
      { __typename?: 'AiChatThreadType' }
      & Pick<AiChatThreadType, 'id' | 'title' | 'status' | 'createdAt' | 'lastMessageAt' | 'pinnedAt'>
    ), messages: Array<(
      { __typename?: 'AiChatMessageType' }
      & Pick<AiChatMessageType, 'id' | 'role' | 'text' | 'createdAt' | 'blocks' | 'interrupted'>
      & { mentions: Array<(
        { __typename?: 'AiChatMentionType' }
        & Pick<AiChatMentionType, 'kind' | 'id' | 'label'>
      )>, attachments: Array<(
        { __typename?: 'AiChatAttachmentType' }
        & Pick<AiChatAttachmentType, 'id' | 'url' | 'name' | 'mime' | 'size' | 'width' | 'height'>
      )>, toolCalls: Array<(
        { __typename?: 'AiChatToolCallType' }
        & Pick<AiChatToolCallType, 'name' | 'argsSummary' | 'status' | 'resultSummary'>
        & { source?: Maybe<(
          { __typename?: 'AiToolSourceType' }
          & Pick<AiToolSourceType, 'kind' | 'label'>
        )> }
      )>, pendingActions: Array<(
        { __typename?: 'AiChatPendingActionType' }
        & Pick<AiChatPendingActionType, 'id' | 'tool' | 'willDo' | 'status' | 'result' | 'createdAt'>
        & { source?: Maybe<(
          { __typename?: 'AiToolSourceType' }
          & Pick<AiToolSourceType, 'kind' | 'label'>
        )> }
      )> }
    )>, toolEvents: Array<(
      { __typename?: 'AiChatToolEventType' }
      & Pick<AiChatToolEventType, 'id' | 'messageId' | 'seq' | 'name' | 'args' | 'status' | 'resultPreview' | 'startedAt' | 'finishedAt'>
      & { source?: Maybe<(
        { __typename?: 'AiToolSourceType' }
        & Pick<AiToolSourceType, 'kind' | 'label'>
      )> }
    )>, activeRun?: Maybe<(
      { __typename?: 'AiAgentRunType' }
      & Pick<AiAgentRunType, 'id' | 'agentKey' | 'status' | 'model' | 'createdAt' | 'startedAt' | 'finishedAt' | 'error'>
      & { steps: Array<(
        { __typename?: 'AiAgentRunStepType' }
        & Pick<AiAgentRunStepType, 'id' | 'node' | 'status' | 'startedAt' | 'finishedAt' | 'summary' | 'error'>
      )> }
    )>, lastRun?: Maybe<(
      { __typename?: 'AiAgentRunType' }
      & Pick<AiAgentRunType, 'id' | 'agentKey' | 'status' | 'model' | 'createdAt' | 'startedAt' | 'finishedAt' | 'error'>
    )> }
  )> }
);

export type ErpAiChatMentionSuggestionsQueryVariables = Exact<{
  query: Scalars['String'];
  kinds?: Maybe<Array<Scalars['String']>>;
}>;


export type ErpAiChatMentionSuggestionsQuery = (
  { __typename?: 'Query' }
  & { aiChatMentionSearch: Array<(
    { __typename?: 'AiChatMentionSuggestionType' }
    & Pick<AiChatMentionSuggestionType, 'kind' | 'id' | 'label' | 'sublabel'>
  )> }
);

export type ErpAiFindingsQueryVariables = Exact<{
  kind?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  feedback?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type ErpAiFindingsQuery = (
  { __typename?: 'Query' }
  & { aiFindings: (
    { __typename?: 'AiFindingPageType' }
    & Pick<AiFindingPageType, 'total' | 'hasMore'>
    & { rows: Array<(
      { __typename?: 'AiFindingType' }
      & Pick<AiFindingType, 'id' | 'kind' | 'severity' | 'summary' | 'confidence' | 'groupId' | 'groupName' | 'lessonId' | 'lessonStartsAt' | 'proposedStartsAt' | 'scheduleNote' | 'conversationId' | 'messageIds' | 'excerpts' | 'taskId' | 'taskStatus' | 'feedback' | 'feedbackReason' | 'feedbackByName' | 'createdAt'>
    )> }
  ) }
);

export type ErpAiFindingForTaskQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type ErpAiFindingForTaskQuery = (
  { __typename?: 'Query' }
  & { aiFindingForTask?: Maybe<(
    { __typename?: 'AiFindingType' }
    & Pick<AiFindingType, 'id' | 'kind' | 'severity' | 'summary' | 'confidence' | 'groupId' | 'groupName' | 'lessonId' | 'lessonStartsAt' | 'proposedStartsAt' | 'scheduleNote' | 'conversationId' | 'messageIds' | 'excerpts' | 'taskId' | 'taskStatus' | 'feedback' | 'feedbackReason' | 'feedbackByName' | 'createdAt'>
  )> }
);

export type ErpAiLessonReviewQueueQueryVariables = Exact<{
  reviewStatus?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type ErpAiLessonReviewQueueQuery = (
  { __typename?: 'Query' }
  & { aiLessonAnalyses: (
    { __typename?: 'AiLessonAnalysisPageType' }
    & Pick<AiLessonAnalysisPageType, 'total' | 'hasMore'>
    & { rows: Array<(
      { __typename?: 'AiLessonAnalysisType' }
      & Pick<AiLessonAnalysisType, 'id' | 'lessonId' | 'groupId' | 'groupName' | 'lessonNumber' | 'lessonStartsAt' | 'teacherName' | 'status' | 'overallScore' | 'reviewStatus' | 'createdAt'>
    )> }
  ) }
);

export type ErpAiKnowledgeDocumentsQueryVariables = Exact<{
  category?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
}>;


export type ErpAiKnowledgeDocumentsQuery = (
  { __typename?: 'Query' }
  & { aiKnowledgeDocuments: Array<(
    { __typename?: 'AiKnowledgeDocumentType' }
    & Pick<AiKnowledgeDocumentType, 'id' | 'title' | 'category' | 'status' | 'sourceFileName' | 'version' | 'tokens' | 'chunkCount' | 'updatedAt' | 'updatedByName' | 'verifiedAt' | 'verifiedByName' | 'stale'>
  )> }
);

export type ErpAiKnowledgeDocumentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpAiKnowledgeDocumentQuery = (
  { __typename?: 'Query' }
  & { aiKnowledgeDocument?: Maybe<(
    { __typename?: 'AiKnowledgeDocumentType' }
    & Pick<AiKnowledgeDocumentType, 'id' | 'title' | 'category' | 'status' | 'body' | 'sourceFileName' | 'version' | 'tokens' | 'chunkCount' | 'updatedAt' | 'updatedByName' | 'verifiedAt' | 'verifiedByName' | 'stale'>
  )> }
);

export type ErpAiKnowledgeStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpAiKnowledgeStatsQuery = (
  { __typename?: 'Query' }
  & { aiKnowledgeStats: (
    { __typename?: 'AiKnowledgeStatsType' }
    & Pick<AiKnowledgeStatsType, 'publishedCount' | 'publishedTokens' | 'strategy' | 'lastSweepAt' | 'lastSweepStatus' | 'lastSweepError' | 'vectorsOffReason'>
    & { vectorCoverage: (
      { __typename?: 'AiKbVectorCoverageType' }
      & Pick<AiKbVectorCoverageType, 'withVector' | 'total'>
    ) }
  ) }
);

export type ErpAiKnowledgeSearchQueryVariables = Exact<{
  query: Scalars['String'];
  category?: Maybe<Scalars['String']>;
}>;


export type ErpAiKnowledgeSearchQuery = (
  { __typename?: 'Query' }
  & { aiKnowledgeSearch: Array<(
    { __typename?: 'AiKnowledgeHitType' }
    & Pick<AiKnowledgeHitType, 'documentId' | 'title' | 'headingPath' | 'text' | 'rank'>
  )> }
);

export type ErpAiKbCandidatesQueryVariables = Exact<{
  category?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ErpAiKbCandidatesQuery = (
  { __typename?: 'Query' }
  & { aiKbCandidates: (
    { __typename?: 'AiKbCandidatePageType' }
    & Pick<AiKbCandidatePageType, 'total'>
    & { items: Array<(
      { __typename?: 'AiKbCandidateType' }
      & ErpAiKbCandidateFieldsFragment
    )> }
  ) }
);

export type ErpAiKbCandidateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpAiKbCandidateQuery = (
  { __typename?: 'Query' }
  & { aiKbCandidate?: Maybe<(
    { __typename?: 'AiKbCandidateType' }
    & ErpAiKbCandidateFieldsFragment
  )> }
);

export type ErpAiKbReviewerMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpAiKbReviewerMeQuery = (
  { __typename?: 'Query' }
  & { aiKbReviewerMe: (
    { __typename?: 'AiKbReviewerMeType' }
    & Pick<AiKbReviewerMeType, 'isAdmin' | 'categories' | 'pendingCount'>
  ) }
);

export type ErpAiKbReviewersQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpAiKbReviewersQuery = (
  { __typename?: 'Query' }
  & { aiKbReviewers: Array<(
    { __typename?: 'AiKbReviewerCategoryType' }
    & Pick<AiKbReviewerCategoryType, 'category'>
    & { users: Array<(
      { __typename?: 'AiKbReviewerUserType' }
      & Pick<AiKbReviewerUserType, 'id' | 'name' | 'email'>
    )> }
  )> }
);

export type ErpAiKbReviewerCandidatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpAiKbReviewerCandidatesQuery = (
  { __typename?: 'Query' }
  & { aiKbReviewerCandidates: Array<(
    { __typename?: 'AiKbReviewerUserType' }
    & Pick<AiKbReviewerUserType, 'id' | 'name' | 'email'>
  )> }
);

export type ErpAiKnowledgeRevisionsQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type ErpAiKnowledgeRevisionsQuery = (
  { __typename?: 'Query' }
  & { aiKnowledgeRevisions: Array<(
    { __typename?: 'AiKnowledgeRevisionType' }
    & Pick<AiKnowledgeRevisionType, 'id' | 'version' | 'title' | 'category' | 'reason' | 'authorName' | 'candidateId' | 'body' | 'createdAt'>
  )> }
);

export type ErpAiReplyQualityWeeksQueryVariables = Exact<{
  weeks?: Maybe<Scalars['Int']>;
}>;


export type ErpAiReplyQualityWeeksQuery = (
  { __typename?: 'Query' }
  & { aiReplyQuality: Array<(
    { __typename?: 'AiReplyQualityWeekType' }
    & Pick<AiReplyQualityWeekType, 'week' | 'weekStart' | 'computedAt'>
    & { total?: Maybe<(
      { __typename?: 'AiReplyQualityRowType' }
      & Pick<AiReplyQualityRowType, 'channel' | 'topic' | 'created' | 'sent' | 'sentUnedited' | 'uneditedShare' | 'medianEditDistance' | 'rejected' | 'kbEmptyShare' | 'candidatesNew' | 'candidatesApproved'>
      & { topRejectReasons: Array<(
        { __typename?: 'AiCountType' }
        & Pick<AiCountType, 'label' | 'count'>
      )>, topMissingInfo: Array<(
        { __typename?: 'AiCountType' }
        & Pick<AiCountType, 'label' | 'count'>
      )> }
    )>, rows: Array<(
      { __typename?: 'AiReplyQualityRowType' }
      & Pick<AiReplyQualityRowType, 'channel' | 'topic' | 'created' | 'sent' | 'sentUnedited' | 'uneditedShare' | 'medianEditDistance' | 'rejected' | 'kbEmptyShare' | 'candidatesNew' | 'candidatesApproved'>
      & { topRejectReasons: Array<(
        { __typename?: 'AiCountType' }
        & Pick<AiCountType, 'label' | 'count'>
      )>, topMissingInfo: Array<(
        { __typename?: 'AiCountType' }
        & Pick<AiCountType, 'label' | 'count'>
      )> }
    )> }
  )> }
);

export type ErpAiLessonAnalysisQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type ErpAiLessonAnalysisQuery = (
  { __typename?: 'Query' }
  & { aiLessonAnalysis?: Maybe<(
    { __typename?: 'AiLessonAnalysisType' }
    & Pick<AiLessonAnalysisType, 'id' | 'lessonId' | 'groupId' | 'groupName' | 'courseId' | 'lessonNumber' | 'lessonStartsAt' | 'teacherName' | 'status' | 'lessonStatus' | 'overallScore' | 'understandingScore' | 'understandingBand' | 'summary' | 'strengths' | 'developmentArea' | 'alerts' | 'reviewStatus' | 'reviewNote' | 'model' | 'createdAt' | 'error'>
    & { criteria: Array<(
      { __typename?: 'AiLessonCriterionType' }
      & Pick<AiLessonCriterionType, 'id' | 'label' | 'weight' | 'status' | 'score' | 'confidence' | 'whyScore' | 'whyNotHigher' | 'nextLevel'>
    )>, recommendation?: Maybe<(
      { __typename?: 'AiLessonRecommendationType' }
      & Pick<AiLessonRecommendationType, 'ruleId' | 'name' | 'action' | 'steps' | 'implementationCheck' | 'effectCheck'>
    )>, speakers: Array<(
      { __typename?: 'AiLessonSpeakerType' }
      & Pick<AiLessonSpeakerType, 'code' | 'label' | 'role'>
    )> }
  )> }
);

export type ErpAiLessonAnalysesQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  reviewStatus?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type ErpAiLessonAnalysesQuery = (
  { __typename?: 'Query' }
  & { aiLessonAnalyses: (
    { __typename?: 'AiLessonAnalysisPageType' }
    & Pick<AiLessonAnalysisPageType, 'total' | 'hasMore'>
    & { rows: Array<(
      { __typename?: 'AiLessonAnalysisType' }
      & Pick<AiLessonAnalysisType, 'id' | 'lessonId' | 'groupId' | 'groupName' | 'courseId' | 'lessonNumber' | 'lessonStartsAt' | 'teacherName' | 'status' | 'lessonStatus' | 'overallScore' | 'understandingScore' | 'understandingBand' | 'reviewStatus' | 'createdAt'>
      & { recommendation?: Maybe<(
        { __typename?: 'AiLessonRecommendationType' }
        & Pick<AiLessonRecommendationType, 'ruleId' | 'name' | 'action' | 'steps' | 'implementationCheck' | 'effectCheck'>
      )> }
    )> }
  ) }
);

export type ErpAiTeacherPracticePortraitQueryVariables = Exact<{
  teacherId: Scalars['ID'];
}>;


export type ErpAiTeacherPracticePortraitQuery = (
  { __typename?: 'Query' }
  & { aiTeacherPracticePortrait?: Maybe<(
    { __typename?: 'AiTeacherPracticePortraitType' }
    & Pick<AiTeacherPracticePortraitType, 'teacherId' | 'lessonsAnalyzed' | 'maturity' | 'narrative' | 'generatedAt' | 'narrativeGeneratedAt' | 'narrativeAnalysesCount' | 'narrativeStatus' | 'narrativeError' | 'narrativeMinAnalyses'>
    & { criteria: Array<(
      { __typename?: 'AiPracticeCriterionStatType' }
      & Pick<AiPracticeCriterionStatType, 'id' | 'label' | 'n' | 'median' | 'q1' | 'q3' | 'coverage' | 'trend'>
    )> }
  )> }
);

export type ErpAiCourseLessonComparisonQueryVariables = Exact<{
  courseId: Scalars['ID'];
  lessonNumber: Scalars['Int'];
}>;


export type ErpAiCourseLessonComparisonQuery = (
  { __typename?: 'Query' }
  & { aiCourseLessonComparison: (
    { __typename?: 'AiCourseLessonComparisonType' }
    & Pick<AiCourseLessonComparisonType, 'courseId' | 'lessonNumber'>
    & { rows: Array<(
      { __typename?: 'AiCourseLessonRowType' }
      & Pick<AiCourseLessonRowType, 'groupId' | 'groupName' | 'lessonId' | 'lessonStartsAt' | 'teacherName' | 'overallScore' | 'recommendationRule' | 'criteria'>
    )> }
  ) }
);

export type ErpAiLessonBatchEstimateQueryVariables = Exact<{
  lessonIds: Array<Scalars['ID']>;
}>;


export type ErpAiLessonBatchEstimateQuery = (
  { __typename?: 'Query' }
  & { estimateAiLessonAnalyses: (
    { __typename?: 'AiLessonEstimateType' }
    & Pick<AiLessonEstimateType, 'lessons' | 'withTranscript' | 'withoutTranscript' | 'alreadyAnalyzed' | 'running' | 'toAnalyze' | 'transcriptBytes' | 'unknownSize' | 'estimatedCostUsd' | 'inFlightCostUsd' | 'costBasis' | 'budgetSpentUsd' | 'budgetLimitUsd' | 'budgetLeftUsd' | 'budgetEnough'>
  ) }
);

export type ErpLessonWindowQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type ErpLessonWindowQuery = (
  { __typename?: 'Query' }
  & { aiLessonView?: Maybe<(
    { __typename?: 'AiLessonViewType' }
    & Pick<AiLessonViewType, 'lessonId' | 'name' | 'lessonNumber' | 'startsAt' | 'endsAt' | 'isOver' | 'groupId' | 'groupName' | 'courseId' | 'teacherName' | 'hasTranscript' | 'recordingStatus' | 'videoUrl' | 'aiSummary' | 'aiTimecodes'>
    & { surveys: Array<(
      { __typename?: 'AiLessonSurveyType' }
      & Pick<AiLessonSurveyType, 'assignmentId' | 'surveyId' | 'surveyTitle' | 'isActive' | 'responsesCount' | 'eligibleCount'>
      & { questions: Array<(
        { __typename?: 'AiLessonSurveyQuestionType' }
        & Pick<AiLessonSurveyQuestionType, 'questionId' | 'question' | 'questionType' | 'answersCount' | 'average'>
      )>, comments: Array<(
        { __typename?: 'AiLessonSurveyCommentType' }
        & Pick<AiLessonSurveyCommentType, 'questionId' | 'question' | 'text' | 'submittedAt'>
      )> }
    )> }
  )> }
);

export type ErpAiLessonLaunchAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpAiLessonLaunchAvailabilityQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'aiLessonLaunchEnabled'>
);

export type ErpAiStudentPortraitQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type ErpAiStudentPortraitQuery = (
  { __typename?: 'Query' }
  & { aiStudentPortrait: (
    { __typename?: 'AiStudentPortraitType' }
    & Pick<AiStudentPortraitType, 'studentId' | 'status' | 'stale' | 'generatedAt' | 'model' | 'error' | 'summary' | 'learning' | 'engagement' | 'sentimentTrend' | 'communication'>
    & { risks: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, openNeeds: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, nextActions: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, about: Array<(
      { __typename?: 'AiPortraitFactType' }
      & Pick<AiPortraitFactType, 'key' | 'label' | 'value'>
    )>, strengths: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, concerns: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )>, checkpoints: Array<(
      { __typename?: 'AiPortraitCheckpointType' }
      & Pick<AiPortraitCheckpointType, 'key' | 'status' | 'text'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )> }
  ) }
);

export type ErpAiStudentFinancePortraitQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type ErpAiStudentFinancePortraitQuery = (
  { __typename?: 'Query' }
  & { aiStudentFinancePortrait?: Maybe<(
    { __typename?: 'AiStudentFinancePortraitType' }
    & Pick<AiStudentFinancePortraitType, 'studentId' | 'status' | 'generatedAt' | 'summary'>
    & { items: Array<(
      { __typename?: 'AiPortraitItemType' }
      & Pick<AiPortraitItemType, 'text' | 'severity'>
      & { evidence: Array<(
        { __typename?: 'AiEvidenceRefType' }
        & Pick<AiEvidenceRefType, 'kind' | 'id' | 'label' | 'at' | 'leadId'>
      )> }
    )> }
  )> }
);

export type ErpAiReplySuggestionQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type ErpAiReplySuggestionQuery = (
  { __typename?: 'Query' }
  & { aiReplySuggestion?: Maybe<(
    { __typename?: 'AiReplySuggestionType' }
    & Pick<AiReplySuggestionType, 'id' | 'conversationId' | 'forMessageId' | 'status' | 'topic' | 'language' | 'text' | 'html' | 'confidence' | 'missingInfo' | 'error' | 'financeHidden' | 'createdAt' | 'updatedAt'>
    & { citations: Array<(
      { __typename?: 'AiCitationType' }
      & Pick<AiCitationType, 'kind' | 'ref' | 'label'>
    )> }
  )> }
);

export type ErpAiChatToolCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpAiChatToolCatalogQuery = (
  { __typename?: 'Query' }
  & { aiChatToolCatalog: Array<(
    { __typename?: 'AiBuiltinToolType' }
    & Pick<AiBuiltinToolType, 'name' | 'group' | 'kind' | 'description' | 'enabled' | 'defaultEnabled'>
  )> }
);

export type ErpAiSkillsQueryVariables = Exact<{
  status?: Maybe<Scalars['String']>;
}>;


export type ErpAiSkillsQuery = (
  { __typename?: 'Query' }
  & { aiSkills: Array<(
    { __typename?: 'AiAgentSkillType' }
    & Pick<AiAgentSkillType, 'id' | 'slug' | 'title' | 'description' | 'status' | 'source' | 'version' | 'agents' | 'pluginId' | 'pluginName' | 'updatedAt' | 'createdByName'>
    & { files: Array<(
      { __typename?: 'AiSkillFileType' }
      & Pick<AiSkillFileType, 'path' | 'size'>
    )> }
  )> }
);

export type ErpAiSkillQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpAiSkillQuery = (
  { __typename?: 'Query' }
  & { aiSkill?: Maybe<(
    { __typename?: 'AiAgentSkillType' }
    & Pick<AiAgentSkillType, 'id' | 'slug' | 'title' | 'description' | 'instructions' | 'status' | 'source' | 'version' | 'agents' | 'pluginId' | 'pluginName' | 'updatedAt' | 'createdByName' | 'skipped'>
    & { files: Array<(
      { __typename?: 'AiSkillFileType' }
      & Pick<AiSkillFileType, 'path' | 'size'>
    )> }
  )> }
);

export type ErpAiMcpConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpAiMcpConnectionsQuery = (
  { __typename?: 'Query' }
  & { aiMcpConnections: Array<(
    { __typename?: 'AiMcpConnectionType' }
    & Pick<AiMcpConnectionType, 'id' | 'slug' | 'title' | 'url' | 'transport' | 'authType' | 'headerName' | 'hasSecret' | 'oauthConnected' | 'oauthExpiresAt' | 'allowPii' | 'enabled' | 'status' | 'lastCheckedAt' | 'lastError' | 'serverName' | 'serverVersion' | 'pluginId' | 'pluginName' | 'note'>
    & { tools: Array<(
      { __typename?: 'AiMcpToolType' }
      & Pick<AiMcpToolType, 'name' | 'description' | 'inputSchema' | 'enabled' | 'requiresApproval' | 'missing' | 'changed' | 'unsupportedReason'>
    )>, notes: Array<(
      { __typename?: 'AiExtNoteType' }
      & Pick<AiExtNoteType, 'code' | 'params'>
    )> }
  )> }
);

export type ErpAiMcpConnectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpAiMcpConnectionQuery = (
  { __typename?: 'Query' }
  & { aiMcpConnection?: Maybe<(
    { __typename?: 'AiMcpConnectionType' }
    & Pick<AiMcpConnectionType, 'id' | 'slug' | 'title' | 'url' | 'transport' | 'authType' | 'headerName' | 'hasSecret' | 'oauthConnected' | 'oauthExpiresAt' | 'allowPii' | 'enabled' | 'status' | 'lastCheckedAt' | 'lastError' | 'serverName' | 'serverVersion' | 'pluginId' | 'pluginName' | 'note'>
    & { tools: Array<(
      { __typename?: 'AiMcpToolType' }
      & Pick<AiMcpToolType, 'name' | 'description' | 'inputSchema' | 'enabled' | 'requiresApproval' | 'missing' | 'changed' | 'unsupportedReason'>
    )>, notes: Array<(
      { __typename?: 'AiExtNoteType' }
      & Pick<AiExtNoteType, 'code' | 'params'>
    )> }
  )> }
);

export type ErpAiPluginsQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpAiPluginsQuery = (
  { __typename?: 'Query' }
  & { aiPlugins: Array<(
    { __typename?: 'AiPluginType' }
    & Pick<AiPluginType, 'id' | 'name' | 'version' | 'description' | 'enabled' | 'skipped' | 'createdAt'>
    & { skippedItems: Array<(
      { __typename?: 'AiExtNoteType' }
      & Pick<AiExtNoteType, 'code' | 'params'>
    )>, skills: Array<(
      { __typename?: 'AiAgentSkillType' }
      & Pick<AiAgentSkillType, 'id' | 'slug' | 'title' | 'status' | 'source' | 'version'>
    )>, connections: Array<(
      { __typename?: 'AiMcpConnectionType' }
      & Pick<AiMcpConnectionType, 'id' | 'slug' | 'title' | 'url' | 'authType' | 'hasSecret' | 'oauthConnected' | 'enabled' | 'status' | 'note'>
    )> }
  )> }
);

export type PaginatedTeachersApplicationsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type PaginatedTeachersApplicationsQuery = (
  { __typename?: 'Query' }
  & { allTeachersApplications?: Maybe<(
    { __typename?: 'ApplicationFilterTypeConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'ApplicationFilterTypeEdge' }
      & { node?: Maybe<(
        { __typename?: 'ApplicationType' }
        & Pick<ApplicationType, 'id' | 'title' | 'lessonsCount' | 'servicePrice' | 'currency' | 'isTerminated' | 'isCompleted' | 'appointedLessonsCount'>
        & { teacher: (
          { __typename?: 'TeacherFilterType' }
          & Pick<TeacherFilterType, 'fullName'>
        ), group: (
          { __typename?: 'MethodistGroupType' }
          & Pick<MethodistGroupType, 'name'>
        ), employmentType?: Maybe<{ __typename: 'IndividualEntrepreneurType' } | { __typename: 'LegalEntityType' } | { __typename: 'SelfEmployedType' } | { __typename: 'NaturalPersonType' }> }
      )> }
    )>> }
  )> }
);

export type GetApplicationsForGroupQueryVariables = Exact<{
  byGroupId?: Maybe<Scalars['Decimal']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
  groupsFilter?: Maybe<Scalars['Boolean']>;
}>;


export type GetApplicationsForGroupQuery = (
  { __typename?: 'Query' }
  & { allTeachersApplications?: Maybe<(
    { __typename?: 'ApplicationFilterTypeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ApplicationFilterTypeEdge' }
      & { node?: Maybe<(
        { __typename?: 'ApplicationType' }
        & Pick<ApplicationType, 'id' | 'title' | 'lessonsCount' | 'appointedLessonsCount'>
        & { teacher: (
          { __typename?: 'TeacherFilterType' }
          & Pick<TeacherFilterType, 'fullName'>
        ) }
      )> }
    )>> }
  )> }
);

export type LoadEditingApplicationQueryVariables = Exact<{
  applicationId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
}>;


export type LoadEditingApplicationQuery = (
  { __typename?: 'Query' }
  & { teacherApplication?: Maybe<(
    { __typename?: 'ApplicationType' }
    & Pick<ApplicationType, 'id' | 'title' | 'date' | 'lessonsCount' | 'servicePrice' | 'riaPrice' | 'currency' | 'comment' | 'isTerminated' | 'lastLessonDate' | 'isCompleted' | 'deleteAvailable' | 'appointedLessonsCount' | 'rateUnit' | 'rateIsGross'>
    & { billingEntity?: Maybe<(
      { __typename?: 'TeacherBillingEntityType' }
      & Pick<TeacherBillingEntityType, 'id'>
    )>, country?: Maybe<(
      { __typename?: 'CountryType' }
      & Pick<CountryType, 'id' | 'title'>
    )>, teacher: (
      { __typename?: 'TeacherFilterType' }
      & Pick<TeacherFilterType, 'id' | 'fullName'>
      & { employmentTypes?: Maybe<Array<Maybe<{ __typename: 'IndividualEntrepreneurType' } | { __typename: 'LegalEntityType' } | { __typename: 'SelfEmployedType' } | { __typename: 'NaturalPersonType' }>>> }
    ), group: (
      { __typename?: 'MethodistGroupType' }
      & Pick<MethodistGroupType, 'id' | 'name' | 'freeLessonsCount' | 'startDate'>
      & { course: (
        { __typename?: 'CourseFilterType' }
        & Pick<CourseFilterType, 'id' | 'name'>
      ) }
    ), lessons: (
      { __typename?: 'GroupLessonTypeConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'GroupLessonTypeEdge' }
        & { node?: Maybe<(
          { __typename?: 'GroupLessonType' }
          & Pick<GroupLessonType, 'date'>
        )> }
      )>> }
    ), employmentType?: Maybe<{ __typename: 'IndividualEntrepreneurType' } | { __typename: 'LegalEntityType' } | { __typename: 'SelfEmployedType' } | { __typename: 'NaturalPersonType' }> }
  )> }
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'UserNode' }
    & UserFieldsFragment
  )> }
);

export type ErpCareerMembersQueryVariables = Exact<{
  status?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpCareerMembersQuery = (
  { __typename?: 'Query' }
  & { careerMembers: Array<(
    { __typename?: 'CareerMemberType' }
    & Pick<CareerMemberType, 'id' | 'studentId' | 'studentName' | 'studentEmail' | 'groupId' | 'groupName' | 'directionId' | 'directionTitle' | 'status' | 'enrolledAt' | 'notes' | 'lessonsCompleted' | 'lessonsTotal'>
  )> }
);

export type ErpCareerMemberDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpCareerMemberDetailQuery = (
  { __typename?: 'Query' }
  & { careerMemberDetail?: Maybe<(
    { __typename?: 'CareerMemberType' }
    & Pick<CareerMemberType, 'id' | 'studentName' | 'studentEmail'>
    & { growth?: Maybe<(
      { __typename?: 'MemberGrowthType' }
      & Pick<MemberGrowthType, 'xp' | 'level' | 'levelTitle' | 'medalsEarned' | 'medalsTotal' | 'trackTitle' | 'trackIsDefault'>
      & { nextCourses: Array<(
        { __typename?: 'NextCourseType' }
        & Pick<NextCourseType, 'courseId' | 'courseName' | 'courseUrl' | 'adds' | 'covered' | 'totalMissing'>
      )>, codes: Array<(
        { __typename?: 'PromoCodeType' }
        & Pick<PromoCodeType, 'id' | 'code' | 'status' | 'expiresAt' | 'campaignTitle' | 'discountKind' | 'discountValue' | 'currency'>
      )> }
    )>, profile?: Maybe<(
      { __typename?: 'CareerProfileType' }
      & Pick<CareerProfileType, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'photoUrl' | 'city' | 'country' | 'relocationReady' | 'workMode' | 'workPermit' | 'availableFrom' | 'seniority' | 'desiredPosition' | 'desiredSalary' | 'githubUrl' | 'linkedinUrl' | 'portfolioUrl' | 'customSkills' | 'isSearchable' | 'contactsVisible' | 'completeness'>
      & { skills: Array<(
        { __typename?: 'StudentSkillType' }
        & Pick<StudentSkillType, 'skillId' | 'name' | 'category' | 'level' | 'years'>
      )>, projects: Array<(
        { __typename?: 'PortfolioProjectType' }
        & Pick<PortfolioProjectType, 'id' | 'title' | 'description' | 'role' | 'repoUrl' | 'demoUrl' | 'technologyNames'>
      )>, experience: Array<(
        { __typename?: 'WorkExperienceType' }
        & Pick<WorkExperienceType, 'id' | 'company' | 'position' | 'description' | 'startYear' | 'startMonth' | 'endYear' | 'endMonth' | 'isCurrent'>
      )>, education: Array<(
        { __typename?: 'EducationType' }
        & Pick<EducationType, 'id' | 'institution' | 'degree' | 'specialization' | 'startYear' | 'startMonth' | 'endYear' | 'endMonth'>
      )>, languages: Array<(
        { __typename?: 'LanguageSkillType' }
        & Pick<LanguageSkillType, 'id' | 'language' | 'level'>
      )>, certificates: Array<(
        { __typename?: 'CertificateType' }
        & Pick<CertificateType, 'id' | 'title' | 'issuer' | 'issuedAt' | 'url' | 'fileUrl'>
      )>, locales: Array<(
        { __typename?: 'CvLocaleType' }
        & Pick<CvLocaleType, 'language' | 'jobTitle' | 'about'>
      )> }
    )> }
  )> }
);

export type ErpCareerDirectionsQueryVariables = Exact<{
  includeInactive?: Maybe<Scalars['Boolean']>;
}>;


export type ErpCareerDirectionsQuery = (
  { __typename?: 'Query' }
  & { careerDirections: Array<(
    { __typename?: 'CareerDirectionType' }
    & Pick<CareerDirectionType, 'id' | 'slug' | 'title' | 'order' | 'isActive'>
  )> }
);

export type ErpCareerLessonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpCareerLessonsQuery = (
  { __typename?: 'Query' }
  & { careerLessonsErp: Array<(
    { __typename?: 'CareerLessonType' }
    & Pick<CareerLessonType, 'id' | 'order' | 'title' | 'summary' | 'content' | 'durationMin' | 'completionKind' | 'artifactHint' | 'outcomeKind' | 'outcomeLabel' | 'materialLanguage' | 'isPublished' | 'videoUrl'>
    & { attachments: Array<(
      { __typename?: 'CareerLessonAttachmentType' }
      & Pick<CareerLessonAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'url'>
    )>, stats?: Maybe<(
      { __typename?: 'CareerLessonStatsType' }
      & Pick<CareerLessonStatsType, 'openedCount' | 'completedCount' | 'membersTotal'>
    )>, quizQuestions: Array<(
      { __typename?: 'CareerQuizQuestionType' }
      & Pick<CareerQuizQuestionType, 'id' | 'order' | 'text' | 'options' | 'correctIndexes'>
    )>, exercise?: Maybe<(
      { __typename?: 'CareerLessonExerciseType' }
      & Pick<CareerLessonExerciseType, 'id' | 'intro' | 'outro' | 'templateId' | 'templateTitle' | 'hasSubmissions'>
      & { fields: Array<(
        { __typename?: 'CareerExerciseFieldType' }
        & Pick<CareerExerciseFieldType, 'id' | 'number' | 'label' | 'helpText' | 'placeholder' | 'fieldType' | 'required' | 'options' | 'maxLength' | 'binding' | 'bindingLanguage'>
      )> }
    )> }
  )> }
);

export type CareerMemberLearningProgressQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type CareerMemberLearningProgressQuery = (
  { __typename?: 'Query' }
  & { careerMemberProgress: Array<(
    { __typename?: 'CareerMemberLessonProgressType' }
    & Pick<CareerMemberLessonProgressType, 'lessonId' | 'order' | 'title' | 'isOpened' | 'openedAt' | 'openCount' | 'isCompleted' | 'completedAt'>
  )> }
);

export type ErpVacanciesQueryVariables = Exact<{
  status?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  freshness?: Maybe<Scalars['String']>;
  hideArchived?: Maybe<Scalars['Boolean']>;
}>;


export type ErpVacanciesQuery = (
  { __typename?: 'Query' }
  & { careerVacanciesErp: Array<(
    { __typename?: 'VacancyType' }
    & Pick<VacancyType, 'id' | 'title' | 'companyName' | 'applyUrl' | 'location' | 'workMode' | 'seniority' | 'employmentType' | 'salaryMin' | 'salaryMax' | 'salaryCurrency' | 'description' | 'status' | 'publishedAt' | 'expiresAt' | 'createdAt' | 'directionIds' | 'directionTitles' | 'skillIds' | 'skillNames' | 'appliedCount' | 'source' | 'createdByName' | 'reviewedByName' | 'reviewedAt' | 'updatedAt'>
    & { duplicateOf: Array<(
      { __typename?: 'VacancyDuplicateHintType' }
      & Pick<VacancyDuplicateHintType, 'vacancyId' | 'title' | 'companyName' | 'status' | 'score'>
    )> }
  )> }
);

export type ErpVacancyBoardQueryVariables = Exact<{
  status?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  freshness?: Maybe<Scalars['String']>;
  hideArchived?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<Scalars['String']>;
  orderDir?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
}>;


export type ErpVacancyBoardQuery = (
  { __typename?: 'Query' }
  & { careerVacancyBoard: (
    { __typename?: 'VacancyBoardConnection' }
    & Pick<VacancyBoardConnection, 'totalCount' | 'totalCountCapped'>
    & { edges: Array<(
      { __typename?: 'VacancyEdge' }
      & Pick<VacancyEdge, 'cursor'>
      & { node: (
        { __typename?: 'VacancyType' }
        & Pick<VacancyType, 'id' | 'title' | 'companyName' | 'applyUrl' | 'location' | 'workMode' | 'seniority' | 'employmentType' | 'salaryMin' | 'salaryMax' | 'salaryCurrency' | 'description' | 'status' | 'publishedAt' | 'expiresAt' | 'createdAt' | 'directionIds' | 'directionTitles' | 'skillIds' | 'skillNames' | 'appliedCount' | 'source' | 'createdByName' | 'reviewedByName' | 'reviewedAt' | 'updatedAt'>
        & { duplicateOf: Array<(
          { __typename?: 'VacancyDuplicateHintType' }
          & Pick<VacancyDuplicateHintType, 'vacancyId' | 'title' | 'companyName' | 'status' | 'score'>
        )> }
      ) }
    )>, pageInfo: (
      { __typename?: 'VacancyPageInfo' }
      & Pick<VacancyPageInfo, 'hasNextPage' | 'endCursor'>
    ) }
  ) }
);

export type ErpVacancyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpVacancyQuery = (
  { __typename?: 'Query' }
  & { careerVacancyErp?: Maybe<(
    { __typename?: 'VacancyType' }
    & Pick<VacancyType, 'id' | 'title' | 'companyName' | 'applyUrl' | 'location' | 'workMode' | 'seniority' | 'employmentType' | 'salaryMin' | 'salaryMax' | 'salaryCurrency' | 'description' | 'status' | 'publishedAt' | 'expiresAt' | 'createdAt' | 'directionIds' | 'directionTitles' | 'skillIds' | 'skillNames' | 'appliedCount' | 'source' | 'createdByName' | 'reviewedByName' | 'reviewedAt' | 'updatedAt'>
    & { duplicateOf: Array<(
      { __typename?: 'VacancyDuplicateHintType' }
      & Pick<VacancyDuplicateHintType, 'vacancyId' | 'title' | 'companyName' | 'status' | 'score'>
    )> }
  )> }
);

export type ErpCareerDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpCareerDashboardQuery = (
  { __typename?: 'Query' }
  & { careerDashboard: (
    { __typename?: 'CareerDashboardType' }
    & Pick<CareerDashboardType, 'members' | 'trained' | 'profileReady' | 'applied' | 'placed' | 'vacanciesPublished' | 'vacanciesDraft' | 'vacanciesDraftFromAgent' | 'oldestDraftDays'>
  ) }
);

export type CareerPlacementQueueQueryVariables = Exact<{ [key: string]: never; }>;


export type CareerPlacementQueueQuery = (
  { __typename?: 'Query' }
  & { careerPlacementConfirmations: Array<(
    { __typename?: 'CareerApplicationType' }
    & Pick<CareerApplicationType, 'id' | 'studentId' | 'studentName' | 'companyName' | 'position' | 'appliedAt' | 'updatedAt'>
  )> }
);

export type ErpCareerSkillsQueryVariables = Exact<{
  category?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
}>;


export type ErpCareerSkillsQuery = (
  { __typename?: 'Query' }
  & { careerSkillsErp: Array<(
    { __typename?: 'SkillType' }
    & Pick<SkillType, 'id' | 'name' | 'slug' | 'category'>
  )> }
);

export type ErpCareerSkillsDictionaryQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
}>;


export type ErpCareerSkillsDictionaryQuery = (
  { __typename?: 'Query' }
  & { careerSkillsErp: Array<(
    { __typename?: 'SkillType' }
    & Pick<SkillType, 'id' | 'name' | 'slug' | 'category' | 'description' | 'aliases' | 'iconUrl' | 'isActive' | 'holderCount' | 'courseCount' | 'demandVacancies' | 'demandComputedAt'>
    & { levelCriteria: Array<(
      { __typename?: 'SkillLevelCriteriaType' }
      & Pick<SkillLevelCriteriaType, 'level' | 'points' | 'example'>
    )> }
  )> }
);

export type ErpCareerCourseSkillSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpCareerCourseSkillSummaryQuery = (
  { __typename?: 'Query' }
  & { careerCourseSkillSummary: Array<(
    { __typename?: 'CourseSkillSummaryType' }
    & Pick<CourseSkillSummaryType, 'courseId' | 'courseName' | 'skillCount' | 'directionTitles'>
  )> }
);

export type ErpCareerCourseSkillsQueryVariables = Exact<{
  courseId?: Maybe<Scalars['ID']>;
}>;


export type ErpCareerCourseSkillsQuery = (
  { __typename?: 'Query' }
  & { careerCourseSkills: Array<(
    { __typename?: 'CourseSkillType' }
    & Pick<CourseSkillType, 'id' | 'courseId' | 'courseName' | 'skillId' | 'skillName' | 'skillCategory' | 'level' | 'unlockLessonNumber' | 'order' | 'isActive'>
  )> }
);

export type ErpCourseProgramLessonsQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type ErpCourseProgramLessonsQuery = (
  { __typename?: 'Query' }
  & { courseProgramLessons: Array<(
    { __typename?: 'CourseProgramLessonType' }
    & Pick<CourseProgramLessonType, 'number' | 'name' | 'moduleName' | 'lessonId' | 'moduleId' | 'marketingModuleId' | 'lmsDescription' | 'taskTypes'>
  )>, courseProgramFrame: (
    { __typename?: 'CourseProgramFrameType' }
    & Pick<CourseProgramFrameType, 'title' | 'hours' | 'description' | 'exists'>
    & { marketingModules: Array<(
      { __typename?: 'MarketingModuleType' }
      & Pick<MarketingModuleType, 'id' | 'name' | 'description'>
    )> }
  ) }
);

export type ErpGroupSkillsQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type ErpGroupSkillsQuery = (
  { __typename?: 'Query' }
  & { careerGroupSkills: Array<(
    { __typename?: 'GroupSkillType' }
    & Pick<GroupSkillType, 'id' | 'groupId' | 'skillId' | 'skillName' | 'skillCategory' | 'level' | 'unlockLessonId' | 'unlockLessonNumber' | 'unlockLessonName' | 'unlockLessonDate' | 'order' | 'isActive'>
  )>, groupProgramLessons: Array<(
    { __typename?: 'GroupProgramLessonType' }
    & Pick<GroupProgramLessonType, 'lessonId' | 'number' | 'name' | 'moduleName' | 'date' | 'isOver'>
  )> }
);

export type ErpCareerStudentCompletionsQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type ErpCareerStudentCompletionsQuery = (
  { __typename?: 'Query' }
  & { careerStudentCompletions: Array<(
    { __typename?: 'CourseCompletionType' }
    & Pick<CourseCompletionType, 'courseId' | 'courseName' | 'groupId' | 'groupName' | 'completed' | 'derived' | 'hasDiploma' | 'manualStatus'>
  )> }
);

export type ErpCareerExerciseVocabularyQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpCareerExerciseVocabularyQuery = (
  { __typename?: 'Query' }
  & { careerExerciseVocabulary: (
    { __typename?: 'ExerciseVocabularyType' }
    & Pick<ExerciseVocabularyType, 'maxFields' | 'maxOptions'>
    & { fieldTypes: Array<(
      { __typename?: 'ExerciseFieldKindType' }
      & Pick<ExerciseFieldKindType, 'value' | 'label' | 'hasOptions'>
    )>, bindings: Array<(
      { __typename?: 'ExerciseBindingType' }
      & Pick<ExerciseBindingType, 'value' | 'label' | 'fieldTypes' | 'isCollection' | 'needsLanguage' | 'subFields'>
    )> }
  ) }
);

export type ErpCareerPromoCampaignsQueryVariables = Exact<{
  includeInactive?: Maybe<Scalars['Boolean']>;
}>;


export type ErpCareerPromoCampaignsQuery = (
  { __typename?: 'Query' }
  & { careerPromoCampaigns: Array<(
    { __typename?: 'PromoCampaignType' }
    & Pick<PromoCampaignType, 'id' | 'code' | 'title' | 'description' | 'prefix' | 'discountKind' | 'discountValue' | 'currency' | 'ttlDays' | 'hardExpiresAt' | 'maxCodes' | 'ruleKind' | 'ruleParams' | 'isActive' | 'issuedCount' | 'redeemedCount'>
  )> }
);

export type ErpCareerPromoCodesQueryVariables = Exact<{
  campaignId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpCareerPromoCodesQuery = (
  { __typename?: 'Query' }
  & { careerPromoCodes: Array<(
    { __typename?: 'PromoCodeErpType' }
    & Pick<PromoCodeErpType, 'id' | 'code' | 'status' | 'studentId' | 'studentName' | 'campaignCode' | 'expiresAt' | 'redeemedAt' | 'agreementId' | 'agreementTitle' | 'isAmbiguous' | 'revokeReason'>
  )> }
);

export type ErpCareerGrowthRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpCareerGrowthRulesQuery = (
  { __typename?: 'Query' }
  & { careerGrowthRules: Array<(
    { __typename?: 'GrowthRuleType' }
    & Pick<GrowthRuleType, 'value' | 'label' | 'paramKey' | 'progressKind'>
  )> }
);

export type ErpCareerGrowthDictionaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpCareerGrowthDictionaryQuery = (
  { __typename?: 'Query' }
  & { careerAchievements: Array<(
    { __typename?: 'AchievementErpType' }
    & Pick<AchievementErpType, 'id' | 'code' | 'title' | 'description' | 'icon' | 'category' | 'points' | 'ruleKind' | 'ruleParams' | 'isSecret' | 'order' | 'isActive' | 'grantedCount'>
  )>, careerGrowthTracks: Array<(
    { __typename?: 'GrowthTrackErpType' }
    & Pick<GrowthTrackErpType, 'id' | 'code' | 'title' | 'description' | 'longDescription' | 'salaryFrom' | 'salaryTo' | 'salaryCurrency' | 'icon' | 'order' | 'isActive' | 'targetSkills' | 'targetSkillIds' | 'siteCourseIds' | 'steps' | 'chosenCount'>
    & { stepRows: Array<(
      { __typename?: 'GrowthStepErpType' }
      & Pick<GrowthStepErpType, 'title' | 'description' | 'ruleKind' | 'ruleParams'>
    )> }
  )>, careerTrackIcons: Array<(
    { __typename?: 'TrackIconType' }
    & Pick<TrackIconType, 'value' | 'label'>
  )> }
);

export type ErpCareerShareTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpCareerShareTemplatesQuery = (
  { __typename?: 'Query' }
  & { careerShareTemplates: Array<(
    { __typename?: 'ShareTemplateType' }
    & Pick<ShareTemplateType, 'channel' | 'language' | 'text' | 'targetUrl' | 'isActive'>
  )> }
);

export type ErpCareerGroupRosterQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpCareerGroupRosterQuery = (
  { __typename?: 'Query' }
  & { careerGroupRoster: Array<(
    { __typename?: 'CareerRosterRowType' }
    & Pick<CareerRosterRowType, 'studentId' | 'fullName' | 'email' | 'groupName' | 'memberStatus'>
  )> }
);

export type ErpCareerExerciseTemplatesQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  includeHidden?: Maybe<Scalars['Boolean']>;
}>;


export type ErpCareerExerciseTemplatesQuery = (
  { __typename?: 'Query' }
  & { careerExerciseTemplates: Array<(
    { __typename?: 'CareerExerciseTemplateType' }
    & Pick<CareerExerciseTemplateType, 'id' | 'title' | 'intro' | 'outro' | 'isActive' | 'hasSubmissions' | 'submissionsCount' | 'lessonTitles' | 'updatedAt'>
    & { fields: Array<(
      { __typename?: 'CareerExerciseFieldType' }
      & Pick<CareerExerciseFieldType, 'id' | 'number' | 'label' | 'helpText' | 'placeholder' | 'fieldType' | 'required' | 'options' | 'maxLength' | 'binding' | 'bindingLanguage'>
    )> }
  )> }
);

export type ErpCareerSiteCoursesQueryVariables = Exact<{
  includeHidden?: Maybe<Scalars['Boolean']>;
}>;


export type ErpCareerSiteCoursesQuery = (
  { __typename?: 'Query' }
  & { careerSiteCourses: Array<(
    { __typename?: 'SiteCourseErpType' }
    & Pick<SiteCourseErpType, 'id' | 'slug' | 'name' | 'order' | 'isActive' | 'erpCourseId' | 'erpCourseName'>
    & { skills: Array<(
      { __typename?: 'SiteCourseSkillErpType' }
      & Pick<SiteCourseSkillErpType, 'skillId' | 'skillName' | 'level'>
    )> }
  )> }
);

export type CashFlowReportQueryVariables = Exact<{
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  grain?: Maybe<Scalars['String']>;
  includeInternal?: Maybe<Scalars['Boolean']>;
}>;


export type CashFlowReportQuery = (
  { __typename?: 'Query' }
  & { cashFlowReport?: Maybe<(
    { __typename?: 'CashFlowReportType' }
    & Pick<CashFlowReportType, 'grain' | 'currency' | 'openingCash' | 'closingCash' | 'asOf' | 'lastPeriodComplete' | 'totalRevenue' | 'totalReturns' | 'totalOutflow' | 'totalOperatingCashFlow' | 'totalFunding' | 'rateMissingCount' | 'internalExcludedCount' | 'monthlyBurnPln' | 'runwayMonths'>
    & { accrual?: Maybe<(
      { __typename?: 'AccrualComparisonType' }
      & Pick<AccrualComparisonType, 'invoiced' | 'received' | 'difference' | 'invoiceCount'>
    )>, periods?: Maybe<Array<Maybe<(
      { __typename?: 'CashFlowPeriodType' }
      & Pick<CashFlowPeriodType, 'key' | 'revenue' | 'returns' | 'outflow' | 'operatingCashFlow' | 'funding' | 'net' | 'cash' | 'rows'>
    )>>>, rows?: Maybe<Array<Maybe<(
      { __typename?: 'CashFlowRowType' }
      & Pick<CashFlowRowType, 'key' | 'label' | 'level' | 'parentKey' | 'section' | 'group' | 'hasChildren' | 'values' | 'total'>
    )>>> }
  )> }
);

export type CashFlowTransactionsQueryVariables = Exact<{
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  categorySlugs?: Maybe<Array<Maybe<Scalars['String']>>>;
  direction?: Maybe<Scalars['String']>;
  uncategorisedOnly?: Maybe<Scalars['Boolean']>;
  needsReview?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type CashFlowTransactionsQuery = (
  { __typename?: 'Query' }
  & { bankTransactions?: Maybe<(
    { __typename?: 'BankTransactionPage' }
    & Pick<BankTransactionPage, 'totalCount' | 'page' | 'perPage'>
    & { summary?: Maybe<(
      { __typename?: 'BankTransactionSummary' }
      & Pick<BankTransactionSummary, 'count' | 'inflowPln' | 'outflowPln'>
    )>, items?: Maybe<Array<Maybe<(
      { __typename?: 'BankTransactionType' }
      & Pick<BankTransactionType, 'pk' | 'bookedAt' | 'amount' | 'currency' | 'balanceAfter' | 'accountName' | 'rawType' | 'description' | 'counterpartyName' | 'categorySlug' | 'categoryName' | 'categorySource' | 'isInternalTransfer' | 'needsReview'>
      & { links?: Maybe<Array<Maybe<(
        { __typename?: 'BankTransactionLinkType' }
        & Pick<BankTransactionLinkType, 'pk' | 'targetType' | 'targetId' | 'targetLabel' | 'matchSource'>
      )>>> }
    )>>> }
  )> }
);

export type CashFlowDictionariesQueryVariables = Exact<{ [key: string]: never; }>;


export type CashFlowDictionariesQuery = (
  { __typename?: 'Query' }
  & { cashFlowCategories?: Maybe<Array<Maybe<(
    { __typename?: 'CashFlowCategoryType' }
    & Pick<CashFlowCategoryType, 'pk' | 'slug' | 'name' | 'group' | 'section' | 'learningPolicy'>
  )>>>, bankAccounts?: Maybe<Array<Maybe<(
    { __typename?: 'BankAccountType' }
    & Pick<BankAccountType, 'pk' | 'slug' | 'name' | 'kind' | 'transactionsCount' | 'netAmountPln'>
  )>>> }
);

export type CashFlowControlQueryVariables = Exact<{ [key: string]: never; }>;


export type CashFlowControlQuery = (
  { __typename?: 'Query' }
  & { cashFlowControl?: Maybe<(
    { __typename?: 'CashFlowControlType' }
    & Pick<CashFlowControlType, 'transactionsCount' | 'uncategorisedCount' | 'internalCount' | 'internalUnpairedCount' | 'needsReviewCount' | 'heuristicDedupCount' | 'rulesTotal' | 'rulesNeedingAttention'>
    & { accounts?: Maybe<Array<Maybe<(
      { __typename?: 'BankAccountType' }
      & Pick<BankAccountType, 'pk' | 'slug' | 'name' | 'iban' | 'transactionsCount' | 'netAmountPln'>
    )>>>, checks?: Maybe<Array<Maybe<(
      { __typename?: 'CashFlowCheckType' }
      & Pick<CashFlowCheckType, 'code' | 'status' | 'detail' | 'subject' | 'count'>
    )>>> }
  )> }
);

export type CashFlowRulesQueryVariables = Exact<{
  isActive?: Maybe<Scalars['Boolean']>;
  health?: Maybe<Scalars['String']>;
  needsAttention?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type CashFlowRulesQuery = (
  { __typename?: 'Query' }
  & { cashFlowRules?: Maybe<Array<Maybe<(
    { __typename?: 'CashFlowRuleType' }
    & Pick<CashFlowRuleType, 'pk' | 'keyKind' | 'keyValue' | 'direction' | 'categorySlug' | 'categoryName' | 'priority' | 'isActive' | 'health' | 'origin' | 'hitsCount' | 'overridesCount' | 'validFrom' | 'validTo'>
  )>>> }
);

export type BankStatementImportsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type BankStatementImportsQuery = (
  { __typename?: 'Query' }
  & { bankStatementImports?: Maybe<Array<Maybe<(
    { __typename?: 'BankStatementImportType' }
    & Pick<BankStatementImportType, 'pk' | 'fileName' | 'status' | 'dryRun' | 'rowsTotal' | 'createdCount' | 'duplicateCount' | 'failedCount' | 'balanceGapCount' | 'periodFrom' | 'periodTo' | 'errorMessage' | 'createdAt' | 'createdByName'>
  )>>> }
);

export type CashFlowSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CashFlowSettingsQuery = (
  { __typename?: 'Query' }
  & { cashFlowSettings?: Maybe<(
    { __typename?: 'CashFlowSettingsType' }
    & Pick<CashFlowSettingsType, 'pk' | 'ownPartyNames' | 'internalTransferAutodetect' | 'internalTransferWindowDays'>
  )> }
);

export type GatewaySettlementsQueryVariables = Exact<{
  status?: Maybe<Scalars['String']>;
}>;


export type GatewaySettlementsQuery = (
  { __typename?: 'Query' }
  & { gatewaySettlements?: Maybe<Array<Maybe<(
    { __typename?: 'GatewaySettlementType' }
    & Pick<GatewaySettlementType, 'pk' | 'provider' | 'merchantCode' | 'externalRef' | 'bookedAt' | 'amountBank' | 'itemsTotal' | 'feeAmount' | 'feeSource' | 'unallocated' | 'status' | 'reasonCode'>
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'GatewaySettlementItemType' }
      & Pick<GatewaySettlementItemType, 'pk' | 'invoiceId' | 'invoiceNumber' | 'kind' | 'amount' | 'matchSource'>
    )>>> }
  )>>> }
);

export type GatewaySettlementCandidatesQueryVariables = Exact<{
  settlementId: Scalars['ID'];
}>;


export type GatewaySettlementCandidatesQuery = (
  { __typename?: 'Query' }
  & { gatewaySettlementCandidates?: Maybe<Array<Maybe<(
    { __typename?: 'GatewaySettlementCandidateType' }
    & Pick<GatewaySettlementCandidateType, 'invoiceId' | 'number' | 'issueDate' | 'amount' | 'preselected' | 'alreadyInSettlementId'>
  )>>> }
);

export type DocumentCashFlowQueryVariables = Exact<{
  targetType: Scalars['String'];
  targetId: Scalars['ID'];
}>;


export type DocumentCashFlowQuery = (
  { __typename?: 'Query' }
  & { documentCashFlow?: Maybe<(
    { __typename?: 'DocumentCashFlowType' }
    & Pick<DocumentCashFlowType, 'status' | 'totalPln' | 'settlementProvider' | 'settlementRef' | 'settlementBookedAt'>
    & { rows?: Maybe<Array<Maybe<(
      { __typename?: 'DocumentCashFlowRowType' }
      & Pick<DocumentCashFlowRowType, 'pk' | 'bookedAt' | 'amount' | 'currency' | 'accountName' | 'description' | 'counterpartyName' | 'matchSource'>
    )>>> }
  )> }
);

export type BankTransactionMatchCandidatesQueryVariables = Exact<{
  transactionId: Scalars['ID'];
}>;


export type BankTransactionMatchCandidatesQuery = (
  { __typename?: 'Query' }
  & { bankTransactionMatchCandidates?: Maybe<Array<Maybe<(
    { __typename?: 'MatchCandidateType' }
    & Pick<MatchCandidateType, 'targetType' | 'targetId' | 'label' | 'amount' | 'confidence' | 'strategy'>
  )>>> }
);

export type StudentConversationsPagedQueryVariables = Exact<{
  studentId: Scalars['ID'];
  kinds?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type StudentConversationsPagedQuery = (
  { __typename?: 'Query' }
  & { studentConversationsPage: (
    { __typename?: 'ConversationConnection' }
    & Pick<ConversationConnection, 'totalCount' | 'totalCountCapped'>
    & { pageInfo?: Maybe<(
      { __typename?: 'MessagePageInfo' }
      & Pick<MessagePageInfo, 'hasNextPage' | 'endCursor'>
    )>, edges?: Maybe<Array<(
      { __typename?: 'ConversationEdge' }
      & Pick<ConversationEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ConversationType' }
        & Pick<ConversationType, 'id' | 'kind' | 'title' | 'displayTitle' | 'externalId' | 'teamId' | 'mailboxEmail' | 'unreadCount' | 'status' | 'hasUnhandled' | 'lastMessageAt'>
      )> }
    )>> }
  ) }
);

export type GroupConversationsPagedQueryVariables = Exact<{
  groupId: Scalars['ID'];
  kinds?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type GroupConversationsPagedQuery = (
  { __typename?: 'Query' }
  & { groupConversationsPage: (
    { __typename?: 'ConversationConnection' }
    & Pick<ConversationConnection, 'totalCount' | 'totalCountCapped'>
    & { pageInfo?: Maybe<(
      { __typename?: 'MessagePageInfo' }
      & Pick<MessagePageInfo, 'hasNextPage' | 'endCursor'>
    )>, edges?: Maybe<Array<(
      { __typename?: 'ConversationEdge' }
      & Pick<ConversationEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ConversationType' }
        & Pick<ConversationType, 'id' | 'kind' | 'title' | 'displayTitle' | 'externalId' | 'teamId' | 'mailboxEmail' | 'unreadCount' | 'status' | 'hasUnhandled' | 'lastMessageAt'>
      )> }
    )>> }
  ) }
);

export type TeacherConversationsPagedQueryVariables = Exact<{
  teacherId: Scalars['ID'];
  kinds?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type TeacherConversationsPagedQuery = (
  { __typename?: 'Query' }
  & { teacherConversationsPage: (
    { __typename?: 'ConversationConnection' }
    & Pick<ConversationConnection, 'totalCount' | 'totalCountCapped'>
    & { pageInfo?: Maybe<(
      { __typename?: 'MessagePageInfo' }
      & Pick<MessagePageInfo, 'hasNextPage' | 'endCursor'>
    )>, edges?: Maybe<Array<(
      { __typename?: 'ConversationEdge' }
      & Pick<ConversationEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ConversationType' }
        & Pick<ConversationType, 'id' | 'kind' | 'title' | 'displayTitle' | 'externalId' | 'teamId' | 'mailboxEmail' | 'unreadCount' | 'status' | 'hasUnhandled' | 'lastMessageAt'>
      )> }
    )>> }
  ) }
);

export type GmailMailboxesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GmailMailboxesListQuery = (
  { __typename?: 'Query' }
  & { gmailMailboxes: Array<(
    { __typename?: 'GmailMailboxType' }
    & Pick<GmailMailboxType, 'id' | 'email' | 'displayName'>
  )> }
);

export type BroadcastJobProgressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BroadcastJobProgressQuery = (
  { __typename?: 'Query' }
  & { broadcastJob?: Maybe<(
    { __typename?: 'BroadcastJobType' }
    & Pick<BroadcastJobType, 'id' | 'status' | 'total' | 'sentCount' | 'failedCount' | 'errorMessage'>
    & { recipients: Array<(
      { __typename?: 'BroadcastRecipientType' }
      & Pick<BroadcastRecipientType, 'id' | 'studentName' | 'status' | 'reason'>
    )> }
  )> }
);

export type GroupSlackChannelsQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupSlackChannelsQuery = (
  { __typename?: 'Query' }
  & { groupSlackChannels: Array<(
    { __typename?: 'GroupChannelRow' }
    & Pick<GroupChannelRow, 'slackChannelId' | 'channelName' | 'teamId' | 'conversationId' | 'unreadCount' | 'hasUnhandled' | 'lastMessageAt'>
  )> }
);

export type ConversationThreadPageQueryVariables = Exact<{
  conversationId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type ConversationThreadPageQuery = (
  { __typename?: 'Query' }
  & { conversationThread: (
    { __typename?: 'MessageConnection' }
    & { edges?: Maybe<Array<(
      { __typename?: 'MessageEdge' }
      & Pick<MessageEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'MessageType' }
        & Pick<MessageType, 'id' | 'direction' | 'authorName' | 'authorDisplay' | 'authorExternalId' | 'kind' | 'body' | 'bodyHtml' | 'sentAt' | 'isHandled'>
        & { attachments: Array<(
          { __typename?: 'MessageAttachmentType' }
          & Pick<MessageAttachmentType, 'index' | 'name' | 'size' | 'mime' | 'contentId' | 'inline'>
        )>, linkedTask?: Maybe<(
          { __typename?: 'StaffTaskType' }
          & Pick<StaffTaskType, 'id' | 'title' | 'status'>
        )> }
      )> }
    )>>, pageInfo?: Maybe<(
      { __typename?: 'MessagePageInfo' }
      & Pick<MessagePageInfo, 'hasNextPage' | 'endCursor'>
    )> }
  ) }
);

export type DashboardConversationsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  unhandledOnly?: Maybe<Scalars['Boolean']>;
  kinds?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type DashboardConversationsQuery = (
  { __typename?: 'Query' }
  & { conversationsBrowser: (
    { __typename?: 'ConversationConnection' }
    & Pick<ConversationConnection, 'totalCount' | 'totalCountCapped'>
    & { edges?: Maybe<Array<(
      { __typename?: 'ConversationEdge' }
      & Pick<ConversationEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ConversationType' }
        & Pick<ConversationType, 'id' | 'kind' | 'displayTitle' | 'mailboxEmail' | 'status' | 'unreadCount' | 'hasUnhandled' | 'lastMessageAt'>
        & { student?: Maybe<(
          { __typename?: 'StudentType' }
          & Pick<StudentType, 'id'>
          & { user?: Maybe<(
            { __typename?: 'CustomUserType' }
            & Pick<CustomUserType, 'id' | 'firstName' | 'lastName'>
          )> }
        )>, group?: Maybe<(
          { __typename?: 'MethodistGroupType' }
          & Pick<MethodistGroupType, 'id' | 'name'>
        )>, workspaceGroup?: Maybe<(
          { __typename?: 'MethodistGroupType' }
          & Pick<MethodistGroupType, 'id' | 'name'>
        )> }
      )> }
    )>>, pageInfo?: Maybe<(
      { __typename?: 'MessagePageInfo' }
      & Pick<MessagePageInfo, 'hasNextPage' | 'endCursor'>
    )> }
  ) }
);

export type GroupCommsIndexBadgesQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupCommsIndexBadgesQuery = (
  { __typename?: 'Query' }
  & { groupCommsIndex: (
    { __typename?: 'GroupCommsIndex' }
    & Pick<GroupCommsIndex, 'groupId' | 'channelsUnread' | 'channelsUnhandled' | 'slackUnreadTotal' | 'mailUnreadTotal' | 'slackUnhandled' | 'mailUnhandled' | 'pendingConversations'>
    & { students: Array<(
      { __typename?: 'StudentCommsBadgeRow' }
      & Pick<StudentCommsBadgeRow, 'studentId' | 'firstName' | 'lastName' | 'email' | 'inRoster' | 'terminated' | 'unread' | 'unreadSlack' | 'unreadMail' | 'unhandled' | 'unhandledSlack' | 'unhandledMail'>
    )>, teachers: Array<(
      { __typename?: 'TeacherCommsBadgeRow' }
      & Pick<TeacherCommsBadgeRow, 'teacherId' | 'firstName' | 'lastName' | 'email' | 'unread' | 'unreadSlack' | 'unreadMail' | 'unhandled' | 'unhandledSlack' | 'unhandledMail'>
    )> }
  ) }
);

export type StudentSlackUserQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type StudentSlackUserQuery = (
  { __typename?: 'Query' }
  & { slackUserLink?: Maybe<(
    { __typename?: 'SlackUserLinkType' }
    & Pick<SlackUserLinkType, 'id' | 'slackUserId' | 'email'>
  )> }
);

export type SlackOauthRedirectUriQueryVariables = Exact<{ [key: string]: never; }>;


export type SlackOauthRedirectUriQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'slackOauthRedirectUri'>
);

export type GroupSlackWorkspaceQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupSlackWorkspaceQuery = (
  { __typename?: 'Query' }
  & { slackWorkspaceLink?: Maybe<(
    { __typename?: 'SlackWorkspaceLinkType' }
    & Pick<SlackWorkspaceLinkType, 'id' | 'teamId' | 'workspaceName' | 'enabled' | 'channelCount' | 'oauthConfigured'>
  )> }
);

export type GroupSlackMembersQueryVariables = Exact<{
  groupId: Scalars['ID'];
  unmatchedOnly?: Maybe<Scalars['Boolean']>;
}>;


export type GroupSlackMembersQuery = (
  { __typename?: 'Query' }
  & { slackWorkspaceMembers: Array<(
    { __typename?: 'SlackUserLinkType' }
    & Pick<SlackUserLinkType, 'id' | 'slackUserId' | 'email' | 'displayName'>
    & { student?: Maybe<(
      { __typename?: 'StudentType' }
      & Pick<StudentType, 'id'>
    )> }
  )> }
);

export type MySlackTokenStatusQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type MySlackTokenStatusQuery = (
  { __typename?: 'Query' }
  & { mySlackUserToken: (
    { __typename?: 'SlackUserTokenStatusType' }
    & Pick<SlackUserTokenStatusType, 'hasToken' | 'slackUserId'>
  ) }
);

export type ConversationReplyIdentityQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type ConversationReplyIdentityQuery = (
  { __typename?: 'Query' }
  & { replyIdentity: (
    { __typename?: 'ReplyIdentityType' }
    & Pick<ReplyIdentityType, 'via' | 'name'>
  ) }
);

export type GroupMessagesFeedQueryVariables = Exact<{
  groupId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  unreadOnly?: Maybe<Scalars['Boolean']>;
  flaggedOnly?: Maybe<Scalars['Boolean']>;
  unhandledOnly?: Maybe<Scalars['Boolean']>;
  channelId?: Maybe<Scalars['ID']>;
}>;


export type GroupMessagesFeedQuery = (
  { __typename?: 'Query' }
  & { groupMessages: (
    { __typename?: 'MessageConnection' }
    & { edges?: Maybe<Array<(
      { __typename?: 'MessageEdge' }
      & Pick<MessageEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'MessageType' }
        & Pick<MessageType, 'id' | 'conversationId' | 'channelName' | 'kind' | 'direction' | 'authorName' | 'authorDisplay' | 'body' | 'sentAt' | 'isRead' | 'isFlagged' | 'isHandled'>
        & { linkedTask?: Maybe<(
          { __typename?: 'StaffTaskType' }
          & Pick<StaffTaskType, 'id' | 'title' | 'status'>
        )> }
      )> }
    )>>, pageInfo?: Maybe<(
      { __typename?: 'MessagePageInfo' }
      & Pick<MessagePageInfo, 'hasNextPage' | 'endCursor'>
    )> }
  ) }
);

export type CommsIntegrationsHealthQueryVariables = Exact<{ [key: string]: never; }>;


export type CommsIntegrationsHealthQuery = (
  { __typename?: 'Query' }
  & { communicationsHealth: (
    { __typename?: 'CommunicationsHealth' }
    & Pick<CommunicationsHealth, 'slackSyncEnabled' | 'gmailSyncEnabled' | 'mailboxesEnabled'>
    & { lastSlackRun?: Maybe<(
      { __typename?: 'CommsSyncRunType' }
      & Pick<CommsSyncRunType, 'status' | 'startedAt' | 'stats' | 'errorMessage'>
    )>, lastGmailRun?: Maybe<(
      { __typename?: 'CommsSyncRunType' }
      & Pick<CommsSyncRunType, 'status' | 'startedAt' | 'stats' | 'errorMessage'>
    )>, groups: Array<(
      { __typename?: 'CommsGroupHealthRow' }
      & Pick<CommsGroupHealthRow, 'groupId' | 'groupName' | 'studentsCount' | 'workspaceLinked' | 'teamId' | 'workspaceEnabled' | 'hasBotToken' | 'realtimeConfigured' | 'hasMyManagerToken' | 'inSyncWindow' | 'channelsLinked' | 'channelsMirrored' | 'membersTotal' | 'membersMatched' | 'slackMessages' | 'mailThreads' | 'lastInboundAt' | 'lastSyncAt' | 'verdict'>
    )> }
  ) }
);

export type MessageInlineImagesListQueryVariables = Exact<{
  messageId: Scalars['ID'];
}>;


export type MessageInlineImagesListQuery = (
  { __typename?: 'Query' }
  & { messageInlineImages: Array<(
    { __typename?: 'MessageInlineImageType' }
    & Pick<MessageInlineImageType, 'cid' | 'url'>
  )> }
);

export type GetAllCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCompaniesQuery = (
  { __typename?: 'Query' }
  & { allCompanies?: Maybe<(
    { __typename?: 'CompanyConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'CompanyEdge' }
      & { node?: Maybe<(
        { __typename?: 'CompanyType' }
        & Pick<CompanyType, 'id' | 'name' | 'comment'>
      )> }
    )>> }
  )> }
);

export type GetCompanyByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyByIdQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'CompanyType' }
    & Pick<CompanyType, 'id' | 'name' | 'responsiblePerson' | 'email' | 'phone' | 'registrationNumber' | 'comment'>
  )> }
);

export type GetCountriesForTeachersQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type GetCountriesForTeachersQuery = (
  { __typename?: 'Query' }
  & { allCountries?: Maybe<(
    { __typename?: 'CountryConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'CountryEdge' }
      & { node?: Maybe<(
        { __typename?: 'CountryType' }
        & Pick<CountryType, 'id' | 'title'>
      )> }
    )>> }
  )> }
);

export type PaginatedCoursesQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type PaginatedCoursesQuery = (
  { __typename?: 'Query' }
  & { allCourses?: Maybe<(
    { __typename?: 'CourseFilterTypeConnection' }
    & Pick<CourseFilterTypeConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'CourseFilterTypeEdge' }
      & Pick<CourseFilterTypeEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'CourseType' }
        & Pick<CourseType, 'id' | 'name' | 'educationForm'>
        & { category?: Maybe<(
          { __typename?: 'CategoryType' }
          & Pick<CategoryType, 'name'>
        )> }
      )> }
    )>> }
  )> }
);

export type GetCoursesForOptionsQueryVariables = Exact<{
  agreementDate: Scalars['Date'];
}>;


export type GetCoursesForOptionsQuery = (
  { __typename?: 'Query' }
  & { allCourses?: Maybe<(
    { __typename?: 'CourseFilterTypeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'CourseFilterTypeEdge' }
      & { node?: Maybe<(
        { __typename?: 'CourseType' }
        & Pick<CourseType, 'id' | 'name'>
        & { groups: (
          { __typename?: 'MethodistGroupTypeConnection' }
          & { edges: Array<Maybe<(
            { __typename?: 'MethodistGroupTypeEdge' }
            & { node?: Maybe<(
              { __typename?: 'MethodistGroupType' }
              & Pick<MethodistGroupType, 'id' | 'name' | 'price' | 'currency'>
            )> }
          )>> }
        ) }
      )> }
    )>> }
  )> }
);

export type GetCoursesForTeacherQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
}>;


export type GetCoursesForTeacherQuery = (
  { __typename?: 'Query' }
  & { allCourses?: Maybe<(
    { __typename?: 'CourseFilterTypeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'CourseFilterTypeEdge' }
      & { node?: Maybe<(
        { __typename?: 'CourseType' }
        & Pick<CourseType, 'id' | 'name'>
      )> }
    )>> }
  )> }
);

export type GetCourseDataForGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCourseDataForGroupQuery = (
  { __typename?: 'Query' }
  & { course?: Maybe<(
    { __typename?: 'CourseType' }
    & Pick<CourseType, 'id' | 'name' | 'price' | 'currency'>
    & { teachers?: Maybe<(
      { __typename?: 'TeacherFilterTypeConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'TeacherFilterTypeEdge' }
        & { node?: Maybe<(
          { __typename?: 'TeacherType' }
          & Pick<TeacherType, 'id' | 'fullName'>
        )> }
      )>> }
    )>, modules: Array<(
      { __typename?: 'CourseModuleType' }
      & Pick<CourseModuleType, 'id' | 'name'>
      & { lessons: (
        { __typename?: 'CourseLessonTypeConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'CourseLessonTypeEdge' }
          & { node?: Maybe<(
            { __typename?: 'CourseLessonType' }
            & Pick<CourseLessonType, 'id' | 'index' | 'name' | 'lmsDescription' | 'taskTypes'>
            & { teacherAttachments: (
              { __typename?: 'TeacherLessonAttachmentsTypeConnection' }
              & { edges: Array<Maybe<(
                { __typename?: 'TeacherLessonAttachmentsTypeEdge' }
                & { node?: Maybe<(
                  { __typename?: 'TeacherLessonAttachmentsType' }
                  & Pick<TeacherLessonAttachmentsType, 'id'>
                )> }
              )>> }
            ), studentAttachments: (
              { __typename?: 'StudentLessonAttachmentsTypeConnection' }
              & { edges: Array<Maybe<(
                { __typename?: 'StudentLessonAttachmentsTypeEdge' }
                & { node?: Maybe<(
                  { __typename?: 'StudentLessonAttachmentsType' }
                  & Pick<StudentLessonAttachmentsType, 'id'>
                )> }
              )>> }
            ) }
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type GetCourseDataForApplicationQueryVariables = Exact<{
  id: Scalars['ID'];
  groupsDate: Scalars['Date'];
}>;


export type GetCourseDataForApplicationQuery = (
  { __typename?: 'Query' }
  & { course?: Maybe<(
    { __typename?: 'CourseType' }
    & { groups: (
      { __typename?: 'MethodistGroupTypeConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'MethodistGroupTypeEdge' }
        & { node?: Maybe<(
          { __typename?: 'MethodistGroupType' }
          & Pick<MethodistGroupType, 'id' | 'name' | 'freeLessonsCount'>
        )> }
      )>> }
    ) }
  )> }
);

export type CourseTariffPricesQueryVariables = Exact<{
  courseId: Scalars['ID'];
}>;


export type CourseTariffPricesQuery = (
  { __typename?: 'Query' }
  & { coursePlanPrices: Array<(
    { __typename?: 'CoursePlanPriceType' }
    & Pick<CoursePlanPriceType, 'id' | 'courseId' | 'planId' | 'planName' | 'planIsActive' | 'currency' | 'amount'>
  )> }
);

export type CourseCardNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CourseCardNameQuery = (
  { __typename?: 'Query' }
  & { course?: Maybe<(
    { __typename?: 'CourseType' }
    & Pick<CourseType, 'id' | 'name'>
  )> }
);

export type KommoLeadListQueryVariables = Exact<{
  statusIds?: Maybe<Array<Scalars['ID']>>;
  responsible?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  includeClosed?: Maybe<Scalars['Boolean']>;
  ladder?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Array<Scalars['String']>>;
  utmMedium?: Maybe<Array<Scalars['String']>>;
  utmCampaign?: Maybe<Array<Scalars['String']>>;
  fundingStatus?: Maybe<Array<Scalars['String']>>;
  hasFunding?: Maybe<Scalars['Boolean']>;
  hasStudent?: Maybe<Scalars['Boolean']>;
  createdFrom?: Maybe<Scalars['Date']>;
  sort?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  nextContact?: Maybe<Scalars['String']>;
  aploraCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
}>;


export type KommoLeadListQuery = (
  { __typename?: 'Query' }
  & { kommoLeads: (
    { __typename?: 'KommoLeadPageType' }
    & Pick<KommoLeadPageType, 'total' | 'source' | 'syncedAt'>
    & { items: Array<(
      { __typename?: 'KommoLeadType' }
      & KommoLeadRowFieldsFragment
    )> }
  ) }
);

export type KommoLeadFacetsQueryVariables = Exact<{
  includeClosed?: Maybe<Scalars['Boolean']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  nextContact?: Maybe<Scalars['String']>;
  aploraCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
}>;


export type KommoLeadFacetsQuery = (
  { __typename?: 'Query' }
  & { kommoLeadFacets: (
    { __typename?: 'KommoLeadFacetsType' }
    & Pick<KommoLeadFacetsType, 'withFunding' | 'withStudent'>
    & { utmSource: Array<(
      { __typename?: 'FacetValueType' }
      & Pick<FacetValueType, 'value' | 'count'>
    )>, utmMedium: Array<(
      { __typename?: 'FacetValueType' }
      & Pick<FacetValueType, 'value' | 'count'>
    )>, utmCampaign: Array<(
      { __typename?: 'FacetValueType' }
      & Pick<FacetValueType, 'value' | 'count'>
    )>, fundingStatus: Array<(
      { __typename?: 'FacetValueType' }
      & Pick<FacetValueType, 'value' | 'count'>
    )> }
  ) }
);

export type KommoLeadStageListQueryVariables = Exact<{ [key: string]: never; }>;


export type KommoLeadStageListQuery = (
  { __typename?: 'Query' }
  & { kommoLeadStages: Array<(
    { __typename?: 'KommoStageType' }
    & Pick<KommoStageType, 'leadsCount'>
    & KommoStageFieldsFragment
  )> }
);

export type KommoLeadCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type KommoLeadCardQuery = (
  { __typename?: 'Query' }
  & { kommoLead?: Maybe<(
    { __typename?: 'KommoLeadType' }
    & KommoLeadCardFieldsFragment
  )> }
);

export type ContractLeadLadderHeadQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContractLeadLadderHeadQuery = (
  { __typename?: 'Query' }
  & { kommoLead?: Maybe<(
    { __typename?: 'KommoLeadType' }
    & Pick<KommoLeadType, 'id' | 'personName' | 'isClosed' | 'inPipeline' | 'isDeleted'>
    & { ladderReadiness: Array<(
      { __typename?: 'LeadLadderReadinessType' }
      & Pick<LeadLadderReadinessType, 'kind' | 'warning' | 'firstSms' | 'firstSmsSegments'>
    )> }
  )> }
);

export type KommoLeadNoteListQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type KommoLeadNoteListQuery = (
  { __typename?: 'Query' }
  & { kommoLeadNotes: (
    { __typename?: 'KommoNotesType' }
    & { items: Array<(
      { __typename?: 'KommoNoteType' }
      & KommoNoteFieldsFragment
    )>, error?: Maybe<(
      { __typename?: 'CrmErrorType' }
      & Pick<CrmErrorType, 'code' | 'message'>
    )> }
  ) }
);

export type KommoLeadEventListQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type KommoLeadEventListQuery = (
  { __typename?: 'Query' }
  & { kommoLeadEvents: Array<(
    { __typename?: 'LeadEventType' }
    & Pick<LeadEventType, 'id' | 'kind' | 'actorName' | 'createdAt' | 'messageId' | 'code'>
  )> }
);

export type LeadSmsStateQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type LeadSmsStateQuery = (
  { __typename?: 'Query' }
  & { kommoLeadSms?: Maybe<(
    { __typename?: 'LeadSmsStateType' }
    & LeadSmsStateFieldsFragment
  )> }
);

export type LeadSmsPreviewQueryVariables = Exact<{
  leadId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<LeadSmsLinkInput>;
}>;


export type LeadSmsPreviewQuery = (
  { __typename?: 'Query' }
  & { previewLeadSms?: Maybe<(
    { __typename?: 'SmsPreviewType' }
    & SmsPreviewFieldsFragment
  )> }
);

export type KommoLeadLadderListQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type KommoLeadLadderListQuery = (
  { __typename?: 'Query' }
  & { kommoLeadLadders: Array<(
    { __typename?: 'LeadLadderRunType' }
    & LeadLadderRunFieldsFragment
  )> }
);

export type KommoLeadThreadListQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type KommoLeadThreadListQuery = (
  { __typename?: 'Query' }
  & { kommoLeadConversations: Array<(
    { __typename?: 'ConversationType' }
    & LeadConversationFieldsFragment
  )> }
);

export type KommoUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type KommoUserListQuery = (
  { __typename?: 'Query' }
  & { kommoUsers: Array<(
    { __typename?: 'KommoUserType' }
    & KommoUserFieldsFragment
  )> }
);

export type KommoSyncStateQueryVariables = Exact<{ [key: string]: never; }>;


export type KommoSyncStateQuery = (
  { __typename?: 'Query' }
  & { kommoSyncStatus: (
    { __typename?: 'KommoSyncStatusType' }
    & KommoSyncStatusFieldsFragment
  ) }
);

export type CandidateSmsStateQueryVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type CandidateSmsStateQuery = (
  { __typename?: 'Query' }
  & { fundingCandidateSms?: Maybe<(
    { __typename?: 'LeadSmsStateType' }
    & LeadSmsStateFieldsFragment
  )> }
);

export type CandidateSmsPreviewQueryVariables = Exact<{
  candidateId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<LeadSmsLinkInput>;
}>;


export type CandidateSmsPreviewQuery = (
  { __typename?: 'Query' }
  & { previewFundingCandidateSms?: Maybe<(
    { __typename?: 'SmsPreviewType' }
    & SmsPreviewFieldsFragment
  )> }
);

export type PaletteLeadsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
}>;


export type PaletteLeadsQuery = (
  { __typename?: 'Query' }
  & { kommoLeads: (
    { __typename?: 'KommoLeadPageType' }
    & { items: Array<(
      { __typename?: 'KommoLeadType' }
      & Pick<KommoLeadType, 'id' | 'name' | 'personName' | 'phone' | 'email' | 'isClosed'>
      & { stage?: Maybe<(
        { __typename?: 'KommoStageType' }
        & Pick<KommoStageType, 'id' | 'name'>
      )> }
    )> }
  ) }
);

export type KommoLeadBoardColumnQueryVariables = Exact<{
  statusIds?: Maybe<Array<Scalars['ID']>>;
  responsible?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  includeClosed?: Maybe<Scalars['Boolean']>;
  ladder?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Array<Scalars['String']>>;
  utmMedium?: Maybe<Array<Scalars['String']>>;
  utmCampaign?: Maybe<Array<Scalars['String']>>;
  fundingStatus?: Maybe<Array<Scalars['String']>>;
  hasFunding?: Maybe<Scalars['Boolean']>;
  hasStudent?: Maybe<Scalars['Boolean']>;
  createdFrom?: Maybe<Scalars['Date']>;
  sort?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  nextContact?: Maybe<Scalars['String']>;
  aploraCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
}>;


export type KommoLeadBoardColumnQuery = (
  { __typename?: 'Query' }
  & { kommoLeads: (
    { __typename?: 'KommoLeadPageType' }
    & Pick<KommoLeadPageType, 'total'>
    & { items: Array<(
      { __typename?: 'KommoLeadType' }
      & KommoLeadBoardFieldsFragment
    )> }
  ) }
);

export type KommoLeadStageTotalsQueryVariables = Exact<{
  responsible?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  includeClosed?: Maybe<Scalars['Boolean']>;
  ladder?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Array<Scalars['String']>>;
  utmMedium?: Maybe<Array<Scalars['String']>>;
  utmCampaign?: Maybe<Array<Scalars['String']>>;
  fundingStatus?: Maybe<Array<Scalars['String']>>;
  hasFunding?: Maybe<Scalars['Boolean']>;
  hasStudent?: Maybe<Scalars['Boolean']>;
  createdFrom?: Maybe<Scalars['Date']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  nextContact?: Maybe<Scalars['String']>;
  aploraCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  hotMinWinChance?: Maybe<Scalars['Float']>;
}>;


export type KommoLeadStageTotalsQuery = (
  { __typename?: 'Query' }
  & { kommoLeadStageCounts: Array<(
    { __typename?: 'KommoLeadStageCountType' }
    & Pick<KommoLeadStageCountType, 'statusId' | 'count' | 'priceSum' | 'hotCount'>
  )> }
);

export type KommoLeadsCreatedRecentlyQueryVariables = Exact<{
  statusIds?: Maybe<Array<Scalars['ID']>>;
  responsible?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  includeClosed?: Maybe<Scalars['Boolean']>;
  ladder?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Array<Scalars['String']>>;
  utmMedium?: Maybe<Array<Scalars['String']>>;
  utmCampaign?: Maybe<Array<Scalars['String']>>;
  fundingStatus?: Maybe<Array<Scalars['String']>>;
  hasFunding?: Maybe<Scalars['Boolean']>;
  hasStudent?: Maybe<Scalars['Boolean']>;
  createdFrom: Scalars['Date'];
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  nextContact?: Maybe<Scalars['String']>;
  aploraCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
}>;


export type KommoLeadsCreatedRecentlyQuery = (
  { __typename?: 'Query' }
  & { kommoLeads: (
    { __typename?: 'KommoLeadPageType' }
    & Pick<KommoLeadPageType, 'total'>
  ) }
);

export type KommoLossReasonListQueryVariables = Exact<{ [key: string]: never; }>;


export type KommoLossReasonListQuery = (
  { __typename?: 'Query' }
  & { kommoLossReasons: (
    { __typename?: 'KommoLossReasonsType' }
    & { items: Array<(
      { __typename?: 'KommoLossReasonType' }
      & Pick<KommoLossReasonType, 'id' | 'name' | 'sort'>
    )>, error?: Maybe<(
      { __typename?: 'CrmErrorType' }
      & Pick<CrmErrorType, 'code' | 'message'>
    )> }
  ) }
);

export type KommoResponsibleListQueryVariables = Exact<{ [key: string]: never; }>;


export type KommoResponsibleListQuery = (
  { __typename?: 'Query' }
  & { kommoLeadResponsibles: Array<(
    { __typename?: 'KommoResponsibleOptionType' }
    & Pick<KommoResponsibleOptionType, 'id' | 'kommoId' | 'name' | 'erpUserId' | 'erpUserName'>
  )> }
);

export type KommoLeadAssignmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type KommoLeadAssignmentQuery = (
  { __typename?: 'Query' }
  & { kommoLead?: Maybe<(
    { __typename?: 'KommoLeadType' }
    & Pick<KommoLeadType, 'id' | 'responsibleId' | 'stageEnteredAt' | 'price' | 'courseRaw'>
  )> }
);

export type MarketingLeadListQueryVariables = Exact<{
  filter: MarketingFilter;
  channel?: Maybe<Scalars['String']>;
  subChannel?: Maybe<Scalars['String']>;
  campaign?: Maybe<Scalars['ID']>;
  family?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  includeRepeats?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type MarketingLeadListQuery = (
  { __typename?: 'Query' }
  & { marketingLeads: (
    { __typename?: 'MarketingLeadsPage' }
    & Pick<MarketingLeadsPage, 'total'>
    & { items: Array<(
      { __typename?: 'MarketingLeadRow' }
      & Pick<MarketingLeadRow, 'kommoLeadId' | 'kommoId' | 'personName' | 'isClosed' | 'responsibleName' | 'channel' | 'subChannel' | 'campaignId' | 'campaignName' | 'familySlug' | 'offer' | 'device' | 'isRepeat' | 'createdAt' | 'hasContract' | 'contractSigned' | 'hasSale' | 'salePrice' | 'saleCurrency' | 'salePricePln' | 'visitsBefore'>
      & { stage?: Maybe<(
        { __typename?: 'LeadStageRef' }
        & Pick<LeadStageRef, 'id' | 'name' | 'color'>
      )> }
    )> }
  ) }
);

export type LeadJourneyTimelineQueryVariables = Exact<{
  kommoLeadId: Scalars['ID'];
}>;


export type LeadJourneyTimelineQuery = (
  { __typename?: 'Query' }
  & { leadJourney?: Maybe<(
    { __typename?: 'LeadJourney' }
    & { lead: (
      { __typename?: 'LeadJourneyLead' }
      & Pick<LeadJourneyLead, 'kommoLeadId' | 'kommoId' | 'personName' | 'name' | 'phone' | 'email' | 'isClosed' | 'responsibleName' | 'createdAt' | 'courseRaw' | 'kommoUrl'>
      & { stage?: Maybe<(
        { __typename?: 'LeadStageRef' }
        & Pick<LeadStageRef, 'id' | 'name' | 'color'>
      )> }
    ), events: Array<(
      { __typename?: 'LeadJourneyEvent' }
      & Pick<LeadJourneyEvent, 'at' | 'kind' | 'title' | 'detail' | 'channel' | 'tone' | 'meta'>
    )> }
  )> }
);

export type LeadAploraCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LeadAploraCardQuery = (
  { __typename?: 'Query' }
  & { kommoLead?: Maybe<(
    { __typename?: 'KommoLeadType' }
    & Pick<KommoLeadType, 'id'>
    & { aplora?: Maybe<(
      { __typename?: 'AploraLeadType' }
      & Pick<AploraLeadType, 'aploraUrl' | 'crmUrl' | 'changedAt' | 'syncedAt' | 'stale' | 'error' | 'deleted' | 'mergedIntoKommoId' | 'status' | 'stage' | 'daysInFunnel' | 'managerName' | 'summaryMd' | 'summaryText' | 'outcomeSummaryText' | 'lastContactAt' | 'nextContactDate' | 'nextContactTip' | 'callsTotal' | 'callsAnalyzed' | 'learn' | 'managerRisks' | 'profile' | 'outcome' | 'dealAmount' | 'lossReasons' | 'consent' | 'externalFactors' | 'acquisitionChannel' | 'lastCall'>
      & { scoring: (
        { __typename?: 'AploraScoringType' }
        & Pick<AploraScoringType, 'winChance' | 'winTier' | 'leadCategory' | 'leadTemperature' | 'learnScore' | 'qualificationCompleteness' | 'dealProbability' | 'avgManagerScore'>
      ), calls: Array<(
        { __typename?: 'AploraCallBriefType' }
        & Pick<AploraCallBriefType, 'callId' | 'startedAt' | 'durationSeconds' | 'direction' | 'managerName' | 'analyzed' | 'baseScore' | 'growthScore' | 'scoreBand' | 'summaryText'>
      )> }
    )> }
  )> }
);

export type LeadAploraCallReviewQueryVariables = Exact<{
  leadId: Scalars['ID'];
  callId: Scalars['ID'];
}>;


export type LeadAploraCallReviewQuery = (
  { __typename?: 'Query' }
  & { aploraCallAnalysis?: Maybe<(
    { __typename?: 'AploraCallAnalysisType' }
    & Pick<AploraCallAnalysisType, 'callId' | 'aploraUrl' | 'startedAt' | 'durationSeconds' | 'managerName' | 'baseScore' | 'growthScore' | 'scoreBand' | 'summaryMd' | 'summaryText' | 'managerFeedback' | 'managerSummary' | 'didWell' | 'mistakes' | 'growthPoints' | 'nextCallRecommendations' | 'redFlags'>
  )> }
);

export type LeadAploraCallTextQueryVariables = Exact<{
  leadId: Scalars['ID'];
  callId: Scalars['ID'];
}>;


export type LeadAploraCallTextQuery = (
  { __typename?: 'Query' }
  & { aploraCallTranscript?: Maybe<(
    { __typename?: 'AploraTranscriptType' }
    & Pick<AploraTranscriptType, 'callId' | 'transcript'>
  )> }
);

export type LeadSavedViewsQueryVariables = Exact<{
  scope?: Maybe<Scalars['String']>;
}>;


export type LeadSavedViewsQuery = (
  { __typename?: 'Query' }
  & { leadSavedViews: Array<(
    { __typename?: 'LeadSavedViewType' }
    & Pick<LeadSavedViewType, 'id' | 'name' | 'filters' | 'view' | 'shared' | 'isMine' | 'position' | 'scope'>
  )> }
);

export type GroupsOverviewListQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  onlyIssues?: Maybe<Scalars['Boolean']>;
  activeWithinDays?: Maybe<Scalars['Int']>;
}>;


export type GroupsOverviewListQuery = (
  { __typename?: 'Query' }
  & { groupsOverview: Array<(
    { __typename?: 'GroupOverviewRow' }
    & Pick<GroupOverviewRow, 'groupId' | 'name' | 'course' | 'startDate' | 'lastLessonDate' | 'studentsCount' | 'debtorsCount' | 'unhandledStudentsCount' | 'unreadStudentsCount' | 'unreadMessagesCount' | 'unreadSlackCount' | 'unreadMailCount' | 'unhandledSlackCount' | 'unhandledMailCount' | 'openTasksCount' | 'overdueTasksCount'>
    & { debtAmounts: Array<(
      { __typename?: 'LmsAmountDueType' }
      & Pick<LmsAmountDueType, 'currency' | 'amount'>
    )>, upcomingAmounts: Array<(
      { __typename?: 'LmsAmountDueType' }
      & Pick<LmsAmountDueType, 'currency' | 'amount'>
    )> }
  )> }
);

export type PaginatedContributionsQueryVariables = Exact<{
  contributionNum?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
}>;


export type PaginatedContributionsQuery = (
  { __typename?: 'Query' }
  & { allContributions?: Maybe<(
    { __typename?: 'ContributionConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'ContributionEdge' }
      & Pick<ContributionEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ContributionType' }
        & Pick<ContributionType, 'id' | 'date' | 'complete' | 'delay' | 'remainder' | 'amountByn' | 'amountForeign' | 'agreementTitle'>
        & { person?: Maybe<(
          { __typename?: 'Person' }
          & Pick<Person, 'firstName' | 'lastName' | 'middleName' | 'phone'>
        )>, agreement: (
          { __typename?: 'AgreementType' }
          & Pick<AgreementType, 'currency'>
        ), group?: Maybe<(
          { __typename?: 'GroupsType' }
          & Pick<GroupsType, 'id' | 'name'>
        )> }
      )> }
    )>> }
  )> }
);

export type DebtorsMetaQueryVariables = Exact<{
  contributionNum?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
}>;


export type DebtorsMetaQuery = (
  { __typename?: 'Query' }
  & { metaContributions?: Maybe<(
    { __typename?: 'MetaContribution' }
    & Pick<MetaContribution, 'totalCount'>
  )> }
);

export type GetContributionsMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContributionsMetaQuery = (
  { __typename?: 'Query' }
  & { metaContributions?: Maybe<(
    { __typename?: 'MetaContribution' }
    & Pick<MetaContribution, 'contributionsNums'>
  )> }
);

export type ErpGroupDiplomasQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type ErpGroupDiplomasQuery = (
  { __typename?: 'Query' }
  & { groupDiplomas: Array<(
    { __typename?: 'GroupDiplomaRowType' }
    & Pick<GroupDiplomaRowType, 'agreementTitle' | 'graduationProjectMark' | 'hasGraduationProjectLesson'>
    & { student: (
      { __typename?: 'DiplomaStudentType' }
      & Pick<DiplomaStudentType, 'id' | 'firstName' | 'lastName' | 'fullName' | 'email'>
    ), pl?: Maybe<(
      { __typename?: 'DiplomaType' }
      & Pick<DiplomaType, 'id' | 'pk' | 'language' | 'source' | 'originalName' | 'contentType' | 'sizeBytes' | 'version' | 'uploadedAt' | 'uploadedByName'>
    )>, en?: Maybe<(
      { __typename?: 'DiplomaType' }
      & Pick<DiplomaType, 'id' | 'pk' | 'language' | 'source' | 'originalName' | 'contentType' | 'sizeBytes' | 'version' | 'uploadedAt' | 'uploadedByName'>
    )> }
  )> }
);

export type ErpDiplomaDownloadUrlQueryVariables = Exact<{
  diplomaId: Scalars['ID'];
}>;


export type ErpDiplomaDownloadUrlQuery = (
  { __typename?: 'Query' }
  & { diplomaDownloadUrl?: Maybe<(
    { __typename?: 'DiplomaDownloadUrlType' }
    & Pick<DiplomaDownloadUrlType, 'url' | 'expiresAt'>
  )> }
);

export type DocTemplatesListQueryVariables = Exact<{
  kind?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
}>;


export type DocTemplatesListQuery = (
  { __typename?: 'Query' }
  & { documentTemplates: Array<(
    { __typename?: 'DocumentTemplateType' }
    & Pick<DocumentTemplateType, 'id' | 'code' | 'name' | 'kind' | 'scope' | 'isActive' | 'legalEntityId' | 'legalEntityName' | 'version' | 'currentVersionId' | 'createdAt' | 'updatedAt' | 'updatedByName'>
    & { versions: Array<(
      { __typename?: 'DocumentTemplateVersionType' }
      & Pick<DocumentTemplateVersionType, 'id' | 'version' | 'origin' | 'comment' | 'createdAt' | 'createdByName' | 'isCurrent'>
    )> }
  )> }
);

export type DocTemplateEditorSourceQueryVariables = Exact<{
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
}>;


export type DocTemplateEditorSourceQuery = (
  { __typename?: 'Query' }
  & { documentTemplateEditable?: Maybe<(
    { __typename?: 'DocumentTemplateEditableType' }
    & Pick<DocumentTemplateEditableType, 'html'>
    & { template: (
      { __typename?: 'DocumentTemplateType' }
      & Pick<DocumentTemplateType, 'id' | 'code' | 'name' | 'kind' | 'scope' | 'isActive' | 'legalEntityId' | 'legalEntityName' | 'version' | 'currentVersionId' | 'createdAt' | 'updatedAt' | 'updatedByName'>
    ), tokens: Array<(
      { __typename?: 'ContractTemplateTokenType' }
      & Pick<ContractTemplateTokenType, 'n' | 'kind' | 'role' | 'code' | 'label' | 'labelPl' | 'removable' | 'placement'>
    )>, variables: Array<(
      { __typename?: 'ContractTemplateVariableType' }
      & Pick<ContractTemplateVariableType, 'code' | 'group' | 'label' | 'labelPl' | 'groupLabel' | 'groupLabelPl'>
    )> }
  )> }
);

export type DocTemplateDraftSampleQueryVariables = Exact<{
  id: Scalars['ID'];
  html: Scalars['String'];
}>;


export type DocTemplateDraftSampleQuery = (
  { __typename?: 'Query' }
  & { documentTemplatePreviewDraft: (
    { __typename?: 'DocumentPreviewDraftType' }
    & Pick<DocumentPreviewDraftType, 'html'>
    & { problems: Array<(
      { __typename?: 'ContractTemplateProblemType' }
      & Pick<ContractTemplateProblemType, 'code' | 'message' | 'token'>
    )> }
  ) }
);

export type DocIssuePreviewQueryVariables = Exact<{
  templateId: Scalars['ID'];
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  issuePlace?: Maybe<Scalars['String']>;
}>;


export type DocIssuePreviewQuery = (
  { __typename?: 'Query' }
  & { previewDocument: (
    { __typename?: 'DocumentPreviewType' }
    & Pick<DocumentPreviewType, 'html' | 'numberPreview' | 'errorCode' | 'errorMessage'>
    & { missingFields: Array<(
      { __typename?: 'DocumentMissingFieldType' }
      & Pick<DocumentMissingFieldType, 'code' | 'label' | 'labelPl'>
    )>, hiddenFields: Array<(
      { __typename?: 'DocumentMissingFieldType' }
      & Pick<DocumentMissingFieldType, 'code' | 'label' | 'labelPl'>
    )> }
  ) }
);

export type IssuedDocsHistoryQueryVariables = Exact<{
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
}>;


export type IssuedDocsHistoryQuery = (
  { __typename?: 'Query' }
  & { issuedDocuments: Array<(
    { __typename?: 'IssuedDocumentType' }
    & Pick<IssuedDocumentType, 'id' | 'number' | 'kind' | 'scope' | 'templateId' | 'templateName' | 'templateVersion' | 'studentId' | 'studentName' | 'agreementId' | 'agreementTitle' | 'groupId' | 'groupName' | 'issueDate' | 'issuePlace' | 'issuedAt' | 'issuedByName' | 'missingFields' | 'hiddenFields' | 'hasFile'>
    & { sends: Array<(
      { __typename?: 'IssuedDocumentSendType' }
      & Pick<IssuedDocumentSendType, 'id' | 'sentAt' | 'sentTo' | 'sentByName' | 'mailboxEmail' | 'conversationId'>
    )> }
  )> }
);

export type IssuedDocFileDownloadQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IssuedDocFileDownloadQuery = (
  { __typename?: 'Query' }
  & { issuedDocumentFile?: Maybe<(
    { __typename?: 'DocumentFileType' }
    & Pick<DocumentFileType, 'fileName' | 'contentType' | 'contentBase64'>
  )> }
);

export type DocSendDraftQueryVariables = Exact<{
  issuedDocumentId: Scalars['ID'];
}>;


export type DocSendDraftQuery = (
  { __typename?: 'Query' }
  & { documentSendDefaults: (
    { __typename?: 'DocumentSendDefaultsType' }
    & Pick<DocumentSendDefaultsType, 'to' | 'subject' | 'html' | 'mailboxEmail' | 'mailboxes'>
  ) }
);

export type ErpFundingOperatorsQueryVariables = Exact<{
  programType?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  powiatId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  pageChanged?: Maybe<Scalars['Boolean']>;
  pageSegment?: Maybe<Scalars['String']>;
  intakeConfirmation?: Maybe<Scalars['String']>;
  clientType?: Maybe<Scalars['String']>;
  intakePeriod?: Maybe<Scalars['String']>;
  urlSuspect?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ErpFundingOperatorsQuery = (
  { __typename?: 'Query' }
  & { fundingOperators: Array<(
    { __typename?: 'FundingOperatorType' }
    & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'programName' | 'projectNumber' | 'isActive' | 'coverageScope' | 'powiatsUnresolved' | 'maxAmount' | 'maxAmountCurrency' | 'ownContributionPercent' | 'paymentMethod' | 'decisionDays' | 'rollingIntake' | 'acceptsUnemployed' | 'acceptsEmployerApplications' | 'supportsDisabled' | 'supportsAge50Plus' | 'greenCompetences' | 'servedStatuses' | 'instructionUrl' | 'instructionReady' | 'projectUrl' | 'newsUrl' | 'documentsUrl' | 'pageState' | 'hasConfirmedIntake' | 'clientType' | 'intakePeriod' | 'nameSaysB2b' | 'urlSuspect' | 'pageLinksCount' | 'pageChanged' | 'pageChangedAt' | 'pageHashCheckedAt' | 'pageCheckedOkAt' | 'lastNotifiedAt' | 'phone' | 'email' | 'comment' | 'internalNote' | 'candidatesCount'>
    & { voivodeship?: Maybe<(
      { __typename?: 'VoivodeshipType' }
      & Pick<VoivodeshipType, 'id' | 'name'>
    )>, powiats: Array<(
      { __typename?: 'PowiatType' }
      & Pick<PowiatType, 'id' | 'name' | 'code' | 'kind' | 'voivodeshipName'>
    )>, currentIntake?: Maybe<(
      { __typename?: 'FundingIntakeType' }
      & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'startsAtTime' | 'endsAtTime' | 'status' | 'phase' | 'daysLeft' | 'confirmedAt' | 'confirmedByName'>
    )> }
  )> }
);

export type ErpFundingCandidatesQueryVariables = Exact<{
  status?: Maybe<Scalars['String']>;
  statusGroup?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  matchStatus?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  isStudent?: Maybe<Scalars['Boolean']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  employmentStatus?: Maybe<Scalars['String']>;
  needsAttention?: Maybe<Scalars['Boolean']>;
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  needsOperatorReview?: Maybe<Scalars['Boolean']>;
  operatorMatch?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ErpFundingCandidatesQuery = (
  { __typename?: 'Query' }
  & { fundingCandidates: Array<(
    { __typename?: 'FundingCandidateType' }
    & Pick<FundingCandidateType, 'id' | 'fullName' | 'email' | 'phone' | 'status' | 'statusChangedAt' | 'outcome' | 'employmentStatus' | 'city' | 'isDeposit' | 'needsAttention' | 'attentionNote' | 'matchStatus' | 'isStudent' | 'studentId' | 'linkedUserName' | 'linkedUserEmail' | 'powiatRaw' | 'activeOperatorsCount' | 'disabledOperatorsCount'>
    & { voivodeship?: Maybe<(
      { __typename?: 'VoivodeshipType' }
      & Pick<VoivodeshipType, 'id' | 'name'>
    )>, powiat?: Maybe<(
      { __typename?: 'PowiatType' }
      & Pick<PowiatType, 'id' | 'name'>
    )>, primaryOperator?: Maybe<(
      { __typename?: 'FundingOperatorType' }
      & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
    )>, operators: Array<(
      { __typename?: 'FundingOperatorType' }
      & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
    )> }
  )> }
);

export type ErpFundingCandidateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpFundingCandidateQuery = (
  { __typename?: 'Query' }
  & { fundingCandidate?: Maybe<(
    { __typename?: 'FundingCandidateType' }
    & Pick<FundingCandidateType, 'id' | 'fullName' | 'firstName' | 'lastName' | 'email' | 'phone' | 'status' | 'statusChangedAt' | 'outcome' | 'declineReason' | 'appliedAt' | 'decisionAt' | 'approvedAmount' | 'ownContributionAmount' | 'currency' | 'city' | 'powiatRaw' | 'isDeposit' | 'needsAttention' | 'attentionNote' | 'attentionSetByName' | 'attentionSetAt' | 'attentionTaskId' | 'testDrive' | 'reminderAt' | 'taskNote' | 'notes' | 'courseName' | 'courseId' | 'desiredStartMonth' | 'assignedToName' | 'employmentStatus' | 'isUnemployed' | 'isAdult' | 'is50Plus' | 'hasEmployer' | 'kfsGeoBasis' | 'employerName' | 'employerSameVoivodeship' | 'hasDisabilityCertificate' | 'inFinancialHardship' | 'usedFundingBefore' | 'employerCanApply' | 'jdgSuspended' | 'preferredTracks' | 'matchStatus' | 'matchRule' | 'userLocked' | 'linkedUserId' | 'linkedUserName' | 'linkedUserEmail' | 'isStudent' | 'studentId' | 'agreementTitle' | 'legalEntityName' | 'source' | 'isArchived' | 'supportId' | 'createdAt' | 'activeOperatorsCount' | 'disabledOperatorsCount'>
    & { nextIntake?: Maybe<(
      { __typename?: 'FundingIntakeType' }
      & Pick<FundingIntakeType, 'id' | 'startsOn' | 'operatorId' | 'operatorName'>
    )>, intake?: Maybe<(
      { __typename?: 'FundingIntakeType' }
      & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
    )>, employerVoivodeship?: Maybe<(
      { __typename?: 'VoivodeshipType' }
      & Pick<VoivodeshipType, 'id' | 'name'>
    )>, employerPowiat?: Maybe<(
      { __typename?: 'PowiatType' }
      & Pick<PowiatType, 'id' | 'name'>
    )>, duplicateCandidates: Array<(
      { __typename?: 'DuplicateCandidateType' }
      & Pick<DuplicateCandidateType, 'id' | 'fullName' | 'status' | 'createdAt'>
    )>, voivodeship?: Maybe<(
      { __typename?: 'VoivodeshipType' }
      & Pick<VoivodeshipType, 'id' | 'name'>
    )>, powiat?: Maybe<(
      { __typename?: 'PowiatType' }
      & Pick<PowiatType, 'id' | 'name'>
    )>, primaryOperator?: Maybe<(
      { __typename?: 'FundingOperatorType' }
      & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType' | 'ownContributionPercent' | 'decisionDays' | 'coverageScope' | 'instructionUrl' | 'instructionReady'>
      & { voivodeship?: Maybe<(
        { __typename?: 'VoivodeshipType' }
        & Pick<VoivodeshipType, 'id' | 'name'>
      )>, powiats: Array<(
        { __typename?: 'PowiatType' }
        & Pick<PowiatType, 'id' | 'name' | 'kind' | 'voivodeshipName'>
      )>, currentIntake?: Maybe<(
        { __typename?: 'FundingIntakeType' }
        & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
      )> }
    )>, operators: Array<(
      { __typename?: 'FundingOperatorType' }
      & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType'>
    )>, operatorLinks: Array<(
      { __typename?: 'CandidateOperatorLinkType' }
      & Pick<CandidateOperatorLinkType, 'id' | 'isActive' | 'isPrimary' | 'source' | 'addedAt' | 'addedByName' | 'deactivatedAt' | 'deactivatedByName' | 'deactivationReason' | 'deactivationReasonLabel' | 'note'>
      & { operator: (
        { __typename?: 'FundingOperatorType' }
        & Pick<FundingOperatorType, 'id' | 'name' | 'programName' | 'programType' | 'clientType' | 'ownContributionPercent' | 'decisionDays' | 'coverageScope' | 'rollingIntake' | 'instructionUrl' | 'instructionReady'>
        & { voivodeship?: Maybe<(
          { __typename?: 'VoivodeshipType' }
          & Pick<VoivodeshipType, 'id' | 'name'>
        )>, powiats: Array<(
          { __typename?: 'PowiatType' }
          & Pick<PowiatType, 'id' | 'name' | 'kind' | 'voivodeshipName'>
        )>, currentIntake?: Maybe<(
          { __typename?: 'FundingIntakeType' }
          & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
        )> }
      ) }
    )>, events: Array<(
      { __typename?: 'CandidateEventType' }
      & Pick<CandidateEventType, 'id' | 'fromStatus' | 'toStatus' | 'fromOperatorId' | 'fromOperatorName' | 'toOperatorId' | 'toOperatorName' | 'changedByName' | 'changedAt' | 'note'>
    )>, kommoLeads: Array<(
      { __typename?: 'PersonKommoLeadType' }
      & PersonKommoLeadFieldsFragment
    )> }
  )> }
);

export type ErpFundingBoardQueryVariables = Exact<{
  operatorId?: Maybe<Scalars['ID']>;
  matchStatus?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  isStudent?: Maybe<Scalars['Boolean']>;
  employmentStatus?: Maybe<Scalars['String']>;
  needsAttention?: Maybe<Scalars['Boolean']>;
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  needsOperatorReview?: Maybe<Scalars['Boolean']>;
  operatorMatch?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpFundingBoardQuery = (
  { __typename?: 'Query' }
  & { fundingBoard: (
    { __typename?: 'FundingBoardType' }
    & Pick<FundingBoardType, 'total' | 'ambiguousMatches' | 'duplicateSubmissions' | 'unresolvedPlaces' | 'depositWaiting' | 'pageChangedOperators' | 'suspiciousUrls' | 'operatorMissing' | 'submissionsNeedOperator' | 'needsAttention'>
    & { groups: Array<(
      { __typename?: 'StatusGroupType' }
      & Pick<StatusGroupType, 'key' | 'title' | 'statuses' | 'count'>
    )>, stages: Array<(
      { __typename?: 'StatusGroupType' }
      & Pick<StatusGroupType, 'key' | 'title' | 'statuses' | 'count'>
    )>, buckets: Array<(
      { __typename?: 'StatusBucketType' }
      & Pick<StatusBucketType, 'status' | 'count'>
    )> }
  ) }
);

export type ErpFundingCandidateKfsBasisQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpFundingCandidateKfsBasisQuery = (
  { __typename?: 'Query' }
  & { fundingCandidate?: Maybe<(
    { __typename?: 'FundingCandidateType' }
    & Pick<FundingCandidateType, 'id' | 'employmentStatus' | 'kfsGeoBasis'>
  )> }
);

export type ErpOperatorsForCandidateQueryVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type ErpOperatorsForCandidateQuery = (
  { __typename?: 'Query' }
  & { operatorsForCandidate: Array<(
    { __typename?: 'FundingOperatorType' }
    & Pick<FundingOperatorType, 'id' | 'name' | 'programName' | 'programType' | 'paymentMethod' | 'maxAmount' | 'ownContributionPercent' | 'decisionDays' | 'rollingIntake' | 'instructionReady' | 'clientType' | 'intakePeriod' | 'coverageScope'>
    & { voivodeship?: Maybe<(
      { __typename?: 'VoivodeshipType' }
      & Pick<VoivodeshipType, 'id' | 'name'>
    )>, powiats: Array<(
      { __typename?: 'PowiatType' }
      & Pick<PowiatType, 'id' | 'name' | 'kind' | 'voivodeshipName'>
    )>, currentIntake?: Maybe<(
      { __typename?: 'FundingIntakeType' }
      & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
    )> }
  )> }
);

export type ErpFundingDictionariesQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpFundingDictionariesQuery = (
  { __typename?: 'Query' }
  & { fundingVoivodeships: Array<(
    { __typename?: 'VoivodeshipType' }
    & Pick<VoivodeshipType, 'id' | 'code' | 'name'>
  )> }
);

export type ErpFundingPowiatsQueryVariables = Exact<{
  voivodeshipId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpFundingPowiatsQuery = (
  { __typename?: 'Query' }
  & { fundingPowiats: Array<(
    { __typename?: 'PowiatType' }
    & Pick<PowiatType, 'id' | 'code' | 'name' | 'kind' | 'voivodeshipId' | 'voivodeshipName' | 'matchedAlias'>
  )> }
);

export type ErpFundingGeoAliasesQueryVariables = Exact<{
  status?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type ErpFundingGeoAliasesQuery = (
  { __typename?: 'Query' }
  & { fundingGeoAliases: Array<(
    { __typename?: 'GeoAliasType' }
    & Pick<GeoAliasType, 'id' | 'rawValue' | 'normalized' | 'status' | 'hits' | 'wholeVoivodeship' | 'suggestionScore'>
    & { powiat?: Maybe<(
      { __typename?: 'PowiatType' }
      & Pick<PowiatType, 'id' | 'name' | 'code' | 'kind' | 'voivodeshipName'>
    )>, contextVoivodeship?: Maybe<(
      { __typename?: 'VoivodeshipType' }
      & Pick<VoivodeshipType, 'id' | 'name'>
    )>, candidatePowiats: Array<(
      { __typename?: 'PowiatType' }
      & Pick<PowiatType, 'id' | 'name' | 'kind' | 'voivodeshipName'>
    )>, suggestedPowiat?: Maybe<(
      { __typename?: 'PowiatType' }
      & Pick<PowiatType, 'id' | 'name' | 'code' | 'kind' | 'voivodeshipName'>
    )> }
  )> }
);

export type ErpFundingImportRunsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  taskName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  triggerSource?: Maybe<Scalars['String']>;
  dryRun?: Maybe<Scalars['Boolean']>;
}>;


export type ErpFundingImportRunsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fundingImportRunsTotal'>
  & { fundingImportRuns: Array<(
    { __typename?: 'ImportRunType' }
    & Pick<ImportRunType, 'id' | 'taskName' | 'triggerSource' | 'startedByName' | 'dryRun' | 'status' | 'startedAt' | 'finishedAt' | 'durationSeconds' | 'errorMessage' | 'stats'>
  )> }
);

export type ErpFundingTaskSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpFundingTaskSummaryQuery = (
  { __typename?: 'Query' }
  & { fundingTaskSummary: Array<(
    { __typename?: 'TaskSummaryType' }
    & Pick<TaskSummaryType, 'task' | 'taskName' | 'scheduled' | 'scheduleFlag'>
    & { lastRun?: Maybe<(
      { __typename?: 'ImportRunType' }
      & Pick<ImportRunType, 'id' | 'status' | 'dryRun' | 'triggerSource' | 'startedByName' | 'startedAt' | 'durationSeconds' | 'errorMessage' | 'stats'>
    )> }
  )> }
);

export type ErpFundingWatchHealthQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpFundingWatchHealthQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fundingWatchOperatorsBroken'>
  & { fundingWatchHealth: Array<(
    { __typename?: 'WatchHealthType' }
    & Pick<WatchHealthType, 'problem' | 'count' | 'operators'>
    & { operatorRefs: Array<(
      { __typename?: 'FundingOperatorRefType' }
      & Pick<FundingOperatorRefType, 'id' | 'name'>
    )> }
  )> }
);

export type ErpFundingImportRunQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpFundingImportRunQuery = (
  { __typename?: 'Query' }
  & { fundingImportRun?: Maybe<(
    { __typename?: 'ImportRunType' }
    & Pick<ImportRunType, 'id' | 'taskName' | 'triggerSource' | 'startedByName' | 'dryRun' | 'status' | 'startedAt' | 'finishedAt' | 'durationSeconds' | 'errorMessage' | 'stats' | 'sourceExportedAt'>
  )> }
);

export type ErpFundingFormSubmissionsTotalQueryVariables = Exact<{
  state?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  submittedFrom?: Maybe<Scalars['Date']>;
  submittedTo?: Maybe<Scalars['Date']>;
}>;


export type ErpFundingFormSubmissionsTotalQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fundingFormSubmissionsTotal'>
);

export type ErpFundingOperatorsTotalQueryVariables = Exact<{
  programType?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  powiatId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
  pageChanged?: Maybe<Scalars['Boolean']>;
  pageSegment?: Maybe<Scalars['String']>;
  intakeConfirmation?: Maybe<Scalars['String']>;
  clientType?: Maybe<Scalars['String']>;
  intakePeriod?: Maybe<Scalars['String']>;
  urlSuspect?: Maybe<Scalars['Boolean']>;
}>;


export type ErpFundingOperatorsTotalQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fundingOperatorsTotal'>
);

export type ErpFundingCandidatesTotalQueryVariables = Exact<{
  status?: Maybe<Scalars['String']>;
  statusGroup?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  matchStatus?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  isStudent?: Maybe<Scalars['Boolean']>;
  employmentStatus?: Maybe<Scalars['String']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  needsAttention?: Maybe<Scalars['Boolean']>;
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  needsOperatorReview?: Maybe<Scalars['Boolean']>;
  operatorMatch?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpFundingCandidatesTotalQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fundingCandidatesTotal'>
);

export type ErpFundingForUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ErpFundingForUserQuery = (
  { __typename?: 'Query' }
  & { fundingCandidateForUser?: Maybe<(
    { __typename?: 'FundingCandidateType' }
    & Pick<FundingCandidateType, 'id' | 'status' | 'statusChangedAt' | 'isDeposit' | 'needsAttention' | 'attentionNote' | 'approvedAmount' | 'currency' | 'matchStatus' | 'activeOperatorsCount'>
    & { primaryOperator?: Maybe<(
      { __typename?: 'FundingOperatorType' }
      & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType' | 'instructionUrl' | 'instructionReady' | 'rollingIntake'>
      & { currentIntake?: Maybe<(
        { __typename?: 'FundingIntakeType' }
        & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
      )> }
    )>, operators: Array<(
      { __typename?: 'FundingOperatorType' }
      & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'clientType' | 'instructionUrl' | 'instructionReady' | 'rollingIntake'>
      & { currentIntake?: Maybe<(
        { __typename?: 'FundingIntakeType' }
        & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'status'>
      )> }
    )> }
  )> }
);

export type ErpFundingUserSearchQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
}>;


export type ErpFundingUserSearchQuery = (
  { __typename?: 'Query' }
  & { users?: Maybe<(
    { __typename?: 'UserNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'UserNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'UserNode' }
        & Pick<UserNode, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'roles'>
        & { student?: Maybe<(
          { __typename?: 'StudentType' }
          & Pick<StudentType, 'id'>
        )> }
      )> }
    )>> }
  )> }
);

export type ErpFundingOperatorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpFundingOperatorQuery = (
  { __typename?: 'Query' }
  & { fundingOperator?: Maybe<(
    { __typename?: 'FundingOperatorType' }
    & Pick<FundingOperatorType, 'id' | 'name' | 'programType' | 'programName' | 'projectNumber' | 'isActive' | 'coverageScope' | 'coverageIncomplete' | 'powiatsUnresolved' | 'maxAmount' | 'maxAmountCurrency' | 'ownContributionPercent' | 'paymentMethod' | 'decisionDays' | 'implementationStart' | 'implementationEnd' | 'rollingIntake' | 'acceptsUnemployed' | 'acceptsEmployerApplications' | 'supportsDisabled' | 'supportsAge50Plus' | 'greenCompetences' | 'servedStatuses' | 'instructionUrl' | 'instructionReady' | 'operatorInstructionUrl' | 'projectUrl' | 'newsUrl' | 'documentsUrl' | 'documentsNote' | 'pageState' | 'hasConfirmedIntake' | 'clientType' | 'intakePeriod' | 'nameSaysB2b' | 'urlSuspect' | 'pageLinksCount' | 'pageChanged' | 'pageChangedAt' | 'pageChangedReason' | 'pageTextWatched' | 'pageHashCheckedAt' | 'pageCheckedOkAt' | 'feedUrl' | 'lastNotifiedAt' | 'phone' | 'email' | 'comment' | 'internalNote' | 'candidatesCount'>
    & { voivodeship?: Maybe<(
      { __typename?: 'VoivodeshipType' }
      & Pick<VoivodeshipType, 'id' | 'name'>
    )>, powiats: Array<(
      { __typename?: 'PowiatType' }
      & Pick<PowiatType, 'id' | 'name' | 'code' | 'kind' | 'voivodeshipName'>
    )>, pageDiff?: Maybe<(
      { __typename?: 'PageDiffType' }
      & Pick<PageDiffType, 'comparable' | 'added' | 'removed' | 'addedTotal' | 'removedTotal'>
    )>, currentIntake?: Maybe<(
      { __typename?: 'FundingIntakeType' }
      & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'startsAtTime' | 'endsAtTime' | 'status' | 'phase' | 'daysLeft' | 'confirmedAt' | 'confirmedByName'>
    )>, intakes: Array<(
      { __typename?: 'FundingIntakeType' }
      & Pick<FundingIntakeType, 'id' | 'startsOn' | 'endsOn' | 'startsAtTime' | 'endsAtTime' | 'announcedAt' | 'status' | 'phase' | 'daysLeft' | 'confirmedAt' | 'confirmedByName' | 'notifiedAt' | 'notifiedCount' | 'candidatesCount' | 'sourceUrl' | 'note'>
    )> }
  )> }
);

export type ErpFundingIntakeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpFundingIntakeQuery = (
  { __typename?: 'Query' }
  & { fundingIntake?: Maybe<(
    { __typename?: 'FundingIntakeType' }
    & Pick<FundingIntakeType, 'id' | 'operatorId' | 'operatorName' | 'operatorProgramType' | 'operatorClientType' | 'startsOn' | 'endsOn' | 'startsAtTime' | 'endsAtTime' | 'announcedAt' | 'status' | 'phase' | 'daysLeft' | 'sourceUrl' | 'note' | 'confirmedAt' | 'confirmedByName' | 'notifiedAt' | 'notifiedCount' | 'candidatesCount' | 'waitingCandidatesCount'>
    & { mail: (
      { __typename?: 'IntakeMailType' }
      & Pick<IntakeMailType, 'sent' | 'failed' | 'pending' | 'waiting' | 'firstPlannedOn' | 'nextRunAt'>
    ) }
  )> }
);

export type ErpFundingIntakesQueryVariables = Exact<{
  operatorId?: Maybe<Scalars['ID']>;
  phase?: Maybe<Array<Scalars['String']>>;
  confirmation?: Maybe<Scalars['String']>;
  startsFrom?: Maybe<Scalars['Date']>;
  startsTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ErpFundingIntakesQuery = (
  { __typename?: 'Query' }
  & { fundingIntakes: Array<(
    { __typename?: 'FundingIntakeType' }
    & Pick<FundingIntakeType, 'id' | 'operatorId' | 'operatorName' | 'operatorProgramType' | 'operatorClientType' | 'startsOn' | 'endsOn' | 'startsAtTime' | 'endsAtTime' | 'status' | 'phase' | 'daysLeft' | 'note' | 'confirmedAt' | 'confirmedByName' | 'notifiedAt' | 'notifiedCount' | 'candidatesCount' | 'waitingCandidatesCount' | 'firstPlannedOn'>
  )> }
);

export type ErpFundingIntakesTotalQueryVariables = Exact<{
  operatorId?: Maybe<Scalars['ID']>;
  phase?: Maybe<Array<Scalars['String']>>;
  confirmation?: Maybe<Scalars['String']>;
  startsFrom?: Maybe<Scalars['Date']>;
  startsTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpFundingIntakesTotalQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fundingIntakesTotal'>
);

export type ErpFundingStatsQueryVariables = Exact<{
  dimension: Scalars['String'];
  statusGroup?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  matchStatus?: Maybe<Scalars['String']>;
  voivodeshipId?: Maybe<Scalars['ID']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  isStudent?: Maybe<Scalars['Boolean']>;
  employmentStatus?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpFundingStatsQuery = (
  { __typename?: 'Query' }
  & { fundingCandidateStats: (
    { __typename?: 'FundingStatsType' }
    & Pick<FundingStatsType, 'dimension' | 'total' | 'medianDecisionDays' | 'depositWaiting'>
    & { buckets: Array<(
      { __typename?: 'StatsBucketType' }
      & Pick<StatsBucketType, 'key' | 'label' | 'value' | 'share'>
    )> }
  ) }
);

export type ErpFundingNotificationsQueryVariables = Exact<{
  candidateId?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  deliveryState?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  intakeId?: Maybe<Scalars['ID']>;
  ruleId?: Maybe<Scalars['ID']>;
  templateId?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ErpFundingNotificationsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fundingNotificationsTotal'>
  & { fundingNotifications: Array<(
    { __typename?: 'FundingNotificationType' }
    & Pick<FundingNotificationType, 'id' | 'kind' | 'status' | 'email' | 'reason' | 'sentAt' | 'createdAt' | 'operatorId' | 'operatorName' | 'operatorClientType' | 'intakeId' | 'intakeStartsOn' | 'intakeEndsOn' | 'templateId' | 'templateName' | 'ruleId' | 'ruleOffsetDays' | 'ruleEveryDays' | 'dynamicData' | 'dedupKey' | 'sgMessageId' | 'runId' | 'candidateId' | 'candidateName' | 'deliveryState' | 'deliveredAt' | 'firstOpenedAt' | 'openCount' | 'bounceReason' | 'dropReason'>
  )> }
);

export type ErpFundingFormSubmissionsQueryVariables = Exact<{
  state?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  submittedFrom?: Maybe<Scalars['Date']>;
  submittedTo?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ErpFundingFormSubmissionsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fundingFormUrl'>
  & { fundingFormSubmissions: Array<(
    { __typename?: 'FormSubmissionType' }
    & Pick<FormSubmissionType, 'id' | 'email' | 'phone' | 'submittedAt' | 'processedAt' | 'processError' | 'candidateId' | 'candidateName' | 'utmSource' | 'utmCampaign' | 'rejectedReason' | 'botSignal' | 'state' | 'candidateStatus' | 'candidateOperatorId' | 'candidateOperatorIds' | 'candidateOperatorName' | 'candidateVoivodeship' | 'candidateVoivodeshipId' | 'candidateEmploymentStatus' | 'candidateEmployerName'>
    & { candidateOperators: Array<(
      { __typename?: 'FundingOperatorRefType' }
      & Pick<FundingOperatorRefType, 'id' | 'name'>
    )>, geoRejected: Array<(
      { __typename?: 'GeoRejectionType' }
      & Pick<GeoRejectionType, 'key' | 'value'>
    )> }
  )> }
);

export type ErpFundingSubmissionStatesQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  submittedFrom?: Maybe<Scalars['Date']>;
  submittedTo?: Maybe<Scalars['Date']>;
}>;


export type ErpFundingSubmissionStatesQuery = (
  { __typename?: 'Query' }
  & { fundingSubmissionStates: Array<(
    { __typename?: 'SubmissionStateCountType' }
    & Pick<SubmissionStateCountType, 'state' | 'count'>
  )> }
);

export type ErpFundingFormSubmissionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpFundingFormSubmissionQuery = (
  { __typename?: 'Query' }
  & { fundingFormSubmission?: Maybe<(
    { __typename?: 'FormSubmissionType' }
    & Pick<FormSubmissionType, 'id' | 'email' | 'phone' | 'submittedAt' | 'processedAt' | 'processError' | 'utmSource' | 'utmCampaign' | 'rejectedReason' | 'state' | 'candidateId' | 'candidateName' | 'candidateStatus' | 'candidateOperatorId' | 'candidateOperatorIds' | 'candidateOperatorName' | 'candidateVoivodeship' | 'candidateVoivodeshipId' | 'candidateEmploymentStatus' | 'candidateEmployerName' | 'candidateOperatorSource' | 'candidateOperatorSetBy' | 'candidateOperatorSetAt'>
    & { candidateOperators: Array<(
      { __typename?: 'FundingOperatorRefType' }
      & Pick<FundingOperatorRefType, 'id' | 'name'>
    )>, geoRejected: Array<(
      { __typename?: 'GeoRejectionType' }
      & Pick<GeoRejectionType, 'key' | 'value'>
    )>, payloadAnswers: Array<(
      { __typename?: 'FormAnswerType' }
      & Pick<FormAnswerType, 'field' | 'value'>
    )> }
  )> }
);

export type ErpPublicFundingGeoQueryVariables = Exact<{
  voivodeshipId?: Maybe<Scalars['ID']>;
}>;


export type ErpPublicFundingGeoQuery = (
  { __typename?: 'Query' }
  & { publicFundingVoivodeships: Array<(
    { __typename?: 'VoivodeshipType' }
    & Pick<VoivodeshipType, 'id' | 'name'>
  )>, publicFundingPowiats: Array<(
    { __typename?: 'PowiatType' }
    & Pick<PowiatType, 'id' | 'name' | 'voivodeshipId'>
  )> }
);

export type ErpFundingMailSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpFundingMailSettingsQuery = (
  { __typename?: 'Query' }
  & { fundingMailSettings: (
    { __typename?: 'FundingMailSettingsType' }
    & Pick<FundingMailSettingsType, 'paused' | 'fromEmail' | 'fromName' | 'replyTo' | 'effectiveFromEmail' | 'effectiveFromName' | 'effectiveReplyTo' | 'soonSendHour' | 'runningSendHour' | 'updatedAt' | 'updatedByName' | 'serverMailEnabled' | 'testRecipient' | 'notifyScheduled' | 'automatchScheduled' | 'shortenerEnabled' | 'canEdit' | 'automatchBlocked'>
  ) }
);

export type ErpFundingMailRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpFundingMailRulesQuery = (
  { __typename?: 'Query' }
  & { fundingMailRules: Array<(
    { __typename?: 'FundingMailRuleType' }
    & Pick<FundingMailRuleType, 'id' | 'code' | 'kind' | 'offsetDays' | 'everyDays' | 'templateId' | 'templateName' | 'templateSubject' | 'isActive' | 'updatedAt' | 'updatedByName' | 'canDelete' | 'sentCount'>
  )> }
);

export type ErpFundingMailVariablesQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpFundingMailVariablesQuery = (
  { __typename?: 'Query' }
  & { fundingMailVariables: Array<(
    { __typename?: 'FundingMailVariableType' }
    & Pick<FundingMailVariableType, 'name' | 'descriptionRu' | 'descriptionPl' | 'example'>
  )> }
);

export type ErpFundingMailSendgridTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpFundingMailSendgridTemplatesQuery = (
  { __typename?: 'Query' }
  & { fundingMailSendgridTemplates: (
    { __typename?: 'FundingMailSendgridTemplatesType' }
    & Pick<FundingMailSendgridTemplatesType, 'success'>
    & { templates: Array<(
      { __typename?: 'SendgridTemplateType' }
      & Pick<SendgridTemplateType, 'id' | 'name' | 'subject' | 'versionId' | 'updatedAt'>
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  ) }
);

export type ErpFundingMailTemplateCheckQueryVariables = Exact<{
  templateId: Scalars['String'];
}>;


export type ErpFundingMailTemplateCheckQuery = (
  { __typename?: 'Query' }
  & { fundingMailTemplateCheck: (
    { __typename?: 'FundingMailTemplateCheckType' }
    & Pick<FundingMailTemplateCheckType, 'success' | 'templateId' | 'name' | 'subject' | 'hasActiveVersion' | 'usedVariables' | 'unknownVariables' | 'unusedVariables'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  ) }
);

export type ErpFundingMailCalendarQueryVariables = Exact<{
  days?: Maybe<Scalars['Int']>;
}>;


export type ErpFundingMailCalendarQuery = (
  { __typename?: 'Query' }
  & { fundingMailCalendar: Array<(
    { __typename?: 'FundingMailCalendarEntryType' }
    & Pick<FundingMailCalendarEntryType, 'date' | 'kind' | 'ruleId' | 'offsetDays' | 'daysLeft' | 'intakeId' | 'intakeStartsOn' | 'intakeEndsOn' | 'operatorId' | 'operatorName' | 'recipients' | 'alreadySent' | 'templateId' | 'templateName' | 'sendHour' | 'sendAt'>
  )> }
);

export type StudentDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StudentDetailQuery = (
  { __typename?: 'Query' }
  & { student?: Maybe<(
    { __typename?: 'StudentType' }
    & Pick<StudentType, 'id' | 'registrationDate' | 'acquisitionSource'>
    & { kommoLeads: Array<(
      { __typename?: 'PersonKommoLeadType' }
      & PersonKommoLeadFieldsFragment
    )>, user?: Maybe<(
      { __typename?: 'CustomUserType' }
      & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'middleName' | 'email' | 'phone'>
    )>, educationGroups: Array<(
      { __typename?: 'StudentEducationGroupType' }
      & Pick<StudentEducationGroupType, 'groupId' | 'groupName' | 'courseName' | 'agreementTerminated'>
    )>, timeline?: Maybe<(
      { __typename?: 'StudentTimelineConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'StudentTimelineEdge' }
        & { node?: Maybe<(
          { __typename?: 'StudentTimelineEventType' }
          & Pick<StudentTimelineEventType, 'id' | 'type' | 'date' | 'label' | 'meta'>
        )> }
      )>> }
    )>, accountsPayables?: Maybe<Array<Maybe<(
      { __typename?: 'AccountsPayableType' }
      & Pick<AccountsPayableType, 'id' | 'amountForeign' | 'amountByn' | 'currency' | 'repaid'>
      & { startedAgreement: (
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id' | 'agreementTitle'>
      ) }
    )>>>, agreements: Array<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'agreementTitle' | 'currency' | 'budgetAmount' | 'paidAmount' | 'debtAmount' | 'upcomingAmount' | 'terminated' | 'terminatedDate' | 'transferOut' | 'freeOfCharge' | 'statePrefinanced' | 'date' | 'partialAttendance' | 'paymentByCompany' | 'vat' | 'resident' | 'promocode' | 'comment' | 'legalName' | 'taxId' | 'street' | 'city' | 'zipCode' | 'address'>
      & { country?: Maybe<(
        { __typename?: 'CountryType' }
        & Pick<CountryType, 'id' | 'title'>
      )>, company?: Maybe<(
        { __typename?: 'CompanyType' }
        & Pick<CompanyType, 'id' | 'name'>
      )>, group: (
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name' | 'startDate'>
        & { course: (
          { __typename?: 'CourseFilterType' }
          & Pick<CourseFilterType, 'id' | 'name'>
        ) }
      ), firstLesson?: Maybe<(
        { __typename?: 'GroupLessonType' }
        & Pick<GroupLessonType, 'id' | 'name' | 'lessonNumber'>
      )>, lastLesson?: Maybe<(
        { __typename?: 'GroupLessonType' }
        & Pick<GroupLessonType, 'id' | 'name' | 'date' | 'lessonNumber'>
      )>, pandadocDocument?: Maybe<(
        { __typename?: 'PandaDocDocumentType' }
        & Pick<PandaDocDocumentType, 'id' | 'pandadocId' | 'name' | 'status' | 'outcome' | 'docType' | 'course' | 'dateCompleted' | 'ttsHours'>
      )>, contractDocument?: Maybe<(
        { __typename?: 'ContractSummaryType' }
        & Pick<ContractSummaryType, 'id' | 'number' | 'status' | 'fulfilmentStatus' | 'completedAt'>
      )>, payments?: Maybe<Array<Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<PaymentType, 'id' | 'date' | 'amountAgreement' | 'currency' | 'source'>
        & { fakturowniaInvoice?: Maybe<(
          { __typename?: 'FakturowniaInvoiceType' }
          & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'status' | 'priceGross' | 'outstanding' | 'kind' | 'currency'>
        )>, contribution?: Maybe<(
          { __typename?: 'ContributionType' }
          & Pick<ContributionType, 'id'>
        )> }
      )>>>, contributions: (
        { __typename?: 'ContributionTypeConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'ContributionTypeEdge' }
          & { node?: Maybe<(
            { __typename?: 'ContributionType' }
            & Pick<ContributionType, 'id' | 'date' | 'amountForeign' | 'amountByn' | 'complete' | 'remainder' | 'delay' | 'status' | 'coveredAmount' | 'debt' | 'paidManually'>
            & { proformas?: Maybe<Array<(
              { __typename?: 'FakturowniaInvoiceType' }
              & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'status' | 'paymentTo' | 'currency' | 'priceGross' | 'viewUrl' | 'isOpenProforma'>
              & { vatChild?: Maybe<(
                { __typename?: 'FakturowniaInvoiceType' }
                & Pick<FakturowniaInvoiceType, 'id' | 'number'>
              )> }
            )>>, invoices?: Maybe<Array<Maybe<(
              { __typename?: 'FakturowniaInvoiceType' }
              & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'kind' | 'status' | 'paid' | 'outstanding' | 'netGross' | 'netPaid' | 'paymentTo' | 'currency' | 'provisionBlockedReason' | 'contributionMatchSource'>
              & { payment?: Maybe<(
                { __typename?: 'PaymentType' }
                & Pick<PaymentType, 'id' | 'date' | 'amountAgreement' | 'currency'>
              )> }
            )>>>, currencyMismatchInvoices: Array<(
              { __typename?: 'FakturowniaInvoiceType' }
              & Pick<FakturowniaInvoiceType, 'id' | 'number' | 'currency' | 'kind' | 'paid'>
            )>, payment?: Maybe<(
              { __typename?: 'PaymentType' }
              & Pick<PaymentType, 'id' | 'date' | 'amountAgreement' | 'currency'>
              & { fakturowniaInvoice?: Maybe<(
                { __typename?: 'FakturowniaInvoiceType' }
                & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'status' | 'priceGross' | 'outstanding' | 'kind' | 'currency'>
              )> }
            )> }
          )> }
        )>> }
      ), chargeback?: Maybe<(
        { __typename?: 'ChargebackType' }
        & Pick<ChargebackType, 'id' | 'currency' | 'amountForeign' | 'amountByn' | 'date'>
      )>, startAccountsPayable?: Maybe<(
        { __typename?: 'AccountsPayableType' }
        & Pick<AccountsPayableType, 'id' | 'amountForeign' | 'currency' | 'repaid'>
      )>, corrections?: Maybe<Array<Maybe<(
        { __typename?: 'PaymentCorrectionType' }
        & Pick<PaymentCorrectionType, 'id' | 'date' | 'amountForeign' | 'amountByn' | 'currency' | 'reason'>
        & { payment?: Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<PaymentType, 'id'>
        )> }
      )>>> }
    )> }
  )> }
);

export type GroupDetailQueryVariables = Exact<{
  id: Scalars['ID'];
  withStaffFields: Scalars['Boolean'];
}>;


export type GroupDetailQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'GroupType' }
    & MakeOptional<Pick<GroupType, 'id' | 'name' | 'startDate' | 'price' | 'currency' | 'studentsCount' | 'lessonsCount' | 'passedLessonsCount' | 'freeLessonsCount' | 'contributionsSum' | 'maxStudentsCount' | 'freePlaces' | 'statusFinished' | 'datetimeNextLesson' | 'deleteAvailable' | 'isFree' | 'comment' | 'publishedLms' | 'publishedLmsForTeacher' | 'publishedLmsForMethodist'>, 'price' | 'currency' | 'deleteAvailable'>
    & { course: (
      { __typename?: 'CourseFilterType' }
      & Pick<CourseFilterType, 'id' | 'name'>
    ), teachers?: Maybe<Array<Maybe<(
      { __typename?: 'TeacherType' }
      & Pick<TeacherType, 'id' | 'fullName'>
    )>>> }
  )> }
);

export type TeacherDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TeacherDetailQuery = (
  { __typename?: 'Query' }
  & { teacher?: Maybe<(
    { __typename?: 'TeacherType' }
    & Pick<TeacherType, 'id' | 'fullName' | 'accessToLms' | 'isDismissed' | 'groupsCount' | 'rating' | 'studentRating' | 'studentRatingCount' | 'internalNote' | 'interviewRecording' | 'photo' | 'description' | 'courses'>
    & { studentComments?: Maybe<Array<(
      { __typename?: 'TeacherStudentCommentType' }
      & Pick<TeacherStudentCommentType, 'studentName' | 'comment' | 'createdAt' | 'courseName' | 'groupName'>
    )>>, user: (
      { __typename?: 'CustomUserType' }
      & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'middleName' | 'email' | 'phone'>
    ), coursesCanTeach?: Maybe<Array<(
      { __typename?: 'TeacherCourseRef' }
      & Pick<TeacherCourseRef, 'id' | 'name'>
    )>>, employmentTypes?: Maybe<Array<Maybe<{ __typename: 'IndividualEntrepreneurType' } | { __typename: 'LegalEntityType' } | { __typename: 'SelfEmployedType' } | { __typename: 'NaturalPersonType' }>>>, applications?: Maybe<(
      { __typename?: 'ApplicationConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ApplicationEdge' }
        & { node?: Maybe<(
          { __typename?: 'ApplicationType' }
          & Pick<ApplicationType, 'id' | 'title' | 'lessonsCount' | 'appointedLessonsCount' | 'servicePrice' | 'riaPrice' | 'currency' | 'isTerminated' | 'isCompleted'>
          & { teacher: (
            { __typename?: 'TeacherFilterType' }
            & Pick<TeacherFilterType, 'id' | 'fullName'>
          ), group: (
            { __typename?: 'MethodistGroupType' }
            & Pick<MethodistGroupType, 'id' | 'name'>
          ), employmentType?: Maybe<{ __typename: 'IndividualEntrepreneurType' } | { __typename: 'LegalEntityType' } | { __typename: 'SelfEmployedType' } | { __typename: 'NaturalPersonType' }> }
        )> }
      )>> }
    )> }
  )> }
);

export type EsignAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type EsignAvailabilityQuery = (
  { __typename?: 'Query' }
  & { esignSettings: (
    { __typename?: 'EsignSettingsType' }
    & Pick<EsignSettingsType, 'enabled' | 'mailEnabled' | 'mailRedirected' | 'inviteVia' | 'shortLinksEnabled'>
  ) }
);

export type ContractDocumentsListQueryVariables = Exact<{
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  fulfilmentStatus?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  signState?: Maybe<Array<Scalars['String']>>;
  expiringWithinDays?: Maybe<Scalars['Int']>;
  needsAction?: Maybe<Scalars['Boolean']>;
  hotMinWinChance?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  withCounts?: Maybe<Scalars['Boolean']>;
}>;


export type ContractDocumentsListQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'contractDocumentsTotal'>
  & { contractDocuments: Array<(
    { __typename?: 'ContractDocumentType' }
    & Pick<ContractDocumentType, 'id' | 'kind' | 'number' | 'status' | 'fulfilmentStatus' | 'cancelConflict' | 'textPending' | 'signerFirstName' | 'signerLastName' | 'signerEmail' | 'signerPhone' | 'signerLegalName' | 'groupId' | 'groupName' | 'courseName' | 'teacherId' | 'applicationId' | 'applicationTitle' | 'studentId' | 'agreementId' | 'currency' | 'listPrice' | 'price' | 'createdByName' | 'sellerId' | 'sellerName' | 'sentById' | 'sentByName' | 'canManage' | 'createdAt' | 'sentAt' | 'emailOpenedAt' | 'openedAt' | 'signedAt' | 'completedAt' | 'crmLeadId' | 'aploraWinChance' | 'aploraConsent' | 'aploraNextContactDate' | 'signState' | 'expiresInDays'>
    & { paymentPlan?: Maybe<(
      { __typename?: 'PaymentPlanType' }
      & Pick<PaymentPlanType, 'id' | 'name'>
    )> }
  )>, contractDocumentStatusCounts: Array<(
    { __typename?: 'ContractStatusCountType' }
    & Pick<ContractStatusCountType, 'status' | 'count' | 'hotCount'>
  )> }
);

export type ContractBoardColumnAmountsQueryVariables = Exact<{
  kind?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  fulfilmentStatus?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  signState?: Maybe<Array<Scalars['String']>>;
  expiringWithinDays?: Maybe<Scalars['Int']>;
  needsAction?: Maybe<Scalars['Boolean']>;
}>;


export type ContractBoardColumnAmountsQuery = (
  { __typename?: 'Query' }
  & { contractDocumentAmounts: Array<(
    { __typename?: 'ContractAmountType' }
    & Pick<ContractAmountType, 'currency' | 'amount' | 'count'>
  )> }
);

export type ContractSignedRecentlyQueryVariables = Exact<{
  kind?: Maybe<Scalars['String']>;
  fulfilmentStatus?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  aploraMinWinChance?: Maybe<Scalars['Float']>;
  signState?: Maybe<Array<Scalars['String']>>;
  expiringWithinDays?: Maybe<Scalars['Int']>;
  needsAction?: Maybe<Scalars['Boolean']>;
  signedFrom: Scalars['Date'];
}>;


export type ContractSignedRecentlyQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'contractDocumentsTotal'>
  & { contractDocumentAmounts: Array<(
    { __typename?: 'ContractAmountType' }
    & Pick<ContractAmountType, 'currency' | 'amount' | 'count'>
  )> }
);

export type ContractDocumentCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContractDocumentCardQuery = (
  { __typename?: 'Query' }
  & { contractDocument?: Maybe<(
    { __typename?: 'ContractDocumentType' }
    & EsignContractCardFieldsFragment
  )> }
);

export type EsignContractPdfLinksQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EsignContractPdfLinksQuery = (
  { __typename?: 'Query' }
  & { contractDocument?: Maybe<(
    { __typename?: 'ContractDocumentType' }
    & Pick<ContractDocumentType, 'id' | 'previewPdfUrl' | 'signedPdfUrl'>
  )> }
);

export type EsignPaymentPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type EsignPaymentPlansQuery = (
  { __typename?: 'Query' }
  & { paymentPlans: Array<(
    { __typename?: 'PaymentPlanType' }
    & Pick<PaymentPlanType, 'id' | 'code' | 'name' | 'installments' | 'firstDueKind' | 'firstDueDays' | 'marksStatePrefinanced' | 'bankInstallments'>
  )> }
);

export type EsignDraftDefaultsQueryVariables = Exact<{
  groupId: Scalars['ID'];
  paymentPlanId: Scalars['ID'];
  currency?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  excludeContractId?: Maybe<Scalars['ID']>;
  crmLeadId?: Maybe<Scalars['ID']>;
}>;


export type EsignDraftDefaultsQuery = (
  { __typename?: 'Query' }
  & { contractDraftDefaults?: Maybe<(
    { __typename?: 'ContractDraftDefaultsType' }
    & Pick<ContractDraftDefaultsType, 'listPrice' | 'listPriceSource' | 'currency' | 'nextNumberPreview' | 'matchedUserId' | 'matchedUserName' | 'warnings'>
    & { schedule: Array<(
      { __typename?: 'ContractInstallmentType' }
      & Pick<ContractInstallmentType, 'n' | 'amount' | 'rule' | 'ruleKind' | 'ruleParams'>
    )> }
  )> }
);

export type EsignDraftFromLeadQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type EsignDraftFromLeadQuery = (
  { __typename?: 'Query' }
  & { contractDraftFromLead?: Maybe<(
    { __typename?: 'ContractDraftFromLeadType' }
    & Pick<ContractDraftFromLeadType, 'leadId' | 'leadName' | 'firstName' | 'lastName' | 'email' | 'phone' | 'crmLeadId' | 'crmLeadBlocked' | 'courseId' | 'courseName' | 'courseSource' | 'courseRaw' | 'suggestedGroupId' | 'paymentPlanId' | 'paymentPlanReason'>
    & { groups: Array<(
      { __typename?: 'ContractDraftGroupType' }
      & Pick<ContractDraftGroupType, 'id' | 'name' | 'startDate'>
    )>, fundingCandidate?: Maybe<(
      { __typename?: 'LeadFundingLinkType' }
      & Pick<LeadFundingLinkType, 'id' | 'name' | 'status' | 'isArchived'>
    )>, existingContracts: Array<(
      { __typename?: 'LeadContractType' }
      & Pick<LeadContractType, 'id' | 'number' | 'status' | 'kind' | 'createdAt'>
    )> }
  )> }
);

export type EsignGroupOptionsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type EsignGroupOptionsQuery = (
  { __typename?: 'Query' }
  & { allGroups?: Maybe<(
    { __typename?: 'GroupConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'GroupEdge' }
      & { node?: Maybe<(
        { __typename?: 'GroupType' }
        & Pick<GroupType, 'id' | 'name' | 'startDate' | 'currency'>
        & { course: (
          { __typename?: 'CourseFilterType' }
          & Pick<CourseFilterType, 'id' | 'name'>
        ) }
      )> }
    )>> }
  )> }
);

export type EsignCrmLeadFieldsFragment = (
  { __typename?: 'CrmLeadType' }
  & Pick<CrmLeadType, 'id' | 'name' | 'statusId' | 'statusName' | 'statusColor' | 'updatedAt' | 'responsibleName' | 'contactId' | 'firstName' | 'lastName' | 'email' | 'phone' | 'url'>
);

export type EsignCrmLeadsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
}>;


export type EsignCrmLeadsQuery = (
  { __typename?: 'Query' }
  & { crmLeads: (
    { __typename?: 'CrmLeadPageType' }
    & Pick<CrmLeadPageType, 'hasMore'>
    & { items: Array<(
      { __typename?: 'CrmLeadType' }
      & EsignCrmLeadFieldsFragment
    )>, error?: Maybe<(
      { __typename?: 'CrmErrorType' }
      & Pick<CrmErrorType, 'code' | 'message'>
    )> }
  ) }
);

export type EsignCrmLeadStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type EsignCrmLeadStatusesQuery = (
  { __typename?: 'Query' }
  & { crmLeadStatuses: (
    { __typename?: 'CrmLeadStatusListType' }
    & { items: Array<(
      { __typename?: 'CrmLeadStatusType' }
      & Pick<CrmLeadStatusType, 'id' | 'name' | 'color'>
    )>, error?: Maybe<(
      { __typename?: 'CrmErrorType' }
      & Pick<CrmErrorType, 'code' | 'message'>
    )> }
  ) }
);

export type EsignCrmLeadLabelQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EsignCrmLeadLabelQuery = (
  { __typename?: 'Query' }
  & { crmLead?: Maybe<(
    { __typename?: 'CrmLeadType' }
    & EsignCrmLeadFieldsFragment
  )> }
);

export type ContractFilterGroupsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  selectedId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type ContractFilterGroupsQuery = (
  { __typename?: 'Query' }
  & { contractGroupOptions: Array<(
    { __typename?: 'ContractGroupOptionType' }
    & Pick<ContractGroupOptionType, 'id' | 'name' | 'startDate' | 'courseName'>
  )> }
);

export type EsignGroupLabelQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
}>;


export type EsignGroupLabelQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'GroupType' }
    & Pick<GroupType, 'id' | 'name' | 'startDate' | 'currency'>
    & { course: (
      { __typename?: 'CourseFilterType' }
      & Pick<CourseFilterType, 'id' | 'name'>
    ) }
  )> }
);

export type EsignPersonOptionsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type EsignPersonOptionsQuery = (
  { __typename?: 'Query' }
  & { allStudents?: Maybe<(
    { __typename?: 'StudentConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'StudentEdge' }
      & { node?: Maybe<(
        { __typename?: 'StudentType' }
        & Pick<StudentType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'CustomUserType' }
          & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'email' | 'phone'>
        )> }
      )> }
    )>> }
  )> }
);

export type ContractOutreachStateQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type ContractOutreachStateQuery = (
  { __typename?: 'Query' }
  & { contractOutreach?: Maybe<(
    { __typename?: 'ContractOutreachType' }
    & EsignOutreachFieldsFragment
  )> }
);

export type ContractOutreachSummaryListQueryVariables = Exact<{
  contractIds: Array<Scalars['ID']>;
}>;


export type ContractOutreachSummaryListQuery = (
  { __typename?: 'Query' }
  & { contractOutreachSummaries: Array<(
    { __typename?: 'ContractOutreachSummaryType' }
    & Pick<ContractOutreachSummaryType, 'contractId' | 'smsSent' | 'lastSmsAt' | 'humanClicks'>
  )> }
);

export type ContractSellerOptionsQueryVariables = Exact<{
  forReassign?: Maybe<Scalars['Boolean']>;
}>;


export type ContractSellerOptionsQuery = (
  { __typename?: 'Query' }
  & { contractSellers: Array<(
    { __typename?: 'ContractSellerType' }
    & Pick<ContractSellerType, 'id' | 'name' | 'email'>
  )> }
);

export type ContractSenderOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContractSenderOptionsQuery = (
  { __typename?: 'Query' }
  & { contractSenders: Array<(
    { __typename?: 'ContractSellerType' }
    & Pick<ContractSellerType, 'id' | 'name' | 'email'>
  )> }
);

export type ContractConversationListQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type ContractConversationListQuery = (
  { __typename?: 'Query' }
  & { contractConversations: Array<(
    { __typename?: 'ConversationType' }
    & Pick<ConversationType, 'id' | 'kind' | 'title' | 'displayTitle' | 'externalId' | 'mailboxEmail' | 'unreadCount' | 'unhandledCount' | 'status' | 'hasUnhandled' | 'lastMessageAt'>
  )> }
);

export type ContractMailSummaryListQueryVariables = Exact<{
  contractIds: Array<Scalars['ID']>;
}>;


export type ContractMailSummaryListQuery = (
  { __typename?: 'Query' }
  & { contractMailSummaries: Array<(
    { __typename?: 'ContractMailSummaryType' }
    & Pick<ContractMailSummaryType, 'contractId' | 'threads' | 'unhandled' | 'lastInboundAt'>
  )> }
);

export type ContractMailboxOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContractMailboxOptionsQuery = (
  { __typename?: 'Query' }
  & { gmailMailboxes: Array<(
    { __typename?: 'GmailMailboxType' }
    & Pick<GmailMailboxType, 'id' | 'email' | 'displayName' | 'isPersonal' | 'isMine' | 'ownerName'>
  )> }
);

export type ContractMessageTemplatesQueryVariables = Exact<{
  channel?: Maybe<Scalars['String']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  topic?: Maybe<Scalars['String']>;
  includeOthers?: Maybe<Scalars['Boolean']>;
}>;


export type ContractMessageTemplatesQuery = (
  { __typename?: 'Query' }
  & { messageTemplates: Array<(
    { __typename?: 'MessageTemplateType' }
    & EsignMessageTemplateFieldsFragment
  )> }
);

export type EsignInvitePreviewQueryVariables = Exact<{
  documentId: Scalars['ID'];
  emailSubject?: Maybe<Scalars['String']>;
  emailBody?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
}>;


export type EsignInvitePreviewQuery = (
  { __typename?: 'Query' }
  & { contractInvitePreview?: Maybe<(
    { __typename?: 'ContractInvitePreviewType' }
    & Pick<ContractInvitePreviewType, 'subject' | 'body' | 'rawSubject' | 'rawBody' | 'fromEmail' | 'fromName' | 'toEmail' | 'templateCode' | 'templateId' | 'hasOwnCopy' | 'ownCopyId' | 'templateName' | 'templateNamePl' | 'isPersonal' | 'via' | 'editable' | 'canSend' | 'skipReason' | 'errorCode' | 'errorMessage' | 'errorField'>
    & { templates: Array<(
      { __typename?: 'ContractInviteTemplateOptionType' }
      & Pick<ContractInviteTemplateOptionType, 'id' | 'code' | 'name' | 'namePl' | 'isPersonal'>
    )> }
  )> }
);

export type MessageTemplatesEditableQueryVariables = Exact<{
  topic?: Maybe<Scalars['String']>;
}>;


export type MessageTemplatesEditableQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'canEditMessageTemplates'>
);

export type ContractMessageVariablesQueryVariables = Exact<{
  topic?: Maybe<Scalars['String']>;
}>;


export type ContractMessageVariablesQuery = (
  { __typename?: 'Query' }
  & { messageTemplateVariables: Array<(
    { __typename?: 'TemplateVariableType' }
    & Pick<TemplateVariableType, 'name' | 'description' | 'descriptionRu' | 'descriptionPl' | 'source' | 'sourceRu' | 'sourcePl' | 'example'>
  )> }
);

export type ContractsSmsBulkPreviewQueryVariables = Exact<{
  contractIds: Array<Scalars['ID']>;
  text: Scalars['String'];
}>;


export type ContractsSmsBulkPreviewQuery = (
  { __typename?: 'Query' }
  & { previewContractsSms?: Maybe<(
    { __typename?: 'ContractsSmsPreviewType' }
    & Pick<ContractsSmsPreviewType, 'willSend' | 'skipped' | 'segmentsTotal'>
    & { rows: Array<(
      { __typename?: 'ContractSmsBulkRowType' }
      & Pick<ContractSmsBulkRowType, 'contractId' | 'number' | 'signerName' | 'ok' | 'code' | 'message' | 'segments'>
    )>, sample?: Maybe<(
      { __typename?: 'SmsPreviewType' }
      & Pick<SmsPreviewType, 'body' | 'encoding' | 'segments' | 'maxSegments' | 'tooLong' | 'withOptOut' | 'available' | 'reason' | 'message'>
    )> }
  )> }
);

export type ContractSmsPreviewQueryVariables = Exact<{
  contractId: Scalars['ID'];
  text: Scalars['String'];
}>;


export type ContractSmsPreviewQuery = (
  { __typename?: 'Query' }
  & { previewContractSms?: Maybe<(
    { __typename?: 'SmsPreviewType' }
    & Pick<SmsPreviewType, 'body' | 'encoding' | 'segments' | 'maxSegments' | 'tooLong' | 'withOptOut' | 'available' | 'reason' | 'message'>
  )> }
);

export type ContractTemplateListQueryVariables = Exact<{
  kind?: Maybe<Scalars['String']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
}>;


export type ContractTemplateListQuery = (
  { __typename?: 'Query' }
  & { contractTemplates: Array<(
    { __typename?: 'ContractTemplateType' }
    & EsignContractTemplateFieldsFragment
  )> }
);

export type ContractTemplateSampleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContractTemplateSampleQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'contractTemplatePreview'>
);

export type ContractTemplateEditorSourceQueryVariables = Exact<{
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
}>;


export type ContractTemplateEditorSourceQuery = (
  { __typename?: 'Query' }
  & { contractTemplateEditable?: Maybe<(
    { __typename?: 'ContractTemplateEditableType' }
    & Pick<ContractTemplateEditableType, 'html'>
    & { template: (
      { __typename?: 'ContractTemplateType' }
      & EsignContractTemplateFieldsFragment
    ), tokens: Array<(
      { __typename?: 'ContractTemplateTokenType' }
      & Pick<ContractTemplateTokenType, 'n' | 'kind' | 'role' | 'code' | 'label' | 'labelPl' | 'removable' | 'placement'>
    )>, variables: Array<(
      { __typename?: 'ContractTemplateVariableType' }
      & Pick<ContractTemplateVariableType, 'code' | 'group' | 'label' | 'labelPl' | 'groupLabel' | 'groupLabelPl'>
    )> }
  )> }
);

export type ContractTemplateDraftSampleQueryVariables = Exact<{
  id: Scalars['ID'];
  html: Scalars['String'];
  tokens?: Maybe<Scalars['JSONString']>;
}>;


export type ContractTemplateDraftSampleQuery = (
  { __typename?: 'Query' }
  & { contractTemplatePreviewDraft: (
    { __typename?: 'ContractTemplatePreviewDraftType' }
    & Pick<ContractTemplatePreviewDraftType, 'html'>
    & { problems: Array<(
      { __typename?: 'ContractTemplateProblemType' }
      & Pick<ContractTemplateProblemType, 'code' | 'message' | 'token'>
    )> }
  ) }
);

export type ContractAnalyticsReportQueryVariables = Exact<{
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  course?: Maybe<Scalars['String']>;
  granularity?: Maybe<Scalars['String']>;
}>;


export type ContractAnalyticsReportQuery = (
  { __typename?: 'Query' }
  & { contractAnalytics?: Maybe<(
    { __typename?: 'ContractAnalyticsType' }
    & Pick<ContractAnalyticsType, 'amountsVisible'>
    & { funnel: (
      { __typename?: 'FunnelType' }
      & Pick<FunnelType, 'created' | 'sent' | 'opened' | 'signed' | 'enrolled'>
    ), statuses: Array<(
      { __typename?: 'StatusCountType' }
      & Pick<StatusCountType, 'status' | 'count'>
    )>, tts: (
      { __typename?: 'TimeToSignType' }
      & Pick<TimeToSignType, 'signedCount' | 'medianHours' | 'avgHours' | 'within24hPct' | 'within72hPct'>
    ), sellers: Array<(
      { __typename?: 'SellerStatType' }
      & Pick<SellerStatType, 'sellerId' | 'name' | 'created' | 'sent' | 'signed' | 'signedInPeriod' | 'conversionPct' | 'medianHours'>
      & { amounts?: Maybe<Array<(
        { __typename?: 'MoneyType' }
        & Pick<MoneyType, 'currency' | 'amount'>
      )>> }
    )>, courses: Array<(
      { __typename?: 'CourseStatType' }
      & Pick<CourseStatType, 'course' | 'created' | 'sent' | 'signed' | 'conversionPct'>
    )>, series: Array<(
      { __typename?: 'SeriesPointType' }
      & Pick<SeriesPointType, 'period' | 'created' | 'sent' | 'signed'>
    )>, sms: (
      { __typename?: 'SmsStatType' }
      & Pick<SmsStatType, 'sent' | 'delivered' | 'failed' | 'humanClicks' | 'contractsClicked'>
    ) }
  )> }
);

export type FakturowniaInvoiceIdsQueryVariables = Exact<{
  direction?: Maybe<Scalars['String']>;
  needsLinkOnly?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type FakturowniaInvoiceIdsQuery = (
  { __typename?: 'Query' }
  & { fakturowniaInvoices?: Maybe<Array<Maybe<(
    { __typename?: 'FakturowniaInvoiceType' }
    & Pick<FakturowniaInvoiceType, 'id'>
  )>>> }
);

export type FakturowniaInvoicesQueryVariables = Exact<{
  direction?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  matchStatus?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  overdueOnly?: Maybe<Scalars['Boolean']>;
  parentId?: Maybe<Scalars['ID']>;
  needsLinkOnly?: Maybe<Scalars['Boolean']>;
  provisionBlockedOnly?: Maybe<Scalars['Boolean']>;
}>;


export type FakturowniaInvoicesQuery = (
  { __typename?: 'Query' }
  & { fakturowniaInvoices?: Maybe<Array<Maybe<(
    { __typename?: 'FakturowniaInvoiceType' }
    & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'direction' | 'kind' | 'status' | 'issueDate' | 'paymentTo' | 'paidDate' | 'currency' | 'priceGross' | 'paid' | 'outstanding' | 'buyerEmail' | 'buyerName' | 'buyerTaxNo' | 'matchStatus' | 'groupMatchSource' | 'contributionMatchSource' | 'provisionBlockedReason' | 'isCorrection' | 'isAdvance' | 'isFinal' | 'isEstimate' | 'isQuotation' | 'isProforma'>
    & { linkedStudent?: Maybe<(
      { __typename?: 'StudentType' }
      & Pick<StudentType, 'id'>
      & { user?: Maybe<(
        { __typename?: 'CustomUserType' }
        & Pick<CustomUserType, 'id' | 'email' | 'firstName' | 'lastName'>
      )> }
    )>, linkedGroup?: Maybe<(
      { __typename?: 'MethodistGroupType' }
      & Pick<MethodistGroupType, 'id' | 'name'>
      & { course: (
        { __typename?: 'CourseFilterType' }
        & Pick<CourseFilterType, 'id' | 'title'>
      ) }
    )>, payment?: Maybe<(
      { __typename?: 'PaymentType' }
      & Pick<PaymentType, 'id' | 'date' | 'amountAgreement' | 'currency'>
      & { agreement: (
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id'>
      ) }
    )>, contribution?: Maybe<(
      { __typename?: 'ContributionType' }
      & Pick<ContributionType, 'id' | 'date' | 'amountForeign' | 'status'>
    )>, agreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'agreementTitle'>
      & { student: (
        { __typename?: 'StudentType' }
        & Pick<StudentType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'CustomUserType' }
          & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'email'>
        )> }
      ), group: (
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name'>
      ) }
    )>, parentInvoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'number'>
    )>, corrections?: Maybe<Array<Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'outstanding'>
    )>>> }
  )>>> }
);

export type FakturowniaInvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FakturowniaInvoiceQuery = (
  { __typename?: 'Query' }
  & { fakturowniaInvoice?: Maybe<(
    { __typename?: 'FakturowniaInvoiceType' }
    & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'fakturowniaId' | 'number' | 'kind' | 'direction' | 'status' | 'issueDate' | 'sellDate' | 'paymentTo' | 'paidDate' | 'currency' | 'priceNet' | 'priceGross' | 'paid' | 'outstanding' | 'buyerEmail' | 'buyerName' | 'buyerTaxNo' | 'sellerName' | 'correctionReason' | 'accountingKind' | 'matchStatus' | 'groupMatchSource' | 'linkedAt' | 'isCorrection' | 'isAdvance' | 'isFinal' | 'isEstimate' | 'isQuotation' | 'rawPayload'>
    & { linkedStudent?: Maybe<(
      { __typename?: 'StudentType' }
      & Pick<StudentType, 'id'>
      & { user?: Maybe<(
        { __typename?: 'CustomUserType' }
        & Pick<CustomUserType, 'id' | 'email' | 'firstName' | 'lastName' | 'phone'>
      )> }
    )>, linkedGroup?: Maybe<(
      { __typename?: 'MethodistGroupType' }
      & Pick<MethodistGroupType, 'id' | 'name'>
      & { course: (
        { __typename?: 'CourseFilterType' }
        & Pick<CourseFilterType, 'id' | 'title'>
      ) }
    )>, payment?: Maybe<(
      { __typename?: 'PaymentType' }
      & Pick<PaymentType, 'id' | 'date' | 'amountAgreement' | 'currency'>
      & { agreement: (
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id' | 'agreementTitle'>
        & { student: (
          { __typename?: 'StudentType' }
          & Pick<StudentType, 'id'>
          & { user?: Maybe<(
            { __typename?: 'CustomUserType' }
            & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'email' | 'phone'>
          )> }
        ), group: (
          { __typename?: 'MethodistGroupType' }
          & Pick<MethodistGroupType, 'id' | 'name'>
          & { course: (
            { __typename?: 'CourseFilterType' }
            & Pick<CourseFilterType, 'id' | 'title'>
          ) }
        ) }
      ) }
    )>, agreement?: Maybe<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'agreementTitle'>
      & { student: (
        { __typename?: 'StudentType' }
        & Pick<StudentType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'CustomUserType' }
          & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'email' | 'phone'>
        )> }
      ), group: (
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name'>
        & { course: (
          { __typename?: 'CourseFilterType' }
          & Pick<CourseFilterType, 'id' | 'title'>
        ) }
      ) }
    )>, fakturowniaPayments?: Maybe<Array<Maybe<(
      { __typename?: 'FakturowniaPaymentType' }
      & Pick<FakturowniaPaymentType, 'id' | 'pk' | 'fakturowniaId' | 'paidDate' | 'price' | 'currency' | 'kind'>
    )>>>, parentInvoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'number' | 'issueDate' | 'priceGross' | 'status' | 'currency'>
    )>, corrections?: Maybe<Array<Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'issueDate' | 'priceGross' | 'currency' | 'correctionReason' | 'status' | 'outstanding'>
    )>>>, advances?: Maybe<Array<Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'issueDate' | 'priceGross' | 'currency' | 'status' | 'paid'>
    )>>>, finalInvoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'issueDate' | 'priceGross' | 'currency' | 'status' | 'paid'>
    )> }
  )> }
);

export type FakturowniaSyncStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type FakturowniaSyncStatusQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fakturowniaUnmatchedCount'>
  & { fakturowniaSyncStatus?: Maybe<(
    { __typename?: 'FakturowniaSyncStatus' }
    & Pick<FakturowniaSyncStatus, 'isRunning'>
    & { lastRun?: Maybe<(
      { __typename?: 'FakturowniaSyncRunType' }
      & Pick<FakturowniaSyncRunType, 'startedAt' | 'finishedAt' | 'status' | 'stats' | 'errorMessage' | 'taskName'>
    )>, lastSuccess?: Maybe<(
      { __typename?: 'FakturowniaSyncRunType' }
      & Pick<FakturowniaSyncRunType, 'startedAt' | 'stats'>
    )> }
  )> }
);

export type StudentAgreementsForLinkingQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type StudentAgreementsForLinkingQuery = (
  { __typename?: 'Query' }
  & { student?: Maybe<(
    { __typename?: 'StudentType' }
    & Pick<StudentType, 'id'>
    & { user?: Maybe<(
      { __typename?: 'CustomUserType' }
      & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'email'>
    )>, agreements: Array<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'agreementTitle' | 'currency' | 'terminated'>
      & { group: (
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name'>
      ), contributions: (
        { __typename?: 'ContributionTypeConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'ContributionTypeEdge' }
          & { node?: Maybe<(
            { __typename?: 'ContributionType' }
            & Pick<ContributionType, 'id' | 'date' | 'amountForeign' | 'amountByn' | 'status' | 'debt' | 'complete' | 'remainder'>
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type FakturowniaUnmatchedCountQueryVariables = Exact<{ [key: string]: never; }>;


export type FakturowniaUnmatchedCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fakturowniaUnmatchedCount'>
);

export type ExpensesQueryVariables = Exact<{
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  source?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  recurrence?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  teacherId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  legalEntityId?: Maybe<Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type ExpensesQuery = (
  { __typename?: 'Query' }
  & { expenses?: Maybe<Array<Maybe<(
    { __typename?: 'ExpenseType' }
    & Pick<ExpenseType, 'id' | 'pk' | 'date' | 'amount' | 'amountPln' | 'currency' | 'description' | 'counterpartyName' | 'counterpartyTaxNo' | 'source' | 'paidAt' | 'dueAt' | 'isOverdue' | 'documentUrl' | 'notes' | 'recurrence' | 'recurrenceDay' | 'recurrenceUntil' | 'status' | 'isCorrection' | 'correctionReason'>
    & { category?: Maybe<(
      { __typename?: 'ExpenseCategoryType' }
      & Pick<ExpenseCategoryType, 'id' | 'name' | 'slug'>
    )>, relatedTeacher?: Maybe<(
      { __typename?: 'TeacherFilterType' }
      & Pick<TeacherFilterType, 'id'>
      & { user: (
        { __typename?: 'CustomUserType' }
        & Pick<CustomUserType, 'id' | 'firstName' | 'lastName'>
      ) }
    )>, relatedGroup?: Maybe<(
      { __typename?: 'MethodistGroupType' }
      & Pick<MethodistGroupType, 'id' | 'name'>
    )>, relatedFakturowniaInvoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'kind' | 'correctionReason'>
      & { parentInvoice?: Maybe<(
        { __typename?: 'FakturowniaInvoiceType' }
        & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number'>
      )> }
    )> }
  )>>> }
);

export type ExpenseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExpenseQuery = (
  { __typename?: 'Query' }
  & { expense?: Maybe<(
    { __typename?: 'ExpenseType' }
    & Pick<ExpenseType, 'id' | 'pk' | 'date' | 'amount' | 'amountPln' | 'currency' | 'description' | 'counterpartyName' | 'counterpartyTaxNo' | 'source' | 'paidAt' | 'dueAt' | 'isOverdue' | 'documentUrl' | 'notes' | 'recurrence' | 'recurrenceDay' | 'recurrenceUntil' | 'status' | 'isCorrection' | 'correctionReason'>
    & { category?: Maybe<(
      { __typename?: 'ExpenseCategoryType' }
      & Pick<ExpenseCategoryType, 'id' | 'name' | 'slug'>
    )>, relatedTeacher?: Maybe<(
      { __typename?: 'TeacherFilterType' }
      & Pick<TeacherFilterType, 'id'>
      & { user: (
        { __typename?: 'CustomUserType' }
        & Pick<CustomUserType, 'id' | 'firstName' | 'lastName'>
      ) }
    )>, relatedGroup?: Maybe<(
      { __typename?: 'MethodistGroupType' }
      & Pick<MethodistGroupType, 'id' | 'name'>
      & { course: (
        { __typename?: 'CourseFilterType' }
        & Pick<CourseFilterType, 'id' | 'title'>
      ) }
    )>, relatedFakturowniaInvoice?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'kind' | 'status' | 'correctionReason'>
      & { parentInvoice?: Maybe<(
        { __typename?: 'FakturowniaInvoiceType' }
        & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number'>
      )> }
    )> }
  )> }
);

export type ReceivedInvoicesForExpenseQueryVariables = Exact<{
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  unlinkedOnly?: Maybe<Scalars['Boolean']>;
}>;


export type ReceivedInvoicesForExpenseQuery = (
  { __typename?: 'Query' }
  & { receivedInvoicesForExpense?: Maybe<Array<Maybe<(
    { __typename?: 'ReceivedInvoiceForExpenseType' }
    & Pick<ReceivedInvoiceForExpenseType, 'pk' | 'number' | 'issueDate' | 'paymentTo' | 'currency' | 'priceGross' | 'buyerName' | 'buyerTaxNo' | 'accountingKind' | 'kind' | 'status'>
  )>>> }
);

export type ExpenseCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseCategoriesQuery = (
  { __typename?: 'Query' }
  & { expenseCategories?: Maybe<Array<Maybe<(
    { __typename?: 'ExpenseCategoryType' }
    & Pick<ExpenseCategoryType, 'id' | 'pk' | 'name' | 'slug' | 'isActive'>
  )>>> }
);

export type ExpenseAggregatesQueryVariables = Exact<{
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  groupBy: Scalars['String'];
  teacherId?: Maybe<Scalars['ID']>;
}>;


export type ExpenseAggregatesQuery = (
  { __typename?: 'Query' }
  & { expenseAggregates?: Maybe<Array<Maybe<(
    { __typename?: 'ExpenseAggregateRow' }
    & Pick<ExpenseAggregateRow, 'group' | 'total' | 'count'>
  )>>> }
);

export type FakturowniaInvoiceAggregatesQueryVariables = Exact<{
  direction?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  groupBy: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
}>;


export type FakturowniaInvoiceAggregatesQuery = (
  { __typename?: 'Query' }
  & { fakturowniaInvoiceAggregates?: Maybe<Array<Maybe<(
    { __typename?: 'FakturowniaInvoiceAggregateRow' }
    & Pick<FakturowniaInvoiceAggregateRow, 'group' | 'totalGross' | 'totalPaid' | 'totalOutstanding' | 'totalExpected' | 'count'>
  )>>> }
);

export type InvoiceIssuePreflightQueryVariables = Exact<{
  agreementId: Scalars['ID'];
  contributionId?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
}>;


export type InvoiceIssuePreflightQuery = (
  { __typename?: 'Query' }
  & { fakturowniaContributionBillability: (
    { __typename?: 'FakturowniaBillabilityType' }
    & Pick<FakturowniaBillabilityType, 'billable' | 'kind' | 'reason' | 'agreementId' | 'contributionId' | 'studentName' | 'groupName' | 'courseName' | 'amount' | 'currency' | 'paymentTo' | 'positionName' | 'taxRate' | 'buyerName' | 'buyerEmail' | 'buyerTaxNo' | 'buyerAddress' | 'missingFields'>
  ) }
);

export type GroupInvoiceIssuePreflightQueryVariables = Exact<{
  groupId: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
}>;


export type GroupInvoiceIssuePreflightQuery = (
  { __typename?: 'Query' }
  & { fakturowniaGroupBillingPreview: (
    { __typename?: 'FakturowniaGroupBillingPreviewType' }
    & Pick<FakturowniaGroupBillingPreviewType, 'total' | 'billableCount' | 'skippedCount'>
    & { rows: Array<(
      { __typename?: 'FakturowniaBillabilityType' }
      & Pick<FakturowniaBillabilityType, 'billable' | 'reason' | 'agreementId' | 'contributionId' | 'studentName' | 'groupName' | 'courseName' | 'amount' | 'currency' | 'paymentTo' | 'positionName' | 'taxRate' | 'buyerName' | 'buyerEmail' | 'buyerTaxNo' | 'buyerAddress' | 'missingFields'>
    )> }
  ) }
);

export type InvoiceIssueJobProgressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InvoiceIssueJobProgressQuery = (
  { __typename?: 'Query' }
  & { fakturowniaBillingJob?: Maybe<(
    { __typename?: 'FakturowniaBillingJobType' }
    & Pick<FakturowniaBillingJobType, 'id' | 'pk' | 'status' | 'documentKind' | 'total' | 'issuedCount' | 'skippedCount' | 'failedCount'>
    & { rows?: Maybe<Array<(
      { __typename?: 'FakturowniaBillingJobRowType' }
      & Pick<FakturowniaBillingJobRowType, 'pk' | 'status' | 'reason' | 'amount' | 'currency' | 'studentName' | 'invoiceNumber' | 'viewUrl'>
    )>> }
  )> }
);

export type StudentProformasQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type StudentProformasQuery = (
  { __typename?: 'Query' }
  & { fakturowniaInvoices?: Maybe<Array<Maybe<(
    { __typename?: 'FakturowniaInvoiceType' }
    & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'kind' | 'status' | 'issueDate' | 'paymentTo' | 'currency' | 'priceGross' | 'paid' | 'outstanding' | 'viewUrl' | 'isProforma' | 'isOpenProforma' | 'proformaForContributionId'>
    & { vatChild?: Maybe<(
      { __typename?: 'FakturowniaInvoiceType' }
      & Pick<FakturowniaInvoiceType, 'id' | 'pk' | 'number' | 'viewUrl'>
    )> }
  )>>> }
);

export type PlannedYearContributionsQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type PlannedYearContributionsQuery = (
  { __typename?: 'Query' }
  & { financePlan?: Maybe<Array<Maybe<(
    { __typename?: 'MonthBudget' }
    & Pick<MonthBudget, 'month' | 'USD' | 'EUR' | 'BYN' | 'RUB' | 'PLN'>
  )>>>, financeBudget?: Maybe<Array<Maybe<(
    { __typename?: 'MonthBudget' }
    & Pick<MonthBudget, 'month' | 'USD' | 'EUR' | 'BYN' | 'RUB' | 'PLN'>
  )>>> }
);

export type PlannedMonthContributionsQueryVariables = Exact<{
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type PlannedMonthContributionsQuery = (
  { __typename?: 'Query' }
  & { financeMonthBudget?: Maybe<(
    { __typename?: 'WeeksBudgetInfo' }
    & { plan?: Maybe<Array<Maybe<(
      { __typename?: 'WeeksBudget' }
      & Pick<WeeksBudget, 'week' | 'USD' | 'EUR' | 'BYN' | 'RUB' | 'PLN'>
    )>>>, budget?: Maybe<Array<Maybe<(
      { __typename?: 'WeeksBudget' }
      & Pick<WeeksBudget, 'week' | 'USD' | 'EUR' | 'BYN' | 'RUB' | 'PLN'>
    )>>> }
  )> }
);

export type FinanceYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceYearsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'financeYears'>
);

export type PaginatedGroupsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  withStaffFields: Scalars['Boolean'];
}>;


export type PaginatedGroupsQuery = (
  { __typename?: 'Query' }
  & { allGroups?: Maybe<(
    { __typename?: 'GroupConnection' }
    & Pick<GroupConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'GroupEdge' }
      & Pick<GroupEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'GroupType' }
        & MakeOptional<Pick<GroupType, 'id' | 'name' | 'startDate' | 'lessonsCount' | 'studentsCount' | 'publishedLms' | 'publishedLmsForTeacher' | 'publishedLmsForMethodist' | 'price' | 'currency' | 'contributionsSum'>, 'price' | 'currency'>
        & { classesDays: Array<(
          { __typename?: 'DayOfClassType' }
          & Pick<DayOfClassType, 'weekDay'>
        )> }
      )> }
    )>> }
  )> }
);

export type LoadEditingGroupQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type LoadEditingGroupQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'GroupType' }
    & Pick<GroupType, 'id' | 'name' | 'price' | 'currency' | 'startDate' | 'deleteAvailable'>
    & { course: (
      { __typename?: 'CourseFilterType' }
      & Pick<CourseFilterType, 'id' | 'name'>
    ), classesDays: Array<(
      { __typename?: 'DayOfClassType' }
      & Pick<DayOfClassType, 'id' | 'weekDay' | 'startTime' | 'endTime'>
    )>, modules: Array<(
      { __typename?: 'GroupModuleType' }
      & Pick<GroupModuleType, 'id' | 'name'>
      & { lessons: (
        { __typename?: 'GroupLessonTypeConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'GroupLessonTypeEdge' }
          & { node?: Maybe<(
            { __typename?: 'GroupLessonType' }
            & Pick<GroupLessonType, 'id' | 'name' | 'lessonNumber' | 'additional' | 'date' | 'lmsDescription'>
            & { teacherApplication?: Maybe<(
              { __typename?: 'ApplicationType' }
              & Pick<ApplicationType, 'id'>
              & { teacher: (
                { __typename?: 'TeacherFilterType' }
                & Pick<TeacherFilterType, 'fullName'>
              ) }
            )> }
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type GroupJoinLinkInfoQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
}>;


export type GroupJoinLinkInfoQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'GroupType' }
    & GroupJoinLinkFieldsFragment
  )> }
);

export type LessonJoinClicksListQueryVariables = Exact<{
  lessonId: Scalars['Int'];
}>;


export type LessonJoinClicksListQuery = (
  { __typename?: 'Query' }
  & { lessonJoinClicks?: Maybe<Array<Maybe<(
    { __typename?: 'LessonJoinClickType' }
    & Pick<LessonJoinClickType, 'id' | 'userName' | 'role' | 'clickedAt' | 'clicksCount' | 'attendanceState'>
  )>>> }
);

export type GroupAttendanceSummaryQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupAttendanceSummaryQuery = (
  { __typename?: 'Query' }
  & { groupAttendanceSummary?: Maybe<(
    { __typename?: 'GroupAttendanceSummary' }
    & Pick<GroupAttendanceSummary, 'groupId' | 'threshold' | 'totalLessons' | 'passedLessons' | 'unclosedLessons' | 'averageAttendance' | 'studentsBelowThresholdCount'>
    & { students: Array<(
      { __typename?: 'GroupAttendanceStudentRow' }
      & Pick<GroupAttendanceStudentRow, 'studentId' | 'fullName' | 'expectedLessons' | 'attended' | 'missed' | 'attendanceRate' | 'belowThreshold'>
    )> }
  )> }
);

export type GroupPerformanceSummaryQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupPerformanceSummaryQuery = (
  { __typename?: 'Query' }
  & { groupPerformanceSummary?: Maybe<(
    { __typename?: 'GroupPerformanceSummary' }
    & Pick<GroupPerformanceSummary, 'groupId' | 'averageMark' | 'studentsWithoutMarks'>
    & { top: Array<(
      { __typename?: 'StudentPerfRow' }
      & Pick<StudentPerfRow, 'studentId' | 'fullName' | 'averageMark' | 'marksCount'>
    )>, bottom: Array<(
      { __typename?: 'StudentPerfRow' }
      & Pick<StudentPerfRow, 'studentId' | 'fullName' | 'averageMark' | 'marksCount'>
    )> }
  )> }
);

export type GroupRevenueAggregatesQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupRevenueAggregatesQuery = (
  { __typename?: 'Query' }
  & { groupRevenueAggregates?: Maybe<(
    { __typename?: 'GroupRevenueAggregates' }
    & Pick<GroupRevenueAggregates, 'groupId'>
    & { rows: Array<(
      { __typename?: 'GroupRevenueRow' }
      & Pick<GroupRevenueRow, 'currency' | 'budget' | 'paid' | 'debt' | 'upcoming' | 'agreementsActive' | 'studentsWithDebt'>
    )> }
  )> }
);

export type GroupLessonsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupLessonsQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'GroupType' }
    & Pick<GroupType, 'id'>
    & { classesDays: Array<(
      { __typename?: 'DayOfClassType' }
      & Pick<DayOfClassType, 'weekDay' | 'startTime' | 'endTime'>
    )>, zoomAccount?: Maybe<(
      { __typename?: 'ZoomAccountType' }
      & Pick<ZoomAccountType, 'id' | 'displayName'>
    )>, zoomSchedules: (
      { __typename?: 'GroupZoomScheduleTypeConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'GroupZoomScheduleTypeEdge' }
        & { node?: Maybe<(
          { __typename?: 'GroupZoomScheduleType' }
          & Pick<GroupZoomScheduleType, 'id' | 'weekDay' | 'runTime' | 'isActive'>
        )> }
      )>> }
    ), lessons?: Maybe<Array<(
      { __typename?: 'GroupLessonType' }
      & Pick<GroupLessonType, 'id' | 'name' | 'number' | 'lessonNumber' | 'date' | 'startTime' | 'endTime' | 'startsAt' | 'endsAt' | 'finished' | 'additional' | 'whiteboardId'>
      & { homeworkStats?: Maybe<(
        { __typename?: 'LessonHomeworkStatsType' }
        & Pick<LessonHomeworkStatsType, 'hasAssignment' | 'assignmentSource' | 'totalStudents' | 'submittedCount' | 'gradedCount' | 'suspiciousCount'>
      )>, module: (
        { __typename?: 'GroupModuleType' }
        & Pick<GroupModuleType, 'id' | 'name'>
      ), teacher?: Maybe<(
        { __typename?: 'TeacherType' }
        & Pick<TeacherType, 'id' | 'fullName'>
      )>, zoomRecordingMeta?: Maybe<(
        { __typename?: 'LessonRecordingType' }
        & LessonRecordingFieldsFragment
      )> }
    )>> }
  )> }
);

export type GroupRosterQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupRosterQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'GroupType' }
    & Pick<GroupType, 'id'>
    & { agreements: Array<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'agreementTitle' | 'currency' | 'budgetAmount' | 'paidAmount' | 'debtAmount' | 'upcomingAmount' | 'terminated' | 'terminatedDate' | 'date' | 'contributionsCount' | 'paidContributionsCount' | 'freeOfCharge' | 'statePrefinanced'>
      & { student: (
        { __typename?: 'StudentType' }
        & Pick<StudentType, 'id' | 'isLmsBlocked'>
        & { user?: Maybe<(
          { __typename?: 'CustomUserType' }
          & Pick<CustomUserType, 'id' | 'firstName' | 'middleName' | 'lastName' | 'email' | 'phone'>
        )> }
      ), pandadocDocument?: Maybe<(
        { __typename?: 'PandaDocDocumentType' }
        & Pick<PandaDocDocumentType, 'id' | 'status' | 'outcome'>
      )>, contractDocument?: Maybe<(
        { __typename?: 'ContractSummaryType' }
        & Pick<ContractSummaryType, 'id' | 'number' | 'status' | 'fulfilmentStatus'>
      )>, scheduleContributions: Array<(
        { __typename?: 'ContributionType' }
        & Pick<ContributionType, 'id' | 'date' | 'amountForeign' | 'status' | 'debt' | 'hasVatInvoice'>
        & { invoices?: Maybe<Array<Maybe<(
          { __typename?: 'FakturowniaInvoiceType' }
          & Pick<FakturowniaInvoiceType, 'id' | 'number' | 'kind' | 'status' | 'isCorrection' | 'isAdvance' | 'isFinal' | 'isEstimate' | 'isQuotation'>
        )>>>, currencyMismatchInvoices: Array<(
          { __typename?: 'FakturowniaInvoiceType' }
          & Pick<FakturowniaInvoiceType, 'id' | 'currency'>
        )> }
      )> }
    )> }
  )> }
);

export type GroupFinanceContributionsQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupFinanceContributionsQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'GroupType' }
    & Pick<GroupType, 'id'>
    & { agreements: Array<(
      { __typename?: 'AgreementType' }
      & Pick<AgreementType, 'id' | 'currency' | 'budgetAmount' | 'paidAmount' | 'terminated' | 'debtAmount' | 'upcomingAmount' | 'freeOfCharge' | 'statePrefinanced'>
      & { scheduleContributions: Array<(
        { __typename?: 'ContributionType' }
        & Pick<ContributionType, 'id' | 'date' | 'amountForeign' | 'complete' | 'remainder' | 'delay' | 'coveredAmount' | 'debt' | 'status'>
      )> }
    )> }
  )> }
);

export type GroupMaterialsQueryVariables = Exact<{
  groupId: Scalars['ID'];
  lessonId?: Maybe<Scalars['ID']>;
  kind?: Maybe<MaterialKindEnum>;
}>;


export type GroupMaterialsQuery = (
  { __typename?: 'Query' }
  & { materials: Array<Maybe<(
    { __typename?: 'MaterialType' }
    & Pick<MaterialType, 'id' | 'pk' | 'kind' | 'title' | 'description' | 'dueDate' | 'createdAt' | 'updatedAt'>
    & { createdBy?: Maybe<(
      { __typename?: 'CustomUserType' }
      & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'email'>
    )>, lesson?: Maybe<(
      { __typename?: 'GroupLessonType' }
      & Pick<GroupLessonType, 'id' | 'name' | 'number' | 'lessonNumber' | 'date'>
    )>, attachments: Array<(
      { __typename?: 'MaterialAttachmentType' }
      & Pick<MaterialAttachmentType, 'id' | 'pk' | 'originalName' | 'contentType' | 'sizeBytes' | 'uploadedAt' | 'url'>
    )> }
  )>> }
);

export type ErpGroupHomeworkOverviewQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type ErpGroupHomeworkOverviewQuery = (
  { __typename?: 'Query' }
  & { groupHomeworkOverviewForErp: Array<(
    { __typename?: 'LessonHomeworkStatsType' }
    & Pick<LessonHomeworkStatsType, 'lessonId' | 'hasAssignment' | 'assignmentSource' | 'assignmentRef' | 'textbookFileCount' | 'textbookFileName' | 'totalStudents' | 'submittedCount' | 'gradedCount' | 'aiDoneCount' | 'suspiciousCount'>
  )> }
);

export type ErpLessonHomeworkSubmissionsQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type ErpLessonHomeworkSubmissionsQuery = (
  { __typename?: 'Query' }
  & { lessonHomeworkSubmissionsForErp: Array<(
    { __typename?: 'HomeworkRosterRowType' }
    & Pick<HomeworkRosterRowType, 'studentId' | 'studentName' | 'hwMark'>
    & { submission?: Maybe<(
      { __typename?: 'HomeworkSubmissionType' }
      & HomeworkSubmissionFieldsFragment
    )> }
  )> }
);

export type ErpStudentHomeworkQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type ErpStudentHomeworkQuery = (
  { __typename?: 'Query' }
  & { studentHomeworkForErp: Array<(
    { __typename?: 'StudentHomeworkRowType' }
    & Pick<StudentHomeworkRowType, 'groupId' | 'groupName' | 'lessonId' | 'lessonName' | 'assignmentTitle' | 'hwMark'>
    & { submission?: Maybe<(
      { __typename?: 'HomeworkSubmissionType' }
      & HomeworkSubmissionFieldsFragment
    )> }
  )> }
);

export type ErpHomeworkSubmissionDownloadUrlQueryVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type ErpHomeworkSubmissionDownloadUrlQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'homeworkSubmissionDownloadUrlForErp'>
);

export type ErpGroupHomeworkMarksQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type ErpGroupHomeworkMarksQuery = (
  { __typename?: 'Query' }
  & { groupHomeworkMarksForErp: Array<(
    { __typename?: 'StudentLessonHwMarkType' }
    & Pick<StudentLessonHwMarkType, 'lessonId' | 'studentId' | 'hwMark' | 'submitted'>
  )> }
);

export type PaginatedJournalsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  withStaffFields: Scalars['Boolean'];
}>;


export type PaginatedJournalsQuery = (
  { __typename?: 'Query' }
  & { allGroups?: Maybe<(
    { __typename?: 'GroupConnection' }
    & Pick<GroupConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'GroupEdge' }
      & Pick<GroupEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'GroupType' }
        & Pick<GroupType, 'id' | 'name'>
        & { course: (
          { __typename?: 'CourseFilterType' }
          & Pick<CourseFilterType, 'name'>
        ), teachers?: Maybe<Array<Maybe<(
          { __typename?: 'TeacherType' }
          & Pick<TeacherType, 'fullName'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type PaginatedJournalQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type PaginatedJournalQuery = (
  { __typename?: 'Query' }
  & { journal?: Maybe<(
    { __typename?: 'GroupLessonConnection' }
    & Pick<GroupLessonConnection, 'id' | 'groupName' | 'comment'>
    & { edges: Array<Maybe<(
      { __typename?: 'GroupLessonEdge' }
      & { node?: Maybe<(
        { __typename?: 'GroupLessonType' }
        & Pick<GroupLessonType, 'id' | 'date' | 'lessonNumber' | 'whiteboardId'>
      )> }
    )>> }
  )> }
);

export type StudentsForJournalQueryVariables = Exact<{
  lessonsId: Array<Maybe<Scalars['Int']>>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  groupId: Scalars['Int'];
}>;


export type StudentsForJournalQuery = (
  { __typename?: 'Query' }
  & { studentsForJournal?: Maybe<(
    { __typename?: 'StudentConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'StudentEdge' }
      & Pick<StudentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'StudentType' }
        & Pick<StudentType, 'id' | 'agreementIsActive'>
        & { user?: Maybe<(
          { __typename?: 'CustomUserType' }
          & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'middleName'>
        )>, attendances: (
          { __typename?: 'AttendanceTypeConnection' }
          & { edges: Array<Maybe<(
            { __typename?: 'AttendanceTypeEdge' }
            & { node?: Maybe<(
              { __typename?: 'AttendanceType' }
              & Pick<AttendanceType, 'id' | 'attendance' | 'source' | 'markedAt' | 'markedByName'>
              & { lesson: (
                { __typename?: 'GroupLessonType' }
                & Pick<GroupLessonType, 'id'>
              ) }
            )> }
          )>> }
        ) }
      )> }
    )>> }
  )> }
);

export type LoadEditingJournalQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type LoadEditingJournalQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'GroupType' }
    & Pick<GroupType, 'id' | 'comment'>
    & { classesDays: Array<(
      { __typename?: 'DayOfClassType' }
      & Pick<DayOfClassType, 'id' | 'weekDay' | 'startTime' | 'endTime'>
    )>, modules: Array<(
      { __typename?: 'GroupModuleType' }
      & Pick<GroupModuleType, 'id' | 'name'>
      & { lessons: (
        { __typename?: 'GroupLessonTypeConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'GroupLessonTypeEdge' }
          & { node?: Maybe<(
            { __typename?: 'GroupLessonType' }
            & Pick<GroupLessonType, 'id' | 'name' | 'lessonNumber' | 'additional' | 'date' | 'lmsDescription'>
            & { teacherApplication?: Maybe<(
              { __typename?: 'ApplicationType' }
              & Pick<ApplicationType, 'id'>
              & { teacher: (
                { __typename?: 'TeacherFilterType' }
                & Pick<TeacherFilterType, 'fullName'>
              ) }
            )> }
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type LmsBlockSettingsViewQueryVariables = Exact<{ [key: string]: never; }>;


export type LmsBlockSettingsViewQuery = (
  { __typename?: 'Query' }
  & { lmsBlockSettings: (
    { __typename?: 'LmsBlockSettingsType' }
    & Pick<LmsBlockSettingsType, 'robotEnabled' | 'overdueDays' | 'mailEnabled' | 'slackEnabled' | 'smsEnabled' | 'suspendedTemplateId' | 'suspendedTemplateName' | 'restoredTemplateId' | 'restoredTemplateName' | 'updatedAt' | 'updatedByName' | 'serverRobotAllowed' | 'serverMailAllowed' | 'serverSlackAllowed' | 'serverSmsAllowed' | 'canEdit'>
  ) }
);

export type LmsBlockTemplatePickerQueryVariables = Exact<{ [key: string]: never; }>;


export type LmsBlockTemplatePickerQuery = (
  { __typename?: 'Query' }
  & { lmsBlockSendgridTemplates: (
    { __typename?: 'LmsBlockSendgridTemplatesType' }
    & Pick<LmsBlockSendgridTemplatesType, 'success'>
    & { templates: Array<(
      { __typename?: 'SendgridTemplateType' }
      & Pick<SendgridTemplateType, 'id' | 'name' | 'subject' | 'versionId' | 'updatedAt'>
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'code' | 'message'>
    )>>> }
  ) }
);

export type LmsBlockTemplateVariablesListQueryVariables = Exact<{ [key: string]: never; }>;


export type LmsBlockTemplateVariablesListQuery = (
  { __typename?: 'Query' }
  & { lmsBlockTemplateVariables: Array<(
    { __typename?: 'LmsBlockTemplateVariableType' }
    & Pick<LmsBlockTemplateVariableType, 'name' | 'type' | 'descriptionPl' | 'descriptionRu' | 'example'>
    & { fields: Array<(
      { __typename?: 'LmsBlockTemplateVariableFieldType' }
      & Pick<LmsBlockTemplateVariableFieldType, 'name' | 'type' | 'descriptionPl' | 'descriptionRu' | 'example'>
    )> }
  )> }
);

export type LmsBlockTemplateExampleDataQueryVariables = Exact<{
  kind: Scalars['String'];
}>;


export type LmsBlockTemplateExampleDataQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'lmsBlockTemplateExample'>
);

export type MarketingOverviewReportQueryVariables = Exact<{
  filter: MarketingFilter;
  granularity?: Maybe<MarketingGranularity>;
  compare?: Maybe<MarketingCompare>;
}>;


export type MarketingOverviewReportQuery = (
  { __typename?: 'Query' }
  & { marketingOverview: (
    { __typename?: 'MarketingOverview' }
    & Pick<MarketingOverview, 'dataVersion' | 'leadHistoryFrom'>
    & { current: (
      { __typename?: 'MarketingMetrics' }
      & MarketingMetricsFieldsFragment
    ), previous: (
      { __typename?: 'MarketingMetrics' }
      & MarketingMetricsFieldsFragment
    ), compareInfo?: Maybe<(
      { __typename?: 'MarketingCompareInfo' }
      & MarketingCompareInfoFieldsFragment
    )>, coverage: (
      { __typename?: 'MarketingCoverageInfo' }
      & Pick<MarketingCoverageInfo, 'spendComplete' | 'missingSpendDays' | 'provisionalFrom'>
    ), series: Array<(
      { __typename?: 'MarketingSeriesPoint' }
      & Pick<MarketingSeriesPoint, 'period' | 'dateFrom' | 'dateTo' | 'previousPeriod' | 'previousDateFrom' | 'previousDateTo'>
      & { metrics: (
        { __typename?: 'MarketingMetrics' }
        & MarketingMetricsFieldsFragment
      ), previous?: Maybe<(
        { __typename?: 'MarketingMetrics' }
        & MarketingMetricsFieldsFragment
      )> }
    )>, channels: Array<(
      { __typename?: 'MarketingChannelShare' }
      & Pick<MarketingChannelShare, 'channel'>
      & { metrics: (
        { __typename?: 'MarketingMetrics' }
        & MarketingMetricsFieldsFragment
      ) }
    )>, sources: Array<(
      { __typename?: 'MarketingSourceStatus' }
      & MarketingSourceStatusFieldsFragment
    )>, planFact: Array<(
      { __typename?: 'MarketingPlanFact' }
      & Pick<MarketingPlanFact, 'metric' | 'target' | 'fact' | 'pace'>
    )> }
  ) }
);

export type MarketingDataVersionProbeQueryVariables = Exact<{
  filter: MarketingFilter;
}>;


export type MarketingDataVersionProbeQuery = (
  { __typename?: 'Query' }
  & { marketingOverview: (
    { __typename?: 'MarketingOverview' }
    & Pick<MarketingOverview, 'dataVersion'>
  ) }
);

export type MarketingBreakdownReportQueryVariables = Exact<{
  filter: MarketingFilter;
  dimension: MarketingDimension;
  parentKey?: Maybe<Scalars['String']>;
  withSeries?: Maybe<Scalars['Boolean']>;
  granularity?: Maybe<MarketingGranularity>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
  compare?: Maybe<MarketingCompare>;
  includeVanished?: Maybe<Scalars['Boolean']>;
  having?: Maybe<Array<MarketingRowPredicate>>;
  minSpendPln?: Maybe<Scalars['Decimal']>;
  minCrmLeads?: Maybe<Scalars['Int']>;
}>;


export type MarketingBreakdownReportQuery = (
  { __typename?: 'Query' }
  & { marketingBreakdown: (
    { __typename?: 'MarketingBreakdown' }
    & Pick<MarketingBreakdown, 'dimension' | 'totalCount'>
    & { crumbs: Array<(
      { __typename?: 'MarketingOption' }
      & Pick<MarketingOption, 'id' | 'name'>
    )>, total: (
      { __typename?: 'MarketingMetrics' }
      & MarketingMetricsFieldsFragment
    ), predicateCounts: Array<(
      { __typename?: 'MarketingCount' }
      & Pick<MarketingCount, 'value' | 'count'>
    )>, compareInfo?: Maybe<(
      { __typename?: 'MarketingCompareInfo' }
      & MarketingCompareInfoFieldsFragment
    )>, rows: Array<(
      { __typename?: 'MarketingBreakdownRow' }
      & Pick<MarketingBreakdownRow, 'key' | 'label' | 'platform' | 'status' | 'format' | 'thumbnailUrl' | 'salesCoverage'>
      & { metrics: (
        { __typename?: 'MarketingMetrics' }
        & MarketingMetricsFieldsFragment
      ), previous?: Maybe<(
        { __typename?: 'MarketingMetrics' }
        & MarketingMetricsFieldsFragment
      )>, series?: Maybe<Array<(
        { __typename?: 'MarketingSeriesPoint' }
        & Pick<MarketingSeriesPoint, 'period' | 'dateFrom' | 'dateTo'>
        & { metrics: (
          { __typename?: 'MarketingMetrics' }
          & MarketingMetricsFieldsFragment
        ) }
      )>> }
    )> }
  ) }
);

export type MarketingMatrixReportQueryVariables = Exact<{
  filter: MarketingFilter;
  rows?: Maybe<MarketingDimension>;
  cols?: Maybe<MarketingDimension>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
}>;


export type MarketingMatrixReportQuery = (
  { __typename?: 'Query' }
  & { marketingMatrix: Array<(
    { __typename?: 'MarketingMatrixCell' }
    & Pick<MarketingMatrixCell, 'rowKey' | 'rowLabel' | 'colKey' | 'colLabel'>
    & { metrics: (
      { __typename?: 'MarketingMetrics' }
      & MarketingMetricsFieldsFragment
    ) }
  )> }
);

export type MarketingSeriesReportQueryVariables = Exact<{
  filter: MarketingFilter;
  granularity?: Maybe<MarketingGranularity>;
  compare?: Maybe<MarketingCompare>;
}>;


export type MarketingSeriesReportQuery = (
  { __typename?: 'Query' }
  & { marketingSeries: Array<(
    { __typename?: 'MarketingSeriesPoint' }
    & Pick<MarketingSeriesPoint, 'period' | 'dateFrom' | 'dateTo' | 'previousPeriod' | 'previousDateFrom' | 'previousDateTo'>
    & { metrics: (
      { __typename?: 'MarketingMetrics' }
      & MarketingMetricsFieldsFragment
    ), previous?: Maybe<(
      { __typename?: 'MarketingMetrics' }
      & MarketingMetricsFieldsFragment
    )> }
  )> }
);

export type MarketingSalesReportQueryVariables = Exact<{
  filter: MarketingFilter;
  onlySales?: Maybe<Scalars['Boolean']>;
  coverage?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type MarketingSalesReportQuery = (
  { __typename?: 'Query' }
  & { marketingSales: (
    { __typename?: 'MarketingSalesPage' }
    & Pick<MarketingSalesPage, 'totalCount'>
    & { rows: Array<(
      { __typename?: 'MarketingSaleRow' }
      & Pick<MarketingSaleRow, 'id' | 'source' | 'sourceId' | 'day' | 'kind' | 'isSale' | 'saleReason' | 'familySlug' | 'familyName' | 'pricePln' | 'cashPln' | 'emailMasked' | 'leadKommoId' | 'coverage' | 'lastChannel' | 'lastCampaign' | 'lastAd' | 'firstChannel' | 'leadToSaleDays'>
      & { touches: Array<(
        { __typename?: 'MarketingSaleTouch' }
        & Pick<MarketingSaleTouch, 'at' | 'pipelineKind' | 'channel' | 'campaign' | 'ad' | 'matchRule' | 'isFirst' | 'isLast'>
      )> }
    )> }
  ) }
);

export type MarketingSaleByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MarketingSaleByIdQuery = (
  { __typename?: 'Query' }
  & { marketingSale?: Maybe<(
    { __typename?: 'MarketingSaleRow' }
    & Pick<MarketingSaleRow, 'id' | 'source' | 'sourceId' | 'day' | 'kind' | 'isSale' | 'saleReason' | 'familySlug' | 'familyName' | 'pricePln' | 'cashPln' | 'emailMasked' | 'leadKommoId' | 'coverage' | 'lastChannel' | 'lastCampaign' | 'lastAd' | 'firstChannel' | 'leadToSaleDays'>
    & { touches: Array<(
      { __typename?: 'MarketingSaleTouch' }
      & Pick<MarketingSaleTouch, 'at' | 'pipelineKind' | 'channel' | 'campaign' | 'ad' | 'matchRule' | 'isFirst' | 'isLast'>
    )> }
  )> }
);

export type MarketingDataQualityReportQueryVariables = Exact<{
  filter: MarketingFilter;
}>;


export type MarketingDataQualityReportQuery = (
  { __typename?: 'Query' }
  & { marketingDataQuality: (
    { __typename?: 'MarketingDataQuality' }
    & Pick<MarketingDataQuality, 'metaPlatformLeads' | 'metaCrmLeads' | 'metaTouchesAll' | 'crmLeadsWithoutCourse' | 'crmLeadsTotal' | 'salesUnknownCourseRepeats'>
    & { salesCoverage: Array<(
      { __typename?: 'MarketingCoverageStep' }
      & Pick<MarketingCoverageStep, 'level' | 'count'>
    )>, crmLeadsBySource: Array<(
      { __typename?: 'MarketingCount' }
      & Pick<MarketingCount, 'value' | 'count'>
    )>, unmappedSources: Array<(
      { __typename?: 'MarketingUnmappedValue' }
      & Pick<MarketingUnmappedValue, 'field' | 'value' | 'count' | 'platform' | 'familyMissing' | 'campaignMissing'>
    )>, unmappedCampaigns: Array<(
      { __typename?: 'MarketingUnmappedValue' }
      & Pick<MarketingUnmappedValue, 'field' | 'value' | 'count' | 'platform' | 'familyMissing' | 'campaignMissing'>
    )>, accountReconciliation: Array<(
      { __typename?: 'MarketingReconRow' }
      & Pick<MarketingReconRow, 'platform' | 'day' | 'campaignSum' | 'accountTotal' | 'diffPct'>
    )>, sources: Array<(
      { __typename?: 'MarketingSourceStatus' }
      & MarketingSourceStatusFieldsFragment
    )>, siteTracking?: Maybe<(
      { __typename?: 'MarketingSiteTracking' }
      & Pick<MarketingSiteTracking, 'enabled' | 'collectingSince' | 'lastAcceptedAt' | 'days' | 'accepted' | 'events' | 'queue' | 'leads' | 'linkedLeads' | 'linkedLeadShare'>
      & { dropped: Array<(
        { __typename?: 'MarketingCount' }
        & Pick<MarketingCount, 'value' | 'count'>
      )> }
    )> }
  ) }
);

export type MarketingSourcesStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingSourcesStatusQuery = (
  { __typename?: 'Query' }
  & { marketingSources: Array<(
    { __typename?: 'MarketingSourceStatus' }
    & MarketingSourceStatusFieldsFragment
  )> }
);

export type MarketingOfflineConversionsReportQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type MarketingOfflineConversionsReportQuery = (
  { __typename?: 'Query' }
  & { marketingOfflineConversions?: Maybe<(
    { __typename?: 'MarketingOfflineConversionsType' }
    & Pick<MarketingOfflineConversionsType, 'enabled' | 'googleEnabled' | 'metaEnabled' | 'retractEnabled' | 'since'>
    & { lastRun?: Maybe<(
      { __typename?: 'MarketingOfflineRunType' }
      & Pick<MarketingOfflineRunType, 'status' | 'startedAt' | 'finishedAt' | 'errorMessage' | 'stats'>
    )>, counts7d: Array<(
      { __typename?: 'MarketingOfflineCountType' }
      & Pick<MarketingOfflineCountType, 'platform' | 'event' | 'status' | 'count'>
    )>, counts30d: Array<(
      { __typename?: 'MarketingOfflineCountType' }
      & Pick<MarketingOfflineCountType, 'platform' | 'event' | 'status' | 'count'>
    )>, issues: Array<(
      { __typename?: 'MarketingOfflineIssueType' }
      & Pick<MarketingOfflineIssueType, 'id' | 'platform' | 'event' | 'status' | 'errorCode' | 'eventTime' | 'updatedAt' | 'saleId' | 'source' | 'sourceId'>
    )> }
  )> }
);

export type MarketingTaxonomyReportQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingTaxonomyReportQuery = (
  { __typename?: 'Query' }
  & { marketingTaxonomy: (
    { __typename?: 'MarketingTaxonomy' }
    & Pick<MarketingTaxonomy, 'brandRegex' | 'ga4KeyEvents' | 'siteHosts' | 'pageTypes'>
    & { channelRules: Array<(
      { __typename?: 'MarketingChannelRuleType' }
      & MarketingChannelRuleFieldsFragment
    )>, families: Array<(
      { __typename?: 'MarketingCourseFamilyType' }
      & Pick<MarketingCourseFamilyType, 'id' | 'slug' | 'name' | 'isSold' | 'sort'>
      & { aliases: Array<(
        { __typename?: 'MarketingCourseAliasType' }
        & MarketingCourseAliasFieldsFragment
      )> }
    )>, offerRules: Array<(
      { __typename?: 'MarketingOfferRuleType' }
      & MarketingOfferRuleFieldsFragment
    )>, pipelines: Array<(
      { __typename?: 'MarketingPipelineType' }
      & MarketingPipelineFieldsFragment
    )>, legalEntities: Array<(
      { __typename?: 'MarketingOption' }
      & Pick<MarketingOption, 'id' | 'name'>
    )>, courses: Array<(
      { __typename?: 'MarketingOption' }
      & Pick<MarketingOption, 'id' | 'name'>
    )>, campaignAliases: Array<(
      { __typename?: 'MarketingCampaignAliasType' }
      & MarketingCampaignAliasFieldsFragment
    )>, signalRouting: (
      { __typename?: 'MarketingSignalRoutingType' }
      & Pick<MarketingSignalRoutingType, 'kinds' | 'minSeverity' | 'assigneeIds'>
    ), staffOptions: Array<(
      { __typename?: 'MarketingOption' }
      & Pick<MarketingOption, 'id' | 'name'>
    )>, pageTypeRules: Array<(
      { __typename?: 'MarketingPageTypeRule' }
      & Pick<MarketingPageTypeRule, 'type' | 'regex'>
    )> }
  ) }
);

export type MarketingCreativesReportQueryVariables = Exact<{
  filter: MarketingFilter;
  fatigueOnly?: Maybe<Scalars['Boolean']>;
  format?: Maybe<Scalars['String']>;
  withSeries?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  adIds?: Maybe<Array<Scalars['ID']>>;
  compare?: Maybe<MarketingCompare>;
  having?: Maybe<Array<MarketingRowPredicate>>;
  minSpendPln?: Maybe<Scalars['Decimal']>;
  minCrmLeads?: Maybe<Scalars['Int']>;
  groupBy?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type MarketingCreativesReportQuery = (
  { __typename?: 'Query' }
  & { marketingCreatives: (
    { __typename?: 'MarketingCreativesPage' }
    & Pick<MarketingCreativesPage, 'totalCount'>
    & { predicateCounts: Array<(
      { __typename?: 'MarketingCount' }
      & Pick<MarketingCount, 'value' | 'count'>
    )>, compareInfo?: Maybe<(
      { __typename?: 'MarketingCompareInfo' }
      & MarketingCompareInfoFieldsFragment
    )>, groups: Array<(
      { __typename?: 'MarketingCreativeGroup' }
      & Pick<MarketingCreativeGroup, 'key' | 'label' | 'ads'>
      & { metrics: (
        { __typename?: 'MarketingMetrics' }
        & MarketingMetricsFieldsFragment
      ) }
    )>, rows: Array<(
      { __typename?: 'MarketingCreativeRow' }
      & Pick<MarketingCreativeRow, 'id' | 'platform' | 'externalId' | 'name' | 'level' | 'crmScope' | 'campaignId' | 'campaignName' | 'adsetName' | 'format' | 'thumbnailUrl' | 'title' | 'status' | 'firstDay' | 'ageDays' | 'familySlug' | 'offer' | 'frequency' | 'reach28d' | 'hookRate' | 'holdRate' | 'cplPlatformPln' | 'conversionsPlatform'>
      & { metrics: (
        { __typename?: 'MarketingMetrics' }
        & MarketingMetricsFieldsFragment
      ), previous?: Maybe<(
        { __typename?: 'MarketingMetrics' }
        & MarketingMetricsFieldsFragment
      )>, fatigue: (
        { __typename?: 'MarketingFatigue' }
        & Pick<MarketingFatigue, 'flagged' | 'reasons' | 'ctr7d' | 'ctrBase' | 'ctrStart' | 'ctrPrev' | 'frequency28d' | 'cpm7d' | 'cpmPrev' | 'cpmChangePct' | 'cpl7d' | 'cplMedian' | 'cplRatio' | 'hookRate' | 'hookPrev' | 'holdRate' | 'holdPrev'>
      ), series?: Maybe<Array<(
        { __typename?: 'MarketingSeriesPoint' }
        & Pick<MarketingSeriesPoint, 'period'>
        & { metrics: (
          { __typename?: 'MarketingMetrics' }
          & MarketingMetricsFieldsFragment
        ) }
      )>> }
    )>, formats: Array<(
      { __typename?: 'MarketingFormatStat' }
      & Pick<MarketingFormatStat, 'format' | 'familySlug' | 'offer' | 'ads' | 'hookRate'>
      & { metrics: (
        { __typename?: 'MarketingMetrics' }
        & MarketingMetricsFieldsFragment
      ) }
    )> }
  ) }
);

export type MarketingAdChoicesQueryVariables = Exact<{
  filter: MarketingFilter;
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type MarketingAdChoicesQuery = (
  { __typename?: 'Query' }
  & { marketingCreatives: (
    { __typename?: 'MarketingCreativesPage' }
    & { rows: Array<(
      { __typename?: 'MarketingCreativeRow' }
      & Pick<MarketingCreativeRow, 'id' | 'name' | 'platform' | 'campaignName' | 'thumbnailUrl'>
    )> }
  ) }
);

export type MarketingCohortsReportQueryVariables = Exact<{
  filter: MarketingFilter;
  pathKind?: Maybe<Scalars['String']>;
  granularity?: Maybe<MarketingGranularity>;
  splitBy?: Maybe<Scalars['String']>;
}>;


export type MarketingCohortsReportQuery = (
  { __typename?: 'Query' }
  & { marketingCohorts: Array<(
    { __typename?: 'MarketingCohortRow' }
    & Pick<MarketingCohortRow, 'cohort' | 'dateFrom' | 'dateTo' | 'split' | 'splitLabel' | 'leads' | 'sales7' | 'sales14' | 'sales30' | 'sales60' | 'sales90' | 'revenue90Pln' | 'mature7' | 'mature14' | 'mature30' | 'mature60' | 'mature90'>
  )> }
);

export type MarketingLeadDynamicsReportQueryVariables = Exact<{
  filter: MarketingFilter;
  granularity?: Maybe<MarketingGranularity>;
  compare?: Maybe<MarketingCompare>;
  groupBy?: Maybe<Scalars['String']>;
  top?: Maybe<Scalars['Int']>;
}>;


export type MarketingLeadDynamicsReportQuery = (
  { __typename?: 'Query' }
  & { marketingLeadDynamics: (
    { __typename?: 'MarketingLeadDynamics' }
    & Pick<MarketingLeadDynamics, 'granularity' | 'groupBy'>
    & { groups: Array<(
      { __typename?: 'MarketingLeadGroup' }
      & Pick<MarketingLeadGroup, 'key' | 'label' | 'crmLeads' | 'crmLeadsRepeat' | 'sales' | 'revenuePln'>
    )>, points: Array<(
      { __typename?: 'MarketingLeadDynamicsPoint' }
      & Pick<MarketingLeadDynamicsPoint, 'period' | 'dateFrom' | 'dateTo' | 'crmLeads' | 'crmLeadsRepeat' | 'sales' | 'revenuePln' | 'previousPeriod' | 'previousDateFrom' | 'previousDateTo' | 'previousCrmLeads' | 'previousCrmLeadsRepeat' | 'previousSales' | 'previousRevenuePln'>
      & { groups: Array<(
        { __typename?: 'MarketingLeadGroupValue' }
        & Pick<MarketingLeadGroupValue, 'key' | 'crmLeads' | 'crmLeadsRepeat' | 'sales' | 'revenuePln'>
      )> }
    )>, totals: (
      { __typename?: 'MarketingLeadTotals' }
      & Pick<MarketingLeadTotals, 'crmLeads' | 'crmLeadsRepeat' | 'sales' | 'revenuePln'>
      & { previous?: Maybe<(
        { __typename?: 'MarketingLeadTotals' }
        & Pick<MarketingLeadTotals, 'crmLeads' | 'crmLeadsRepeat' | 'sales' | 'revenuePln'>
      )> }
    ), compareInfo?: Maybe<(
      { __typename?: 'MarketingCompareInfo' }
      & MarketingCompareInfoFieldsFragment
    )> }
  ) }
);

export type MarketingPathCohortsReportQueryVariables = Exact<{
  filter: MarketingFilter;
  groupBy?: Maybe<Scalars['String']>;
}>;


export type MarketingPathCohortsReportQuery = (
  { __typename?: 'Query' }
  & { marketingPathCohorts: Array<(
    { __typename?: 'MarketingPathCohortRow' }
    & Pick<MarketingPathCohortRow, 'key' | 'leads' | 'sales7' | 'sales14' | 'sales30' | 'sales60' | 'sales90' | 'revenue90Pln' | 'conversion90' | 'matureShare'>
  )> }
);

export type MarketingChannelOverlapReportQueryVariables = Exact<{
  filter: MarketingFilter;
}>;


export type MarketingChannelOverlapReportQuery = (
  { __typename?: 'Query' }
  & { marketingChannelOverlap: Array<(
    { __typename?: 'MarketingOverlapCell' }
    & Pick<MarketingOverlapCell, 'row' | 'col' | 'leads' | 'sales'>
  )> }
);

export type MarketingContractsReportQueryVariables = Exact<{
  filter: MarketingFilter;
  granularity?: Maybe<MarketingGranularity>;
  compare?: Maybe<MarketingCompare>;
}>;


export type MarketingContractsReportQuery = (
  { __typename?: 'Query' }
  & { marketingContracts: (
    { __typename?: 'MarketingContractsReport' }
    & { totals: (
      { __typename?: 'MarketingContractsTotals' }
      & Pick<MarketingContractsTotals, 'sent' | 'opened' | 'signed' | 'pending' | 'lost' | 'signRate' | 'medianHoursToSign' | 'medianDaysLeadToContract'>
      & { previous?: Maybe<(
        { __typename?: 'MarketingContractsTotals' }
        & Pick<MarketingContractsTotals, 'sent' | 'opened' | 'signed' | 'pending' | 'lost' | 'signRate' | 'medianHoursToSign' | 'medianDaysLeadToContract'>
      )> }
    ), series: Array<(
      { __typename?: 'MarketingContractsPoint' }
      & Pick<MarketingContractsPoint, 'period' | 'dateFrom' | 'dateTo' | 'sent' | 'signed' | 'pending' | 'lost' | 'previousPeriod'>
      & { previous?: Maybe<(
        { __typename?: 'MarketingContractsCounts' }
        & Pick<MarketingContractsCounts, 'sent' | 'signed' | 'pending' | 'lost'>
      )> }
    )>, timeToSign: Array<(
      { __typename?: 'MarketingContractsBucket' }
      & Pick<MarketingContractsBucket, 'key' | 'count'>
    )>, pendingAge: Array<(
      { __typename?: 'MarketingContractsBucket' }
      & Pick<MarketingContractsBucket, 'key' | 'count'>
    )>, byKind: Array<(
      { __typename?: 'MarketingContractsKindRow' }
      & Pick<MarketingContractsKindRow, 'kind' | 'sent' | 'signed' | 'pending' | 'lost'>
    )>, coverage: Array<(
      { __typename?: 'MarketingCoverageStep' }
      & Pick<MarketingCoverageStep, 'level' | 'count'>
    )>, unknownLegalEntity?: Maybe<(
      { __typename?: 'MarketingContractsCounts' }
      & Pick<MarketingContractsCounts, 'sent' | 'signed' | 'pending' | 'lost'>
    )>, compareInfo?: Maybe<(
      { __typename?: 'MarketingCompareInfo' }
      & MarketingCompareInfoFieldsFragment
    )> }
  ) }
);

export type MarketingActionsListQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type MarketingActionsListQuery = (
  { __typename?: 'Query' }
  & { marketingActions: Array<(
    { __typename?: 'MarketingActionItem' }
    & Pick<MarketingActionItem, 'id' | 'source' | 'kind' | 'severity' | 'titleKey' | 'params' | 'metrics' | 'valuePlnEst' | 'valueKind' | 'valueWindowDays' | 'familyValuePlnEst' | 'familyKeywords' | 'familySlug' | 'entityId' | 'entityName' | 'channel' | 'inspector' | 'link' | 'signalId' | 'windowFrom' | 'windowTo' | 'lastSeen'>
  )> }
);

export type MarketingJourneyReportQueryVariables = Exact<{
  filter: MarketingFilter;
}>;


export type MarketingJourneyReportQuery = (
  { __typename?: 'Query' }
  & { marketingJourney: (
    { __typename?: 'MarketingJourney' }
    & Pick<MarketingJourney, 'historyFrom'>
    & { indirect: Array<(
      { __typename?: 'MarketingJourneyStep' }
      & Pick<MarketingJourneyStep, 'pipelineKind' | 'people' | 'reachedMain' | 'buyers'>
    )>, withinMain: Array<(
      { __typename?: 'MarketingJourneyBucket' }
      & Pick<MarketingJourneyBucket, 'key' | 'people' | 'buyers'>
    )>, lagSales: Array<(
      { __typename?: 'MarketingJourneyLagBucket' }
      & Pick<MarketingJourneyLagBucket, 'key' | 'sales'>
    )>, speedToLead: Array<(
      { __typename?: 'MarketingJourneyBucket' }
      & Pick<MarketingJourneyBucket, 'key' | 'people' | 'buyers'>
    )>, byDevice: Array<(
      { __typename?: 'MarketingDeviceRow' }
      & Pick<MarketingDeviceRow, 'device' | 'crmLeads' | 'crmLeadsRepeat' | 'sales' | 'revenuePln' | 'conversion'>
    )> }
  ) }
);

export type MarketingTargetsListQueryVariables = Exact<{
  month: Scalars['Date'];
}>;


export type MarketingTargetsListQuery = (
  { __typename?: 'Query' }
  & { marketingTargets: Array<(
    { __typename?: 'MarketingTargetType' }
    & MarketingTargetFieldsFragment
  )> }
);

export type MarketingSignalsFeedQueryVariables = Exact<{
  status?: Maybe<Array<Scalars['String']>>;
  kinds?: Maybe<Array<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type MarketingSignalsFeedQuery = (
  { __typename?: 'Query' }
  & { marketingSignals: Array<(
    { __typename?: 'MarketingSignalType' }
    & MarketingSignalFieldsFragment
  )> }
);

export type MarketingCampaignChoicesQueryVariables = Exact<{
  platform: Scalars['String'];
  search?: Maybe<Scalars['String']>;
}>;


export type MarketingCampaignChoicesQuery = (
  { __typename?: 'Query' }
  & { marketingCampaignOptions: Array<(
    { __typename?: 'MarketingOption' }
    & Pick<MarketingOption, 'id' | 'name'>
  )> }
);

export type MarketingSearchEngineReportQueryVariables = Exact<{
  filter: MarketingFilter;
  engine?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['Boolean']>;
  zone?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type MarketingSearchEngineReportQuery = (
  { __typename?: 'Query' }
  & { marketingSearch: (
    { __typename?: 'MarketingSearchReport' }
    & Pick<MarketingSearchReport, 'engine' | 'namedClicksShare' | 'totalCount' | 'provisionalFrom' | 'snapshotDate' | 'includesSubdomains' | 'otherHosts'>
    & { total: (
      { __typename?: 'MarketingSearchPoint' }
      & Pick<MarketingSearchPoint, 'day' | 'clicks' | 'impressions' | 'position'>
    ), series: Array<(
      { __typename?: 'MarketingSearchPoint' }
      & Pick<MarketingSearchPoint, 'day' | 'clicks' | 'impressions' | 'position'>
    )>, zones: Array<(
      { __typename?: 'MarketingSearchZone' }
      & Pick<MarketingSearchZone, 'zone' | 'queries' | 'impressions' | 'clicks'>
    )>, rows: Array<(
      { __typename?: 'MarketingSearchRow' }
      & MarketingSearchRowFieldsFragment
    )> }
  ) }
);

export type MarketingSearchTotalsProbeQueryVariables = Exact<{
  filter: MarketingFilter;
  engine?: Maybe<Scalars['String']>;
}>;


export type MarketingSearchTotalsProbeQuery = (
  { __typename?: 'Query' }
  & { marketingSearch: (
    { __typename?: 'MarketingSearchReport' }
    & Pick<MarketingSearchReport, 'engine'>
    & { total: (
      { __typename?: 'MarketingSearchPoint' }
      & Pick<MarketingSearchPoint, 'day' | 'clicks' | 'impressions' | 'position'>
    ), series: Array<(
      { __typename?: 'MarketingSearchPoint' }
      & Pick<MarketingSearchPoint, 'day'>
    )> }
  ) }
);

export type MarketingSiteTrafficReportQueryVariables = Exact<{
  filter: MarketingFilter;
  groupBy?: Maybe<Scalars['String']>;
}>;


export type MarketingSiteTrafficReportQuery = (
  { __typename?: 'Query' }
  & { marketingTraffic: Array<(
    { __typename?: 'MarketingTrafficRow' }
    & Pick<MarketingTrafficRow, 'channelGroup' | 'source' | 'medium' | 'campaign' | 'sessions' | 'users' | 'engaged' | 'keyEvents'>
  )> }
);

export type MarketingAiAssistantsReportQueryVariables = Exact<{
  filter: MarketingFilter;
}>;


export type MarketingAiAssistantsReportQuery = (
  { __typename?: 'Query' }
  & { marketingAiReferrals: Array<(
    { __typename?: 'MarketingAiReferralRow' }
    & Pick<MarketingAiReferralRow, 'assistant' | 'landingPage' | 'sessions' | 'engaged'>
  )> }
);

export type MarketingSearchDemandReportQueryVariables = Exact<{
  filter: MarketingFilter;
}>;


export type MarketingSearchDemandReportQuery = (
  { __typename?: 'Query' }
  & { marketingDemand: Array<(
    { __typename?: 'MarketingDemandRow' }
    & Pick<MarketingDemandRow, 'familySlug' | 'familyName' | 'isSold' | 'impressions' | 'prevImpressions' | 'clicks' | 'crmLeads' | 'sales' | 'searchVolume' | 'volumeTrend' | 'volumeMonths'>
    & { topQueries: Array<(
      { __typename?: 'MarketingSearchRow' }
      & MarketingSearchRowFieldsFragment
    )> }
  )> }
);

export type MarketingAdsSearchTermsReportQueryVariables = Exact<{
  filter: MarketingFilter;
  familySlug?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type MarketingAdsSearchTermsReportQuery = (
  { __typename?: 'Query' }
  & { marketingSearchTerms: (
    { __typename?: 'MarketingSearchTermsPage' }
    & Pick<MarketingSearchTermsPage, 'totalCount' | 'coverageShare'>
    & { rows: Array<(
      { __typename?: 'MarketingSearchTermRow' }
      & Pick<MarketingSearchTermRow, 'term' | 'campaign' | 'adGroup' | 'impressions' | 'clicks' | 'spendPln' | 'conversions' | 'familySlug'>
    )> }
  ) }
);

export type MarketingSalesForecastReportQueryVariables = Exact<{
  month?: Maybe<Scalars['Date']>;
  familySlug?: Maybe<Scalars['String']>;
}>;


export type MarketingSalesForecastReportQuery = (
  { __typename?: 'Query' }
  & { marketingForecast: Array<(
    { __typename?: 'MarketingForecastRow' }
    & Pick<MarketingForecastRow, 'familySlug' | 'familyName' | 'month' | 'salesMtd' | 'p10' | 'p50' | 'p90' | 'target' | 'smallBase' | 'expectedNewLeads' | 'leadToSale' | 'daysLeft' | 'pace28d' | 'expectedFromOpenLeads' | 'expectedFromNewLeads'>
    & { openLeads: Array<(
      { __typename?: 'MarketingForecastStage' }
      & Pick<MarketingForecastStage, 'stage' | 'leads' | 'probability' | 'basis' | 'observations'>
    )>, groups: Array<(
      { __typename?: 'MarketingGroupFill' }
      & Pick<MarketingGroupFill, 'groupId' | 'name' | 'startDate' | 'seats' | 'enrolled' | 'expectedBeforeStart' | 'fillP50' | 'risk'>
    )> }
  )> }
);

export type MarketingWeeklySnapshotsListQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  isoWeek?: Maybe<Scalars['String']>;
}>;


export type MarketingWeeklySnapshotsListQuery = (
  { __typename?: 'Query' }
  & { marketingSnapshots: Array<(
    { __typename?: 'MarketingSnapshotType' }
    & Pick<MarketingSnapshotType, 'id' | 'isoWeek' | 'dateFrom' | 'dateTo' | 'frozenAt' | 'dataVersion' | 'rebuiltCount' | 'summary'>
  )> }
);

export type MarketingDigestHistoryListQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type MarketingDigestHistoryListQuery = (
  { __typename?: 'Query' }
  & { marketingDigests: Array<(
    { __typename?: 'MarketingDigestType' }
    & Pick<MarketingDigestType, 'id' | 'isoWeek' | 'status' | 'model' | 'factsChecked' | 'rejectedNumbers' | 'attempts' | 'createdAt' | 'createdBy' | 'startedAt' | 'finishedAt' | 'error'>
  )> }
);

export type MarketingDigestWeekTextQueryVariables = Exact<{
  isoWeek: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
}>;


export type MarketingDigestWeekTextQuery = (
  { __typename?: 'Query' }
  & { marketingDigests: Array<(
    { __typename?: 'MarketingDigestType' }
    & Pick<MarketingDigestType, 'id' | 'isoWeek' | 'status' | 'text' | 'model' | 'factsChecked' | 'rejectedNumbers' | 'attempts' | 'createdAt' | 'createdBy' | 'startedAt' | 'finishedAt' | 'error' | 'inputTokens' | 'outputTokens'>
  )> }
);

export type MarketingSendgridEmailReportQueryVariables = Exact<{
  filter: MarketingFilter;
}>;


export type MarketingSendgridEmailReportQuery = (
  { __typename?: 'Query' }
  & { marketingEmail: (
    { __typename?: 'MarketingEmailReport' }
    & Pick<MarketingEmailReport, 'delivered' | 'uniqueOpens' | 'uniqueClicks' | 'emailLeads' | 'emailSales'>
    & { sends: Array<(
      { __typename?: 'MarketingEmailSend' }
      & Pick<MarketingEmailSend, 'id' | 'name' | 'sentAt' | 'delivered' | 'uniqueOpens' | 'uniqueClicks' | 'unsubscribes' | 'bounces' | 'emailLeads' | 'emailSales' | 'categories'>
    )>, series: Array<(
      { __typename?: 'MarketingSearchPoint' }
      & Pick<MarketingSearchPoint, 'day' | 'clicks' | 'impressions' | 'position'>
    )>, account: (
      { __typename?: 'MarketingEmailTotals' }
      & Pick<MarketingEmailTotals, 'delivered' | 'uniqueOpens' | 'uniqueClicks' | 'requests'>
    ), categories: Array<(
      { __typename?: 'MarketingEmailCategory' }
      & Pick<MarketingEmailCategory, 'name' | 'delivered' | 'uniqueOpens' | 'uniqueClicks'>
    )> }
  ) }
);

export type MarketingVisitorJourneyReportQueryVariables = Exact<{
  filter: MarketingFilter;
  compare?: Maybe<MarketingCompare>;
  granularity?: Maybe<MarketingGranularity>;
}>;


export type MarketingVisitorJourneyReportQuery = (
  { __typename?: 'Query' }
  & { marketingVisitorJourney: (
    { __typename?: 'MarketingVisitorJourney' }
    & Pick<MarketingVisitorJourney, 'collectingSince'>
    & { kpis: (
      { __typename?: 'MarketingVisitorKpis' }
      & Pick<MarketingVisitorKpis, 'leads' | 'linkedLeads' | 'linkedShare' | 'visitors' | 'sessions' | 'medianVisits' | 'medianDays' | 'medianPages' | 'firstVisitShare'>
    ), previous?: Maybe<(
      { __typename?: 'MarketingVisitorKpis' }
      & Pick<MarketingVisitorKpis, 'leads' | 'linkedLeads' | 'linkedShare' | 'visitors' | 'sessions' | 'medianVisits' | 'medianDays' | 'medianPages' | 'firstVisitShare'>
    )>, visitsBeforeLead: Array<(
      { __typename?: 'MarketingVisitorBucket' }
      & Pick<MarketingVisitorBucket, 'key' | 'count' | 'share' | 'previous'>
    )>, daysToLead: Array<(
      { __typename?: 'MarketingVisitorBucket' }
      & Pick<MarketingVisitorBucket, 'key' | 'count' | 'share' | 'previous'>
    )>, pagesBeforeLead: Array<(
      { __typename?: 'MarketingVisitorBucket' }
      & Pick<MarketingVisitorBucket, 'key' | 'count' | 'share' | 'previous'>
    )>, channelMatrix: Array<(
      { __typename?: 'MarketingVisitorMatrixCell' }
      & Pick<MarketingVisitorMatrixCell, 'firstChannel' | 'leadChannel' | 'leads'>
    )>, typicalPaths: Array<(
      { __typename?: 'MarketingTypicalPath' }
      & Pick<MarketingTypicalPath, 'types' | 'count' | 'share' | 'medianDays'>
    )>, compareInfo?: Maybe<(
      { __typename?: 'MarketingCompareInfo' }
      & MarketingCompareInfoFieldsFragment
    )> }
  ) }
);

export type MarketingVisitorSamplesListQueryVariables = Exact<{
  filter: MarketingFilter;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  onlyLinked?: Maybe<Scalars['Boolean']>;
}>;


export type MarketingVisitorSamplesListQuery = (
  { __typename?: 'Query' }
  & { marketingVisitors: (
    { __typename?: 'MarketingVisitorsPage' }
    & Pick<MarketingVisitorsPage, 'totalCount' | 'roundedToDay'>
    & { rows: Array<(
      { __typename?: 'MarketingVisitorSample' }
      & Pick<MarketingVisitorSample, 'id' | 'firstSeenAt' | 'firstChannel' | 'sessions' | 'pageviews' | 'pages' | 'leadAt' | 'leadChannel' | 'daysToLead' | 'familySlug' | 'outcome'>
    )> }
  ) }
);

export type MarketingVisitorTimelineCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketingVisitorTimelineCardQuery = (
  { __typename?: 'Query' }
  & { marketingVisitor?: Maybe<(
    { __typename?: 'MarketingVisitorTimeline' }
    & Pick<MarketingVisitorTimeline, 'id' | 'roundedToDay' | 'firstSeenAt' | 'lastSeenAt' | 'sessions' | 'pageviews' | 'devices' | 'device'>
    & { events: Array<(
      { __typename?: 'MarketingVisitorEvent' }
      & Pick<MarketingVisitorEvent, 'kind' | 'at' | 'channel' | 'subChannel' | 'landingPath' | 'pages' | 'pageviews' | 'durationS' | 'formSubmits' | 'device' | 'familySlug' | 'isRepeat' | 'pageType' | 'outcome'>
    )> }
  )> }
);

export type MarketingSitePagesReportQueryVariables = Exact<{
  filter: MarketingFilter;
  compare?: Maybe<MarketingCompare>;
  granularity?: Maybe<MarketingGranularity>;
  pageTypes?: Maybe<Array<Scalars['String']>>;
  familySlug?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type MarketingSitePagesReportQuery = (
  { __typename?: 'Query' }
  & { marketingPages: (
    { __typename?: 'MarketingPagesPage' }
    & Pick<MarketingPagesPage, 'totalCount' | 'denominator' | 'collectingSince'>
    & { typeCounts: Array<(
      { __typename?: 'MarketingCount' }
      & Pick<MarketingCount, 'value' | 'count'>
    )>, totals: (
      { __typename?: 'MarketingPageMetrics' }
      & MarketingPageMetricsFieldsFragment
    ), previousTotals?: Maybe<(
      { __typename?: 'MarketingPageMetrics' }
      & MarketingPageMetricsFieldsFragment
    )>, rows: Array<(
      { __typename?: 'MarketingPageRow' }
      & Pick<MarketingPageRow, 'path' | 'pageType' | 'familySlug' | 'firstSeen'>
      & { metrics: (
        { __typename?: 'MarketingPageMetrics' }
        & MarketingPageMetricsFieldsFragment
      ), previous?: Maybe<(
        { __typename?: 'MarketingPageMetrics' }
        & MarketingPageMetricsFieldsFragment
      )> }
    )>, compareInfo?: Maybe<(
      { __typename?: 'MarketingCompareInfo' }
      & MarketingCompareInfoFieldsFragment
    )> }
  ) }
);

export type MarketingSitePageCardQueryVariables = Exact<{
  path: Scalars['String'];
  filter: MarketingFilter;
  compare?: Maybe<MarketingCompare>;
  granularity?: Maybe<MarketingGranularity>;
}>;


export type MarketingSitePageCardQuery = (
  { __typename?: 'Query' }
  & { marketingPage: (
    { __typename?: 'MarketingPageCard' }
    & Pick<MarketingPageCard, 'path' | 'pageType' | 'familySlug' | 'firstSeen' | 'known' | 'denominator' | 'collectingSince'>
    & { metrics: (
      { __typename?: 'MarketingPageMetrics' }
      & MarketingPageMetricsFieldsFragment
    ), previous?: Maybe<(
      { __typename?: 'MarketingPageMetrics' }
      & MarketingPageMetricsFieldsFragment
    )>, series: Array<(
      { __typename?: 'MarketingPagePoint' }
      & Pick<MarketingPagePoint, 'period' | 'dateFrom' | 'dateTo' | 'previousPeriod' | 'previousDateFrom' | 'previousDateTo'>
      & { metrics: (
        { __typename?: 'MarketingPageMetrics' }
        & MarketingPageMetricsFieldsFragment
      ), previous?: Maybe<(
        { __typename?: 'MarketingPageMetrics' }
        & MarketingPageMetricsFieldsFragment
      )> }
    )>, entrySources: Array<(
      { __typename?: 'MarketingPageSource' }
      & Pick<MarketingPageSource, 'source' | 'key' | 'sessions' | 'crmLeads' | 'keyEvents'>
    )>, nextPages: Array<(
      { __typename?: 'MarketingPageLink' }
      & Pick<MarketingPageLink, 'path' | 'pageType' | 'count' | 'share'>
    )>, gscQueries: Array<(
      { __typename?: 'MarketingPageQuery' }
      & Pick<MarketingPageQuery, 'query' | 'clicks' | 'impressions' | 'position'>
    )>, compareInfo?: Maybe<(
      { __typename?: 'MarketingCompareInfo' }
      & MarketingCompareInfoFieldsFragment
    )> }
  ) }
);

export type MarketingSeoWeeksListQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type MarketingSeoWeeksListQuery = (
  { __typename?: 'Query' }
  & { marketingSeoWeeks: Array<(
    { __typename?: 'MarketingSeoWeek' }
    & Pick<MarketingSeoWeek, 'week' | 'isoWeek' | 'checkedAt' | 'keywords' | 'aiAnswers' | 'state' | 'partial'>
  )> }
);

export type MarketingSeoOverviewReportQueryVariables = Exact<{
  week?: Maybe<Scalars['String']>;
  compareWeek?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['Boolean']>;
}>;


export type MarketingSeoOverviewReportQuery = (
  { __typename?: 'Query' }
  & { marketingSeoOverview: (
    { __typename?: 'MarketingSeoOverview' }
    & Pick<MarketingSeoOverview, 'week' | 'compareWeek' | 'isoWeek' | 'compareIsoWeek' | 'ownDomain' | 'locationCode' | 'languageCode' | 'device' | 'checkedAt' | 'nextRunAt' | 'stale' | 'keywords' | 'comparableKeywords' | 'sov' | 'sovPrev' | 'top3' | 'top3Prev' | 'top10' | 'top10Prev' | 'top20' | 'top20Prev' | 'avgPosition' | 'avgPositionPrev' | 'estClicks' | 'estClicksPrev' | 'gscClicks' | 'gscClicksPrev' | 'gscImpressions' | 'gscImpressionsPrev' | 'gscFrom' | 'gscTo' | 'aiAnswers' | 'aiMentionShare' | 'aiMentionSharePrev' | 'aiCitationShare' | 'aiSmallSample' | 'referringDomains' | 'referringDomainsPrev' | 'ctrNote'>
    & { domains: Array<(
      { __typename?: 'MarketingSeoDomainVisibility' }
      & Pick<MarketingSeoDomainVisibility, 'domain' | 'label' | 'isOwn' | 'sov' | 'sovPrev' | 'top3' | 'top10' | 'top10Prev' | 'avgPosition' | 'estClicks'>
    )>, movers: Array<(
      { __typename?: 'MarketingSeoMover' }
      & Pick<MarketingSeoMover, 'keywordId' | 'keyword' | 'familySlug' | 'position' | 'prevPosition' | 'delta' | 'change' | 'volume'>
    )>, moveCounts: (
      { __typename?: 'MarketingSeoMoveCounts' }
      & Pick<MarketingSeoMoveCounts, 'new' | 'lost' | 'up' | 'down'>
    ), ideas: Array<(
      { __typename?: 'MarketingSeoOpportunity' }
      & MarketingSeoOpportunityFieldsFragment
    )> }
  ) }
);

export type MarketingSeoKeywordsListQueryVariables = Exact<{
  week?: Maybe<Scalars['String']>;
  compareWeek?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['Boolean']>;
  tracked?: Maybe<Scalars['Boolean']>;
  change?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type MarketingSeoKeywordsListQuery = (
  { __typename?: 'Query' }
  & { marketingSeoKeywords: (
    { __typename?: 'MarketingSeoKeywordsPage' }
    & Pick<MarketingSeoKeywordsPage, 'week' | 'compareWeek' | 'totalCount'>
    & { rows: Array<(
      { __typename?: 'MarketingSeoKeywordRow' }
      & MarketingSeoKeywordRowFieldsFragment
    )>, zoneCounts: Array<(
      { __typename?: 'MarketingCount' }
      & Pick<MarketingCount, 'value' | 'count'>
    )>, changeCounts: Array<(
      { __typename?: 'MarketingCount' }
      & Pick<MarketingCount, 'value' | 'count'>
    )>, zonesByWeek: Array<(
      { __typename?: 'MarketingSeoZoneWeek' }
      & Pick<MarketingSeoZoneWeek, 'week' | 'isoWeek' | 'top3' | 'pos4to10' | 'pos11to20' | 'beyond20'>
    )> }
  ) }
);

export type MarketingSeoKeywordCardQueryVariables = Exact<{
  id: Scalars['ID'];
  weeks?: Maybe<Scalars['Int']>;
}>;


export type MarketingSeoKeywordCardQuery = (
  { __typename?: 'Query' }
  & { marketingSeoKeyword: (
    { __typename?: 'MarketingSeoKeywordCard' }
    & Pick<MarketingSeoKeywordCard, 'serpWeek' | 'features' | 'hasAiOverview' | 'aiOverviewRefs' | 'leaderDomain'>
    & { keyword: (
      { __typename?: 'MarketingSeoKeywordRow' }
      & MarketingSeoKeywordRowFieldsFragment
    ), serp: Array<(
      { __typename?: 'MarketingSeoSerpItem' }
      & Pick<MarketingSeoSerpItem, 'rank' | 'domain' | 'url' | 'title' | 'isOwn' | 'isTracked'>
    )>, positions: Array<(
      { __typename?: 'MarketingSeoPositionPoint' }
      & Pick<MarketingSeoPositionPoint, 'week' | 'isoWeek' | 'own' | 'leader'>
    )>, gsc: Array<(
      { __typename?: 'MarketingSeoGscPoint' }
      & Pick<MarketingSeoGscPoint, 'week' | 'isoWeek' | 'clicks' | 'impressions' | 'position'>
    )>, labs: Array<(
      { __typename?: 'MarketingSeoLabsRank' }
      & Pick<MarketingSeoLabsRank, 'domain' | 'position' | 'url' | 'etv' | 'month'>
    )>, monthlySearches: Array<(
      { __typename?: 'MarketingSeoMonthVolume' }
      & Pick<MarketingSeoMonthVolume, 'year' | 'month' | 'searchVolume'>
    )>, opportunities: Array<(
      { __typename?: 'MarketingSeoOpportunity' }
      & MarketingSeoOpportunityFieldsFragment
    )> }
  ) }
);

export type MarketingSeoSeriesReportQueryVariables = Exact<{
  familySlug?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['Boolean']>;
  weeks?: Maybe<Scalars['Int']>;
}>;


export type MarketingSeoSeriesReportQuery = (
  { __typename?: 'Query' }
  & { marketingSeoSeries: Array<(
    { __typename?: 'MarketingSeoPoint' }
    & Pick<MarketingSeoPoint, 'week' | 'isoWeek' | 'ownSov' | 'top3' | 'pos4to10' | 'pos11to20' | 'beyond20'>
    & { domains: Array<(
      { __typename?: 'MarketingSeoDomainPoint' }
      & Pick<MarketingSeoDomainPoint, 'domain' | 'label' | 'isOwn' | 'sov' | 'top3' | 'top10' | 'avgPosition' | 'estClicks'>
    )> }
  )> }
);

export type MarketingSeoCompetitorsReportQueryVariables = Exact<{
  week?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
}>;


export type MarketingSeoCompetitorsReportQuery = (
  { __typename?: 'Query' }
  & { marketingSeoCompetitors: (
    { __typename?: 'MarketingSeoCompetitors' }
    & Pick<MarketingSeoCompetitors, 'week' | 'month' | 'aioKeywords' | 'aiAnswers'>
    & { domains: Array<(
      { __typename?: 'MarketingSeoCompetitor' }
      & Pick<MarketingSeoCompetitor, 'domain' | 'label' | 'isOwn' | 'sov' | 'top3' | 'top10' | 'top20' | 'avgPosition' | 'estClicks' | 'labsEtv' | 'labsKeywords' | 'labsTop3' | 'labsTop10' | 'referringDomains' | 'backlinks' | 'backlinksRank' | 'aiMentionShare' | 'aiCitationShare' | 'aioCitationShare'>
      & { labsZones: Array<(
        { __typename?: 'MarketingCount' }
        & Pick<MarketingCount, 'value' | 'count'>
      )> }
    )>, matrix: Array<(
      { __typename?: 'MarketingSeoFamilyCell' }
      & Pick<MarketingSeoFamilyCell, 'familySlug' | 'familyName' | 'isSold' | 'domain' | 'isOwn' | 'keywords' | 'top10' | 'top10Share' | 'sov'>
    )> }
  ) }
);

export type MarketingSeoIdeasListQueryVariables = Exact<{
  month?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  unmapped?: Maybe<Scalars['Boolean']>;
  minVolume?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  includeNavigational?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type MarketingSeoIdeasListQuery = (
  { __typename?: 'Query' }
  & { marketingSeoGaps: (
    { __typename?: 'MarketingSeoGapsPage' }
    & Pick<MarketingSeoGapsPage, 'month' | 'totalCount'>
    & { rows: Array<(
      { __typename?: 'MarketingSeoGapRow' }
      & Pick<MarketingSeoGapRow, 'keywordId' | 'keyword' | 'familySlug' | 'familyName' | 'isSold' | 'searchVolume' | 'intent' | 'difficulty' | 'ownPosition' | 'ownUrl' | 'kind' | 'isQuestion' | 'opportunityId' | 'status' | 'valuePlnEst'>
      & { competitors: Array<(
        { __typename?: 'MarketingSeoDomainRank' }
        & Pick<MarketingSeoDomainRank, 'domain' | 'position' | 'url'>
      )> }
    )>, topics: Array<(
      { __typename?: 'MarketingSeoTopic' }
      & Pick<MarketingSeoTopic, 'key' | 'label' | 'familySlug' | 'hasCourse' | 'keywords' | 'searchVolume' | 'topKeywords' | 'opportunityId' | 'status' | 'intent' | 'suggestedAction' | 'score' | 'courseSearchVolume'>
      & { competitors: Array<(
        { __typename?: 'MarketingSeoDomainCount' }
        & Pick<MarketingSeoDomainCount, 'domain' | 'keywords'>
      )> }
    )>, clusters: Array<(
      { __typename?: 'MarketingSeoCluster' }
      & Pick<MarketingSeoCluster, 'key' | 'label' | 'familySlug' | 'isSold' | 'keywords' | 'searchVolume' | 'kind' | 'action' | 'intent' | 'suggestedAction' | 'score' | 'courseSearchVolume' | 'ownUrl' | 'topKeywords' | 'opportunityIds' | 'planned' | 'valuePlnEst'>
      & { kindCounts: Array<(
        { __typename?: 'MarketingCount' }
        & Pick<MarketingCount, 'value' | 'count'>
      )>, competitors: Array<(
        { __typename?: 'MarketingSeoDomainCount' }
        & Pick<MarketingSeoDomainCount, 'domain' | 'keywords'>
      )> }
    )>, kindCounts: Array<(
      { __typename?: 'MarketingCount' }
      & Pick<MarketingCount, 'value' | 'count'>
    )>, hiddenCounts: Array<(
      { __typename?: 'MarketingCount' }
      & Pick<MarketingCount, 'value' | 'count'>
    )> }
  ) }
);

export type MarketingAiVisibilityReportQueryVariables = Exact<{
  week?: Maybe<Scalars['String']>;
  familySlug?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
}>;


export type MarketingAiVisibilityReportQuery = (
  { __typename?: 'Query' }
  & { marketingSeoAi: (
    { __typename?: 'MarketingSeoAiReport' }
    & Pick<MarketingSeoAiReport, 'week' | 'compareWeek' | 'isoWeek' | 'system' | 'group' | 'answers' | 'answersPrev' | 'smallSample' | 'mentionShare' | 'citationShare' | 'mentionSharePrev' | 'citationSharePrev' | 'aioKeywords' | 'aioWithOverview' | 'aioShare' | 'aioOwnCited' | 'aioOwnCitedShare'>
    & { domains: Array<(
      { __typename?: 'MarketingSeoAiDomain' }
      & Pick<MarketingSeoAiDomain, 'domain' | 'label' | 'isOwn' | 'mentioned' | 'cited' | 'mentionShare' | 'citationShare' | 'n'>
    )>, series: Array<(
      { __typename?: 'MarketingSeoAiPoint' }
      & Pick<MarketingSeoAiPoint, 'week' | 'isoWeek' | 'system' | 'n' | 'mentionShare' | 'citationShare'>
    )>, questions: Array<(
      { __typename?: 'MarketingSeoAiQuestionRow' }
      & Pick<MarketingSeoAiQuestionRow, 'id' | 'text' | 'group' | 'familySlug' | 'answers' | 'competitors' | 'citedUrls'>
      & { perSystem: Array<(
        { __typename?: 'MarketingSeoAiSystemCell' }
        & Pick<MarketingSeoAiSystemCell, 'system' | 'answers' | 'mentioned' | 'cited'>
      )> }
    )>, aioDomains: Array<(
      { __typename?: 'MarketingSeoAioDomain' }
      & Pick<MarketingSeoAioDomain, 'domain' | 'keywords' | 'share'>
    )> }
  ) }
);

export type MarketingAiAnswerCardQueryVariables = Exact<{
  questionId: Scalars['ID'];
  week?: Maybe<Scalars['String']>;
}>;


export type MarketingAiAnswerCardQuery = (
  { __typename?: 'Query' }
  & { marketingSeoAiAnswers: Array<(
    { __typename?: 'MarketingSeoAiAnswer' }
    & Pick<MarketingSeoAiAnswer, 'id' | 'system' | 'week' | 'repeatNo' | 'model' | 'answerText' | 'sources' | 'fanOut' | 'ownMentioned' | 'ownCited' | 'checkedAt'>
    & { mentions: Array<(
      { __typename?: 'MarketingSeoAiMention' }
      & Pick<MarketingSeoAiMention, 'domain' | 'mentioned' | 'cited' | 'firstPos'>
    )> }
  )> }
);

export type MarketingSeoLinksReportQueryVariables = Exact<{
  month?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type MarketingSeoLinksReportQuery = (
  { __typename?: 'Query' }
  & { marketingSeoBacklinks: (
    { __typename?: 'MarketingSeoBacklinks' }
    & Pick<MarketingSeoBacklinks, 'month' | 'prevMonth' | 'ownNew' | 'ownLost' | 'gapTotal'>
    & { domains: Array<(
      { __typename?: 'MarketingSeoBacklinkDomain' }
      & Pick<MarketingSeoBacklinkDomain, 'domain' | 'label' | 'isOwn' | 'referringDomains' | 'referringDomainsPrev' | 'referringMainDomains' | 'backlinks' | 'rank'>
    )>, gaps: Array<(
      { __typename?: 'MarketingSeoLinkGapRow' }
      & Pick<MarketingSeoLinkGapRow, 'refDomain' | 'rank' | 'backlinks' | 'linksTo' | 'opportunityId' | 'status'>
    )> }
  ) }
);

export type MarketingSeoFunnelReportQueryVariables = Exact<{
  filter: MarketingFilter;
}>;


export type MarketingSeoFunnelReportQuery = (
  { __typename?: 'Query' }
  & { marketingSeoFunnel: Array<(
    { __typename?: 'MarketingSeoFunnelRow' }
    & Pick<MarketingSeoFunnelRow, 'familySlug' | 'familyName' | 'isSold' | 'sov' | 'labsEtv' | 'searchVolume' | 'gscClicks' | 'gscImpressions' | 'organicEntrances' | 'crmLeads' | 'sales' | 'revenuePln'>
  )> }
);

export type MarketingSeoBudgetCardQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingSeoBudgetCardQuery = (
  { __typename?: 'Query' }
  & { marketingSeoBudget: (
    { __typename?: 'MarketingSeoBudget' }
    & Pick<MarketingSeoBudget, 'month' | 'capUsd' | 'envCapUsd' | 'spentUsd' | 'reservedUsd' | 'uncertainUsd' | 'remainingUsd' | 'maxRunUsd' | 'balanceUsd' | 'balanceAt' | 'pricesSource' | 'pricesVerifiedOn' | 'enabled' | 'aiEnabled' | 'offReason' | 'aiOffReason' | 'mode'>
    & { estimates: Array<(
      { __typename?: 'MarketingSeoEstimate' }
      & Pick<MarketingSeoEstimate, 'kind' | 'estimateUsd' | 'keywords' | 'questions' | 'ai' | 'upperBound' | 'refusal'>
      & { items: Array<(
        { __typename?: 'MarketingSeoEstimateItem' }
        & Pick<MarketingSeoEstimateItem, 'endpoint' | 'requests' | 'results' | 'costUsd'>
      )> }
    )>, runs: Array<(
      { __typename?: 'MarketingSeoRunType' }
      & Pick<MarketingSeoRunType, 'id' | 'kind' | 'state' | 'mode' | 'week' | 'month' | 'ai' | 'estimateUsd' | 'spentUsd' | 'createdAt' | 'finishedAt' | 'refusal' | 'error'>
    )>, history: Array<(
      { __typename?: 'MarketingSeoBudgetMonth' }
      & Pick<MarketingSeoBudgetMonth, 'month' | 'spentUsd' | 'reservedUsd' | 'uncertainUsd' | 'capUsd'>
    )> }
  ) }
);

export type MarketingSeoOpportunitiesListQueryVariables = Exact<{
  kinds?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Array<Scalars['String']>>;
  familySlug?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type MarketingSeoOpportunitiesListQuery = (
  { __typename?: 'Query' }
  & { marketingSeoOpportunities: Array<(
    { __typename?: 'MarketingSeoOpportunity' }
    & MarketingSeoOpportunityFieldsFragment
  )> }
);

export type MarketingSeoTaxonomyReportQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingSeoTaxonomyReportQuery = (
  { __typename?: 'Query' }
  & { marketingTaxonomy: (
    { __typename?: 'MarketingTaxonomy' }
    & { seoDomains: Array<(
      { __typename?: 'MarketingSeoDomainType' }
      & Pick<MarketingSeoDomainType, 'id' | 'domain' | 'label' | 'isOwn' | 'active' | 'source' | 'brandRegex' | 'suggestedMetrics'>
    )>, seoQuestions: Array<(
      { __typename?: 'MarketingSeoQuestionType' }
      & Pick<MarketingSeoQuestionType, 'id' | 'familySlug' | 'group' | 'textPl' | 'active' | 'sort' | 'version' | 'source'>
    )>, seoSettings: (
      { __typename?: 'MarketingSeoSettingsType' }
      & Pick<MarketingSeoSettingsType, 'ownDomain' | 'locationCode' | 'languageCode' | 'device' | 'depth' | 'maxTracked' | 'aiRepeats' | 'minGapVolume' | 'excludedTopics' | 'trackedCount'>
    ) }
  ) }
);

export type GetMyMcpAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyMcpAccessQuery = (
  { __typename?: 'Query' }
  & { myMcpAccess: (
    { __typename?: 'McpAccessType' }
    & Pick<McpAccessType, 'enabled' | 'endpoint' | 'blockedReason' | 'callsLast30Days'>
    & { connections: Array<(
      { __typename?: 'McpConnectionType' }
      & Pick<McpConnectionType, 'id' | 'application' | 'scope' | 'created' | 'expires' | 'lastUsed'>
    )> }
  ) }
);

export type MyCommsCountersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCommsCountersQuery = (
  { __typename?: 'Query' }
  & { myCommsCounters: (
    { __typename?: 'MyCommsCountersType' }
    & Pick<MyCommsCountersType, 'mailUnread' | 'slackUnread' | 'unhandled' | 'overdueTasks'>
  ) }
);

export type NotificationBadgeQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationBadgeQuery = (
  { __typename?: 'Query' }
  & { staffNotificationsSummary?: Maybe<(
    { __typename?: 'StaffNotificationsSummaryType' }
    & Pick<StaffNotificationsSummaryType, 'unreadCount' | 'totalCount' | 'latestId' | 'latestCreatedAt' | 'pollSeconds'>
    & { soundAlarm: (
      { __typename?: 'SoundAlarmType' }
      & Pick<SoundAlarmType, 'active' | 'taskId' | 'title'>
    ) }
  )> }
);

export type NotificationFeedQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  unreadOnly?: Maybe<Scalars['Boolean']>;
}>;


export type NotificationFeedQuery = (
  { __typename?: 'Query' }
  & { staffNotifications?: Maybe<(
    { __typename?: 'StaffNotificationPageType' }
    & Pick<StaffNotificationPageType, 'unreadCount' | 'hasNextPage' | 'endCursor'>
    & { edges: Array<(
      { __typename?: 'StaffNotificationEdgeType' }
      & Pick<StaffNotificationEdgeType, 'cursor'>
      & { node: (
        { __typename?: 'StaffNotificationType' }
        & Pick<StaffNotificationType, 'id' | 'kind' | 'title' | 'body' | 'taskId' | 'priority' | 'dueDate' | 'actorName' | 'createdAt' | 'readAt'>
      ) }
    )> }
  )> }
);

export type NotificationPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPrefsQuery = (
  { __typename?: 'Query' }
  & { staffNotificationSettings?: Maybe<(
    { __typename?: 'StaffNotificationSettingsType' }
    & Pick<StaffNotificationSettingsType, 'soundEnabled' | 'pollSeconds' | 'repeatAfterMinutes' | 'quietFrom' | 'quietTo' | 'enabledKinds' | 'telegramEnabled' | 'telegramLinked' | 'telegramUsername' | 'telegramLinkedAt' | 'telegramBlockedAt' | 'telegramAvailable' | 'robotRules'>
    & { availableKinds: Array<(
      { __typename?: 'StaffNotificationKindType' }
      & Pick<StaffNotificationKindType, 'key' | 'label' | 'enabled'>
    )>, availableRobotRules: Array<(
      { __typename?: 'StaffRobotRuleType' }
      & Pick<StaffRobotRuleType, 'key' | 'label' | 'enabled' | 'available'>
    )> }
  )> }
);

export type PandaDocAnalyticsQueryVariables = Exact<{
  granularity?: Maybe<Scalars['String']>;
  course?: Maybe<Scalars['String']>;
  docType?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  source?: Maybe<Scalars['String']>;
  sellerId?: Maybe<Scalars['ID']>;
  sentById?: Maybe<Scalars['ID']>;
}>;


export type PandaDocAnalyticsQuery = (
  { __typename?: 'Query' }
  & { pandadocAnalytics?: Maybe<(
    { __typename?: 'PandaDocAnalyticsType' }
    & Pick<PandaDocAnalyticsType, 'granularity' | 'course'>
    & { window?: Maybe<(
      { __typename?: 'PandaDocWindow' }
      & Pick<PandaDocWindow, 'docsLoaded' | 'totalInDb' | 'signedCount' | 'minDate' | 'maxDate'>
    )>, volumeKpi?: Maybe<(
      { __typename?: 'PandaDocVolumeKpi' }
      & Pick<PandaDocVolumeKpi, 'total' | 'students' | 'trainers' | 'dofin' | 'last30'>
    )>, ttsKpi?: Maybe<(
      { __typename?: 'PandaDocTTSKpi' }
      & Pick<PandaDocTtsKpi, 'medianHours' | 'meanHours' | 'pct24h' | 'pct3d' | 'sample'>
    )>, conversionKpi?: Maybe<(
      { __typename?: 'PandaDocConversionKpi' }
      & Pick<PandaDocConversionKpi, 'sent' | 'signed' | 'active' | 'lost' | 'signedPct' | 'activePct' | 'lostPct' | 'ratePct'>
    )>, volumeSeries?: Maybe<(
      { __typename?: 'PandaDocVolumeSeries' }
      & { students?: Maybe<(
        { __typename?: 'PandaDocCountSeries' }
        & Pick<PandaDocCountSeries, 'labels' | 'values'>
      )>, trainers?: Maybe<(
        { __typename?: 'PandaDocCountSeries' }
        & Pick<PandaDocCountSeries, 'labels' | 'values'>
      )>, dofin?: Maybe<(
        { __typename?: 'PandaDocCountSeries' }
        & Pick<PandaDocCountSeries, 'labels' | 'values'>
      )> }
    )>, ttsHistogram?: Maybe<(
      { __typename?: 'PandaDocHistogram' }
      & Pick<PandaDocHistogram, 'labels' | 'values'>
    )>, ttsByCourse?: Maybe<Array<Maybe<(
      { __typename?: 'PandaDocCourseTTS' }
      & Pick<PandaDocCourseTts, 'course' | 'avgDays' | 'sample'>
    )>>>, ttsMedianSeries?: Maybe<(
      { __typename?: 'PandaDocTTSMedianSeries' }
      & { students?: Maybe<(
        { __typename?: 'PandaDocTTSSeries' }
        & Pick<PandaDocTtsSeries, 'labels' | 'values'>
      )>, trainers?: Maybe<(
        { __typename?: 'PandaDocTTSSeries' }
        & Pick<PandaDocTtsSeries, 'labels' | 'values'>
      )>, dofin?: Maybe<(
        { __typename?: 'PandaDocTTSSeries' }
        & Pick<PandaDocTtsSeries, 'labels' | 'values'>
      )> }
    )>, conversionByCourse?: Maybe<Array<Maybe<(
      { __typename?: 'PandaDocCourseConversion' }
      & Pick<PandaDocCourseConversion, 'course' | 'signed' | 'active' | 'lost'>
    )>>>, conversionSeries?: Maybe<(
      { __typename?: 'PandaDocConversionSeriesGroup' }
      & { students?: Maybe<(
        { __typename?: 'PandaDocConversionSeries' }
        & Pick<PandaDocConversionSeries, 'labels' | 'signed' | 'active' | 'lost'>
      )>, dofin?: Maybe<(
        { __typename?: 'PandaDocConversionSeries' }
        & Pick<PandaDocConversionSeries, 'labels' | 'signed' | 'active' | 'lost'>
      )> }
    )> }
  )> }
);

export type PandaDocDocumentsQueryVariables = Exact<{
  course?: Maybe<Scalars['String']>;
  docType?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  studentMatches?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type PandaDocDocumentsQuery = (
  { __typename?: 'Query' }
  & { pandadocDocuments?: Maybe<(
    { __typename?: 'PandaDocDocumentConnection' }
    & Pick<PandaDocDocumentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'PandaDocDocumentEdge' }
      & Pick<PandaDocDocumentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'PandaDocDocumentType' }
        & Pick<PandaDocDocumentType, 'id' | 'pk' | 'pandadocId' | 'name' | 'status' | 'docType' | 'course' | 'outcome' | 'ttsHours' | 'dateCreated' | 'dateModified' | 'dateSent' | 'dateCompleted' | 'provisionedAt' | 'matchType' | 'folderName' | 'recipientEmail' | 'recipientPhone' | 'unavailable'>
        & { agreement?: Maybe<(
          { __typename?: 'AgreementType' }
          & Pick<AgreementType, 'id' | 'agreementTitle'>
          & { student: (
            { __typename?: 'StudentType' }
            & Pick<StudentType, 'id'>
            & { user?: Maybe<(
              { __typename?: 'CustomUserType' }
              & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'email'>
            )> }
          ), group: (
            { __typename?: 'MethodistGroupType' }
            & Pick<MethodistGroupType, 'id' | 'name'>
          ), contractDocument?: Maybe<(
            { __typename?: 'ContractSummaryType' }
            & Pick<ContractSummaryType, 'id' | 'status'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type UnlinkedPandaDocSearchQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  docType?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type UnlinkedPandaDocSearchQuery = (
  { __typename?: 'Query' }
  & { pandadocDocuments?: Maybe<(
    { __typename?: 'PandaDocDocumentConnection' }
    & Pick<PandaDocDocumentConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'PandaDocDocumentEdge' }
      & { node?: Maybe<(
        { __typename?: 'PandaDocDocumentType' }
        & Pick<PandaDocDocumentType, 'id' | 'pandadocId' | 'name' | 'outcome' | 'folderName' | 'dateCompleted' | 'recipientEmail' | 'recipientPhone'>
      )> }
    )>> }
  )> }
);

export type TeacherPandadocDocsQueryVariables = Exact<{
  teacherId?: Maybe<Scalars['ID']>;
  teacherMatches?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type TeacherPandadocDocsQuery = (
  { __typename?: 'Query' }
  & { pandadocDocuments?: Maybe<(
    { __typename?: 'PandaDocDocumentConnection' }
    & Pick<PandaDocDocumentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'PandaDocDocumentEdge' }
      & Pick<PandaDocDocumentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'PandaDocDocumentType' }
        & Pick<PandaDocDocumentType, 'id' | 'pk' | 'pandadocId' | 'name' | 'status' | 'outcome' | 'dateCreated' | 'dateCompleted' | 'provisionedAt' | 'matchType' | 'recipientEmail' | 'recipientPhone' | 'contractUrl'>
        & { teacher?: Maybe<(
          { __typename?: 'TeacherType' }
          & Pick<TeacherType, 'id'>
        )> }
      )> }
    )>> }
  )> }
);

export type PandaDocProvisioningFoldersQueryVariables = Exact<{
  course?: Maybe<Scalars['String']>;
}>;


export type PandaDocProvisioningFoldersQuery = (
  { __typename?: 'Query' }
  & { pandadocProvisioningFolders?: Maybe<Array<Maybe<(
    { __typename?: 'ProvisioningFolder' }
    & Pick<ProvisioningFolder, 'folderUuid' | 'folderName' | 'detectedCourseId' | 'detectedCourseName' | 'existingGroupId' | 'existingGroupName'>
    & { studentDocs?: Maybe<Array<Maybe<(
      { __typename?: 'ProvisioningStudentDoc' }
      & Pick<ProvisioningStudentDoc, 'pandadocId' | 'pk' | 'name' | 'status' | 'outcome' | 'firstName' | 'lastName' | 'email' | 'phone' | 'contractUrl' | 'phoneMissing' | 'userExists' | 'studentExists' | 'existingUserId' | 'alreadyProvisioned'>
    )>>> }
  )>>> }
);

export type PandaDocSyncStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type PandaDocSyncStatusQuery = (
  { __typename?: 'Query' }
  & { pandadocSyncStatus?: Maybe<(
    { __typename?: 'PandaDocSyncStatusType' }
    & Pick<PandaDocSyncStatusType, 'documentsCount' | 'detailsPending' | 'lastListSyncAt' | 'lastDetailsSyncAt' | 'newestDocDate' | 'lastDocumentsPulled' | 'lastRunStatus' | 'lastError' | 'syncRunning'>
  )> }
);

export type ParticipationAgreementListQueryVariables = Exact<{
  candidateId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
}>;


export type ParticipationAgreementListQuery = (
  { __typename?: 'Query' }
  & { fundingParticipationAgreements: Array<(
    { __typename?: 'ParticipationAgreementType' }
    & Pick<ParticipationAgreementType, 'id' | 'agreementTitle' | 'studentId' | 'studentName' | 'groupId' | 'groupName' | 'courseName' | 'date' | 'windowFrom' | 'windowTo' | 'lessonsCount' | 'terminated' | 'terminatedDate' | 'statePrefinanced' | 'cofunded' | 'isCandidateAgreement'>
  )> }
);

export type ParticipationSummaryCardQueryVariables = Exact<{
  agreementId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
}>;


export type ParticipationSummaryCardQuery = (
  { __typename?: 'Query' }
  & { fundingParticipationSummary?: Maybe<(
    { __typename?: 'ParticipationSummaryType' }
    & Pick<ParticipationSummaryType, 'agreementId' | 'dateFrom' | 'dateTo' | 'generatedAt' | 'minPercent' | 'supportId' | 'operatorId' | 'operatorName' | 'projectNumber' | 'lessonsPlanned' | 'lessonsHeld' | 'lessonsFuture' | 'lessonsWithZoomData' | 'lessonsAttended' | 'lessonsPartial' | 'lessonsAbsent' | 'additionalLessons' | 'additionalAttended' | 'minutesInZoom' | 'minutesPlanned' | 'minutesAttended' | 'hoursPercent' | 'journalPresent' | 'journalPercent'>
    & { lessons: Array<(
      { __typename?: 'ParticipationLessonType' }
      & Pick<ParticipationLessonType, 'lessonId' | 'number' | 'date' | 'name' | 'startsAt' | 'endsAt' | 'additional' | 'status' | 'minutesPlanned' | 'minutesInZoom' | 'minutesOverlap' | 'percent' | 'journal' | 'sessionsCount' | 'firstJoin' | 'lastLeave'>
    )>, warnings: Array<(
      { __typename?: 'ParticipationWarningType' }
      & Pick<ParticipationWarningType, 'code' | 'count' | 'dates'>
    )> }
  )> }
);

export type ParticipationReportFileQueryVariables = Exact<{
  agreementId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  format: ParticipationReportFormat;
  language?: Maybe<Scalars['String']>;
}>;


export type ParticipationReportFileQuery = (
  { __typename?: 'Query' }
  & { fundingParticipationReport?: Maybe<(
    { __typename?: 'ParticipationFileType' }
    & Pick<ParticipationFileType, 'fileName' | 'contentType' | 'contentBase64'>
  )> }
);

export type GroupParticipationReportFileQueryVariables = Exact<{
  groupId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  language?: Maybe<Scalars['String']>;
}>;


export type GroupParticipationReportFileQuery = (
  { __typename?: 'Query' }
  & { groupParticipationReport?: Maybe<(
    { __typename?: 'ParticipationFileType' }
    & Pick<ParticipationFileType, 'fileName' | 'contentType' | 'contentBase64'>
  )> }
);

export type PaymentCalendarRowFieldsFragment = (
  { __typename?: 'PaymentCalendarRowType' }
  & Pick<PaymentCalendarRowType, 'direction' | 'source' | 'kind' | 'title' | 'date' | 'amount' | 'currency' | 'amountPln' | 'comment' | 'status' | 'incomeState' | 'editable' | 'rateMissing' | 'sourceRef' | 'plannedPaymentId' | 'relatedGroupId' | 'relatedTeacherId' | 'balanceAfterPln' | 'toneAfter' | 'counterpartyName' | 'invoiceId' | 'invoiceNumber' | 'invoiceExternalUrl' | 'expenseId' | 'contributionId'>
);

export type PaymentCalendarQueryVariables = Exact<{
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  legalEntityId?: Maybe<Scalars['ID']>;
}>;


export type PaymentCalendarQuery = (
  { __typename?: 'Query' }
  & { paymentCalendar?: Maybe<(
    { __typename?: 'PaymentCalendarType' }
    & Pick<PaymentCalendarType, 'dateFrom' | 'dateTo' | 'openingBalancePln' | 'totalIncomePln' | 'totalExpensePln' | 'totalReceivedPln' | 'totalAwaitedPln' | 'totalOverduePln' | 'totalToPayPln' | 'minBalancePln' | 'hasShortfall' | 'hasRateMissing'>
    & { days?: Maybe<Array<Maybe<(
      { __typename?: 'PaymentCalendarDayType' }
      & Pick<PaymentCalendarDayType, 'date' | 'incomeTotalPln' | 'expenseTotalPln' | 'receivedTotalPln' | 'openingBalancePln' | 'endBalancePln' | 'tone' | 'hasRateMissing'>
      & { incomeRows?: Maybe<Array<Maybe<(
        { __typename?: 'PaymentCalendarRowType' }
        & PaymentCalendarRowFieldsFragment
      )>>>, expenseRows?: Maybe<Array<Maybe<(
        { __typename?: 'PaymentCalendarRowType' }
        & PaymentCalendarRowFieldsFragment
      )>>>, receivedRows?: Maybe<Array<Maybe<(
        { __typename?: 'PaymentCalendarRowType' }
        & PaymentCalendarRowFieldsFragment
      )>>> }
    )>>> }
  )> }
);

export type PaymentCalendarSettingsQueryVariables = Exact<{
  legalEntityId?: Maybe<Scalars['ID']>;
}>;


export type PaymentCalendarSettingsQuery = (
  { __typename?: 'Query' }
  & { paymentCalendarSettings?: Maybe<(
    { __typename?: 'PaymentCalendarSettingsType' }
    & Pick<PaymentCalendarSettingsType, 'teacherPayoutDay' | 'incomeOffsetDays' | 'legalEntityId'>
  )>, exchangeRates?: Maybe<Array<Maybe<(
    { __typename?: 'ExchangeRateType' }
    & Pick<ExchangeRateType, 'pk' | 'currency' | 'rateToPln' | 'effectiveFrom'>
  )>>>, cashBalances?: Maybe<Array<Maybe<(
    { __typename?: 'CashBalanceSnapshotType' }
    & Pick<CashBalanceSnapshotType, 'pk' | 'asOfDate' | 'amountPln' | 'legalEntityId'>
  )>>> }
);

export type PaginatedPerformancesQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type PaginatedPerformancesQuery = (
  { __typename?: 'Query' }
  & { allStudentsAchievement?: Maybe<(
    { __typename?: 'StudentsAchievementConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'StudentsAchievementEdge' }
      & Pick<StudentsAchievementEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id' | 'attendancesInfo' | 'courseWorksAverage' | 'hwSummary' | 'graduationProjectMark'>
        & { student: (
          { __typename?: 'StudentType' }
          & Pick<StudentType, 'id'>
          & { user?: Maybe<(
            { __typename?: 'CustomUserType' }
            & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'middleName'>
          )> }
        ), group: (
          { __typename?: 'MethodistGroupType' }
          & Pick<MethodistGroupType, 'id' | 'name'>
          & { course: (
            { __typename?: 'CourseFilterType' }
            & Pick<CourseFilterType, 'educationForm'>
          ) }
        ) }
      )> }
    )>> }
  )> }
);

export type PnlExportRunsQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type PnlExportRunsQuery = (
  { __typename?: 'Query' }
  & { pnlExportRuns?: Maybe<Array<(
    { __typename?: 'PnlExportRunType' }
    & Pick<PnlExportRunType, 'id' | 'status' | 'fileFormat' | 'language' | 'monthFrom' | 'monthTo' | 'groupId' | 'groupName' | 'fileName' | 'size' | 'stats' | 'error' | 'createdByName' | 'createdAt' | 'finishedAt' | 'isDownloadable' | 'isFilePurged'>
  )>> }
);

export type PnlExportGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type PnlExportGroupsQuery = (
  { __typename?: 'Query' }
  & { pnlExportGroups?: Maybe<Array<(
    { __typename?: 'PnlExportGroupType' }
    & Pick<PnlExportGroupType, 'id' | 'name' | 'courseName' | 'startDate'>
  )>> }
);

export type PnlExportFileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PnlExportFileQuery = (
  { __typename?: 'Query' }
  & { pnlExportFile?: Maybe<(
    { __typename?: 'PnlExportFileType' }
    & Pick<PnlExportFileType, 'fileName' | 'contentType' | 'contentBase64'>
  )> }
);

export type MailSignaturesListQueryVariables = Exact<{ [key: string]: never; }>;


export type MailSignaturesListQuery = (
  { __typename?: 'Query' }
  & { myMailSignatures: Array<(
    { __typename?: 'MailSignatureType' }
    & Pick<MailSignatureType, 'id' | 'mailboxEmail' | 'html' | 'source' | 'importedAt' | 'updatedAt'>
  )> }
);

export type RuntimeSettingsListQueryVariables = Exact<{
  section?: Maybe<Scalars['String']>;
}>;


export type RuntimeSettingsListQuery = (
  { __typename?: 'Query' }
  & { runtimeSettings: Array<(
    { __typename?: 'RuntimeSettingType' }
    & RuntimeSettingFieldsFragment
  )> }
);

export type RuntimeSettingSectionsListQueryVariables = Exact<{ [key: string]: never; }>;


export type RuntimeSettingSectionsListQuery = (
  { __typename?: 'Query' }
  & { runtimeSettingSections: Array<(
    { __typename?: 'RuntimeSettingSectionType' }
    & Pick<RuntimeSettingSectionType, 'id' | 'labelRu' | 'labelPl'>
  )> }
);

export type RuntimeSettingHistoryQueryVariables = Exact<{
  key?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type RuntimeSettingHistoryQuery = (
  { __typename?: 'Query' }
  & { runtimeSettingChanges: Array<(
    { __typename?: 'RuntimeSettingChangeType' }
    & Pick<RuntimeSettingChangeType, 'id' | 'key' | 'old' | 'new' | 'reason' | 'userName' | 'createdAt'>
  )> }
);

export type ScheduledTasksListQueryVariables = Exact<{ [key: string]: never; }>;


export type ScheduledTasksListQuery = (
  { __typename?: 'Query' }
  & { scheduledTasks: (
    { __typename?: 'ScheduledTasksType' }
    & { entries: Array<(
      { __typename?: 'ScheduledTaskEntryType' }
      & Pick<ScheduledTaskEntryType, 'name' | 'task' | 'domain' | 'schedule' | 'keys' | 'offKeys' | 'effectiveOn' | 'alwaysOn' | 'periodicTaskEnabled' | 'lastRunAt' | 'totalRunCount' | 'lastSkippedAt'>
      & { keyStates: Array<(
        { __typename?: 'ScheduledKeyStateType' }
        & Pick<ScheduledKeyStateType, 'key' | 'on' | 'source'>
      )>, lastJournalRun?: Maybe<(
        { __typename?: 'ScheduledRunType' }
        & ScheduledRunFieldsFragment
      )> }
    )>, orphans: Array<(
      { __typename?: 'OrphanPeriodicTaskType' }
      & Pick<OrphanPeriodicTaskType, 'name' | 'task' | 'enabled' | 'schedule' | 'lastRunAt' | 'totalRunCount'>
    )> }
  ) }
);

export type MailTemplatesListQueryVariables = Exact<{ [key: string]: never; }>;


export type MailTemplatesListQuery = (
  { __typename?: 'Query' }
  & { sendgridTemplates: Array<(
    { __typename?: 'SendgridTemplateType' }
    & Pick<SendgridTemplateType, 'id' | 'name' | 'subject' | 'versionId'>
  )> }
);

export type MailGroupContactListQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type MailGroupContactListQuery = (
  { __typename?: 'Query' }
  & { sendgridGroupList?: Maybe<(
    { __typename?: 'SendgridGroupListType' }
    & Pick<SendgridGroupListType, 'id' | 'sendgridListId' | 'name' | 'contactCount' | 'lastSyncStatus' | 'lastSyncedAt' | 'errorMessage'>
  )> }
);

export type MailCandidatesListQueryVariables = Exact<{
  groupId: Scalars['ID'];
  mode?: Maybe<Scalars['String']>;
  includeTerminated?: Maybe<Scalars['Boolean']>;
}>;


export type MailCandidatesListQuery = (
  { __typename?: 'Query' }
  & { groupMailCandidates: Array<(
    { __typename?: 'GroupMailCandidateType' }
    & Pick<GroupMailCandidateType, 'studentId' | 'studentName' | 'email' | 'agreementTitle' | 'agreementTerminated' | 'invoiceId' | 'invoiceNumber' | 'invoiceIssueDate' | 'invoiceDueDate' | 'invoiceOutstanding' | 'invoiceCurrency' | 'invoiceUrl' | 'isOverdue' | 'daysOverdue' | 'lastMailedAt'>
  )> }
);

export type MailJobProgressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MailJobProgressQuery = (
  { __typename?: 'Query' }
  & { mailJob?: Maybe<(
    { __typename?: 'MailJobType' }
    & Pick<MailJobType, 'id' | 'status' | 'templateName' | 'total' | 'sentCount' | 'failedCount' | 'deliveredCount' | 'openedCount' | 'clickedCount' | 'bouncedCount' | 'errorMessage' | 'createdAt' | 'finishedAt' | 'createdByName'>
    & { recipients: Array<(
      { __typename?: 'MailRecipientType' }
      & Pick<MailRecipientType, 'id' | 'studentName' | 'email' | 'status' | 'reason' | 'invoiceNumber' | 'deliveredAt' | 'firstOpenedAt' | 'openCount' | 'firstClickedAt' | 'clickCount' | 'lastClickUrl' | 'bouncedAt' | 'bounceReason' | 'droppedAt' | 'dropReason' | 'unsubscribedAt'>
    )> }
  )> }
);

export type MailJobsHistoryQueryVariables = Exact<{
  groupId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
}>;


export type MailJobsHistoryQuery = (
  { __typename?: 'Query' }
  & { mailJobs: Array<(
    { __typename?: 'MailJobType' }
    & Pick<MailJobType, 'id' | 'status' | 'templateName' | 'total' | 'sentCount' | 'failedCount' | 'deliveredCount' | 'openedCount' | 'clickedCount' | 'bouncedCount' | 'createdAt' | 'finishedAt' | 'createdByName'>
    & { recipients: Array<(
      { __typename?: 'MailRecipientType' }
      & Pick<MailRecipientType, 'id' | 'studentName' | 'email' | 'status' | 'reason' | 'deliveredAt' | 'firstOpenedAt' | 'openCount' | 'firstClickedAt' | 'clickCount' | 'lastClickUrl' | 'droppedAt' | 'dropReason'>
    )> }
  )> }
);

export type SettingsMetaQueryVariables = Exact<{
  withGroups: Scalars['Boolean'];
}>;


export type SettingsMetaQuery = (
  { __typename?: 'Query' }
  & { metaCourses?: Maybe<(
    { __typename?: 'MetaCourses' }
    & Pick<MetaCourses, 'totalCount'>
  )>, metaGroups?: Maybe<(
    { __typename?: 'MetaGroups' }
    & Pick<MetaGroups, 'totalCount'>
  )> }
);

export type ShortLinkSettingsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ShortLinkSettingsInfoQuery = (
  { __typename?: 'Query' }
  & { shortLinkSettings: (
    { __typename?: 'ShortLinkSettingsType' }
    & Pick<ShortLinkSettingsType, 'enabled' | 'baseUrl'>
  ) }
);

export type ShortLinkListQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  mine?: Maybe<Scalars['Boolean']>;
  channel?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['ID']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  clicks?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ShortLinkListQuery = (
  { __typename?: 'Query' }
  & { shortLinks: Array<(
    { __typename?: 'ShortLinkType' }
    & ShortLinkFieldsFragment
  )>, shortLinkSummary: (
    { __typename?: 'ShortLinkSummaryType' }
    & Pick<ShortLinkSummaryType, 'total' | 'live' | 'humanClicks' | 'clicks'>
  ) }
);

export type ShortLinkExportPageQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  mine?: Maybe<Scalars['Boolean']>;
  channel?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['ID']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  clicks?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ShortLinkExportPageQuery = (
  { __typename?: 'Query' }
  & { shortLinks: Array<(
    { __typename?: 'ShortLinkType' }
    & ShortLinkFieldsFragment
  )> }
);

export type ShortLinkFacetListQueryVariables = Exact<{ [key: string]: never; }>;


export type ShortLinkFacetListQuery = (
  { __typename?: 'Query' }
  & { shortLinkFacets: (
    { __typename?: 'ShortLinkFacetsType' }
    & Pick<ShortLinkFacetsType, 'channels' | 'tags'>
    & { authors: Array<(
      { __typename?: 'ShortLinkAuthorType' }
      & Pick<ShortLinkAuthorType, 'id' | 'name'>
    )> }
  ) }
);

export type ShortLinkCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShortLinkCardQuery = (
  { __typename?: 'Query' }
  & { shortLink?: Maybe<(
    { __typename?: 'ShortLinkType' }
    & ShortLinkFieldsFragment
  )> }
);

export type ShortLinkDailyClickListQueryVariables = Exact<{
  id: Scalars['ID'];
  days?: Maybe<Scalars['Int']>;
}>;


export type ShortLinkDailyClickListQuery = (
  { __typename?: 'Query' }
  & { shortLinkDailyClicks: Array<(
    { __typename?: 'ShortLinkDayType' }
    & Pick<ShortLinkDayType, 'date' | 'human' | 'total'>
  )> }
);

export type ShortLinkClickListQueryVariables = Exact<{
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
}>;


export type ShortLinkClickListQuery = (
  { __typename?: 'Query' }
  & { shortLinkClicks: Array<(
    { __typename?: 'ShortLinkClickType' }
    & Pick<ShortLinkClickType, 'id' | 'clickedAt' | 'human' | 'counted' | 'isBot' | 'source'>
  )> }
);

export type SmsJournalPageQueryVariables = Exact<{
  topic?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  dlrStatus?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  contractId?: Maybe<Scalars['ID']>;
  campaignId?: Maybe<Scalars['ID']>;
  createdById?: Maybe<Scalars['ID']>;
  createdFrom?: Maybe<Scalars['Date']>;
  createdTo?: Maybe<Scalars['Date']>;
  phoneTail?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  leadId?: Maybe<Scalars['ID']>;
  candidateId?: Maybe<Scalars['ID']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type SmsJournalPageQuery = (
  { __typename?: 'Query' }
  & { smsJournal: (
    { __typename?: 'SmsJournalPageType' }
    & Pick<SmsJournalPageType, 'total' | 'totalCost' | 'totalSegments'>
    & { items: Array<(
      { __typename?: 'SmsMessageType' }
      & SmsMessageFieldsFragment
    )> }
  ) }
);

export type SmsJournalFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SmsJournalFilterOptionsQuery = (
  { __typename?: 'Query' }
  & { smsJournalFacets: (
    { __typename?: 'SmsJournalFacetsType' }
    & Pick<SmsJournalFacetsType, 'topics'>
    & { authors: Array<(
      { __typename?: 'SmsAuthorType' }
      & Pick<SmsAuthorType, 'id' | 'name'>
    )>, campaigns: Array<(
      { __typename?: 'SmsCampaignRefType' }
      & Pick<SmsCampaignRefType, 'id' | 'title'>
    )> }
  ) }
);

export type StudentSmsStateQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type StudentSmsStateQuery = (
  { __typename?: 'Query' }
  & { studentSms?: Maybe<(
    { __typename?: 'StudentSmsStateType' }
    & StudentSmsStateFieldsFragment
  )> }
);

export type StudentSmsPreviewQueryVariables = Exact<{
  studentId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<SmsLinkInput>;
}>;


export type StudentSmsPreviewQuery = (
  { __typename?: 'Query' }
  & { previewStudentSms?: Maybe<(
    { __typename?: 'SmsPreviewType' }
    & SmsPreviewFieldsFragment
  )> }
);

export type TeacherSmsStateQueryVariables = Exact<{
  teacherId: Scalars['ID'];
}>;


export type TeacherSmsStateQuery = (
  { __typename?: 'Query' }
  & { teacherSms?: Maybe<(
    { __typename?: 'TeacherSmsStateType' }
    & TeacherSmsStateFieldsFragment
  )> }
);

export type TeacherSmsPreviewQueryVariables = Exact<{
  teacherId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<TeacherSmsLinkInput>;
}>;


export type TeacherSmsPreviewQuery = (
  { __typename?: 'Query' }
  & { previewTeacherSms?: Maybe<(
    { __typename?: 'SmsPreviewType' }
    & SmsPreviewFieldsFragment
  )> }
);

export type GroupSmsCandidatesQueryVariables = Exact<{
  groupId: Scalars['ID'];
  mode?: Maybe<Scalars['String']>;
}>;


export type GroupSmsCandidatesQuery = (
  { __typename?: 'Query' }
  & { smsCampaignCandidates: Array<(
    { __typename?: 'SmsCampaignCandidateType' }
    & Pick<SmsCampaignCandidateType, 'studentId' | 'studentName' | 'phoneMasked' | 'reason' | 'invoiceId' | 'invoiceNumber' | 'amount' | 'currency' | 'dueDate'>
  )> }
);

export type GroupSmsPreviewQueryVariables = Exact<{
  groupId: Scalars['ID'];
  text: Scalars['String'];
  link?: Maybe<SmsLinkInput>;
  mode?: Maybe<Scalars['String']>;
  studentIds?: Maybe<Array<Scalars['ID']>>;
}>;


export type GroupSmsPreviewQuery = (
  { __typename?: 'Query' }
  & { previewSmsCampaign?: Maybe<(
    { __typename?: 'SmsCampaignPreviewType' }
    & Pick<SmsCampaignPreviewType, 'recipients' | 'excluded' | 'total' | 'reason' | 'message'>
    & { sample?: Maybe<(
      { __typename?: 'SmsPreviewType' }
      & SmsPreviewFieldsFragment
    )> }
  )> }
);

export type GroupSmsCampaignsQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
}>;


export type GroupSmsCampaignsQuery = (
  { __typename?: 'Query' }
  & { smsCampaigns: Array<(
    { __typename?: 'SmsCampaignType' }
    & SmsCampaignFieldsFragment
  )> }
);

export type SmsCampaignProgressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SmsCampaignProgressQuery = (
  { __typename?: 'Query' }
  & { smsCampaign?: Maybe<(
    { __typename?: 'SmsCampaignType' }
    & SmsCampaignFieldsFragment
  )> }
);

export type SmsSettingsViewQueryVariables = Exact<{ [key: string]: never; }>;


export type SmsSettingsViewQuery = (
  { __typename?: 'Query' }
  & { smsSettings: (
    { __typename?: 'SmsSettingsType' }
    & SmsSettingsFieldsFragment
  ) }
);

export type LinkAddressesViewQueryVariables = Exact<{ [key: string]: never; }>;


export type LinkAddressesViewQuery = (
  { __typename?: 'Query' }
  & { linkAddresses: (
    { __typename?: 'LinkAddressesType' }
    & LinkAddressesFieldsFragment
  ) }
);

export type SmsProviderStateQueryVariables = Exact<{
  refresh?: Maybe<Scalars['Boolean']>;
}>;


export type SmsProviderStateQuery = (
  { __typename?: 'Query' }
  & { smsProviderStatus: (
    { __typename?: 'SmsProviderStatusType' }
    & SmsProviderStatusFieldsFragment
  ) }
);

export type SmsReminderPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type SmsReminderPlansQuery = (
  { __typename?: 'Query' }
  & { reminderPlans: Array<(
    { __typename?: 'ReminderPlanType' }
    & SmsReminderPlanFieldsFragment
  )> }
);

export type SmsReminderDryRunQueryVariables = Exact<{
  topic: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
}>;


export type SmsReminderDryRunQuery = (
  { __typename?: 'Query' }
  & { previewSmsReminders: Array<(
    { __typename?: 'SmsReminderPreviewType' }
    & Pick<SmsReminderPreviewType, 'topic' | 'subjectId' | 'subjectLabel' | 'step' | 'dueAt' | 'dueNow' | 'phoneMasked' | 'reason' | 'state' | 'condition' | 'body' | 'segments'>
  )> }
);

export type GetAppStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppStateQuery = (
  { __typename?: 'Query' }
  & { appState: (
    { __typename?: 'appState' }
    & Pick<AppState, 'bootstrapped'>
  ) }
);

export type GetAuthStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthStateQuery = (
  { __typename?: 'Query' }
  & { authState: (
    { __typename?: 'authState' }
    & Pick<AuthState, 'isLoggedIn' | 'access_token'>
  ) }
);

export type StudentAcademicQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
}>;


export type StudentAcademicQuery = (
  { __typename?: 'Query' }
  & { student?: Maybe<(
    { __typename?: 'StudentType' }
    & Pick<StudentType, 'id' | 'attendancePercent' | 'averageMark'>
    & { lessons?: Maybe<(
      { __typename?: 'StudentLessonConnection' }
      & Pick<StudentLessonConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'StudentLessonEdge' }
        & { node?: Maybe<(
          { __typename?: 'StudentLessonNodeType' }
          & Pick<StudentLessonNodeType, 'id' | 'date' | 'lessonNumber' | 'name' | 'attended' | 'mark'>
        )> }
      )>> }
    )> }
  )> }
);

export type PaginatedStudentsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type PaginatedStudentsQuery = (
  { __typename?: 'Query' }
  & { allStudents?: Maybe<(
    { __typename?: 'StudentConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'StudentEdge' }
      & Pick<StudentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'StudentType' }
        & Pick<StudentType, 'id' | 'isLmsBlocked'>
        & { user?: Maybe<(
          { __typename?: 'CustomUserType' }
          & Pick<CustomUserType, 'id' | 'lastName' | 'firstName' | 'middleName' | 'phone' | 'email'>
        )>, agreements: Array<(
          { __typename?: 'AgreementType' }
          & Pick<AgreementType, 'id' | 'agreementTitle' | 'currency' | 'budgetAmount' | 'paidAmount' | 'debtAmount' | 'upcomingAmount' | 'terminated'>
          & { group: (
            { __typename?: 'MethodistGroupType' }
            & Pick<MethodistGroupType, 'id' | 'name'>
          ) }
        )> }
      )> }
    )>> }
  )> }
);

export type LoadAgreementByIdQueryVariables = Exact<{
  agreementId: Scalars['ID'];
}>;


export type LoadAgreementByIdQuery = (
  { __typename?: 'Query' }
  & { agreement?: Maybe<(
    { __typename?: 'AgreementType' }
    & Pick<AgreementType, 'id' | 'agreementTitle' | 'currency' | 'terminated' | 'paymentByCompany' | 'vat' | 'date' | 'comment' | 'budgetAmount' | 'paidAmount' | 'debtAmount' | 'upcomingAmount' | 'partialAttendance' | 'terminatedDate' | 'transferOut' | 'freeOfCharge' | 'statePrefinanced' | 'promocode' | 'resident'>
    & { firstLesson?: Maybe<(
      { __typename?: 'GroupLessonType' }
      & Pick<GroupLessonType, 'id' | 'name' | 'lessonNumber'>
    )>, lastLesson?: Maybe<(
      { __typename?: 'GroupLessonType' }
      & Pick<GroupLessonType, 'id' | 'name' | 'date' | 'lessonNumber'>
    )>, chargeback?: Maybe<(
      { __typename?: 'ChargebackType' }
      & Pick<ChargebackType, 'id' | 'amountByn' | 'amountForeign' | 'currency'>
    )>, contributions: (
      { __typename?: 'ContributionTypeConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContributionTypeEdge' }
        & { node?: Maybe<(
          { __typename?: 'ContributionType' }
          & Pick<ContributionType, 'id' | 'date' | 'amountForeign' | 'amountByn'>
        )> }
      )>> }
    ), company?: Maybe<(
      { __typename?: 'CompanyType' }
      & Pick<CompanyType, 'id' | 'name'>
    )>, country?: Maybe<(
      { __typename?: 'CountryType' }
      & Pick<CountryType, 'id' | 'title'>
    )>, student: (
      { __typename?: 'StudentType' }
      & Pick<StudentType, 'id'>
      & { user?: Maybe<(
        { __typename?: 'CustomUserType' }
        & Pick<CustomUserType, 'id' | 'firstName' | 'middleName' | 'lastName' | 'phone' | 'email'>
      )> }
    ), group: (
      { __typename?: 'MethodistGroupType' }
      & Pick<MethodistGroupType, 'id' | 'name' | 'startDate'>
      & { course: (
        { __typename?: 'CourseFilterType' }
        & Pick<CourseFilterType, 'id' | 'name'>
      ) }
    ), startAccountsPayable?: Maybe<(
      { __typename?: 'AccountsPayableType' }
      & Pick<AccountsPayableType, 'id' | 'amountByn' | 'amountForeign' | 'repaid'>
    )>, accountsPayable: Array<(
      { __typename?: 'AccountsPayableType' }
      & Pick<AccountsPayableType, 'id' | 'amountForeign' | 'currency'>
      & { startedAgreement: (
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id' | 'agreementTitle'>
      ) }
    )> }
  )> }
);

export type MetaStudentsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
}>;


export type MetaStudentsQuery = (
  { __typename?: 'Query' }
  & { metaStudents?: Maybe<(
    { __typename?: 'MetaStudents' }
    & Pick<MetaStudents, 'totalCount' | 'agreementsCount'>
  )> }
);

export type CheckUserExistQueryVariables = Exact<{
  email: Scalars['String'];
  phone: Scalars['String'];
}>;


export type CheckUserExistQuery = (
  { __typename?: 'Query' }
  & { verifyStudent?: Maybe<(
    { __typename?: 'VerifiedStudent' }
    & Pick<VerifiedStudent, 'message' | 'code'>
    & { student?: Maybe<(
      { __typename?: 'StudentType' }
      & Pick<StudentType, 'id'>
      & { user?: Maybe<(
        { __typename?: 'CustomUserType' }
        & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'middleName' | 'phone' | 'email' | 'roles'>
      )> }
    )>, user?: Maybe<(
      { __typename?: 'CustomUserType' }
      & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'middleName' | 'phone' | 'email' | 'roles'>
    )>, customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>> }
  )> }
);

export type LoadLessonsOptionsQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type LoadLessonsOptionsQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'GroupType' }
    & Pick<GroupType, 'id'>
    & { lessons?: Maybe<Array<(
      { __typename?: 'GroupLessonType' }
      & Pick<GroupLessonType, 'id' | 'name' | 'date' | 'lessonNumber'>
    )>> }
  )> }
);

export type AccountsPayablesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountsPayablesQuery = (
  { __typename?: 'Query' }
  & { student?: Maybe<(
    { __typename?: 'StudentType' }
    & Pick<StudentType, 'id'>
    & { accountsPayables?: Maybe<Array<Maybe<(
      { __typename?: 'AccountsPayableType' }
      & Pick<AccountsPayableType, 'id' | 'amountForeign' | 'currency' | 'repaid'>
      & { startedAgreement: (
        { __typename?: 'AgreementType' }
        & Pick<AgreementType, 'id' | 'agreementTitle'>
      ) }
    )>>> }
  )> }
);

export type StudentLmsBlockQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type StudentLmsBlockQuery = (
  { __typename?: 'Query' }
  & { studentAccessBlock?: Maybe<(
    { __typename?: 'StudentAccessBlockType' }
    & Pick<StudentAccessBlockType, 'id' | 'isBlocked' | 'reason' | 'overdueInvoiceCount' | 'maxOverdueDays' | 'source' | 'blockedAt' | 'blockedByName' | 'unblockedAt' | 'unblockedByName'>
    & { blockingInvoices: Array<(
      { __typename?: 'LmsBlockInvoiceType' }
      & Pick<LmsBlockInvoiceType, 'invoiceId' | 'fakturowniaId' | 'number' | 'amount' | 'gross' | 'currency' | 'paymentTo' | 'daysOverdue' | 'paymentUrl' | 'viewUrl' | 'isPaid'>
    )>, amountsDue: Array<(
      { __typename?: 'LmsAmountDueType' }
      & Pick<LmsAmountDueType, 'amount' | 'currency'>
    )> }
  )> }
);

export type StudentLmsBlockHistoryQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type StudentLmsBlockHistoryQuery = (
  { __typename?: 'Query' }
  & { studentAccessBlockEvents: Array<(
    { __typename?: 'LmsBlockEventType' }
    & Pick<LmsBlockEventType, 'id' | 'action' | 'source' | 'actorName' | 'createdAt' | 'reason' | 'notifyStudent'>
    & { invoices: Array<(
      { __typename?: 'LmsBlockInvoiceType' }
      & Pick<LmsBlockInvoiceType, 'invoiceId' | 'number' | 'amount' | 'currency' | 'paymentTo' | 'daysOverdue' | 'viewUrl'>
    )>, amountsDue: Array<(
      { __typename?: 'LmsAmountDueType' }
      & Pick<LmsAmountDueType, 'amount' | 'currency'>
    )>, notifications: Array<(
      { __typename?: 'LmsBlockNotificationType' }
      & Pick<LmsBlockNotificationType, 'id' | 'channel' | 'kind' | 'status' | 'skipReason' | 'error' | 'sentAt' | 'createdAt'>
    )> }
  )> }
);

export type LmsSuspensionsPageQueryVariables = Exact<{
  status?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type LmsSuspensionsPageQuery = (
  { __typename?: 'Query' }
  & { lmsSuspensions: (
    { __typename?: 'LmsSuspensionPageType' }
    & Pick<LmsSuspensionPageType, 'total'>
    & { items: Array<(
      { __typename?: 'LmsSuspensionRowType' }
      & Pick<LmsSuspensionRowType, 'status' | 'studentId' | 'studentName' | 'studentEmail' | 'source' | 'reason' | 'blockedAt' | 'blockedByName' | 'restoredAt' | 'restoredByName' | 'restoredSource' | 'skipReason'>
      & { groups: Array<(
        { __typename?: 'LmsSuspensionGroupType' }
        & Pick<LmsSuspensionGroupType, 'id' | 'name'>
      )>, invoices: Array<(
        { __typename?: 'LmsBlockInvoiceType' }
        & Pick<LmsBlockInvoiceType, 'invoiceId' | 'fakturowniaId' | 'number' | 'amount' | 'gross' | 'currency' | 'paymentTo' | 'daysOverdue' | 'paymentUrl' | 'viewUrl' | 'isPaid'>
      )>, amountsDue: Array<(
        { __typename?: 'LmsAmountDueType' }
        & Pick<LmsAmountDueType, 'amount' | 'currency'>
      )>, notifications: Array<(
        { __typename?: 'LmsBlockNotificationType' }
        & Pick<LmsBlockNotificationType, 'id' | 'channel' | 'kind' | 'status' | 'skipReason' | 'error' | 'sentAt' | 'createdAt'>
      )> }
    )> }
  ) }
);

export type LmsBlockRobotLatestRunQueryVariables = Exact<{ [key: string]: never; }>;


export type LmsBlockRobotLatestRunQuery = (
  { __typename?: 'Query' }
  & { lmsBlockRobotLastRun?: Maybe<(
    { __typename?: 'LmsBlockRunType' }
    & Pick<LmsBlockRunType, 'id' | 'taskName' | 'status' | 'triggerSource' | 'startedAt' | 'finishedAt' | 'stats' | 'errorMessage'>
  )> }
);

export type DebtorCandidatesListQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
}>;


export type DebtorCandidatesListQuery = (
  { __typename?: 'Query' }
  & { debtorCandidates: Array<(
    { __typename?: 'DebtorCandidateType' }
    & Pick<DebtorCandidateType, 'overdueInvoiceCount' | 'maxOverdueDays' | 'currentlyBlocked'>
    & { student: (
      { __typename?: 'StudentType' }
      & Pick<StudentType, 'id'>
      & { user?: Maybe<(
        { __typename?: 'CustomUserType' }
        & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'middleName' | 'email'>
      )> }
    ), overdueAmounts: Array<(
      { __typename?: 'LmsAmountDueType' }
      & Pick<LmsAmountDueType, 'amount' | 'currency'>
    )> }
  )> }
);

export type StudentNotesListQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type StudentNotesListQuery = (
  { __typename?: 'Query' }
  & { studentNotes: Array<(
    { __typename?: 'StudentNoteType' }
    & Pick<StudentNoteType, 'id' | 'body' | 'sentiment' | 'pinned' | 'createdAt' | 'authorName'>
  )> }
);

export type GroupNotesListQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupNotesListQuery = (
  { __typename?: 'Query' }
  & { groupNotes: Array<(
    { __typename?: 'StudentNoteType' }
    & Pick<StudentNoteType, 'id' | 'body' | 'sentiment' | 'pinned' | 'createdAt' | 'authorName'>
  )> }
);

export type StudentTasksListQueryVariables = Exact<{
  studentId: Scalars['ID'];
  includeClosed?: Maybe<Scalars['Boolean']>;
}>;


export type StudentTasksListQuery = (
  { __typename?: 'Query' }
  & { studentTasks: Array<(
    { __typename?: 'StaffTaskType' }
    & Pick<StaffTaskType, 'id' | 'title' | 'description' | 'status' | 'priority' | 'dueDate' | 'completedAt' | 'createdAt' | 'assigneeName'>
    & { links: Array<(
      { __typename?: 'TaskLinkType' }
      & Pick<TaskLinkType, 'id' | 'kind' | 'objectId' | 'name' | 'hint' | 'missing' | 'href'>
    )> }
  )> }
);

export type GroupTasksListQueryVariables = Exact<{
  groupId: Scalars['ID'];
  includeClosed?: Maybe<Scalars['Boolean']>;
}>;


export type GroupTasksListQuery = (
  { __typename?: 'Query' }
  & { groupTasks: Array<(
    { __typename?: 'StaffTaskType' }
    & Pick<StaffTaskType, 'id' | 'title' | 'description' | 'status' | 'priority' | 'dueDate' | 'completedAt' | 'createdAt' | 'assigneeName'>
    & { links: Array<(
      { __typename?: 'TaskLinkType' }
      & Pick<TaskLinkType, 'id' | 'kind' | 'objectId' | 'name' | 'hint' | 'missing' | 'href'>
    )> }
  )> }
);

export type AgreementTasksListQueryVariables = Exact<{
  agreementId: Scalars['ID'];
  includeClosed?: Maybe<Scalars['Boolean']>;
}>;


export type AgreementTasksListQuery = (
  { __typename?: 'Query' }
  & { agreementTasks: Array<(
    { __typename?: 'StaffTaskType' }
    & Pick<StaffTaskType, 'id' | 'title' | 'description' | 'status' | 'priority' | 'dueDate' | 'completedAt' | 'createdAt' | 'assigneeName'>
    & { links: Array<(
      { __typename?: 'TaskLinkType' }
      & Pick<TaskLinkType, 'id' | 'kind' | 'objectId' | 'name' | 'hint' | 'missing' | 'href'>
    )> }
  )> }
);

export type MyTasksListQueryVariables = Exact<{
  includeClosed?: Maybe<Scalars['Boolean']>;
}>;


export type MyTasksListQuery = (
  { __typename?: 'Query' }
  & { myTasks: Array<(
    { __typename?: 'StaffTaskType' }
    & Pick<StaffTaskType, 'id' | 'title' | 'status' | 'priority' | 'dueDate' | 'assigneeName'>
    & { links: Array<(
      { __typename?: 'TaskLinkType' }
      & Pick<TaskLinkType, 'id' | 'kind' | 'objectId' | 'name' | 'hint' | 'missing' | 'href'>
    )> }
  )> }
);

export type StaffTasksSummaryQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
  assigneeMe?: Maybe<Scalars['Boolean']>;
  assigneeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
}>;


export type StaffTasksSummaryQuery = (
  { __typename?: 'Query' }
  & { staffTasksSummary: (
    { __typename?: 'StaffTasksSummaryType' }
    & Pick<StaffTasksSummaryType, 'openCount' | 'overdueCount' | 'todayCount'>
  ) }
);

export type StaffTasksListQueryVariables = Exact<{
  groupId?: Maybe<Scalars['ID']>;
  studentId?: Maybe<Scalars['ID']>;
  agreementId?: Maybe<Scalars['ID']>;
  teacherId?: Maybe<Scalars['ID']>;
  assigneeMe?: Maybe<Scalars['Boolean']>;
  assigneeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  statuses?: Maybe<Array<Maybe<Scalars['String']>>>;
  priorities?: Maybe<Array<Maybe<Scalars['String']>>>;
  dueFrom?: Maybe<Scalars['Date']>;
  dueTo?: Maybe<Scalars['Date']>;
  search?: Maybe<Scalars['String']>;
  includeClosed?: Maybe<Scalars['Boolean']>;
  closedWithinDays?: Maybe<Scalars['Int']>;
  links?: Maybe<Array<Maybe<TaskLinkInput>>>;
}>;


export type StaffTasksListQuery = (
  { __typename?: 'Query' }
  & { staffTasks: Array<(
    { __typename?: 'StaffTaskType' }
    & Pick<StaffTaskType, 'id' | 'title' | 'description' | 'status' | 'priority' | 'startDate' | 'dueDate' | 'position' | 'fromMessage' | 'completedAt' | 'createdAt' | 'updatedAt' | 'assigneeId' | 'assigneeName' | 'createdByName' | 'commentsCount' | 'attachmentsCount' | 'coverAttachmentId'>
    & { links: Array<(
      { __typename?: 'TaskLinkType' }
      & Pick<TaskLinkType, 'id' | 'kind' | 'objectId' | 'name' | 'hint' | 'missing' | 'href'>
    )> }
  )> }
);

export type TaskLinkKindsListQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskLinkKindsListQuery = (
  { __typename?: 'Query' }
  & { taskLinkKinds: Array<(
    { __typename?: 'TaskLinkKindType' }
    & Pick<TaskLinkKindType, 'key' | 'label'>
  )> }
);

export type TaskLinkSearchListQueryVariables = Exact<{
  kind: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type TaskLinkSearchListQuery = (
  { __typename?: 'Query' }
  & { taskLinkSearch: Array<(
    { __typename?: 'TaskLinkType' }
    & Pick<TaskLinkType, 'objectId' | 'name' | 'hint'>
  )> }
);

export type TaskDetailsCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TaskDetailsCardQuery = (
  { __typename?: 'Query' }
  & { staffTask?: Maybe<(
    { __typename?: 'StaffTaskType' }
    & Pick<StaffTaskType, 'id' | 'attachmentsCount'>
    & { comments: Array<(
      { __typename?: 'StaffTaskCommentType' }
      & Pick<StaffTaskCommentType, 'id' | 'body' | 'authorName' | 'createdAt' | 'editedAt' | 'canEdit'>
      & { attachments: Array<(
        { __typename?: 'StaffTaskAttachmentType' }
        & Pick<StaffTaskAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'isImage' | 'commentId' | 'uploadedByName' | 'createdAt' | 'canDelete'>
      )> }
    )>, links: Array<(
      { __typename?: 'TaskLinkType' }
      & Pick<TaskLinkType, 'id' | 'kind' | 'objectId' | 'name' | 'hint' | 'missing' | 'href' | 'createdByName' | 'createdAt'>
    )>, attachments: Array<(
      { __typename?: 'StaffTaskAttachmentType' }
      & Pick<StaffTaskAttachmentType, 'id' | 'originalName' | 'contentType' | 'sizeBytes' | 'isImage' | 'commentId' | 'uploadedByName' | 'createdAt' | 'canDelete'>
    )> }
  )> }
);

export type TaskAttachmentLinkQueryVariables = Exact<{
  attachmentId: Scalars['ID'];
}>;


export type TaskAttachmentLinkQuery = (
  { __typename?: 'Query' }
  & { staffTaskAttachmentUrl?: Maybe<(
    { __typename?: 'TaskAttachmentUrlType' }
    & Pick<TaskAttachmentUrlType, 'url' | 'expiresAt' | 'originalName'>
  )> }
);

export type TaskAttachmentRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskAttachmentRulesQuery = (
  { __typename?: 'Query' }
  & { taskAttachmentLimits: (
    { __typename?: 'TaskAttachmentLimitsType' }
    & Pick<TaskAttachmentLimitsType, 'maxBytes' | 'maxPerTask' | 'allowedExtensions' | 'acceptAttribute'>
  ) }
);

export type StaffUsersListQueryVariables = Exact<{ [key: string]: never; }>;


export type StaffUsersListQuery = (
  { __typename?: 'Query' }
  & { staffUsers: Array<(
    { __typename?: 'StaffUserType' }
    & Pick<StaffUserType, 'id' | 'name' | 'email'>
  )> }
);

export type StudentMiniCardViewQueryVariables = Exact<{
  studentId: Scalars['ID'];
}>;


export type StudentMiniCardViewQuery = (
  { __typename?: 'Query' }
  & { studentMiniCard?: Maybe<(
    { __typename?: 'StudentMiniCard' }
    & Pick<StudentMiniCard, 'studentId' | 'firstName' | 'lastName' | 'middleName' | 'email' | 'phone' | 'isLmsBlocked' | 'openTasksCount' | 'notesCount'>
    & { groups: Array<(
      { __typename?: 'StudentMiniCardGroupRow' }
      & Pick<StudentMiniCardGroupRow, 'agreementId' | 'agreementTitle' | 'groupId' | 'groupName' | 'courseName' | 'status' | 'terminatedDate' | 'freeOfCharge' | 'statePrefinanced' | 'paymentByCompany'>
    )>, finance?: Maybe<(
      { __typename?: 'StudentMiniCardFinance' }
      & Pick<StudentMiniCardFinance, 'isDebtor' | 'overdueInvoiceCount' | 'maxOverdueDays' | 'overdueSince' | 'isBlocked' | 'blockReason'>
      & { overdueAmounts: Array<(
        { __typename?: 'LmsAmountDueType' }
        & Pick<LmsAmountDueType, 'amount' | 'currency'>
      )>, totals: (
        { __typename?: 'StudentTotals' }
        & { byCurrency: Array<(
          { __typename?: 'StudentTotalsRow' }
          & Pick<StudentTotalsRow, 'currency' | 'totalBudget' | 'totalPaid' | 'totalDebt' | 'totalUpcoming'>
        )> }
      ) }
    )>, recentTasks: Array<(
      { __typename?: 'StaffTaskType' }
      & Pick<StaffTaskType, 'id' | 'title' | 'status' | 'priority' | 'dueDate' | 'assigneeName'>
    )>, recentNotes: Array<(
      { __typename?: 'StudentNoteType' }
      & Pick<StudentNoteType, 'id' | 'body' | 'sentiment' | 'pinned' | 'createdAt' | 'authorName'>
    )>, surveys?: Maybe<(
      { __typename?: 'StudentMiniCardSurveys' }
      & Pick<StudentMiniCardSurveys, 'respondedCount' | 'pendingCount' | 'avgScore' | 'negativeCount' | 'lastSubmittedAt'>
      & { recentSignals: Array<(
        { __typename?: 'StudentMiniCardSurveySignal' }
        & Pick<StudentMiniCardSurveySignal, 'responseId' | 'surveyTitle' | 'groupName' | 'lessonNumber' | 'teacherName' | 'submittedAt' | 'score' | 'sentiment' | 'excerpt'>
      )> }
    )> }
  )> }
);

export type StudentSlackWorkspacesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StudentSlackWorkspacesQuery = (
  { __typename?: 'Query' }
  & { student?: Maybe<(
    { __typename?: 'StudentType' }
    & Pick<StudentType, 'id'>
    & { slackWorkspaces: Array<(
      { __typename?: 'StudentSlackWorkspaceType' }
      & Pick<StudentSlackWorkspaceType, 'groupId' | 'groupName' | 'teamId' | 'workspaceName' | 'workspaceUrl' | 'slackUserId' | 'displayName' | 'agreementTerminated' | 'openWorkspaceUrl' | 'profileUrl' | 'appProfileUrl' | 'adminUrl'>
    )> }
  )> }
);

export type TaskSmartLinksQueryVariables = Exact<{
  text: Scalars['String'];
}>;


export type TaskSmartLinksQuery = (
  { __typename?: 'Query' }
  & { taskSmartLinks: Array<(
    { __typename?: 'TaskSmartLinkType' }
    & Pick<TaskSmartLinkType, 'kind' | 'id' | 'label' | 'hint' | 'reason' | 'confident'>
  )> }
);

export type TaskImageUrlsQueryVariables = Exact<{
  attachmentIds: Array<Scalars['ID']>;
}>;


export type TaskImageUrlsQuery = (
  { __typename?: 'Query' }
  & { staffTaskImageUrls: Array<(
    { __typename?: 'TaskImageUrlType' }
    & Pick<TaskImageUrlType, 'id' | 'url' | 'expiresAt'>
  )> }
);

export type ErpSurveysListQueryVariables = Exact<{
  courseId?: Maybe<Scalars['ID']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpSurveysListQuery = (
  { __typename?: 'Query' }
  & { surveys: Array<(
    { __typename?: 'SurveyType' }
    & Pick<SurveyType, 'id' | 'title' | 'courseId' | 'courseName' | 'defaultLessonNumber' | 'isArchived' | 'hasResponses' | 'questionsCount' | 'assignmentsCount' | 'groupNames' | 'updatedAt'>
  )> }
);

export type ErpSurveyDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ErpSurveyDetailQuery = (
  { __typename?: 'Query' }
  & { survey?: Maybe<(
    { __typename?: 'SurveyType' }
    & Pick<SurveyType, 'id' | 'title' | 'description' | 'courseId' | 'courseName' | 'defaultLessonNumber' | 'isArchived' | 'hasResponses'>
    & { questions: Array<(
      { __typename?: 'SurveyQuestionType' }
      & Pick<SurveyQuestionType, 'id' | 'number' | 'text' | 'questionType' | 'metric' | 'required' | 'options'>
    )> }
  )> }
);

export type ErpGroupSurveyAssignmentsQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type ErpGroupSurveyAssignmentsQuery = (
  { __typename?: 'Query' }
  & { groupSurveyAssignments: Array<(
    { __typename?: 'SurveyAssignmentType' }
    & Pick<SurveyAssignmentType, 'id' | 'surveyId' | 'surveyTitle' | 'lessonId' | 'lessonName' | 'lessonNumber' | 'lessonDate' | 'isActive' | 'origin' | 'planId' | 'respondedCount' | 'eligibleCount'>
  )> }
);

export type ErpSurveyTargetingQueryVariables = Exact<{
  surveyId: Scalars['ID'];
}>;


export type ErpSurveyTargetingQuery = (
  { __typename?: 'Query' }
  & { surveyTargeting?: Maybe<(
    { __typename?: 'SurveyTargetingType' }
    & { plans: Array<(
      { __typename?: 'SurveyPlanType' }
      & Pick<SurveyPlanType, 'id' | 'scope' | 'courseId' | 'courseName' | 'onlyActiveGroups' | 'triggerKind' | 'triggerLessonNumber' | 'skipPastLessons' | 'isActive' | 'assignmentsCount' | 'respondedCount' | 'hasResponses'>
      & { groups: Array<(
        { __typename?: 'SurveyPlanGroupRefType' }
        & Pick<SurveyPlanGroupRefType, 'groupId' | 'groupName'>
      )> }
    )> }
  )> }
);

export type ErpSurveyTargetGroupsQueryVariables = Exact<{
  surveyId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
  onlyActive?: Maybe<Scalars['Boolean']>;
  triggerKind?: Maybe<Scalars['String']>;
  triggerLessonNumber?: Maybe<Scalars['Int']>;
}>;


export type ErpSurveyTargetGroupsQuery = (
  { __typename?: 'Query' }
  & { surveyTargetGroups: Array<(
    { __typename?: 'SurveyTargetGroupType' }
    & Pick<SurveyTargetGroupType, 'groupId' | 'groupName' | 'courseId' | 'courseName' | 'startDate' | 'lessonsCount' | 'isActive' | 'resolvedLessonId' | 'resolvedLessonName' | 'resolvedLessonNumber' | 'resolvedLessonDate' | 'resolvedLessonIsOver' | 'skipReason' | 'alreadyAttached'>
  )> }
);

export type ErpSurveySummaryQueryVariables = Exact<{
  surveyId: Scalars['ID'];
  groupIds?: Maybe<Array<Scalars['ID']>>;
  planId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
}>;


export type ErpSurveySummaryQuery = (
  { __typename?: 'Query' }
  & { surveySummary?: Maybe<(
    { __typename?: 'SurveySummaryType' }
    & Pick<SurveySummaryType, 'assignmentsCount' | 'groupsCount' | 'respondedCount' | 'eligibleCount' | 'responseRate'>
    & { survey: (
      { __typename?: 'SurveyType' }
      & Pick<SurveyType, 'id' | 'title' | 'courseName'>
    ), questionResults: Array<(
      { __typename?: 'SurveyQuestionResultType' }
      & Pick<SurveyQuestionResultType, 'answersCount' | 'average'>
      & { question: (
        { __typename?: 'SurveyQuestionType' }
        & Pick<SurveyQuestionType, 'id' | 'number' | 'text' | 'questionType' | 'metric' | 'required' | 'options'>
      ), distribution: Array<(
        { __typename?: 'SurveyDistributionBucketType' }
        & Pick<SurveyDistributionBucketType, 'key' | 'label' | 'count'>
      )> }
    )>, groupBreakdown: Array<(
      { __typename?: 'SurveyGroupBreakdownType' }
      & Pick<SurveyGroupBreakdownType, 'assignmentId' | 'groupId' | 'groupName' | 'lessonName' | 'lessonNumber' | 'lessonDate' | 'isActive' | 'origin' | 'respondedCount' | 'eligibleCount' | 'responseRate' | 'averageRating'>
    )> }
  )> }
);

export type ErpTeacherSurveyFeedbackQueryVariables = Exact<{
  teacherId: Scalars['ID'];
  courseId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  bucket?: Maybe<Scalars['String']>;
}>;


export type ErpTeacherSurveyFeedbackQuery = (
  { __typename?: 'Query' }
  & { teacherSurveyFeedback?: Maybe<(
    { __typename?: 'TeacherSurveyFeedbackReportType' }
    & Pick<TeacherSurveyFeedbackReportType, 'teacherId' | 'teacherName' | 'average' | 'ratingsCount' | 'commentsCount'>
    & { trend: Array<(
      { __typename?: 'TeacherRatingPointType' }
      & Pick<TeacherRatingPointType, 'period' | 'average' | 'count'>
    )>, byCourse: Array<(
      { __typename?: 'TeacherRatingBucketType' }
      & Pick<TeacherRatingBucketType, 'id' | 'name' | 'average' | 'count'>
    )>, byGroup: Array<(
      { __typename?: 'TeacherRatingBucketType' }
      & Pick<TeacherRatingBucketType, 'id' | 'name' | 'average' | 'count'>
    )>, comments: Array<(
      { __typename?: 'TeacherStudentCommentType' }
      & Pick<TeacherStudentCommentType, 'studentName' | 'comment' | 'createdAt' | 'courseName' | 'groupName'>
    )> }
  )> }
);

export type ErpTeacherSurveyLeaderboardQueryVariables = Exact<{
  courseId?: Maybe<Scalars['ID']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  minResponses?: Maybe<Scalars['Int']>;
}>;


export type ErpTeacherSurveyLeaderboardQuery = (
  { __typename?: 'Query' }
  & { teacherSurveyLeaderboard: Array<(
    { __typename?: 'TeacherLeaderboardRowType' }
    & Pick<TeacherLeaderboardRowType, 'teacherId' | 'teacherName' | 'average' | 'ratingsCount' | 'commentsCount' | 'coursesCount' | 'enoughData'>
  )> }
);

export type ErpSurveyAssignmentResultsQueryVariables = Exact<{
  assignmentId: Scalars['ID'];
}>;


export type ErpSurveyAssignmentResultsQuery = (
  { __typename?: 'Query' }
  & { surveyAssignmentResults?: Maybe<(
    { __typename?: 'SurveyAssignmentResultsType' }
    & { assignment: (
      { __typename?: 'SurveyAssignmentType' }
      & Pick<SurveyAssignmentType, 'id' | 'surveyTitle' | 'groupId' | 'groupName' | 'lessonName' | 'lessonNumber' | 'respondedCount' | 'eligibleCount'>
    ), respondents: Array<(
      { __typename?: 'SurveyRespondentStatusType' }
      & Pick<SurveyRespondentStatusType, 'studentId' | 'fullName' | 'email' | 'responded' | 'submittedAt' | 'responseId'>
    )>, questionResults: Array<(
      { __typename?: 'SurveyQuestionResultType' }
      & Pick<SurveyQuestionResultType, 'answersCount' | 'average'>
      & { question: (
        { __typename?: 'SurveyQuestionType' }
        & Pick<SurveyQuestionType, 'id' | 'number' | 'text' | 'questionType' | 'metric' | 'required' | 'options'>
      ), distribution: Array<(
        { __typename?: 'SurveyDistributionBucketType' }
        & Pick<SurveyDistributionBucketType, 'key' | 'label' | 'count'>
      )> }
    )> }
  )> }
);

export type ErpSurveyResponseDetailQueryVariables = Exact<{
  responseId: Scalars['ID'];
}>;


export type ErpSurveyResponseDetailQuery = (
  { __typename?: 'Query' }
  & { surveyResponseDetail?: Maybe<(
    { __typename?: 'SurveyResponseDetailType' }
    & Pick<SurveyResponseDetailType, 'responseId' | 'studentId' | 'fullName' | 'submittedAt'>
    & { answers: Array<(
      { __typename?: 'SurveyAnswerViewType' }
      & Pick<SurveyAnswerViewType, 'questionId' | 'value'>
    )> }
  )> }
);

export type ErpSurveyAnalyticsQueryVariables = Exact<{
  dimension: Scalars['String'];
  filter?: Maybe<SurveyAnalyticsFilter>;
}>;


export type ErpSurveyAnalyticsQuery = (
  { __typename?: 'Query' }
  & { surveyAnalytics: Array<(
    { __typename?: 'SurveyAnalyticsRowType' }
    & Pick<SurveyAnalyticsRowType, 'key' | 'label' | 'sortKey' | 'assignmentsCount' | 'surveysCount' | 'responsesCount' | 'studentsCount' | 'answersCount' | 'eligibleCount' | 'responseRate' | 'avgScore' | 'negativeShare' | 'avgRating' | 'avgNps' | 'avgTeacherRating' | 'yesShare' | 'lowAnswersShare'>
  )> }
);

export type ErpSurveySignalsQueryVariables = Exact<{
  dimensions?: Maybe<Array<Scalars['String']>>;
  minSample?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  filter?: Maybe<SurveyAnalyticsFilter>;
}>;


export type ErpSurveySignalsQuery = (
  { __typename?: 'Query' }
  & { surveySignals: Array<(
    { __typename?: 'SurveySignalType' }
    & Pick<SurveySignalType, 'kind' | 'dimension' | 'key' | 'label' | 'value' | 'previousValue' | 'delta' | 'sampleSize' | 'severity'>
  )> }
);

export type ErpSurveyQuestionBreakdownQueryVariables = Exact<{
  surveyId: Scalars['ID'];
  questionId: Scalars['ID'];
  dimension: Scalars['String'];
  filter?: Maybe<SurveyAnalyticsFilter>;
}>;


export type ErpSurveyQuestionBreakdownQuery = (
  { __typename?: 'Query' }
  & { surveyQuestionBreakdown?: Maybe<(
    { __typename?: 'SurveyQuestionBreakdownType' }
    & Pick<SurveyQuestionBreakdownType, 'dimension'>
    & { question: (
      { __typename?: 'SurveyQuestionType' }
      & Pick<SurveyQuestionType, 'id' | 'number' | 'text' | 'questionType' | 'metric' | 'required' | 'options'>
    ), total: (
      { __typename?: 'SurveyQuestionResultType' }
      & Pick<SurveyQuestionResultType, 'answersCount' | 'average'>
      & { distribution: Array<(
        { __typename?: 'SurveyDistributionBucketType' }
        & Pick<SurveyDistributionBucketType, 'key' | 'label' | 'count'>
      )> }
    ), slices: Array<(
      { __typename?: 'SurveyQuestionSliceType' }
      & Pick<SurveyQuestionSliceType, 'key' | 'label' | 'sortKey' | 'responsesCount'>
      & { result: (
        { __typename?: 'SurveyQuestionResultType' }
        & Pick<SurveyQuestionResultType, 'answersCount' | 'average'>
        & { distribution: Array<(
          { __typename?: 'SurveyDistributionBucketType' }
          & Pick<SurveyDistributionBucketType, 'key' | 'label' | 'count'>
        )> }
      ) }
    )> }
  )> }
);

export type ErpSurveyCommentsQueryVariables = Exact<{
  filter?: Maybe<SurveyAnalyticsFilter>;
  search?: Maybe<Scalars['String']>;
  sentiment?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  problemOnly?: Maybe<Scalars['Boolean']>;
}>;


export type ErpSurveyCommentsQuery = (
  { __typename?: 'Query' }
  & { surveyComments: (
    { __typename?: 'SurveyCommentPageType' }
    & Pick<SurveyCommentPageType, 'hasNext' | 'cursor'>
    & { items: Array<(
      { __typename?: 'SurveyCommentType' }
      & Pick<SurveyCommentType, 'answerId' | 'responseId' | 'questionId' | 'questionText' | 'metric' | 'text' | 'studentId' | 'studentName' | 'groupId' | 'groupName' | 'courseName' | 'surveyId' | 'surveyTitle' | 'lessonNumber' | 'lessonDate' | 'teacherId' | 'teacherName' | 'submittedAt' | 'score' | 'sentiment'>
      & { insight?: Maybe<(
        { __typename?: 'SurveyAnswerInsightType' }
        & Pick<SurveyAnswerInsightType, 'lang' | 'textRu' | 'textPl' | 'sentiment' | 'isProblem' | 'topic' | 'summary'>
      )> }
    )> }
  ) }
);

export type ErpSurveyAssignmentsQueryVariables = Exact<{
  surveyId: Scalars['ID'];
  groupIds?: Maybe<Array<Scalars['ID']>>;
  planId?: Maybe<Scalars['ID']>;
  onlyActive?: Maybe<Scalars['Boolean']>;
  origin?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpSurveyAssignmentsQuery = (
  { __typename?: 'Query' }
  & { surveyAssignments: Array<(
    { __typename?: 'SurveyGroupBreakdownType' }
    & Pick<SurveyGroupBreakdownType, 'assignmentId' | 'surveyId' | 'surveyTitle' | 'groupId' | 'groupName' | 'courseId' | 'courseName' | 'lessonId' | 'lessonName' | 'lessonNumber' | 'lessonDate' | 'teacherId' | 'teacherName' | 'isActive' | 'origin' | 'planId' | 'createdAt' | 'respondedCount' | 'eligibleCount' | 'responseRate' | 'averageRating' | 'avgScore' | 'negativeShare'>
  )> }
);

export type ErpStudentSurveyResponsesQueryVariables = Exact<{
  studentId: Scalars['ID'];
  surveyId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  includePending?: Maybe<Scalars['Boolean']>;
}>;


export type ErpStudentSurveyResponsesQuery = (
  { __typename?: 'Query' }
  & { studentSurveyResponses?: Maybe<(
    { __typename?: 'StudentSurveyHistoryType' }
    & Pick<StudentSurveyHistoryType, 'studentId' | 'fullName' | 'respondedCount' | 'pendingCount' | 'avgScore' | 'negativeCount'>
    & { responses: Array<(
      { __typename?: 'StudentSurveyResponseRowType' }
      & Pick<StudentSurveyResponseRowType, 'responseId' | 'assignmentId' | 'surveyId' | 'surveyTitle' | 'groupId' | 'groupName' | 'courseName' | 'lessonId' | 'lessonName' | 'lessonNumber' | 'lessonDate' | 'teacherId' | 'teacherName' | 'submittedAt' | 'score' | 'minScore' | 'scoredAnswersCount' | 'sentiment' | 'excerpt'>
      & { questions: Array<(
        { __typename?: 'SurveyQuestionType' }
        & Pick<SurveyQuestionType, 'id' | 'number' | 'text' | 'questionType' | 'metric' | 'required' | 'options'>
      )>, answers: Array<(
        { __typename?: 'SurveyAnswerViewType' }
        & Pick<SurveyAnswerViewType, 'questionId' | 'value'>
      )> }
    )>, pending: Array<(
      { __typename?: 'StudentSurveyPendingRowType' }
      & Pick<StudentSurveyPendingRowType, 'assignmentId' | 'surveyId' | 'surveyTitle' | 'groupId' | 'groupName' | 'lessonId' | 'lessonName' | 'lessonNumber' | 'lessonDate' | 'teacherName'>
    )> }
  )> }
);

export type ErpSurveyQuestionTagsQueryVariables = Exact<{
  onlyUntagged?: Maybe<Scalars['Boolean']>;
  courseId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpSurveyQuestionTagsQuery = (
  { __typename?: 'Query' }
  & { surveyQuestionTags: Array<(
    { __typename?: 'SurveyQuestionTagRowType' }
    & Pick<SurveyQuestionTagRowType, 'questionId' | 'surveyId' | 'surveyTitle' | 'courseName' | 'number' | 'text' | 'questionType' | 'metric' | 'suggestedMetric'>
  )> }
);

export type ErpSurveyUntaggedCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpSurveyUntaggedCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'surveyUntaggedCount'>
);

export type ErpSurveyResponseMatrixQueryVariables = Exact<{
  surveyId: Scalars['ID'];
  groupIds?: Maybe<Array<Scalars['ID']>>;
}>;


export type ErpSurveyResponseMatrixQuery = (
  { __typename?: 'Query' }
  & { surveyResponseMatrix?: Maybe<(
    { __typename?: 'SurveyResponseMatrixType' }
    & { survey: (
      { __typename?: 'SurveyType' }
      & Pick<SurveyType, 'id' | 'title'>
    ), questions: Array<(
      { __typename?: 'SurveyQuestionType' }
      & Pick<SurveyQuestionType, 'id' | 'number' | 'text' | 'questionType' | 'metric' | 'required' | 'options'>
    )>, rows: Array<(
      { __typename?: 'SurveyMatrixRowType' }
      & Pick<SurveyMatrixRowType, 'responseId' | 'studentId' | 'fullName' | 'groupId' | 'groupName' | 'lessonNumber' | 'submittedAt' | 'score' | 'sentiment'>
      & { answers: Array<(
        { __typename?: 'SurveyMatrixAnswerType' }
        & Pick<SurveyMatrixAnswerType, 'questionId' | 'value'>
      )> }
    )> }
  )> }
);

export type ErpSurveyGroupHistoryQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type ErpSurveyGroupHistoryQuery = (
  { __typename?: 'Query' }
  & { surveyGroupTimeline?: Maybe<(
    { __typename?: 'SurveyGroupTimelineType' }
    & { rows: Array<(
      { __typename?: 'SurveyTimelineRowType' }
      & Pick<SurveyTimelineRowType, 'assignmentId' | 'surveyId' | 'surveyTitle' | 'lessonNumber' | 'lessonDate' | 'eligible' | 'responded' | 'avgScore' | 'negativeShare' | 'avgRating' | 'avgNps'>
    )>, metrics: Array<(
      { __typename?: 'SurveyMetricRowType' }
      & Pick<SurveyMetricRowType, 'metric' | 'avgScore' | 'answers'>
    )> }
  )> }
);

export type ErpSurveyGroupStudentsQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type ErpSurveyGroupStudentsQuery = (
  { __typename?: 'Query' }
  & { surveyGroupStudents: Array<(
    { __typename?: 'SurveyGroupStudentRowType' }
    & Pick<SurveyGroupStudentRowType, 'studentId' | 'studentName' | 'eligible' | 'responded' | 'avgScore' | 'negativeCount' | 'lastAnsweredAt' | 'lastComment' | 'lastCommentAt'>
    & { lastCommentInsight?: Maybe<(
      { __typename?: 'SurveyAnswerInsightType' }
      & Pick<SurveyAnswerInsightType, 'lang' | 'textRu' | 'textPl' | 'sentiment' | 'isProblem' | 'topic' | 'summary'>
    )> }
  )> }
);

export type ErpSurveyDigestListQueryVariables = Exact<{
  scope: Scalars['String'];
  scopeId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
}>;


export type ErpSurveyDigestListQuery = (
  { __typename?: 'Query' }
  & { surveyDigests: Array<(
    { __typename?: 'SurveyDigestType' }
    & Pick<SurveyDigestType, 'id' | 'scope' | 'scopeId' | 'status' | 'textRu' | 'textPl' | 'model' | 'error' | 'createdAt' | 'finishedAt' | 'byName'>
  )> }
);

export type ErpTeacherAiProfileQueryVariables = Exact<{
  teacherId: Scalars['ID'];
}>;


export type ErpTeacherAiProfileQuery = (
  { __typename?: 'Query' }
  & { teacherAiProfile?: Maybe<(
    { __typename?: 'TeacherAiProfileType' }
    & Pick<TeacherAiProfileType, 'teacherId' | 'status' | 'yearsExperienceTotal' | 'yearsExperienceTeaching' | 'communicationScore' | 'teachingScore' | 'strengths' | 'redFlags' | 'suspicious' | 'suspicionNotes' | 'aiModel' | 'promptVersion' | 'errorMessage' | 'analyzedAt'>
    & { summary: Array<(
      { __typename?: 'AiSourceTextType' }
      & Pick<AiSourceTextType, 'sourceKind' | 'text'>
    )>, communication: Array<(
      { __typename?: 'AiSourceTextType' }
      & Pick<AiSourceTextType, 'sourceKind' | 'text'>
    )>, teachingExperience: Array<(
      { __typename?: 'AiSourceTextType' }
      & Pick<AiSourceTextType, 'sourceKind' | 'text'>
    )>, skills: Array<(
      { __typename?: 'AiSkillType' }
      & Pick<AiSkillType, 'name' | 'category' | 'claimedLevel' | 'assessedLevel' | 'evidence' | 'sourceKinds'>
    )>, languages: Array<(
      { __typename?: 'AiLanguageType' }
      & Pick<AiLanguageType, 'language' | 'level' | 'basis'>
    )>, provenance: Array<(
      { __typename?: 'AiFieldProvenanceType' }
      & Pick<AiFieldProvenanceType, 'field' | 'runId' | 'sourceKind'>
    )>, suggestions: Array<(
      { __typename?: 'TeacherCourseSuggestionType' }
      & Pick<TeacherCourseSuggestionType, 'id' | 'courseId' | 'courseName' | 'confidence' | 'rationale' | 'sourceKind' | 'status' | 'decidedByName' | 'decidedAt' | 'alreadyQualified'>
    )>, runs: Array<(
      { __typename?: 'TeacherAiRunType' }
      & Pick<TeacherAiRunType, 'id' | 'sourceKind' | 'status' | 'interviewId' | 'aiModel' | 'promptVersion' | 'errorMessage' | 'droppedCourseIds' | 'createdAt' | 'analyzedAt'>
    )> }
  )> }
);

export type TeacherBillingEntitiesListQueryVariables = Exact<{
  teacherId: Scalars['ID'];
  includeInactive?: Maybe<Scalars['Boolean']>;
}>;


export type TeacherBillingEntitiesListQuery = (
  { __typename?: 'Query' }
  & { teacherBillingEntities: Array<(
    { __typename?: 'TeacherBillingEntityType' }
    & Pick<TeacherBillingEntityType, 'id' | 'teacherId' | 'kind' | 'legalName' | 'nip' | 'vatMode' | 'vatRate' | 'isDefault' | 'isActive' | 'createdAt' | 'updatedAt'>
  )> }
);

export type GroupTeacherTermsQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GroupTeacherTermsQuery = (
  { __typename?: 'Query' }
  & { groupTeacherApplications: Array<(
    { __typename?: 'ApplicationType' }
    & Pick<ApplicationType, 'id' | 'title' | 'date' | 'lessonsCount' | 'servicePrice' | 'currency' | 'isTerminated' | 'rateUnit' | 'rateIsGross' | 'termsMissing'>
    & { teacher: (
      { __typename?: 'TeacherFilterType' }
      & Pick<TeacherFilterType, 'id' | 'fullName'>
    ), billingEntity?: Maybe<(
      { __typename?: 'TeacherBillingEntityType' }
      & Pick<TeacherBillingEntityType, 'id' | 'teacherId' | 'kind' | 'legalName' | 'nip' | 'vatMode' | 'vatRate' | 'isDefault' | 'isActive' | 'createdAt' | 'updatedAt'>
    )> }
  )> }
);

export type ErpTeacherDocumentsQueryVariables = Exact<{
  teacherId: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
}>;


export type ErpTeacherDocumentsQuery = (
  { __typename?: 'Query' }
  & { teacherDocuments: Array<(
    { __typename?: 'TeacherDocumentType' }
    & Pick<TeacherDocumentType, 'id' | 'teacherId' | 'kind' | 'version' | 'originalName' | 'contentType' | 'sizeBytes' | 'extractionStatus' | 'hasText' | 'textChars' | 'isCurrent' | 'uploadedAt' | 'uploadedByName'>
  )> }
);

export type ErpTeacherDocumentTextQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type ErpTeacherDocumentTextQuery = (
  { __typename?: 'Query' }
  & { teacherDocumentText?: Maybe<(
    { __typename?: 'TeacherDocumentTextType' }
    & Pick<TeacherDocumentTextType, 'documentId' | 'extractionStatus' | 'text'>
  )> }
);

export type ErpTeacherDocumentDownloadUrlQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type ErpTeacherDocumentDownloadUrlQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'teacherDocumentDownloadUrl'>
);

export type ErpTeacherInterviewsQueryVariables = Exact<{
  teacherId: Scalars['ID'];
}>;


export type ErpTeacherInterviewsQuery = (
  { __typename?: 'Query' }
  & { teacherInterviews: Array<(
    { __typename?: 'TeacherInterviewType' }
    & Pick<TeacherInterviewType, 'id' | 'teacherId' | 'source' | 'title' | 'recordedAt' | 'durationMinutes' | 'status' | 'errorMessage' | 'retryCount' | 'externalUrl' | 'hasVideo' | 'sizeBytes' | 'hasTranscript' | 'transcriptSource' | 'transcriptChars' | 'zoomRecordingId' | 'zoomTopic' | 'zoomAccountEmail' | 'createdAt' | 'createdByName'>
  )> }
);

export type ErpTeacherInterviewTranscriptQueryVariables = Exact<{
  interviewId: Scalars['ID'];
}>;


export type ErpTeacherInterviewTranscriptQuery = (
  { __typename?: 'Query' }
  & { teacherInterviewTranscript?: Maybe<(
    { __typename?: 'TeacherInterviewTranscriptType' }
    & Pick<TeacherInterviewTranscriptType, 'interviewId' | 'transcriptSource' | 'text'>
  )> }
);

export type ErpTeacherInterviewVideoUrlQueryVariables = Exact<{
  interviewId: Scalars['ID'];
}>;


export type ErpTeacherInterviewVideoUrlQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'teacherInterviewVideoUrl'>
);

export type ErpInterviewZoomCandidatesQueryVariables = Exact<{
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  accountId?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ErpInterviewZoomCandidatesQuery = (
  { __typename?: 'Query' }
  & { interviewZoomCandidates: Array<(
    { __typename?: 'InterviewZoomCandidateType' }
    & Pick<InterviewZoomCandidateType, 'id' | 'topic' | 'startTime' | 'durationMinutes' | 'totalSizeBytes' | 'accountId' | 'accountEmail' | 'hasVideo' | 'hasTranscript' | 'isAlreadyAttached' | 'retentionWarning'>
  )> }
);

export type ErpInterviewZoomDefaultAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type ErpInterviewZoomDefaultAccountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'interviewZoomDefaultAccountId'>
);

export type AllTeachersQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  course?: Maybe<Scalars['Decimal']>;
  minRating?: Maybe<Scalars['Decimal']>;
  availability?: Maybe<Scalars['String']>;
}>;


export type AllTeachersQuery = (
  { __typename?: 'Query' }
  & { allTeachers?: Maybe<(
    { __typename?: 'TeacherFilterTypeConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'TeacherFilterTypeEdge' }
      & { node?: Maybe<(
        { __typename?: 'TeacherType' }
        & Pick<TeacherType, 'id' | 'accessToLms' | 'fullName' | 'isDismissed' | 'rating' | 'availability' | 'courses'>
        & { user: (
          { __typename?: 'CustomUserType' }
          & Pick<CustomUserType, 'id' | 'phone' | 'email'>
        ) }
      )> }
    )>> }
  )> }
);

export type VerifyTeacherQueryVariables = Exact<{
  firstName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
}>;


export type VerifyTeacherQuery = (
  { __typename?: 'Query' }
  & { verifyTeacher?: Maybe<(
    { __typename?: 'VerifiedTeacher' }
    & Pick<VerifiedTeacher, 'code'>
    & { customErrors?: Maybe<Array<Maybe<(
      { __typename?: 'CustomErrorType' }
      & Pick<CustomErrorType, 'field' | 'message' | 'code'>
    )>>>, user?: Maybe<(
      { __typename?: 'CustomUserType' }
      & Pick<CustomUserType, 'id' | 'firstName' | 'middleName' | 'lastName' | 'phone' | 'email' | 'roles'>
    )>, teacher?: Maybe<(
      { __typename?: 'TeacherType' }
      & Pick<TeacherType, 'id'>
      & { user: (
        { __typename?: 'CustomUserType' }
        & Pick<CustomUserType, 'id' | 'firstName' | 'middleName' | 'lastName' | 'phone' | 'email'>
      ) }
    )> }
  )> }
);

export type GetTeacherDataQueryVariables = Exact<{
  teacherId?: Maybe<Scalars['ID']>;
}>;


export type GetTeacherDataQuery = (
  { __typename?: 'Query' }
  & { teacher?: Maybe<(
    { __typename?: 'TeacherType' }
    & { employmentTypes?: Maybe<Array<Maybe<{ __typename: 'IndividualEntrepreneurType' } | { __typename: 'LegalEntityType' } | { __typename: 'SelfEmployedType' } | { __typename: 'NaturalPersonType' }>>> }
  )> }
);

export type GetTeacherTypesQueryVariables = Exact<{
  teacherId: Scalars['ID'];
}>;


export type GetTeacherTypesQuery = (
  { __typename?: 'Query' }
  & { teacher?: Maybe<(
    { __typename?: 'TeacherType' }
    & { employmentTypes?: Maybe<Array<Maybe<(
      { __typename: 'IndividualEntrepreneurType' }
      & Pick<IndividualEntrepreneurType, 'id' | 'registrationAddress' | 'accountNumber' | 'bankTitle' | 'bic' | 'inn'>
    ) | (
      { __typename: 'LegalEntityType' }
      & Pick<LegalEntityType, 'id' | 'registrationAddress' | 'accountNumber' | 'bankTitle' | 'bic' | 'tittle' | 'inn'>
    ) | (
      { __typename: 'SelfEmployedType' }
      & Pick<SelfEmployedType, 'id' | 'registrationAddress' | 'accountNumber' | 'bankTitle' | 'bic' | 'passportNumber' | 'inn'>
      & { nationality: (
        { __typename?: 'CountryType' }
        & Pick<CountryType, 'id' | 'title'>
      ) }
    ) | (
      { __typename: 'NaturalPersonType' }
      & Pick<NaturalPersonType, 'id' | 'registrationAddress' | 'accountNumber' | 'bankTitle' | 'bic' | 'passportNumber'>
      & { nationality: (
        { __typename?: 'CountryType' }
        & Pick<CountryType, 'id' | 'title'>
      ) }
    )>>> }
  )> }
);

export type GetEditTeacherQueryVariables = Exact<{
  teacherId: Scalars['ID'];
}>;


export type GetEditTeacherQuery = (
  { __typename?: 'Query' }
  & { teacher?: Maybe<(
    { __typename?: 'TeacherType' }
    & Pick<TeacherType, 'id' | 'accessToLms' | 'siteDisplay'>
    & { user: (
      { __typename?: 'CustomUserType' }
      & Pick<CustomUserType, 'id' | 'firstName' | 'lastName' | 'middleName' | 'email' | 'phone'>
    ), employmentTypes?: Maybe<Array<Maybe<(
      { __typename: 'IndividualEntrepreneurType' }
      & Pick<IndividualEntrepreneurType, 'id' | 'registrationAddress' | 'accountNumber' | 'bankTitle' | 'bic' | 'inn'>
    ) | (
      { __typename: 'LegalEntityType' }
      & Pick<LegalEntityType, 'id' | 'registrationAddress' | 'accountNumber' | 'bankTitle' | 'bic' | 'tittle' | 'inn'>
    ) | (
      { __typename: 'SelfEmployedType' }
      & Pick<SelfEmployedType, 'id' | 'registrationAddress' | 'accountNumber' | 'bankTitle' | 'bic' | 'passportNumber' | 'inn'>
      & { nationality: (
        { __typename?: 'CountryType' }
        & Pick<CountryType, 'id' | 'title'>
      ) }
    ) | (
      { __typename: 'NaturalPersonType' }
      & Pick<NaturalPersonType, 'id' | 'registrationAddress' | 'accountNumber' | 'bankTitle' | 'bic' | 'passportNumber'>
      & { nationality: (
        { __typename?: 'CountryType' }
        & Pick<CountryType, 'id' | 'title'>
      ) }
    )>>> }
  )> }
);

export type ErpTeacherLoadQueryVariables = Exact<{
  teacherId: Scalars['ID'];
  horizonDays?: Maybe<Scalars['Int']>;
}>;


export type ErpTeacherLoadQuery = (
  { __typename?: 'Query' }
  & { teacherLoad?: Maybe<(
    { __typename?: 'TeacherLoadType' }
    & Pick<TeacherLoadType, 'activeGroups' | 'activeApplications' | 'nextLessonDate' | 'lessonsNext30Days' | 'hoursNext30Days' | 'hoursPerWeek' | 'loadBand' | 'horizonDays'>
    & { weeks: Array<(
      { __typename?: 'TeacherLoadWeekType' }
      & Pick<TeacherLoadWeekType, 'weekStart' | 'lessons' | 'minutes' | 'groups'>
    )>, applications: Array<(
      { __typename?: 'TeacherLoadApplicationType' }
      & Pick<TeacherLoadApplicationType, 'applicationId' | 'title' | 'groupId' | 'groupName' | 'contractedLessons' | 'scheduledLessons' | 'unscheduledLessons' | 'remainingLessons' | 'lastLessonDate'>
    )> }
  )> }
);

export type ErpTeacherCandidateGroupsQueryVariables = Exact<{
  teacherId: Scalars['ID'];
}>;


export type ErpTeacherCandidateGroupsQuery = (
  { __typename?: 'Query' }
  & { teacherCandidateGroups: Array<(
    { __typename?: 'TeacherCandidateGroupType' }
    & Pick<TeacherCandidateGroupType, 'groupId' | 'groupName' | 'courseId' | 'courseName' | 'startDate' | 'openLessons' | 'nextOpenDate'>
  )> }
);

export type TeachersMetaQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
}>;


export type TeachersMetaQuery = (
  { __typename?: 'Query' }
  & { metaTeachers?: Maybe<(
    { __typename?: 'MetaTeachers' }
    & Pick<MetaTeachers, 'totalCount' | 'applicationsCount'>
  )> }
);

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetUserByIdQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'UserNode' }
    & Pick<UserNode, 'pk' | 'firstName' | 'middleName' | 'lastName' | 'email' | 'phone' | 'roles'>
    & { workspaceMailbox?: Maybe<(
      { __typename?: 'StaffMailboxType' }
      & Pick<StaffMailboxType, 'email' | 'enabled'>
    )> }
  )> }
);

export type FindUserDataQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
}>;


export type FindUserDataQuery = (
  { __typename?: 'Query' }
  & { users?: Maybe<(
    { __typename?: 'UserNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'UserNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'UserNode' }
        & Pick<UserNode, 'pk' | 'roles' | 'email' | 'phone' | 'firstName' | 'lastName' | 'middleName'>
        & { student?: Maybe<(
          { __typename?: 'StudentType' }
          & Pick<StudentType, 'id'>
        )> }
      )> }
    )>> }
  )> }
);

export type PaginatedUsersSettingsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type PaginatedUsersSettingsQuery = (
  { __typename?: 'Query' }
  & { allUsersSettings?: Maybe<(
    { __typename?: 'UsersSettingsConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'UsersSettingsEdge' }
      & Pick<UsersSettingsEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'UserNode' }
        & { workspaceMailbox?: Maybe<(
          { __typename?: 'StaffMailboxType' }
          & Pick<StaffMailboxType, 'email' | 'displayName' | 'enabled' | 'scope'>
        )> }
        & UserFieldsFragment
      )> }
    )>> }
  )> }
);

export type MyWorkspaceProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyWorkspaceProfileQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'UserNode' }
    & Pick<UserNode, 'id' | 'pk' | 'firstName' | 'lastName' | 'email' | 'roles'>
    & { workspaceMailbox?: Maybe<(
      { __typename?: 'StaffMailboxType' }
      & Pick<StaffMailboxType, 'email' | 'displayName' | 'enabled' | 'scope'>
    )> }
  )>, staffMailboxSettings: (
    { __typename?: 'StaffMailboxSettingsType' }
    & Pick<StaffMailboxSettingsType, 'domains'>
  ) }
);

export type StaffMailboxDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type StaffMailboxDomainsQuery = (
  { __typename?: 'Query' }
  & { staffMailboxSettings: (
    { __typename?: 'StaffMailboxSettingsType' }
    & Pick<StaffMailboxSettingsType, 'domains'>
  ) }
);

export type GetLessonWhiteboardErpQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type GetLessonWhiteboardErpQuery = (
  { __typename?: 'Query' }
  & { lessonWhiteboardForErp?: Maybe<(
    { __typename?: 'WhiteboardType' }
    & Pick<WhiteboardType, 'id' | 'name' | 'sceneJson' | 'sceneVersion' | 'updatedAt'>
    & { files: Array<(
      { __typename?: 'WhiteboardFileType' }
      & Pick<WhiteboardFileType, 'fileId' | 'mimeType' | 'url'>
    )>, lessons: Array<(
      { __typename?: 'WhiteboardLessonRefType' }
      & Pick<WhiteboardLessonRefType, 'lessonId' | 'lessonName' | 'lessonNumber' | 'lessonDate'>
    )> }
  )> }
);

export type LessonHeaderForWhiteboardQueryVariables = Exact<{
  groupLessonId: Scalars['ID'];
}>;


export type LessonHeaderForWhiteboardQuery = (
  { __typename?: 'Query' }
  & { zoomLesson?: Maybe<(
    { __typename?: 'GroupLessonForLMSType' }
    & Pick<GroupLessonForLmsType, 'id' | 'name' | 'date' | 'startTime' | 'endTime' | 'lessonNumber' | 'whiteboardId'>
    & { module: (
      { __typename?: 'GroupModuleType' }
      & Pick<GroupModuleType, 'id'>
      & { group: (
        { __typename?: 'MethodistGroupType' }
        & Pick<MethodistGroupType, 'id' | 'name'>
      ) }
    ) }
  )> }
);

export type ZoomDashboardQueryVariables = Exact<{
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
}>;


export type ZoomDashboardQuery = (
  { __typename?: 'Query' }
  & { zoomDashboard?: Maybe<(
    { __typename?: 'ZoomDashboardType' }
    & Pick<ZoomDashboardType, 'dateFrom' | 'dateTo' | 'lessonsTotal' | 'lessonsMatched' | 'lessonsMissing' | 'lessonsSkipped' | 'recordingsTotal' | 'recordingsOrphan'>
    & { pipeline?: Maybe<(
      { __typename?: 'ZoomDashboardPipelineCounts' }
      & Pick<ZoomDashboardPipelineCounts, 'downloading' | 'uploaded' | 'aiProcessing' | 'aiCompleted' | 'published' | 'failed'>
    )> }
  )> }
);

export type AllZoomLessonsQueryVariables = Exact<{
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  groupId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type AllZoomLessonsQuery = (
  { __typename?: 'Query' }
  & { allZoomLessons?: Maybe<(
    { __typename?: 'ZoomLessonConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'ZoomLessonEdge' }
      & Pick<ZoomLessonEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'GroupLessonForLMSType' }
        & ZoomLessonFieldsFragment
      )> }
    )>> }
  )> }
);

export type LessonRecordingByLessonQueryVariables = Exact<{
  groupLessonId: Scalars['ID'];
}>;


export type LessonRecordingByLessonQuery = (
  { __typename?: 'Query' }
  & { zoomLesson?: Maybe<(
    { __typename?: 'GroupLessonForLMSType' }
    & { zoomRecordingMeta?: Maybe<(
      { __typename?: 'LessonRecordingType' }
      & LessonRecordingFieldsFragment
    )> }
    & GroupLessonForZoomFieldsFragment
  )> }
);

export type AllZoomRecordingsQueryVariables = Exact<{
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  accountId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  orphanOnly?: Maybe<Scalars['Boolean']>;
  tooShort?: Maybe<Scalars['Boolean']>;
  showDeleted?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type AllZoomRecordingsQuery = (
  { __typename?: 'Query' }
  & { allZoomRecordings?: Maybe<(
    { __typename?: 'ZoomRecordingConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'ZoomRecordingEdge' }
      & Pick<ZoomRecordingEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ZoomRecordingType' }
        & { lessonRecordings?: Maybe<Array<Maybe<(
          { __typename?: 'LessonRecordingType' }
          & Pick<LessonRecordingType, 'id' | 'status'>
          & { lesson?: Maybe<(
            { __typename?: 'GroupLessonForLMSType' }
            & Pick<GroupLessonForLmsType, 'id' | 'name'>
            & { module: (
              { __typename?: 'GroupModuleType' }
              & { group: (
                { __typename?: 'MethodistGroupType' }
                & Pick<MethodistGroupType, 'id' | 'name'>
              ) }
            ) }
          )> }
        )>>> }
        & ZoomRecordingFieldsFragment
      )> }
    )>> }
  )> }
);

export type RecentlyMatchedQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  mine?: Maybe<Scalars['Boolean']>;
}>;


export type RecentlyMatchedQuery = (
  { __typename?: 'Query' }
  & { recentlyMatchedLessonRecordings?: Maybe<Array<Maybe<(
    { __typename?: 'LessonRecordingType' }
    & LessonRecordingFieldsFragment
  )>>> }
);

export type ZoomAccountUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type ZoomAccountUsageQuery = (
  { __typename?: 'Query' }
  & { zoomAccountUsage?: Maybe<(
    { __typename?: 'ZoomAccountUsageType' }
    & ZoomAccountUsageFieldsFragment
  )> }
);

export type ZoomTooShortCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ZoomTooShortCountQuery = (
  { __typename?: 'Query' }
  & { allZoomRecordings?: Maybe<(
    { __typename?: 'ZoomRecordingConnection' }
    & Pick<ZoomRecordingConnection, 'totalCount'>
  )> }
);

export type AllZoomAccountsQueryVariables = Exact<{
  isActive?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type AllZoomAccountsQuery = (
  { __typename?: 'Query' }
  & { allZoomAccounts?: Maybe<(
    { __typename?: 'ZoomAccountConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ZoomAccountEdge' }
      & { node?: Maybe<(
        { __typename?: 'ZoomAccountType' }
        & ZoomAccountFieldsFragment
      )> }
    )>> }
  )> }
);

export type ZoomAssignedGroupsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
}>;


export type ZoomAssignedGroupsQuery = (
  { __typename?: 'Query' }
  & { allGroups?: Maybe<(
    { __typename?: 'GroupConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'GroupEdge' }
      & { node?: Maybe<(
        { __typename?: 'GroupType' }
        & Pick<GroupType, 'id' | 'name' | 'startDate'>
        & { zoomAccount?: Maybe<(
          { __typename?: 'ZoomAccountType' }
          & Pick<ZoomAccountType, 'id' | 'displayName'>
        )> }
      )> }
    )>> }
  )> }
);

export type ZoomUnassignedGroupsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type ZoomUnassignedGroupsQuery = (
  { __typename?: 'Query' }
  & { allGroups?: Maybe<(
    { __typename?: 'GroupConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'GroupEdge' }
      & { node?: Maybe<(
        { __typename?: 'GroupType' }
        & Pick<GroupType, 'id' | 'name' | 'startDate'>
      )> }
    )>> }
  )> }
);

export type AllGroupZoomSchedulesQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
}>;


export type AllGroupZoomSchedulesQuery = (
  { __typename?: 'Query' }
  & { allGroupZoomSchedules?: Maybe<(
    { __typename?: 'GroupZoomScheduleConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'GroupZoomScheduleEdge' }
      & { node?: Maybe<(
        { __typename?: 'GroupZoomScheduleType' }
        & GroupZoomScheduleFieldsFragment
      )> }
    )>> }
  )> }
);

export type AllZoomProcessingLogQueryVariables = Exact<{
  lessonId?: Maybe<Scalars['ID']>;
  level?: Maybe<Scalars['String']>;
  step?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type AllZoomProcessingLogQuery = (
  { __typename?: 'Query' }
  & { allZoomProcessingLog?: Maybe<(
    { __typename?: 'ZoomProcessingLogConnection' }
    & Pick<ZoomProcessingLogConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'ZoomProcessingLogEdge' }
      & { node?: Maybe<(
        { __typename?: 'ZoomProcessingLogType' }
        & ZoomProcessingLogFieldsFragment
      )> }
    )>> }
  )> }
);

export type ZoomAuditLogQueryVariables = Exact<{
  action?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  targetKind?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type ZoomAuditLogQuery = (
  { __typename?: 'Query' }
  & { zoomAuditLog?: Maybe<(
    { __typename?: 'ZoomAuditLogConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'ZoomAuditLogEdge' }
      & Pick<ZoomAuditLogEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ZoomAuditLogType' }
        & ZoomAuditEntryFieldsFragment
      )> }
    )>> }
  )> }
);

export type ZoomParticipantsCoverageListQueryVariables = Exact<{
  groupId: Scalars['ID'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
}>;


export type ZoomParticipantsCoverageListQuery = (
  { __typename?: 'Query' }
  & { zoomParticipantsCoverage: Array<(
    { __typename?: 'ZoomLessonCoverageType' }
    & Pick<ZoomLessonCoverageType, 'lessonId' | 'lessonName' | 'date' | 'startsAt' | 'endsAt' | 'additional' | 'status' | 'rule' | 'sessionsCount' | 'matchedCount' | 'unmatchedCount' | 'suggestedCount' | 'staffCount' | 'ignoredCount'>
    & { instances: Array<(
      { __typename?: 'ZoomMeetingInstanceType' }
      & Pick<ZoomMeetingInstanceType, 'id' | 'uuid' | 'meetingId' | 'topic' | 'startTime' | 'endTime' | 'durationMinutes' | 'participantsCount' | 'lessonId' | 'lessonRule' | 'lessonAmbiguous' | 'lessonLocked' | 'participantsStatus' | 'participantsFetchedAt' | 'participantsError'>
    )>, candidateInstances: Array<(
      { __typename?: 'ZoomMeetingInstanceType' }
      & Pick<ZoomMeetingInstanceType, 'id' | 'uuid' | 'meetingId' | 'topic' | 'startTime' | 'endTime' | 'durationMinutes' | 'participantsCount' | 'lessonId' | 'lessonRule' | 'lessonAmbiguous' | 'lessonLocked' | 'participantsStatus' | 'participantsFetchedAt' | 'participantsError'>
    )> }
  )> }
);

export type ZoomLessonParticipantListQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type ZoomLessonParticipantListQuery = (
  { __typename?: 'Query' }
  & { zoomLessonParticipants: Array<(
    { __typename?: 'ZoomParticipantSessionType' }
    & Pick<ZoomParticipantSessionType, 'id' | 'instanceId' | 'name' | 'email' | 'joinTime' | 'leaveTime' | 'durationSeconds' | 'status' | 'failover' | 'identityKey' | 'matchStatus' | 'matchRule' | 'offRoster' | 'matchedUserId' | 'matchedUserName' | 'matchedStudentId' | 'matchedByName' | 'matchedAt'>
  )> }
);

export type ZoomLessonRosterListQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type ZoomLessonRosterListQuery = (
  { __typename?: 'Query' }
  & { zoomLessonRoster: Array<(
    { __typename?: 'ZoomRosterPersonType' }
    & Pick<ZoomRosterPersonType, 'userId' | 'studentId' | 'fullName'>
  )> }
);

export const AttentionProbeFragmentDoc = gql`
    fragment AttentionProbe on FundingCandidateType {
  id
  needsAttention
  attentionNote
}
    `;
export const ErpAiKbCandidateFieldsFragmentDoc = gql`
    fragment ErpAiKbCandidateFields on AiKbCandidateType {
  id
  kind
  category
  claim
  question
  targetDocumentId
  targetDocumentTitle
  targetHeading
  conflictRefs
  conflicts {
    ref
    documentId
    title
    headingPath
    text
  }
  evidence {
    source
    ref
    at
    conversationId
    messageId
    callId
    suggestionId
    groupId
    studentId
    excerpt
  }
  supportCount
  confidence
  status
  duplicateOfId
  rejectReason
  reviewedByName
  reviewedAt
  appliedRevisionVersion
  createdAt
  updatedAt
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on UserNode {
  id
  username
  isActive
  firstName
  middleName
  lastName
  email
  roles
  verified
  isStaff
  dateJoined
  pk
  archived
  secondaryEmail
  lastLogin
  phone
}
    `;
export const LeadUtmFieldsFragmentDoc = gql`
    fragment LeadUtmFields on LeadUtmType {
  source
  medium
  campaign
  content
  term
  referrer
  formName
  tracking
}
    `;
export const PersonKommoLeadFieldsFragmentDoc = gql`
    fragment PersonKommoLeadFields on PersonKommoLeadType {
  id
  kommoId
  name
  stageName
  stageColor
  responsibleName
  isClosed
  createdAt
  utm {
    ...LeadUtmFields
  }
  linkRule
  kommoUrl
}
    ${LeadUtmFieldsFragmentDoc}`;
export const KommoStageFieldsFragmentDoc = gql`
    fragment KommoStageFields on KommoStageType {
  id
  name
  color
  sort
  isClosed
}
    `;
export const LeadUserLinkFieldsFragmentDoc = gql`
    fragment LeadUserLinkFields on LeadUserLinkType {
  userId
  name
  email
  studentId
}
    `;
export const KommoLeadRowFieldsFragmentDoc = gql`
    fragment KommoLeadRowFields on KommoLeadType {
  id
  kommoId
  name
  personName
  stage {
    ...KommoStageFields
  }
  isClosed
  inPipeline
  isDeleted
  responsibleName
  responsibleUserId
  responsibleUserName
  firstName
  lastName
  phone
  email
  phones
  emails
  kommoUrl
  createdAt
  updatedAt
  closedAt
  syncedAt
  lastSmsAt
  smsCount
  ladders {
    kind
    status
  }
  utm {
    ...LeadUtmFields
  }
  fundingCandidate {
    id
    name
    status
    isArchived
  }
  candidateRule
  linkedUser {
    ...LeadUserLinkFields
  }
  userRule
  aploraWinChance
  aploraCategory
  aploraTemperature
  aploraNextContactDate
  aploraLearnScore
  aploraConsent
}
    ${KommoStageFieldsFragmentDoc}
${LeadUtmFieldsFragmentDoc}
${LeadUserLinkFieldsFragmentDoc}`;
export const KommoLeadCardFieldsFragmentDoc = gql`
    fragment KommoLeadCardFields on KommoLeadType {
  ...KommoLeadRowFields
  contracts {
    id
    number
    status
    kind
    createdAt
    signingLadder {
      state
      available
      reason
      autoReminders
      nextStepAt
      nextStepReason
      sentAt
      canManage
      handlerName
    }
  }
  fundingCandidates {
    id
    name
    status
    createdAt
    formForeign
  }
  candidateConflict
  userConflict
  fundingCandidate {
    id
    name
    status
    isArchived
    operators {
      id
      name
      isPrimary
    }
    intakeId
    intakeStartsOn
    intakeEndsOn
    lastSubmissionAt
    createdAt
  }
  candidateLocked
  userLocked
  userOptions {
    ...LeadUserLinkFields
  }
  ladderReadiness {
    kind
    warning
    firstSms
    firstSmsSegments
  }
}
    ${KommoLeadRowFieldsFragmentDoc}
${LeadUserLinkFieldsFragmentDoc}`;
export const KommoNoteFieldsFragmentDoc = gql`
    fragment KommoNoteFields on KommoNoteType {
  id
  noteType
  text
  duration
  createdAt
  authorName
  fromErp
  erpStatus
}
    `;
export const SmsMessageFieldsFragmentDoc = gql`
    fragment SmsMessageFields on SmsMessageType {
  id
  topic
  step
  status
  skipReason
  error
  body
  phoneMasked
  segments
  encoding
  cost
  dlrStatus
  deliveredAt
  sentAt
  scheduledFor
  createdAt
  createdByName
  studentId
  studentName
  teacherId
  teacherName
  signerName
  leadId
  leadName
  candidateId
  candidateName
  subjectKind
  subjectId
  subjectLabel
  campaignId
  shortLinkId
  shortLinkUrl
  targetUrl
  humanClicks
  clicks
  canRetry
  canCancel
}
    `;
export const LeadSmsStateFieldsFragmentDoc = gql`
    fragment LeadSmsStateFields on LeadSmsStateType {
  available
  reason
  phoneMasked
  messages {
    ...SmsMessageFields
  }
}
    ${SmsMessageFieldsFragmentDoc}`;
export const LeadLadderRunFieldsFragmentDoc = gql`
    fragment LeadLadderRunFields on LeadLadderRunType {
  id
  kind
  topic
  status
  startedAt
  startedByName
  days
  endsAt
  stoppedAt
  stoppedByName
  finishedAt
  finishReason
  submissionAt
  warning
  nextStepAt
  sent
  linkClicks
}
    `;
export const LeadConversationFieldsFragmentDoc = gql`
    fragment LeadConversationFields on ConversationType {
  id
  kind
  title
  displayTitle
  externalId
  mailboxEmail
  unreadCount
  unhandledCount
  status
  hasUnhandled
  lastMessageAt
}
    `;
export const KommoUserFieldsFragmentDoc = gql`
    fragment KommoUserFields on KommoUserType {
  id
  kommoId
  name
  email
  isActive
  erpUserId
  erpUserName
  matchSource
  locked
  leadsCount
}
    `;
export const KommoSyncStatusFieldsFragmentDoc = gql`
    fragment KommoSyncStatusFields on KommoSyncStatusType {
  source
  syncEnabled
  notesEnabled
  lastIncrementalAt
  lastFullAt
  lastStatus
  lastError
  leads
  unmappedResponsibles
  notesPending
  notesFailed
  runs {
    id
    full
    triggerSource
    startedByName
    status
    created
    updated
    error
    startedAt
    finishedAt
  }
}
    `;
export const KommoLeadBoardFieldsFragmentDoc = gql`
    fragment KommoLeadBoardFields on KommoLeadType {
  ...KommoLeadRowFields
  price
  courseRaw
  stageEnteredAt
  responsibleId
  contracts {
    id
    status
  }
}
    ${KommoLeadRowFieldsFragmentDoc}`;
export const KommoLeadMovedFieldsFragmentDoc = gql`
    fragment KommoLeadMovedFields on KommoLeadType {
  ...KommoLeadRowFields
  price
  courseRaw
  stageEnteredAt
  responsibleId
}
    ${KommoLeadRowFieldsFragmentDoc}`;
export const EsignContractCardFieldsFragmentDoc = gql`
    fragment EsignContractCardFields on ContractDocumentType {
  id
  uuid
  kind
  number
  status
  fulfilmentStatus
  fulfilmentError
  fulfilmentCandidates {
    id
    name
    isStudentHere
  }
  cancelConflict
  textPending
  signerFirstName
  signerLastName
  signerEmail
  signerPhone
  groupId
  groupName
  courseName
  paymentPlan {
    id
    code
    name
    installments
    firstDueKind
    firstDueDays
    marksStatePrefinanced
  }
  currency
  listPrice
  price
  schedule {
    n
    amount
    rule
    ruleKind
    ruleParams
  }
  company {
    name
    taxId
    regon
    address
    paymentModel
    invoiceTo
    pricePerPerson
    totalPrice
    participants {
      firstName
      lastName
      email
      phone
    }
  }
  teacherId
  applicationId
  applicationTitle
  studentId
  agreementId
  teacherAgreementId
  existingUserId
  createdById
  createdByName
  templateId
  templateCode
  templateName
  templateAppendix
  sellerId
  sellerName
  sellerLocked
  sentById
  sentByName
  canSeeCorrespondence
  canManage
  emailFrom
  inviteMailbox
  inviteMailboxKind
  inviteBlockedReason
  createdAt
  sentAt
  emailSentAt
  emailDeliveredAt
  emailOpenedAt
  emailBouncedAt
  emailSendCount
  emailError {
    code
    message
    occurredAt
  }
  openedAt
  signedAt
  completedAt
  rejectedAt
  rejectionReason
  cancelledAt
  cancelReason
  expiresAt
  sendError
  signerLegalName
  signerTaxId
  signerAddress
  signerPesel
  crmLeadId
  crmLeadUrl
  signState
  expiresInDays
  aploraWinChance
  aploraConsent
  aploraNextContactDate
  crmLead {
    id
    kommoId
    personName
    name
    isClosed
    kommoUrl
  }
  requisiteWarnings
  consents
  signerFields {
    key
    label
    value
    checked
  }
  events {
    id
    source
    event
    occurredAt
    actorName
    details
  }
}
    `;
export const EsignOutreachFieldsFragmentDoc = gql`
    fragment EsignOutreachFields on ContractOutreachType {
  available
  reason
  stopped
  autoReminders
  nextStepAt
  nextStepCondition
  nextStepReason
  state
  messages {
    id
    step
    stepLabel
    condition
    status
    skipReason
    scheduledFor
    createdAt
    sentAt
    deliveredAt
    dlrStatus
    segments
    phoneMasked
    body
    templateCode
    templateName
    templateNamePl
    createdByName
    error
  }
  link {
    clickCount
    humanClickCount
    firstHumanClickedAt
    lastClickedAt
    expiresAt
    revoked
  }
}
    `;
export const EsignMessageTemplateFieldsFragmentDoc = gql`
    fragment EsignMessageTemplateFields on MessageTemplateType {
  id
  channel
  code
  name
  namePl
  subject
  body
  isSystem
  isActive
  updatedAt
  updatedByName
  usedIn
  usedInPl
  isPersonal
  ownerId
  ownerName
  canEdit
  canDelete
}
    `;
export const EsignContractTemplateFieldsFragmentDoc = gql`
    fragment EsignContractTemplateFields on ContractTemplateType {
  id
  code
  version
  kind
  name
  language
  appendix
  description
  isActive
  origin
  createdByName
  createdAt
  comment
  basedOnId
  basedOnCode
  basedOnVersion
  hasPendingGit
  pendingGitVersion
  legalEntityId
  legalEntityName
  isGitCode
}
    `;
export const GroupJoinLinkFieldsFragmentDoc = gql`
    fragment GroupJoinLinkFields on GroupType {
  id
  lessonJoinUrl
  activeLinkOverride {
    id
    date
    joinUrl
    setVia
    setByName
    createdAt
  }
}
    `;
export const HomeworkSubmissionFieldsFragmentDoc = gql`
    fragment HomeworkSubmissionFields on HomeworkSubmissionType {
  id
  githubUrl
  fileName
  fileSizeBytes
  status
  attempt
  submittedAt
  teacherComment
  gradedAt
  gradedByName
  aiReview {
    status
    aiScore
    aiSummary
    aiJustification
    suspiciousContent
    suspicionNotes
    errorMessage
    analyzedAt
  }
}
    `;
export const MarketingMetricsFieldsFragmentDoc = gql`
    fragment MarketingMetricsFields on MarketingMetrics {
  spendPln
  spendCoveredPln
  spendCoveredThrough
  impressions
  clicks
  ctr
  cpc
  cpm
  leadsPlatform
  crmLeads
  crmLeadsRepeat
  touchesOther
  sales
  revenuePln
  cashPln
  cplPln
  costPerSalePln
  roas
  roasCash
  ratiosThrough
  cplCoveredPln
  costPerSaleCoveredPln
  roasCovered
  roasCashCovered
  contractsSent
  contractsSigned
  contractsPending
  contractsLost
  contractSignRate
  costPerContractPln
  leadToSale
  leadToContract
}
    `;
export const MarketingCompareInfoFieldsFragmentDoc = gql`
    fragment MarketingCompareInfoFields on MarketingCompareInfo {
  mode
  unit
  dateFrom
  dateTo
  aligned
  partial
  cutToDate
}
    `;
export const MarketingSourceStatusFieldsFragmentDoc = gql`
    fragment MarketingSourceStatusFields on MarketingSourceStatus {
  source
  mode
  coveredFrom
  coveredTo
  completeThrough
  lastSuccessAt
  lastError
  running
}
    `;
export const MarketingChannelRuleFieldsFragmentDoc = gql`
    fragment MarketingChannelRuleFields on MarketingChannelRuleType {
  id
  priority
  field
  match
  pattern
  channel
  subChannel
  isPaid
  active
  note
}
    `;
export const MarketingCourseAliasFieldsFragmentDoc = gql`
    fragment MarketingCourseAliasFields on MarketingCourseAliasType {
  id
  kind
  value
  courseId
  priority
}
    `;
export const MarketingOfferRuleFieldsFragmentDoc = gql`
    fragment MarketingOfferRuleFields on MarketingOfferRuleType {
  id
  priority
  field
  regex
  offer
}
    `;
export const MarketingPipelineFieldsFragmentDoc = gql`
    fragment MarketingPipelineFields on MarketingPipelineType {
  id
  kommoId
  name
  funnelKind
  funnelKindLocked
}
    `;
export const MarketingTargetFieldsFragmentDoc = gql`
    fragment MarketingTargetFields on MarketingTargetType {
  id
  month
  channel
  familySlug
  metric
  value
  note
  updatedAt
}
    `;
export const MarketingSignalFieldsFragmentDoc = gql`
    fragment MarketingSignalFields on MarketingSignalType {
  id
  kind
  severity
  status
  entityId
  entityName
  familySlug
  channel
  windowFrom
  windowTo
  metrics
  params
  firstSeen
  lastSeen
  ackBy
}
    `;
export const MarketingCampaignAliasFieldsFragmentDoc = gql`
    fragment MarketingCampaignAliasFields on MarketingCampaignAliasType {
  id
  platform
  field
  rawValue
  entityId
  entityName
  createdBy
  createdAt
}
    `;
export const MarketingSearchRowFieldsFragmentDoc = gql`
    fragment MarketingSearchRowFields on MarketingSearchRow {
  key
  key2
  host
  familySlug
  brand
  clicks
  impressions
  ctr
  position
  prevClicks
  prevImpressions
  prevPosition
}
    `;
export const MarketingPageMetricsFieldsFragmentDoc = gql`
    fragment MarketingPageMetricsFields on MarketingPageMetrics {
  ga4Sessions
  ga4Engaged
  ga4KeyEvents
  ga4Views
  gscClicks
  gscImpressions
  fpPageviews
  fpEntrances
  fpSessions
  fpVisitors
  fpFormViews
  fpFormSubmits
  crmLeadsLanding
  crmLeadsForm
  crmLeadsAssisted
  salesLanding
  salesAssisted
  landingConversion
  formConversion
  assistRate
  denominator
}
    `;
export const MarketingSeoOpportunityFieldsFragmentDoc = gql`
    fragment MarketingSeoOpportunityFields on MarketingSeoOpportunity {
  id
  kind
  status
  familySlug
  familyName
  keywordId
  keyword
  url
  params
  evidence
  score
  valuePlnEst
  isCurrent
  firstSeen
  lastSeen
  decidedBy
  decidedAt
  note
  link
}
    `;
export const MarketingSeoKeywordRowFieldsFragmentDoc = gql`
    fragment MarketingSeoKeywordRowFields on MarketingSeoKeywordRow {
  id
  keyword
  familySlug
  isBrand
  brandOf
  intent
  searchVolume
  cpc
  difficulty
  tracked
  excluded
  trackReason
  source
  position
  prevPosition
  delta
  change
  comparable
  zone
  url
  spark
  bestCompetitor
  bestCompetitorPosition
  bestCompetitorSource
  serpOrganic
  domainPosition
  gscClicks28d
  gscImpressions28d
  gscPosition28d
  hasAiOverview
  aiOverviewCitesUs
}
    `;
export const ScheduledRunFieldsFragmentDoc = gql`
    fragment ScheduledRunFields on ScheduledRunType {
  beatKey
  at
  source
  status
  error
  triggerSource
}
    `;
export const RuntimeSettingFieldsFragmentDoc = gql`
    fragment RuntimeSettingFields on RuntimeSettingType {
  key
  section
  domain
  type
  mode
  optIn
  danger
  labelRu
  labelPl
  helpRu
  helpPl
  value
  envValue
  dbValue
  hasDbValue
  source
  serverForbids
  standBlocks
  readOnly
  choices
  updatedAt
  updatedByName
  beatKeys
  lastRun {
    ...ScheduledRunFields
  }
}
    ${ScheduledRunFieldsFragmentDoc}`;
export const ShortLinkFieldsFragmentDoc = gql`
    fragment ShortLinkFields on ShortLinkType {
  id
  kind
  title
  channel
  tags
  code
  url
  targetUrl
  targetHost
  subjectKind
  subjectId
  subjectLabel
  leadId
  candidateId
  clickCount
  humanClickCount
  firstHumanClickedAt
  lastClickedAt
  expiresAt
  revokedAt
  createdAt
  createdByName
  state
  canEdit
  canRevoke
}
    `;
export const SmsPreviewFieldsFragmentDoc = gql`
    fragment SmsPreviewFields on SmsPreviewType {
  body
  encoding
  segments
  maxSegments
  tooLong
  withOptOut
  available
  reason
  message
}
    `;
export const StudentSmsStateFieldsFragmentDoc = gql`
    fragment StudentSmsStateFields on StudentSmsStateType {
  available
  reason
  phoneMasked
  messages {
    ...SmsMessageFields
  }
  invoices {
    id
    number
    amount
    currency
    dueDate
    daysOverdue
    hasPayUrl
  }
}
    ${SmsMessageFieldsFragmentDoc}`;
export const TeacherSmsStateFieldsFragmentDoc = gql`
    fragment TeacherSmsStateFields on TeacherSmsStateType {
  available
  reason
  phoneMasked
  messages {
    ...SmsMessageFields
  }
  documents {
    id
    number
    kind
    expiresAt
  }
}
    ${SmsMessageFieldsFragmentDoc}`;
export const SmsCampaignFieldsFragmentDoc = gql`
    fragment SmsCampaignFields on SmsCampaignType {
  id
  title
  body
  mode
  linkKind
  linkUrl
  groupId
  groupName
  createdAt
  createdByName
  cancelledAt
  counts {
    total
    pending
    sent
    failed
    skipped
    delivered
    retryable
    cost
    finished
  }
}
    `;
export const SmsSettingsFieldsFragmentDoc = gql`
    fragment SmsSettingsFields on SmsSettingsType {
  enabled
  remindersEnabled
  senderName
  quietStart
  quietEnd
  dailyCapPerPhone
  allowUnicode
  allowForeignNumbers
  maxSegments
  lowBalancePoints
  legalEntityIds
  updatedAt
  updatedByName
  serverSmsAllowed
  serverRemindersAllowed
  provider
  tokenConfigured
  webhookConfigured
  webhookUrlMasked
  shortlinkBaseUrl
  onlyTo
  canEdit
  optOutSuffix
  defaultOptOutSuffix
  canEditTexts
}
    `;
export const LinkAddressesFieldsFragmentDoc = gql`
    fragment LinkAddressesFields on LinkAddressesType {
  dofinFormUrl
  dofinFormUrlDefault
  dofinFormUrlSaved
  lmsBaseUrl
  lmsBaseUrlDefault
  lmsBaseUrlSaved
  lmsInvoicesUrl
  shortlinkBaseUrl
  documensoBaseUrl
  canEdit
  updatedAt
  updatedByName
}
    `;
export const SmsProviderStatusFieldsFragmentDoc = gql`
    fragment SmsProviderStatusFields on SmsProviderStatusType {
  provider
  tokenConfigured
  checkedAt
  ok
  points
  paymentType
  lowBalance
  lowBalancePoints
  senderName
  senderStatus
  senderActive
  error
  errorCode
}
    `;
export const SmsConnectionCheckFieldsFragmentDoc = gql`
    fragment SmsConnectionCheckFields on SmsConnectionCheckType {
  ok
  provider
  cost
  parts
  segments
  error
  errorCode
}
    `;
export const SmsReminderPlanFieldsFragmentDoc = gql`
    fragment SmsReminderPlanFields on ReminderPlanType {
  topic
  enabled
  canEdit
  active
  states
  anchors
  impossibleSteps
  steps {
    id
    step
    anchor
    offsetMinutes
    condition
    templateCode
    enabled
  }
  templates {
    code
    name
    namePl
    body
  }
}
    `;
export const ZoomAccountUsageFieldsFragmentDoc = gql`
    fragment ZoomAccountUsageFields on ZoomAccountUsageType {
  id
  usersCount
  recordingsCount
  filesCount
  recordingsSizeBytes
  planStorageTotalBytes
  planStorageUsedBytes
  planStorageFreeBytes
  storageUsedPercent
  planRecordingType
  planUsageAvailable
  syncedAt
}
    `;
export const GroupLessonForZoomFieldsFragmentDoc = gql`
    fragment GroupLessonForZoomFields on GroupLessonForLMSType {
  id
  name
  number
  date
  startTime
  endTime
  video
  lmsDescription
  finished
  module {
    id
    group {
      id
      name
      zoomAccount {
        id
        displayName
      }
      course {
        id
        name
      }
    }
  }
}
    `;
export const ZoomAccountFieldsFragmentDoc = gql`
    fragment ZoomAccountFields on ZoomAccountType {
  id
  zoomUserId
  email
  displayName
  isActive
  notes
  syncedAt
  createdAt
}
    `;
export const ZoomRecordingFieldsFragmentDoc = gql`
    fragment ZoomRecordingFields on ZoomRecordingType {
  id
  pk
  zoomMeetingUuid
  zoomMeetingId
  topic
  startTime
  durationMinutes
  totalSizeBytes
  files
  deletedFromZoom
  deletedAt
  syncedAt
  isOrphan
  isMatched
  isTooShort
  status
  failureReason
  zoomAccount {
    ...ZoomAccountFields
  }
}
    ${ZoomAccountFieldsFragmentDoc}`;
export const LessonRecordingFieldsFragmentDoc = gql`
    fragment LessonRecordingFields on LessonRecordingType {
  id
  status
  matchedBy
  ambiguous
  transcriptS3Key
  chatS3Key
  audioS3Key
  aiSummary
  aiTimecodes
  aiModel
  errorMessage
  retryCount
  lastAttemptAt
  canResume
  createdAt
  updatedAt
  matchedByUser {
    id
    email
    firstName
    lastName
  }
  lesson {
    ...GroupLessonForZoomFields
  }
  zoomRecording {
    ...ZoomRecordingFields
  }
}
    ${GroupLessonForZoomFieldsFragmentDoc}
${ZoomRecordingFieldsFragmentDoc}`;
export const ZoomLessonFieldsFragmentDoc = gql`
    fragment ZoomLessonFields on GroupLessonForLMSType {
  ...GroupLessonForZoomFields
  zoomRecordingMeta {
    ...LessonRecordingFields
  }
}
    ${GroupLessonForZoomFieldsFragmentDoc}
${LessonRecordingFieldsFragmentDoc}`;
export const ZoomProcessingLogFieldsFragmentDoc = gql`
    fragment ZoomProcessingLogFields on ZoomProcessingLogType {
  id
  step
  level
  message
  details
  createdAt
  lessonRecording {
    id
    status
  }
}
    `;
export const GroupZoomScheduleFieldsFragmentDoc = gql`
    fragment GroupZoomScheduleFields on GroupZoomScheduleType {
  id
  weekDay
  runTime
  isActive
  group {
    id
    name
  }
}
    `;
export const ZoomAuditEntryFieldsFragmentDoc = gql`
    fragment ZoomAuditEntryFields on ZoomAuditLogType {
  id
  action
  targetKind
  targetId
  details
  createdAt
  user {
    id
    email
    firstName
    lastName
  }
}
    `;
export const ErpVacancyFieldsFragmentDoc = gql`
    fragment ErpVacancyFields on VacancyType {
  id
  title
  companyName
  applyUrl
  location
  workMode
  seniority
  employmentType
  salaryMin
  salaryMax
  salaryCurrency
  description
  status
  publishedAt
  expiresAt
  createdAt
  directionIds
  directionTitles
  skillIds
  skillNames
  appliedCount
  source
  createdByName
  reviewedByName
  reviewedAt
  updatedAt
  duplicateOf {
    vacancyId
    title
    companyName
    status
    score
  }
}
    `;
export const DocumentFieldsFragmentDoc = gql`
    fragment DocumentFields on TeacherDocumentType {
  id
  kind
  version
  originalName
  contentType
  sizeBytes
  extractionStatus
  hasText
  textChars
  isCurrent
  uploadedAt
}
    `;
export const InterviewFieldsFragmentDoc = gql`
    fragment InterviewFields on TeacherInterviewType {
  id
  source
  title
  recordedAt
  durationMinutes
  status
  errorMessage
  externalUrl
  hasVideo
  sizeBytes
  hasTranscript
  transcriptSource
  transcriptChars
  zoomRecordingId
  zoomTopic
}
    `;
export const EsignCrmLeadFieldsFragmentDoc = gql`
    fragment EsignCrmLeadFields on CrmLeadType {
  id
  name
  statusId
  statusName
  statusColor
  updatedAt
  responsibleName
  contactId
  firstName
  lastName
  email
  phone
  url
}
    `;
export const PaymentCalendarRowFieldsFragmentDoc = gql`
    fragment PaymentCalendarRowFields on PaymentCalendarRowType {
  direction
  source
  kind
  title
  date
  amount
  currency
  amountPln
  comment
  status
  incomeState
  editable
  rateMissing
  sourceRef
  plannedPaymentId
  relatedGroupId
  relatedTeacherId
  balanceAfterPln
  toneAfter
  counterpartyName
  invoiceId
  invoiceNumber
  invoiceExternalUrl
  expenseId
  contributionId
}
    `;
export const AttentionCardProbeDocument = gql`
    query AttentionCardProbe($id: ID!) {
  fundingCandidate(id: $id) {
    id
    needsAttention
    attentionNote
    attentionSetByName
    attentionSetAt
    attentionTaskId
    isArchived
    status
    nextIntake {
      id
      startsOn
      operatorName
    }
  }
}
    `;

/**
 * __useAttentionCardProbeQuery__
 *
 * To run a query within a React component, call `useAttentionCardProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttentionCardProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttentionCardProbeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAttentionCardProbeQuery(baseOptions: Apollo.QueryHookOptions<AttentionCardProbeQuery, AttentionCardProbeQueryVariables>) {
        return Apollo.useQuery<AttentionCardProbeQuery, AttentionCardProbeQueryVariables>(AttentionCardProbeDocument, baseOptions);
      }
export function useAttentionCardProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttentionCardProbeQuery, AttentionCardProbeQueryVariables>) {
          return Apollo.useLazyQuery<AttentionCardProbeQuery, AttentionCardProbeQueryVariables>(AttentionCardProbeDocument, baseOptions);
        }
export type AttentionCardProbeQueryHookResult = ReturnType<typeof useAttentionCardProbeQuery>;
export type AttentionCardProbeLazyQueryHookResult = ReturnType<typeof useAttentionCardProbeLazyQuery>;
export type AttentionCardProbeQueryResult = Apollo.QueryResult<AttentionCardProbeQuery, AttentionCardProbeQueryVariables>;
export const InvoicesProbeDocument = gql`
    query InvoicesProbe($page: Int, $perPage: Int, $dateFrom: Date) {
  fakturowniaInvoices(page: $page, perPage: $perPage, dateFrom: $dateFrom) {
    id
  }
}
    `;

/**
 * __useInvoicesProbeQuery__
 *
 * To run a query within a React component, call `useInvoicesProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesProbeQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      dateFrom: // value for 'dateFrom'
 *   },
 * });
 */
export function useInvoicesProbeQuery(baseOptions?: Apollo.QueryHookOptions<InvoicesProbeQuery, InvoicesProbeQueryVariables>) {
        return Apollo.useQuery<InvoicesProbeQuery, InvoicesProbeQueryVariables>(InvoicesProbeDocument, baseOptions);
      }
export function useInvoicesProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesProbeQuery, InvoicesProbeQueryVariables>) {
          return Apollo.useLazyQuery<InvoicesProbeQuery, InvoicesProbeQueryVariables>(InvoicesProbeDocument, baseOptions);
        }
export type InvoicesProbeQueryHookResult = ReturnType<typeof useInvoicesProbeQuery>;
export type InvoicesProbeLazyQueryHookResult = ReturnType<typeof useInvoicesProbeLazyQuery>;
export type InvoicesProbeQueryResult = Apollo.QueryResult<InvoicesProbeQuery, InvoicesProbeQueryVariables>;
export const ExpensesProbeDocument = gql`
    query ExpensesProbe($page: Int, $perPage: Int, $recurrence: String) {
  expenses(page: $page, perPage: $perPage, recurrence: $recurrence) {
    id
  }
}
    `;

/**
 * __useExpensesProbeQuery__
 *
 * To run a query within a React component, call `useExpensesProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesProbeQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      recurrence: // value for 'recurrence'
 *   },
 * });
 */
export function useExpensesProbeQuery(baseOptions?: Apollo.QueryHookOptions<ExpensesProbeQuery, ExpensesProbeQueryVariables>) {
        return Apollo.useQuery<ExpensesProbeQuery, ExpensesProbeQueryVariables>(ExpensesProbeDocument, baseOptions);
      }
export function useExpensesProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpensesProbeQuery, ExpensesProbeQueryVariables>) {
          return Apollo.useLazyQuery<ExpensesProbeQuery, ExpensesProbeQueryVariables>(ExpensesProbeDocument, baseOptions);
        }
export type ExpensesProbeQueryHookResult = ReturnType<typeof useExpensesProbeQuery>;
export type ExpensesProbeLazyQueryHookResult = ReturnType<typeof useExpensesProbeLazyQuery>;
export type ExpensesProbeQueryResult = Apollo.QueryResult<ExpensesProbeQuery, ExpensesProbeQueryVariables>;
export const BrowserProbeDocument = gql`
    query BrowserProbe($groupId: ID, $unhandledOnly: Boolean) {
  conversationsBrowser(groupId: $groupId, unhandledOnly: $unhandledOnly) {
    totalCount
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useBrowserProbeQuery__
 *
 * To run a query within a React component, call `useBrowserProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrowserProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrowserProbeQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      unhandledOnly: // value for 'unhandledOnly'
 *   },
 * });
 */
export function useBrowserProbeQuery(baseOptions?: Apollo.QueryHookOptions<BrowserProbeQuery, BrowserProbeQueryVariables>) {
        return Apollo.useQuery<BrowserProbeQuery, BrowserProbeQueryVariables>(BrowserProbeDocument, baseOptions);
      }
export function useBrowserProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrowserProbeQuery, BrowserProbeQueryVariables>) {
          return Apollo.useLazyQuery<BrowserProbeQuery, BrowserProbeQueryVariables>(BrowserProbeDocument, baseOptions);
        }
export type BrowserProbeQueryHookResult = ReturnType<typeof useBrowserProbeQuery>;
export type BrowserProbeLazyQueryHookResult = ReturnType<typeof useBrowserProbeLazyQuery>;
export type BrowserProbeQueryResult = Apollo.QueryResult<BrowserProbeQuery, BrowserProbeQueryVariables>;
export const ZoomLessonsProbeDocument = gql`
    query ZoomLessonsProbe($dateFrom: Date!, $dateTo: Date!, $groupId: ID, $first: Int, $after: String) {
  allZoomLessons(
    dateFrom: $dateFrom
    dateTo: $dateTo
    groupId: $groupId
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useZoomLessonsProbeQuery__
 *
 * To run a query within a React component, call `useZoomLessonsProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomLessonsProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomLessonsProbeQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      groupId: // value for 'groupId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useZoomLessonsProbeQuery(baseOptions: Apollo.QueryHookOptions<ZoomLessonsProbeQuery, ZoomLessonsProbeQueryVariables>) {
        return Apollo.useQuery<ZoomLessonsProbeQuery, ZoomLessonsProbeQueryVariables>(ZoomLessonsProbeDocument, baseOptions);
      }
export function useZoomLessonsProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomLessonsProbeQuery, ZoomLessonsProbeQueryVariables>) {
          return Apollo.useLazyQuery<ZoomLessonsProbeQuery, ZoomLessonsProbeQueryVariables>(ZoomLessonsProbeDocument, baseOptions);
        }
export type ZoomLessonsProbeQueryHookResult = ReturnType<typeof useZoomLessonsProbeQuery>;
export type ZoomLessonsProbeLazyQueryHookResult = ReturnType<typeof useZoomLessonsProbeLazyQuery>;
export type ZoomLessonsProbeQueryResult = Apollo.QueryResult<ZoomLessonsProbeQuery, ZoomLessonsProbeQueryVariables>;
export const CreativesProbeDocument = gql`
    query CreativesProbe($from: Date!) {
  marketingCreatives(filter: {dateFrom: $from, dateTo: $from}) {
    rows {
      id
      name
      series {
        period
      }
    }
  }
}
    `;

/**
 * __useCreativesProbeQuery__
 *
 * To run a query within a React component, call `useCreativesProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativesProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativesProbeQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useCreativesProbeQuery(baseOptions: Apollo.QueryHookOptions<CreativesProbeQuery, CreativesProbeQueryVariables>) {
        return Apollo.useQuery<CreativesProbeQuery, CreativesProbeQueryVariables>(CreativesProbeDocument, baseOptions);
      }
export function useCreativesProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativesProbeQuery, CreativesProbeQueryVariables>) {
          return Apollo.useLazyQuery<CreativesProbeQuery, CreativesProbeQueryVariables>(CreativesProbeDocument, baseOptions);
        }
export type CreativesProbeQueryHookResult = ReturnType<typeof useCreativesProbeQuery>;
export type CreativesProbeLazyQueryHookResult = ReturnType<typeof useCreativesProbeLazyQuery>;
export type CreativesProbeQueryResult = Apollo.QueryResult<CreativesProbeQuery, CreativesProbeQueryVariables>;
export const EmailProbeDocument = gql`
    query EmailProbe($from: Date!) {
  marketingEmail(filter: {dateFrom: $from, dateTo: $from}) {
    sends {
      id
      name
      emailLeads
    }
  }
}
    `;

/**
 * __useEmailProbeQuery__
 *
 * To run a query within a React component, call `useEmailProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailProbeQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useEmailProbeQuery(baseOptions: Apollo.QueryHookOptions<EmailProbeQuery, EmailProbeQueryVariables>) {
        return Apollo.useQuery<EmailProbeQuery, EmailProbeQueryVariables>(EmailProbeDocument, baseOptions);
      }
export function useEmailProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailProbeQuery, EmailProbeQueryVariables>) {
          return Apollo.useLazyQuery<EmailProbeQuery, EmailProbeQueryVariables>(EmailProbeDocument, baseOptions);
        }
export type EmailProbeQueryHookResult = ReturnType<typeof useEmailProbeQuery>;
export type EmailProbeLazyQueryHookResult = ReturnType<typeof useEmailProbeLazyQuery>;
export type EmailProbeQueryResult = Apollo.QueryResult<EmailProbeQuery, EmailProbeQueryVariables>;
export const ListDocument = gql`
    query List($needsAttention: Boolean, $statusGroup: String) {
  fundingCandidates(needsAttention: $needsAttention, statusGroup: $statusGroup) {
    id
    needsAttention
  }
}
    `;

/**
 * __useListQuery__
 *
 * To run a query within a React component, call `useListQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListQuery({
 *   variables: {
 *      needsAttention: // value for 'needsAttention'
 *      statusGroup: // value for 'statusGroup'
 *   },
 * });
 */
export function useListQuery(baseOptions?: Apollo.QueryHookOptions<ListQuery, ListQueryVariables>) {
        return Apollo.useQuery<ListQuery, ListQueryVariables>(ListDocument, baseOptions);
      }
export function useListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListQuery, ListQueryVariables>) {
          return Apollo.useLazyQuery<ListQuery, ListQueryVariables>(ListDocument, baseOptions);
        }
export type ListQueryHookResult = ReturnType<typeof useListQuery>;
export type ListLazyQueryHookResult = ReturnType<typeof useListLazyQuery>;
export type ListQueryResult = Apollo.QueryResult<ListQuery, ListQueryVariables>;
export const BoardDocument = gql`
    query Board($isDeposit: Boolean) {
  fundingBoard(isDeposit: $isDeposit) {
    total
    needsAttention
  }
}
    `;

/**
 * __useBoardQuery__
 *
 * To run a query within a React component, call `useBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardQuery({
 *   variables: {
 *      isDeposit: // value for 'isDeposit'
 *   },
 * });
 */
export function useBoardQuery(baseOptions?: Apollo.QueryHookOptions<BoardQuery, BoardQueryVariables>) {
        return Apollo.useQuery<BoardQuery, BoardQueryVariables>(BoardDocument, baseOptions);
      }
export function useBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoardQuery, BoardQueryVariables>) {
          return Apollo.useLazyQuery<BoardQuery, BoardQueryVariables>(BoardDocument, baseOptions);
        }
export type BoardQueryHookResult = ReturnType<typeof useBoardQuery>;
export type BoardLazyQueryHookResult = ReturnType<typeof useBoardLazyQuery>;
export type BoardQueryResult = Apollo.QueryResult<BoardQuery, BoardQueryVariables>;
export const TotalDocument = gql`
    query Total($needsAttention: Boolean) {
  fundingCandidatesTotal(needsAttention: $needsAttention)
}
    `;

/**
 * __useTotalQuery__
 *
 * To run a query within a React component, call `useTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalQuery({
 *   variables: {
 *      needsAttention: // value for 'needsAttention'
 *   },
 * });
 */
export function useTotalQuery(baseOptions?: Apollo.QueryHookOptions<TotalQuery, TotalQueryVariables>) {
        return Apollo.useQuery<TotalQuery, TotalQueryVariables>(TotalDocument, baseOptions);
      }
export function useTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalQuery, TotalQueryVariables>) {
          return Apollo.useLazyQuery<TotalQuery, TotalQueryVariables>(TotalDocument, baseOptions);
        }
export type TotalQueryHookResult = ReturnType<typeof useTotalQuery>;
export type TotalLazyQueryHookResult = ReturnType<typeof useTotalLazyQuery>;
export type TotalQueryResult = Apollo.QueryResult<TotalQuery, TotalQueryVariables>;
export const CorrectAgreementGroupActionDocument = gql`
    mutation CorrectAgreementGroupAction($agreementId: ID!, $groupId: ID!, $reason: String!) {
  correctAgreementGroup(
    agreementId: $agreementId
    groupId: $groupId
    reason: $reason
  ) {
    success
    customErrors {
      field
      code
      message
    }
    agreement {
      id
      agreementTitle
    }
    oldTitle
    newTitle
    titleChanged
    titleKeptReason
  }
}
    `;
export type CorrectAgreementGroupActionMutationFn = Apollo.MutationFunction<CorrectAgreementGroupActionMutation, CorrectAgreementGroupActionMutationVariables>;

/**
 * __useCorrectAgreementGroupActionMutation__
 *
 * To run a mutation, you first call `useCorrectAgreementGroupActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorrectAgreementGroupActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [correctAgreementGroupActionMutation, { data, loading, error }] = useCorrectAgreementGroupActionMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      groupId: // value for 'groupId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCorrectAgreementGroupActionMutation(baseOptions?: Apollo.MutationHookOptions<CorrectAgreementGroupActionMutation, CorrectAgreementGroupActionMutationVariables>) {
        return Apollo.useMutation<CorrectAgreementGroupActionMutation, CorrectAgreementGroupActionMutationVariables>(CorrectAgreementGroupActionDocument, baseOptions);
      }
export type CorrectAgreementGroupActionMutationHookResult = ReturnType<typeof useCorrectAgreementGroupActionMutation>;
export type CorrectAgreementGroupActionMutationResult = Apollo.MutationResult<CorrectAgreementGroupActionMutation>;
export type CorrectAgreementGroupActionMutationOptions = Apollo.BaseMutationOptions<CorrectAgreementGroupActionMutation, CorrectAgreementGroupActionMutationVariables>;
export const UndoEnrollmentActionDocument = gql`
    mutation UndoEnrollmentAction($agreementId: ID!, $reason: String!) {
  undoEnrollment(agreementId: $agreementId, reason: $reason) {
    success
    customErrors {
      field
      code
      message
    }
    studentId
    studentVisible
  }
}
    `;
export type UndoEnrollmentActionMutationFn = Apollo.MutationFunction<UndoEnrollmentActionMutation, UndoEnrollmentActionMutationVariables>;

/**
 * __useUndoEnrollmentActionMutation__
 *
 * To run a mutation, you first call `useUndoEnrollmentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoEnrollmentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoEnrollmentActionMutation, { data, loading, error }] = useUndoEnrollmentActionMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUndoEnrollmentActionMutation(baseOptions?: Apollo.MutationHookOptions<UndoEnrollmentActionMutation, UndoEnrollmentActionMutationVariables>) {
        return Apollo.useMutation<UndoEnrollmentActionMutation, UndoEnrollmentActionMutationVariables>(UndoEnrollmentActionDocument, baseOptions);
      }
export type UndoEnrollmentActionMutationHookResult = ReturnType<typeof useUndoEnrollmentActionMutation>;
export type UndoEnrollmentActionMutationResult = Apollo.MutationResult<UndoEnrollmentActionMutation>;
export type UndoEnrollmentActionMutationOptions = Apollo.BaseMutationOptions<UndoEnrollmentActionMutation, UndoEnrollmentActionMutationVariables>;
export const ErpStartAiAgentRunDocument = gql`
    mutation ErpStartAiAgentRun($agentKey: String!, $subjectKind: String, $subjectId: ID) {
  startAiAgentRun(
    agentKey: $agentKey
    subjectKind: $subjectKind
    subjectId: $subjectId
  ) {
    id
    agentKey
    trigger
    status
    subjectKind
    subjectId
    subjectLabel
    createdAt
    startedAt
    finishedAt
    durationMs
    provider
    model
    inputTokens
    cachedTokens
    outputTokens
    costUsd
    resultSummary
    error
    createdByName
  }
}
    `;
export type ErpStartAiAgentRunMutationFn = Apollo.MutationFunction<ErpStartAiAgentRunMutation, ErpStartAiAgentRunMutationVariables>;

/**
 * __useErpStartAiAgentRunMutation__
 *
 * To run a mutation, you first call `useErpStartAiAgentRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpStartAiAgentRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpStartAiAgentRunMutation, { data, loading, error }] = useErpStartAiAgentRunMutation({
 *   variables: {
 *      agentKey: // value for 'agentKey'
 *      subjectKind: // value for 'subjectKind'
 *      subjectId: // value for 'subjectId'
 *   },
 * });
 */
export function useErpStartAiAgentRunMutation(baseOptions?: Apollo.MutationHookOptions<ErpStartAiAgentRunMutation, ErpStartAiAgentRunMutationVariables>) {
        return Apollo.useMutation<ErpStartAiAgentRunMutation, ErpStartAiAgentRunMutationVariables>(ErpStartAiAgentRunDocument, baseOptions);
      }
export type ErpStartAiAgentRunMutationHookResult = ReturnType<typeof useErpStartAiAgentRunMutation>;
export type ErpStartAiAgentRunMutationResult = Apollo.MutationResult<ErpStartAiAgentRunMutation>;
export type ErpStartAiAgentRunMutationOptions = Apollo.BaseMutationOptions<ErpStartAiAgentRunMutation, ErpStartAiAgentRunMutationVariables>;
export const ErpCancelAiAgentRunDocument = gql`
    mutation ErpCancelAiAgentRun($id: ID!) {
  cancelAiAgentRun(id: $id) {
    id
    agentKey
    trigger
    status
    startedAt
    finishedAt
    durationMs
    inputTokens
    cachedTokens
    outputTokens
    costUsd
    resultSummary
    error
  }
}
    `;
export type ErpCancelAiAgentRunMutationFn = Apollo.MutationFunction<ErpCancelAiAgentRunMutation, ErpCancelAiAgentRunMutationVariables>;

/**
 * __useErpCancelAiAgentRunMutation__
 *
 * To run a mutation, you first call `useErpCancelAiAgentRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpCancelAiAgentRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpCancelAiAgentRunMutation, { data, loading, error }] = useErpCancelAiAgentRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpCancelAiAgentRunMutation(baseOptions?: Apollo.MutationHookOptions<ErpCancelAiAgentRunMutation, ErpCancelAiAgentRunMutationVariables>) {
        return Apollo.useMutation<ErpCancelAiAgentRunMutation, ErpCancelAiAgentRunMutationVariables>(ErpCancelAiAgentRunDocument, baseOptions);
      }
export type ErpCancelAiAgentRunMutationHookResult = ReturnType<typeof useErpCancelAiAgentRunMutation>;
export type ErpCancelAiAgentRunMutationResult = Apollo.MutationResult<ErpCancelAiAgentRunMutation>;
export type ErpCancelAiAgentRunMutationOptions = Apollo.BaseMutationOptions<ErpCancelAiAgentRunMutation, ErpCancelAiAgentRunMutationVariables>;
export const ErpSendAiChatMessageDocument = gql`
    mutation ErpSendAiChatMessage($threadId: ID, $text: String!, $mentions: [AiChatMentionInput!], $attachmentIds: [ID!]) {
  sendAiChatMessage(
    threadId: $threadId
    text: $text
    mentions: $mentions
    attachmentIds: $attachmentIds
  ) {
    thread {
      id
      title
      status
      createdAt
      lastMessageAt
      pinnedAt
    }
    messages {
      id
      role
      text
      createdAt
      blocks
      interrupted
      mentions {
        kind
        id
        label
      }
      attachments {
        id
        url
        name
        mime
        size
        width
        height
      }
      toolCalls {
        name
        argsSummary
        status
        resultSummary
        source {
          kind
          label
        }
      }
      pendingActions {
        id
        tool
        willDo
        status
        result
        createdAt
        source {
          kind
          label
        }
      }
    }
    toolEvents {
      id
      messageId
      seq
      name
      args
      status
      resultPreview
      startedAt
      finishedAt
      source {
        kind
        label
      }
    }
    activeRun {
      id
      agentKey
      status
      model
      createdAt
      startedAt
      finishedAt
      error
      steps {
        id
        node
        status
        startedAt
        finishedAt
        summary
        error
      }
    }
    lastRun {
      id
      agentKey
      status
      model
      createdAt
      startedAt
      finishedAt
      error
    }
  }
}
    `;
export type ErpSendAiChatMessageMutationFn = Apollo.MutationFunction<ErpSendAiChatMessageMutation, ErpSendAiChatMessageMutationVariables>;

/**
 * __useErpSendAiChatMessageMutation__
 *
 * To run a mutation, you first call `useErpSendAiChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSendAiChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSendAiChatMessageMutation, { data, loading, error }] = useErpSendAiChatMessageMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      text: // value for 'text'
 *      mentions: // value for 'mentions'
 *      attachmentIds: // value for 'attachmentIds'
 *   },
 * });
 */
export function useErpSendAiChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<ErpSendAiChatMessageMutation, ErpSendAiChatMessageMutationVariables>) {
        return Apollo.useMutation<ErpSendAiChatMessageMutation, ErpSendAiChatMessageMutationVariables>(ErpSendAiChatMessageDocument, baseOptions);
      }
export type ErpSendAiChatMessageMutationHookResult = ReturnType<typeof useErpSendAiChatMessageMutation>;
export type ErpSendAiChatMessageMutationResult = Apollo.MutationResult<ErpSendAiChatMessageMutation>;
export type ErpSendAiChatMessageMutationOptions = Apollo.BaseMutationOptions<ErpSendAiChatMessageMutation, ErpSendAiChatMessageMutationVariables>;
export const ErpResolveAiChatActionDocument = gql`
    mutation ErpResolveAiChatAction($id: ID!, $approve: Boolean!) {
  resolveAiChatAction(id: $id, approve: $approve) {
    id
    tool
    willDo
    status
    result
    createdAt
    source {
      kind
      label
    }
  }
}
    `;
export type ErpResolveAiChatActionMutationFn = Apollo.MutationFunction<ErpResolveAiChatActionMutation, ErpResolveAiChatActionMutationVariables>;

/**
 * __useErpResolveAiChatActionMutation__
 *
 * To run a mutation, you first call `useErpResolveAiChatActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpResolveAiChatActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpResolveAiChatActionMutation, { data, loading, error }] = useErpResolveAiChatActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approve: // value for 'approve'
 *   },
 * });
 */
export function useErpResolveAiChatActionMutation(baseOptions?: Apollo.MutationHookOptions<ErpResolveAiChatActionMutation, ErpResolveAiChatActionMutationVariables>) {
        return Apollo.useMutation<ErpResolveAiChatActionMutation, ErpResolveAiChatActionMutationVariables>(ErpResolveAiChatActionDocument, baseOptions);
      }
export type ErpResolveAiChatActionMutationHookResult = ReturnType<typeof useErpResolveAiChatActionMutation>;
export type ErpResolveAiChatActionMutationResult = Apollo.MutationResult<ErpResolveAiChatActionMutation>;
export type ErpResolveAiChatActionMutationOptions = Apollo.BaseMutationOptions<ErpResolveAiChatActionMutation, ErpResolveAiChatActionMutationVariables>;
export const ErpDeleteAiChatThreadDocument = gql`
    mutation ErpDeleteAiChatThread($id: ID!) {
  deleteAiChatThread(id: $id)
}
    `;
export type ErpDeleteAiChatThreadMutationFn = Apollo.MutationFunction<ErpDeleteAiChatThreadMutation, ErpDeleteAiChatThreadMutationVariables>;

/**
 * __useErpDeleteAiChatThreadMutation__
 *
 * To run a mutation, you first call `useErpDeleteAiChatThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpDeleteAiChatThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpDeleteAiChatThreadMutation, { data, loading, error }] = useErpDeleteAiChatThreadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpDeleteAiChatThreadMutation(baseOptions?: Apollo.MutationHookOptions<ErpDeleteAiChatThreadMutation, ErpDeleteAiChatThreadMutationVariables>) {
        return Apollo.useMutation<ErpDeleteAiChatThreadMutation, ErpDeleteAiChatThreadMutationVariables>(ErpDeleteAiChatThreadDocument, baseOptions);
      }
export type ErpDeleteAiChatThreadMutationHookResult = ReturnType<typeof useErpDeleteAiChatThreadMutation>;
export type ErpDeleteAiChatThreadMutationResult = Apollo.MutationResult<ErpDeleteAiChatThreadMutation>;
export type ErpDeleteAiChatThreadMutationOptions = Apollo.BaseMutationOptions<ErpDeleteAiChatThreadMutation, ErpDeleteAiChatThreadMutationVariables>;
export const ErpUploadAiChatAttachmentDocument = gql`
    mutation ErpUploadAiChatAttachment($file: Upload!) {
  uploadAiChatAttachment(file: $file) {
    id
    url
    name
    mime
    size
    width
    height
  }
}
    `;
export type ErpUploadAiChatAttachmentMutationFn = Apollo.MutationFunction<ErpUploadAiChatAttachmentMutation, ErpUploadAiChatAttachmentMutationVariables>;

/**
 * __useErpUploadAiChatAttachmentMutation__
 *
 * To run a mutation, you first call `useErpUploadAiChatAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpUploadAiChatAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpUploadAiChatAttachmentMutation, { data, loading, error }] = useErpUploadAiChatAttachmentMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useErpUploadAiChatAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<ErpUploadAiChatAttachmentMutation, ErpUploadAiChatAttachmentMutationVariables>) {
        return Apollo.useMutation<ErpUploadAiChatAttachmentMutation, ErpUploadAiChatAttachmentMutationVariables>(ErpUploadAiChatAttachmentDocument, baseOptions);
      }
export type ErpUploadAiChatAttachmentMutationHookResult = ReturnType<typeof useErpUploadAiChatAttachmentMutation>;
export type ErpUploadAiChatAttachmentMutationResult = Apollo.MutationResult<ErpUploadAiChatAttachmentMutation>;
export type ErpUploadAiChatAttachmentMutationOptions = Apollo.BaseMutationOptions<ErpUploadAiChatAttachmentMutation, ErpUploadAiChatAttachmentMutationVariables>;
export const ErpPinAiChatThreadDocument = gql`
    mutation ErpPinAiChatThread($id: ID!, $pinned: Boolean!) {
  pinAiChatThread(id: $id, pinned: $pinned) {
    id
    title
    status
    createdAt
    lastMessageAt
    pinnedAt
  }
}
    `;
export type ErpPinAiChatThreadMutationFn = Apollo.MutationFunction<ErpPinAiChatThreadMutation, ErpPinAiChatThreadMutationVariables>;

/**
 * __useErpPinAiChatThreadMutation__
 *
 * To run a mutation, you first call `useErpPinAiChatThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpPinAiChatThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpPinAiChatThreadMutation, { data, loading, error }] = useErpPinAiChatThreadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function useErpPinAiChatThreadMutation(baseOptions?: Apollo.MutationHookOptions<ErpPinAiChatThreadMutation, ErpPinAiChatThreadMutationVariables>) {
        return Apollo.useMutation<ErpPinAiChatThreadMutation, ErpPinAiChatThreadMutationVariables>(ErpPinAiChatThreadDocument, baseOptions);
      }
export type ErpPinAiChatThreadMutationHookResult = ReturnType<typeof useErpPinAiChatThreadMutation>;
export type ErpPinAiChatThreadMutationResult = Apollo.MutationResult<ErpPinAiChatThreadMutation>;
export type ErpPinAiChatThreadMutationOptions = Apollo.BaseMutationOptions<ErpPinAiChatThreadMutation, ErpPinAiChatThreadMutationVariables>;
export const ErpRenameAiChatThreadDocument = gql`
    mutation ErpRenameAiChatThread($id: ID!, $title: String!) {
  renameAiChatThread(id: $id, title: $title) {
    id
    title
    status
    createdAt
    lastMessageAt
    pinnedAt
  }
}
    `;
export type ErpRenameAiChatThreadMutationFn = Apollo.MutationFunction<ErpRenameAiChatThreadMutation, ErpRenameAiChatThreadMutationVariables>;

/**
 * __useErpRenameAiChatThreadMutation__
 *
 * To run a mutation, you first call `useErpRenameAiChatThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRenameAiChatThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRenameAiChatThreadMutation, { data, loading, error }] = useErpRenameAiChatThreadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useErpRenameAiChatThreadMutation(baseOptions?: Apollo.MutationHookOptions<ErpRenameAiChatThreadMutation, ErpRenameAiChatThreadMutationVariables>) {
        return Apollo.useMutation<ErpRenameAiChatThreadMutation, ErpRenameAiChatThreadMutationVariables>(ErpRenameAiChatThreadDocument, baseOptions);
      }
export type ErpRenameAiChatThreadMutationHookResult = ReturnType<typeof useErpRenameAiChatThreadMutation>;
export type ErpRenameAiChatThreadMutationResult = Apollo.MutationResult<ErpRenameAiChatThreadMutation>;
export type ErpRenameAiChatThreadMutationOptions = Apollo.BaseMutationOptions<ErpRenameAiChatThreadMutation, ErpRenameAiChatThreadMutationVariables>;
export const ErpArchiveAiChatThreadDocument = gql`
    mutation ErpArchiveAiChatThread($id: ID!, $archived: Boolean!) {
  archiveAiChatThread(id: $id, archived: $archived) {
    id
    title
    status
    createdAt
    lastMessageAt
    pinnedAt
  }
}
    `;
export type ErpArchiveAiChatThreadMutationFn = Apollo.MutationFunction<ErpArchiveAiChatThreadMutation, ErpArchiveAiChatThreadMutationVariables>;

/**
 * __useErpArchiveAiChatThreadMutation__
 *
 * To run a mutation, you first call `useErpArchiveAiChatThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpArchiveAiChatThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpArchiveAiChatThreadMutation, { data, loading, error }] = useErpArchiveAiChatThreadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useErpArchiveAiChatThreadMutation(baseOptions?: Apollo.MutationHookOptions<ErpArchiveAiChatThreadMutation, ErpArchiveAiChatThreadMutationVariables>) {
        return Apollo.useMutation<ErpArchiveAiChatThreadMutation, ErpArchiveAiChatThreadMutationVariables>(ErpArchiveAiChatThreadDocument, baseOptions);
      }
export type ErpArchiveAiChatThreadMutationHookResult = ReturnType<typeof useErpArchiveAiChatThreadMutation>;
export type ErpArchiveAiChatThreadMutationResult = Apollo.MutationResult<ErpArchiveAiChatThreadMutation>;
export type ErpArchiveAiChatThreadMutationOptions = Apollo.BaseMutationOptions<ErpArchiveAiChatThreadMutation, ErpArchiveAiChatThreadMutationVariables>;
export const ErpRejectAiFindingDocument = gql`
    mutation ErpRejectAiFinding($id: ID!, $reason: String) {
  rejectAiFinding(id: $id, reason: $reason) {
    id
    kind
    severity
    summary
    confidence
    groupId
    groupName
    lessonId
    lessonStartsAt
    proposedStartsAt
    scheduleNote
    conversationId
    messageIds
    excerpts
    taskId
    taskStatus
    feedback
    feedbackReason
    feedbackByName
    createdAt
  }
}
    `;
export type ErpRejectAiFindingMutationFn = Apollo.MutationFunction<ErpRejectAiFindingMutation, ErpRejectAiFindingMutationVariables>;

/**
 * __useErpRejectAiFindingMutation__
 *
 * To run a mutation, you first call `useErpRejectAiFindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRejectAiFindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRejectAiFindingMutation, { data, loading, error }] = useErpRejectAiFindingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useErpRejectAiFindingMutation(baseOptions?: Apollo.MutationHookOptions<ErpRejectAiFindingMutation, ErpRejectAiFindingMutationVariables>) {
        return Apollo.useMutation<ErpRejectAiFindingMutation, ErpRejectAiFindingMutationVariables>(ErpRejectAiFindingDocument, baseOptions);
      }
export type ErpRejectAiFindingMutationHookResult = ReturnType<typeof useErpRejectAiFindingMutation>;
export type ErpRejectAiFindingMutationResult = Apollo.MutationResult<ErpRejectAiFindingMutation>;
export type ErpRejectAiFindingMutationOptions = Apollo.BaseMutationOptions<ErpRejectAiFindingMutation, ErpRejectAiFindingMutationVariables>;
export const ErpConfirmAiFindingDocument = gql`
    mutation ErpConfirmAiFinding($id: ID!) {
  confirmAiFinding(id: $id) {
    id
    kind
    severity
    summary
    confidence
    groupId
    groupName
    lessonId
    lessonStartsAt
    proposedStartsAt
    scheduleNote
    conversationId
    messageIds
    excerpts
    taskId
    taskStatus
    feedback
    feedbackReason
    feedbackByName
    createdAt
  }
}
    `;
export type ErpConfirmAiFindingMutationFn = Apollo.MutationFunction<ErpConfirmAiFindingMutation, ErpConfirmAiFindingMutationVariables>;

/**
 * __useErpConfirmAiFindingMutation__
 *
 * To run a mutation, you first call `useErpConfirmAiFindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpConfirmAiFindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpConfirmAiFindingMutation, { data, loading, error }] = useErpConfirmAiFindingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpConfirmAiFindingMutation(baseOptions?: Apollo.MutationHookOptions<ErpConfirmAiFindingMutation, ErpConfirmAiFindingMutationVariables>) {
        return Apollo.useMutation<ErpConfirmAiFindingMutation, ErpConfirmAiFindingMutationVariables>(ErpConfirmAiFindingDocument, baseOptions);
      }
export type ErpConfirmAiFindingMutationHookResult = ReturnType<typeof useErpConfirmAiFindingMutation>;
export type ErpConfirmAiFindingMutationResult = Apollo.MutationResult<ErpConfirmAiFindingMutation>;
export type ErpConfirmAiFindingMutationOptions = Apollo.BaseMutationOptions<ErpConfirmAiFindingMutation, ErpConfirmAiFindingMutationVariables>;
export const ErpSaveAiKnowledgeDocumentDocument = gql`
    mutation ErpSaveAiKnowledgeDocument($id: ID, $title: String!, $category: String!, $body: String!, $expectedVersion: Int) {
  saveAiKnowledgeDocument(
    id: $id
    title: $title
    category: $category
    body: $body
    expectedVersion: $expectedVersion
  ) {
    id
    title
    category
    status
    body
    sourceFileName
    version
    tokens
    chunkCount
    updatedAt
    updatedByName
    verifiedAt
    verifiedByName
    stale
  }
}
    `;
export type ErpSaveAiKnowledgeDocumentMutationFn = Apollo.MutationFunction<ErpSaveAiKnowledgeDocumentMutation, ErpSaveAiKnowledgeDocumentMutationVariables>;

/**
 * __useErpSaveAiKnowledgeDocumentMutation__
 *
 * To run a mutation, you first call `useErpSaveAiKnowledgeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSaveAiKnowledgeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSaveAiKnowledgeDocumentMutation, { data, loading, error }] = useErpSaveAiKnowledgeDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      category: // value for 'category'
 *      body: // value for 'body'
 *      expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useErpSaveAiKnowledgeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ErpSaveAiKnowledgeDocumentMutation, ErpSaveAiKnowledgeDocumentMutationVariables>) {
        return Apollo.useMutation<ErpSaveAiKnowledgeDocumentMutation, ErpSaveAiKnowledgeDocumentMutationVariables>(ErpSaveAiKnowledgeDocumentDocument, baseOptions);
      }
export type ErpSaveAiKnowledgeDocumentMutationHookResult = ReturnType<typeof useErpSaveAiKnowledgeDocumentMutation>;
export type ErpSaveAiKnowledgeDocumentMutationResult = Apollo.MutationResult<ErpSaveAiKnowledgeDocumentMutation>;
export type ErpSaveAiKnowledgeDocumentMutationOptions = Apollo.BaseMutationOptions<ErpSaveAiKnowledgeDocumentMutation, ErpSaveAiKnowledgeDocumentMutationVariables>;
export const ErpUploadAiKnowledgeDocumentDocument = gql`
    mutation ErpUploadAiKnowledgeDocument($file: Upload!, $category: String!, $title: String) {
  uploadAiKnowledgeDocument(file: $file, category: $category, title: $title) {
    id
    title
    category
    status
    body
    sourceFileName
    version
    tokens
    chunkCount
    updatedAt
    updatedByName
    verifiedAt
    verifiedByName
    stale
  }
}
    `;
export type ErpUploadAiKnowledgeDocumentMutationFn = Apollo.MutationFunction<ErpUploadAiKnowledgeDocumentMutation, ErpUploadAiKnowledgeDocumentMutationVariables>;

/**
 * __useErpUploadAiKnowledgeDocumentMutation__
 *
 * To run a mutation, you first call `useErpUploadAiKnowledgeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpUploadAiKnowledgeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpUploadAiKnowledgeDocumentMutation, { data, loading, error }] = useErpUploadAiKnowledgeDocumentMutation({
 *   variables: {
 *      file: // value for 'file'
 *      category: // value for 'category'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useErpUploadAiKnowledgeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ErpUploadAiKnowledgeDocumentMutation, ErpUploadAiKnowledgeDocumentMutationVariables>) {
        return Apollo.useMutation<ErpUploadAiKnowledgeDocumentMutation, ErpUploadAiKnowledgeDocumentMutationVariables>(ErpUploadAiKnowledgeDocumentDocument, baseOptions);
      }
export type ErpUploadAiKnowledgeDocumentMutationHookResult = ReturnType<typeof useErpUploadAiKnowledgeDocumentMutation>;
export type ErpUploadAiKnowledgeDocumentMutationResult = Apollo.MutationResult<ErpUploadAiKnowledgeDocumentMutation>;
export type ErpUploadAiKnowledgeDocumentMutationOptions = Apollo.BaseMutationOptions<ErpUploadAiKnowledgeDocumentMutation, ErpUploadAiKnowledgeDocumentMutationVariables>;
export const ErpSetAiKnowledgeDocumentStatusDocument = gql`
    mutation ErpSetAiKnowledgeDocumentStatus($id: ID!, $status: String!) {
  setAiKnowledgeDocumentStatus(id: $id, status: $status) {
    id
    title
    category
    status
    body
    sourceFileName
    version
    tokens
    chunkCount
    updatedAt
    updatedByName
    verifiedAt
    verifiedByName
    stale
  }
}
    `;
export type ErpSetAiKnowledgeDocumentStatusMutationFn = Apollo.MutationFunction<ErpSetAiKnowledgeDocumentStatusMutation, ErpSetAiKnowledgeDocumentStatusMutationVariables>;

/**
 * __useErpSetAiKnowledgeDocumentStatusMutation__
 *
 * To run a mutation, you first call `useErpSetAiKnowledgeDocumentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSetAiKnowledgeDocumentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSetAiKnowledgeDocumentStatusMutation, { data, loading, error }] = useErpSetAiKnowledgeDocumentStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useErpSetAiKnowledgeDocumentStatusMutation(baseOptions?: Apollo.MutationHookOptions<ErpSetAiKnowledgeDocumentStatusMutation, ErpSetAiKnowledgeDocumentStatusMutationVariables>) {
        return Apollo.useMutation<ErpSetAiKnowledgeDocumentStatusMutation, ErpSetAiKnowledgeDocumentStatusMutationVariables>(ErpSetAiKnowledgeDocumentStatusDocument, baseOptions);
      }
export type ErpSetAiKnowledgeDocumentStatusMutationHookResult = ReturnType<typeof useErpSetAiKnowledgeDocumentStatusMutation>;
export type ErpSetAiKnowledgeDocumentStatusMutationResult = Apollo.MutationResult<ErpSetAiKnowledgeDocumentStatusMutation>;
export type ErpSetAiKnowledgeDocumentStatusMutationOptions = Apollo.BaseMutationOptions<ErpSetAiKnowledgeDocumentStatusMutation, ErpSetAiKnowledgeDocumentStatusMutationVariables>;
export const ErpDeleteAiKnowledgeDocumentDocument = gql`
    mutation ErpDeleteAiKnowledgeDocument($id: ID!) {
  deleteAiKnowledgeDocument(id: $id)
}
    `;
export type ErpDeleteAiKnowledgeDocumentMutationFn = Apollo.MutationFunction<ErpDeleteAiKnowledgeDocumentMutation, ErpDeleteAiKnowledgeDocumentMutationVariables>;

/**
 * __useErpDeleteAiKnowledgeDocumentMutation__
 *
 * To run a mutation, you first call `useErpDeleteAiKnowledgeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpDeleteAiKnowledgeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpDeleteAiKnowledgeDocumentMutation, { data, loading, error }] = useErpDeleteAiKnowledgeDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpDeleteAiKnowledgeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ErpDeleteAiKnowledgeDocumentMutation, ErpDeleteAiKnowledgeDocumentMutationVariables>) {
        return Apollo.useMutation<ErpDeleteAiKnowledgeDocumentMutation, ErpDeleteAiKnowledgeDocumentMutationVariables>(ErpDeleteAiKnowledgeDocumentDocument, baseOptions);
      }
export type ErpDeleteAiKnowledgeDocumentMutationHookResult = ReturnType<typeof useErpDeleteAiKnowledgeDocumentMutation>;
export type ErpDeleteAiKnowledgeDocumentMutationResult = Apollo.MutationResult<ErpDeleteAiKnowledgeDocumentMutation>;
export type ErpDeleteAiKnowledgeDocumentMutationOptions = Apollo.BaseMutationOptions<ErpDeleteAiKnowledgeDocumentMutation, ErpDeleteAiKnowledgeDocumentMutationVariables>;
export const ErpApproveAiKbCandidateDocument = gql`
    mutation ErpApproveAiKbCandidate($id: ID!, $claim: String, $answer: String, $mode: String, $replaceLine: String, $targetDocumentId: ID, $targetHeading: String) {
  approveAiKbCandidate(
    id: $id
    claim: $claim
    answer: $answer
    mode: $mode
    replaceLine: $replaceLine
    targetDocumentId: $targetDocumentId
    targetHeading: $targetHeading
  ) {
    ...ErpAiKbCandidateFields
  }
}
    ${ErpAiKbCandidateFieldsFragmentDoc}`;
export type ErpApproveAiKbCandidateMutationFn = Apollo.MutationFunction<ErpApproveAiKbCandidateMutation, ErpApproveAiKbCandidateMutationVariables>;

/**
 * __useErpApproveAiKbCandidateMutation__
 *
 * To run a mutation, you first call `useErpApproveAiKbCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpApproveAiKbCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpApproveAiKbCandidateMutation, { data, loading, error }] = useErpApproveAiKbCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      claim: // value for 'claim'
 *      answer: // value for 'answer'
 *      mode: // value for 'mode'
 *      replaceLine: // value for 'replaceLine'
 *      targetDocumentId: // value for 'targetDocumentId'
 *      targetHeading: // value for 'targetHeading'
 *   },
 * });
 */
export function useErpApproveAiKbCandidateMutation(baseOptions?: Apollo.MutationHookOptions<ErpApproveAiKbCandidateMutation, ErpApproveAiKbCandidateMutationVariables>) {
        return Apollo.useMutation<ErpApproveAiKbCandidateMutation, ErpApproveAiKbCandidateMutationVariables>(ErpApproveAiKbCandidateDocument, baseOptions);
      }
export type ErpApproveAiKbCandidateMutationHookResult = ReturnType<typeof useErpApproveAiKbCandidateMutation>;
export type ErpApproveAiKbCandidateMutationResult = Apollo.MutationResult<ErpApproveAiKbCandidateMutation>;
export type ErpApproveAiKbCandidateMutationOptions = Apollo.BaseMutationOptions<ErpApproveAiKbCandidateMutation, ErpApproveAiKbCandidateMutationVariables>;
export const ErpRejectAiKbCandidateDocument = gql`
    mutation ErpRejectAiKbCandidate($id: ID!, $reason: String!) {
  rejectAiKbCandidate(id: $id, reason: $reason) {
    ...ErpAiKbCandidateFields
  }
}
    ${ErpAiKbCandidateFieldsFragmentDoc}`;
export type ErpRejectAiKbCandidateMutationFn = Apollo.MutationFunction<ErpRejectAiKbCandidateMutation, ErpRejectAiKbCandidateMutationVariables>;

/**
 * __useErpRejectAiKbCandidateMutation__
 *
 * To run a mutation, you first call `useErpRejectAiKbCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRejectAiKbCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRejectAiKbCandidateMutation, { data, loading, error }] = useErpRejectAiKbCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useErpRejectAiKbCandidateMutation(baseOptions?: Apollo.MutationHookOptions<ErpRejectAiKbCandidateMutation, ErpRejectAiKbCandidateMutationVariables>) {
        return Apollo.useMutation<ErpRejectAiKbCandidateMutation, ErpRejectAiKbCandidateMutationVariables>(ErpRejectAiKbCandidateDocument, baseOptions);
      }
export type ErpRejectAiKbCandidateMutationHookResult = ReturnType<typeof useErpRejectAiKbCandidateMutation>;
export type ErpRejectAiKbCandidateMutationResult = Apollo.MutationResult<ErpRejectAiKbCandidateMutation>;
export type ErpRejectAiKbCandidateMutationOptions = Apollo.BaseMutationOptions<ErpRejectAiKbCandidateMutation, ErpRejectAiKbCandidateMutationVariables>;
export const ErpMarkAiKbCandidateDuplicateDocument = gql`
    mutation ErpMarkAiKbCandidateDuplicate($id: ID!, $duplicateOfId: ID) {
  markAiKbCandidateDuplicate(id: $id, duplicateOfId: $duplicateOfId) {
    ...ErpAiKbCandidateFields
  }
}
    ${ErpAiKbCandidateFieldsFragmentDoc}`;
export type ErpMarkAiKbCandidateDuplicateMutationFn = Apollo.MutationFunction<ErpMarkAiKbCandidateDuplicateMutation, ErpMarkAiKbCandidateDuplicateMutationVariables>;

/**
 * __useErpMarkAiKbCandidateDuplicateMutation__
 *
 * To run a mutation, you first call `useErpMarkAiKbCandidateDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpMarkAiKbCandidateDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpMarkAiKbCandidateDuplicateMutation, { data, loading, error }] = useErpMarkAiKbCandidateDuplicateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duplicateOfId: // value for 'duplicateOfId'
 *   },
 * });
 */
export function useErpMarkAiKbCandidateDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<ErpMarkAiKbCandidateDuplicateMutation, ErpMarkAiKbCandidateDuplicateMutationVariables>) {
        return Apollo.useMutation<ErpMarkAiKbCandidateDuplicateMutation, ErpMarkAiKbCandidateDuplicateMutationVariables>(ErpMarkAiKbCandidateDuplicateDocument, baseOptions);
      }
export type ErpMarkAiKbCandidateDuplicateMutationHookResult = ReturnType<typeof useErpMarkAiKbCandidateDuplicateMutation>;
export type ErpMarkAiKbCandidateDuplicateMutationResult = Apollo.MutationResult<ErpMarkAiKbCandidateDuplicateMutation>;
export type ErpMarkAiKbCandidateDuplicateMutationOptions = Apollo.BaseMutationOptions<ErpMarkAiKbCandidateDuplicateMutation, ErpMarkAiKbCandidateDuplicateMutationVariables>;
export const ErpUpdateAiKbCandidateDocument = gql`
    mutation ErpUpdateAiKbCandidate($id: ID!, $claim: String, $question: String, $category: String, $targetDocumentId: ID, $targetHeading: String) {
  updateAiKbCandidate(
    id: $id
    claim: $claim
    question: $question
    category: $category
    targetDocumentId: $targetDocumentId
    targetHeading: $targetHeading
  ) {
    ...ErpAiKbCandidateFields
  }
}
    ${ErpAiKbCandidateFieldsFragmentDoc}`;
export type ErpUpdateAiKbCandidateMutationFn = Apollo.MutationFunction<ErpUpdateAiKbCandidateMutation, ErpUpdateAiKbCandidateMutationVariables>;

/**
 * __useErpUpdateAiKbCandidateMutation__
 *
 * To run a mutation, you first call `useErpUpdateAiKbCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpUpdateAiKbCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpUpdateAiKbCandidateMutation, { data, loading, error }] = useErpUpdateAiKbCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      claim: // value for 'claim'
 *      question: // value for 'question'
 *      category: // value for 'category'
 *      targetDocumentId: // value for 'targetDocumentId'
 *      targetHeading: // value for 'targetHeading'
 *   },
 * });
 */
export function useErpUpdateAiKbCandidateMutation(baseOptions?: Apollo.MutationHookOptions<ErpUpdateAiKbCandidateMutation, ErpUpdateAiKbCandidateMutationVariables>) {
        return Apollo.useMutation<ErpUpdateAiKbCandidateMutation, ErpUpdateAiKbCandidateMutationVariables>(ErpUpdateAiKbCandidateDocument, baseOptions);
      }
export type ErpUpdateAiKbCandidateMutationHookResult = ReturnType<typeof useErpUpdateAiKbCandidateMutation>;
export type ErpUpdateAiKbCandidateMutationResult = Apollo.MutationResult<ErpUpdateAiKbCandidateMutation>;
export type ErpUpdateAiKbCandidateMutationOptions = Apollo.BaseMutationOptions<ErpUpdateAiKbCandidateMutation, ErpUpdateAiKbCandidateMutationVariables>;
export const ErpSetAiKbReviewersDocument = gql`
    mutation ErpSetAiKbReviewers($category: String!, $userIds: [ID!]!) {
  setAiKbReviewers(category: $category, userIds: $userIds) {
    category
    users {
      id
      name
      email
    }
  }
}
    `;
export type ErpSetAiKbReviewersMutationFn = Apollo.MutationFunction<ErpSetAiKbReviewersMutation, ErpSetAiKbReviewersMutationVariables>;

/**
 * __useErpSetAiKbReviewersMutation__
 *
 * To run a mutation, you first call `useErpSetAiKbReviewersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSetAiKbReviewersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSetAiKbReviewersMutation, { data, loading, error }] = useErpSetAiKbReviewersMutation({
 *   variables: {
 *      category: // value for 'category'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useErpSetAiKbReviewersMutation(baseOptions?: Apollo.MutationHookOptions<ErpSetAiKbReviewersMutation, ErpSetAiKbReviewersMutationVariables>) {
        return Apollo.useMutation<ErpSetAiKbReviewersMutation, ErpSetAiKbReviewersMutationVariables>(ErpSetAiKbReviewersDocument, baseOptions);
      }
export type ErpSetAiKbReviewersMutationHookResult = ReturnType<typeof useErpSetAiKbReviewersMutation>;
export type ErpSetAiKbReviewersMutationResult = Apollo.MutationResult<ErpSetAiKbReviewersMutation>;
export type ErpSetAiKbReviewersMutationOptions = Apollo.BaseMutationOptions<ErpSetAiKbReviewersMutation, ErpSetAiKbReviewersMutationVariables>;
export const ErpRollbackAiKnowledgeDocumentDocument = gql`
    mutation ErpRollbackAiKnowledgeDocument($id: ID!, $version: Int!) {
  rollbackAiKnowledgeDocument(id: $id, version: $version) {
    id
    title
    category
    status
    body
    sourceFileName
    version
    tokens
    chunkCount
    updatedAt
    updatedByName
    verifiedAt
    verifiedByName
    stale
  }
}
    `;
export type ErpRollbackAiKnowledgeDocumentMutationFn = Apollo.MutationFunction<ErpRollbackAiKnowledgeDocumentMutation, ErpRollbackAiKnowledgeDocumentMutationVariables>;

/**
 * __useErpRollbackAiKnowledgeDocumentMutation__
 *
 * To run a mutation, you first call `useErpRollbackAiKnowledgeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRollbackAiKnowledgeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRollbackAiKnowledgeDocumentMutation, { data, loading, error }] = useErpRollbackAiKnowledgeDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useErpRollbackAiKnowledgeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ErpRollbackAiKnowledgeDocumentMutation, ErpRollbackAiKnowledgeDocumentMutationVariables>) {
        return Apollo.useMutation<ErpRollbackAiKnowledgeDocumentMutation, ErpRollbackAiKnowledgeDocumentMutationVariables>(ErpRollbackAiKnowledgeDocumentDocument, baseOptions);
      }
export type ErpRollbackAiKnowledgeDocumentMutationHookResult = ReturnType<typeof useErpRollbackAiKnowledgeDocumentMutation>;
export type ErpRollbackAiKnowledgeDocumentMutationResult = Apollo.MutationResult<ErpRollbackAiKnowledgeDocumentMutation>;
export type ErpRollbackAiKnowledgeDocumentMutationOptions = Apollo.BaseMutationOptions<ErpRollbackAiKnowledgeDocumentMutation, ErpRollbackAiKnowledgeDocumentMutationVariables>;
export const ErpVerifyAiKnowledgeDocumentDocument = gql`
    mutation ErpVerifyAiKnowledgeDocument($id: ID!) {
  verifyAiKnowledgeDocument(id: $id) {
    id
    title
    category
    status
    body
    sourceFileName
    version
    tokens
    chunkCount
    updatedAt
    updatedByName
    verifiedAt
    verifiedByName
    stale
  }
}
    `;
export type ErpVerifyAiKnowledgeDocumentMutationFn = Apollo.MutationFunction<ErpVerifyAiKnowledgeDocumentMutation, ErpVerifyAiKnowledgeDocumentMutationVariables>;

/**
 * __useErpVerifyAiKnowledgeDocumentMutation__
 *
 * To run a mutation, you first call `useErpVerifyAiKnowledgeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpVerifyAiKnowledgeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpVerifyAiKnowledgeDocumentMutation, { data, loading, error }] = useErpVerifyAiKnowledgeDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpVerifyAiKnowledgeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ErpVerifyAiKnowledgeDocumentMutation, ErpVerifyAiKnowledgeDocumentMutationVariables>) {
        return Apollo.useMutation<ErpVerifyAiKnowledgeDocumentMutation, ErpVerifyAiKnowledgeDocumentMutationVariables>(ErpVerifyAiKnowledgeDocumentDocument, baseOptions);
      }
export type ErpVerifyAiKnowledgeDocumentMutationHookResult = ReturnType<typeof useErpVerifyAiKnowledgeDocumentMutation>;
export type ErpVerifyAiKnowledgeDocumentMutationResult = Apollo.MutationResult<ErpVerifyAiKnowledgeDocumentMutation>;
export type ErpVerifyAiKnowledgeDocumentMutationOptions = Apollo.BaseMutationOptions<ErpVerifyAiKnowledgeDocumentMutation, ErpVerifyAiKnowledgeDocumentMutationVariables>;
export const ErpRequestAiLessonAnalysisDocument = gql`
    mutation ErpRequestAiLessonAnalysis($lessonId: ID!, $force: Boolean) {
  requestAiLessonAnalysis(lessonId: $lessonId, force: $force) {
    id
    lessonId
    groupId
    groupName
    courseId
    lessonNumber
    lessonStartsAt
    teacherName
    status
    lessonStatus
    overallScore
    understandingScore
    understandingBand
    summary
    strengths
    developmentArea
    criteria {
      id
      label
      weight
      status
      score
      confidence
      whyScore
      whyNotHigher
      nextLevel
    }
    recommendation {
      ruleId
      name
      action
      steps
      implementationCheck
      effectCheck
    }
    alerts
    reviewStatus
    reviewNote
    model
    createdAt
    error
    speakers {
      code
      label
      role
    }
  }
}
    `;
export type ErpRequestAiLessonAnalysisMutationFn = Apollo.MutationFunction<ErpRequestAiLessonAnalysisMutation, ErpRequestAiLessonAnalysisMutationVariables>;

/**
 * __useErpRequestAiLessonAnalysisMutation__
 *
 * To run a mutation, you first call `useErpRequestAiLessonAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRequestAiLessonAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRequestAiLessonAnalysisMutation, { data, loading, error }] = useErpRequestAiLessonAnalysisMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useErpRequestAiLessonAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<ErpRequestAiLessonAnalysisMutation, ErpRequestAiLessonAnalysisMutationVariables>) {
        return Apollo.useMutation<ErpRequestAiLessonAnalysisMutation, ErpRequestAiLessonAnalysisMutationVariables>(ErpRequestAiLessonAnalysisDocument, baseOptions);
      }
export type ErpRequestAiLessonAnalysisMutationHookResult = ReturnType<typeof useErpRequestAiLessonAnalysisMutation>;
export type ErpRequestAiLessonAnalysisMutationResult = Apollo.MutationResult<ErpRequestAiLessonAnalysisMutation>;
export type ErpRequestAiLessonAnalysisMutationOptions = Apollo.BaseMutationOptions<ErpRequestAiLessonAnalysisMutation, ErpRequestAiLessonAnalysisMutationVariables>;
export const ErpReviewAiLessonAnalysisDocument = gql`
    mutation ErpReviewAiLessonAnalysis($id: ID!, $decision: String!, $note: String) {
  reviewAiLessonAnalysis(id: $id, decision: $decision, note: $note) {
    id
    status
    lessonStatus
    reviewStatus
    reviewNote
  }
}
    `;
export type ErpReviewAiLessonAnalysisMutationFn = Apollo.MutationFunction<ErpReviewAiLessonAnalysisMutation, ErpReviewAiLessonAnalysisMutationVariables>;

/**
 * __useErpReviewAiLessonAnalysisMutation__
 *
 * To run a mutation, you first call `useErpReviewAiLessonAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpReviewAiLessonAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpReviewAiLessonAnalysisMutation, { data, loading, error }] = useErpReviewAiLessonAnalysisMutation({
 *   variables: {
 *      id: // value for 'id'
 *      decision: // value for 'decision'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useErpReviewAiLessonAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<ErpReviewAiLessonAnalysisMutation, ErpReviewAiLessonAnalysisMutationVariables>) {
        return Apollo.useMutation<ErpReviewAiLessonAnalysisMutation, ErpReviewAiLessonAnalysisMutationVariables>(ErpReviewAiLessonAnalysisDocument, baseOptions);
      }
export type ErpReviewAiLessonAnalysisMutationHookResult = ReturnType<typeof useErpReviewAiLessonAnalysisMutation>;
export type ErpReviewAiLessonAnalysisMutationResult = Apollo.MutationResult<ErpReviewAiLessonAnalysisMutation>;
export type ErpReviewAiLessonAnalysisMutationOptions = Apollo.BaseMutationOptions<ErpReviewAiLessonAnalysisMutation, ErpReviewAiLessonAnalysisMutationVariables>;
export const ErpRequestAiLessonBatchDocument = gql`
    mutation ErpRequestAiLessonBatch($lessonIds: [ID!]!, $force: Boolean) {
  requestAiLessonAnalyses(lessonIds: $lessonIds, force: $force) {
    started
    refused
    items {
      lessonId
      outcome
      cached
      refusal
      message
      analysis {
        id
        lessonId
        groupId
        groupName
        courseId
        lessonNumber
        lessonStartsAt
        teacherName
        status
        lessonStatus
        overallScore
        understandingScore
        understandingBand
        reviewStatus
        createdAt
        recommendation {
          ruleId
          name
          action
          steps
          implementationCheck
          effectCheck
        }
      }
    }
  }
}
    `;
export type ErpRequestAiLessonBatchMutationFn = Apollo.MutationFunction<ErpRequestAiLessonBatchMutation, ErpRequestAiLessonBatchMutationVariables>;

/**
 * __useErpRequestAiLessonBatchMutation__
 *
 * To run a mutation, you first call `useErpRequestAiLessonBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRequestAiLessonBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRequestAiLessonBatchMutation, { data, loading, error }] = useErpRequestAiLessonBatchMutation({
 *   variables: {
 *      lessonIds: // value for 'lessonIds'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useErpRequestAiLessonBatchMutation(baseOptions?: Apollo.MutationHookOptions<ErpRequestAiLessonBatchMutation, ErpRequestAiLessonBatchMutationVariables>) {
        return Apollo.useMutation<ErpRequestAiLessonBatchMutation, ErpRequestAiLessonBatchMutationVariables>(ErpRequestAiLessonBatchDocument, baseOptions);
      }
export type ErpRequestAiLessonBatchMutationHookResult = ReturnType<typeof useErpRequestAiLessonBatchMutation>;
export type ErpRequestAiLessonBatchMutationResult = Apollo.MutationResult<ErpRequestAiLessonBatchMutation>;
export type ErpRequestAiLessonBatchMutationOptions = Apollo.BaseMutationOptions<ErpRequestAiLessonBatchMutation, ErpRequestAiLessonBatchMutationVariables>;
export const ErpGenerateTeacherNarrativeDocument = gql`
    mutation ErpGenerateTeacherNarrative($teacherId: ID!) {
  generateAiTeacherNarrative(teacherId: $teacherId) {
    id
    teacherId
    status
    text
    analysesCount
    model
    error
    createdAt
    finishedAt
    unchanged
  }
}
    `;
export type ErpGenerateTeacherNarrativeMutationFn = Apollo.MutationFunction<ErpGenerateTeacherNarrativeMutation, ErpGenerateTeacherNarrativeMutationVariables>;

/**
 * __useErpGenerateTeacherNarrativeMutation__
 *
 * To run a mutation, you first call `useErpGenerateTeacherNarrativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpGenerateTeacherNarrativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpGenerateTeacherNarrativeMutation, { data, loading, error }] = useErpGenerateTeacherNarrativeMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useErpGenerateTeacherNarrativeMutation(baseOptions?: Apollo.MutationHookOptions<ErpGenerateTeacherNarrativeMutation, ErpGenerateTeacherNarrativeMutationVariables>) {
        return Apollo.useMutation<ErpGenerateTeacherNarrativeMutation, ErpGenerateTeacherNarrativeMutationVariables>(ErpGenerateTeacherNarrativeDocument, baseOptions);
      }
export type ErpGenerateTeacherNarrativeMutationHookResult = ReturnType<typeof useErpGenerateTeacherNarrativeMutation>;
export type ErpGenerateTeacherNarrativeMutationResult = Apollo.MutationResult<ErpGenerateTeacherNarrativeMutation>;
export type ErpGenerateTeacherNarrativeMutationOptions = Apollo.BaseMutationOptions<ErpGenerateTeacherNarrativeMutation, ErpGenerateTeacherNarrativeMutationVariables>;
export const ErpRefreshAiStudentPortraitDocument = gql`
    mutation ErpRefreshAiStudentPortrait($studentId: ID!) {
  refreshAiStudentPortrait(studentId: $studentId) {
    studentId
    status
    stale
    generatedAt
    model
    error
    summary
    learning
    engagement
    sentimentTrend
    communication
    risks {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    openNeeds {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    nextActions {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    about {
      key
      label
      value
    }
    strengths {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    concerns {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    checkpoints {
      key
      status
      text
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
  }
}
    `;
export type ErpRefreshAiStudentPortraitMutationFn = Apollo.MutationFunction<ErpRefreshAiStudentPortraitMutation, ErpRefreshAiStudentPortraitMutationVariables>;

/**
 * __useErpRefreshAiStudentPortraitMutation__
 *
 * To run a mutation, you first call `useErpRefreshAiStudentPortraitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRefreshAiStudentPortraitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRefreshAiStudentPortraitMutation, { data, loading, error }] = useErpRefreshAiStudentPortraitMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useErpRefreshAiStudentPortraitMutation(baseOptions?: Apollo.MutationHookOptions<ErpRefreshAiStudentPortraitMutation, ErpRefreshAiStudentPortraitMutationVariables>) {
        return Apollo.useMutation<ErpRefreshAiStudentPortraitMutation, ErpRefreshAiStudentPortraitMutationVariables>(ErpRefreshAiStudentPortraitDocument, baseOptions);
      }
export type ErpRefreshAiStudentPortraitMutationHookResult = ReturnType<typeof useErpRefreshAiStudentPortraitMutation>;
export type ErpRefreshAiStudentPortraitMutationResult = Apollo.MutationResult<ErpRefreshAiStudentPortraitMutation>;
export type ErpRefreshAiStudentPortraitMutationOptions = Apollo.BaseMutationOptions<ErpRefreshAiStudentPortraitMutation, ErpRefreshAiStudentPortraitMutationVariables>;
export const ErpRequestAiReplySuggestionDocument = gql`
    mutation ErpRequestAiReplySuggestion($conversationId: ID!) {
  requestAiReplySuggestion(conversationId: $conversationId) {
    id
    conversationId
    forMessageId
    status
    topic
    language
    text
    html
    confidence
    citations {
      kind
      ref
      label
    }
    missingInfo
    error
    financeHidden
    createdAt
    updatedAt
  }
}
    `;
export type ErpRequestAiReplySuggestionMutationFn = Apollo.MutationFunction<ErpRequestAiReplySuggestionMutation, ErpRequestAiReplySuggestionMutationVariables>;

/**
 * __useErpRequestAiReplySuggestionMutation__
 *
 * To run a mutation, you first call `useErpRequestAiReplySuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRequestAiReplySuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRequestAiReplySuggestionMutation, { data, loading, error }] = useErpRequestAiReplySuggestionMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useErpRequestAiReplySuggestionMutation(baseOptions?: Apollo.MutationHookOptions<ErpRequestAiReplySuggestionMutation, ErpRequestAiReplySuggestionMutationVariables>) {
        return Apollo.useMutation<ErpRequestAiReplySuggestionMutation, ErpRequestAiReplySuggestionMutationVariables>(ErpRequestAiReplySuggestionDocument, baseOptions);
      }
export type ErpRequestAiReplySuggestionMutationHookResult = ReturnType<typeof useErpRequestAiReplySuggestionMutation>;
export type ErpRequestAiReplySuggestionMutationResult = Apollo.MutationResult<ErpRequestAiReplySuggestionMutation>;
export type ErpRequestAiReplySuggestionMutationOptions = Apollo.BaseMutationOptions<ErpRequestAiReplySuggestionMutation, ErpRequestAiReplySuggestionMutationVariables>;
export const ErpMarkAiReplySuggestionDocument = gql`
    mutation ErpMarkAiReplySuggestion($id: ID!, $action: String!, $reason: String) {
  markAiReplySuggestion(id: $id, action: $action, reason: $reason) {
    id
    conversationId
    forMessageId
    status
    topic
    language
    text
    html
    confidence
    citations {
      kind
      ref
      label
    }
    missingInfo
    error
    financeHidden
    createdAt
    updatedAt
  }
}
    `;
export type ErpMarkAiReplySuggestionMutationFn = Apollo.MutationFunction<ErpMarkAiReplySuggestionMutation, ErpMarkAiReplySuggestionMutationVariables>;

/**
 * __useErpMarkAiReplySuggestionMutation__
 *
 * To run a mutation, you first call `useErpMarkAiReplySuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpMarkAiReplySuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpMarkAiReplySuggestionMutation, { data, loading, error }] = useErpMarkAiReplySuggestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      action: // value for 'action'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useErpMarkAiReplySuggestionMutation(baseOptions?: Apollo.MutationHookOptions<ErpMarkAiReplySuggestionMutation, ErpMarkAiReplySuggestionMutationVariables>) {
        return Apollo.useMutation<ErpMarkAiReplySuggestionMutation, ErpMarkAiReplySuggestionMutationVariables>(ErpMarkAiReplySuggestionDocument, baseOptions);
      }
export type ErpMarkAiReplySuggestionMutationHookResult = ReturnType<typeof useErpMarkAiReplySuggestionMutation>;
export type ErpMarkAiReplySuggestionMutationResult = Apollo.MutationResult<ErpMarkAiReplySuggestionMutation>;
export type ErpMarkAiReplySuggestionMutationOptions = Apollo.BaseMutationOptions<ErpMarkAiReplySuggestionMutation, ErpMarkAiReplySuggestionMutationVariables>;
export const ErpSetAiChatToolEnabledDocument = gql`
    mutation ErpSetAiChatToolEnabled($name: String!, $enabled: Boolean!) {
  setAiChatToolEnabled(name: $name, enabled: $enabled) {
    name
    group
    kind
    description
    enabled
    defaultEnabled
  }
}
    `;
export type ErpSetAiChatToolEnabledMutationFn = Apollo.MutationFunction<ErpSetAiChatToolEnabledMutation, ErpSetAiChatToolEnabledMutationVariables>;

/**
 * __useErpSetAiChatToolEnabledMutation__
 *
 * To run a mutation, you first call `useErpSetAiChatToolEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSetAiChatToolEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSetAiChatToolEnabledMutation, { data, loading, error }] = useErpSetAiChatToolEnabledMutation({
 *   variables: {
 *      name: // value for 'name'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useErpSetAiChatToolEnabledMutation(baseOptions?: Apollo.MutationHookOptions<ErpSetAiChatToolEnabledMutation, ErpSetAiChatToolEnabledMutationVariables>) {
        return Apollo.useMutation<ErpSetAiChatToolEnabledMutation, ErpSetAiChatToolEnabledMutationVariables>(ErpSetAiChatToolEnabledDocument, baseOptions);
      }
export type ErpSetAiChatToolEnabledMutationHookResult = ReturnType<typeof useErpSetAiChatToolEnabledMutation>;
export type ErpSetAiChatToolEnabledMutationResult = Apollo.MutationResult<ErpSetAiChatToolEnabledMutation>;
export type ErpSetAiChatToolEnabledMutationOptions = Apollo.BaseMutationOptions<ErpSetAiChatToolEnabledMutation, ErpSetAiChatToolEnabledMutationVariables>;
export const ErpSaveAiSkillDocument = gql`
    mutation ErpSaveAiSkill($input: AiSkillInput!) {
  saveAiSkill(input: $input) {
    id
    slug
    title
    description
    instructions
    status
    source
    version
    agents
    files {
      path
      size
    }
    pluginId
    pluginName
    updatedAt
    createdByName
    skipped
  }
}
    `;
export type ErpSaveAiSkillMutationFn = Apollo.MutationFunction<ErpSaveAiSkillMutation, ErpSaveAiSkillMutationVariables>;

/**
 * __useErpSaveAiSkillMutation__
 *
 * To run a mutation, you first call `useErpSaveAiSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSaveAiSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSaveAiSkillMutation, { data, loading, error }] = useErpSaveAiSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErpSaveAiSkillMutation(baseOptions?: Apollo.MutationHookOptions<ErpSaveAiSkillMutation, ErpSaveAiSkillMutationVariables>) {
        return Apollo.useMutation<ErpSaveAiSkillMutation, ErpSaveAiSkillMutationVariables>(ErpSaveAiSkillDocument, baseOptions);
      }
export type ErpSaveAiSkillMutationHookResult = ReturnType<typeof useErpSaveAiSkillMutation>;
export type ErpSaveAiSkillMutationResult = Apollo.MutationResult<ErpSaveAiSkillMutation>;
export type ErpSaveAiSkillMutationOptions = Apollo.BaseMutationOptions<ErpSaveAiSkillMutation, ErpSaveAiSkillMutationVariables>;
export const ErpImportAiSkillDocument = gql`
    mutation ErpImportAiSkill($file: Upload!) {
  importAiSkill(file: $file) {
    id
    slug
    title
    description
    instructions
    status
    source
    version
    agents
    files {
      path
      size
    }
    pluginId
    pluginName
    updatedAt
    createdByName
    skipped
  }
}
    `;
export type ErpImportAiSkillMutationFn = Apollo.MutationFunction<ErpImportAiSkillMutation, ErpImportAiSkillMutationVariables>;

/**
 * __useErpImportAiSkillMutation__
 *
 * To run a mutation, you first call `useErpImportAiSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpImportAiSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpImportAiSkillMutation, { data, loading, error }] = useErpImportAiSkillMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useErpImportAiSkillMutation(baseOptions?: Apollo.MutationHookOptions<ErpImportAiSkillMutation, ErpImportAiSkillMutationVariables>) {
        return Apollo.useMutation<ErpImportAiSkillMutation, ErpImportAiSkillMutationVariables>(ErpImportAiSkillDocument, baseOptions);
      }
export type ErpImportAiSkillMutationHookResult = ReturnType<typeof useErpImportAiSkillMutation>;
export type ErpImportAiSkillMutationResult = Apollo.MutationResult<ErpImportAiSkillMutation>;
export type ErpImportAiSkillMutationOptions = Apollo.BaseMutationOptions<ErpImportAiSkillMutation, ErpImportAiSkillMutationVariables>;
export const ErpSetAiSkillStatusDocument = gql`
    mutation ErpSetAiSkillStatus($id: ID!, $status: String!) {
  setAiSkillStatus(id: $id, status: $status) {
    id
    slug
    title
    description
    instructions
    status
    source
    version
    agents
    files {
      path
      size
    }
    pluginId
    pluginName
    updatedAt
    createdByName
    skipped
  }
}
    `;
export type ErpSetAiSkillStatusMutationFn = Apollo.MutationFunction<ErpSetAiSkillStatusMutation, ErpSetAiSkillStatusMutationVariables>;

/**
 * __useErpSetAiSkillStatusMutation__
 *
 * To run a mutation, you first call `useErpSetAiSkillStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSetAiSkillStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSetAiSkillStatusMutation, { data, loading, error }] = useErpSetAiSkillStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useErpSetAiSkillStatusMutation(baseOptions?: Apollo.MutationHookOptions<ErpSetAiSkillStatusMutation, ErpSetAiSkillStatusMutationVariables>) {
        return Apollo.useMutation<ErpSetAiSkillStatusMutation, ErpSetAiSkillStatusMutationVariables>(ErpSetAiSkillStatusDocument, baseOptions);
      }
export type ErpSetAiSkillStatusMutationHookResult = ReturnType<typeof useErpSetAiSkillStatusMutation>;
export type ErpSetAiSkillStatusMutationResult = Apollo.MutationResult<ErpSetAiSkillStatusMutation>;
export type ErpSetAiSkillStatusMutationOptions = Apollo.BaseMutationOptions<ErpSetAiSkillStatusMutation, ErpSetAiSkillStatusMutationVariables>;
export const ErpDeleteAiSkillDocument = gql`
    mutation ErpDeleteAiSkill($id: ID!) {
  deleteAiSkill(id: $id)
}
    `;
export type ErpDeleteAiSkillMutationFn = Apollo.MutationFunction<ErpDeleteAiSkillMutation, ErpDeleteAiSkillMutationVariables>;

/**
 * __useErpDeleteAiSkillMutation__
 *
 * To run a mutation, you first call `useErpDeleteAiSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpDeleteAiSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpDeleteAiSkillMutation, { data, loading, error }] = useErpDeleteAiSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpDeleteAiSkillMutation(baseOptions?: Apollo.MutationHookOptions<ErpDeleteAiSkillMutation, ErpDeleteAiSkillMutationVariables>) {
        return Apollo.useMutation<ErpDeleteAiSkillMutation, ErpDeleteAiSkillMutationVariables>(ErpDeleteAiSkillDocument, baseOptions);
      }
export type ErpDeleteAiSkillMutationHookResult = ReturnType<typeof useErpDeleteAiSkillMutation>;
export type ErpDeleteAiSkillMutationResult = Apollo.MutationResult<ErpDeleteAiSkillMutation>;
export type ErpDeleteAiSkillMutationOptions = Apollo.BaseMutationOptions<ErpDeleteAiSkillMutation, ErpDeleteAiSkillMutationVariables>;
export const ErpSaveAiMcpConnectionDocument = gql`
    mutation ErpSaveAiMcpConnection($input: AiMcpConnectionInput!) {
  saveAiMcpConnection(input: $input) {
    id
    slug
    title
    url
    transport
    authType
    headerName
    hasSecret
    oauthConnected
    oauthExpiresAt
    allowPii
    enabled
    status
    lastCheckedAt
    lastError
    serverName
    serverVersion
    tools {
      name
      description
      inputSchema
      enabled
      requiresApproval
      missing
      changed
      unsupportedReason
    }
    pluginId
    pluginName
    note
    notes {
      code
      params
    }
  }
}
    `;
export type ErpSaveAiMcpConnectionMutationFn = Apollo.MutationFunction<ErpSaveAiMcpConnectionMutation, ErpSaveAiMcpConnectionMutationVariables>;

/**
 * __useErpSaveAiMcpConnectionMutation__
 *
 * To run a mutation, you first call `useErpSaveAiMcpConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSaveAiMcpConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSaveAiMcpConnectionMutation, { data, loading, error }] = useErpSaveAiMcpConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErpSaveAiMcpConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ErpSaveAiMcpConnectionMutation, ErpSaveAiMcpConnectionMutationVariables>) {
        return Apollo.useMutation<ErpSaveAiMcpConnectionMutation, ErpSaveAiMcpConnectionMutationVariables>(ErpSaveAiMcpConnectionDocument, baseOptions);
      }
export type ErpSaveAiMcpConnectionMutationHookResult = ReturnType<typeof useErpSaveAiMcpConnectionMutation>;
export type ErpSaveAiMcpConnectionMutationResult = Apollo.MutationResult<ErpSaveAiMcpConnectionMutation>;
export type ErpSaveAiMcpConnectionMutationOptions = Apollo.BaseMutationOptions<ErpSaveAiMcpConnectionMutation, ErpSaveAiMcpConnectionMutationVariables>;
export const ErpTestAiMcpConnectionDocument = gql`
    mutation ErpTestAiMcpConnection($id: ID!) {
  testAiMcpConnection(id: $id) {
    id
    slug
    title
    url
    transport
    authType
    headerName
    hasSecret
    oauthConnected
    oauthExpiresAt
    allowPii
    enabled
    status
    lastCheckedAt
    lastError
    serverName
    serverVersion
    tools {
      name
      description
      inputSchema
      enabled
      requiresApproval
      missing
      changed
      unsupportedReason
    }
    pluginId
    pluginName
    note
    notes {
      code
      params
    }
  }
}
    `;
export type ErpTestAiMcpConnectionMutationFn = Apollo.MutationFunction<ErpTestAiMcpConnectionMutation, ErpTestAiMcpConnectionMutationVariables>;

/**
 * __useErpTestAiMcpConnectionMutation__
 *
 * To run a mutation, you first call `useErpTestAiMcpConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpTestAiMcpConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpTestAiMcpConnectionMutation, { data, loading, error }] = useErpTestAiMcpConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpTestAiMcpConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ErpTestAiMcpConnectionMutation, ErpTestAiMcpConnectionMutationVariables>) {
        return Apollo.useMutation<ErpTestAiMcpConnectionMutation, ErpTestAiMcpConnectionMutationVariables>(ErpTestAiMcpConnectionDocument, baseOptions);
      }
export type ErpTestAiMcpConnectionMutationHookResult = ReturnType<typeof useErpTestAiMcpConnectionMutation>;
export type ErpTestAiMcpConnectionMutationResult = Apollo.MutationResult<ErpTestAiMcpConnectionMutation>;
export type ErpTestAiMcpConnectionMutationOptions = Apollo.BaseMutationOptions<ErpTestAiMcpConnectionMutation, ErpTestAiMcpConnectionMutationVariables>;
export const ErpStartAiMcpOAuthDocument = gql`
    mutation ErpStartAiMcpOAuth($id: ID!) {
  startAiMcpOAuth(id: $id)
}
    `;
export type ErpStartAiMcpOAuthMutationFn = Apollo.MutationFunction<ErpStartAiMcpOAuthMutation, ErpStartAiMcpOAuthMutationVariables>;

/**
 * __useErpStartAiMcpOAuthMutation__
 *
 * To run a mutation, you first call `useErpStartAiMcpOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpStartAiMcpOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpStartAiMcpOAuthMutation, { data, loading, error }] = useErpStartAiMcpOAuthMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpStartAiMcpOAuthMutation(baseOptions?: Apollo.MutationHookOptions<ErpStartAiMcpOAuthMutation, ErpStartAiMcpOAuthMutationVariables>) {
        return Apollo.useMutation<ErpStartAiMcpOAuthMutation, ErpStartAiMcpOAuthMutationVariables>(ErpStartAiMcpOAuthDocument, baseOptions);
      }
export type ErpStartAiMcpOAuthMutationHookResult = ReturnType<typeof useErpStartAiMcpOAuthMutation>;
export type ErpStartAiMcpOAuthMutationResult = Apollo.MutationResult<ErpStartAiMcpOAuthMutation>;
export type ErpStartAiMcpOAuthMutationOptions = Apollo.BaseMutationOptions<ErpStartAiMcpOAuthMutation, ErpStartAiMcpOAuthMutationVariables>;
export const ErpSetAiMcpToolSettingsDocument = gql`
    mutation ErpSetAiMcpToolSettings($id: ID!, $tools: [AiMcpToolSettingInput!]!) {
  setAiMcpToolSettings(id: $id, tools: $tools) {
    id
    slug
    title
    url
    transport
    authType
    headerName
    hasSecret
    oauthConnected
    oauthExpiresAt
    allowPii
    enabled
    status
    lastCheckedAt
    lastError
    serverName
    serverVersion
    tools {
      name
      description
      inputSchema
      enabled
      requiresApproval
      missing
      changed
      unsupportedReason
    }
    pluginId
    pluginName
    note
    notes {
      code
      params
    }
  }
}
    `;
export type ErpSetAiMcpToolSettingsMutationFn = Apollo.MutationFunction<ErpSetAiMcpToolSettingsMutation, ErpSetAiMcpToolSettingsMutationVariables>;

/**
 * __useErpSetAiMcpToolSettingsMutation__
 *
 * To run a mutation, you first call `useErpSetAiMcpToolSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSetAiMcpToolSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSetAiMcpToolSettingsMutation, { data, loading, error }] = useErpSetAiMcpToolSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tools: // value for 'tools'
 *   },
 * });
 */
export function useErpSetAiMcpToolSettingsMutation(baseOptions?: Apollo.MutationHookOptions<ErpSetAiMcpToolSettingsMutation, ErpSetAiMcpToolSettingsMutationVariables>) {
        return Apollo.useMutation<ErpSetAiMcpToolSettingsMutation, ErpSetAiMcpToolSettingsMutationVariables>(ErpSetAiMcpToolSettingsDocument, baseOptions);
      }
export type ErpSetAiMcpToolSettingsMutationHookResult = ReturnType<typeof useErpSetAiMcpToolSettingsMutation>;
export type ErpSetAiMcpToolSettingsMutationResult = Apollo.MutationResult<ErpSetAiMcpToolSettingsMutation>;
export type ErpSetAiMcpToolSettingsMutationOptions = Apollo.BaseMutationOptions<ErpSetAiMcpToolSettingsMutation, ErpSetAiMcpToolSettingsMutationVariables>;
export const ErpDeleteAiMcpConnectionDocument = gql`
    mutation ErpDeleteAiMcpConnection($id: ID!) {
  deleteAiMcpConnection(id: $id)
}
    `;
export type ErpDeleteAiMcpConnectionMutationFn = Apollo.MutationFunction<ErpDeleteAiMcpConnectionMutation, ErpDeleteAiMcpConnectionMutationVariables>;

/**
 * __useErpDeleteAiMcpConnectionMutation__
 *
 * To run a mutation, you first call `useErpDeleteAiMcpConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpDeleteAiMcpConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpDeleteAiMcpConnectionMutation, { data, loading, error }] = useErpDeleteAiMcpConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpDeleteAiMcpConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ErpDeleteAiMcpConnectionMutation, ErpDeleteAiMcpConnectionMutationVariables>) {
        return Apollo.useMutation<ErpDeleteAiMcpConnectionMutation, ErpDeleteAiMcpConnectionMutationVariables>(ErpDeleteAiMcpConnectionDocument, baseOptions);
      }
export type ErpDeleteAiMcpConnectionMutationHookResult = ReturnType<typeof useErpDeleteAiMcpConnectionMutation>;
export type ErpDeleteAiMcpConnectionMutationResult = Apollo.MutationResult<ErpDeleteAiMcpConnectionMutation>;
export type ErpDeleteAiMcpConnectionMutationOptions = Apollo.BaseMutationOptions<ErpDeleteAiMcpConnectionMutation, ErpDeleteAiMcpConnectionMutationVariables>;
export const ErpImportAiPluginDocument = gql`
    mutation ErpImportAiPlugin($file: Upload!) {
  importAiPlugin(file: $file) {
    id
    name
    version
    description
    enabled
    skipped
    skippedItems {
      code
      params
    }
    createdAt
    skills {
      id
      slug
      title
      status
      source
      version
    }
    connections {
      id
      slug
      title
      url
      authType
      hasSecret
      oauthConnected
      enabled
      status
      note
    }
  }
}
    `;
export type ErpImportAiPluginMutationFn = Apollo.MutationFunction<ErpImportAiPluginMutation, ErpImportAiPluginMutationVariables>;

/**
 * __useErpImportAiPluginMutation__
 *
 * To run a mutation, you first call `useErpImportAiPluginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpImportAiPluginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpImportAiPluginMutation, { data, loading, error }] = useErpImportAiPluginMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useErpImportAiPluginMutation(baseOptions?: Apollo.MutationHookOptions<ErpImportAiPluginMutation, ErpImportAiPluginMutationVariables>) {
        return Apollo.useMutation<ErpImportAiPluginMutation, ErpImportAiPluginMutationVariables>(ErpImportAiPluginDocument, baseOptions);
      }
export type ErpImportAiPluginMutationHookResult = ReturnType<typeof useErpImportAiPluginMutation>;
export type ErpImportAiPluginMutationResult = Apollo.MutationResult<ErpImportAiPluginMutation>;
export type ErpImportAiPluginMutationOptions = Apollo.BaseMutationOptions<ErpImportAiPluginMutation, ErpImportAiPluginMutationVariables>;
export const ErpSetAiPluginEnabledDocument = gql`
    mutation ErpSetAiPluginEnabled($id: ID!, $enabled: Boolean!) {
  setAiPluginEnabled(id: $id, enabled: $enabled) {
    id
    name
    version
    description
    enabled
    skipped
    skippedItems {
      code
      params
    }
    createdAt
    skills {
      id
      slug
      title
      status
      source
      version
    }
    connections {
      id
      slug
      title
      url
      authType
      hasSecret
      oauthConnected
      enabled
      status
      note
    }
  }
}
    `;
export type ErpSetAiPluginEnabledMutationFn = Apollo.MutationFunction<ErpSetAiPluginEnabledMutation, ErpSetAiPluginEnabledMutationVariables>;

/**
 * __useErpSetAiPluginEnabledMutation__
 *
 * To run a mutation, you first call `useErpSetAiPluginEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSetAiPluginEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSetAiPluginEnabledMutation, { data, loading, error }] = useErpSetAiPluginEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useErpSetAiPluginEnabledMutation(baseOptions?: Apollo.MutationHookOptions<ErpSetAiPluginEnabledMutation, ErpSetAiPluginEnabledMutationVariables>) {
        return Apollo.useMutation<ErpSetAiPluginEnabledMutation, ErpSetAiPluginEnabledMutationVariables>(ErpSetAiPluginEnabledDocument, baseOptions);
      }
export type ErpSetAiPluginEnabledMutationHookResult = ReturnType<typeof useErpSetAiPluginEnabledMutation>;
export type ErpSetAiPluginEnabledMutationResult = Apollo.MutationResult<ErpSetAiPluginEnabledMutation>;
export type ErpSetAiPluginEnabledMutationOptions = Apollo.BaseMutationOptions<ErpSetAiPluginEnabledMutation, ErpSetAiPluginEnabledMutationVariables>;
export const ErpDeleteAiPluginDocument = gql`
    mutation ErpDeleteAiPlugin($id: ID!) {
  deleteAiPlugin(id: $id)
}
    `;
export type ErpDeleteAiPluginMutationFn = Apollo.MutationFunction<ErpDeleteAiPluginMutation, ErpDeleteAiPluginMutationVariables>;

/**
 * __useErpDeleteAiPluginMutation__
 *
 * To run a mutation, you first call `useErpDeleteAiPluginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpDeleteAiPluginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpDeleteAiPluginMutation, { data, loading, error }] = useErpDeleteAiPluginMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpDeleteAiPluginMutation(baseOptions?: Apollo.MutationHookOptions<ErpDeleteAiPluginMutation, ErpDeleteAiPluginMutationVariables>) {
        return Apollo.useMutation<ErpDeleteAiPluginMutation, ErpDeleteAiPluginMutationVariables>(ErpDeleteAiPluginDocument, baseOptions);
      }
export type ErpDeleteAiPluginMutationHookResult = ReturnType<typeof useErpDeleteAiPluginMutation>;
export type ErpDeleteAiPluginMutationResult = Apollo.MutationResult<ErpDeleteAiPluginMutation>;
export type ErpDeleteAiPluginMutationOptions = Apollo.BaseMutationOptions<ErpDeleteAiPluginMutation, ErpDeleteAiPluginMutationVariables>;
export const AppendTeacherApplicationDocument = gql`
    mutation appendTeacherApplication($application: ApplicationInputType!, $teacherId: ID!) {
  addTeacherApplication(application: $application, teacherId: $teacherId) {
    success
    customErrors {
      field
      message
      code
    }
    application {
      id
    }
  }
}
    `;
export type AppendTeacherApplicationMutationFn = Apollo.MutationFunction<AppendTeacherApplicationMutation, AppendTeacherApplicationMutationVariables>;

/**
 * __useAppendTeacherApplicationMutation__
 *
 * To run a mutation, you first call `useAppendTeacherApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendTeacherApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendTeacherApplicationMutation, { data, loading, error }] = useAppendTeacherApplicationMutation({
 *   variables: {
 *      application: // value for 'application'
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useAppendTeacherApplicationMutation(baseOptions?: Apollo.MutationHookOptions<AppendTeacherApplicationMutation, AppendTeacherApplicationMutationVariables>) {
        return Apollo.useMutation<AppendTeacherApplicationMutation, AppendTeacherApplicationMutationVariables>(AppendTeacherApplicationDocument, baseOptions);
      }
export type AppendTeacherApplicationMutationHookResult = ReturnType<typeof useAppendTeacherApplicationMutation>;
export type AppendTeacherApplicationMutationResult = Apollo.MutationResult<AppendTeacherApplicationMutation>;
export type AppendTeacherApplicationMutationOptions = Apollo.BaseMutationOptions<AppendTeacherApplicationMutation, AppendTeacherApplicationMutationVariables>;
export const UpdateTeacherApplicationDocument = gql`
    mutation updateTeacherApplication($application: UpdateApplicationInputType!) {
  updateTeacherApplication(application: $application) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type UpdateTeacherApplicationMutationFn = Apollo.MutationFunction<UpdateTeacherApplicationMutation, UpdateTeacherApplicationMutationVariables>;

/**
 * __useUpdateTeacherApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateTeacherApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeacherApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeacherApplicationMutation, { data, loading, error }] = useUpdateTeacherApplicationMutation({
 *   variables: {
 *      application: // value for 'application'
 *   },
 * });
 */
export function useUpdateTeacherApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeacherApplicationMutation, UpdateTeacherApplicationMutationVariables>) {
        return Apollo.useMutation<UpdateTeacherApplicationMutation, UpdateTeacherApplicationMutationVariables>(UpdateTeacherApplicationDocument, baseOptions);
      }
export type UpdateTeacherApplicationMutationHookResult = ReturnType<typeof useUpdateTeacherApplicationMutation>;
export type UpdateTeacherApplicationMutationResult = Apollo.MutationResult<UpdateTeacherApplicationMutation>;
export type UpdateTeacherApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateTeacherApplicationMutation, UpdateTeacherApplicationMutationVariables>;
export const RemoveApplicationDocument = gql`
    mutation removeApplication($id: ID!) {
  deleteTeacherApplication(applicationId: $id) {
    success
    errors
  }
}
    `;
export type RemoveApplicationMutationFn = Apollo.MutationFunction<RemoveApplicationMutation, RemoveApplicationMutationVariables>;

/**
 * __useRemoveApplicationMutation__
 *
 * To run a mutation, you first call `useRemoveApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeApplicationMutation, { data, loading, error }] = useRemoveApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveApplicationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveApplicationMutation, RemoveApplicationMutationVariables>) {
        return Apollo.useMutation<RemoveApplicationMutation, RemoveApplicationMutationVariables>(RemoveApplicationDocument, baseOptions);
      }
export type RemoveApplicationMutationHookResult = ReturnType<typeof useRemoveApplicationMutation>;
export type RemoveApplicationMutationResult = Apollo.MutationResult<RemoveApplicationMutation>;
export type RemoveApplicationMutationOptions = Apollo.BaseMutationOptions<RemoveApplicationMutation, RemoveApplicationMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken($refresh_token: String!, $scope: String!) {
  refreshToken(refreshToken: $refresh_token, scope: $scope) {
    token
    refreshToken
    payload
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refresh_token: // value for 'refresh_token'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, baseOptions);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation sendPasswordResetEmail($email: String!) {
  sendPasswordResetEmail(email: $email) {
    success
    errors
  }
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, baseOptions);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const PasswordSetDocument = gql`
    mutation passwordSet($newPassword1: String!, $newPassword2: String!, $token: String!) {
  passwordSet(
    newPassword1: $newPassword1
    newPassword2: $newPassword2
    token: $token
  ) {
    success
    errors
  }
}
    `;
export type PasswordSetMutationFn = Apollo.MutationFunction<PasswordSetMutation, PasswordSetMutationVariables>;

/**
 * __usePasswordSetMutation__
 *
 * To run a mutation, you first call `usePasswordSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordSetMutation, { data, loading, error }] = usePasswordSetMutation({
 *   variables: {
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePasswordSetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordSetMutation, PasswordSetMutationVariables>) {
        return Apollo.useMutation<PasswordSetMutation, PasswordSetMutationVariables>(PasswordSetDocument, baseOptions);
      }
export type PasswordSetMutationHookResult = ReturnType<typeof usePasswordSetMutation>;
export type PasswordSetMutationResult = Apollo.MutationResult<PasswordSetMutation>;
export type PasswordSetMutationOptions = Apollo.BaseMutationOptions<PasswordSetMutation, PasswordSetMutationVariables>;
export const PasswordResetDocument = gql`
    mutation passwordReset($newPassword1: String!, $newPassword2: String!, $token: String!) {
  passwordReset(
    newPassword1: $newPassword1
    newPassword2: $newPassword2
    token: $token
  ) {
    success
    errors
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, baseOptions);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const VerifyTokenDocument = gql`
    mutation verifyToken($token: String!) {
  verifyToken(token: $token) {
    success
    errors
  }
}
    `;
export type VerifyTokenMutationFn = Apollo.MutationFunction<VerifyTokenMutation, VerifyTokenMutationVariables>;

/**
 * __useVerifyTokenMutation__
 *
 * To run a mutation, you first call `useVerifyTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTokenMutation, { data, loading, error }] = useVerifyTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTokenMutation, VerifyTokenMutationVariables>) {
        return Apollo.useMutation<VerifyTokenMutation, VerifyTokenMutationVariables>(VerifyTokenDocument, baseOptions);
      }
export type VerifyTokenMutationHookResult = ReturnType<typeof useVerifyTokenMutation>;
export type VerifyTokenMutationResult = Apollo.MutationResult<VerifyTokenMutation>;
export type VerifyTokenMutationOptions = Apollo.BaseMutationOptions<VerifyTokenMutation, VerifyTokenMutationVariables>;
export const LoginDocument = gql`
    mutation login($password: String!, $email: String!, $scope: String!) {
  customLogin(password: $password, email: $email, scope: $scope) {
    success
    errors
    token
    refreshToken
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      password: // value for 'password'
 *      email: // value for 'email'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, baseOptions);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const EnrollToCareerCenterDocument = gql`
    mutation EnrollToCareerCenter($studentIds: [ID!], $groupId: ID, $directionId: ID) {
  enrollCareerMembers(
    studentIds: $studentIds
    groupId: $groupId
    directionId: $directionId
  ) {
    success
    customErrors {
      field
      message
      code
    }
    created
    reactivated
    skipped
  }
}
    `;
export type EnrollToCareerCenterMutationFn = Apollo.MutationFunction<EnrollToCareerCenterMutation, EnrollToCareerCenterMutationVariables>;

/**
 * __useEnrollToCareerCenterMutation__
 *
 * To run a mutation, you first call `useEnrollToCareerCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollToCareerCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollToCareerCenterMutation, { data, loading, error }] = useEnrollToCareerCenterMutation({
 *   variables: {
 *      studentIds: // value for 'studentIds'
 *      groupId: // value for 'groupId'
 *      directionId: // value for 'directionId'
 *   },
 * });
 */
export function useEnrollToCareerCenterMutation(baseOptions?: Apollo.MutationHookOptions<EnrollToCareerCenterMutation, EnrollToCareerCenterMutationVariables>) {
        return Apollo.useMutation<EnrollToCareerCenterMutation, EnrollToCareerCenterMutationVariables>(EnrollToCareerCenterDocument, baseOptions);
      }
export type EnrollToCareerCenterMutationHookResult = ReturnType<typeof useEnrollToCareerCenterMutation>;
export type EnrollToCareerCenterMutationResult = Apollo.MutationResult<EnrollToCareerCenterMutation>;
export type EnrollToCareerCenterMutationOptions = Apollo.BaseMutationOptions<EnrollToCareerCenterMutation, EnrollToCareerCenterMutationVariables>;
export const SetCareerMembersAccessDocument = gql`
    mutation SetCareerMembersAccess($memberIds: [ID!]!, $removed: Boolean!) {
  setCareerMembersAccess(memberIds: $memberIds, removed: $removed) {
    success
    customErrors {
      code
      field
      message
    }
    changed
    unchanged
    missing
  }
}
    `;
export type SetCareerMembersAccessMutationFn = Apollo.MutationFunction<SetCareerMembersAccessMutation, SetCareerMembersAccessMutationVariables>;

/**
 * __useSetCareerMembersAccessMutation__
 *
 * To run a mutation, you first call `useSetCareerMembersAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCareerMembersAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCareerMembersAccessMutation, { data, loading, error }] = useSetCareerMembersAccessMutation({
 *   variables: {
 *      memberIds: // value for 'memberIds'
 *      removed: // value for 'removed'
 *   },
 * });
 */
export function useSetCareerMembersAccessMutation(baseOptions?: Apollo.MutationHookOptions<SetCareerMembersAccessMutation, SetCareerMembersAccessMutationVariables>) {
        return Apollo.useMutation<SetCareerMembersAccessMutation, SetCareerMembersAccessMutationVariables>(SetCareerMembersAccessDocument, baseOptions);
      }
export type SetCareerMembersAccessMutationHookResult = ReturnType<typeof useSetCareerMembersAccessMutation>;
export type SetCareerMembersAccessMutationResult = Apollo.MutationResult<SetCareerMembersAccessMutation>;
export type SetCareerMembersAccessMutationOptions = Apollo.BaseMutationOptions<SetCareerMembersAccessMutation, SetCareerMembersAccessMutationVariables>;
export const SaveCareerMemberDocument = gql`
    mutation SaveCareerMember($id: ID!, $input: CareerMemberInput!) {
  updateCareerMember(id: $id, input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    member {
      id
      studentId
      studentName
      studentEmail
      groupId
      groupName
      directionId
      directionTitle
      status
      enrolledAt
      notes
      lessonsCompleted
      lessonsTotal
    }
  }
}
    `;
export type SaveCareerMemberMutationFn = Apollo.MutationFunction<SaveCareerMemberMutation, SaveCareerMemberMutationVariables>;

/**
 * __useSaveCareerMemberMutation__
 *
 * To run a mutation, you first call `useSaveCareerMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCareerMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCareerMemberMutation, { data, loading, error }] = useSaveCareerMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCareerMemberMutation(baseOptions?: Apollo.MutationHookOptions<SaveCareerMemberMutation, SaveCareerMemberMutationVariables>) {
        return Apollo.useMutation<SaveCareerMemberMutation, SaveCareerMemberMutationVariables>(SaveCareerMemberDocument, baseOptions);
      }
export type SaveCareerMemberMutationHookResult = ReturnType<typeof useSaveCareerMemberMutation>;
export type SaveCareerMemberMutationResult = Apollo.MutationResult<SaveCareerMemberMutation>;
export type SaveCareerMemberMutationOptions = Apollo.BaseMutationOptions<SaveCareerMemberMutation, SaveCareerMemberMutationVariables>;
export const SaveCareerLessonDocument = gql`
    mutation SaveCareerLesson($id: ID, $input: CareerLessonInput!) {
  upsertCareerLesson(id: $id, input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    lesson {
      id
      order
      title
      summary
      content
      durationMin
      completionKind
      artifactHint
      outcomeKind
      outcomeLabel
      materialLanguage
      isPublished
      videoUrl
      attachments {
        id
        originalName
        contentType
        sizeBytes
        url
      }
      stats {
        openedCount
        completedCount
        membersTotal
      }
      quizQuestions {
        id
        order
        text
        options
        correctIndexes
      }
    }
  }
}
    `;
export type SaveCareerLessonMutationFn = Apollo.MutationFunction<SaveCareerLessonMutation, SaveCareerLessonMutationVariables>;

/**
 * __useSaveCareerLessonMutation__
 *
 * To run a mutation, you first call `useSaveCareerLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCareerLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCareerLessonMutation, { data, loading, error }] = useSaveCareerLessonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCareerLessonMutation(baseOptions?: Apollo.MutationHookOptions<SaveCareerLessonMutation, SaveCareerLessonMutationVariables>) {
        return Apollo.useMutation<SaveCareerLessonMutation, SaveCareerLessonMutationVariables>(SaveCareerLessonDocument, baseOptions);
      }
export type SaveCareerLessonMutationHookResult = ReturnType<typeof useSaveCareerLessonMutation>;
export type SaveCareerLessonMutationResult = Apollo.MutationResult<SaveCareerLessonMutation>;
export type SaveCareerLessonMutationOptions = Apollo.BaseMutationOptions<SaveCareerLessonMutation, SaveCareerLessonMutationVariables>;
export const AttachCareerLessonVideoDocument = gql`
    mutation AttachCareerLessonVideo($lessonId: ID!, $video: Upload!) {
  uploadCareerLessonVideo(lessonId: $lessonId, video: $video) {
    success
    customErrors {
      field
      message
      code
    }
    lesson {
      id
      videoUrl
      attachments {
        id
        originalName
        contentType
        sizeBytes
        url
      }
    }
  }
}
    `;
export type AttachCareerLessonVideoMutationFn = Apollo.MutationFunction<AttachCareerLessonVideoMutation, AttachCareerLessonVideoMutationVariables>;

/**
 * __useAttachCareerLessonVideoMutation__
 *
 * To run a mutation, you first call `useAttachCareerLessonVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachCareerLessonVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachCareerLessonVideoMutation, { data, loading, error }] = useAttachCareerLessonVideoMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      video: // value for 'video'
 *   },
 * });
 */
export function useAttachCareerLessonVideoMutation(baseOptions?: Apollo.MutationHookOptions<AttachCareerLessonVideoMutation, AttachCareerLessonVideoMutationVariables>) {
        return Apollo.useMutation<AttachCareerLessonVideoMutation, AttachCareerLessonVideoMutationVariables>(AttachCareerLessonVideoDocument, baseOptions);
      }
export type AttachCareerLessonVideoMutationHookResult = ReturnType<typeof useAttachCareerLessonVideoMutation>;
export type AttachCareerLessonVideoMutationResult = Apollo.MutationResult<AttachCareerLessonVideoMutation>;
export type AttachCareerLessonVideoMutationOptions = Apollo.BaseMutationOptions<AttachCareerLessonVideoMutation, AttachCareerLessonVideoMutationVariables>;
export const RemoveCareerLessonVideoDocument = gql`
    mutation RemoveCareerLessonVideo($lessonId: ID!) {
  clearCareerLessonVideo(lessonId: $lessonId) {
    success
    customErrors {
      field
      message
      code
    }
    lesson {
      id
      videoUrl
      attachments {
        id
        originalName
        contentType
        sizeBytes
        url
      }
    }
  }
}
    `;
export type RemoveCareerLessonVideoMutationFn = Apollo.MutationFunction<RemoveCareerLessonVideoMutation, RemoveCareerLessonVideoMutationVariables>;

/**
 * __useRemoveCareerLessonVideoMutation__
 *
 * To run a mutation, you first call `useRemoveCareerLessonVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCareerLessonVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCareerLessonVideoMutation, { data, loading, error }] = useRemoveCareerLessonVideoMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useRemoveCareerLessonVideoMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCareerLessonVideoMutation, RemoveCareerLessonVideoMutationVariables>) {
        return Apollo.useMutation<RemoveCareerLessonVideoMutation, RemoveCareerLessonVideoMutationVariables>(RemoveCareerLessonVideoDocument, baseOptions);
      }
export type RemoveCareerLessonVideoMutationHookResult = ReturnType<typeof useRemoveCareerLessonVideoMutation>;
export type RemoveCareerLessonVideoMutationResult = Apollo.MutationResult<RemoveCareerLessonVideoMutation>;
export type RemoveCareerLessonVideoMutationOptions = Apollo.BaseMutationOptions<RemoveCareerLessonVideoMutation, RemoveCareerLessonVideoMutationVariables>;
export const AttachCareerLessonFileDocument = gql`
    mutation AttachCareerLessonFile($lessonId: ID!, $file: Upload!) {
  addCareerLessonAttachment(lessonId: $lessonId, file: $file) {
    success
    customErrors {
      field
      message
      code
    }
    attachment {
      id
      originalName
      contentType
      sizeBytes
      url
    }
    lesson {
      id
      videoUrl
      attachments {
        id
        originalName
        contentType
        sizeBytes
        url
      }
    }
  }
}
    `;
export type AttachCareerLessonFileMutationFn = Apollo.MutationFunction<AttachCareerLessonFileMutation, AttachCareerLessonFileMutationVariables>;

/**
 * __useAttachCareerLessonFileMutation__
 *
 * To run a mutation, you first call `useAttachCareerLessonFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachCareerLessonFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachCareerLessonFileMutation, { data, loading, error }] = useAttachCareerLessonFileMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useAttachCareerLessonFileMutation(baseOptions?: Apollo.MutationHookOptions<AttachCareerLessonFileMutation, AttachCareerLessonFileMutationVariables>) {
        return Apollo.useMutation<AttachCareerLessonFileMutation, AttachCareerLessonFileMutationVariables>(AttachCareerLessonFileDocument, baseOptions);
      }
export type AttachCareerLessonFileMutationHookResult = ReturnType<typeof useAttachCareerLessonFileMutation>;
export type AttachCareerLessonFileMutationResult = Apollo.MutationResult<AttachCareerLessonFileMutation>;
export type AttachCareerLessonFileMutationOptions = Apollo.BaseMutationOptions<AttachCareerLessonFileMutation, AttachCareerLessonFileMutationVariables>;
export const DetachCareerLessonFileDocument = gql`
    mutation DetachCareerLessonFile($attachmentId: ID!) {
  removeCareerLessonAttachment(attachmentId: $attachmentId) {
    success
    ok
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type DetachCareerLessonFileMutationFn = Apollo.MutationFunction<DetachCareerLessonFileMutation, DetachCareerLessonFileMutationVariables>;

/**
 * __useDetachCareerLessonFileMutation__
 *
 * To run a mutation, you first call `useDetachCareerLessonFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachCareerLessonFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachCareerLessonFileMutation, { data, loading, error }] = useDetachCareerLessonFileMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDetachCareerLessonFileMutation(baseOptions?: Apollo.MutationHookOptions<DetachCareerLessonFileMutation, DetachCareerLessonFileMutationVariables>) {
        return Apollo.useMutation<DetachCareerLessonFileMutation, DetachCareerLessonFileMutationVariables>(DetachCareerLessonFileDocument, baseOptions);
      }
export type DetachCareerLessonFileMutationHookResult = ReturnType<typeof useDetachCareerLessonFileMutation>;
export type DetachCareerLessonFileMutationResult = Apollo.MutationResult<DetachCareerLessonFileMutation>;
export type DetachCareerLessonFileMutationOptions = Apollo.BaseMutationOptions<DetachCareerLessonFileMutation, DetachCareerLessonFileMutationVariables>;
export const SaveCareerLessonQuizDocument = gql`
    mutation SaveCareerLessonQuiz($lessonId: ID!, $questions: [CareerQuizQuestionInput!]!) {
  setCareerLessonQuiz(lessonId: $lessonId, questions: $questions) {
    success
    customErrors {
      field
      message
      code
    }
    lesson {
      id
      quizQuestions {
        id
        order
        text
        options
        correctIndexes
      }
    }
  }
}
    `;
export type SaveCareerLessonQuizMutationFn = Apollo.MutationFunction<SaveCareerLessonQuizMutation, SaveCareerLessonQuizMutationVariables>;

/**
 * __useSaveCareerLessonQuizMutation__
 *
 * To run a mutation, you first call `useSaveCareerLessonQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCareerLessonQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCareerLessonQuizMutation, { data, loading, error }] = useSaveCareerLessonQuizMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      questions: // value for 'questions'
 *   },
 * });
 */
export function useSaveCareerLessonQuizMutation(baseOptions?: Apollo.MutationHookOptions<SaveCareerLessonQuizMutation, SaveCareerLessonQuizMutationVariables>) {
        return Apollo.useMutation<SaveCareerLessonQuizMutation, SaveCareerLessonQuizMutationVariables>(SaveCareerLessonQuizDocument, baseOptions);
      }
export type SaveCareerLessonQuizMutationHookResult = ReturnType<typeof useSaveCareerLessonQuizMutation>;
export type SaveCareerLessonQuizMutationResult = Apollo.MutationResult<SaveCareerLessonQuizMutation>;
export type SaveCareerLessonQuizMutationOptions = Apollo.BaseMutationOptions<SaveCareerLessonQuizMutation, SaveCareerLessonQuizMutationVariables>;
export const UpsertVacancyDocument = gql`
    mutation UpsertVacancy($id: ID, $input: VacancyInput!) {
  upsertVacancy(id: $id, input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    vacancy {
      ...ErpVacancyFields
    }
  }
}
    ${ErpVacancyFieldsFragmentDoc}`;
export type UpsertVacancyMutationFn = Apollo.MutationFunction<UpsertVacancyMutation, UpsertVacancyMutationVariables>;

/**
 * __useUpsertVacancyMutation__
 *
 * To run a mutation, you first call `useUpsertVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVacancyMutation, { data, loading, error }] = useUpsertVacancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertVacancyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertVacancyMutation, UpsertVacancyMutationVariables>) {
        return Apollo.useMutation<UpsertVacancyMutation, UpsertVacancyMutationVariables>(UpsertVacancyDocument, baseOptions);
      }
export type UpsertVacancyMutationHookResult = ReturnType<typeof useUpsertVacancyMutation>;
export type UpsertVacancyMutationResult = Apollo.MutationResult<UpsertVacancyMutation>;
export type UpsertVacancyMutationOptions = Apollo.BaseMutationOptions<UpsertVacancyMutation, UpsertVacancyMutationVariables>;
export const DeleteVacancyDocument = gql`
    mutation DeleteVacancy($id: ID!) {
  deleteVacancy(id: $id) {
    success
    ok
    deletedInteractions
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type DeleteVacancyMutationFn = Apollo.MutationFunction<DeleteVacancyMutation, DeleteVacancyMutationVariables>;

/**
 * __useDeleteVacancyMutation__
 *
 * To run a mutation, you first call `useDeleteVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVacancyMutation, { data, loading, error }] = useDeleteVacancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVacancyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVacancyMutation, DeleteVacancyMutationVariables>) {
        return Apollo.useMutation<DeleteVacancyMutation, DeleteVacancyMutationVariables>(DeleteVacancyDocument, baseOptions);
      }
export type DeleteVacancyMutationHookResult = ReturnType<typeof useDeleteVacancyMutation>;
export type DeleteVacancyMutationResult = Apollo.MutationResult<DeleteVacancyMutation>;
export type DeleteVacancyMutationOptions = Apollo.BaseMutationOptions<DeleteVacancyMutation, DeleteVacancyMutationVariables>;
export const SetVacancyStatusDocument = gql`
    mutation SetVacancyStatus($id: ID!, $status: String!) {
  setVacancyStatus(id: $id, status: $status) {
    success
    customErrors {
      field
      message
      code
    }
    vacancy {
      ...ErpVacancyFields
    }
  }
}
    ${ErpVacancyFieldsFragmentDoc}`;
export type SetVacancyStatusMutationFn = Apollo.MutationFunction<SetVacancyStatusMutation, SetVacancyStatusMutationVariables>;

/**
 * __useSetVacancyStatusMutation__
 *
 * To run a mutation, you first call `useSetVacancyStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVacancyStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVacancyStatusMutation, { data, loading, error }] = useSetVacancyStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetVacancyStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetVacancyStatusMutation, SetVacancyStatusMutationVariables>) {
        return Apollo.useMutation<SetVacancyStatusMutation, SetVacancyStatusMutationVariables>(SetVacancyStatusDocument, baseOptions);
      }
export type SetVacancyStatusMutationHookResult = ReturnType<typeof useSetVacancyStatusMutation>;
export type SetVacancyStatusMutationResult = Apollo.MutationResult<SetVacancyStatusMutation>;
export type SetVacancyStatusMutationOptions = Apollo.BaseMutationOptions<SetVacancyStatusMutation, SetVacancyStatusMutationVariables>;
export const BulkPublishVacanciesDocument = gql`
    mutation BulkPublishVacancies($ids: [ID!]!) {
  bulkPublishVacancies(ids: $ids) {
    success
    customErrors {
      field
      message
      code
    }
    published
  }
}
    `;
export type BulkPublishVacanciesMutationFn = Apollo.MutationFunction<BulkPublishVacanciesMutation, BulkPublishVacanciesMutationVariables>;

/**
 * __useBulkPublishVacanciesMutation__
 *
 * To run a mutation, you first call `useBulkPublishVacanciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPublishVacanciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPublishVacanciesMutation, { data, loading, error }] = useBulkPublishVacanciesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkPublishVacanciesMutation(baseOptions?: Apollo.MutationHookOptions<BulkPublishVacanciesMutation, BulkPublishVacanciesMutationVariables>) {
        return Apollo.useMutation<BulkPublishVacanciesMutation, BulkPublishVacanciesMutationVariables>(BulkPublishVacanciesDocument, baseOptions);
      }
export type BulkPublishVacanciesMutationHookResult = ReturnType<typeof useBulkPublishVacanciesMutation>;
export type BulkPublishVacanciesMutationResult = Apollo.MutationResult<BulkPublishVacanciesMutation>;
export type BulkPublishVacanciesMutationOptions = Apollo.BaseMutationOptions<BulkPublishVacanciesMutation, BulkPublishVacanciesMutationVariables>;
export const RecordPlacementDocument = gql`
    mutation RecordPlacement($memberId: ID!, $input: PlacementInput!) {
  recordPlacement(memberId: $memberId, input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    placement {
      id
      memberId
      studentName
      companyName
      position
      startedAt
      confirmedAt
    }
  }
}
    `;
export type RecordPlacementMutationFn = Apollo.MutationFunction<RecordPlacementMutation, RecordPlacementMutationVariables>;

/**
 * __useRecordPlacementMutation__
 *
 * To run a mutation, you first call `useRecordPlacementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPlacementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPlacementMutation, { data, loading, error }] = useRecordPlacementMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordPlacementMutation(baseOptions?: Apollo.MutationHookOptions<RecordPlacementMutation, RecordPlacementMutationVariables>) {
        return Apollo.useMutation<RecordPlacementMutation, RecordPlacementMutationVariables>(RecordPlacementDocument, baseOptions);
      }
export type RecordPlacementMutationHookResult = ReturnType<typeof useRecordPlacementMutation>;
export type RecordPlacementMutationResult = Apollo.MutationResult<RecordPlacementMutation>;
export type RecordPlacementMutationOptions = Apollo.BaseMutationOptions<RecordPlacementMutation, RecordPlacementMutationVariables>;
export const BulkSetVacancyStatusDocument = gql`
    mutation BulkSetVacancyStatus($ids: [ID!]!, $status: String!) {
  bulkSetVacancyStatus(ids: $ids, status: $status) {
    success
    moved
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type BulkSetVacancyStatusMutationFn = Apollo.MutationFunction<BulkSetVacancyStatusMutation, BulkSetVacancyStatusMutationVariables>;

/**
 * __useBulkSetVacancyStatusMutation__
 *
 * To run a mutation, you first call `useBulkSetVacancyStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSetVacancyStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSetVacancyStatusMutation, { data, loading, error }] = useBulkSetVacancyStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBulkSetVacancyStatusMutation(baseOptions?: Apollo.MutationHookOptions<BulkSetVacancyStatusMutation, BulkSetVacancyStatusMutationVariables>) {
        return Apollo.useMutation<BulkSetVacancyStatusMutation, BulkSetVacancyStatusMutationVariables>(BulkSetVacancyStatusDocument, baseOptions);
      }
export type BulkSetVacancyStatusMutationHookResult = ReturnType<typeof useBulkSetVacancyStatusMutation>;
export type BulkSetVacancyStatusMutationResult = Apollo.MutationResult<BulkSetVacancyStatusMutation>;
export type BulkSetVacancyStatusMutationOptions = Apollo.BaseMutationOptions<BulkSetVacancyStatusMutation, BulkSetVacancyStatusMutationVariables>;
export const SaveCareerSkillDocument = gql`
    mutation SaveCareerSkill($input: CareerSkillInput!) {
  upsertCareerSkill(input: $input) {
    success
    skill {
      id
      name
      slug
      category
      description
      isActive
      levelCriteria {
        level
        points
        example
      }
    }
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveCareerSkillMutationFn = Apollo.MutationFunction<SaveCareerSkillMutation, SaveCareerSkillMutationVariables>;

/**
 * __useSaveCareerSkillMutation__
 *
 * To run a mutation, you first call `useSaveCareerSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCareerSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCareerSkillMutation, { data, loading, error }] = useSaveCareerSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCareerSkillMutation(baseOptions?: Apollo.MutationHookOptions<SaveCareerSkillMutation, SaveCareerSkillMutationVariables>) {
        return Apollo.useMutation<SaveCareerSkillMutation, SaveCareerSkillMutationVariables>(SaveCareerSkillDocument, baseOptions);
      }
export type SaveCareerSkillMutationHookResult = ReturnType<typeof useSaveCareerSkillMutation>;
export type SaveCareerSkillMutationResult = Apollo.MutationResult<SaveCareerSkillMutation>;
export type SaveCareerSkillMutationOptions = Apollo.BaseMutationOptions<SaveCareerSkillMutation, SaveCareerSkillMutationVariables>;
export const ToggleCareerSkillDocument = gql`
    mutation ToggleCareerSkill($id: ID!, $isActive: Boolean!) {
  setCareerSkillActive(id: $id, isActive: $isActive) {
    success
    skill {
      id
      isActive
    }
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type ToggleCareerSkillMutationFn = Apollo.MutationFunction<ToggleCareerSkillMutation, ToggleCareerSkillMutationVariables>;

/**
 * __useToggleCareerSkillMutation__
 *
 * To run a mutation, you first call `useToggleCareerSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCareerSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCareerSkillMutation, { data, loading, error }] = useToggleCareerSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useToggleCareerSkillMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCareerSkillMutation, ToggleCareerSkillMutationVariables>) {
        return Apollo.useMutation<ToggleCareerSkillMutation, ToggleCareerSkillMutationVariables>(ToggleCareerSkillDocument, baseOptions);
      }
export type ToggleCareerSkillMutationHookResult = ReturnType<typeof useToggleCareerSkillMutation>;
export type ToggleCareerSkillMutationResult = Apollo.MutationResult<ToggleCareerSkillMutation>;
export type ToggleCareerSkillMutationOptions = Apollo.BaseMutationOptions<ToggleCareerSkillMutation, ToggleCareerSkillMutationVariables>;
export const SaveCareerSkillIconDocument = gql`
    mutation SaveCareerSkillIcon($id: ID!, $icon: Upload, $clear: Boolean) {
  setCareerSkillIcon(id: $id, icon: $icon, clear: $clear) {
    success
    skill {
      id
      iconUrl
    }
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveCareerSkillIconMutationFn = Apollo.MutationFunction<SaveCareerSkillIconMutation, SaveCareerSkillIconMutationVariables>;

/**
 * __useSaveCareerSkillIconMutation__
 *
 * To run a mutation, you first call `useSaveCareerSkillIconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCareerSkillIconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCareerSkillIconMutation, { data, loading, error }] = useSaveCareerSkillIconMutation({
 *   variables: {
 *      id: // value for 'id'
 *      icon: // value for 'icon'
 *      clear: // value for 'clear'
 *   },
 * });
 */
export function useSaveCareerSkillIconMutation(baseOptions?: Apollo.MutationHookOptions<SaveCareerSkillIconMutation, SaveCareerSkillIconMutationVariables>) {
        return Apollo.useMutation<SaveCareerSkillIconMutation, SaveCareerSkillIconMutationVariables>(SaveCareerSkillIconDocument, baseOptions);
      }
export type SaveCareerSkillIconMutationHookResult = ReturnType<typeof useSaveCareerSkillIconMutation>;
export type SaveCareerSkillIconMutationResult = Apollo.MutationResult<SaveCareerSkillIconMutation>;
export type SaveCareerSkillIconMutationOptions = Apollo.BaseMutationOptions<SaveCareerSkillIconMutation, SaveCareerSkillIconMutationVariables>;
export const JoinCareerSkillsDocument = gql`
    mutation JoinCareerSkills($sourceId: ID!, $targetId: ID!) {
  mergeCareerSkills(sourceId: $sourceId, targetId: $targetId) {
    success
    movedStudentSkills
    movedVacancies
    movedProjects
    movedCourseSkills
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type JoinCareerSkillsMutationFn = Apollo.MutationFunction<JoinCareerSkillsMutation, JoinCareerSkillsMutationVariables>;

/**
 * __useJoinCareerSkillsMutation__
 *
 * To run a mutation, you first call `useJoinCareerSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCareerSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCareerSkillsMutation, { data, loading, error }] = useJoinCareerSkillsMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useJoinCareerSkillsMutation(baseOptions?: Apollo.MutationHookOptions<JoinCareerSkillsMutation, JoinCareerSkillsMutationVariables>) {
        return Apollo.useMutation<JoinCareerSkillsMutation, JoinCareerSkillsMutationVariables>(JoinCareerSkillsDocument, baseOptions);
      }
export type JoinCareerSkillsMutationHookResult = ReturnType<typeof useJoinCareerSkillsMutation>;
export type JoinCareerSkillsMutationResult = Apollo.MutationResult<JoinCareerSkillsMutation>;
export type JoinCareerSkillsMutationOptions = Apollo.BaseMutationOptions<JoinCareerSkillsMutation, JoinCareerSkillsMutationVariables>;
export const SaveGroupSkillsDocument = gql`
    mutation SaveGroupSkills($groupId: ID!, $rows: [GroupSkillInput!]!) {
  setGroupSkills(groupId: $groupId, rows: $rows) {
    success
    added
    updated
    deactivated
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveGroupSkillsMutationFn = Apollo.MutationFunction<SaveGroupSkillsMutation, SaveGroupSkillsMutationVariables>;

/**
 * __useSaveGroupSkillsMutation__
 *
 * To run a mutation, you first call `useSaveGroupSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGroupSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGroupSkillsMutation, { data, loading, error }] = useSaveGroupSkillsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      rows: // value for 'rows'
 *   },
 * });
 */
export function useSaveGroupSkillsMutation(baseOptions?: Apollo.MutationHookOptions<SaveGroupSkillsMutation, SaveGroupSkillsMutationVariables>) {
        return Apollo.useMutation<SaveGroupSkillsMutation, SaveGroupSkillsMutationVariables>(SaveGroupSkillsDocument, baseOptions);
      }
export type SaveGroupSkillsMutationHookResult = ReturnType<typeof useSaveGroupSkillsMutation>;
export type SaveGroupSkillsMutationResult = Apollo.MutationResult<SaveGroupSkillsMutation>;
export type SaveGroupSkillsMutationOptions = Apollo.BaseMutationOptions<SaveGroupSkillsMutation, SaveGroupSkillsMutationVariables>;
export const SaveCourseSkillsDocument = gql`
    mutation SaveCourseSkills($courseId: ID!, $rows: [CourseSkillInput!]!) {
  setCourseSkills(courseId: $courseId, rows: $rows) {
    success
    added
    updated
    deactivated
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveCourseSkillsMutationFn = Apollo.MutationFunction<SaveCourseSkillsMutation, SaveCourseSkillsMutationVariables>;

/**
 * __useSaveCourseSkillsMutation__
 *
 * To run a mutation, you first call `useSaveCourseSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCourseSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCourseSkillsMutation, { data, loading, error }] = useSaveCourseSkillsMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      rows: // value for 'rows'
 *   },
 * });
 */
export function useSaveCourseSkillsMutation(baseOptions?: Apollo.MutationHookOptions<SaveCourseSkillsMutation, SaveCourseSkillsMutationVariables>) {
        return Apollo.useMutation<SaveCourseSkillsMutation, SaveCourseSkillsMutationVariables>(SaveCourseSkillsDocument, baseOptions);
      }
export type SaveCourseSkillsMutationHookResult = ReturnType<typeof useSaveCourseSkillsMutation>;
export type SaveCourseSkillsMutationResult = Apollo.MutationResult<SaveCourseSkillsMutation>;
export type SaveCourseSkillsMutationOptions = Apollo.BaseMutationOptions<SaveCourseSkillsMutation, SaveCourseSkillsMutationVariables>;
export const SaveCourseCompletionDocument = gql`
    mutation SaveCourseCompletion($studentId: ID!, $courseId: ID!, $status: String!, $note: String) {
  setCourseCompletion(
    studentId: $studentId
    courseId: $courseId
    status: $status
    note: $note
  ) {
    success
    completedCourseIds
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveCourseCompletionMutationFn = Apollo.MutationFunction<SaveCourseCompletionMutation, SaveCourseCompletionMutationVariables>;

/**
 * __useSaveCourseCompletionMutation__
 *
 * To run a mutation, you first call `useSaveCourseCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCourseCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCourseCompletionMutation, { data, loading, error }] = useSaveCourseCompletionMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      courseId: // value for 'courseId'
 *      status: // value for 'status'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSaveCourseCompletionMutation(baseOptions?: Apollo.MutationHookOptions<SaveCourseCompletionMutation, SaveCourseCompletionMutationVariables>) {
        return Apollo.useMutation<SaveCourseCompletionMutation, SaveCourseCompletionMutationVariables>(SaveCourseCompletionDocument, baseOptions);
      }
export type SaveCourseCompletionMutationHookResult = ReturnType<typeof useSaveCourseCompletionMutation>;
export type SaveCourseCompletionMutationResult = Apollo.MutationResult<SaveCourseCompletionMutation>;
export type SaveCourseCompletionMutationOptions = Apollo.BaseMutationOptions<SaveCourseCompletionMutation, SaveCourseCompletionMutationVariables>;
export const RecalcStudentCourseSkillsDocument = gql`
    mutation RecalcStudentCourseSkills($studentId: ID!) {
  syncStudentCourseSkills(studentId: $studentId) {
    success
    granted
    promoted
    demoted
    unchanged
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type RecalcStudentCourseSkillsMutationFn = Apollo.MutationFunction<RecalcStudentCourseSkillsMutation, RecalcStudentCourseSkillsMutationVariables>;

/**
 * __useRecalcStudentCourseSkillsMutation__
 *
 * To run a mutation, you first call `useRecalcStudentCourseSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalcStudentCourseSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalcStudentCourseSkillsMutation, { data, loading, error }] = useRecalcStudentCourseSkillsMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useRecalcStudentCourseSkillsMutation(baseOptions?: Apollo.MutationHookOptions<RecalcStudentCourseSkillsMutation, RecalcStudentCourseSkillsMutationVariables>) {
        return Apollo.useMutation<RecalcStudentCourseSkillsMutation, RecalcStudentCourseSkillsMutationVariables>(RecalcStudentCourseSkillsDocument, baseOptions);
      }
export type RecalcStudentCourseSkillsMutationHookResult = ReturnType<typeof useRecalcStudentCourseSkillsMutation>;
export type RecalcStudentCourseSkillsMutationResult = Apollo.MutationResult<RecalcStudentCourseSkillsMutation>;
export type RecalcStudentCourseSkillsMutationOptions = Apollo.BaseMutationOptions<RecalcStudentCourseSkillsMutation, RecalcStudentCourseSkillsMutationVariables>;
export const SaveCareerExerciseTemplateDocument = gql`
    mutation SaveCareerExerciseTemplate($templateId: ID, $title: String!, $intro: String, $outro: String, $fields: [CareerExerciseFieldInput!]!) {
  saveCareerExerciseTemplate(
    templateId: $templateId
    title: $title
    intro: $intro
    outro: $outro
    fields: $fields
  ) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveCareerExerciseTemplateMutationFn = Apollo.MutationFunction<SaveCareerExerciseTemplateMutation, SaveCareerExerciseTemplateMutationVariables>;

/**
 * __useSaveCareerExerciseTemplateMutation__
 *
 * To run a mutation, you first call `useSaveCareerExerciseTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCareerExerciseTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCareerExerciseTemplateMutation, { data, loading, error }] = useSaveCareerExerciseTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      title: // value for 'title'
 *      intro: // value for 'intro'
 *      outro: // value for 'outro'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useSaveCareerExerciseTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveCareerExerciseTemplateMutation, SaveCareerExerciseTemplateMutationVariables>) {
        return Apollo.useMutation<SaveCareerExerciseTemplateMutation, SaveCareerExerciseTemplateMutationVariables>(SaveCareerExerciseTemplateDocument, baseOptions);
      }
export type SaveCareerExerciseTemplateMutationHookResult = ReturnType<typeof useSaveCareerExerciseTemplateMutation>;
export type SaveCareerExerciseTemplateMutationResult = Apollo.MutationResult<SaveCareerExerciseTemplateMutation>;
export type SaveCareerExerciseTemplateMutationOptions = Apollo.BaseMutationOptions<SaveCareerExerciseTemplateMutation, SaveCareerExerciseTemplateMutationVariables>;
export const ToggleCareerExerciseTemplateDocument = gql`
    mutation ToggleCareerExerciseTemplate($templateId: ID!, $isActive: Boolean!) {
  toggleCareerExerciseTemplate(templateId: $templateId, isActive: $isActive) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type ToggleCareerExerciseTemplateMutationFn = Apollo.MutationFunction<ToggleCareerExerciseTemplateMutation, ToggleCareerExerciseTemplateMutationVariables>;

/**
 * __useToggleCareerExerciseTemplateMutation__
 *
 * To run a mutation, you first call `useToggleCareerExerciseTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCareerExerciseTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCareerExerciseTemplateMutation, { data, loading, error }] = useToggleCareerExerciseTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useToggleCareerExerciseTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCareerExerciseTemplateMutation, ToggleCareerExerciseTemplateMutationVariables>) {
        return Apollo.useMutation<ToggleCareerExerciseTemplateMutation, ToggleCareerExerciseTemplateMutationVariables>(ToggleCareerExerciseTemplateDocument, baseOptions);
      }
export type ToggleCareerExerciseTemplateMutationHookResult = ReturnType<typeof useToggleCareerExerciseTemplateMutation>;
export type ToggleCareerExerciseTemplateMutationResult = Apollo.MutationResult<ToggleCareerExerciseTemplateMutation>;
export type ToggleCareerExerciseTemplateMutationOptions = Apollo.BaseMutationOptions<ToggleCareerExerciseTemplateMutation, ToggleCareerExerciseTemplateMutationVariables>;
export const AttachCareerExerciseTemplateDocument = gql`
    mutation AttachCareerExerciseTemplate($lessonId: ID!, $templateId: ID!) {
  attachCareerExerciseTemplate(lessonId: $lessonId, templateId: $templateId) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type AttachCareerExerciseTemplateMutationFn = Apollo.MutationFunction<AttachCareerExerciseTemplateMutation, AttachCareerExerciseTemplateMutationVariables>;

/**
 * __useAttachCareerExerciseTemplateMutation__
 *
 * To run a mutation, you first call `useAttachCareerExerciseTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachCareerExerciseTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachCareerExerciseTemplateMutation, { data, loading, error }] = useAttachCareerExerciseTemplateMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useAttachCareerExerciseTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AttachCareerExerciseTemplateMutation, AttachCareerExerciseTemplateMutationVariables>) {
        return Apollo.useMutation<AttachCareerExerciseTemplateMutation, AttachCareerExerciseTemplateMutationVariables>(AttachCareerExerciseTemplateDocument, baseOptions);
      }
export type AttachCareerExerciseTemplateMutationHookResult = ReturnType<typeof useAttachCareerExerciseTemplateMutation>;
export type AttachCareerExerciseTemplateMutationResult = Apollo.MutationResult<AttachCareerExerciseTemplateMutation>;
export type AttachCareerExerciseTemplateMutationOptions = Apollo.BaseMutationOptions<AttachCareerExerciseTemplateMutation, AttachCareerExerciseTemplateMutationVariables>;
export const DetachCareerExerciseTemplateDocument = gql`
    mutation DetachCareerExerciseTemplate($lessonId: ID!) {
  detachCareerExerciseTemplate(lessonId: $lessonId) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type DetachCareerExerciseTemplateMutationFn = Apollo.MutationFunction<DetachCareerExerciseTemplateMutation, DetachCareerExerciseTemplateMutationVariables>;

/**
 * __useDetachCareerExerciseTemplateMutation__
 *
 * To run a mutation, you first call `useDetachCareerExerciseTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachCareerExerciseTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachCareerExerciseTemplateMutation, { data, loading, error }] = useDetachCareerExerciseTemplateMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useDetachCareerExerciseTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DetachCareerExerciseTemplateMutation, DetachCareerExerciseTemplateMutationVariables>) {
        return Apollo.useMutation<DetachCareerExerciseTemplateMutation, DetachCareerExerciseTemplateMutationVariables>(DetachCareerExerciseTemplateDocument, baseOptions);
      }
export type DetachCareerExerciseTemplateMutationHookResult = ReturnType<typeof useDetachCareerExerciseTemplateMutation>;
export type DetachCareerExerciseTemplateMutationResult = Apollo.MutationResult<DetachCareerExerciseTemplateMutation>;
export type DetachCareerExerciseTemplateMutationOptions = Apollo.BaseMutationOptions<DetachCareerExerciseTemplateMutation, DetachCareerExerciseTemplateMutationVariables>;
export const DropCareerExerciseSubmissionsDocument = gql`
    mutation DropCareerExerciseSubmissions($templateId: ID!, $confirm: Boolean!) {
  resetCareerExerciseTemplate(templateId: $templateId, confirm: $confirm) {
    success
    deletedSubmissions
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type DropCareerExerciseSubmissionsMutationFn = Apollo.MutationFunction<DropCareerExerciseSubmissionsMutation, DropCareerExerciseSubmissionsMutationVariables>;

/**
 * __useDropCareerExerciseSubmissionsMutation__
 *
 * To run a mutation, you first call `useDropCareerExerciseSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropCareerExerciseSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropCareerExerciseSubmissionsMutation, { data, loading, error }] = useDropCareerExerciseSubmissionsMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      confirm: // value for 'confirm'
 *   },
 * });
 */
export function useDropCareerExerciseSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<DropCareerExerciseSubmissionsMutation, DropCareerExerciseSubmissionsMutationVariables>) {
        return Apollo.useMutation<DropCareerExerciseSubmissionsMutation, DropCareerExerciseSubmissionsMutationVariables>(DropCareerExerciseSubmissionsDocument, baseOptions);
      }
export type DropCareerExerciseSubmissionsMutationHookResult = ReturnType<typeof useDropCareerExerciseSubmissionsMutation>;
export type DropCareerExerciseSubmissionsMutationResult = Apollo.MutationResult<DropCareerExerciseSubmissionsMutation>;
export type DropCareerExerciseSubmissionsMutationOptions = Apollo.BaseMutationOptions<DropCareerExerciseSubmissionsMutation, DropCareerExerciseSubmissionsMutationVariables>;
export const SavePromoCampaignDocument = gql`
    mutation SavePromoCampaign($input: PromoCampaignInput!) {
  upsertPromoCampaign(input: $input) {
    success
    campaignId
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SavePromoCampaignMutationFn = Apollo.MutationFunction<SavePromoCampaignMutation, SavePromoCampaignMutationVariables>;

/**
 * __useSavePromoCampaignMutation__
 *
 * To run a mutation, you first call `useSavePromoCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePromoCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePromoCampaignMutation, { data, loading, error }] = useSavePromoCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePromoCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SavePromoCampaignMutation, SavePromoCampaignMutationVariables>) {
        return Apollo.useMutation<SavePromoCampaignMutation, SavePromoCampaignMutationVariables>(SavePromoCampaignDocument, baseOptions);
      }
export type SavePromoCampaignMutationHookResult = ReturnType<typeof useSavePromoCampaignMutation>;
export type SavePromoCampaignMutationResult = Apollo.MutationResult<SavePromoCampaignMutation>;
export type SavePromoCampaignMutationOptions = Apollo.BaseMutationOptions<SavePromoCampaignMutation, SavePromoCampaignMutationVariables>;
export const TogglePromoCampaignDocument = gql`
    mutation TogglePromoCampaign($id: ID!, $isActive: Boolean!) {
  setPromoCampaignActive(id: $id, isActive: $isActive) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type TogglePromoCampaignMutationFn = Apollo.MutationFunction<TogglePromoCampaignMutation, TogglePromoCampaignMutationVariables>;

/**
 * __useTogglePromoCampaignMutation__
 *
 * To run a mutation, you first call `useTogglePromoCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePromoCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePromoCampaignMutation, { data, loading, error }] = useTogglePromoCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useTogglePromoCampaignMutation(baseOptions?: Apollo.MutationHookOptions<TogglePromoCampaignMutation, TogglePromoCampaignMutationVariables>) {
        return Apollo.useMutation<TogglePromoCampaignMutation, TogglePromoCampaignMutationVariables>(TogglePromoCampaignDocument, baseOptions);
      }
export type TogglePromoCampaignMutationHookResult = ReturnType<typeof useTogglePromoCampaignMutation>;
export type TogglePromoCampaignMutationResult = Apollo.MutationResult<TogglePromoCampaignMutation>;
export type TogglePromoCampaignMutationOptions = Apollo.BaseMutationOptions<TogglePromoCampaignMutation, TogglePromoCampaignMutationVariables>;
export const GivePromoCodeDocument = gql`
    mutation GivePromoCode($campaignId: ID!, $studentId: ID!) {
  issuePromoCode(campaignId: $campaignId, studentId: $studentId) {
    success
    code
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type GivePromoCodeMutationFn = Apollo.MutationFunction<GivePromoCodeMutation, GivePromoCodeMutationVariables>;

/**
 * __useGivePromoCodeMutation__
 *
 * To run a mutation, you first call `useGivePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGivePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [givePromoCodeMutation, { data, loading, error }] = useGivePromoCodeMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGivePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<GivePromoCodeMutation, GivePromoCodeMutationVariables>) {
        return Apollo.useMutation<GivePromoCodeMutation, GivePromoCodeMutationVariables>(GivePromoCodeDocument, baseOptions);
      }
export type GivePromoCodeMutationHookResult = ReturnType<typeof useGivePromoCodeMutation>;
export type GivePromoCodeMutationResult = Apollo.MutationResult<GivePromoCodeMutation>;
export type GivePromoCodeMutationOptions = Apollo.BaseMutationOptions<GivePromoCodeMutation, GivePromoCodeMutationVariables>;
export const DropPromoCodeDocument = gql`
    mutation DropPromoCode($id: ID!, $reason: String) {
  revokePromoCode(id: $id, reason: $reason) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type DropPromoCodeMutationFn = Apollo.MutationFunction<DropPromoCodeMutation, DropPromoCodeMutationVariables>;

/**
 * __useDropPromoCodeMutation__
 *
 * To run a mutation, you first call `useDropPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropPromoCodeMutation, { data, loading, error }] = useDropPromoCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDropPromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<DropPromoCodeMutation, DropPromoCodeMutationVariables>) {
        return Apollo.useMutation<DropPromoCodeMutation, DropPromoCodeMutationVariables>(DropPromoCodeDocument, baseOptions);
      }
export type DropPromoCodeMutationHookResult = ReturnType<typeof useDropPromoCodeMutation>;
export type DropPromoCodeMutationResult = Apollo.MutationResult<DropPromoCodeMutation>;
export type DropPromoCodeMutationOptions = Apollo.BaseMutationOptions<DropPromoCodeMutation, DropPromoCodeMutationVariables>;
export const CheckPromoCodesDocument = gql`
    mutation CheckPromoCodes {
  reconcilePromoCodes {
    success
    checked
    redeemed
    ambiguous
    expired
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type CheckPromoCodesMutationFn = Apollo.MutationFunction<CheckPromoCodesMutation, CheckPromoCodesMutationVariables>;

/**
 * __useCheckPromoCodesMutation__
 *
 * To run a mutation, you first call `useCheckPromoCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckPromoCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkPromoCodesMutation, { data, loading, error }] = useCheckPromoCodesMutation({
 *   variables: {
 *   },
 * });
 */
export function useCheckPromoCodesMutation(baseOptions?: Apollo.MutationHookOptions<CheckPromoCodesMutation, CheckPromoCodesMutationVariables>) {
        return Apollo.useMutation<CheckPromoCodesMutation, CheckPromoCodesMutationVariables>(CheckPromoCodesDocument, baseOptions);
      }
export type CheckPromoCodesMutationHookResult = ReturnType<typeof useCheckPromoCodesMutation>;
export type CheckPromoCodesMutationResult = Apollo.MutationResult<CheckPromoCodesMutation>;
export type CheckPromoCodesMutationOptions = Apollo.BaseMutationOptions<CheckPromoCodesMutation, CheckPromoCodesMutationVariables>;
export const SaveShareTemplateDocument = gql`
    mutation SaveShareTemplate($input: ShareTemplateInput!) {
  upsertShareTemplate(input: $input) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveShareTemplateMutationFn = Apollo.MutationFunction<SaveShareTemplateMutation, SaveShareTemplateMutationVariables>;

/**
 * __useSaveShareTemplateMutation__
 *
 * To run a mutation, you first call `useSaveShareTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveShareTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveShareTemplateMutation, { data, loading, error }] = useSaveShareTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveShareTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveShareTemplateMutation, SaveShareTemplateMutationVariables>) {
        return Apollo.useMutation<SaveShareTemplateMutation, SaveShareTemplateMutationVariables>(SaveShareTemplateDocument, baseOptions);
      }
export type SaveShareTemplateMutationHookResult = ReturnType<typeof useSaveShareTemplateMutation>;
export type SaveShareTemplateMutationResult = Apollo.MutationResult<SaveShareTemplateMutation>;
export type SaveShareTemplateMutationOptions = Apollo.BaseMutationOptions<SaveShareTemplateMutation, SaveShareTemplateMutationVariables>;
export const SaveGrowthTrackDocument = gql`
    mutation SaveGrowthTrack($input: GrowthTrackInput!) {
  saveGrowthTrack(input: $input) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveGrowthTrackMutationFn = Apollo.MutationFunction<SaveGrowthTrackMutation, SaveGrowthTrackMutationVariables>;

/**
 * __useSaveGrowthTrackMutation__
 *
 * To run a mutation, you first call `useSaveGrowthTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGrowthTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGrowthTrackMutation, { data, loading, error }] = useSaveGrowthTrackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGrowthTrackMutation(baseOptions?: Apollo.MutationHookOptions<SaveGrowthTrackMutation, SaveGrowthTrackMutationVariables>) {
        return Apollo.useMutation<SaveGrowthTrackMutation, SaveGrowthTrackMutationVariables>(SaveGrowthTrackDocument, baseOptions);
      }
export type SaveGrowthTrackMutationHookResult = ReturnType<typeof useSaveGrowthTrackMutation>;
export type SaveGrowthTrackMutationResult = Apollo.MutationResult<SaveGrowthTrackMutation>;
export type SaveGrowthTrackMutationOptions = Apollo.BaseMutationOptions<SaveGrowthTrackMutation, SaveGrowthTrackMutationVariables>;
export const ToggleGrowthTrackDocument = gql`
    mutation ToggleGrowthTrack($trackId: ID!, $isActive: Boolean!) {
  toggleGrowthTrack(trackId: $trackId, isActive: $isActive) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type ToggleGrowthTrackMutationFn = Apollo.MutationFunction<ToggleGrowthTrackMutation, ToggleGrowthTrackMutationVariables>;

/**
 * __useToggleGrowthTrackMutation__
 *
 * To run a mutation, you first call `useToggleGrowthTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleGrowthTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleGrowthTrackMutation, { data, loading, error }] = useToggleGrowthTrackMutation({
 *   variables: {
 *      trackId: // value for 'trackId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useToggleGrowthTrackMutation(baseOptions?: Apollo.MutationHookOptions<ToggleGrowthTrackMutation, ToggleGrowthTrackMutationVariables>) {
        return Apollo.useMutation<ToggleGrowthTrackMutation, ToggleGrowthTrackMutationVariables>(ToggleGrowthTrackDocument, baseOptions);
      }
export type ToggleGrowthTrackMutationHookResult = ReturnType<typeof useToggleGrowthTrackMutation>;
export type ToggleGrowthTrackMutationResult = Apollo.MutationResult<ToggleGrowthTrackMutation>;
export type ToggleGrowthTrackMutationOptions = Apollo.BaseMutationOptions<ToggleGrowthTrackMutation, ToggleGrowthTrackMutationVariables>;
export const SaveAchievementDocument = gql`
    mutation SaveAchievement($input: AchievementInput!) {
  saveAchievement(input: $input) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveAchievementMutationFn = Apollo.MutationFunction<SaveAchievementMutation, SaveAchievementMutationVariables>;

/**
 * __useSaveAchievementMutation__
 *
 * To run a mutation, you first call `useSaveAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAchievementMutation, { data, loading, error }] = useSaveAchievementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAchievementMutation(baseOptions?: Apollo.MutationHookOptions<SaveAchievementMutation, SaveAchievementMutationVariables>) {
        return Apollo.useMutation<SaveAchievementMutation, SaveAchievementMutationVariables>(SaveAchievementDocument, baseOptions);
      }
export type SaveAchievementMutationHookResult = ReturnType<typeof useSaveAchievementMutation>;
export type SaveAchievementMutationResult = Apollo.MutationResult<SaveAchievementMutation>;
export type SaveAchievementMutationOptions = Apollo.BaseMutationOptions<SaveAchievementMutation, SaveAchievementMutationVariables>;
export const ToggleAchievementDocument = gql`
    mutation ToggleAchievement($achievementId: ID!, $isActive: Boolean!) {
  toggleAchievement(achievementId: $achievementId, isActive: $isActive) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type ToggleAchievementMutationFn = Apollo.MutationFunction<ToggleAchievementMutation, ToggleAchievementMutationVariables>;

/**
 * __useToggleAchievementMutation__
 *
 * To run a mutation, you first call `useToggleAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAchievementMutation, { data, loading, error }] = useToggleAchievementMutation({
 *   variables: {
 *      achievementId: // value for 'achievementId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useToggleAchievementMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAchievementMutation, ToggleAchievementMutationVariables>) {
        return Apollo.useMutation<ToggleAchievementMutation, ToggleAchievementMutationVariables>(ToggleAchievementDocument, baseOptions);
      }
export type ToggleAchievementMutationHookResult = ReturnType<typeof useToggleAchievementMutation>;
export type ToggleAchievementMutationResult = Apollo.MutationResult<ToggleAchievementMutation>;
export type ToggleAchievementMutationOptions = Apollo.BaseMutationOptions<ToggleAchievementMutation, ToggleAchievementMutationVariables>;
export const SaveSiteCourseDocument = gql`
    mutation SaveSiteCourse($input: SiteCourseInput!) {
  saveSiteCourse(input: $input) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SaveSiteCourseMutationFn = Apollo.MutationFunction<SaveSiteCourseMutation, SaveSiteCourseMutationVariables>;

/**
 * __useSaveSiteCourseMutation__
 *
 * To run a mutation, you first call `useSaveSiteCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSiteCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSiteCourseMutation, { data, loading, error }] = useSaveSiteCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSiteCourseMutation(baseOptions?: Apollo.MutationHookOptions<SaveSiteCourseMutation, SaveSiteCourseMutationVariables>) {
        return Apollo.useMutation<SaveSiteCourseMutation, SaveSiteCourseMutationVariables>(SaveSiteCourseDocument, baseOptions);
      }
export type SaveSiteCourseMutationHookResult = ReturnType<typeof useSaveSiteCourseMutation>;
export type SaveSiteCourseMutationResult = Apollo.MutationResult<SaveSiteCourseMutation>;
export type SaveSiteCourseMutationOptions = Apollo.BaseMutationOptions<SaveSiteCourseMutation, SaveSiteCourseMutationVariables>;
export const ToggleSiteCourseDocument = gql`
    mutation ToggleSiteCourse($siteCourseId: ID!, $isActive: Boolean!) {
  toggleSiteCourse(siteCourseId: $siteCourseId, isActive: $isActive) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type ToggleSiteCourseMutationFn = Apollo.MutationFunction<ToggleSiteCourseMutation, ToggleSiteCourseMutationVariables>;

/**
 * __useToggleSiteCourseMutation__
 *
 * To run a mutation, you first call `useToggleSiteCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSiteCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSiteCourseMutation, { data, loading, error }] = useToggleSiteCourseMutation({
 *   variables: {
 *      siteCourseId: // value for 'siteCourseId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useToggleSiteCourseMutation(baseOptions?: Apollo.MutationHookOptions<ToggleSiteCourseMutation, ToggleSiteCourseMutationVariables>) {
        return Apollo.useMutation<ToggleSiteCourseMutation, ToggleSiteCourseMutationVariables>(ToggleSiteCourseDocument, baseOptions);
      }
export type ToggleSiteCourseMutationHookResult = ReturnType<typeof useToggleSiteCourseMutation>;
export type ToggleSiteCourseMutationResult = Apollo.MutationResult<ToggleSiteCourseMutation>;
export type ToggleSiteCourseMutationOptions = Apollo.BaseMutationOptions<ToggleSiteCourseMutation, ToggleSiteCourseMutationVariables>;
export const SetCourseProgramDocument = gql`
    mutation SetCourseProgram($courseId: ID!, $modules: [ProgramModuleInput!]!) {
  setCourseProgram(courseId: $courseId, modules: $modules) {
    success
    modules
    lessons
    lessonsRemoved
    lessonsWithoutMarketing
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SetCourseProgramMutationFn = Apollo.MutationFunction<SetCourseProgramMutation, SetCourseProgramMutationVariables>;

/**
 * __useSetCourseProgramMutation__
 *
 * To run a mutation, you first call `useSetCourseProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCourseProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCourseProgramMutation, { data, loading, error }] = useSetCourseProgramMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      modules: // value for 'modules'
 *   },
 * });
 */
export function useSetCourseProgramMutation(baseOptions?: Apollo.MutationHookOptions<SetCourseProgramMutation, SetCourseProgramMutationVariables>) {
        return Apollo.useMutation<SetCourseProgramMutation, SetCourseProgramMutationVariables>(SetCourseProgramDocument, baseOptions);
      }
export type SetCourseProgramMutationHookResult = ReturnType<typeof useSetCourseProgramMutation>;
export type SetCourseProgramMutationResult = Apollo.MutationResult<SetCourseProgramMutation>;
export type SetCourseProgramMutationOptions = Apollo.BaseMutationOptions<SetCourseProgramMutation, SetCourseProgramMutationVariables>;
export const UploadBankStatementDocument = gql`
    mutation UploadBankStatement($file: Upload!, $dryRun: Boolean, $accountSlug: String) {
  uploadBankStatement(file: $file, dryRun: $dryRun, accountSlug: $accountSlug) {
    success
    errors
    dryRun
    alreadyImported
    accountName
    accountIbanLearned
    processingStats
    run {
      pk
      fileName
      status
      rowsTotal
      createdCount
      duplicateCount
      failedCount
      balanceGapCount
      periodFrom
      periodTo
      report
    }
  }
}
    `;
export type UploadBankStatementMutationFn = Apollo.MutationFunction<UploadBankStatementMutation, UploadBankStatementMutationVariables>;

/**
 * __useUploadBankStatementMutation__
 *
 * To run a mutation, you first call `useUploadBankStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBankStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBankStatementMutation, { data, loading, error }] = useUploadBankStatementMutation({
 *   variables: {
 *      file: // value for 'file'
 *      dryRun: // value for 'dryRun'
 *      accountSlug: // value for 'accountSlug'
 *   },
 * });
 */
export function useUploadBankStatementMutation(baseOptions?: Apollo.MutationHookOptions<UploadBankStatementMutation, UploadBankStatementMutationVariables>) {
        return Apollo.useMutation<UploadBankStatementMutation, UploadBankStatementMutationVariables>(UploadBankStatementDocument, baseOptions);
      }
export type UploadBankStatementMutationHookResult = ReturnType<typeof useUploadBankStatementMutation>;
export type UploadBankStatementMutationResult = Apollo.MutationResult<UploadBankStatementMutation>;
export type UploadBankStatementMutationOptions = Apollo.BaseMutationOptions<UploadBankStatementMutation, UploadBankStatementMutationVariables>;
export const ConfirmCashFlowRuleDocument = gql`
    mutation ConfirmCashFlowRule($transactionId: ID!, $categorySlug: String!, $retroactive: Boolean) {
  confirmCashFlowRule(
    transactionId: $transactionId
    categorySlug: $categorySlug
    retroactive: $retroactive
  ) {
    success
    errors
    ruleOutcome
    ruleReason
    rule {
      pk
      keyKind
      keyValue
      categoryName
      validFrom
    }
  }
}
    `;
export type ConfirmCashFlowRuleMutationFn = Apollo.MutationFunction<ConfirmCashFlowRuleMutation, ConfirmCashFlowRuleMutationVariables>;

/**
 * __useConfirmCashFlowRuleMutation__
 *
 * To run a mutation, you first call `useConfirmCashFlowRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCashFlowRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCashFlowRuleMutation, { data, loading, error }] = useConfirmCashFlowRuleMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      categorySlug: // value for 'categorySlug'
 *      retroactive: // value for 'retroactive'
 *   },
 * });
 */
export function useConfirmCashFlowRuleMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCashFlowRuleMutation, ConfirmCashFlowRuleMutationVariables>) {
        return Apollo.useMutation<ConfirmCashFlowRuleMutation, ConfirmCashFlowRuleMutationVariables>(ConfirmCashFlowRuleDocument, baseOptions);
      }
export type ConfirmCashFlowRuleMutationHookResult = ReturnType<typeof useConfirmCashFlowRuleMutation>;
export type ConfirmCashFlowRuleMutationResult = Apollo.MutationResult<ConfirmCashFlowRuleMutation>;
export type ConfirmCashFlowRuleMutationOptions = Apollo.BaseMutationOptions<ConfirmCashFlowRuleMutation, ConfirmCashFlowRuleMutationVariables>;
export const ResolveCashFlowRuleConflictDocument = gql`
    mutation ResolveCashFlowRuleConflict($transactionId: ID!, $categorySlug: String!, $strategy: String!) {
  resolveCashFlowRuleConflict(
    transactionId: $transactionId
    categorySlug: $categorySlug
    strategy: $strategy
  ) {
    success
    errors
    ruleOutcome
    ruleReason
    rule {
      pk
      categoryName
      validFrom
      validTo
    }
  }
}
    `;
export type ResolveCashFlowRuleConflictMutationFn = Apollo.MutationFunction<ResolveCashFlowRuleConflictMutation, ResolveCashFlowRuleConflictMutationVariables>;

/**
 * __useResolveCashFlowRuleConflictMutation__
 *
 * To run a mutation, you first call `useResolveCashFlowRuleConflictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveCashFlowRuleConflictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveCashFlowRuleConflictMutation, { data, loading, error }] = useResolveCashFlowRuleConflictMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      categorySlug: // value for 'categorySlug'
 *      strategy: // value for 'strategy'
 *   },
 * });
 */
export function useResolveCashFlowRuleConflictMutation(baseOptions?: Apollo.MutationHookOptions<ResolveCashFlowRuleConflictMutation, ResolveCashFlowRuleConflictMutationVariables>) {
        return Apollo.useMutation<ResolveCashFlowRuleConflictMutation, ResolveCashFlowRuleConflictMutationVariables>(ResolveCashFlowRuleConflictDocument, baseOptions);
      }
export type ResolveCashFlowRuleConflictMutationHookResult = ReturnType<typeof useResolveCashFlowRuleConflictMutation>;
export type ResolveCashFlowRuleConflictMutationResult = Apollo.MutationResult<ResolveCashFlowRuleConflictMutation>;
export type ResolveCashFlowRuleConflictMutationOptions = Apollo.BaseMutationOptions<ResolveCashFlowRuleConflictMutation, ResolveCashFlowRuleConflictMutationVariables>;
export const UpdateCashFlowRuleDocument = gql`
    mutation UpdateCashFlowRule($id: ID!, $isActive: Boolean, $priority: Int, $categorySlug: String, $resetHealth: Boolean) {
  updateCashFlowRule(
    id: $id
    isActive: $isActive
    priority: $priority
    categorySlug: $categorySlug
    resetHealth: $resetHealth
  ) {
    success
    errors
    rule {
      pk
      isActive
      priority
      categorySlug
      categoryName
      health
      overridesCount
    }
  }
}
    `;
export type UpdateCashFlowRuleMutationFn = Apollo.MutationFunction<UpdateCashFlowRuleMutation, UpdateCashFlowRuleMutationVariables>;

/**
 * __useUpdateCashFlowRuleMutation__
 *
 * To run a mutation, you first call `useUpdateCashFlowRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCashFlowRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCashFlowRuleMutation, { data, loading, error }] = useUpdateCashFlowRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *      priority: // value for 'priority'
 *      categorySlug: // value for 'categorySlug'
 *      resetHealth: // value for 'resetHealth'
 *   },
 * });
 */
export function useUpdateCashFlowRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCashFlowRuleMutation, UpdateCashFlowRuleMutationVariables>) {
        return Apollo.useMutation<UpdateCashFlowRuleMutation, UpdateCashFlowRuleMutationVariables>(UpdateCashFlowRuleDocument, baseOptions);
      }
export type UpdateCashFlowRuleMutationHookResult = ReturnType<typeof useUpdateCashFlowRuleMutation>;
export type UpdateCashFlowRuleMutationResult = Apollo.MutationResult<UpdateCashFlowRuleMutation>;
export type UpdateCashFlowRuleMutationOptions = Apollo.BaseMutationOptions<UpdateCashFlowRuleMutation, UpdateCashFlowRuleMutationVariables>;
export const DeleteCashFlowRuleDocument = gql`
    mutation DeleteCashFlowRule($id: ID!) {
  deleteCashFlowRule(id: $id) {
    success
    errors
    stats
  }
}
    `;
export type DeleteCashFlowRuleMutationFn = Apollo.MutationFunction<DeleteCashFlowRuleMutation, DeleteCashFlowRuleMutationVariables>;

/**
 * __useDeleteCashFlowRuleMutation__
 *
 * To run a mutation, you first call `useDeleteCashFlowRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCashFlowRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCashFlowRuleMutation, { data, loading, error }] = useDeleteCashFlowRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCashFlowRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCashFlowRuleMutation, DeleteCashFlowRuleMutationVariables>) {
        return Apollo.useMutation<DeleteCashFlowRuleMutation, DeleteCashFlowRuleMutationVariables>(DeleteCashFlowRuleDocument, baseOptions);
      }
export type DeleteCashFlowRuleMutationHookResult = ReturnType<typeof useDeleteCashFlowRuleMutation>;
export type DeleteCashFlowRuleMutationResult = Apollo.MutationResult<DeleteCashFlowRuleMutation>;
export type DeleteCashFlowRuleMutationOptions = Apollo.BaseMutationOptions<DeleteCashFlowRuleMutation, DeleteCashFlowRuleMutationVariables>;
export const UpdateCashFlowSettingsDocument = gql`
    mutation UpdateCashFlowSettings($ownPartyNames: String, $internalTransferAutodetect: Boolean, $internalTransferWindowDays: Int) {
  updateCashFlowSettings(
    ownPartyNames: $ownPartyNames
    internalTransferAutodetect: $internalTransferAutodetect
    internalTransferWindowDays: $internalTransferWindowDays
  ) {
    success
    errors
    settings {
      ownPartyNames
      internalTransferAutodetect
      internalTransferWindowDays
    }
  }
}
    `;
export type UpdateCashFlowSettingsMutationFn = Apollo.MutationFunction<UpdateCashFlowSettingsMutation, UpdateCashFlowSettingsMutationVariables>;

/**
 * __useUpdateCashFlowSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCashFlowSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCashFlowSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCashFlowSettingsMutation, { data, loading, error }] = useUpdateCashFlowSettingsMutation({
 *   variables: {
 *      ownPartyNames: // value for 'ownPartyNames'
 *      internalTransferAutodetect: // value for 'internalTransferAutodetect'
 *      internalTransferWindowDays: // value for 'internalTransferWindowDays'
 *   },
 * });
 */
export function useUpdateCashFlowSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCashFlowSettingsMutation, UpdateCashFlowSettingsMutationVariables>) {
        return Apollo.useMutation<UpdateCashFlowSettingsMutation, UpdateCashFlowSettingsMutationVariables>(UpdateCashFlowSettingsDocument, baseOptions);
      }
export type UpdateCashFlowSettingsMutationHookResult = ReturnType<typeof useUpdateCashFlowSettingsMutation>;
export type UpdateCashFlowSettingsMutationResult = Apollo.MutationResult<UpdateCashFlowSettingsMutation>;
export type UpdateCashFlowSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCashFlowSettingsMutation, UpdateCashFlowSettingsMutationVariables>;
export const SetBankTransactionCategoryDocument = gql`
    mutation SetBankTransactionCategory($id: ID!, $categorySlug: String, $learn: Boolean) {
  setBankTransactionCategory(id: $id, categorySlug: $categorySlug, learn: $learn) {
    success
    errors
    ruleOutcome
    ruleReason
    rule {
      pk
      keyKind
      keyValue
      categoryName
    }
    conflictingRule {
      pk
      categoryName
    }
    preview {
      keyKind
      keyValue
      direction
      wouldAffect
      samples
    }
    transaction {
      pk
      categorySlug
      categoryName
      categorySource
    }
  }
}
    `;
export type SetBankTransactionCategoryMutationFn = Apollo.MutationFunction<SetBankTransactionCategoryMutation, SetBankTransactionCategoryMutationVariables>;

/**
 * __useSetBankTransactionCategoryMutation__
 *
 * To run a mutation, you first call `useSetBankTransactionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBankTransactionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBankTransactionCategoryMutation, { data, loading, error }] = useSetBankTransactionCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      categorySlug: // value for 'categorySlug'
 *      learn: // value for 'learn'
 *   },
 * });
 */
export function useSetBankTransactionCategoryMutation(baseOptions?: Apollo.MutationHookOptions<SetBankTransactionCategoryMutation, SetBankTransactionCategoryMutationVariables>) {
        return Apollo.useMutation<SetBankTransactionCategoryMutation, SetBankTransactionCategoryMutationVariables>(SetBankTransactionCategoryDocument, baseOptions);
      }
export type SetBankTransactionCategoryMutationHookResult = ReturnType<typeof useSetBankTransactionCategoryMutation>;
export type SetBankTransactionCategoryMutationResult = Apollo.MutationResult<SetBankTransactionCategoryMutation>;
export type SetBankTransactionCategoryMutationOptions = Apollo.BaseMutationOptions<SetBankTransactionCategoryMutation, SetBankTransactionCategoryMutationVariables>;
export const SetBankTransactionInternalDocument = gql`
    mutation SetBankTransactionInternal($id: ID!, $isInternal: Boolean!) {
  setBankTransactionInternal(id: $id, isInternal: $isInternal) {
    success
    errors
    transaction {
      pk
      isInternalTransfer
      internalSource
      needsReview
    }
  }
}
    `;
export type SetBankTransactionInternalMutationFn = Apollo.MutationFunction<SetBankTransactionInternalMutation, SetBankTransactionInternalMutationVariables>;

/**
 * __useSetBankTransactionInternalMutation__
 *
 * To run a mutation, you first call `useSetBankTransactionInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBankTransactionInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBankTransactionInternalMutation, { data, loading, error }] = useSetBankTransactionInternalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isInternal: // value for 'isInternal'
 *   },
 * });
 */
export function useSetBankTransactionInternalMutation(baseOptions?: Apollo.MutationHookOptions<SetBankTransactionInternalMutation, SetBankTransactionInternalMutationVariables>) {
        return Apollo.useMutation<SetBankTransactionInternalMutation, SetBankTransactionInternalMutationVariables>(SetBankTransactionInternalDocument, baseOptions);
      }
export type SetBankTransactionInternalMutationHookResult = ReturnType<typeof useSetBankTransactionInternalMutation>;
export type SetBankTransactionInternalMutationResult = Apollo.MutationResult<SetBankTransactionInternalMutation>;
export type SetBankTransactionInternalMutationOptions = Apollo.BaseMutationOptions<SetBankTransactionInternalMutation, SetBankTransactionInternalMutationVariables>;
export const ProcessUploadedStatementDocument = gql`
    mutation ProcessUploadedStatement($dryRun: Boolean) {
  processUploadedStatement(dryRun: $dryRun) {
    success
    errors
    dryRun
    stats
  }
}
    `;
export type ProcessUploadedStatementMutationFn = Apollo.MutationFunction<ProcessUploadedStatementMutation, ProcessUploadedStatementMutationVariables>;

/**
 * __useProcessUploadedStatementMutation__
 *
 * To run a mutation, you first call `useProcessUploadedStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessUploadedStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processUploadedStatementMutation, { data, loading, error }] = useProcessUploadedStatementMutation({
 *   variables: {
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useProcessUploadedStatementMutation(baseOptions?: Apollo.MutationHookOptions<ProcessUploadedStatementMutation, ProcessUploadedStatementMutationVariables>) {
        return Apollo.useMutation<ProcessUploadedStatementMutation, ProcessUploadedStatementMutationVariables>(ProcessUploadedStatementDocument, baseOptions);
      }
export type ProcessUploadedStatementMutationHookResult = ReturnType<typeof useProcessUploadedStatementMutation>;
export type ProcessUploadedStatementMutationResult = Apollo.MutationResult<ProcessUploadedStatementMutation>;
export type ProcessUploadedStatementMutationOptions = Apollo.BaseMutationOptions<ProcessUploadedStatementMutation, ProcessUploadedStatementMutationVariables>;
export const RunCashFlowCategorizationDocument = gql`
    mutation RunCashFlowCategorization($dryRun: Boolean) {
  runCashFlowCategorization(dryRun: $dryRun) {
    success
    errors
    dryRun
    stats
  }
}
    `;
export type RunCashFlowCategorizationMutationFn = Apollo.MutationFunction<RunCashFlowCategorizationMutation, RunCashFlowCategorizationMutationVariables>;

/**
 * __useRunCashFlowCategorizationMutation__
 *
 * To run a mutation, you first call `useRunCashFlowCategorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunCashFlowCategorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runCashFlowCategorizationMutation, { data, loading, error }] = useRunCashFlowCategorizationMutation({
 *   variables: {
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useRunCashFlowCategorizationMutation(baseOptions?: Apollo.MutationHookOptions<RunCashFlowCategorizationMutation, RunCashFlowCategorizationMutationVariables>) {
        return Apollo.useMutation<RunCashFlowCategorizationMutation, RunCashFlowCategorizationMutationVariables>(RunCashFlowCategorizationDocument, baseOptions);
      }
export type RunCashFlowCategorizationMutationHookResult = ReturnType<typeof useRunCashFlowCategorizationMutation>;
export type RunCashFlowCategorizationMutationResult = Apollo.MutationResult<RunCashFlowCategorizationMutation>;
export type RunCashFlowCategorizationMutationOptions = Apollo.BaseMutationOptions<RunCashFlowCategorizationMutation, RunCashFlowCategorizationMutationVariables>;
export const RunInternalTransferDetectionDocument = gql`
    mutation RunInternalTransferDetection($dryRun: Boolean) {
  runInternalTransferDetection(dryRun: $dryRun) {
    success
    errors
    dryRun
    stats
  }
}
    `;
export type RunInternalTransferDetectionMutationFn = Apollo.MutationFunction<RunInternalTransferDetectionMutation, RunInternalTransferDetectionMutationVariables>;

/**
 * __useRunInternalTransferDetectionMutation__
 *
 * To run a mutation, you first call `useRunInternalTransferDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunInternalTransferDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runInternalTransferDetectionMutation, { data, loading, error }] = useRunInternalTransferDetectionMutation({
 *   variables: {
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useRunInternalTransferDetectionMutation(baseOptions?: Apollo.MutationHookOptions<RunInternalTransferDetectionMutation, RunInternalTransferDetectionMutationVariables>) {
        return Apollo.useMutation<RunInternalTransferDetectionMutation, RunInternalTransferDetectionMutationVariables>(RunInternalTransferDetectionDocument, baseOptions);
      }
export type RunInternalTransferDetectionMutationHookResult = ReturnType<typeof useRunInternalTransferDetectionMutation>;
export type RunInternalTransferDetectionMutationResult = Apollo.MutationResult<RunInternalTransferDetectionMutation>;
export type RunInternalTransferDetectionMutationOptions = Apollo.BaseMutationOptions<RunInternalTransferDetectionMutation, RunInternalTransferDetectionMutationVariables>;
export const RunCashFlowMatchingDocument = gql`
    mutation RunCashFlowMatching($dryRun: Boolean) {
  runCashFlowMatching(dryRun: $dryRun) {
    success
    errors
    dryRun
    stats
  }
}
    `;
export type RunCashFlowMatchingMutationFn = Apollo.MutationFunction<RunCashFlowMatchingMutation, RunCashFlowMatchingMutationVariables>;

/**
 * __useRunCashFlowMatchingMutation__
 *
 * To run a mutation, you first call `useRunCashFlowMatchingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunCashFlowMatchingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runCashFlowMatchingMutation, { data, loading, error }] = useRunCashFlowMatchingMutation({
 *   variables: {
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useRunCashFlowMatchingMutation(baseOptions?: Apollo.MutationHookOptions<RunCashFlowMatchingMutation, RunCashFlowMatchingMutationVariables>) {
        return Apollo.useMutation<RunCashFlowMatchingMutation, RunCashFlowMatchingMutationVariables>(RunCashFlowMatchingDocument, baseOptions);
      }
export type RunCashFlowMatchingMutationHookResult = ReturnType<typeof useRunCashFlowMatchingMutation>;
export type RunCashFlowMatchingMutationResult = Apollo.MutationResult<RunCashFlowMatchingMutation>;
export type RunCashFlowMatchingMutationOptions = Apollo.BaseMutationOptions<RunCashFlowMatchingMutation, RunCashFlowMatchingMutationVariables>;
export const SeedCashFlowRulesDocument = gql`
    mutation SeedCashFlowRules($dryRun: Boolean) {
  seedCashFlowRules(dryRun: $dryRun) {
    success
    errors
    dryRun
    stats
  }
}
    `;
export type SeedCashFlowRulesMutationFn = Apollo.MutationFunction<SeedCashFlowRulesMutation, SeedCashFlowRulesMutationVariables>;

/**
 * __useSeedCashFlowRulesMutation__
 *
 * To run a mutation, you first call `useSeedCashFlowRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedCashFlowRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedCashFlowRulesMutation, { data, loading, error }] = useSeedCashFlowRulesMutation({
 *   variables: {
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useSeedCashFlowRulesMutation(baseOptions?: Apollo.MutationHookOptions<SeedCashFlowRulesMutation, SeedCashFlowRulesMutationVariables>) {
        return Apollo.useMutation<SeedCashFlowRulesMutation, SeedCashFlowRulesMutationVariables>(SeedCashFlowRulesDocument, baseOptions);
      }
export type SeedCashFlowRulesMutationHookResult = ReturnType<typeof useSeedCashFlowRulesMutation>;
export type SeedCashFlowRulesMutationResult = Apollo.MutationResult<SeedCashFlowRulesMutation>;
export type SeedCashFlowRulesMutationOptions = Apollo.BaseMutationOptions<SeedCashFlowRulesMutation, SeedCashFlowRulesMutationVariables>;
export const DetectGatewaySettlementsDocument = gql`
    mutation DetectGatewaySettlements($dryRun: Boolean) {
  detectGatewaySettlements(dryRun: $dryRun) {
    success
    errors
    dryRun
    stats
  }
}
    `;
export type DetectGatewaySettlementsMutationFn = Apollo.MutationFunction<DetectGatewaySettlementsMutation, DetectGatewaySettlementsMutationVariables>;

/**
 * __useDetectGatewaySettlementsMutation__
 *
 * To run a mutation, you first call `useDetectGatewaySettlementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetectGatewaySettlementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detectGatewaySettlementsMutation, { data, loading, error }] = useDetectGatewaySettlementsMutation({
 *   variables: {
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useDetectGatewaySettlementsMutation(baseOptions?: Apollo.MutationHookOptions<DetectGatewaySettlementsMutation, DetectGatewaySettlementsMutationVariables>) {
        return Apollo.useMutation<DetectGatewaySettlementsMutation, DetectGatewaySettlementsMutationVariables>(DetectGatewaySettlementsDocument, baseOptions);
      }
export type DetectGatewaySettlementsMutationHookResult = ReturnType<typeof useDetectGatewaySettlementsMutation>;
export type DetectGatewaySettlementsMutationResult = Apollo.MutationResult<DetectGatewaySettlementsMutation>;
export type DetectGatewaySettlementsMutationOptions = Apollo.BaseMutationOptions<DetectGatewaySettlementsMutation, DetectGatewaySettlementsMutationVariables>;
export const AddGatewaySettlementItemDocument = gql`
    mutation AddGatewaySettlementItem($settlementId: ID!, $invoiceId: ID!) {
  addGatewaySettlementItem(settlementId: $settlementId, invoiceId: $invoiceId) {
    success
    errors
    settlement {
      pk
      itemsTotal
      feeAmount
      unallocated
      status
      items {
        pk
        invoiceId
        invoiceNumber
        amount
        matchSource
      }
    }
  }
}
    `;
export type AddGatewaySettlementItemMutationFn = Apollo.MutationFunction<AddGatewaySettlementItemMutation, AddGatewaySettlementItemMutationVariables>;

/**
 * __useAddGatewaySettlementItemMutation__
 *
 * To run a mutation, you first call `useAddGatewaySettlementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGatewaySettlementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGatewaySettlementItemMutation, { data, loading, error }] = useAddGatewaySettlementItemMutation({
 *   variables: {
 *      settlementId: // value for 'settlementId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useAddGatewaySettlementItemMutation(baseOptions?: Apollo.MutationHookOptions<AddGatewaySettlementItemMutation, AddGatewaySettlementItemMutationVariables>) {
        return Apollo.useMutation<AddGatewaySettlementItemMutation, AddGatewaySettlementItemMutationVariables>(AddGatewaySettlementItemDocument, baseOptions);
      }
export type AddGatewaySettlementItemMutationHookResult = ReturnType<typeof useAddGatewaySettlementItemMutation>;
export type AddGatewaySettlementItemMutationResult = Apollo.MutationResult<AddGatewaySettlementItemMutation>;
export type AddGatewaySettlementItemMutationOptions = Apollo.BaseMutationOptions<AddGatewaySettlementItemMutation, AddGatewaySettlementItemMutationVariables>;
export const RemoveGatewaySettlementItemDocument = gql`
    mutation RemoveGatewaySettlementItem($itemId: ID!) {
  removeGatewaySettlementItem(itemId: $itemId) {
    success
    errors
    settlement {
      pk
      itemsTotal
      feeAmount
      unallocated
      status
      items {
        pk
        invoiceId
        invoiceNumber
        amount
        matchSource
      }
    }
  }
}
    `;
export type RemoveGatewaySettlementItemMutationFn = Apollo.MutationFunction<RemoveGatewaySettlementItemMutation, RemoveGatewaySettlementItemMutationVariables>;

/**
 * __useRemoveGatewaySettlementItemMutation__
 *
 * To run a mutation, you first call `useRemoveGatewaySettlementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGatewaySettlementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGatewaySettlementItemMutation, { data, loading, error }] = useRemoveGatewaySettlementItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useRemoveGatewaySettlementItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGatewaySettlementItemMutation, RemoveGatewaySettlementItemMutationVariables>) {
        return Apollo.useMutation<RemoveGatewaySettlementItemMutation, RemoveGatewaySettlementItemMutationVariables>(RemoveGatewaySettlementItemDocument, baseOptions);
      }
export type RemoveGatewaySettlementItemMutationHookResult = ReturnType<typeof useRemoveGatewaySettlementItemMutation>;
export type RemoveGatewaySettlementItemMutationResult = Apollo.MutationResult<RemoveGatewaySettlementItemMutation>;
export type RemoveGatewaySettlementItemMutationOptions = Apollo.BaseMutationOptions<RemoveGatewaySettlementItemMutation, RemoveGatewaySettlementItemMutationVariables>;
export const MarkGatewaySettlementReconciledDocument = gql`
    mutation MarkGatewaySettlementReconciled($settlementId: ID!, $notes: String!) {
  markGatewaySettlementReconciled(settlementId: $settlementId, notes: $notes) {
    success
    errors
    settlement {
      pk
      status
      notes
    }
  }
}
    `;
export type MarkGatewaySettlementReconciledMutationFn = Apollo.MutationFunction<MarkGatewaySettlementReconciledMutation, MarkGatewaySettlementReconciledMutationVariables>;

/**
 * __useMarkGatewaySettlementReconciledMutation__
 *
 * To run a mutation, you first call `useMarkGatewaySettlementReconciledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkGatewaySettlementReconciledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markGatewaySettlementReconciledMutation, { data, loading, error }] = useMarkGatewaySettlementReconciledMutation({
 *   variables: {
 *      settlementId: // value for 'settlementId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useMarkGatewaySettlementReconciledMutation(baseOptions?: Apollo.MutationHookOptions<MarkGatewaySettlementReconciledMutation, MarkGatewaySettlementReconciledMutationVariables>) {
        return Apollo.useMutation<MarkGatewaySettlementReconciledMutation, MarkGatewaySettlementReconciledMutationVariables>(MarkGatewaySettlementReconciledDocument, baseOptions);
      }
export type MarkGatewaySettlementReconciledMutationHookResult = ReturnType<typeof useMarkGatewaySettlementReconciledMutation>;
export type MarkGatewaySettlementReconciledMutationResult = Apollo.MutationResult<MarkGatewaySettlementReconciledMutation>;
export type MarkGatewaySettlementReconciledMutationOptions = Apollo.BaseMutationOptions<MarkGatewaySettlementReconciledMutation, MarkGatewaySettlementReconciledMutationVariables>;
export const LinkBankTransactionDocument = gql`
    mutation LinkBankTransaction($transactionId: ID!, $targetType: String!, $targetId: ID!) {
  linkBankTransaction(
    transactionId: $transactionId
    targetType: $targetType
    targetId: $targetId
  ) {
    success
    errors
    transaction {
      pk
      links {
        pk
        targetType
        targetId
        targetLabel
        matchSource
      }
    }
  }
}
    `;
export type LinkBankTransactionMutationFn = Apollo.MutationFunction<LinkBankTransactionMutation, LinkBankTransactionMutationVariables>;

/**
 * __useLinkBankTransactionMutation__
 *
 * To run a mutation, you first call `useLinkBankTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkBankTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkBankTransactionMutation, { data, loading, error }] = useLinkBankTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      targetType: // value for 'targetType'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useLinkBankTransactionMutation(baseOptions?: Apollo.MutationHookOptions<LinkBankTransactionMutation, LinkBankTransactionMutationVariables>) {
        return Apollo.useMutation<LinkBankTransactionMutation, LinkBankTransactionMutationVariables>(LinkBankTransactionDocument, baseOptions);
      }
export type LinkBankTransactionMutationHookResult = ReturnType<typeof useLinkBankTransactionMutation>;
export type LinkBankTransactionMutationResult = Apollo.MutationResult<LinkBankTransactionMutation>;
export type LinkBankTransactionMutationOptions = Apollo.BaseMutationOptions<LinkBankTransactionMutation, LinkBankTransactionMutationVariables>;
export const UnlinkBankTransactionDocument = gql`
    mutation UnlinkBankTransaction($linkId: ID!) {
  unlinkBankTransaction(linkId: $linkId) {
    success
    errors
    transaction {
      pk
      links {
        pk
        targetType
        targetId
        targetLabel
        matchSource
      }
    }
  }
}
    `;
export type UnlinkBankTransactionMutationFn = Apollo.MutationFunction<UnlinkBankTransactionMutation, UnlinkBankTransactionMutationVariables>;

/**
 * __useUnlinkBankTransactionMutation__
 *
 * To run a mutation, you first call `useUnlinkBankTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkBankTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkBankTransactionMutation, { data, loading, error }] = useUnlinkBankTransactionMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useUnlinkBankTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkBankTransactionMutation, UnlinkBankTransactionMutationVariables>) {
        return Apollo.useMutation<UnlinkBankTransactionMutation, UnlinkBankTransactionMutationVariables>(UnlinkBankTransactionDocument, baseOptions);
      }
export type UnlinkBankTransactionMutationHookResult = ReturnType<typeof useUnlinkBankTransactionMutation>;
export type UnlinkBankTransactionMutationResult = Apollo.MutationResult<UnlinkBankTransactionMutation>;
export type UnlinkBankTransactionMutationOptions = Apollo.BaseMutationOptions<UnlinkBankTransactionMutation, UnlinkBankTransactionMutationVariables>;
export const SetBankTransactionCategoryBulkDocument = gql`
    mutation SetBankTransactionCategoryBulk($ids: [ID!]!, $categorySlug: String, $learn: Boolean) {
  setBankTransactionCategoryBulk(
    ids: $ids
    categorySlug: $categorySlug
    learn: $learn
  ) {
    success
    errors
    stats
  }
}
    `;
export type SetBankTransactionCategoryBulkMutationFn = Apollo.MutationFunction<SetBankTransactionCategoryBulkMutation, SetBankTransactionCategoryBulkMutationVariables>;

/**
 * __useSetBankTransactionCategoryBulkMutation__
 *
 * To run a mutation, you first call `useSetBankTransactionCategoryBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBankTransactionCategoryBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBankTransactionCategoryBulkMutation, { data, loading, error }] = useSetBankTransactionCategoryBulkMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      categorySlug: // value for 'categorySlug'
 *      learn: // value for 'learn'
 *   },
 * });
 */
export function useSetBankTransactionCategoryBulkMutation(baseOptions?: Apollo.MutationHookOptions<SetBankTransactionCategoryBulkMutation, SetBankTransactionCategoryBulkMutationVariables>) {
        return Apollo.useMutation<SetBankTransactionCategoryBulkMutation, SetBankTransactionCategoryBulkMutationVariables>(SetBankTransactionCategoryBulkDocument, baseOptions);
      }
export type SetBankTransactionCategoryBulkMutationHookResult = ReturnType<typeof useSetBankTransactionCategoryBulkMutation>;
export type SetBankTransactionCategoryBulkMutationResult = Apollo.MutationResult<SetBankTransactionCategoryBulkMutation>;
export type SetBankTransactionCategoryBulkMutationOptions = Apollo.BaseMutationOptions<SetBankTransactionCategoryBulkMutation, SetBankTransactionCategoryBulkMutationVariables>;
export const SetGatewaySettlementFeeDocument = gql`
    mutation SetGatewaySettlementFee($settlementId: ID!, $feeAmount: Float!) {
  setGatewaySettlementFee(settlementId: $settlementId, feeAmount: $feeAmount) {
    success
    errors
    settlement {
      pk
      feeAmount
      feeSource
      unallocated
      status
    }
  }
}
    `;
export type SetGatewaySettlementFeeMutationFn = Apollo.MutationFunction<SetGatewaySettlementFeeMutation, SetGatewaySettlementFeeMutationVariables>;

/**
 * __useSetGatewaySettlementFeeMutation__
 *
 * To run a mutation, you first call `useSetGatewaySettlementFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGatewaySettlementFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGatewaySettlementFeeMutation, { data, loading, error }] = useSetGatewaySettlementFeeMutation({
 *   variables: {
 *      settlementId: // value for 'settlementId'
 *      feeAmount: // value for 'feeAmount'
 *   },
 * });
 */
export function useSetGatewaySettlementFeeMutation(baseOptions?: Apollo.MutationHookOptions<SetGatewaySettlementFeeMutation, SetGatewaySettlementFeeMutationVariables>) {
        return Apollo.useMutation<SetGatewaySettlementFeeMutation, SetGatewaySettlementFeeMutationVariables>(SetGatewaySettlementFeeDocument, baseOptions);
      }
export type SetGatewaySettlementFeeMutationHookResult = ReturnType<typeof useSetGatewaySettlementFeeMutation>;
export type SetGatewaySettlementFeeMutationResult = Apollo.MutationResult<SetGatewaySettlementFeeMutation>;
export type SetGatewaySettlementFeeMutationOptions = Apollo.BaseMutationOptions<SetGatewaySettlementFeeMutation, SetGatewaySettlementFeeMutationVariables>;
export const ReconcileGatewaySettlementsDocument = gql`
    mutation ReconcileGatewaySettlements($dryRun: Boolean) {
  reconcileGatewaySettlements(dryRun: $dryRun) {
    success
    errors
    dryRun
    stats
  }
}
    `;
export type ReconcileGatewaySettlementsMutationFn = Apollo.MutationFunction<ReconcileGatewaySettlementsMutation, ReconcileGatewaySettlementsMutationVariables>;

/**
 * __useReconcileGatewaySettlementsMutation__
 *
 * To run a mutation, you first call `useReconcileGatewaySettlementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcileGatewaySettlementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcileGatewaySettlementsMutation, { data, loading, error }] = useReconcileGatewaySettlementsMutation({
 *   variables: {
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useReconcileGatewaySettlementsMutation(baseOptions?: Apollo.MutationHookOptions<ReconcileGatewaySettlementsMutation, ReconcileGatewaySettlementsMutationVariables>) {
        return Apollo.useMutation<ReconcileGatewaySettlementsMutation, ReconcileGatewaySettlementsMutationVariables>(ReconcileGatewaySettlementsDocument, baseOptions);
      }
export type ReconcileGatewaySettlementsMutationHookResult = ReturnType<typeof useReconcileGatewaySettlementsMutation>;
export type ReconcileGatewaySettlementsMutationResult = Apollo.MutationResult<ReconcileGatewaySettlementsMutation>;
export type ReconcileGatewaySettlementsMutationOptions = Apollo.BaseMutationOptions<ReconcileGatewaySettlementsMutation, ReconcileGatewaySettlementsMutationVariables>;
export const RollbackBankStatementImportDocument = gql`
    mutation RollbackBankStatementImport($importId: ID!, $dryRun: Boolean) {
  rollbackBankStatementImport(importId: $importId, dryRun: $dryRun) {
    success
    errors
    dryRun
    stats
  }
}
    `;
export type RollbackBankStatementImportMutationFn = Apollo.MutationFunction<RollbackBankStatementImportMutation, RollbackBankStatementImportMutationVariables>;

/**
 * __useRollbackBankStatementImportMutation__
 *
 * To run a mutation, you first call `useRollbackBankStatementImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollbackBankStatementImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollbackBankStatementImportMutation, { data, loading, error }] = useRollbackBankStatementImportMutation({
 *   variables: {
 *      importId: // value for 'importId'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useRollbackBankStatementImportMutation(baseOptions?: Apollo.MutationHookOptions<RollbackBankStatementImportMutation, RollbackBankStatementImportMutationVariables>) {
        return Apollo.useMutation<RollbackBankStatementImportMutation, RollbackBankStatementImportMutationVariables>(RollbackBankStatementImportDocument, baseOptions);
      }
export type RollbackBankStatementImportMutationHookResult = ReturnType<typeof useRollbackBankStatementImportMutation>;
export type RollbackBankStatementImportMutationResult = Apollo.MutationResult<RollbackBankStatementImportMutation>;
export type RollbackBankStatementImportMutationOptions = Apollo.BaseMutationOptions<RollbackBankStatementImportMutation, RollbackBankStatementImportMutationVariables>;
export const ClearBankTransactionReviewDocument = gql`
    mutation ClearBankTransactionReview($id: ID!) {
  clearBankTransactionReview(id: $id) {
    success
    errors
    transaction {
      pk
      needsReview
    }
  }
}
    `;
export type ClearBankTransactionReviewMutationFn = Apollo.MutationFunction<ClearBankTransactionReviewMutation, ClearBankTransactionReviewMutationVariables>;

/**
 * __useClearBankTransactionReviewMutation__
 *
 * To run a mutation, you first call `useClearBankTransactionReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearBankTransactionReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearBankTransactionReviewMutation, { data, loading, error }] = useClearBankTransactionReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClearBankTransactionReviewMutation(baseOptions?: Apollo.MutationHookOptions<ClearBankTransactionReviewMutation, ClearBankTransactionReviewMutationVariables>) {
        return Apollo.useMutation<ClearBankTransactionReviewMutation, ClearBankTransactionReviewMutationVariables>(ClearBankTransactionReviewDocument, baseOptions);
      }
export type ClearBankTransactionReviewMutationHookResult = ReturnType<typeof useClearBankTransactionReviewMutation>;
export type ClearBankTransactionReviewMutationResult = Apollo.MutationResult<ClearBankTransactionReviewMutation>;
export type ClearBankTransactionReviewMutationOptions = Apollo.BaseMutationOptions<ClearBankTransactionReviewMutation, ClearBankTransactionReviewMutationVariables>;
export const PostSlackReplyDocument = gql`
    mutation PostSlackReply($conversationId: ID!, $text: String!, $seenMessageId: ID) {
  sendSlackMessage(
    conversationId: $conversationId
    text: $text
    seenMessageId: $seenMessageId
  ) {
    success
    customErrors {
      field
      message
      code
    }
    message {
      id
      direction
      authorName
      authorDisplay
      authorExternalId
      body
      bodyHtml
      attachments {
        index
        name
        size
        mime
        contentId
        inline
      }
      sentAt
      isHandled
      linkedTask {
        id
        title
        status
      }
    }
    conversation {
      id
      hasUnhandled
      unhandledCount
      unreadCount
    }
    readMessageIds
    handledMessageIds
    truncated
  }
}
    `;
export type PostSlackReplyMutationFn = Apollo.MutationFunction<PostSlackReplyMutation, PostSlackReplyMutationVariables>;

/**
 * __usePostSlackReplyMutation__
 *
 * To run a mutation, you first call `usePostSlackReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostSlackReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postSlackReplyMutation, { data, loading, error }] = usePostSlackReplyMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      text: // value for 'text'
 *      seenMessageId: // value for 'seenMessageId'
 *   },
 * });
 */
export function usePostSlackReplyMutation(baseOptions?: Apollo.MutationHookOptions<PostSlackReplyMutation, PostSlackReplyMutationVariables>) {
        return Apollo.useMutation<PostSlackReplyMutation, PostSlackReplyMutationVariables>(PostSlackReplyDocument, baseOptions);
      }
export type PostSlackReplyMutationHookResult = ReturnType<typeof usePostSlackReplyMutation>;
export type PostSlackReplyMutationResult = Apollo.MutationResult<PostSlackReplyMutation>;
export type PostSlackReplyMutationOptions = Apollo.BaseMutationOptions<PostSlackReplyMutation, PostSlackReplyMutationVariables>;
export const SendSlackChannelMsgDocument = gql`
    mutation SendSlackChannelMsg($groupId: ID!, $slackChannelId: String!, $text: String!) {
  sendSlackChannelMessage(
    groupId: $groupId
    slackChannelId: $slackChannelId
    text: $text
  ) {
    success
    conversationId
    customErrors {
      field
      message
      code
    }
    message {
      id
      direction
      authorName
      body
      sentAt
    }
  }
}
    `;
export type SendSlackChannelMsgMutationFn = Apollo.MutationFunction<SendSlackChannelMsgMutation, SendSlackChannelMsgMutationVariables>;

/**
 * __useSendSlackChannelMsgMutation__
 *
 * To run a mutation, you first call `useSendSlackChannelMsgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSlackChannelMsgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSlackChannelMsgMutation, { data, loading, error }] = useSendSlackChannelMsgMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      slackChannelId: // value for 'slackChannelId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSendSlackChannelMsgMutation(baseOptions?: Apollo.MutationHookOptions<SendSlackChannelMsgMutation, SendSlackChannelMsgMutationVariables>) {
        return Apollo.useMutation<SendSlackChannelMsgMutation, SendSlackChannelMsgMutationVariables>(SendSlackChannelMsgDocument, baseOptions);
      }
export type SendSlackChannelMsgMutationHookResult = ReturnType<typeof useSendSlackChannelMsgMutation>;
export type SendSlackChannelMsgMutationResult = Apollo.MutationResult<SendSlackChannelMsgMutation>;
export type SendSlackChannelMsgMutationOptions = Apollo.BaseMutationOptions<SendSlackChannelMsgMutation, SendSlackChannelMsgMutationVariables>;
export const StartSlackDialogDocument = gql`
    mutation StartSlackDialog($studentId: ID, $teacherId: ID, $groupId: ID!, $text: String!) {
  startSlackDm(
    studentId: $studentId
    teacherId: $teacherId
    groupId: $groupId
    text: $text
  ) {
    success
    conversationId
    customErrors {
      field
      message
      code
    }
    message {
      id
      direction
      authorName
      body
      sentAt
    }
  }
}
    `;
export type StartSlackDialogMutationFn = Apollo.MutationFunction<StartSlackDialogMutation, StartSlackDialogMutationVariables>;

/**
 * __useStartSlackDialogMutation__
 *
 * To run a mutation, you first call `useStartSlackDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSlackDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSlackDialogMutation, { data, loading, error }] = useStartSlackDialogMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      teacherId: // value for 'teacherId'
 *      groupId: // value for 'groupId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useStartSlackDialogMutation(baseOptions?: Apollo.MutationHookOptions<StartSlackDialogMutation, StartSlackDialogMutationVariables>) {
        return Apollo.useMutation<StartSlackDialogMutation, StartSlackDialogMutationVariables>(StartSlackDialogDocument, baseOptions);
      }
export type StartSlackDialogMutationHookResult = ReturnType<typeof useStartSlackDialogMutation>;
export type StartSlackDialogMutationResult = Apollo.MutationResult<StartSlackDialogMutation>;
export type StartSlackDialogMutationOptions = Apollo.BaseMutationOptions<StartSlackDialogMutation, StartSlackDialogMutationVariables>;
export const SendNewEmailMsgDocument = gql`
    mutation SendNewEmailMsg($mailboxEmail: String!, $toEmail: String!, $subject: String, $text: String, $html: String, $attachmentIds: [ID], $studentId: ID, $teacherId: ID) {
  sendNewEmail(
    mailboxEmail: $mailboxEmail
    toEmail: $toEmail
    subject: $subject
    text: $text
    html: $html
    attachmentIds: $attachmentIds
    studentId: $studentId
    teacherId: $teacherId
  ) {
    success
    conversationId
    customErrors {
      field
      message
      code
    }
    message {
      id
      direction
      authorName
      body
      sentAt
    }
  }
}
    `;
export type SendNewEmailMsgMutationFn = Apollo.MutationFunction<SendNewEmailMsgMutation, SendNewEmailMsgMutationVariables>;

/**
 * __useSendNewEmailMsgMutation__
 *
 * To run a mutation, you first call `useSendNewEmailMsgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNewEmailMsgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNewEmailMsgMutation, { data, loading, error }] = useSendNewEmailMsgMutation({
 *   variables: {
 *      mailboxEmail: // value for 'mailboxEmail'
 *      toEmail: // value for 'toEmail'
 *      subject: // value for 'subject'
 *      text: // value for 'text'
 *      html: // value for 'html'
 *      attachmentIds: // value for 'attachmentIds'
 *      studentId: // value for 'studentId'
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useSendNewEmailMsgMutation(baseOptions?: Apollo.MutationHookOptions<SendNewEmailMsgMutation, SendNewEmailMsgMutationVariables>) {
        return Apollo.useMutation<SendNewEmailMsgMutation, SendNewEmailMsgMutationVariables>(SendNewEmailMsgDocument, baseOptions);
      }
export type SendNewEmailMsgMutationHookResult = ReturnType<typeof useSendNewEmailMsgMutation>;
export type SendNewEmailMsgMutationResult = Apollo.MutationResult<SendNewEmailMsgMutation>;
export type SendNewEmailMsgMutationOptions = Apollo.BaseMutationOptions<SendNewEmailMsgMutation, SendNewEmailMsgMutationVariables>;
export const SendGroupBroadcastDocument = gql`
    mutation SendGroupBroadcast($groupId: ID!, $studentIds: [ID!]!, $channel: String!, $mailboxEmail: String, $subject: String, $text: String, $html: String, $attachmentIds: [ID]) {
  broadcastGroupMessage(
    groupId: $groupId
    studentIds: $studentIds
    channel: $channel
    mailboxEmail: $mailboxEmail
    subject: $subject
    text: $text
    html: $html
    attachmentIds: $attachmentIds
  ) {
    success
    broadcastJobId
    total
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type SendGroupBroadcastMutationFn = Apollo.MutationFunction<SendGroupBroadcastMutation, SendGroupBroadcastMutationVariables>;

/**
 * __useSendGroupBroadcastMutation__
 *
 * To run a mutation, you first call `useSendGroupBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGroupBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGroupBroadcastMutation, { data, loading, error }] = useSendGroupBroadcastMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      studentIds: // value for 'studentIds'
 *      channel: // value for 'channel'
 *      mailboxEmail: // value for 'mailboxEmail'
 *      subject: // value for 'subject'
 *      text: // value for 'text'
 *      html: // value for 'html'
 *      attachmentIds: // value for 'attachmentIds'
 *   },
 * });
 */
export function useSendGroupBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<SendGroupBroadcastMutation, SendGroupBroadcastMutationVariables>) {
        return Apollo.useMutation<SendGroupBroadcastMutation, SendGroupBroadcastMutationVariables>(SendGroupBroadcastDocument, baseOptions);
      }
export type SendGroupBroadcastMutationHookResult = ReturnType<typeof useSendGroupBroadcastMutation>;
export type SendGroupBroadcastMutationResult = Apollo.MutationResult<SendGroupBroadcastMutation>;
export type SendGroupBroadcastMutationOptions = Apollo.BaseMutationOptions<SendGroupBroadcastMutation, SendGroupBroadcastMutationVariables>;
export const PostGmailReplyDocument = gql`
    mutation PostGmailReply($conversationId: ID!, $text: String, $html: String, $attachmentIds: [ID], $seenMessageId: ID) {
  sendGmailReply(
    conversationId: $conversationId
    text: $text
    html: $html
    attachmentIds: $attachmentIds
    seenMessageId: $seenMessageId
  ) {
    success
    customErrors {
      field
      message
      code
    }
    message {
      id
      direction
      authorName
      authorDisplay
      authorExternalId
      body
      bodyHtml
      attachments {
        index
        name
        size
        mime
        contentId
        inline
      }
      sentAt
      isHandled
      linkedTask {
        id
        title
        status
      }
    }
    conversation {
      id
      hasUnhandled
      unhandledCount
      unreadCount
    }
    readMessageIds
    handledMessageIds
    truncated
  }
}
    `;
export type PostGmailReplyMutationFn = Apollo.MutationFunction<PostGmailReplyMutation, PostGmailReplyMutationVariables>;

/**
 * __usePostGmailReplyMutation__
 *
 * To run a mutation, you first call `usePostGmailReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostGmailReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postGmailReplyMutation, { data, loading, error }] = usePostGmailReplyMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      text: // value for 'text'
 *      html: // value for 'html'
 *      attachmentIds: // value for 'attachmentIds'
 *      seenMessageId: // value for 'seenMessageId'
 *   },
 * });
 */
export function usePostGmailReplyMutation(baseOptions?: Apollo.MutationHookOptions<PostGmailReplyMutation, PostGmailReplyMutationVariables>) {
        return Apollo.useMutation<PostGmailReplyMutation, PostGmailReplyMutationVariables>(PostGmailReplyDocument, baseOptions);
      }
export type PostGmailReplyMutationHookResult = ReturnType<typeof usePostGmailReplyMutation>;
export type PostGmailReplyMutationResult = Apollo.MutationResult<PostGmailReplyMutation>;
export type PostGmailReplyMutationOptions = Apollo.BaseMutationOptions<PostGmailReplyMutation, PostGmailReplyMutationVariables>;
export const MapSlackUserDocument = gql`
    mutation MapSlackUser($slackUserId: String!, $studentId: ID, $teacherId: ID, $email: String, $groupId: ID) {
  linkSlackUser(
    slackUserId: $slackUserId
    studentId: $studentId
    teacherId: $teacherId
    email: $email
    groupId: $groupId
  ) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type MapSlackUserMutationFn = Apollo.MutationFunction<MapSlackUserMutation, MapSlackUserMutationVariables>;

/**
 * __useMapSlackUserMutation__
 *
 * To run a mutation, you first call `useMapSlackUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMapSlackUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mapSlackUserMutation, { data, loading, error }] = useMapSlackUserMutation({
 *   variables: {
 *      slackUserId: // value for 'slackUserId'
 *      studentId: // value for 'studentId'
 *      teacherId: // value for 'teacherId'
 *      email: // value for 'email'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useMapSlackUserMutation(baseOptions?: Apollo.MutationHookOptions<MapSlackUserMutation, MapSlackUserMutationVariables>) {
        return Apollo.useMutation<MapSlackUserMutation, MapSlackUserMutationVariables>(MapSlackUserDocument, baseOptions);
      }
export type MapSlackUserMutationHookResult = ReturnType<typeof useMapSlackUserMutation>;
export type MapSlackUserMutationResult = Apollo.MutationResult<MapSlackUserMutation>;
export type MapSlackUserMutationOptions = Apollo.BaseMutationOptions<MapSlackUserMutation, MapSlackUserMutationVariables>;
export const MarkMsgReadDocument = gql`
    mutation MarkMsgRead($messageId: ID!, $read: Boolean) {
  markMessageRead(messageId: $messageId, read: $read) {
    success
    customErrors {
      field
      message
      code
    }
    message {
      id
      isRead
    }
  }
}
    `;
export type MarkMsgReadMutationFn = Apollo.MutationFunction<MarkMsgReadMutation, MarkMsgReadMutationVariables>;

/**
 * __useMarkMsgReadMutation__
 *
 * To run a mutation, you first call `useMarkMsgReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMsgReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMsgReadMutation, { data, loading, error }] = useMarkMsgReadMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useMarkMsgReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkMsgReadMutation, MarkMsgReadMutationVariables>) {
        return Apollo.useMutation<MarkMsgReadMutation, MarkMsgReadMutationVariables>(MarkMsgReadDocument, baseOptions);
      }
export type MarkMsgReadMutationHookResult = ReturnType<typeof useMarkMsgReadMutation>;
export type MarkMsgReadMutationResult = Apollo.MutationResult<MarkMsgReadMutation>;
export type MarkMsgReadMutationOptions = Apollo.BaseMutationOptions<MarkMsgReadMutation, MarkMsgReadMutationVariables>;
export const FlagMsgDocument = gql`
    mutation FlagMsg($messageId: ID!, $flagged: Boolean) {
  flagMessage(messageId: $messageId, flagged: $flagged) {
    success
    customErrors {
      field
      message
      code
    }
    message {
      id
      isFlagged
    }
  }
}
    `;
export type FlagMsgMutationFn = Apollo.MutationFunction<FlagMsgMutation, FlagMsgMutationVariables>;

/**
 * __useFlagMsgMutation__
 *
 * To run a mutation, you first call `useFlagMsgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagMsgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagMsgMutation, { data, loading, error }] = useFlagMsgMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      flagged: // value for 'flagged'
 *   },
 * });
 */
export function useFlagMsgMutation(baseOptions?: Apollo.MutationHookOptions<FlagMsgMutation, FlagMsgMutationVariables>) {
        return Apollo.useMutation<FlagMsgMutation, FlagMsgMutationVariables>(FlagMsgDocument, baseOptions);
      }
export type FlagMsgMutationHookResult = ReturnType<typeof useFlagMsgMutation>;
export type FlagMsgMutationResult = Apollo.MutationResult<FlagMsgMutation>;
export type FlagMsgMutationOptions = Apollo.BaseMutationOptions<FlagMsgMutation, FlagMsgMutationVariables>;
export const SetMsgHandledDocument = gql`
    mutation SetMsgHandled($messageId: ID!, $handled: Boolean, $cascade: Boolean) {
  setMessageHandled(messageId: $messageId, handled: $handled, cascade: $cascade) {
    success
    customErrors {
      field
      message
      code
    }
    message {
      id
      isHandled
      isRead
    }
    conversation {
      id
      hasUnhandled
      unhandledCount
      unreadCount
    }
    readMessageIds
    handledMessageIds
    truncated
  }
}
    `;
export type SetMsgHandledMutationFn = Apollo.MutationFunction<SetMsgHandledMutation, SetMsgHandledMutationVariables>;

/**
 * __useSetMsgHandledMutation__
 *
 * To run a mutation, you first call `useSetMsgHandledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMsgHandledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMsgHandledMutation, { data, loading, error }] = useSetMsgHandledMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      handled: // value for 'handled'
 *      cascade: // value for 'cascade'
 *   },
 * });
 */
export function useSetMsgHandledMutation(baseOptions?: Apollo.MutationHookOptions<SetMsgHandledMutation, SetMsgHandledMutationVariables>) {
        return Apollo.useMutation<SetMsgHandledMutation, SetMsgHandledMutationVariables>(SetMsgHandledDocument, baseOptions);
      }
export type SetMsgHandledMutationHookResult = ReturnType<typeof useSetMsgHandledMutation>;
export type SetMsgHandledMutationResult = Apollo.MutationResult<SetMsgHandledMutation>;
export type SetMsgHandledMutationOptions = Apollo.BaseMutationOptions<SetMsgHandledMutation, SetMsgHandledMutationVariables>;
export const MarkConvsHandledDocument = gql`
    mutation MarkConvsHandled($scope: String!, $conversationId: ID, $studentId: ID, $teacherId: ID, $groupId: ID, $kinds: [String!], $search: String, $dateFrom: Date, $dateTo: Date, $unhandledOnly: Boolean) {
  markConversationsHandled(
    scope: $scope
    conversationId: $conversationId
    studentId: $studentId
    teacherId: $teacherId
    groupId: $groupId
    kinds: $kinds
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    unhandledOnly: $unhandledOnly
  ) {
    success
    customErrors {
      field
      message
      code
    }
    messagesAffected
    conversationsAffected
    truncated
    undoable
    readMessageIds
    handledMessageIds
    conversations {
      id
      unreadCount
      unhandledCount
      hasUnhandled
    }
  }
}
    `;
export type MarkConvsHandledMutationFn = Apollo.MutationFunction<MarkConvsHandledMutation, MarkConvsHandledMutationVariables>;

/**
 * __useMarkConvsHandledMutation__
 *
 * To run a mutation, you first call `useMarkConvsHandledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConvsHandledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConvsHandledMutation, { data, loading, error }] = useMarkConvsHandledMutation({
 *   variables: {
 *      scope: // value for 'scope'
 *      conversationId: // value for 'conversationId'
 *      studentId: // value for 'studentId'
 *      teacherId: // value for 'teacherId'
 *      groupId: // value for 'groupId'
 *      kinds: // value for 'kinds'
 *      search: // value for 'search'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      unhandledOnly: // value for 'unhandledOnly'
 *   },
 * });
 */
export function useMarkConvsHandledMutation(baseOptions?: Apollo.MutationHookOptions<MarkConvsHandledMutation, MarkConvsHandledMutationVariables>) {
        return Apollo.useMutation<MarkConvsHandledMutation, MarkConvsHandledMutationVariables>(MarkConvsHandledDocument, baseOptions);
      }
export type MarkConvsHandledMutationHookResult = ReturnType<typeof useMarkConvsHandledMutation>;
export type MarkConvsHandledMutationResult = Apollo.MutationResult<MarkConvsHandledMutation>;
export type MarkConvsHandledMutationOptions = Apollo.BaseMutationOptions<MarkConvsHandledMutation, MarkConvsHandledMutationVariables>;
export const MarkConvReadDocument = gql`
    mutation MarkConvRead($conversationId: ID!, $read: Boolean) {
  markConversationRead(conversationId: $conversationId, read: $read) {
    success
    customErrors {
      field
      message
      code
    }
    updated
    conversation {
      id
      unreadCount
      hasUnhandled
    }
  }
}
    `;
export type MarkConvReadMutationFn = Apollo.MutationFunction<MarkConvReadMutation, MarkConvReadMutationVariables>;

/**
 * __useMarkConvReadMutation__
 *
 * To run a mutation, you first call `useMarkConvReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConvReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConvReadMutation, { data, loading, error }] = useMarkConvReadMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useMarkConvReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkConvReadMutation, MarkConvReadMutationVariables>) {
        return Apollo.useMutation<MarkConvReadMutation, MarkConvReadMutationVariables>(MarkConvReadDocument, baseOptions);
      }
export type MarkConvReadMutationHookResult = ReturnType<typeof useMarkConvReadMutation>;
export type MarkConvReadMutationResult = Apollo.MutationResult<MarkConvReadMutation>;
export type MarkConvReadMutationOptions = Apollo.BaseMutationOptions<MarkConvReadMutation, MarkConvReadMutationVariables>;
export const SetConvStatusDocument = gql`
    mutation SetConvStatus($conversationId: ID!, $status: String!) {
  setConversationStatus(conversationId: $conversationId, status: $status) {
    success
    customErrors {
      field
      message
      code
    }
    conversation {
      id
      status
    }
  }
}
    `;
export type SetConvStatusMutationFn = Apollo.MutationFunction<SetConvStatusMutation, SetConvStatusMutationVariables>;

/**
 * __useSetConvStatusMutation__
 *
 * To run a mutation, you first call `useSetConvStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConvStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConvStatusMutation, { data, loading, error }] = useSetConvStatusMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetConvStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetConvStatusMutation, SetConvStatusMutationVariables>) {
        return Apollo.useMutation<SetConvStatusMutation, SetConvStatusMutationVariables>(SetConvStatusDocument, baseOptions);
      }
export type SetConvStatusMutationHookResult = ReturnType<typeof useSetConvStatusMutation>;
export type SetConvStatusMutationResult = Apollo.MutationResult<SetConvStatusMutation>;
export type SetConvStatusMutationOptions = Apollo.BaseMutationOptions<SetConvStatusMutation, SetConvStatusMutationVariables>;
export const CreateTaskFromMsgDocument = gql`
    mutation CreateTaskFromMsg($messageId: ID!, $title: String!, $description: String, $dueDate: Date, $assigneeId: ID, $priority: String, $groupId: ID) {
  createTaskFromMessage(
    messageId: $messageId
    title: $title
    description: $description
    dueDate: $dueDate
    assigneeId: $assigneeId
    priority: $priority
    groupId: $groupId
  ) {
    success
    customErrors {
      field
      message
      code
    }
    task {
      id
      title
      status
    }
    message {
      id
      isHandled
      linkedTask {
        id
        title
        status
      }
    }
    conversation {
      id
      status
      hasUnhandled
      unhandledCount
    }
  }
}
    `;
export type CreateTaskFromMsgMutationFn = Apollo.MutationFunction<CreateTaskFromMsgMutation, CreateTaskFromMsgMutationVariables>;

/**
 * __useCreateTaskFromMsgMutation__
 *
 * To run a mutation, you first call `useCreateTaskFromMsgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskFromMsgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskFromMsgMutation, { data, loading, error }] = useCreateTaskFromMsgMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      dueDate: // value for 'dueDate'
 *      assigneeId: // value for 'assigneeId'
 *      priority: // value for 'priority'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useCreateTaskFromMsgMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskFromMsgMutation, CreateTaskFromMsgMutationVariables>) {
        return Apollo.useMutation<CreateTaskFromMsgMutation, CreateTaskFromMsgMutationVariables>(CreateTaskFromMsgDocument, baseOptions);
      }
export type CreateTaskFromMsgMutationHookResult = ReturnType<typeof useCreateTaskFromMsgMutation>;
export type CreateTaskFromMsgMutationResult = Apollo.MutationResult<CreateTaskFromMsgMutation>;
export type CreateTaskFromMsgMutationOptions = Apollo.BaseMutationOptions<CreateTaskFromMsgMutation, CreateTaskFromMsgMutationVariables>;
export const TriggerGmailSyncDocument = gql`
    mutation TriggerGmailSync {
  syncGmailNow {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type TriggerGmailSyncMutationFn = Apollo.MutationFunction<TriggerGmailSyncMutation, TriggerGmailSyncMutationVariables>;

/**
 * __useTriggerGmailSyncMutation__
 *
 * To run a mutation, you first call `useTriggerGmailSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerGmailSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerGmailSyncMutation, { data, loading, error }] = useTriggerGmailSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerGmailSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerGmailSyncMutation, TriggerGmailSyncMutationVariables>) {
        return Apollo.useMutation<TriggerGmailSyncMutation, TriggerGmailSyncMutationVariables>(TriggerGmailSyncDocument, baseOptions);
      }
export type TriggerGmailSyncMutationHookResult = ReturnType<typeof useTriggerGmailSyncMutation>;
export type TriggerGmailSyncMutationResult = Apollo.MutationResult<TriggerGmailSyncMutation>;
export type TriggerGmailSyncMutationOptions = Apollo.BaseMutationOptions<TriggerGmailSyncMutation, TriggerGmailSyncMutationVariables>;
export const TriggerCommsSyncDocument = gql`
    mutation TriggerCommsSync($groupId: ID) {
  syncCommunicationsNow(groupId: $groupId) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type TriggerCommsSyncMutationFn = Apollo.MutationFunction<TriggerCommsSyncMutation, TriggerCommsSyncMutationVariables>;

/**
 * __useTriggerCommsSyncMutation__
 *
 * To run a mutation, you first call `useTriggerCommsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCommsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCommsSyncMutation, { data, loading, error }] = useTriggerCommsSyncMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useTriggerCommsSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerCommsSyncMutation, TriggerCommsSyncMutationVariables>) {
        return Apollo.useMutation<TriggerCommsSyncMutation, TriggerCommsSyncMutationVariables>(TriggerCommsSyncDocument, baseOptions);
      }
export type TriggerCommsSyncMutationHookResult = ReturnType<typeof useTriggerCommsSyncMutation>;
export type TriggerCommsSyncMutationResult = Apollo.MutationResult<TriggerCommsSyncMutation>;
export type TriggerCommsSyncMutationOptions = Apollo.BaseMutationOptions<TriggerCommsSyncMutation, TriggerCommsSyncMutationVariables>;
export const SaveSlackWorkspaceDocument = gql`
    mutation SaveSlackWorkspace($groupId: ID!, $botToken: String, $signingSecret: String, $workspaceName: String, $oauthClientId: String, $oauthClientSecret: String) {
  setSlackWorkspace(
    groupId: $groupId
    botToken: $botToken
    signingSecret: $signingSecret
    workspaceName: $workspaceName
    oauthClientId: $oauthClientId
    oauthClientSecret: $oauthClientSecret
  ) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type SaveSlackWorkspaceMutationFn = Apollo.MutationFunction<SaveSlackWorkspaceMutation, SaveSlackWorkspaceMutationVariables>;

/**
 * __useSaveSlackWorkspaceMutation__
 *
 * To run a mutation, you first call `useSaveSlackWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSlackWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSlackWorkspaceMutation, { data, loading, error }] = useSaveSlackWorkspaceMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      botToken: // value for 'botToken'
 *      signingSecret: // value for 'signingSecret'
 *      workspaceName: // value for 'workspaceName'
 *      oauthClientId: // value for 'oauthClientId'
 *      oauthClientSecret: // value for 'oauthClientSecret'
 *   },
 * });
 */
export function useSaveSlackWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<SaveSlackWorkspaceMutation, SaveSlackWorkspaceMutationVariables>) {
        return Apollo.useMutation<SaveSlackWorkspaceMutation, SaveSlackWorkspaceMutationVariables>(SaveSlackWorkspaceDocument, baseOptions);
      }
export type SaveSlackWorkspaceMutationHookResult = ReturnType<typeof useSaveSlackWorkspaceMutation>;
export type SaveSlackWorkspaceMutationResult = Apollo.MutationResult<SaveSlackWorkspaceMutation>;
export type SaveSlackWorkspaceMutationOptions = Apollo.BaseMutationOptions<SaveSlackWorkspaceMutation, SaveSlackWorkspaceMutationVariables>;
export const SaveMySlackUserTokenDocument = gql`
    mutation SaveMySlackUserToken($groupId: ID!, $userToken: String!) {
  setMySlackUserToken(groupId: $groupId, userToken: $userToken) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type SaveMySlackUserTokenMutationFn = Apollo.MutationFunction<SaveMySlackUserTokenMutation, SaveMySlackUserTokenMutationVariables>;

/**
 * __useSaveMySlackUserTokenMutation__
 *
 * To run a mutation, you first call `useSaveMySlackUserTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMySlackUserTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMySlackUserTokenMutation, { data, loading, error }] = useSaveMySlackUserTokenMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userToken: // value for 'userToken'
 *   },
 * });
 */
export function useSaveMySlackUserTokenMutation(baseOptions?: Apollo.MutationHookOptions<SaveMySlackUserTokenMutation, SaveMySlackUserTokenMutationVariables>) {
        return Apollo.useMutation<SaveMySlackUserTokenMutation, SaveMySlackUserTokenMutationVariables>(SaveMySlackUserTokenDocument, baseOptions);
      }
export type SaveMySlackUserTokenMutationHookResult = ReturnType<typeof useSaveMySlackUserTokenMutation>;
export type SaveMySlackUserTokenMutationResult = Apollo.MutationResult<SaveMySlackUserTokenMutation>;
export type SaveMySlackUserTokenMutationOptions = Apollo.BaseMutationOptions<SaveMySlackUserTokenMutation, SaveMySlackUserTokenMutationVariables>;
export const BeginSlackUserOauthDocument = gql`
    mutation BeginSlackUserOauth($groupId: ID!) {
  startSlackUserOauth(groupId: $groupId) {
    success
    customErrors {
      field
      code
      message
    }
    authorizeUrl
  }
}
    `;
export type BeginSlackUserOauthMutationFn = Apollo.MutationFunction<BeginSlackUserOauthMutation, BeginSlackUserOauthMutationVariables>;

/**
 * __useBeginSlackUserOauthMutation__
 *
 * To run a mutation, you first call `useBeginSlackUserOauthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeginSlackUserOauthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beginSlackUserOauthMutation, { data, loading, error }] = useBeginSlackUserOauthMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useBeginSlackUserOauthMutation(baseOptions?: Apollo.MutationHookOptions<BeginSlackUserOauthMutation, BeginSlackUserOauthMutationVariables>) {
        return Apollo.useMutation<BeginSlackUserOauthMutation, BeginSlackUserOauthMutationVariables>(BeginSlackUserOauthDocument, baseOptions);
      }
export type BeginSlackUserOauthMutationHookResult = ReturnType<typeof useBeginSlackUserOauthMutation>;
export type BeginSlackUserOauthMutationResult = Apollo.MutationResult<BeginSlackUserOauthMutation>;
export type BeginSlackUserOauthMutationOptions = Apollo.BaseMutationOptions<BeginSlackUserOauthMutation, BeginSlackUserOauthMutationVariables>;
export const RevertMsgTriageDocument = gql`
    mutation RevertMsgTriage($read: [ID!], $handled: [ID!]) {
  revertMessagesTriage(readMessageIds: $read, handledMessageIds: $handled) {
    success
    customErrors {
      field
      message
      code
    }
    messagesReverted
    conversations {
      id
      unreadCount
      unhandledCount
      hasUnhandled
    }
  }
}
    `;
export type RevertMsgTriageMutationFn = Apollo.MutationFunction<RevertMsgTriageMutation, RevertMsgTriageMutationVariables>;

/**
 * __useRevertMsgTriageMutation__
 *
 * To run a mutation, you first call `useRevertMsgTriageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertMsgTriageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertMsgTriageMutation, { data, loading, error }] = useRevertMsgTriageMutation({
 *   variables: {
 *      read: // value for 'read'
 *      handled: // value for 'handled'
 *   },
 * });
 */
export function useRevertMsgTriageMutation(baseOptions?: Apollo.MutationHookOptions<RevertMsgTriageMutation, RevertMsgTriageMutationVariables>) {
        return Apollo.useMutation<RevertMsgTriageMutation, RevertMsgTriageMutationVariables>(RevertMsgTriageDocument, baseOptions);
      }
export type RevertMsgTriageMutationHookResult = ReturnType<typeof useRevertMsgTriageMutation>;
export type RevertMsgTriageMutationResult = Apollo.MutationResult<RevertMsgTriageMutation>;
export type RevertMsgTriageMutationOptions = Apollo.BaseMutationOptions<RevertMsgTriageMutation, RevertMsgTriageMutationVariables>;
export const AddCompanyDocument = gql`
    mutation addCompany($companyInput: CompanyInput!) {
  createCompany(companyInput: $companyInput) {
    success
    errors
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type AddCompanyMutationFn = Apollo.MutationFunction<AddCompanyMutation, AddCompanyMutationVariables>;

/**
 * __useAddCompanyMutation__
 *
 * To run a mutation, you first call `useAddCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyMutation, { data, loading, error }] = useAddCompanyMutation({
 *   variables: {
 *      companyInput: // value for 'companyInput'
 *   },
 * });
 */
export function useAddCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyMutation, AddCompanyMutationVariables>) {
        return Apollo.useMutation<AddCompanyMutation, AddCompanyMutationVariables>(AddCompanyDocument, baseOptions);
      }
export type AddCompanyMutationHookResult = ReturnType<typeof useAddCompanyMutation>;
export type AddCompanyMutationResult = Apollo.MutationResult<AddCompanyMutation>;
export type AddCompanyMutationOptions = Apollo.BaseMutationOptions<AddCompanyMutation, AddCompanyMutationVariables>;
export const EditCompanyDocument = gql`
    mutation editCompany($companyId: ID!, $companyInput: UpdateCompanyInput!) {
  updateCompany(companyId: $companyId, companyInput: $companyInput) {
    company {
      id
      name
      responsiblePerson
      email
      phone
      registrationNumber
      comment
    }
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type EditCompanyMutationFn = Apollo.MutationFunction<EditCompanyMutation, EditCompanyMutationVariables>;

/**
 * __useEditCompanyMutation__
 *
 * To run a mutation, you first call `useEditCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyMutation, { data, loading, error }] = useEditCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      companyInput: // value for 'companyInput'
 *   },
 * });
 */
export function useEditCompanyMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyMutation, EditCompanyMutationVariables>) {
        return Apollo.useMutation<EditCompanyMutation, EditCompanyMutationVariables>(EditCompanyDocument, baseOptions);
      }
export type EditCompanyMutationHookResult = ReturnType<typeof useEditCompanyMutation>;
export type EditCompanyMutationResult = Apollo.MutationResult<EditCompanyMutation>;
export type EditCompanyMutationOptions = Apollo.BaseMutationOptions<EditCompanyMutation, EditCompanyMutationVariables>;
export const SaveCourseTariffPriceDocument = gql`
    mutation SaveCourseTariffPrice($courseId: ID!, $planId: ID!, $currency: String!, $amount: String!) {
  setCoursePlanPrice(
    courseId: $courseId
    planId: $planId
    currency: $currency
    amount: $amount
  ) {
    success
    customErrors {
      field
      code
      message
    }
    price {
      id
      courseId
      planId
      planName
      planIsActive
      currency
      amount
    }
  }
}
    `;
export type SaveCourseTariffPriceMutationFn = Apollo.MutationFunction<SaveCourseTariffPriceMutation, SaveCourseTariffPriceMutationVariables>;

/**
 * __useSaveCourseTariffPriceMutation__
 *
 * To run a mutation, you first call `useSaveCourseTariffPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCourseTariffPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCourseTariffPriceMutation, { data, loading, error }] = useSaveCourseTariffPriceMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      planId: // value for 'planId'
 *      currency: // value for 'currency'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useSaveCourseTariffPriceMutation(baseOptions?: Apollo.MutationHookOptions<SaveCourseTariffPriceMutation, SaveCourseTariffPriceMutationVariables>) {
        return Apollo.useMutation<SaveCourseTariffPriceMutation, SaveCourseTariffPriceMutationVariables>(SaveCourseTariffPriceDocument, baseOptions);
      }
export type SaveCourseTariffPriceMutationHookResult = ReturnType<typeof useSaveCourseTariffPriceMutation>;
export type SaveCourseTariffPriceMutationResult = Apollo.MutationResult<SaveCourseTariffPriceMutation>;
export type SaveCourseTariffPriceMutationOptions = Apollo.BaseMutationOptions<SaveCourseTariffPriceMutation, SaveCourseTariffPriceMutationVariables>;
export const RemoveCourseTariffPriceDocument = gql`
    mutation RemoveCourseTariffPrice($id: ID!) {
  deleteCoursePlanPrice(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type RemoveCourseTariffPriceMutationFn = Apollo.MutationFunction<RemoveCourseTariffPriceMutation, RemoveCourseTariffPriceMutationVariables>;

/**
 * __useRemoveCourseTariffPriceMutation__
 *
 * To run a mutation, you first call `useRemoveCourseTariffPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCourseTariffPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCourseTariffPriceMutation, { data, loading, error }] = useRemoveCourseTariffPriceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCourseTariffPriceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCourseTariffPriceMutation, RemoveCourseTariffPriceMutationVariables>) {
        return Apollo.useMutation<RemoveCourseTariffPriceMutation, RemoveCourseTariffPriceMutationVariables>(RemoveCourseTariffPriceDocument, baseOptions);
      }
export type RemoveCourseTariffPriceMutationHookResult = ReturnType<typeof useRemoveCourseTariffPriceMutation>;
export type RemoveCourseTariffPriceMutationResult = Apollo.MutationResult<RemoveCourseTariffPriceMutation>;
export type RemoveCourseTariffPriceMutationOptions = Apollo.BaseMutationOptions<RemoveCourseTariffPriceMutation, RemoveCourseTariffPriceMutationVariables>;
export const WriteLeadSmsDocument = gql`
    mutation WriteLeadSms($leadId: ID!, $text: String!, $link: LeadSmsLinkInput, $templateId: ID, $requestKey: String) {
  sendLeadSms(
    leadId: $leadId
    text: $text
    link: $link
    templateId: $templateId
    requestKey: $requestKey
  ) {
    success
    customErrors {
      field
      code
      message
    }
    message {
      ...SmsMessageFields
    }
    state {
      ...LeadSmsStateFields
    }
  }
}
    ${SmsMessageFieldsFragmentDoc}
${LeadSmsStateFieldsFragmentDoc}`;
export type WriteLeadSmsMutationFn = Apollo.MutationFunction<WriteLeadSmsMutation, WriteLeadSmsMutationVariables>;

/**
 * __useWriteLeadSmsMutation__
 *
 * To run a mutation, you first call `useWriteLeadSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteLeadSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeLeadSmsMutation, { data, loading, error }] = useWriteLeadSmsMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      text: // value for 'text'
 *      link: // value for 'link'
 *      templateId: // value for 'templateId'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useWriteLeadSmsMutation(baseOptions?: Apollo.MutationHookOptions<WriteLeadSmsMutation, WriteLeadSmsMutationVariables>) {
        return Apollo.useMutation<WriteLeadSmsMutation, WriteLeadSmsMutationVariables>(WriteLeadSmsDocument, baseOptions);
      }
export type WriteLeadSmsMutationHookResult = ReturnType<typeof useWriteLeadSmsMutation>;
export type WriteLeadSmsMutationResult = Apollo.MutationResult<WriteLeadSmsMutation>;
export type WriteLeadSmsMutationOptions = Apollo.BaseMutationOptions<WriteLeadSmsMutation, WriteLeadSmsMutationVariables>;
export const RefreshLeadDocument = gql`
    mutation RefreshLead($id: ID!) {
  refreshKommoLead(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
    refreshed
    lead {
      ...KommoLeadCardFields
    }
  }
}
    ${KommoLeadCardFieldsFragmentDoc}`;
export type RefreshLeadMutationFn = Apollo.MutationFunction<RefreshLeadMutation, RefreshLeadMutationVariables>;

/**
 * __useRefreshLeadMutation__
 *
 * To run a mutation, you first call `useRefreshLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshLeadMutation, { data, loading, error }] = useRefreshLeadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshLeadMutation(baseOptions?: Apollo.MutationHookOptions<RefreshLeadMutation, RefreshLeadMutationVariables>) {
        return Apollo.useMutation<RefreshLeadMutation, RefreshLeadMutationVariables>(RefreshLeadDocument, baseOptions);
      }
export type RefreshLeadMutationHookResult = ReturnType<typeof useRefreshLeadMutation>;
export type RefreshLeadMutationResult = Apollo.MutationResult<RefreshLeadMutation>;
export type RefreshLeadMutationOptions = Apollo.BaseMutationOptions<RefreshLeadMutation, RefreshLeadMutationVariables>;
export const SyncLeadsNowDocument = gql`
    mutation SyncLeadsNow($full: Boolean) {
  syncKommoLeads(full: $full) {
    success
    customErrors {
      field
      code
      message
    }
    queued
  }
}
    `;
export type SyncLeadsNowMutationFn = Apollo.MutationFunction<SyncLeadsNowMutation, SyncLeadsNowMutationVariables>;

/**
 * __useSyncLeadsNowMutation__
 *
 * To run a mutation, you first call `useSyncLeadsNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncLeadsNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncLeadsNowMutation, { data, loading, error }] = useSyncLeadsNowMutation({
 *   variables: {
 *      full: // value for 'full'
 *   },
 * });
 */
export function useSyncLeadsNowMutation(baseOptions?: Apollo.MutationHookOptions<SyncLeadsNowMutation, SyncLeadsNowMutationVariables>) {
        return Apollo.useMutation<SyncLeadsNowMutation, SyncLeadsNowMutationVariables>(SyncLeadsNowDocument, baseOptions);
      }
export type SyncLeadsNowMutationHookResult = ReturnType<typeof useSyncLeadsNowMutation>;
export type SyncLeadsNowMutationResult = Apollo.MutationResult<SyncLeadsNowMutation>;
export type SyncLeadsNowMutationOptions = Apollo.BaseMutationOptions<SyncLeadsNowMutation, SyncLeadsNowMutationVariables>;
export const SaveKommoUserMappingDocument = gql`
    mutation SaveKommoUserMapping($kommoUserId: ID!, $userId: ID, $locked: Boolean) {
  setKommoUserMapping(kommoUserId: $kommoUserId, userId: $userId, locked: $locked) {
    success
    customErrors {
      field
      code
      message
    }
    user {
      ...KommoUserFields
    }
  }
}
    ${KommoUserFieldsFragmentDoc}`;
export type SaveKommoUserMappingMutationFn = Apollo.MutationFunction<SaveKommoUserMappingMutation, SaveKommoUserMappingMutationVariables>;

/**
 * __useSaveKommoUserMappingMutation__
 *
 * To run a mutation, you first call `useSaveKommoUserMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveKommoUserMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveKommoUserMappingMutation, { data, loading, error }] = useSaveKommoUserMappingMutation({
 *   variables: {
 *      kommoUserId: // value for 'kommoUserId'
 *      userId: // value for 'userId'
 *      locked: // value for 'locked'
 *   },
 * });
 */
export function useSaveKommoUserMappingMutation(baseOptions?: Apollo.MutationHookOptions<SaveKommoUserMappingMutation, SaveKommoUserMappingMutationVariables>) {
        return Apollo.useMutation<SaveKommoUserMappingMutation, SaveKommoUserMappingMutationVariables>(SaveKommoUserMappingDocument, baseOptions);
      }
export type SaveKommoUserMappingMutationHookResult = ReturnType<typeof useSaveKommoUserMappingMutation>;
export type SaveKommoUserMappingMutationResult = Apollo.MutationResult<SaveKommoUserMappingMutation>;
export type SaveKommoUserMappingMutationOptions = Apollo.BaseMutationOptions<SaveKommoUserMappingMutation, SaveKommoUserMappingMutationVariables>;
export const RetryLeadNotesDocument = gql`
    mutation RetryLeadNotes {
  retryKommoNotes {
    success
    customErrors {
      field
      code
      message
    }
    count
  }
}
    `;
export type RetryLeadNotesMutationFn = Apollo.MutationFunction<RetryLeadNotesMutation, RetryLeadNotesMutationVariables>;

/**
 * __useRetryLeadNotesMutation__
 *
 * To run a mutation, you first call `useRetryLeadNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryLeadNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryLeadNotesMutation, { data, loading, error }] = useRetryLeadNotesMutation({
 *   variables: {
 *   },
 * });
 */
export function useRetryLeadNotesMutation(baseOptions?: Apollo.MutationHookOptions<RetryLeadNotesMutation, RetryLeadNotesMutationVariables>) {
        return Apollo.useMutation<RetryLeadNotesMutation, RetryLeadNotesMutationVariables>(RetryLeadNotesDocument, baseOptions);
      }
export type RetryLeadNotesMutationHookResult = ReturnType<typeof useRetryLeadNotesMutation>;
export type RetryLeadNotesMutationResult = Apollo.MutationResult<RetryLeadNotesMutation>;
export type RetryLeadNotesMutationOptions = Apollo.BaseMutationOptions<RetryLeadNotesMutation, RetryLeadNotesMutationVariables>;
export const WriteCandidateSmsDocument = gql`
    mutation WriteCandidateSms($candidateId: ID!, $text: String!, $link: LeadSmsLinkInput, $templateId: ID, $requestKey: String) {
  sendFundingCandidateSms(
    candidateId: $candidateId
    text: $text
    link: $link
    templateId: $templateId
    requestKey: $requestKey
  ) {
    success
    customErrors {
      field
      code
      message
    }
    message {
      ...SmsMessageFields
    }
    state {
      ...LeadSmsStateFields
    }
  }
}
    ${SmsMessageFieldsFragmentDoc}
${LeadSmsStateFieldsFragmentDoc}`;
export type WriteCandidateSmsMutationFn = Apollo.MutationFunction<WriteCandidateSmsMutation, WriteCandidateSmsMutationVariables>;

/**
 * __useWriteCandidateSmsMutation__
 *
 * To run a mutation, you first call `useWriteCandidateSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteCandidateSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeCandidateSmsMutation, { data, loading, error }] = useWriteCandidateSmsMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      text: // value for 'text'
 *      link: // value for 'link'
 *      templateId: // value for 'templateId'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useWriteCandidateSmsMutation(baseOptions?: Apollo.MutationHookOptions<WriteCandidateSmsMutation, WriteCandidateSmsMutationVariables>) {
        return Apollo.useMutation<WriteCandidateSmsMutation, WriteCandidateSmsMutationVariables>(WriteCandidateSmsDocument, baseOptions);
      }
export type WriteCandidateSmsMutationHookResult = ReturnType<typeof useWriteCandidateSmsMutation>;
export type WriteCandidateSmsMutationResult = Apollo.MutationResult<WriteCandidateSmsMutation>;
export type WriteCandidateSmsMutationOptions = Apollo.BaseMutationOptions<WriteCandidateSmsMutation, WriteCandidateSmsMutationVariables>;
export const StartLadderForLeadDocument = gql`
    mutation StartLadderForLead($leadId: ID!, $kind: String!, $days: Int, $requestKey: String) {
  startLeadLadder(
    leadId: $leadId
    kind: $kind
    days: $days
    requestKey: $requestKey
  ) {
    success
    customErrors {
      field
      code
      message
    }
    warning
    ladder {
      ...LeadLadderRunFields
    }
  }
}
    ${LeadLadderRunFieldsFragmentDoc}`;
export type StartLadderForLeadMutationFn = Apollo.MutationFunction<StartLadderForLeadMutation, StartLadderForLeadMutationVariables>;

/**
 * __useStartLadderForLeadMutation__
 *
 * To run a mutation, you first call `useStartLadderForLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartLadderForLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startLadderForLeadMutation, { data, loading, error }] = useStartLadderForLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      kind: // value for 'kind'
 *      days: // value for 'days'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useStartLadderForLeadMutation(baseOptions?: Apollo.MutationHookOptions<StartLadderForLeadMutation, StartLadderForLeadMutationVariables>) {
        return Apollo.useMutation<StartLadderForLeadMutation, StartLadderForLeadMutationVariables>(StartLadderForLeadDocument, baseOptions);
      }
export type StartLadderForLeadMutationHookResult = ReturnType<typeof useStartLadderForLeadMutation>;
export type StartLadderForLeadMutationResult = Apollo.MutationResult<StartLadderForLeadMutation>;
export type StartLadderForLeadMutationOptions = Apollo.BaseMutationOptions<StartLadderForLeadMutation, StartLadderForLeadMutationVariables>;
export const StopLeadLadderRunDocument = gql`
    mutation StopLeadLadderRun($runId: ID!) {
  stopLeadLadder(runId: $runId) {
    success
    customErrors {
      field
      code
      message
    }
    ladder {
      ...LeadLadderRunFields
    }
  }
}
    ${LeadLadderRunFieldsFragmentDoc}`;
export type StopLeadLadderRunMutationFn = Apollo.MutationFunction<StopLeadLadderRunMutation, StopLeadLadderRunMutationVariables>;

/**
 * __useStopLeadLadderRunMutation__
 *
 * To run a mutation, you first call `useStopLeadLadderRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopLeadLadderRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopLeadLadderRunMutation, { data, loading, error }] = useStopLeadLadderRunMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useStopLeadLadderRunMutation(baseOptions?: Apollo.MutationHookOptions<StopLeadLadderRunMutation, StopLeadLadderRunMutationVariables>) {
        return Apollo.useMutation<StopLeadLadderRunMutation, StopLeadLadderRunMutationVariables>(StopLeadLadderRunDocument, baseOptions);
      }
export type StopLeadLadderRunMutationHookResult = ReturnType<typeof useStopLeadLadderRunMutation>;
export type StopLeadLadderRunMutationResult = Apollo.MutationResult<StopLeadLadderRunMutation>;
export type StopLeadLadderRunMutationOptions = Apollo.BaseMutationOptions<StopLeadLadderRunMutation, StopLeadLadderRunMutationVariables>;
export const ResumeLeadLadderRunDocument = gql`
    mutation ResumeLeadLadderRun($runId: ID!) {
  resumeLeadLadder(runId: $runId) {
    success
    customErrors {
      field
      code
      message
    }
    ladder {
      ...LeadLadderRunFields
    }
  }
}
    ${LeadLadderRunFieldsFragmentDoc}`;
export type ResumeLeadLadderRunMutationFn = Apollo.MutationFunction<ResumeLeadLadderRunMutation, ResumeLeadLadderRunMutationVariables>;

/**
 * __useResumeLeadLadderRunMutation__
 *
 * To run a mutation, you first call `useResumeLeadLadderRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeLeadLadderRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeLeadLadderRunMutation, { data, loading, error }] = useResumeLeadLadderRunMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useResumeLeadLadderRunMutation(baseOptions?: Apollo.MutationHookOptions<ResumeLeadLadderRunMutation, ResumeLeadLadderRunMutationVariables>) {
        return Apollo.useMutation<ResumeLeadLadderRunMutation, ResumeLeadLadderRunMutationVariables>(ResumeLeadLadderRunDocument, baseOptions);
      }
export type ResumeLeadLadderRunMutationHookResult = ReturnType<typeof useResumeLeadLadderRunMutation>;
export type ResumeLeadLadderRunMutationResult = Apollo.MutationResult<ResumeLeadLadderRunMutation>;
export type ResumeLeadLadderRunMutationOptions = Apollo.BaseMutationOptions<ResumeLeadLadderRunMutation, ResumeLeadLadderRunMutationVariables>;
export const WriteLeadEmailDocument = gql`
    mutation WriteLeadEmail($leadId: ID!, $mailboxEmail: String!, $subject: String!, $text: String, $html: String, $attachmentIds: [ID], $templateId: ID, $requestKey: String, $aiDraftId: ID) {
  sendLeadEmail(
    leadId: $leadId
    mailboxEmail: $mailboxEmail
    subject: $subject
    text: $text
    html: $html
    attachmentIds: $attachmentIds
    templateId: $templateId
    requestKey: $requestKey
    aiDraftId: $aiDraftId
  ) {
    success
    customErrors {
      field
      code
      message
    }
    conversationId
  }
}
    `;
export type WriteLeadEmailMutationFn = Apollo.MutationFunction<WriteLeadEmailMutation, WriteLeadEmailMutationVariables>;

/**
 * __useWriteLeadEmailMutation__
 *
 * To run a mutation, you first call `useWriteLeadEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteLeadEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeLeadEmailMutation, { data, loading, error }] = useWriteLeadEmailMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      mailboxEmail: // value for 'mailboxEmail'
 *      subject: // value for 'subject'
 *      text: // value for 'text'
 *      html: // value for 'html'
 *      attachmentIds: // value for 'attachmentIds'
 *      templateId: // value for 'templateId'
 *      requestKey: // value for 'requestKey'
 *      aiDraftId: // value for 'aiDraftId'
 *   },
 * });
 */
export function useWriteLeadEmailMutation(baseOptions?: Apollo.MutationHookOptions<WriteLeadEmailMutation, WriteLeadEmailMutationVariables>) {
        return Apollo.useMutation<WriteLeadEmailMutation, WriteLeadEmailMutationVariables>(WriteLeadEmailDocument, baseOptions);
      }
export type WriteLeadEmailMutationHookResult = ReturnType<typeof useWriteLeadEmailMutation>;
export type WriteLeadEmailMutationResult = Apollo.MutationResult<WriteLeadEmailMutation>;
export type WriteLeadEmailMutationOptions = Apollo.BaseMutationOptions<WriteLeadEmailMutation, WriteLeadEmailMutationVariables>;
export const InviteLeadToFormDocument = gql`
    mutation InviteLeadToForm($leadId: ID!, $mailboxEmail: String!, $subject: String!, $text: String, $html: String, $attachmentIds: [ID], $templateId: ID, $startLadder: Boolean, $days: Int, $requestKey: String) {
  inviteLeadToFundingForm(
    leadId: $leadId
    mailboxEmail: $mailboxEmail
    subject: $subject
    text: $text
    html: $html
    attachmentIds: $attachmentIds
    templateId: $templateId
    startLadder: $startLadder
    days: $days
    requestKey: $requestKey
  ) {
    success
    customErrors {
      field
      code
      message
    }
    conversationId
    ladderWarning
    ladder {
      ...LeadLadderRunFields
    }
  }
}
    ${LeadLadderRunFieldsFragmentDoc}`;
export type InviteLeadToFormMutationFn = Apollo.MutationFunction<InviteLeadToFormMutation, InviteLeadToFormMutationVariables>;

/**
 * __useInviteLeadToFormMutation__
 *
 * To run a mutation, you first call `useInviteLeadToFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteLeadToFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteLeadToFormMutation, { data, loading, error }] = useInviteLeadToFormMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      mailboxEmail: // value for 'mailboxEmail'
 *      subject: // value for 'subject'
 *      text: // value for 'text'
 *      html: // value for 'html'
 *      attachmentIds: // value for 'attachmentIds'
 *      templateId: // value for 'templateId'
 *      startLadder: // value for 'startLadder'
 *      days: // value for 'days'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useInviteLeadToFormMutation(baseOptions?: Apollo.MutationHookOptions<InviteLeadToFormMutation, InviteLeadToFormMutationVariables>) {
        return Apollo.useMutation<InviteLeadToFormMutation, InviteLeadToFormMutationVariables>(InviteLeadToFormDocument, baseOptions);
      }
export type InviteLeadToFormMutationHookResult = ReturnType<typeof useInviteLeadToFormMutation>;
export type InviteLeadToFormMutationResult = Apollo.MutationResult<InviteLeadToFormMutation>;
export type InviteLeadToFormMutationOptions = Apollo.BaseMutationOptions<InviteLeadToFormMutation, InviteLeadToFormMutationVariables>;
export const ErpLinkKommoLeadDocument = gql`
    mutation ErpLinkKommoLead($leadId: ID!, $what: String!, $targetId: ID) {
  linkKommoLead(leadId: $leadId, what: $what, targetId: $targetId) {
    success
    customErrors {
      field
      code
      message
    }
    lead {
      ...KommoLeadCardFields
    }
  }
}
    ${KommoLeadCardFieldsFragmentDoc}`;
export type ErpLinkKommoLeadMutationFn = Apollo.MutationFunction<ErpLinkKommoLeadMutation, ErpLinkKommoLeadMutationVariables>;

/**
 * __useErpLinkKommoLeadMutation__
 *
 * To run a mutation, you first call `useErpLinkKommoLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpLinkKommoLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpLinkKommoLeadMutation, { data, loading, error }] = useErpLinkKommoLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      what: // value for 'what'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useErpLinkKommoLeadMutation(baseOptions?: Apollo.MutationHookOptions<ErpLinkKommoLeadMutation, ErpLinkKommoLeadMutationVariables>) {
        return Apollo.useMutation<ErpLinkKommoLeadMutation, ErpLinkKommoLeadMutationVariables>(ErpLinkKommoLeadDocument, baseOptions);
      }
export type ErpLinkKommoLeadMutationHookResult = ReturnType<typeof useErpLinkKommoLeadMutation>;
export type ErpLinkKommoLeadMutationResult = Apollo.MutationResult<ErpLinkKommoLeadMutation>;
export type ErpLinkKommoLeadMutationOptions = Apollo.BaseMutationOptions<ErpLinkKommoLeadMutation, ErpLinkKommoLeadMutationVariables>;
export const ErpResetKommoLeadLinkDocument = gql`
    mutation ErpResetKommoLeadLink($leadId: ID!, $what: String!) {
  resetKommoLeadLink(leadId: $leadId, what: $what) {
    success
    customErrors {
      field
      code
      message
    }
    lead {
      ...KommoLeadCardFields
    }
  }
}
    ${KommoLeadCardFieldsFragmentDoc}`;
export type ErpResetKommoLeadLinkMutationFn = Apollo.MutationFunction<ErpResetKommoLeadLinkMutation, ErpResetKommoLeadLinkMutationVariables>;

/**
 * __useErpResetKommoLeadLinkMutation__
 *
 * To run a mutation, you first call `useErpResetKommoLeadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpResetKommoLeadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpResetKommoLeadLinkMutation, { data, loading, error }] = useErpResetKommoLeadLinkMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      what: // value for 'what'
 *   },
 * });
 */
export function useErpResetKommoLeadLinkMutation(baseOptions?: Apollo.MutationHookOptions<ErpResetKommoLeadLinkMutation, ErpResetKommoLeadLinkMutationVariables>) {
        return Apollo.useMutation<ErpResetKommoLeadLinkMutation, ErpResetKommoLeadLinkMutationVariables>(ErpResetKommoLeadLinkDocument, baseOptions);
      }
export type ErpResetKommoLeadLinkMutationHookResult = ReturnType<typeof useErpResetKommoLeadLinkMutation>;
export type ErpResetKommoLeadLinkMutationResult = Apollo.MutationResult<ErpResetKommoLeadLinkMutation>;
export type ErpResetKommoLeadLinkMutationOptions = Apollo.BaseMutationOptions<ErpResetKommoLeadLinkMutation, ErpResetKommoLeadLinkMutationVariables>;
export const MoveKommoLeadStageDocument = gql`
    mutation MoveKommoLeadStage($id: ID!, $statusId: ID!, $lossReasonId: ID) {
  moveKommoLead(id: $id, statusId: $statusId, lossReasonId: $lossReasonId) {
    success
    changed
    customErrors {
      field
      message
      code
    }
    lead {
      ...KommoLeadMovedFields
    }
  }
}
    ${KommoLeadMovedFieldsFragmentDoc}`;
export type MoveKommoLeadStageMutationFn = Apollo.MutationFunction<MoveKommoLeadStageMutation, MoveKommoLeadStageMutationVariables>;

/**
 * __useMoveKommoLeadStageMutation__
 *
 * To run a mutation, you first call `useMoveKommoLeadStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveKommoLeadStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveKommoLeadStageMutation, { data, loading, error }] = useMoveKommoLeadStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      statusId: // value for 'statusId'
 *      lossReasonId: // value for 'lossReasonId'
 *   },
 * });
 */
export function useMoveKommoLeadStageMutation(baseOptions?: Apollo.MutationHookOptions<MoveKommoLeadStageMutation, MoveKommoLeadStageMutationVariables>) {
        return Apollo.useMutation<MoveKommoLeadStageMutation, MoveKommoLeadStageMutationVariables>(MoveKommoLeadStageDocument, baseOptions);
      }
export type MoveKommoLeadStageMutationHookResult = ReturnType<typeof useMoveKommoLeadStageMutation>;
export type MoveKommoLeadStageMutationResult = Apollo.MutationResult<MoveKommoLeadStageMutation>;
export type MoveKommoLeadStageMutationOptions = Apollo.BaseMutationOptions<MoveKommoLeadStageMutation, MoveKommoLeadStageMutationVariables>;
export const AssignKommoLeadResponsibleDocument = gql`
    mutation AssignKommoLeadResponsible($id: ID!, $userId: ID!) {
  setKommoLeadResponsible(id: $id, userId: $userId) {
    success
    changed
    customErrors {
      field
      message
      code
    }
    lead {
      ...KommoLeadMovedFields
    }
  }
}
    ${KommoLeadMovedFieldsFragmentDoc}`;
export type AssignKommoLeadResponsibleMutationFn = Apollo.MutationFunction<AssignKommoLeadResponsibleMutation, AssignKommoLeadResponsibleMutationVariables>;

/**
 * __useAssignKommoLeadResponsibleMutation__
 *
 * To run a mutation, you first call `useAssignKommoLeadResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignKommoLeadResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignKommoLeadResponsibleMutation, { data, loading, error }] = useAssignKommoLeadResponsibleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignKommoLeadResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<AssignKommoLeadResponsibleMutation, AssignKommoLeadResponsibleMutationVariables>) {
        return Apollo.useMutation<AssignKommoLeadResponsibleMutation, AssignKommoLeadResponsibleMutationVariables>(AssignKommoLeadResponsibleDocument, baseOptions);
      }
export type AssignKommoLeadResponsibleMutationHookResult = ReturnType<typeof useAssignKommoLeadResponsibleMutation>;
export type AssignKommoLeadResponsibleMutationResult = Apollo.MutationResult<AssignKommoLeadResponsibleMutation>;
export type AssignKommoLeadResponsibleMutationOptions = Apollo.BaseMutationOptions<AssignKommoLeadResponsibleMutation, AssignKommoLeadResponsibleMutationVariables>;
export const DraftLeadAploraFollowupDocument = gql`
    mutation DraftLeadAploraFollowup($leadId: ID!, $callId: ID!, $regenerate: Boolean, $requestKey: String) {
  aploraFollowupDraft(
    leadId: $leadId
    callId: $callId
    regenerate: $regenerate
    requestKey: $requestKey
  ) {
    success
    customErrors {
      field
      message
      code
    }
    draft {
      emailSubject
      emailBody
      messengerText
      cached
    }
  }
}
    `;
export type DraftLeadAploraFollowupMutationFn = Apollo.MutationFunction<DraftLeadAploraFollowupMutation, DraftLeadAploraFollowupMutationVariables>;

/**
 * __useDraftLeadAploraFollowupMutation__
 *
 * To run a mutation, you first call `useDraftLeadAploraFollowupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftLeadAploraFollowupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftLeadAploraFollowupMutation, { data, loading, error }] = useDraftLeadAploraFollowupMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      callId: // value for 'callId'
 *      regenerate: // value for 'regenerate'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useDraftLeadAploraFollowupMutation(baseOptions?: Apollo.MutationHookOptions<DraftLeadAploraFollowupMutation, DraftLeadAploraFollowupMutationVariables>) {
        return Apollo.useMutation<DraftLeadAploraFollowupMutation, DraftLeadAploraFollowupMutationVariables>(DraftLeadAploraFollowupDocument, baseOptions);
      }
export type DraftLeadAploraFollowupMutationHookResult = ReturnType<typeof useDraftLeadAploraFollowupMutation>;
export type DraftLeadAploraFollowupMutationResult = Apollo.MutationResult<DraftLeadAploraFollowupMutation>;
export type DraftLeadAploraFollowupMutationOptions = Apollo.BaseMutationOptions<DraftLeadAploraFollowupMutation, DraftLeadAploraFollowupMutationVariables>;
export const DraftLeadEmailDocument = gql`
    mutation DraftLeadEmail($leadId: ID!, $kind: String!, $contractId: ID, $hint: String, $regenerate: Boolean, $requestKey: String) {
  draftLeadEmail(
    leadId: $leadId
    kind: $kind
    contractId: $contractId
    hint: $hint
    regenerate: $regenerate
    requestKey: $requestKey
  ) {
    success
    customErrors {
      field
      code
      message
    }
    draft {
      id
      kind
      subject
      html
      text
      cached
      contractId
      createdAt
    }
  }
}
    `;
export type DraftLeadEmailMutationFn = Apollo.MutationFunction<DraftLeadEmailMutation, DraftLeadEmailMutationVariables>;

/**
 * __useDraftLeadEmailMutation__
 *
 * To run a mutation, you first call `useDraftLeadEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftLeadEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftLeadEmailMutation, { data, loading, error }] = useDraftLeadEmailMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      kind: // value for 'kind'
 *      contractId: // value for 'contractId'
 *      hint: // value for 'hint'
 *      regenerate: // value for 'regenerate'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useDraftLeadEmailMutation(baseOptions?: Apollo.MutationHookOptions<DraftLeadEmailMutation, DraftLeadEmailMutationVariables>) {
        return Apollo.useMutation<DraftLeadEmailMutation, DraftLeadEmailMutationVariables>(DraftLeadEmailDocument, baseOptions);
      }
export type DraftLeadEmailMutationHookResult = ReturnType<typeof useDraftLeadEmailMutation>;
export type DraftLeadEmailMutationResult = Apollo.MutationResult<DraftLeadEmailMutation>;
export type DraftLeadEmailMutationOptions = Apollo.BaseMutationOptions<DraftLeadEmailMutation, DraftLeadEmailMutationVariables>;
export const SaveLeadSavedViewDocument = gql`
    mutation SaveLeadSavedView($id: ID, $name: String!, $filters: GenericScalar!, $view: String!, $shared: Boolean, $scope: String) {
  saveLeadSavedView(
    id: $id
    name: $name
    filters: $filters
    view: $view
    shared: $shared
    scope: $scope
  ) {
    success
    customErrors {
      field
      code
      message
    }
    view {
      id
      name
      filters
      view
      shared
      isMine
      position
      scope
    }
  }
}
    `;
export type SaveLeadSavedViewMutationFn = Apollo.MutationFunction<SaveLeadSavedViewMutation, SaveLeadSavedViewMutationVariables>;

/**
 * __useSaveLeadSavedViewMutation__
 *
 * To run a mutation, you first call `useSaveLeadSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLeadSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLeadSavedViewMutation, { data, loading, error }] = useSaveLeadSavedViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      filters: // value for 'filters'
 *      view: // value for 'view'
 *      shared: // value for 'shared'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useSaveLeadSavedViewMutation(baseOptions?: Apollo.MutationHookOptions<SaveLeadSavedViewMutation, SaveLeadSavedViewMutationVariables>) {
        return Apollo.useMutation<SaveLeadSavedViewMutation, SaveLeadSavedViewMutationVariables>(SaveLeadSavedViewDocument, baseOptions);
      }
export type SaveLeadSavedViewMutationHookResult = ReturnType<typeof useSaveLeadSavedViewMutation>;
export type SaveLeadSavedViewMutationResult = Apollo.MutationResult<SaveLeadSavedViewMutation>;
export type SaveLeadSavedViewMutationOptions = Apollo.BaseMutationOptions<SaveLeadSavedViewMutation, SaveLeadSavedViewMutationVariables>;
export const DeleteLeadSavedViewDocument = gql`
    mutation DeleteLeadSavedView($id: ID!, $scope: String) {
  deleteLeadSavedView(id: $id, scope: $scope) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type DeleteLeadSavedViewMutationFn = Apollo.MutationFunction<DeleteLeadSavedViewMutation, DeleteLeadSavedViewMutationVariables>;

/**
 * __useDeleteLeadSavedViewMutation__
 *
 * To run a mutation, you first call `useDeleteLeadSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeadSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeadSavedViewMutation, { data, loading, error }] = useDeleteLeadSavedViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useDeleteLeadSavedViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeadSavedViewMutation, DeleteLeadSavedViewMutationVariables>) {
        return Apollo.useMutation<DeleteLeadSavedViewMutation, DeleteLeadSavedViewMutationVariables>(DeleteLeadSavedViewDocument, baseOptions);
      }
export type DeleteLeadSavedViewMutationHookResult = ReturnType<typeof useDeleteLeadSavedViewMutation>;
export type DeleteLeadSavedViewMutationResult = Apollo.MutationResult<DeleteLeadSavedViewMutation>;
export type DeleteLeadSavedViewMutationOptions = Apollo.BaseMutationOptions<DeleteLeadSavedViewMutation, DeleteLeadSavedViewMutationVariables>;
export const CheckPaymentsDebtDocument = gql`
    mutation CheckPaymentsDebt($agreements: [String]!) {
  checkStudentDebt(agreementsInput: $agreements) {
    customErrors {
      code
      field
      message
    }
    success
  }
}
    `;
export type CheckPaymentsDebtMutationFn = Apollo.MutationFunction<CheckPaymentsDebtMutation, CheckPaymentsDebtMutationVariables>;

/**
 * __useCheckPaymentsDebtMutation__
 *
 * To run a mutation, you first call `useCheckPaymentsDebtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckPaymentsDebtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkPaymentsDebtMutation, { data, loading, error }] = useCheckPaymentsDebtMutation({
 *   variables: {
 *      agreements: // value for 'agreements'
 *   },
 * });
 */
export function useCheckPaymentsDebtMutation(baseOptions?: Apollo.MutationHookOptions<CheckPaymentsDebtMutation, CheckPaymentsDebtMutationVariables>) {
        return Apollo.useMutation<CheckPaymentsDebtMutation, CheckPaymentsDebtMutationVariables>(CheckPaymentsDebtDocument, baseOptions);
      }
export type CheckPaymentsDebtMutationHookResult = ReturnType<typeof useCheckPaymentsDebtMutation>;
export type CheckPaymentsDebtMutationResult = Apollo.MutationResult<CheckPaymentsDebtMutation>;
export type CheckPaymentsDebtMutationOptions = Apollo.BaseMutationOptions<CheckPaymentsDebtMutation, CheckPaymentsDebtMutationVariables>;
export const UploadDiplomaFileDocument = gql`
    mutation UploadDiplomaFile($studentId: ID!, $groupId: ID!, $language: DiplomaLanguageEnum!, $file: Upload!, $replaceExisting: Boolean) {
  uploadStudentDiploma(
    studentId: $studentId
    groupId: $groupId
    language: $language
    file: $file
    replaceExisting: $replaceExisting
  ) {
    success
    customErrors {
      field
      code
      message
    }
    diploma {
      id
      pk
      language
      source
      originalName
      contentType
      sizeBytes
      version
      uploadedAt
      uploadedByName
    }
  }
}
    `;
export type UploadDiplomaFileMutationFn = Apollo.MutationFunction<UploadDiplomaFileMutation, UploadDiplomaFileMutationVariables>;

/**
 * __useUploadDiplomaFileMutation__
 *
 * To run a mutation, you first call `useUploadDiplomaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDiplomaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDiplomaFileMutation, { data, loading, error }] = useUploadDiplomaFileMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      groupId: // value for 'groupId'
 *      language: // value for 'language'
 *      file: // value for 'file'
 *      replaceExisting: // value for 'replaceExisting'
 *   },
 * });
 */
export function useUploadDiplomaFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadDiplomaFileMutation, UploadDiplomaFileMutationVariables>) {
        return Apollo.useMutation<UploadDiplomaFileMutation, UploadDiplomaFileMutationVariables>(UploadDiplomaFileDocument, baseOptions);
      }
export type UploadDiplomaFileMutationHookResult = ReturnType<typeof useUploadDiplomaFileMutation>;
export type UploadDiplomaFileMutationResult = Apollo.MutationResult<UploadDiplomaFileMutation>;
export type UploadDiplomaFileMutationOptions = Apollo.BaseMutationOptions<UploadDiplomaFileMutation, UploadDiplomaFileMutationVariables>;
export const RemoveDiplomaFileDocument = gql`
    mutation RemoveDiplomaFile($diplomaId: ID!) {
  deleteStudentDiploma(diplomaId: $diplomaId) {
    success
    ok
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type RemoveDiplomaFileMutationFn = Apollo.MutationFunction<RemoveDiplomaFileMutation, RemoveDiplomaFileMutationVariables>;

/**
 * __useRemoveDiplomaFileMutation__
 *
 * To run a mutation, you first call `useRemoveDiplomaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDiplomaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDiplomaFileMutation, { data, loading, error }] = useRemoveDiplomaFileMutation({
 *   variables: {
 *      diplomaId: // value for 'diplomaId'
 *   },
 * });
 */
export function useRemoveDiplomaFileMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDiplomaFileMutation, RemoveDiplomaFileMutationVariables>) {
        return Apollo.useMutation<RemoveDiplomaFileMutation, RemoveDiplomaFileMutationVariables>(RemoveDiplomaFileDocument, baseOptions);
      }
export type RemoveDiplomaFileMutationHookResult = ReturnType<typeof useRemoveDiplomaFileMutation>;
export type RemoveDiplomaFileMutationResult = Apollo.MutationResult<RemoveDiplomaFileMutation>;
export type RemoveDiplomaFileMutationOptions = Apollo.BaseMutationOptions<RemoveDiplomaFileMutation, RemoveDiplomaFileMutationVariables>;
export const PreviewDiplomaMatchDocument = gql`
    mutation PreviewDiplomaMatch($groupId: ID!, $fileNames: [String!]!) {
  matchDiplomaFiles(groupId: $groupId, fileNames: $fileNames) {
    success
    customErrors {
      field
      code
      message
    }
    preview {
      summary {
        total
        matched
        ambiguous
        noMatch
        duplicates
        willReplace
      }
      rows {
        fileName
        status
        language
        matchedBy
        confidence
        student {
          id
          firstName
          lastName
          fullName
          email
        }
        candidates {
          fullName
          student {
            id
            firstName
            lastName
            fullName
            email
          }
        }
        wouldReplace {
          id
          language
          originalName
          version
          uploadedAt
        }
      }
      unmatchedStudents {
        fullName
        missingLanguages
        student {
          id
          firstName
          lastName
          fullName
          email
        }
      }
    }
  }
}
    `;
export type PreviewDiplomaMatchMutationFn = Apollo.MutationFunction<PreviewDiplomaMatchMutation, PreviewDiplomaMatchMutationVariables>;

/**
 * __usePreviewDiplomaMatchMutation__
 *
 * To run a mutation, you first call `usePreviewDiplomaMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewDiplomaMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewDiplomaMatchMutation, { data, loading, error }] = usePreviewDiplomaMatchMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      fileNames: // value for 'fileNames'
 *   },
 * });
 */
export function usePreviewDiplomaMatchMutation(baseOptions?: Apollo.MutationHookOptions<PreviewDiplomaMatchMutation, PreviewDiplomaMatchMutationVariables>) {
        return Apollo.useMutation<PreviewDiplomaMatchMutation, PreviewDiplomaMatchMutationVariables>(PreviewDiplomaMatchDocument, baseOptions);
      }
export type PreviewDiplomaMatchMutationHookResult = ReturnType<typeof usePreviewDiplomaMatchMutation>;
export type PreviewDiplomaMatchMutationResult = Apollo.MutationResult<PreviewDiplomaMatchMutation>;
export type PreviewDiplomaMatchMutationOptions = Apollo.BaseMutationOptions<PreviewDiplomaMatchMutation, PreviewDiplomaMatchMutationVariables>;
export const CreateDocTemplateDocument = gql`
    mutation CreateDocTemplate($name: String!, $kind: String, $scope: String, $basedOnId: ID, $legalEntityId: ID) {
  createDocumentTemplate(
    name: $name
    kind: $kind
    scope: $scope
    basedOnId: $basedOnId
    legalEntityId: $legalEntityId
  ) {
    success
    customErrors {
      field
      code
      message
    }
    problems {
      code
      message
      token
    }
    template {
      id
      code
      name
      kind
      scope
      isActive
      legalEntityId
      legalEntityName
      version
      currentVersionId
      createdAt
      updatedAt
      updatedByName
      versions {
        id
        version
        origin
        comment
        createdAt
        createdByName
        isCurrent
      }
    }
  }
}
    `;
export type CreateDocTemplateMutationFn = Apollo.MutationFunction<CreateDocTemplateMutation, CreateDocTemplateMutationVariables>;

/**
 * __useCreateDocTemplateMutation__
 *
 * To run a mutation, you first call `useCreateDocTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocTemplateMutation, { data, loading, error }] = useCreateDocTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      kind: // value for 'kind'
 *      scope: // value for 'scope'
 *      basedOnId: // value for 'basedOnId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useCreateDocTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocTemplateMutation, CreateDocTemplateMutationVariables>) {
        return Apollo.useMutation<CreateDocTemplateMutation, CreateDocTemplateMutationVariables>(CreateDocTemplateDocument, baseOptions);
      }
export type CreateDocTemplateMutationHookResult = ReturnType<typeof useCreateDocTemplateMutation>;
export type CreateDocTemplateMutationResult = Apollo.MutationResult<CreateDocTemplateMutation>;
export type CreateDocTemplateMutationOptions = Apollo.BaseMutationOptions<CreateDocTemplateMutation, CreateDocTemplateMutationVariables>;
export const StoreDocTemplateDocument = gql`
    mutation StoreDocTemplate($id: ID!, $html: String, $name: String, $comment: String) {
  saveDocumentTemplate(id: $id, html: $html, name: $name, comment: $comment) {
    success
    customErrors {
      field
      code
      message
    }
    problems {
      code
      message
      token
    }
    template {
      id
      code
      name
      kind
      scope
      isActive
      legalEntityId
      legalEntityName
      version
      currentVersionId
      createdAt
      updatedAt
      updatedByName
      versions {
        id
        version
        origin
        comment
        createdAt
        createdByName
        isCurrent
      }
    }
  }
}
    `;
export type StoreDocTemplateMutationFn = Apollo.MutationFunction<StoreDocTemplateMutation, StoreDocTemplateMutationVariables>;

/**
 * __useStoreDocTemplateMutation__
 *
 * To run a mutation, you first call `useStoreDocTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreDocTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeDocTemplateMutation, { data, loading, error }] = useStoreDocTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      html: // value for 'html'
 *      name: // value for 'name'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useStoreDocTemplateMutation(baseOptions?: Apollo.MutationHookOptions<StoreDocTemplateMutation, StoreDocTemplateMutationVariables>) {
        return Apollo.useMutation<StoreDocTemplateMutation, StoreDocTemplateMutationVariables>(StoreDocTemplateDocument, baseOptions);
      }
export type StoreDocTemplateMutationHookResult = ReturnType<typeof useStoreDocTemplateMutation>;
export type StoreDocTemplateMutationResult = Apollo.MutationResult<StoreDocTemplateMutation>;
export type StoreDocTemplateMutationOptions = Apollo.BaseMutationOptions<StoreDocTemplateMutation, StoreDocTemplateMutationVariables>;
export const ToggleDocTemplateDocument = gql`
    mutation ToggleDocTemplate($id: ID!, $active: Boolean!) {
  setDocumentTemplateActive(id: $id, active: $active) {
    success
    customErrors {
      field
      code
      message
    }
    template {
      id
      code
      name
      kind
      scope
      isActive
      legalEntityId
      legalEntityName
      version
      currentVersionId
      createdAt
      updatedAt
      updatedByName
      versions {
        id
        version
        origin
        comment
        createdAt
        createdByName
        isCurrent
      }
    }
  }
}
    `;
export type ToggleDocTemplateMutationFn = Apollo.MutationFunction<ToggleDocTemplateMutation, ToggleDocTemplateMutationVariables>;

/**
 * __useToggleDocTemplateMutation__
 *
 * To run a mutation, you first call `useToggleDocTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDocTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDocTemplateMutation, { data, loading, error }] = useToggleDocTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useToggleDocTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleDocTemplateMutation, ToggleDocTemplateMutationVariables>) {
        return Apollo.useMutation<ToggleDocTemplateMutation, ToggleDocTemplateMutationVariables>(ToggleDocTemplateDocument, baseOptions);
      }
export type ToggleDocTemplateMutationHookResult = ReturnType<typeof useToggleDocTemplateMutation>;
export type ToggleDocTemplateMutationResult = Apollo.MutationResult<ToggleDocTemplateMutation>;
export type ToggleDocTemplateMutationOptions = Apollo.BaseMutationOptions<ToggleDocTemplateMutation, ToggleDocTemplateMutationVariables>;
export const SwitchDocTemplateVersionDocument = gql`
    mutation SwitchDocTemplateVersion($versionId: ID!) {
  activateDocumentTemplateVersion(versionId: $versionId) {
    success
    customErrors {
      field
      code
      message
    }
    template {
      id
      code
      name
      kind
      scope
      isActive
      legalEntityId
      legalEntityName
      version
      currentVersionId
      createdAt
      updatedAt
      updatedByName
      versions {
        id
        version
        origin
        comment
        createdAt
        createdByName
        isCurrent
      }
    }
  }
}
    `;
export type SwitchDocTemplateVersionMutationFn = Apollo.MutationFunction<SwitchDocTemplateVersionMutation, SwitchDocTemplateVersionMutationVariables>;

/**
 * __useSwitchDocTemplateVersionMutation__
 *
 * To run a mutation, you first call `useSwitchDocTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchDocTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchDocTemplateVersionMutation, { data, loading, error }] = useSwitchDocTemplateVersionMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useSwitchDocTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<SwitchDocTemplateVersionMutation, SwitchDocTemplateVersionMutationVariables>) {
        return Apollo.useMutation<SwitchDocTemplateVersionMutation, SwitchDocTemplateVersionMutationVariables>(SwitchDocTemplateVersionDocument, baseOptions);
      }
export type SwitchDocTemplateVersionMutationHookResult = ReturnType<typeof useSwitchDocTemplateVersionMutation>;
export type SwitchDocTemplateVersionMutationResult = Apollo.MutationResult<SwitchDocTemplateVersionMutation>;
export type SwitchDocTemplateVersionMutationOptions = Apollo.BaseMutationOptions<SwitchDocTemplateVersionMutation, SwitchDocTemplateVersionMutationVariables>;
export const IssueDocPdfDocument = gql`
    mutation IssueDocPdf($templateId: ID!, $studentId: ID, $agreementId: ID, $groupId: ID, $issuePlace: String) {
  issueDocument(
    templateId: $templateId
    studentId: $studentId
    agreementId: $agreementId
    groupId: $groupId
    issuePlace: $issuePlace
  ) {
    success
    customErrors {
      field
      code
      message
    }
    issuedDocument {
      id
      number
      kind
      scope
      templateId
      templateName
      templateVersion
      studentId
      studentName
      agreementId
      agreementTitle
      groupId
      groupName
      issueDate
      issuePlace
      issuedAt
      issuedByName
      missingFields
      hiddenFields
      hasFile
      sends {
        id
        sentAt
        sentTo
        sentByName
        mailboxEmail
        conversationId
      }
    }
    file {
      fileName
      contentType
      contentBase64
    }
    missingFields {
      code
      label
      labelPl
    }
    hiddenFields {
      code
      label
      labelPl
    }
  }
}
    `;
export type IssueDocPdfMutationFn = Apollo.MutationFunction<IssueDocPdfMutation, IssueDocPdfMutationVariables>;

/**
 * __useIssueDocPdfMutation__
 *
 * To run a mutation, you first call `useIssueDocPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueDocPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueDocPdfMutation, { data, loading, error }] = useIssueDocPdfMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      studentId: // value for 'studentId'
 *      agreementId: // value for 'agreementId'
 *      groupId: // value for 'groupId'
 *      issuePlace: // value for 'issuePlace'
 *   },
 * });
 */
export function useIssueDocPdfMutation(baseOptions?: Apollo.MutationHookOptions<IssueDocPdfMutation, IssueDocPdfMutationVariables>) {
        return Apollo.useMutation<IssueDocPdfMutation, IssueDocPdfMutationVariables>(IssueDocPdfDocument, baseOptions);
      }
export type IssueDocPdfMutationHookResult = ReturnType<typeof useIssueDocPdfMutation>;
export type IssueDocPdfMutationResult = Apollo.MutationResult<IssueDocPdfMutation>;
export type IssueDocPdfMutationOptions = Apollo.BaseMutationOptions<IssueDocPdfMutation, IssueDocPdfMutationVariables>;
export const SendIssuedDocPdfDocument = gql`
    mutation SendIssuedDocPdf($issuedDocumentId: ID!, $to: String, $subject: String, $html: String, $mailboxEmail: String) {
  sendIssuedDocument(
    issuedDocumentId: $issuedDocumentId
    to: $to
    subject: $subject
    html: $html
    mailboxEmail: $mailboxEmail
  ) {
    success
    customErrors {
      field
      code
      message
    }
    conversationId
    send {
      id
      sentAt
      sentTo
      sentByName
      mailboxEmail
      conversationId
    }
    issuedDocument {
      id
      hasFile
      sends {
        id
        sentAt
        sentTo
        sentByName
        mailboxEmail
        conversationId
      }
    }
  }
}
    `;
export type SendIssuedDocPdfMutationFn = Apollo.MutationFunction<SendIssuedDocPdfMutation, SendIssuedDocPdfMutationVariables>;

/**
 * __useSendIssuedDocPdfMutation__
 *
 * To run a mutation, you first call `useSendIssuedDocPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendIssuedDocPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendIssuedDocPdfMutation, { data, loading, error }] = useSendIssuedDocPdfMutation({
 *   variables: {
 *      issuedDocumentId: // value for 'issuedDocumentId'
 *      to: // value for 'to'
 *      subject: // value for 'subject'
 *      html: // value for 'html'
 *      mailboxEmail: // value for 'mailboxEmail'
 *   },
 * });
 */
export function useSendIssuedDocPdfMutation(baseOptions?: Apollo.MutationHookOptions<SendIssuedDocPdfMutation, SendIssuedDocPdfMutationVariables>) {
        return Apollo.useMutation<SendIssuedDocPdfMutation, SendIssuedDocPdfMutationVariables>(SendIssuedDocPdfDocument, baseOptions);
      }
export type SendIssuedDocPdfMutationHookResult = ReturnType<typeof useSendIssuedDocPdfMutation>;
export type SendIssuedDocPdfMutationResult = Apollo.MutationResult<SendIssuedDocPdfMutation>;
export type SendIssuedDocPdfMutationOptions = Apollo.BaseMutationOptions<SendIssuedDocPdfMutation, SendIssuedDocPdfMutationVariables>;
export const ErpChangeCandidateStatusDocument = gql`
    mutation ErpChangeCandidateStatus($candidateId: ID!, $status: String!, $note: String) {
  changeCandidateStatus(candidateId: $candidateId, status: $status, note: $note) {
    success
    customErrors {
      field
      code
      message
    }
    candidate {
      id
      status
      statusChangedAt
    }
  }
}
    `;
export type ErpChangeCandidateStatusMutationFn = Apollo.MutationFunction<ErpChangeCandidateStatusMutation, ErpChangeCandidateStatusMutationVariables>;

/**
 * __useErpChangeCandidateStatusMutation__
 *
 * To run a mutation, you first call `useErpChangeCandidateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpChangeCandidateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpChangeCandidateStatusMutation, { data, loading, error }] = useErpChangeCandidateStatusMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      status: // value for 'status'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useErpChangeCandidateStatusMutation(baseOptions?: Apollo.MutationHookOptions<ErpChangeCandidateStatusMutation, ErpChangeCandidateStatusMutationVariables>) {
        return Apollo.useMutation<ErpChangeCandidateStatusMutation, ErpChangeCandidateStatusMutationVariables>(ErpChangeCandidateStatusDocument, baseOptions);
      }
export type ErpChangeCandidateStatusMutationHookResult = ReturnType<typeof useErpChangeCandidateStatusMutation>;
export type ErpChangeCandidateStatusMutationResult = Apollo.MutationResult<ErpChangeCandidateStatusMutation>;
export type ErpChangeCandidateStatusMutationOptions = Apollo.BaseMutationOptions<ErpChangeCandidateStatusMutation, ErpChangeCandidateStatusMutationVariables>;
export const ErpAddCandidateOperatorsDocument = gql`
    mutation ErpAddCandidateOperators($candidateId: ID!, $operatorIds: [ID!]!, $note: String) {
  addCandidateOperators(
    candidateId: $candidateId
    operatorIds: $operatorIds
    note: $note
  ) {
    success
    addedCount
    customErrors {
      field
      code
      message
    }
    candidate {
      id
      activeOperatorsCount
      disabledOperatorsCount
      primaryOperator {
        id
        name
        programType
        clientType
      }
      operators {
        id
        name
        programType
        clientType
      }
      operatorLinks {
        id
        isActive
        isPrimary
        source
        addedAt
        addedByName
        deactivatedAt
        deactivatedByName
        deactivationReason
        deactivationReasonLabel
        note
        operator {
          id
          name
          programName
          programType
          clientType
          ownContributionPercent
          decisionDays
          coverageScope
          rollingIntake
          instructionUrl
          instructionReady
          voivodeship {
            id
            name
          }
          powiats {
            id
            name
          }
          currentIntake {
            id
            startsOn
            endsOn
            status
          }
        }
      }
    }
  }
}
    `;
export type ErpAddCandidateOperatorsMutationFn = Apollo.MutationFunction<ErpAddCandidateOperatorsMutation, ErpAddCandidateOperatorsMutationVariables>;

/**
 * __useErpAddCandidateOperatorsMutation__
 *
 * To run a mutation, you first call `useErpAddCandidateOperatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpAddCandidateOperatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpAddCandidateOperatorsMutation, { data, loading, error }] = useErpAddCandidateOperatorsMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      operatorIds: // value for 'operatorIds'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useErpAddCandidateOperatorsMutation(baseOptions?: Apollo.MutationHookOptions<ErpAddCandidateOperatorsMutation, ErpAddCandidateOperatorsMutationVariables>) {
        return Apollo.useMutation<ErpAddCandidateOperatorsMutation, ErpAddCandidateOperatorsMutationVariables>(ErpAddCandidateOperatorsDocument, baseOptions);
      }
export type ErpAddCandidateOperatorsMutationHookResult = ReturnType<typeof useErpAddCandidateOperatorsMutation>;
export type ErpAddCandidateOperatorsMutationResult = Apollo.MutationResult<ErpAddCandidateOperatorsMutation>;
export type ErpAddCandidateOperatorsMutationOptions = Apollo.BaseMutationOptions<ErpAddCandidateOperatorsMutation, ErpAddCandidateOperatorsMutationVariables>;
export const ErpDeactivateCandidateOperatorDocument = gql`
    mutation ErpDeactivateCandidateOperator($candidateId: ID!, $operatorId: ID!, $reason: String!, $note: String) {
  deactivateCandidateOperator(
    candidateId: $candidateId
    operatorId: $operatorId
    reason: $reason
    note: $note
  ) {
    success
    customErrors {
      field
      code
      message
    }
    candidate {
      id
      activeOperatorsCount
      disabledOperatorsCount
      primaryOperator {
        id
        name
        programType
        clientType
      }
      operators {
        id
        name
        programType
        clientType
      }
      operatorLinks {
        id
        isActive
        isPrimary
        source
        addedAt
        addedByName
        deactivatedAt
        deactivatedByName
        deactivationReason
        deactivationReasonLabel
        note
        operator {
          id
          name
          programName
          programType
          clientType
          ownContributionPercent
          decisionDays
          coverageScope
          rollingIntake
          instructionUrl
          instructionReady
          voivodeship {
            id
            name
          }
          powiats {
            id
            name
          }
          currentIntake {
            id
            startsOn
            endsOn
            status
          }
        }
      }
    }
  }
}
    `;
export type ErpDeactivateCandidateOperatorMutationFn = Apollo.MutationFunction<ErpDeactivateCandidateOperatorMutation, ErpDeactivateCandidateOperatorMutationVariables>;

/**
 * __useErpDeactivateCandidateOperatorMutation__
 *
 * To run a mutation, you first call `useErpDeactivateCandidateOperatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpDeactivateCandidateOperatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpDeactivateCandidateOperatorMutation, { data, loading, error }] = useErpDeactivateCandidateOperatorMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      operatorId: // value for 'operatorId'
 *      reason: // value for 'reason'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useErpDeactivateCandidateOperatorMutation(baseOptions?: Apollo.MutationHookOptions<ErpDeactivateCandidateOperatorMutation, ErpDeactivateCandidateOperatorMutationVariables>) {
        return Apollo.useMutation<ErpDeactivateCandidateOperatorMutation, ErpDeactivateCandidateOperatorMutationVariables>(ErpDeactivateCandidateOperatorDocument, baseOptions);
      }
export type ErpDeactivateCandidateOperatorMutationHookResult = ReturnType<typeof useErpDeactivateCandidateOperatorMutation>;
export type ErpDeactivateCandidateOperatorMutationResult = Apollo.MutationResult<ErpDeactivateCandidateOperatorMutation>;
export type ErpDeactivateCandidateOperatorMutationOptions = Apollo.BaseMutationOptions<ErpDeactivateCandidateOperatorMutation, ErpDeactivateCandidateOperatorMutationVariables>;
export const ErpReactivateCandidateOperatorDocument = gql`
    mutation ErpReactivateCandidateOperator($candidateId: ID!, $operatorId: ID!, $note: String) {
  reactivateCandidateOperator(
    candidateId: $candidateId
    operatorId: $operatorId
    note: $note
  ) {
    success
    customErrors {
      field
      code
      message
    }
    candidate {
      id
      activeOperatorsCount
      disabledOperatorsCount
      primaryOperator {
        id
        name
        programType
        clientType
      }
      operators {
        id
        name
        programType
        clientType
      }
      operatorLinks {
        id
        isActive
        isPrimary
        source
        addedAt
        addedByName
        deactivatedAt
        deactivatedByName
        deactivationReason
        deactivationReasonLabel
        note
        operator {
          id
          name
          programName
          programType
          clientType
          ownContributionPercent
          decisionDays
          coverageScope
          rollingIntake
          instructionUrl
          instructionReady
          voivodeship {
            id
            name
          }
          powiats {
            id
            name
          }
          currentIntake {
            id
            startsOn
            endsOn
            status
          }
        }
      }
    }
  }
}
    `;
export type ErpReactivateCandidateOperatorMutationFn = Apollo.MutationFunction<ErpReactivateCandidateOperatorMutation, ErpReactivateCandidateOperatorMutationVariables>;

/**
 * __useErpReactivateCandidateOperatorMutation__
 *
 * To run a mutation, you first call `useErpReactivateCandidateOperatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpReactivateCandidateOperatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpReactivateCandidateOperatorMutation, { data, loading, error }] = useErpReactivateCandidateOperatorMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      operatorId: // value for 'operatorId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useErpReactivateCandidateOperatorMutation(baseOptions?: Apollo.MutationHookOptions<ErpReactivateCandidateOperatorMutation, ErpReactivateCandidateOperatorMutationVariables>) {
        return Apollo.useMutation<ErpReactivateCandidateOperatorMutation, ErpReactivateCandidateOperatorMutationVariables>(ErpReactivateCandidateOperatorDocument, baseOptions);
      }
export type ErpReactivateCandidateOperatorMutationHookResult = ReturnType<typeof useErpReactivateCandidateOperatorMutation>;
export type ErpReactivateCandidateOperatorMutationResult = Apollo.MutationResult<ErpReactivateCandidateOperatorMutation>;
export type ErpReactivateCandidateOperatorMutationOptions = Apollo.BaseMutationOptions<ErpReactivateCandidateOperatorMutation, ErpReactivateCandidateOperatorMutationVariables>;
export const ErpSetCandidatePrimaryOperatorDocument = gql`
    mutation ErpSetCandidatePrimaryOperator($candidateId: ID!, $operatorId: ID, $note: String) {
  setCandidatePrimaryOperator(
    candidateId: $candidateId
    operatorId: $operatorId
    note: $note
  ) {
    success
    customErrors {
      field
      code
      message
    }
    candidate {
      id
      activeOperatorsCount
      disabledOperatorsCount
      primaryOperator {
        id
        name
        programType
        clientType
      }
      operators {
        id
        name
        programType
        clientType
      }
      operatorLinks {
        id
        isActive
        isPrimary
        source
        addedAt
        addedByName
        deactivatedAt
        deactivatedByName
        deactivationReason
        deactivationReasonLabel
        note
        operator {
          id
          name
          programName
          programType
          clientType
          ownContributionPercent
          decisionDays
          coverageScope
          rollingIntake
          instructionUrl
          instructionReady
          voivodeship {
            id
            name
          }
          powiats {
            id
            name
          }
          currentIntake {
            id
            startsOn
            endsOn
            status
          }
        }
      }
    }
  }
}
    `;
export type ErpSetCandidatePrimaryOperatorMutationFn = Apollo.MutationFunction<ErpSetCandidatePrimaryOperatorMutation, ErpSetCandidatePrimaryOperatorMutationVariables>;

/**
 * __useErpSetCandidatePrimaryOperatorMutation__
 *
 * To run a mutation, you first call `useErpSetCandidatePrimaryOperatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSetCandidatePrimaryOperatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSetCandidatePrimaryOperatorMutation, { data, loading, error }] = useErpSetCandidatePrimaryOperatorMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      operatorId: // value for 'operatorId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useErpSetCandidatePrimaryOperatorMutation(baseOptions?: Apollo.MutationHookOptions<ErpSetCandidatePrimaryOperatorMutation, ErpSetCandidatePrimaryOperatorMutationVariables>) {
        return Apollo.useMutation<ErpSetCandidatePrimaryOperatorMutation, ErpSetCandidatePrimaryOperatorMutationVariables>(ErpSetCandidatePrimaryOperatorDocument, baseOptions);
      }
export type ErpSetCandidatePrimaryOperatorMutationHookResult = ReturnType<typeof useErpSetCandidatePrimaryOperatorMutation>;
export type ErpSetCandidatePrimaryOperatorMutationResult = Apollo.MutationResult<ErpSetCandidatePrimaryOperatorMutation>;
export type ErpSetCandidatePrimaryOperatorMutationOptions = Apollo.BaseMutationOptions<ErpSetCandidatePrimaryOperatorMutation, ErpSetCandidatePrimaryOperatorMutationVariables>;
export const ErpSetCandidateAttentionDocument = gql`
    mutation ErpSetCandidateAttention($id: ID!, $on: Boolean!, $note: String) {
  setFundingCandidateAttention(candidateId: $id, on: $on, note: $note) {
    success
    customErrors {
      field
      code
      message
    }
    candidate {
      id
      needsAttention
      attentionNote
      attentionSetByName
      attentionSetAt
      nextIntake {
        id
        startsOn
        operatorId
        operatorName
      }
      events {
        id
        fromStatus
        toStatus
        fromOperatorId
        fromOperatorName
        toOperatorId
        toOperatorName
        changedByName
        changedAt
        note
      }
    }
  }
}
    `;
export type ErpSetCandidateAttentionMutationFn = Apollo.MutationFunction<ErpSetCandidateAttentionMutation, ErpSetCandidateAttentionMutationVariables>;

/**
 * __useErpSetCandidateAttentionMutation__
 *
 * To run a mutation, you first call `useErpSetCandidateAttentionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSetCandidateAttentionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSetCandidateAttentionMutation, { data, loading, error }] = useErpSetCandidateAttentionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      on: // value for 'on'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useErpSetCandidateAttentionMutation(baseOptions?: Apollo.MutationHookOptions<ErpSetCandidateAttentionMutation, ErpSetCandidateAttentionMutationVariables>) {
        return Apollo.useMutation<ErpSetCandidateAttentionMutation, ErpSetCandidateAttentionMutationVariables>(ErpSetCandidateAttentionDocument, baseOptions);
      }
export type ErpSetCandidateAttentionMutationHookResult = ReturnType<typeof useErpSetCandidateAttentionMutation>;
export type ErpSetCandidateAttentionMutationResult = Apollo.MutationResult<ErpSetCandidateAttentionMutation>;
export type ErpSetCandidateAttentionMutationOptions = Apollo.BaseMutationOptions<ErpSetCandidateAttentionMutation, ErpSetCandidateAttentionMutationVariables>;
export const ErpLinkCandidateToUserDocument = gql`
    mutation ErpLinkCandidateToUser($candidateId: ID!, $userId: ID!) {
  linkCandidateToUser(candidateId: $candidateId, userId: $userId) {
    success
    customErrors {
      field
      code
      message
    }
    candidate {
      id
      matchStatus
      userLocked
      linkedUserId
      linkedUserName
      isStudent
      studentId
    }
  }
}
    `;
export type ErpLinkCandidateToUserMutationFn = Apollo.MutationFunction<ErpLinkCandidateToUserMutation, ErpLinkCandidateToUserMutationVariables>;

/**
 * __useErpLinkCandidateToUserMutation__
 *
 * To run a mutation, you first call `useErpLinkCandidateToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpLinkCandidateToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpLinkCandidateToUserMutation, { data, loading, error }] = useErpLinkCandidateToUserMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useErpLinkCandidateToUserMutation(baseOptions?: Apollo.MutationHookOptions<ErpLinkCandidateToUserMutation, ErpLinkCandidateToUserMutationVariables>) {
        return Apollo.useMutation<ErpLinkCandidateToUserMutation, ErpLinkCandidateToUserMutationVariables>(ErpLinkCandidateToUserDocument, baseOptions);
      }
export type ErpLinkCandidateToUserMutationHookResult = ReturnType<typeof useErpLinkCandidateToUserMutation>;
export type ErpLinkCandidateToUserMutationResult = Apollo.MutationResult<ErpLinkCandidateToUserMutation>;
export type ErpLinkCandidateToUserMutationOptions = Apollo.BaseMutationOptions<ErpLinkCandidateToUserMutation, ErpLinkCandidateToUserMutationVariables>;
export const ErpUnlinkCandidateFromUserDocument = gql`
    mutation ErpUnlinkCandidateFromUser($candidateId: ID!) {
  unlinkCandidateFromUser(candidateId: $candidateId) {
    success
    customErrors {
      field
      code
      message
    }
    candidate {
      id
      matchStatus
      userLocked
      linkedUserId
      linkedUserName
      isStudent
    }
  }
}
    `;
export type ErpUnlinkCandidateFromUserMutationFn = Apollo.MutationFunction<ErpUnlinkCandidateFromUserMutation, ErpUnlinkCandidateFromUserMutationVariables>;

/**
 * __useErpUnlinkCandidateFromUserMutation__
 *
 * To run a mutation, you first call `useErpUnlinkCandidateFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpUnlinkCandidateFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpUnlinkCandidateFromUserMutation, { data, loading, error }] = useErpUnlinkCandidateFromUserMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useErpUnlinkCandidateFromUserMutation(baseOptions?: Apollo.MutationHookOptions<ErpUnlinkCandidateFromUserMutation, ErpUnlinkCandidateFromUserMutationVariables>) {
        return Apollo.useMutation<ErpUnlinkCandidateFromUserMutation, ErpUnlinkCandidateFromUserMutationVariables>(ErpUnlinkCandidateFromUserDocument, baseOptions);
      }
export type ErpUnlinkCandidateFromUserMutationHookResult = ReturnType<typeof useErpUnlinkCandidateFromUserMutation>;
export type ErpUnlinkCandidateFromUserMutationResult = Apollo.MutationResult<ErpUnlinkCandidateFromUserMutation>;
export type ErpUnlinkCandidateFromUserMutationOptions = Apollo.BaseMutationOptions<ErpUnlinkCandidateFromUserMutation, ErpUnlinkCandidateFromUserMutationVariables>;
export const ErpSaveFundingCandidateDocument = gql`
    mutation ErpSaveFundingCandidate($id: ID, $input: FundingCandidateInput!) {
  saveFundingCandidate(id: $id, input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    candidate {
      id
      fullName
      email
      phone
      city
      employmentStatus
      employerName
      kfsGeoBasis
      employerVoivodeship {
        id
        name
      }
      employerPowiat {
        id
        name
      }
      isAdult
      is50Plus
      isUnemployed
      jdgSuspended
      hasDisabilityCertificate
      inFinancialHardship
      usedFundingBefore
      employerCanApply
      outcome
      notes
      taskNote
      approvedAmount
      currency
      supportId
      isArchived
      operators {
        id
        name
        programType
        clientType
      }
      activeOperatorsCount
    }
    supportIdLink
  }
}
    `;
export type ErpSaveFundingCandidateMutationFn = Apollo.MutationFunction<ErpSaveFundingCandidateMutation, ErpSaveFundingCandidateMutationVariables>;

/**
 * __useErpSaveFundingCandidateMutation__
 *
 * To run a mutation, you first call `useErpSaveFundingCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSaveFundingCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSaveFundingCandidateMutation, { data, loading, error }] = useErpSaveFundingCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErpSaveFundingCandidateMutation(baseOptions?: Apollo.MutationHookOptions<ErpSaveFundingCandidateMutation, ErpSaveFundingCandidateMutationVariables>) {
        return Apollo.useMutation<ErpSaveFundingCandidateMutation, ErpSaveFundingCandidateMutationVariables>(ErpSaveFundingCandidateDocument, baseOptions);
      }
export type ErpSaveFundingCandidateMutationHookResult = ReturnType<typeof useErpSaveFundingCandidateMutation>;
export type ErpSaveFundingCandidateMutationResult = Apollo.MutationResult<ErpSaveFundingCandidateMutation>;
export type ErpSaveFundingCandidateMutationOptions = Apollo.BaseMutationOptions<ErpSaveFundingCandidateMutation, ErpSaveFundingCandidateMutationVariables>;
export const ErpDeleteFundingCandidateDocument = gql`
    mutation ErpDeleteFundingCandidate($id: ID!) {
  deleteFundingCandidate(id: $id) {
    success
    deletedId
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type ErpDeleteFundingCandidateMutationFn = Apollo.MutationFunction<ErpDeleteFundingCandidateMutation, ErpDeleteFundingCandidateMutationVariables>;

/**
 * __useErpDeleteFundingCandidateMutation__
 *
 * To run a mutation, you first call `useErpDeleteFundingCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpDeleteFundingCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpDeleteFundingCandidateMutation, { data, loading, error }] = useErpDeleteFundingCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpDeleteFundingCandidateMutation(baseOptions?: Apollo.MutationHookOptions<ErpDeleteFundingCandidateMutation, ErpDeleteFundingCandidateMutationVariables>) {
        return Apollo.useMutation<ErpDeleteFundingCandidateMutation, ErpDeleteFundingCandidateMutationVariables>(ErpDeleteFundingCandidateDocument, baseOptions);
      }
export type ErpDeleteFundingCandidateMutationHookResult = ReturnType<typeof useErpDeleteFundingCandidateMutation>;
export type ErpDeleteFundingCandidateMutationResult = Apollo.MutationResult<ErpDeleteFundingCandidateMutation>;
export type ErpDeleteFundingCandidateMutationOptions = Apollo.BaseMutationOptions<ErpDeleteFundingCandidateMutation, ErpDeleteFundingCandidateMutationVariables>;
export const ErpSaveFundingOperatorDocument = gql`
    mutation ErpSaveFundingOperator($id: ID, $input: FundingOperatorInput!) {
  saveFundingOperator(id: $id, input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    operator {
      id
      name
      programType
      projectNumber
      isActive
      coverageScope
      instructionUrl
      instructionReady
      newsUrl
      feedUrl
      maxAmount
      paymentMethod
      comment
    }
    projectNumberLink
    linkedCandidatesCount
  }
}
    `;
export type ErpSaveFundingOperatorMutationFn = Apollo.MutationFunction<ErpSaveFundingOperatorMutation, ErpSaveFundingOperatorMutationVariables>;

/**
 * __useErpSaveFundingOperatorMutation__
 *
 * To run a mutation, you first call `useErpSaveFundingOperatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSaveFundingOperatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSaveFundingOperatorMutation, { data, loading, error }] = useErpSaveFundingOperatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErpSaveFundingOperatorMutation(baseOptions?: Apollo.MutationHookOptions<ErpSaveFundingOperatorMutation, ErpSaveFundingOperatorMutationVariables>) {
        return Apollo.useMutation<ErpSaveFundingOperatorMutation, ErpSaveFundingOperatorMutationVariables>(ErpSaveFundingOperatorDocument, baseOptions);
      }
export type ErpSaveFundingOperatorMutationHookResult = ReturnType<typeof useErpSaveFundingOperatorMutation>;
export type ErpSaveFundingOperatorMutationResult = Apollo.MutationResult<ErpSaveFundingOperatorMutation>;
export type ErpSaveFundingOperatorMutationOptions = Apollo.BaseMutationOptions<ErpSaveFundingOperatorMutation, ErpSaveFundingOperatorMutationVariables>;
export const ErpSaveFundingIntakeDocument = gql`
    mutation ErpSaveFundingIntake($id: ID, $operatorId: ID!, $startsOn: Date, $endsOn: Date, $startsAtTime: Time, $endsAtTime: Time, $announcedAt: Date, $status: String, $sourceUrl: String, $note: String, $confirmed: Boolean) {
  saveFundingIntake(
    id: $id
    operatorId: $operatorId
    startsOn: $startsOn
    endsOn: $endsOn
    startsAtTime: $startsAtTime
    endsAtTime: $endsAtTime
    announcedAt: $announcedAt
    status: $status
    sourceUrl: $sourceUrl
    note: $note
    confirmed: $confirmed
  ) {
    success
    customErrors {
      field
      code
      message
    }
    intake {
      id
      operatorId
      operatorName
      startsOn
      endsOn
      startsAtTime
      endsAtTime
      announcedAt
      status
      sourceUrl
      note
      confirmedAt
      confirmedByName
    }
  }
}
    `;
export type ErpSaveFundingIntakeMutationFn = Apollo.MutationFunction<ErpSaveFundingIntakeMutation, ErpSaveFundingIntakeMutationVariables>;

/**
 * __useErpSaveFundingIntakeMutation__
 *
 * To run a mutation, you first call `useErpSaveFundingIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSaveFundingIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSaveFundingIntakeMutation, { data, loading, error }] = useErpSaveFundingIntakeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      operatorId: // value for 'operatorId'
 *      startsOn: // value for 'startsOn'
 *      endsOn: // value for 'endsOn'
 *      startsAtTime: // value for 'startsAtTime'
 *      endsAtTime: // value for 'endsAtTime'
 *      announcedAt: // value for 'announcedAt'
 *      status: // value for 'status'
 *      sourceUrl: // value for 'sourceUrl'
 *      note: // value for 'note'
 *      confirmed: // value for 'confirmed'
 *   },
 * });
 */
export function useErpSaveFundingIntakeMutation(baseOptions?: Apollo.MutationHookOptions<ErpSaveFundingIntakeMutation, ErpSaveFundingIntakeMutationVariables>) {
        return Apollo.useMutation<ErpSaveFundingIntakeMutation, ErpSaveFundingIntakeMutationVariables>(ErpSaveFundingIntakeDocument, baseOptions);
      }
export type ErpSaveFundingIntakeMutationHookResult = ReturnType<typeof useErpSaveFundingIntakeMutation>;
export type ErpSaveFundingIntakeMutationResult = Apollo.MutationResult<ErpSaveFundingIntakeMutation>;
export type ErpSaveFundingIntakeMutationOptions = Apollo.BaseMutationOptions<ErpSaveFundingIntakeMutation, ErpSaveFundingIntakeMutationVariables>;
export const ErpResolveGeoAliasDocument = gql`
    mutation ErpResolveGeoAlias($id: ID!, $powiatId: ID, $ignore: Boolean) {
  resolveGeoAlias(id: $id, powiatId: $powiatId, ignore: $ignore) {
    success
    customErrors {
      field
      code
      message
    }
    alias {
      id
      rawValue
      status
      powiat {
        id
        name
      }
    }
  }
}
    `;
export type ErpResolveGeoAliasMutationFn = Apollo.MutationFunction<ErpResolveGeoAliasMutation, ErpResolveGeoAliasMutationVariables>;

/**
 * __useErpResolveGeoAliasMutation__
 *
 * To run a mutation, you first call `useErpResolveGeoAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpResolveGeoAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpResolveGeoAliasMutation, { data, loading, error }] = useErpResolveGeoAliasMutation({
 *   variables: {
 *      id: // value for 'id'
 *      powiatId: // value for 'powiatId'
 *      ignore: // value for 'ignore'
 *   },
 * });
 */
export function useErpResolveGeoAliasMutation(baseOptions?: Apollo.MutationHookOptions<ErpResolveGeoAliasMutation, ErpResolveGeoAliasMutationVariables>) {
        return Apollo.useMutation<ErpResolveGeoAliasMutation, ErpResolveGeoAliasMutationVariables>(ErpResolveGeoAliasDocument, baseOptions);
      }
export type ErpResolveGeoAliasMutationHookResult = ReturnType<typeof useErpResolveGeoAliasMutation>;
export type ErpResolveGeoAliasMutationResult = Apollo.MutationResult<ErpResolveGeoAliasMutation>;
export type ErpResolveGeoAliasMutationOptions = Apollo.BaseMutationOptions<ErpResolveGeoAliasMutation, ErpResolveGeoAliasMutationVariables>;
export const ErpDeleteFundingIntakeDocument = gql`
    mutation ErpDeleteFundingIntake($id: ID!) {
  deleteFundingIntake(id: $id) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ErpDeleteFundingIntakeMutationFn = Apollo.MutationFunction<ErpDeleteFundingIntakeMutation, ErpDeleteFundingIntakeMutationVariables>;

/**
 * __useErpDeleteFundingIntakeMutation__
 *
 * To run a mutation, you first call `useErpDeleteFundingIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpDeleteFundingIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpDeleteFundingIntakeMutation, { data, loading, error }] = useErpDeleteFundingIntakeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpDeleteFundingIntakeMutation(baseOptions?: Apollo.MutationHookOptions<ErpDeleteFundingIntakeMutation, ErpDeleteFundingIntakeMutationVariables>) {
        return Apollo.useMutation<ErpDeleteFundingIntakeMutation, ErpDeleteFundingIntakeMutationVariables>(ErpDeleteFundingIntakeDocument, baseOptions);
      }
export type ErpDeleteFundingIntakeMutationHookResult = ReturnType<typeof useErpDeleteFundingIntakeMutation>;
export type ErpDeleteFundingIntakeMutationResult = Apollo.MutationResult<ErpDeleteFundingIntakeMutation>;
export type ErpDeleteFundingIntakeMutationOptions = Apollo.BaseMutationOptions<ErpDeleteFundingIntakeMutation, ErpDeleteFundingIntakeMutationVariables>;
export const ErpSubmitFundingFormDocument = gql`
    mutation ErpSubmitFundingForm($payload: JSONString!, $recaptchaToken: String, $utm: JSONString) {
  submitFundingForm(payload: $payload, recaptchaToken: $recaptchaToken, utm: $utm) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ErpSubmitFundingFormMutationFn = Apollo.MutationFunction<ErpSubmitFundingFormMutation, ErpSubmitFundingFormMutationVariables>;

/**
 * __useErpSubmitFundingFormMutation__
 *
 * To run a mutation, you first call `useErpSubmitFundingFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSubmitFundingFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSubmitFundingFormMutation, { data, loading, error }] = useErpSubmitFundingFormMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      recaptchaToken: // value for 'recaptchaToken'
 *      utm: // value for 'utm'
 *   },
 * });
 */
export function useErpSubmitFundingFormMutation(baseOptions?: Apollo.MutationHookOptions<ErpSubmitFundingFormMutation, ErpSubmitFundingFormMutationVariables>) {
        return Apollo.useMutation<ErpSubmitFundingFormMutation, ErpSubmitFundingFormMutationVariables>(ErpSubmitFundingFormDocument, baseOptions);
      }
export type ErpSubmitFundingFormMutationHookResult = ReturnType<typeof useErpSubmitFundingFormMutation>;
export type ErpSubmitFundingFormMutationResult = Apollo.MutationResult<ErpSubmitFundingFormMutation>;
export type ErpSubmitFundingFormMutationOptions = Apollo.BaseMutationOptions<ErpSubmitFundingFormMutation, ErpSubmitFundingFormMutationVariables>;
export const ErpReviewOperatorPageDocument = gql`
    mutation ErpReviewOperatorPage($operatorId: ID!, $intake: FundingIntakeInput) {
  reviewOperatorPage(operatorId: $operatorId, intake: $intake) {
    success
    customErrors {
      field
      code
      message
    }
    operator {
      id
      pageState
      hasConfirmedIntake
      pageChanged
      pageChangedAt
      pageHashCheckedAt
      pageCheckedOkAt
      intakes {
        id
        startsOn
        endsOn
        startsAtTime
        endsAtTime
        announcedAt
        status
        phase
        daysLeft
        confirmedAt
        confirmedByName
        notifiedAt
        notifiedCount
        candidatesCount
        sourceUrl
        note
      }
    }
  }
}
    `;
export type ErpReviewOperatorPageMutationFn = Apollo.MutationFunction<ErpReviewOperatorPageMutation, ErpReviewOperatorPageMutationVariables>;

/**
 * __useErpReviewOperatorPageMutation__
 *
 * To run a mutation, you first call `useErpReviewOperatorPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpReviewOperatorPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpReviewOperatorPageMutation, { data, loading, error }] = useErpReviewOperatorPageMutation({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      intake: // value for 'intake'
 *   },
 * });
 */
export function useErpReviewOperatorPageMutation(baseOptions?: Apollo.MutationHookOptions<ErpReviewOperatorPageMutation, ErpReviewOperatorPageMutationVariables>) {
        return Apollo.useMutation<ErpReviewOperatorPageMutation, ErpReviewOperatorPageMutationVariables>(ErpReviewOperatorPageDocument, baseOptions);
      }
export type ErpReviewOperatorPageMutationHookResult = ReturnType<typeof useErpReviewOperatorPageMutation>;
export type ErpReviewOperatorPageMutationResult = Apollo.MutationResult<ErpReviewOperatorPageMutation>;
export type ErpReviewOperatorPageMutationOptions = Apollo.BaseMutationOptions<ErpReviewOperatorPageMutation, ErpReviewOperatorPageMutationVariables>;
export const ErpConfirmFundingIntakeDocument = gql`
    mutation ErpConfirmFundingIntake($id: ID!, $confirmed: Boolean!) {
  confirmFundingIntake(id: $id, confirmed: $confirmed) {
    success
    customErrors {
      field
      code
      message
    }
    intake {
      id
      confirmedAt
      confirmedByName
    }
  }
}
    `;
export type ErpConfirmFundingIntakeMutationFn = Apollo.MutationFunction<ErpConfirmFundingIntakeMutation, ErpConfirmFundingIntakeMutationVariables>;

/**
 * __useErpConfirmFundingIntakeMutation__
 *
 * To run a mutation, you first call `useErpConfirmFundingIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpConfirmFundingIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpConfirmFundingIntakeMutation, { data, loading, error }] = useErpConfirmFundingIntakeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      confirmed: // value for 'confirmed'
 *   },
 * });
 */
export function useErpConfirmFundingIntakeMutation(baseOptions?: Apollo.MutationHookOptions<ErpConfirmFundingIntakeMutation, ErpConfirmFundingIntakeMutationVariables>) {
        return Apollo.useMutation<ErpConfirmFundingIntakeMutation, ErpConfirmFundingIntakeMutationVariables>(ErpConfirmFundingIntakeDocument, baseOptions);
      }
export type ErpConfirmFundingIntakeMutationHookResult = ReturnType<typeof useErpConfirmFundingIntakeMutation>;
export type ErpConfirmFundingIntakeMutationResult = Apollo.MutationResult<ErpConfirmFundingIntakeMutation>;
export type ErpConfirmFundingIntakeMutationOptions = Apollo.BaseMutationOptions<ErpConfirmFundingIntakeMutation, ErpConfirmFundingIntakeMutationVariables>;
export const ErpRetryFormSubmissionDocument = gql`
    mutation ErpRetryFormSubmission($id: ID!) {
  retryFormSubmission(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
    submission {
      id
      state
      processError
      candidateId
      candidateName
    }
  }
}
    `;
export type ErpRetryFormSubmissionMutationFn = Apollo.MutationFunction<ErpRetryFormSubmissionMutation, ErpRetryFormSubmissionMutationVariables>;

/**
 * __useErpRetryFormSubmissionMutation__
 *
 * To run a mutation, you first call `useErpRetryFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRetryFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRetryFormSubmissionMutation, { data, loading, error }] = useErpRetryFormSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpRetryFormSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<ErpRetryFormSubmissionMutation, ErpRetryFormSubmissionMutationVariables>) {
        return Apollo.useMutation<ErpRetryFormSubmissionMutation, ErpRetryFormSubmissionMutationVariables>(ErpRetryFormSubmissionDocument, baseOptions);
      }
export type ErpRetryFormSubmissionMutationHookResult = ReturnType<typeof useErpRetryFormSubmissionMutation>;
export type ErpRetryFormSubmissionMutationResult = Apollo.MutationResult<ErpRetryFormSubmissionMutation>;
export type ErpRetryFormSubmissionMutationOptions = Apollo.BaseMutationOptions<ErpRetryFormSubmissionMutation, ErpRetryFormSubmissionMutationVariables>;
export const ErpRunFundingTaskDocument = gql`
    mutation ErpRunFundingTask($task: String!, $dryRun: Boolean) {
  runFundingTask(task: $task, dryRun: $dryRun) {
    success
    taskId
    workerOnline
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type ErpRunFundingTaskMutationFn = Apollo.MutationFunction<ErpRunFundingTaskMutation, ErpRunFundingTaskMutationVariables>;

/**
 * __useErpRunFundingTaskMutation__
 *
 * To run a mutation, you first call `useErpRunFundingTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpRunFundingTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpRunFundingTaskMutation, { data, loading, error }] = useErpRunFundingTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useErpRunFundingTaskMutation(baseOptions?: Apollo.MutationHookOptions<ErpRunFundingTaskMutation, ErpRunFundingTaskMutationVariables>) {
        return Apollo.useMutation<ErpRunFundingTaskMutation, ErpRunFundingTaskMutationVariables>(ErpRunFundingTaskDocument, baseOptions);
      }
export type ErpRunFundingTaskMutationHookResult = ReturnType<typeof useErpRunFundingTaskMutation>;
export type ErpRunFundingTaskMutationResult = Apollo.MutationResult<ErpRunFundingTaskMutation>;
export type ErpRunFundingTaskMutationOptions = Apollo.BaseMutationOptions<ErpRunFundingTaskMutation, ErpRunFundingTaskMutationVariables>;
export const ErpSaveFundingMailSettingsDocument = gql`
    mutation ErpSaveFundingMailSettings($input: FundingMailSettingsInput!) {
  saveFundingMailSettings(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    mailSettings {
      paused
      fromEmail
      fromName
      replyTo
      effectiveFromEmail
      effectiveFromName
      effectiveReplyTo
      soonSendHour
      runningSendHour
      updatedAt
      updatedByName
      serverMailEnabled
      testRecipient
      notifyScheduled
      automatchScheduled
      shortenerEnabled
      canEdit
      automatchBlocked
    }
  }
}
    `;
export type ErpSaveFundingMailSettingsMutationFn = Apollo.MutationFunction<ErpSaveFundingMailSettingsMutation, ErpSaveFundingMailSettingsMutationVariables>;

/**
 * __useErpSaveFundingMailSettingsMutation__
 *
 * To run a mutation, you first call `useErpSaveFundingMailSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSaveFundingMailSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSaveFundingMailSettingsMutation, { data, loading, error }] = useErpSaveFundingMailSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErpSaveFundingMailSettingsMutation(baseOptions?: Apollo.MutationHookOptions<ErpSaveFundingMailSettingsMutation, ErpSaveFundingMailSettingsMutationVariables>) {
        return Apollo.useMutation<ErpSaveFundingMailSettingsMutation, ErpSaveFundingMailSettingsMutationVariables>(ErpSaveFundingMailSettingsDocument, baseOptions);
      }
export type ErpSaveFundingMailSettingsMutationHookResult = ReturnType<typeof useErpSaveFundingMailSettingsMutation>;
export type ErpSaveFundingMailSettingsMutationResult = Apollo.MutationResult<ErpSaveFundingMailSettingsMutation>;
export type ErpSaveFundingMailSettingsMutationOptions = Apollo.BaseMutationOptions<ErpSaveFundingMailSettingsMutation, ErpSaveFundingMailSettingsMutationVariables>;
export const ErpSaveFundingMailRuleDocument = gql`
    mutation ErpSaveFundingMailRule($input: FundingMailRuleInput!) {
  saveFundingMailRule(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    rule {
      id
      code
      kind
      offsetDays
      everyDays
      templateId
      templateName
      templateSubject
      isActive
      updatedAt
      updatedByName
      canDelete
      sentCount
    }
  }
}
    `;
export type ErpSaveFundingMailRuleMutationFn = Apollo.MutationFunction<ErpSaveFundingMailRuleMutation, ErpSaveFundingMailRuleMutationVariables>;

/**
 * __useErpSaveFundingMailRuleMutation__
 *
 * To run a mutation, you first call `useErpSaveFundingMailRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSaveFundingMailRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSaveFundingMailRuleMutation, { data, loading, error }] = useErpSaveFundingMailRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErpSaveFundingMailRuleMutation(baseOptions?: Apollo.MutationHookOptions<ErpSaveFundingMailRuleMutation, ErpSaveFundingMailRuleMutationVariables>) {
        return Apollo.useMutation<ErpSaveFundingMailRuleMutation, ErpSaveFundingMailRuleMutationVariables>(ErpSaveFundingMailRuleDocument, baseOptions);
      }
export type ErpSaveFundingMailRuleMutationHookResult = ReturnType<typeof useErpSaveFundingMailRuleMutation>;
export type ErpSaveFundingMailRuleMutationResult = Apollo.MutationResult<ErpSaveFundingMailRuleMutation>;
export type ErpSaveFundingMailRuleMutationOptions = Apollo.BaseMutationOptions<ErpSaveFundingMailRuleMutation, ErpSaveFundingMailRuleMutationVariables>;
export const ErpDeleteFundingMailRuleDocument = gql`
    mutation ErpDeleteFundingMailRule($id: ID!) {
  deleteFundingMailRule(id: $id) {
    success
    deletedId
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type ErpDeleteFundingMailRuleMutationFn = Apollo.MutationFunction<ErpDeleteFundingMailRuleMutation, ErpDeleteFundingMailRuleMutationVariables>;

/**
 * __useErpDeleteFundingMailRuleMutation__
 *
 * To run a mutation, you first call `useErpDeleteFundingMailRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpDeleteFundingMailRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpDeleteFundingMailRuleMutation, { data, loading, error }] = useErpDeleteFundingMailRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpDeleteFundingMailRuleMutation(baseOptions?: Apollo.MutationHookOptions<ErpDeleteFundingMailRuleMutation, ErpDeleteFundingMailRuleMutationVariables>) {
        return Apollo.useMutation<ErpDeleteFundingMailRuleMutation, ErpDeleteFundingMailRuleMutationVariables>(ErpDeleteFundingMailRuleDocument, baseOptions);
      }
export type ErpDeleteFundingMailRuleMutationHookResult = ReturnType<typeof useErpDeleteFundingMailRuleMutation>;
export type ErpDeleteFundingMailRuleMutationResult = Apollo.MutationResult<ErpDeleteFundingMailRuleMutation>;
export type ErpDeleteFundingMailRuleMutationOptions = Apollo.BaseMutationOptions<ErpDeleteFundingMailRuleMutation, ErpDeleteFundingMailRuleMutationVariables>;
export const ErpSendFundingMailTestDocument = gql`
    mutation ErpSendFundingMailTest($ruleId: ID!, $intakeId: ID, $templateId: String) {
  sendFundingMailTest(
    ruleId: $ruleId
    intakeId: $intakeId
    templateId: $templateId
  ) {
    success
    sentTo
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type ErpSendFundingMailTestMutationFn = Apollo.MutationFunction<ErpSendFundingMailTestMutation, ErpSendFundingMailTestMutationVariables>;

/**
 * __useErpSendFundingMailTestMutation__
 *
 * To run a mutation, you first call `useErpSendFundingMailTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErpSendFundingMailTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erpSendFundingMailTestMutation, { data, loading, error }] = useErpSendFundingMailTestMutation({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *      intakeId: // value for 'intakeId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useErpSendFundingMailTestMutation(baseOptions?: Apollo.MutationHookOptions<ErpSendFundingMailTestMutation, ErpSendFundingMailTestMutationVariables>) {
        return Apollo.useMutation<ErpSendFundingMailTestMutation, ErpSendFundingMailTestMutationVariables>(ErpSendFundingMailTestDocument, baseOptions);
      }
export type ErpSendFundingMailTestMutationHookResult = ReturnType<typeof useErpSendFundingMailTestMutation>;
export type ErpSendFundingMailTestMutationResult = Apollo.MutationResult<ErpSendFundingMailTestMutation>;
export type ErpSendFundingMailTestMutationOptions = Apollo.BaseMutationOptions<ErpSendFundingMailTestMutation, ErpSendFundingMailTestMutationVariables>;
export const CreateStudentContractDocument = gql`
    mutation CreateStudentContract($input: StudentContractDraftInput!) {
  createStudentContractDraft(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type CreateStudentContractMutationFn = Apollo.MutationFunction<CreateStudentContractMutation, CreateStudentContractMutationVariables>;

/**
 * __useCreateStudentContractMutation__
 *
 * To run a mutation, you first call `useCreateStudentContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudentContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudentContractMutation, { data, loading, error }] = useCreateStudentContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStudentContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateStudentContractMutation, CreateStudentContractMutationVariables>) {
        return Apollo.useMutation<CreateStudentContractMutation, CreateStudentContractMutationVariables>(CreateStudentContractDocument, baseOptions);
      }
export type CreateStudentContractMutationHookResult = ReturnType<typeof useCreateStudentContractMutation>;
export type CreateStudentContractMutationResult = Apollo.MutationResult<CreateStudentContractMutation>;
export type CreateStudentContractMutationOptions = Apollo.BaseMutationOptions<CreateStudentContractMutation, CreateStudentContractMutationVariables>;
export const UpdateStudentContractDocument = gql`
    mutation UpdateStudentContract($id: ID!, $input: StudentContractDraftInput!) {
  updateContractDraft(id: $id, input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type UpdateStudentContractMutationFn = Apollo.MutationFunction<UpdateStudentContractMutation, UpdateStudentContractMutationVariables>;

/**
 * __useUpdateStudentContractMutation__
 *
 * To run a mutation, you first call `useUpdateStudentContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentContractMutation, { data, loading, error }] = useUpdateStudentContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudentContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentContractMutation, UpdateStudentContractMutationVariables>) {
        return Apollo.useMutation<UpdateStudentContractMutation, UpdateStudentContractMutationVariables>(UpdateStudentContractDocument, baseOptions);
      }
export type UpdateStudentContractMutationHookResult = ReturnType<typeof useUpdateStudentContractMutation>;
export type UpdateStudentContractMutationResult = Apollo.MutationResult<UpdateStudentContractMutation>;
export type UpdateStudentContractMutationOptions = Apollo.BaseMutationOptions<UpdateStudentContractMutation, UpdateStudentContractMutationVariables>;
export const CreateCompanyContractDocument = gql`
    mutation CreateCompanyContract($input: CompanyContractDraftInput!) {
  createCompanyContractDraft(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type CreateCompanyContractMutationFn = Apollo.MutationFunction<CreateCompanyContractMutation, CreateCompanyContractMutationVariables>;

/**
 * __useCreateCompanyContractMutation__
 *
 * To run a mutation, you first call `useCreateCompanyContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyContractMutation, { data, loading, error }] = useCreateCompanyContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyContractMutation, CreateCompanyContractMutationVariables>) {
        return Apollo.useMutation<CreateCompanyContractMutation, CreateCompanyContractMutationVariables>(CreateCompanyContractDocument, baseOptions);
      }
export type CreateCompanyContractMutationHookResult = ReturnType<typeof useCreateCompanyContractMutation>;
export type CreateCompanyContractMutationResult = Apollo.MutationResult<CreateCompanyContractMutation>;
export type CreateCompanyContractMutationOptions = Apollo.BaseMutationOptions<CreateCompanyContractMutation, CreateCompanyContractMutationVariables>;
export const UpdateCompanyContractDocument = gql`
    mutation UpdateCompanyContract($id: ID!, $input: CompanyContractDraftInput!) {
  updateCompanyContractDraft(id: $id, input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type UpdateCompanyContractMutationFn = Apollo.MutationFunction<UpdateCompanyContractMutation, UpdateCompanyContractMutationVariables>;

/**
 * __useUpdateCompanyContractMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyContractMutation, { data, loading, error }] = useUpdateCompanyContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyContractMutation, UpdateCompanyContractMutationVariables>) {
        return Apollo.useMutation<UpdateCompanyContractMutation, UpdateCompanyContractMutationVariables>(UpdateCompanyContractDocument, baseOptions);
      }
export type UpdateCompanyContractMutationHookResult = ReturnType<typeof useUpdateCompanyContractMutation>;
export type UpdateCompanyContractMutationResult = Apollo.MutationResult<UpdateCompanyContractMutation>;
export type UpdateCompanyContractMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyContractMutation, UpdateCompanyContractMutationVariables>;
export const SendEsignContractDocument = gql`
    mutation SendEsignContract($id: ID!, $sendEmail: Boolean!, $emailSubject: String, $emailBody: String, $templateId: ID, $aiDraftId: ID) {
  sendContract(
    id: $id
    sendEmail: $sendEmail
    emailSubject: $emailSubject
    emailBody: $emailBody
    templateId: $templateId
    aiDraftId: $aiDraftId
  ) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type SendEsignContractMutationFn = Apollo.MutationFunction<SendEsignContractMutation, SendEsignContractMutationVariables>;

/**
 * __useSendEsignContractMutation__
 *
 * To run a mutation, you first call `useSendEsignContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEsignContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEsignContractMutation, { data, loading, error }] = useSendEsignContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sendEmail: // value for 'sendEmail'
 *      emailSubject: // value for 'emailSubject'
 *      emailBody: // value for 'emailBody'
 *      templateId: // value for 'templateId'
 *      aiDraftId: // value for 'aiDraftId'
 *   },
 * });
 */
export function useSendEsignContractMutation(baseOptions?: Apollo.MutationHookOptions<SendEsignContractMutation, SendEsignContractMutationVariables>) {
        return Apollo.useMutation<SendEsignContractMutation, SendEsignContractMutationVariables>(SendEsignContractDocument, baseOptions);
      }
export type SendEsignContractMutationHookResult = ReturnType<typeof useSendEsignContractMutation>;
export type SendEsignContractMutationResult = Apollo.MutationResult<SendEsignContractMutation>;
export type SendEsignContractMutationOptions = Apollo.BaseMutationOptions<SendEsignContractMutation, SendEsignContractMutationVariables>;
export const ResendEsignEmailDocument = gql`
    mutation ResendEsignEmail($id: ID!, $emailSubject: String, $emailBody: String, $templateId: ID, $aiDraftId: ID) {
  resendContractEmail(
    id: $id
    emailSubject: $emailSubject
    emailBody: $emailBody
    templateId: $templateId
    aiDraftId: $aiDraftId
  ) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type ResendEsignEmailMutationFn = Apollo.MutationFunction<ResendEsignEmailMutation, ResendEsignEmailMutationVariables>;

/**
 * __useResendEsignEmailMutation__
 *
 * To run a mutation, you first call `useResendEsignEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEsignEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEsignEmailMutation, { data, loading, error }] = useResendEsignEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailSubject: // value for 'emailSubject'
 *      emailBody: // value for 'emailBody'
 *      templateId: // value for 'templateId'
 *      aiDraftId: // value for 'aiDraftId'
 *   },
 * });
 */
export function useResendEsignEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendEsignEmailMutation, ResendEsignEmailMutationVariables>) {
        return Apollo.useMutation<ResendEsignEmailMutation, ResendEsignEmailMutationVariables>(ResendEsignEmailDocument, baseOptions);
      }
export type ResendEsignEmailMutationHookResult = ReturnType<typeof useResendEsignEmailMutation>;
export type ResendEsignEmailMutationResult = Apollo.MutationResult<ResendEsignEmailMutation>;
export type ResendEsignEmailMutationOptions = Apollo.BaseMutationOptions<ResendEsignEmailMutation, ResendEsignEmailMutationVariables>;
export const RevealEsignLinkDocument = gql`
    mutation RevealEsignLink($id: ID!) {
  revealContractSigningLink(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
    url
    expiresAt
  }
}
    `;
export type RevealEsignLinkMutationFn = Apollo.MutationFunction<RevealEsignLinkMutation, RevealEsignLinkMutationVariables>;

/**
 * __useRevealEsignLinkMutation__
 *
 * To run a mutation, you first call `useRevealEsignLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevealEsignLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revealEsignLinkMutation, { data, loading, error }] = useRevealEsignLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevealEsignLinkMutation(baseOptions?: Apollo.MutationHookOptions<RevealEsignLinkMutation, RevealEsignLinkMutationVariables>) {
        return Apollo.useMutation<RevealEsignLinkMutation, RevealEsignLinkMutationVariables>(RevealEsignLinkDocument, baseOptions);
      }
export type RevealEsignLinkMutationHookResult = ReturnType<typeof useRevealEsignLinkMutation>;
export type RevealEsignLinkMutationResult = Apollo.MutationResult<RevealEsignLinkMutation>;
export type RevealEsignLinkMutationOptions = Apollo.BaseMutationOptions<RevealEsignLinkMutation, RevealEsignLinkMutationVariables>;
export const CancelEsignContractDocument = gql`
    mutation CancelEsignContract($id: ID!, $reason: String!) {
  cancelContract(id: $id, reason: $reason) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type CancelEsignContractMutationFn = Apollo.MutationFunction<CancelEsignContractMutation, CancelEsignContractMutationVariables>;

/**
 * __useCancelEsignContractMutation__
 *
 * To run a mutation, you first call `useCancelEsignContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEsignContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEsignContractMutation, { data, loading, error }] = useCancelEsignContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelEsignContractMutation(baseOptions?: Apollo.MutationHookOptions<CancelEsignContractMutation, CancelEsignContractMutationVariables>) {
        return Apollo.useMutation<CancelEsignContractMutation, CancelEsignContractMutationVariables>(CancelEsignContractDocument, baseOptions);
      }
export type CancelEsignContractMutationHookResult = ReturnType<typeof useCancelEsignContractMutation>;
export type CancelEsignContractMutationResult = Apollo.MutationResult<CancelEsignContractMutation>;
export type CancelEsignContractMutationOptions = Apollo.BaseMutationOptions<CancelEsignContractMutation, CancelEsignContractMutationVariables>;
export const RetryEsignFulfilmentDocument = gql`
    mutation RetryEsignFulfilment($id: ID!, $existingUserId: ID) {
  retryContractFulfilment(id: $id, existingUserId: $existingUserId) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type RetryEsignFulfilmentMutationFn = Apollo.MutationFunction<RetryEsignFulfilmentMutation, RetryEsignFulfilmentMutationVariables>;

/**
 * __useRetryEsignFulfilmentMutation__
 *
 * To run a mutation, you first call `useRetryEsignFulfilmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryEsignFulfilmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryEsignFulfilmentMutation, { data, loading, error }] = useRetryEsignFulfilmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      existingUserId: // value for 'existingUserId'
 *   },
 * });
 */
export function useRetryEsignFulfilmentMutation(baseOptions?: Apollo.MutationHookOptions<RetryEsignFulfilmentMutation, RetryEsignFulfilmentMutationVariables>) {
        return Apollo.useMutation<RetryEsignFulfilmentMutation, RetryEsignFulfilmentMutationVariables>(RetryEsignFulfilmentDocument, baseOptions);
      }
export type RetryEsignFulfilmentMutationHookResult = ReturnType<typeof useRetryEsignFulfilmentMutation>;
export type RetryEsignFulfilmentMutationResult = Apollo.MutationResult<RetryEsignFulfilmentMutation>;
export type RetryEsignFulfilmentMutationOptions = Apollo.BaseMutationOptions<RetryEsignFulfilmentMutation, RetryEsignFulfilmentMutationVariables>;
export const CreateTeacherFrameworkDocument = gql`
    mutation CreateTeacherFramework($teacherId: ID!, $templateCode: String, $templateId: ID, $courseIds: [ID!]) {
  createTeacherFrameworkDraft(
    teacherId: $teacherId
    templateCode: $templateCode
    templateId: $templateId
    courseIds: $courseIds
  ) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type CreateTeacherFrameworkMutationFn = Apollo.MutationFunction<CreateTeacherFrameworkMutation, CreateTeacherFrameworkMutationVariables>;

/**
 * __useCreateTeacherFrameworkMutation__
 *
 * To run a mutation, you first call `useCreateTeacherFrameworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeacherFrameworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeacherFrameworkMutation, { data, loading, error }] = useCreateTeacherFrameworkMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      templateCode: // value for 'templateCode'
 *      templateId: // value for 'templateId'
 *      courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useCreateTeacherFrameworkMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeacherFrameworkMutation, CreateTeacherFrameworkMutationVariables>) {
        return Apollo.useMutation<CreateTeacherFrameworkMutation, CreateTeacherFrameworkMutationVariables>(CreateTeacherFrameworkDocument, baseOptions);
      }
export type CreateTeacherFrameworkMutationHookResult = ReturnType<typeof useCreateTeacherFrameworkMutation>;
export type CreateTeacherFrameworkMutationResult = Apollo.MutationResult<CreateTeacherFrameworkMutation>;
export type CreateTeacherFrameworkMutationOptions = Apollo.BaseMutationOptions<CreateTeacherFrameworkMutation, CreateTeacherFrameworkMutationVariables>;
export const CreateTeacherAnnexDocument = gql`
    mutation CreateTeacherAnnex($applicationId: ID!, $templateId: ID) {
  createTeacherAnnexDraft(applicationId: $applicationId, templateId: $templateId) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type CreateTeacherAnnexMutationFn = Apollo.MutationFunction<CreateTeacherAnnexMutation, CreateTeacherAnnexMutationVariables>;

/**
 * __useCreateTeacherAnnexMutation__
 *
 * To run a mutation, you first call `useCreateTeacherAnnexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeacherAnnexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeacherAnnexMutation, { data, loading, error }] = useCreateTeacherAnnexMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useCreateTeacherAnnexMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeacherAnnexMutation, CreateTeacherAnnexMutationVariables>) {
        return Apollo.useMutation<CreateTeacherAnnexMutation, CreateTeacherAnnexMutationVariables>(CreateTeacherAnnexDocument, baseOptions);
      }
export type CreateTeacherAnnexMutationHookResult = ReturnType<typeof useCreateTeacherAnnexMutation>;
export type CreateTeacherAnnexMutationResult = Apollo.MutationResult<CreateTeacherAnnexMutation>;
export type CreateTeacherAnnexMutationOptions = Apollo.BaseMutationOptions<CreateTeacherAnnexMutation, CreateTeacherAnnexMutationVariables>;
export const RequestContractReminderDocument = gql`
    mutation RequestContractReminder($contractId: ID!) {
  sendContractReminderNow(contractId: $contractId) {
    success
    customErrors {
      field
      code
      message
    }
    outreach {
      ...EsignOutreachFields
    }
  }
}
    ${EsignOutreachFieldsFragmentDoc}`;
export type RequestContractReminderMutationFn = Apollo.MutationFunction<RequestContractReminderMutation, RequestContractReminderMutationVariables>;

/**
 * __useRequestContractReminderMutation__
 *
 * To run a mutation, you first call `useRequestContractReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestContractReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestContractReminderMutation, { data, loading, error }] = useRequestContractReminderMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useRequestContractReminderMutation(baseOptions?: Apollo.MutationHookOptions<RequestContractReminderMutation, RequestContractReminderMutationVariables>) {
        return Apollo.useMutation<RequestContractReminderMutation, RequestContractReminderMutationVariables>(RequestContractReminderDocument, baseOptions);
      }
export type RequestContractReminderMutationHookResult = ReturnType<typeof useRequestContractReminderMutation>;
export type RequestContractReminderMutationResult = Apollo.MutationResult<RequestContractReminderMutation>;
export type RequestContractReminderMutationOptions = Apollo.BaseMutationOptions<RequestContractReminderMutation, RequestContractReminderMutationVariables>;
export const PauseContractRemindersDocument = gql`
    mutation PauseContractReminders($contractId: ID!) {
  stopContractReminders(contractId: $contractId) {
    success
    customErrors {
      field
      code
      message
    }
    outreach {
      ...EsignOutreachFields
    }
  }
}
    ${EsignOutreachFieldsFragmentDoc}`;
export type PauseContractRemindersMutationFn = Apollo.MutationFunction<PauseContractRemindersMutation, PauseContractRemindersMutationVariables>;

/**
 * __usePauseContractRemindersMutation__
 *
 * To run a mutation, you first call `usePauseContractRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseContractRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseContractRemindersMutation, { data, loading, error }] = usePauseContractRemindersMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function usePauseContractRemindersMutation(baseOptions?: Apollo.MutationHookOptions<PauseContractRemindersMutation, PauseContractRemindersMutationVariables>) {
        return Apollo.useMutation<PauseContractRemindersMutation, PauseContractRemindersMutationVariables>(PauseContractRemindersDocument, baseOptions);
      }
export type PauseContractRemindersMutationHookResult = ReturnType<typeof usePauseContractRemindersMutation>;
export type PauseContractRemindersMutationResult = Apollo.MutationResult<PauseContractRemindersMutation>;
export type PauseContractRemindersMutationOptions = Apollo.BaseMutationOptions<PauseContractRemindersMutation, PauseContractRemindersMutationVariables>;
export const ContinueContractRemindersDocument = gql`
    mutation ContinueContractReminders($contractId: ID!) {
  resumeContractReminders(contractId: $contractId) {
    success
    customErrors {
      field
      code
      message
    }
    outreach {
      ...EsignOutreachFields
    }
  }
}
    ${EsignOutreachFieldsFragmentDoc}`;
export type ContinueContractRemindersMutationFn = Apollo.MutationFunction<ContinueContractRemindersMutation, ContinueContractRemindersMutationVariables>;

/**
 * __useContinueContractRemindersMutation__
 *
 * To run a mutation, you first call `useContinueContractRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueContractRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueContractRemindersMutation, { data, loading, error }] = useContinueContractRemindersMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContinueContractRemindersMutation(baseOptions?: Apollo.MutationHookOptions<ContinueContractRemindersMutation, ContinueContractRemindersMutationVariables>) {
        return Apollo.useMutation<ContinueContractRemindersMutation, ContinueContractRemindersMutationVariables>(ContinueContractRemindersDocument, baseOptions);
      }
export type ContinueContractRemindersMutationHookResult = ReturnType<typeof useContinueContractRemindersMutation>;
export type ContinueContractRemindersMutationResult = Apollo.MutationResult<ContinueContractRemindersMutation>;
export type ContinueContractRemindersMutationOptions = Apollo.BaseMutationOptions<ContinueContractRemindersMutation, ContinueContractRemindersMutationVariables>;
export const ReassignEsignSellerDocument = gql`
    mutation ReassignEsignSeller($id: ID!, $sellerId: ID!, $reason: String!) {
  reassignContractSeller(id: $id, sellerId: $sellerId, reason: $reason) {
    success
    customErrors {
      field
      code
      message
    }
    contract {
      ...EsignContractCardFields
    }
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;
export type ReassignEsignSellerMutationFn = Apollo.MutationFunction<ReassignEsignSellerMutation, ReassignEsignSellerMutationVariables>;

/**
 * __useReassignEsignSellerMutation__
 *
 * To run a mutation, you first call `useReassignEsignSellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignEsignSellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignEsignSellerMutation, { data, loading, error }] = useReassignEsignSellerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sellerId: // value for 'sellerId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useReassignEsignSellerMutation(baseOptions?: Apollo.MutationHookOptions<ReassignEsignSellerMutation, ReassignEsignSellerMutationVariables>) {
        return Apollo.useMutation<ReassignEsignSellerMutation, ReassignEsignSellerMutationVariables>(ReassignEsignSellerDocument, baseOptions);
      }
export type ReassignEsignSellerMutationHookResult = ReturnType<typeof useReassignEsignSellerMutation>;
export type ReassignEsignSellerMutationResult = Apollo.MutationResult<ReassignEsignSellerMutation>;
export type ReassignEsignSellerMutationOptions = Apollo.BaseMutationOptions<ReassignEsignSellerMutation, ReassignEsignSellerMutationVariables>;
export const RevealEsignShortLinkDocument = gql`
    mutation RevealEsignShortLink($contractId: ID!) {
  revealContractShortLink(contractId: $contractId) {
    success
    customErrors {
      field
      code
      message
    }
    url
    expiresAt
  }
}
    `;
export type RevealEsignShortLinkMutationFn = Apollo.MutationFunction<RevealEsignShortLinkMutation, RevealEsignShortLinkMutationVariables>;

/**
 * __useRevealEsignShortLinkMutation__
 *
 * To run a mutation, you first call `useRevealEsignShortLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevealEsignShortLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revealEsignShortLinkMutation, { data, loading, error }] = useRevealEsignShortLinkMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useRevealEsignShortLinkMutation(baseOptions?: Apollo.MutationHookOptions<RevealEsignShortLinkMutation, RevealEsignShortLinkMutationVariables>) {
        return Apollo.useMutation<RevealEsignShortLinkMutation, RevealEsignShortLinkMutationVariables>(RevealEsignShortLinkDocument, baseOptions);
      }
export type RevealEsignShortLinkMutationHookResult = ReturnType<typeof useRevealEsignShortLinkMutation>;
export type RevealEsignShortLinkMutationResult = Apollo.MutationResult<RevealEsignShortLinkMutation>;
export type RevealEsignShortLinkMutationOptions = Apollo.BaseMutationOptions<RevealEsignShortLinkMutation, RevealEsignShortLinkMutationVariables>;
export const WriteContractEmailDocument = gql`
    mutation WriteContractEmail($contractId: ID!, $mailboxEmail: String!, $subject: String!, $text: String, $html: String, $attachmentIds: [ID], $templateId: ID, $aiDraftId: ID) {
  sendContractEmail(
    contractId: $contractId
    mailboxEmail: $mailboxEmail
    subject: $subject
    text: $text
    html: $html
    attachmentIds: $attachmentIds
    templateId: $templateId
    aiDraftId: $aiDraftId
  ) {
    success
    customErrors {
      field
      code
      message
    }
    conversationId
  }
}
    `;
export type WriteContractEmailMutationFn = Apollo.MutationFunction<WriteContractEmailMutation, WriteContractEmailMutationVariables>;

/**
 * __useWriteContractEmailMutation__
 *
 * To run a mutation, you first call `useWriteContractEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteContractEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeContractEmailMutation, { data, loading, error }] = useWriteContractEmailMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      mailboxEmail: // value for 'mailboxEmail'
 *      subject: // value for 'subject'
 *      text: // value for 'text'
 *      html: // value for 'html'
 *      attachmentIds: // value for 'attachmentIds'
 *      templateId: // value for 'templateId'
 *      aiDraftId: // value for 'aiDraftId'
 *   },
 * });
 */
export function useWriteContractEmailMutation(baseOptions?: Apollo.MutationHookOptions<WriteContractEmailMutation, WriteContractEmailMutationVariables>) {
        return Apollo.useMutation<WriteContractEmailMutation, WriteContractEmailMutationVariables>(WriteContractEmailDocument, baseOptions);
      }
export type WriteContractEmailMutationHookResult = ReturnType<typeof useWriteContractEmailMutation>;
export type WriteContractEmailMutationResult = Apollo.MutationResult<WriteContractEmailMutation>;
export type WriteContractEmailMutationOptions = Apollo.BaseMutationOptions<WriteContractEmailMutation, WriteContractEmailMutationVariables>;
export const SendContractSmsTextDocument = gql`
    mutation SendContractSmsText($contractId: ID!, $text: String!, $templateId: ID) {
  sendContractSms(contractId: $contractId, text: $text, templateId: $templateId) {
    success
    customErrors {
      field
      code
      message
    }
    outreach {
      ...EsignOutreachFields
    }
  }
}
    ${EsignOutreachFieldsFragmentDoc}`;
export type SendContractSmsTextMutationFn = Apollo.MutationFunction<SendContractSmsTextMutation, SendContractSmsTextMutationVariables>;

/**
 * __useSendContractSmsTextMutation__
 *
 * To run a mutation, you first call `useSendContractSmsTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContractSmsTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContractSmsTextMutation, { data, loading, error }] = useSendContractSmsTextMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      text: // value for 'text'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useSendContractSmsTextMutation(baseOptions?: Apollo.MutationHookOptions<SendContractSmsTextMutation, SendContractSmsTextMutationVariables>) {
        return Apollo.useMutation<SendContractSmsTextMutation, SendContractSmsTextMutationVariables>(SendContractSmsTextDocument, baseOptions);
      }
export type SendContractSmsTextMutationHookResult = ReturnType<typeof useSendContractSmsTextMutation>;
export type SendContractSmsTextMutationResult = Apollo.MutationResult<SendContractSmsTextMutation>;
export type SendContractSmsTextMutationOptions = Apollo.BaseMutationOptions<SendContractSmsTextMutation, SendContractSmsTextMutationVariables>;
export const SendContractsSmsBulkDocument = gql`
    mutation SendContractsSmsBulk($contractIds: [ID!]!, $text: String!, $templateId: ID, $requestKey: String!) {
  sendContractsSms(
    contractIds: $contractIds
    text: $text
    templateId: $templateId
    requestKey: $requestKey
  ) {
    success
    sent
    skipped
    customErrors {
      field
      code
      message
    }
    rows {
      contractId
      number
      signerName
      ok
      code
      message
      segments
    }
  }
}
    `;
export type SendContractsSmsBulkMutationFn = Apollo.MutationFunction<SendContractsSmsBulkMutation, SendContractsSmsBulkMutationVariables>;

/**
 * __useSendContractsSmsBulkMutation__
 *
 * To run a mutation, you first call `useSendContractsSmsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContractsSmsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContractsSmsBulkMutation, { data, loading, error }] = useSendContractsSmsBulkMutation({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *      text: // value for 'text'
 *      templateId: // value for 'templateId'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useSendContractsSmsBulkMutation(baseOptions?: Apollo.MutationHookOptions<SendContractsSmsBulkMutation, SendContractsSmsBulkMutationVariables>) {
        return Apollo.useMutation<SendContractsSmsBulkMutation, SendContractsSmsBulkMutationVariables>(SendContractsSmsBulkDocument, baseOptions);
      }
export type SendContractsSmsBulkMutationHookResult = ReturnType<typeof useSendContractsSmsBulkMutation>;
export type SendContractsSmsBulkMutationResult = Apollo.MutationResult<SendContractsSmsBulkMutation>;
export type SendContractsSmsBulkMutationOptions = Apollo.BaseMutationOptions<SendContractsSmsBulkMutation, SendContractsSmsBulkMutationVariables>;
export const SaveContractMessageTemplateDocument = gql`
    mutation SaveContractMessageTemplate($id: ID, $channel: String!, $name: String!, $namePl: String, $subject: String, $body: String!, $isActive: Boolean, $topic: String, $personal: Boolean) {
  saveMessageTemplate(
    id: $id
    channel: $channel
    name: $name
    namePl: $namePl
    subject: $subject
    body: $body
    isActive: $isActive
    topic: $topic
    personal: $personal
  ) {
    success
    customErrors {
      field
      code
      message
    }
    template {
      ...EsignMessageTemplateFields
    }
  }
}
    ${EsignMessageTemplateFieldsFragmentDoc}`;
export type SaveContractMessageTemplateMutationFn = Apollo.MutationFunction<SaveContractMessageTemplateMutation, SaveContractMessageTemplateMutationVariables>;

/**
 * __useSaveContractMessageTemplateMutation__
 *
 * To run a mutation, you first call `useSaveContractMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContractMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContractMessageTemplateMutation, { data, loading, error }] = useSaveContractMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *      name: // value for 'name'
 *      namePl: // value for 'namePl'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      isActive: // value for 'isActive'
 *      topic: // value for 'topic'
 *      personal: // value for 'personal'
 *   },
 * });
 */
export function useSaveContractMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveContractMessageTemplateMutation, SaveContractMessageTemplateMutationVariables>) {
        return Apollo.useMutation<SaveContractMessageTemplateMutation, SaveContractMessageTemplateMutationVariables>(SaveContractMessageTemplateDocument, baseOptions);
      }
export type SaveContractMessageTemplateMutationHookResult = ReturnType<typeof useSaveContractMessageTemplateMutation>;
export type SaveContractMessageTemplateMutationResult = Apollo.MutationResult<SaveContractMessageTemplateMutation>;
export type SaveContractMessageTemplateMutationOptions = Apollo.BaseMutationOptions<SaveContractMessageTemplateMutation, SaveContractMessageTemplateMutationVariables>;
export const DeleteContractMessageTemplateDocument = gql`
    mutation DeleteContractMessageTemplate($id: ID!) {
  deleteMessageTemplate(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
    deletedId
  }
}
    `;
export type DeleteContractMessageTemplateMutationFn = Apollo.MutationFunction<DeleteContractMessageTemplateMutation, DeleteContractMessageTemplateMutationVariables>;

/**
 * __useDeleteContractMessageTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteContractMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractMessageTemplateMutation, { data, loading, error }] = useDeleteContractMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractMessageTemplateMutation, DeleteContractMessageTemplateMutationVariables>) {
        return Apollo.useMutation<DeleteContractMessageTemplateMutation, DeleteContractMessageTemplateMutationVariables>(DeleteContractMessageTemplateDocument, baseOptions);
      }
export type DeleteContractMessageTemplateMutationHookResult = ReturnType<typeof useDeleteContractMessageTemplateMutation>;
export type DeleteContractMessageTemplateMutationResult = Apollo.MutationResult<DeleteContractMessageTemplateMutation>;
export type DeleteContractMessageTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteContractMessageTemplateMutation, DeleteContractMessageTemplateMutationVariables>;
export const StoreContractTemplateVersionDocument = gql`
    mutation StoreContractTemplateVersion($id: ID!, $html: String!, $tokens: JSONString, $comment: String) {
  saveContractTemplateVersion(
    id: $id
    html: $html
    tokens: $tokens
    comment: $comment
  ) {
    success
    customErrors {
      field
      code
      message
    }
    problems {
      code
      message
      token
    }
    rerenderedDrafts
    template {
      ...EsignContractTemplateFields
    }
  }
}
    ${EsignContractTemplateFieldsFragmentDoc}`;
export type StoreContractTemplateVersionMutationFn = Apollo.MutationFunction<StoreContractTemplateVersionMutation, StoreContractTemplateVersionMutationVariables>;

/**
 * __useStoreContractTemplateVersionMutation__
 *
 * To run a mutation, you first call `useStoreContractTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreContractTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeContractTemplateVersionMutation, { data, loading, error }] = useStoreContractTemplateVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      html: // value for 'html'
 *      tokens: // value for 'tokens'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useStoreContractTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<StoreContractTemplateVersionMutation, StoreContractTemplateVersionMutationVariables>) {
        return Apollo.useMutation<StoreContractTemplateVersionMutation, StoreContractTemplateVersionMutationVariables>(StoreContractTemplateVersionDocument, baseOptions);
      }
export type StoreContractTemplateVersionMutationHookResult = ReturnType<typeof useStoreContractTemplateVersionMutation>;
export type StoreContractTemplateVersionMutationResult = Apollo.MutationResult<StoreContractTemplateVersionMutation>;
export type StoreContractTemplateVersionMutationOptions = Apollo.BaseMutationOptions<StoreContractTemplateVersionMutation, StoreContractTemplateVersionMutationVariables>;
export const CopyContractTemplateDocument = gql`
    mutation CopyContractTemplate($basedOnId: ID!, $name: String!, $code: String, $legalEntityId: ID, $appendix: String) {
  createContractTemplate(
    basedOnId: $basedOnId
    name: $name
    code: $code
    legalEntityId: $legalEntityId
    appendix: $appendix
  ) {
    success
    customErrors {
      field
      code
      message
    }
    problems {
      code
      message
      token
    }
    template {
      ...EsignContractTemplateFields
    }
  }
}
    ${EsignContractTemplateFieldsFragmentDoc}`;
export type CopyContractTemplateMutationFn = Apollo.MutationFunction<CopyContractTemplateMutation, CopyContractTemplateMutationVariables>;

/**
 * __useCopyContractTemplateMutation__
 *
 * To run a mutation, you first call `useCopyContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyContractTemplateMutation, { data, loading, error }] = useCopyContractTemplateMutation({
 *   variables: {
 *      basedOnId: // value for 'basedOnId'
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      legalEntityId: // value for 'legalEntityId'
 *      appendix: // value for 'appendix'
 *   },
 * });
 */
export function useCopyContractTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CopyContractTemplateMutation, CopyContractTemplateMutationVariables>) {
        return Apollo.useMutation<CopyContractTemplateMutation, CopyContractTemplateMutationVariables>(CopyContractTemplateDocument, baseOptions);
      }
export type CopyContractTemplateMutationHookResult = ReturnType<typeof useCopyContractTemplateMutation>;
export type CopyContractTemplateMutationResult = Apollo.MutationResult<CopyContractTemplateMutation>;
export type CopyContractTemplateMutationOptions = Apollo.BaseMutationOptions<CopyContractTemplateMutation, CopyContractTemplateMutationVariables>;
export const SwitchContractTemplateVersionDocument = gql`
    mutation SwitchContractTemplateVersion($id: ID!) {
  activateContractTemplateVersion(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
    problems {
      code
      message
      token
    }
    rerenderedDrafts
    template {
      ...EsignContractTemplateFields
    }
  }
}
    ${EsignContractTemplateFieldsFragmentDoc}`;
export type SwitchContractTemplateVersionMutationFn = Apollo.MutationFunction<SwitchContractTemplateVersionMutation, SwitchContractTemplateVersionMutationVariables>;

/**
 * __useSwitchContractTemplateVersionMutation__
 *
 * To run a mutation, you first call `useSwitchContractTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchContractTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchContractTemplateVersionMutation, { data, loading, error }] = useSwitchContractTemplateVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSwitchContractTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<SwitchContractTemplateVersionMutation, SwitchContractTemplateVersionMutationVariables>) {
        return Apollo.useMutation<SwitchContractTemplateVersionMutation, SwitchContractTemplateVersionMutationVariables>(SwitchContractTemplateVersionDocument, baseOptions);
      }
export type SwitchContractTemplateVersionMutationHookResult = ReturnType<typeof useSwitchContractTemplateVersionMutation>;
export type SwitchContractTemplateVersionMutationResult = Apollo.MutationResult<SwitchContractTemplateVersionMutation>;
export type SwitchContractTemplateVersionMutationOptions = Apollo.BaseMutationOptions<SwitchContractTemplateVersionMutation, SwitchContractTemplateVersionMutationVariables>;
export const ToggleContractTemplateCodeDocument = gql`
    mutation ToggleContractTemplateCode($code: String!, $active: Boolean!) {
  setContractTemplateActive(code: $code, active: $active) {
    success
    customErrors {
      field
      code
      message
    }
    problems {
      code
      message
      token
    }
    template {
      ...EsignContractTemplateFields
    }
  }
}
    ${EsignContractTemplateFieldsFragmentDoc}`;
export type ToggleContractTemplateCodeMutationFn = Apollo.MutationFunction<ToggleContractTemplateCodeMutation, ToggleContractTemplateCodeMutationVariables>;

/**
 * __useToggleContractTemplateCodeMutation__
 *
 * To run a mutation, you first call `useToggleContractTemplateCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleContractTemplateCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleContractTemplateCodeMutation, { data, loading, error }] = useToggleContractTemplateCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useToggleContractTemplateCodeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleContractTemplateCodeMutation, ToggleContractTemplateCodeMutationVariables>) {
        return Apollo.useMutation<ToggleContractTemplateCodeMutation, ToggleContractTemplateCodeMutationVariables>(ToggleContractTemplateCodeDocument, baseOptions);
      }
export type ToggleContractTemplateCodeMutationHookResult = ReturnType<typeof useToggleContractTemplateCodeMutation>;
export type ToggleContractTemplateCodeMutationResult = Apollo.MutationResult<ToggleContractTemplateCodeMutation>;
export type ToggleContractTemplateCodeMutationOptions = Apollo.BaseMutationOptions<ToggleContractTemplateCodeMutation, ToggleContractTemplateCodeMutationVariables>;
export const DraftContractEmailDocument = gql`
    mutation DraftContractEmail($contractId: ID!, $kind: String!, $hint: String, $regenerate: Boolean, $requestKey: String) {
  draftContractEmail(
    contractId: $contractId
    kind: $kind
    hint: $hint
    regenerate: $regenerate
    requestKey: $requestKey
  ) {
    success
    customErrors {
      field
      code
      message
    }
    draft {
      id
      kind
      subject
      html
      text
      cached
      contractId
      createdAt
    }
  }
}
    `;
export type DraftContractEmailMutationFn = Apollo.MutationFunction<DraftContractEmailMutation, DraftContractEmailMutationVariables>;

/**
 * __useDraftContractEmailMutation__
 *
 * To run a mutation, you first call `useDraftContractEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftContractEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftContractEmailMutation, { data, loading, error }] = useDraftContractEmailMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      kind: // value for 'kind'
 *      hint: // value for 'hint'
 *      regenerate: // value for 'regenerate'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useDraftContractEmailMutation(baseOptions?: Apollo.MutationHookOptions<DraftContractEmailMutation, DraftContractEmailMutationVariables>) {
        return Apollo.useMutation<DraftContractEmailMutation, DraftContractEmailMutationVariables>(DraftContractEmailDocument, baseOptions);
      }
export type DraftContractEmailMutationHookResult = ReturnType<typeof useDraftContractEmailMutation>;
export type DraftContractEmailMutationResult = Apollo.MutationResult<DraftContractEmailMutation>;
export type DraftContractEmailMutationOptions = Apollo.BaseMutationOptions<DraftContractEmailMutation, DraftContractEmailMutationVariables>;
export const RunFakturowniaSyncDocument = gql`
    mutation RunFakturowniaSync($period: String) {
  triggerFakturowniaSync(period: $period) {
    enqueued
    message
    lastRun {
      startedAt
      finishedAt
      status
    }
  }
}
    `;
export type RunFakturowniaSyncMutationFn = Apollo.MutationFunction<RunFakturowniaSyncMutation, RunFakturowniaSyncMutationVariables>;

/**
 * __useRunFakturowniaSyncMutation__
 *
 * To run a mutation, you first call `useRunFakturowniaSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunFakturowniaSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runFakturowniaSyncMutation, { data, loading, error }] = useRunFakturowniaSyncMutation({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useRunFakturowniaSyncMutation(baseOptions?: Apollo.MutationHookOptions<RunFakturowniaSyncMutation, RunFakturowniaSyncMutationVariables>) {
        return Apollo.useMutation<RunFakturowniaSyncMutation, RunFakturowniaSyncMutationVariables>(RunFakturowniaSyncDocument, baseOptions);
      }
export type RunFakturowniaSyncMutationHookResult = ReturnType<typeof useRunFakturowniaSyncMutation>;
export type RunFakturowniaSyncMutationResult = Apollo.MutationResult<RunFakturowniaSyncMutation>;
export type RunFakturowniaSyncMutationOptions = Apollo.BaseMutationOptions<RunFakturowniaSyncMutation, RunFakturowniaSyncMutationVariables>;
export const RunFakturowniaGroupSyncDocument = gql`
    mutation RunFakturowniaGroupSync($groupId: ID!, $period: String) {
  triggerFakturowniaGroupSync(groupId: $groupId, period: $period) {
    enqueued
    message
    emailsTargeted
    lastRun {
      startedAt
      finishedAt
      status
    }
  }
}
    `;
export type RunFakturowniaGroupSyncMutationFn = Apollo.MutationFunction<RunFakturowniaGroupSyncMutation, RunFakturowniaGroupSyncMutationVariables>;

/**
 * __useRunFakturowniaGroupSyncMutation__
 *
 * To run a mutation, you first call `useRunFakturowniaGroupSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunFakturowniaGroupSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runFakturowniaGroupSyncMutation, { data, loading, error }] = useRunFakturowniaGroupSyncMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useRunFakturowniaGroupSyncMutation(baseOptions?: Apollo.MutationHookOptions<RunFakturowniaGroupSyncMutation, RunFakturowniaGroupSyncMutationVariables>) {
        return Apollo.useMutation<RunFakturowniaGroupSyncMutation, RunFakturowniaGroupSyncMutationVariables>(RunFakturowniaGroupSyncDocument, baseOptions);
      }
export type RunFakturowniaGroupSyncMutationHookResult = ReturnType<typeof useRunFakturowniaGroupSyncMutation>;
export type RunFakturowniaGroupSyncMutationResult = Apollo.MutationResult<RunFakturowniaGroupSyncMutation>;
export type RunFakturowniaGroupSyncMutationOptions = Apollo.BaseMutationOptions<RunFakturowniaGroupSyncMutation, RunFakturowniaGroupSyncMutationVariables>;
export const MatchFakturowniaInvoiceDocument = gql`
    mutation MatchFakturowniaInvoice($invoiceId: ID!, $studentId: ID!, $groupId: ID) {
  matchFakturowniaInvoice(
    invoiceId: $invoiceId
    studentId: $studentId
    groupId: $groupId
  ) {
    success
    errors
    invoice {
      id
      matchStatus
      groupMatchSource
      linkedAt
      isCorrection
      isAdvance
      isFinal
      isEstimate
      isQuotation
      linkedStudent {
        id
        user {
          id
          email
          firstName
          lastName
        }
      }
      linkedGroup {
        id
        name
      }
    }
  }
}
    `;
export type MatchFakturowniaInvoiceMutationFn = Apollo.MutationFunction<MatchFakturowniaInvoiceMutation, MatchFakturowniaInvoiceMutationVariables>;

/**
 * __useMatchFakturowniaInvoiceMutation__
 *
 * To run a mutation, you first call `useMatchFakturowniaInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchFakturowniaInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchFakturowniaInvoiceMutation, { data, loading, error }] = useMatchFakturowniaInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      studentId: // value for 'studentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useMatchFakturowniaInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<MatchFakturowniaInvoiceMutation, MatchFakturowniaInvoiceMutationVariables>) {
        return Apollo.useMutation<MatchFakturowniaInvoiceMutation, MatchFakturowniaInvoiceMutationVariables>(MatchFakturowniaInvoiceDocument, baseOptions);
      }
export type MatchFakturowniaInvoiceMutationHookResult = ReturnType<typeof useMatchFakturowniaInvoiceMutation>;
export type MatchFakturowniaInvoiceMutationResult = Apollo.MutationResult<MatchFakturowniaInvoiceMutation>;
export type MatchFakturowniaInvoiceMutationOptions = Apollo.BaseMutationOptions<MatchFakturowniaInvoiceMutation, MatchFakturowniaInvoiceMutationVariables>;
export const SetFakturowniaInvoiceGroupDocument = gql`
    mutation SetFakturowniaInvoiceGroup($invoiceId: ID!, $groupId: ID) {
  setFakturowniaInvoiceGroup(invoiceId: $invoiceId, groupId: $groupId) {
    success
    errors
    invoice {
      id
      groupMatchSource
      isCorrection
      isAdvance
      isFinal
      isEstimate
      isQuotation
      linkedGroup {
        id
        name
      }
    }
  }
}
    `;
export type SetFakturowniaInvoiceGroupMutationFn = Apollo.MutationFunction<SetFakturowniaInvoiceGroupMutation, SetFakturowniaInvoiceGroupMutationVariables>;

/**
 * __useSetFakturowniaInvoiceGroupMutation__
 *
 * To run a mutation, you first call `useSetFakturowniaInvoiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFakturowniaInvoiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFakturowniaInvoiceGroupMutation, { data, loading, error }] = useSetFakturowniaInvoiceGroupMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetFakturowniaInvoiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<SetFakturowniaInvoiceGroupMutation, SetFakturowniaInvoiceGroupMutationVariables>) {
        return Apollo.useMutation<SetFakturowniaInvoiceGroupMutation, SetFakturowniaInvoiceGroupMutationVariables>(SetFakturowniaInvoiceGroupDocument, baseOptions);
      }
export type SetFakturowniaInvoiceGroupMutationHookResult = ReturnType<typeof useSetFakturowniaInvoiceGroupMutation>;
export type SetFakturowniaInvoiceGroupMutationResult = Apollo.MutationResult<SetFakturowniaInvoiceGroupMutation>;
export type SetFakturowniaInvoiceGroupMutationOptions = Apollo.BaseMutationOptions<SetFakturowniaInvoiceGroupMutation, SetFakturowniaInvoiceGroupMutationVariables>;
export const UnlinkFakturowniaInvoiceDocument = gql`
    mutation UnlinkFakturowniaInvoice($invoiceId: ID!) {
  unlinkFakturowniaInvoice(invoiceId: $invoiceId) {
    success
    errors
    invoice {
      id
      matchStatus
      payment {
        id
      }
      agreement {
        id
      }
    }
  }
}
    `;
export type UnlinkFakturowniaInvoiceMutationFn = Apollo.MutationFunction<UnlinkFakturowniaInvoiceMutation, UnlinkFakturowniaInvoiceMutationVariables>;

/**
 * __useUnlinkFakturowniaInvoiceMutation__
 *
 * To run a mutation, you first call `useUnlinkFakturowniaInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkFakturowniaInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkFakturowniaInvoiceMutation, { data, loading, error }] = useUnlinkFakturowniaInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useUnlinkFakturowniaInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkFakturowniaInvoiceMutation, UnlinkFakturowniaInvoiceMutationVariables>) {
        return Apollo.useMutation<UnlinkFakturowniaInvoiceMutation, UnlinkFakturowniaInvoiceMutationVariables>(UnlinkFakturowniaInvoiceDocument, baseOptions);
      }
export type UnlinkFakturowniaInvoiceMutationHookResult = ReturnType<typeof useUnlinkFakturowniaInvoiceMutation>;
export type UnlinkFakturowniaInvoiceMutationResult = Apollo.MutationResult<UnlinkFakturowniaInvoiceMutation>;
export type UnlinkFakturowniaInvoiceMutationOptions = Apollo.BaseMutationOptions<UnlinkFakturowniaInvoiceMutation, UnlinkFakturowniaInvoiceMutationVariables>;
export const PinInvoiceToContributionDocument = gql`
    mutation PinInvoiceToContribution($invoiceId: ID!, $contributionId: ID!) {
  linkInvoiceToContribution(
    invoiceId: $invoiceId
    contributionId: $contributionId
  ) {
    success
    errors
    errorCode
    invoice {
      id
      contributionMatchSource
      provisionBlockedReason
      contribution {
        id
        date
        amountForeign
        status
        coveredAmount
        debt
        paidManually
      }
      payment {
        id
      }
    }
  }
}
    `;
export type PinInvoiceToContributionMutationFn = Apollo.MutationFunction<PinInvoiceToContributionMutation, PinInvoiceToContributionMutationVariables>;

/**
 * __usePinInvoiceToContributionMutation__
 *
 * To run a mutation, you first call `usePinInvoiceToContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinInvoiceToContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinInvoiceToContributionMutation, { data, loading, error }] = usePinInvoiceToContributionMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      contributionId: // value for 'contributionId'
 *   },
 * });
 */
export function usePinInvoiceToContributionMutation(baseOptions?: Apollo.MutationHookOptions<PinInvoiceToContributionMutation, PinInvoiceToContributionMutationVariables>) {
        return Apollo.useMutation<PinInvoiceToContributionMutation, PinInvoiceToContributionMutationVariables>(PinInvoiceToContributionDocument, baseOptions);
      }
export type PinInvoiceToContributionMutationHookResult = ReturnType<typeof usePinInvoiceToContributionMutation>;
export type PinInvoiceToContributionMutationResult = Apollo.MutationResult<PinInvoiceToContributionMutation>;
export type PinInvoiceToContributionMutationOptions = Apollo.BaseMutationOptions<PinInvoiceToContributionMutation, PinInvoiceToContributionMutationVariables>;
export const UnpinInvoiceFromContributionDocument = gql`
    mutation UnpinInvoiceFromContribution($invoiceId: ID!) {
  unlinkInvoiceFromContribution(invoiceId: $invoiceId) {
    success
    errors
    invoice {
      id
      contributionMatchSource
      provisionBlockedReason
      contribution {
        id
      }
    }
  }
}
    `;
export type UnpinInvoiceFromContributionMutationFn = Apollo.MutationFunction<UnpinInvoiceFromContributionMutation, UnpinInvoiceFromContributionMutationVariables>;

/**
 * __useUnpinInvoiceFromContributionMutation__
 *
 * To run a mutation, you first call `useUnpinInvoiceFromContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinInvoiceFromContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinInvoiceFromContributionMutation, { data, loading, error }] = useUnpinInvoiceFromContributionMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useUnpinInvoiceFromContributionMutation(baseOptions?: Apollo.MutationHookOptions<UnpinInvoiceFromContributionMutation, UnpinInvoiceFromContributionMutationVariables>) {
        return Apollo.useMutation<UnpinInvoiceFromContributionMutation, UnpinInvoiceFromContributionMutationVariables>(UnpinInvoiceFromContributionDocument, baseOptions);
      }
export type UnpinInvoiceFromContributionMutationHookResult = ReturnType<typeof useUnpinInvoiceFromContributionMutation>;
export type UnpinInvoiceFromContributionMutationResult = Apollo.MutationResult<UnpinInvoiceFromContributionMutation>;
export type UnpinInvoiceFromContributionMutationOptions = Apollo.BaseMutationOptions<UnpinInvoiceFromContributionMutation, UnpinInvoiceFromContributionMutationVariables>;
export const RerunFakturowniaMatcherDocument = gql`
    mutation RerunFakturowniaMatcher($invoiceId: ID!) {
  rerunFakturowniaMatcher(invoiceId: $invoiceId) {
    success
    errors
    invoice {
      id
      matchStatus
      groupMatchSource
      isCorrection
      isAdvance
      isFinal
      isEstimate
      isQuotation
      linkedStudent {
        id
        user {
          id
          email
        }
      }
      linkedGroup {
        id
        name
      }
    }
  }
}
    `;
export type RerunFakturowniaMatcherMutationFn = Apollo.MutationFunction<RerunFakturowniaMatcherMutation, RerunFakturowniaMatcherMutationVariables>;

/**
 * __useRerunFakturowniaMatcherMutation__
 *
 * To run a mutation, you first call `useRerunFakturowniaMatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunFakturowniaMatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunFakturowniaMatcherMutation, { data, loading, error }] = useRerunFakturowniaMatcherMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useRerunFakturowniaMatcherMutation(baseOptions?: Apollo.MutationHookOptions<RerunFakturowniaMatcherMutation, RerunFakturowniaMatcherMutationVariables>) {
        return Apollo.useMutation<RerunFakturowniaMatcherMutation, RerunFakturowniaMatcherMutationVariables>(RerunFakturowniaMatcherDocument, baseOptions);
      }
export type RerunFakturowniaMatcherMutationHookResult = ReturnType<typeof useRerunFakturowniaMatcherMutation>;
export type RerunFakturowniaMatcherMutationResult = Apollo.MutationResult<RerunFakturowniaMatcherMutation>;
export type RerunFakturowniaMatcherMutationOptions = Apollo.BaseMutationOptions<RerunFakturowniaMatcherMutation, RerunFakturowniaMatcherMutationVariables>;
export const CreateExpenseDocument = gql`
    mutation CreateExpense($input: ExpenseInput!) {
  createExpense(input: $input) {
    success
    errors
    expense {
      id
      pk
      date
      amount
      amountPln
      currency
      recurrence
      recurrenceDay
      recurrenceUntil
      status
    }
  }
}
    `;
export type CreateExpenseMutationFn = Apollo.MutationFunction<CreateExpenseMutation, CreateExpenseMutationVariables>;

/**
 * __useCreateExpenseMutation__
 *
 * To run a mutation, you first call `useCreateExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpenseMutation, { data, loading, error }] = useCreateExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpenseMutation, CreateExpenseMutationVariables>) {
        return Apollo.useMutation<CreateExpenseMutation, CreateExpenseMutationVariables>(CreateExpenseDocument, baseOptions);
      }
export type CreateExpenseMutationHookResult = ReturnType<typeof useCreateExpenseMutation>;
export type CreateExpenseMutationResult = Apollo.MutationResult<CreateExpenseMutation>;
export type CreateExpenseMutationOptions = Apollo.BaseMutationOptions<CreateExpenseMutation, CreateExpenseMutationVariables>;
export const UpdateExpenseDocument = gql`
    mutation UpdateExpense($input: UpdateExpenseInput!) {
  updateExpense(input: $input) {
    success
    errors
    expense {
      id
      pk
      amount
      amountPln
      currency
      notes
      documentUrl
      paidAt
      description
      counterpartyName
      counterpartyTaxNo
      recurrence
      recurrenceDay
      recurrenceUntil
      status
      category {
        id
        slug
        name
      }
      relatedTeacher {
        id
      }
      relatedGroup {
        id
        name
      }
      relatedFakturowniaInvoice {
        id
        pk
        number
      }
    }
  }
}
    `;
export type UpdateExpenseMutationFn = Apollo.MutationFunction<UpdateExpenseMutation, UpdateExpenseMutationVariables>;

/**
 * __useUpdateExpenseMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseMutation, { data, loading, error }] = useUpdateExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpenseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables>) {
        return Apollo.useMutation<UpdateExpenseMutation, UpdateExpenseMutationVariables>(UpdateExpenseDocument, baseOptions);
      }
export type UpdateExpenseMutationHookResult = ReturnType<typeof useUpdateExpenseMutation>;
export type UpdateExpenseMutationResult = Apollo.MutationResult<UpdateExpenseMutation>;
export type UpdateExpenseMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables>;
export const SetExpenseStatusDocument = gql`
    mutation SetExpenseStatus($id: ID!, $status: String!, $paidAt: Date) {
  setExpenseStatus(id: $id, status: $status, paidAt: $paidAt) {
    success
    errors
    expense {
      id
      pk
      status
      paidAt
    }
  }
}
    `;
export type SetExpenseStatusMutationFn = Apollo.MutationFunction<SetExpenseStatusMutation, SetExpenseStatusMutationVariables>;

/**
 * __useSetExpenseStatusMutation__
 *
 * To run a mutation, you first call `useSetExpenseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExpenseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExpenseStatusMutation, { data, loading, error }] = useSetExpenseStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      paidAt: // value for 'paidAt'
 *   },
 * });
 */
export function useSetExpenseStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetExpenseStatusMutation, SetExpenseStatusMutationVariables>) {
        return Apollo.useMutation<SetExpenseStatusMutation, SetExpenseStatusMutationVariables>(SetExpenseStatusDocument, baseOptions);
      }
export type SetExpenseStatusMutationHookResult = ReturnType<typeof useSetExpenseStatusMutation>;
export type SetExpenseStatusMutationResult = Apollo.MutationResult<SetExpenseStatusMutation>;
export type SetExpenseStatusMutationOptions = Apollo.BaseMutationOptions<SetExpenseStatusMutation, SetExpenseStatusMutationVariables>;
export const RemoveExpenseDocument = gql`
    mutation RemoveExpense($id: ID!) {
  deleteExpense(id: $id) {
    success
    errors
  }
}
    `;
export type RemoveExpenseMutationFn = Apollo.MutationFunction<RemoveExpenseMutation, RemoveExpenseMutationVariables>;

/**
 * __useRemoveExpenseMutation__
 *
 * To run a mutation, you first call `useRemoveExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExpenseMutation, { data, loading, error }] = useRemoveExpenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveExpenseMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExpenseMutation, RemoveExpenseMutationVariables>) {
        return Apollo.useMutation<RemoveExpenseMutation, RemoveExpenseMutationVariables>(RemoveExpenseDocument, baseOptions);
      }
export type RemoveExpenseMutationHookResult = ReturnType<typeof useRemoveExpenseMutation>;
export type RemoveExpenseMutationResult = Apollo.MutationResult<RemoveExpenseMutation>;
export type RemoveExpenseMutationOptions = Apollo.BaseMutationOptions<RemoveExpenseMutation, RemoveExpenseMutationVariables>;
export const AddExpenseCategoryDocument = gql`
    mutation AddExpenseCategory($name: String!, $slug: String!) {
  createExpenseCategory(name: $name, slug: $slug) {
    success
    errors
    category {
      id
      pk
      name
      slug
      isActive
    }
  }
}
    `;
export type AddExpenseCategoryMutationFn = Apollo.MutationFunction<AddExpenseCategoryMutation, AddExpenseCategoryMutationVariables>;

/**
 * __useAddExpenseCategoryMutation__
 *
 * To run a mutation, you first call `useAddExpenseCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExpenseCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExpenseCategoryMutation, { data, loading, error }] = useAddExpenseCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAddExpenseCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AddExpenseCategoryMutation, AddExpenseCategoryMutationVariables>) {
        return Apollo.useMutation<AddExpenseCategoryMutation, AddExpenseCategoryMutationVariables>(AddExpenseCategoryDocument, baseOptions);
      }
export type AddExpenseCategoryMutationHookResult = ReturnType<typeof useAddExpenseCategoryMutation>;
export type AddExpenseCategoryMutationResult = Apollo.MutationResult<AddExpenseCategoryMutation>;
export type AddExpenseCategoryMutationOptions = Apollo.BaseMutationOptions<AddExpenseCategoryMutation, AddExpenseCategoryMutationVariables>;
export const IssueVatInvoiceForContributionDocument = gql`
    mutation IssueVatInvoiceForContribution($agreementId: ID!, $contributionId: ID, $paymentTo: Date, $allowReissue: Boolean, $kind: String) {
  issueInvoiceForContribution(
    agreementId: $agreementId
    contributionId: $contributionId
    paymentTo: $paymentTo
    allowReissue: $allowReissue
    kind: $kind
  ) {
    success
    errors
    errorCode
    documentCreated
    invoice {
      id
      pk
      number
      status
      kind
      issueDate
      paymentTo
      currency
      priceGross
      outstanding
      viewUrl
      paymentUrl
      isProforma
      proformaForContributionId
      contribution {
        id
        date
        amountForeign
        status
        coveredAmount
        debt
      }
    }
  }
}
    `;
export type IssueVatInvoiceForContributionMutationFn = Apollo.MutationFunction<IssueVatInvoiceForContributionMutation, IssueVatInvoiceForContributionMutationVariables>;

/**
 * __useIssueVatInvoiceForContributionMutation__
 *
 * To run a mutation, you first call `useIssueVatInvoiceForContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueVatInvoiceForContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueVatInvoiceForContributionMutation, { data, loading, error }] = useIssueVatInvoiceForContributionMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      contributionId: // value for 'contributionId'
 *      paymentTo: // value for 'paymentTo'
 *      allowReissue: // value for 'allowReissue'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useIssueVatInvoiceForContributionMutation(baseOptions?: Apollo.MutationHookOptions<IssueVatInvoiceForContributionMutation, IssueVatInvoiceForContributionMutationVariables>) {
        return Apollo.useMutation<IssueVatInvoiceForContributionMutation, IssueVatInvoiceForContributionMutationVariables>(IssueVatInvoiceForContributionDocument, baseOptions);
      }
export type IssueVatInvoiceForContributionMutationHookResult = ReturnType<typeof useIssueVatInvoiceForContributionMutation>;
export type IssueVatInvoiceForContributionMutationResult = Apollo.MutationResult<IssueVatInvoiceForContributionMutation>;
export type IssueVatInvoiceForContributionMutationOptions = Apollo.BaseMutationOptions<IssueVatInvoiceForContributionMutation, IssueVatInvoiceForContributionMutationVariables>;
export const EnqueueBulkInvoiceIssueDocument = gql`
    mutation EnqueueBulkInvoiceIssue($groupId: ID!, $agreementIds: [ID!], $paymentTo: Date, $expectedBillableCount: Int, $kind: String) {
  issueInvoicesForGroup(
    groupId: $groupId
    agreementIds: $agreementIds
    paymentTo: $paymentTo
    expectedBillableCount: $expectedBillableCount
    kind: $kind
  ) {
    success
    errors
    errorCode
    total
    billableCount
    skippedCount
    job {
      id
      pk
      status
      total
      issuedCount
      skippedCount
      failedCount
      documentKind
    }
  }
}
    `;
export type EnqueueBulkInvoiceIssueMutationFn = Apollo.MutationFunction<EnqueueBulkInvoiceIssueMutation, EnqueueBulkInvoiceIssueMutationVariables>;

/**
 * __useEnqueueBulkInvoiceIssueMutation__
 *
 * To run a mutation, you first call `useEnqueueBulkInvoiceIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnqueueBulkInvoiceIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enqueueBulkInvoiceIssueMutation, { data, loading, error }] = useEnqueueBulkInvoiceIssueMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      agreementIds: // value for 'agreementIds'
 *      paymentTo: // value for 'paymentTo'
 *      expectedBillableCount: // value for 'expectedBillableCount'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useEnqueueBulkInvoiceIssueMutation(baseOptions?: Apollo.MutationHookOptions<EnqueueBulkInvoiceIssueMutation, EnqueueBulkInvoiceIssueMutationVariables>) {
        return Apollo.useMutation<EnqueueBulkInvoiceIssueMutation, EnqueueBulkInvoiceIssueMutationVariables>(EnqueueBulkInvoiceIssueDocument, baseOptions);
      }
export type EnqueueBulkInvoiceIssueMutationHookResult = ReturnType<typeof useEnqueueBulkInvoiceIssueMutation>;
export type EnqueueBulkInvoiceIssueMutationResult = Apollo.MutationResult<EnqueueBulkInvoiceIssueMutation>;
export type EnqueueBulkInvoiceIssueMutationOptions = Apollo.BaseMutationOptions<EnqueueBulkInvoiceIssueMutation, EnqueueBulkInvoiceIssueMutationVariables>;
export const ConvertProformaToVatDocument = gql`
    mutation ConvertProformaToVat($invoiceId: ID!, $dryRun: Boolean) {
  issueVatFromProforma(invoiceId: $invoiceId, dryRun: $dryRun) {
    success
    errors
    errorCode
    documentCreated
    invoice {
      id
      pk
      number
      kind
      status
      issueDate
      paymentTo
      currency
      priceGross
      paid
      outstanding
      viewUrl
      isProforma
      isOpenProforma
      proformaForContributionId
      vatChild {
        id
        pk
        number
        viewUrl
      }
    }
  }
}
    `;
export type ConvertProformaToVatMutationFn = Apollo.MutationFunction<ConvertProformaToVatMutation, ConvertProformaToVatMutationVariables>;

/**
 * __useConvertProformaToVatMutation__
 *
 * To run a mutation, you first call `useConvertProformaToVatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertProformaToVatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertProformaToVatMutation, { data, loading, error }] = useConvertProformaToVatMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useConvertProformaToVatMutation(baseOptions?: Apollo.MutationHookOptions<ConvertProformaToVatMutation, ConvertProformaToVatMutationVariables>) {
        return Apollo.useMutation<ConvertProformaToVatMutation, ConvertProformaToVatMutationVariables>(ConvertProformaToVatDocument, baseOptions);
      }
export type ConvertProformaToVatMutationHookResult = ReturnType<typeof useConvertProformaToVatMutation>;
export type ConvertProformaToVatMutationResult = Apollo.MutationResult<ConvertProformaToVatMutation>;
export type ConvertProformaToVatMutationOptions = Apollo.BaseMutationOptions<ConvertProformaToVatMutation, ConvertProformaToVatMutationVariables>;
export const PinProformaToContributionDocument = gql`
    mutation PinProformaToContribution($invoiceId: ID!, $contributionId: ID!) {
  linkProformaToContribution(
    invoiceId: $invoiceId
    contributionId: $contributionId
  ) {
    success
    errors
    errorCode
    invoice {
      id
      isOpenProforma
      proformaForContributionId
    }
  }
}
    `;
export type PinProformaToContributionMutationFn = Apollo.MutationFunction<PinProformaToContributionMutation, PinProformaToContributionMutationVariables>;

/**
 * __usePinProformaToContributionMutation__
 *
 * To run a mutation, you first call `usePinProformaToContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinProformaToContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinProformaToContributionMutation, { data, loading, error }] = usePinProformaToContributionMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      contributionId: // value for 'contributionId'
 *   },
 * });
 */
export function usePinProformaToContributionMutation(baseOptions?: Apollo.MutationHookOptions<PinProformaToContributionMutation, PinProformaToContributionMutationVariables>) {
        return Apollo.useMutation<PinProformaToContributionMutation, PinProformaToContributionMutationVariables>(PinProformaToContributionDocument, baseOptions);
      }
export type PinProformaToContributionMutationHookResult = ReturnType<typeof usePinProformaToContributionMutation>;
export type PinProformaToContributionMutationResult = Apollo.MutationResult<PinProformaToContributionMutation>;
export type PinProformaToContributionMutationOptions = Apollo.BaseMutationOptions<PinProformaToContributionMutation, PinProformaToContributionMutationVariables>;
export const UnpinProformaFromContributionDocument = gql`
    mutation UnpinProformaFromContribution($invoiceId: ID!) {
  unlinkProformaFromContribution(invoiceId: $invoiceId) {
    success
    errors
    errorCode
    invoice {
      id
      isOpenProforma
      proformaForContributionId
    }
  }
}
    `;
export type UnpinProformaFromContributionMutationFn = Apollo.MutationFunction<UnpinProformaFromContributionMutation, UnpinProformaFromContributionMutationVariables>;

/**
 * __useUnpinProformaFromContributionMutation__
 *
 * To run a mutation, you first call `useUnpinProformaFromContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinProformaFromContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinProformaFromContributionMutation, { data, loading, error }] = useUnpinProformaFromContributionMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useUnpinProformaFromContributionMutation(baseOptions?: Apollo.MutationHookOptions<UnpinProformaFromContributionMutation, UnpinProformaFromContributionMutationVariables>) {
        return Apollo.useMutation<UnpinProformaFromContributionMutation, UnpinProformaFromContributionMutationVariables>(UnpinProformaFromContributionDocument, baseOptions);
      }
export type UnpinProformaFromContributionMutationHookResult = ReturnType<typeof useUnpinProformaFromContributionMutation>;
export type UnpinProformaFromContributionMutationResult = Apollo.MutationResult<UnpinProformaFromContributionMutation>;
export type UnpinProformaFromContributionMutationOptions = Apollo.BaseMutationOptions<UnpinProformaFromContributionMutation, UnpinProformaFromContributionMutationVariables>;
export const SaveGroupLessonLinkDocument = gql`
    mutation SaveGroupLessonLink($groupId: Int!, $joinUrl: String!) {
  setGroupLessonLink(groupId: $groupId, joinUrl: $joinUrl) {
    success
    group {
      ...GroupJoinLinkFields
    }
  }
}
    ${GroupJoinLinkFieldsFragmentDoc}`;
export type SaveGroupLessonLinkMutationFn = Apollo.MutationFunction<SaveGroupLessonLinkMutation, SaveGroupLessonLinkMutationVariables>;

/**
 * __useSaveGroupLessonLinkMutation__
 *
 * To run a mutation, you first call `useSaveGroupLessonLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGroupLessonLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGroupLessonLinkMutation, { data, loading, error }] = useSaveGroupLessonLinkMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      joinUrl: // value for 'joinUrl'
 *   },
 * });
 */
export function useSaveGroupLessonLinkMutation(baseOptions?: Apollo.MutationHookOptions<SaveGroupLessonLinkMutation, SaveGroupLessonLinkMutationVariables>) {
        return Apollo.useMutation<SaveGroupLessonLinkMutation, SaveGroupLessonLinkMutationVariables>(SaveGroupLessonLinkDocument, baseOptions);
      }
export type SaveGroupLessonLinkMutationHookResult = ReturnType<typeof useSaveGroupLessonLinkMutation>;
export type SaveGroupLessonLinkMutationResult = Apollo.MutationResult<SaveGroupLessonLinkMutation>;
export type SaveGroupLessonLinkMutationOptions = Apollo.BaseMutationOptions<SaveGroupLessonLinkMutation, SaveGroupLessonLinkMutationVariables>;
export const PutGroupLinkOverrideDocument = gql`
    mutation PutGroupLinkOverride($groupId: Int!, $joinUrl: String!, $date: Date) {
  setGroupLessonLinkOverride(groupId: $groupId, joinUrl: $joinUrl, date: $date) {
    success
    group {
      ...GroupJoinLinkFields
    }
  }
}
    ${GroupJoinLinkFieldsFragmentDoc}`;
export type PutGroupLinkOverrideMutationFn = Apollo.MutationFunction<PutGroupLinkOverrideMutation, PutGroupLinkOverrideMutationVariables>;

/**
 * __usePutGroupLinkOverrideMutation__
 *
 * To run a mutation, you first call `usePutGroupLinkOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutGroupLinkOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putGroupLinkOverrideMutation, { data, loading, error }] = usePutGroupLinkOverrideMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      joinUrl: // value for 'joinUrl'
 *      date: // value for 'date'
 *   },
 * });
 */
export function usePutGroupLinkOverrideMutation(baseOptions?: Apollo.MutationHookOptions<PutGroupLinkOverrideMutation, PutGroupLinkOverrideMutationVariables>) {
        return Apollo.useMutation<PutGroupLinkOverrideMutation, PutGroupLinkOverrideMutationVariables>(PutGroupLinkOverrideDocument, baseOptions);
      }
export type PutGroupLinkOverrideMutationHookResult = ReturnType<typeof usePutGroupLinkOverrideMutation>;
export type PutGroupLinkOverrideMutationResult = Apollo.MutationResult<PutGroupLinkOverrideMutation>;
export type PutGroupLinkOverrideMutationOptions = Apollo.BaseMutationOptions<PutGroupLinkOverrideMutation, PutGroupLinkOverrideMutationVariables>;
export const DropGroupLinkOverrideDocument = gql`
    mutation DropGroupLinkOverride($groupId: Int!, $date: Date!) {
  clearGroupLessonLinkOverride(groupId: $groupId, date: $date) {
    success
    group {
      ...GroupJoinLinkFields
    }
  }
}
    ${GroupJoinLinkFieldsFragmentDoc}`;
export type DropGroupLinkOverrideMutationFn = Apollo.MutationFunction<DropGroupLinkOverrideMutation, DropGroupLinkOverrideMutationVariables>;

/**
 * __useDropGroupLinkOverrideMutation__
 *
 * To run a mutation, you first call `useDropGroupLinkOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropGroupLinkOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropGroupLinkOverrideMutation, { data, loading, error }] = useDropGroupLinkOverrideMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useDropGroupLinkOverrideMutation(baseOptions?: Apollo.MutationHookOptions<DropGroupLinkOverrideMutation, DropGroupLinkOverrideMutationVariables>) {
        return Apollo.useMutation<DropGroupLinkOverrideMutation, DropGroupLinkOverrideMutationVariables>(DropGroupLinkOverrideDocument, baseOptions);
      }
export type DropGroupLinkOverrideMutationHookResult = ReturnType<typeof useDropGroupLinkOverrideMutation>;
export type DropGroupLinkOverrideMutationResult = Apollo.MutationResult<DropGroupLinkOverrideMutation>;
export type DropGroupLinkOverrideMutationOptions = Apollo.BaseMutationOptions<DropGroupLinkOverrideMutation, DropGroupLinkOverrideMutationVariables>;
export const RemoveGroupDocument = gql`
    mutation removeGroup($groupId: Int!) {
  deleteGroup(groupId: $groupId) {
    success
    errors
  }
}
    `;
export type RemoveGroupMutationFn = Apollo.MutationFunction<RemoveGroupMutation, RemoveGroupMutationVariables>;

/**
 * __useRemoveGroupMutation__
 *
 * To run a mutation, you first call `useRemoveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupMutation, { data, loading, error }] = useRemoveGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useRemoveGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupMutation, RemoveGroupMutationVariables>) {
        return Apollo.useMutation<RemoveGroupMutation, RemoveGroupMutationVariables>(RemoveGroupDocument, baseOptions);
      }
export type RemoveGroupMutationHookResult = ReturnType<typeof useRemoveGroupMutation>;
export type RemoveGroupMutationResult = Apollo.MutationResult<RemoveGroupMutation>;
export type RemoveGroupMutationOptions = Apollo.BaseMutationOptions<RemoveGroupMutation, RemoveGroupMutationVariables>;
export const PublishToLmsDocument = gql`
    mutation publishToLMS($groupId: ID!, $publishedLms: Boolean!, $publishedForTeachers: Boolean, $publishedLmsForMethodist: Boolean) {
  publishGroup(
    groupId: $groupId
    publishedLms: $publishedLms
    publishedForTeachers: $publishedForTeachers
    publishedLmsForMethodist: $publishedLmsForMethodist
  ) {
    success
    errors
  }
}
    `;
export type PublishToLmsMutationFn = Apollo.MutationFunction<PublishToLmsMutation, PublishToLmsMutationVariables>;

/**
 * __usePublishToLmsMutation__
 *
 * To run a mutation, you first call `usePublishToLmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishToLmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishToLmsMutation, { data, loading, error }] = usePublishToLmsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      publishedLms: // value for 'publishedLms'
 *      publishedForTeachers: // value for 'publishedForTeachers'
 *      publishedLmsForMethodist: // value for 'publishedLmsForMethodist'
 *   },
 * });
 */
export function usePublishToLmsMutation(baseOptions?: Apollo.MutationHookOptions<PublishToLmsMutation, PublishToLmsMutationVariables>) {
        return Apollo.useMutation<PublishToLmsMutation, PublishToLmsMutationVariables>(PublishToLmsDocument, baseOptions);
      }
export type PublishToLmsMutationHookResult = ReturnType<typeof usePublishToLmsMutation>;
export type PublishToLmsMutationResult = Apollo.MutationResult<PublishToLmsMutation>;
export type PublishToLmsMutationOptions = Apollo.BaseMutationOptions<PublishToLmsMutation, PublishToLmsMutationVariables>;
export const AddGroupDocument = gql`
    mutation AddGroup($groupInput: GroupInput!, $moduleInput: [ModuleInput]!) {
  createGroup(groupInput: $groupInput, moduleInput: $moduleInput) {
    success
    errors
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type AddGroupMutationFn = Apollo.MutationFunction<AddGroupMutation, AddGroupMutationVariables>;

/**
 * __useAddGroupMutation__
 *
 * To run a mutation, you first call `useAddGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGroupMutation, { data, loading, error }] = useAddGroupMutation({
 *   variables: {
 *      groupInput: // value for 'groupInput'
 *      moduleInput: // value for 'moduleInput'
 *   },
 * });
 */
export function useAddGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddGroupMutation, AddGroupMutationVariables>) {
        return Apollo.useMutation<AddGroupMutation, AddGroupMutationVariables>(AddGroupDocument, baseOptions);
      }
export type AddGroupMutationHookResult = ReturnType<typeof useAddGroupMutation>;
export type AddGroupMutationResult = Apollo.MutationResult<AddGroupMutation>;
export type AddGroupMutationOptions = Apollo.BaseMutationOptions<AddGroupMutation, AddGroupMutationVariables>;
export const ChangeGroupDocument = gql`
    mutation changeGroup($groupId: Int!, $groupInput: UpdateGroupInput!) {
  updateGroup(groupId: $groupId, groupInput: $groupInput) {
    success
    errors
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ChangeGroupMutationFn = Apollo.MutationFunction<ChangeGroupMutation, ChangeGroupMutationVariables>;

/**
 * __useChangeGroupMutation__
 *
 * To run a mutation, you first call `useChangeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeGroupMutation, { data, loading, error }] = useChangeGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      groupInput: // value for 'groupInput'
 *   },
 * });
 */
export function useChangeGroupMutation(baseOptions?: Apollo.MutationHookOptions<ChangeGroupMutation, ChangeGroupMutationVariables>) {
        return Apollo.useMutation<ChangeGroupMutation, ChangeGroupMutationVariables>(ChangeGroupDocument, baseOptions);
      }
export type ChangeGroupMutationHookResult = ReturnType<typeof useChangeGroupMutation>;
export type ChangeGroupMutationResult = Apollo.MutationResult<ChangeGroupMutation>;
export type ChangeGroupMutationOptions = Apollo.BaseMutationOptions<ChangeGroupMutation, ChangeGroupMutationVariables>;
export const GroupAppendStudentDocument = gql`
    mutation GroupAppendStudent($studentId: ID!, $agreementInput: CreateAgreementInputBase!) {
  appendStudentToGroup(studentId: $studentId, agreementInput: $agreementInput) {
    success
    customErrors {
      field
      message
      code
    }
    errors
    agreement {
      id
      agreementTitle
      currency
      budgetAmount
      paidAmount
      terminated
      date
    }
  }
}
    `;
export type GroupAppendStudentMutationFn = Apollo.MutationFunction<GroupAppendStudentMutation, GroupAppendStudentMutationVariables>;

/**
 * __useGroupAppendStudentMutation__
 *
 * To run a mutation, you first call `useGroupAppendStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupAppendStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupAppendStudentMutation, { data, loading, error }] = useGroupAppendStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      agreementInput: // value for 'agreementInput'
 *   },
 * });
 */
export function useGroupAppendStudentMutation(baseOptions?: Apollo.MutationHookOptions<GroupAppendStudentMutation, GroupAppendStudentMutationVariables>) {
        return Apollo.useMutation<GroupAppendStudentMutation, GroupAppendStudentMutationVariables>(GroupAppendStudentDocument, baseOptions);
      }
export type GroupAppendStudentMutationHookResult = ReturnType<typeof useGroupAppendStudentMutation>;
export type GroupAppendStudentMutationResult = Apollo.MutationResult<GroupAppendStudentMutation>;
export type GroupAppendStudentMutationOptions = Apollo.BaseMutationOptions<GroupAppendStudentMutation, GroupAppendStudentMutationVariables>;
export const GroupTerminateAgreementDocument = gql`
    mutation GroupTerminateAgreement($agreementId: ID!, $terminatedDate: Date, $terminatedReason: TerminatedReasonEnum, $comment: String) {
  terminateAgreement(
    agreementId: $agreementId
    terminatedDate: $terminatedDate
    terminatedReason: $terminatedReason
    comment: $comment
  ) {
    success
    customErrors {
      field
      message
      code
    }
    agreement {
      id
      terminated
      terminatedDate
    }
  }
}
    `;
export type GroupTerminateAgreementMutationFn = Apollo.MutationFunction<GroupTerminateAgreementMutation, GroupTerminateAgreementMutationVariables>;

/**
 * __useGroupTerminateAgreementMutation__
 *
 * To run a mutation, you first call `useGroupTerminateAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupTerminateAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupTerminateAgreementMutation, { data, loading, error }] = useGroupTerminateAgreementMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      terminatedDate: // value for 'terminatedDate'
 *      terminatedReason: // value for 'terminatedReason'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useGroupTerminateAgreementMutation(baseOptions?: Apollo.MutationHookOptions<GroupTerminateAgreementMutation, GroupTerminateAgreementMutationVariables>) {
        return Apollo.useMutation<GroupTerminateAgreementMutation, GroupTerminateAgreementMutationVariables>(GroupTerminateAgreementDocument, baseOptions);
      }
export type GroupTerminateAgreementMutationHookResult = ReturnType<typeof useGroupTerminateAgreementMutation>;
export type GroupTerminateAgreementMutationResult = Apollo.MutationResult<GroupTerminateAgreementMutation>;
export type GroupTerminateAgreementMutationOptions = Apollo.BaseMutationOptions<GroupTerminateAgreementMutation, GroupTerminateAgreementMutationVariables>;
export const GroupRestoreCourseAccessDocument = gql`
    mutation GroupRestoreCourseAccess($agreementId: ID!) {
  restoreCourseAccess(agreementId: $agreementId) {
    success
    customErrors {
      field
      message
      code
    }
    restoredLessons
    agreement {
      id
      terminated
    }
  }
}
    `;
export type GroupRestoreCourseAccessMutationFn = Apollo.MutationFunction<GroupRestoreCourseAccessMutation, GroupRestoreCourseAccessMutationVariables>;

/**
 * __useGroupRestoreCourseAccessMutation__
 *
 * To run a mutation, you first call `useGroupRestoreCourseAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupRestoreCourseAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupRestoreCourseAccessMutation, { data, loading, error }] = useGroupRestoreCourseAccessMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useGroupRestoreCourseAccessMutation(baseOptions?: Apollo.MutationHookOptions<GroupRestoreCourseAccessMutation, GroupRestoreCourseAccessMutationVariables>) {
        return Apollo.useMutation<GroupRestoreCourseAccessMutation, GroupRestoreCourseAccessMutationVariables>(GroupRestoreCourseAccessDocument, baseOptions);
      }
export type GroupRestoreCourseAccessMutationHookResult = ReturnType<typeof useGroupRestoreCourseAccessMutation>;
export type GroupRestoreCourseAccessMutationResult = Apollo.MutationResult<GroupRestoreCourseAccessMutation>;
export type GroupRestoreCourseAccessMutationOptions = Apollo.BaseMutationOptions<GroupRestoreCourseAccessMutation, GroupRestoreCourseAccessMutationVariables>;
export const ChangeAttendanceDocument = gql`
    mutation changeAttendance($attendanceId: Int!, $attendance: Boolean!) {
  updateAttendance(attendanceId: $attendanceId, attendance: $attendance) {
    success
    customErrors {
      field
      message
      code
    }
    attendance {
      id
      attendance
      source
      markedAt
      markedByName
    }
  }
}
    `;
export type ChangeAttendanceMutationFn = Apollo.MutationFunction<ChangeAttendanceMutation, ChangeAttendanceMutationVariables>;

/**
 * __useChangeAttendanceMutation__
 *
 * To run a mutation, you first call `useChangeAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAttendanceMutation, { data, loading, error }] = useChangeAttendanceMutation({
 *   variables: {
 *      attendanceId: // value for 'attendanceId'
 *      attendance: // value for 'attendance'
 *   },
 * });
 */
export function useChangeAttendanceMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAttendanceMutation, ChangeAttendanceMutationVariables>) {
        return Apollo.useMutation<ChangeAttendanceMutation, ChangeAttendanceMutationVariables>(ChangeAttendanceDocument, baseOptions);
      }
export type ChangeAttendanceMutationHookResult = ReturnType<typeof useChangeAttendanceMutation>;
export type ChangeAttendanceMutationResult = Apollo.MutationResult<ChangeAttendanceMutation>;
export type ChangeAttendanceMutationOptions = Apollo.BaseMutationOptions<ChangeAttendanceMutation, ChangeAttendanceMutationVariables>;
export const ChangeDateOfLessonDocument = gql`
    mutation changeDateOfLesson($groupId: Int!, $newDate: Date!, $oldDate: Date!) {
  changeLessonDates(groupId: $groupId, newDate: $newDate, oldDate: $oldDate) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ChangeDateOfLessonMutationFn = Apollo.MutationFunction<ChangeDateOfLessonMutation, ChangeDateOfLessonMutationVariables>;

/**
 * __useChangeDateOfLessonMutation__
 *
 * To run a mutation, you first call `useChangeDateOfLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDateOfLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDateOfLessonMutation, { data, loading, error }] = useChangeDateOfLessonMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      newDate: // value for 'newDate'
 *      oldDate: // value for 'oldDate'
 *   },
 * });
 */
export function useChangeDateOfLessonMutation(baseOptions?: Apollo.MutationHookOptions<ChangeDateOfLessonMutation, ChangeDateOfLessonMutationVariables>) {
        return Apollo.useMutation<ChangeDateOfLessonMutation, ChangeDateOfLessonMutationVariables>(ChangeDateOfLessonDocument, baseOptions);
      }
export type ChangeDateOfLessonMutationHookResult = ReturnType<typeof useChangeDateOfLessonMutation>;
export type ChangeDateOfLessonMutationResult = Apollo.MutationResult<ChangeDateOfLessonMutation>;
export type ChangeDateOfLessonMutationOptions = Apollo.BaseMutationOptions<ChangeDateOfLessonMutation, ChangeDateOfLessonMutationVariables>;
export const ChangeJournalDocument = gql`
    mutation changeJournal($groupId: Int!, $daysOfClass: [DayOfClassInput!]!, $modules: [UpdateModuleInput]!, $comment: String!) {
  updateJournal(
    groupId: $groupId
    daysOfClass: $daysOfClass
    modules: $modules
    comment: $comment
  ) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ChangeJournalMutationFn = Apollo.MutationFunction<ChangeJournalMutation, ChangeJournalMutationVariables>;

/**
 * __useChangeJournalMutation__
 *
 * To run a mutation, you first call `useChangeJournalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeJournalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeJournalMutation, { data, loading, error }] = useChangeJournalMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      daysOfClass: // value for 'daysOfClass'
 *      modules: // value for 'modules'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useChangeJournalMutation(baseOptions?: Apollo.MutationHookOptions<ChangeJournalMutation, ChangeJournalMutationVariables>) {
        return Apollo.useMutation<ChangeJournalMutation, ChangeJournalMutationVariables>(ChangeJournalDocument, baseOptions);
      }
export type ChangeJournalMutationHookResult = ReturnType<typeof useChangeJournalMutation>;
export type ChangeJournalMutationResult = Apollo.MutationResult<ChangeJournalMutation>;
export type ChangeJournalMutationOptions = Apollo.BaseMutationOptions<ChangeJournalMutation, ChangeJournalMutationVariables>;
export const StoreLmsBlockSettingsDocument = gql`
    mutation StoreLmsBlockSettings($input: LmsBlockSettingsInput!) {
  saveLmsBlockSettings(input: $input) {
    success
    settings {
      robotEnabled
      overdueDays
      mailEnabled
      slackEnabled
      smsEnabled
      suspendedTemplateId
      suspendedTemplateName
      restoredTemplateId
      restoredTemplateName
      updatedAt
      updatedByName
      serverRobotAllowed
      serverMailAllowed
      serverSlackAllowed
      serverSmsAllowed
      canEdit
    }
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type StoreLmsBlockSettingsMutationFn = Apollo.MutationFunction<StoreLmsBlockSettingsMutation, StoreLmsBlockSettingsMutationVariables>;

/**
 * __useStoreLmsBlockSettingsMutation__
 *
 * To run a mutation, you first call `useStoreLmsBlockSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreLmsBlockSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeLmsBlockSettingsMutation, { data, loading, error }] = useStoreLmsBlockSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreLmsBlockSettingsMutation(baseOptions?: Apollo.MutationHookOptions<StoreLmsBlockSettingsMutation, StoreLmsBlockSettingsMutationVariables>) {
        return Apollo.useMutation<StoreLmsBlockSettingsMutation, StoreLmsBlockSettingsMutationVariables>(StoreLmsBlockSettingsDocument, baseOptions);
      }
export type StoreLmsBlockSettingsMutationHookResult = ReturnType<typeof useStoreLmsBlockSettingsMutation>;
export type StoreLmsBlockSettingsMutationResult = Apollo.MutationResult<StoreLmsBlockSettingsMutation>;
export type StoreLmsBlockSettingsMutationOptions = Apollo.BaseMutationOptions<StoreLmsBlockSettingsMutation, StoreLmsBlockSettingsMutationVariables>;
export const TryLmsBlockTemplateDocument = gql`
    mutation TryLmsBlockTemplate($kind: String!, $templateId: String) {
  sendLmsBlockTestEmail(kind: $kind, templateId: $templateId) {
    success
    sentTo
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type TryLmsBlockTemplateMutationFn = Apollo.MutationFunction<TryLmsBlockTemplateMutation, TryLmsBlockTemplateMutationVariables>;

/**
 * __useTryLmsBlockTemplateMutation__
 *
 * To run a mutation, you first call `useTryLmsBlockTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTryLmsBlockTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tryLmsBlockTemplateMutation, { data, loading, error }] = useTryLmsBlockTemplateMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTryLmsBlockTemplateMutation(baseOptions?: Apollo.MutationHookOptions<TryLmsBlockTemplateMutation, TryLmsBlockTemplateMutationVariables>) {
        return Apollo.useMutation<TryLmsBlockTemplateMutation, TryLmsBlockTemplateMutationVariables>(TryLmsBlockTemplateDocument, baseOptions);
      }
export type TryLmsBlockTemplateMutationHookResult = ReturnType<typeof useTryLmsBlockTemplateMutation>;
export type TryLmsBlockTemplateMutationResult = Apollo.MutationResult<TryLmsBlockTemplateMutation>;
export type TryLmsBlockTemplateMutationOptions = Apollo.BaseMutationOptions<TryLmsBlockTemplateMutation, TryLmsBlockTemplateMutationVariables>;
export const RefreshMarketingSourcesNowDocument = gql`
    mutation RefreshMarketingSourcesNow($sources: [String!]) {
  refreshMarketingSources(sources: $sources) {
    success
    customErrors {
      field
      code
      message
    }
    queued
    skipped {
      source
      reason
    }
    rebuildQueued
  }
}
    `;
export type RefreshMarketingSourcesNowMutationFn = Apollo.MutationFunction<RefreshMarketingSourcesNowMutation, RefreshMarketingSourcesNowMutationVariables>;

/**
 * __useRefreshMarketingSourcesNowMutation__
 *
 * To run a mutation, you first call `useRefreshMarketingSourcesNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMarketingSourcesNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMarketingSourcesNowMutation, { data, loading, error }] = useRefreshMarketingSourcesNowMutation({
 *   variables: {
 *      sources: // value for 'sources'
 *   },
 * });
 */
export function useRefreshMarketingSourcesNowMutation(baseOptions?: Apollo.MutationHookOptions<RefreshMarketingSourcesNowMutation, RefreshMarketingSourcesNowMutationVariables>) {
        return Apollo.useMutation<RefreshMarketingSourcesNowMutation, RefreshMarketingSourcesNowMutationVariables>(RefreshMarketingSourcesNowDocument, baseOptions);
      }
export type RefreshMarketingSourcesNowMutationHookResult = ReturnType<typeof useRefreshMarketingSourcesNowMutation>;
export type RefreshMarketingSourcesNowMutationResult = Apollo.MutationResult<RefreshMarketingSourcesNowMutation>;
export type RefreshMarketingSourcesNowMutationOptions = Apollo.BaseMutationOptions<RefreshMarketingSourcesNowMutation, RefreshMarketingSourcesNowMutationVariables>;
export const StoreMarketingChannelRuleDocument = gql`
    mutation StoreMarketingChannelRule($input: MarketingChannelRuleInput!) {
  saveMarketingChannelRule(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    rule {
      ...MarketingChannelRuleFields
    }
  }
}
    ${MarketingChannelRuleFieldsFragmentDoc}`;
export type StoreMarketingChannelRuleMutationFn = Apollo.MutationFunction<StoreMarketingChannelRuleMutation, StoreMarketingChannelRuleMutationVariables>;

/**
 * __useStoreMarketingChannelRuleMutation__
 *
 * To run a mutation, you first call `useStoreMarketingChannelRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMarketingChannelRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMarketingChannelRuleMutation, { data, loading, error }] = useStoreMarketingChannelRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreMarketingChannelRuleMutation(baseOptions?: Apollo.MutationHookOptions<StoreMarketingChannelRuleMutation, StoreMarketingChannelRuleMutationVariables>) {
        return Apollo.useMutation<StoreMarketingChannelRuleMutation, StoreMarketingChannelRuleMutationVariables>(StoreMarketingChannelRuleDocument, baseOptions);
      }
export type StoreMarketingChannelRuleMutationHookResult = ReturnType<typeof useStoreMarketingChannelRuleMutation>;
export type StoreMarketingChannelRuleMutationResult = Apollo.MutationResult<StoreMarketingChannelRuleMutation>;
export type StoreMarketingChannelRuleMutationOptions = Apollo.BaseMutationOptions<StoreMarketingChannelRuleMutation, StoreMarketingChannelRuleMutationVariables>;
export const RemoveMarketingChannelRuleDocument = gql`
    mutation RemoveMarketingChannelRule($id: ID!) {
  deleteMarketingChannelRule(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type RemoveMarketingChannelRuleMutationFn = Apollo.MutationFunction<RemoveMarketingChannelRuleMutation, RemoveMarketingChannelRuleMutationVariables>;

/**
 * __useRemoveMarketingChannelRuleMutation__
 *
 * To run a mutation, you first call `useRemoveMarketingChannelRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarketingChannelRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarketingChannelRuleMutation, { data, loading, error }] = useRemoveMarketingChannelRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMarketingChannelRuleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarketingChannelRuleMutation, RemoveMarketingChannelRuleMutationVariables>) {
        return Apollo.useMutation<RemoveMarketingChannelRuleMutation, RemoveMarketingChannelRuleMutationVariables>(RemoveMarketingChannelRuleDocument, baseOptions);
      }
export type RemoveMarketingChannelRuleMutationHookResult = ReturnType<typeof useRemoveMarketingChannelRuleMutation>;
export type RemoveMarketingChannelRuleMutationResult = Apollo.MutationResult<RemoveMarketingChannelRuleMutation>;
export type RemoveMarketingChannelRuleMutationOptions = Apollo.BaseMutationOptions<RemoveMarketingChannelRuleMutation, RemoveMarketingChannelRuleMutationVariables>;
export const StoreMarketingCourseFamilyDocument = gql`
    mutation StoreMarketingCourseFamily($input: MarketingCourseFamilyInput!) {
  saveMarketingCourseFamily(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    family {
      id
      slug
      name
      isSold
      sort
      aliases {
        ...MarketingCourseAliasFields
      }
    }
  }
}
    ${MarketingCourseAliasFieldsFragmentDoc}`;
export type StoreMarketingCourseFamilyMutationFn = Apollo.MutationFunction<StoreMarketingCourseFamilyMutation, StoreMarketingCourseFamilyMutationVariables>;

/**
 * __useStoreMarketingCourseFamilyMutation__
 *
 * To run a mutation, you first call `useStoreMarketingCourseFamilyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMarketingCourseFamilyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMarketingCourseFamilyMutation, { data, loading, error }] = useStoreMarketingCourseFamilyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreMarketingCourseFamilyMutation(baseOptions?: Apollo.MutationHookOptions<StoreMarketingCourseFamilyMutation, StoreMarketingCourseFamilyMutationVariables>) {
        return Apollo.useMutation<StoreMarketingCourseFamilyMutation, StoreMarketingCourseFamilyMutationVariables>(StoreMarketingCourseFamilyDocument, baseOptions);
      }
export type StoreMarketingCourseFamilyMutationHookResult = ReturnType<typeof useStoreMarketingCourseFamilyMutation>;
export type StoreMarketingCourseFamilyMutationResult = Apollo.MutationResult<StoreMarketingCourseFamilyMutation>;
export type StoreMarketingCourseFamilyMutationOptions = Apollo.BaseMutationOptions<StoreMarketingCourseFamilyMutation, StoreMarketingCourseFamilyMutationVariables>;
export const StoreMarketingCourseAliasDocument = gql`
    mutation StoreMarketingCourseAlias($input: MarketingCourseAliasInput!) {
  saveMarketingCourseAlias(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    alias {
      ...MarketingCourseAliasFields
    }
  }
}
    ${MarketingCourseAliasFieldsFragmentDoc}`;
export type StoreMarketingCourseAliasMutationFn = Apollo.MutationFunction<StoreMarketingCourseAliasMutation, StoreMarketingCourseAliasMutationVariables>;

/**
 * __useStoreMarketingCourseAliasMutation__
 *
 * To run a mutation, you first call `useStoreMarketingCourseAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMarketingCourseAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMarketingCourseAliasMutation, { data, loading, error }] = useStoreMarketingCourseAliasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreMarketingCourseAliasMutation(baseOptions?: Apollo.MutationHookOptions<StoreMarketingCourseAliasMutation, StoreMarketingCourseAliasMutationVariables>) {
        return Apollo.useMutation<StoreMarketingCourseAliasMutation, StoreMarketingCourseAliasMutationVariables>(StoreMarketingCourseAliasDocument, baseOptions);
      }
export type StoreMarketingCourseAliasMutationHookResult = ReturnType<typeof useStoreMarketingCourseAliasMutation>;
export type StoreMarketingCourseAliasMutationResult = Apollo.MutationResult<StoreMarketingCourseAliasMutation>;
export type StoreMarketingCourseAliasMutationOptions = Apollo.BaseMutationOptions<StoreMarketingCourseAliasMutation, StoreMarketingCourseAliasMutationVariables>;
export const RemoveMarketingCourseAliasDocument = gql`
    mutation RemoveMarketingCourseAlias($id: ID!) {
  deleteMarketingCourseAlias(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type RemoveMarketingCourseAliasMutationFn = Apollo.MutationFunction<RemoveMarketingCourseAliasMutation, RemoveMarketingCourseAliasMutationVariables>;

/**
 * __useRemoveMarketingCourseAliasMutation__
 *
 * To run a mutation, you first call `useRemoveMarketingCourseAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarketingCourseAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarketingCourseAliasMutation, { data, loading, error }] = useRemoveMarketingCourseAliasMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMarketingCourseAliasMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarketingCourseAliasMutation, RemoveMarketingCourseAliasMutationVariables>) {
        return Apollo.useMutation<RemoveMarketingCourseAliasMutation, RemoveMarketingCourseAliasMutationVariables>(RemoveMarketingCourseAliasDocument, baseOptions);
      }
export type RemoveMarketingCourseAliasMutationHookResult = ReturnType<typeof useRemoveMarketingCourseAliasMutation>;
export type RemoveMarketingCourseAliasMutationResult = Apollo.MutationResult<RemoveMarketingCourseAliasMutation>;
export type RemoveMarketingCourseAliasMutationOptions = Apollo.BaseMutationOptions<RemoveMarketingCourseAliasMutation, RemoveMarketingCourseAliasMutationVariables>;
export const StoreMarketingOfferRuleDocument = gql`
    mutation StoreMarketingOfferRule($input: MarketingOfferRuleInput!) {
  saveMarketingOfferRule(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    rule {
      ...MarketingOfferRuleFields
    }
  }
}
    ${MarketingOfferRuleFieldsFragmentDoc}`;
export type StoreMarketingOfferRuleMutationFn = Apollo.MutationFunction<StoreMarketingOfferRuleMutation, StoreMarketingOfferRuleMutationVariables>;

/**
 * __useStoreMarketingOfferRuleMutation__
 *
 * To run a mutation, you first call `useStoreMarketingOfferRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMarketingOfferRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMarketingOfferRuleMutation, { data, loading, error }] = useStoreMarketingOfferRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreMarketingOfferRuleMutation(baseOptions?: Apollo.MutationHookOptions<StoreMarketingOfferRuleMutation, StoreMarketingOfferRuleMutationVariables>) {
        return Apollo.useMutation<StoreMarketingOfferRuleMutation, StoreMarketingOfferRuleMutationVariables>(StoreMarketingOfferRuleDocument, baseOptions);
      }
export type StoreMarketingOfferRuleMutationHookResult = ReturnType<typeof useStoreMarketingOfferRuleMutation>;
export type StoreMarketingOfferRuleMutationResult = Apollo.MutationResult<StoreMarketingOfferRuleMutation>;
export type StoreMarketingOfferRuleMutationOptions = Apollo.BaseMutationOptions<StoreMarketingOfferRuleMutation, StoreMarketingOfferRuleMutationVariables>;
export const RemoveMarketingOfferRuleDocument = gql`
    mutation RemoveMarketingOfferRule($id: ID!) {
  deleteMarketingOfferRule(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type RemoveMarketingOfferRuleMutationFn = Apollo.MutationFunction<RemoveMarketingOfferRuleMutation, RemoveMarketingOfferRuleMutationVariables>;

/**
 * __useRemoveMarketingOfferRuleMutation__
 *
 * To run a mutation, you first call `useRemoveMarketingOfferRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarketingOfferRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarketingOfferRuleMutation, { data, loading, error }] = useRemoveMarketingOfferRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMarketingOfferRuleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarketingOfferRuleMutation, RemoveMarketingOfferRuleMutationVariables>) {
        return Apollo.useMutation<RemoveMarketingOfferRuleMutation, RemoveMarketingOfferRuleMutationVariables>(RemoveMarketingOfferRuleDocument, baseOptions);
      }
export type RemoveMarketingOfferRuleMutationHookResult = ReturnType<typeof useRemoveMarketingOfferRuleMutation>;
export type RemoveMarketingOfferRuleMutationResult = Apollo.MutationResult<RemoveMarketingOfferRuleMutation>;
export type RemoveMarketingOfferRuleMutationOptions = Apollo.BaseMutationOptions<RemoveMarketingOfferRuleMutation, RemoveMarketingOfferRuleMutationVariables>;
export const ChangeMarketingPipelineKindDocument = gql`
    mutation ChangeMarketingPipelineKind($id: ID!, $funnelKind: String!, $locked: Boolean!) {
  setMarketingPipelineKind(id: $id, funnelKind: $funnelKind, locked: $locked) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type ChangeMarketingPipelineKindMutationFn = Apollo.MutationFunction<ChangeMarketingPipelineKindMutation, ChangeMarketingPipelineKindMutationVariables>;

/**
 * __useChangeMarketingPipelineKindMutation__
 *
 * To run a mutation, you first call `useChangeMarketingPipelineKindMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMarketingPipelineKindMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMarketingPipelineKindMutation, { data, loading, error }] = useChangeMarketingPipelineKindMutation({
 *   variables: {
 *      id: // value for 'id'
 *      funnelKind: // value for 'funnelKind'
 *      locked: // value for 'locked'
 *   },
 * });
 */
export function useChangeMarketingPipelineKindMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMarketingPipelineKindMutation, ChangeMarketingPipelineKindMutationVariables>) {
        return Apollo.useMutation<ChangeMarketingPipelineKindMutation, ChangeMarketingPipelineKindMutationVariables>(ChangeMarketingPipelineKindDocument, baseOptions);
      }
export type ChangeMarketingPipelineKindMutationHookResult = ReturnType<typeof useChangeMarketingPipelineKindMutation>;
export type ChangeMarketingPipelineKindMutationResult = Apollo.MutationResult<ChangeMarketingPipelineKindMutation>;
export type ChangeMarketingPipelineKindMutationOptions = Apollo.BaseMutationOptions<ChangeMarketingPipelineKindMutation, ChangeMarketingPipelineKindMutationVariables>;
export const PinMarketingAdEntityDocument = gql`
    mutation PinMarketingAdEntity($id: ID!, $familySlug: String, $offer: String, $locked: Boolean!) {
  overrideMarketingAdEntity(
    id: $id
    familySlug: $familySlug
    offer: $offer
    locked: $locked
  ) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type PinMarketingAdEntityMutationFn = Apollo.MutationFunction<PinMarketingAdEntityMutation, PinMarketingAdEntityMutationVariables>;

/**
 * __usePinMarketingAdEntityMutation__
 *
 * To run a mutation, you first call `usePinMarketingAdEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinMarketingAdEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinMarketingAdEntityMutation, { data, loading, error }] = usePinMarketingAdEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      familySlug: // value for 'familySlug'
 *      offer: // value for 'offer'
 *      locked: // value for 'locked'
 *   },
 * });
 */
export function usePinMarketingAdEntityMutation(baseOptions?: Apollo.MutationHookOptions<PinMarketingAdEntityMutation, PinMarketingAdEntityMutationVariables>) {
        return Apollo.useMutation<PinMarketingAdEntityMutation, PinMarketingAdEntityMutationVariables>(PinMarketingAdEntityDocument, baseOptions);
      }
export type PinMarketingAdEntityMutationHookResult = ReturnType<typeof usePinMarketingAdEntityMutation>;
export type PinMarketingAdEntityMutationResult = Apollo.MutationResult<PinMarketingAdEntityMutation>;
export type PinMarketingAdEntityMutationOptions = Apollo.BaseMutationOptions<PinMarketingAdEntityMutation, PinMarketingAdEntityMutationVariables>;
export const CorrectMarketingSaleDocument = gql`
    mutation CorrectMarketingSale($input: MarketingSaleOverrideInput!) {
  overrideMarketingSale(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type CorrectMarketingSaleMutationFn = Apollo.MutationFunction<CorrectMarketingSaleMutation, CorrectMarketingSaleMutationVariables>;

/**
 * __useCorrectMarketingSaleMutation__
 *
 * To run a mutation, you first call `useCorrectMarketingSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorrectMarketingSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [correctMarketingSaleMutation, { data, loading, error }] = useCorrectMarketingSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCorrectMarketingSaleMutation(baseOptions?: Apollo.MutationHookOptions<CorrectMarketingSaleMutation, CorrectMarketingSaleMutationVariables>) {
        return Apollo.useMutation<CorrectMarketingSaleMutation, CorrectMarketingSaleMutationVariables>(CorrectMarketingSaleDocument, baseOptions);
      }
export type CorrectMarketingSaleMutationHookResult = ReturnType<typeof useCorrectMarketingSaleMutation>;
export type CorrectMarketingSaleMutationResult = Apollo.MutationResult<CorrectMarketingSaleMutation>;
export type CorrectMarketingSaleMutationOptions = Apollo.BaseMutationOptions<CorrectMarketingSaleMutation, CorrectMarketingSaleMutationVariables>;
export const SetMarketingPlanTargetDocument = gql`
    mutation SetMarketingPlanTarget($input: MarketingTargetInput!) {
  setMarketingTarget(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type SetMarketingPlanTargetMutationFn = Apollo.MutationFunction<SetMarketingPlanTargetMutation, SetMarketingPlanTargetMutationVariables>;

/**
 * __useSetMarketingPlanTargetMutation__
 *
 * To run a mutation, you first call `useSetMarketingPlanTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMarketingPlanTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMarketingPlanTargetMutation, { data, loading, error }] = useSetMarketingPlanTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMarketingPlanTargetMutation(baseOptions?: Apollo.MutationHookOptions<SetMarketingPlanTargetMutation, SetMarketingPlanTargetMutationVariables>) {
        return Apollo.useMutation<SetMarketingPlanTargetMutation, SetMarketingPlanTargetMutationVariables>(SetMarketingPlanTargetDocument, baseOptions);
      }
export type SetMarketingPlanTargetMutationHookResult = ReturnType<typeof useSetMarketingPlanTargetMutation>;
export type SetMarketingPlanTargetMutationResult = Apollo.MutationResult<SetMarketingPlanTargetMutation>;
export type SetMarketingPlanTargetMutationOptions = Apollo.BaseMutationOptions<SetMarketingPlanTargetMutation, SetMarketingPlanTargetMutationVariables>;
export const DecideMarketingSignalDocument = gql`
    mutation DecideMarketingSignal($id: ID!, $status: String!) {
  ackMarketingSignal(id: $id, status: $status) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type DecideMarketingSignalMutationFn = Apollo.MutationFunction<DecideMarketingSignalMutation, DecideMarketingSignalMutationVariables>;

/**
 * __useDecideMarketingSignalMutation__
 *
 * To run a mutation, you first call `useDecideMarketingSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecideMarketingSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decideMarketingSignalMutation, { data, loading, error }] = useDecideMarketingSignalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useDecideMarketingSignalMutation(baseOptions?: Apollo.MutationHookOptions<DecideMarketingSignalMutation, DecideMarketingSignalMutationVariables>) {
        return Apollo.useMutation<DecideMarketingSignalMutation, DecideMarketingSignalMutationVariables>(DecideMarketingSignalDocument, baseOptions);
      }
export type DecideMarketingSignalMutationHookResult = ReturnType<typeof useDecideMarketingSignalMutation>;
export type DecideMarketingSignalMutationResult = Apollo.MutationResult<DecideMarketingSignalMutation>;
export type DecideMarketingSignalMutationOptions = Apollo.BaseMutationOptions<DecideMarketingSignalMutation, DecideMarketingSignalMutationVariables>;
export const StoreMarketingCampaignAliasDocument = gql`
    mutation StoreMarketingCampaignAlias($input: MarketingCampaignAliasInput!) {
  saveMarketingCampaignAlias(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    alias {
      ...MarketingCampaignAliasFields
    }
  }
}
    ${MarketingCampaignAliasFieldsFragmentDoc}`;
export type StoreMarketingCampaignAliasMutationFn = Apollo.MutationFunction<StoreMarketingCampaignAliasMutation, StoreMarketingCampaignAliasMutationVariables>;

/**
 * __useStoreMarketingCampaignAliasMutation__
 *
 * To run a mutation, you first call `useStoreMarketingCampaignAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMarketingCampaignAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMarketingCampaignAliasMutation, { data, loading, error }] = useStoreMarketingCampaignAliasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreMarketingCampaignAliasMutation(baseOptions?: Apollo.MutationHookOptions<StoreMarketingCampaignAliasMutation, StoreMarketingCampaignAliasMutationVariables>) {
        return Apollo.useMutation<StoreMarketingCampaignAliasMutation, StoreMarketingCampaignAliasMutationVariables>(StoreMarketingCampaignAliasDocument, baseOptions);
      }
export type StoreMarketingCampaignAliasMutationHookResult = ReturnType<typeof useStoreMarketingCampaignAliasMutation>;
export type StoreMarketingCampaignAliasMutationResult = Apollo.MutationResult<StoreMarketingCampaignAliasMutation>;
export type StoreMarketingCampaignAliasMutationOptions = Apollo.BaseMutationOptions<StoreMarketingCampaignAliasMutation, StoreMarketingCampaignAliasMutationVariables>;
export const RemoveMarketingCampaignAliasDocument = gql`
    mutation RemoveMarketingCampaignAlias($id: ID!) {
  deleteMarketingCampaignAlias(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type RemoveMarketingCampaignAliasMutationFn = Apollo.MutationFunction<RemoveMarketingCampaignAliasMutation, RemoveMarketingCampaignAliasMutationVariables>;

/**
 * __useRemoveMarketingCampaignAliasMutation__
 *
 * To run a mutation, you first call `useRemoveMarketingCampaignAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarketingCampaignAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarketingCampaignAliasMutation, { data, loading, error }] = useRemoveMarketingCampaignAliasMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMarketingCampaignAliasMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarketingCampaignAliasMutation, RemoveMarketingCampaignAliasMutationVariables>) {
        return Apollo.useMutation<RemoveMarketingCampaignAliasMutation, RemoveMarketingCampaignAliasMutationVariables>(RemoveMarketingCampaignAliasDocument, baseOptions);
      }
export type RemoveMarketingCampaignAliasMutationHookResult = ReturnType<typeof useRemoveMarketingCampaignAliasMutation>;
export type RemoveMarketingCampaignAliasMutationResult = Apollo.MutationResult<RemoveMarketingCampaignAliasMutation>;
export type RemoveMarketingCampaignAliasMutationOptions = Apollo.BaseMutationOptions<RemoveMarketingCampaignAliasMutation, RemoveMarketingCampaignAliasMutationVariables>;
export const StoreMarketingSearchSettingsDocument = gql`
    mutation StoreMarketingSearchSettings($brandRegex: String, $ga4KeyEvents: [String!], $siteHosts: [String!]) {
  saveMarketingSearchSettings(
    brandRegex: $brandRegex
    ga4KeyEvents: $ga4KeyEvents
    siteHosts: $siteHosts
  ) {
    success
    customErrors {
      field
      code
      message
    }
    brandRegex
    ga4KeyEvents
    siteHosts
  }
}
    `;
export type StoreMarketingSearchSettingsMutationFn = Apollo.MutationFunction<StoreMarketingSearchSettingsMutation, StoreMarketingSearchSettingsMutationVariables>;

/**
 * __useStoreMarketingSearchSettingsMutation__
 *
 * To run a mutation, you first call `useStoreMarketingSearchSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMarketingSearchSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMarketingSearchSettingsMutation, { data, loading, error }] = useStoreMarketingSearchSettingsMutation({
 *   variables: {
 *      brandRegex: // value for 'brandRegex'
 *      ga4KeyEvents: // value for 'ga4KeyEvents'
 *      siteHosts: // value for 'siteHosts'
 *   },
 * });
 */
export function useStoreMarketingSearchSettingsMutation(baseOptions?: Apollo.MutationHookOptions<StoreMarketingSearchSettingsMutation, StoreMarketingSearchSettingsMutationVariables>) {
        return Apollo.useMutation<StoreMarketingSearchSettingsMutation, StoreMarketingSearchSettingsMutationVariables>(StoreMarketingSearchSettingsDocument, baseOptions);
      }
export type StoreMarketingSearchSettingsMutationHookResult = ReturnType<typeof useStoreMarketingSearchSettingsMutation>;
export type StoreMarketingSearchSettingsMutationResult = Apollo.MutationResult<StoreMarketingSearchSettingsMutation>;
export type StoreMarketingSearchSettingsMutationOptions = Apollo.BaseMutationOptions<StoreMarketingSearchSettingsMutation, StoreMarketingSearchSettingsMutationVariables>;
export const QueueMarketingDigestRebuildDocument = gql`
    mutation QueueMarketingDigestRebuild($isoWeek: String) {
  generateMarketingDigest(isoWeek: $isoWeek) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type QueueMarketingDigestRebuildMutationFn = Apollo.MutationFunction<QueueMarketingDigestRebuildMutation, QueueMarketingDigestRebuildMutationVariables>;

/**
 * __useQueueMarketingDigestRebuildMutation__
 *
 * To run a mutation, you first call `useQueueMarketingDigestRebuildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueMarketingDigestRebuildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueMarketingDigestRebuildMutation, { data, loading, error }] = useQueueMarketingDigestRebuildMutation({
 *   variables: {
 *      isoWeek: // value for 'isoWeek'
 *   },
 * });
 */
export function useQueueMarketingDigestRebuildMutation(baseOptions?: Apollo.MutationHookOptions<QueueMarketingDigestRebuildMutation, QueueMarketingDigestRebuildMutationVariables>) {
        return Apollo.useMutation<QueueMarketingDigestRebuildMutation, QueueMarketingDigestRebuildMutationVariables>(QueueMarketingDigestRebuildDocument, baseOptions);
      }
export type QueueMarketingDigestRebuildMutationHookResult = ReturnType<typeof useQueueMarketingDigestRebuildMutation>;
export type QueueMarketingDigestRebuildMutationResult = Apollo.MutationResult<QueueMarketingDigestRebuildMutation>;
export type QueueMarketingDigestRebuildMutationOptions = Apollo.BaseMutationOptions<QueueMarketingDigestRebuildMutation, QueueMarketingDigestRebuildMutationVariables>;
export const StoreMarketingSignalRoutingDocument = gql`
    mutation StoreMarketingSignalRouting($input: MarketingSignalRoutingInput!) {
  saveMarketingSignalRouting(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type StoreMarketingSignalRoutingMutationFn = Apollo.MutationFunction<StoreMarketingSignalRoutingMutation, StoreMarketingSignalRoutingMutationVariables>;

/**
 * __useStoreMarketingSignalRoutingMutation__
 *
 * To run a mutation, you first call `useStoreMarketingSignalRoutingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMarketingSignalRoutingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMarketingSignalRoutingMutation, { data, loading, error }] = useStoreMarketingSignalRoutingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreMarketingSignalRoutingMutation(baseOptions?: Apollo.MutationHookOptions<StoreMarketingSignalRoutingMutation, StoreMarketingSignalRoutingMutationVariables>) {
        return Apollo.useMutation<StoreMarketingSignalRoutingMutation, StoreMarketingSignalRoutingMutationVariables>(StoreMarketingSignalRoutingDocument, baseOptions);
      }
export type StoreMarketingSignalRoutingMutationHookResult = ReturnType<typeof useStoreMarketingSignalRoutingMutation>;
export type StoreMarketingSignalRoutingMutationResult = Apollo.MutationResult<StoreMarketingSignalRoutingMutation>;
export type StoreMarketingSignalRoutingMutationOptions = Apollo.BaseMutationOptions<StoreMarketingSignalRoutingMutation, StoreMarketingSignalRoutingMutationVariables>;
export const SaveMarketingPageTypesFormDocument = gql`
    mutation SaveMarketingPageTypesForm($rules: [MarketingPageTypeRuleInput!]!) {
  saveMarketingPageTypes(rules: $rules) {
    success
    customErrors {
      field
      code
      message
    }
    rules {
      type
      regex
    }
    changed
  }
}
    `;
export type SaveMarketingPageTypesFormMutationFn = Apollo.MutationFunction<SaveMarketingPageTypesFormMutation, SaveMarketingPageTypesFormMutationVariables>;

/**
 * __useSaveMarketingPageTypesFormMutation__
 *
 * To run a mutation, you first call `useSaveMarketingPageTypesFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMarketingPageTypesFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMarketingPageTypesFormMutation, { data, loading, error }] = useSaveMarketingPageTypesFormMutation({
 *   variables: {
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useSaveMarketingPageTypesFormMutation(baseOptions?: Apollo.MutationHookOptions<SaveMarketingPageTypesFormMutation, SaveMarketingPageTypesFormMutationVariables>) {
        return Apollo.useMutation<SaveMarketingPageTypesFormMutation, SaveMarketingPageTypesFormMutationVariables>(SaveMarketingPageTypesFormDocument, baseOptions);
      }
export type SaveMarketingPageTypesFormMutationHookResult = ReturnType<typeof useSaveMarketingPageTypesFormMutation>;
export type SaveMarketingPageTypesFormMutationResult = Apollo.MutationResult<SaveMarketingPageTypesFormMutation>;
export type SaveMarketingPageTypesFormMutationOptions = Apollo.BaseMutationOptions<SaveMarketingPageTypesFormMutation, SaveMarketingPageTypesFormMutationVariables>;
export const SaveMarketingSeoSettingsFormDocument = gql`
    mutation SaveMarketingSeoSettingsForm($input: MarketingSeoSettingsInput!) {
  saveMarketingSeoSettings(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    settings {
      ownDomain
      locationCode
      languageCode
      device
      depth
      maxTracked
      aiRepeats
      minGapVolume
      excludedTopics
      trackedCount
    }
    domains {
      id
      domain
      label
      isOwn
      active
      source
      brandRegex
      suggestedMetrics
    }
  }
}
    `;
export type SaveMarketingSeoSettingsFormMutationFn = Apollo.MutationFunction<SaveMarketingSeoSettingsFormMutation, SaveMarketingSeoSettingsFormMutationVariables>;

/**
 * __useSaveMarketingSeoSettingsFormMutation__
 *
 * To run a mutation, you first call `useSaveMarketingSeoSettingsFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMarketingSeoSettingsFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMarketingSeoSettingsFormMutation, { data, loading, error }] = useSaveMarketingSeoSettingsFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMarketingSeoSettingsFormMutation(baseOptions?: Apollo.MutationHookOptions<SaveMarketingSeoSettingsFormMutation, SaveMarketingSeoSettingsFormMutationVariables>) {
        return Apollo.useMutation<SaveMarketingSeoSettingsFormMutation, SaveMarketingSeoSettingsFormMutationVariables>(SaveMarketingSeoSettingsFormDocument, baseOptions);
      }
export type SaveMarketingSeoSettingsFormMutationHookResult = ReturnType<typeof useSaveMarketingSeoSettingsFormMutation>;
export type SaveMarketingSeoSettingsFormMutationResult = Apollo.MutationResult<SaveMarketingSeoSettingsFormMutation>;
export type SaveMarketingSeoSettingsFormMutationOptions = Apollo.BaseMutationOptions<SaveMarketingSeoSettingsFormMutation, SaveMarketingSeoSettingsFormMutationVariables>;
export const SaveMarketingSeoKeywordFlagsDocument = gql`
    mutation SaveMarketingSeoKeywordFlags($id: ID!, $excluded: Boolean, $tracked: Boolean) {
  saveMarketingSeoKeyword(id: $id, excluded: $excluded, tracked: $tracked) {
    success
    customErrors {
      field
      code
      message
    }
    id
    tracked
    excluded
  }
}
    `;
export type SaveMarketingSeoKeywordFlagsMutationFn = Apollo.MutationFunction<SaveMarketingSeoKeywordFlagsMutation, SaveMarketingSeoKeywordFlagsMutationVariables>;

/**
 * __useSaveMarketingSeoKeywordFlagsMutation__
 *
 * To run a mutation, you first call `useSaveMarketingSeoKeywordFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMarketingSeoKeywordFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMarketingSeoKeywordFlagsMutation, { data, loading, error }] = useSaveMarketingSeoKeywordFlagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      excluded: // value for 'excluded'
 *      tracked: // value for 'tracked'
 *   },
 * });
 */
export function useSaveMarketingSeoKeywordFlagsMutation(baseOptions?: Apollo.MutationHookOptions<SaveMarketingSeoKeywordFlagsMutation, SaveMarketingSeoKeywordFlagsMutationVariables>) {
        return Apollo.useMutation<SaveMarketingSeoKeywordFlagsMutation, SaveMarketingSeoKeywordFlagsMutationVariables>(SaveMarketingSeoKeywordFlagsDocument, baseOptions);
      }
export type SaveMarketingSeoKeywordFlagsMutationHookResult = ReturnType<typeof useSaveMarketingSeoKeywordFlagsMutation>;
export type SaveMarketingSeoKeywordFlagsMutationResult = Apollo.MutationResult<SaveMarketingSeoKeywordFlagsMutation>;
export type SaveMarketingSeoKeywordFlagsMutationOptions = Apollo.BaseMutationOptions<SaveMarketingSeoKeywordFlagsMutation, SaveMarketingSeoKeywordFlagsMutationVariables>;
export const AddMarketingSeoKeywordsFormDocument = gql`
    mutation AddMarketingSeoKeywordsForm($keywords: [String!]!, $familySlug: String) {
  addMarketingSeoKeywords(keywords: $keywords, familySlug: $familySlug) {
    success
    customErrors {
      field
      code
      message
    }
    added
    existing
    tracked
    rejected
  }
}
    `;
export type AddMarketingSeoKeywordsFormMutationFn = Apollo.MutationFunction<AddMarketingSeoKeywordsFormMutation, AddMarketingSeoKeywordsFormMutationVariables>;

/**
 * __useAddMarketingSeoKeywordsFormMutation__
 *
 * To run a mutation, you first call `useAddMarketingSeoKeywordsFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMarketingSeoKeywordsFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMarketingSeoKeywordsFormMutation, { data, loading, error }] = useAddMarketingSeoKeywordsFormMutation({
 *   variables: {
 *      keywords: // value for 'keywords'
 *      familySlug: // value for 'familySlug'
 *   },
 * });
 */
export function useAddMarketingSeoKeywordsFormMutation(baseOptions?: Apollo.MutationHookOptions<AddMarketingSeoKeywordsFormMutation, AddMarketingSeoKeywordsFormMutationVariables>) {
        return Apollo.useMutation<AddMarketingSeoKeywordsFormMutation, AddMarketingSeoKeywordsFormMutationVariables>(AddMarketingSeoKeywordsFormDocument, baseOptions);
      }
export type AddMarketingSeoKeywordsFormMutationHookResult = ReturnType<typeof useAddMarketingSeoKeywordsFormMutation>;
export type AddMarketingSeoKeywordsFormMutationResult = Apollo.MutationResult<AddMarketingSeoKeywordsFormMutation>;
export type AddMarketingSeoKeywordsFormMutationOptions = Apollo.BaseMutationOptions<AddMarketingSeoKeywordsFormMutation, AddMarketingSeoKeywordsFormMutationVariables>;
export const SaveMarketingSeoQuestionFormDocument = gql`
    mutation SaveMarketingSeoQuestionForm($input: MarketingSeoQuestionInput!) {
  saveMarketingSeoQuestion(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    question {
      id
      familySlug
      group
      textPl
      active
      sort
      version
      source
    }
  }
}
    `;
export type SaveMarketingSeoQuestionFormMutationFn = Apollo.MutationFunction<SaveMarketingSeoQuestionFormMutation, SaveMarketingSeoQuestionFormMutationVariables>;

/**
 * __useSaveMarketingSeoQuestionFormMutation__
 *
 * To run a mutation, you first call `useSaveMarketingSeoQuestionFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMarketingSeoQuestionFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMarketingSeoQuestionFormMutation, { data, loading, error }] = useSaveMarketingSeoQuestionFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMarketingSeoQuestionFormMutation(baseOptions?: Apollo.MutationHookOptions<SaveMarketingSeoQuestionFormMutation, SaveMarketingSeoQuestionFormMutationVariables>) {
        return Apollo.useMutation<SaveMarketingSeoQuestionFormMutation, SaveMarketingSeoQuestionFormMutationVariables>(SaveMarketingSeoQuestionFormDocument, baseOptions);
      }
export type SaveMarketingSeoQuestionFormMutationHookResult = ReturnType<typeof useSaveMarketingSeoQuestionFormMutation>;
export type SaveMarketingSeoQuestionFormMutationResult = Apollo.MutationResult<SaveMarketingSeoQuestionFormMutation>;
export type SaveMarketingSeoQuestionFormMutationOptions = Apollo.BaseMutationOptions<SaveMarketingSeoQuestionFormMutation, SaveMarketingSeoQuestionFormMutationVariables>;
export const RemoveMarketingSeoQuestionDocument = gql`
    mutation RemoveMarketingSeoQuestion($id: ID!) {
  deleteMarketingSeoQuestion(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
    deleted
  }
}
    `;
export type RemoveMarketingSeoQuestionMutationFn = Apollo.MutationFunction<RemoveMarketingSeoQuestionMutation, RemoveMarketingSeoQuestionMutationVariables>;

/**
 * __useRemoveMarketingSeoQuestionMutation__
 *
 * To run a mutation, you first call `useRemoveMarketingSeoQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarketingSeoQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarketingSeoQuestionMutation, { data, loading, error }] = useRemoveMarketingSeoQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMarketingSeoQuestionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarketingSeoQuestionMutation, RemoveMarketingSeoQuestionMutationVariables>) {
        return Apollo.useMutation<RemoveMarketingSeoQuestionMutation, RemoveMarketingSeoQuestionMutationVariables>(RemoveMarketingSeoQuestionDocument, baseOptions);
      }
export type RemoveMarketingSeoQuestionMutationHookResult = ReturnType<typeof useRemoveMarketingSeoQuestionMutation>;
export type RemoveMarketingSeoQuestionMutationResult = Apollo.MutationResult<RemoveMarketingSeoQuestionMutation>;
export type RemoveMarketingSeoQuestionMutationOptions = Apollo.BaseMutationOptions<RemoveMarketingSeoQuestionMutation, RemoveMarketingSeoQuestionMutationVariables>;
export const DecideMarketingSeoOpportunitiesDocument = gql`
    mutation DecideMarketingSeoOpportunities($ids: [ID!]!, $status: String!, $note: String) {
  setMarketingSeoOpportunityStatus(ids: $ids, status: $status, note: $note) {
    success
    customErrors {
      field
      code
      message
    }
    updated
    opportunities {
      ...MarketingSeoOpportunityFields
    }
  }
}
    ${MarketingSeoOpportunityFieldsFragmentDoc}`;
export type DecideMarketingSeoOpportunitiesMutationFn = Apollo.MutationFunction<DecideMarketingSeoOpportunitiesMutation, DecideMarketingSeoOpportunitiesMutationVariables>;

/**
 * __useDecideMarketingSeoOpportunitiesMutation__
 *
 * To run a mutation, you first call `useDecideMarketingSeoOpportunitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecideMarketingSeoOpportunitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decideMarketingSeoOpportunitiesMutation, { data, loading, error }] = useDecideMarketingSeoOpportunitiesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useDecideMarketingSeoOpportunitiesMutation(baseOptions?: Apollo.MutationHookOptions<DecideMarketingSeoOpportunitiesMutation, DecideMarketingSeoOpportunitiesMutationVariables>) {
        return Apollo.useMutation<DecideMarketingSeoOpportunitiesMutation, DecideMarketingSeoOpportunitiesMutationVariables>(DecideMarketingSeoOpportunitiesDocument, baseOptions);
      }
export type DecideMarketingSeoOpportunitiesMutationHookResult = ReturnType<typeof useDecideMarketingSeoOpportunitiesMutation>;
export type DecideMarketingSeoOpportunitiesMutationResult = Apollo.MutationResult<DecideMarketingSeoOpportunitiesMutation>;
export type DecideMarketingSeoOpportunitiesMutationOptions = Apollo.BaseMutationOptions<DecideMarketingSeoOpportunitiesMutation, DecideMarketingSeoOpportunitiesMutationVariables>;
export const RunMarketingSeoJobDocument = gql`
    mutation RunMarketingSeoJob($kind: String!, $dryRun: Boolean) {
  runMarketingSeo(kind: $kind, dryRun: $dryRun) {
    success
    customErrors {
      field
      code
      message
    }
    estimate {
      kind
      estimateUsd
      keywords
      questions
      ai
      upperBound
      refusal
      items {
        endpoint
        requests
        results
        costUsd
      }
    }
    queued
    dryRun
  }
}
    `;
export type RunMarketingSeoJobMutationFn = Apollo.MutationFunction<RunMarketingSeoJobMutation, RunMarketingSeoJobMutationVariables>;

/**
 * __useRunMarketingSeoJobMutation__
 *
 * To run a mutation, you first call `useRunMarketingSeoJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunMarketingSeoJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runMarketingSeoJobMutation, { data, loading, error }] = useRunMarketingSeoJobMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useRunMarketingSeoJobMutation(baseOptions?: Apollo.MutationHookOptions<RunMarketingSeoJobMutation, RunMarketingSeoJobMutationVariables>) {
        return Apollo.useMutation<RunMarketingSeoJobMutation, RunMarketingSeoJobMutationVariables>(RunMarketingSeoJobDocument, baseOptions);
      }
export type RunMarketingSeoJobMutationHookResult = ReturnType<typeof useRunMarketingSeoJobMutation>;
export type RunMarketingSeoJobMutationResult = Apollo.MutationResult<RunMarketingSeoJobMutation>;
export type RunMarketingSeoJobMutationOptions = Apollo.BaseMutationOptions<RunMarketingSeoJobMutation, RunMarketingSeoJobMutationVariables>;
export const MaterialCreateDocument = gql`
    mutation MaterialCreate($input: CreateMaterialInput!) {
  createMaterial(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    material {
      id
      pk
      kind
      title
      description
      dueDate
      createdAt
      lesson {
        id
        name
        number
      }
    }
  }
}
    `;
export type MaterialCreateMutationFn = Apollo.MutationFunction<MaterialCreateMutation, MaterialCreateMutationVariables>;

/**
 * __useMaterialCreateMutation__
 *
 * To run a mutation, you first call `useMaterialCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaterialCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [materialCreateMutation, { data, loading, error }] = useMaterialCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMaterialCreateMutation(baseOptions?: Apollo.MutationHookOptions<MaterialCreateMutation, MaterialCreateMutationVariables>) {
        return Apollo.useMutation<MaterialCreateMutation, MaterialCreateMutationVariables>(MaterialCreateDocument, baseOptions);
      }
export type MaterialCreateMutationHookResult = ReturnType<typeof useMaterialCreateMutation>;
export type MaterialCreateMutationResult = Apollo.MutationResult<MaterialCreateMutation>;
export type MaterialCreateMutationOptions = Apollo.BaseMutationOptions<MaterialCreateMutation, MaterialCreateMutationVariables>;
export const MaterialUpdateDocument = gql`
    mutation MaterialUpdate($id: ID!, $input: UpdateMaterialInput!) {
  updateMaterial(id: $id, input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    material {
      id
      pk
      kind
      title
      description
      dueDate
      updatedAt
    }
  }
}
    `;
export type MaterialUpdateMutationFn = Apollo.MutationFunction<MaterialUpdateMutation, MaterialUpdateMutationVariables>;

/**
 * __useMaterialUpdateMutation__
 *
 * To run a mutation, you first call `useMaterialUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaterialUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [materialUpdateMutation, { data, loading, error }] = useMaterialUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMaterialUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MaterialUpdateMutation, MaterialUpdateMutationVariables>) {
        return Apollo.useMutation<MaterialUpdateMutation, MaterialUpdateMutationVariables>(MaterialUpdateDocument, baseOptions);
      }
export type MaterialUpdateMutationHookResult = ReturnType<typeof useMaterialUpdateMutation>;
export type MaterialUpdateMutationResult = Apollo.MutationResult<MaterialUpdateMutation>;
export type MaterialUpdateMutationOptions = Apollo.BaseMutationOptions<MaterialUpdateMutation, MaterialUpdateMutationVariables>;
export const MaterialDeleteDocument = gql`
    mutation MaterialDelete($id: ID!) {
  deleteMaterial(id: $id) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type MaterialDeleteMutationFn = Apollo.MutationFunction<MaterialDeleteMutation, MaterialDeleteMutationVariables>;

/**
 * __useMaterialDeleteMutation__
 *
 * To run a mutation, you first call `useMaterialDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaterialDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [materialDeleteMutation, { data, loading, error }] = useMaterialDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMaterialDeleteMutation(baseOptions?: Apollo.MutationHookOptions<MaterialDeleteMutation, MaterialDeleteMutationVariables>) {
        return Apollo.useMutation<MaterialDeleteMutation, MaterialDeleteMutationVariables>(MaterialDeleteDocument, baseOptions);
      }
export type MaterialDeleteMutationHookResult = ReturnType<typeof useMaterialDeleteMutation>;
export type MaterialDeleteMutationResult = Apollo.MutationResult<MaterialDeleteMutation>;
export type MaterialDeleteMutationOptions = Apollo.BaseMutationOptions<MaterialDeleteMutation, MaterialDeleteMutationVariables>;
export const McpRevokeConnectionDocument = gql`
    mutation McpRevokeConnection($id: ID!) {
  revokeMcpConnection(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type McpRevokeConnectionMutationFn = Apollo.MutationFunction<McpRevokeConnectionMutation, McpRevokeConnectionMutationVariables>;

/**
 * __useMcpRevokeConnectionMutation__
 *
 * To run a mutation, you first call `useMcpRevokeConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMcpRevokeConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mcpRevokeConnectionMutation, { data, loading, error }] = useMcpRevokeConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMcpRevokeConnectionMutation(baseOptions?: Apollo.MutationHookOptions<McpRevokeConnectionMutation, McpRevokeConnectionMutationVariables>) {
        return Apollo.useMutation<McpRevokeConnectionMutation, McpRevokeConnectionMutationVariables>(McpRevokeConnectionDocument, baseOptions);
      }
export type McpRevokeConnectionMutationHookResult = ReturnType<typeof useMcpRevokeConnectionMutation>;
export type McpRevokeConnectionMutationResult = Apollo.MutationResult<McpRevokeConnectionMutation>;
export type McpRevokeConnectionMutationOptions = Apollo.BaseMutationOptions<McpRevokeConnectionMutation, McpRevokeConnectionMutationVariables>;
export const MarkNotificationsReadDocument = gql`
    mutation MarkNotificationsRead($ids: [ID!]!) {
  markStaffNotificationsRead(ids: $ids) {
    success
    customErrors {
      field
      message
      code
    }
    summary {
      unreadCount
      totalCount
      soundAlarm {
        active
        taskId
        title
      }
    }
  }
}
    `;
export type MarkNotificationsReadMutationFn = Apollo.MutationFunction<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>;

/**
 * __useMarkNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsReadMutation, { data, loading, error }] = useMarkNotificationsReadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>) {
        return Apollo.useMutation<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>(MarkNotificationsReadDocument, baseOptions);
      }
export type MarkNotificationsReadMutationHookResult = ReturnType<typeof useMarkNotificationsReadMutation>;
export type MarkNotificationsReadMutationResult = Apollo.MutationResult<MarkNotificationsReadMutation>;
export type MarkNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>;
export const MarkAllNotificationsReadDocument = gql`
    mutation MarkAllNotificationsRead($before: DateTime) {
  markAllStaffNotificationsRead(before: $before) {
    success
    customErrors {
      field
      message
      code
    }
    summary {
      unreadCount
      totalCount
      soundAlarm {
        active
        taskId
        title
      }
    }
  }
}
    `;
export type MarkAllNotificationsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>;

/**
 * __useMarkAllNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsReadMutation, { data, loading, error }] = useMarkAllNotificationsReadMutation({
 *   variables: {
 *      before: // value for 'before'
 *   },
 * });
 */
export function useMarkAllNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>) {
        return Apollo.useMutation<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>(MarkAllNotificationsReadDocument, baseOptions);
      }
export type MarkAllNotificationsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>;
export const SaveNotificationPrefsDocument = gql`
    mutation SaveNotificationPrefs($input: StaffNotificationSettingsInput!) {
  updateStaffNotificationSettings(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    settings {
      soundEnabled
      pollSeconds
      repeatAfterMinutes
      quietFrom
      quietTo
      enabledKinds
      availableKinds {
        key
        label
        enabled
      }
      telegramEnabled
      telegramLinked
      telegramUsername
      telegramLinkedAt
      telegramBlockedAt
      telegramAvailable
      robotRules
      availableRobotRules {
        key
        label
        enabled
        available
      }
    }
  }
}
    `;
export type SaveNotificationPrefsMutationFn = Apollo.MutationFunction<SaveNotificationPrefsMutation, SaveNotificationPrefsMutationVariables>;

/**
 * __useSaveNotificationPrefsMutation__
 *
 * To run a mutation, you first call `useSaveNotificationPrefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNotificationPrefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNotificationPrefsMutation, { data, loading, error }] = useSaveNotificationPrefsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveNotificationPrefsMutation(baseOptions?: Apollo.MutationHookOptions<SaveNotificationPrefsMutation, SaveNotificationPrefsMutationVariables>) {
        return Apollo.useMutation<SaveNotificationPrefsMutation, SaveNotificationPrefsMutationVariables>(SaveNotificationPrefsDocument, baseOptions);
      }
export type SaveNotificationPrefsMutationHookResult = ReturnType<typeof useSaveNotificationPrefsMutation>;
export type SaveNotificationPrefsMutationResult = Apollo.MutationResult<SaveNotificationPrefsMutation>;
export type SaveNotificationPrefsMutationOptions = Apollo.BaseMutationOptions<SaveNotificationPrefsMutation, SaveNotificationPrefsMutationVariables>;
export const StartTelegramLinkDocument = gql`
    mutation StartTelegramLink {
  startTelegramLink {
    success
    customErrors {
      field
      message
      code
    }
    link {
      deepLink
      expiresAt
    }
  }
}
    `;
export type StartTelegramLinkMutationFn = Apollo.MutationFunction<StartTelegramLinkMutation, StartTelegramLinkMutationVariables>;

/**
 * __useStartTelegramLinkMutation__
 *
 * To run a mutation, you first call `useStartTelegramLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTelegramLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTelegramLinkMutation, { data, loading, error }] = useStartTelegramLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartTelegramLinkMutation(baseOptions?: Apollo.MutationHookOptions<StartTelegramLinkMutation, StartTelegramLinkMutationVariables>) {
        return Apollo.useMutation<StartTelegramLinkMutation, StartTelegramLinkMutationVariables>(StartTelegramLinkDocument, baseOptions);
      }
export type StartTelegramLinkMutationHookResult = ReturnType<typeof useStartTelegramLinkMutation>;
export type StartTelegramLinkMutationResult = Apollo.MutationResult<StartTelegramLinkMutation>;
export type StartTelegramLinkMutationOptions = Apollo.BaseMutationOptions<StartTelegramLinkMutation, StartTelegramLinkMutationVariables>;
export const DropTelegramLinkDocument = gql`
    mutation DropTelegramLink {
  unlinkTelegram {
    success
    customErrors {
      field
      message
      code
    }
    settings {
      telegramEnabled
      telegramLinked
      telegramUsername
      telegramLinkedAt
      telegramBlockedAt
      telegramAvailable
    }
  }
}
    `;
export type DropTelegramLinkMutationFn = Apollo.MutationFunction<DropTelegramLinkMutation, DropTelegramLinkMutationVariables>;

/**
 * __useDropTelegramLinkMutation__
 *
 * To run a mutation, you first call `useDropTelegramLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropTelegramLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropTelegramLinkMutation, { data, loading, error }] = useDropTelegramLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useDropTelegramLinkMutation(baseOptions?: Apollo.MutationHookOptions<DropTelegramLinkMutation, DropTelegramLinkMutationVariables>) {
        return Apollo.useMutation<DropTelegramLinkMutation, DropTelegramLinkMutationVariables>(DropTelegramLinkDocument, baseOptions);
      }
export type DropTelegramLinkMutationHookResult = ReturnType<typeof useDropTelegramLinkMutation>;
export type DropTelegramLinkMutationResult = Apollo.MutationResult<DropTelegramLinkMutation>;
export type DropTelegramLinkMutationOptions = Apollo.BaseMutationOptions<DropTelegramLinkMutation, DropTelegramLinkMutationVariables>;
export const ProvisionPandaDocStudentsDocument = gql`
    mutation ProvisionPandaDocStudents($groupId: ID!, $contributionAmount: Float!, $currency: String!, $documents: [ProvisionDocOverrideInput!]!) {
  provisionStudents(
    groupId: $groupId
    contributionAmount: $contributionAmount
    currency: $currency
    documents: $documents
  ) {
    results {
      pandadocId
      success
      skipped
      agreementId
      error
    }
    errors
  }
}
    `;
export type ProvisionPandaDocStudentsMutationFn = Apollo.MutationFunction<ProvisionPandaDocStudentsMutation, ProvisionPandaDocStudentsMutationVariables>;

/**
 * __useProvisionPandaDocStudentsMutation__
 *
 * To run a mutation, you first call `useProvisionPandaDocStudentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionPandaDocStudentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionPandaDocStudentsMutation, { data, loading, error }] = useProvisionPandaDocStudentsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      contributionAmount: // value for 'contributionAmount'
 *      currency: // value for 'currency'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useProvisionPandaDocStudentsMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionPandaDocStudentsMutation, ProvisionPandaDocStudentsMutationVariables>) {
        return Apollo.useMutation<ProvisionPandaDocStudentsMutation, ProvisionPandaDocStudentsMutationVariables>(ProvisionPandaDocStudentsDocument, baseOptions);
      }
export type ProvisionPandaDocStudentsMutationHookResult = ReturnType<typeof useProvisionPandaDocStudentsMutation>;
export type ProvisionPandaDocStudentsMutationResult = Apollo.MutationResult<ProvisionPandaDocStudentsMutation>;
export type ProvisionPandaDocStudentsMutationOptions = Apollo.BaseMutationOptions<ProvisionPandaDocStudentsMutation, ProvisionPandaDocStudentsMutationVariables>;
export const RunPandaDocSyncDocument = gql`
    mutation RunPandaDocSync {
  triggerPandadocSync {
    enqueued
    message
    syncStatus {
      documentsCount
      detailsPending
      lastListSyncAt
      lastDetailsSyncAt
      newestDocDate
      lastDocumentsPulled
      lastRunStatus
      lastError
    }
  }
}
    `;
export type RunPandaDocSyncMutationFn = Apollo.MutationFunction<RunPandaDocSyncMutation, RunPandaDocSyncMutationVariables>;

/**
 * __useRunPandaDocSyncMutation__
 *
 * To run a mutation, you first call `useRunPandaDocSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunPandaDocSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runPandaDocSyncMutation, { data, loading, error }] = useRunPandaDocSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useRunPandaDocSyncMutation(baseOptions?: Apollo.MutationHookOptions<RunPandaDocSyncMutation, RunPandaDocSyncMutationVariables>) {
        return Apollo.useMutation<RunPandaDocSyncMutation, RunPandaDocSyncMutationVariables>(RunPandaDocSyncDocument, baseOptions);
      }
export type RunPandaDocSyncMutationHookResult = ReturnType<typeof useRunPandaDocSyncMutation>;
export type RunPandaDocSyncMutationResult = Apollo.MutationResult<RunPandaDocSyncMutation>;
export type RunPandaDocSyncMutationOptions = Apollo.BaseMutationOptions<RunPandaDocSyncMutation, RunPandaDocSyncMutationVariables>;
export const RunPandaDocReparseDocument = gql`
    mutation RunPandaDocReparse($markRefetch: Boolean) {
  reparsePandadocRecipients(markRefetch: $markRefetch) {
    enqueued
    message
    syncStatus {
      documentsCount
      detailsPending
      lastRunStatus
      lastError
      syncRunning
    }
  }
}
    `;
export type RunPandaDocReparseMutationFn = Apollo.MutationFunction<RunPandaDocReparseMutation, RunPandaDocReparseMutationVariables>;

/**
 * __useRunPandaDocReparseMutation__
 *
 * To run a mutation, you first call `useRunPandaDocReparseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunPandaDocReparseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runPandaDocReparseMutation, { data, loading, error }] = useRunPandaDocReparseMutation({
 *   variables: {
 *      markRefetch: // value for 'markRefetch'
 *   },
 * });
 */
export function useRunPandaDocReparseMutation(baseOptions?: Apollo.MutationHookOptions<RunPandaDocReparseMutation, RunPandaDocReparseMutationVariables>) {
        return Apollo.useMutation<RunPandaDocReparseMutation, RunPandaDocReparseMutationVariables>(RunPandaDocReparseDocument, baseOptions);
      }
export type RunPandaDocReparseMutationHookResult = ReturnType<typeof useRunPandaDocReparseMutation>;
export type RunPandaDocReparseMutationResult = Apollo.MutationResult<RunPandaDocReparseMutation>;
export type RunPandaDocReparseMutationOptions = Apollo.BaseMutationOptions<RunPandaDocReparseMutation, RunPandaDocReparseMutationVariables>;
export const LinkPandaDocDocumentDocument = gql`
    mutation LinkPandaDocDocument($pandadocId: String!, $agreementId: ID!) {
  linkPandadocDocument(pandadocId: $pandadocId, agreementId: $agreementId) {
    document {
      id
      pandadocId
      matchType
      agreement {
        id
        agreementTitle
      }
    }
    errors
  }
}
    `;
export type LinkPandaDocDocumentMutationFn = Apollo.MutationFunction<LinkPandaDocDocumentMutation, LinkPandaDocDocumentMutationVariables>;

/**
 * __useLinkPandaDocDocumentMutation__
 *
 * To run a mutation, you first call `useLinkPandaDocDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkPandaDocDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkPandaDocDocumentMutation, { data, loading, error }] = useLinkPandaDocDocumentMutation({
 *   variables: {
 *      pandadocId: // value for 'pandadocId'
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useLinkPandaDocDocumentMutation(baseOptions?: Apollo.MutationHookOptions<LinkPandaDocDocumentMutation, LinkPandaDocDocumentMutationVariables>) {
        return Apollo.useMutation<LinkPandaDocDocumentMutation, LinkPandaDocDocumentMutationVariables>(LinkPandaDocDocumentDocument, baseOptions);
      }
export type LinkPandaDocDocumentMutationHookResult = ReturnType<typeof useLinkPandaDocDocumentMutation>;
export type LinkPandaDocDocumentMutationResult = Apollo.MutationResult<LinkPandaDocDocumentMutation>;
export type LinkPandaDocDocumentMutationOptions = Apollo.BaseMutationOptions<LinkPandaDocDocumentMutation, LinkPandaDocDocumentMutationVariables>;
export const UnlinkPandaDocDocumentDocument = gql`
    mutation UnlinkPandaDocDocument($pandadocId: String!) {
  unlinkPandadocDocument(pandadocId: $pandadocId) {
    document {
      id
      pandadocId
      matchType
      agreement {
        id
        agreementTitle
      }
    }
    errors
  }
}
    `;
export type UnlinkPandaDocDocumentMutationFn = Apollo.MutationFunction<UnlinkPandaDocDocumentMutation, UnlinkPandaDocDocumentMutationVariables>;

/**
 * __useUnlinkPandaDocDocumentMutation__
 *
 * To run a mutation, you first call `useUnlinkPandaDocDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkPandaDocDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkPandaDocDocumentMutation, { data, loading, error }] = useUnlinkPandaDocDocumentMutation({
 *   variables: {
 *      pandadocId: // value for 'pandadocId'
 *   },
 * });
 */
export function useUnlinkPandaDocDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkPandaDocDocumentMutation, UnlinkPandaDocDocumentMutationVariables>) {
        return Apollo.useMutation<UnlinkPandaDocDocumentMutation, UnlinkPandaDocDocumentMutationVariables>(UnlinkPandaDocDocumentDocument, baseOptions);
      }
export type UnlinkPandaDocDocumentMutationHookResult = ReturnType<typeof useUnlinkPandaDocDocumentMutation>;
export type UnlinkPandaDocDocumentMutationResult = Apollo.MutationResult<UnlinkPandaDocDocumentMutation>;
export type UnlinkPandaDocDocumentMutationOptions = Apollo.BaseMutationOptions<UnlinkPandaDocDocumentMutation, UnlinkPandaDocDocumentMutationVariables>;
export const AttachPandadocTeacherDocument = gql`
    mutation AttachPandadocTeacher($pandadocId: String!, $teacherId: ID!) {
  linkPandadocTeacher(pandadocId: $pandadocId, teacherId: $teacherId) {
    document {
      id
      pandadocId
      matchType
      teacher {
        id
      }
    }
    errors
  }
}
    `;
export type AttachPandadocTeacherMutationFn = Apollo.MutationFunction<AttachPandadocTeacherMutation, AttachPandadocTeacherMutationVariables>;

/**
 * __useAttachPandadocTeacherMutation__
 *
 * To run a mutation, you first call `useAttachPandadocTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachPandadocTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachPandadocTeacherMutation, { data, loading, error }] = useAttachPandadocTeacherMutation({
 *   variables: {
 *      pandadocId: // value for 'pandadocId'
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useAttachPandadocTeacherMutation(baseOptions?: Apollo.MutationHookOptions<AttachPandadocTeacherMutation, AttachPandadocTeacherMutationVariables>) {
        return Apollo.useMutation<AttachPandadocTeacherMutation, AttachPandadocTeacherMutationVariables>(AttachPandadocTeacherDocument, baseOptions);
      }
export type AttachPandadocTeacherMutationHookResult = ReturnType<typeof useAttachPandadocTeacherMutation>;
export type AttachPandadocTeacherMutationResult = Apollo.MutationResult<AttachPandadocTeacherMutation>;
export type AttachPandadocTeacherMutationOptions = Apollo.BaseMutationOptions<AttachPandadocTeacherMutation, AttachPandadocTeacherMutationVariables>;
export const DetachPandadocTeacherDocument = gql`
    mutation DetachPandadocTeacher($pandadocId: String!) {
  unlinkPandadocTeacher(pandadocId: $pandadocId) {
    document {
      id
      pandadocId
      matchType
      teacher {
        id
      }
    }
    errors
  }
}
    `;
export type DetachPandadocTeacherMutationFn = Apollo.MutationFunction<DetachPandadocTeacherMutation, DetachPandadocTeacherMutationVariables>;

/**
 * __useDetachPandadocTeacherMutation__
 *
 * To run a mutation, you first call `useDetachPandadocTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachPandadocTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachPandadocTeacherMutation, { data, loading, error }] = useDetachPandadocTeacherMutation({
 *   variables: {
 *      pandadocId: // value for 'pandadocId'
 *   },
 * });
 */
export function useDetachPandadocTeacherMutation(baseOptions?: Apollo.MutationHookOptions<DetachPandadocTeacherMutation, DetachPandadocTeacherMutationVariables>) {
        return Apollo.useMutation<DetachPandadocTeacherMutation, DetachPandadocTeacherMutationVariables>(DetachPandadocTeacherDocument, baseOptions);
      }
export type DetachPandadocTeacherMutationHookResult = ReturnType<typeof useDetachPandadocTeacherMutation>;
export type DetachPandadocTeacherMutationResult = Apollo.MutationResult<DetachPandadocTeacherMutation>;
export type DetachPandadocTeacherMutationOptions = Apollo.BaseMutationOptions<DetachPandadocTeacherMutation, DetachPandadocTeacherMutationVariables>;
export const CreatePlannedPaymentDocument = gql`
    mutation CreatePlannedPayment($input: PlannedPaymentInput!) {
  createPlannedPayment(input: $input) {
    success
    errors
    plannedPayment {
      pk
      direction
      kind
      date
      amount
      currency
      comment
      status
    }
  }
}
    `;
export type CreatePlannedPaymentMutationFn = Apollo.MutationFunction<CreatePlannedPaymentMutation, CreatePlannedPaymentMutationVariables>;

/**
 * __useCreatePlannedPaymentMutation__
 *
 * To run a mutation, you first call `useCreatePlannedPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlannedPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlannedPaymentMutation, { data, loading, error }] = useCreatePlannedPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlannedPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlannedPaymentMutation, CreatePlannedPaymentMutationVariables>) {
        return Apollo.useMutation<CreatePlannedPaymentMutation, CreatePlannedPaymentMutationVariables>(CreatePlannedPaymentDocument, baseOptions);
      }
export type CreatePlannedPaymentMutationHookResult = ReturnType<typeof useCreatePlannedPaymentMutation>;
export type CreatePlannedPaymentMutationResult = Apollo.MutationResult<CreatePlannedPaymentMutation>;
export type CreatePlannedPaymentMutationOptions = Apollo.BaseMutationOptions<CreatePlannedPaymentMutation, CreatePlannedPaymentMutationVariables>;
export const UpdatePlannedPaymentDocument = gql`
    mutation UpdatePlannedPayment($input: UpdatePlannedPaymentInput!) {
  updatePlannedPayment(input: $input) {
    success
    errors
    plannedPayment {
      pk
      date
      amount
      currency
      comment
      status
    }
  }
}
    `;
export type UpdatePlannedPaymentMutationFn = Apollo.MutationFunction<UpdatePlannedPaymentMutation, UpdatePlannedPaymentMutationVariables>;

/**
 * __useUpdatePlannedPaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePlannedPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannedPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlannedPaymentMutation, { data, loading, error }] = useUpdatePlannedPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlannedPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlannedPaymentMutation, UpdatePlannedPaymentMutationVariables>) {
        return Apollo.useMutation<UpdatePlannedPaymentMutation, UpdatePlannedPaymentMutationVariables>(UpdatePlannedPaymentDocument, baseOptions);
      }
export type UpdatePlannedPaymentMutationHookResult = ReturnType<typeof useUpdatePlannedPaymentMutation>;
export type UpdatePlannedPaymentMutationResult = Apollo.MutationResult<UpdatePlannedPaymentMutation>;
export type UpdatePlannedPaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePlannedPaymentMutation, UpdatePlannedPaymentMutationVariables>;
export const DeletePlannedPaymentDocument = gql`
    mutation DeletePlannedPayment($id: ID!) {
  deletePlannedPayment(id: $id) {
    success
    errors
  }
}
    `;
export type DeletePlannedPaymentMutationFn = Apollo.MutationFunction<DeletePlannedPaymentMutation, DeletePlannedPaymentMutationVariables>;

/**
 * __useDeletePlannedPaymentMutation__
 *
 * To run a mutation, you first call `useDeletePlannedPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlannedPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlannedPaymentMutation, { data, loading, error }] = useDeletePlannedPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlannedPaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlannedPaymentMutation, DeletePlannedPaymentMutationVariables>) {
        return Apollo.useMutation<DeletePlannedPaymentMutation, DeletePlannedPaymentMutationVariables>(DeletePlannedPaymentDocument, baseOptions);
      }
export type DeletePlannedPaymentMutationHookResult = ReturnType<typeof useDeletePlannedPaymentMutation>;
export type DeletePlannedPaymentMutationResult = Apollo.MutationResult<DeletePlannedPaymentMutation>;
export type DeletePlannedPaymentMutationOptions = Apollo.BaseMutationOptions<DeletePlannedPaymentMutation, DeletePlannedPaymentMutationVariables>;
export const SetCashBalanceDocument = gql`
    mutation SetCashBalance($amountPln: Float!, $asOfDate: Date!, $legalEntityId: ID, $comment: String) {
  setCashBalance(
    amountPln: $amountPln
    asOfDate: $asOfDate
    legalEntityId: $legalEntityId
    comment: $comment
  ) {
    success
    errors
    cashBalance {
      pk
      asOfDate
      amountPln
    }
  }
}
    `;
export type SetCashBalanceMutationFn = Apollo.MutationFunction<SetCashBalanceMutation, SetCashBalanceMutationVariables>;

/**
 * __useSetCashBalanceMutation__
 *
 * To run a mutation, you first call `useSetCashBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCashBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCashBalanceMutation, { data, loading, error }] = useSetCashBalanceMutation({
 *   variables: {
 *      amountPln: // value for 'amountPln'
 *      asOfDate: // value for 'asOfDate'
 *      legalEntityId: // value for 'legalEntityId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetCashBalanceMutation(baseOptions?: Apollo.MutationHookOptions<SetCashBalanceMutation, SetCashBalanceMutationVariables>) {
        return Apollo.useMutation<SetCashBalanceMutation, SetCashBalanceMutationVariables>(SetCashBalanceDocument, baseOptions);
      }
export type SetCashBalanceMutationHookResult = ReturnType<typeof useSetCashBalanceMutation>;
export type SetCashBalanceMutationResult = Apollo.MutationResult<SetCashBalanceMutation>;
export type SetCashBalanceMutationOptions = Apollo.BaseMutationOptions<SetCashBalanceMutation, SetCashBalanceMutationVariables>;
export const SetExchangeRateDocument = gql`
    mutation SetExchangeRate($currency: String!, $rateToPln: Float!, $effectiveFrom: Date!, $comment: String) {
  setExchangeRate(
    currency: $currency
    rateToPln: $rateToPln
    effectiveFrom: $effectiveFrom
    comment: $comment
  ) {
    success
    errors
    exchangeRate {
      pk
      currency
      rateToPln
      effectiveFrom
    }
  }
}
    `;
export type SetExchangeRateMutationFn = Apollo.MutationFunction<SetExchangeRateMutation, SetExchangeRateMutationVariables>;

/**
 * __useSetExchangeRateMutation__
 *
 * To run a mutation, you first call `useSetExchangeRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExchangeRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExchangeRateMutation, { data, loading, error }] = useSetExchangeRateMutation({
 *   variables: {
 *      currency: // value for 'currency'
 *      rateToPln: // value for 'rateToPln'
 *      effectiveFrom: // value for 'effectiveFrom'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetExchangeRateMutation(baseOptions?: Apollo.MutationHookOptions<SetExchangeRateMutation, SetExchangeRateMutationVariables>) {
        return Apollo.useMutation<SetExchangeRateMutation, SetExchangeRateMutationVariables>(SetExchangeRateDocument, baseOptions);
      }
export type SetExchangeRateMutationHookResult = ReturnType<typeof useSetExchangeRateMutation>;
export type SetExchangeRateMutationResult = Apollo.MutationResult<SetExchangeRateMutation>;
export type SetExchangeRateMutationOptions = Apollo.BaseMutationOptions<SetExchangeRateMutation, SetExchangeRateMutationVariables>;
export const SetPaymentCalendarSettingsDocument = gql`
    mutation SetPaymentCalendarSettings($teacherPayoutDay: Int, $incomeOffsetDays: Int, $legalEntityId: ID) {
  setPaymentCalendarSettings(
    teacherPayoutDay: $teacherPayoutDay
    incomeOffsetDays: $incomeOffsetDays
    legalEntityId: $legalEntityId
  ) {
    success
    errors
    calendarSettings {
      teacherPayoutDay
      incomeOffsetDays
      legalEntityId
    }
  }
}
    `;
export type SetPaymentCalendarSettingsMutationFn = Apollo.MutationFunction<SetPaymentCalendarSettingsMutation, SetPaymentCalendarSettingsMutationVariables>;

/**
 * __useSetPaymentCalendarSettingsMutation__
 *
 * To run a mutation, you first call `useSetPaymentCalendarSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentCalendarSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentCalendarSettingsMutation, { data, loading, error }] = useSetPaymentCalendarSettingsMutation({
 *   variables: {
 *      teacherPayoutDay: // value for 'teacherPayoutDay'
 *      incomeOffsetDays: // value for 'incomeOffsetDays'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useSetPaymentCalendarSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentCalendarSettingsMutation, SetPaymentCalendarSettingsMutationVariables>) {
        return Apollo.useMutation<SetPaymentCalendarSettingsMutation, SetPaymentCalendarSettingsMutationVariables>(SetPaymentCalendarSettingsDocument, baseOptions);
      }
export type SetPaymentCalendarSettingsMutationHookResult = ReturnType<typeof useSetPaymentCalendarSettingsMutation>;
export type SetPaymentCalendarSettingsMutationResult = Apollo.MutationResult<SetPaymentCalendarSettingsMutation>;
export type SetPaymentCalendarSettingsMutationOptions = Apollo.BaseMutationOptions<SetPaymentCalendarSettingsMutation, SetPaymentCalendarSettingsMutationVariables>;
export const OrderPnlExportDocument = gql`
    mutation OrderPnlExport($monthFrom: String!, $monthTo: String!, $fileFormat: String!, $language: String, $groupId: ID) {
  requestPnlExport(
    monthFrom: $monthFrom
    monthTo: $monthTo
    fileFormat: $fileFormat
    language: $language
    groupId: $groupId
  ) {
    success
    customErrors {
      field
      code
      message
    }
    run {
      id
      status
      fileFormat
      language
      monthFrom
      monthTo
      groupId
      groupName
      fileName
      size
      stats
      error
      createdByName
      createdAt
      finishedAt
      isDownloadable
      isFilePurged
    }
  }
}
    `;
export type OrderPnlExportMutationFn = Apollo.MutationFunction<OrderPnlExportMutation, OrderPnlExportMutationVariables>;

/**
 * __useOrderPnlExportMutation__
 *
 * To run a mutation, you first call `useOrderPnlExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPnlExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPnlExportMutation, { data, loading, error }] = useOrderPnlExportMutation({
 *   variables: {
 *      monthFrom: // value for 'monthFrom'
 *      monthTo: // value for 'monthTo'
 *      fileFormat: // value for 'fileFormat'
 *      language: // value for 'language'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useOrderPnlExportMutation(baseOptions?: Apollo.MutationHookOptions<OrderPnlExportMutation, OrderPnlExportMutationVariables>) {
        return Apollo.useMutation<OrderPnlExportMutation, OrderPnlExportMutationVariables>(OrderPnlExportDocument, baseOptions);
      }
export type OrderPnlExportMutationHookResult = ReturnType<typeof useOrderPnlExportMutation>;
export type OrderPnlExportMutationResult = Apollo.MutationResult<OrderPnlExportMutation>;
export type OrderPnlExportMutationOptions = Apollo.BaseMutationOptions<OrderPnlExportMutation, OrderPnlExportMutationVariables>;
export const StoreMailSignatureDocument = gql`
    mutation StoreMailSignature($mailboxEmail: String, $html: String!) {
  saveMailSignature(mailboxEmail: $mailboxEmail, html: $html) {
    id
    mailboxEmail
    html
    source
    importedAt
    updatedAt
  }
}
    `;
export type StoreMailSignatureMutationFn = Apollo.MutationFunction<StoreMailSignatureMutation, StoreMailSignatureMutationVariables>;

/**
 * __useStoreMailSignatureMutation__
 *
 * To run a mutation, you first call `useStoreMailSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMailSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMailSignatureMutation, { data, loading, error }] = useStoreMailSignatureMutation({
 *   variables: {
 *      mailboxEmail: // value for 'mailboxEmail'
 *      html: // value for 'html'
 *   },
 * });
 */
export function useStoreMailSignatureMutation(baseOptions?: Apollo.MutationHookOptions<StoreMailSignatureMutation, StoreMailSignatureMutationVariables>) {
        return Apollo.useMutation<StoreMailSignatureMutation, StoreMailSignatureMutationVariables>(StoreMailSignatureDocument, baseOptions);
      }
export type StoreMailSignatureMutationHookResult = ReturnType<typeof useStoreMailSignatureMutation>;
export type StoreMailSignatureMutationResult = Apollo.MutationResult<StoreMailSignatureMutation>;
export type StoreMailSignatureMutationOptions = Apollo.BaseMutationOptions<StoreMailSignatureMutation, StoreMailSignatureMutationVariables>;
export const PullGmailSignatureDocument = gql`
    mutation PullGmailSignature($mailboxEmail: String!) {
  importGmailSignature(mailboxEmail: $mailboxEmail) {
    id
    mailboxEmail
    html
    source
    importedAt
    updatedAt
  }
}
    `;
export type PullGmailSignatureMutationFn = Apollo.MutationFunction<PullGmailSignatureMutation, PullGmailSignatureMutationVariables>;

/**
 * __usePullGmailSignatureMutation__
 *
 * To run a mutation, you first call `usePullGmailSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePullGmailSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pullGmailSignatureMutation, { data, loading, error }] = usePullGmailSignatureMutation({
 *   variables: {
 *      mailboxEmail: // value for 'mailboxEmail'
 *   },
 * });
 */
export function usePullGmailSignatureMutation(baseOptions?: Apollo.MutationHookOptions<PullGmailSignatureMutation, PullGmailSignatureMutationVariables>) {
        return Apollo.useMutation<PullGmailSignatureMutation, PullGmailSignatureMutationVariables>(PullGmailSignatureDocument, baseOptions);
      }
export type PullGmailSignatureMutationHookResult = ReturnType<typeof usePullGmailSignatureMutation>;
export type PullGmailSignatureMutationResult = Apollo.MutationResult<PullGmailSignatureMutation>;
export type PullGmailSignatureMutationOptions = Apollo.BaseMutationOptions<PullGmailSignatureMutation, PullGmailSignatureMutationVariables>;
export const AddEmailAttachmentDraftDocument = gql`
    mutation AddEmailAttachmentDraft($file: Upload!) {
  uploadEmailAttachment(file: $file) {
    id
    name
    size
    mime
  }
}
    `;
export type AddEmailAttachmentDraftMutationFn = Apollo.MutationFunction<AddEmailAttachmentDraftMutation, AddEmailAttachmentDraftMutationVariables>;

/**
 * __useAddEmailAttachmentDraftMutation__
 *
 * To run a mutation, you first call `useAddEmailAttachmentDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailAttachmentDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailAttachmentDraftMutation, { data, loading, error }] = useAddEmailAttachmentDraftMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useAddEmailAttachmentDraftMutation(baseOptions?: Apollo.MutationHookOptions<AddEmailAttachmentDraftMutation, AddEmailAttachmentDraftMutationVariables>) {
        return Apollo.useMutation<AddEmailAttachmentDraftMutation, AddEmailAttachmentDraftMutationVariables>(AddEmailAttachmentDraftDocument, baseOptions);
      }
export type AddEmailAttachmentDraftMutationHookResult = ReturnType<typeof useAddEmailAttachmentDraftMutation>;
export type AddEmailAttachmentDraftMutationResult = Apollo.MutationResult<AddEmailAttachmentDraftMutation>;
export type AddEmailAttachmentDraftMutationOptions = Apollo.BaseMutationOptions<AddEmailAttachmentDraftMutation, AddEmailAttachmentDraftMutationVariables>;
export const OpenEmailAttachmentDocument = gql`
    mutation OpenEmailAttachment($messageId: ID!, $index: Int!) {
  emailAttachmentLink(messageId: $messageId, index: $index)
}
    `;
export type OpenEmailAttachmentMutationFn = Apollo.MutationFunction<OpenEmailAttachmentMutation, OpenEmailAttachmentMutationVariables>;

/**
 * __useOpenEmailAttachmentMutation__
 *
 * To run a mutation, you first call `useOpenEmailAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenEmailAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openEmailAttachmentMutation, { data, loading, error }] = useOpenEmailAttachmentMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useOpenEmailAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<OpenEmailAttachmentMutation, OpenEmailAttachmentMutationVariables>) {
        return Apollo.useMutation<OpenEmailAttachmentMutation, OpenEmailAttachmentMutationVariables>(OpenEmailAttachmentDocument, baseOptions);
      }
export type OpenEmailAttachmentMutationHookResult = ReturnType<typeof useOpenEmailAttachmentMutation>;
export type OpenEmailAttachmentMutationResult = Apollo.MutationResult<OpenEmailAttachmentMutation>;
export type OpenEmailAttachmentMutationOptions = Apollo.BaseMutationOptions<OpenEmailAttachmentMutation, OpenEmailAttachmentMutationVariables>;
export const SetRuntimeSettingValueDocument = gql`
    mutation SetRuntimeSettingValue($key: String!, $value: JSONString!, $reason: String) {
  setRuntimeSetting(key: $key, value: $value, reason: $reason) {
    success
    changed
    customErrors {
      field
      code
      message
    }
    setting {
      ...RuntimeSettingFields
    }
  }
}
    ${RuntimeSettingFieldsFragmentDoc}`;
export type SetRuntimeSettingValueMutationFn = Apollo.MutationFunction<SetRuntimeSettingValueMutation, SetRuntimeSettingValueMutationVariables>;

/**
 * __useSetRuntimeSettingValueMutation__
 *
 * To run a mutation, you first call `useSetRuntimeSettingValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRuntimeSettingValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRuntimeSettingValueMutation, { data, loading, error }] = useSetRuntimeSettingValueMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useSetRuntimeSettingValueMutation(baseOptions?: Apollo.MutationHookOptions<SetRuntimeSettingValueMutation, SetRuntimeSettingValueMutationVariables>) {
        return Apollo.useMutation<SetRuntimeSettingValueMutation, SetRuntimeSettingValueMutationVariables>(SetRuntimeSettingValueDocument, baseOptions);
      }
export type SetRuntimeSettingValueMutationHookResult = ReturnType<typeof useSetRuntimeSettingValueMutation>;
export type SetRuntimeSettingValueMutationResult = Apollo.MutationResult<SetRuntimeSettingValueMutation>;
export type SetRuntimeSettingValueMutationOptions = Apollo.BaseMutationOptions<SetRuntimeSettingValueMutation, SetRuntimeSettingValueMutationVariables>;
export const ClearRuntimeSettingValueDocument = gql`
    mutation ClearRuntimeSettingValue($key: String!, $reason: String) {
  clearRuntimeSetting(key: $key, reason: $reason) {
    success
    changed
    customErrors {
      field
      code
      message
    }
    setting {
      ...RuntimeSettingFields
    }
  }
}
    ${RuntimeSettingFieldsFragmentDoc}`;
export type ClearRuntimeSettingValueMutationFn = Apollo.MutationFunction<ClearRuntimeSettingValueMutation, ClearRuntimeSettingValueMutationVariables>;

/**
 * __useClearRuntimeSettingValueMutation__
 *
 * To run a mutation, you first call `useClearRuntimeSettingValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRuntimeSettingValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRuntimeSettingValueMutation, { data, loading, error }] = useClearRuntimeSettingValueMutation({
 *   variables: {
 *      key: // value for 'key'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useClearRuntimeSettingValueMutation(baseOptions?: Apollo.MutationHookOptions<ClearRuntimeSettingValueMutation, ClearRuntimeSettingValueMutationVariables>) {
        return Apollo.useMutation<ClearRuntimeSettingValueMutation, ClearRuntimeSettingValueMutationVariables>(ClearRuntimeSettingValueDocument, baseOptions);
      }
export type ClearRuntimeSettingValueMutationHookResult = ReturnType<typeof useClearRuntimeSettingValueMutation>;
export type ClearRuntimeSettingValueMutationResult = Apollo.MutationResult<ClearRuntimeSettingValueMutation>;
export type ClearRuntimeSettingValueMutationOptions = Apollo.BaseMutationOptions<ClearRuntimeSettingValueMutation, ClearRuntimeSettingValueMutationVariables>;
export const DisableOrphanPeriodicTaskActionDocument = gql`
    mutation DisableOrphanPeriodicTaskAction($name: String!, $reason: String) {
  disableOrphanPeriodicTask(name: $name, reason: $reason) {
    success
    changed
    customErrors {
      field
      code
      message
    }
    orphan {
      name
      task
      enabled
      schedule
      lastRunAt
      totalRunCount
    }
  }
}
    `;
export type DisableOrphanPeriodicTaskActionMutationFn = Apollo.MutationFunction<DisableOrphanPeriodicTaskActionMutation, DisableOrphanPeriodicTaskActionMutationVariables>;

/**
 * __useDisableOrphanPeriodicTaskActionMutation__
 *
 * To run a mutation, you first call `useDisableOrphanPeriodicTaskActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableOrphanPeriodicTaskActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableOrphanPeriodicTaskActionMutation, { data, loading, error }] = useDisableOrphanPeriodicTaskActionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDisableOrphanPeriodicTaskActionMutation(baseOptions?: Apollo.MutationHookOptions<DisableOrphanPeriodicTaskActionMutation, DisableOrphanPeriodicTaskActionMutationVariables>) {
        return Apollo.useMutation<DisableOrphanPeriodicTaskActionMutation, DisableOrphanPeriodicTaskActionMutationVariables>(DisableOrphanPeriodicTaskActionDocument, baseOptions);
      }
export type DisableOrphanPeriodicTaskActionMutationHookResult = ReturnType<typeof useDisableOrphanPeriodicTaskActionMutation>;
export type DisableOrphanPeriodicTaskActionMutationResult = Apollo.MutationResult<DisableOrphanPeriodicTaskActionMutation>;
export type DisableOrphanPeriodicTaskActionMutationOptions = Apollo.BaseMutationOptions<DisableOrphanPeriodicTaskActionMutation, DisableOrphanPeriodicTaskActionMutationVariables>;
export const MailSyncContactListDocument = gql`
    mutation MailSyncContactList($groupId: ID!) {
  syncGroupSendgridList(groupId: $groupId) {
    success
    list {
      id
      sendgridListId
      name
      contactCount
      lastSyncStatus
      lastSyncedAt
      errorMessage
    }
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type MailSyncContactListMutationFn = Apollo.MutationFunction<MailSyncContactListMutation, MailSyncContactListMutationVariables>;

/**
 * __useMailSyncContactListMutation__
 *
 * To run a mutation, you first call `useMailSyncContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSyncContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSyncContactListMutation, { data, loading, error }] = useMailSyncContactListMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useMailSyncContactListMutation(baseOptions?: Apollo.MutationHookOptions<MailSyncContactListMutation, MailSyncContactListMutationVariables>) {
        return Apollo.useMutation<MailSyncContactListMutation, MailSyncContactListMutationVariables>(MailSyncContactListDocument, baseOptions);
      }
export type MailSyncContactListMutationHookResult = ReturnType<typeof useMailSyncContactListMutation>;
export type MailSyncContactListMutationResult = Apollo.MutationResult<MailSyncContactListMutation>;
export type MailSyncContactListMutationOptions = Apollo.BaseMutationOptions<MailSyncContactListMutation, MailSyncContactListMutationVariables>;
export const MailSendToGroupDocument = gql`
    mutation MailSendToGroup($groupId: ID!, $templateId: String!, $templateName: String, $recipients: [MailRecipientInput!]!, $subjectOverride: String) {
  sendGroupTemplateEmail(
    groupId: $groupId
    templateId: $templateId
    templateName: $templateName
    recipients: $recipients
    subjectOverride: $subjectOverride
  ) {
    success
    mailJobId
    total
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type MailSendToGroupMutationFn = Apollo.MutationFunction<MailSendToGroupMutation, MailSendToGroupMutationVariables>;

/**
 * __useMailSendToGroupMutation__
 *
 * To run a mutation, you first call `useMailSendToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSendToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSendToGroupMutation, { data, loading, error }] = useMailSendToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      templateId: // value for 'templateId'
 *      templateName: // value for 'templateName'
 *      recipients: // value for 'recipients'
 *      subjectOverride: // value for 'subjectOverride'
 *   },
 * });
 */
export function useMailSendToGroupMutation(baseOptions?: Apollo.MutationHookOptions<MailSendToGroupMutation, MailSendToGroupMutationVariables>) {
        return Apollo.useMutation<MailSendToGroupMutation, MailSendToGroupMutationVariables>(MailSendToGroupDocument, baseOptions);
      }
export type MailSendToGroupMutationHookResult = ReturnType<typeof useMailSendToGroupMutation>;
export type MailSendToGroupMutationResult = Apollo.MutationResult<MailSendToGroupMutation>;
export type MailSendToGroupMutationOptions = Apollo.BaseMutationOptions<MailSendToGroupMutation, MailSendToGroupMutationVariables>;
export const CreateManualShortLinkDocument = gql`
    mutation CreateManualShortLink($targetUrl: String!, $title: String!, $expiresAt: DateTime, $channel: String, $tags: [String!]) {
  createShortLink(
    targetUrl: $targetUrl
    title: $title
    expiresAt: $expiresAt
    channel: $channel
    tags: $tags
  ) {
    success
    customErrors {
      field
      code
      message
    }
    link {
      ...ShortLinkFields
    }
  }
}
    ${ShortLinkFieldsFragmentDoc}`;
export type CreateManualShortLinkMutationFn = Apollo.MutationFunction<CreateManualShortLinkMutation, CreateManualShortLinkMutationVariables>;

/**
 * __useCreateManualShortLinkMutation__
 *
 * To run a mutation, you first call `useCreateManualShortLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualShortLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualShortLinkMutation, { data, loading, error }] = useCreateManualShortLinkMutation({
 *   variables: {
 *      targetUrl: // value for 'targetUrl'
 *      title: // value for 'title'
 *      expiresAt: // value for 'expiresAt'
 *      channel: // value for 'channel'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateManualShortLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualShortLinkMutation, CreateManualShortLinkMutationVariables>) {
        return Apollo.useMutation<CreateManualShortLinkMutation, CreateManualShortLinkMutationVariables>(CreateManualShortLinkDocument, baseOptions);
      }
export type CreateManualShortLinkMutationHookResult = ReturnType<typeof useCreateManualShortLinkMutation>;
export type CreateManualShortLinkMutationResult = Apollo.MutationResult<CreateManualShortLinkMutation>;
export type CreateManualShortLinkMutationOptions = Apollo.BaseMutationOptions<CreateManualShortLinkMutation, CreateManualShortLinkMutationVariables>;
export const UpdateManualShortLinkDocument = gql`
    mutation UpdateManualShortLink($id: ID!, $title: String!, $expiresAt: DateTime, $clearExpiry: Boolean, $channel: String, $tags: [String!]) {
  updateShortLink(
    id: $id
    title: $title
    expiresAt: $expiresAt
    clearExpiry: $clearExpiry
    channel: $channel
    tags: $tags
  ) {
    success
    customErrors {
      field
      code
      message
    }
    link {
      ...ShortLinkFields
    }
  }
}
    ${ShortLinkFieldsFragmentDoc}`;
export type UpdateManualShortLinkMutationFn = Apollo.MutationFunction<UpdateManualShortLinkMutation, UpdateManualShortLinkMutationVariables>;

/**
 * __useUpdateManualShortLinkMutation__
 *
 * To run a mutation, you first call `useUpdateManualShortLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualShortLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualShortLinkMutation, { data, loading, error }] = useUpdateManualShortLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      expiresAt: // value for 'expiresAt'
 *      clearExpiry: // value for 'clearExpiry'
 *      channel: // value for 'channel'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateManualShortLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManualShortLinkMutation, UpdateManualShortLinkMutationVariables>) {
        return Apollo.useMutation<UpdateManualShortLinkMutation, UpdateManualShortLinkMutationVariables>(UpdateManualShortLinkDocument, baseOptions);
      }
export type UpdateManualShortLinkMutationHookResult = ReturnType<typeof useUpdateManualShortLinkMutation>;
export type UpdateManualShortLinkMutationResult = Apollo.MutationResult<UpdateManualShortLinkMutation>;
export type UpdateManualShortLinkMutationOptions = Apollo.BaseMutationOptions<UpdateManualShortLinkMutation, UpdateManualShortLinkMutationVariables>;
export const RevokeManualShortLinkDocument = gql`
    mutation RevokeManualShortLink($id: ID!) {
  revokeShortLink(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
    link {
      ...ShortLinkFields
    }
  }
}
    ${ShortLinkFieldsFragmentDoc}`;
export type RevokeManualShortLinkMutationFn = Apollo.MutationFunction<RevokeManualShortLinkMutation, RevokeManualShortLinkMutationVariables>;

/**
 * __useRevokeManualShortLinkMutation__
 *
 * To run a mutation, you first call `useRevokeManualShortLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeManualShortLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeManualShortLinkMutation, { data, loading, error }] = useRevokeManualShortLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeManualShortLinkMutation(baseOptions?: Apollo.MutationHookOptions<RevokeManualShortLinkMutation, RevokeManualShortLinkMutationVariables>) {
        return Apollo.useMutation<RevokeManualShortLinkMutation, RevokeManualShortLinkMutationVariables>(RevokeManualShortLinkDocument, baseOptions);
      }
export type RevokeManualShortLinkMutationHookResult = ReturnType<typeof useRevokeManualShortLinkMutation>;
export type RevokeManualShortLinkMutationResult = Apollo.MutationResult<RevokeManualShortLinkMutation>;
export type RevokeManualShortLinkMutationOptions = Apollo.BaseMutationOptions<RevokeManualShortLinkMutation, RevokeManualShortLinkMutationVariables>;
export const RevokeManyShortLinksDocument = gql`
    mutation RevokeManyShortLinks($ids: [ID!]!) {
  revokeShortLinks(ids: $ids) {
    success
    customErrors {
      field
      code
      message
    }
    revokedIds
    skipped
  }
}
    `;
export type RevokeManyShortLinksMutationFn = Apollo.MutationFunction<RevokeManyShortLinksMutation, RevokeManyShortLinksMutationVariables>;

/**
 * __useRevokeManyShortLinksMutation__
 *
 * To run a mutation, you first call `useRevokeManyShortLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeManyShortLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeManyShortLinksMutation, { data, loading, error }] = useRevokeManyShortLinksMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRevokeManyShortLinksMutation(baseOptions?: Apollo.MutationHookOptions<RevokeManyShortLinksMutation, RevokeManyShortLinksMutationVariables>) {
        return Apollo.useMutation<RevokeManyShortLinksMutation, RevokeManyShortLinksMutationVariables>(RevokeManyShortLinksDocument, baseOptions);
      }
export type RevokeManyShortLinksMutationHookResult = ReturnType<typeof useRevokeManyShortLinksMutation>;
export type RevokeManyShortLinksMutationResult = Apollo.MutationResult<RevokeManyShortLinksMutation>;
export type RevokeManyShortLinksMutationOptions = Apollo.BaseMutationOptions<RevokeManyShortLinksMutation, RevokeManyShortLinksMutationVariables>;
export const QueueStudentSmsDocument = gql`
    mutation QueueStudentSms($studentId: ID!, $text: String!, $link: SmsLinkInput, $templateId: ID, $requestKey: String) {
  sendStudentSms(
    studentId: $studentId
    text: $text
    link: $link
    templateId: $templateId
    requestKey: $requestKey
  ) {
    success
    customErrors {
      field
      code
      message
    }
    message {
      ...SmsMessageFields
    }
    state {
      ...StudentSmsStateFields
    }
  }
}
    ${SmsMessageFieldsFragmentDoc}
${StudentSmsStateFieldsFragmentDoc}`;
export type QueueStudentSmsMutationFn = Apollo.MutationFunction<QueueStudentSmsMutation, QueueStudentSmsMutationVariables>;

/**
 * __useQueueStudentSmsMutation__
 *
 * To run a mutation, you first call `useQueueStudentSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueStudentSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueStudentSmsMutation, { data, loading, error }] = useQueueStudentSmsMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      text: // value for 'text'
 *      link: // value for 'link'
 *      templateId: // value for 'templateId'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useQueueStudentSmsMutation(baseOptions?: Apollo.MutationHookOptions<QueueStudentSmsMutation, QueueStudentSmsMutationVariables>) {
        return Apollo.useMutation<QueueStudentSmsMutation, QueueStudentSmsMutationVariables>(QueueStudentSmsDocument, baseOptions);
      }
export type QueueStudentSmsMutationHookResult = ReturnType<typeof useQueueStudentSmsMutation>;
export type QueueStudentSmsMutationResult = Apollo.MutationResult<QueueStudentSmsMutation>;
export type QueueStudentSmsMutationOptions = Apollo.BaseMutationOptions<QueueStudentSmsMutation, QueueStudentSmsMutationVariables>;
export const QueueTeacherSmsDocument = gql`
    mutation QueueTeacherSms($teacherId: ID!, $text: String!, $link: TeacherSmsLinkInput, $templateId: ID, $requestKey: String) {
  sendTeacherSms(
    teacherId: $teacherId
    text: $text
    link: $link
    templateId: $templateId
    requestKey: $requestKey
  ) {
    success
    customErrors {
      field
      code
      message
    }
    message {
      ...SmsMessageFields
    }
    state {
      ...TeacherSmsStateFields
    }
  }
}
    ${SmsMessageFieldsFragmentDoc}
${TeacherSmsStateFieldsFragmentDoc}`;
export type QueueTeacherSmsMutationFn = Apollo.MutationFunction<QueueTeacherSmsMutation, QueueTeacherSmsMutationVariables>;

/**
 * __useQueueTeacherSmsMutation__
 *
 * To run a mutation, you first call `useQueueTeacherSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueTeacherSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueTeacherSmsMutation, { data, loading, error }] = useQueueTeacherSmsMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      text: // value for 'text'
 *      link: // value for 'link'
 *      templateId: // value for 'templateId'
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useQueueTeacherSmsMutation(baseOptions?: Apollo.MutationHookOptions<QueueTeacherSmsMutation, QueueTeacherSmsMutationVariables>) {
        return Apollo.useMutation<QueueTeacherSmsMutation, QueueTeacherSmsMutationVariables>(QueueTeacherSmsDocument, baseOptions);
      }
export type QueueTeacherSmsMutationHookResult = ReturnType<typeof useQueueTeacherSmsMutation>;
export type QueueTeacherSmsMutationResult = Apollo.MutationResult<QueueTeacherSmsMutation>;
export type QueueTeacherSmsMutationOptions = Apollo.BaseMutationOptions<QueueTeacherSmsMutation, QueueTeacherSmsMutationVariables>;
export const LaunchGroupSmsDocument = gql`
    mutation LaunchGroupSms($groupId: ID!, $text: String!, $title: String, $link: SmsLinkInput, $mode: String, $templateId: ID, $requestKey: String, $studentIds: [ID!]) {
  sendGroupSms(
    groupId: $groupId
    text: $text
    title: $title
    link: $link
    mode: $mode
    templateId: $templateId
    requestKey: $requestKey
    studentIds: $studentIds
  ) {
    success
    customErrors {
      field
      code
      message
    }
    campaign {
      ...SmsCampaignFields
    }
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type LaunchGroupSmsMutationFn = Apollo.MutationFunction<LaunchGroupSmsMutation, LaunchGroupSmsMutationVariables>;

/**
 * __useLaunchGroupSmsMutation__
 *
 * To run a mutation, you first call `useLaunchGroupSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchGroupSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchGroupSmsMutation, { data, loading, error }] = useLaunchGroupSmsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      text: // value for 'text'
 *      title: // value for 'title'
 *      link: // value for 'link'
 *      mode: // value for 'mode'
 *      templateId: // value for 'templateId'
 *      requestKey: // value for 'requestKey'
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useLaunchGroupSmsMutation(baseOptions?: Apollo.MutationHookOptions<LaunchGroupSmsMutation, LaunchGroupSmsMutationVariables>) {
        return Apollo.useMutation<LaunchGroupSmsMutation, LaunchGroupSmsMutationVariables>(LaunchGroupSmsDocument, baseOptions);
      }
export type LaunchGroupSmsMutationHookResult = ReturnType<typeof useLaunchGroupSmsMutation>;
export type LaunchGroupSmsMutationResult = Apollo.MutationResult<LaunchGroupSmsMutation>;
export type LaunchGroupSmsMutationOptions = Apollo.BaseMutationOptions<LaunchGroupSmsMutation, LaunchGroupSmsMutationVariables>;
export const RepeatSmsCampaignDocument = gql`
    mutation RepeatSmsCampaign($campaignId: ID!) {
  resendSmsCampaign(campaignId: $campaignId) {
    success
    customErrors {
      field
      code
      message
    }
    created
    campaign {
      ...SmsCampaignFields
    }
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type RepeatSmsCampaignMutationFn = Apollo.MutationFunction<RepeatSmsCampaignMutation, RepeatSmsCampaignMutationVariables>;

/**
 * __useRepeatSmsCampaignMutation__
 *
 * To run a mutation, you first call `useRepeatSmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepeatSmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repeatSmsCampaignMutation, { data, loading, error }] = useRepeatSmsCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useRepeatSmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RepeatSmsCampaignMutation, RepeatSmsCampaignMutationVariables>) {
        return Apollo.useMutation<RepeatSmsCampaignMutation, RepeatSmsCampaignMutationVariables>(RepeatSmsCampaignDocument, baseOptions);
      }
export type RepeatSmsCampaignMutationHookResult = ReturnType<typeof useRepeatSmsCampaignMutation>;
export type RepeatSmsCampaignMutationResult = Apollo.MutationResult<RepeatSmsCampaignMutation>;
export type RepeatSmsCampaignMutationOptions = Apollo.BaseMutationOptions<RepeatSmsCampaignMutation, RepeatSmsCampaignMutationVariables>;
export const RequeueSmsMessageDocument = gql`
    mutation RequeueSmsMessage($messageId: ID!) {
  retrySmsMessage(messageId: $messageId) {
    success
    customErrors {
      field
      code
      message
    }
    message {
      ...SmsMessageFields
    }
  }
}
    ${SmsMessageFieldsFragmentDoc}`;
export type RequeueSmsMessageMutationFn = Apollo.MutationFunction<RequeueSmsMessageMutation, RequeueSmsMessageMutationVariables>;

/**
 * __useRequeueSmsMessageMutation__
 *
 * To run a mutation, you first call `useRequeueSmsMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequeueSmsMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requeueSmsMessageMutation, { data, loading, error }] = useRequeueSmsMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useRequeueSmsMessageMutation(baseOptions?: Apollo.MutationHookOptions<RequeueSmsMessageMutation, RequeueSmsMessageMutationVariables>) {
        return Apollo.useMutation<RequeueSmsMessageMutation, RequeueSmsMessageMutationVariables>(RequeueSmsMessageDocument, baseOptions);
      }
export type RequeueSmsMessageMutationHookResult = ReturnType<typeof useRequeueSmsMessageMutation>;
export type RequeueSmsMessageMutationResult = Apollo.MutationResult<RequeueSmsMessageMutation>;
export type RequeueSmsMessageMutationOptions = Apollo.BaseMutationOptions<RequeueSmsMessageMutation, RequeueSmsMessageMutationVariables>;
export const WithdrawSmsMessageDocument = gql`
    mutation WithdrawSmsMessage($messageId: ID!) {
  cancelSmsMessage(messageId: $messageId) {
    success
    customErrors {
      field
      code
      message
    }
    message {
      ...SmsMessageFields
    }
  }
}
    ${SmsMessageFieldsFragmentDoc}`;
export type WithdrawSmsMessageMutationFn = Apollo.MutationFunction<WithdrawSmsMessageMutation, WithdrawSmsMessageMutationVariables>;

/**
 * __useWithdrawSmsMessageMutation__
 *
 * To run a mutation, you first call `useWithdrawSmsMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawSmsMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawSmsMessageMutation, { data, loading, error }] = useWithdrawSmsMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useWithdrawSmsMessageMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawSmsMessageMutation, WithdrawSmsMessageMutationVariables>) {
        return Apollo.useMutation<WithdrawSmsMessageMutation, WithdrawSmsMessageMutationVariables>(WithdrawSmsMessageDocument, baseOptions);
      }
export type WithdrawSmsMessageMutationHookResult = ReturnType<typeof useWithdrawSmsMessageMutation>;
export type WithdrawSmsMessageMutationResult = Apollo.MutationResult<WithdrawSmsMessageMutation>;
export type WithdrawSmsMessageMutationOptions = Apollo.BaseMutationOptions<WithdrawSmsMessageMutation, WithdrawSmsMessageMutationVariables>;
export const StoreSmsSettingsDocument = gql`
    mutation StoreSmsSettings($input: SmsSettingsInput!) {
  saveSmsSettings(input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    smsSettings {
      ...SmsSettingsFields
    }
  }
}
    ${SmsSettingsFieldsFragmentDoc}`;
export type StoreSmsSettingsMutationFn = Apollo.MutationFunction<StoreSmsSettingsMutation, StoreSmsSettingsMutationVariables>;

/**
 * __useStoreSmsSettingsMutation__
 *
 * To run a mutation, you first call `useStoreSmsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreSmsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeSmsSettingsMutation, { data, loading, error }] = useStoreSmsSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreSmsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<StoreSmsSettingsMutation, StoreSmsSettingsMutationVariables>) {
        return Apollo.useMutation<StoreSmsSettingsMutation, StoreSmsSettingsMutationVariables>(StoreSmsSettingsDocument, baseOptions);
      }
export type StoreSmsSettingsMutationHookResult = ReturnType<typeof useStoreSmsSettingsMutation>;
export type StoreSmsSettingsMutationResult = Apollo.MutationResult<StoreSmsSettingsMutation>;
export type StoreSmsSettingsMutationOptions = Apollo.BaseMutationOptions<StoreSmsSettingsMutation, StoreSmsSettingsMutationVariables>;
export const StoreSmsTextsDocument = gql`
    mutation StoreSmsTexts($optOutSuffix: String!) {
  saveSmsTexts(optOutSuffix: $optOutSuffix) {
    success
    customErrors {
      field
      code
      message
    }
    smsSettings {
      ...SmsSettingsFields
    }
  }
}
    ${SmsSettingsFieldsFragmentDoc}`;
export type StoreSmsTextsMutationFn = Apollo.MutationFunction<StoreSmsTextsMutation, StoreSmsTextsMutationVariables>;

/**
 * __useStoreSmsTextsMutation__
 *
 * To run a mutation, you first call `useStoreSmsTextsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreSmsTextsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeSmsTextsMutation, { data, loading, error }] = useStoreSmsTextsMutation({
 *   variables: {
 *      optOutSuffix: // value for 'optOutSuffix'
 *   },
 * });
 */
export function useStoreSmsTextsMutation(baseOptions?: Apollo.MutationHookOptions<StoreSmsTextsMutation, StoreSmsTextsMutationVariables>) {
        return Apollo.useMutation<StoreSmsTextsMutation, StoreSmsTextsMutationVariables>(StoreSmsTextsDocument, baseOptions);
      }
export type StoreSmsTextsMutationHookResult = ReturnType<typeof useStoreSmsTextsMutation>;
export type StoreSmsTextsMutationResult = Apollo.MutationResult<StoreSmsTextsMutation>;
export type StoreSmsTextsMutationOptions = Apollo.BaseMutationOptions<StoreSmsTextsMutation, StoreSmsTextsMutationVariables>;
export const StoreLinkAddressesDocument = gql`
    mutation StoreLinkAddresses($dofinFormUrl: String, $lmsBaseUrl: String) {
  saveLinkAddresses(dofinFormUrl: $dofinFormUrl, lmsBaseUrl: $lmsBaseUrl) {
    success
    customErrors {
      field
      code
      message
    }
    linkAddresses {
      ...LinkAddressesFields
    }
  }
}
    ${LinkAddressesFieldsFragmentDoc}`;
export type StoreLinkAddressesMutationFn = Apollo.MutationFunction<StoreLinkAddressesMutation, StoreLinkAddressesMutationVariables>;

/**
 * __useStoreLinkAddressesMutation__
 *
 * To run a mutation, you first call `useStoreLinkAddressesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreLinkAddressesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeLinkAddressesMutation, { data, loading, error }] = useStoreLinkAddressesMutation({
 *   variables: {
 *      dofinFormUrl: // value for 'dofinFormUrl'
 *      lmsBaseUrl: // value for 'lmsBaseUrl'
 *   },
 * });
 */
export function useStoreLinkAddressesMutation(baseOptions?: Apollo.MutationHookOptions<StoreLinkAddressesMutation, StoreLinkAddressesMutationVariables>) {
        return Apollo.useMutation<StoreLinkAddressesMutation, StoreLinkAddressesMutationVariables>(StoreLinkAddressesDocument, baseOptions);
      }
export type StoreLinkAddressesMutationHookResult = ReturnType<typeof useStoreLinkAddressesMutation>;
export type StoreLinkAddressesMutationResult = Apollo.MutationResult<StoreLinkAddressesMutation>;
export type StoreLinkAddressesMutationOptions = Apollo.BaseMutationOptions<StoreLinkAddressesMutation, StoreLinkAddressesMutationVariables>;
export const StoreSmsReminderPlanDocument = gql`
    mutation StoreSmsReminderPlan($topic: String!, $enabled: Boolean!, $steps: [ReminderStepInput!]!) {
  saveReminderPlan(topic: $topic, enabled: $enabled, steps: $steps) {
    success
    customErrors {
      field
      code
      message
    }
    plan {
      ...SmsReminderPlanFields
    }
  }
}
    ${SmsReminderPlanFieldsFragmentDoc}`;
export type StoreSmsReminderPlanMutationFn = Apollo.MutationFunction<StoreSmsReminderPlanMutation, StoreSmsReminderPlanMutationVariables>;

/**
 * __useStoreSmsReminderPlanMutation__
 *
 * To run a mutation, you first call `useStoreSmsReminderPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreSmsReminderPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeSmsReminderPlanMutation, { data, loading, error }] = useStoreSmsReminderPlanMutation({
 *   variables: {
 *      topic: // value for 'topic'
 *      enabled: // value for 'enabled'
 *      steps: // value for 'steps'
 *   },
 * });
 */
export function useStoreSmsReminderPlanMutation(baseOptions?: Apollo.MutationHookOptions<StoreSmsReminderPlanMutation, StoreSmsReminderPlanMutationVariables>) {
        return Apollo.useMutation<StoreSmsReminderPlanMutation, StoreSmsReminderPlanMutationVariables>(StoreSmsReminderPlanDocument, baseOptions);
      }
export type StoreSmsReminderPlanMutationHookResult = ReturnType<typeof useStoreSmsReminderPlanMutation>;
export type StoreSmsReminderPlanMutationResult = Apollo.MutationResult<StoreSmsReminderPlanMutation>;
export type StoreSmsReminderPlanMutationOptions = Apollo.BaseMutationOptions<StoreSmsReminderPlanMutation, StoreSmsReminderPlanMutationVariables>;
export const ProbeSmsConnectionDocument = gql`
    mutation ProbeSmsConnection($to: String!) {
  checkSmsConnection(to: $to) {
    success
    customErrors {
      field
      code
      message
    }
    result {
      ...SmsConnectionCheckFields
    }
    status {
      ...SmsProviderStatusFields
    }
  }
}
    ${SmsConnectionCheckFieldsFragmentDoc}
${SmsProviderStatusFieldsFragmentDoc}`;
export type ProbeSmsConnectionMutationFn = Apollo.MutationFunction<ProbeSmsConnectionMutation, ProbeSmsConnectionMutationVariables>;

/**
 * __useProbeSmsConnectionMutation__
 *
 * To run a mutation, you first call `useProbeSmsConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProbeSmsConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [probeSmsConnectionMutation, { data, loading, error }] = useProbeSmsConnectionMutation({
 *   variables: {
 *      to: // value for 'to'
 *   },
 * });
 */
export function useProbeSmsConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ProbeSmsConnectionMutation, ProbeSmsConnectionMutationVariables>) {
        return Apollo.useMutation<ProbeSmsConnectionMutation, ProbeSmsConnectionMutationVariables>(ProbeSmsConnectionDocument, baseOptions);
      }
export type ProbeSmsConnectionMutationHookResult = ReturnType<typeof useProbeSmsConnectionMutation>;
export type ProbeSmsConnectionMutationResult = Apollo.MutationResult<ProbeSmsConnectionMutation>;
export type ProbeSmsConnectionMutationOptions = Apollo.BaseMutationOptions<ProbeSmsConnectionMutation, ProbeSmsConnectionMutationVariables>;
export const DispatchSmsTestDocument = gql`
    mutation DispatchSmsTest($to: String!, $text: String) {
  sendSmsTest(to: $to, text: $text) {
    success
    customErrors {
      field
      code
      message
    }
    result {
      ...SmsConnectionCheckFields
    }
  }
}
    ${SmsConnectionCheckFieldsFragmentDoc}`;
export type DispatchSmsTestMutationFn = Apollo.MutationFunction<DispatchSmsTestMutation, DispatchSmsTestMutationVariables>;

/**
 * __useDispatchSmsTestMutation__
 *
 * To run a mutation, you first call `useDispatchSmsTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispatchSmsTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispatchSmsTestMutation, { data, loading, error }] = useDispatchSmsTestMutation({
 *   variables: {
 *      to: // value for 'to'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useDispatchSmsTestMutation(baseOptions?: Apollo.MutationHookOptions<DispatchSmsTestMutation, DispatchSmsTestMutationVariables>) {
        return Apollo.useMutation<DispatchSmsTestMutation, DispatchSmsTestMutationVariables>(DispatchSmsTestDocument, baseOptions);
      }
export type DispatchSmsTestMutationHookResult = ReturnType<typeof useDispatchSmsTestMutation>;
export type DispatchSmsTestMutationResult = Apollo.MutationResult<DispatchSmsTestMutation>;
export type DispatchSmsTestMutationOptions = Apollo.BaseMutationOptions<DispatchSmsTestMutation, DispatchSmsTestMutationVariables>;
export const AddAgreementDocument = gql`
    mutation addAgreement($agreementInput: CreateAgreementInput!) {
  createAgreement(agreementInput: $agreementInput) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type AddAgreementMutationFn = Apollo.MutationFunction<AddAgreementMutation, AddAgreementMutationVariables>;

/**
 * __useAddAgreementMutation__
 *
 * To run a mutation, you first call `useAddAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAgreementMutation, { data, loading, error }] = useAddAgreementMutation({
 *   variables: {
 *      agreementInput: // value for 'agreementInput'
 *   },
 * });
 */
export function useAddAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AddAgreementMutation, AddAgreementMutationVariables>) {
        return Apollo.useMutation<AddAgreementMutation, AddAgreementMutationVariables>(AddAgreementDocument, baseOptions);
      }
export type AddAgreementMutationHookResult = ReturnType<typeof useAddAgreementMutation>;
export type AddAgreementMutationResult = Apollo.MutationResult<AddAgreementMutation>;
export type AddAgreementMutationOptions = Apollo.BaseMutationOptions<AddAgreementMutation, AddAgreementMutationVariables>;
export const EditStudentWithAgreementDocument = gql`
    mutation editStudentWithAgreement($agreementId: ID!, $updateStudentInput: UpdateStudentInput!) {
  updateStudentWithAgreement(
    agreementId: $agreementId
    updateStudentInput: $updateStudentInput
  ) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type EditStudentWithAgreementMutationFn = Apollo.MutationFunction<EditStudentWithAgreementMutation, EditStudentWithAgreementMutationVariables>;

/**
 * __useEditStudentWithAgreementMutation__
 *
 * To run a mutation, you first call `useEditStudentWithAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStudentWithAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStudentWithAgreementMutation, { data, loading, error }] = useEditStudentWithAgreementMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      updateStudentInput: // value for 'updateStudentInput'
 *   },
 * });
 */
export function useEditStudentWithAgreementMutation(baseOptions?: Apollo.MutationHookOptions<EditStudentWithAgreementMutation, EditStudentWithAgreementMutationVariables>) {
        return Apollo.useMutation<EditStudentWithAgreementMutation, EditStudentWithAgreementMutationVariables>(EditStudentWithAgreementDocument, baseOptions);
      }
export type EditStudentWithAgreementMutationHookResult = ReturnType<typeof useEditStudentWithAgreementMutation>;
export type EditStudentWithAgreementMutationResult = Apollo.MutationResult<EditStudentWithAgreementMutation>;
export type EditStudentWithAgreementMutationOptions = Apollo.BaseMutationOptions<EditStudentWithAgreementMutation, EditStudentWithAgreementMutationVariables>;
export const AddRoleAndAgreementDocument = gql`
    mutation addRoleAndAgreement($agreementInput: CreateAgreementInputBase!, $userId: ID!) {
  appendStudentRoleAndAgreement(agreementInput: $agreementInput, userId: $userId) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type AddRoleAndAgreementMutationFn = Apollo.MutationFunction<AddRoleAndAgreementMutation, AddRoleAndAgreementMutationVariables>;

/**
 * __useAddRoleAndAgreementMutation__
 *
 * To run a mutation, you first call `useAddRoleAndAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleAndAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleAndAgreementMutation, { data, loading, error }] = useAddRoleAndAgreementMutation({
 *   variables: {
 *      agreementInput: // value for 'agreementInput'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddRoleAndAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AddRoleAndAgreementMutation, AddRoleAndAgreementMutationVariables>) {
        return Apollo.useMutation<AddRoleAndAgreementMutation, AddRoleAndAgreementMutationVariables>(AddRoleAndAgreementDocument, baseOptions);
      }
export type AddRoleAndAgreementMutationHookResult = ReturnType<typeof useAddRoleAndAgreementMutation>;
export type AddRoleAndAgreementMutationResult = Apollo.MutationResult<AddRoleAndAgreementMutation>;
export type AddRoleAndAgreementMutationOptions = Apollo.BaseMutationOptions<AddRoleAndAgreementMutation, AddRoleAndAgreementMutationVariables>;
export const AddStudentWithAgreementDocument = gql`
    mutation addStudentWithAgreement($agreementInput: CreateAgreementInputBase!, $studentInput: StudentInput!) {
  createStudentWithAgreement(
    agreementInput: $agreementInput
    studentInput: $studentInput
  ) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type AddStudentWithAgreementMutationFn = Apollo.MutationFunction<AddStudentWithAgreementMutation, AddStudentWithAgreementMutationVariables>;

/**
 * __useAddStudentWithAgreementMutation__
 *
 * To run a mutation, you first call `useAddStudentWithAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStudentWithAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStudentWithAgreementMutation, { data, loading, error }] = useAddStudentWithAgreementMutation({
 *   variables: {
 *      agreementInput: // value for 'agreementInput'
 *      studentInput: // value for 'studentInput'
 *   },
 * });
 */
export function useAddStudentWithAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AddStudentWithAgreementMutation, AddStudentWithAgreementMutationVariables>) {
        return Apollo.useMutation<AddStudentWithAgreementMutation, AddStudentWithAgreementMutationVariables>(AddStudentWithAgreementDocument, baseOptions);
      }
export type AddStudentWithAgreementMutationHookResult = ReturnType<typeof useAddStudentWithAgreementMutation>;
export type AddStudentWithAgreementMutationResult = Apollo.MutationResult<AddStudentWithAgreementMutation>;
export type AddStudentWithAgreementMutationOptions = Apollo.BaseMutationOptions<AddStudentWithAgreementMutation, AddStudentWithAgreementMutationVariables>;
export const RemovePaymentDocument = gql`
    mutation RemovePayment($id: ID!) {
  deletePayment(id: $id) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type RemovePaymentMutationFn = Apollo.MutationFunction<RemovePaymentMutation, RemovePaymentMutationVariables>;

/**
 * __useRemovePaymentMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMutation, { data, loading, error }] = useRemovePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePaymentMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentMutation, RemovePaymentMutationVariables>) {
        return Apollo.useMutation<RemovePaymentMutation, RemovePaymentMutationVariables>(RemovePaymentDocument, baseOptions);
      }
export type RemovePaymentMutationHookResult = ReturnType<typeof useRemovePaymentMutation>;
export type RemovePaymentMutationResult = Apollo.MutationResult<RemovePaymentMutation>;
export type RemovePaymentMutationOptions = Apollo.BaseMutationOptions<RemovePaymentMutation, RemovePaymentMutationVariables>;
export const MoveAgreementToGroupDocument = gql`
    mutation MoveAgreementToGroup($input: ChangeAgreementGroupInput!) {
  changeAgreementGroup(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    oldAgreement {
      id
      terminated
      terminatedDate
    }
    newAgreement {
      id
      agreementTitle
      group {
        id
        name
      }
    }
  }
}
    `;
export type MoveAgreementToGroupMutationFn = Apollo.MutationFunction<MoveAgreementToGroupMutation, MoveAgreementToGroupMutationVariables>;

/**
 * __useMoveAgreementToGroupMutation__
 *
 * To run a mutation, you first call `useMoveAgreementToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAgreementToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAgreementToGroupMutation, { data, loading, error }] = useMoveAgreementToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveAgreementToGroupMutation(baseOptions?: Apollo.MutationHookOptions<MoveAgreementToGroupMutation, MoveAgreementToGroupMutationVariables>) {
        return Apollo.useMutation<MoveAgreementToGroupMutation, MoveAgreementToGroupMutationVariables>(MoveAgreementToGroupDocument, baseOptions);
      }
export type MoveAgreementToGroupMutationHookResult = ReturnType<typeof useMoveAgreementToGroupMutation>;
export type MoveAgreementToGroupMutationResult = Apollo.MutationResult<MoveAgreementToGroupMutation>;
export type MoveAgreementToGroupMutationOptions = Apollo.BaseMutationOptions<MoveAgreementToGroupMutation, MoveAgreementToGroupMutationVariables>;
export const AttachContributionToPaymentDocument = gql`
    mutation AttachContributionToPayment($input: LinkContributionInput!) {
  linkContributionToPayment(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    contribution {
      id
      complete
      remainder
      payment {
        id
        date
        amountAgreement
        currency
        fakturowniaInvoice {
          id
          number
          status
        }
      }
    }
    payment {
      id
      contribution {
        id
      }
      agreement {
        id
        paidAmount
      }
    }
  }
}
    `;
export type AttachContributionToPaymentMutationFn = Apollo.MutationFunction<AttachContributionToPaymentMutation, AttachContributionToPaymentMutationVariables>;

/**
 * __useAttachContributionToPaymentMutation__
 *
 * To run a mutation, you first call `useAttachContributionToPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachContributionToPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachContributionToPaymentMutation, { data, loading, error }] = useAttachContributionToPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachContributionToPaymentMutation(baseOptions?: Apollo.MutationHookOptions<AttachContributionToPaymentMutation, AttachContributionToPaymentMutationVariables>) {
        return Apollo.useMutation<AttachContributionToPaymentMutation, AttachContributionToPaymentMutationVariables>(AttachContributionToPaymentDocument, baseOptions);
      }
export type AttachContributionToPaymentMutationHookResult = ReturnType<typeof useAttachContributionToPaymentMutation>;
export type AttachContributionToPaymentMutationResult = Apollo.MutationResult<AttachContributionToPaymentMutation>;
export type AttachContributionToPaymentMutationOptions = Apollo.BaseMutationOptions<AttachContributionToPaymentMutation, AttachContributionToPaymentMutationVariables>;
export const ZeroContributionDocument = gql`
    mutation ZeroContribution($contributionId: ID!) {
  zeroOutContribution(contributionId: $contributionId) {
    success
    customErrors {
      field
      message
      code
    }
    contribution {
      id
      complete
      remainder
    }
  }
}
    `;
export type ZeroContributionMutationFn = Apollo.MutationFunction<ZeroContributionMutation, ZeroContributionMutationVariables>;

/**
 * __useZeroContributionMutation__
 *
 * To run a mutation, you first call `useZeroContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZeroContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zeroContributionMutation, { data, loading, error }] = useZeroContributionMutation({
 *   variables: {
 *      contributionId: // value for 'contributionId'
 *   },
 * });
 */
export function useZeroContributionMutation(baseOptions?: Apollo.MutationHookOptions<ZeroContributionMutation, ZeroContributionMutationVariables>) {
        return Apollo.useMutation<ZeroContributionMutation, ZeroContributionMutationVariables>(ZeroContributionDocument, baseOptions);
      }
export type ZeroContributionMutationHookResult = ReturnType<typeof useZeroContributionMutation>;
export type ZeroContributionMutationResult = Apollo.MutationResult<ZeroContributionMutation>;
export type ZeroContributionMutationOptions = Apollo.BaseMutationOptions<ZeroContributionMutation, ZeroContributionMutationVariables>;
export const IssuePaymentCorrectionDocument = gql`
    mutation IssuePaymentCorrection($input: CreatePaymentCorrectionInput!) {
  createPaymentCorrection(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    correction {
      id
      date
      amountForeign
      amountByn
      currency
      reason
      payment {
        id
      }
    }
  }
}
    `;
export type IssuePaymentCorrectionMutationFn = Apollo.MutationFunction<IssuePaymentCorrectionMutation, IssuePaymentCorrectionMutationVariables>;

/**
 * __useIssuePaymentCorrectionMutation__
 *
 * To run a mutation, you first call `useIssuePaymentCorrectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssuePaymentCorrectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issuePaymentCorrectionMutation, { data, loading, error }] = useIssuePaymentCorrectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssuePaymentCorrectionMutation(baseOptions?: Apollo.MutationHookOptions<IssuePaymentCorrectionMutation, IssuePaymentCorrectionMutationVariables>) {
        return Apollo.useMutation<IssuePaymentCorrectionMutation, IssuePaymentCorrectionMutationVariables>(IssuePaymentCorrectionDocument, baseOptions);
      }
export type IssuePaymentCorrectionMutationHookResult = ReturnType<typeof useIssuePaymentCorrectionMutation>;
export type IssuePaymentCorrectionMutationResult = Apollo.MutationResult<IssuePaymentCorrectionMutation>;
export type IssuePaymentCorrectionMutationOptions = Apollo.BaseMutationOptions<IssuePaymentCorrectionMutation, IssuePaymentCorrectionMutationVariables>;
export const EditPaymentCorrectionDocument = gql`
    mutation EditPaymentCorrection($input: UpdatePaymentCorrectionInput!) {
  updatePaymentCorrection(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    correction {
      id
    }
  }
}
    `;
export type EditPaymentCorrectionMutationFn = Apollo.MutationFunction<EditPaymentCorrectionMutation, EditPaymentCorrectionMutationVariables>;

/**
 * __useEditPaymentCorrectionMutation__
 *
 * To run a mutation, you first call `useEditPaymentCorrectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPaymentCorrectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPaymentCorrectionMutation, { data, loading, error }] = useEditPaymentCorrectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPaymentCorrectionMutation(baseOptions?: Apollo.MutationHookOptions<EditPaymentCorrectionMutation, EditPaymentCorrectionMutationVariables>) {
        return Apollo.useMutation<EditPaymentCorrectionMutation, EditPaymentCorrectionMutationVariables>(EditPaymentCorrectionDocument, baseOptions);
      }
export type EditPaymentCorrectionMutationHookResult = ReturnType<typeof useEditPaymentCorrectionMutation>;
export type EditPaymentCorrectionMutationResult = Apollo.MutationResult<EditPaymentCorrectionMutation>;
export type EditPaymentCorrectionMutationOptions = Apollo.BaseMutationOptions<EditPaymentCorrectionMutation, EditPaymentCorrectionMutationVariables>;
export const RemovePaymentCorrectionDocument = gql`
    mutation RemovePaymentCorrection($id: ID!) {
  deletePaymentCorrection(id: $id) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type RemovePaymentCorrectionMutationFn = Apollo.MutationFunction<RemovePaymentCorrectionMutation, RemovePaymentCorrectionMutationVariables>;

/**
 * __useRemovePaymentCorrectionMutation__
 *
 * To run a mutation, you first call `useRemovePaymentCorrectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentCorrectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentCorrectionMutation, { data, loading, error }] = useRemovePaymentCorrectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePaymentCorrectionMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentCorrectionMutation, RemovePaymentCorrectionMutationVariables>) {
        return Apollo.useMutation<RemovePaymentCorrectionMutation, RemovePaymentCorrectionMutationVariables>(RemovePaymentCorrectionDocument, baseOptions);
      }
export type RemovePaymentCorrectionMutationHookResult = ReturnType<typeof useRemovePaymentCorrectionMutation>;
export type RemovePaymentCorrectionMutationResult = Apollo.MutationResult<RemovePaymentCorrectionMutation>;
export type RemovePaymentCorrectionMutationOptions = Apollo.BaseMutationOptions<RemovePaymentCorrectionMutation, RemovePaymentCorrectionMutationVariables>;
export const MarkAgreementTransferOutDocument = gql`
    mutation MarkAgreementTransferOut($agreementId: ID!, $transferOut: Boolean!) {
  setAgreementTransferOut(agreementId: $agreementId, transferOut: $transferOut) {
    customErrors {
      field
      message
      code
    }
    agreement {
      id
      transferOut
    }
  }
}
    `;
export type MarkAgreementTransferOutMutationFn = Apollo.MutationFunction<MarkAgreementTransferOutMutation, MarkAgreementTransferOutMutationVariables>;

/**
 * __useMarkAgreementTransferOutMutation__
 *
 * To run a mutation, you first call `useMarkAgreementTransferOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAgreementTransferOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAgreementTransferOutMutation, { data, loading, error }] = useMarkAgreementTransferOutMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      transferOut: // value for 'transferOut'
 *   },
 * });
 */
export function useMarkAgreementTransferOutMutation(baseOptions?: Apollo.MutationHookOptions<MarkAgreementTransferOutMutation, MarkAgreementTransferOutMutationVariables>) {
        return Apollo.useMutation<MarkAgreementTransferOutMutation, MarkAgreementTransferOutMutationVariables>(MarkAgreementTransferOutDocument, baseOptions);
      }
export type MarkAgreementTransferOutMutationHookResult = ReturnType<typeof useMarkAgreementTransferOutMutation>;
export type MarkAgreementTransferOutMutationResult = Apollo.MutationResult<MarkAgreementTransferOutMutation>;
export type MarkAgreementTransferOutMutationOptions = Apollo.BaseMutationOptions<MarkAgreementTransferOutMutation, MarkAgreementTransferOutMutationVariables>;
export const MarkAgreementFreeOfChargeDocument = gql`
    mutation MarkAgreementFreeOfCharge($agreementId: ID!, $freeOfCharge: Boolean!) {
  setAgreementFreeOfCharge(agreementId: $agreementId, freeOfCharge: $freeOfCharge) {
    customErrors {
      field
      message
      code
    }
    agreement {
      id
      freeOfCharge
      statePrefinanced
    }
  }
}
    `;
export type MarkAgreementFreeOfChargeMutationFn = Apollo.MutationFunction<MarkAgreementFreeOfChargeMutation, MarkAgreementFreeOfChargeMutationVariables>;

/**
 * __useMarkAgreementFreeOfChargeMutation__
 *
 * To run a mutation, you first call `useMarkAgreementFreeOfChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAgreementFreeOfChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAgreementFreeOfChargeMutation, { data, loading, error }] = useMarkAgreementFreeOfChargeMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      freeOfCharge: // value for 'freeOfCharge'
 *   },
 * });
 */
export function useMarkAgreementFreeOfChargeMutation(baseOptions?: Apollo.MutationHookOptions<MarkAgreementFreeOfChargeMutation, MarkAgreementFreeOfChargeMutationVariables>) {
        return Apollo.useMutation<MarkAgreementFreeOfChargeMutation, MarkAgreementFreeOfChargeMutationVariables>(MarkAgreementFreeOfChargeDocument, baseOptions);
      }
export type MarkAgreementFreeOfChargeMutationHookResult = ReturnType<typeof useMarkAgreementFreeOfChargeMutation>;
export type MarkAgreementFreeOfChargeMutationResult = Apollo.MutationResult<MarkAgreementFreeOfChargeMutation>;
export type MarkAgreementFreeOfChargeMutationOptions = Apollo.BaseMutationOptions<MarkAgreementFreeOfChargeMutation, MarkAgreementFreeOfChargeMutationVariables>;
export const MarkAgreementStatePrefinancedDocument = gql`
    mutation MarkAgreementStatePrefinanced($agreementId: ID!, $statePrefinanced: Boolean!) {
  setAgreementStatePrefinanced(
    agreementId: $agreementId
    statePrefinanced: $statePrefinanced
  ) {
    customErrors {
      field
      message
      code
    }
    agreement {
      id
      freeOfCharge
      statePrefinanced
    }
  }
}
    `;
export type MarkAgreementStatePrefinancedMutationFn = Apollo.MutationFunction<MarkAgreementStatePrefinancedMutation, MarkAgreementStatePrefinancedMutationVariables>;

/**
 * __useMarkAgreementStatePrefinancedMutation__
 *
 * To run a mutation, you first call `useMarkAgreementStatePrefinancedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAgreementStatePrefinancedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAgreementStatePrefinancedMutation, { data, loading, error }] = useMarkAgreementStatePrefinancedMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      statePrefinanced: // value for 'statePrefinanced'
 *   },
 * });
 */
export function useMarkAgreementStatePrefinancedMutation(baseOptions?: Apollo.MutationHookOptions<MarkAgreementStatePrefinancedMutation, MarkAgreementStatePrefinancedMutationVariables>) {
        return Apollo.useMutation<MarkAgreementStatePrefinancedMutation, MarkAgreementStatePrefinancedMutationVariables>(MarkAgreementStatePrefinancedDocument, baseOptions);
      }
export type MarkAgreementStatePrefinancedMutationHookResult = ReturnType<typeof useMarkAgreementStatePrefinancedMutation>;
export type MarkAgreementStatePrefinancedMutationResult = Apollo.MutationResult<MarkAgreementStatePrefinancedMutation>;
export type MarkAgreementStatePrefinancedMutationOptions = Apollo.BaseMutationOptions<MarkAgreementStatePrefinancedMutation, MarkAgreementStatePrefinancedMutationVariables>;
export const IssueLmsBlockDocument = gql`
    mutation IssueLmsBlock($studentId: ID!, $reason: String, $notifyStudent: Boolean) {
  blockStudentLmsAccess(
    studentId: $studentId
    reason: $reason
    notifyStudent: $notifyStudent
  ) {
    success
    customErrors {
      field
      message
      code
    }
    accessBlock {
      id
      isBlocked
      reason
      overdueInvoiceCount
      maxOverdueDays
      source
      blockedAt
      blockedByName
    }
  }
}
    `;
export type IssueLmsBlockMutationFn = Apollo.MutationFunction<IssueLmsBlockMutation, IssueLmsBlockMutationVariables>;

/**
 * __useIssueLmsBlockMutation__
 *
 * To run a mutation, you first call `useIssueLmsBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueLmsBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueLmsBlockMutation, { data, loading, error }] = useIssueLmsBlockMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      reason: // value for 'reason'
 *      notifyStudent: // value for 'notifyStudent'
 *   },
 * });
 */
export function useIssueLmsBlockMutation(baseOptions?: Apollo.MutationHookOptions<IssueLmsBlockMutation, IssueLmsBlockMutationVariables>) {
        return Apollo.useMutation<IssueLmsBlockMutation, IssueLmsBlockMutationVariables>(IssueLmsBlockDocument, baseOptions);
      }
export type IssueLmsBlockMutationHookResult = ReturnType<typeof useIssueLmsBlockMutation>;
export type IssueLmsBlockMutationResult = Apollo.MutationResult<IssueLmsBlockMutation>;
export type IssueLmsBlockMutationOptions = Apollo.BaseMutationOptions<IssueLmsBlockMutation, IssueLmsBlockMutationVariables>;
export const LiftLmsBlockDocument = gql`
    mutation LiftLmsBlock($studentId: ID!, $reason: String, $notifyStudent: Boolean) {
  unblockStudentLmsAccess(
    studentId: $studentId
    reason: $reason
    notifyStudent: $notifyStudent
  ) {
    success
    customErrors {
      field
      message
      code
    }
    accessBlock {
      id
      isBlocked
      manualOverride
      unblockedAt
      unblockedByName
    }
  }
}
    `;
export type LiftLmsBlockMutationFn = Apollo.MutationFunction<LiftLmsBlockMutation, LiftLmsBlockMutationVariables>;

/**
 * __useLiftLmsBlockMutation__
 *
 * To run a mutation, you first call `useLiftLmsBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLiftLmsBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [liftLmsBlockMutation, { data, loading, error }] = useLiftLmsBlockMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      reason: // value for 'reason'
 *      notifyStudent: // value for 'notifyStudent'
 *   },
 * });
 */
export function useLiftLmsBlockMutation(baseOptions?: Apollo.MutationHookOptions<LiftLmsBlockMutation, LiftLmsBlockMutationVariables>) {
        return Apollo.useMutation<LiftLmsBlockMutation, LiftLmsBlockMutationVariables>(LiftLmsBlockDocument, baseOptions);
      }
export type LiftLmsBlockMutationHookResult = ReturnType<typeof useLiftLmsBlockMutation>;
export type LiftLmsBlockMutationResult = Apollo.MutationResult<LiftLmsBlockMutation>;
export type LiftLmsBlockMutationOptions = Apollo.BaseMutationOptions<LiftLmsBlockMutation, LiftLmsBlockMutationVariables>;
export const AddNoteDocument = gql`
    mutation AddNote($input: CreateStudentNoteInput!) {
  createStudentNote(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    note {
      id
      body
      sentiment
      pinned
      createdAt
      authorName
    }
  }
}
    `;
export type AddNoteMutationFn = Apollo.MutationFunction<AddNoteMutation, AddNoteMutationVariables>;

/**
 * __useAddNoteMutation__
 *
 * To run a mutation, you first call `useAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteMutation, { data, loading, error }] = useAddNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteMutation, AddNoteMutationVariables>) {
        return Apollo.useMutation<AddNoteMutation, AddNoteMutationVariables>(AddNoteDocument, baseOptions);
      }
export type AddNoteMutationHookResult = ReturnType<typeof useAddNoteMutation>;
export type AddNoteMutationResult = Apollo.MutationResult<AddNoteMutation>;
export type AddNoteMutationOptions = Apollo.BaseMutationOptions<AddNoteMutation, AddNoteMutationVariables>;
export const EditNoteDocument = gql`
    mutation EditNote($input: UpdateStudentNoteInput!) {
  updateStudentNote(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    note {
      id
      body
      sentiment
      pinned
    }
  }
}
    `;
export type EditNoteMutationFn = Apollo.MutationFunction<EditNoteMutation, EditNoteMutationVariables>;

/**
 * __useEditNoteMutation__
 *
 * To run a mutation, you first call `useEditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNoteMutation, { data, loading, error }] = useEditNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditNoteMutation(baseOptions?: Apollo.MutationHookOptions<EditNoteMutation, EditNoteMutationVariables>) {
        return Apollo.useMutation<EditNoteMutation, EditNoteMutationVariables>(EditNoteDocument, baseOptions);
      }
export type EditNoteMutationHookResult = ReturnType<typeof useEditNoteMutation>;
export type EditNoteMutationResult = Apollo.MutationResult<EditNoteMutation>;
export type EditNoteMutationOptions = Apollo.BaseMutationOptions<EditNoteMutation, EditNoteMutationVariables>;
export const RemoveNoteDocument = gql`
    mutation RemoveNote($id: ID!) {
  deleteStudentNote(id: $id) {
    success
    customErrors {
      code
      message
    }
  }
}
    `;
export type RemoveNoteMutationFn = Apollo.MutationFunction<RemoveNoteMutation, RemoveNoteMutationVariables>;

/**
 * __useRemoveNoteMutation__
 *
 * To run a mutation, you first call `useRemoveNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNoteMutation, { data, loading, error }] = useRemoveNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveNoteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNoteMutation, RemoveNoteMutationVariables>) {
        return Apollo.useMutation<RemoveNoteMutation, RemoveNoteMutationVariables>(RemoveNoteDocument, baseOptions);
      }
export type RemoveNoteMutationHookResult = ReturnType<typeof useRemoveNoteMutation>;
export type RemoveNoteMutationResult = Apollo.MutationResult<RemoveNoteMutation>;
export type RemoveNoteMutationOptions = Apollo.BaseMutationOptions<RemoveNoteMutation, RemoveNoteMutationVariables>;
export const AddTaskDocument = gql`
    mutation AddTask($input: CreateStaffTaskInput!, $files: [Upload]) {
  createStaffTask(input: $input, files: $files) {
    success
    customErrors {
      field
      message
      code
    }
    task {
      id
      title
      description
      status
      priority
      startDate
      dueDate
      completedAt
      createdAt
      assigneeId
      assigneeName
    }
  }
}
    `;
export type AddTaskMutationFn = Apollo.MutationFunction<AddTaskMutation, AddTaskMutationVariables>;

/**
 * __useAddTaskMutation__
 *
 * To run a mutation, you first call `useAddTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskMutation, { data, loading, error }] = useAddTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useAddTaskMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskMutation, AddTaskMutationVariables>) {
        return Apollo.useMutation<AddTaskMutation, AddTaskMutationVariables>(AddTaskDocument, baseOptions);
      }
export type AddTaskMutationHookResult = ReturnType<typeof useAddTaskMutation>;
export type AddTaskMutationResult = Apollo.MutationResult<AddTaskMutation>;
export type AddTaskMutationOptions = Apollo.BaseMutationOptions<AddTaskMutation, AddTaskMutationVariables>;
export const EditTaskDocument = gql`
    mutation EditTask($input: UpdateStaffTaskInput!) {
  updateStaffTask(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    task {
      id
      title
      description
      priority
      startDate
      dueDate
      updatedAt
      assigneeId
      assigneeName
      links {
        id
        kind
        objectId
        name
        hint
        missing
        href
      }
    }
  }
}
    `;
export type EditTaskMutationFn = Apollo.MutationFunction<EditTaskMutation, EditTaskMutationVariables>;

/**
 * __useEditTaskMutation__
 *
 * To run a mutation, you first call `useEditTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskMutation, { data, loading, error }] = useEditTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTaskMutation(baseOptions?: Apollo.MutationHookOptions<EditTaskMutation, EditTaskMutationVariables>) {
        return Apollo.useMutation<EditTaskMutation, EditTaskMutationVariables>(EditTaskDocument, baseOptions);
      }
export type EditTaskMutationHookResult = ReturnType<typeof useEditTaskMutation>;
export type EditTaskMutationResult = Apollo.MutationResult<EditTaskMutation>;
export type EditTaskMutationOptions = Apollo.BaseMutationOptions<EditTaskMutation, EditTaskMutationVariables>;
export const ChangeTaskStatusDocument = gql`
    mutation ChangeTaskStatus($id: ID!, $status: String!) {
  updateTaskStatus(id: $id, status: $status) {
    success
    customErrors {
      field
      message
      code
    }
    task {
      id
      status
      completedAt
      updatedAt
    }
  }
}
    `;
export type ChangeTaskStatusMutationFn = Apollo.MutationFunction<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>;

/**
 * __useChangeTaskStatusMutation__
 *
 * To run a mutation, you first call `useChangeTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTaskStatusMutation, { data, loading, error }] = useChangeTaskStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>) {
        return Apollo.useMutation<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>(ChangeTaskStatusDocument, baseOptions);
      }
export type ChangeTaskStatusMutationHookResult = ReturnType<typeof useChangeTaskStatusMutation>;
export type ChangeTaskStatusMutationResult = Apollo.MutationResult<ChangeTaskStatusMutation>;
export type ChangeTaskStatusMutationOptions = Apollo.BaseMutationOptions<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>;
export const RemoveTaskDocument = gql`
    mutation RemoveTask($id: ID!) {
  deleteStaffTask(id: $id) {
    success
    customErrors {
      code
      message
    }
  }
}
    `;
export type RemoveTaskMutationFn = Apollo.MutationFunction<RemoveTaskMutation, RemoveTaskMutationVariables>;

/**
 * __useRemoveTaskMutation__
 *
 * To run a mutation, you first call `useRemoveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskMutation, { data, loading, error }] = useRemoveTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTaskMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskMutation, RemoveTaskMutationVariables>) {
        return Apollo.useMutation<RemoveTaskMutation, RemoveTaskMutationVariables>(RemoveTaskDocument, baseOptions);
      }
export type RemoveTaskMutationHookResult = ReturnType<typeof useRemoveTaskMutation>;
export type RemoveTaskMutationResult = Apollo.MutationResult<RemoveTaskMutation>;
export type RemoveTaskMutationOptions = Apollo.BaseMutationOptions<RemoveTaskMutation, RemoveTaskMutationVariables>;
export const MoveTaskDocument = gql`
    mutation MoveTask($input: MoveStaffTaskInput!) {
  moveStaffTask(input: $input) {
    success
    customErrors {
      field
      message
      code
    }
    task {
      id
      status
      startDate
      dueDate
      position
      completedAt
      updatedAt
    }
  }
}
    `;
export type MoveTaskMutationFn = Apollo.MutationFunction<MoveTaskMutation, MoveTaskMutationVariables>;

/**
 * __useMoveTaskMutation__
 *
 * To run a mutation, you first call `useMoveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTaskMutation, { data, loading, error }] = useMoveTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTaskMutation(baseOptions?: Apollo.MutationHookOptions<MoveTaskMutation, MoveTaskMutationVariables>) {
        return Apollo.useMutation<MoveTaskMutation, MoveTaskMutationVariables>(MoveTaskDocument, baseOptions);
      }
export type MoveTaskMutationHookResult = ReturnType<typeof useMoveTaskMutation>;
export type MoveTaskMutationResult = Apollo.MutationResult<MoveTaskMutation>;
export type MoveTaskMutationOptions = Apollo.BaseMutationOptions<MoveTaskMutation, MoveTaskMutationVariables>;
export const MarkInstallmentPaidManuallyDocument = gql`
    mutation MarkInstallmentPaidManually($contributionId: ID!, $date: Date!, $amount: Float) {
  markContributionPaidManually(
    contributionId: $contributionId
    date: $date
    amount: $amount
  ) {
    success
    customErrors {
      field
      message
      code
    }
    contribution {
      id
      status
      coveredAmount
      debt
      paidManually
      complete
      remainder
      payment {
        id
        date
        amountAgreement
        currency
      }
    }
  }
}
    `;
export type MarkInstallmentPaidManuallyMutationFn = Apollo.MutationFunction<MarkInstallmentPaidManuallyMutation, MarkInstallmentPaidManuallyMutationVariables>;

/**
 * __useMarkInstallmentPaidManuallyMutation__
 *
 * To run a mutation, you first call `useMarkInstallmentPaidManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInstallmentPaidManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInstallmentPaidManuallyMutation, { data, loading, error }] = useMarkInstallmentPaidManuallyMutation({
 *   variables: {
 *      contributionId: // value for 'contributionId'
 *      date: // value for 'date'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useMarkInstallmentPaidManuallyMutation(baseOptions?: Apollo.MutationHookOptions<MarkInstallmentPaidManuallyMutation, MarkInstallmentPaidManuallyMutationVariables>) {
        return Apollo.useMutation<MarkInstallmentPaidManuallyMutation, MarkInstallmentPaidManuallyMutationVariables>(MarkInstallmentPaidManuallyDocument, baseOptions);
      }
export type MarkInstallmentPaidManuallyMutationHookResult = ReturnType<typeof useMarkInstallmentPaidManuallyMutation>;
export type MarkInstallmentPaidManuallyMutationResult = Apollo.MutationResult<MarkInstallmentPaidManuallyMutation>;
export type MarkInstallmentPaidManuallyMutationOptions = Apollo.BaseMutationOptions<MarkInstallmentPaidManuallyMutation, MarkInstallmentPaidManuallyMutationVariables>;
export const RevertInstallmentManualPaymentDocument = gql`
    mutation RevertInstallmentManualPayment($contributionId: ID!) {
  revertManualContributionPayment(contributionId: $contributionId) {
    success
    customErrors {
      field
      message
      code
    }
    contribution {
      id
      status
      coveredAmount
      debt
      paidManually
      complete
      remainder
      payment {
        id
      }
    }
  }
}
    `;
export type RevertInstallmentManualPaymentMutationFn = Apollo.MutationFunction<RevertInstallmentManualPaymentMutation, RevertInstallmentManualPaymentMutationVariables>;

/**
 * __useRevertInstallmentManualPaymentMutation__
 *
 * To run a mutation, you first call `useRevertInstallmentManualPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertInstallmentManualPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertInstallmentManualPaymentMutation, { data, loading, error }] = useRevertInstallmentManualPaymentMutation({
 *   variables: {
 *      contributionId: // value for 'contributionId'
 *   },
 * });
 */
export function useRevertInstallmentManualPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RevertInstallmentManualPaymentMutation, RevertInstallmentManualPaymentMutationVariables>) {
        return Apollo.useMutation<RevertInstallmentManualPaymentMutation, RevertInstallmentManualPaymentMutationVariables>(RevertInstallmentManualPaymentDocument, baseOptions);
      }
export type RevertInstallmentManualPaymentMutationHookResult = ReturnType<typeof useRevertInstallmentManualPaymentMutation>;
export type RevertInstallmentManualPaymentMutationResult = Apollo.MutationResult<RevertInstallmentManualPaymentMutation>;
export type RevertInstallmentManualPaymentMutationOptions = Apollo.BaseMutationOptions<RevertInstallmentManualPaymentMutation, RevertInstallmentManualPaymentMutationVariables>;
export const AddTaskLinksDocument = gql`
    mutation AddTaskLinks($taskId: ID!, $links: [TaskLinkInput!]!) {
  addStaffTaskLinks(taskId: $taskId, links: $links) {
    success
    customErrors {
      field
      message
      code
    }
    task {
      id
      links {
        id
        kind
        objectId
        name
        hint
        missing
        href
      }
    }
  }
}
    `;
export type AddTaskLinksMutationFn = Apollo.MutationFunction<AddTaskLinksMutation, AddTaskLinksMutationVariables>;

/**
 * __useAddTaskLinksMutation__
 *
 * To run a mutation, you first call `useAddTaskLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskLinksMutation, { data, loading, error }] = useAddTaskLinksMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useAddTaskLinksMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskLinksMutation, AddTaskLinksMutationVariables>) {
        return Apollo.useMutation<AddTaskLinksMutation, AddTaskLinksMutationVariables>(AddTaskLinksDocument, baseOptions);
      }
export type AddTaskLinksMutationHookResult = ReturnType<typeof useAddTaskLinksMutation>;
export type AddTaskLinksMutationResult = Apollo.MutationResult<AddTaskLinksMutation>;
export type AddTaskLinksMutationOptions = Apollo.BaseMutationOptions<AddTaskLinksMutation, AddTaskLinksMutationVariables>;
export const RemoveTaskLinkDocument = gql`
    mutation RemoveTaskLink($linkId: ID!) {
  removeStaffTaskLink(linkId: $linkId) {
    success
    customErrors {
      field
      message
      code
    }
    task {
      id
      links {
        id
        kind
        objectId
        name
        hint
        missing
        href
      }
    }
  }
}
    `;
export type RemoveTaskLinkMutationFn = Apollo.MutationFunction<RemoveTaskLinkMutation, RemoveTaskLinkMutationVariables>;

/**
 * __useRemoveTaskLinkMutation__
 *
 * To run a mutation, you first call `useRemoveTaskLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskLinkMutation, { data, loading, error }] = useRemoveTaskLinkMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useRemoveTaskLinkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskLinkMutation, RemoveTaskLinkMutationVariables>) {
        return Apollo.useMutation<RemoveTaskLinkMutation, RemoveTaskLinkMutationVariables>(RemoveTaskLinkDocument, baseOptions);
      }
export type RemoveTaskLinkMutationHookResult = ReturnType<typeof useRemoveTaskLinkMutation>;
export type RemoveTaskLinkMutationResult = Apollo.MutationResult<RemoveTaskLinkMutation>;
export type RemoveTaskLinkMutationOptions = Apollo.BaseMutationOptions<RemoveTaskLinkMutation, RemoveTaskLinkMutationVariables>;
export const AddTaskCommentDocument = gql`
    mutation AddTaskComment($taskId: ID!, $body: String, $files: [Upload]) {
  addStaffTaskComment(taskId: $taskId, body: $body, files: $files) {
    success
    customErrors {
      field
      message
      code
    }
    comment {
      id
      body
      authorName
      createdAt
      editedAt
      canEdit
      attachments {
        id
        originalName
        contentType
        sizeBytes
        isImage
        commentId
        uploadedByName
        createdAt
        canDelete
      }
    }
    task {
      id
      commentsCount
      attachmentsCount
      coverAttachmentId
      attachments {
        id
        originalName
        contentType
        sizeBytes
        isImage
        commentId
        uploadedByName
        createdAt
        canDelete
      }
    }
  }
}
    `;
export type AddTaskCommentMutationFn = Apollo.MutationFunction<AddTaskCommentMutation, AddTaskCommentMutationVariables>;

/**
 * __useAddTaskCommentMutation__
 *
 * To run a mutation, you first call `useAddTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskCommentMutation, { data, loading, error }] = useAddTaskCommentMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      body: // value for 'body'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useAddTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskCommentMutation, AddTaskCommentMutationVariables>) {
        return Apollo.useMutation<AddTaskCommentMutation, AddTaskCommentMutationVariables>(AddTaskCommentDocument, baseOptions);
      }
export type AddTaskCommentMutationHookResult = ReturnType<typeof useAddTaskCommentMutation>;
export type AddTaskCommentMutationResult = Apollo.MutationResult<AddTaskCommentMutation>;
export type AddTaskCommentMutationOptions = Apollo.BaseMutationOptions<AddTaskCommentMutation, AddTaskCommentMutationVariables>;
export const EditTaskCommentDocument = gql`
    mutation EditTaskComment($id: ID!, $body: String!) {
  editStaffTaskComment(id: $id, body: $body) {
    success
    customErrors {
      field
      message
      code
    }
    comment {
      id
      body
      authorName
      createdAt
      editedAt
      canEdit
    }
  }
}
    `;
export type EditTaskCommentMutationFn = Apollo.MutationFunction<EditTaskCommentMutation, EditTaskCommentMutationVariables>;

/**
 * __useEditTaskCommentMutation__
 *
 * To run a mutation, you first call `useEditTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskCommentMutation, { data, loading, error }] = useEditTaskCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useEditTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<EditTaskCommentMutation, EditTaskCommentMutationVariables>) {
        return Apollo.useMutation<EditTaskCommentMutation, EditTaskCommentMutationVariables>(EditTaskCommentDocument, baseOptions);
      }
export type EditTaskCommentMutationHookResult = ReturnType<typeof useEditTaskCommentMutation>;
export type EditTaskCommentMutationResult = Apollo.MutationResult<EditTaskCommentMutation>;
export type EditTaskCommentMutationOptions = Apollo.BaseMutationOptions<EditTaskCommentMutation, EditTaskCommentMutationVariables>;
export const RemoveTaskCommentDocument = gql`
    mutation RemoveTaskComment($id: ID!) {
  deleteStaffTaskComment(id: $id) {
    success
    customErrors {
      field
      message
      code
    }
    task {
      id
      commentsCount
    }
  }
}
    `;
export type RemoveTaskCommentMutationFn = Apollo.MutationFunction<RemoveTaskCommentMutation, RemoveTaskCommentMutationVariables>;

/**
 * __useRemoveTaskCommentMutation__
 *
 * To run a mutation, you first call `useRemoveTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskCommentMutation, { data, loading, error }] = useRemoveTaskCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskCommentMutation, RemoveTaskCommentMutationVariables>) {
        return Apollo.useMutation<RemoveTaskCommentMutation, RemoveTaskCommentMutationVariables>(RemoveTaskCommentDocument, baseOptions);
      }
export type RemoveTaskCommentMutationHookResult = ReturnType<typeof useRemoveTaskCommentMutation>;
export type RemoveTaskCommentMutationResult = Apollo.MutationResult<RemoveTaskCommentMutation>;
export type RemoveTaskCommentMutationOptions = Apollo.BaseMutationOptions<RemoveTaskCommentMutation, RemoveTaskCommentMutationVariables>;
export const AttachTaskFileDocument = gql`
    mutation AttachTaskFile($taskId: ID!, $file: Upload!, $commentId: ID) {
  addStaffTaskAttachment(taskId: $taskId, file: $file, commentId: $commentId) {
    success
    customErrors {
      field
      message
      code
    }
    attachment {
      id
      originalName
      contentType
      sizeBytes
      isImage
      commentId
      uploadedByName
      createdAt
      canDelete
    }
    task {
      id
      attachmentsCount
      coverAttachmentId
      attachments {
        id
        originalName
        contentType
        sizeBytes
        isImage
        commentId
        uploadedByName
        createdAt
        canDelete
      }
    }
  }
}
    `;
export type AttachTaskFileMutationFn = Apollo.MutationFunction<AttachTaskFileMutation, AttachTaskFileMutationVariables>;

/**
 * __useAttachTaskFileMutation__
 *
 * To run a mutation, you first call `useAttachTaskFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachTaskFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachTaskFileMutation, { data, loading, error }] = useAttachTaskFileMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      file: // value for 'file'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useAttachTaskFileMutation(baseOptions?: Apollo.MutationHookOptions<AttachTaskFileMutation, AttachTaskFileMutationVariables>) {
        return Apollo.useMutation<AttachTaskFileMutation, AttachTaskFileMutationVariables>(AttachTaskFileDocument, baseOptions);
      }
export type AttachTaskFileMutationHookResult = ReturnType<typeof useAttachTaskFileMutation>;
export type AttachTaskFileMutationResult = Apollo.MutationResult<AttachTaskFileMutation>;
export type AttachTaskFileMutationOptions = Apollo.BaseMutationOptions<AttachTaskFileMutation, AttachTaskFileMutationVariables>;
export const DetachTaskFileDocument = gql`
    mutation DetachTaskFile($attachmentId: ID!) {
  removeStaffTaskAttachment(attachmentId: $attachmentId) {
    success
    customErrors {
      field
      message
      code
    }
    task {
      id
      attachmentsCount
      coverAttachmentId
      attachments {
        id
        originalName
        contentType
        sizeBytes
        isImage
        commentId
        uploadedByName
        createdAt
        canDelete
      }
    }
  }
}
    `;
export type DetachTaskFileMutationFn = Apollo.MutationFunction<DetachTaskFileMutation, DetachTaskFileMutationVariables>;

/**
 * __useDetachTaskFileMutation__
 *
 * To run a mutation, you first call `useDetachTaskFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachTaskFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachTaskFileMutation, { data, loading, error }] = useDetachTaskFileMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDetachTaskFileMutation(baseOptions?: Apollo.MutationHookOptions<DetachTaskFileMutation, DetachTaskFileMutationVariables>) {
        return Apollo.useMutation<DetachTaskFileMutation, DetachTaskFileMutationVariables>(DetachTaskFileDocument, baseOptions);
      }
export type DetachTaskFileMutationHookResult = ReturnType<typeof useDetachTaskFileMutation>;
export type DetachTaskFileMutationResult = Apollo.MutationResult<DetachTaskFileMutation>;
export type DetachTaskFileMutationOptions = Apollo.BaseMutationOptions<DetachTaskFileMutation, DetachTaskFileMutationVariables>;
export const SaveNewSurveyDocument = gql`
    mutation SaveNewSurvey($input: SurveyInput!) {
  createSurvey(input: $input) {
    success
    customErrors {
      code
      field
      message
    }
    survey {
      id
    }
  }
}
    `;
export type SaveNewSurveyMutationFn = Apollo.MutationFunction<SaveNewSurveyMutation, SaveNewSurveyMutationVariables>;

/**
 * __useSaveNewSurveyMutation__
 *
 * To run a mutation, you first call `useSaveNewSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNewSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNewSurveyMutation, { data, loading, error }] = useSaveNewSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveNewSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SaveNewSurveyMutation, SaveNewSurveyMutationVariables>) {
        return Apollo.useMutation<SaveNewSurveyMutation, SaveNewSurveyMutationVariables>(SaveNewSurveyDocument, baseOptions);
      }
export type SaveNewSurveyMutationHookResult = ReturnType<typeof useSaveNewSurveyMutation>;
export type SaveNewSurveyMutationResult = Apollo.MutationResult<SaveNewSurveyMutation>;
export type SaveNewSurveyMutationOptions = Apollo.BaseMutationOptions<SaveNewSurveyMutation, SaveNewSurveyMutationVariables>;
export const SaveExistingSurveyDocument = gql`
    mutation SaveExistingSurvey($id: ID!, $input: SurveyInput!) {
  updateSurvey(id: $id, input: $input) {
    success
    customErrors {
      code
      field
      message
    }
    survey {
      id
    }
  }
}
    `;
export type SaveExistingSurveyMutationFn = Apollo.MutationFunction<SaveExistingSurveyMutation, SaveExistingSurveyMutationVariables>;

/**
 * __useSaveExistingSurveyMutation__
 *
 * To run a mutation, you first call `useSaveExistingSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExistingSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExistingSurveyMutation, { data, loading, error }] = useSaveExistingSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveExistingSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SaveExistingSurveyMutation, SaveExistingSurveyMutationVariables>) {
        return Apollo.useMutation<SaveExistingSurveyMutation, SaveExistingSurveyMutationVariables>(SaveExistingSurveyDocument, baseOptions);
      }
export type SaveExistingSurveyMutationHookResult = ReturnType<typeof useSaveExistingSurveyMutation>;
export type SaveExistingSurveyMutationResult = Apollo.MutationResult<SaveExistingSurveyMutation>;
export type SaveExistingSurveyMutationOptions = Apollo.BaseMutationOptions<SaveExistingSurveyMutation, SaveExistingSurveyMutationVariables>;
export const ToggleSurveyArchiveDocument = gql`
    mutation ToggleSurveyArchive($id: ID!, $isArchived: Boolean!) {
  archiveSurvey(id: $id, isArchived: $isArchived) {
    success
    customErrors {
      code
      field
      message
    }
    survey {
      id
      isArchived
    }
  }
}
    `;
export type ToggleSurveyArchiveMutationFn = Apollo.MutationFunction<ToggleSurveyArchiveMutation, ToggleSurveyArchiveMutationVariables>;

/**
 * __useToggleSurveyArchiveMutation__
 *
 * To run a mutation, you first call `useToggleSurveyArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSurveyArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSurveyArchiveMutation, { data, loading, error }] = useToggleSurveyArchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useToggleSurveyArchiveMutation(baseOptions?: Apollo.MutationHookOptions<ToggleSurveyArchiveMutation, ToggleSurveyArchiveMutationVariables>) {
        return Apollo.useMutation<ToggleSurveyArchiveMutation, ToggleSurveyArchiveMutationVariables>(ToggleSurveyArchiveDocument, baseOptions);
      }
export type ToggleSurveyArchiveMutationHookResult = ReturnType<typeof useToggleSurveyArchiveMutation>;
export type ToggleSurveyArchiveMutationResult = Apollo.MutationResult<ToggleSurveyArchiveMutation>;
export type ToggleSurveyArchiveMutationOptions = Apollo.BaseMutationOptions<ToggleSurveyArchiveMutation, ToggleSurveyArchiveMutationVariables>;
export const CloneSurveyDocument = gql`
    mutation CloneSurvey($id: ID!) {
  duplicateSurvey(id: $id) {
    success
    customErrors {
      code
      field
      message
    }
    survey {
      id
    }
  }
}
    `;
export type CloneSurveyMutationFn = Apollo.MutationFunction<CloneSurveyMutation, CloneSurveyMutationVariables>;

/**
 * __useCloneSurveyMutation__
 *
 * To run a mutation, you first call `useCloneSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneSurveyMutation, { data, loading, error }] = useCloneSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CloneSurveyMutation, CloneSurveyMutationVariables>) {
        return Apollo.useMutation<CloneSurveyMutation, CloneSurveyMutationVariables>(CloneSurveyDocument, baseOptions);
      }
export type CloneSurveyMutationHookResult = ReturnType<typeof useCloneSurveyMutation>;
export type CloneSurveyMutationResult = Apollo.MutationResult<CloneSurveyMutation>;
export type CloneSurveyMutationOptions = Apollo.BaseMutationOptions<CloneSurveyMutation, CloneSurveyMutationVariables>;
export const AttachSurveyToGroupDocument = gql`
    mutation AttachSurveyToGroup($surveyId: ID!, $groupId: ID!, $triggerLessonId: ID!) {
  assignSurveyToGroup(
    surveyId: $surveyId
    groupId: $groupId
    triggerLessonId: $triggerLessonId
  ) {
    success
    customErrors {
      code
      field
      message
    }
    assignment {
      id
    }
  }
}
    `;
export type AttachSurveyToGroupMutationFn = Apollo.MutationFunction<AttachSurveyToGroupMutation, AttachSurveyToGroupMutationVariables>;

/**
 * __useAttachSurveyToGroupMutation__
 *
 * To run a mutation, you first call `useAttachSurveyToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachSurveyToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachSurveyToGroupMutation, { data, loading, error }] = useAttachSurveyToGroupMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      groupId: // value for 'groupId'
 *      triggerLessonId: // value for 'triggerLessonId'
 *   },
 * });
 */
export function useAttachSurveyToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AttachSurveyToGroupMutation, AttachSurveyToGroupMutationVariables>) {
        return Apollo.useMutation<AttachSurveyToGroupMutation, AttachSurveyToGroupMutationVariables>(AttachSurveyToGroupDocument, baseOptions);
      }
export type AttachSurveyToGroupMutationHookResult = ReturnType<typeof useAttachSurveyToGroupMutation>;
export type AttachSurveyToGroupMutationResult = Apollo.MutationResult<AttachSurveyToGroupMutation>;
export type AttachSurveyToGroupMutationOptions = Apollo.BaseMutationOptions<AttachSurveyToGroupMutation, AttachSurveyToGroupMutationVariables>;
export const EditSurveyAssignmentDocument = gql`
    mutation EditSurveyAssignment($id: ID!, $isActive: Boolean, $triggerLessonId: ID) {
  updateSurveyAssignment(
    id: $id
    isActive: $isActive
    triggerLessonId: $triggerLessonId
  ) {
    success
    customErrors {
      code
      field
      message
    }
    assignment {
      id
      isActive
    }
  }
}
    `;
export type EditSurveyAssignmentMutationFn = Apollo.MutationFunction<EditSurveyAssignmentMutation, EditSurveyAssignmentMutationVariables>;

/**
 * __useEditSurveyAssignmentMutation__
 *
 * To run a mutation, you first call `useEditSurveyAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSurveyAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSurveyAssignmentMutation, { data, loading, error }] = useEditSurveyAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *      triggerLessonId: // value for 'triggerLessonId'
 *   },
 * });
 */
export function useEditSurveyAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<EditSurveyAssignmentMutation, EditSurveyAssignmentMutationVariables>) {
        return Apollo.useMutation<EditSurveyAssignmentMutation, EditSurveyAssignmentMutationVariables>(EditSurveyAssignmentDocument, baseOptions);
      }
export type EditSurveyAssignmentMutationHookResult = ReturnType<typeof useEditSurveyAssignmentMutation>;
export type EditSurveyAssignmentMutationResult = Apollo.MutationResult<EditSurveyAssignmentMutation>;
export type EditSurveyAssignmentMutationOptions = Apollo.BaseMutationOptions<EditSurveyAssignmentMutation, EditSurveyAssignmentMutationVariables>;
export const RemoveSurveyAssignmentDocument = gql`
    mutation RemoveSurveyAssignment($id: ID!) {
  deleteSurveyAssignment(id: $id) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type RemoveSurveyAssignmentMutationFn = Apollo.MutationFunction<RemoveSurveyAssignmentMutation, RemoveSurveyAssignmentMutationVariables>;

/**
 * __useRemoveSurveyAssignmentMutation__
 *
 * To run a mutation, you first call `useRemoveSurveyAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSurveyAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSurveyAssignmentMutation, { data, loading, error }] = useRemoveSurveyAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSurveyAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSurveyAssignmentMutation, RemoveSurveyAssignmentMutationVariables>) {
        return Apollo.useMutation<RemoveSurveyAssignmentMutation, RemoveSurveyAssignmentMutationVariables>(RemoveSurveyAssignmentDocument, baseOptions);
      }
export type RemoveSurveyAssignmentMutationHookResult = ReturnType<typeof useRemoveSurveyAssignmentMutation>;
export type RemoveSurveyAssignmentMutationResult = Apollo.MutationResult<RemoveSurveyAssignmentMutation>;
export type RemoveSurveyAssignmentMutationOptions = Apollo.BaseMutationOptions<RemoveSurveyAssignmentMutation, RemoveSurveyAssignmentMutationVariables>;
export const SaveSurveyTargetingDocument = gql`
    mutation SaveSurveyTargeting($surveyId: ID!, $plans: [SurveyPlanInput!]!) {
  setSurveyTargeting(surveyId: $surveyId, plans: $plans) {
    success
    customErrors {
      code
      field
      message
    }
    targeting {
      assignmentsCreated
      assignmentsAdopted
      assignmentsDeactivated
      assignmentsDeleted
      skipped {
        groupId
        groupName
        reason
      }
      plans {
        id
        scope
        courseId
        courseName
        onlyActiveGroups
        triggerKind
        triggerLessonNumber
        skipPastLessons
        isActive
        assignmentsCount
        respondedCount
        hasResponses
        groups {
          groupId
          groupName
        }
      }
    }
  }
}
    `;
export type SaveSurveyTargetingMutationFn = Apollo.MutationFunction<SaveSurveyTargetingMutation, SaveSurveyTargetingMutationVariables>;

/**
 * __useSaveSurveyTargetingMutation__
 *
 * To run a mutation, you first call `useSaveSurveyTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSurveyTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSurveyTargetingMutation, { data, loading, error }] = useSaveSurveyTargetingMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      plans: // value for 'plans'
 *   },
 * });
 */
export function useSaveSurveyTargetingMutation(baseOptions?: Apollo.MutationHookOptions<SaveSurveyTargetingMutation, SaveSurveyTargetingMutationVariables>) {
        return Apollo.useMutation<SaveSurveyTargetingMutation, SaveSurveyTargetingMutationVariables>(SaveSurveyTargetingDocument, baseOptions);
      }
export type SaveSurveyTargetingMutationHookResult = ReturnType<typeof useSaveSurveyTargetingMutation>;
export type SaveSurveyTargetingMutationResult = Apollo.MutationResult<SaveSurveyTargetingMutation>;
export type SaveSurveyTargetingMutationOptions = Apollo.BaseMutationOptions<SaveSurveyTargetingMutation, SaveSurveyTargetingMutationVariables>;
export const AttachSurveyToGroupsDocument = gql`
    mutation AttachSurveyToGroups($surveyId: ID!, $groupIds: [ID!]!, $triggerKind: String!, $triggerLessonNumber: Int) {
  assignSurveyToGroups(
    surveyId: $surveyId
    groupIds: $groupIds
    triggerKind: $triggerKind
    triggerLessonNumber: $triggerLessonNumber
  ) {
    success
    customErrors {
      code
      field
      message
    }
    createdCount
    skipped {
      groupId
      groupName
      reason
    }
  }
}
    `;
export type AttachSurveyToGroupsMutationFn = Apollo.MutationFunction<AttachSurveyToGroupsMutation, AttachSurveyToGroupsMutationVariables>;

/**
 * __useAttachSurveyToGroupsMutation__
 *
 * To run a mutation, you first call `useAttachSurveyToGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachSurveyToGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachSurveyToGroupsMutation, { data, loading, error }] = useAttachSurveyToGroupsMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      groupIds: // value for 'groupIds'
 *      triggerKind: // value for 'triggerKind'
 *      triggerLessonNumber: // value for 'triggerLessonNumber'
 *   },
 * });
 */
export function useAttachSurveyToGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AttachSurveyToGroupsMutation, AttachSurveyToGroupsMutationVariables>) {
        return Apollo.useMutation<AttachSurveyToGroupsMutation, AttachSurveyToGroupsMutationVariables>(AttachSurveyToGroupsDocument, baseOptions);
      }
export type AttachSurveyToGroupsMutationHookResult = ReturnType<typeof useAttachSurveyToGroupsMutation>;
export type AttachSurveyToGroupsMutationResult = Apollo.MutationResult<AttachSurveyToGroupsMutation>;
export type AttachSurveyToGroupsMutationOptions = Apollo.BaseMutationOptions<AttachSurveyToGroupsMutation, AttachSurveyToGroupsMutationVariables>;
export const SaveQuestionMetricsDocument = gql`
    mutation SaveQuestionMetrics($items: [QuestionMetricInput!]!) {
  setQuestionMetrics(items: $items) {
    success
    customErrors {
      code
      field
      message
    }
    changedCount
  }
}
    `;
export type SaveQuestionMetricsMutationFn = Apollo.MutationFunction<SaveQuestionMetricsMutation, SaveQuestionMetricsMutationVariables>;

/**
 * __useSaveQuestionMetricsMutation__
 *
 * To run a mutation, you first call `useSaveQuestionMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuestionMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuestionMetricsMutation, { data, loading, error }] = useSaveQuestionMetricsMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useSaveQuestionMetricsMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuestionMetricsMutation, SaveQuestionMetricsMutationVariables>) {
        return Apollo.useMutation<SaveQuestionMetricsMutation, SaveQuestionMetricsMutationVariables>(SaveQuestionMetricsDocument, baseOptions);
      }
export type SaveQuestionMetricsMutationHookResult = ReturnType<typeof useSaveQuestionMetricsMutation>;
export type SaveQuestionMetricsMutationResult = Apollo.MutationResult<SaveQuestionMetricsMutation>;
export type SaveQuestionMetricsMutationOptions = Apollo.BaseMutationOptions<SaveQuestionMetricsMutation, SaveQuestionMetricsMutationVariables>;
export const RequestSurveyDigestDocument = gql`
    mutation RequestSurveyDigest($scope: String!, $scopeId: ID!) {
  generateSurveyDigest(scope: $scope, scopeId: $scopeId) {
    id
    scope
    scopeId
    status
    textRu
    textPl
    model
    error
    createdAt
    finishedAt
    byName
  }
}
    `;
export type RequestSurveyDigestMutationFn = Apollo.MutationFunction<RequestSurveyDigestMutation, RequestSurveyDigestMutationVariables>;

/**
 * __useRequestSurveyDigestMutation__
 *
 * To run a mutation, you first call `useRequestSurveyDigestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSurveyDigestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSurveyDigestMutation, { data, loading, error }] = useRequestSurveyDigestMutation({
 *   variables: {
 *      scope: // value for 'scope'
 *      scopeId: // value for 'scopeId'
 *   },
 * });
 */
export function useRequestSurveyDigestMutation(baseOptions?: Apollo.MutationHookOptions<RequestSurveyDigestMutation, RequestSurveyDigestMutationVariables>) {
        return Apollo.useMutation<RequestSurveyDigestMutation, RequestSurveyDigestMutationVariables>(RequestSurveyDigestDocument, baseOptions);
      }
export type RequestSurveyDigestMutationHookResult = ReturnType<typeof useRequestSurveyDigestMutation>;
export type RequestSurveyDigestMutationResult = Apollo.MutationResult<RequestSurveyDigestMutation>;
export type RequestSurveyDigestMutationOptions = Apollo.BaseMutationOptions<RequestSurveyDigestMutation, RequestSurveyDigestMutationVariables>;
export const RunInterviewAnalysisDocument = gql`
    mutation RunInterviewAnalysis($interviewId: ID!) {
  runTeacherInterviewAnalysis(interviewId: $interviewId) {
    success
    customErrors {
      code
      field
      message
    }
    run {
      id
      sourceKind
      status
    }
  }
}
    `;
export type RunInterviewAnalysisMutationFn = Apollo.MutationFunction<RunInterviewAnalysisMutation, RunInterviewAnalysisMutationVariables>;

/**
 * __useRunInterviewAnalysisMutation__
 *
 * To run a mutation, you first call `useRunInterviewAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunInterviewAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runInterviewAnalysisMutation, { data, loading, error }] = useRunInterviewAnalysisMutation({
 *   variables: {
 *      interviewId: // value for 'interviewId'
 *   },
 * });
 */
export function useRunInterviewAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<RunInterviewAnalysisMutation, RunInterviewAnalysisMutationVariables>) {
        return Apollo.useMutation<RunInterviewAnalysisMutation, RunInterviewAnalysisMutationVariables>(RunInterviewAnalysisDocument, baseOptions);
      }
export type RunInterviewAnalysisMutationHookResult = ReturnType<typeof useRunInterviewAnalysisMutation>;
export type RunInterviewAnalysisMutationResult = Apollo.MutationResult<RunInterviewAnalysisMutation>;
export type RunInterviewAnalysisMutationOptions = Apollo.BaseMutationOptions<RunInterviewAnalysisMutation, RunInterviewAnalysisMutationVariables>;
export const RecomputeAiProfileDocument = gql`
    mutation RecomputeAiProfile($teacherId: ID!) {
  recomputeTeacherAiProfile(teacherId: $teacherId) {
    success
    customErrors {
      code
      field
      message
    }
    profile {
      teacherId
      status
    }
  }
}
    `;
export type RecomputeAiProfileMutationFn = Apollo.MutationFunction<RecomputeAiProfileMutation, RecomputeAiProfileMutationVariables>;

/**
 * __useRecomputeAiProfileMutation__
 *
 * To run a mutation, you first call `useRecomputeAiProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecomputeAiProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recomputeAiProfileMutation, { data, loading, error }] = useRecomputeAiProfileMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useRecomputeAiProfileMutation(baseOptions?: Apollo.MutationHookOptions<RecomputeAiProfileMutation, RecomputeAiProfileMutationVariables>) {
        return Apollo.useMutation<RecomputeAiProfileMutation, RecomputeAiProfileMutationVariables>(RecomputeAiProfileDocument, baseOptions);
      }
export type RecomputeAiProfileMutationHookResult = ReturnType<typeof useRecomputeAiProfileMutation>;
export type RecomputeAiProfileMutationResult = Apollo.MutationResult<RecomputeAiProfileMutation>;
export type RecomputeAiProfileMutationOptions = Apollo.BaseMutationOptions<RecomputeAiProfileMutation, RecomputeAiProfileMutationVariables>;
export const ApplyCourseSuggestionsDocument = gql`
    mutation ApplyCourseSuggestions($teacherId: ID!, $suggestionIds: [ID!]!, $action: String!) {
  applyTeacherCourseSuggestions(
    teacherId: $teacherId
    suggestionIds: $suggestionIds
    action: $action
  ) {
    success
    customErrors {
      code
      field
      message
    }
    result {
      accepted
      rejected
    }
  }
}
    `;
export type ApplyCourseSuggestionsMutationFn = Apollo.MutationFunction<ApplyCourseSuggestionsMutation, ApplyCourseSuggestionsMutationVariables>;

/**
 * __useApplyCourseSuggestionsMutation__
 *
 * To run a mutation, you first call `useApplyCourseSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCourseSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCourseSuggestionsMutation, { data, loading, error }] = useApplyCourseSuggestionsMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      suggestionIds: // value for 'suggestionIds'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useApplyCourseSuggestionsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCourseSuggestionsMutation, ApplyCourseSuggestionsMutationVariables>) {
        return Apollo.useMutation<ApplyCourseSuggestionsMutation, ApplyCourseSuggestionsMutationVariables>(ApplyCourseSuggestionsDocument, baseOptions);
      }
export type ApplyCourseSuggestionsMutationHookResult = ReturnType<typeof useApplyCourseSuggestionsMutation>;
export type ApplyCourseSuggestionsMutationResult = Apollo.MutationResult<ApplyCourseSuggestionsMutation>;
export type ApplyCourseSuggestionsMutationOptions = Apollo.BaseMutationOptions<ApplyCourseSuggestionsMutation, ApplyCourseSuggestionsMutationVariables>;
export const AddTeacherBillingEntityDocument = gql`
    mutation AddTeacherBillingEntity($teacherId: ID!, $input: TeacherBillingEntityInput!) {
  createTeacherBillingEntity(teacherId: $teacherId, input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    billingEntity {
      id
      teacherId
      kind
      legalName
      nip
      vatMode
      vatRate
      isDefault
      isActive
      createdAt
      updatedAt
    }
  }
}
    `;
export type AddTeacherBillingEntityMutationFn = Apollo.MutationFunction<AddTeacherBillingEntityMutation, AddTeacherBillingEntityMutationVariables>;

/**
 * __useAddTeacherBillingEntityMutation__
 *
 * To run a mutation, you first call `useAddTeacherBillingEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeacherBillingEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeacherBillingEntityMutation, { data, loading, error }] = useAddTeacherBillingEntityMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTeacherBillingEntityMutation(baseOptions?: Apollo.MutationHookOptions<AddTeacherBillingEntityMutation, AddTeacherBillingEntityMutationVariables>) {
        return Apollo.useMutation<AddTeacherBillingEntityMutation, AddTeacherBillingEntityMutationVariables>(AddTeacherBillingEntityDocument, baseOptions);
      }
export type AddTeacherBillingEntityMutationHookResult = ReturnType<typeof useAddTeacherBillingEntityMutation>;
export type AddTeacherBillingEntityMutationResult = Apollo.MutationResult<AddTeacherBillingEntityMutation>;
export type AddTeacherBillingEntityMutationOptions = Apollo.BaseMutationOptions<AddTeacherBillingEntityMutation, AddTeacherBillingEntityMutationVariables>;
export const EditTeacherBillingEntityDocument = gql`
    mutation EditTeacherBillingEntity($id: ID!, $input: TeacherBillingEntityInput!) {
  updateTeacherBillingEntity(id: $id, input: $input) {
    success
    customErrors {
      field
      code
      message
    }
    billingEntity {
      id
      teacherId
      kind
      legalName
      nip
      vatMode
      vatRate
      isDefault
      isActive
      createdAt
      updatedAt
    }
  }
}
    `;
export type EditTeacherBillingEntityMutationFn = Apollo.MutationFunction<EditTeacherBillingEntityMutation, EditTeacherBillingEntityMutationVariables>;

/**
 * __useEditTeacherBillingEntityMutation__
 *
 * To run a mutation, you first call `useEditTeacherBillingEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTeacherBillingEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTeacherBillingEntityMutation, { data, loading, error }] = useEditTeacherBillingEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTeacherBillingEntityMutation(baseOptions?: Apollo.MutationHookOptions<EditTeacherBillingEntityMutation, EditTeacherBillingEntityMutationVariables>) {
        return Apollo.useMutation<EditTeacherBillingEntityMutation, EditTeacherBillingEntityMutationVariables>(EditTeacherBillingEntityDocument, baseOptions);
      }
export type EditTeacherBillingEntityMutationHookResult = ReturnType<typeof useEditTeacherBillingEntityMutation>;
export type EditTeacherBillingEntityMutationResult = Apollo.MutationResult<EditTeacherBillingEntityMutation>;
export type EditTeacherBillingEntityMutationOptions = Apollo.BaseMutationOptions<EditTeacherBillingEntityMutation, EditTeacherBillingEntityMutationVariables>;
export const MakeDefaultTeacherBillingEntityDocument = gql`
    mutation MakeDefaultTeacherBillingEntity($id: ID!) {
  setDefaultTeacherBillingEntity(id: $id) {
    success
    customErrors {
      field
      code
      message
    }
    billingEntity {
      id
      isDefault
    }
  }
}
    `;
export type MakeDefaultTeacherBillingEntityMutationFn = Apollo.MutationFunction<MakeDefaultTeacherBillingEntityMutation, MakeDefaultTeacherBillingEntityMutationVariables>;

/**
 * __useMakeDefaultTeacherBillingEntityMutation__
 *
 * To run a mutation, you first call `useMakeDefaultTeacherBillingEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeDefaultTeacherBillingEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeDefaultTeacherBillingEntityMutation, { data, loading, error }] = useMakeDefaultTeacherBillingEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMakeDefaultTeacherBillingEntityMutation(baseOptions?: Apollo.MutationHookOptions<MakeDefaultTeacherBillingEntityMutation, MakeDefaultTeacherBillingEntityMutationVariables>) {
        return Apollo.useMutation<MakeDefaultTeacherBillingEntityMutation, MakeDefaultTeacherBillingEntityMutationVariables>(MakeDefaultTeacherBillingEntityDocument, baseOptions);
      }
export type MakeDefaultTeacherBillingEntityMutationHookResult = ReturnType<typeof useMakeDefaultTeacherBillingEntityMutation>;
export type MakeDefaultTeacherBillingEntityMutationResult = Apollo.MutationResult<MakeDefaultTeacherBillingEntityMutation>;
export type MakeDefaultTeacherBillingEntityMutationOptions = Apollo.BaseMutationOptions<MakeDefaultTeacherBillingEntityMutation, MakeDefaultTeacherBillingEntityMutationVariables>;
export const StoreApplicationFinanceTermsDocument = gql`
    mutation StoreApplicationFinanceTerms($applicationId: ID!, $rateUnit: String, $rateIsGross: Boolean, $billingEntityId: ID, $clearBillingEntity: Boolean, $servicePrice: Float, $currency: String) {
  setApplicationFinanceTerms(
    applicationId: $applicationId
    rateUnit: $rateUnit
    rateIsGross: $rateIsGross
    billingEntityId: $billingEntityId
    clearBillingEntity: $clearBillingEntity
    servicePrice: $servicePrice
    currency: $currency
  ) {
    success
    customErrors {
      field
      code
      message
    }
    application {
      id
      servicePrice
      currency
      rateUnit
      rateIsGross
      termsMissing
      billingEntity {
        id
        teacherId
        kind
        legalName
        nip
        vatMode
        vatRate
        isDefault
        isActive
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export type StoreApplicationFinanceTermsMutationFn = Apollo.MutationFunction<StoreApplicationFinanceTermsMutation, StoreApplicationFinanceTermsMutationVariables>;

/**
 * __useStoreApplicationFinanceTermsMutation__
 *
 * To run a mutation, you first call `useStoreApplicationFinanceTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreApplicationFinanceTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeApplicationFinanceTermsMutation, { data, loading, error }] = useStoreApplicationFinanceTermsMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      rateUnit: // value for 'rateUnit'
 *      rateIsGross: // value for 'rateIsGross'
 *      billingEntityId: // value for 'billingEntityId'
 *      clearBillingEntity: // value for 'clearBillingEntity'
 *      servicePrice: // value for 'servicePrice'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useStoreApplicationFinanceTermsMutation(baseOptions?: Apollo.MutationHookOptions<StoreApplicationFinanceTermsMutation, StoreApplicationFinanceTermsMutationVariables>) {
        return Apollo.useMutation<StoreApplicationFinanceTermsMutation, StoreApplicationFinanceTermsMutationVariables>(StoreApplicationFinanceTermsDocument, baseOptions);
      }
export type StoreApplicationFinanceTermsMutationHookResult = ReturnType<typeof useStoreApplicationFinanceTermsMutation>;
export type StoreApplicationFinanceTermsMutationResult = Apollo.MutationResult<StoreApplicationFinanceTermsMutation>;
export type StoreApplicationFinanceTermsMutationOptions = Apollo.BaseMutationOptions<StoreApplicationFinanceTermsMutation, StoreApplicationFinanceTermsMutationVariables>;
export const UploadTeacherDocumentDocument = gql`
    mutation UploadTeacherDocument($teacherId: ID!, $file: Upload!, $kind: String) {
  uploadTeacherDocument(teacherId: $teacherId, file: $file, kind: $kind) {
    success
    customErrors {
      code
      field
      message
    }
    document {
      ...DocumentFields
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;
export type UploadTeacherDocumentMutationFn = Apollo.MutationFunction<UploadTeacherDocumentMutation, UploadTeacherDocumentMutationVariables>;

/**
 * __useUploadTeacherDocumentMutation__
 *
 * To run a mutation, you first call `useUploadTeacherDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadTeacherDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadTeacherDocumentMutation, { data, loading, error }] = useUploadTeacherDocumentMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      file: // value for 'file'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useUploadTeacherDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadTeacherDocumentMutation, UploadTeacherDocumentMutationVariables>) {
        return Apollo.useMutation<UploadTeacherDocumentMutation, UploadTeacherDocumentMutationVariables>(UploadTeacherDocumentDocument, baseOptions);
      }
export type UploadTeacherDocumentMutationHookResult = ReturnType<typeof useUploadTeacherDocumentMutation>;
export type UploadTeacherDocumentMutationResult = Apollo.MutationResult<UploadTeacherDocumentMutation>;
export type UploadTeacherDocumentMutationOptions = Apollo.BaseMutationOptions<UploadTeacherDocumentMutation, UploadTeacherDocumentMutationVariables>;
export const SaveDocumentTextDocument = gql`
    mutation SaveDocumentText($documentId: ID!, $text: String!) {
  setTeacherDocumentText(documentId: $documentId, text: $text) {
    success
    customErrors {
      code
      field
      message
    }
    document {
      ...DocumentFields
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;
export type SaveDocumentTextMutationFn = Apollo.MutationFunction<SaveDocumentTextMutation, SaveDocumentTextMutationVariables>;

/**
 * __useSaveDocumentTextMutation__
 *
 * To run a mutation, you first call `useSaveDocumentTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDocumentTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDocumentTextMutation, { data, loading, error }] = useSaveDocumentTextMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSaveDocumentTextMutation(baseOptions?: Apollo.MutationHookOptions<SaveDocumentTextMutation, SaveDocumentTextMutationVariables>) {
        return Apollo.useMutation<SaveDocumentTextMutation, SaveDocumentTextMutationVariables>(SaveDocumentTextDocument, baseOptions);
      }
export type SaveDocumentTextMutationHookResult = ReturnType<typeof useSaveDocumentTextMutation>;
export type SaveDocumentTextMutationResult = Apollo.MutationResult<SaveDocumentTextMutation>;
export type SaveDocumentTextMutationOptions = Apollo.BaseMutationOptions<SaveDocumentTextMutation, SaveDocumentTextMutationVariables>;
export const RemoveTeacherDocumentDocument = gql`
    mutation RemoveTeacherDocument($documentId: ID!) {
  deleteTeacherDocument(documentId: $documentId) {
    success
    customErrors {
      code
      field
      message
    }
    teacherId
  }
}
    `;
export type RemoveTeacherDocumentMutationFn = Apollo.MutationFunction<RemoveTeacherDocumentMutation, RemoveTeacherDocumentMutationVariables>;

/**
 * __useRemoveTeacherDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveTeacherDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeacherDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeacherDocumentMutation, { data, loading, error }] = useRemoveTeacherDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRemoveTeacherDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeacherDocumentMutation, RemoveTeacherDocumentMutationVariables>) {
        return Apollo.useMutation<RemoveTeacherDocumentMutation, RemoveTeacherDocumentMutationVariables>(RemoveTeacherDocumentDocument, baseOptions);
      }
export type RemoveTeacherDocumentMutationHookResult = ReturnType<typeof useRemoveTeacherDocumentMutation>;
export type RemoveTeacherDocumentMutationResult = Apollo.MutationResult<RemoveTeacherDocumentMutation>;
export type RemoveTeacherDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveTeacherDocumentMutation, RemoveTeacherDocumentMutationVariables>;
export const RunDocumentAnalysisDocument = gql`
    mutation RunDocumentAnalysis($documentId: ID!) {
  runTeacherDocumentAnalysis(documentId: $documentId) {
    success
    customErrors {
      code
      field
      message
    }
    run {
      id
      sourceKind
      status
      documentId
    }
  }
}
    `;
export type RunDocumentAnalysisMutationFn = Apollo.MutationFunction<RunDocumentAnalysisMutation, RunDocumentAnalysisMutationVariables>;

/**
 * __useRunDocumentAnalysisMutation__
 *
 * To run a mutation, you first call `useRunDocumentAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunDocumentAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runDocumentAnalysisMutation, { data, loading, error }] = useRunDocumentAnalysisMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRunDocumentAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<RunDocumentAnalysisMutation, RunDocumentAnalysisMutationVariables>) {
        return Apollo.useMutation<RunDocumentAnalysisMutation, RunDocumentAnalysisMutationVariables>(RunDocumentAnalysisDocument, baseOptions);
      }
export type RunDocumentAnalysisMutationHookResult = ReturnType<typeof useRunDocumentAnalysisMutation>;
export type RunDocumentAnalysisMutationResult = Apollo.MutationResult<RunDocumentAnalysisMutation>;
export type RunDocumentAnalysisMutationOptions = Apollo.BaseMutationOptions<RunDocumentAnalysisMutation, RunDocumentAnalysisMutationVariables>;
export const AttachInterviewFromZoomDocument = gql`
    mutation AttachInterviewFromZoom($teacherId: ID!, $zoomRecordingId: ID!, $title: String) {
  attachTeacherInterviewZoom(
    teacherId: $teacherId
    zoomRecordingId: $zoomRecordingId
    title: $title
  ) {
    success
    customErrors {
      code
      field
      message
    }
    interview {
      ...InterviewFields
    }
  }
}
    ${InterviewFieldsFragmentDoc}`;
export type AttachInterviewFromZoomMutationFn = Apollo.MutationFunction<AttachInterviewFromZoomMutation, AttachInterviewFromZoomMutationVariables>;

/**
 * __useAttachInterviewFromZoomMutation__
 *
 * To run a mutation, you first call `useAttachInterviewFromZoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachInterviewFromZoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachInterviewFromZoomMutation, { data, loading, error }] = useAttachInterviewFromZoomMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      zoomRecordingId: // value for 'zoomRecordingId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useAttachInterviewFromZoomMutation(baseOptions?: Apollo.MutationHookOptions<AttachInterviewFromZoomMutation, AttachInterviewFromZoomMutationVariables>) {
        return Apollo.useMutation<AttachInterviewFromZoomMutation, AttachInterviewFromZoomMutationVariables>(AttachInterviewFromZoomDocument, baseOptions);
      }
export type AttachInterviewFromZoomMutationHookResult = ReturnType<typeof useAttachInterviewFromZoomMutation>;
export type AttachInterviewFromZoomMutationResult = Apollo.MutationResult<AttachInterviewFromZoomMutation>;
export type AttachInterviewFromZoomMutationOptions = Apollo.BaseMutationOptions<AttachInterviewFromZoomMutation, AttachInterviewFromZoomMutationVariables>;
export const AttachInterviewLinkDocument = gql`
    mutation AttachInterviewLink($teacherId: ID!, $url: String!, $title: String, $recordedAt: DateTime) {
  attachTeacherInterviewLink(
    teacherId: $teacherId
    url: $url
    title: $title
    recordedAt: $recordedAt
  ) {
    success
    customErrors {
      code
      field
      message
    }
    interview {
      ...InterviewFields
    }
  }
}
    ${InterviewFieldsFragmentDoc}`;
export type AttachInterviewLinkMutationFn = Apollo.MutationFunction<AttachInterviewLinkMutation, AttachInterviewLinkMutationVariables>;

/**
 * __useAttachInterviewLinkMutation__
 *
 * To run a mutation, you first call `useAttachInterviewLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachInterviewLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachInterviewLinkMutation, { data, loading, error }] = useAttachInterviewLinkMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      url: // value for 'url'
 *      title: // value for 'title'
 *      recordedAt: // value for 'recordedAt'
 *   },
 * });
 */
export function useAttachInterviewLinkMutation(baseOptions?: Apollo.MutationHookOptions<AttachInterviewLinkMutation, AttachInterviewLinkMutationVariables>) {
        return Apollo.useMutation<AttachInterviewLinkMutation, AttachInterviewLinkMutationVariables>(AttachInterviewLinkDocument, baseOptions);
      }
export type AttachInterviewLinkMutationHookResult = ReturnType<typeof useAttachInterviewLinkMutation>;
export type AttachInterviewLinkMutationResult = Apollo.MutationResult<AttachInterviewLinkMutation>;
export type AttachInterviewLinkMutationOptions = Apollo.BaseMutationOptions<AttachInterviewLinkMutation, AttachInterviewLinkMutationVariables>;
export const UploadInterviewVideoDocument = gql`
    mutation UploadInterviewVideo($teacherId: ID!, $file: Upload!, $title: String, $recordedAt: DateTime) {
  uploadTeacherInterviewVideo(
    teacherId: $teacherId
    file: $file
    title: $title
    recordedAt: $recordedAt
  ) {
    success
    customErrors {
      code
      field
      message
    }
    interview {
      ...InterviewFields
    }
  }
}
    ${InterviewFieldsFragmentDoc}`;
export type UploadInterviewVideoMutationFn = Apollo.MutationFunction<UploadInterviewVideoMutation, UploadInterviewVideoMutationVariables>;

/**
 * __useUploadInterviewVideoMutation__
 *
 * To run a mutation, you first call `useUploadInterviewVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInterviewVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInterviewVideoMutation, { data, loading, error }] = useUploadInterviewVideoMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      file: // value for 'file'
 *      title: // value for 'title'
 *      recordedAt: // value for 'recordedAt'
 *   },
 * });
 */
export function useUploadInterviewVideoMutation(baseOptions?: Apollo.MutationHookOptions<UploadInterviewVideoMutation, UploadInterviewVideoMutationVariables>) {
        return Apollo.useMutation<UploadInterviewVideoMutation, UploadInterviewVideoMutationVariables>(UploadInterviewVideoDocument, baseOptions);
      }
export type UploadInterviewVideoMutationHookResult = ReturnType<typeof useUploadInterviewVideoMutation>;
export type UploadInterviewVideoMutationResult = Apollo.MutationResult<UploadInterviewVideoMutation>;
export type UploadInterviewVideoMutationOptions = Apollo.BaseMutationOptions<UploadInterviewVideoMutation, UploadInterviewVideoMutationVariables>;
export const SaveInterviewTranscriptDocument = gql`
    mutation SaveInterviewTranscript($interviewId: ID!, $text: String!) {
  setTeacherInterviewTranscript(interviewId: $interviewId, text: $text) {
    success
    customErrors {
      code
      field
      message
    }
    interview {
      ...InterviewFields
    }
  }
}
    ${InterviewFieldsFragmentDoc}`;
export type SaveInterviewTranscriptMutationFn = Apollo.MutationFunction<SaveInterviewTranscriptMutation, SaveInterviewTranscriptMutationVariables>;

/**
 * __useSaveInterviewTranscriptMutation__
 *
 * To run a mutation, you first call `useSaveInterviewTranscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInterviewTranscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInterviewTranscriptMutation, { data, loading, error }] = useSaveInterviewTranscriptMutation({
 *   variables: {
 *      interviewId: // value for 'interviewId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSaveInterviewTranscriptMutation(baseOptions?: Apollo.MutationHookOptions<SaveInterviewTranscriptMutation, SaveInterviewTranscriptMutationVariables>) {
        return Apollo.useMutation<SaveInterviewTranscriptMutation, SaveInterviewTranscriptMutationVariables>(SaveInterviewTranscriptDocument, baseOptions);
      }
export type SaveInterviewTranscriptMutationHookResult = ReturnType<typeof useSaveInterviewTranscriptMutation>;
export type SaveInterviewTranscriptMutationResult = Apollo.MutationResult<SaveInterviewTranscriptMutation>;
export type SaveInterviewTranscriptMutationOptions = Apollo.BaseMutationOptions<SaveInterviewTranscriptMutation, SaveInterviewTranscriptMutationVariables>;
export const RetryInterviewDownloadDocument = gql`
    mutation RetryInterviewDownload($interviewId: ID!) {
  retryTeacherInterviewDownload(interviewId: $interviewId) {
    success
    customErrors {
      code
      field
      message
    }
    interview {
      ...InterviewFields
    }
  }
}
    ${InterviewFieldsFragmentDoc}`;
export type RetryInterviewDownloadMutationFn = Apollo.MutationFunction<RetryInterviewDownloadMutation, RetryInterviewDownloadMutationVariables>;

/**
 * __useRetryInterviewDownloadMutation__
 *
 * To run a mutation, you first call `useRetryInterviewDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryInterviewDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryInterviewDownloadMutation, { data, loading, error }] = useRetryInterviewDownloadMutation({
 *   variables: {
 *      interviewId: // value for 'interviewId'
 *   },
 * });
 */
export function useRetryInterviewDownloadMutation(baseOptions?: Apollo.MutationHookOptions<RetryInterviewDownloadMutation, RetryInterviewDownloadMutationVariables>) {
        return Apollo.useMutation<RetryInterviewDownloadMutation, RetryInterviewDownloadMutationVariables>(RetryInterviewDownloadDocument, baseOptions);
      }
export type RetryInterviewDownloadMutationHookResult = ReturnType<typeof useRetryInterviewDownloadMutation>;
export type RetryInterviewDownloadMutationResult = Apollo.MutationResult<RetryInterviewDownloadMutation>;
export type RetryInterviewDownloadMutationOptions = Apollo.BaseMutationOptions<RetryInterviewDownloadMutation, RetryInterviewDownloadMutationVariables>;
export const RemoveInterviewDocument = gql`
    mutation RemoveInterview($interviewId: ID!) {
  deleteTeacherInterview(interviewId: $interviewId) {
    success
    customErrors {
      code
      field
      message
    }
    teacherId
  }
}
    `;
export type RemoveInterviewMutationFn = Apollo.MutationFunction<RemoveInterviewMutation, RemoveInterviewMutationVariables>;

/**
 * __useRemoveInterviewMutation__
 *
 * To run a mutation, you first call `useRemoveInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInterviewMutation, { data, loading, error }] = useRemoveInterviewMutation({
 *   variables: {
 *      interviewId: // value for 'interviewId'
 *   },
 * });
 */
export function useRemoveInterviewMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInterviewMutation, RemoveInterviewMutationVariables>) {
        return Apollo.useMutation<RemoveInterviewMutation, RemoveInterviewMutationVariables>(RemoveInterviewDocument, baseOptions);
      }
export type RemoveInterviewMutationHookResult = ReturnType<typeof useRemoveInterviewMutation>;
export type RemoveInterviewMutationResult = Apollo.MutationResult<RemoveInterviewMutation>;
export type RemoveInterviewMutationOptions = Apollo.BaseMutationOptions<RemoveInterviewMutation, RemoveInterviewMutationVariables>;
export const RefreshInterviewZoomDocument = gql`
    mutation RefreshInterviewZoom($dateFrom: Date!, $dateTo: Date!) {
  refreshInterviewZoomRecordings(dateFrom: $dateFrom, dateTo: $dateTo) {
    success
    customErrors {
      code
      field
      message
    }
    result {
      created
      updated
      skippedNoAccount
      skippedProcessing
      accountsSynced
      cooldown
    }
  }
}
    `;
export type RefreshInterviewZoomMutationFn = Apollo.MutationFunction<RefreshInterviewZoomMutation, RefreshInterviewZoomMutationVariables>;

/**
 * __useRefreshInterviewZoomMutation__
 *
 * To run a mutation, you first call `useRefreshInterviewZoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshInterviewZoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshInterviewZoomMutation, { data, loading, error }] = useRefreshInterviewZoomMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useRefreshInterviewZoomMutation(baseOptions?: Apollo.MutationHookOptions<RefreshInterviewZoomMutation, RefreshInterviewZoomMutationVariables>) {
        return Apollo.useMutation<RefreshInterviewZoomMutation, RefreshInterviewZoomMutationVariables>(RefreshInterviewZoomDocument, baseOptions);
      }
export type RefreshInterviewZoomMutationHookResult = ReturnType<typeof useRefreshInterviewZoomMutation>;
export type RefreshInterviewZoomMutationResult = Apollo.MutationResult<RefreshInterviewZoomMutation>;
export type RefreshInterviewZoomMutationOptions = Apollo.BaseMutationOptions<RefreshInterviewZoomMutation, RefreshInterviewZoomMutationVariables>;
export const AddUniqueTeacherDocument = gql`
    mutation addUniqueTeacher($application: ApplicationInputType!, $employmentTypes: EmploymentInputType!, $teacher: NewTeacherInput!) {
  createUniqueTeacher(
    application: $application
    employmentTypes: $employmentTypes
    teacher: $teacher
  ) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type AddUniqueTeacherMutationFn = Apollo.MutationFunction<AddUniqueTeacherMutation, AddUniqueTeacherMutationVariables>;

/**
 * __useAddUniqueTeacherMutation__
 *
 * To run a mutation, you first call `useAddUniqueTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUniqueTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUniqueTeacherMutation, { data, loading, error }] = useAddUniqueTeacherMutation({
 *   variables: {
 *      application: // value for 'application'
 *      employmentTypes: // value for 'employmentTypes'
 *      teacher: // value for 'teacher'
 *   },
 * });
 */
export function useAddUniqueTeacherMutation(baseOptions?: Apollo.MutationHookOptions<AddUniqueTeacherMutation, AddUniqueTeacherMutationVariables>) {
        return Apollo.useMutation<AddUniqueTeacherMutation, AddUniqueTeacherMutationVariables>(AddUniqueTeacherDocument, baseOptions);
      }
export type AddUniqueTeacherMutationHookResult = ReturnType<typeof useAddUniqueTeacherMutation>;
export type AddUniqueTeacherMutationResult = Apollo.MutationResult<AddUniqueTeacherMutation>;
export type AddUniqueTeacherMutationOptions = Apollo.BaseMutationOptions<AddUniqueTeacherMutation, AddUniqueTeacherMutationVariables>;
export const AddTeacherStandaloneDocument = gql`
    mutation AddTeacherStandalone($teacher: NewTeacherInput!) {
  createTeacher(teacher: $teacher) {
    success
    customErrors {
      field
      message
      code
    }
    teacher {
      id
      fullName
    }
  }
}
    `;
export type AddTeacherStandaloneMutationFn = Apollo.MutationFunction<AddTeacherStandaloneMutation, AddTeacherStandaloneMutationVariables>;

/**
 * __useAddTeacherStandaloneMutation__
 *
 * To run a mutation, you first call `useAddTeacherStandaloneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeacherStandaloneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeacherStandaloneMutation, { data, loading, error }] = useAddTeacherStandaloneMutation({
 *   variables: {
 *      teacher: // value for 'teacher'
 *   },
 * });
 */
export function useAddTeacherStandaloneMutation(baseOptions?: Apollo.MutationHookOptions<AddTeacherStandaloneMutation, AddTeacherStandaloneMutationVariables>) {
        return Apollo.useMutation<AddTeacherStandaloneMutation, AddTeacherStandaloneMutationVariables>(AddTeacherStandaloneDocument, baseOptions);
      }
export type AddTeacherStandaloneMutationHookResult = ReturnType<typeof useAddTeacherStandaloneMutation>;
export type AddTeacherStandaloneMutationResult = Apollo.MutationResult<AddTeacherStandaloneMutation>;
export type AddTeacherStandaloneMutationOptions = Apollo.BaseMutationOptions<AddTeacherStandaloneMutation, AddTeacherStandaloneMutationVariables>;
export const AddNewTeacherRoleDocument = gql`
    mutation addNewTeacherRole($application: ApplicationInputType!, $employmentTypes: EmploymentInputType!, $siteDisplay: Boolean, $userId: ID!) {
  addTeacherRole(
    application: $application
    employmentTypes: $employmentTypes
    siteDisplay: $siteDisplay
    userId: $userId
  ) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type AddNewTeacherRoleMutationFn = Apollo.MutationFunction<AddNewTeacherRoleMutation, AddNewTeacherRoleMutationVariables>;

/**
 * __useAddNewTeacherRoleMutation__
 *
 * To run a mutation, you first call `useAddNewTeacherRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewTeacherRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewTeacherRoleMutation, { data, loading, error }] = useAddNewTeacherRoleMutation({
 *   variables: {
 *      application: // value for 'application'
 *      employmentTypes: // value for 'employmentTypes'
 *      siteDisplay: // value for 'siteDisplay'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddNewTeacherRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddNewTeacherRoleMutation, AddNewTeacherRoleMutationVariables>) {
        return Apollo.useMutation<AddNewTeacherRoleMutation, AddNewTeacherRoleMutationVariables>(AddNewTeacherRoleDocument, baseOptions);
      }
export type AddNewTeacherRoleMutationHookResult = ReturnType<typeof useAddNewTeacherRoleMutation>;
export type AddNewTeacherRoleMutationResult = Apollo.MutationResult<AddNewTeacherRoleMutation>;
export type AddNewTeacherRoleMutationOptions = Apollo.BaseMutationOptions<AddNewTeacherRoleMutation, AddNewTeacherRoleMutationVariables>;
export const AddTeacherExistDocument = gql`
    mutation AddTeacherExist($application: ApplicationInputType!, $employmentTypes: ExistEmploymentInputType!, $teacherId: ID!) {
  addTeacherExist(
    application: $application
    employmentTypes: $employmentTypes
    teacherId: $teacherId
  ) {
    success
    customErrors {
      field
      message
      code
    }
    application {
      id
    }
  }
}
    `;
export type AddTeacherExistMutationFn = Apollo.MutationFunction<AddTeacherExistMutation, AddTeacherExistMutationVariables>;

/**
 * __useAddTeacherExistMutation__
 *
 * To run a mutation, you first call `useAddTeacherExistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeacherExistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeacherExistMutation, { data, loading, error }] = useAddTeacherExistMutation({
 *   variables: {
 *      application: // value for 'application'
 *      employmentTypes: // value for 'employmentTypes'
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useAddTeacherExistMutation(baseOptions?: Apollo.MutationHookOptions<AddTeacherExistMutation, AddTeacherExistMutationVariables>) {
        return Apollo.useMutation<AddTeacherExistMutation, AddTeacherExistMutationVariables>(AddTeacherExistDocument, baseOptions);
      }
export type AddTeacherExistMutationHookResult = ReturnType<typeof useAddTeacherExistMutation>;
export type AddTeacherExistMutationResult = Apollo.MutationResult<AddTeacherExistMutation>;
export type AddTeacherExistMutationOptions = Apollo.BaseMutationOptions<AddTeacherExistMutation, AddTeacherExistMutationVariables>;
export const EditTeacherWithTypeDocument = gql`
    mutation editTeacherWithType($employmentInput: ExistEmploymentInputType!, $teacherId: ID, $teacherInput: TeacherWithTypeInput!) {
  updateTeacherWithType(
    teacherId: $teacherId
    employmentInput: $employmentInput
    teacherInput: $teacherInput
  ) {
    success
    errors
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type EditTeacherWithTypeMutationFn = Apollo.MutationFunction<EditTeacherWithTypeMutation, EditTeacherWithTypeMutationVariables>;

/**
 * __useEditTeacherWithTypeMutation__
 *
 * To run a mutation, you first call `useEditTeacherWithTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTeacherWithTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTeacherWithTypeMutation, { data, loading, error }] = useEditTeacherWithTypeMutation({
 *   variables: {
 *      employmentInput: // value for 'employmentInput'
 *      teacherId: // value for 'teacherId'
 *      teacherInput: // value for 'teacherInput'
 *   },
 * });
 */
export function useEditTeacherWithTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditTeacherWithTypeMutation, EditTeacherWithTypeMutationVariables>) {
        return Apollo.useMutation<EditTeacherWithTypeMutation, EditTeacherWithTypeMutationVariables>(EditTeacherWithTypeDocument, baseOptions);
      }
export type EditTeacherWithTypeMutationHookResult = ReturnType<typeof useEditTeacherWithTypeMutation>;
export type EditTeacherWithTypeMutationResult = Apollo.MutationResult<EditTeacherWithTypeMutation>;
export type EditTeacherWithTypeMutationOptions = Apollo.BaseMutationOptions<EditTeacherWithTypeMutation, EditTeacherWithTypeMutationVariables>;
export const SaveTeacherProfileDocument = gql`
    mutation SaveTeacherProfile($teacherId: ID!, $rating: Int, $internalNote: String, $interviewRecording: String, $coursesCanTeachIds: [ID!]) {
  setTeacherProfile(
    teacherId: $teacherId
    rating: $rating
    internalNote: $internalNote
    interviewRecording: $interviewRecording
    coursesCanTeachIds: $coursesCanTeachIds
  ) {
    success
    customErrors {
      field
      message
      code
    }
    teacher {
      id
      rating
      internalNote
      interviewRecording
      coursesCanTeach {
        id
        name
      }
    }
  }
}
    `;
export type SaveTeacherProfileMutationFn = Apollo.MutationFunction<SaveTeacherProfileMutation, SaveTeacherProfileMutationVariables>;

/**
 * __useSaveTeacherProfileMutation__
 *
 * To run a mutation, you first call `useSaveTeacherProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTeacherProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTeacherProfileMutation, { data, loading, error }] = useSaveTeacherProfileMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      rating: // value for 'rating'
 *      internalNote: // value for 'internalNote'
 *      interviewRecording: // value for 'interviewRecording'
 *      coursesCanTeachIds: // value for 'coursesCanTeachIds'
 *   },
 * });
 */
export function useSaveTeacherProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveTeacherProfileMutation, SaveTeacherProfileMutationVariables>) {
        return Apollo.useMutation<SaveTeacherProfileMutation, SaveTeacherProfileMutationVariables>(SaveTeacherProfileDocument, baseOptions);
      }
export type SaveTeacherProfileMutationHookResult = ReturnType<typeof useSaveTeacherProfileMutation>;
export type SaveTeacherProfileMutationResult = Apollo.MutationResult<SaveTeacherProfileMutation>;
export type SaveTeacherProfileMutationOptions = Apollo.BaseMutationOptions<SaveTeacherProfileMutation, SaveTeacherProfileMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($firstName: String!, $lastName: String!, $middleName: String!, $email: String!, $roles: String!, $phone: String!, $workspaceEmail: String) {
  createUser(
    firstName: $firstName
    lastName: $lastName
    middleName: $middleName
    email: $email
    roles: $roles
    phone: $phone
    workspaceEmail: $workspaceEmail
  ) {
    success
    errors
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      middleName: // value for 'middleName'
 *      email: // value for 'email'
 *      roles: // value for 'roles'
 *      phone: // value for 'phone'
 *      workspaceEmail: // value for 'workspaceEmail'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, baseOptions);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($pk: ID!, $firstName: String!, $lastName: String!, $middleName: String!, $email: String!, $roles: String!, $phone: String!) {
  updateUserSettings(
    userId: $pk
    userSettingsInput: {firstName: $firstName, lastName: $lastName, middleName: $middleName, email: $email, roles: $roles, phone: $phone}
  ) {
    user {
      id
    }
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      middleName: // value for 'middleName'
 *      email: // value for 'email'
 *      roles: // value for 'roles'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, baseOptions);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($pk: ID!) {
  deleteUserSettings(userId: $pk) {
    success
    errors
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, baseOptions);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const AddUserRolesDocument = gql`
    mutation addUserRoles($roles: String!, $userId: ID!) {
  appendRolesUserSettings(roles: $roles, userId: $userId) {
    user {
      id
    }
  }
}
    `;
export type AddUserRolesMutationFn = Apollo.MutationFunction<AddUserRolesMutation, AddUserRolesMutationVariables>;

/**
 * __useAddUserRolesMutation__
 *
 * To run a mutation, you first call `useAddUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserRolesMutation, { data, loading, error }] = useAddUserRolesMutation({
 *   variables: {
 *      roles: // value for 'roles'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<AddUserRolesMutation, AddUserRolesMutationVariables>) {
        return Apollo.useMutation<AddUserRolesMutation, AddUserRolesMutationVariables>(AddUserRolesDocument, baseOptions);
      }
export type AddUserRolesMutationHookResult = ReturnType<typeof useAddUserRolesMutation>;
export type AddUserRolesMutationResult = Apollo.MutationResult<AddUserRolesMutation>;
export type AddUserRolesMutationOptions = Apollo.BaseMutationOptions<AddUserRolesMutation, AddUserRolesMutationVariables>;
export const LinkStaffMailboxDocument = gql`
    mutation LinkStaffMailbox($userId: ID!, $email: String!, $displayName: String, $scope: String) {
  setStaffMailbox(
    userId: $userId
    email: $email
    displayName: $displayName
    scope: $scope
  ) {
    success
    customErrors {
      field
      code
      message
    }
    mailbox {
      email
      displayName
      enabled
      scope
    }
  }
}
    `;
export type LinkStaffMailboxMutationFn = Apollo.MutationFunction<LinkStaffMailboxMutation, LinkStaffMailboxMutationVariables>;

/**
 * __useLinkStaffMailboxMutation__
 *
 * To run a mutation, you first call `useLinkStaffMailboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkStaffMailboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkStaffMailboxMutation, { data, loading, error }] = useLinkStaffMailboxMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *      displayName: // value for 'displayName'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useLinkStaffMailboxMutation(baseOptions?: Apollo.MutationHookOptions<LinkStaffMailboxMutation, LinkStaffMailboxMutationVariables>) {
        return Apollo.useMutation<LinkStaffMailboxMutation, LinkStaffMailboxMutationVariables>(LinkStaffMailboxDocument, baseOptions);
      }
export type LinkStaffMailboxMutationHookResult = ReturnType<typeof useLinkStaffMailboxMutation>;
export type LinkStaffMailboxMutationResult = Apollo.MutationResult<LinkStaffMailboxMutation>;
export type LinkStaffMailboxMutationOptions = Apollo.BaseMutationOptions<LinkStaffMailboxMutation, LinkStaffMailboxMutationVariables>;
export const ProbeStaffMailboxDocument = gql`
    mutation ProbeStaffMailbox($userId: ID) {
  checkStaffMailbox(userId: $userId) {
    success
    ok
    code
    message
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type ProbeStaffMailboxMutationFn = Apollo.MutationFunction<ProbeStaffMailboxMutation, ProbeStaffMailboxMutationVariables>;

/**
 * __useProbeStaffMailboxMutation__
 *
 * To run a mutation, you first call `useProbeStaffMailboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProbeStaffMailboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [probeStaffMailboxMutation, { data, loading, error }] = useProbeStaffMailboxMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProbeStaffMailboxMutation(baseOptions?: Apollo.MutationHookOptions<ProbeStaffMailboxMutation, ProbeStaffMailboxMutationVariables>) {
        return Apollo.useMutation<ProbeStaffMailboxMutation, ProbeStaffMailboxMutationVariables>(ProbeStaffMailboxDocument, baseOptions);
      }
export type ProbeStaffMailboxMutationHookResult = ReturnType<typeof useProbeStaffMailboxMutation>;
export type ProbeStaffMailboxMutationResult = Apollo.MutationResult<ProbeStaffMailboxMutation>;
export type ProbeStaffMailboxMutationOptions = Apollo.BaseMutationOptions<ProbeStaffMailboxMutation, ProbeStaffMailboxMutationVariables>;
export const ZoomSyncAccountsDocument = gql`
    mutation ZoomSyncAccounts {
  syncZoomAccounts {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomSyncAccountsMutationFn = Apollo.MutationFunction<ZoomSyncAccountsMutation, ZoomSyncAccountsMutationVariables>;

/**
 * __useZoomSyncAccountsMutation__
 *
 * To run a mutation, you first call `useZoomSyncAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomSyncAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomSyncAccountsMutation, { data, loading, error }] = useZoomSyncAccountsMutation({
 *   variables: {
 *   },
 * });
 */
export function useZoomSyncAccountsMutation(baseOptions?: Apollo.MutationHookOptions<ZoomSyncAccountsMutation, ZoomSyncAccountsMutationVariables>) {
        return Apollo.useMutation<ZoomSyncAccountsMutation, ZoomSyncAccountsMutationVariables>(ZoomSyncAccountsDocument, baseOptions);
      }
export type ZoomSyncAccountsMutationHookResult = ReturnType<typeof useZoomSyncAccountsMutation>;
export type ZoomSyncAccountsMutationResult = Apollo.MutationResult<ZoomSyncAccountsMutation>;
export type ZoomSyncAccountsMutationOptions = Apollo.BaseMutationOptions<ZoomSyncAccountsMutation, ZoomSyncAccountsMutationVariables>;
export const ZoomSyncRecordingsDocument = gql`
    mutation ZoomSyncRecordings($date: Date!) {
  syncZoomRecordings(date: $date) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomSyncRecordingsMutationFn = Apollo.MutationFunction<ZoomSyncRecordingsMutation, ZoomSyncRecordingsMutationVariables>;

/**
 * __useZoomSyncRecordingsMutation__
 *
 * To run a mutation, you first call `useZoomSyncRecordingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomSyncRecordingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomSyncRecordingsMutation, { data, loading, error }] = useZoomSyncRecordingsMutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useZoomSyncRecordingsMutation(baseOptions?: Apollo.MutationHookOptions<ZoomSyncRecordingsMutation, ZoomSyncRecordingsMutationVariables>) {
        return Apollo.useMutation<ZoomSyncRecordingsMutation, ZoomSyncRecordingsMutationVariables>(ZoomSyncRecordingsDocument, baseOptions);
      }
export type ZoomSyncRecordingsMutationHookResult = ReturnType<typeof useZoomSyncRecordingsMutation>;
export type ZoomSyncRecordingsMutationResult = Apollo.MutationResult<ZoomSyncRecordingsMutation>;
export type ZoomSyncRecordingsMutationOptions = Apollo.BaseMutationOptions<ZoomSyncRecordingsMutation, ZoomSyncRecordingsMutationVariables>;
export const ZoomRefreshAllDocument = gql`
    mutation ZoomRefreshAll($dateFrom: Date, $dateTo: Date) {
  refreshAllZoomData(dateFrom: $dateFrom, dateTo: $dateTo) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomRefreshAllMutationFn = Apollo.MutationFunction<ZoomRefreshAllMutation, ZoomRefreshAllMutationVariables>;

/**
 * __useZoomRefreshAllMutation__
 *
 * To run a mutation, you first call `useZoomRefreshAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomRefreshAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomRefreshAllMutation, { data, loading, error }] = useZoomRefreshAllMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useZoomRefreshAllMutation(baseOptions?: Apollo.MutationHookOptions<ZoomRefreshAllMutation, ZoomRefreshAllMutationVariables>) {
        return Apollo.useMutation<ZoomRefreshAllMutation, ZoomRefreshAllMutationVariables>(ZoomRefreshAllDocument, baseOptions);
      }
export type ZoomRefreshAllMutationHookResult = ReturnType<typeof useZoomRefreshAllMutation>;
export type ZoomRefreshAllMutationResult = Apollo.MutationResult<ZoomRefreshAllMutation>;
export type ZoomRefreshAllMutationOptions = Apollo.BaseMutationOptions<ZoomRefreshAllMutation, ZoomRefreshAllMutationVariables>;
export const ZoomSyncAllRecordingsDocument = gql`
    mutation ZoomSyncAllRecordings($dateFrom: Date, $dateTo: Date) {
  syncAllZoomRecordings(dateFrom: $dateFrom, dateTo: $dateTo) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomSyncAllRecordingsMutationFn = Apollo.MutationFunction<ZoomSyncAllRecordingsMutation, ZoomSyncAllRecordingsMutationVariables>;

/**
 * __useZoomSyncAllRecordingsMutation__
 *
 * To run a mutation, you first call `useZoomSyncAllRecordingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomSyncAllRecordingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomSyncAllRecordingsMutation, { data, loading, error }] = useZoomSyncAllRecordingsMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useZoomSyncAllRecordingsMutation(baseOptions?: Apollo.MutationHookOptions<ZoomSyncAllRecordingsMutation, ZoomSyncAllRecordingsMutationVariables>) {
        return Apollo.useMutation<ZoomSyncAllRecordingsMutation, ZoomSyncAllRecordingsMutationVariables>(ZoomSyncAllRecordingsDocument, baseOptions);
      }
export type ZoomSyncAllRecordingsMutationHookResult = ReturnType<typeof useZoomSyncAllRecordingsMutation>;
export type ZoomSyncAllRecordingsMutationResult = Apollo.MutationResult<ZoomSyncAllRecordingsMutation>;
export type ZoomSyncAllRecordingsMutationOptions = Apollo.BaseMutationOptions<ZoomSyncAllRecordingsMutation, ZoomSyncAllRecordingsMutationVariables>;
export const ZoomSyncUsageDocument = gql`
    mutation ZoomSyncUsage {
  syncZoomUsage {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomSyncUsageMutationFn = Apollo.MutationFunction<ZoomSyncUsageMutation, ZoomSyncUsageMutationVariables>;

/**
 * __useZoomSyncUsageMutation__
 *
 * To run a mutation, you first call `useZoomSyncUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomSyncUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomSyncUsageMutation, { data, loading, error }] = useZoomSyncUsageMutation({
 *   variables: {
 *   },
 * });
 */
export function useZoomSyncUsageMutation(baseOptions?: Apollo.MutationHookOptions<ZoomSyncUsageMutation, ZoomSyncUsageMutationVariables>) {
        return Apollo.useMutation<ZoomSyncUsageMutation, ZoomSyncUsageMutationVariables>(ZoomSyncUsageDocument, baseOptions);
      }
export type ZoomSyncUsageMutationHookResult = ReturnType<typeof useZoomSyncUsageMutation>;
export type ZoomSyncUsageMutationResult = Apollo.MutationResult<ZoomSyncUsageMutation>;
export type ZoomSyncUsageMutationOptions = Apollo.BaseMutationOptions<ZoomSyncUsageMutation, ZoomSyncUsageMutationVariables>;
export const ZoomRunAutoMatchingDocument = gql`
    mutation ZoomRunAutoMatching($date: Date!) {
  runAutoMatching(date: $date) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomRunAutoMatchingMutationFn = Apollo.MutationFunction<ZoomRunAutoMatchingMutation, ZoomRunAutoMatchingMutationVariables>;

/**
 * __useZoomRunAutoMatchingMutation__
 *
 * To run a mutation, you first call `useZoomRunAutoMatchingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomRunAutoMatchingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomRunAutoMatchingMutation, { data, loading, error }] = useZoomRunAutoMatchingMutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useZoomRunAutoMatchingMutation(baseOptions?: Apollo.MutationHookOptions<ZoomRunAutoMatchingMutation, ZoomRunAutoMatchingMutationVariables>) {
        return Apollo.useMutation<ZoomRunAutoMatchingMutation, ZoomRunAutoMatchingMutationVariables>(ZoomRunAutoMatchingDocument, baseOptions);
      }
export type ZoomRunAutoMatchingMutationHookResult = ReturnType<typeof useZoomRunAutoMatchingMutation>;
export type ZoomRunAutoMatchingMutationResult = Apollo.MutationResult<ZoomRunAutoMatchingMutation>;
export type ZoomRunAutoMatchingMutationOptions = Apollo.BaseMutationOptions<ZoomRunAutoMatchingMutation, ZoomRunAutoMatchingMutationVariables>;
export const ZoomSetGroupAccountDocument = gql`
    mutation ZoomSetGroupAccount($groupId: ID!, $zoomAccountId: ID) {
  setGroupZoomAccount(groupId: $groupId, zoomAccountId: $zoomAccountId) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomSetGroupAccountMutationFn = Apollo.MutationFunction<ZoomSetGroupAccountMutation, ZoomSetGroupAccountMutationVariables>;

/**
 * __useZoomSetGroupAccountMutation__
 *
 * To run a mutation, you first call `useZoomSetGroupAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomSetGroupAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomSetGroupAccountMutation, { data, loading, error }] = useZoomSetGroupAccountMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      zoomAccountId: // value for 'zoomAccountId'
 *   },
 * });
 */
export function useZoomSetGroupAccountMutation(baseOptions?: Apollo.MutationHookOptions<ZoomSetGroupAccountMutation, ZoomSetGroupAccountMutationVariables>) {
        return Apollo.useMutation<ZoomSetGroupAccountMutation, ZoomSetGroupAccountMutationVariables>(ZoomSetGroupAccountDocument, baseOptions);
      }
export type ZoomSetGroupAccountMutationHookResult = ReturnType<typeof useZoomSetGroupAccountMutation>;
export type ZoomSetGroupAccountMutationResult = Apollo.MutationResult<ZoomSetGroupAccountMutation>;
export type ZoomSetGroupAccountMutationOptions = Apollo.BaseMutationOptions<ZoomSetGroupAccountMutation, ZoomSetGroupAccountMutationVariables>;
export const ZoomSetGroupScheduleDocument = gql`
    mutation ZoomSetGroupSchedule($groupId: ID!, $zoomAccountId: ID, $slots: [GroupZoomScheduleSlotInput!]!) {
  setGroupZoomSchedule(
    groupId: $groupId
    zoomAccountId: $zoomAccountId
    slots: $slots
  ) {
    success
    customErrors {
      field
      message
      code
    }
    schedules {
      ...GroupZoomScheduleFields
    }
  }
}
    ${GroupZoomScheduleFieldsFragmentDoc}`;
export type ZoomSetGroupScheduleMutationFn = Apollo.MutationFunction<ZoomSetGroupScheduleMutation, ZoomSetGroupScheduleMutationVariables>;

/**
 * __useZoomSetGroupScheduleMutation__
 *
 * To run a mutation, you first call `useZoomSetGroupScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomSetGroupScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomSetGroupScheduleMutation, { data, loading, error }] = useZoomSetGroupScheduleMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      zoomAccountId: // value for 'zoomAccountId'
 *      slots: // value for 'slots'
 *   },
 * });
 */
export function useZoomSetGroupScheduleMutation(baseOptions?: Apollo.MutationHookOptions<ZoomSetGroupScheduleMutation, ZoomSetGroupScheduleMutationVariables>) {
        return Apollo.useMutation<ZoomSetGroupScheduleMutation, ZoomSetGroupScheduleMutationVariables>(ZoomSetGroupScheduleDocument, baseOptions);
      }
export type ZoomSetGroupScheduleMutationHookResult = ReturnType<typeof useZoomSetGroupScheduleMutation>;
export type ZoomSetGroupScheduleMutationResult = Apollo.MutationResult<ZoomSetGroupScheduleMutation>;
export type ZoomSetGroupScheduleMutationOptions = Apollo.BaseMutationOptions<ZoomSetGroupScheduleMutation, ZoomSetGroupScheduleMutationVariables>;
export const ZoomCreateManualMatchDocument = gql`
    mutation ZoomCreateManualMatch($lessonId: ID!, $zoomRecordingId: ID!) {
  createManualLessonRecording(
    lessonId: $lessonId
    zoomRecordingId: $zoomRecordingId
  ) {
    success
    customErrors {
      field
      message
      code
    }
    lessonRecording {
      id
      status
    }
  }
}
    `;
export type ZoomCreateManualMatchMutationFn = Apollo.MutationFunction<ZoomCreateManualMatchMutation, ZoomCreateManualMatchMutationVariables>;

/**
 * __useZoomCreateManualMatchMutation__
 *
 * To run a mutation, you first call `useZoomCreateManualMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomCreateManualMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomCreateManualMatchMutation, { data, loading, error }] = useZoomCreateManualMatchMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      zoomRecordingId: // value for 'zoomRecordingId'
 *   },
 * });
 */
export function useZoomCreateManualMatchMutation(baseOptions?: Apollo.MutationHookOptions<ZoomCreateManualMatchMutation, ZoomCreateManualMatchMutationVariables>) {
        return Apollo.useMutation<ZoomCreateManualMatchMutation, ZoomCreateManualMatchMutationVariables>(ZoomCreateManualMatchDocument, baseOptions);
      }
export type ZoomCreateManualMatchMutationHookResult = ReturnType<typeof useZoomCreateManualMatchMutation>;
export type ZoomCreateManualMatchMutationResult = Apollo.MutationResult<ZoomCreateManualMatchMutation>;
export type ZoomCreateManualMatchMutationOptions = Apollo.BaseMutationOptions<ZoomCreateManualMatchMutation, ZoomCreateManualMatchMutationVariables>;
export const ZoomUnlinkRecordingDocument = gql`
    mutation ZoomUnlinkRecording($id: ID!) {
  unlinkLessonRecording(id: $id) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomUnlinkRecordingMutationFn = Apollo.MutationFunction<ZoomUnlinkRecordingMutation, ZoomUnlinkRecordingMutationVariables>;

/**
 * __useZoomUnlinkRecordingMutation__
 *
 * To run a mutation, you first call `useZoomUnlinkRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomUnlinkRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomUnlinkRecordingMutation, { data, loading, error }] = useZoomUnlinkRecordingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useZoomUnlinkRecordingMutation(baseOptions?: Apollo.MutationHookOptions<ZoomUnlinkRecordingMutation, ZoomUnlinkRecordingMutationVariables>) {
        return Apollo.useMutation<ZoomUnlinkRecordingMutation, ZoomUnlinkRecordingMutationVariables>(ZoomUnlinkRecordingDocument, baseOptions);
      }
export type ZoomUnlinkRecordingMutationHookResult = ReturnType<typeof useZoomUnlinkRecordingMutation>;
export type ZoomUnlinkRecordingMutationResult = Apollo.MutationResult<ZoomUnlinkRecordingMutation>;
export type ZoomUnlinkRecordingMutationOptions = Apollo.BaseMutationOptions<ZoomUnlinkRecordingMutation, ZoomUnlinkRecordingMutationVariables>;
export const ZoomMarkMissingDocument = gql`
    mutation ZoomMarkMissing($lessonId: ID!) {
  markLessonMissingRecording(lessonId: $lessonId) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomMarkMissingMutationFn = Apollo.MutationFunction<ZoomMarkMissingMutation, ZoomMarkMissingMutationVariables>;

/**
 * __useZoomMarkMissingMutation__
 *
 * To run a mutation, you first call `useZoomMarkMissingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomMarkMissingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomMarkMissingMutation, { data, loading, error }] = useZoomMarkMissingMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useZoomMarkMissingMutation(baseOptions?: Apollo.MutationHookOptions<ZoomMarkMissingMutation, ZoomMarkMissingMutationVariables>) {
        return Apollo.useMutation<ZoomMarkMissingMutation, ZoomMarkMissingMutationVariables>(ZoomMarkMissingDocument, baseOptions);
      }
export type ZoomMarkMissingMutationHookResult = ReturnType<typeof useZoomMarkMissingMutation>;
export type ZoomMarkMissingMutationResult = Apollo.MutationResult<ZoomMarkMissingMutation>;
export type ZoomMarkMissingMutationOptions = Apollo.BaseMutationOptions<ZoomMarkMissingMutation, ZoomMarkMissingMutationVariables>;
export const ZoomRetryRecordingDocument = gql`
    mutation ZoomRetryRecording($id: ID!) {
  retryLessonRecording(id: $id) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomRetryRecordingMutationFn = Apollo.MutationFunction<ZoomRetryRecordingMutation, ZoomRetryRecordingMutationVariables>;

/**
 * __useZoomRetryRecordingMutation__
 *
 * To run a mutation, you first call `useZoomRetryRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomRetryRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomRetryRecordingMutation, { data, loading, error }] = useZoomRetryRecordingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useZoomRetryRecordingMutation(baseOptions?: Apollo.MutationHookOptions<ZoomRetryRecordingMutation, ZoomRetryRecordingMutationVariables>) {
        return Apollo.useMutation<ZoomRetryRecordingMutation, ZoomRetryRecordingMutationVariables>(ZoomRetryRecordingDocument, baseOptions);
      }
export type ZoomRetryRecordingMutationHookResult = ReturnType<typeof useZoomRetryRecordingMutation>;
export type ZoomRetryRecordingMutationResult = Apollo.MutationResult<ZoomRetryRecordingMutation>;
export type ZoomRetryRecordingMutationOptions = Apollo.BaseMutationOptions<ZoomRetryRecordingMutation, ZoomRetryRecordingMutationVariables>;
export const ZoomReprocessAiDocument = gql`
    mutation ZoomReprocessAi($id: ID!) {
  reprocessAi(id: $id) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomReprocessAiMutationFn = Apollo.MutationFunction<ZoomReprocessAiMutation, ZoomReprocessAiMutationVariables>;

/**
 * __useZoomReprocessAiMutation__
 *
 * To run a mutation, you first call `useZoomReprocessAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomReprocessAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomReprocessAiMutation, { data, loading, error }] = useZoomReprocessAiMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useZoomReprocessAiMutation(baseOptions?: Apollo.MutationHookOptions<ZoomReprocessAiMutation, ZoomReprocessAiMutationVariables>) {
        return Apollo.useMutation<ZoomReprocessAiMutation, ZoomReprocessAiMutationVariables>(ZoomReprocessAiDocument, baseOptions);
      }
export type ZoomReprocessAiMutationHookResult = ReturnType<typeof useZoomReprocessAiMutation>;
export type ZoomReprocessAiMutationResult = Apollo.MutationResult<ZoomReprocessAiMutation>;
export type ZoomReprocessAiMutationOptions = Apollo.BaseMutationOptions<ZoomReprocessAiMutation, ZoomReprocessAiMutationVariables>;
export const ZoomDeleteRecordingDocument = gql`
    mutation ZoomDeleteRecording($id: ID!, $confirm: String!) {
  deleteZoomRecording(id: $id, confirm: $confirm) {
    success
    customErrors {
      field
      message
      code
    }
    zoomRecording {
      id
      pk
      deletedFromZoom
      deletedAt
    }
  }
}
    `;
export type ZoomDeleteRecordingMutationFn = Apollo.MutationFunction<ZoomDeleteRecordingMutation, ZoomDeleteRecordingMutationVariables>;

/**
 * __useZoomDeleteRecordingMutation__
 *
 * To run a mutation, you first call `useZoomDeleteRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomDeleteRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomDeleteRecordingMutation, { data, loading, error }] = useZoomDeleteRecordingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      confirm: // value for 'confirm'
 *   },
 * });
 */
export function useZoomDeleteRecordingMutation(baseOptions?: Apollo.MutationHookOptions<ZoomDeleteRecordingMutation, ZoomDeleteRecordingMutationVariables>) {
        return Apollo.useMutation<ZoomDeleteRecordingMutation, ZoomDeleteRecordingMutationVariables>(ZoomDeleteRecordingDocument, baseOptions);
      }
export type ZoomDeleteRecordingMutationHookResult = ReturnType<typeof useZoomDeleteRecordingMutation>;
export type ZoomDeleteRecordingMutationResult = Apollo.MutationResult<ZoomDeleteRecordingMutation>;
export type ZoomDeleteRecordingMutationOptions = Apollo.BaseMutationOptions<ZoomDeleteRecordingMutation, ZoomDeleteRecordingMutationVariables>;
export const ZoomDeleteRecordingsDocument = gql`
    mutation ZoomDeleteRecordings($ids: [ID!]!, $confirm: Boolean!) {
  deleteZoomRecordings(ids: $ids, confirm: $confirm) {
    success
    customErrors {
      field
      message
      code
    }
    queued
    skipped
    rows {
      id
      queued
      reason
    }
  }
}
    `;
export type ZoomDeleteRecordingsMutationFn = Apollo.MutationFunction<ZoomDeleteRecordingsMutation, ZoomDeleteRecordingsMutationVariables>;

/**
 * __useZoomDeleteRecordingsMutation__
 *
 * To run a mutation, you first call `useZoomDeleteRecordingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomDeleteRecordingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomDeleteRecordingsMutation, { data, loading, error }] = useZoomDeleteRecordingsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      confirm: // value for 'confirm'
 *   },
 * });
 */
export function useZoomDeleteRecordingsMutation(baseOptions?: Apollo.MutationHookOptions<ZoomDeleteRecordingsMutation, ZoomDeleteRecordingsMutationVariables>) {
        return Apollo.useMutation<ZoomDeleteRecordingsMutation, ZoomDeleteRecordingsMutationVariables>(ZoomDeleteRecordingsDocument, baseOptions);
      }
export type ZoomDeleteRecordingsMutationHookResult = ReturnType<typeof useZoomDeleteRecordingsMutation>;
export type ZoomDeleteRecordingsMutationResult = Apollo.MutationResult<ZoomDeleteRecordingsMutation>;
export type ZoomDeleteRecordingsMutationOptions = Apollo.BaseMutationOptions<ZoomDeleteRecordingsMutation, ZoomDeleteRecordingsMutationVariables>;
export const ZoomTriggerGroupProcessDocument = gql`
    mutation ZoomTriggerGroupProcess($groupId: ID!, $dateFrom: Date, $dateTo: Date) {
  triggerZoomGroupProcess(groupId: $groupId, dateFrom: $dateFrom, dateTo: $dateTo) {
    success
    customErrors {
      field
      message
      code
    }
    enqueued
    queuedCount
    message
  }
}
    `;
export type ZoomTriggerGroupProcessMutationFn = Apollo.MutationFunction<ZoomTriggerGroupProcessMutation, ZoomTriggerGroupProcessMutationVariables>;

/**
 * __useZoomTriggerGroupProcessMutation__
 *
 * To run a mutation, you first call `useZoomTriggerGroupProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomTriggerGroupProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomTriggerGroupProcessMutation, { data, loading, error }] = useZoomTriggerGroupProcessMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useZoomTriggerGroupProcessMutation(baseOptions?: Apollo.MutationHookOptions<ZoomTriggerGroupProcessMutation, ZoomTriggerGroupProcessMutationVariables>) {
        return Apollo.useMutation<ZoomTriggerGroupProcessMutation, ZoomTriggerGroupProcessMutationVariables>(ZoomTriggerGroupProcessDocument, baseOptions);
      }
export type ZoomTriggerGroupProcessMutationHookResult = ReturnType<typeof useZoomTriggerGroupProcessMutation>;
export type ZoomTriggerGroupProcessMutationResult = Apollo.MutationResult<ZoomTriggerGroupProcessMutation>;
export type ZoomTriggerGroupProcessMutationOptions = Apollo.BaseMutationOptions<ZoomTriggerGroupProcessMutation, ZoomTriggerGroupProcessMutationVariables>;
export const ZoomSendMorningReportDocument = gql`
    mutation ZoomSendMorningReport($date: Date) {
  sendMorningReport(date: $date) {
    success
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type ZoomSendMorningReportMutationFn = Apollo.MutationFunction<ZoomSendMorningReportMutation, ZoomSendMorningReportMutationVariables>;

/**
 * __useZoomSendMorningReportMutation__
 *
 * To run a mutation, you first call `useZoomSendMorningReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomSendMorningReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomSendMorningReportMutation, { data, loading, error }] = useZoomSendMorningReportMutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useZoomSendMorningReportMutation(baseOptions?: Apollo.MutationHookOptions<ZoomSendMorningReportMutation, ZoomSendMorningReportMutationVariables>) {
        return Apollo.useMutation<ZoomSendMorningReportMutation, ZoomSendMorningReportMutationVariables>(ZoomSendMorningReportDocument, baseOptions);
      }
export type ZoomSendMorningReportMutationHookResult = ReturnType<typeof useZoomSendMorningReportMutation>;
export type ZoomSendMorningReportMutationResult = Apollo.MutationResult<ZoomSendMorningReportMutation>;
export type ZoomSendMorningReportMutationOptions = Apollo.BaseMutationOptions<ZoomSendMorningReportMutation, ZoomSendMorningReportMutationVariables>;
export const QueueZoomParticipantsSyncDocument = gql`
    mutation QueueZoomParticipantsSync($groupId: ID!, $dateFrom: Date!, $dateTo: Date!, $force: Boolean) {
  requestZoomParticipantsSync(
    groupId: $groupId
    dateFrom: $dateFrom
    dateTo: $dateTo
    force: $force
  ) {
    success
    customErrors {
      field
      code
      message
    }
    queued
  }
}
    `;
export type QueueZoomParticipantsSyncMutationFn = Apollo.MutationFunction<QueueZoomParticipantsSyncMutation, QueueZoomParticipantsSyncMutationVariables>;

/**
 * __useQueueZoomParticipantsSyncMutation__
 *
 * To run a mutation, you first call `useQueueZoomParticipantsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueZoomParticipantsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueZoomParticipantsSyncMutation, { data, loading, error }] = useQueueZoomParticipantsSyncMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useQueueZoomParticipantsSyncMutation(baseOptions?: Apollo.MutationHookOptions<QueueZoomParticipantsSyncMutation, QueueZoomParticipantsSyncMutationVariables>) {
        return Apollo.useMutation<QueueZoomParticipantsSyncMutation, QueueZoomParticipantsSyncMutationVariables>(QueueZoomParticipantsSyncDocument, baseOptions);
      }
export type QueueZoomParticipantsSyncMutationHookResult = ReturnType<typeof useQueueZoomParticipantsSyncMutation>;
export type QueueZoomParticipantsSyncMutationResult = Apollo.MutationResult<QueueZoomParticipantsSyncMutation>;
export type QueueZoomParticipantsSyncMutationOptions = Apollo.BaseMutationOptions<QueueZoomParticipantsSyncMutation, QueueZoomParticipantsSyncMutationVariables>;
export const ResolveZoomParticipantDocument = gql`
    mutation ResolveZoomParticipant($sessionId: ID!, $userId: ID, $ignore: Boolean, $remember: Boolean) {
  matchZoomParticipant(
    sessionId: $sessionId
    userId: $userId
    ignore: $ignore
    remember: $remember
  ) {
    success
    customErrors {
      field
      code
      message
    }
    aliasCreated
    sessions {
      id
      instanceId
      name
      email
      joinTime
      leaveTime
      durationSeconds
      status
      failover
      identityKey
      matchStatus
      matchRule
      offRoster
      matchedUserId
      matchedUserName
      matchedStudentId
      matchedByName
      matchedAt
    }
  }
}
    `;
export type ResolveZoomParticipantMutationFn = Apollo.MutationFunction<ResolveZoomParticipantMutation, ResolveZoomParticipantMutationVariables>;

/**
 * __useResolveZoomParticipantMutation__
 *
 * To run a mutation, you first call `useResolveZoomParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveZoomParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveZoomParticipantMutation, { data, loading, error }] = useResolveZoomParticipantMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      userId: // value for 'userId'
 *      ignore: // value for 'ignore'
 *      remember: // value for 'remember'
 *   },
 * });
 */
export function useResolveZoomParticipantMutation(baseOptions?: Apollo.MutationHookOptions<ResolveZoomParticipantMutation, ResolveZoomParticipantMutationVariables>) {
        return Apollo.useMutation<ResolveZoomParticipantMutation, ResolveZoomParticipantMutationVariables>(ResolveZoomParticipantDocument, baseOptions);
      }
export type ResolveZoomParticipantMutationHookResult = ReturnType<typeof useResolveZoomParticipantMutation>;
export type ResolveZoomParticipantMutationResult = Apollo.MutationResult<ResolveZoomParticipantMutation>;
export type ResolveZoomParticipantMutationOptions = Apollo.BaseMutationOptions<ResolveZoomParticipantMutation, ResolveZoomParticipantMutationVariables>;
export const AttachZoomInstanceToLessonDocument = gql`
    mutation AttachZoomInstanceToLesson($lessonId: ID!, $instanceUuid: String, $meetingId: String) {
  linkZoomInstanceToLesson(
    lessonId: $lessonId
    instanceUuid: $instanceUuid
    meetingId: $meetingId
  ) {
    success
    customErrors {
      field
      code
      message
    }
    queued
    instances {
      id
      uuid
      meetingId
      topic
      startTime
      endTime
      durationMinutes
      participantsCount
      lessonId
      lessonRule
      lessonAmbiguous
      lessonLocked
      participantsStatus
      participantsFetchedAt
      participantsError
    }
  }
}
    `;
export type AttachZoomInstanceToLessonMutationFn = Apollo.MutationFunction<AttachZoomInstanceToLessonMutation, AttachZoomInstanceToLessonMutationVariables>;

/**
 * __useAttachZoomInstanceToLessonMutation__
 *
 * To run a mutation, you first call `useAttachZoomInstanceToLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachZoomInstanceToLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachZoomInstanceToLessonMutation, { data, loading, error }] = useAttachZoomInstanceToLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      instanceUuid: // value for 'instanceUuid'
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useAttachZoomInstanceToLessonMutation(baseOptions?: Apollo.MutationHookOptions<AttachZoomInstanceToLessonMutation, AttachZoomInstanceToLessonMutationVariables>) {
        return Apollo.useMutation<AttachZoomInstanceToLessonMutation, AttachZoomInstanceToLessonMutationVariables>(AttachZoomInstanceToLessonDocument, baseOptions);
      }
export type AttachZoomInstanceToLessonMutationHookResult = ReturnType<typeof useAttachZoomInstanceToLessonMutation>;
export type AttachZoomInstanceToLessonMutationResult = Apollo.MutationResult<AttachZoomInstanceToLessonMutation>;
export type AttachZoomInstanceToLessonMutationOptions = Apollo.BaseMutationOptions<AttachZoomInstanceToLessonMutation, AttachZoomInstanceToLessonMutationVariables>;
export const DetachZoomInstanceDocument = gql`
    mutation DetachZoomInstance($instanceId: ID!) {
  unlinkZoomInstance(instanceId: $instanceId) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type DetachZoomInstanceMutationFn = Apollo.MutationFunction<DetachZoomInstanceMutation, DetachZoomInstanceMutationVariables>;

/**
 * __useDetachZoomInstanceMutation__
 *
 * To run a mutation, you first call `useDetachZoomInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachZoomInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachZoomInstanceMutation, { data, loading, error }] = useDetachZoomInstanceMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useDetachZoomInstanceMutation(baseOptions?: Apollo.MutationHookOptions<DetachZoomInstanceMutation, DetachZoomInstanceMutationVariables>) {
        return Apollo.useMutation<DetachZoomInstanceMutation, DetachZoomInstanceMutationVariables>(DetachZoomInstanceDocument, baseOptions);
      }
export type DetachZoomInstanceMutationHookResult = ReturnType<typeof useDetachZoomInstanceMutation>;
export type DetachZoomInstanceMutationResult = Apollo.MutationResult<DetachZoomInstanceMutation>;
export type DetachZoomInstanceMutationOptions = Apollo.BaseMutationOptions<DetachZoomInstanceMutation, DetachZoomInstanceMutationVariables>;
export const AgreementCorrectionPrecheckDocument = gql`
    query AgreementCorrectionPrecheck($agreementId: ID!, $targetGroupId: ID) {
  agreementCorrectionCheck(
    agreementId: $agreementId
    targetGroupId: $targetGroupId
  ) {
    canCorrect
    canUndo
    correctBlockers
    undoBlockers
    warnings
    undoDeadline
  }
}
    `;

/**
 * __useAgreementCorrectionPrecheckQuery__
 *
 * To run a query within a React component, call `useAgreementCorrectionPrecheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementCorrectionPrecheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgreementCorrectionPrecheckQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      targetGroupId: // value for 'targetGroupId'
 *   },
 * });
 */
export function useAgreementCorrectionPrecheckQuery(baseOptions: Apollo.QueryHookOptions<AgreementCorrectionPrecheckQuery, AgreementCorrectionPrecheckQueryVariables>) {
        return Apollo.useQuery<AgreementCorrectionPrecheckQuery, AgreementCorrectionPrecheckQueryVariables>(AgreementCorrectionPrecheckDocument, baseOptions);
      }
export function useAgreementCorrectionPrecheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgreementCorrectionPrecheckQuery, AgreementCorrectionPrecheckQueryVariables>) {
          return Apollo.useLazyQuery<AgreementCorrectionPrecheckQuery, AgreementCorrectionPrecheckQueryVariables>(AgreementCorrectionPrecheckDocument, baseOptions);
        }
export type AgreementCorrectionPrecheckQueryHookResult = ReturnType<typeof useAgreementCorrectionPrecheckQuery>;
export type AgreementCorrectionPrecheckLazyQueryHookResult = ReturnType<typeof useAgreementCorrectionPrecheckLazyQuery>;
export type AgreementCorrectionPrecheckQueryResult = Apollo.QueryResult<AgreementCorrectionPrecheckQuery, AgreementCorrectionPrecheckQueryVariables>;
export const ErpAiAgentOverviewDocument = gql`
    query ErpAiAgentOverview {
  aiAgentOverview {
    monthCostUsd
    monthBudgetUsd
    peakNow
    agents {
      key
      label
      description
      enabled
      offReason
      provider
      model
      version
      monthCostUsd
      monthBudgetUsd
      runsToday
      runningCount
      queuedCount
      lastRunAt
      lastStatus
      metrics
      manualStart
      subjectKinds
    }
    costByDay {
      day
      agentKey
      costUsd
      calls
    }
  }
}
    `;

/**
 * __useErpAiAgentOverviewQuery__
 *
 * To run a query within a React component, call `useErpAiAgentOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiAgentOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiAgentOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpAiAgentOverviewQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiAgentOverviewQuery, ErpAiAgentOverviewQueryVariables>) {
        return Apollo.useQuery<ErpAiAgentOverviewQuery, ErpAiAgentOverviewQueryVariables>(ErpAiAgentOverviewDocument, baseOptions);
      }
export function useErpAiAgentOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiAgentOverviewQuery, ErpAiAgentOverviewQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiAgentOverviewQuery, ErpAiAgentOverviewQueryVariables>(ErpAiAgentOverviewDocument, baseOptions);
        }
export type ErpAiAgentOverviewQueryHookResult = ReturnType<typeof useErpAiAgentOverviewQuery>;
export type ErpAiAgentOverviewLazyQueryHookResult = ReturnType<typeof useErpAiAgentOverviewLazyQuery>;
export type ErpAiAgentOverviewQueryResult = Apollo.QueryResult<ErpAiAgentOverviewQuery, ErpAiAgentOverviewQueryVariables>;
export const ErpAiAgentRunsDocument = gql`
    query ErpAiAgentRuns($agentKey: String, $status: String, $trigger: String, $offset: Int, $limit: Int) {
  aiAgentRuns(
    agentKey: $agentKey
    status: $status
    trigger: $trigger
    offset: $offset
    limit: $limit
  ) {
    total
    hasMore
    rows {
      id
      agentKey
      trigger
      status
      subjectKind
      subjectId
      subjectLabel
      createdAt
      startedAt
      finishedAt
      durationMs
      provider
      model
      inputTokens
      cachedTokens
      outputTokens
      costUsd
      resultSummary
      error
      createdByName
    }
  }
}
    `;

/**
 * __useErpAiAgentRunsQuery__
 *
 * To run a query within a React component, call `useErpAiAgentRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiAgentRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiAgentRunsQuery({
 *   variables: {
 *      agentKey: // value for 'agentKey'
 *      status: // value for 'status'
 *      trigger: // value for 'trigger'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useErpAiAgentRunsQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiAgentRunsQuery, ErpAiAgentRunsQueryVariables>) {
        return Apollo.useQuery<ErpAiAgentRunsQuery, ErpAiAgentRunsQueryVariables>(ErpAiAgentRunsDocument, baseOptions);
      }
export function useErpAiAgentRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiAgentRunsQuery, ErpAiAgentRunsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiAgentRunsQuery, ErpAiAgentRunsQueryVariables>(ErpAiAgentRunsDocument, baseOptions);
        }
export type ErpAiAgentRunsQueryHookResult = ReturnType<typeof useErpAiAgentRunsQuery>;
export type ErpAiAgentRunsLazyQueryHookResult = ReturnType<typeof useErpAiAgentRunsLazyQuery>;
export type ErpAiAgentRunsQueryResult = Apollo.QueryResult<ErpAiAgentRunsQuery, ErpAiAgentRunsQueryVariables>;
export const ErpAiAgentRunDocument = gql`
    query ErpAiAgentRun($id: ID!) {
  aiAgentRun(id: $id) {
    id
    agentKey
    trigger
    status
    subjectKind
    subjectId
    subjectLabel
    createdAt
    startedAt
    finishedAt
    durationMs
    provider
    model
    inputTokens
    cachedTokens
    outputTokens
    costUsd
    resultSummary
    error
    createdByName
    steps {
      id
      node
      status
      startedAt
      finishedAt
      summary
      error
    }
  }
}
    `;

/**
 * __useErpAiAgentRunQuery__
 *
 * To run a query within a React component, call `useErpAiAgentRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiAgentRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiAgentRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpAiAgentRunQuery(baseOptions: Apollo.QueryHookOptions<ErpAiAgentRunQuery, ErpAiAgentRunQueryVariables>) {
        return Apollo.useQuery<ErpAiAgentRunQuery, ErpAiAgentRunQueryVariables>(ErpAiAgentRunDocument, baseOptions);
      }
export function useErpAiAgentRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiAgentRunQuery, ErpAiAgentRunQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiAgentRunQuery, ErpAiAgentRunQueryVariables>(ErpAiAgentRunDocument, baseOptions);
        }
export type ErpAiAgentRunQueryHookResult = ReturnType<typeof useErpAiAgentRunQuery>;
export type ErpAiAgentRunLazyQueryHookResult = ReturnType<typeof useErpAiAgentRunLazyQuery>;
export type ErpAiAgentRunQueryResult = Apollo.QueryResult<ErpAiAgentRunQuery, ErpAiAgentRunQueryVariables>;
export const ErpAiChatThreadsDocument = gql`
    query ErpAiChatThreads($archived: Boolean) {
  aiChatThreads(archived: $archived) {
    id
    title
    status
    createdAt
    lastMessageAt
    pinnedAt
  }
}
    `;

/**
 * __useErpAiChatThreadsQuery__
 *
 * To run a query within a React component, call `useErpAiChatThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiChatThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiChatThreadsQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useErpAiChatThreadsQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiChatThreadsQuery, ErpAiChatThreadsQueryVariables>) {
        return Apollo.useQuery<ErpAiChatThreadsQuery, ErpAiChatThreadsQueryVariables>(ErpAiChatThreadsDocument, baseOptions);
      }
export function useErpAiChatThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiChatThreadsQuery, ErpAiChatThreadsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiChatThreadsQuery, ErpAiChatThreadsQueryVariables>(ErpAiChatThreadsDocument, baseOptions);
        }
export type ErpAiChatThreadsQueryHookResult = ReturnType<typeof useErpAiChatThreadsQuery>;
export type ErpAiChatThreadsLazyQueryHookResult = ReturnType<typeof useErpAiChatThreadsLazyQuery>;
export type ErpAiChatThreadsQueryResult = Apollo.QueryResult<ErpAiChatThreadsQuery, ErpAiChatThreadsQueryVariables>;
export const ErpAiChatThreadDocument = gql`
    query ErpAiChatThread($id: ID!) {
  aiChatThread(id: $id) {
    thread {
      id
      title
      status
      createdAt
      lastMessageAt
      pinnedAt
    }
    messages {
      id
      role
      text
      createdAt
      blocks
      interrupted
      mentions {
        kind
        id
        label
      }
      attachments {
        id
        url
        name
        mime
        size
        width
        height
      }
      toolCalls {
        name
        argsSummary
        status
        resultSummary
        source {
          kind
          label
        }
      }
      pendingActions {
        id
        tool
        willDo
        status
        result
        createdAt
        source {
          kind
          label
        }
      }
    }
    toolEvents {
      id
      messageId
      seq
      name
      args
      status
      resultPreview
      startedAt
      finishedAt
      source {
        kind
        label
      }
    }
    activeRun {
      id
      agentKey
      status
      model
      createdAt
      startedAt
      finishedAt
      error
      steps {
        id
        node
        status
        startedAt
        finishedAt
        summary
        error
      }
    }
    lastRun {
      id
      agentKey
      status
      model
      createdAt
      startedAt
      finishedAt
      error
    }
  }
}
    `;

/**
 * __useErpAiChatThreadQuery__
 *
 * To run a query within a React component, call `useErpAiChatThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiChatThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiChatThreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpAiChatThreadQuery(baseOptions: Apollo.QueryHookOptions<ErpAiChatThreadQuery, ErpAiChatThreadQueryVariables>) {
        return Apollo.useQuery<ErpAiChatThreadQuery, ErpAiChatThreadQueryVariables>(ErpAiChatThreadDocument, baseOptions);
      }
export function useErpAiChatThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiChatThreadQuery, ErpAiChatThreadQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiChatThreadQuery, ErpAiChatThreadQueryVariables>(ErpAiChatThreadDocument, baseOptions);
        }
export type ErpAiChatThreadQueryHookResult = ReturnType<typeof useErpAiChatThreadQuery>;
export type ErpAiChatThreadLazyQueryHookResult = ReturnType<typeof useErpAiChatThreadLazyQuery>;
export type ErpAiChatThreadQueryResult = Apollo.QueryResult<ErpAiChatThreadQuery, ErpAiChatThreadQueryVariables>;
export const ErpAiChatMentionSuggestionsDocument = gql`
    query ErpAiChatMentionSuggestions($query: String!, $kinds: [String!]) {
  aiChatMentionSearch(query: $query, kinds: $kinds) {
    kind
    id
    label
    sublabel
  }
}
    `;

/**
 * __useErpAiChatMentionSuggestionsQuery__
 *
 * To run a query within a React component, call `useErpAiChatMentionSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiChatMentionSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiChatMentionSuggestionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      kinds: // value for 'kinds'
 *   },
 * });
 */
export function useErpAiChatMentionSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<ErpAiChatMentionSuggestionsQuery, ErpAiChatMentionSuggestionsQueryVariables>) {
        return Apollo.useQuery<ErpAiChatMentionSuggestionsQuery, ErpAiChatMentionSuggestionsQueryVariables>(ErpAiChatMentionSuggestionsDocument, baseOptions);
      }
export function useErpAiChatMentionSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiChatMentionSuggestionsQuery, ErpAiChatMentionSuggestionsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiChatMentionSuggestionsQuery, ErpAiChatMentionSuggestionsQueryVariables>(ErpAiChatMentionSuggestionsDocument, baseOptions);
        }
export type ErpAiChatMentionSuggestionsQueryHookResult = ReturnType<typeof useErpAiChatMentionSuggestionsQuery>;
export type ErpAiChatMentionSuggestionsLazyQueryHookResult = ReturnType<typeof useErpAiChatMentionSuggestionsLazyQuery>;
export type ErpAiChatMentionSuggestionsQueryResult = Apollo.QueryResult<ErpAiChatMentionSuggestionsQuery, ErpAiChatMentionSuggestionsQueryVariables>;
export const ErpAiFindingsDocument = gql`
    query ErpAiFindings($kind: String, $groupId: ID, $feedback: String, $offset: Int, $limit: Int) {
  aiFindings(
    kind: $kind
    groupId: $groupId
    feedback: $feedback
    offset: $offset
    limit: $limit
  ) {
    total
    hasMore
    rows {
      id
      kind
      severity
      summary
      confidence
      groupId
      groupName
      lessonId
      lessonStartsAt
      proposedStartsAt
      scheduleNote
      conversationId
      messageIds
      excerpts
      taskId
      taskStatus
      feedback
      feedbackReason
      feedbackByName
      createdAt
    }
  }
}
    `;

/**
 * __useErpAiFindingsQuery__
 *
 * To run a query within a React component, call `useErpAiFindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiFindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiFindingsQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      groupId: // value for 'groupId'
 *      feedback: // value for 'feedback'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useErpAiFindingsQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiFindingsQuery, ErpAiFindingsQueryVariables>) {
        return Apollo.useQuery<ErpAiFindingsQuery, ErpAiFindingsQueryVariables>(ErpAiFindingsDocument, baseOptions);
      }
export function useErpAiFindingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiFindingsQuery, ErpAiFindingsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiFindingsQuery, ErpAiFindingsQueryVariables>(ErpAiFindingsDocument, baseOptions);
        }
export type ErpAiFindingsQueryHookResult = ReturnType<typeof useErpAiFindingsQuery>;
export type ErpAiFindingsLazyQueryHookResult = ReturnType<typeof useErpAiFindingsLazyQuery>;
export type ErpAiFindingsQueryResult = Apollo.QueryResult<ErpAiFindingsQuery, ErpAiFindingsQueryVariables>;
export const ErpAiFindingForTaskDocument = gql`
    query ErpAiFindingForTask($taskId: ID!) {
  aiFindingForTask(taskId: $taskId) {
    id
    kind
    severity
    summary
    confidence
    groupId
    groupName
    lessonId
    lessonStartsAt
    proposedStartsAt
    scheduleNote
    conversationId
    messageIds
    excerpts
    taskId
    taskStatus
    feedback
    feedbackReason
    feedbackByName
    createdAt
  }
}
    `;

/**
 * __useErpAiFindingForTaskQuery__
 *
 * To run a query within a React component, call `useErpAiFindingForTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiFindingForTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiFindingForTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useErpAiFindingForTaskQuery(baseOptions: Apollo.QueryHookOptions<ErpAiFindingForTaskQuery, ErpAiFindingForTaskQueryVariables>) {
        return Apollo.useQuery<ErpAiFindingForTaskQuery, ErpAiFindingForTaskQueryVariables>(ErpAiFindingForTaskDocument, baseOptions);
      }
export function useErpAiFindingForTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiFindingForTaskQuery, ErpAiFindingForTaskQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiFindingForTaskQuery, ErpAiFindingForTaskQueryVariables>(ErpAiFindingForTaskDocument, baseOptions);
        }
export type ErpAiFindingForTaskQueryHookResult = ReturnType<typeof useErpAiFindingForTaskQuery>;
export type ErpAiFindingForTaskLazyQueryHookResult = ReturnType<typeof useErpAiFindingForTaskLazyQuery>;
export type ErpAiFindingForTaskQueryResult = Apollo.QueryResult<ErpAiFindingForTaskQuery, ErpAiFindingForTaskQueryVariables>;
export const ErpAiLessonReviewQueueDocument = gql`
    query ErpAiLessonReviewQueue($reviewStatus: String, $offset: Int, $limit: Int) {
  aiLessonAnalyses(reviewStatus: $reviewStatus, offset: $offset, limit: $limit) {
    total
    hasMore
    rows {
      id
      lessonId
      groupId
      groupName
      lessonNumber
      lessonStartsAt
      teacherName
      status
      overallScore
      reviewStatus
      createdAt
    }
  }
}
    `;

/**
 * __useErpAiLessonReviewQueueQuery__
 *
 * To run a query within a React component, call `useErpAiLessonReviewQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiLessonReviewQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiLessonReviewQueueQuery({
 *   variables: {
 *      reviewStatus: // value for 'reviewStatus'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useErpAiLessonReviewQueueQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiLessonReviewQueueQuery, ErpAiLessonReviewQueueQueryVariables>) {
        return Apollo.useQuery<ErpAiLessonReviewQueueQuery, ErpAiLessonReviewQueueQueryVariables>(ErpAiLessonReviewQueueDocument, baseOptions);
      }
export function useErpAiLessonReviewQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiLessonReviewQueueQuery, ErpAiLessonReviewQueueQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiLessonReviewQueueQuery, ErpAiLessonReviewQueueQueryVariables>(ErpAiLessonReviewQueueDocument, baseOptions);
        }
export type ErpAiLessonReviewQueueQueryHookResult = ReturnType<typeof useErpAiLessonReviewQueueQuery>;
export type ErpAiLessonReviewQueueLazyQueryHookResult = ReturnType<typeof useErpAiLessonReviewQueueLazyQuery>;
export type ErpAiLessonReviewQueueQueryResult = Apollo.QueryResult<ErpAiLessonReviewQueueQuery, ErpAiLessonReviewQueueQueryVariables>;
export const ErpAiKnowledgeDocumentsDocument = gql`
    query ErpAiKnowledgeDocuments($category: String, $status: String, $q: String) {
  aiKnowledgeDocuments(category: $category, status: $status, q: $q) {
    id
    title
    category
    status
    sourceFileName
    version
    tokens
    chunkCount
    updatedAt
    updatedByName
    verifiedAt
    verifiedByName
    stale
  }
}
    `;

/**
 * __useErpAiKnowledgeDocumentsQuery__
 *
 * To run a query within a React component, call `useErpAiKnowledgeDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKnowledgeDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKnowledgeDocumentsQuery({
 *   variables: {
 *      category: // value for 'category'
 *      status: // value for 'status'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useErpAiKnowledgeDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiKnowledgeDocumentsQuery, ErpAiKnowledgeDocumentsQueryVariables>) {
        return Apollo.useQuery<ErpAiKnowledgeDocumentsQuery, ErpAiKnowledgeDocumentsQueryVariables>(ErpAiKnowledgeDocumentsDocument, baseOptions);
      }
export function useErpAiKnowledgeDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKnowledgeDocumentsQuery, ErpAiKnowledgeDocumentsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKnowledgeDocumentsQuery, ErpAiKnowledgeDocumentsQueryVariables>(ErpAiKnowledgeDocumentsDocument, baseOptions);
        }
export type ErpAiKnowledgeDocumentsQueryHookResult = ReturnType<typeof useErpAiKnowledgeDocumentsQuery>;
export type ErpAiKnowledgeDocumentsLazyQueryHookResult = ReturnType<typeof useErpAiKnowledgeDocumentsLazyQuery>;
export type ErpAiKnowledgeDocumentsQueryResult = Apollo.QueryResult<ErpAiKnowledgeDocumentsQuery, ErpAiKnowledgeDocumentsQueryVariables>;
export const ErpAiKnowledgeDocumentDocument = gql`
    query ErpAiKnowledgeDocument($id: ID!) {
  aiKnowledgeDocument(id: $id) {
    id
    title
    category
    status
    body
    sourceFileName
    version
    tokens
    chunkCount
    updatedAt
    updatedByName
    verifiedAt
    verifiedByName
    stale
  }
}
    `;

/**
 * __useErpAiKnowledgeDocumentQuery__
 *
 * To run a query within a React component, call `useErpAiKnowledgeDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKnowledgeDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKnowledgeDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpAiKnowledgeDocumentQuery(baseOptions: Apollo.QueryHookOptions<ErpAiKnowledgeDocumentQuery, ErpAiKnowledgeDocumentQueryVariables>) {
        return Apollo.useQuery<ErpAiKnowledgeDocumentQuery, ErpAiKnowledgeDocumentQueryVariables>(ErpAiKnowledgeDocumentDocument, baseOptions);
      }
export function useErpAiKnowledgeDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKnowledgeDocumentQuery, ErpAiKnowledgeDocumentQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKnowledgeDocumentQuery, ErpAiKnowledgeDocumentQueryVariables>(ErpAiKnowledgeDocumentDocument, baseOptions);
        }
export type ErpAiKnowledgeDocumentQueryHookResult = ReturnType<typeof useErpAiKnowledgeDocumentQuery>;
export type ErpAiKnowledgeDocumentLazyQueryHookResult = ReturnType<typeof useErpAiKnowledgeDocumentLazyQuery>;
export type ErpAiKnowledgeDocumentQueryResult = Apollo.QueryResult<ErpAiKnowledgeDocumentQuery, ErpAiKnowledgeDocumentQueryVariables>;
export const ErpAiKnowledgeStatsDocument = gql`
    query ErpAiKnowledgeStats {
  aiKnowledgeStats {
    publishedCount
    publishedTokens
    strategy
    vectorCoverage {
      withVector
      total
    }
    lastSweepAt
    lastSweepStatus
    lastSweepError
    vectorsOffReason
  }
}
    `;

/**
 * __useErpAiKnowledgeStatsQuery__
 *
 * To run a query within a React component, call `useErpAiKnowledgeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKnowledgeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKnowledgeStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpAiKnowledgeStatsQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiKnowledgeStatsQuery, ErpAiKnowledgeStatsQueryVariables>) {
        return Apollo.useQuery<ErpAiKnowledgeStatsQuery, ErpAiKnowledgeStatsQueryVariables>(ErpAiKnowledgeStatsDocument, baseOptions);
      }
export function useErpAiKnowledgeStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKnowledgeStatsQuery, ErpAiKnowledgeStatsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKnowledgeStatsQuery, ErpAiKnowledgeStatsQueryVariables>(ErpAiKnowledgeStatsDocument, baseOptions);
        }
export type ErpAiKnowledgeStatsQueryHookResult = ReturnType<typeof useErpAiKnowledgeStatsQuery>;
export type ErpAiKnowledgeStatsLazyQueryHookResult = ReturnType<typeof useErpAiKnowledgeStatsLazyQuery>;
export type ErpAiKnowledgeStatsQueryResult = Apollo.QueryResult<ErpAiKnowledgeStatsQuery, ErpAiKnowledgeStatsQueryVariables>;
export const ErpAiKnowledgeSearchDocument = gql`
    query ErpAiKnowledgeSearch($query: String!, $category: String) {
  aiKnowledgeSearch(query: $query, category: $category) {
    documentId
    title
    headingPath
    text
    rank
  }
}
    `;

/**
 * __useErpAiKnowledgeSearchQuery__
 *
 * To run a query within a React component, call `useErpAiKnowledgeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKnowledgeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKnowledgeSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useErpAiKnowledgeSearchQuery(baseOptions: Apollo.QueryHookOptions<ErpAiKnowledgeSearchQuery, ErpAiKnowledgeSearchQueryVariables>) {
        return Apollo.useQuery<ErpAiKnowledgeSearchQuery, ErpAiKnowledgeSearchQueryVariables>(ErpAiKnowledgeSearchDocument, baseOptions);
      }
export function useErpAiKnowledgeSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKnowledgeSearchQuery, ErpAiKnowledgeSearchQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKnowledgeSearchQuery, ErpAiKnowledgeSearchQueryVariables>(ErpAiKnowledgeSearchDocument, baseOptions);
        }
export type ErpAiKnowledgeSearchQueryHookResult = ReturnType<typeof useErpAiKnowledgeSearchQuery>;
export type ErpAiKnowledgeSearchLazyQueryHookResult = ReturnType<typeof useErpAiKnowledgeSearchLazyQuery>;
export type ErpAiKnowledgeSearchQueryResult = Apollo.QueryResult<ErpAiKnowledgeSearchQuery, ErpAiKnowledgeSearchQueryVariables>;
export const ErpAiKbCandidatesDocument = gql`
    query ErpAiKbCandidates($category: String, $kind: String, $status: String, $limit: Int, $offset: Int) {
  aiKbCandidates(
    category: $category
    kind: $kind
    status: $status
    limit: $limit
    offset: $offset
  ) {
    items {
      ...ErpAiKbCandidateFields
    }
    total
  }
}
    ${ErpAiKbCandidateFieldsFragmentDoc}`;

/**
 * __useErpAiKbCandidatesQuery__
 *
 * To run a query within a React component, call `useErpAiKbCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKbCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKbCandidatesQuery({
 *   variables: {
 *      category: // value for 'category'
 *      kind: // value for 'kind'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useErpAiKbCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiKbCandidatesQuery, ErpAiKbCandidatesQueryVariables>) {
        return Apollo.useQuery<ErpAiKbCandidatesQuery, ErpAiKbCandidatesQueryVariables>(ErpAiKbCandidatesDocument, baseOptions);
      }
export function useErpAiKbCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKbCandidatesQuery, ErpAiKbCandidatesQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKbCandidatesQuery, ErpAiKbCandidatesQueryVariables>(ErpAiKbCandidatesDocument, baseOptions);
        }
export type ErpAiKbCandidatesQueryHookResult = ReturnType<typeof useErpAiKbCandidatesQuery>;
export type ErpAiKbCandidatesLazyQueryHookResult = ReturnType<typeof useErpAiKbCandidatesLazyQuery>;
export type ErpAiKbCandidatesQueryResult = Apollo.QueryResult<ErpAiKbCandidatesQuery, ErpAiKbCandidatesQueryVariables>;
export const ErpAiKbCandidateDocument = gql`
    query ErpAiKbCandidate($id: ID!) {
  aiKbCandidate(id: $id) {
    ...ErpAiKbCandidateFields
  }
}
    ${ErpAiKbCandidateFieldsFragmentDoc}`;

/**
 * __useErpAiKbCandidateQuery__
 *
 * To run a query within a React component, call `useErpAiKbCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKbCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKbCandidateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpAiKbCandidateQuery(baseOptions: Apollo.QueryHookOptions<ErpAiKbCandidateQuery, ErpAiKbCandidateQueryVariables>) {
        return Apollo.useQuery<ErpAiKbCandidateQuery, ErpAiKbCandidateQueryVariables>(ErpAiKbCandidateDocument, baseOptions);
      }
export function useErpAiKbCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKbCandidateQuery, ErpAiKbCandidateQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKbCandidateQuery, ErpAiKbCandidateQueryVariables>(ErpAiKbCandidateDocument, baseOptions);
        }
export type ErpAiKbCandidateQueryHookResult = ReturnType<typeof useErpAiKbCandidateQuery>;
export type ErpAiKbCandidateLazyQueryHookResult = ReturnType<typeof useErpAiKbCandidateLazyQuery>;
export type ErpAiKbCandidateQueryResult = Apollo.QueryResult<ErpAiKbCandidateQuery, ErpAiKbCandidateQueryVariables>;
export const ErpAiKbReviewerMeDocument = gql`
    query ErpAiKbReviewerMe {
  aiKbReviewerMe {
    isAdmin
    categories
    pendingCount
  }
}
    `;

/**
 * __useErpAiKbReviewerMeQuery__
 *
 * To run a query within a React component, call `useErpAiKbReviewerMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKbReviewerMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKbReviewerMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpAiKbReviewerMeQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiKbReviewerMeQuery, ErpAiKbReviewerMeQueryVariables>) {
        return Apollo.useQuery<ErpAiKbReviewerMeQuery, ErpAiKbReviewerMeQueryVariables>(ErpAiKbReviewerMeDocument, baseOptions);
      }
export function useErpAiKbReviewerMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKbReviewerMeQuery, ErpAiKbReviewerMeQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKbReviewerMeQuery, ErpAiKbReviewerMeQueryVariables>(ErpAiKbReviewerMeDocument, baseOptions);
        }
export type ErpAiKbReviewerMeQueryHookResult = ReturnType<typeof useErpAiKbReviewerMeQuery>;
export type ErpAiKbReviewerMeLazyQueryHookResult = ReturnType<typeof useErpAiKbReviewerMeLazyQuery>;
export type ErpAiKbReviewerMeQueryResult = Apollo.QueryResult<ErpAiKbReviewerMeQuery, ErpAiKbReviewerMeQueryVariables>;
export const ErpAiKbReviewersDocument = gql`
    query ErpAiKbReviewers {
  aiKbReviewers {
    category
    users {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useErpAiKbReviewersQuery__
 *
 * To run a query within a React component, call `useErpAiKbReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKbReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKbReviewersQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpAiKbReviewersQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiKbReviewersQuery, ErpAiKbReviewersQueryVariables>) {
        return Apollo.useQuery<ErpAiKbReviewersQuery, ErpAiKbReviewersQueryVariables>(ErpAiKbReviewersDocument, baseOptions);
      }
export function useErpAiKbReviewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKbReviewersQuery, ErpAiKbReviewersQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKbReviewersQuery, ErpAiKbReviewersQueryVariables>(ErpAiKbReviewersDocument, baseOptions);
        }
export type ErpAiKbReviewersQueryHookResult = ReturnType<typeof useErpAiKbReviewersQuery>;
export type ErpAiKbReviewersLazyQueryHookResult = ReturnType<typeof useErpAiKbReviewersLazyQuery>;
export type ErpAiKbReviewersQueryResult = Apollo.QueryResult<ErpAiKbReviewersQuery, ErpAiKbReviewersQueryVariables>;
export const ErpAiKbReviewerCandidatesDocument = gql`
    query ErpAiKbReviewerCandidates {
  aiKbReviewerCandidates {
    id
    name
    email
  }
}
    `;

/**
 * __useErpAiKbReviewerCandidatesQuery__
 *
 * To run a query within a React component, call `useErpAiKbReviewerCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKbReviewerCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKbReviewerCandidatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpAiKbReviewerCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiKbReviewerCandidatesQuery, ErpAiKbReviewerCandidatesQueryVariables>) {
        return Apollo.useQuery<ErpAiKbReviewerCandidatesQuery, ErpAiKbReviewerCandidatesQueryVariables>(ErpAiKbReviewerCandidatesDocument, baseOptions);
      }
export function useErpAiKbReviewerCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKbReviewerCandidatesQuery, ErpAiKbReviewerCandidatesQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKbReviewerCandidatesQuery, ErpAiKbReviewerCandidatesQueryVariables>(ErpAiKbReviewerCandidatesDocument, baseOptions);
        }
export type ErpAiKbReviewerCandidatesQueryHookResult = ReturnType<typeof useErpAiKbReviewerCandidatesQuery>;
export type ErpAiKbReviewerCandidatesLazyQueryHookResult = ReturnType<typeof useErpAiKbReviewerCandidatesLazyQuery>;
export type ErpAiKbReviewerCandidatesQueryResult = Apollo.QueryResult<ErpAiKbReviewerCandidatesQuery, ErpAiKbReviewerCandidatesQueryVariables>;
export const ErpAiKnowledgeRevisionsDocument = gql`
    query ErpAiKnowledgeRevisions($documentId: ID!) {
  aiKnowledgeRevisions(documentId: $documentId) {
    id
    version
    title
    category
    reason
    authorName
    candidateId
    body
    createdAt
  }
}
    `;

/**
 * __useErpAiKnowledgeRevisionsQuery__
 *
 * To run a query within a React component, call `useErpAiKnowledgeRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiKnowledgeRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiKnowledgeRevisionsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useErpAiKnowledgeRevisionsQuery(baseOptions: Apollo.QueryHookOptions<ErpAiKnowledgeRevisionsQuery, ErpAiKnowledgeRevisionsQueryVariables>) {
        return Apollo.useQuery<ErpAiKnowledgeRevisionsQuery, ErpAiKnowledgeRevisionsQueryVariables>(ErpAiKnowledgeRevisionsDocument, baseOptions);
      }
export function useErpAiKnowledgeRevisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiKnowledgeRevisionsQuery, ErpAiKnowledgeRevisionsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiKnowledgeRevisionsQuery, ErpAiKnowledgeRevisionsQueryVariables>(ErpAiKnowledgeRevisionsDocument, baseOptions);
        }
export type ErpAiKnowledgeRevisionsQueryHookResult = ReturnType<typeof useErpAiKnowledgeRevisionsQuery>;
export type ErpAiKnowledgeRevisionsLazyQueryHookResult = ReturnType<typeof useErpAiKnowledgeRevisionsLazyQuery>;
export type ErpAiKnowledgeRevisionsQueryResult = Apollo.QueryResult<ErpAiKnowledgeRevisionsQuery, ErpAiKnowledgeRevisionsQueryVariables>;
export const ErpAiReplyQualityWeeksDocument = gql`
    query ErpAiReplyQualityWeeks($weeks: Int) {
  aiReplyQuality(weeks: $weeks) {
    week
    weekStart
    computedAt
    total {
      channel
      topic
      created
      sent
      sentUnedited
      uneditedShare
      medianEditDistance
      rejected
      topRejectReasons {
        label
        count
      }
      topMissingInfo {
        label
        count
      }
      kbEmptyShare
      candidatesNew
      candidatesApproved
    }
    rows {
      channel
      topic
      created
      sent
      sentUnedited
      uneditedShare
      medianEditDistance
      rejected
      topRejectReasons {
        label
        count
      }
      topMissingInfo {
        label
        count
      }
      kbEmptyShare
      candidatesNew
      candidatesApproved
    }
  }
}
    `;

/**
 * __useErpAiReplyQualityWeeksQuery__
 *
 * To run a query within a React component, call `useErpAiReplyQualityWeeksQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiReplyQualityWeeksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiReplyQualityWeeksQuery({
 *   variables: {
 *      weeks: // value for 'weeks'
 *   },
 * });
 */
export function useErpAiReplyQualityWeeksQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiReplyQualityWeeksQuery, ErpAiReplyQualityWeeksQueryVariables>) {
        return Apollo.useQuery<ErpAiReplyQualityWeeksQuery, ErpAiReplyQualityWeeksQueryVariables>(ErpAiReplyQualityWeeksDocument, baseOptions);
      }
export function useErpAiReplyQualityWeeksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiReplyQualityWeeksQuery, ErpAiReplyQualityWeeksQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiReplyQualityWeeksQuery, ErpAiReplyQualityWeeksQueryVariables>(ErpAiReplyQualityWeeksDocument, baseOptions);
        }
export type ErpAiReplyQualityWeeksQueryHookResult = ReturnType<typeof useErpAiReplyQualityWeeksQuery>;
export type ErpAiReplyQualityWeeksLazyQueryHookResult = ReturnType<typeof useErpAiReplyQualityWeeksLazyQuery>;
export type ErpAiReplyQualityWeeksQueryResult = Apollo.QueryResult<ErpAiReplyQualityWeeksQuery, ErpAiReplyQualityWeeksQueryVariables>;
export const ErpAiLessonAnalysisDocument = gql`
    query ErpAiLessonAnalysis($lessonId: ID!) {
  aiLessonAnalysis(lessonId: $lessonId) {
    id
    lessonId
    groupId
    groupName
    courseId
    lessonNumber
    lessonStartsAt
    teacherName
    status
    lessonStatus
    overallScore
    understandingScore
    understandingBand
    summary
    strengths
    developmentArea
    criteria {
      id
      label
      weight
      status
      score
      confidence
      whyScore
      whyNotHigher
      nextLevel
    }
    recommendation {
      ruleId
      name
      action
      steps
      implementationCheck
      effectCheck
    }
    alerts
    reviewStatus
    reviewNote
    model
    createdAt
    error
    speakers {
      code
      label
      role
    }
  }
}
    `;

/**
 * __useErpAiLessonAnalysisQuery__
 *
 * To run a query within a React component, call `useErpAiLessonAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiLessonAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiLessonAnalysisQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useErpAiLessonAnalysisQuery(baseOptions: Apollo.QueryHookOptions<ErpAiLessonAnalysisQuery, ErpAiLessonAnalysisQueryVariables>) {
        return Apollo.useQuery<ErpAiLessonAnalysisQuery, ErpAiLessonAnalysisQueryVariables>(ErpAiLessonAnalysisDocument, baseOptions);
      }
export function useErpAiLessonAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiLessonAnalysisQuery, ErpAiLessonAnalysisQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiLessonAnalysisQuery, ErpAiLessonAnalysisQueryVariables>(ErpAiLessonAnalysisDocument, baseOptions);
        }
export type ErpAiLessonAnalysisQueryHookResult = ReturnType<typeof useErpAiLessonAnalysisQuery>;
export type ErpAiLessonAnalysisLazyQueryHookResult = ReturnType<typeof useErpAiLessonAnalysisLazyQuery>;
export type ErpAiLessonAnalysisQueryResult = Apollo.QueryResult<ErpAiLessonAnalysisQuery, ErpAiLessonAnalysisQueryVariables>;
export const ErpAiLessonAnalysesDocument = gql`
    query ErpAiLessonAnalyses($groupId: ID, $teacherId: ID, $courseId: ID, $reviewStatus: String, $offset: Int, $limit: Int) {
  aiLessonAnalyses(
    groupId: $groupId
    teacherId: $teacherId
    courseId: $courseId
    reviewStatus: $reviewStatus
    offset: $offset
    limit: $limit
  ) {
    total
    hasMore
    rows {
      id
      lessonId
      groupId
      groupName
      courseId
      lessonNumber
      lessonStartsAt
      teacherName
      status
      lessonStatus
      overallScore
      understandingScore
      understandingBand
      reviewStatus
      createdAt
      recommendation {
        ruleId
        name
        action
        steps
        implementationCheck
        effectCheck
      }
    }
  }
}
    `;

/**
 * __useErpAiLessonAnalysesQuery__
 *
 * To run a query within a React component, call `useErpAiLessonAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiLessonAnalysesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiLessonAnalysesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      teacherId: // value for 'teacherId'
 *      courseId: // value for 'courseId'
 *      reviewStatus: // value for 'reviewStatus'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useErpAiLessonAnalysesQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiLessonAnalysesQuery, ErpAiLessonAnalysesQueryVariables>) {
        return Apollo.useQuery<ErpAiLessonAnalysesQuery, ErpAiLessonAnalysesQueryVariables>(ErpAiLessonAnalysesDocument, baseOptions);
      }
export function useErpAiLessonAnalysesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiLessonAnalysesQuery, ErpAiLessonAnalysesQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiLessonAnalysesQuery, ErpAiLessonAnalysesQueryVariables>(ErpAiLessonAnalysesDocument, baseOptions);
        }
export type ErpAiLessonAnalysesQueryHookResult = ReturnType<typeof useErpAiLessonAnalysesQuery>;
export type ErpAiLessonAnalysesLazyQueryHookResult = ReturnType<typeof useErpAiLessonAnalysesLazyQuery>;
export type ErpAiLessonAnalysesQueryResult = Apollo.QueryResult<ErpAiLessonAnalysesQuery, ErpAiLessonAnalysesQueryVariables>;
export const ErpAiTeacherPracticePortraitDocument = gql`
    query ErpAiTeacherPracticePortrait($teacherId: ID!) {
  aiTeacherPracticePortrait(teacherId: $teacherId) {
    teacherId
    lessonsAnalyzed
    maturity
    criteria {
      id
      label
      n
      median
      q1
      q3
      coverage
      trend
    }
    narrative
    generatedAt
    narrativeGeneratedAt
    narrativeAnalysesCount
    narrativeStatus
    narrativeError
    narrativeMinAnalyses
  }
}
    `;

/**
 * __useErpAiTeacherPracticePortraitQuery__
 *
 * To run a query within a React component, call `useErpAiTeacherPracticePortraitQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiTeacherPracticePortraitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiTeacherPracticePortraitQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useErpAiTeacherPracticePortraitQuery(baseOptions: Apollo.QueryHookOptions<ErpAiTeacherPracticePortraitQuery, ErpAiTeacherPracticePortraitQueryVariables>) {
        return Apollo.useQuery<ErpAiTeacherPracticePortraitQuery, ErpAiTeacherPracticePortraitQueryVariables>(ErpAiTeacherPracticePortraitDocument, baseOptions);
      }
export function useErpAiTeacherPracticePortraitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiTeacherPracticePortraitQuery, ErpAiTeacherPracticePortraitQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiTeacherPracticePortraitQuery, ErpAiTeacherPracticePortraitQueryVariables>(ErpAiTeacherPracticePortraitDocument, baseOptions);
        }
export type ErpAiTeacherPracticePortraitQueryHookResult = ReturnType<typeof useErpAiTeacherPracticePortraitQuery>;
export type ErpAiTeacherPracticePortraitLazyQueryHookResult = ReturnType<typeof useErpAiTeacherPracticePortraitLazyQuery>;
export type ErpAiTeacherPracticePortraitQueryResult = Apollo.QueryResult<ErpAiTeacherPracticePortraitQuery, ErpAiTeacherPracticePortraitQueryVariables>;
export const ErpAiCourseLessonComparisonDocument = gql`
    query ErpAiCourseLessonComparison($courseId: ID!, $lessonNumber: Int!) {
  aiCourseLessonComparison(courseId: $courseId, lessonNumber: $lessonNumber) {
    courseId
    lessonNumber
    rows {
      groupId
      groupName
      lessonId
      lessonStartsAt
      teacherName
      overallScore
      recommendationRule
      criteria
    }
  }
}
    `;

/**
 * __useErpAiCourseLessonComparisonQuery__
 *
 * To run a query within a React component, call `useErpAiCourseLessonComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiCourseLessonComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiCourseLessonComparisonQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      lessonNumber: // value for 'lessonNumber'
 *   },
 * });
 */
export function useErpAiCourseLessonComparisonQuery(baseOptions: Apollo.QueryHookOptions<ErpAiCourseLessonComparisonQuery, ErpAiCourseLessonComparisonQueryVariables>) {
        return Apollo.useQuery<ErpAiCourseLessonComparisonQuery, ErpAiCourseLessonComparisonQueryVariables>(ErpAiCourseLessonComparisonDocument, baseOptions);
      }
export function useErpAiCourseLessonComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiCourseLessonComparisonQuery, ErpAiCourseLessonComparisonQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiCourseLessonComparisonQuery, ErpAiCourseLessonComparisonQueryVariables>(ErpAiCourseLessonComparisonDocument, baseOptions);
        }
export type ErpAiCourseLessonComparisonQueryHookResult = ReturnType<typeof useErpAiCourseLessonComparisonQuery>;
export type ErpAiCourseLessonComparisonLazyQueryHookResult = ReturnType<typeof useErpAiCourseLessonComparisonLazyQuery>;
export type ErpAiCourseLessonComparisonQueryResult = Apollo.QueryResult<ErpAiCourseLessonComparisonQuery, ErpAiCourseLessonComparisonQueryVariables>;
export const ErpAiLessonBatchEstimateDocument = gql`
    query ErpAiLessonBatchEstimate($lessonIds: [ID!]!) {
  estimateAiLessonAnalyses(lessonIds: $lessonIds) {
    lessons
    withTranscript
    withoutTranscript
    alreadyAnalyzed
    running
    toAnalyze
    transcriptBytes
    unknownSize
    estimatedCostUsd
    inFlightCostUsd
    costBasis
    budgetSpentUsd
    budgetLimitUsd
    budgetLeftUsd
    budgetEnough
  }
}
    `;

/**
 * __useErpAiLessonBatchEstimateQuery__
 *
 * To run a query within a React component, call `useErpAiLessonBatchEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiLessonBatchEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiLessonBatchEstimateQuery({
 *   variables: {
 *      lessonIds: // value for 'lessonIds'
 *   },
 * });
 */
export function useErpAiLessonBatchEstimateQuery(baseOptions: Apollo.QueryHookOptions<ErpAiLessonBatchEstimateQuery, ErpAiLessonBatchEstimateQueryVariables>) {
        return Apollo.useQuery<ErpAiLessonBatchEstimateQuery, ErpAiLessonBatchEstimateQueryVariables>(ErpAiLessonBatchEstimateDocument, baseOptions);
      }
export function useErpAiLessonBatchEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiLessonBatchEstimateQuery, ErpAiLessonBatchEstimateQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiLessonBatchEstimateQuery, ErpAiLessonBatchEstimateQueryVariables>(ErpAiLessonBatchEstimateDocument, baseOptions);
        }
export type ErpAiLessonBatchEstimateQueryHookResult = ReturnType<typeof useErpAiLessonBatchEstimateQuery>;
export type ErpAiLessonBatchEstimateLazyQueryHookResult = ReturnType<typeof useErpAiLessonBatchEstimateLazyQuery>;
export type ErpAiLessonBatchEstimateQueryResult = Apollo.QueryResult<ErpAiLessonBatchEstimateQuery, ErpAiLessonBatchEstimateQueryVariables>;
export const ErpLessonWindowDocument = gql`
    query ErpLessonWindow($lessonId: ID!) {
  aiLessonView(lessonId: $lessonId) {
    lessonId
    name
    lessonNumber
    startsAt
    endsAt
    isOver
    groupId
    groupName
    courseId
    teacherName
    hasTranscript
    recordingStatus
    videoUrl
    aiSummary
    aiTimecodes
    surveys {
      assignmentId
      surveyId
      surveyTitle
      isActive
      responsesCount
      eligibleCount
      questions {
        questionId
        question
        questionType
        answersCount
        average
      }
      comments {
        questionId
        question
        text
        submittedAt
      }
    }
  }
}
    `;

/**
 * __useErpLessonWindowQuery__
 *
 * To run a query within a React component, call `useErpLessonWindowQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpLessonWindowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpLessonWindowQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useErpLessonWindowQuery(baseOptions: Apollo.QueryHookOptions<ErpLessonWindowQuery, ErpLessonWindowQueryVariables>) {
        return Apollo.useQuery<ErpLessonWindowQuery, ErpLessonWindowQueryVariables>(ErpLessonWindowDocument, baseOptions);
      }
export function useErpLessonWindowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpLessonWindowQuery, ErpLessonWindowQueryVariables>) {
          return Apollo.useLazyQuery<ErpLessonWindowQuery, ErpLessonWindowQueryVariables>(ErpLessonWindowDocument, baseOptions);
        }
export type ErpLessonWindowQueryHookResult = ReturnType<typeof useErpLessonWindowQuery>;
export type ErpLessonWindowLazyQueryHookResult = ReturnType<typeof useErpLessonWindowLazyQuery>;
export type ErpLessonWindowQueryResult = Apollo.QueryResult<ErpLessonWindowQuery, ErpLessonWindowQueryVariables>;
export const ErpAiLessonLaunchAvailabilityDocument = gql`
    query ErpAiLessonLaunchAvailability {
  aiLessonLaunchEnabled
}
    `;

/**
 * __useErpAiLessonLaunchAvailabilityQuery__
 *
 * To run a query within a React component, call `useErpAiLessonLaunchAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiLessonLaunchAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiLessonLaunchAvailabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpAiLessonLaunchAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiLessonLaunchAvailabilityQuery, ErpAiLessonLaunchAvailabilityQueryVariables>) {
        return Apollo.useQuery<ErpAiLessonLaunchAvailabilityQuery, ErpAiLessonLaunchAvailabilityQueryVariables>(ErpAiLessonLaunchAvailabilityDocument, baseOptions);
      }
export function useErpAiLessonLaunchAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiLessonLaunchAvailabilityQuery, ErpAiLessonLaunchAvailabilityQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiLessonLaunchAvailabilityQuery, ErpAiLessonLaunchAvailabilityQueryVariables>(ErpAiLessonLaunchAvailabilityDocument, baseOptions);
        }
export type ErpAiLessonLaunchAvailabilityQueryHookResult = ReturnType<typeof useErpAiLessonLaunchAvailabilityQuery>;
export type ErpAiLessonLaunchAvailabilityLazyQueryHookResult = ReturnType<typeof useErpAiLessonLaunchAvailabilityLazyQuery>;
export type ErpAiLessonLaunchAvailabilityQueryResult = Apollo.QueryResult<ErpAiLessonLaunchAvailabilityQuery, ErpAiLessonLaunchAvailabilityQueryVariables>;
export const ErpAiStudentPortraitDocument = gql`
    query ErpAiStudentPortrait($studentId: ID!) {
  aiStudentPortrait(studentId: $studentId) {
    studentId
    status
    stale
    generatedAt
    model
    error
    summary
    learning
    engagement
    sentimentTrend
    communication
    risks {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    openNeeds {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    nextActions {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    about {
      key
      label
      value
    }
    strengths {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    concerns {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
    checkpoints {
      key
      status
      text
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
  }
}
    `;

/**
 * __useErpAiStudentPortraitQuery__
 *
 * To run a query within a React component, call `useErpAiStudentPortraitQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiStudentPortraitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiStudentPortraitQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useErpAiStudentPortraitQuery(baseOptions: Apollo.QueryHookOptions<ErpAiStudentPortraitQuery, ErpAiStudentPortraitQueryVariables>) {
        return Apollo.useQuery<ErpAiStudentPortraitQuery, ErpAiStudentPortraitQueryVariables>(ErpAiStudentPortraitDocument, baseOptions);
      }
export function useErpAiStudentPortraitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiStudentPortraitQuery, ErpAiStudentPortraitQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiStudentPortraitQuery, ErpAiStudentPortraitQueryVariables>(ErpAiStudentPortraitDocument, baseOptions);
        }
export type ErpAiStudentPortraitQueryHookResult = ReturnType<typeof useErpAiStudentPortraitQuery>;
export type ErpAiStudentPortraitLazyQueryHookResult = ReturnType<typeof useErpAiStudentPortraitLazyQuery>;
export type ErpAiStudentPortraitQueryResult = Apollo.QueryResult<ErpAiStudentPortraitQuery, ErpAiStudentPortraitQueryVariables>;
export const ErpAiStudentFinancePortraitDocument = gql`
    query ErpAiStudentFinancePortrait($studentId: ID!) {
  aiStudentFinancePortrait(studentId: $studentId) {
    studentId
    status
    generatedAt
    summary
    items {
      text
      severity
      evidence {
        kind
        id
        label
        at
        leadId
      }
    }
  }
}
    `;

/**
 * __useErpAiStudentFinancePortraitQuery__
 *
 * To run a query within a React component, call `useErpAiStudentFinancePortraitQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiStudentFinancePortraitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiStudentFinancePortraitQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useErpAiStudentFinancePortraitQuery(baseOptions: Apollo.QueryHookOptions<ErpAiStudentFinancePortraitQuery, ErpAiStudentFinancePortraitQueryVariables>) {
        return Apollo.useQuery<ErpAiStudentFinancePortraitQuery, ErpAiStudentFinancePortraitQueryVariables>(ErpAiStudentFinancePortraitDocument, baseOptions);
      }
export function useErpAiStudentFinancePortraitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiStudentFinancePortraitQuery, ErpAiStudentFinancePortraitQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiStudentFinancePortraitQuery, ErpAiStudentFinancePortraitQueryVariables>(ErpAiStudentFinancePortraitDocument, baseOptions);
        }
export type ErpAiStudentFinancePortraitQueryHookResult = ReturnType<typeof useErpAiStudentFinancePortraitQuery>;
export type ErpAiStudentFinancePortraitLazyQueryHookResult = ReturnType<typeof useErpAiStudentFinancePortraitLazyQuery>;
export type ErpAiStudentFinancePortraitQueryResult = Apollo.QueryResult<ErpAiStudentFinancePortraitQuery, ErpAiStudentFinancePortraitQueryVariables>;
export const ErpAiReplySuggestionDocument = gql`
    query ErpAiReplySuggestion($conversationId: ID!) {
  aiReplySuggestion(conversationId: $conversationId) {
    id
    conversationId
    forMessageId
    status
    topic
    language
    text
    html
    confidence
    citations {
      kind
      ref
      label
    }
    missingInfo
    error
    financeHidden
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useErpAiReplySuggestionQuery__
 *
 * To run a query within a React component, call `useErpAiReplySuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiReplySuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiReplySuggestionQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useErpAiReplySuggestionQuery(baseOptions: Apollo.QueryHookOptions<ErpAiReplySuggestionQuery, ErpAiReplySuggestionQueryVariables>) {
        return Apollo.useQuery<ErpAiReplySuggestionQuery, ErpAiReplySuggestionQueryVariables>(ErpAiReplySuggestionDocument, baseOptions);
      }
export function useErpAiReplySuggestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiReplySuggestionQuery, ErpAiReplySuggestionQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiReplySuggestionQuery, ErpAiReplySuggestionQueryVariables>(ErpAiReplySuggestionDocument, baseOptions);
        }
export type ErpAiReplySuggestionQueryHookResult = ReturnType<typeof useErpAiReplySuggestionQuery>;
export type ErpAiReplySuggestionLazyQueryHookResult = ReturnType<typeof useErpAiReplySuggestionLazyQuery>;
export type ErpAiReplySuggestionQueryResult = Apollo.QueryResult<ErpAiReplySuggestionQuery, ErpAiReplySuggestionQueryVariables>;
export const ErpAiChatToolCatalogDocument = gql`
    query ErpAiChatToolCatalog {
  aiChatToolCatalog {
    name
    group
    kind
    description
    enabled
    defaultEnabled
  }
}
    `;

/**
 * __useErpAiChatToolCatalogQuery__
 *
 * To run a query within a React component, call `useErpAiChatToolCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiChatToolCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiChatToolCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpAiChatToolCatalogQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiChatToolCatalogQuery, ErpAiChatToolCatalogQueryVariables>) {
        return Apollo.useQuery<ErpAiChatToolCatalogQuery, ErpAiChatToolCatalogQueryVariables>(ErpAiChatToolCatalogDocument, baseOptions);
      }
export function useErpAiChatToolCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiChatToolCatalogQuery, ErpAiChatToolCatalogQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiChatToolCatalogQuery, ErpAiChatToolCatalogQueryVariables>(ErpAiChatToolCatalogDocument, baseOptions);
        }
export type ErpAiChatToolCatalogQueryHookResult = ReturnType<typeof useErpAiChatToolCatalogQuery>;
export type ErpAiChatToolCatalogLazyQueryHookResult = ReturnType<typeof useErpAiChatToolCatalogLazyQuery>;
export type ErpAiChatToolCatalogQueryResult = Apollo.QueryResult<ErpAiChatToolCatalogQuery, ErpAiChatToolCatalogQueryVariables>;
export const ErpAiSkillsDocument = gql`
    query ErpAiSkills($status: String) {
  aiSkills(status: $status) {
    id
    slug
    title
    description
    status
    source
    version
    agents
    files {
      path
      size
    }
    pluginId
    pluginName
    updatedAt
    createdByName
  }
}
    `;

/**
 * __useErpAiSkillsQuery__
 *
 * To run a query within a React component, call `useErpAiSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiSkillsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useErpAiSkillsQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiSkillsQuery, ErpAiSkillsQueryVariables>) {
        return Apollo.useQuery<ErpAiSkillsQuery, ErpAiSkillsQueryVariables>(ErpAiSkillsDocument, baseOptions);
      }
export function useErpAiSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiSkillsQuery, ErpAiSkillsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiSkillsQuery, ErpAiSkillsQueryVariables>(ErpAiSkillsDocument, baseOptions);
        }
export type ErpAiSkillsQueryHookResult = ReturnType<typeof useErpAiSkillsQuery>;
export type ErpAiSkillsLazyQueryHookResult = ReturnType<typeof useErpAiSkillsLazyQuery>;
export type ErpAiSkillsQueryResult = Apollo.QueryResult<ErpAiSkillsQuery, ErpAiSkillsQueryVariables>;
export const ErpAiSkillDocument = gql`
    query ErpAiSkill($id: ID!) {
  aiSkill(id: $id) {
    id
    slug
    title
    description
    instructions
    status
    source
    version
    agents
    files {
      path
      size
    }
    pluginId
    pluginName
    updatedAt
    createdByName
    skipped
  }
}
    `;

/**
 * __useErpAiSkillQuery__
 *
 * To run a query within a React component, call `useErpAiSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiSkillQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpAiSkillQuery(baseOptions: Apollo.QueryHookOptions<ErpAiSkillQuery, ErpAiSkillQueryVariables>) {
        return Apollo.useQuery<ErpAiSkillQuery, ErpAiSkillQueryVariables>(ErpAiSkillDocument, baseOptions);
      }
export function useErpAiSkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiSkillQuery, ErpAiSkillQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiSkillQuery, ErpAiSkillQueryVariables>(ErpAiSkillDocument, baseOptions);
        }
export type ErpAiSkillQueryHookResult = ReturnType<typeof useErpAiSkillQuery>;
export type ErpAiSkillLazyQueryHookResult = ReturnType<typeof useErpAiSkillLazyQuery>;
export type ErpAiSkillQueryResult = Apollo.QueryResult<ErpAiSkillQuery, ErpAiSkillQueryVariables>;
export const ErpAiMcpConnectionsDocument = gql`
    query ErpAiMcpConnections {
  aiMcpConnections {
    id
    slug
    title
    url
    transport
    authType
    headerName
    hasSecret
    oauthConnected
    oauthExpiresAt
    allowPii
    enabled
    status
    lastCheckedAt
    lastError
    serverName
    serverVersion
    tools {
      name
      description
      inputSchema
      enabled
      requiresApproval
      missing
      changed
      unsupportedReason
    }
    pluginId
    pluginName
    note
    notes {
      code
      params
    }
  }
}
    `;

/**
 * __useErpAiMcpConnectionsQuery__
 *
 * To run a query within a React component, call `useErpAiMcpConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiMcpConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiMcpConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpAiMcpConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiMcpConnectionsQuery, ErpAiMcpConnectionsQueryVariables>) {
        return Apollo.useQuery<ErpAiMcpConnectionsQuery, ErpAiMcpConnectionsQueryVariables>(ErpAiMcpConnectionsDocument, baseOptions);
      }
export function useErpAiMcpConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiMcpConnectionsQuery, ErpAiMcpConnectionsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiMcpConnectionsQuery, ErpAiMcpConnectionsQueryVariables>(ErpAiMcpConnectionsDocument, baseOptions);
        }
export type ErpAiMcpConnectionsQueryHookResult = ReturnType<typeof useErpAiMcpConnectionsQuery>;
export type ErpAiMcpConnectionsLazyQueryHookResult = ReturnType<typeof useErpAiMcpConnectionsLazyQuery>;
export type ErpAiMcpConnectionsQueryResult = Apollo.QueryResult<ErpAiMcpConnectionsQuery, ErpAiMcpConnectionsQueryVariables>;
export const ErpAiMcpConnectionDocument = gql`
    query ErpAiMcpConnection($id: ID!) {
  aiMcpConnection(id: $id) {
    id
    slug
    title
    url
    transport
    authType
    headerName
    hasSecret
    oauthConnected
    oauthExpiresAt
    allowPii
    enabled
    status
    lastCheckedAt
    lastError
    serverName
    serverVersion
    tools {
      name
      description
      inputSchema
      enabled
      requiresApproval
      missing
      changed
      unsupportedReason
    }
    pluginId
    pluginName
    note
    notes {
      code
      params
    }
  }
}
    `;

/**
 * __useErpAiMcpConnectionQuery__
 *
 * To run a query within a React component, call `useErpAiMcpConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiMcpConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiMcpConnectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpAiMcpConnectionQuery(baseOptions: Apollo.QueryHookOptions<ErpAiMcpConnectionQuery, ErpAiMcpConnectionQueryVariables>) {
        return Apollo.useQuery<ErpAiMcpConnectionQuery, ErpAiMcpConnectionQueryVariables>(ErpAiMcpConnectionDocument, baseOptions);
      }
export function useErpAiMcpConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiMcpConnectionQuery, ErpAiMcpConnectionQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiMcpConnectionQuery, ErpAiMcpConnectionQueryVariables>(ErpAiMcpConnectionDocument, baseOptions);
        }
export type ErpAiMcpConnectionQueryHookResult = ReturnType<typeof useErpAiMcpConnectionQuery>;
export type ErpAiMcpConnectionLazyQueryHookResult = ReturnType<typeof useErpAiMcpConnectionLazyQuery>;
export type ErpAiMcpConnectionQueryResult = Apollo.QueryResult<ErpAiMcpConnectionQuery, ErpAiMcpConnectionQueryVariables>;
export const ErpAiPluginsDocument = gql`
    query ErpAiPlugins {
  aiPlugins {
    id
    name
    version
    description
    enabled
    skipped
    skippedItems {
      code
      params
    }
    createdAt
    skills {
      id
      slug
      title
      status
      source
      version
    }
    connections {
      id
      slug
      title
      url
      authType
      hasSecret
      oauthConnected
      enabled
      status
      note
    }
  }
}
    `;

/**
 * __useErpAiPluginsQuery__
 *
 * To run a query within a React component, call `useErpAiPluginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpAiPluginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpAiPluginsQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpAiPluginsQuery(baseOptions?: Apollo.QueryHookOptions<ErpAiPluginsQuery, ErpAiPluginsQueryVariables>) {
        return Apollo.useQuery<ErpAiPluginsQuery, ErpAiPluginsQueryVariables>(ErpAiPluginsDocument, baseOptions);
      }
export function useErpAiPluginsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpAiPluginsQuery, ErpAiPluginsQueryVariables>) {
          return Apollo.useLazyQuery<ErpAiPluginsQuery, ErpAiPluginsQueryVariables>(ErpAiPluginsDocument, baseOptions);
        }
export type ErpAiPluginsQueryHookResult = ReturnType<typeof useErpAiPluginsQuery>;
export type ErpAiPluginsLazyQueryHookResult = ReturnType<typeof useErpAiPluginsLazyQuery>;
export type ErpAiPluginsQueryResult = Apollo.QueryResult<ErpAiPluginsQuery, ErpAiPluginsQueryVariables>;
export const PaginatedTeachersApplicationsDocument = gql`
    query PaginatedTeachersApplications($query: String, $before: String, $after: String, $first: Int, $last: Int) {
  allTeachersApplications(
    query: $query
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        title
        lessonsCount
        servicePrice
        currency
        isTerminated
        isCompleted
        appointedLessonsCount
        teacher {
          fullName
        }
        group {
          name
        }
        employmentType {
          __typename
        }
      }
    }
  }
}
    `;

/**
 * __usePaginatedTeachersApplicationsQuery__
 *
 * To run a query within a React component, call `usePaginatedTeachersApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedTeachersApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedTeachersApplicationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePaginatedTeachersApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedTeachersApplicationsQuery, PaginatedTeachersApplicationsQueryVariables>) {
        return Apollo.useQuery<PaginatedTeachersApplicationsQuery, PaginatedTeachersApplicationsQueryVariables>(PaginatedTeachersApplicationsDocument, baseOptions);
      }
export function usePaginatedTeachersApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedTeachersApplicationsQuery, PaginatedTeachersApplicationsQueryVariables>) {
          return Apollo.useLazyQuery<PaginatedTeachersApplicationsQuery, PaginatedTeachersApplicationsQueryVariables>(PaginatedTeachersApplicationsDocument, baseOptions);
        }
export type PaginatedTeachersApplicationsQueryHookResult = ReturnType<typeof usePaginatedTeachersApplicationsQuery>;
export type PaginatedTeachersApplicationsLazyQueryHookResult = ReturnType<typeof usePaginatedTeachersApplicationsLazyQuery>;
export type PaginatedTeachersApplicationsQueryResult = Apollo.QueryResult<PaginatedTeachersApplicationsQuery, PaginatedTeachersApplicationsQueryVariables>;
export const GetApplicationsForGroupDocument = gql`
    query getApplicationsForGroup($byGroupId: Decimal, $isTerminated: Boolean, $groupsFilter: Boolean) {
  allTeachersApplications(
    byGroupId: $byGroupId
    isTerminated: $isTerminated
    groupsFilter: $groupsFilter
  ) {
    edges {
      node {
        id
        title
        lessonsCount
        appointedLessonsCount
        teacher {
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetApplicationsForGroupQuery__
 *
 * To run a query within a React component, call `useGetApplicationsForGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsForGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationsForGroupQuery({
 *   variables: {
 *      byGroupId: // value for 'byGroupId'
 *      isTerminated: // value for 'isTerminated'
 *      groupsFilter: // value for 'groupsFilter'
 *   },
 * });
 */
export function useGetApplicationsForGroupQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationsForGroupQuery, GetApplicationsForGroupQueryVariables>) {
        return Apollo.useQuery<GetApplicationsForGroupQuery, GetApplicationsForGroupQueryVariables>(GetApplicationsForGroupDocument, baseOptions);
      }
export function useGetApplicationsForGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationsForGroupQuery, GetApplicationsForGroupQueryVariables>) {
          return Apollo.useLazyQuery<GetApplicationsForGroupQuery, GetApplicationsForGroupQueryVariables>(GetApplicationsForGroupDocument, baseOptions);
        }
export type GetApplicationsForGroupQueryHookResult = ReturnType<typeof useGetApplicationsForGroupQuery>;
export type GetApplicationsForGroupLazyQueryHookResult = ReturnType<typeof useGetApplicationsForGroupLazyQuery>;
export type GetApplicationsForGroupQueryResult = Apollo.QueryResult<GetApplicationsForGroupQuery, GetApplicationsForGroupQueryVariables>;
export const LoadEditingApplicationDocument = gql`
    query loadEditingApplication($applicationId: ID!, $first: Int, $orderBy: String) {
  teacherApplication(applicationId: $applicationId) {
    id
    title
    date
    lessonsCount
    servicePrice
    riaPrice
    currency
    comment
    isTerminated
    lastLessonDate
    isCompleted
    deleteAvailable
    appointedLessonsCount
    rateUnit
    rateIsGross
    billingEntity {
      id
    }
    country {
      id
      title
    }
    teacher {
      id
      fullName
      employmentTypes {
        __typename
      }
    }
    group {
      id
      name
      freeLessonsCount
      startDate
      course {
        id
        name
      }
    }
    lessons(first: $first, orderBy: $orderBy) {
      edges {
        node {
          date
        }
      }
    }
    employmentType {
      __typename
    }
  }
}
    `;

/**
 * __useLoadEditingApplicationQuery__
 *
 * To run a query within a React component, call `useLoadEditingApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadEditingApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadEditingApplicationQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLoadEditingApplicationQuery(baseOptions: Apollo.QueryHookOptions<LoadEditingApplicationQuery, LoadEditingApplicationQueryVariables>) {
        return Apollo.useQuery<LoadEditingApplicationQuery, LoadEditingApplicationQueryVariables>(LoadEditingApplicationDocument, baseOptions);
      }
export function useLoadEditingApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadEditingApplicationQuery, LoadEditingApplicationQueryVariables>) {
          return Apollo.useLazyQuery<LoadEditingApplicationQuery, LoadEditingApplicationQueryVariables>(LoadEditingApplicationDocument, baseOptions);
        }
export type LoadEditingApplicationQueryHookResult = ReturnType<typeof useLoadEditingApplicationQuery>;
export type LoadEditingApplicationLazyQueryHookResult = ReturnType<typeof useLoadEditingApplicationLazyQuery>;
export type LoadEditingApplicationQueryResult = Apollo.QueryResult<LoadEditingApplicationQuery, LoadEditingApplicationQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const ErpCareerMembersDocument = gql`
    query ErpCareerMembers($status: String, $directionId: ID, $search: String) {
  careerMembers(status: $status, directionId: $directionId, search: $search) {
    id
    studentId
    studentName
    studentEmail
    groupId
    groupName
    directionId
    directionTitle
    status
    enrolledAt
    notes
    lessonsCompleted
    lessonsTotal
  }
}
    `;

/**
 * __useErpCareerMembersQuery__
 *
 * To run a query within a React component, call `useErpCareerMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerMembersQuery({
 *   variables: {
 *      status: // value for 'status'
 *      directionId: // value for 'directionId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpCareerMembersQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerMembersQuery, ErpCareerMembersQueryVariables>) {
        return Apollo.useQuery<ErpCareerMembersQuery, ErpCareerMembersQueryVariables>(ErpCareerMembersDocument, baseOptions);
      }
export function useErpCareerMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerMembersQuery, ErpCareerMembersQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerMembersQuery, ErpCareerMembersQueryVariables>(ErpCareerMembersDocument, baseOptions);
        }
export type ErpCareerMembersQueryHookResult = ReturnType<typeof useErpCareerMembersQuery>;
export type ErpCareerMembersLazyQueryHookResult = ReturnType<typeof useErpCareerMembersLazyQuery>;
export type ErpCareerMembersQueryResult = Apollo.QueryResult<ErpCareerMembersQuery, ErpCareerMembersQueryVariables>;
export const ErpCareerMemberDetailDocument = gql`
    query ErpCareerMemberDetail($id: ID!) {
  careerMemberDetail(id: $id) {
    id
    growth {
      xp
      level
      levelTitle
      medalsEarned
      medalsTotal
      trackTitle
      trackIsDefault
      nextCourses {
        courseId
        courseName
        courseUrl
        adds
        covered
        totalMissing
      }
      codes {
        id
        code
        status
        expiresAt
        campaignTitle
        discountKind
        discountValue
        currency
      }
    }
    studentName
    studentEmail
    profile {
      id
      firstName
      lastName
      email
      phone
      photoUrl
      city
      country
      relocationReady
      workMode
      workPermit
      availableFrom
      seniority
      desiredPosition
      desiredSalary
      githubUrl
      linkedinUrl
      portfolioUrl
      customSkills
      isSearchable
      contactsVisible
      completeness
      skills {
        skillId
        name
        category
        level
        years
      }
      projects {
        id
        title
        description
        role
        repoUrl
        demoUrl
        technologyNames
      }
      experience {
        id
        company
        position
        description
        startYear
        startMonth
        endYear
        endMonth
        isCurrent
      }
      education {
        id
        institution
        degree
        specialization
        startYear
        startMonth
        endYear
        endMonth
      }
      languages {
        id
        language
        level
      }
      certificates {
        id
        title
        issuer
        issuedAt
        url
        fileUrl
      }
      locales {
        language
        jobTitle
        about
      }
    }
  }
}
    `;

/**
 * __useErpCareerMemberDetailQuery__
 *
 * To run a query within a React component, call `useErpCareerMemberDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerMemberDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerMemberDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpCareerMemberDetailQuery(baseOptions: Apollo.QueryHookOptions<ErpCareerMemberDetailQuery, ErpCareerMemberDetailQueryVariables>) {
        return Apollo.useQuery<ErpCareerMemberDetailQuery, ErpCareerMemberDetailQueryVariables>(ErpCareerMemberDetailDocument, baseOptions);
      }
export function useErpCareerMemberDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerMemberDetailQuery, ErpCareerMemberDetailQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerMemberDetailQuery, ErpCareerMemberDetailQueryVariables>(ErpCareerMemberDetailDocument, baseOptions);
        }
export type ErpCareerMemberDetailQueryHookResult = ReturnType<typeof useErpCareerMemberDetailQuery>;
export type ErpCareerMemberDetailLazyQueryHookResult = ReturnType<typeof useErpCareerMemberDetailLazyQuery>;
export type ErpCareerMemberDetailQueryResult = Apollo.QueryResult<ErpCareerMemberDetailQuery, ErpCareerMemberDetailQueryVariables>;
export const ErpCareerDirectionsDocument = gql`
    query ErpCareerDirections($includeInactive: Boolean) {
  careerDirections(includeInactive: $includeInactive) {
    id
    slug
    title
    order
    isActive
  }
}
    `;

/**
 * __useErpCareerDirectionsQuery__
 *
 * To run a query within a React component, call `useErpCareerDirectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerDirectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerDirectionsQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useErpCareerDirectionsQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerDirectionsQuery, ErpCareerDirectionsQueryVariables>) {
        return Apollo.useQuery<ErpCareerDirectionsQuery, ErpCareerDirectionsQueryVariables>(ErpCareerDirectionsDocument, baseOptions);
      }
export function useErpCareerDirectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerDirectionsQuery, ErpCareerDirectionsQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerDirectionsQuery, ErpCareerDirectionsQueryVariables>(ErpCareerDirectionsDocument, baseOptions);
        }
export type ErpCareerDirectionsQueryHookResult = ReturnType<typeof useErpCareerDirectionsQuery>;
export type ErpCareerDirectionsLazyQueryHookResult = ReturnType<typeof useErpCareerDirectionsLazyQuery>;
export type ErpCareerDirectionsQueryResult = Apollo.QueryResult<ErpCareerDirectionsQuery, ErpCareerDirectionsQueryVariables>;
export const ErpCareerLessonsDocument = gql`
    query ErpCareerLessons {
  careerLessonsErp {
    id
    order
    title
    summary
    content
    durationMin
    completionKind
    artifactHint
    outcomeKind
    outcomeLabel
    materialLanguage
    isPublished
    videoUrl
    attachments {
      id
      originalName
      contentType
      sizeBytes
      url
    }
    stats {
      openedCount
      completedCount
      membersTotal
    }
    quizQuestions {
      id
      order
      text
      options
      correctIndexes
    }
    exercise {
      id
      intro
      outro
      templateId
      templateTitle
      hasSubmissions
      fields {
        id
        number
        label
        helpText
        placeholder
        fieldType
        required
        options
        maxLength
        binding
        bindingLanguage
      }
    }
  }
}
    `;

/**
 * __useErpCareerLessonsQuery__
 *
 * To run a query within a React component, call `useErpCareerLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpCareerLessonsQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerLessonsQuery, ErpCareerLessonsQueryVariables>) {
        return Apollo.useQuery<ErpCareerLessonsQuery, ErpCareerLessonsQueryVariables>(ErpCareerLessonsDocument, baseOptions);
      }
export function useErpCareerLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerLessonsQuery, ErpCareerLessonsQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerLessonsQuery, ErpCareerLessonsQueryVariables>(ErpCareerLessonsDocument, baseOptions);
        }
export type ErpCareerLessonsQueryHookResult = ReturnType<typeof useErpCareerLessonsQuery>;
export type ErpCareerLessonsLazyQueryHookResult = ReturnType<typeof useErpCareerLessonsLazyQuery>;
export type ErpCareerLessonsQueryResult = Apollo.QueryResult<ErpCareerLessonsQuery, ErpCareerLessonsQueryVariables>;
export const CareerMemberLearningProgressDocument = gql`
    query CareerMemberLearningProgress($memberId: ID!) {
  careerMemberProgress(memberId: $memberId) {
    lessonId
    order
    title
    isOpened
    openedAt
    openCount
    isCompleted
    completedAt
  }
}
    `;

/**
 * __useCareerMemberLearningProgressQuery__
 *
 * To run a query within a React component, call `useCareerMemberLearningProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerMemberLearningProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerMemberLearningProgressQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCareerMemberLearningProgressQuery(baseOptions: Apollo.QueryHookOptions<CareerMemberLearningProgressQuery, CareerMemberLearningProgressQueryVariables>) {
        return Apollo.useQuery<CareerMemberLearningProgressQuery, CareerMemberLearningProgressQueryVariables>(CareerMemberLearningProgressDocument, baseOptions);
      }
export function useCareerMemberLearningProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerMemberLearningProgressQuery, CareerMemberLearningProgressQueryVariables>) {
          return Apollo.useLazyQuery<CareerMemberLearningProgressQuery, CareerMemberLearningProgressQueryVariables>(CareerMemberLearningProgressDocument, baseOptions);
        }
export type CareerMemberLearningProgressQueryHookResult = ReturnType<typeof useCareerMemberLearningProgressQuery>;
export type CareerMemberLearningProgressLazyQueryHookResult = ReturnType<typeof useCareerMemberLearningProgressLazyQuery>;
export type CareerMemberLearningProgressQueryResult = Apollo.QueryResult<CareerMemberLearningProgressQuery, CareerMemberLearningProgressQueryVariables>;
export const ErpVacanciesDocument = gql`
    query ErpVacancies($status: String, $directionId: ID, $search: String, $createdFrom: Date, $createdTo: Date, $freshness: String, $hideArchived: Boolean) {
  careerVacanciesErp(
    status: $status
    directionId: $directionId
    search: $search
    createdFrom: $createdFrom
    createdTo: $createdTo
    freshness: $freshness
    hideArchived: $hideArchived
  ) {
    id
    title
    companyName
    applyUrl
    location
    workMode
    seniority
    employmentType
    salaryMin
    salaryMax
    salaryCurrency
    description
    status
    publishedAt
    expiresAt
    createdAt
    directionIds
    directionTitles
    skillIds
    skillNames
    appliedCount
    source
    createdByName
    reviewedByName
    reviewedAt
    updatedAt
    duplicateOf {
      vacancyId
      title
      companyName
      status
      score
    }
  }
}
    `;

/**
 * __useErpVacanciesQuery__
 *
 * To run a query within a React component, call `useErpVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpVacanciesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      directionId: // value for 'directionId'
 *      search: // value for 'search'
 *      createdFrom: // value for 'createdFrom'
 *      createdTo: // value for 'createdTo'
 *      freshness: // value for 'freshness'
 *      hideArchived: // value for 'hideArchived'
 *   },
 * });
 */
export function useErpVacanciesQuery(baseOptions?: Apollo.QueryHookOptions<ErpVacanciesQuery, ErpVacanciesQueryVariables>) {
        return Apollo.useQuery<ErpVacanciesQuery, ErpVacanciesQueryVariables>(ErpVacanciesDocument, baseOptions);
      }
export function useErpVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpVacanciesQuery, ErpVacanciesQueryVariables>) {
          return Apollo.useLazyQuery<ErpVacanciesQuery, ErpVacanciesQueryVariables>(ErpVacanciesDocument, baseOptions);
        }
export type ErpVacanciesQueryHookResult = ReturnType<typeof useErpVacanciesQuery>;
export type ErpVacanciesLazyQueryHookResult = ReturnType<typeof useErpVacanciesLazyQuery>;
export type ErpVacanciesQueryResult = Apollo.QueryResult<ErpVacanciesQuery, ErpVacanciesQueryVariables>;
export const ErpVacancyBoardDocument = gql`
    query ErpVacancyBoard($status: String, $directionId: ID, $search: String, $createdFrom: Date, $createdTo: Date, $freshness: String, $hideArchived: Boolean, $source: String, $hasDuplicates: Boolean, $orderBy: String, $orderDir: String, $first: Int, $after: String, $skillIds: [ID!]) {
  careerVacancyBoard(
    status: $status
    directionId: $directionId
    search: $search
    createdFrom: $createdFrom
    createdTo: $createdTo
    freshness: $freshness
    hideArchived: $hideArchived
    source: $source
    hasDuplicates: $hasDuplicates
    orderBy: $orderBy
    orderDir: $orderDir
    first: $first
    after: $after
    skillIds: $skillIds
  ) {
    edges {
      cursor
      node {
        id
        title
        companyName
        applyUrl
        location
        workMode
        seniority
        employmentType
        salaryMin
        salaryMax
        salaryCurrency
        description
        status
        publishedAt
        expiresAt
        createdAt
        directionIds
        directionTitles
        skillIds
        skillNames
        appliedCount
        source
        createdByName
        reviewedByName
        reviewedAt
        updatedAt
        duplicateOf {
          vacancyId
          title
          companyName
          status
          score
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    totalCountCapped
  }
}
    `;

/**
 * __useErpVacancyBoardQuery__
 *
 * To run a query within a React component, call `useErpVacancyBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpVacancyBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpVacancyBoardQuery({
 *   variables: {
 *      status: // value for 'status'
 *      directionId: // value for 'directionId'
 *      search: // value for 'search'
 *      createdFrom: // value for 'createdFrom'
 *      createdTo: // value for 'createdTo'
 *      freshness: // value for 'freshness'
 *      hideArchived: // value for 'hideArchived'
 *      source: // value for 'source'
 *      hasDuplicates: // value for 'hasDuplicates'
 *      orderBy: // value for 'orderBy'
 *      orderDir: // value for 'orderDir'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      skillIds: // value for 'skillIds'
 *   },
 * });
 */
export function useErpVacancyBoardQuery(baseOptions?: Apollo.QueryHookOptions<ErpVacancyBoardQuery, ErpVacancyBoardQueryVariables>) {
        return Apollo.useQuery<ErpVacancyBoardQuery, ErpVacancyBoardQueryVariables>(ErpVacancyBoardDocument, baseOptions);
      }
export function useErpVacancyBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpVacancyBoardQuery, ErpVacancyBoardQueryVariables>) {
          return Apollo.useLazyQuery<ErpVacancyBoardQuery, ErpVacancyBoardQueryVariables>(ErpVacancyBoardDocument, baseOptions);
        }
export type ErpVacancyBoardQueryHookResult = ReturnType<typeof useErpVacancyBoardQuery>;
export type ErpVacancyBoardLazyQueryHookResult = ReturnType<typeof useErpVacancyBoardLazyQuery>;
export type ErpVacancyBoardQueryResult = Apollo.QueryResult<ErpVacancyBoardQuery, ErpVacancyBoardQueryVariables>;
export const ErpVacancyDocument = gql`
    query ErpVacancy($id: ID!) {
  careerVacancyErp(id: $id) {
    id
    title
    companyName
    applyUrl
    location
    workMode
    seniority
    employmentType
    salaryMin
    salaryMax
    salaryCurrency
    description
    status
    publishedAt
    expiresAt
    createdAt
    directionIds
    directionTitles
    skillIds
    skillNames
    appliedCount
    source
    createdByName
    reviewedByName
    reviewedAt
    updatedAt
    duplicateOf {
      vacancyId
      title
      companyName
      status
      score
    }
  }
}
    `;

/**
 * __useErpVacancyQuery__
 *
 * To run a query within a React component, call `useErpVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpVacancyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpVacancyQuery(baseOptions: Apollo.QueryHookOptions<ErpVacancyQuery, ErpVacancyQueryVariables>) {
        return Apollo.useQuery<ErpVacancyQuery, ErpVacancyQueryVariables>(ErpVacancyDocument, baseOptions);
      }
export function useErpVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpVacancyQuery, ErpVacancyQueryVariables>) {
          return Apollo.useLazyQuery<ErpVacancyQuery, ErpVacancyQueryVariables>(ErpVacancyDocument, baseOptions);
        }
export type ErpVacancyQueryHookResult = ReturnType<typeof useErpVacancyQuery>;
export type ErpVacancyLazyQueryHookResult = ReturnType<typeof useErpVacancyLazyQuery>;
export type ErpVacancyQueryResult = Apollo.QueryResult<ErpVacancyQuery, ErpVacancyQueryVariables>;
export const ErpCareerDashboardDocument = gql`
    query ErpCareerDashboard {
  careerDashboard {
    members
    trained
    profileReady
    applied
    placed
    vacanciesPublished
    vacanciesDraft
    vacanciesDraftFromAgent
    oldestDraftDays
  }
}
    `;

/**
 * __useErpCareerDashboardQuery__
 *
 * To run a query within a React component, call `useErpCareerDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpCareerDashboardQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerDashboardQuery, ErpCareerDashboardQueryVariables>) {
        return Apollo.useQuery<ErpCareerDashboardQuery, ErpCareerDashboardQueryVariables>(ErpCareerDashboardDocument, baseOptions);
      }
export function useErpCareerDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerDashboardQuery, ErpCareerDashboardQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerDashboardQuery, ErpCareerDashboardQueryVariables>(ErpCareerDashboardDocument, baseOptions);
        }
export type ErpCareerDashboardQueryHookResult = ReturnType<typeof useErpCareerDashboardQuery>;
export type ErpCareerDashboardLazyQueryHookResult = ReturnType<typeof useErpCareerDashboardLazyQuery>;
export type ErpCareerDashboardQueryResult = Apollo.QueryResult<ErpCareerDashboardQuery, ErpCareerDashboardQueryVariables>;
export const CareerPlacementQueueDocument = gql`
    query CareerPlacementQueue {
  careerPlacementConfirmations {
    id
    studentId
    studentName
    companyName
    position
    appliedAt
    updatedAt
  }
}
    `;

/**
 * __useCareerPlacementQueueQuery__
 *
 * To run a query within a React component, call `useCareerPlacementQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerPlacementQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerPlacementQueueQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareerPlacementQueueQuery(baseOptions?: Apollo.QueryHookOptions<CareerPlacementQueueQuery, CareerPlacementQueueQueryVariables>) {
        return Apollo.useQuery<CareerPlacementQueueQuery, CareerPlacementQueueQueryVariables>(CareerPlacementQueueDocument, baseOptions);
      }
export function useCareerPlacementQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerPlacementQueueQuery, CareerPlacementQueueQueryVariables>) {
          return Apollo.useLazyQuery<CareerPlacementQueueQuery, CareerPlacementQueueQueryVariables>(CareerPlacementQueueDocument, baseOptions);
        }
export type CareerPlacementQueueQueryHookResult = ReturnType<typeof useCareerPlacementQueueQuery>;
export type CareerPlacementQueueLazyQueryHookResult = ReturnType<typeof useCareerPlacementQueueLazyQuery>;
export type CareerPlacementQueueQueryResult = Apollo.QueryResult<CareerPlacementQueueQuery, CareerPlacementQueueQueryVariables>;
export const ErpCareerSkillsDocument = gql`
    query ErpCareerSkills($category: String, $query: String) {
  careerSkillsErp(category: $category, query: $query) {
    id
    name
    slug
    category
  }
}
    `;

/**
 * __useErpCareerSkillsQuery__
 *
 * To run a query within a React component, call `useErpCareerSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerSkillsQuery({
 *   variables: {
 *      category: // value for 'category'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useErpCareerSkillsQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerSkillsQuery, ErpCareerSkillsQueryVariables>) {
        return Apollo.useQuery<ErpCareerSkillsQuery, ErpCareerSkillsQueryVariables>(ErpCareerSkillsDocument, baseOptions);
      }
export function useErpCareerSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerSkillsQuery, ErpCareerSkillsQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerSkillsQuery, ErpCareerSkillsQueryVariables>(ErpCareerSkillsDocument, baseOptions);
        }
export type ErpCareerSkillsQueryHookResult = ReturnType<typeof useErpCareerSkillsQuery>;
export type ErpCareerSkillsLazyQueryHookResult = ReturnType<typeof useErpCareerSkillsLazyQuery>;
export type ErpCareerSkillsQueryResult = Apollo.QueryResult<ErpCareerSkillsQuery, ErpCareerSkillsQueryVariables>;
export const ErpCareerSkillsDictionaryDocument = gql`
    query ErpCareerSkillsDictionary($query: String, $category: String) {
  careerSkillsErp(
    query: $query
    category: $category
    includeInactive: true
    withStats: true
    limit: 500
  ) {
    id
    name
    slug
    category
    description
    aliases
    levelCriteria {
      level
      points
      example
    }
    iconUrl
    isActive
    holderCount
    courseCount
    demandVacancies
    demandComputedAt
  }
}
    `;

/**
 * __useErpCareerSkillsDictionaryQuery__
 *
 * To run a query within a React component, call `useErpCareerSkillsDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerSkillsDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerSkillsDictionaryQuery({
 *   variables: {
 *      query: // value for 'query'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useErpCareerSkillsDictionaryQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerSkillsDictionaryQuery, ErpCareerSkillsDictionaryQueryVariables>) {
        return Apollo.useQuery<ErpCareerSkillsDictionaryQuery, ErpCareerSkillsDictionaryQueryVariables>(ErpCareerSkillsDictionaryDocument, baseOptions);
      }
export function useErpCareerSkillsDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerSkillsDictionaryQuery, ErpCareerSkillsDictionaryQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerSkillsDictionaryQuery, ErpCareerSkillsDictionaryQueryVariables>(ErpCareerSkillsDictionaryDocument, baseOptions);
        }
export type ErpCareerSkillsDictionaryQueryHookResult = ReturnType<typeof useErpCareerSkillsDictionaryQuery>;
export type ErpCareerSkillsDictionaryLazyQueryHookResult = ReturnType<typeof useErpCareerSkillsDictionaryLazyQuery>;
export type ErpCareerSkillsDictionaryQueryResult = Apollo.QueryResult<ErpCareerSkillsDictionaryQuery, ErpCareerSkillsDictionaryQueryVariables>;
export const ErpCareerCourseSkillSummaryDocument = gql`
    query ErpCareerCourseSkillSummary {
  careerCourseSkillSummary {
    courseId
    courseName
    skillCount
    directionTitles
  }
}
    `;

/**
 * __useErpCareerCourseSkillSummaryQuery__
 *
 * To run a query within a React component, call `useErpCareerCourseSkillSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerCourseSkillSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerCourseSkillSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpCareerCourseSkillSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerCourseSkillSummaryQuery, ErpCareerCourseSkillSummaryQueryVariables>) {
        return Apollo.useQuery<ErpCareerCourseSkillSummaryQuery, ErpCareerCourseSkillSummaryQueryVariables>(ErpCareerCourseSkillSummaryDocument, baseOptions);
      }
export function useErpCareerCourseSkillSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerCourseSkillSummaryQuery, ErpCareerCourseSkillSummaryQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerCourseSkillSummaryQuery, ErpCareerCourseSkillSummaryQueryVariables>(ErpCareerCourseSkillSummaryDocument, baseOptions);
        }
export type ErpCareerCourseSkillSummaryQueryHookResult = ReturnType<typeof useErpCareerCourseSkillSummaryQuery>;
export type ErpCareerCourseSkillSummaryLazyQueryHookResult = ReturnType<typeof useErpCareerCourseSkillSummaryLazyQuery>;
export type ErpCareerCourseSkillSummaryQueryResult = Apollo.QueryResult<ErpCareerCourseSkillSummaryQuery, ErpCareerCourseSkillSummaryQueryVariables>;
export const ErpCareerCourseSkillsDocument = gql`
    query ErpCareerCourseSkills($courseId: ID) {
  careerCourseSkills(courseId: $courseId) {
    id
    courseId
    courseName
    skillId
    skillName
    skillCategory
    level
    unlockLessonNumber
    order
    isActive
  }
}
    `;

/**
 * __useErpCareerCourseSkillsQuery__
 *
 * To run a query within a React component, call `useErpCareerCourseSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerCourseSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerCourseSkillsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useErpCareerCourseSkillsQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerCourseSkillsQuery, ErpCareerCourseSkillsQueryVariables>) {
        return Apollo.useQuery<ErpCareerCourseSkillsQuery, ErpCareerCourseSkillsQueryVariables>(ErpCareerCourseSkillsDocument, baseOptions);
      }
export function useErpCareerCourseSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerCourseSkillsQuery, ErpCareerCourseSkillsQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerCourseSkillsQuery, ErpCareerCourseSkillsQueryVariables>(ErpCareerCourseSkillsDocument, baseOptions);
        }
export type ErpCareerCourseSkillsQueryHookResult = ReturnType<typeof useErpCareerCourseSkillsQuery>;
export type ErpCareerCourseSkillsLazyQueryHookResult = ReturnType<typeof useErpCareerCourseSkillsLazyQuery>;
export type ErpCareerCourseSkillsQueryResult = Apollo.QueryResult<ErpCareerCourseSkillsQuery, ErpCareerCourseSkillsQueryVariables>;
export const ErpCourseProgramLessonsDocument = gql`
    query ErpCourseProgramLessons($courseId: ID!) {
  courseProgramLessons(courseId: $courseId) {
    number
    name
    moduleName
    lessonId
    moduleId
    marketingModuleId
    lmsDescription
    taskTypes
  }
  courseProgramFrame(courseId: $courseId) {
    title
    hours
    description
    exists
    marketingModules {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useErpCourseProgramLessonsQuery__
 *
 * To run a query within a React component, call `useErpCourseProgramLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCourseProgramLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCourseProgramLessonsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useErpCourseProgramLessonsQuery(baseOptions: Apollo.QueryHookOptions<ErpCourseProgramLessonsQuery, ErpCourseProgramLessonsQueryVariables>) {
        return Apollo.useQuery<ErpCourseProgramLessonsQuery, ErpCourseProgramLessonsQueryVariables>(ErpCourseProgramLessonsDocument, baseOptions);
      }
export function useErpCourseProgramLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCourseProgramLessonsQuery, ErpCourseProgramLessonsQueryVariables>) {
          return Apollo.useLazyQuery<ErpCourseProgramLessonsQuery, ErpCourseProgramLessonsQueryVariables>(ErpCourseProgramLessonsDocument, baseOptions);
        }
export type ErpCourseProgramLessonsQueryHookResult = ReturnType<typeof useErpCourseProgramLessonsQuery>;
export type ErpCourseProgramLessonsLazyQueryHookResult = ReturnType<typeof useErpCourseProgramLessonsLazyQuery>;
export type ErpCourseProgramLessonsQueryResult = Apollo.QueryResult<ErpCourseProgramLessonsQuery, ErpCourseProgramLessonsQueryVariables>;
export const ErpGroupSkillsDocument = gql`
    query ErpGroupSkills($groupId: ID!) {
  careerGroupSkills(groupId: $groupId) {
    id
    groupId
    skillId
    skillName
    skillCategory
    level
    unlockLessonId
    unlockLessonNumber
    unlockLessonName
    unlockLessonDate
    order
    isActive
  }
  groupProgramLessons(groupId: $groupId) {
    lessonId
    number
    name
    moduleName
    date
    isOver
  }
}
    `;

/**
 * __useErpGroupSkillsQuery__
 *
 * To run a query within a React component, call `useErpGroupSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpGroupSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpGroupSkillsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useErpGroupSkillsQuery(baseOptions: Apollo.QueryHookOptions<ErpGroupSkillsQuery, ErpGroupSkillsQueryVariables>) {
        return Apollo.useQuery<ErpGroupSkillsQuery, ErpGroupSkillsQueryVariables>(ErpGroupSkillsDocument, baseOptions);
      }
export function useErpGroupSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpGroupSkillsQuery, ErpGroupSkillsQueryVariables>) {
          return Apollo.useLazyQuery<ErpGroupSkillsQuery, ErpGroupSkillsQueryVariables>(ErpGroupSkillsDocument, baseOptions);
        }
export type ErpGroupSkillsQueryHookResult = ReturnType<typeof useErpGroupSkillsQuery>;
export type ErpGroupSkillsLazyQueryHookResult = ReturnType<typeof useErpGroupSkillsLazyQuery>;
export type ErpGroupSkillsQueryResult = Apollo.QueryResult<ErpGroupSkillsQuery, ErpGroupSkillsQueryVariables>;
export const ErpCareerStudentCompletionsDocument = gql`
    query ErpCareerStudentCompletions($studentId: ID!) {
  careerStudentCompletions(studentId: $studentId) {
    courseId
    courseName
    groupId
    groupName
    completed
    derived
    hasDiploma
    manualStatus
  }
}
    `;

/**
 * __useErpCareerStudentCompletionsQuery__
 *
 * To run a query within a React component, call `useErpCareerStudentCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerStudentCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerStudentCompletionsQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useErpCareerStudentCompletionsQuery(baseOptions: Apollo.QueryHookOptions<ErpCareerStudentCompletionsQuery, ErpCareerStudentCompletionsQueryVariables>) {
        return Apollo.useQuery<ErpCareerStudentCompletionsQuery, ErpCareerStudentCompletionsQueryVariables>(ErpCareerStudentCompletionsDocument, baseOptions);
      }
export function useErpCareerStudentCompletionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerStudentCompletionsQuery, ErpCareerStudentCompletionsQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerStudentCompletionsQuery, ErpCareerStudentCompletionsQueryVariables>(ErpCareerStudentCompletionsDocument, baseOptions);
        }
export type ErpCareerStudentCompletionsQueryHookResult = ReturnType<typeof useErpCareerStudentCompletionsQuery>;
export type ErpCareerStudentCompletionsLazyQueryHookResult = ReturnType<typeof useErpCareerStudentCompletionsLazyQuery>;
export type ErpCareerStudentCompletionsQueryResult = Apollo.QueryResult<ErpCareerStudentCompletionsQuery, ErpCareerStudentCompletionsQueryVariables>;
export const ErpCareerExerciseVocabularyDocument = gql`
    query ErpCareerExerciseVocabulary {
  careerExerciseVocabulary {
    maxFields
    maxOptions
    fieldTypes {
      value
      label
      hasOptions
    }
    bindings {
      value
      label
      fieldTypes
      isCollection
      needsLanguage
      subFields
    }
  }
}
    `;

/**
 * __useErpCareerExerciseVocabularyQuery__
 *
 * To run a query within a React component, call `useErpCareerExerciseVocabularyQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerExerciseVocabularyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerExerciseVocabularyQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpCareerExerciseVocabularyQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerExerciseVocabularyQuery, ErpCareerExerciseVocabularyQueryVariables>) {
        return Apollo.useQuery<ErpCareerExerciseVocabularyQuery, ErpCareerExerciseVocabularyQueryVariables>(ErpCareerExerciseVocabularyDocument, baseOptions);
      }
export function useErpCareerExerciseVocabularyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerExerciseVocabularyQuery, ErpCareerExerciseVocabularyQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerExerciseVocabularyQuery, ErpCareerExerciseVocabularyQueryVariables>(ErpCareerExerciseVocabularyDocument, baseOptions);
        }
export type ErpCareerExerciseVocabularyQueryHookResult = ReturnType<typeof useErpCareerExerciseVocabularyQuery>;
export type ErpCareerExerciseVocabularyLazyQueryHookResult = ReturnType<typeof useErpCareerExerciseVocabularyLazyQuery>;
export type ErpCareerExerciseVocabularyQueryResult = Apollo.QueryResult<ErpCareerExerciseVocabularyQuery, ErpCareerExerciseVocabularyQueryVariables>;
export const ErpCareerPromoCampaignsDocument = gql`
    query ErpCareerPromoCampaigns($includeInactive: Boolean) {
  careerPromoCampaigns(includeInactive: $includeInactive) {
    id
    code
    title
    description
    prefix
    discountKind
    discountValue
    currency
    ttlDays
    hardExpiresAt
    maxCodes
    ruleKind
    ruleParams
    isActive
    issuedCount
    redeemedCount
  }
}
    `;

/**
 * __useErpCareerPromoCampaignsQuery__
 *
 * To run a query within a React component, call `useErpCareerPromoCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerPromoCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerPromoCampaignsQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useErpCareerPromoCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerPromoCampaignsQuery, ErpCareerPromoCampaignsQueryVariables>) {
        return Apollo.useQuery<ErpCareerPromoCampaignsQuery, ErpCareerPromoCampaignsQueryVariables>(ErpCareerPromoCampaignsDocument, baseOptions);
      }
export function useErpCareerPromoCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerPromoCampaignsQuery, ErpCareerPromoCampaignsQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerPromoCampaignsQuery, ErpCareerPromoCampaignsQueryVariables>(ErpCareerPromoCampaignsDocument, baseOptions);
        }
export type ErpCareerPromoCampaignsQueryHookResult = ReturnType<typeof useErpCareerPromoCampaignsQuery>;
export type ErpCareerPromoCampaignsLazyQueryHookResult = ReturnType<typeof useErpCareerPromoCampaignsLazyQuery>;
export type ErpCareerPromoCampaignsQueryResult = Apollo.QueryResult<ErpCareerPromoCampaignsQuery, ErpCareerPromoCampaignsQueryVariables>;
export const ErpCareerPromoCodesDocument = gql`
    query ErpCareerPromoCodes($campaignId: ID, $status: String, $search: String) {
  careerPromoCodes(campaignId: $campaignId, status: $status, search: $search) {
    id
    code
    status
    studentId
    studentName
    campaignCode
    expiresAt
    redeemedAt
    agreementId
    agreementTitle
    isAmbiguous
    revokeReason
  }
}
    `;

/**
 * __useErpCareerPromoCodesQuery__
 *
 * To run a query within a React component, call `useErpCareerPromoCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerPromoCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerPromoCodesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpCareerPromoCodesQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerPromoCodesQuery, ErpCareerPromoCodesQueryVariables>) {
        return Apollo.useQuery<ErpCareerPromoCodesQuery, ErpCareerPromoCodesQueryVariables>(ErpCareerPromoCodesDocument, baseOptions);
      }
export function useErpCareerPromoCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerPromoCodesQuery, ErpCareerPromoCodesQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerPromoCodesQuery, ErpCareerPromoCodesQueryVariables>(ErpCareerPromoCodesDocument, baseOptions);
        }
export type ErpCareerPromoCodesQueryHookResult = ReturnType<typeof useErpCareerPromoCodesQuery>;
export type ErpCareerPromoCodesLazyQueryHookResult = ReturnType<typeof useErpCareerPromoCodesLazyQuery>;
export type ErpCareerPromoCodesQueryResult = Apollo.QueryResult<ErpCareerPromoCodesQuery, ErpCareerPromoCodesQueryVariables>;
export const ErpCareerGrowthRulesDocument = gql`
    query ErpCareerGrowthRules {
  careerGrowthRules {
    value
    label
    paramKey
    progressKind
  }
}
    `;

/**
 * __useErpCareerGrowthRulesQuery__
 *
 * To run a query within a React component, call `useErpCareerGrowthRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerGrowthRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerGrowthRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpCareerGrowthRulesQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerGrowthRulesQuery, ErpCareerGrowthRulesQueryVariables>) {
        return Apollo.useQuery<ErpCareerGrowthRulesQuery, ErpCareerGrowthRulesQueryVariables>(ErpCareerGrowthRulesDocument, baseOptions);
      }
export function useErpCareerGrowthRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerGrowthRulesQuery, ErpCareerGrowthRulesQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerGrowthRulesQuery, ErpCareerGrowthRulesQueryVariables>(ErpCareerGrowthRulesDocument, baseOptions);
        }
export type ErpCareerGrowthRulesQueryHookResult = ReturnType<typeof useErpCareerGrowthRulesQuery>;
export type ErpCareerGrowthRulesLazyQueryHookResult = ReturnType<typeof useErpCareerGrowthRulesLazyQuery>;
export type ErpCareerGrowthRulesQueryResult = Apollo.QueryResult<ErpCareerGrowthRulesQuery, ErpCareerGrowthRulesQueryVariables>;
export const ErpCareerGrowthDictionaryDocument = gql`
    query ErpCareerGrowthDictionary {
  careerAchievements {
    id
    code
    title
    description
    icon
    category
    points
    ruleKind
    ruleParams
    isSecret
    order
    isActive
    grantedCount
  }
  careerGrowthTracks {
    id
    code
    title
    description
    longDescription
    salaryFrom
    salaryTo
    salaryCurrency
    icon
    order
    isActive
    targetSkills
    targetSkillIds
    siteCourseIds
    steps
    stepRows {
      title
      description
      ruleKind
      ruleParams
    }
    chosenCount
  }
  careerTrackIcons {
    value
    label
  }
}
    `;

/**
 * __useErpCareerGrowthDictionaryQuery__
 *
 * To run a query within a React component, call `useErpCareerGrowthDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerGrowthDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerGrowthDictionaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpCareerGrowthDictionaryQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerGrowthDictionaryQuery, ErpCareerGrowthDictionaryQueryVariables>) {
        return Apollo.useQuery<ErpCareerGrowthDictionaryQuery, ErpCareerGrowthDictionaryQueryVariables>(ErpCareerGrowthDictionaryDocument, baseOptions);
      }
export function useErpCareerGrowthDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerGrowthDictionaryQuery, ErpCareerGrowthDictionaryQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerGrowthDictionaryQuery, ErpCareerGrowthDictionaryQueryVariables>(ErpCareerGrowthDictionaryDocument, baseOptions);
        }
export type ErpCareerGrowthDictionaryQueryHookResult = ReturnType<typeof useErpCareerGrowthDictionaryQuery>;
export type ErpCareerGrowthDictionaryLazyQueryHookResult = ReturnType<typeof useErpCareerGrowthDictionaryLazyQuery>;
export type ErpCareerGrowthDictionaryQueryResult = Apollo.QueryResult<ErpCareerGrowthDictionaryQuery, ErpCareerGrowthDictionaryQueryVariables>;
export const ErpCareerShareTemplatesDocument = gql`
    query ErpCareerShareTemplates {
  careerShareTemplates {
    channel
    language
    text
    targetUrl
    isActive
  }
}
    `;

/**
 * __useErpCareerShareTemplatesQuery__
 *
 * To run a query within a React component, call `useErpCareerShareTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerShareTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerShareTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpCareerShareTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerShareTemplatesQuery, ErpCareerShareTemplatesQueryVariables>) {
        return Apollo.useQuery<ErpCareerShareTemplatesQuery, ErpCareerShareTemplatesQueryVariables>(ErpCareerShareTemplatesDocument, baseOptions);
      }
export function useErpCareerShareTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerShareTemplatesQuery, ErpCareerShareTemplatesQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerShareTemplatesQuery, ErpCareerShareTemplatesQueryVariables>(ErpCareerShareTemplatesDocument, baseOptions);
        }
export type ErpCareerShareTemplatesQueryHookResult = ReturnType<typeof useErpCareerShareTemplatesQuery>;
export type ErpCareerShareTemplatesLazyQueryHookResult = ReturnType<typeof useErpCareerShareTemplatesLazyQuery>;
export type ErpCareerShareTemplatesQueryResult = Apollo.QueryResult<ErpCareerShareTemplatesQuery, ErpCareerShareTemplatesQueryVariables>;
export const ErpCareerGroupRosterDocument = gql`
    query ErpCareerGroupRoster($groupId: ID, $search: String) {
  careerGroupRoster(groupId: $groupId, search: $search) {
    studentId
    fullName
    email
    groupName
    memberStatus
  }
}
    `;

/**
 * __useErpCareerGroupRosterQuery__
 *
 * To run a query within a React component, call `useErpCareerGroupRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerGroupRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerGroupRosterQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpCareerGroupRosterQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerGroupRosterQuery, ErpCareerGroupRosterQueryVariables>) {
        return Apollo.useQuery<ErpCareerGroupRosterQuery, ErpCareerGroupRosterQueryVariables>(ErpCareerGroupRosterDocument, baseOptions);
      }
export function useErpCareerGroupRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerGroupRosterQuery, ErpCareerGroupRosterQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerGroupRosterQuery, ErpCareerGroupRosterQueryVariables>(ErpCareerGroupRosterDocument, baseOptions);
        }
export type ErpCareerGroupRosterQueryHookResult = ReturnType<typeof useErpCareerGroupRosterQuery>;
export type ErpCareerGroupRosterLazyQueryHookResult = ReturnType<typeof useErpCareerGroupRosterLazyQuery>;
export type ErpCareerGroupRosterQueryResult = Apollo.QueryResult<ErpCareerGroupRosterQuery, ErpCareerGroupRosterQueryVariables>;
export const ErpCareerExerciseTemplatesDocument = gql`
    query ErpCareerExerciseTemplates($search: String, $includeHidden: Boolean) {
  careerExerciseTemplates(search: $search, includeHidden: $includeHidden) {
    id
    title
    intro
    outro
    isActive
    hasSubmissions
    submissionsCount
    lessonTitles
    updatedAt
    fields {
      id
      number
      label
      helpText
      placeholder
      fieldType
      required
      options
      maxLength
      binding
      bindingLanguage
    }
  }
}
    `;

/**
 * __useErpCareerExerciseTemplatesQuery__
 *
 * To run a query within a React component, call `useErpCareerExerciseTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerExerciseTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerExerciseTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      includeHidden: // value for 'includeHidden'
 *   },
 * });
 */
export function useErpCareerExerciseTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerExerciseTemplatesQuery, ErpCareerExerciseTemplatesQueryVariables>) {
        return Apollo.useQuery<ErpCareerExerciseTemplatesQuery, ErpCareerExerciseTemplatesQueryVariables>(ErpCareerExerciseTemplatesDocument, baseOptions);
      }
export function useErpCareerExerciseTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerExerciseTemplatesQuery, ErpCareerExerciseTemplatesQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerExerciseTemplatesQuery, ErpCareerExerciseTemplatesQueryVariables>(ErpCareerExerciseTemplatesDocument, baseOptions);
        }
export type ErpCareerExerciseTemplatesQueryHookResult = ReturnType<typeof useErpCareerExerciseTemplatesQuery>;
export type ErpCareerExerciseTemplatesLazyQueryHookResult = ReturnType<typeof useErpCareerExerciseTemplatesLazyQuery>;
export type ErpCareerExerciseTemplatesQueryResult = Apollo.QueryResult<ErpCareerExerciseTemplatesQuery, ErpCareerExerciseTemplatesQueryVariables>;
export const ErpCareerSiteCoursesDocument = gql`
    query ErpCareerSiteCourses($includeHidden: Boolean) {
  careerSiteCourses(includeHidden: $includeHidden) {
    id
    slug
    name
    order
    isActive
    erpCourseId
    erpCourseName
    skills {
      skillId
      skillName
      level
    }
  }
}
    `;

/**
 * __useErpCareerSiteCoursesQuery__
 *
 * To run a query within a React component, call `useErpCareerSiteCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpCareerSiteCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpCareerSiteCoursesQuery({
 *   variables: {
 *      includeHidden: // value for 'includeHidden'
 *   },
 * });
 */
export function useErpCareerSiteCoursesQuery(baseOptions?: Apollo.QueryHookOptions<ErpCareerSiteCoursesQuery, ErpCareerSiteCoursesQueryVariables>) {
        return Apollo.useQuery<ErpCareerSiteCoursesQuery, ErpCareerSiteCoursesQueryVariables>(ErpCareerSiteCoursesDocument, baseOptions);
      }
export function useErpCareerSiteCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpCareerSiteCoursesQuery, ErpCareerSiteCoursesQueryVariables>) {
          return Apollo.useLazyQuery<ErpCareerSiteCoursesQuery, ErpCareerSiteCoursesQueryVariables>(ErpCareerSiteCoursesDocument, baseOptions);
        }
export type ErpCareerSiteCoursesQueryHookResult = ReturnType<typeof useErpCareerSiteCoursesQuery>;
export type ErpCareerSiteCoursesLazyQueryHookResult = ReturnType<typeof useErpCareerSiteCoursesLazyQuery>;
export type ErpCareerSiteCoursesQueryResult = Apollo.QueryResult<ErpCareerSiteCoursesQuery, ErpCareerSiteCoursesQueryVariables>;
export const CashFlowReportDocument = gql`
    query CashFlowReport($dateFrom: Date, $dateTo: Date, $grain: String, $includeInternal: Boolean) {
  cashFlowReport(
    dateFrom: $dateFrom
    dateTo: $dateTo
    grain: $grain
    includeInternal: $includeInternal
  ) {
    grain
    currency
    openingCash
    closingCash
    asOf
    lastPeriodComplete
    totalRevenue
    totalReturns
    totalOutflow
    totalOperatingCashFlow
    totalFunding
    rateMissingCount
    internalExcludedCount
    monthlyBurnPln
    runwayMonths
    accrual {
      invoiced
      received
      difference
      invoiceCount
    }
    periods {
      key
      revenue
      returns
      outflow
      operatingCashFlow
      funding
      net
      cash
      rows
    }
    rows {
      key
      label
      level
      parentKey
      section
      group
      hasChildren
      values
      total
    }
  }
}
    `;

/**
 * __useCashFlowReportQuery__
 *
 * To run a query within a React component, call `useCashFlowReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowReportQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      grain: // value for 'grain'
 *      includeInternal: // value for 'includeInternal'
 *   },
 * });
 */
export function useCashFlowReportQuery(baseOptions?: Apollo.QueryHookOptions<CashFlowReportQuery, CashFlowReportQueryVariables>) {
        return Apollo.useQuery<CashFlowReportQuery, CashFlowReportQueryVariables>(CashFlowReportDocument, baseOptions);
      }
export function useCashFlowReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowReportQuery, CashFlowReportQueryVariables>) {
          return Apollo.useLazyQuery<CashFlowReportQuery, CashFlowReportQueryVariables>(CashFlowReportDocument, baseOptions);
        }
export type CashFlowReportQueryHookResult = ReturnType<typeof useCashFlowReportQuery>;
export type CashFlowReportLazyQueryHookResult = ReturnType<typeof useCashFlowReportLazyQuery>;
export type CashFlowReportQueryResult = Apollo.QueryResult<CashFlowReportQuery, CashFlowReportQueryVariables>;
export const CashFlowTransactionsDocument = gql`
    query CashFlowTransactions($dateFrom: Date, $dateTo: Date, $categorySlugs: [String], $direction: String, $uncategorisedOnly: Boolean, $needsReview: Boolean, $search: String, $page: Int, $perPage: Int) {
  bankTransactions(
    dateFrom: $dateFrom
    dateTo: $dateTo
    categorySlugs: $categorySlugs
    direction: $direction
    uncategorisedOnly: $uncategorisedOnly
    needsReview: $needsReview
    search: $search
    page: $page
    perPage: $perPage
  ) {
    totalCount
    page
    perPage
    summary {
      count
      inflowPln
      outflowPln
    }
    items {
      pk
      bookedAt
      amount
      currency
      balanceAfter
      accountName
      rawType
      description
      counterpartyName
      categorySlug
      categoryName
      categorySource
      isInternalTransfer
      needsReview
      links {
        pk
        targetType
        targetId
        targetLabel
        matchSource
      }
    }
  }
}
    `;

/**
 * __useCashFlowTransactionsQuery__
 *
 * To run a query within a React component, call `useCashFlowTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowTransactionsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      categorySlugs: // value for 'categorySlugs'
 *      direction: // value for 'direction'
 *      uncategorisedOnly: // value for 'uncategorisedOnly'
 *      needsReview: // value for 'needsReview'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCashFlowTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<CashFlowTransactionsQuery, CashFlowTransactionsQueryVariables>) {
        return Apollo.useQuery<CashFlowTransactionsQuery, CashFlowTransactionsQueryVariables>(CashFlowTransactionsDocument, baseOptions);
      }
export function useCashFlowTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowTransactionsQuery, CashFlowTransactionsQueryVariables>) {
          return Apollo.useLazyQuery<CashFlowTransactionsQuery, CashFlowTransactionsQueryVariables>(CashFlowTransactionsDocument, baseOptions);
        }
export type CashFlowTransactionsQueryHookResult = ReturnType<typeof useCashFlowTransactionsQuery>;
export type CashFlowTransactionsLazyQueryHookResult = ReturnType<typeof useCashFlowTransactionsLazyQuery>;
export type CashFlowTransactionsQueryResult = Apollo.QueryResult<CashFlowTransactionsQuery, CashFlowTransactionsQueryVariables>;
export const CashFlowDictionariesDocument = gql`
    query CashFlowDictionaries {
  cashFlowCategories {
    pk
    slug
    name
    group
    section
    learningPolicy
  }
  bankAccounts {
    pk
    slug
    name
    kind
    transactionsCount
    netAmountPln
  }
}
    `;

/**
 * __useCashFlowDictionariesQuery__
 *
 * To run a query within a React component, call `useCashFlowDictionariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowDictionariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowDictionariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashFlowDictionariesQuery(baseOptions?: Apollo.QueryHookOptions<CashFlowDictionariesQuery, CashFlowDictionariesQueryVariables>) {
        return Apollo.useQuery<CashFlowDictionariesQuery, CashFlowDictionariesQueryVariables>(CashFlowDictionariesDocument, baseOptions);
      }
export function useCashFlowDictionariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowDictionariesQuery, CashFlowDictionariesQueryVariables>) {
          return Apollo.useLazyQuery<CashFlowDictionariesQuery, CashFlowDictionariesQueryVariables>(CashFlowDictionariesDocument, baseOptions);
        }
export type CashFlowDictionariesQueryHookResult = ReturnType<typeof useCashFlowDictionariesQuery>;
export type CashFlowDictionariesLazyQueryHookResult = ReturnType<typeof useCashFlowDictionariesLazyQuery>;
export type CashFlowDictionariesQueryResult = Apollo.QueryResult<CashFlowDictionariesQuery, CashFlowDictionariesQueryVariables>;
export const CashFlowControlDocument = gql`
    query CashFlowControl {
  cashFlowControl {
    transactionsCount
    uncategorisedCount
    internalCount
    internalUnpairedCount
    needsReviewCount
    heuristicDedupCount
    rulesTotal
    rulesNeedingAttention
    accounts {
      pk
      slug
      name
      iban
      transactionsCount
      netAmountPln
    }
    checks {
      code
      status
      detail
      subject
      count
    }
  }
}
    `;

/**
 * __useCashFlowControlQuery__
 *
 * To run a query within a React component, call `useCashFlowControlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowControlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowControlQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashFlowControlQuery(baseOptions?: Apollo.QueryHookOptions<CashFlowControlQuery, CashFlowControlQueryVariables>) {
        return Apollo.useQuery<CashFlowControlQuery, CashFlowControlQueryVariables>(CashFlowControlDocument, baseOptions);
      }
export function useCashFlowControlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowControlQuery, CashFlowControlQueryVariables>) {
          return Apollo.useLazyQuery<CashFlowControlQuery, CashFlowControlQueryVariables>(CashFlowControlDocument, baseOptions);
        }
export type CashFlowControlQueryHookResult = ReturnType<typeof useCashFlowControlQuery>;
export type CashFlowControlLazyQueryHookResult = ReturnType<typeof useCashFlowControlLazyQuery>;
export type CashFlowControlQueryResult = Apollo.QueryResult<CashFlowControlQuery, CashFlowControlQueryVariables>;
export const CashFlowRulesDocument = gql`
    query CashFlowRules($isActive: Boolean, $health: String, $needsAttention: Boolean, $page: Int, $perPage: Int) {
  cashFlowRules(
    isActive: $isActive
    health: $health
    needsAttention: $needsAttention
    page: $page
    perPage: $perPage
  ) {
    pk
    keyKind
    keyValue
    direction
    categorySlug
    categoryName
    priority
    isActive
    health
    origin
    hitsCount
    overridesCount
    validFrom
    validTo
  }
}
    `;

/**
 * __useCashFlowRulesQuery__
 *
 * To run a query within a React component, call `useCashFlowRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowRulesQuery({
 *   variables: {
 *      isActive: // value for 'isActive'
 *      health: // value for 'health'
 *      needsAttention: // value for 'needsAttention'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCashFlowRulesQuery(baseOptions?: Apollo.QueryHookOptions<CashFlowRulesQuery, CashFlowRulesQueryVariables>) {
        return Apollo.useQuery<CashFlowRulesQuery, CashFlowRulesQueryVariables>(CashFlowRulesDocument, baseOptions);
      }
export function useCashFlowRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowRulesQuery, CashFlowRulesQueryVariables>) {
          return Apollo.useLazyQuery<CashFlowRulesQuery, CashFlowRulesQueryVariables>(CashFlowRulesDocument, baseOptions);
        }
export type CashFlowRulesQueryHookResult = ReturnType<typeof useCashFlowRulesQuery>;
export type CashFlowRulesLazyQueryHookResult = ReturnType<typeof useCashFlowRulesLazyQuery>;
export type CashFlowRulesQueryResult = Apollo.QueryResult<CashFlowRulesQuery, CashFlowRulesQueryVariables>;
export const BankStatementImportsDocument = gql`
    query BankStatementImports($limit: Int) {
  bankStatementImports(limit: $limit) {
    pk
    fileName
    status
    dryRun
    rowsTotal
    createdCount
    duplicateCount
    failedCount
    balanceGapCount
    periodFrom
    periodTo
    errorMessage
    createdAt
    createdByName
  }
}
    `;

/**
 * __useBankStatementImportsQuery__
 *
 * To run a query within a React component, call `useBankStatementImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankStatementImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankStatementImportsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBankStatementImportsQuery(baseOptions?: Apollo.QueryHookOptions<BankStatementImportsQuery, BankStatementImportsQueryVariables>) {
        return Apollo.useQuery<BankStatementImportsQuery, BankStatementImportsQueryVariables>(BankStatementImportsDocument, baseOptions);
      }
export function useBankStatementImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankStatementImportsQuery, BankStatementImportsQueryVariables>) {
          return Apollo.useLazyQuery<BankStatementImportsQuery, BankStatementImportsQueryVariables>(BankStatementImportsDocument, baseOptions);
        }
export type BankStatementImportsQueryHookResult = ReturnType<typeof useBankStatementImportsQuery>;
export type BankStatementImportsLazyQueryHookResult = ReturnType<typeof useBankStatementImportsLazyQuery>;
export type BankStatementImportsQueryResult = Apollo.QueryResult<BankStatementImportsQuery, BankStatementImportsQueryVariables>;
export const CashFlowSettingsDocument = gql`
    query CashFlowSettings {
  cashFlowSettings {
    pk
    ownPartyNames
    internalTransferAutodetect
    internalTransferWindowDays
  }
}
    `;

/**
 * __useCashFlowSettingsQuery__
 *
 * To run a query within a React component, call `useCashFlowSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashFlowSettingsQuery(baseOptions?: Apollo.QueryHookOptions<CashFlowSettingsQuery, CashFlowSettingsQueryVariables>) {
        return Apollo.useQuery<CashFlowSettingsQuery, CashFlowSettingsQueryVariables>(CashFlowSettingsDocument, baseOptions);
      }
export function useCashFlowSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowSettingsQuery, CashFlowSettingsQueryVariables>) {
          return Apollo.useLazyQuery<CashFlowSettingsQuery, CashFlowSettingsQueryVariables>(CashFlowSettingsDocument, baseOptions);
        }
export type CashFlowSettingsQueryHookResult = ReturnType<typeof useCashFlowSettingsQuery>;
export type CashFlowSettingsLazyQueryHookResult = ReturnType<typeof useCashFlowSettingsLazyQuery>;
export type CashFlowSettingsQueryResult = Apollo.QueryResult<CashFlowSettingsQuery, CashFlowSettingsQueryVariables>;
export const GatewaySettlementsDocument = gql`
    query GatewaySettlements($status: String) {
  gatewaySettlements(status: $status) {
    pk
    provider
    merchantCode
    externalRef
    bookedAt
    amountBank
    itemsTotal
    feeAmount
    feeSource
    unallocated
    status
    reasonCode
    items {
      pk
      invoiceId
      invoiceNumber
      kind
      amount
      matchSource
    }
  }
}
    `;

/**
 * __useGatewaySettlementsQuery__
 *
 * To run a query within a React component, call `useGatewaySettlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatewaySettlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatewaySettlementsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGatewaySettlementsQuery(baseOptions?: Apollo.QueryHookOptions<GatewaySettlementsQuery, GatewaySettlementsQueryVariables>) {
        return Apollo.useQuery<GatewaySettlementsQuery, GatewaySettlementsQueryVariables>(GatewaySettlementsDocument, baseOptions);
      }
export function useGatewaySettlementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatewaySettlementsQuery, GatewaySettlementsQueryVariables>) {
          return Apollo.useLazyQuery<GatewaySettlementsQuery, GatewaySettlementsQueryVariables>(GatewaySettlementsDocument, baseOptions);
        }
export type GatewaySettlementsQueryHookResult = ReturnType<typeof useGatewaySettlementsQuery>;
export type GatewaySettlementsLazyQueryHookResult = ReturnType<typeof useGatewaySettlementsLazyQuery>;
export type GatewaySettlementsQueryResult = Apollo.QueryResult<GatewaySettlementsQuery, GatewaySettlementsQueryVariables>;
export const GatewaySettlementCandidatesDocument = gql`
    query GatewaySettlementCandidates($settlementId: ID!) {
  gatewaySettlementCandidates(settlementId: $settlementId) {
    invoiceId
    number
    issueDate
    amount
    preselected
    alreadyInSettlementId
  }
}
    `;

/**
 * __useGatewaySettlementCandidatesQuery__
 *
 * To run a query within a React component, call `useGatewaySettlementCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatewaySettlementCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatewaySettlementCandidatesQuery({
 *   variables: {
 *      settlementId: // value for 'settlementId'
 *   },
 * });
 */
export function useGatewaySettlementCandidatesQuery(baseOptions: Apollo.QueryHookOptions<GatewaySettlementCandidatesQuery, GatewaySettlementCandidatesQueryVariables>) {
        return Apollo.useQuery<GatewaySettlementCandidatesQuery, GatewaySettlementCandidatesQueryVariables>(GatewaySettlementCandidatesDocument, baseOptions);
      }
export function useGatewaySettlementCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatewaySettlementCandidatesQuery, GatewaySettlementCandidatesQueryVariables>) {
          return Apollo.useLazyQuery<GatewaySettlementCandidatesQuery, GatewaySettlementCandidatesQueryVariables>(GatewaySettlementCandidatesDocument, baseOptions);
        }
export type GatewaySettlementCandidatesQueryHookResult = ReturnType<typeof useGatewaySettlementCandidatesQuery>;
export type GatewaySettlementCandidatesLazyQueryHookResult = ReturnType<typeof useGatewaySettlementCandidatesLazyQuery>;
export type GatewaySettlementCandidatesQueryResult = Apollo.QueryResult<GatewaySettlementCandidatesQuery, GatewaySettlementCandidatesQueryVariables>;
export const DocumentCashFlowDocument = gql`
    query DocumentCashFlow($targetType: String!, $targetId: ID!) {
  documentCashFlow(targetType: $targetType, targetId: $targetId) {
    status
    totalPln
    settlementProvider
    settlementRef
    settlementBookedAt
    rows {
      pk
      bookedAt
      amount
      currency
      accountName
      description
      counterpartyName
      matchSource
    }
  }
}
    `;

/**
 * __useDocumentCashFlowQuery__
 *
 * To run a query within a React component, call `useDocumentCashFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentCashFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentCashFlowQuery({
 *   variables: {
 *      targetType: // value for 'targetType'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useDocumentCashFlowQuery(baseOptions: Apollo.QueryHookOptions<DocumentCashFlowQuery, DocumentCashFlowQueryVariables>) {
        return Apollo.useQuery<DocumentCashFlowQuery, DocumentCashFlowQueryVariables>(DocumentCashFlowDocument, baseOptions);
      }
export function useDocumentCashFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentCashFlowQuery, DocumentCashFlowQueryVariables>) {
          return Apollo.useLazyQuery<DocumentCashFlowQuery, DocumentCashFlowQueryVariables>(DocumentCashFlowDocument, baseOptions);
        }
export type DocumentCashFlowQueryHookResult = ReturnType<typeof useDocumentCashFlowQuery>;
export type DocumentCashFlowLazyQueryHookResult = ReturnType<typeof useDocumentCashFlowLazyQuery>;
export type DocumentCashFlowQueryResult = Apollo.QueryResult<DocumentCashFlowQuery, DocumentCashFlowQueryVariables>;
export const BankTransactionMatchCandidatesDocument = gql`
    query BankTransactionMatchCandidates($transactionId: ID!) {
  bankTransactionMatchCandidates(transactionId: $transactionId) {
    targetType
    targetId
    label
    amount
    confidence
    strategy
  }
}
    `;

/**
 * __useBankTransactionMatchCandidatesQuery__
 *
 * To run a query within a React component, call `useBankTransactionMatchCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankTransactionMatchCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankTransactionMatchCandidatesQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useBankTransactionMatchCandidatesQuery(baseOptions: Apollo.QueryHookOptions<BankTransactionMatchCandidatesQuery, BankTransactionMatchCandidatesQueryVariables>) {
        return Apollo.useQuery<BankTransactionMatchCandidatesQuery, BankTransactionMatchCandidatesQueryVariables>(BankTransactionMatchCandidatesDocument, baseOptions);
      }
export function useBankTransactionMatchCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankTransactionMatchCandidatesQuery, BankTransactionMatchCandidatesQueryVariables>) {
          return Apollo.useLazyQuery<BankTransactionMatchCandidatesQuery, BankTransactionMatchCandidatesQueryVariables>(BankTransactionMatchCandidatesDocument, baseOptions);
        }
export type BankTransactionMatchCandidatesQueryHookResult = ReturnType<typeof useBankTransactionMatchCandidatesQuery>;
export type BankTransactionMatchCandidatesLazyQueryHookResult = ReturnType<typeof useBankTransactionMatchCandidatesLazyQuery>;
export type BankTransactionMatchCandidatesQueryResult = Apollo.QueryResult<BankTransactionMatchCandidatesQuery, BankTransactionMatchCandidatesQueryVariables>;
export const StudentConversationsPagedDocument = gql`
    query StudentConversationsPaged($studentId: ID!, $kinds: [String!], $first: Int, $after: String) {
  studentConversationsPage(
    studentId: $studentId
    kinds: $kinds
    first: $first
    after: $after
  ) {
    totalCount
    totalCountCapped
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        id
        kind
        title
        displayTitle
        externalId
        teamId
        mailboxEmail
        unreadCount
        status
        hasUnhandled
        lastMessageAt
      }
    }
  }
}
    `;

/**
 * __useStudentConversationsPagedQuery__
 *
 * To run a query within a React component, call `useStudentConversationsPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentConversationsPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentConversationsPagedQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      kinds: // value for 'kinds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useStudentConversationsPagedQuery(baseOptions: Apollo.QueryHookOptions<StudentConversationsPagedQuery, StudentConversationsPagedQueryVariables>) {
        return Apollo.useQuery<StudentConversationsPagedQuery, StudentConversationsPagedQueryVariables>(StudentConversationsPagedDocument, baseOptions);
      }
export function useStudentConversationsPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentConversationsPagedQuery, StudentConversationsPagedQueryVariables>) {
          return Apollo.useLazyQuery<StudentConversationsPagedQuery, StudentConversationsPagedQueryVariables>(StudentConversationsPagedDocument, baseOptions);
        }
export type StudentConversationsPagedQueryHookResult = ReturnType<typeof useStudentConversationsPagedQuery>;
export type StudentConversationsPagedLazyQueryHookResult = ReturnType<typeof useStudentConversationsPagedLazyQuery>;
export type StudentConversationsPagedQueryResult = Apollo.QueryResult<StudentConversationsPagedQuery, StudentConversationsPagedQueryVariables>;
export const GroupConversationsPagedDocument = gql`
    query GroupConversationsPaged($groupId: ID!, $kinds: [String!], $first: Int, $after: String) {
  groupConversationsPage(
    groupId: $groupId
    kinds: $kinds
    first: $first
    after: $after
  ) {
    totalCount
    totalCountCapped
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        id
        kind
        title
        displayTitle
        externalId
        teamId
        mailboxEmail
        unreadCount
        status
        hasUnhandled
        lastMessageAt
      }
    }
  }
}
    `;

/**
 * __useGroupConversationsPagedQuery__
 *
 * To run a query within a React component, call `useGroupConversationsPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupConversationsPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupConversationsPagedQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      kinds: // value for 'kinds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGroupConversationsPagedQuery(baseOptions: Apollo.QueryHookOptions<GroupConversationsPagedQuery, GroupConversationsPagedQueryVariables>) {
        return Apollo.useQuery<GroupConversationsPagedQuery, GroupConversationsPagedQueryVariables>(GroupConversationsPagedDocument, baseOptions);
      }
export function useGroupConversationsPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupConversationsPagedQuery, GroupConversationsPagedQueryVariables>) {
          return Apollo.useLazyQuery<GroupConversationsPagedQuery, GroupConversationsPagedQueryVariables>(GroupConversationsPagedDocument, baseOptions);
        }
export type GroupConversationsPagedQueryHookResult = ReturnType<typeof useGroupConversationsPagedQuery>;
export type GroupConversationsPagedLazyQueryHookResult = ReturnType<typeof useGroupConversationsPagedLazyQuery>;
export type GroupConversationsPagedQueryResult = Apollo.QueryResult<GroupConversationsPagedQuery, GroupConversationsPagedQueryVariables>;
export const TeacherConversationsPagedDocument = gql`
    query TeacherConversationsPaged($teacherId: ID!, $kinds: [String!], $first: Int, $after: String) {
  teacherConversationsPage(
    teacherId: $teacherId
    kinds: $kinds
    first: $first
    after: $after
  ) {
    totalCount
    totalCountCapped
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        id
        kind
        title
        displayTitle
        externalId
        teamId
        mailboxEmail
        unreadCount
        status
        hasUnhandled
        lastMessageAt
      }
    }
  }
}
    `;

/**
 * __useTeacherConversationsPagedQuery__
 *
 * To run a query within a React component, call `useTeacherConversationsPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherConversationsPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherConversationsPagedQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      kinds: // value for 'kinds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTeacherConversationsPagedQuery(baseOptions: Apollo.QueryHookOptions<TeacherConversationsPagedQuery, TeacherConversationsPagedQueryVariables>) {
        return Apollo.useQuery<TeacherConversationsPagedQuery, TeacherConversationsPagedQueryVariables>(TeacherConversationsPagedDocument, baseOptions);
      }
export function useTeacherConversationsPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherConversationsPagedQuery, TeacherConversationsPagedQueryVariables>) {
          return Apollo.useLazyQuery<TeacherConversationsPagedQuery, TeacherConversationsPagedQueryVariables>(TeacherConversationsPagedDocument, baseOptions);
        }
export type TeacherConversationsPagedQueryHookResult = ReturnType<typeof useTeacherConversationsPagedQuery>;
export type TeacherConversationsPagedLazyQueryHookResult = ReturnType<typeof useTeacherConversationsPagedLazyQuery>;
export type TeacherConversationsPagedQueryResult = Apollo.QueryResult<TeacherConversationsPagedQuery, TeacherConversationsPagedQueryVariables>;
export const GmailMailboxesListDocument = gql`
    query GmailMailboxesList {
  gmailMailboxes {
    id
    email
    displayName
  }
}
    `;

/**
 * __useGmailMailboxesListQuery__
 *
 * To run a query within a React component, call `useGmailMailboxesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGmailMailboxesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGmailMailboxesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGmailMailboxesListQuery(baseOptions?: Apollo.QueryHookOptions<GmailMailboxesListQuery, GmailMailboxesListQueryVariables>) {
        return Apollo.useQuery<GmailMailboxesListQuery, GmailMailboxesListQueryVariables>(GmailMailboxesListDocument, baseOptions);
      }
export function useGmailMailboxesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GmailMailboxesListQuery, GmailMailboxesListQueryVariables>) {
          return Apollo.useLazyQuery<GmailMailboxesListQuery, GmailMailboxesListQueryVariables>(GmailMailboxesListDocument, baseOptions);
        }
export type GmailMailboxesListQueryHookResult = ReturnType<typeof useGmailMailboxesListQuery>;
export type GmailMailboxesListLazyQueryHookResult = ReturnType<typeof useGmailMailboxesListLazyQuery>;
export type GmailMailboxesListQueryResult = Apollo.QueryResult<GmailMailboxesListQuery, GmailMailboxesListQueryVariables>;
export const BroadcastJobProgressDocument = gql`
    query BroadcastJobProgress($id: ID!) {
  broadcastJob(id: $id) {
    id
    status
    total
    sentCount
    failedCount
    errorMessage
    recipients {
      id
      studentName
      status
      reason
    }
  }
}
    `;

/**
 * __useBroadcastJobProgressQuery__
 *
 * To run a query within a React component, call `useBroadcastJobProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastJobProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastJobProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBroadcastJobProgressQuery(baseOptions: Apollo.QueryHookOptions<BroadcastJobProgressQuery, BroadcastJobProgressQueryVariables>) {
        return Apollo.useQuery<BroadcastJobProgressQuery, BroadcastJobProgressQueryVariables>(BroadcastJobProgressDocument, baseOptions);
      }
export function useBroadcastJobProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastJobProgressQuery, BroadcastJobProgressQueryVariables>) {
          return Apollo.useLazyQuery<BroadcastJobProgressQuery, BroadcastJobProgressQueryVariables>(BroadcastJobProgressDocument, baseOptions);
        }
export type BroadcastJobProgressQueryHookResult = ReturnType<typeof useBroadcastJobProgressQuery>;
export type BroadcastJobProgressLazyQueryHookResult = ReturnType<typeof useBroadcastJobProgressLazyQuery>;
export type BroadcastJobProgressQueryResult = Apollo.QueryResult<BroadcastJobProgressQuery, BroadcastJobProgressQueryVariables>;
export const GroupSlackChannelsDocument = gql`
    query GroupSlackChannels($groupId: ID!) {
  groupSlackChannels(groupId: $groupId) {
    slackChannelId
    channelName
    teamId
    conversationId
    unreadCount
    hasUnhandled
    lastMessageAt
  }
}
    `;

/**
 * __useGroupSlackChannelsQuery__
 *
 * To run a query within a React component, call `useGroupSlackChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupSlackChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupSlackChannelsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupSlackChannelsQuery(baseOptions: Apollo.QueryHookOptions<GroupSlackChannelsQuery, GroupSlackChannelsQueryVariables>) {
        return Apollo.useQuery<GroupSlackChannelsQuery, GroupSlackChannelsQueryVariables>(GroupSlackChannelsDocument, baseOptions);
      }
export function useGroupSlackChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupSlackChannelsQuery, GroupSlackChannelsQueryVariables>) {
          return Apollo.useLazyQuery<GroupSlackChannelsQuery, GroupSlackChannelsQueryVariables>(GroupSlackChannelsDocument, baseOptions);
        }
export type GroupSlackChannelsQueryHookResult = ReturnType<typeof useGroupSlackChannelsQuery>;
export type GroupSlackChannelsLazyQueryHookResult = ReturnType<typeof useGroupSlackChannelsLazyQuery>;
export type GroupSlackChannelsQueryResult = Apollo.QueryResult<GroupSlackChannelsQuery, GroupSlackChannelsQueryVariables>;
export const ConversationThreadPageDocument = gql`
    query ConversationThreadPage($conversationId: ID!, $first: Int, $after: String) {
  conversationThread(
    conversationId: $conversationId
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        direction
        authorName
        authorDisplay
        authorExternalId
        kind
        body
        bodyHtml
        attachments {
          index
          name
          size
          mime
          contentId
          inline
        }
        sentAt
        isHandled
        linkedTask {
          id
          title
          status
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useConversationThreadPageQuery__
 *
 * To run a query within a React component, call `useConversationThreadPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationThreadPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationThreadPageQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useConversationThreadPageQuery(baseOptions: Apollo.QueryHookOptions<ConversationThreadPageQuery, ConversationThreadPageQueryVariables>) {
        return Apollo.useQuery<ConversationThreadPageQuery, ConversationThreadPageQueryVariables>(ConversationThreadPageDocument, baseOptions);
      }
export function useConversationThreadPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationThreadPageQuery, ConversationThreadPageQueryVariables>) {
          return Apollo.useLazyQuery<ConversationThreadPageQuery, ConversationThreadPageQueryVariables>(ConversationThreadPageDocument, baseOptions);
        }
export type ConversationThreadPageQueryHookResult = ReturnType<typeof useConversationThreadPageQuery>;
export type ConversationThreadPageLazyQueryHookResult = ReturnType<typeof useConversationThreadPageLazyQuery>;
export type ConversationThreadPageQueryResult = Apollo.QueryResult<ConversationThreadPageQuery, ConversationThreadPageQueryVariables>;
export const DashboardConversationsDocument = gql`
    query DashboardConversations($search: String, $groupId: ID, $studentId: ID, $dateFrom: Date, $dateTo: Date, $unhandledOnly: Boolean, $kinds: [String!], $first: Int, $after: String) {
  conversationsBrowser(
    search: $search
    groupId: $groupId
    studentId: $studentId
    dateFrom: $dateFrom
    dateTo: $dateTo
    unhandledOnly: $unhandledOnly
    kinds: $kinds
    first: $first
    after: $after
  ) {
    totalCount
    totalCountCapped
    edges {
      cursor
      node {
        id
        kind
        displayTitle
        mailboxEmail
        status
        unreadCount
        hasUnhandled
        lastMessageAt
        student {
          id
          user {
            id
            firstName
            lastName
          }
        }
        group {
          id
          name
        }
        workspaceGroup {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useDashboardConversationsQuery__
 *
 * To run a query within a React component, call `useDashboardConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardConversationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      groupId: // value for 'groupId'
 *      studentId: // value for 'studentId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      unhandledOnly: // value for 'unhandledOnly'
 *      kinds: // value for 'kinds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDashboardConversationsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardConversationsQuery, DashboardConversationsQueryVariables>) {
        return Apollo.useQuery<DashboardConversationsQuery, DashboardConversationsQueryVariables>(DashboardConversationsDocument, baseOptions);
      }
export function useDashboardConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardConversationsQuery, DashboardConversationsQueryVariables>) {
          return Apollo.useLazyQuery<DashboardConversationsQuery, DashboardConversationsQueryVariables>(DashboardConversationsDocument, baseOptions);
        }
export type DashboardConversationsQueryHookResult = ReturnType<typeof useDashboardConversationsQuery>;
export type DashboardConversationsLazyQueryHookResult = ReturnType<typeof useDashboardConversationsLazyQuery>;
export type DashboardConversationsQueryResult = Apollo.QueryResult<DashboardConversationsQuery, DashboardConversationsQueryVariables>;
export const GroupCommsIndexBadgesDocument = gql`
    query GroupCommsIndexBadges($groupId: ID!) {
  groupCommsIndex(groupId: $groupId) {
    groupId
    channelsUnread
    channelsUnhandled
    slackUnreadTotal
    mailUnreadTotal
    slackUnhandled
    mailUnhandled
    pendingConversations
    students {
      studentId
      firstName
      lastName
      email
      inRoster
      terminated
      unread
      unreadSlack
      unreadMail
      unhandled
      unhandledSlack
      unhandledMail
    }
    teachers {
      teacherId
      firstName
      lastName
      email
      unread
      unreadSlack
      unreadMail
      unhandled
      unhandledSlack
      unhandledMail
    }
  }
}
    `;

/**
 * __useGroupCommsIndexBadgesQuery__
 *
 * To run a query within a React component, call `useGroupCommsIndexBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupCommsIndexBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupCommsIndexBadgesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupCommsIndexBadgesQuery(baseOptions: Apollo.QueryHookOptions<GroupCommsIndexBadgesQuery, GroupCommsIndexBadgesQueryVariables>) {
        return Apollo.useQuery<GroupCommsIndexBadgesQuery, GroupCommsIndexBadgesQueryVariables>(GroupCommsIndexBadgesDocument, baseOptions);
      }
export function useGroupCommsIndexBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupCommsIndexBadgesQuery, GroupCommsIndexBadgesQueryVariables>) {
          return Apollo.useLazyQuery<GroupCommsIndexBadgesQuery, GroupCommsIndexBadgesQueryVariables>(GroupCommsIndexBadgesDocument, baseOptions);
        }
export type GroupCommsIndexBadgesQueryHookResult = ReturnType<typeof useGroupCommsIndexBadgesQuery>;
export type GroupCommsIndexBadgesLazyQueryHookResult = ReturnType<typeof useGroupCommsIndexBadgesLazyQuery>;
export type GroupCommsIndexBadgesQueryResult = Apollo.QueryResult<GroupCommsIndexBadgesQuery, GroupCommsIndexBadgesQueryVariables>;
export const StudentSlackUserDocument = gql`
    query StudentSlackUser($studentId: ID!) {
  slackUserLink(studentId: $studentId) {
    id
    slackUserId
    email
  }
}
    `;

/**
 * __useStudentSlackUserQuery__
 *
 * To run a query within a React component, call `useStudentSlackUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSlackUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSlackUserQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentSlackUserQuery(baseOptions: Apollo.QueryHookOptions<StudentSlackUserQuery, StudentSlackUserQueryVariables>) {
        return Apollo.useQuery<StudentSlackUserQuery, StudentSlackUserQueryVariables>(StudentSlackUserDocument, baseOptions);
      }
export function useStudentSlackUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentSlackUserQuery, StudentSlackUserQueryVariables>) {
          return Apollo.useLazyQuery<StudentSlackUserQuery, StudentSlackUserQueryVariables>(StudentSlackUserDocument, baseOptions);
        }
export type StudentSlackUserQueryHookResult = ReturnType<typeof useStudentSlackUserQuery>;
export type StudentSlackUserLazyQueryHookResult = ReturnType<typeof useStudentSlackUserLazyQuery>;
export type StudentSlackUserQueryResult = Apollo.QueryResult<StudentSlackUserQuery, StudentSlackUserQueryVariables>;
export const SlackOauthRedirectUriDocument = gql`
    query SlackOauthRedirectUri {
  slackOauthRedirectUri
}
    `;

/**
 * __useSlackOauthRedirectUriQuery__
 *
 * To run a query within a React component, call `useSlackOauthRedirectUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlackOauthRedirectUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlackOauthRedirectUriQuery({
 *   variables: {
 *   },
 * });
 */
export function useSlackOauthRedirectUriQuery(baseOptions?: Apollo.QueryHookOptions<SlackOauthRedirectUriQuery, SlackOauthRedirectUriQueryVariables>) {
        return Apollo.useQuery<SlackOauthRedirectUriQuery, SlackOauthRedirectUriQueryVariables>(SlackOauthRedirectUriDocument, baseOptions);
      }
export function useSlackOauthRedirectUriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlackOauthRedirectUriQuery, SlackOauthRedirectUriQueryVariables>) {
          return Apollo.useLazyQuery<SlackOauthRedirectUriQuery, SlackOauthRedirectUriQueryVariables>(SlackOauthRedirectUriDocument, baseOptions);
        }
export type SlackOauthRedirectUriQueryHookResult = ReturnType<typeof useSlackOauthRedirectUriQuery>;
export type SlackOauthRedirectUriLazyQueryHookResult = ReturnType<typeof useSlackOauthRedirectUriLazyQuery>;
export type SlackOauthRedirectUriQueryResult = Apollo.QueryResult<SlackOauthRedirectUriQuery, SlackOauthRedirectUriQueryVariables>;
export const GroupSlackWorkspaceDocument = gql`
    query GroupSlackWorkspace($groupId: ID!) {
  slackWorkspaceLink(groupId: $groupId) {
    id
    teamId
    workspaceName
    enabled
    channelCount
    oauthConfigured
  }
}
    `;

/**
 * __useGroupSlackWorkspaceQuery__
 *
 * To run a query within a React component, call `useGroupSlackWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupSlackWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupSlackWorkspaceQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupSlackWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GroupSlackWorkspaceQuery, GroupSlackWorkspaceQueryVariables>) {
        return Apollo.useQuery<GroupSlackWorkspaceQuery, GroupSlackWorkspaceQueryVariables>(GroupSlackWorkspaceDocument, baseOptions);
      }
export function useGroupSlackWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupSlackWorkspaceQuery, GroupSlackWorkspaceQueryVariables>) {
          return Apollo.useLazyQuery<GroupSlackWorkspaceQuery, GroupSlackWorkspaceQueryVariables>(GroupSlackWorkspaceDocument, baseOptions);
        }
export type GroupSlackWorkspaceQueryHookResult = ReturnType<typeof useGroupSlackWorkspaceQuery>;
export type GroupSlackWorkspaceLazyQueryHookResult = ReturnType<typeof useGroupSlackWorkspaceLazyQuery>;
export type GroupSlackWorkspaceQueryResult = Apollo.QueryResult<GroupSlackWorkspaceQuery, GroupSlackWorkspaceQueryVariables>;
export const GroupSlackMembersDocument = gql`
    query GroupSlackMembers($groupId: ID!, $unmatchedOnly: Boolean) {
  slackWorkspaceMembers(groupId: $groupId, unmatchedOnly: $unmatchedOnly) {
    id
    slackUserId
    email
    displayName
    student {
      id
    }
  }
}
    `;

/**
 * __useGroupSlackMembersQuery__
 *
 * To run a query within a React component, call `useGroupSlackMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupSlackMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupSlackMembersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      unmatchedOnly: // value for 'unmatchedOnly'
 *   },
 * });
 */
export function useGroupSlackMembersQuery(baseOptions: Apollo.QueryHookOptions<GroupSlackMembersQuery, GroupSlackMembersQueryVariables>) {
        return Apollo.useQuery<GroupSlackMembersQuery, GroupSlackMembersQueryVariables>(GroupSlackMembersDocument, baseOptions);
      }
export function useGroupSlackMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupSlackMembersQuery, GroupSlackMembersQueryVariables>) {
          return Apollo.useLazyQuery<GroupSlackMembersQuery, GroupSlackMembersQueryVariables>(GroupSlackMembersDocument, baseOptions);
        }
export type GroupSlackMembersQueryHookResult = ReturnType<typeof useGroupSlackMembersQuery>;
export type GroupSlackMembersLazyQueryHookResult = ReturnType<typeof useGroupSlackMembersLazyQuery>;
export type GroupSlackMembersQueryResult = Apollo.QueryResult<GroupSlackMembersQuery, GroupSlackMembersQueryVariables>;
export const MySlackTokenStatusDocument = gql`
    query MySlackTokenStatus($groupId: ID!) {
  mySlackUserToken(groupId: $groupId) {
    hasToken
    slackUserId
  }
}
    `;

/**
 * __useMySlackTokenStatusQuery__
 *
 * To run a query within a React component, call `useMySlackTokenStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySlackTokenStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySlackTokenStatusQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useMySlackTokenStatusQuery(baseOptions: Apollo.QueryHookOptions<MySlackTokenStatusQuery, MySlackTokenStatusQueryVariables>) {
        return Apollo.useQuery<MySlackTokenStatusQuery, MySlackTokenStatusQueryVariables>(MySlackTokenStatusDocument, baseOptions);
      }
export function useMySlackTokenStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySlackTokenStatusQuery, MySlackTokenStatusQueryVariables>) {
          return Apollo.useLazyQuery<MySlackTokenStatusQuery, MySlackTokenStatusQueryVariables>(MySlackTokenStatusDocument, baseOptions);
        }
export type MySlackTokenStatusQueryHookResult = ReturnType<typeof useMySlackTokenStatusQuery>;
export type MySlackTokenStatusLazyQueryHookResult = ReturnType<typeof useMySlackTokenStatusLazyQuery>;
export type MySlackTokenStatusQueryResult = Apollo.QueryResult<MySlackTokenStatusQuery, MySlackTokenStatusQueryVariables>;
export const ConversationReplyIdentityDocument = gql`
    query ConversationReplyIdentity($conversationId: ID!) {
  replyIdentity(conversationId: $conversationId) {
    via
    name
  }
}
    `;

/**
 * __useConversationReplyIdentityQuery__
 *
 * To run a query within a React component, call `useConversationReplyIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationReplyIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationReplyIdentityQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationReplyIdentityQuery(baseOptions: Apollo.QueryHookOptions<ConversationReplyIdentityQuery, ConversationReplyIdentityQueryVariables>) {
        return Apollo.useQuery<ConversationReplyIdentityQuery, ConversationReplyIdentityQueryVariables>(ConversationReplyIdentityDocument, baseOptions);
      }
export function useConversationReplyIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationReplyIdentityQuery, ConversationReplyIdentityQueryVariables>) {
          return Apollo.useLazyQuery<ConversationReplyIdentityQuery, ConversationReplyIdentityQueryVariables>(ConversationReplyIdentityDocument, baseOptions);
        }
export type ConversationReplyIdentityQueryHookResult = ReturnType<typeof useConversationReplyIdentityQuery>;
export type ConversationReplyIdentityLazyQueryHookResult = ReturnType<typeof useConversationReplyIdentityLazyQuery>;
export type ConversationReplyIdentityQueryResult = Apollo.QueryResult<ConversationReplyIdentityQuery, ConversationReplyIdentityQueryVariables>;
export const GroupMessagesFeedDocument = gql`
    query GroupMessagesFeed($groupId: ID!, $first: Int, $after: String, $search: String, $unreadOnly: Boolean, $flaggedOnly: Boolean, $unhandledOnly: Boolean, $channelId: ID) {
  groupMessages(
    groupId: $groupId
    first: $first
    after: $after
    search: $search
    unreadOnly: $unreadOnly
    flaggedOnly: $flaggedOnly
    unhandledOnly: $unhandledOnly
    channelId: $channelId
  ) {
    edges {
      cursor
      node {
        id
        conversationId
        channelName
        kind
        direction
        authorName
        authorDisplay
        body
        sentAt
        isRead
        isFlagged
        isHandled
        linkedTask {
          id
          title
          status
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGroupMessagesFeedQuery__
 *
 * To run a query within a React component, call `useGroupMessagesFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMessagesFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMessagesFeedQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      unreadOnly: // value for 'unreadOnly'
 *      flaggedOnly: // value for 'flaggedOnly'
 *      unhandledOnly: // value for 'unhandledOnly'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGroupMessagesFeedQuery(baseOptions: Apollo.QueryHookOptions<GroupMessagesFeedQuery, GroupMessagesFeedQueryVariables>) {
        return Apollo.useQuery<GroupMessagesFeedQuery, GroupMessagesFeedQueryVariables>(GroupMessagesFeedDocument, baseOptions);
      }
export function useGroupMessagesFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupMessagesFeedQuery, GroupMessagesFeedQueryVariables>) {
          return Apollo.useLazyQuery<GroupMessagesFeedQuery, GroupMessagesFeedQueryVariables>(GroupMessagesFeedDocument, baseOptions);
        }
export type GroupMessagesFeedQueryHookResult = ReturnType<typeof useGroupMessagesFeedQuery>;
export type GroupMessagesFeedLazyQueryHookResult = ReturnType<typeof useGroupMessagesFeedLazyQuery>;
export type GroupMessagesFeedQueryResult = Apollo.QueryResult<GroupMessagesFeedQuery, GroupMessagesFeedQueryVariables>;
export const CommsIntegrationsHealthDocument = gql`
    query CommsIntegrationsHealth {
  communicationsHealth {
    slackSyncEnabled
    gmailSyncEnabled
    mailboxesEnabled
    lastSlackRun {
      status
      startedAt
      stats
      errorMessage
    }
    lastGmailRun {
      status
      startedAt
      stats
      errorMessage
    }
    groups {
      groupId
      groupName
      studentsCount
      workspaceLinked
      teamId
      workspaceEnabled
      hasBotToken
      realtimeConfigured
      hasMyManagerToken
      inSyncWindow
      channelsLinked
      channelsMirrored
      membersTotal
      membersMatched
      slackMessages
      mailThreads
      lastInboundAt
      lastSyncAt
      verdict
    }
  }
}
    `;

/**
 * __useCommsIntegrationsHealthQuery__
 *
 * To run a query within a React component, call `useCommsIntegrationsHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommsIntegrationsHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommsIntegrationsHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommsIntegrationsHealthQuery(baseOptions?: Apollo.QueryHookOptions<CommsIntegrationsHealthQuery, CommsIntegrationsHealthQueryVariables>) {
        return Apollo.useQuery<CommsIntegrationsHealthQuery, CommsIntegrationsHealthQueryVariables>(CommsIntegrationsHealthDocument, baseOptions);
      }
export function useCommsIntegrationsHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommsIntegrationsHealthQuery, CommsIntegrationsHealthQueryVariables>) {
          return Apollo.useLazyQuery<CommsIntegrationsHealthQuery, CommsIntegrationsHealthQueryVariables>(CommsIntegrationsHealthDocument, baseOptions);
        }
export type CommsIntegrationsHealthQueryHookResult = ReturnType<typeof useCommsIntegrationsHealthQuery>;
export type CommsIntegrationsHealthLazyQueryHookResult = ReturnType<typeof useCommsIntegrationsHealthLazyQuery>;
export type CommsIntegrationsHealthQueryResult = Apollo.QueryResult<CommsIntegrationsHealthQuery, CommsIntegrationsHealthQueryVariables>;
export const MessageInlineImagesListDocument = gql`
    query MessageInlineImagesList($messageId: ID!) {
  messageInlineImages(messageId: $messageId) {
    cid
    url
  }
}
    `;

/**
 * __useMessageInlineImagesListQuery__
 *
 * To run a query within a React component, call `useMessageInlineImagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageInlineImagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageInlineImagesListQuery({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useMessageInlineImagesListQuery(baseOptions: Apollo.QueryHookOptions<MessageInlineImagesListQuery, MessageInlineImagesListQueryVariables>) {
        return Apollo.useQuery<MessageInlineImagesListQuery, MessageInlineImagesListQueryVariables>(MessageInlineImagesListDocument, baseOptions);
      }
export function useMessageInlineImagesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageInlineImagesListQuery, MessageInlineImagesListQueryVariables>) {
          return Apollo.useLazyQuery<MessageInlineImagesListQuery, MessageInlineImagesListQueryVariables>(MessageInlineImagesListDocument, baseOptions);
        }
export type MessageInlineImagesListQueryHookResult = ReturnType<typeof useMessageInlineImagesListQuery>;
export type MessageInlineImagesListLazyQueryHookResult = ReturnType<typeof useMessageInlineImagesListLazyQuery>;
export type MessageInlineImagesListQueryResult = Apollo.QueryResult<MessageInlineImagesListQuery, MessageInlineImagesListQueryVariables>;
export const GetAllCompaniesDocument = gql`
    query getAllCompanies {
  allCompanies {
    edges {
      node {
        id
        name
        comment
      }
    }
  }
}
    `;

/**
 * __useGetAllCompaniesQuery__
 *
 * To run a query within a React component, call `useGetAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
        return Apollo.useQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, baseOptions);
      }
export function useGetAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
          return Apollo.useLazyQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, baseOptions);
        }
export type GetAllCompaniesQueryHookResult = ReturnType<typeof useGetAllCompaniesQuery>;
export type GetAllCompaniesLazyQueryHookResult = ReturnType<typeof useGetAllCompaniesLazyQuery>;
export type GetAllCompaniesQueryResult = Apollo.QueryResult<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>;
export const GetCompanyByIdDocument = gql`
    query getCompanyById($id: ID!) {
  company(id: $id) {
    id
    name
    responsiblePerson
    email
    phone
    registrationNumber
    comment
  }
}
    `;

/**
 * __useGetCompanyByIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>) {
        return Apollo.useQuery<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>(GetCompanyByIdDocument, baseOptions);
      }
export function useGetCompanyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>(GetCompanyByIdDocument, baseOptions);
        }
export type GetCompanyByIdQueryHookResult = ReturnType<typeof useGetCompanyByIdQuery>;
export type GetCompanyByIdLazyQueryHookResult = ReturnType<typeof useGetCompanyByIdLazyQuery>;
export type GetCompanyByIdQueryResult = Apollo.QueryResult<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>;
export const GetCountriesForTeachersDocument = gql`
    query GetCountriesForTeachers($before: String, $after: String, $first: Int, $last: Int) {
  allCountries(before: $before, after: $after, first: $first, last: $last) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetCountriesForTeachersQuery__
 *
 * To run a query within a React component, call `useGetCountriesForTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesForTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesForTeachersQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetCountriesForTeachersQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesForTeachersQuery, GetCountriesForTeachersQueryVariables>) {
        return Apollo.useQuery<GetCountriesForTeachersQuery, GetCountriesForTeachersQueryVariables>(GetCountriesForTeachersDocument, baseOptions);
      }
export function useGetCountriesForTeachersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesForTeachersQuery, GetCountriesForTeachersQueryVariables>) {
          return Apollo.useLazyQuery<GetCountriesForTeachersQuery, GetCountriesForTeachersQueryVariables>(GetCountriesForTeachersDocument, baseOptions);
        }
export type GetCountriesForTeachersQueryHookResult = ReturnType<typeof useGetCountriesForTeachersQuery>;
export type GetCountriesForTeachersLazyQueryHookResult = ReturnType<typeof useGetCountriesForTeachersLazyQuery>;
export type GetCountriesForTeachersQueryResult = Apollo.QueryResult<GetCountriesForTeachersQuery, GetCountriesForTeachersQueryVariables>;
export const PaginatedCoursesDocument = gql`
    query PaginatedCourses($query: String, $first: Int, $after: String) {
  allCourses(query: $query, first: $first, after: $after) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        name
        educationForm
        category {
          name
        }
      }
    }
  }
}
    `;

/**
 * __usePaginatedCoursesQuery__
 *
 * To run a query within a React component, call `usePaginatedCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCoursesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaginatedCoursesQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedCoursesQuery, PaginatedCoursesQueryVariables>) {
        return Apollo.useQuery<PaginatedCoursesQuery, PaginatedCoursesQueryVariables>(PaginatedCoursesDocument, baseOptions);
      }
export function usePaginatedCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedCoursesQuery, PaginatedCoursesQueryVariables>) {
          return Apollo.useLazyQuery<PaginatedCoursesQuery, PaginatedCoursesQueryVariables>(PaginatedCoursesDocument, baseOptions);
        }
export type PaginatedCoursesQueryHookResult = ReturnType<typeof usePaginatedCoursesQuery>;
export type PaginatedCoursesLazyQueryHookResult = ReturnType<typeof usePaginatedCoursesLazyQuery>;
export type PaginatedCoursesQueryResult = Apollo.QueryResult<PaginatedCoursesQuery, PaginatedCoursesQueryVariables>;
export const GetCoursesForOptionsDocument = gql`
    query GetCoursesForOptions($agreementDate: Date!) {
  allCourses {
    edges {
      node {
        id
        name
        groups(hideCompleted: $agreementDate) {
          edges {
            node {
              id
              name
              price
              currency
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCoursesForOptionsQuery__
 *
 * To run a query within a React component, call `useGetCoursesForOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesForOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesForOptionsQuery({
 *   variables: {
 *      agreementDate: // value for 'agreementDate'
 *   },
 * });
 */
export function useGetCoursesForOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesForOptionsQuery, GetCoursesForOptionsQueryVariables>) {
        return Apollo.useQuery<GetCoursesForOptionsQuery, GetCoursesForOptionsQueryVariables>(GetCoursesForOptionsDocument, baseOptions);
      }
export function useGetCoursesForOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesForOptionsQuery, GetCoursesForOptionsQueryVariables>) {
          return Apollo.useLazyQuery<GetCoursesForOptionsQuery, GetCoursesForOptionsQueryVariables>(GetCoursesForOptionsDocument, baseOptions);
        }
export type GetCoursesForOptionsQueryHookResult = ReturnType<typeof useGetCoursesForOptionsQuery>;
export type GetCoursesForOptionsLazyQueryHookResult = ReturnType<typeof useGetCoursesForOptionsLazyQuery>;
export type GetCoursesForOptionsQueryResult = Apollo.QueryResult<GetCoursesForOptionsQuery, GetCoursesForOptionsQueryVariables>;
export const GetCoursesForTeacherDocument = gql`
    query GetCoursesForTeacher($first: Int, $query: String) {
  allCourses(first: $first, query: $query) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCoursesForTeacherQuery__
 *
 * To run a query within a React component, call `useGetCoursesForTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesForTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesForTeacherQuery({
 *   variables: {
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetCoursesForTeacherQuery(baseOptions?: Apollo.QueryHookOptions<GetCoursesForTeacherQuery, GetCoursesForTeacherQueryVariables>) {
        return Apollo.useQuery<GetCoursesForTeacherQuery, GetCoursesForTeacherQueryVariables>(GetCoursesForTeacherDocument, baseOptions);
      }
export function useGetCoursesForTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesForTeacherQuery, GetCoursesForTeacherQueryVariables>) {
          return Apollo.useLazyQuery<GetCoursesForTeacherQuery, GetCoursesForTeacherQueryVariables>(GetCoursesForTeacherDocument, baseOptions);
        }
export type GetCoursesForTeacherQueryHookResult = ReturnType<typeof useGetCoursesForTeacherQuery>;
export type GetCoursesForTeacherLazyQueryHookResult = ReturnType<typeof useGetCoursesForTeacherLazyQuery>;
export type GetCoursesForTeacherQueryResult = Apollo.QueryResult<GetCoursesForTeacherQuery, GetCoursesForTeacherQueryVariables>;
export const GetCourseDataForGroupDocument = gql`
    query getCourseDataForGroup($id: ID!) {
  course(courseId: $id) {
    id
    name
    price
    currency
    teachers {
      edges {
        node {
          id
          fullName
        }
      }
    }
    modules {
      id
      name
      lessons {
        edges {
          node {
            id
            index
            name
            lmsDescription
            taskTypes
            teacherAttachments {
              edges {
                node {
                  id
                }
              }
            }
            studentAttachments {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseDataForGroupQuery__
 *
 * To run a query within a React component, call `useGetCourseDataForGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseDataForGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseDataForGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseDataForGroupQuery(baseOptions: Apollo.QueryHookOptions<GetCourseDataForGroupQuery, GetCourseDataForGroupQueryVariables>) {
        return Apollo.useQuery<GetCourseDataForGroupQuery, GetCourseDataForGroupQueryVariables>(GetCourseDataForGroupDocument, baseOptions);
      }
export function useGetCourseDataForGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseDataForGroupQuery, GetCourseDataForGroupQueryVariables>) {
          return Apollo.useLazyQuery<GetCourseDataForGroupQuery, GetCourseDataForGroupQueryVariables>(GetCourseDataForGroupDocument, baseOptions);
        }
export type GetCourseDataForGroupQueryHookResult = ReturnType<typeof useGetCourseDataForGroupQuery>;
export type GetCourseDataForGroupLazyQueryHookResult = ReturnType<typeof useGetCourseDataForGroupLazyQuery>;
export type GetCourseDataForGroupQueryResult = Apollo.QueryResult<GetCourseDataForGroupQuery, GetCourseDataForGroupQueryVariables>;
export const GetCourseDataForApplicationDocument = gql`
    query getCourseDataForApplication($id: ID!, $groupsDate: Date!) {
  course(courseId: $id) {
    groups(hideCompleted: $groupsDate) {
      edges {
        node {
          id
          name
          freeLessonsCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseDataForApplicationQuery__
 *
 * To run a query within a React component, call `useGetCourseDataForApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseDataForApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseDataForApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      groupsDate: // value for 'groupsDate'
 *   },
 * });
 */
export function useGetCourseDataForApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetCourseDataForApplicationQuery, GetCourseDataForApplicationQueryVariables>) {
        return Apollo.useQuery<GetCourseDataForApplicationQuery, GetCourseDataForApplicationQueryVariables>(GetCourseDataForApplicationDocument, baseOptions);
      }
export function useGetCourseDataForApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseDataForApplicationQuery, GetCourseDataForApplicationQueryVariables>) {
          return Apollo.useLazyQuery<GetCourseDataForApplicationQuery, GetCourseDataForApplicationQueryVariables>(GetCourseDataForApplicationDocument, baseOptions);
        }
export type GetCourseDataForApplicationQueryHookResult = ReturnType<typeof useGetCourseDataForApplicationQuery>;
export type GetCourseDataForApplicationLazyQueryHookResult = ReturnType<typeof useGetCourseDataForApplicationLazyQuery>;
export type GetCourseDataForApplicationQueryResult = Apollo.QueryResult<GetCourseDataForApplicationQuery, GetCourseDataForApplicationQueryVariables>;
export const CourseTariffPricesDocument = gql`
    query CourseTariffPrices($courseId: ID!) {
  coursePlanPrices(courseId: $courseId) {
    id
    courseId
    planId
    planName
    planIsActive
    currency
    amount
  }
}
    `;

/**
 * __useCourseTariffPricesQuery__
 *
 * To run a query within a React component, call `useCourseTariffPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseTariffPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseTariffPricesQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseTariffPricesQuery(baseOptions: Apollo.QueryHookOptions<CourseTariffPricesQuery, CourseTariffPricesQueryVariables>) {
        return Apollo.useQuery<CourseTariffPricesQuery, CourseTariffPricesQueryVariables>(CourseTariffPricesDocument, baseOptions);
      }
export function useCourseTariffPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseTariffPricesQuery, CourseTariffPricesQueryVariables>) {
          return Apollo.useLazyQuery<CourseTariffPricesQuery, CourseTariffPricesQueryVariables>(CourseTariffPricesDocument, baseOptions);
        }
export type CourseTariffPricesQueryHookResult = ReturnType<typeof useCourseTariffPricesQuery>;
export type CourseTariffPricesLazyQueryHookResult = ReturnType<typeof useCourseTariffPricesLazyQuery>;
export type CourseTariffPricesQueryResult = Apollo.QueryResult<CourseTariffPricesQuery, CourseTariffPricesQueryVariables>;
export const CourseCardNameDocument = gql`
    query CourseCardName($id: ID!) {
  course(courseId: $id) {
    id
    name
  }
}
    `;

/**
 * __useCourseCardNameQuery__
 *
 * To run a query within a React component, call `useCourseCardNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseCardNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseCardNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseCardNameQuery(baseOptions: Apollo.QueryHookOptions<CourseCardNameQuery, CourseCardNameQueryVariables>) {
        return Apollo.useQuery<CourseCardNameQuery, CourseCardNameQueryVariables>(CourseCardNameDocument, baseOptions);
      }
export function useCourseCardNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseCardNameQuery, CourseCardNameQueryVariables>) {
          return Apollo.useLazyQuery<CourseCardNameQuery, CourseCardNameQueryVariables>(CourseCardNameDocument, baseOptions);
        }
export type CourseCardNameQueryHookResult = ReturnType<typeof useCourseCardNameQuery>;
export type CourseCardNameLazyQueryHookResult = ReturnType<typeof useCourseCardNameLazyQuery>;
export type CourseCardNameQueryResult = Apollo.QueryResult<CourseCardNameQuery, CourseCardNameQueryVariables>;
export const KommoLeadListDocument = gql`
    query KommoLeadList($statusIds: [ID!], $responsible: String, $search: String, $includeClosed: Boolean, $ladder: String, $utmSource: [String!], $utmMedium: [String!], $utmCampaign: [String!], $fundingStatus: [String!], $hasFunding: Boolean, $hasStudent: Boolean, $createdFrom: Date, $sort: String, $offset: Int, $limit: Int, $aploraMinWinChance: Float, $nextContact: String, $aploraCategories: [String]) {
  kommoLeads(
    statusIds: $statusIds
    responsible: $responsible
    search: $search
    includeClosed: $includeClosed
    ladder: $ladder
    utmSource: $utmSource
    utmMedium: $utmMedium
    utmCampaign: $utmCampaign
    fundingStatus: $fundingStatus
    hasFunding: $hasFunding
    hasStudent: $hasStudent
    createdFrom: $createdFrom
    sort: $sort
    offset: $offset
    limit: $limit
    aploraMinWinChance: $aploraMinWinChance
    nextContact: $nextContact
    aploraCategories: $aploraCategories
  ) {
    items {
      ...KommoLeadRowFields
    }
    total
    source
    syncedAt
  }
}
    ${KommoLeadRowFieldsFragmentDoc}`;

/**
 * __useKommoLeadListQuery__
 *
 * To run a query within a React component, call `useKommoLeadListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadListQuery({
 *   variables: {
 *      statusIds: // value for 'statusIds'
 *      responsible: // value for 'responsible'
 *      search: // value for 'search'
 *      includeClosed: // value for 'includeClosed'
 *      ladder: // value for 'ladder'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      fundingStatus: // value for 'fundingStatus'
 *      hasFunding: // value for 'hasFunding'
 *      hasStudent: // value for 'hasStudent'
 *      createdFrom: // value for 'createdFrom'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      aploraMinWinChance: // value for 'aploraMinWinChance'
 *      nextContact: // value for 'nextContact'
 *      aploraCategories: // value for 'aploraCategories'
 *   },
 * });
 */
export function useKommoLeadListQuery(baseOptions?: Apollo.QueryHookOptions<KommoLeadListQuery, KommoLeadListQueryVariables>) {
        return Apollo.useQuery<KommoLeadListQuery, KommoLeadListQueryVariables>(KommoLeadListDocument, baseOptions);
      }
export function useKommoLeadListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadListQuery, KommoLeadListQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadListQuery, KommoLeadListQueryVariables>(KommoLeadListDocument, baseOptions);
        }
export type KommoLeadListQueryHookResult = ReturnType<typeof useKommoLeadListQuery>;
export type KommoLeadListLazyQueryHookResult = ReturnType<typeof useKommoLeadListLazyQuery>;
export type KommoLeadListQueryResult = Apollo.QueryResult<KommoLeadListQuery, KommoLeadListQueryVariables>;
export const KommoLeadFacetsDocument = gql`
    query KommoLeadFacets($includeClosed: Boolean, $aploraMinWinChance: Float, $nextContact: String, $aploraCategories: [String]) {
  kommoLeadFacets(
    includeClosed: $includeClosed
    aploraMinWinChance: $aploraMinWinChance
    nextContact: $nextContact
    aploraCategories: $aploraCategories
  ) {
    utmSource {
      value
      count
    }
    utmMedium {
      value
      count
    }
    utmCampaign {
      value
      count
    }
    fundingStatus {
      value
      count
    }
    withFunding
    withStudent
  }
}
    `;

/**
 * __useKommoLeadFacetsQuery__
 *
 * To run a query within a React component, call `useKommoLeadFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadFacetsQuery({
 *   variables: {
 *      includeClosed: // value for 'includeClosed'
 *      aploraMinWinChance: // value for 'aploraMinWinChance'
 *      nextContact: // value for 'nextContact'
 *      aploraCategories: // value for 'aploraCategories'
 *   },
 * });
 */
export function useKommoLeadFacetsQuery(baseOptions?: Apollo.QueryHookOptions<KommoLeadFacetsQuery, KommoLeadFacetsQueryVariables>) {
        return Apollo.useQuery<KommoLeadFacetsQuery, KommoLeadFacetsQueryVariables>(KommoLeadFacetsDocument, baseOptions);
      }
export function useKommoLeadFacetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadFacetsQuery, KommoLeadFacetsQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadFacetsQuery, KommoLeadFacetsQueryVariables>(KommoLeadFacetsDocument, baseOptions);
        }
export type KommoLeadFacetsQueryHookResult = ReturnType<typeof useKommoLeadFacetsQuery>;
export type KommoLeadFacetsLazyQueryHookResult = ReturnType<typeof useKommoLeadFacetsLazyQuery>;
export type KommoLeadFacetsQueryResult = Apollo.QueryResult<KommoLeadFacetsQuery, KommoLeadFacetsQueryVariables>;
export const KommoLeadStageListDocument = gql`
    query KommoLeadStageList {
  kommoLeadStages {
    ...KommoStageFields
    leadsCount
  }
}
    ${KommoStageFieldsFragmentDoc}`;

/**
 * __useKommoLeadStageListQuery__
 *
 * To run a query within a React component, call `useKommoLeadStageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadStageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadStageListQuery({
 *   variables: {
 *   },
 * });
 */
export function useKommoLeadStageListQuery(baseOptions?: Apollo.QueryHookOptions<KommoLeadStageListQuery, KommoLeadStageListQueryVariables>) {
        return Apollo.useQuery<KommoLeadStageListQuery, KommoLeadStageListQueryVariables>(KommoLeadStageListDocument, baseOptions);
      }
export function useKommoLeadStageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadStageListQuery, KommoLeadStageListQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadStageListQuery, KommoLeadStageListQueryVariables>(KommoLeadStageListDocument, baseOptions);
        }
export type KommoLeadStageListQueryHookResult = ReturnType<typeof useKommoLeadStageListQuery>;
export type KommoLeadStageListLazyQueryHookResult = ReturnType<typeof useKommoLeadStageListLazyQuery>;
export type KommoLeadStageListQueryResult = Apollo.QueryResult<KommoLeadStageListQuery, KommoLeadStageListQueryVariables>;
export const KommoLeadCardDocument = gql`
    query KommoLeadCard($id: ID!) {
  kommoLead(id: $id) {
    ...KommoLeadCardFields
  }
}
    ${KommoLeadCardFieldsFragmentDoc}`;

/**
 * __useKommoLeadCardQuery__
 *
 * To run a query within a React component, call `useKommoLeadCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKommoLeadCardQuery(baseOptions: Apollo.QueryHookOptions<KommoLeadCardQuery, KommoLeadCardQueryVariables>) {
        return Apollo.useQuery<KommoLeadCardQuery, KommoLeadCardQueryVariables>(KommoLeadCardDocument, baseOptions);
      }
export function useKommoLeadCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadCardQuery, KommoLeadCardQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadCardQuery, KommoLeadCardQueryVariables>(KommoLeadCardDocument, baseOptions);
        }
export type KommoLeadCardQueryHookResult = ReturnType<typeof useKommoLeadCardQuery>;
export type KommoLeadCardLazyQueryHookResult = ReturnType<typeof useKommoLeadCardLazyQuery>;
export type KommoLeadCardQueryResult = Apollo.QueryResult<KommoLeadCardQuery, KommoLeadCardQueryVariables>;
export const ContractLeadLadderHeadDocument = gql`
    query ContractLeadLadderHead($id: ID!) {
  kommoLead(id: $id) {
    id
    personName
    isClosed
    inPipeline
    isDeleted
    ladderReadiness {
      kind
      warning
      firstSms
      firstSmsSegments
    }
  }
}
    `;

/**
 * __useContractLeadLadderHeadQuery__
 *
 * To run a query within a React component, call `useContractLeadLadderHeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractLeadLadderHeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractLeadLadderHeadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractLeadLadderHeadQuery(baseOptions: Apollo.QueryHookOptions<ContractLeadLadderHeadQuery, ContractLeadLadderHeadQueryVariables>) {
        return Apollo.useQuery<ContractLeadLadderHeadQuery, ContractLeadLadderHeadQueryVariables>(ContractLeadLadderHeadDocument, baseOptions);
      }
export function useContractLeadLadderHeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractLeadLadderHeadQuery, ContractLeadLadderHeadQueryVariables>) {
          return Apollo.useLazyQuery<ContractLeadLadderHeadQuery, ContractLeadLadderHeadQueryVariables>(ContractLeadLadderHeadDocument, baseOptions);
        }
export type ContractLeadLadderHeadQueryHookResult = ReturnType<typeof useContractLeadLadderHeadQuery>;
export type ContractLeadLadderHeadLazyQueryHookResult = ReturnType<typeof useContractLeadLadderHeadLazyQuery>;
export type ContractLeadLadderHeadQueryResult = Apollo.QueryResult<ContractLeadLadderHeadQuery, ContractLeadLadderHeadQueryVariables>;
export const KommoLeadNoteListDocument = gql`
    query KommoLeadNoteList($leadId: ID!) {
  kommoLeadNotes(leadId: $leadId) {
    items {
      ...KommoNoteFields
    }
    error {
      code
      message
    }
  }
}
    ${KommoNoteFieldsFragmentDoc}`;

/**
 * __useKommoLeadNoteListQuery__
 *
 * To run a query within a React component, call `useKommoLeadNoteListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadNoteListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadNoteListQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useKommoLeadNoteListQuery(baseOptions: Apollo.QueryHookOptions<KommoLeadNoteListQuery, KommoLeadNoteListQueryVariables>) {
        return Apollo.useQuery<KommoLeadNoteListQuery, KommoLeadNoteListQueryVariables>(KommoLeadNoteListDocument, baseOptions);
      }
export function useKommoLeadNoteListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadNoteListQuery, KommoLeadNoteListQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadNoteListQuery, KommoLeadNoteListQueryVariables>(KommoLeadNoteListDocument, baseOptions);
        }
export type KommoLeadNoteListQueryHookResult = ReturnType<typeof useKommoLeadNoteListQuery>;
export type KommoLeadNoteListLazyQueryHookResult = ReturnType<typeof useKommoLeadNoteListLazyQuery>;
export type KommoLeadNoteListQueryResult = Apollo.QueryResult<KommoLeadNoteListQuery, KommoLeadNoteListQueryVariables>;
export const KommoLeadEventListDocument = gql`
    query KommoLeadEventList($leadId: ID!) {
  kommoLeadEvents(leadId: $leadId) {
    id
    kind
    actorName
    createdAt
    messageId
    code
  }
}
    `;

/**
 * __useKommoLeadEventListQuery__
 *
 * To run a query within a React component, call `useKommoLeadEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadEventListQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useKommoLeadEventListQuery(baseOptions: Apollo.QueryHookOptions<KommoLeadEventListQuery, KommoLeadEventListQueryVariables>) {
        return Apollo.useQuery<KommoLeadEventListQuery, KommoLeadEventListQueryVariables>(KommoLeadEventListDocument, baseOptions);
      }
export function useKommoLeadEventListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadEventListQuery, KommoLeadEventListQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadEventListQuery, KommoLeadEventListQueryVariables>(KommoLeadEventListDocument, baseOptions);
        }
export type KommoLeadEventListQueryHookResult = ReturnType<typeof useKommoLeadEventListQuery>;
export type KommoLeadEventListLazyQueryHookResult = ReturnType<typeof useKommoLeadEventListLazyQuery>;
export type KommoLeadEventListQueryResult = Apollo.QueryResult<KommoLeadEventListQuery, KommoLeadEventListQueryVariables>;
export const LeadSmsStateDocument = gql`
    query LeadSmsState($leadId: ID!) {
  kommoLeadSms(leadId: $leadId) {
    ...LeadSmsStateFields
  }
}
    ${LeadSmsStateFieldsFragmentDoc}`;

/**
 * __useLeadSmsStateQuery__
 *
 * To run a query within a React component, call `useLeadSmsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadSmsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadSmsStateQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useLeadSmsStateQuery(baseOptions: Apollo.QueryHookOptions<LeadSmsStateQuery, LeadSmsStateQueryVariables>) {
        return Apollo.useQuery<LeadSmsStateQuery, LeadSmsStateQueryVariables>(LeadSmsStateDocument, baseOptions);
      }
export function useLeadSmsStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadSmsStateQuery, LeadSmsStateQueryVariables>) {
          return Apollo.useLazyQuery<LeadSmsStateQuery, LeadSmsStateQueryVariables>(LeadSmsStateDocument, baseOptions);
        }
export type LeadSmsStateQueryHookResult = ReturnType<typeof useLeadSmsStateQuery>;
export type LeadSmsStateLazyQueryHookResult = ReturnType<typeof useLeadSmsStateLazyQuery>;
export type LeadSmsStateQueryResult = Apollo.QueryResult<LeadSmsStateQuery, LeadSmsStateQueryVariables>;
export const LeadSmsPreviewDocument = gql`
    query LeadSmsPreview($leadId: ID!, $text: String!, $link: LeadSmsLinkInput) {
  previewLeadSms(leadId: $leadId, text: $text, link: $link) {
    ...SmsPreviewFields
  }
}
    ${SmsPreviewFieldsFragmentDoc}`;

/**
 * __useLeadSmsPreviewQuery__
 *
 * To run a query within a React component, call `useLeadSmsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadSmsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadSmsPreviewQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      text: // value for 'text'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useLeadSmsPreviewQuery(baseOptions: Apollo.QueryHookOptions<LeadSmsPreviewQuery, LeadSmsPreviewQueryVariables>) {
        return Apollo.useQuery<LeadSmsPreviewQuery, LeadSmsPreviewQueryVariables>(LeadSmsPreviewDocument, baseOptions);
      }
export function useLeadSmsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadSmsPreviewQuery, LeadSmsPreviewQueryVariables>) {
          return Apollo.useLazyQuery<LeadSmsPreviewQuery, LeadSmsPreviewQueryVariables>(LeadSmsPreviewDocument, baseOptions);
        }
export type LeadSmsPreviewQueryHookResult = ReturnType<typeof useLeadSmsPreviewQuery>;
export type LeadSmsPreviewLazyQueryHookResult = ReturnType<typeof useLeadSmsPreviewLazyQuery>;
export type LeadSmsPreviewQueryResult = Apollo.QueryResult<LeadSmsPreviewQuery, LeadSmsPreviewQueryVariables>;
export const KommoLeadLadderListDocument = gql`
    query KommoLeadLadderList($leadId: ID!) {
  kommoLeadLadders(leadId: $leadId) {
    ...LeadLadderRunFields
  }
}
    ${LeadLadderRunFieldsFragmentDoc}`;

/**
 * __useKommoLeadLadderListQuery__
 *
 * To run a query within a React component, call `useKommoLeadLadderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadLadderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadLadderListQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useKommoLeadLadderListQuery(baseOptions: Apollo.QueryHookOptions<KommoLeadLadderListQuery, KommoLeadLadderListQueryVariables>) {
        return Apollo.useQuery<KommoLeadLadderListQuery, KommoLeadLadderListQueryVariables>(KommoLeadLadderListDocument, baseOptions);
      }
export function useKommoLeadLadderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadLadderListQuery, KommoLeadLadderListQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadLadderListQuery, KommoLeadLadderListQueryVariables>(KommoLeadLadderListDocument, baseOptions);
        }
export type KommoLeadLadderListQueryHookResult = ReturnType<typeof useKommoLeadLadderListQuery>;
export type KommoLeadLadderListLazyQueryHookResult = ReturnType<typeof useKommoLeadLadderListLazyQuery>;
export type KommoLeadLadderListQueryResult = Apollo.QueryResult<KommoLeadLadderListQuery, KommoLeadLadderListQueryVariables>;
export const KommoLeadThreadListDocument = gql`
    query KommoLeadThreadList($leadId: ID!) {
  kommoLeadConversations(leadId: $leadId) {
    ...LeadConversationFields
  }
}
    ${LeadConversationFieldsFragmentDoc}`;

/**
 * __useKommoLeadThreadListQuery__
 *
 * To run a query within a React component, call `useKommoLeadThreadListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadThreadListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadThreadListQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useKommoLeadThreadListQuery(baseOptions: Apollo.QueryHookOptions<KommoLeadThreadListQuery, KommoLeadThreadListQueryVariables>) {
        return Apollo.useQuery<KommoLeadThreadListQuery, KommoLeadThreadListQueryVariables>(KommoLeadThreadListDocument, baseOptions);
      }
export function useKommoLeadThreadListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadThreadListQuery, KommoLeadThreadListQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadThreadListQuery, KommoLeadThreadListQueryVariables>(KommoLeadThreadListDocument, baseOptions);
        }
export type KommoLeadThreadListQueryHookResult = ReturnType<typeof useKommoLeadThreadListQuery>;
export type KommoLeadThreadListLazyQueryHookResult = ReturnType<typeof useKommoLeadThreadListLazyQuery>;
export type KommoLeadThreadListQueryResult = Apollo.QueryResult<KommoLeadThreadListQuery, KommoLeadThreadListQueryVariables>;
export const KommoUserListDocument = gql`
    query KommoUserList {
  kommoUsers {
    ...KommoUserFields
  }
}
    ${KommoUserFieldsFragmentDoc}`;

/**
 * __useKommoUserListQuery__
 *
 * To run a query within a React component, call `useKommoUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useKommoUserListQuery(baseOptions?: Apollo.QueryHookOptions<KommoUserListQuery, KommoUserListQueryVariables>) {
        return Apollo.useQuery<KommoUserListQuery, KommoUserListQueryVariables>(KommoUserListDocument, baseOptions);
      }
export function useKommoUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoUserListQuery, KommoUserListQueryVariables>) {
          return Apollo.useLazyQuery<KommoUserListQuery, KommoUserListQueryVariables>(KommoUserListDocument, baseOptions);
        }
export type KommoUserListQueryHookResult = ReturnType<typeof useKommoUserListQuery>;
export type KommoUserListLazyQueryHookResult = ReturnType<typeof useKommoUserListLazyQuery>;
export type KommoUserListQueryResult = Apollo.QueryResult<KommoUserListQuery, KommoUserListQueryVariables>;
export const KommoSyncStateDocument = gql`
    query KommoSyncState {
  kommoSyncStatus {
    ...KommoSyncStatusFields
  }
}
    ${KommoSyncStatusFieldsFragmentDoc}`;

/**
 * __useKommoSyncStateQuery__
 *
 * To run a query within a React component, call `useKommoSyncStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoSyncStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoSyncStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useKommoSyncStateQuery(baseOptions?: Apollo.QueryHookOptions<KommoSyncStateQuery, KommoSyncStateQueryVariables>) {
        return Apollo.useQuery<KommoSyncStateQuery, KommoSyncStateQueryVariables>(KommoSyncStateDocument, baseOptions);
      }
export function useKommoSyncStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoSyncStateQuery, KommoSyncStateQueryVariables>) {
          return Apollo.useLazyQuery<KommoSyncStateQuery, KommoSyncStateQueryVariables>(KommoSyncStateDocument, baseOptions);
        }
export type KommoSyncStateQueryHookResult = ReturnType<typeof useKommoSyncStateQuery>;
export type KommoSyncStateLazyQueryHookResult = ReturnType<typeof useKommoSyncStateLazyQuery>;
export type KommoSyncStateQueryResult = Apollo.QueryResult<KommoSyncStateQuery, KommoSyncStateQueryVariables>;
export const CandidateSmsStateDocument = gql`
    query CandidateSmsState($candidateId: ID!) {
  fundingCandidateSms(candidateId: $candidateId) {
    ...LeadSmsStateFields
  }
}
    ${LeadSmsStateFieldsFragmentDoc}`;

/**
 * __useCandidateSmsStateQuery__
 *
 * To run a query within a React component, call `useCandidateSmsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateSmsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateSmsStateQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useCandidateSmsStateQuery(baseOptions: Apollo.QueryHookOptions<CandidateSmsStateQuery, CandidateSmsStateQueryVariables>) {
        return Apollo.useQuery<CandidateSmsStateQuery, CandidateSmsStateQueryVariables>(CandidateSmsStateDocument, baseOptions);
      }
export function useCandidateSmsStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateSmsStateQuery, CandidateSmsStateQueryVariables>) {
          return Apollo.useLazyQuery<CandidateSmsStateQuery, CandidateSmsStateQueryVariables>(CandidateSmsStateDocument, baseOptions);
        }
export type CandidateSmsStateQueryHookResult = ReturnType<typeof useCandidateSmsStateQuery>;
export type CandidateSmsStateLazyQueryHookResult = ReturnType<typeof useCandidateSmsStateLazyQuery>;
export type CandidateSmsStateQueryResult = Apollo.QueryResult<CandidateSmsStateQuery, CandidateSmsStateQueryVariables>;
export const CandidateSmsPreviewDocument = gql`
    query CandidateSmsPreview($candidateId: ID!, $text: String!, $link: LeadSmsLinkInput) {
  previewFundingCandidateSms(candidateId: $candidateId, text: $text, link: $link) {
    ...SmsPreviewFields
  }
}
    ${SmsPreviewFieldsFragmentDoc}`;

/**
 * __useCandidateSmsPreviewQuery__
 *
 * To run a query within a React component, call `useCandidateSmsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateSmsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateSmsPreviewQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      text: // value for 'text'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useCandidateSmsPreviewQuery(baseOptions: Apollo.QueryHookOptions<CandidateSmsPreviewQuery, CandidateSmsPreviewQueryVariables>) {
        return Apollo.useQuery<CandidateSmsPreviewQuery, CandidateSmsPreviewQueryVariables>(CandidateSmsPreviewDocument, baseOptions);
      }
export function useCandidateSmsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateSmsPreviewQuery, CandidateSmsPreviewQueryVariables>) {
          return Apollo.useLazyQuery<CandidateSmsPreviewQuery, CandidateSmsPreviewQueryVariables>(CandidateSmsPreviewDocument, baseOptions);
        }
export type CandidateSmsPreviewQueryHookResult = ReturnType<typeof useCandidateSmsPreviewQuery>;
export type CandidateSmsPreviewLazyQueryHookResult = ReturnType<typeof useCandidateSmsPreviewLazyQuery>;
export type CandidateSmsPreviewQueryResult = Apollo.QueryResult<CandidateSmsPreviewQuery, CandidateSmsPreviewQueryVariables>;
export const PaletteLeadsDocument = gql`
    query PaletteLeads($query: String) {
  kommoLeads(search: $query, includeClosed: true, limit: 5) {
    items {
      id
      name
      personName
      phone
      email
      isClosed
      stage {
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePaletteLeadsQuery__
 *
 * To run a query within a React component, call `usePaletteLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaletteLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaletteLeadsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePaletteLeadsQuery(baseOptions?: Apollo.QueryHookOptions<PaletteLeadsQuery, PaletteLeadsQueryVariables>) {
        return Apollo.useQuery<PaletteLeadsQuery, PaletteLeadsQueryVariables>(PaletteLeadsDocument, baseOptions);
      }
export function usePaletteLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaletteLeadsQuery, PaletteLeadsQueryVariables>) {
          return Apollo.useLazyQuery<PaletteLeadsQuery, PaletteLeadsQueryVariables>(PaletteLeadsDocument, baseOptions);
        }
export type PaletteLeadsQueryHookResult = ReturnType<typeof usePaletteLeadsQuery>;
export type PaletteLeadsLazyQueryHookResult = ReturnType<typeof usePaletteLeadsLazyQuery>;
export type PaletteLeadsQueryResult = Apollo.QueryResult<PaletteLeadsQuery, PaletteLeadsQueryVariables>;
export const KommoLeadBoardColumnDocument = gql`
    query KommoLeadBoardColumn($statusIds: [ID!], $responsible: String, $search: String, $includeClosed: Boolean, $ladder: String, $utmSource: [String!], $utmMedium: [String!], $utmCampaign: [String!], $fundingStatus: [String!], $hasFunding: Boolean, $hasStudent: Boolean, $createdFrom: Date, $sort: String, $offset: Int, $limit: Int, $aploraMinWinChance: Float, $nextContact: String, $aploraCategories: [String]) {
  kommoLeads(
    statusIds: $statusIds
    responsible: $responsible
    search: $search
    includeClosed: $includeClosed
    ladder: $ladder
    utmSource: $utmSource
    utmMedium: $utmMedium
    utmCampaign: $utmCampaign
    fundingStatus: $fundingStatus
    hasFunding: $hasFunding
    hasStudent: $hasStudent
    createdFrom: $createdFrom
    sort: $sort
    offset: $offset
    limit: $limit
    aploraMinWinChance: $aploraMinWinChance
    nextContact: $nextContact
    aploraCategories: $aploraCategories
  ) {
    items {
      ...KommoLeadBoardFields
    }
    total
  }
}
    ${KommoLeadBoardFieldsFragmentDoc}`;

/**
 * __useKommoLeadBoardColumnQuery__
 *
 * To run a query within a React component, call `useKommoLeadBoardColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadBoardColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadBoardColumnQuery({
 *   variables: {
 *      statusIds: // value for 'statusIds'
 *      responsible: // value for 'responsible'
 *      search: // value for 'search'
 *      includeClosed: // value for 'includeClosed'
 *      ladder: // value for 'ladder'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      fundingStatus: // value for 'fundingStatus'
 *      hasFunding: // value for 'hasFunding'
 *      hasStudent: // value for 'hasStudent'
 *      createdFrom: // value for 'createdFrom'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      aploraMinWinChance: // value for 'aploraMinWinChance'
 *      nextContact: // value for 'nextContact'
 *      aploraCategories: // value for 'aploraCategories'
 *   },
 * });
 */
export function useKommoLeadBoardColumnQuery(baseOptions?: Apollo.QueryHookOptions<KommoLeadBoardColumnQuery, KommoLeadBoardColumnQueryVariables>) {
        return Apollo.useQuery<KommoLeadBoardColumnQuery, KommoLeadBoardColumnQueryVariables>(KommoLeadBoardColumnDocument, baseOptions);
      }
export function useKommoLeadBoardColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadBoardColumnQuery, KommoLeadBoardColumnQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadBoardColumnQuery, KommoLeadBoardColumnQueryVariables>(KommoLeadBoardColumnDocument, baseOptions);
        }
export type KommoLeadBoardColumnQueryHookResult = ReturnType<typeof useKommoLeadBoardColumnQuery>;
export type KommoLeadBoardColumnLazyQueryHookResult = ReturnType<typeof useKommoLeadBoardColumnLazyQuery>;
export type KommoLeadBoardColumnQueryResult = Apollo.QueryResult<KommoLeadBoardColumnQuery, KommoLeadBoardColumnQueryVariables>;
export const KommoLeadStageTotalsDocument = gql`
    query KommoLeadStageTotals($responsible: String, $search: String, $includeClosed: Boolean, $ladder: String, $utmSource: [String!], $utmMedium: [String!], $utmCampaign: [String!], $fundingStatus: [String!], $hasFunding: Boolean, $hasStudent: Boolean, $createdFrom: Date, $aploraMinWinChance: Float, $nextContact: String, $aploraCategories: [String], $hotMinWinChance: Float) {
  kommoLeadStageCounts(
    responsible: $responsible
    search: $search
    includeClosed: $includeClosed
    ladder: $ladder
    utmSource: $utmSource
    utmMedium: $utmMedium
    utmCampaign: $utmCampaign
    fundingStatus: $fundingStatus
    hasFunding: $hasFunding
    hasStudent: $hasStudent
    createdFrom: $createdFrom
    aploraMinWinChance: $aploraMinWinChance
    nextContact: $nextContact
    aploraCategories: $aploraCategories
    hotMinWinChance: $hotMinWinChance
  ) {
    statusId
    count
    priceSum
    hotCount
  }
}
    `;

/**
 * __useKommoLeadStageTotalsQuery__
 *
 * To run a query within a React component, call `useKommoLeadStageTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadStageTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadStageTotalsQuery({
 *   variables: {
 *      responsible: // value for 'responsible'
 *      search: // value for 'search'
 *      includeClosed: // value for 'includeClosed'
 *      ladder: // value for 'ladder'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      fundingStatus: // value for 'fundingStatus'
 *      hasFunding: // value for 'hasFunding'
 *      hasStudent: // value for 'hasStudent'
 *      createdFrom: // value for 'createdFrom'
 *      aploraMinWinChance: // value for 'aploraMinWinChance'
 *      nextContact: // value for 'nextContact'
 *      aploraCategories: // value for 'aploraCategories'
 *      hotMinWinChance: // value for 'hotMinWinChance'
 *   },
 * });
 */
export function useKommoLeadStageTotalsQuery(baseOptions?: Apollo.QueryHookOptions<KommoLeadStageTotalsQuery, KommoLeadStageTotalsQueryVariables>) {
        return Apollo.useQuery<KommoLeadStageTotalsQuery, KommoLeadStageTotalsQueryVariables>(KommoLeadStageTotalsDocument, baseOptions);
      }
export function useKommoLeadStageTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadStageTotalsQuery, KommoLeadStageTotalsQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadStageTotalsQuery, KommoLeadStageTotalsQueryVariables>(KommoLeadStageTotalsDocument, baseOptions);
        }
export type KommoLeadStageTotalsQueryHookResult = ReturnType<typeof useKommoLeadStageTotalsQuery>;
export type KommoLeadStageTotalsLazyQueryHookResult = ReturnType<typeof useKommoLeadStageTotalsLazyQuery>;
export type KommoLeadStageTotalsQueryResult = Apollo.QueryResult<KommoLeadStageTotalsQuery, KommoLeadStageTotalsQueryVariables>;
export const KommoLeadsCreatedRecentlyDocument = gql`
    query KommoLeadsCreatedRecently($statusIds: [ID!], $responsible: String, $search: String, $includeClosed: Boolean, $ladder: String, $utmSource: [String!], $utmMedium: [String!], $utmCampaign: [String!], $fundingStatus: [String!], $hasFunding: Boolean, $hasStudent: Boolean, $createdFrom: Date!, $aploraMinWinChance: Float, $nextContact: String, $aploraCategories: [String]) {
  kommoLeads(
    statusIds: $statusIds
    responsible: $responsible
    search: $search
    includeClosed: $includeClosed
    ladder: $ladder
    utmSource: $utmSource
    utmMedium: $utmMedium
    utmCampaign: $utmCampaign
    fundingStatus: $fundingStatus
    hasFunding: $hasFunding
    hasStudent: $hasStudent
    createdFrom: $createdFrom
    aploraMinWinChance: $aploraMinWinChance
    nextContact: $nextContact
    aploraCategories: $aploraCategories
    offset: 0
    limit: 1
  ) {
    total
  }
}
    `;

/**
 * __useKommoLeadsCreatedRecentlyQuery__
 *
 * To run a query within a React component, call `useKommoLeadsCreatedRecentlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadsCreatedRecentlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadsCreatedRecentlyQuery({
 *   variables: {
 *      statusIds: // value for 'statusIds'
 *      responsible: // value for 'responsible'
 *      search: // value for 'search'
 *      includeClosed: // value for 'includeClosed'
 *      ladder: // value for 'ladder'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      fundingStatus: // value for 'fundingStatus'
 *      hasFunding: // value for 'hasFunding'
 *      hasStudent: // value for 'hasStudent'
 *      createdFrom: // value for 'createdFrom'
 *      aploraMinWinChance: // value for 'aploraMinWinChance'
 *      nextContact: // value for 'nextContact'
 *      aploraCategories: // value for 'aploraCategories'
 *   },
 * });
 */
export function useKommoLeadsCreatedRecentlyQuery(baseOptions: Apollo.QueryHookOptions<KommoLeadsCreatedRecentlyQuery, KommoLeadsCreatedRecentlyQueryVariables>) {
        return Apollo.useQuery<KommoLeadsCreatedRecentlyQuery, KommoLeadsCreatedRecentlyQueryVariables>(KommoLeadsCreatedRecentlyDocument, baseOptions);
      }
export function useKommoLeadsCreatedRecentlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadsCreatedRecentlyQuery, KommoLeadsCreatedRecentlyQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadsCreatedRecentlyQuery, KommoLeadsCreatedRecentlyQueryVariables>(KommoLeadsCreatedRecentlyDocument, baseOptions);
        }
export type KommoLeadsCreatedRecentlyQueryHookResult = ReturnType<typeof useKommoLeadsCreatedRecentlyQuery>;
export type KommoLeadsCreatedRecentlyLazyQueryHookResult = ReturnType<typeof useKommoLeadsCreatedRecentlyLazyQuery>;
export type KommoLeadsCreatedRecentlyQueryResult = Apollo.QueryResult<KommoLeadsCreatedRecentlyQuery, KommoLeadsCreatedRecentlyQueryVariables>;
export const KommoLossReasonListDocument = gql`
    query KommoLossReasonList {
  kommoLossReasons {
    items {
      id
      name
      sort
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useKommoLossReasonListQuery__
 *
 * To run a query within a React component, call `useKommoLossReasonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLossReasonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLossReasonListQuery({
 *   variables: {
 *   },
 * });
 */
export function useKommoLossReasonListQuery(baseOptions?: Apollo.QueryHookOptions<KommoLossReasonListQuery, KommoLossReasonListQueryVariables>) {
        return Apollo.useQuery<KommoLossReasonListQuery, KommoLossReasonListQueryVariables>(KommoLossReasonListDocument, baseOptions);
      }
export function useKommoLossReasonListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLossReasonListQuery, KommoLossReasonListQueryVariables>) {
          return Apollo.useLazyQuery<KommoLossReasonListQuery, KommoLossReasonListQueryVariables>(KommoLossReasonListDocument, baseOptions);
        }
export type KommoLossReasonListQueryHookResult = ReturnType<typeof useKommoLossReasonListQuery>;
export type KommoLossReasonListLazyQueryHookResult = ReturnType<typeof useKommoLossReasonListLazyQuery>;
export type KommoLossReasonListQueryResult = Apollo.QueryResult<KommoLossReasonListQuery, KommoLossReasonListQueryVariables>;
export const KommoResponsibleListDocument = gql`
    query KommoResponsibleList {
  kommoLeadResponsibles {
    id
    kommoId
    name
    erpUserId
    erpUserName
  }
}
    `;

/**
 * __useKommoResponsibleListQuery__
 *
 * To run a query within a React component, call `useKommoResponsibleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoResponsibleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoResponsibleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useKommoResponsibleListQuery(baseOptions?: Apollo.QueryHookOptions<KommoResponsibleListQuery, KommoResponsibleListQueryVariables>) {
        return Apollo.useQuery<KommoResponsibleListQuery, KommoResponsibleListQueryVariables>(KommoResponsibleListDocument, baseOptions);
      }
export function useKommoResponsibleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoResponsibleListQuery, KommoResponsibleListQueryVariables>) {
          return Apollo.useLazyQuery<KommoResponsibleListQuery, KommoResponsibleListQueryVariables>(KommoResponsibleListDocument, baseOptions);
        }
export type KommoResponsibleListQueryHookResult = ReturnType<typeof useKommoResponsibleListQuery>;
export type KommoResponsibleListLazyQueryHookResult = ReturnType<typeof useKommoResponsibleListLazyQuery>;
export type KommoResponsibleListQueryResult = Apollo.QueryResult<KommoResponsibleListQuery, KommoResponsibleListQueryVariables>;
export const KommoLeadAssignmentDocument = gql`
    query KommoLeadAssignment($id: ID!) {
  kommoLead(id: $id) {
    id
    responsibleId
    stageEnteredAt
    price
    courseRaw
  }
}
    `;

/**
 * __useKommoLeadAssignmentQuery__
 *
 * To run a query within a React component, call `useKommoLeadAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useKommoLeadAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKommoLeadAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKommoLeadAssignmentQuery(baseOptions: Apollo.QueryHookOptions<KommoLeadAssignmentQuery, KommoLeadAssignmentQueryVariables>) {
        return Apollo.useQuery<KommoLeadAssignmentQuery, KommoLeadAssignmentQueryVariables>(KommoLeadAssignmentDocument, baseOptions);
      }
export function useKommoLeadAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KommoLeadAssignmentQuery, KommoLeadAssignmentQueryVariables>) {
          return Apollo.useLazyQuery<KommoLeadAssignmentQuery, KommoLeadAssignmentQueryVariables>(KommoLeadAssignmentDocument, baseOptions);
        }
export type KommoLeadAssignmentQueryHookResult = ReturnType<typeof useKommoLeadAssignmentQuery>;
export type KommoLeadAssignmentLazyQueryHookResult = ReturnType<typeof useKommoLeadAssignmentLazyQuery>;
export type KommoLeadAssignmentQueryResult = Apollo.QueryResult<KommoLeadAssignmentQuery, KommoLeadAssignmentQueryVariables>;
export const MarketingLeadListDocument = gql`
    query MarketingLeadList($filter: MarketingFilter!, $channel: String, $subChannel: String, $campaign: ID, $family: String, $offer: String, $includeRepeats: Boolean, $limit: Int, $offset: Int) {
  marketingLeads(
    filter: $filter
    channel: $channel
    subChannel: $subChannel
    campaign: $campaign
    family: $family
    offer: $offer
    includeRepeats: $includeRepeats
    limit: $limit
    offset: $offset
  ) {
    items {
      kommoLeadId
      kommoId
      personName
      stage {
        id
        name
        color
      }
      isClosed
      responsibleName
      channel
      subChannel
      campaignId
      campaignName
      familySlug
      offer
      device
      isRepeat
      createdAt
      hasContract
      contractSigned
      hasSale
      salePrice
      saleCurrency
      salePricePln
      visitsBefore
    }
    total
  }
}
    `;

/**
 * __useMarketingLeadListQuery__
 *
 * To run a query within a React component, call `useMarketingLeadListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingLeadListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingLeadListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      channel: // value for 'channel'
 *      subChannel: // value for 'subChannel'
 *      campaign: // value for 'campaign'
 *      family: // value for 'family'
 *      offer: // value for 'offer'
 *      includeRepeats: // value for 'includeRepeats'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMarketingLeadListQuery(baseOptions: Apollo.QueryHookOptions<MarketingLeadListQuery, MarketingLeadListQueryVariables>) {
        return Apollo.useQuery<MarketingLeadListQuery, MarketingLeadListQueryVariables>(MarketingLeadListDocument, baseOptions);
      }
export function useMarketingLeadListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingLeadListQuery, MarketingLeadListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingLeadListQuery, MarketingLeadListQueryVariables>(MarketingLeadListDocument, baseOptions);
        }
export type MarketingLeadListQueryHookResult = ReturnType<typeof useMarketingLeadListQuery>;
export type MarketingLeadListLazyQueryHookResult = ReturnType<typeof useMarketingLeadListLazyQuery>;
export type MarketingLeadListQueryResult = Apollo.QueryResult<MarketingLeadListQuery, MarketingLeadListQueryVariables>;
export const LeadJourneyTimelineDocument = gql`
    query LeadJourneyTimeline($kommoLeadId: ID!) {
  leadJourney(kommoLeadId: $kommoLeadId) {
    lead {
      kommoLeadId
      kommoId
      personName
      name
      phone
      email
      stage {
        id
        name
        color
      }
      isClosed
      responsibleName
      createdAt
      courseRaw
      kommoUrl
    }
    events {
      at
      kind
      title
      detail
      channel
      tone
      meta
    }
  }
}
    `;

/**
 * __useLeadJourneyTimelineQuery__
 *
 * To run a query within a React component, call `useLeadJourneyTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadJourneyTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadJourneyTimelineQuery({
 *   variables: {
 *      kommoLeadId: // value for 'kommoLeadId'
 *   },
 * });
 */
export function useLeadJourneyTimelineQuery(baseOptions: Apollo.QueryHookOptions<LeadJourneyTimelineQuery, LeadJourneyTimelineQueryVariables>) {
        return Apollo.useQuery<LeadJourneyTimelineQuery, LeadJourneyTimelineQueryVariables>(LeadJourneyTimelineDocument, baseOptions);
      }
export function useLeadJourneyTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadJourneyTimelineQuery, LeadJourneyTimelineQueryVariables>) {
          return Apollo.useLazyQuery<LeadJourneyTimelineQuery, LeadJourneyTimelineQueryVariables>(LeadJourneyTimelineDocument, baseOptions);
        }
export type LeadJourneyTimelineQueryHookResult = ReturnType<typeof useLeadJourneyTimelineQuery>;
export type LeadJourneyTimelineLazyQueryHookResult = ReturnType<typeof useLeadJourneyTimelineLazyQuery>;
export type LeadJourneyTimelineQueryResult = Apollo.QueryResult<LeadJourneyTimelineQuery, LeadJourneyTimelineQueryVariables>;
export const LeadAploraCardDocument = gql`
    query LeadAploraCard($id: ID!) {
  kommoLead(id: $id) {
    id
    aplora {
      aploraUrl
      crmUrl
      changedAt
      syncedAt
      stale
      error
      deleted
      mergedIntoKommoId
      status
      stage
      daysInFunnel
      managerName
      scoring {
        winChance
        winTier
        leadCategory
        leadTemperature
        learnScore
        qualificationCompleteness
        dealProbability
        avgManagerScore
      }
      summaryMd
      summaryText
      outcomeSummaryText
      lastContactAt
      nextContactDate
      nextContactTip
      callsTotal
      callsAnalyzed
      learn
      managerRisks
      profile
      outcome
      dealAmount
      lossReasons
      consent
      externalFactors
      acquisitionChannel
      lastCall
      calls {
        callId
        startedAt
        durationSeconds
        direction
        managerName
        analyzed
        baseScore
        growthScore
        scoreBand
        summaryText
      }
    }
  }
}
    `;

/**
 * __useLeadAploraCardQuery__
 *
 * To run a query within a React component, call `useLeadAploraCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadAploraCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadAploraCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeadAploraCardQuery(baseOptions: Apollo.QueryHookOptions<LeadAploraCardQuery, LeadAploraCardQueryVariables>) {
        return Apollo.useQuery<LeadAploraCardQuery, LeadAploraCardQueryVariables>(LeadAploraCardDocument, baseOptions);
      }
export function useLeadAploraCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadAploraCardQuery, LeadAploraCardQueryVariables>) {
          return Apollo.useLazyQuery<LeadAploraCardQuery, LeadAploraCardQueryVariables>(LeadAploraCardDocument, baseOptions);
        }
export type LeadAploraCardQueryHookResult = ReturnType<typeof useLeadAploraCardQuery>;
export type LeadAploraCardLazyQueryHookResult = ReturnType<typeof useLeadAploraCardLazyQuery>;
export type LeadAploraCardQueryResult = Apollo.QueryResult<LeadAploraCardQuery, LeadAploraCardQueryVariables>;
export const LeadAploraCallReviewDocument = gql`
    query LeadAploraCallReview($leadId: ID!, $callId: ID!) {
  aploraCallAnalysis(leadId: $leadId, callId: $callId) {
    callId
    aploraUrl
    startedAt
    durationSeconds
    managerName
    baseScore
    growthScore
    scoreBand
    summaryMd
    summaryText
    managerFeedback
    managerSummary
    didWell
    mistakes
    growthPoints
    nextCallRecommendations
    redFlags
  }
}
    `;

/**
 * __useLeadAploraCallReviewQuery__
 *
 * To run a query within a React component, call `useLeadAploraCallReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadAploraCallReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadAploraCallReviewQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      callId: // value for 'callId'
 *   },
 * });
 */
export function useLeadAploraCallReviewQuery(baseOptions: Apollo.QueryHookOptions<LeadAploraCallReviewQuery, LeadAploraCallReviewQueryVariables>) {
        return Apollo.useQuery<LeadAploraCallReviewQuery, LeadAploraCallReviewQueryVariables>(LeadAploraCallReviewDocument, baseOptions);
      }
export function useLeadAploraCallReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadAploraCallReviewQuery, LeadAploraCallReviewQueryVariables>) {
          return Apollo.useLazyQuery<LeadAploraCallReviewQuery, LeadAploraCallReviewQueryVariables>(LeadAploraCallReviewDocument, baseOptions);
        }
export type LeadAploraCallReviewQueryHookResult = ReturnType<typeof useLeadAploraCallReviewQuery>;
export type LeadAploraCallReviewLazyQueryHookResult = ReturnType<typeof useLeadAploraCallReviewLazyQuery>;
export type LeadAploraCallReviewQueryResult = Apollo.QueryResult<LeadAploraCallReviewQuery, LeadAploraCallReviewQueryVariables>;
export const LeadAploraCallTextDocument = gql`
    query LeadAploraCallText($leadId: ID!, $callId: ID!) {
  aploraCallTranscript(leadId: $leadId, callId: $callId) {
    callId
    transcript
  }
}
    `;

/**
 * __useLeadAploraCallTextQuery__
 *
 * To run a query within a React component, call `useLeadAploraCallTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadAploraCallTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadAploraCallTextQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      callId: // value for 'callId'
 *   },
 * });
 */
export function useLeadAploraCallTextQuery(baseOptions: Apollo.QueryHookOptions<LeadAploraCallTextQuery, LeadAploraCallTextQueryVariables>) {
        return Apollo.useQuery<LeadAploraCallTextQuery, LeadAploraCallTextQueryVariables>(LeadAploraCallTextDocument, baseOptions);
      }
export function useLeadAploraCallTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadAploraCallTextQuery, LeadAploraCallTextQueryVariables>) {
          return Apollo.useLazyQuery<LeadAploraCallTextQuery, LeadAploraCallTextQueryVariables>(LeadAploraCallTextDocument, baseOptions);
        }
export type LeadAploraCallTextQueryHookResult = ReturnType<typeof useLeadAploraCallTextQuery>;
export type LeadAploraCallTextLazyQueryHookResult = ReturnType<typeof useLeadAploraCallTextLazyQuery>;
export type LeadAploraCallTextQueryResult = Apollo.QueryResult<LeadAploraCallTextQuery, LeadAploraCallTextQueryVariables>;
export const LeadSavedViewsDocument = gql`
    query LeadSavedViews($scope: String) {
  leadSavedViews(scope: $scope) {
    id
    name
    filters
    view
    shared
    isMine
    position
    scope
  }
}
    `;

/**
 * __useLeadSavedViewsQuery__
 *
 * To run a query within a React component, call `useLeadSavedViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadSavedViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadSavedViewsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useLeadSavedViewsQuery(baseOptions?: Apollo.QueryHookOptions<LeadSavedViewsQuery, LeadSavedViewsQueryVariables>) {
        return Apollo.useQuery<LeadSavedViewsQuery, LeadSavedViewsQueryVariables>(LeadSavedViewsDocument, baseOptions);
      }
export function useLeadSavedViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadSavedViewsQuery, LeadSavedViewsQueryVariables>) {
          return Apollo.useLazyQuery<LeadSavedViewsQuery, LeadSavedViewsQueryVariables>(LeadSavedViewsDocument, baseOptions);
        }
export type LeadSavedViewsQueryHookResult = ReturnType<typeof useLeadSavedViewsQuery>;
export type LeadSavedViewsLazyQueryHookResult = ReturnType<typeof useLeadSavedViewsLazyQuery>;
export type LeadSavedViewsQueryResult = Apollo.QueryResult<LeadSavedViewsQuery, LeadSavedViewsQueryVariables>;
export const GroupsOverviewListDocument = gql`
    query GroupsOverviewList($search: String, $onlyIssues: Boolean, $activeWithinDays: Int) {
  groupsOverview(
    search: $search
    onlyIssues: $onlyIssues
    activeWithinDays: $activeWithinDays
  ) {
    groupId
    name
    course
    startDate
    lastLessonDate
    studentsCount
    debtAmounts {
      currency
      amount
    }
    upcomingAmounts {
      currency
      amount
    }
    debtorsCount
    unhandledStudentsCount
    unreadStudentsCount
    unreadMessagesCount
    unreadSlackCount
    unreadMailCount
    unhandledSlackCount
    unhandledMailCount
    openTasksCount
    overdueTasksCount
  }
}
    `;

/**
 * __useGroupsOverviewListQuery__
 *
 * To run a query within a React component, call `useGroupsOverviewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsOverviewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsOverviewListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      onlyIssues: // value for 'onlyIssues'
 *      activeWithinDays: // value for 'activeWithinDays'
 *   },
 * });
 */
export function useGroupsOverviewListQuery(baseOptions?: Apollo.QueryHookOptions<GroupsOverviewListQuery, GroupsOverviewListQueryVariables>) {
        return Apollo.useQuery<GroupsOverviewListQuery, GroupsOverviewListQueryVariables>(GroupsOverviewListDocument, baseOptions);
      }
export function useGroupsOverviewListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsOverviewListQuery, GroupsOverviewListQueryVariables>) {
          return Apollo.useLazyQuery<GroupsOverviewListQuery, GroupsOverviewListQueryVariables>(GroupsOverviewListDocument, baseOptions);
        }
export type GroupsOverviewListQueryHookResult = ReturnType<typeof useGroupsOverviewListQuery>;
export type GroupsOverviewListLazyQueryHookResult = ReturnType<typeof useGroupsOverviewListLazyQuery>;
export type GroupsOverviewListQueryResult = Apollo.QueryResult<GroupsOverviewListQuery, GroupsOverviewListQueryVariables>;
export const PaginatedContributionsDocument = gql`
    query PaginatedContributions($contributionNum: Int, $first: Int, $query: String, $after: String) {
  allContributions(
    first: $first
    contributionNum: $contributionNum
    query: $query
    after: $after
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        date
        complete
        delay
        remainder
        amountByn
        amountForeign
        person {
          firstName
          lastName
          middleName
          phone
        }
        agreementTitle
        agreement {
          currency
        }
        group {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __usePaginatedContributionsQuery__
 *
 * To run a query within a React component, call `usePaginatedContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedContributionsQuery({
 *   variables: {
 *      contributionNum: // value for 'contributionNum'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaginatedContributionsQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedContributionsQuery, PaginatedContributionsQueryVariables>) {
        return Apollo.useQuery<PaginatedContributionsQuery, PaginatedContributionsQueryVariables>(PaginatedContributionsDocument, baseOptions);
      }
export function usePaginatedContributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedContributionsQuery, PaginatedContributionsQueryVariables>) {
          return Apollo.useLazyQuery<PaginatedContributionsQuery, PaginatedContributionsQueryVariables>(PaginatedContributionsDocument, baseOptions);
        }
export type PaginatedContributionsQueryHookResult = ReturnType<typeof usePaginatedContributionsQuery>;
export type PaginatedContributionsLazyQueryHookResult = ReturnType<typeof usePaginatedContributionsLazyQuery>;
export type PaginatedContributionsQueryResult = Apollo.QueryResult<PaginatedContributionsQuery, PaginatedContributionsQueryVariables>;
export const DebtorsMetaDocument = gql`
    query DebtorsMeta($contributionNum: Int, $query: String) {
  metaContributions(contributionNum: $contributionNum, query: $query) {
    totalCount
  }
}
    `;

/**
 * __useDebtorsMetaQuery__
 *
 * To run a query within a React component, call `useDebtorsMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebtorsMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebtorsMetaQuery({
 *   variables: {
 *      contributionNum: // value for 'contributionNum'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDebtorsMetaQuery(baseOptions?: Apollo.QueryHookOptions<DebtorsMetaQuery, DebtorsMetaQueryVariables>) {
        return Apollo.useQuery<DebtorsMetaQuery, DebtorsMetaQueryVariables>(DebtorsMetaDocument, baseOptions);
      }
export function useDebtorsMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebtorsMetaQuery, DebtorsMetaQueryVariables>) {
          return Apollo.useLazyQuery<DebtorsMetaQuery, DebtorsMetaQueryVariables>(DebtorsMetaDocument, baseOptions);
        }
export type DebtorsMetaQueryHookResult = ReturnType<typeof useDebtorsMetaQuery>;
export type DebtorsMetaLazyQueryHookResult = ReturnType<typeof useDebtorsMetaLazyQuery>;
export type DebtorsMetaQueryResult = Apollo.QueryResult<DebtorsMetaQuery, DebtorsMetaQueryVariables>;
export const GetContributionsMetaDocument = gql`
    query GetContributionsMeta {
  metaContributions {
    contributionsNums
  }
}
    `;

/**
 * __useGetContributionsMetaQuery__
 *
 * To run a query within a React component, call `useGetContributionsMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContributionsMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContributionsMetaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContributionsMetaQuery(baseOptions?: Apollo.QueryHookOptions<GetContributionsMetaQuery, GetContributionsMetaQueryVariables>) {
        return Apollo.useQuery<GetContributionsMetaQuery, GetContributionsMetaQueryVariables>(GetContributionsMetaDocument, baseOptions);
      }
export function useGetContributionsMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContributionsMetaQuery, GetContributionsMetaQueryVariables>) {
          return Apollo.useLazyQuery<GetContributionsMetaQuery, GetContributionsMetaQueryVariables>(GetContributionsMetaDocument, baseOptions);
        }
export type GetContributionsMetaQueryHookResult = ReturnType<typeof useGetContributionsMetaQuery>;
export type GetContributionsMetaLazyQueryHookResult = ReturnType<typeof useGetContributionsMetaLazyQuery>;
export type GetContributionsMetaQueryResult = Apollo.QueryResult<GetContributionsMetaQuery, GetContributionsMetaQueryVariables>;
export const ErpGroupDiplomasDocument = gql`
    query ErpGroupDiplomas($groupId: ID!) {
  groupDiplomas(groupId: $groupId) {
    agreementTitle
    graduationProjectMark
    hasGraduationProjectLesson
    student {
      id
      firstName
      lastName
      fullName
      email
    }
    pl {
      id
      pk
      language
      source
      originalName
      contentType
      sizeBytes
      version
      uploadedAt
      uploadedByName
    }
    en {
      id
      pk
      language
      source
      originalName
      contentType
      sizeBytes
      version
      uploadedAt
      uploadedByName
    }
  }
}
    `;

/**
 * __useErpGroupDiplomasQuery__
 *
 * To run a query within a React component, call `useErpGroupDiplomasQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpGroupDiplomasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpGroupDiplomasQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useErpGroupDiplomasQuery(baseOptions: Apollo.QueryHookOptions<ErpGroupDiplomasQuery, ErpGroupDiplomasQueryVariables>) {
        return Apollo.useQuery<ErpGroupDiplomasQuery, ErpGroupDiplomasQueryVariables>(ErpGroupDiplomasDocument, baseOptions);
      }
export function useErpGroupDiplomasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpGroupDiplomasQuery, ErpGroupDiplomasQueryVariables>) {
          return Apollo.useLazyQuery<ErpGroupDiplomasQuery, ErpGroupDiplomasQueryVariables>(ErpGroupDiplomasDocument, baseOptions);
        }
export type ErpGroupDiplomasQueryHookResult = ReturnType<typeof useErpGroupDiplomasQuery>;
export type ErpGroupDiplomasLazyQueryHookResult = ReturnType<typeof useErpGroupDiplomasLazyQuery>;
export type ErpGroupDiplomasQueryResult = Apollo.QueryResult<ErpGroupDiplomasQuery, ErpGroupDiplomasQueryVariables>;
export const ErpDiplomaDownloadUrlDocument = gql`
    query ErpDiplomaDownloadUrl($diplomaId: ID!) {
  diplomaDownloadUrl(diplomaId: $diplomaId) {
    url
    expiresAt
  }
}
    `;

/**
 * __useErpDiplomaDownloadUrlQuery__
 *
 * To run a query within a React component, call `useErpDiplomaDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpDiplomaDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpDiplomaDownloadUrlQuery({
 *   variables: {
 *      diplomaId: // value for 'diplomaId'
 *   },
 * });
 */
export function useErpDiplomaDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<ErpDiplomaDownloadUrlQuery, ErpDiplomaDownloadUrlQueryVariables>) {
        return Apollo.useQuery<ErpDiplomaDownloadUrlQuery, ErpDiplomaDownloadUrlQueryVariables>(ErpDiplomaDownloadUrlDocument, baseOptions);
      }
export function useErpDiplomaDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpDiplomaDownloadUrlQuery, ErpDiplomaDownloadUrlQueryVariables>) {
          return Apollo.useLazyQuery<ErpDiplomaDownloadUrlQuery, ErpDiplomaDownloadUrlQueryVariables>(ErpDiplomaDownloadUrlDocument, baseOptions);
        }
export type ErpDiplomaDownloadUrlQueryHookResult = ReturnType<typeof useErpDiplomaDownloadUrlQuery>;
export type ErpDiplomaDownloadUrlLazyQueryHookResult = ReturnType<typeof useErpDiplomaDownloadUrlLazyQuery>;
export type ErpDiplomaDownloadUrlQueryResult = Apollo.QueryResult<ErpDiplomaDownloadUrlQuery, ErpDiplomaDownloadUrlQueryVariables>;
export const DocTemplatesListDocument = gql`
    query DocTemplatesList($kind: String, $scope: String, $includeInactive: Boolean) {
  documentTemplates(kind: $kind, scope: $scope, includeInactive: $includeInactive) {
    id
    code
    name
    kind
    scope
    isActive
    legalEntityId
    legalEntityName
    version
    currentVersionId
    createdAt
    updatedAt
    updatedByName
    versions {
      id
      version
      origin
      comment
      createdAt
      createdByName
      isCurrent
    }
  }
}
    `;

/**
 * __useDocTemplatesListQuery__
 *
 * To run a query within a React component, call `useDocTemplatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocTemplatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocTemplatesListQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      scope: // value for 'scope'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useDocTemplatesListQuery(baseOptions?: Apollo.QueryHookOptions<DocTemplatesListQuery, DocTemplatesListQueryVariables>) {
        return Apollo.useQuery<DocTemplatesListQuery, DocTemplatesListQueryVariables>(DocTemplatesListDocument, baseOptions);
      }
export function useDocTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocTemplatesListQuery, DocTemplatesListQueryVariables>) {
          return Apollo.useLazyQuery<DocTemplatesListQuery, DocTemplatesListQueryVariables>(DocTemplatesListDocument, baseOptions);
        }
export type DocTemplatesListQueryHookResult = ReturnType<typeof useDocTemplatesListQuery>;
export type DocTemplatesListLazyQueryHookResult = ReturnType<typeof useDocTemplatesListLazyQuery>;
export type DocTemplatesListQueryResult = Apollo.QueryResult<DocTemplatesListQuery, DocTemplatesListQueryVariables>;
export const DocTemplateEditorSourceDocument = gql`
    query DocTemplateEditorSource($id: ID!, $language: String) {
  documentTemplateEditable(id: $id, language: $language) {
    template {
      id
      code
      name
      kind
      scope
      isActive
      legalEntityId
      legalEntityName
      version
      currentVersionId
      createdAt
      updatedAt
      updatedByName
    }
    html
    tokens {
      n
      kind
      role
      code
      label
      labelPl
      removable
      placement
    }
    variables {
      code
      group
      label
      labelPl
      groupLabel
      groupLabelPl
    }
  }
}
    `;

/**
 * __useDocTemplateEditorSourceQuery__
 *
 * To run a query within a React component, call `useDocTemplateEditorSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocTemplateEditorSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocTemplateEditorSourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useDocTemplateEditorSourceQuery(baseOptions: Apollo.QueryHookOptions<DocTemplateEditorSourceQuery, DocTemplateEditorSourceQueryVariables>) {
        return Apollo.useQuery<DocTemplateEditorSourceQuery, DocTemplateEditorSourceQueryVariables>(DocTemplateEditorSourceDocument, baseOptions);
      }
export function useDocTemplateEditorSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocTemplateEditorSourceQuery, DocTemplateEditorSourceQueryVariables>) {
          return Apollo.useLazyQuery<DocTemplateEditorSourceQuery, DocTemplateEditorSourceQueryVariables>(DocTemplateEditorSourceDocument, baseOptions);
        }
export type DocTemplateEditorSourceQueryHookResult = ReturnType<typeof useDocTemplateEditorSourceQuery>;
export type DocTemplateEditorSourceLazyQueryHookResult = ReturnType<typeof useDocTemplateEditorSourceLazyQuery>;
export type DocTemplateEditorSourceQueryResult = Apollo.QueryResult<DocTemplateEditorSourceQuery, DocTemplateEditorSourceQueryVariables>;
export const DocTemplateDraftSampleDocument = gql`
    query DocTemplateDraftSample($id: ID!, $html: String!) {
  documentTemplatePreviewDraft(id: $id, html: $html) {
    html
    problems {
      code
      message
      token
    }
  }
}
    `;

/**
 * __useDocTemplateDraftSampleQuery__
 *
 * To run a query within a React component, call `useDocTemplateDraftSampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocTemplateDraftSampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocTemplateDraftSampleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      html: // value for 'html'
 *   },
 * });
 */
export function useDocTemplateDraftSampleQuery(baseOptions: Apollo.QueryHookOptions<DocTemplateDraftSampleQuery, DocTemplateDraftSampleQueryVariables>) {
        return Apollo.useQuery<DocTemplateDraftSampleQuery, DocTemplateDraftSampleQueryVariables>(DocTemplateDraftSampleDocument, baseOptions);
      }
export function useDocTemplateDraftSampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocTemplateDraftSampleQuery, DocTemplateDraftSampleQueryVariables>) {
          return Apollo.useLazyQuery<DocTemplateDraftSampleQuery, DocTemplateDraftSampleQueryVariables>(DocTemplateDraftSampleDocument, baseOptions);
        }
export type DocTemplateDraftSampleQueryHookResult = ReturnType<typeof useDocTemplateDraftSampleQuery>;
export type DocTemplateDraftSampleLazyQueryHookResult = ReturnType<typeof useDocTemplateDraftSampleLazyQuery>;
export type DocTemplateDraftSampleQueryResult = Apollo.QueryResult<DocTemplateDraftSampleQuery, DocTemplateDraftSampleQueryVariables>;
export const DocIssuePreviewDocument = gql`
    query DocIssuePreview($templateId: ID!, $studentId: ID, $agreementId: ID, $groupId: ID, $issuePlace: String) {
  previewDocument(
    templateId: $templateId
    studentId: $studentId
    agreementId: $agreementId
    groupId: $groupId
    issuePlace: $issuePlace
  ) {
    html
    numberPreview
    missingFields {
      code
      label
      labelPl
    }
    hiddenFields {
      code
      label
      labelPl
    }
    errorCode
    errorMessage
  }
}
    `;

/**
 * __useDocIssuePreviewQuery__
 *
 * To run a query within a React component, call `useDocIssuePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocIssuePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocIssuePreviewQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      studentId: // value for 'studentId'
 *      agreementId: // value for 'agreementId'
 *      groupId: // value for 'groupId'
 *      issuePlace: // value for 'issuePlace'
 *   },
 * });
 */
export function useDocIssuePreviewQuery(baseOptions: Apollo.QueryHookOptions<DocIssuePreviewQuery, DocIssuePreviewQueryVariables>) {
        return Apollo.useQuery<DocIssuePreviewQuery, DocIssuePreviewQueryVariables>(DocIssuePreviewDocument, baseOptions);
      }
export function useDocIssuePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocIssuePreviewQuery, DocIssuePreviewQueryVariables>) {
          return Apollo.useLazyQuery<DocIssuePreviewQuery, DocIssuePreviewQueryVariables>(DocIssuePreviewDocument, baseOptions);
        }
export type DocIssuePreviewQueryHookResult = ReturnType<typeof useDocIssuePreviewQuery>;
export type DocIssuePreviewLazyQueryHookResult = ReturnType<typeof useDocIssuePreviewLazyQuery>;
export type DocIssuePreviewQueryResult = Apollo.QueryResult<DocIssuePreviewQuery, DocIssuePreviewQueryVariables>;
export const IssuedDocsHistoryDocument = gql`
    query IssuedDocsHistory($studentId: ID, $groupId: ID) {
  issuedDocuments(studentId: $studentId, groupId: $groupId) {
    id
    number
    kind
    scope
    templateId
    templateName
    templateVersion
    studentId
    studentName
    agreementId
    agreementTitle
    groupId
    groupName
    issueDate
    issuePlace
    issuedAt
    issuedByName
    missingFields
    hiddenFields
    hasFile
    sends {
      id
      sentAt
      sentTo
      sentByName
      mailboxEmail
      conversationId
    }
  }
}
    `;

/**
 * __useIssuedDocsHistoryQuery__
 *
 * To run a query within a React component, call `useIssuedDocsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuedDocsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuedDocsHistoryQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useIssuedDocsHistoryQuery(baseOptions?: Apollo.QueryHookOptions<IssuedDocsHistoryQuery, IssuedDocsHistoryQueryVariables>) {
        return Apollo.useQuery<IssuedDocsHistoryQuery, IssuedDocsHistoryQueryVariables>(IssuedDocsHistoryDocument, baseOptions);
      }
export function useIssuedDocsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssuedDocsHistoryQuery, IssuedDocsHistoryQueryVariables>) {
          return Apollo.useLazyQuery<IssuedDocsHistoryQuery, IssuedDocsHistoryQueryVariables>(IssuedDocsHistoryDocument, baseOptions);
        }
export type IssuedDocsHistoryQueryHookResult = ReturnType<typeof useIssuedDocsHistoryQuery>;
export type IssuedDocsHistoryLazyQueryHookResult = ReturnType<typeof useIssuedDocsHistoryLazyQuery>;
export type IssuedDocsHistoryQueryResult = Apollo.QueryResult<IssuedDocsHistoryQuery, IssuedDocsHistoryQueryVariables>;
export const IssuedDocFileDownloadDocument = gql`
    query IssuedDocFileDownload($id: ID!) {
  issuedDocumentFile(id: $id) {
    fileName
    contentType
    contentBase64
  }
}
    `;

/**
 * __useIssuedDocFileDownloadQuery__
 *
 * To run a query within a React component, call `useIssuedDocFileDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuedDocFileDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuedDocFileDownloadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIssuedDocFileDownloadQuery(baseOptions: Apollo.QueryHookOptions<IssuedDocFileDownloadQuery, IssuedDocFileDownloadQueryVariables>) {
        return Apollo.useQuery<IssuedDocFileDownloadQuery, IssuedDocFileDownloadQueryVariables>(IssuedDocFileDownloadDocument, baseOptions);
      }
export function useIssuedDocFileDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssuedDocFileDownloadQuery, IssuedDocFileDownloadQueryVariables>) {
          return Apollo.useLazyQuery<IssuedDocFileDownloadQuery, IssuedDocFileDownloadQueryVariables>(IssuedDocFileDownloadDocument, baseOptions);
        }
export type IssuedDocFileDownloadQueryHookResult = ReturnType<typeof useIssuedDocFileDownloadQuery>;
export type IssuedDocFileDownloadLazyQueryHookResult = ReturnType<typeof useIssuedDocFileDownloadLazyQuery>;
export type IssuedDocFileDownloadQueryResult = Apollo.QueryResult<IssuedDocFileDownloadQuery, IssuedDocFileDownloadQueryVariables>;
export const DocSendDraftDocument = gql`
    query DocSendDraft($issuedDocumentId: ID!) {
  documentSendDefaults(issuedDocumentId: $issuedDocumentId) {
    to
    subject
    html
    mailboxEmail
    mailboxes
  }
}
    `;

/**
 * __useDocSendDraftQuery__
 *
 * To run a query within a React component, call `useDocSendDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocSendDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocSendDraftQuery({
 *   variables: {
 *      issuedDocumentId: // value for 'issuedDocumentId'
 *   },
 * });
 */
export function useDocSendDraftQuery(baseOptions: Apollo.QueryHookOptions<DocSendDraftQuery, DocSendDraftQueryVariables>) {
        return Apollo.useQuery<DocSendDraftQuery, DocSendDraftQueryVariables>(DocSendDraftDocument, baseOptions);
      }
export function useDocSendDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocSendDraftQuery, DocSendDraftQueryVariables>) {
          return Apollo.useLazyQuery<DocSendDraftQuery, DocSendDraftQueryVariables>(DocSendDraftDocument, baseOptions);
        }
export type DocSendDraftQueryHookResult = ReturnType<typeof useDocSendDraftQuery>;
export type DocSendDraftLazyQueryHookResult = ReturnType<typeof useDocSendDraftLazyQuery>;
export type DocSendDraftQueryResult = Apollo.QueryResult<DocSendDraftQuery, DocSendDraftQueryVariables>;
export const ErpFundingOperatorsDocument = gql`
    query ErpFundingOperators($programType: String, $voivodeshipId: ID, $powiatId: ID, $search: String, $isActive: Boolean, $pageChanged: Boolean, $pageSegment: String, $intakeConfirmation: String, $clientType: String, $intakePeriod: String, $urlSuspect: Boolean, $limit: Int, $offset: Int) {
  fundingOperators(
    programType: $programType
    voivodeshipId: $voivodeshipId
    powiatId: $powiatId
    search: $search
    isActive: $isActive
    pageChanged: $pageChanged
    pageSegment: $pageSegment
    intakeConfirmation: $intakeConfirmation
    clientType: $clientType
    intakePeriod: $intakePeriod
    urlSuspect: $urlSuspect
    limit: $limit
    offset: $offset
  ) {
    id
    name
    programType
    programName
    projectNumber
    isActive
    coverageScope
    voivodeship {
      id
      name
    }
    powiats {
      id
      name
      code
      kind
      voivodeshipName
    }
    powiatsUnresolved
    maxAmount
    maxAmountCurrency
    ownContributionPercent
    paymentMethod
    decisionDays
    rollingIntake
    acceptsUnemployed
    acceptsEmployerApplications
    supportsDisabled
    supportsAge50Plus
    greenCompetences
    servedStatuses
    instructionUrl
    instructionReady
    projectUrl
    newsUrl
    documentsUrl
    pageState
    hasConfirmedIntake
    clientType
    intakePeriod
    nameSaysB2b
    urlSuspect
    pageLinksCount
    pageChanged
    pageChangedAt
    pageHashCheckedAt
    pageCheckedOkAt
    lastNotifiedAt
    phone
    email
    comment
    internalNote
    candidatesCount
    currentIntake {
      id
      startsOn
      endsOn
      startsAtTime
      endsAtTime
      status
      phase
      daysLeft
      confirmedAt
      confirmedByName
    }
  }
}
    `;

/**
 * __useErpFundingOperatorsQuery__
 *
 * To run a query within a React component, call `useErpFundingOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingOperatorsQuery({
 *   variables: {
 *      programType: // value for 'programType'
 *      voivodeshipId: // value for 'voivodeshipId'
 *      powiatId: // value for 'powiatId'
 *      search: // value for 'search'
 *      isActive: // value for 'isActive'
 *      pageChanged: // value for 'pageChanged'
 *      pageSegment: // value for 'pageSegment'
 *      intakeConfirmation: // value for 'intakeConfirmation'
 *      clientType: // value for 'clientType'
 *      intakePeriod: // value for 'intakePeriod'
 *      urlSuspect: // value for 'urlSuspect'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useErpFundingOperatorsQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingOperatorsQuery, ErpFundingOperatorsQueryVariables>) {
        return Apollo.useQuery<ErpFundingOperatorsQuery, ErpFundingOperatorsQueryVariables>(ErpFundingOperatorsDocument, baseOptions);
      }
export function useErpFundingOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingOperatorsQuery, ErpFundingOperatorsQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingOperatorsQuery, ErpFundingOperatorsQueryVariables>(ErpFundingOperatorsDocument, baseOptions);
        }
export type ErpFundingOperatorsQueryHookResult = ReturnType<typeof useErpFundingOperatorsQuery>;
export type ErpFundingOperatorsLazyQueryHookResult = ReturnType<typeof useErpFundingOperatorsLazyQuery>;
export type ErpFundingOperatorsQueryResult = Apollo.QueryResult<ErpFundingOperatorsQuery, ErpFundingOperatorsQueryVariables>;
export const ErpFundingCandidatesDocument = gql`
    query ErpFundingCandidates($status: String, $statusGroup: String, $operatorId: ID, $matchStatus: String, $voivodeshipId: ID, $isDeposit: Boolean, $isStudent: Boolean, $includeArchived: Boolean, $employmentStatus: String, $needsAttention: Boolean, $hasDuplicates: Boolean, $needsOperatorReview: Boolean, $operatorMatch: String, $search: String, $limit: Int, $offset: Int) {
  fundingCandidates(
    status: $status
    statusGroup: $statusGroup
    operatorId: $operatorId
    matchStatus: $matchStatus
    voivodeshipId: $voivodeshipId
    isDeposit: $isDeposit
    isStudent: $isStudent
    includeArchived: $includeArchived
    employmentStatus: $employmentStatus
    needsAttention: $needsAttention
    hasDuplicates: $hasDuplicates
    needsOperatorReview: $needsOperatorReview
    operatorMatch: $operatorMatch
    search: $search
    limit: $limit
    offset: $offset
  ) {
    id
    fullName
    email
    phone
    status
    statusChangedAt
    outcome
    employmentStatus
    city
    isDeposit
    needsAttention
    attentionNote
    matchStatus
    isStudent
    studentId
    linkedUserName
    linkedUserEmail
    voivodeship {
      id
      name
    }
    powiat {
      id
      name
    }
    powiatRaw
    primaryOperator {
      id
      name
      programType
      clientType
    }
    operators {
      id
      name
      programType
      clientType
    }
    activeOperatorsCount
    disabledOperatorsCount
  }
}
    `;

/**
 * __useErpFundingCandidatesQuery__
 *
 * To run a query within a React component, call `useErpFundingCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingCandidatesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      statusGroup: // value for 'statusGroup'
 *      operatorId: // value for 'operatorId'
 *      matchStatus: // value for 'matchStatus'
 *      voivodeshipId: // value for 'voivodeshipId'
 *      isDeposit: // value for 'isDeposit'
 *      isStudent: // value for 'isStudent'
 *      includeArchived: // value for 'includeArchived'
 *      employmentStatus: // value for 'employmentStatus'
 *      needsAttention: // value for 'needsAttention'
 *      hasDuplicates: // value for 'hasDuplicates'
 *      needsOperatorReview: // value for 'needsOperatorReview'
 *      operatorMatch: // value for 'operatorMatch'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useErpFundingCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingCandidatesQuery, ErpFundingCandidatesQueryVariables>) {
        return Apollo.useQuery<ErpFundingCandidatesQuery, ErpFundingCandidatesQueryVariables>(ErpFundingCandidatesDocument, baseOptions);
      }
export function useErpFundingCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingCandidatesQuery, ErpFundingCandidatesQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingCandidatesQuery, ErpFundingCandidatesQueryVariables>(ErpFundingCandidatesDocument, baseOptions);
        }
export type ErpFundingCandidatesQueryHookResult = ReturnType<typeof useErpFundingCandidatesQuery>;
export type ErpFundingCandidatesLazyQueryHookResult = ReturnType<typeof useErpFundingCandidatesLazyQuery>;
export type ErpFundingCandidatesQueryResult = Apollo.QueryResult<ErpFundingCandidatesQuery, ErpFundingCandidatesQueryVariables>;
export const ErpFundingCandidateDocument = gql`
    query ErpFundingCandidate($id: ID!) {
  fundingCandidate(id: $id) {
    id
    fullName
    firstName
    lastName
    email
    phone
    status
    statusChangedAt
    outcome
    declineReason
    appliedAt
    decisionAt
    approvedAmount
    ownContributionAmount
    currency
    city
    powiatRaw
    isDeposit
    needsAttention
    attentionNote
    attentionSetByName
    attentionSetAt
    nextIntake {
      id
      startsOn
      operatorId
      operatorName
    }
    attentionTaskId
    testDrive
    reminderAt
    taskNote
    notes
    courseName
    courseId
    desiredStartMonth
    intake {
      id
      startsOn
      endsOn
      status
    }
    assignedToName
    employmentStatus
    isUnemployed
    isAdult
    is50Plus
    hasEmployer
    kfsGeoBasis
    employerName
    employerSameVoivodeship
    employerVoivodeship {
      id
      name
    }
    employerPowiat {
      id
      name
    }
    hasDisabilityCertificate
    inFinancialHardship
    usedFundingBefore
    employerCanApply
    jdgSuspended
    preferredTracks
    matchStatus
    matchRule
    duplicateCandidates {
      id
      fullName
      status
      createdAt
    }
    userLocked
    linkedUserId
    linkedUserName
    linkedUserEmail
    isStudent
    studentId
    agreementTitle
    legalEntityName
    source
    isArchived
    supportId
    createdAt
    voivodeship {
      id
      name
    }
    powiat {
      id
      name
    }
    primaryOperator {
      id
      name
      programType
      clientType
      ownContributionPercent
      decisionDays
      coverageScope
      voivodeship {
        id
        name
      }
      powiats {
        id
        name
        kind
        voivodeshipName
      }
      instructionUrl
      instructionReady
      currentIntake {
        id
        startsOn
        endsOn
        status
      }
    }
    operators {
      id
      name
      programType
      clientType
    }
    activeOperatorsCount
    disabledOperatorsCount
    operatorLinks {
      id
      isActive
      isPrimary
      source
      addedAt
      addedByName
      deactivatedAt
      deactivatedByName
      deactivationReason
      deactivationReasonLabel
      note
      operator {
        id
        name
        programName
        programType
        clientType
        ownContributionPercent
        decisionDays
        coverageScope
        rollingIntake
        instructionUrl
        instructionReady
        voivodeship {
          id
          name
        }
        powiats {
          id
          name
          kind
          voivodeshipName
        }
        currentIntake {
          id
          startsOn
          endsOn
          status
        }
      }
    }
    events {
      id
      fromStatus
      toStatus
      fromOperatorId
      fromOperatorName
      toOperatorId
      toOperatorName
      changedByName
      changedAt
      note
    }
    kommoLeads {
      ...PersonKommoLeadFields
    }
  }
}
    ${PersonKommoLeadFieldsFragmentDoc}`;

/**
 * __useErpFundingCandidateQuery__
 *
 * To run a query within a React component, call `useErpFundingCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingCandidateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpFundingCandidateQuery(baseOptions: Apollo.QueryHookOptions<ErpFundingCandidateQuery, ErpFundingCandidateQueryVariables>) {
        return Apollo.useQuery<ErpFundingCandidateQuery, ErpFundingCandidateQueryVariables>(ErpFundingCandidateDocument, baseOptions);
      }
export function useErpFundingCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingCandidateQuery, ErpFundingCandidateQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingCandidateQuery, ErpFundingCandidateQueryVariables>(ErpFundingCandidateDocument, baseOptions);
        }
export type ErpFundingCandidateQueryHookResult = ReturnType<typeof useErpFundingCandidateQuery>;
export type ErpFundingCandidateLazyQueryHookResult = ReturnType<typeof useErpFundingCandidateLazyQuery>;
export type ErpFundingCandidateQueryResult = Apollo.QueryResult<ErpFundingCandidateQuery, ErpFundingCandidateQueryVariables>;
export const ErpFundingBoardDocument = gql`
    query ErpFundingBoard($operatorId: ID, $matchStatus: String, $voivodeshipId: ID, $isDeposit: Boolean, $isStudent: Boolean, $employmentStatus: String, $needsAttention: Boolean, $hasDuplicates: Boolean, $needsOperatorReview: Boolean, $operatorMatch: String, $search: String) {
  fundingBoard(
    operatorId: $operatorId
    matchStatus: $matchStatus
    voivodeshipId: $voivodeshipId
    isDeposit: $isDeposit
    isStudent: $isStudent
    employmentStatus: $employmentStatus
    needsAttention: $needsAttention
    hasDuplicates: $hasDuplicates
    needsOperatorReview: $needsOperatorReview
    operatorMatch: $operatorMatch
    search: $search
  ) {
    total
    ambiguousMatches
    duplicateSubmissions
    unresolvedPlaces
    depositWaiting
    pageChangedOperators
    suspiciousUrls
    operatorMissing
    submissionsNeedOperator
    needsAttention
    groups {
      key
      title
      statuses
      count
    }
    stages {
      key
      title
      statuses
      count
    }
    buckets {
      status
      count
    }
  }
}
    `;

/**
 * __useErpFundingBoardQuery__
 *
 * To run a query within a React component, call `useErpFundingBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingBoardQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      matchStatus: // value for 'matchStatus'
 *      voivodeshipId: // value for 'voivodeshipId'
 *      isDeposit: // value for 'isDeposit'
 *      isStudent: // value for 'isStudent'
 *      employmentStatus: // value for 'employmentStatus'
 *      needsAttention: // value for 'needsAttention'
 *      hasDuplicates: // value for 'hasDuplicates'
 *      needsOperatorReview: // value for 'needsOperatorReview'
 *      operatorMatch: // value for 'operatorMatch'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpFundingBoardQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingBoardQuery, ErpFundingBoardQueryVariables>) {
        return Apollo.useQuery<ErpFundingBoardQuery, ErpFundingBoardQueryVariables>(ErpFundingBoardDocument, baseOptions);
      }
export function useErpFundingBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingBoardQuery, ErpFundingBoardQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingBoardQuery, ErpFundingBoardQueryVariables>(ErpFundingBoardDocument, baseOptions);
        }
export type ErpFundingBoardQueryHookResult = ReturnType<typeof useErpFundingBoardQuery>;
export type ErpFundingBoardLazyQueryHookResult = ReturnType<typeof useErpFundingBoardLazyQuery>;
export type ErpFundingBoardQueryResult = Apollo.QueryResult<ErpFundingBoardQuery, ErpFundingBoardQueryVariables>;
export const ErpFundingCandidateKfsBasisDocument = gql`
    query ErpFundingCandidateKfsBasis($id: ID!) {
  fundingCandidate(id: $id) {
    id
    employmentStatus
    kfsGeoBasis
  }
}
    `;

/**
 * __useErpFundingCandidateKfsBasisQuery__
 *
 * To run a query within a React component, call `useErpFundingCandidateKfsBasisQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingCandidateKfsBasisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingCandidateKfsBasisQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpFundingCandidateKfsBasisQuery(baseOptions: Apollo.QueryHookOptions<ErpFundingCandidateKfsBasisQuery, ErpFundingCandidateKfsBasisQueryVariables>) {
        return Apollo.useQuery<ErpFundingCandidateKfsBasisQuery, ErpFundingCandidateKfsBasisQueryVariables>(ErpFundingCandidateKfsBasisDocument, baseOptions);
      }
export function useErpFundingCandidateKfsBasisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingCandidateKfsBasisQuery, ErpFundingCandidateKfsBasisQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingCandidateKfsBasisQuery, ErpFundingCandidateKfsBasisQueryVariables>(ErpFundingCandidateKfsBasisDocument, baseOptions);
        }
export type ErpFundingCandidateKfsBasisQueryHookResult = ReturnType<typeof useErpFundingCandidateKfsBasisQuery>;
export type ErpFundingCandidateKfsBasisLazyQueryHookResult = ReturnType<typeof useErpFundingCandidateKfsBasisLazyQuery>;
export type ErpFundingCandidateKfsBasisQueryResult = Apollo.QueryResult<ErpFundingCandidateKfsBasisQuery, ErpFundingCandidateKfsBasisQueryVariables>;
export const ErpOperatorsForCandidateDocument = gql`
    query ErpOperatorsForCandidate($candidateId: ID!) {
  operatorsForCandidate(candidateId: $candidateId) {
    id
    name
    programName
    programType
    paymentMethod
    maxAmount
    ownContributionPercent
    decisionDays
    rollingIntake
    instructionReady
    clientType
    intakePeriod
    coverageScope
    voivodeship {
      id
      name
    }
    powiats {
      id
      name
      kind
      voivodeshipName
    }
    currentIntake {
      id
      startsOn
      endsOn
      status
    }
  }
}
    `;

/**
 * __useErpOperatorsForCandidateQuery__
 *
 * To run a query within a React component, call `useErpOperatorsForCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpOperatorsForCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpOperatorsForCandidateQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useErpOperatorsForCandidateQuery(baseOptions: Apollo.QueryHookOptions<ErpOperatorsForCandidateQuery, ErpOperatorsForCandidateQueryVariables>) {
        return Apollo.useQuery<ErpOperatorsForCandidateQuery, ErpOperatorsForCandidateQueryVariables>(ErpOperatorsForCandidateDocument, baseOptions);
      }
export function useErpOperatorsForCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpOperatorsForCandidateQuery, ErpOperatorsForCandidateQueryVariables>) {
          return Apollo.useLazyQuery<ErpOperatorsForCandidateQuery, ErpOperatorsForCandidateQueryVariables>(ErpOperatorsForCandidateDocument, baseOptions);
        }
export type ErpOperatorsForCandidateQueryHookResult = ReturnType<typeof useErpOperatorsForCandidateQuery>;
export type ErpOperatorsForCandidateLazyQueryHookResult = ReturnType<typeof useErpOperatorsForCandidateLazyQuery>;
export type ErpOperatorsForCandidateQueryResult = Apollo.QueryResult<ErpOperatorsForCandidateQuery, ErpOperatorsForCandidateQueryVariables>;
export const ErpFundingDictionariesDocument = gql`
    query ErpFundingDictionaries {
  fundingVoivodeships {
    id
    code
    name
  }
}
    `;

/**
 * __useErpFundingDictionariesQuery__
 *
 * To run a query within a React component, call `useErpFundingDictionariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingDictionariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingDictionariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpFundingDictionariesQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingDictionariesQuery, ErpFundingDictionariesQueryVariables>) {
        return Apollo.useQuery<ErpFundingDictionariesQuery, ErpFundingDictionariesQueryVariables>(ErpFundingDictionariesDocument, baseOptions);
      }
export function useErpFundingDictionariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingDictionariesQuery, ErpFundingDictionariesQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingDictionariesQuery, ErpFundingDictionariesQueryVariables>(ErpFundingDictionariesDocument, baseOptions);
        }
export type ErpFundingDictionariesQueryHookResult = ReturnType<typeof useErpFundingDictionariesQuery>;
export type ErpFundingDictionariesLazyQueryHookResult = ReturnType<typeof useErpFundingDictionariesLazyQuery>;
export type ErpFundingDictionariesQueryResult = Apollo.QueryResult<ErpFundingDictionariesQuery, ErpFundingDictionariesQueryVariables>;
export const ErpFundingPowiatsDocument = gql`
    query ErpFundingPowiats($voivodeshipId: ID, $search: String) {
  fundingPowiats(voivodeshipId: $voivodeshipId, search: $search) {
    id
    code
    name
    kind
    voivodeshipId
    voivodeshipName
    matchedAlias
  }
}
    `;

/**
 * __useErpFundingPowiatsQuery__
 *
 * To run a query within a React component, call `useErpFundingPowiatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingPowiatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingPowiatsQuery({
 *   variables: {
 *      voivodeshipId: // value for 'voivodeshipId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpFundingPowiatsQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingPowiatsQuery, ErpFundingPowiatsQueryVariables>) {
        return Apollo.useQuery<ErpFundingPowiatsQuery, ErpFundingPowiatsQueryVariables>(ErpFundingPowiatsDocument, baseOptions);
      }
export function useErpFundingPowiatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingPowiatsQuery, ErpFundingPowiatsQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingPowiatsQuery, ErpFundingPowiatsQueryVariables>(ErpFundingPowiatsDocument, baseOptions);
        }
export type ErpFundingPowiatsQueryHookResult = ReturnType<typeof useErpFundingPowiatsQuery>;
export type ErpFundingPowiatsLazyQueryHookResult = ReturnType<typeof useErpFundingPowiatsLazyQuery>;
export type ErpFundingPowiatsQueryResult = Apollo.QueryResult<ErpFundingPowiatsQuery, ErpFundingPowiatsQueryVariables>;
export const ErpFundingGeoAliasesDocument = gql`
    query ErpFundingGeoAliases($status: String, $limit: Int) {
  fundingGeoAliases(status: $status, limit: $limit) {
    id
    rawValue
    normalized
    status
    hits
    wholeVoivodeship
    suggestionScore
    powiat {
      id
      name
      code
      kind
      voivodeshipName
    }
    contextVoivodeship {
      id
      name
    }
    candidatePowiats {
      id
      name
      kind
      voivodeshipName
    }
    suggestedPowiat {
      id
      name
      code
      kind
      voivodeshipName
    }
  }
}
    `;

/**
 * __useErpFundingGeoAliasesQuery__
 *
 * To run a query within a React component, call `useErpFundingGeoAliasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingGeoAliasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingGeoAliasesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useErpFundingGeoAliasesQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingGeoAliasesQuery, ErpFundingGeoAliasesQueryVariables>) {
        return Apollo.useQuery<ErpFundingGeoAliasesQuery, ErpFundingGeoAliasesQueryVariables>(ErpFundingGeoAliasesDocument, baseOptions);
      }
export function useErpFundingGeoAliasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingGeoAliasesQuery, ErpFundingGeoAliasesQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingGeoAliasesQuery, ErpFundingGeoAliasesQueryVariables>(ErpFundingGeoAliasesDocument, baseOptions);
        }
export type ErpFundingGeoAliasesQueryHookResult = ReturnType<typeof useErpFundingGeoAliasesQuery>;
export type ErpFundingGeoAliasesLazyQueryHookResult = ReturnType<typeof useErpFundingGeoAliasesLazyQuery>;
export type ErpFundingGeoAliasesQueryResult = Apollo.QueryResult<ErpFundingGeoAliasesQuery, ErpFundingGeoAliasesQueryVariables>;
export const ErpFundingImportRunsDocument = gql`
    query ErpFundingImportRuns($limit: Int, $offset: Int, $taskName: String, $status: String, $triggerSource: String, $dryRun: Boolean) {
  fundingImportRuns(
    limit: $limit
    offset: $offset
    taskName: $taskName
    status: $status
    triggerSource: $triggerSource
    dryRun: $dryRun
  ) {
    id
    taskName
    triggerSource
    startedByName
    dryRun
    status
    startedAt
    finishedAt
    durationSeconds
    errorMessage
    stats
  }
  fundingImportRunsTotal(
    taskName: $taskName
    status: $status
    triggerSource: $triggerSource
    dryRun: $dryRun
  )
}
    `;

/**
 * __useErpFundingImportRunsQuery__
 *
 * To run a query within a React component, call `useErpFundingImportRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingImportRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingImportRunsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      taskName: // value for 'taskName'
 *      status: // value for 'status'
 *      triggerSource: // value for 'triggerSource'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useErpFundingImportRunsQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingImportRunsQuery, ErpFundingImportRunsQueryVariables>) {
        return Apollo.useQuery<ErpFundingImportRunsQuery, ErpFundingImportRunsQueryVariables>(ErpFundingImportRunsDocument, baseOptions);
      }
export function useErpFundingImportRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingImportRunsQuery, ErpFundingImportRunsQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingImportRunsQuery, ErpFundingImportRunsQueryVariables>(ErpFundingImportRunsDocument, baseOptions);
        }
export type ErpFundingImportRunsQueryHookResult = ReturnType<typeof useErpFundingImportRunsQuery>;
export type ErpFundingImportRunsLazyQueryHookResult = ReturnType<typeof useErpFundingImportRunsLazyQuery>;
export type ErpFundingImportRunsQueryResult = Apollo.QueryResult<ErpFundingImportRunsQuery, ErpFundingImportRunsQueryVariables>;
export const ErpFundingTaskSummaryDocument = gql`
    query ErpFundingTaskSummary {
  fundingTaskSummary {
    task
    taskName
    scheduled
    scheduleFlag
    lastRun {
      id
      status
      dryRun
      triggerSource
      startedByName
      startedAt
      durationSeconds
      errorMessage
      stats
    }
  }
}
    `;

/**
 * __useErpFundingTaskSummaryQuery__
 *
 * To run a query within a React component, call `useErpFundingTaskSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingTaskSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingTaskSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpFundingTaskSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingTaskSummaryQuery, ErpFundingTaskSummaryQueryVariables>) {
        return Apollo.useQuery<ErpFundingTaskSummaryQuery, ErpFundingTaskSummaryQueryVariables>(ErpFundingTaskSummaryDocument, baseOptions);
      }
export function useErpFundingTaskSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingTaskSummaryQuery, ErpFundingTaskSummaryQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingTaskSummaryQuery, ErpFundingTaskSummaryQueryVariables>(ErpFundingTaskSummaryDocument, baseOptions);
        }
export type ErpFundingTaskSummaryQueryHookResult = ReturnType<typeof useErpFundingTaskSummaryQuery>;
export type ErpFundingTaskSummaryLazyQueryHookResult = ReturnType<typeof useErpFundingTaskSummaryLazyQuery>;
export type ErpFundingTaskSummaryQueryResult = Apollo.QueryResult<ErpFundingTaskSummaryQuery, ErpFundingTaskSummaryQueryVariables>;
export const ErpFundingWatchHealthDocument = gql`
    query ErpFundingWatchHealth {
  fundingWatchHealth {
    problem
    count
    operators
    operatorRefs {
      id
      name
    }
  }
  fundingWatchOperatorsBroken
}
    `;

/**
 * __useErpFundingWatchHealthQuery__
 *
 * To run a query within a React component, call `useErpFundingWatchHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingWatchHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingWatchHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpFundingWatchHealthQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingWatchHealthQuery, ErpFundingWatchHealthQueryVariables>) {
        return Apollo.useQuery<ErpFundingWatchHealthQuery, ErpFundingWatchHealthQueryVariables>(ErpFundingWatchHealthDocument, baseOptions);
      }
export function useErpFundingWatchHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingWatchHealthQuery, ErpFundingWatchHealthQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingWatchHealthQuery, ErpFundingWatchHealthQueryVariables>(ErpFundingWatchHealthDocument, baseOptions);
        }
export type ErpFundingWatchHealthQueryHookResult = ReturnType<typeof useErpFundingWatchHealthQuery>;
export type ErpFundingWatchHealthLazyQueryHookResult = ReturnType<typeof useErpFundingWatchHealthLazyQuery>;
export type ErpFundingWatchHealthQueryResult = Apollo.QueryResult<ErpFundingWatchHealthQuery, ErpFundingWatchHealthQueryVariables>;
export const ErpFundingImportRunDocument = gql`
    query ErpFundingImportRun($id: ID!) {
  fundingImportRun(id: $id) {
    id
    taskName
    triggerSource
    startedByName
    dryRun
    status
    startedAt
    finishedAt
    durationSeconds
    errorMessage
    stats
    sourceExportedAt
  }
}
    `;

/**
 * __useErpFundingImportRunQuery__
 *
 * To run a query within a React component, call `useErpFundingImportRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingImportRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingImportRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpFundingImportRunQuery(baseOptions: Apollo.QueryHookOptions<ErpFundingImportRunQuery, ErpFundingImportRunQueryVariables>) {
        return Apollo.useQuery<ErpFundingImportRunQuery, ErpFundingImportRunQueryVariables>(ErpFundingImportRunDocument, baseOptions);
      }
export function useErpFundingImportRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingImportRunQuery, ErpFundingImportRunQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingImportRunQuery, ErpFundingImportRunQueryVariables>(ErpFundingImportRunDocument, baseOptions);
        }
export type ErpFundingImportRunQueryHookResult = ReturnType<typeof useErpFundingImportRunQuery>;
export type ErpFundingImportRunLazyQueryHookResult = ReturnType<typeof useErpFundingImportRunLazyQuery>;
export type ErpFundingImportRunQueryResult = Apollo.QueryResult<ErpFundingImportRunQuery, ErpFundingImportRunQueryVariables>;
export const ErpFundingFormSubmissionsTotalDocument = gql`
    query ErpFundingFormSubmissionsTotal($state: String, $search: String, $submittedFrom: Date, $submittedTo: Date) {
  fundingFormSubmissionsTotal(
    state: $state
    search: $search
    submittedFrom: $submittedFrom
    submittedTo: $submittedTo
  )
}
    `;

/**
 * __useErpFundingFormSubmissionsTotalQuery__
 *
 * To run a query within a React component, call `useErpFundingFormSubmissionsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingFormSubmissionsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingFormSubmissionsTotalQuery({
 *   variables: {
 *      state: // value for 'state'
 *      search: // value for 'search'
 *      submittedFrom: // value for 'submittedFrom'
 *      submittedTo: // value for 'submittedTo'
 *   },
 * });
 */
export function useErpFundingFormSubmissionsTotalQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingFormSubmissionsTotalQuery, ErpFundingFormSubmissionsTotalQueryVariables>) {
        return Apollo.useQuery<ErpFundingFormSubmissionsTotalQuery, ErpFundingFormSubmissionsTotalQueryVariables>(ErpFundingFormSubmissionsTotalDocument, baseOptions);
      }
export function useErpFundingFormSubmissionsTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingFormSubmissionsTotalQuery, ErpFundingFormSubmissionsTotalQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingFormSubmissionsTotalQuery, ErpFundingFormSubmissionsTotalQueryVariables>(ErpFundingFormSubmissionsTotalDocument, baseOptions);
        }
export type ErpFundingFormSubmissionsTotalQueryHookResult = ReturnType<typeof useErpFundingFormSubmissionsTotalQuery>;
export type ErpFundingFormSubmissionsTotalLazyQueryHookResult = ReturnType<typeof useErpFundingFormSubmissionsTotalLazyQuery>;
export type ErpFundingFormSubmissionsTotalQueryResult = Apollo.QueryResult<ErpFundingFormSubmissionsTotalQuery, ErpFundingFormSubmissionsTotalQueryVariables>;
export const ErpFundingOperatorsTotalDocument = gql`
    query ErpFundingOperatorsTotal($programType: String, $voivodeshipId: ID, $powiatId: ID, $search: String, $isActive: Boolean, $paymentMethod: String, $pageChanged: Boolean, $pageSegment: String, $intakeConfirmation: String, $clientType: String, $intakePeriod: String, $urlSuspect: Boolean) {
  fundingOperatorsTotal(
    programType: $programType
    voivodeshipId: $voivodeshipId
    powiatId: $powiatId
    search: $search
    isActive: $isActive
    paymentMethod: $paymentMethod
    pageChanged: $pageChanged
    pageSegment: $pageSegment
    intakeConfirmation: $intakeConfirmation
    clientType: $clientType
    intakePeriod: $intakePeriod
    urlSuspect: $urlSuspect
  )
}
    `;

/**
 * __useErpFundingOperatorsTotalQuery__
 *
 * To run a query within a React component, call `useErpFundingOperatorsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingOperatorsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingOperatorsTotalQuery({
 *   variables: {
 *      programType: // value for 'programType'
 *      voivodeshipId: // value for 'voivodeshipId'
 *      powiatId: // value for 'powiatId'
 *      search: // value for 'search'
 *      isActive: // value for 'isActive'
 *      paymentMethod: // value for 'paymentMethod'
 *      pageChanged: // value for 'pageChanged'
 *      pageSegment: // value for 'pageSegment'
 *      intakeConfirmation: // value for 'intakeConfirmation'
 *      clientType: // value for 'clientType'
 *      intakePeriod: // value for 'intakePeriod'
 *      urlSuspect: // value for 'urlSuspect'
 *   },
 * });
 */
export function useErpFundingOperatorsTotalQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingOperatorsTotalQuery, ErpFundingOperatorsTotalQueryVariables>) {
        return Apollo.useQuery<ErpFundingOperatorsTotalQuery, ErpFundingOperatorsTotalQueryVariables>(ErpFundingOperatorsTotalDocument, baseOptions);
      }
export function useErpFundingOperatorsTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingOperatorsTotalQuery, ErpFundingOperatorsTotalQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingOperatorsTotalQuery, ErpFundingOperatorsTotalQueryVariables>(ErpFundingOperatorsTotalDocument, baseOptions);
        }
export type ErpFundingOperatorsTotalQueryHookResult = ReturnType<typeof useErpFundingOperatorsTotalQuery>;
export type ErpFundingOperatorsTotalLazyQueryHookResult = ReturnType<typeof useErpFundingOperatorsTotalLazyQuery>;
export type ErpFundingOperatorsTotalQueryResult = Apollo.QueryResult<ErpFundingOperatorsTotalQuery, ErpFundingOperatorsTotalQueryVariables>;
export const ErpFundingCandidatesTotalDocument = gql`
    query ErpFundingCandidatesTotal($status: String, $statusGroup: String, $operatorId: ID, $matchStatus: String, $voivodeshipId: ID, $isDeposit: Boolean, $isStudent: Boolean, $employmentStatus: String, $includeArchived: Boolean, $needsAttention: Boolean, $hasDuplicates: Boolean, $needsOperatorReview: Boolean, $operatorMatch: String, $search: String) {
  fundingCandidatesTotal(
    status: $status
    statusGroup: $statusGroup
    operatorId: $operatorId
    matchStatus: $matchStatus
    voivodeshipId: $voivodeshipId
    isDeposit: $isDeposit
    isStudent: $isStudent
    employmentStatus: $employmentStatus
    includeArchived: $includeArchived
    needsAttention: $needsAttention
    hasDuplicates: $hasDuplicates
    needsOperatorReview: $needsOperatorReview
    operatorMatch: $operatorMatch
    search: $search
  )
}
    `;

/**
 * __useErpFundingCandidatesTotalQuery__
 *
 * To run a query within a React component, call `useErpFundingCandidatesTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingCandidatesTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingCandidatesTotalQuery({
 *   variables: {
 *      status: // value for 'status'
 *      statusGroup: // value for 'statusGroup'
 *      operatorId: // value for 'operatorId'
 *      matchStatus: // value for 'matchStatus'
 *      voivodeshipId: // value for 'voivodeshipId'
 *      isDeposit: // value for 'isDeposit'
 *      isStudent: // value for 'isStudent'
 *      employmentStatus: // value for 'employmentStatus'
 *      includeArchived: // value for 'includeArchived'
 *      needsAttention: // value for 'needsAttention'
 *      hasDuplicates: // value for 'hasDuplicates'
 *      needsOperatorReview: // value for 'needsOperatorReview'
 *      operatorMatch: // value for 'operatorMatch'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpFundingCandidatesTotalQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingCandidatesTotalQuery, ErpFundingCandidatesTotalQueryVariables>) {
        return Apollo.useQuery<ErpFundingCandidatesTotalQuery, ErpFundingCandidatesTotalQueryVariables>(ErpFundingCandidatesTotalDocument, baseOptions);
      }
export function useErpFundingCandidatesTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingCandidatesTotalQuery, ErpFundingCandidatesTotalQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingCandidatesTotalQuery, ErpFundingCandidatesTotalQueryVariables>(ErpFundingCandidatesTotalDocument, baseOptions);
        }
export type ErpFundingCandidatesTotalQueryHookResult = ReturnType<typeof useErpFundingCandidatesTotalQuery>;
export type ErpFundingCandidatesTotalLazyQueryHookResult = ReturnType<typeof useErpFundingCandidatesTotalLazyQuery>;
export type ErpFundingCandidatesTotalQueryResult = Apollo.QueryResult<ErpFundingCandidatesTotalQuery, ErpFundingCandidatesTotalQueryVariables>;
export const ErpFundingForUserDocument = gql`
    query ErpFundingForUser($userId: ID!) {
  fundingCandidateForUser(userId: $userId) {
    id
    status
    statusChangedAt
    isDeposit
    needsAttention
    attentionNote
    approvedAmount
    currency
    matchStatus
    primaryOperator {
      id
      name
      programType
      clientType
      instructionUrl
      instructionReady
      rollingIntake
      currentIntake {
        id
        startsOn
        endsOn
        status
      }
    }
    operators {
      id
      name
      programType
      clientType
      instructionUrl
      instructionReady
      rollingIntake
      currentIntake {
        id
        startsOn
        endsOn
        status
      }
    }
    activeOperatorsCount
  }
}
    `;

/**
 * __useErpFundingForUserQuery__
 *
 * To run a query within a React component, call `useErpFundingForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useErpFundingForUserQuery(baseOptions: Apollo.QueryHookOptions<ErpFundingForUserQuery, ErpFundingForUserQueryVariables>) {
        return Apollo.useQuery<ErpFundingForUserQuery, ErpFundingForUserQueryVariables>(ErpFundingForUserDocument, baseOptions);
      }
export function useErpFundingForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingForUserQuery, ErpFundingForUserQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingForUserQuery, ErpFundingForUserQueryVariables>(ErpFundingForUserDocument, baseOptions);
        }
export type ErpFundingForUserQueryHookResult = ReturnType<typeof useErpFundingForUserQuery>;
export type ErpFundingForUserLazyQueryHookResult = ReturnType<typeof useErpFundingForUserLazyQuery>;
export type ErpFundingForUserQueryResult = Apollo.QueryResult<ErpFundingForUserQuery, ErpFundingForUserQueryVariables>;
export const ErpFundingUserSearchDocument = gql`
    query ErpFundingUserSearch($search: String) {
  users(search: $search, first: 20) {
    edges {
      node {
        id
        firstName
        lastName
        email
        phone
        roles
        student {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useErpFundingUserSearchQuery__
 *
 * To run a query within a React component, call `useErpFundingUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingUserSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpFundingUserSearchQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingUserSearchQuery, ErpFundingUserSearchQueryVariables>) {
        return Apollo.useQuery<ErpFundingUserSearchQuery, ErpFundingUserSearchQueryVariables>(ErpFundingUserSearchDocument, baseOptions);
      }
export function useErpFundingUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingUserSearchQuery, ErpFundingUserSearchQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingUserSearchQuery, ErpFundingUserSearchQueryVariables>(ErpFundingUserSearchDocument, baseOptions);
        }
export type ErpFundingUserSearchQueryHookResult = ReturnType<typeof useErpFundingUserSearchQuery>;
export type ErpFundingUserSearchLazyQueryHookResult = ReturnType<typeof useErpFundingUserSearchLazyQuery>;
export type ErpFundingUserSearchQueryResult = Apollo.QueryResult<ErpFundingUserSearchQuery, ErpFundingUserSearchQueryVariables>;
export const ErpFundingOperatorDocument = gql`
    query ErpFundingOperator($id: ID!) {
  fundingOperator(id: $id) {
    id
    name
    programType
    programName
    projectNumber
    isActive
    coverageScope
    coverageIncomplete
    voivodeship {
      id
      name
    }
    powiats {
      id
      name
      code
      kind
      voivodeshipName
    }
    powiatsUnresolved
    maxAmount
    maxAmountCurrency
    ownContributionPercent
    paymentMethod
    decisionDays
    implementationStart
    implementationEnd
    rollingIntake
    acceptsUnemployed
    acceptsEmployerApplications
    supportsDisabled
    supportsAge50Plus
    greenCompetences
    servedStatuses
    instructionUrl
    instructionReady
    operatorInstructionUrl
    projectUrl
    newsUrl
    documentsUrl
    documentsNote
    pageState
    hasConfirmedIntake
    clientType
    intakePeriod
    nameSaysB2b
    urlSuspect
    pageLinksCount
    pageDiff {
      comparable
      added
      removed
      addedTotal
      removedTotal
    }
    pageChanged
    pageChangedAt
    pageChangedReason
    pageTextWatched
    pageHashCheckedAt
    pageCheckedOkAt
    feedUrl
    lastNotifiedAt
    phone
    email
    comment
    internalNote
    candidatesCount
    currentIntake {
      id
      startsOn
      endsOn
      startsAtTime
      endsAtTime
      status
      phase
      daysLeft
      confirmedAt
      confirmedByName
    }
    intakes {
      id
      startsOn
      endsOn
      startsAtTime
      endsAtTime
      announcedAt
      status
      phase
      daysLeft
      confirmedAt
      confirmedByName
      notifiedAt
      notifiedCount
      candidatesCount
      sourceUrl
      note
    }
  }
}
    `;

/**
 * __useErpFundingOperatorQuery__
 *
 * To run a query within a React component, call `useErpFundingOperatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingOperatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingOperatorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpFundingOperatorQuery(baseOptions: Apollo.QueryHookOptions<ErpFundingOperatorQuery, ErpFundingOperatorQueryVariables>) {
        return Apollo.useQuery<ErpFundingOperatorQuery, ErpFundingOperatorQueryVariables>(ErpFundingOperatorDocument, baseOptions);
      }
export function useErpFundingOperatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingOperatorQuery, ErpFundingOperatorQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingOperatorQuery, ErpFundingOperatorQueryVariables>(ErpFundingOperatorDocument, baseOptions);
        }
export type ErpFundingOperatorQueryHookResult = ReturnType<typeof useErpFundingOperatorQuery>;
export type ErpFundingOperatorLazyQueryHookResult = ReturnType<typeof useErpFundingOperatorLazyQuery>;
export type ErpFundingOperatorQueryResult = Apollo.QueryResult<ErpFundingOperatorQuery, ErpFundingOperatorQueryVariables>;
export const ErpFundingIntakeDocument = gql`
    query ErpFundingIntake($id: ID!) {
  fundingIntake(id: $id) {
    id
    operatorId
    operatorName
    operatorProgramType
    operatorClientType
    startsOn
    endsOn
    startsAtTime
    endsAtTime
    announcedAt
    status
    phase
    daysLeft
    sourceUrl
    note
    confirmedAt
    confirmedByName
    notifiedAt
    notifiedCount
    candidatesCount
    waitingCandidatesCount
    mail {
      sent
      failed
      pending
      waiting
      firstPlannedOn
      nextRunAt
    }
  }
}
    `;

/**
 * __useErpFundingIntakeQuery__
 *
 * To run a query within a React component, call `useErpFundingIntakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingIntakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingIntakeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpFundingIntakeQuery(baseOptions: Apollo.QueryHookOptions<ErpFundingIntakeQuery, ErpFundingIntakeQueryVariables>) {
        return Apollo.useQuery<ErpFundingIntakeQuery, ErpFundingIntakeQueryVariables>(ErpFundingIntakeDocument, baseOptions);
      }
export function useErpFundingIntakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingIntakeQuery, ErpFundingIntakeQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingIntakeQuery, ErpFundingIntakeQueryVariables>(ErpFundingIntakeDocument, baseOptions);
        }
export type ErpFundingIntakeQueryHookResult = ReturnType<typeof useErpFundingIntakeQuery>;
export type ErpFundingIntakeLazyQueryHookResult = ReturnType<typeof useErpFundingIntakeLazyQuery>;
export type ErpFundingIntakeQueryResult = Apollo.QueryResult<ErpFundingIntakeQuery, ErpFundingIntakeQueryVariables>;
export const ErpFundingIntakesDocument = gql`
    query ErpFundingIntakes($operatorId: ID, $phase: [String!], $confirmation: String, $startsFrom: Date, $startsTo: Date, $search: String, $limit: Int, $offset: Int) {
  fundingIntakes(
    operatorId: $operatorId
    phase: $phase
    confirmation: $confirmation
    startsFrom: $startsFrom
    startsTo: $startsTo
    search: $search
    limit: $limit
    offset: $offset
  ) {
    id
    operatorId
    operatorName
    operatorProgramType
    operatorClientType
    startsOn
    endsOn
    startsAtTime
    endsAtTime
    status
    phase
    daysLeft
    note
    confirmedAt
    confirmedByName
    notifiedAt
    notifiedCount
    candidatesCount
    waitingCandidatesCount
    firstPlannedOn
  }
}
    `;

/**
 * __useErpFundingIntakesQuery__
 *
 * To run a query within a React component, call `useErpFundingIntakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingIntakesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingIntakesQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      phase: // value for 'phase'
 *      confirmation: // value for 'confirmation'
 *      startsFrom: // value for 'startsFrom'
 *      startsTo: // value for 'startsTo'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useErpFundingIntakesQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingIntakesQuery, ErpFundingIntakesQueryVariables>) {
        return Apollo.useQuery<ErpFundingIntakesQuery, ErpFundingIntakesQueryVariables>(ErpFundingIntakesDocument, baseOptions);
      }
export function useErpFundingIntakesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingIntakesQuery, ErpFundingIntakesQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingIntakesQuery, ErpFundingIntakesQueryVariables>(ErpFundingIntakesDocument, baseOptions);
        }
export type ErpFundingIntakesQueryHookResult = ReturnType<typeof useErpFundingIntakesQuery>;
export type ErpFundingIntakesLazyQueryHookResult = ReturnType<typeof useErpFundingIntakesLazyQuery>;
export type ErpFundingIntakesQueryResult = Apollo.QueryResult<ErpFundingIntakesQuery, ErpFundingIntakesQueryVariables>;
export const ErpFundingIntakesTotalDocument = gql`
    query ErpFundingIntakesTotal($operatorId: ID, $phase: [String!], $confirmation: String, $startsFrom: Date, $startsTo: Date, $search: String) {
  fundingIntakesTotal(
    operatorId: $operatorId
    phase: $phase
    confirmation: $confirmation
    startsFrom: $startsFrom
    startsTo: $startsTo
    search: $search
  )
}
    `;

/**
 * __useErpFundingIntakesTotalQuery__
 *
 * To run a query within a React component, call `useErpFundingIntakesTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingIntakesTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingIntakesTotalQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      phase: // value for 'phase'
 *      confirmation: // value for 'confirmation'
 *      startsFrom: // value for 'startsFrom'
 *      startsTo: // value for 'startsTo'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpFundingIntakesTotalQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingIntakesTotalQuery, ErpFundingIntakesTotalQueryVariables>) {
        return Apollo.useQuery<ErpFundingIntakesTotalQuery, ErpFundingIntakesTotalQueryVariables>(ErpFundingIntakesTotalDocument, baseOptions);
      }
export function useErpFundingIntakesTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingIntakesTotalQuery, ErpFundingIntakesTotalQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingIntakesTotalQuery, ErpFundingIntakesTotalQueryVariables>(ErpFundingIntakesTotalDocument, baseOptions);
        }
export type ErpFundingIntakesTotalQueryHookResult = ReturnType<typeof useErpFundingIntakesTotalQuery>;
export type ErpFundingIntakesTotalLazyQueryHookResult = ReturnType<typeof useErpFundingIntakesTotalLazyQuery>;
export type ErpFundingIntakesTotalQueryResult = Apollo.QueryResult<ErpFundingIntakesTotalQuery, ErpFundingIntakesTotalQueryVariables>;
export const ErpFundingStatsDocument = gql`
    query ErpFundingStats($dimension: String!, $statusGroup: String, $operatorId: ID, $matchStatus: String, $voivodeshipId: ID, $isDeposit: Boolean, $isStudent: Boolean, $employmentStatus: String, $search: String) {
  fundingCandidateStats(
    dimension: $dimension
    statusGroup: $statusGroup
    operatorId: $operatorId
    matchStatus: $matchStatus
    voivodeshipId: $voivodeshipId
    isDeposit: $isDeposit
    isStudent: $isStudent
    employmentStatus: $employmentStatus
    search: $search
  ) {
    dimension
    total
    medianDecisionDays
    depositWaiting
    buckets {
      key
      label
      value
      share
    }
  }
}
    `;

/**
 * __useErpFundingStatsQuery__
 *
 * To run a query within a React component, call `useErpFundingStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingStatsQuery({
 *   variables: {
 *      dimension: // value for 'dimension'
 *      statusGroup: // value for 'statusGroup'
 *      operatorId: // value for 'operatorId'
 *      matchStatus: // value for 'matchStatus'
 *      voivodeshipId: // value for 'voivodeshipId'
 *      isDeposit: // value for 'isDeposit'
 *      isStudent: // value for 'isStudent'
 *      employmentStatus: // value for 'employmentStatus'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpFundingStatsQuery(baseOptions: Apollo.QueryHookOptions<ErpFundingStatsQuery, ErpFundingStatsQueryVariables>) {
        return Apollo.useQuery<ErpFundingStatsQuery, ErpFundingStatsQueryVariables>(ErpFundingStatsDocument, baseOptions);
      }
export function useErpFundingStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingStatsQuery, ErpFundingStatsQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingStatsQuery, ErpFundingStatsQueryVariables>(ErpFundingStatsDocument, baseOptions);
        }
export type ErpFundingStatsQueryHookResult = ReturnType<typeof useErpFundingStatsQuery>;
export type ErpFundingStatsLazyQueryHookResult = ReturnType<typeof useErpFundingStatsLazyQuery>;
export type ErpFundingStatsQueryResult = Apollo.QueryResult<ErpFundingStatsQuery, ErpFundingStatsQueryVariables>;
export const ErpFundingNotificationsDocument = gql`
    query ErpFundingNotifications($candidateId: ID, $kind: String, $status: String, $deliveryState: String, $operatorId: ID, $intakeId: ID, $ruleId: ID, $templateId: String, $dateFrom: Date, $dateTo: Date, $search: String, $limit: Int, $offset: Int) {
  fundingNotifications(
    candidateId: $candidateId
    kind: $kind
    status: $status
    deliveryState: $deliveryState
    operatorId: $operatorId
    intakeId: $intakeId
    ruleId: $ruleId
    templateId: $templateId
    dateFrom: $dateFrom
    dateTo: $dateTo
    search: $search
    limit: $limit
    offset: $offset
  ) {
    id
    kind
    status
    email
    reason
    sentAt
    createdAt
    operatorId
    operatorName
    operatorClientType
    intakeId
    intakeStartsOn
    intakeEndsOn
    templateId
    templateName
    ruleId
    ruleOffsetDays
    ruleEveryDays
    dynamicData
    dedupKey
    sgMessageId
    runId
    candidateId
    candidateName
    deliveryState
    deliveredAt
    firstOpenedAt
    openCount
    bounceReason
    dropReason
  }
  fundingNotificationsTotal(
    candidateId: $candidateId
    kind: $kind
    status: $status
    deliveryState: $deliveryState
    operatorId: $operatorId
    intakeId: $intakeId
    ruleId: $ruleId
    templateId: $templateId
    dateFrom: $dateFrom
    dateTo: $dateTo
    search: $search
  )
}
    `;

/**
 * __useErpFundingNotificationsQuery__
 *
 * To run a query within a React component, call `useErpFundingNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingNotificationsQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      kind: // value for 'kind'
 *      status: // value for 'status'
 *      deliveryState: // value for 'deliveryState'
 *      operatorId: // value for 'operatorId'
 *      intakeId: // value for 'intakeId'
 *      ruleId: // value for 'ruleId'
 *      templateId: // value for 'templateId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useErpFundingNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingNotificationsQuery, ErpFundingNotificationsQueryVariables>) {
        return Apollo.useQuery<ErpFundingNotificationsQuery, ErpFundingNotificationsQueryVariables>(ErpFundingNotificationsDocument, baseOptions);
      }
export function useErpFundingNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingNotificationsQuery, ErpFundingNotificationsQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingNotificationsQuery, ErpFundingNotificationsQueryVariables>(ErpFundingNotificationsDocument, baseOptions);
        }
export type ErpFundingNotificationsQueryHookResult = ReturnType<typeof useErpFundingNotificationsQuery>;
export type ErpFundingNotificationsLazyQueryHookResult = ReturnType<typeof useErpFundingNotificationsLazyQuery>;
export type ErpFundingNotificationsQueryResult = Apollo.QueryResult<ErpFundingNotificationsQuery, ErpFundingNotificationsQueryVariables>;
export const ErpFundingFormSubmissionsDocument = gql`
    query ErpFundingFormSubmissions($state: String, $search: String, $submittedFrom: Date, $submittedTo: Date, $limit: Int, $offset: Int) {
  fundingFormSubmissions(
    state: $state
    search: $search
    submittedFrom: $submittedFrom
    submittedTo: $submittedTo
    limit: $limit
    offset: $offset
  ) {
    id
    email
    phone
    submittedAt
    processedAt
    processError
    candidateId
    candidateName
    utmSource
    utmCampaign
    rejectedReason
    botSignal
    state
    candidateStatus
    candidateOperatorId
    candidateOperatorIds
    candidateOperatorName
    candidateOperators {
      id
      name
    }
    candidateVoivodeship
    candidateVoivodeshipId
    candidateEmploymentStatus
    candidateEmployerName
    geoRejected {
      key
      value
    }
  }
  fundingFormUrl
}
    `;

/**
 * __useErpFundingFormSubmissionsQuery__
 *
 * To run a query within a React component, call `useErpFundingFormSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingFormSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingFormSubmissionsQuery({
 *   variables: {
 *      state: // value for 'state'
 *      search: // value for 'search'
 *      submittedFrom: // value for 'submittedFrom'
 *      submittedTo: // value for 'submittedTo'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useErpFundingFormSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingFormSubmissionsQuery, ErpFundingFormSubmissionsQueryVariables>) {
        return Apollo.useQuery<ErpFundingFormSubmissionsQuery, ErpFundingFormSubmissionsQueryVariables>(ErpFundingFormSubmissionsDocument, baseOptions);
      }
export function useErpFundingFormSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingFormSubmissionsQuery, ErpFundingFormSubmissionsQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingFormSubmissionsQuery, ErpFundingFormSubmissionsQueryVariables>(ErpFundingFormSubmissionsDocument, baseOptions);
        }
export type ErpFundingFormSubmissionsQueryHookResult = ReturnType<typeof useErpFundingFormSubmissionsQuery>;
export type ErpFundingFormSubmissionsLazyQueryHookResult = ReturnType<typeof useErpFundingFormSubmissionsLazyQuery>;
export type ErpFundingFormSubmissionsQueryResult = Apollo.QueryResult<ErpFundingFormSubmissionsQuery, ErpFundingFormSubmissionsQueryVariables>;
export const ErpFundingSubmissionStatesDocument = gql`
    query ErpFundingSubmissionStates($search: String, $submittedFrom: Date, $submittedTo: Date) {
  fundingSubmissionStates(
    search: $search
    submittedFrom: $submittedFrom
    submittedTo: $submittedTo
  ) {
    state
    count
  }
}
    `;

/**
 * __useErpFundingSubmissionStatesQuery__
 *
 * To run a query within a React component, call `useErpFundingSubmissionStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingSubmissionStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingSubmissionStatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      submittedFrom: // value for 'submittedFrom'
 *      submittedTo: // value for 'submittedTo'
 *   },
 * });
 */
export function useErpFundingSubmissionStatesQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingSubmissionStatesQuery, ErpFundingSubmissionStatesQueryVariables>) {
        return Apollo.useQuery<ErpFundingSubmissionStatesQuery, ErpFundingSubmissionStatesQueryVariables>(ErpFundingSubmissionStatesDocument, baseOptions);
      }
export function useErpFundingSubmissionStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingSubmissionStatesQuery, ErpFundingSubmissionStatesQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingSubmissionStatesQuery, ErpFundingSubmissionStatesQueryVariables>(ErpFundingSubmissionStatesDocument, baseOptions);
        }
export type ErpFundingSubmissionStatesQueryHookResult = ReturnType<typeof useErpFundingSubmissionStatesQuery>;
export type ErpFundingSubmissionStatesLazyQueryHookResult = ReturnType<typeof useErpFundingSubmissionStatesLazyQuery>;
export type ErpFundingSubmissionStatesQueryResult = Apollo.QueryResult<ErpFundingSubmissionStatesQuery, ErpFundingSubmissionStatesQueryVariables>;
export const ErpFundingFormSubmissionDocument = gql`
    query ErpFundingFormSubmission($id: ID!) {
  fundingFormSubmission(id: $id) {
    id
    email
    phone
    submittedAt
    processedAt
    processError
    utmSource
    utmCampaign
    rejectedReason
    state
    candidateId
    candidateName
    candidateStatus
    candidateOperatorId
    candidateOperatorIds
    candidateOperatorName
    candidateOperators {
      id
      name
    }
    candidateVoivodeship
    candidateVoivodeshipId
    candidateEmploymentStatus
    candidateEmployerName
    geoRejected {
      key
      value
    }
    payloadAnswers {
      field
      value
    }
    candidateOperatorSource
    candidateOperatorSetBy
    candidateOperatorSetAt
  }
}
    `;

/**
 * __useErpFundingFormSubmissionQuery__
 *
 * To run a query within a React component, call `useErpFundingFormSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingFormSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingFormSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpFundingFormSubmissionQuery(baseOptions: Apollo.QueryHookOptions<ErpFundingFormSubmissionQuery, ErpFundingFormSubmissionQueryVariables>) {
        return Apollo.useQuery<ErpFundingFormSubmissionQuery, ErpFundingFormSubmissionQueryVariables>(ErpFundingFormSubmissionDocument, baseOptions);
      }
export function useErpFundingFormSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingFormSubmissionQuery, ErpFundingFormSubmissionQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingFormSubmissionQuery, ErpFundingFormSubmissionQueryVariables>(ErpFundingFormSubmissionDocument, baseOptions);
        }
export type ErpFundingFormSubmissionQueryHookResult = ReturnType<typeof useErpFundingFormSubmissionQuery>;
export type ErpFundingFormSubmissionLazyQueryHookResult = ReturnType<typeof useErpFundingFormSubmissionLazyQuery>;
export type ErpFundingFormSubmissionQueryResult = Apollo.QueryResult<ErpFundingFormSubmissionQuery, ErpFundingFormSubmissionQueryVariables>;
export const ErpPublicFundingGeoDocument = gql`
    query ErpPublicFundingGeo($voivodeshipId: ID) {
  publicFundingVoivodeships {
    id
    name
  }
  publicFundingPowiats(voivodeshipId: $voivodeshipId) {
    id
    name
    voivodeshipId
  }
}
    `;

/**
 * __useErpPublicFundingGeoQuery__
 *
 * To run a query within a React component, call `useErpPublicFundingGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpPublicFundingGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpPublicFundingGeoQuery({
 *   variables: {
 *      voivodeshipId: // value for 'voivodeshipId'
 *   },
 * });
 */
export function useErpPublicFundingGeoQuery(baseOptions?: Apollo.QueryHookOptions<ErpPublicFundingGeoQuery, ErpPublicFundingGeoQueryVariables>) {
        return Apollo.useQuery<ErpPublicFundingGeoQuery, ErpPublicFundingGeoQueryVariables>(ErpPublicFundingGeoDocument, baseOptions);
      }
export function useErpPublicFundingGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpPublicFundingGeoQuery, ErpPublicFundingGeoQueryVariables>) {
          return Apollo.useLazyQuery<ErpPublicFundingGeoQuery, ErpPublicFundingGeoQueryVariables>(ErpPublicFundingGeoDocument, baseOptions);
        }
export type ErpPublicFundingGeoQueryHookResult = ReturnType<typeof useErpPublicFundingGeoQuery>;
export type ErpPublicFundingGeoLazyQueryHookResult = ReturnType<typeof useErpPublicFundingGeoLazyQuery>;
export type ErpPublicFundingGeoQueryResult = Apollo.QueryResult<ErpPublicFundingGeoQuery, ErpPublicFundingGeoQueryVariables>;
export const ErpFundingMailSettingsDocument = gql`
    query ErpFundingMailSettings {
  fundingMailSettings {
    paused
    fromEmail
    fromName
    replyTo
    effectiveFromEmail
    effectiveFromName
    effectiveReplyTo
    soonSendHour
    runningSendHour
    updatedAt
    updatedByName
    serverMailEnabled
    testRecipient
    notifyScheduled
    automatchScheduled
    shortenerEnabled
    canEdit
    automatchBlocked
  }
}
    `;

/**
 * __useErpFundingMailSettingsQuery__
 *
 * To run a query within a React component, call `useErpFundingMailSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingMailSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingMailSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpFundingMailSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingMailSettingsQuery, ErpFundingMailSettingsQueryVariables>) {
        return Apollo.useQuery<ErpFundingMailSettingsQuery, ErpFundingMailSettingsQueryVariables>(ErpFundingMailSettingsDocument, baseOptions);
      }
export function useErpFundingMailSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingMailSettingsQuery, ErpFundingMailSettingsQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingMailSettingsQuery, ErpFundingMailSettingsQueryVariables>(ErpFundingMailSettingsDocument, baseOptions);
        }
export type ErpFundingMailSettingsQueryHookResult = ReturnType<typeof useErpFundingMailSettingsQuery>;
export type ErpFundingMailSettingsLazyQueryHookResult = ReturnType<typeof useErpFundingMailSettingsLazyQuery>;
export type ErpFundingMailSettingsQueryResult = Apollo.QueryResult<ErpFundingMailSettingsQuery, ErpFundingMailSettingsQueryVariables>;
export const ErpFundingMailRulesDocument = gql`
    query ErpFundingMailRules {
  fundingMailRules {
    id
    code
    kind
    offsetDays
    everyDays
    templateId
    templateName
    templateSubject
    isActive
    updatedAt
    updatedByName
    canDelete
    sentCount
  }
}
    `;

/**
 * __useErpFundingMailRulesQuery__
 *
 * To run a query within a React component, call `useErpFundingMailRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingMailRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingMailRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpFundingMailRulesQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingMailRulesQuery, ErpFundingMailRulesQueryVariables>) {
        return Apollo.useQuery<ErpFundingMailRulesQuery, ErpFundingMailRulesQueryVariables>(ErpFundingMailRulesDocument, baseOptions);
      }
export function useErpFundingMailRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingMailRulesQuery, ErpFundingMailRulesQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingMailRulesQuery, ErpFundingMailRulesQueryVariables>(ErpFundingMailRulesDocument, baseOptions);
        }
export type ErpFundingMailRulesQueryHookResult = ReturnType<typeof useErpFundingMailRulesQuery>;
export type ErpFundingMailRulesLazyQueryHookResult = ReturnType<typeof useErpFundingMailRulesLazyQuery>;
export type ErpFundingMailRulesQueryResult = Apollo.QueryResult<ErpFundingMailRulesQuery, ErpFundingMailRulesQueryVariables>;
export const ErpFundingMailVariablesDocument = gql`
    query ErpFundingMailVariables {
  fundingMailVariables {
    name
    descriptionRu
    descriptionPl
    example
  }
}
    `;

/**
 * __useErpFundingMailVariablesQuery__
 *
 * To run a query within a React component, call `useErpFundingMailVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingMailVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingMailVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpFundingMailVariablesQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingMailVariablesQuery, ErpFundingMailVariablesQueryVariables>) {
        return Apollo.useQuery<ErpFundingMailVariablesQuery, ErpFundingMailVariablesQueryVariables>(ErpFundingMailVariablesDocument, baseOptions);
      }
export function useErpFundingMailVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingMailVariablesQuery, ErpFundingMailVariablesQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingMailVariablesQuery, ErpFundingMailVariablesQueryVariables>(ErpFundingMailVariablesDocument, baseOptions);
        }
export type ErpFundingMailVariablesQueryHookResult = ReturnType<typeof useErpFundingMailVariablesQuery>;
export type ErpFundingMailVariablesLazyQueryHookResult = ReturnType<typeof useErpFundingMailVariablesLazyQuery>;
export type ErpFundingMailVariablesQueryResult = Apollo.QueryResult<ErpFundingMailVariablesQuery, ErpFundingMailVariablesQueryVariables>;
export const ErpFundingMailSendgridTemplatesDocument = gql`
    query ErpFundingMailSendgridTemplates {
  fundingMailSendgridTemplates {
    success
    templates {
      id
      name
      subject
      versionId
      updatedAt
    }
    customErrors {
      field
      code
      message
    }
  }
}
    `;

/**
 * __useErpFundingMailSendgridTemplatesQuery__
 *
 * To run a query within a React component, call `useErpFundingMailSendgridTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingMailSendgridTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingMailSendgridTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpFundingMailSendgridTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingMailSendgridTemplatesQuery, ErpFundingMailSendgridTemplatesQueryVariables>) {
        return Apollo.useQuery<ErpFundingMailSendgridTemplatesQuery, ErpFundingMailSendgridTemplatesQueryVariables>(ErpFundingMailSendgridTemplatesDocument, baseOptions);
      }
export function useErpFundingMailSendgridTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingMailSendgridTemplatesQuery, ErpFundingMailSendgridTemplatesQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingMailSendgridTemplatesQuery, ErpFundingMailSendgridTemplatesQueryVariables>(ErpFundingMailSendgridTemplatesDocument, baseOptions);
        }
export type ErpFundingMailSendgridTemplatesQueryHookResult = ReturnType<typeof useErpFundingMailSendgridTemplatesQuery>;
export type ErpFundingMailSendgridTemplatesLazyQueryHookResult = ReturnType<typeof useErpFundingMailSendgridTemplatesLazyQuery>;
export type ErpFundingMailSendgridTemplatesQueryResult = Apollo.QueryResult<ErpFundingMailSendgridTemplatesQuery, ErpFundingMailSendgridTemplatesQueryVariables>;
export const ErpFundingMailTemplateCheckDocument = gql`
    query ErpFundingMailTemplateCheck($templateId: String!) {
  fundingMailTemplateCheck(templateId: $templateId) {
    success
    templateId
    name
    subject
    hasActiveVersion
    usedVariables
    unknownVariables
    unusedVariables
    customErrors {
      field
      code
      message
    }
  }
}
    `;

/**
 * __useErpFundingMailTemplateCheckQuery__
 *
 * To run a query within a React component, call `useErpFundingMailTemplateCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingMailTemplateCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingMailTemplateCheckQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useErpFundingMailTemplateCheckQuery(baseOptions: Apollo.QueryHookOptions<ErpFundingMailTemplateCheckQuery, ErpFundingMailTemplateCheckQueryVariables>) {
        return Apollo.useQuery<ErpFundingMailTemplateCheckQuery, ErpFundingMailTemplateCheckQueryVariables>(ErpFundingMailTemplateCheckDocument, baseOptions);
      }
export function useErpFundingMailTemplateCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingMailTemplateCheckQuery, ErpFundingMailTemplateCheckQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingMailTemplateCheckQuery, ErpFundingMailTemplateCheckQueryVariables>(ErpFundingMailTemplateCheckDocument, baseOptions);
        }
export type ErpFundingMailTemplateCheckQueryHookResult = ReturnType<typeof useErpFundingMailTemplateCheckQuery>;
export type ErpFundingMailTemplateCheckLazyQueryHookResult = ReturnType<typeof useErpFundingMailTemplateCheckLazyQuery>;
export type ErpFundingMailTemplateCheckQueryResult = Apollo.QueryResult<ErpFundingMailTemplateCheckQuery, ErpFundingMailTemplateCheckQueryVariables>;
export const ErpFundingMailCalendarDocument = gql`
    query ErpFundingMailCalendar($days: Int) {
  fundingMailCalendar(days: $days) {
    date
    kind
    ruleId
    offsetDays
    daysLeft
    intakeId
    intakeStartsOn
    intakeEndsOn
    operatorId
    operatorName
    recipients
    alreadySent
    templateId
    templateName
    sendHour
    sendAt
  }
}
    `;

/**
 * __useErpFundingMailCalendarQuery__
 *
 * To run a query within a React component, call `useErpFundingMailCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpFundingMailCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpFundingMailCalendarQuery({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useErpFundingMailCalendarQuery(baseOptions?: Apollo.QueryHookOptions<ErpFundingMailCalendarQuery, ErpFundingMailCalendarQueryVariables>) {
        return Apollo.useQuery<ErpFundingMailCalendarQuery, ErpFundingMailCalendarQueryVariables>(ErpFundingMailCalendarDocument, baseOptions);
      }
export function useErpFundingMailCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpFundingMailCalendarQuery, ErpFundingMailCalendarQueryVariables>) {
          return Apollo.useLazyQuery<ErpFundingMailCalendarQuery, ErpFundingMailCalendarQueryVariables>(ErpFundingMailCalendarDocument, baseOptions);
        }
export type ErpFundingMailCalendarQueryHookResult = ReturnType<typeof useErpFundingMailCalendarQuery>;
export type ErpFundingMailCalendarLazyQueryHookResult = ReturnType<typeof useErpFundingMailCalendarLazyQuery>;
export type ErpFundingMailCalendarQueryResult = Apollo.QueryResult<ErpFundingMailCalendarQuery, ErpFundingMailCalendarQueryVariables>;
export const StudentDetailDocument = gql`
    query StudentDetail($id: ID!) {
  student(id: $id) {
    id
    registrationDate
    acquisitionSource
    kommoLeads {
      ...PersonKommoLeadFields
    }
    user {
      id
      firstName
      lastName
      middleName
      email
      phone
    }
    educationGroups {
      groupId
      groupName
      courseName
      agreementTerminated
    }
    timeline {
      edges {
        node {
          id
          type
          date
          label
          meta
        }
      }
    }
    accountsPayables {
      id
      amountForeign
      amountByn
      currency
      repaid
      startedAgreement {
        id
        agreementTitle
      }
    }
    agreements {
      id
      agreementTitle
      currency
      budgetAmount
      paidAmount
      debtAmount
      upcomingAmount
      terminated
      terminatedDate
      transferOut
      freeOfCharge
      statePrefinanced
      date
      partialAttendance
      paymentByCompany
      vat
      resident
      promocode
      comment
      legalName
      taxId
      street
      city
      zipCode
      address
      country {
        id
        title
      }
      company {
        id
        name
      }
      group {
        id
        name
        startDate
        course {
          id
          name
        }
      }
      firstLesson {
        id
        name
        lessonNumber
      }
      lastLesson {
        id
        name
        date
        lessonNumber
      }
      pandadocDocument {
        id
        pandadocId
        name
        status
        outcome
        docType
        course
        dateCompleted
        ttsHours
      }
      contractDocument {
        id
        number
        status
        fulfilmentStatus
        completedAt
      }
      payments {
        id
        date
        amountAgreement
        currency
        source
        fakturowniaInvoice {
          id
          pk
          number
          status
          priceGross
          outstanding
          kind
          currency
        }
        contribution {
          id
        }
      }
      contributions(orderByDateFilter: true) {
        edges {
          node {
            id
            date
            amountForeign
            amountByn
            complete
            remainder
            delay
            status
            coveredAmount
            debt
            paidManually
            proformas {
              id
              pk
              number
              status
              paymentTo
              currency
              priceGross
              viewUrl
              isOpenProforma
              vatChild {
                id
                number
              }
            }
            invoices {
              id
              pk
              number
              kind
              status
              paid
              outstanding
              netGross
              netPaid
              paymentTo
              currency
              provisionBlockedReason
              contributionMatchSource
              payment {
                id
                date
                amountAgreement
                currency
              }
            }
            currencyMismatchInvoices {
              id
              number
              currency
              kind
              paid
            }
            payment {
              id
              date
              amountAgreement
              currency
              fakturowniaInvoice {
                id
                pk
                number
                status
                priceGross
                outstanding
                kind
                currency
              }
            }
          }
        }
      }
      chargeback {
        id
        currency
        amountForeign
        amountByn
        date
      }
      startAccountsPayable {
        id
        amountForeign
        currency
        repaid
      }
      corrections {
        id
        date
        amountForeign
        amountByn
        currency
        reason
        payment {
          id
        }
      }
    }
  }
}
    ${PersonKommoLeadFieldsFragmentDoc}`;

/**
 * __useStudentDetailQuery__
 *
 * To run a query within a React component, call `useStudentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentDetailQuery(baseOptions: Apollo.QueryHookOptions<StudentDetailQuery, StudentDetailQueryVariables>) {
        return Apollo.useQuery<StudentDetailQuery, StudentDetailQueryVariables>(StudentDetailDocument, baseOptions);
      }
export function useStudentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentDetailQuery, StudentDetailQueryVariables>) {
          return Apollo.useLazyQuery<StudentDetailQuery, StudentDetailQueryVariables>(StudentDetailDocument, baseOptions);
        }
export type StudentDetailQueryHookResult = ReturnType<typeof useStudentDetailQuery>;
export type StudentDetailLazyQueryHookResult = ReturnType<typeof useStudentDetailLazyQuery>;
export type StudentDetailQueryResult = Apollo.QueryResult<StudentDetailQuery, StudentDetailQueryVariables>;
export const GroupDetailDocument = gql`
    query GroupDetail($id: ID!, $withStaffFields: Boolean!) {
  group(groupId: $id) {
    id
    name
    startDate
    price @include(if: $withStaffFields)
    currency @include(if: $withStaffFields)
    studentsCount
    lessonsCount
    passedLessonsCount
    freeLessonsCount
    contributionsSum
    maxStudentsCount
    freePlaces
    statusFinished
    datetimeNextLesson
    deleteAvailable @include(if: $withStaffFields)
    isFree
    comment
    publishedLms
    publishedLmsForTeacher
    publishedLmsForMethodist
    course {
      id
      name
    }
    teachers @include(if: $withStaffFields) {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGroupDetailQuery__
 *
 * To run a query within a React component, call `useGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withStaffFields: // value for 'withStaffFields'
 *   },
 * });
 */
export function useGroupDetailQuery(baseOptions: Apollo.QueryHookOptions<GroupDetailQuery, GroupDetailQueryVariables>) {
        return Apollo.useQuery<GroupDetailQuery, GroupDetailQueryVariables>(GroupDetailDocument, baseOptions);
      }
export function useGroupDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupDetailQuery, GroupDetailQueryVariables>) {
          return Apollo.useLazyQuery<GroupDetailQuery, GroupDetailQueryVariables>(GroupDetailDocument, baseOptions);
        }
export type GroupDetailQueryHookResult = ReturnType<typeof useGroupDetailQuery>;
export type GroupDetailLazyQueryHookResult = ReturnType<typeof useGroupDetailLazyQuery>;
export type GroupDetailQueryResult = Apollo.QueryResult<GroupDetailQuery, GroupDetailQueryVariables>;
export const TeacherDetailDocument = gql`
    query TeacherDetail($id: ID!) {
  teacher(teacherId: $id) {
    id
    fullName
    accessToLms
    isDismissed
    groupsCount
    rating
    studentRating
    studentRatingCount
    studentComments {
      studentName
      comment
      createdAt
      courseName
      groupName
    }
    internalNote
    interviewRecording
    photo
    description
    user {
      id
      firstName
      lastName
      middleName
      email
      phone
    }
    courses
    coursesCanTeach {
      id
      name
    }
    employmentTypes {
      __typename
    }
    applications {
      edges {
        node {
          id
          title
          lessonsCount
          appointedLessonsCount
          servicePrice
          riaPrice
          currency
          isTerminated
          isCompleted
          teacher {
            id
            fullName
          }
          group {
            id
            name
          }
          employmentType {
            __typename
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTeacherDetailQuery__
 *
 * To run a query within a React component, call `useTeacherDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeacherDetailQuery(baseOptions: Apollo.QueryHookOptions<TeacherDetailQuery, TeacherDetailQueryVariables>) {
        return Apollo.useQuery<TeacherDetailQuery, TeacherDetailQueryVariables>(TeacherDetailDocument, baseOptions);
      }
export function useTeacherDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherDetailQuery, TeacherDetailQueryVariables>) {
          return Apollo.useLazyQuery<TeacherDetailQuery, TeacherDetailQueryVariables>(TeacherDetailDocument, baseOptions);
        }
export type TeacherDetailQueryHookResult = ReturnType<typeof useTeacherDetailQuery>;
export type TeacherDetailLazyQueryHookResult = ReturnType<typeof useTeacherDetailLazyQuery>;
export type TeacherDetailQueryResult = Apollo.QueryResult<TeacherDetailQuery, TeacherDetailQueryVariables>;
export const EsignAvailabilityDocument = gql`
    query EsignAvailability {
  esignSettings {
    enabled
    mailEnabled
    mailRedirected
    inviteVia
    shortLinksEnabled
  }
}
    `;

/**
 * __useEsignAvailabilityQuery__
 *
 * To run a query within a React component, call `useEsignAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignAvailabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useEsignAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<EsignAvailabilityQuery, EsignAvailabilityQueryVariables>) {
        return Apollo.useQuery<EsignAvailabilityQuery, EsignAvailabilityQueryVariables>(EsignAvailabilityDocument, baseOptions);
      }
export function useEsignAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignAvailabilityQuery, EsignAvailabilityQueryVariables>) {
          return Apollo.useLazyQuery<EsignAvailabilityQuery, EsignAvailabilityQueryVariables>(EsignAvailabilityDocument, baseOptions);
        }
export type EsignAvailabilityQueryHookResult = ReturnType<typeof useEsignAvailabilityQuery>;
export type EsignAvailabilityLazyQueryHookResult = ReturnType<typeof useEsignAvailabilityLazyQuery>;
export type EsignAvailabilityQueryResult = Apollo.QueryResult<EsignAvailabilityQuery, EsignAvailabilityQueryVariables>;
export const ContractDocumentsListDocument = gql`
    query ContractDocumentsList($kind: String, $status: String, $fulfilmentStatus: String, $groupId: ID, $studentId: ID, $teacherId: ID, $createdById: ID, $sellerId: ID, $sentById: ID, $search: String, $dateFrom: Date, $dateTo: Date, $aploraMinWinChance: Float, $signState: [String!], $expiringWithinDays: Int, $needsAction: Boolean, $hotMinWinChance: Float, $sort: String, $limit: Int, $offset: Int, $withCounts: Boolean = true) {
  contractDocuments(
    kind: $kind
    status: $status
    fulfilmentStatus: $fulfilmentStatus
    groupId: $groupId
    studentId: $studentId
    teacherId: $teacherId
    createdById: $createdById
    sellerId: $sellerId
    sentById: $sentById
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    aploraMinWinChance: $aploraMinWinChance
    signState: $signState
    expiringWithinDays: $expiringWithinDays
    needsAction: $needsAction
    sort: $sort
    limit: $limit
    offset: $offset
  ) {
    id
    kind
    number
    status
    fulfilmentStatus
    cancelConflict
    textPending
    signerFirstName
    signerLastName
    signerEmail
    signerPhone
    signerLegalName
    groupId
    groupName
    courseName
    teacherId
    applicationId
    applicationTitle
    studentId
    agreementId
    paymentPlan {
      id
      name
    }
    currency
    listPrice
    price
    createdByName
    sellerId
    sellerName
    sentById
    sentByName
    canManage
    createdAt
    sentAt
    emailOpenedAt
    openedAt
    signedAt
    completedAt
    crmLeadId
    aploraWinChance
    aploraConsent
    aploraNextContactDate
    signState
    expiresInDays
  }
  contractDocumentsTotal(
    kind: $kind
    status: $status
    fulfilmentStatus: $fulfilmentStatus
    groupId: $groupId
    studentId: $studentId
    teacherId: $teacherId
    createdById: $createdById
    sellerId: $sellerId
    sentById: $sentById
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    aploraMinWinChance: $aploraMinWinChance
    signState: $signState
    expiringWithinDays: $expiringWithinDays
    needsAction: $needsAction
  )
  contractDocumentStatusCounts(
    kind: $kind
    status: $status
    fulfilmentStatus: $fulfilmentStatus
    groupId: $groupId
    studentId: $studentId
    teacherId: $teacherId
    createdById: $createdById
    sellerId: $sellerId
    sentById: $sentById
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    aploraMinWinChance: $aploraMinWinChance
    signState: $signState
    expiringWithinDays: $expiringWithinDays
    needsAction: $needsAction
    hotMinWinChance: $hotMinWinChance
  ) @include(if: $withCounts) {
    status
    count
    hotCount
  }
}
    `;

/**
 * __useContractDocumentsListQuery__
 *
 * To run a query within a React component, call `useContractDocumentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDocumentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDocumentsListQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      status: // value for 'status'
 *      fulfilmentStatus: // value for 'fulfilmentStatus'
 *      groupId: // value for 'groupId'
 *      studentId: // value for 'studentId'
 *      teacherId: // value for 'teacherId'
 *      createdById: // value for 'createdById'
 *      sellerId: // value for 'sellerId'
 *      sentById: // value for 'sentById'
 *      search: // value for 'search'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      aploraMinWinChance: // value for 'aploraMinWinChance'
 *      signState: // value for 'signState'
 *      expiringWithinDays: // value for 'expiringWithinDays'
 *      needsAction: // value for 'needsAction'
 *      hotMinWinChance: // value for 'hotMinWinChance'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      withCounts: // value for 'withCounts'
 *   },
 * });
 */
export function useContractDocumentsListQuery(baseOptions?: Apollo.QueryHookOptions<ContractDocumentsListQuery, ContractDocumentsListQueryVariables>) {
        return Apollo.useQuery<ContractDocumentsListQuery, ContractDocumentsListQueryVariables>(ContractDocumentsListDocument, baseOptions);
      }
export function useContractDocumentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractDocumentsListQuery, ContractDocumentsListQueryVariables>) {
          return Apollo.useLazyQuery<ContractDocumentsListQuery, ContractDocumentsListQueryVariables>(ContractDocumentsListDocument, baseOptions);
        }
export type ContractDocumentsListQueryHookResult = ReturnType<typeof useContractDocumentsListQuery>;
export type ContractDocumentsListLazyQueryHookResult = ReturnType<typeof useContractDocumentsListLazyQuery>;
export type ContractDocumentsListQueryResult = Apollo.QueryResult<ContractDocumentsListQuery, ContractDocumentsListQueryVariables>;
export const ContractBoardColumnAmountsDocument = gql`
    query ContractBoardColumnAmounts($kind: String, $status: String, $fulfilmentStatus: String, $groupId: ID, $studentId: ID, $teacherId: ID, $createdById: ID, $sellerId: ID, $sentById: ID, $search: String, $dateFrom: Date, $dateTo: Date, $aploraMinWinChance: Float, $signState: [String!], $expiringWithinDays: Int, $needsAction: Boolean) {
  contractDocumentAmounts(
    kind: $kind
    status: $status
    fulfilmentStatus: $fulfilmentStatus
    groupId: $groupId
    studentId: $studentId
    teacherId: $teacherId
    createdById: $createdById
    sellerId: $sellerId
    sentById: $sentById
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    aploraMinWinChance: $aploraMinWinChance
    signState: $signState
    expiringWithinDays: $expiringWithinDays
    needsAction: $needsAction
  ) {
    currency
    amount
    count
  }
}
    `;

/**
 * __useContractBoardColumnAmountsQuery__
 *
 * To run a query within a React component, call `useContractBoardColumnAmountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBoardColumnAmountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBoardColumnAmountsQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      status: // value for 'status'
 *      fulfilmentStatus: // value for 'fulfilmentStatus'
 *      groupId: // value for 'groupId'
 *      studentId: // value for 'studentId'
 *      teacherId: // value for 'teacherId'
 *      createdById: // value for 'createdById'
 *      sellerId: // value for 'sellerId'
 *      sentById: // value for 'sentById'
 *      search: // value for 'search'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      aploraMinWinChance: // value for 'aploraMinWinChance'
 *      signState: // value for 'signState'
 *      expiringWithinDays: // value for 'expiringWithinDays'
 *      needsAction: // value for 'needsAction'
 *   },
 * });
 */
export function useContractBoardColumnAmountsQuery(baseOptions?: Apollo.QueryHookOptions<ContractBoardColumnAmountsQuery, ContractBoardColumnAmountsQueryVariables>) {
        return Apollo.useQuery<ContractBoardColumnAmountsQuery, ContractBoardColumnAmountsQueryVariables>(ContractBoardColumnAmountsDocument, baseOptions);
      }
export function useContractBoardColumnAmountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractBoardColumnAmountsQuery, ContractBoardColumnAmountsQueryVariables>) {
          return Apollo.useLazyQuery<ContractBoardColumnAmountsQuery, ContractBoardColumnAmountsQueryVariables>(ContractBoardColumnAmountsDocument, baseOptions);
        }
export type ContractBoardColumnAmountsQueryHookResult = ReturnType<typeof useContractBoardColumnAmountsQuery>;
export type ContractBoardColumnAmountsLazyQueryHookResult = ReturnType<typeof useContractBoardColumnAmountsLazyQuery>;
export type ContractBoardColumnAmountsQueryResult = Apollo.QueryResult<ContractBoardColumnAmountsQuery, ContractBoardColumnAmountsQueryVariables>;
export const ContractSignedRecentlyDocument = gql`
    query ContractSignedRecently($kind: String, $fulfilmentStatus: String, $groupId: ID, $studentId: ID, $teacherId: ID, $createdById: ID, $sellerId: ID, $sentById: ID, $search: String, $dateFrom: Date, $dateTo: Date, $aploraMinWinChance: Float, $signState: [String!], $expiringWithinDays: Int, $needsAction: Boolean, $signedFrom: Date!) {
  contractDocumentsTotal(
    kind: $kind
    status: "completed"
    fulfilmentStatus: $fulfilmentStatus
    groupId: $groupId
    studentId: $studentId
    teacherId: $teacherId
    createdById: $createdById
    sellerId: $sellerId
    sentById: $sentById
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    aploraMinWinChance: $aploraMinWinChance
    signState: $signState
    expiringWithinDays: $expiringWithinDays
    needsAction: $needsAction
    signedFrom: $signedFrom
  )
  contractDocumentAmounts(
    kind: $kind
    status: "completed"
    fulfilmentStatus: $fulfilmentStatus
    groupId: $groupId
    studentId: $studentId
    teacherId: $teacherId
    createdById: $createdById
    sellerId: $sellerId
    sentById: $sentById
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    aploraMinWinChance: $aploraMinWinChance
    signState: $signState
    expiringWithinDays: $expiringWithinDays
    needsAction: $needsAction
    signedFrom: $signedFrom
  ) {
    currency
    amount
    count
  }
}
    `;

/**
 * __useContractSignedRecentlyQuery__
 *
 * To run a query within a React component, call `useContractSignedRecentlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractSignedRecentlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractSignedRecentlyQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      fulfilmentStatus: // value for 'fulfilmentStatus'
 *      groupId: // value for 'groupId'
 *      studentId: // value for 'studentId'
 *      teacherId: // value for 'teacherId'
 *      createdById: // value for 'createdById'
 *      sellerId: // value for 'sellerId'
 *      sentById: // value for 'sentById'
 *      search: // value for 'search'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      aploraMinWinChance: // value for 'aploraMinWinChance'
 *      signState: // value for 'signState'
 *      expiringWithinDays: // value for 'expiringWithinDays'
 *      needsAction: // value for 'needsAction'
 *      signedFrom: // value for 'signedFrom'
 *   },
 * });
 */
export function useContractSignedRecentlyQuery(baseOptions: Apollo.QueryHookOptions<ContractSignedRecentlyQuery, ContractSignedRecentlyQueryVariables>) {
        return Apollo.useQuery<ContractSignedRecentlyQuery, ContractSignedRecentlyQueryVariables>(ContractSignedRecentlyDocument, baseOptions);
      }
export function useContractSignedRecentlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractSignedRecentlyQuery, ContractSignedRecentlyQueryVariables>) {
          return Apollo.useLazyQuery<ContractSignedRecentlyQuery, ContractSignedRecentlyQueryVariables>(ContractSignedRecentlyDocument, baseOptions);
        }
export type ContractSignedRecentlyQueryHookResult = ReturnType<typeof useContractSignedRecentlyQuery>;
export type ContractSignedRecentlyLazyQueryHookResult = ReturnType<typeof useContractSignedRecentlyLazyQuery>;
export type ContractSignedRecentlyQueryResult = Apollo.QueryResult<ContractSignedRecentlyQuery, ContractSignedRecentlyQueryVariables>;
export const ContractDocumentCardDocument = gql`
    query ContractDocumentCard($id: ID!) {
  contractDocument(id: $id) {
    ...EsignContractCardFields
  }
}
    ${EsignContractCardFieldsFragmentDoc}`;

/**
 * __useContractDocumentCardQuery__
 *
 * To run a query within a React component, call `useContractDocumentCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDocumentCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDocumentCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractDocumentCardQuery(baseOptions: Apollo.QueryHookOptions<ContractDocumentCardQuery, ContractDocumentCardQueryVariables>) {
        return Apollo.useQuery<ContractDocumentCardQuery, ContractDocumentCardQueryVariables>(ContractDocumentCardDocument, baseOptions);
      }
export function useContractDocumentCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractDocumentCardQuery, ContractDocumentCardQueryVariables>) {
          return Apollo.useLazyQuery<ContractDocumentCardQuery, ContractDocumentCardQueryVariables>(ContractDocumentCardDocument, baseOptions);
        }
export type ContractDocumentCardQueryHookResult = ReturnType<typeof useContractDocumentCardQuery>;
export type ContractDocumentCardLazyQueryHookResult = ReturnType<typeof useContractDocumentCardLazyQuery>;
export type ContractDocumentCardQueryResult = Apollo.QueryResult<ContractDocumentCardQuery, ContractDocumentCardQueryVariables>;
export const EsignContractPdfLinksDocument = gql`
    query EsignContractPdfLinks($id: ID!) {
  contractDocument(id: $id) {
    id
    previewPdfUrl
    signedPdfUrl
  }
}
    `;

/**
 * __useEsignContractPdfLinksQuery__
 *
 * To run a query within a React component, call `useEsignContractPdfLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignContractPdfLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignContractPdfLinksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEsignContractPdfLinksQuery(baseOptions: Apollo.QueryHookOptions<EsignContractPdfLinksQuery, EsignContractPdfLinksQueryVariables>) {
        return Apollo.useQuery<EsignContractPdfLinksQuery, EsignContractPdfLinksQueryVariables>(EsignContractPdfLinksDocument, baseOptions);
      }
export function useEsignContractPdfLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignContractPdfLinksQuery, EsignContractPdfLinksQueryVariables>) {
          return Apollo.useLazyQuery<EsignContractPdfLinksQuery, EsignContractPdfLinksQueryVariables>(EsignContractPdfLinksDocument, baseOptions);
        }
export type EsignContractPdfLinksQueryHookResult = ReturnType<typeof useEsignContractPdfLinksQuery>;
export type EsignContractPdfLinksLazyQueryHookResult = ReturnType<typeof useEsignContractPdfLinksLazyQuery>;
export type EsignContractPdfLinksQueryResult = Apollo.QueryResult<EsignContractPdfLinksQuery, EsignContractPdfLinksQueryVariables>;
export const EsignPaymentPlansDocument = gql`
    query EsignPaymentPlans {
  paymentPlans {
    id
    code
    name
    installments
    firstDueKind
    firstDueDays
    marksStatePrefinanced
    bankInstallments
  }
}
    `;

/**
 * __useEsignPaymentPlansQuery__
 *
 * To run a query within a React component, call `useEsignPaymentPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignPaymentPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignPaymentPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useEsignPaymentPlansQuery(baseOptions?: Apollo.QueryHookOptions<EsignPaymentPlansQuery, EsignPaymentPlansQueryVariables>) {
        return Apollo.useQuery<EsignPaymentPlansQuery, EsignPaymentPlansQueryVariables>(EsignPaymentPlansDocument, baseOptions);
      }
export function useEsignPaymentPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignPaymentPlansQuery, EsignPaymentPlansQueryVariables>) {
          return Apollo.useLazyQuery<EsignPaymentPlansQuery, EsignPaymentPlansQueryVariables>(EsignPaymentPlansDocument, baseOptions);
        }
export type EsignPaymentPlansQueryHookResult = ReturnType<typeof useEsignPaymentPlansQuery>;
export type EsignPaymentPlansLazyQueryHookResult = ReturnType<typeof useEsignPaymentPlansLazyQuery>;
export type EsignPaymentPlansQueryResult = Apollo.QueryResult<EsignPaymentPlansQuery, EsignPaymentPlansQueryVariables>;
export const EsignDraftDefaultsDocument = gql`
    query EsignDraftDefaults($groupId: ID!, $paymentPlanId: ID!, $currency: String, $email: String, $phone: String, $excludeContractId: ID, $crmLeadId: ID) {
  contractDraftDefaults(
    groupId: $groupId
    paymentPlanId: $paymentPlanId
    currency: $currency
    email: $email
    phone: $phone
    excludeContractId: $excludeContractId
    crmLeadId: $crmLeadId
  ) {
    listPrice
    listPriceSource
    currency
    schedule {
      n
      amount
      rule
      ruleKind
      ruleParams
    }
    nextNumberPreview
    matchedUserId
    matchedUserName
    warnings
  }
}
    `;

/**
 * __useEsignDraftDefaultsQuery__
 *
 * To run a query within a React component, call `useEsignDraftDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignDraftDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignDraftDefaultsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      paymentPlanId: // value for 'paymentPlanId'
 *      currency: // value for 'currency'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      excludeContractId: // value for 'excludeContractId'
 *      crmLeadId: // value for 'crmLeadId'
 *   },
 * });
 */
export function useEsignDraftDefaultsQuery(baseOptions: Apollo.QueryHookOptions<EsignDraftDefaultsQuery, EsignDraftDefaultsQueryVariables>) {
        return Apollo.useQuery<EsignDraftDefaultsQuery, EsignDraftDefaultsQueryVariables>(EsignDraftDefaultsDocument, baseOptions);
      }
export function useEsignDraftDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignDraftDefaultsQuery, EsignDraftDefaultsQueryVariables>) {
          return Apollo.useLazyQuery<EsignDraftDefaultsQuery, EsignDraftDefaultsQueryVariables>(EsignDraftDefaultsDocument, baseOptions);
        }
export type EsignDraftDefaultsQueryHookResult = ReturnType<typeof useEsignDraftDefaultsQuery>;
export type EsignDraftDefaultsLazyQueryHookResult = ReturnType<typeof useEsignDraftDefaultsLazyQuery>;
export type EsignDraftDefaultsQueryResult = Apollo.QueryResult<EsignDraftDefaultsQuery, EsignDraftDefaultsQueryVariables>;
export const EsignDraftFromLeadDocument = gql`
    query EsignDraftFromLead($leadId: ID!) {
  contractDraftFromLead(leadId: $leadId) {
    leadId
    leadName
    firstName
    lastName
    email
    phone
    crmLeadId
    crmLeadBlocked
    courseId
    courseName
    courseSource
    courseRaw
    groups {
      id
      name
      startDate
    }
    suggestedGroupId
    paymentPlanId
    paymentPlanReason
    fundingCandidate {
      id
      name
      status
      isArchived
    }
    existingContracts {
      id
      number
      status
      kind
      createdAt
    }
  }
}
    `;

/**
 * __useEsignDraftFromLeadQuery__
 *
 * To run a query within a React component, call `useEsignDraftFromLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignDraftFromLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignDraftFromLeadQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useEsignDraftFromLeadQuery(baseOptions: Apollo.QueryHookOptions<EsignDraftFromLeadQuery, EsignDraftFromLeadQueryVariables>) {
        return Apollo.useQuery<EsignDraftFromLeadQuery, EsignDraftFromLeadQueryVariables>(EsignDraftFromLeadDocument, baseOptions);
      }
export function useEsignDraftFromLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignDraftFromLeadQuery, EsignDraftFromLeadQueryVariables>) {
          return Apollo.useLazyQuery<EsignDraftFromLeadQuery, EsignDraftFromLeadQueryVariables>(EsignDraftFromLeadDocument, baseOptions);
        }
export type EsignDraftFromLeadQueryHookResult = ReturnType<typeof useEsignDraftFromLeadQuery>;
export type EsignDraftFromLeadLazyQueryHookResult = ReturnType<typeof useEsignDraftFromLeadLazyQuery>;
export type EsignDraftFromLeadQueryResult = Apollo.QueryResult<EsignDraftFromLeadQuery, EsignDraftFromLeadQueryVariables>;
export const EsignGroupOptionsDocument = gql`
    query EsignGroupOptions($query: String, $first: Int) {
  allGroups(query: $query, first: $first) {
    edges {
      node {
        id
        name
        startDate
        currency
        course {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useEsignGroupOptionsQuery__
 *
 * To run a query within a React component, call `useEsignGroupOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignGroupOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignGroupOptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useEsignGroupOptionsQuery(baseOptions?: Apollo.QueryHookOptions<EsignGroupOptionsQuery, EsignGroupOptionsQueryVariables>) {
        return Apollo.useQuery<EsignGroupOptionsQuery, EsignGroupOptionsQueryVariables>(EsignGroupOptionsDocument, baseOptions);
      }
export function useEsignGroupOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignGroupOptionsQuery, EsignGroupOptionsQueryVariables>) {
          return Apollo.useLazyQuery<EsignGroupOptionsQuery, EsignGroupOptionsQueryVariables>(EsignGroupOptionsDocument, baseOptions);
        }
export type EsignGroupOptionsQueryHookResult = ReturnType<typeof useEsignGroupOptionsQuery>;
export type EsignGroupOptionsLazyQueryHookResult = ReturnType<typeof useEsignGroupOptionsLazyQuery>;
export type EsignGroupOptionsQueryResult = Apollo.QueryResult<EsignGroupOptionsQuery, EsignGroupOptionsQueryVariables>;
export const EsignCrmLeadsDocument = gql`
    query EsignCrmLeads($query: String, $statusId: ID, $page: Int) {
  crmLeads(query: $query, statusId: $statusId, page: $page) {
    items {
      ...EsignCrmLeadFields
    }
    hasMore
    error {
      code
      message
    }
  }
}
    ${EsignCrmLeadFieldsFragmentDoc}`;

/**
 * __useEsignCrmLeadsQuery__
 *
 * To run a query within a React component, call `useEsignCrmLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignCrmLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignCrmLeadsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      statusId: // value for 'statusId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useEsignCrmLeadsQuery(baseOptions?: Apollo.QueryHookOptions<EsignCrmLeadsQuery, EsignCrmLeadsQueryVariables>) {
        return Apollo.useQuery<EsignCrmLeadsQuery, EsignCrmLeadsQueryVariables>(EsignCrmLeadsDocument, baseOptions);
      }
export function useEsignCrmLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignCrmLeadsQuery, EsignCrmLeadsQueryVariables>) {
          return Apollo.useLazyQuery<EsignCrmLeadsQuery, EsignCrmLeadsQueryVariables>(EsignCrmLeadsDocument, baseOptions);
        }
export type EsignCrmLeadsQueryHookResult = ReturnType<typeof useEsignCrmLeadsQuery>;
export type EsignCrmLeadsLazyQueryHookResult = ReturnType<typeof useEsignCrmLeadsLazyQuery>;
export type EsignCrmLeadsQueryResult = Apollo.QueryResult<EsignCrmLeadsQuery, EsignCrmLeadsQueryVariables>;
export const EsignCrmLeadStatusesDocument = gql`
    query EsignCrmLeadStatuses {
  crmLeadStatuses {
    items {
      id
      name
      color
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useEsignCrmLeadStatusesQuery__
 *
 * To run a query within a React component, call `useEsignCrmLeadStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignCrmLeadStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignCrmLeadStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEsignCrmLeadStatusesQuery(baseOptions?: Apollo.QueryHookOptions<EsignCrmLeadStatusesQuery, EsignCrmLeadStatusesQueryVariables>) {
        return Apollo.useQuery<EsignCrmLeadStatusesQuery, EsignCrmLeadStatusesQueryVariables>(EsignCrmLeadStatusesDocument, baseOptions);
      }
export function useEsignCrmLeadStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignCrmLeadStatusesQuery, EsignCrmLeadStatusesQueryVariables>) {
          return Apollo.useLazyQuery<EsignCrmLeadStatusesQuery, EsignCrmLeadStatusesQueryVariables>(EsignCrmLeadStatusesDocument, baseOptions);
        }
export type EsignCrmLeadStatusesQueryHookResult = ReturnType<typeof useEsignCrmLeadStatusesQuery>;
export type EsignCrmLeadStatusesLazyQueryHookResult = ReturnType<typeof useEsignCrmLeadStatusesLazyQuery>;
export type EsignCrmLeadStatusesQueryResult = Apollo.QueryResult<EsignCrmLeadStatusesQuery, EsignCrmLeadStatusesQueryVariables>;
export const EsignCrmLeadLabelDocument = gql`
    query EsignCrmLeadLabel($id: ID!) {
  crmLead(id: $id) {
    ...EsignCrmLeadFields
  }
}
    ${EsignCrmLeadFieldsFragmentDoc}`;

/**
 * __useEsignCrmLeadLabelQuery__
 *
 * To run a query within a React component, call `useEsignCrmLeadLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignCrmLeadLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignCrmLeadLabelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEsignCrmLeadLabelQuery(baseOptions: Apollo.QueryHookOptions<EsignCrmLeadLabelQuery, EsignCrmLeadLabelQueryVariables>) {
        return Apollo.useQuery<EsignCrmLeadLabelQuery, EsignCrmLeadLabelQueryVariables>(EsignCrmLeadLabelDocument, baseOptions);
      }
export function useEsignCrmLeadLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignCrmLeadLabelQuery, EsignCrmLeadLabelQueryVariables>) {
          return Apollo.useLazyQuery<EsignCrmLeadLabelQuery, EsignCrmLeadLabelQueryVariables>(EsignCrmLeadLabelDocument, baseOptions);
        }
export type EsignCrmLeadLabelQueryHookResult = ReturnType<typeof useEsignCrmLeadLabelQuery>;
export type EsignCrmLeadLabelLazyQueryHookResult = ReturnType<typeof useEsignCrmLeadLabelLazyQuery>;
export type EsignCrmLeadLabelQueryResult = Apollo.QueryResult<EsignCrmLeadLabelQuery, EsignCrmLeadLabelQueryVariables>;
export const ContractFilterGroupsDocument = gql`
    query ContractFilterGroups($query: String, $selectedId: ID, $first: Int) {
  contractGroupOptions(query: $query, selectedId: $selectedId, first: $first) {
    id
    name
    startDate
    courseName
  }
}
    `;

/**
 * __useContractFilterGroupsQuery__
 *
 * To run a query within a React component, call `useContractFilterGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractFilterGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractFilterGroupsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      selectedId: // value for 'selectedId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useContractFilterGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ContractFilterGroupsQuery, ContractFilterGroupsQueryVariables>) {
        return Apollo.useQuery<ContractFilterGroupsQuery, ContractFilterGroupsQueryVariables>(ContractFilterGroupsDocument, baseOptions);
      }
export function useContractFilterGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractFilterGroupsQuery, ContractFilterGroupsQueryVariables>) {
          return Apollo.useLazyQuery<ContractFilterGroupsQuery, ContractFilterGroupsQueryVariables>(ContractFilterGroupsDocument, baseOptions);
        }
export type ContractFilterGroupsQueryHookResult = ReturnType<typeof useContractFilterGroupsQuery>;
export type ContractFilterGroupsLazyQueryHookResult = ReturnType<typeof useContractFilterGroupsLazyQuery>;
export type ContractFilterGroupsQueryResult = Apollo.QueryResult<ContractFilterGroupsQuery, ContractFilterGroupsQueryVariables>;
export const EsignGroupLabelDocument = gql`
    query EsignGroupLabel($groupId: ID) {
  group(groupId: $groupId) {
    id
    name
    startDate
    currency
    course {
      id
      name
    }
  }
}
    `;

/**
 * __useEsignGroupLabelQuery__
 *
 * To run a query within a React component, call `useEsignGroupLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignGroupLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignGroupLabelQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useEsignGroupLabelQuery(baseOptions?: Apollo.QueryHookOptions<EsignGroupLabelQuery, EsignGroupLabelQueryVariables>) {
        return Apollo.useQuery<EsignGroupLabelQuery, EsignGroupLabelQueryVariables>(EsignGroupLabelDocument, baseOptions);
      }
export function useEsignGroupLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignGroupLabelQuery, EsignGroupLabelQueryVariables>) {
          return Apollo.useLazyQuery<EsignGroupLabelQuery, EsignGroupLabelQueryVariables>(EsignGroupLabelDocument, baseOptions);
        }
export type EsignGroupLabelQueryHookResult = ReturnType<typeof useEsignGroupLabelQuery>;
export type EsignGroupLabelLazyQueryHookResult = ReturnType<typeof useEsignGroupLabelLazyQuery>;
export type EsignGroupLabelQueryResult = Apollo.QueryResult<EsignGroupLabelQuery, EsignGroupLabelQueryVariables>;
export const EsignPersonOptionsDocument = gql`
    query EsignPersonOptions($query: String, $first: Int) {
  allStudents(query: $query, first: $first) {
    edges {
      node {
        id
        user {
          id
          firstName
          lastName
          email
          phone
        }
      }
    }
  }
}
    `;

/**
 * __useEsignPersonOptionsQuery__
 *
 * To run a query within a React component, call `useEsignPersonOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignPersonOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignPersonOptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useEsignPersonOptionsQuery(baseOptions?: Apollo.QueryHookOptions<EsignPersonOptionsQuery, EsignPersonOptionsQueryVariables>) {
        return Apollo.useQuery<EsignPersonOptionsQuery, EsignPersonOptionsQueryVariables>(EsignPersonOptionsDocument, baseOptions);
      }
export function useEsignPersonOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignPersonOptionsQuery, EsignPersonOptionsQueryVariables>) {
          return Apollo.useLazyQuery<EsignPersonOptionsQuery, EsignPersonOptionsQueryVariables>(EsignPersonOptionsDocument, baseOptions);
        }
export type EsignPersonOptionsQueryHookResult = ReturnType<typeof useEsignPersonOptionsQuery>;
export type EsignPersonOptionsLazyQueryHookResult = ReturnType<typeof useEsignPersonOptionsLazyQuery>;
export type EsignPersonOptionsQueryResult = Apollo.QueryResult<EsignPersonOptionsQuery, EsignPersonOptionsQueryVariables>;
export const ContractOutreachStateDocument = gql`
    query ContractOutreachState($contractId: ID!) {
  contractOutreach(contractId: $contractId) {
    ...EsignOutreachFields
  }
}
    ${EsignOutreachFieldsFragmentDoc}`;

/**
 * __useContractOutreachStateQuery__
 *
 * To run a query within a React component, call `useContractOutreachStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractOutreachStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractOutreachStateQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractOutreachStateQuery(baseOptions: Apollo.QueryHookOptions<ContractOutreachStateQuery, ContractOutreachStateQueryVariables>) {
        return Apollo.useQuery<ContractOutreachStateQuery, ContractOutreachStateQueryVariables>(ContractOutreachStateDocument, baseOptions);
      }
export function useContractOutreachStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractOutreachStateQuery, ContractOutreachStateQueryVariables>) {
          return Apollo.useLazyQuery<ContractOutreachStateQuery, ContractOutreachStateQueryVariables>(ContractOutreachStateDocument, baseOptions);
        }
export type ContractOutreachStateQueryHookResult = ReturnType<typeof useContractOutreachStateQuery>;
export type ContractOutreachStateLazyQueryHookResult = ReturnType<typeof useContractOutreachStateLazyQuery>;
export type ContractOutreachStateQueryResult = Apollo.QueryResult<ContractOutreachStateQuery, ContractOutreachStateQueryVariables>;
export const ContractOutreachSummaryListDocument = gql`
    query ContractOutreachSummaryList($contractIds: [ID!]!) {
  contractOutreachSummaries(contractIds: $contractIds) {
    contractId
    smsSent
    lastSmsAt
    humanClicks
  }
}
    `;

/**
 * __useContractOutreachSummaryListQuery__
 *
 * To run a query within a React component, call `useContractOutreachSummaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractOutreachSummaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractOutreachSummaryListQuery({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *   },
 * });
 */
export function useContractOutreachSummaryListQuery(baseOptions: Apollo.QueryHookOptions<ContractOutreachSummaryListQuery, ContractOutreachSummaryListQueryVariables>) {
        return Apollo.useQuery<ContractOutreachSummaryListQuery, ContractOutreachSummaryListQueryVariables>(ContractOutreachSummaryListDocument, baseOptions);
      }
export function useContractOutreachSummaryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractOutreachSummaryListQuery, ContractOutreachSummaryListQueryVariables>) {
          return Apollo.useLazyQuery<ContractOutreachSummaryListQuery, ContractOutreachSummaryListQueryVariables>(ContractOutreachSummaryListDocument, baseOptions);
        }
export type ContractOutreachSummaryListQueryHookResult = ReturnType<typeof useContractOutreachSummaryListQuery>;
export type ContractOutreachSummaryListLazyQueryHookResult = ReturnType<typeof useContractOutreachSummaryListLazyQuery>;
export type ContractOutreachSummaryListQueryResult = Apollo.QueryResult<ContractOutreachSummaryListQuery, ContractOutreachSummaryListQueryVariables>;
export const ContractSellerOptionsDocument = gql`
    query ContractSellerOptions($forReassign: Boolean) {
  contractSellers(forReassign: $forReassign) {
    id
    name
    email
  }
}
    `;

/**
 * __useContractSellerOptionsQuery__
 *
 * To run a query within a React component, call `useContractSellerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractSellerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractSellerOptionsQuery({
 *   variables: {
 *      forReassign: // value for 'forReassign'
 *   },
 * });
 */
export function useContractSellerOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ContractSellerOptionsQuery, ContractSellerOptionsQueryVariables>) {
        return Apollo.useQuery<ContractSellerOptionsQuery, ContractSellerOptionsQueryVariables>(ContractSellerOptionsDocument, baseOptions);
      }
export function useContractSellerOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractSellerOptionsQuery, ContractSellerOptionsQueryVariables>) {
          return Apollo.useLazyQuery<ContractSellerOptionsQuery, ContractSellerOptionsQueryVariables>(ContractSellerOptionsDocument, baseOptions);
        }
export type ContractSellerOptionsQueryHookResult = ReturnType<typeof useContractSellerOptionsQuery>;
export type ContractSellerOptionsLazyQueryHookResult = ReturnType<typeof useContractSellerOptionsLazyQuery>;
export type ContractSellerOptionsQueryResult = Apollo.QueryResult<ContractSellerOptionsQuery, ContractSellerOptionsQueryVariables>;
export const ContractSenderOptionsDocument = gql`
    query ContractSenderOptions {
  contractSenders {
    id
    name
    email
  }
}
    `;

/**
 * __useContractSenderOptionsQuery__
 *
 * To run a query within a React component, call `useContractSenderOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractSenderOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractSenderOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContractSenderOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ContractSenderOptionsQuery, ContractSenderOptionsQueryVariables>) {
        return Apollo.useQuery<ContractSenderOptionsQuery, ContractSenderOptionsQueryVariables>(ContractSenderOptionsDocument, baseOptions);
      }
export function useContractSenderOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractSenderOptionsQuery, ContractSenderOptionsQueryVariables>) {
          return Apollo.useLazyQuery<ContractSenderOptionsQuery, ContractSenderOptionsQueryVariables>(ContractSenderOptionsDocument, baseOptions);
        }
export type ContractSenderOptionsQueryHookResult = ReturnType<typeof useContractSenderOptionsQuery>;
export type ContractSenderOptionsLazyQueryHookResult = ReturnType<typeof useContractSenderOptionsLazyQuery>;
export type ContractSenderOptionsQueryResult = Apollo.QueryResult<ContractSenderOptionsQuery, ContractSenderOptionsQueryVariables>;
export const ContractConversationListDocument = gql`
    query ContractConversationList($contractId: ID!) {
  contractConversations(contractId: $contractId) {
    id
    kind
    title
    displayTitle
    externalId
    mailboxEmail
    unreadCount
    unhandledCount
    status
    hasUnhandled
    lastMessageAt
  }
}
    `;

/**
 * __useContractConversationListQuery__
 *
 * To run a query within a React component, call `useContractConversationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractConversationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractConversationListQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractConversationListQuery(baseOptions: Apollo.QueryHookOptions<ContractConversationListQuery, ContractConversationListQueryVariables>) {
        return Apollo.useQuery<ContractConversationListQuery, ContractConversationListQueryVariables>(ContractConversationListDocument, baseOptions);
      }
export function useContractConversationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractConversationListQuery, ContractConversationListQueryVariables>) {
          return Apollo.useLazyQuery<ContractConversationListQuery, ContractConversationListQueryVariables>(ContractConversationListDocument, baseOptions);
        }
export type ContractConversationListQueryHookResult = ReturnType<typeof useContractConversationListQuery>;
export type ContractConversationListLazyQueryHookResult = ReturnType<typeof useContractConversationListLazyQuery>;
export type ContractConversationListQueryResult = Apollo.QueryResult<ContractConversationListQuery, ContractConversationListQueryVariables>;
export const ContractMailSummaryListDocument = gql`
    query ContractMailSummaryList($contractIds: [ID!]!) {
  contractMailSummaries(contractIds: $contractIds) {
    contractId
    threads
    unhandled
    lastInboundAt
  }
}
    `;

/**
 * __useContractMailSummaryListQuery__
 *
 * To run a query within a React component, call `useContractMailSummaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractMailSummaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractMailSummaryListQuery({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *   },
 * });
 */
export function useContractMailSummaryListQuery(baseOptions: Apollo.QueryHookOptions<ContractMailSummaryListQuery, ContractMailSummaryListQueryVariables>) {
        return Apollo.useQuery<ContractMailSummaryListQuery, ContractMailSummaryListQueryVariables>(ContractMailSummaryListDocument, baseOptions);
      }
export function useContractMailSummaryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractMailSummaryListQuery, ContractMailSummaryListQueryVariables>) {
          return Apollo.useLazyQuery<ContractMailSummaryListQuery, ContractMailSummaryListQueryVariables>(ContractMailSummaryListDocument, baseOptions);
        }
export type ContractMailSummaryListQueryHookResult = ReturnType<typeof useContractMailSummaryListQuery>;
export type ContractMailSummaryListLazyQueryHookResult = ReturnType<typeof useContractMailSummaryListLazyQuery>;
export type ContractMailSummaryListQueryResult = Apollo.QueryResult<ContractMailSummaryListQuery, ContractMailSummaryListQueryVariables>;
export const ContractMailboxOptionsDocument = gql`
    query ContractMailboxOptions {
  gmailMailboxes {
    id
    email
    displayName
    isPersonal
    isMine
    ownerName
  }
}
    `;

/**
 * __useContractMailboxOptionsQuery__
 *
 * To run a query within a React component, call `useContractMailboxOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractMailboxOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractMailboxOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContractMailboxOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ContractMailboxOptionsQuery, ContractMailboxOptionsQueryVariables>) {
        return Apollo.useQuery<ContractMailboxOptionsQuery, ContractMailboxOptionsQueryVariables>(ContractMailboxOptionsDocument, baseOptions);
      }
export function useContractMailboxOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractMailboxOptionsQuery, ContractMailboxOptionsQueryVariables>) {
          return Apollo.useLazyQuery<ContractMailboxOptionsQuery, ContractMailboxOptionsQueryVariables>(ContractMailboxOptionsDocument, baseOptions);
        }
export type ContractMailboxOptionsQueryHookResult = ReturnType<typeof useContractMailboxOptionsQuery>;
export type ContractMailboxOptionsLazyQueryHookResult = ReturnType<typeof useContractMailboxOptionsLazyQuery>;
export type ContractMailboxOptionsQueryResult = Apollo.QueryResult<ContractMailboxOptionsQuery, ContractMailboxOptionsQueryVariables>;
export const ContractMessageTemplatesDocument = gql`
    query ContractMessageTemplates($channel: String, $includeInactive: Boolean, $topic: String, $includeOthers: Boolean) {
  messageTemplates(
    channel: $channel
    includeInactive: $includeInactive
    topic: $topic
    includeOthers: $includeOthers
  ) {
    ...EsignMessageTemplateFields
  }
}
    ${EsignMessageTemplateFieldsFragmentDoc}`;

/**
 * __useContractMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useContractMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractMessageTemplatesQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      includeInactive: // value for 'includeInactive'
 *      topic: // value for 'topic'
 *      includeOthers: // value for 'includeOthers'
 *   },
 * });
 */
export function useContractMessageTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ContractMessageTemplatesQuery, ContractMessageTemplatesQueryVariables>) {
        return Apollo.useQuery<ContractMessageTemplatesQuery, ContractMessageTemplatesQueryVariables>(ContractMessageTemplatesDocument, baseOptions);
      }
export function useContractMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractMessageTemplatesQuery, ContractMessageTemplatesQueryVariables>) {
          return Apollo.useLazyQuery<ContractMessageTemplatesQuery, ContractMessageTemplatesQueryVariables>(ContractMessageTemplatesDocument, baseOptions);
        }
export type ContractMessageTemplatesQueryHookResult = ReturnType<typeof useContractMessageTemplatesQuery>;
export type ContractMessageTemplatesLazyQueryHookResult = ReturnType<typeof useContractMessageTemplatesLazyQuery>;
export type ContractMessageTemplatesQueryResult = Apollo.QueryResult<ContractMessageTemplatesQuery, ContractMessageTemplatesQueryVariables>;
export const EsignInvitePreviewDocument = gql`
    query EsignInvitePreview($documentId: ID!, $emailSubject: String, $emailBody: String, $templateId: ID) {
  contractInvitePreview(
    documentId: $documentId
    emailSubject: $emailSubject
    emailBody: $emailBody
    templateId: $templateId
  ) {
    subject
    body
    rawSubject
    rawBody
    fromEmail
    fromName
    toEmail
    templateCode
    templateId
    templates {
      id
      code
      name
      namePl
      isPersonal
    }
    hasOwnCopy
    ownCopyId
    templateName
    templateNamePl
    isPersonal
    via
    editable
    canSend
    skipReason
    errorCode
    errorMessage
    errorField
  }
}
    `;

/**
 * __useEsignInvitePreviewQuery__
 *
 * To run a query within a React component, call `useEsignInvitePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsignInvitePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsignInvitePreviewQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      emailSubject: // value for 'emailSubject'
 *      emailBody: // value for 'emailBody'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useEsignInvitePreviewQuery(baseOptions: Apollo.QueryHookOptions<EsignInvitePreviewQuery, EsignInvitePreviewQueryVariables>) {
        return Apollo.useQuery<EsignInvitePreviewQuery, EsignInvitePreviewQueryVariables>(EsignInvitePreviewDocument, baseOptions);
      }
export function useEsignInvitePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsignInvitePreviewQuery, EsignInvitePreviewQueryVariables>) {
          return Apollo.useLazyQuery<EsignInvitePreviewQuery, EsignInvitePreviewQueryVariables>(EsignInvitePreviewDocument, baseOptions);
        }
export type EsignInvitePreviewQueryHookResult = ReturnType<typeof useEsignInvitePreviewQuery>;
export type EsignInvitePreviewLazyQueryHookResult = ReturnType<typeof useEsignInvitePreviewLazyQuery>;
export type EsignInvitePreviewQueryResult = Apollo.QueryResult<EsignInvitePreviewQuery, EsignInvitePreviewQueryVariables>;
export const MessageTemplatesEditableDocument = gql`
    query MessageTemplatesEditable($topic: String) {
  canEditMessageTemplates(topic: $topic)
}
    `;

/**
 * __useMessageTemplatesEditableQuery__
 *
 * To run a query within a React component, call `useMessageTemplatesEditableQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTemplatesEditableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTemplatesEditableQuery({
 *   variables: {
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useMessageTemplatesEditableQuery(baseOptions?: Apollo.QueryHookOptions<MessageTemplatesEditableQuery, MessageTemplatesEditableQueryVariables>) {
        return Apollo.useQuery<MessageTemplatesEditableQuery, MessageTemplatesEditableQueryVariables>(MessageTemplatesEditableDocument, baseOptions);
      }
export function useMessageTemplatesEditableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageTemplatesEditableQuery, MessageTemplatesEditableQueryVariables>) {
          return Apollo.useLazyQuery<MessageTemplatesEditableQuery, MessageTemplatesEditableQueryVariables>(MessageTemplatesEditableDocument, baseOptions);
        }
export type MessageTemplatesEditableQueryHookResult = ReturnType<typeof useMessageTemplatesEditableQuery>;
export type MessageTemplatesEditableLazyQueryHookResult = ReturnType<typeof useMessageTemplatesEditableLazyQuery>;
export type MessageTemplatesEditableQueryResult = Apollo.QueryResult<MessageTemplatesEditableQuery, MessageTemplatesEditableQueryVariables>;
export const ContractMessageVariablesDocument = gql`
    query ContractMessageVariables($topic: String) {
  messageTemplateVariables(topic: $topic) {
    name
    description
    descriptionRu
    descriptionPl
    source
    sourceRu
    sourcePl
    example
  }
}
    `;

/**
 * __useContractMessageVariablesQuery__
 *
 * To run a query within a React component, call `useContractMessageVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractMessageVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractMessageVariablesQuery({
 *   variables: {
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useContractMessageVariablesQuery(baseOptions?: Apollo.QueryHookOptions<ContractMessageVariablesQuery, ContractMessageVariablesQueryVariables>) {
        return Apollo.useQuery<ContractMessageVariablesQuery, ContractMessageVariablesQueryVariables>(ContractMessageVariablesDocument, baseOptions);
      }
export function useContractMessageVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractMessageVariablesQuery, ContractMessageVariablesQueryVariables>) {
          return Apollo.useLazyQuery<ContractMessageVariablesQuery, ContractMessageVariablesQueryVariables>(ContractMessageVariablesDocument, baseOptions);
        }
export type ContractMessageVariablesQueryHookResult = ReturnType<typeof useContractMessageVariablesQuery>;
export type ContractMessageVariablesLazyQueryHookResult = ReturnType<typeof useContractMessageVariablesLazyQuery>;
export type ContractMessageVariablesQueryResult = Apollo.QueryResult<ContractMessageVariablesQuery, ContractMessageVariablesQueryVariables>;
export const ContractsSmsBulkPreviewDocument = gql`
    query ContractsSmsBulkPreview($contractIds: [ID!]!, $text: String!) {
  previewContractsSms(contractIds: $contractIds, text: $text) {
    willSend
    skipped
    segmentsTotal
    rows {
      contractId
      number
      signerName
      ok
      code
      message
      segments
    }
    sample {
      body
      encoding
      segments
      maxSegments
      tooLong
      withOptOut
      available
      reason
      message
    }
  }
}
    `;

/**
 * __useContractsSmsBulkPreviewQuery__
 *
 * To run a query within a React component, call `useContractsSmsBulkPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsSmsBulkPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsSmsBulkPreviewQuery({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useContractsSmsBulkPreviewQuery(baseOptions: Apollo.QueryHookOptions<ContractsSmsBulkPreviewQuery, ContractsSmsBulkPreviewQueryVariables>) {
        return Apollo.useQuery<ContractsSmsBulkPreviewQuery, ContractsSmsBulkPreviewQueryVariables>(ContractsSmsBulkPreviewDocument, baseOptions);
      }
export function useContractsSmsBulkPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractsSmsBulkPreviewQuery, ContractsSmsBulkPreviewQueryVariables>) {
          return Apollo.useLazyQuery<ContractsSmsBulkPreviewQuery, ContractsSmsBulkPreviewQueryVariables>(ContractsSmsBulkPreviewDocument, baseOptions);
        }
export type ContractsSmsBulkPreviewQueryHookResult = ReturnType<typeof useContractsSmsBulkPreviewQuery>;
export type ContractsSmsBulkPreviewLazyQueryHookResult = ReturnType<typeof useContractsSmsBulkPreviewLazyQuery>;
export type ContractsSmsBulkPreviewQueryResult = Apollo.QueryResult<ContractsSmsBulkPreviewQuery, ContractsSmsBulkPreviewQueryVariables>;
export const ContractSmsPreviewDocument = gql`
    query ContractSmsPreview($contractId: ID!, $text: String!) {
  previewContractSms(contractId: $contractId, text: $text) {
    body
    encoding
    segments
    maxSegments
    tooLong
    withOptOut
    available
    reason
    message
  }
}
    `;

/**
 * __useContractSmsPreviewQuery__
 *
 * To run a query within a React component, call `useContractSmsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractSmsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractSmsPreviewQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useContractSmsPreviewQuery(baseOptions: Apollo.QueryHookOptions<ContractSmsPreviewQuery, ContractSmsPreviewQueryVariables>) {
        return Apollo.useQuery<ContractSmsPreviewQuery, ContractSmsPreviewQueryVariables>(ContractSmsPreviewDocument, baseOptions);
      }
export function useContractSmsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractSmsPreviewQuery, ContractSmsPreviewQueryVariables>) {
          return Apollo.useLazyQuery<ContractSmsPreviewQuery, ContractSmsPreviewQueryVariables>(ContractSmsPreviewDocument, baseOptions);
        }
export type ContractSmsPreviewQueryHookResult = ReturnType<typeof useContractSmsPreviewQuery>;
export type ContractSmsPreviewLazyQueryHookResult = ReturnType<typeof useContractSmsPreviewLazyQuery>;
export type ContractSmsPreviewQueryResult = Apollo.QueryResult<ContractSmsPreviewQuery, ContractSmsPreviewQueryVariables>;
export const ContractTemplateListDocument = gql`
    query ContractTemplateList($kind: String, $includeInactive: Boolean, $code: String) {
  contractTemplates(kind: $kind, includeInactive: $includeInactive, code: $code) {
    ...EsignContractTemplateFields
  }
}
    ${EsignContractTemplateFieldsFragmentDoc}`;

/**
 * __useContractTemplateListQuery__
 *
 * To run a query within a React component, call `useContractTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTemplateListQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      includeInactive: // value for 'includeInactive'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useContractTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<ContractTemplateListQuery, ContractTemplateListQueryVariables>) {
        return Apollo.useQuery<ContractTemplateListQuery, ContractTemplateListQueryVariables>(ContractTemplateListDocument, baseOptions);
      }
export function useContractTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractTemplateListQuery, ContractTemplateListQueryVariables>) {
          return Apollo.useLazyQuery<ContractTemplateListQuery, ContractTemplateListQueryVariables>(ContractTemplateListDocument, baseOptions);
        }
export type ContractTemplateListQueryHookResult = ReturnType<typeof useContractTemplateListQuery>;
export type ContractTemplateListLazyQueryHookResult = ReturnType<typeof useContractTemplateListLazyQuery>;
export type ContractTemplateListQueryResult = Apollo.QueryResult<ContractTemplateListQuery, ContractTemplateListQueryVariables>;
export const ContractTemplateSampleDocument = gql`
    query ContractTemplateSample($id: ID!) {
  contractTemplatePreview(id: $id)
}
    `;

/**
 * __useContractTemplateSampleQuery__
 *
 * To run a query within a React component, call `useContractTemplateSampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateSampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTemplateSampleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractTemplateSampleQuery(baseOptions: Apollo.QueryHookOptions<ContractTemplateSampleQuery, ContractTemplateSampleQueryVariables>) {
        return Apollo.useQuery<ContractTemplateSampleQuery, ContractTemplateSampleQueryVariables>(ContractTemplateSampleDocument, baseOptions);
      }
export function useContractTemplateSampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractTemplateSampleQuery, ContractTemplateSampleQueryVariables>) {
          return Apollo.useLazyQuery<ContractTemplateSampleQuery, ContractTemplateSampleQueryVariables>(ContractTemplateSampleDocument, baseOptions);
        }
export type ContractTemplateSampleQueryHookResult = ReturnType<typeof useContractTemplateSampleQuery>;
export type ContractTemplateSampleLazyQueryHookResult = ReturnType<typeof useContractTemplateSampleLazyQuery>;
export type ContractTemplateSampleQueryResult = Apollo.QueryResult<ContractTemplateSampleQuery, ContractTemplateSampleQueryVariables>;
export const ContractTemplateEditorSourceDocument = gql`
    query ContractTemplateEditorSource($id: ID!, $language: String) {
  contractTemplateEditable(id: $id, language: $language) {
    template {
      ...EsignContractTemplateFields
    }
    html
    tokens {
      n
      kind
      role
      code
      label
      labelPl
      removable
      placement
    }
    variables {
      code
      group
      label
      labelPl
      groupLabel
      groupLabelPl
    }
  }
}
    ${EsignContractTemplateFieldsFragmentDoc}`;

/**
 * __useContractTemplateEditorSourceQuery__
 *
 * To run a query within a React component, call `useContractTemplateEditorSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEditorSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTemplateEditorSourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useContractTemplateEditorSourceQuery(baseOptions: Apollo.QueryHookOptions<ContractTemplateEditorSourceQuery, ContractTemplateEditorSourceQueryVariables>) {
        return Apollo.useQuery<ContractTemplateEditorSourceQuery, ContractTemplateEditorSourceQueryVariables>(ContractTemplateEditorSourceDocument, baseOptions);
      }
export function useContractTemplateEditorSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractTemplateEditorSourceQuery, ContractTemplateEditorSourceQueryVariables>) {
          return Apollo.useLazyQuery<ContractTemplateEditorSourceQuery, ContractTemplateEditorSourceQueryVariables>(ContractTemplateEditorSourceDocument, baseOptions);
        }
export type ContractTemplateEditorSourceQueryHookResult = ReturnType<typeof useContractTemplateEditorSourceQuery>;
export type ContractTemplateEditorSourceLazyQueryHookResult = ReturnType<typeof useContractTemplateEditorSourceLazyQuery>;
export type ContractTemplateEditorSourceQueryResult = Apollo.QueryResult<ContractTemplateEditorSourceQuery, ContractTemplateEditorSourceQueryVariables>;
export const ContractTemplateDraftSampleDocument = gql`
    query ContractTemplateDraftSample($id: ID!, $html: String!, $tokens: JSONString) {
  contractTemplatePreviewDraft(id: $id, html: $html, tokens: $tokens) {
    html
    problems {
      code
      message
      token
    }
  }
}
    `;

/**
 * __useContractTemplateDraftSampleQuery__
 *
 * To run a query within a React component, call `useContractTemplateDraftSampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateDraftSampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTemplateDraftSampleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      html: // value for 'html'
 *      tokens: // value for 'tokens'
 *   },
 * });
 */
export function useContractTemplateDraftSampleQuery(baseOptions: Apollo.QueryHookOptions<ContractTemplateDraftSampleQuery, ContractTemplateDraftSampleQueryVariables>) {
        return Apollo.useQuery<ContractTemplateDraftSampleQuery, ContractTemplateDraftSampleQueryVariables>(ContractTemplateDraftSampleDocument, baseOptions);
      }
export function useContractTemplateDraftSampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractTemplateDraftSampleQuery, ContractTemplateDraftSampleQueryVariables>) {
          return Apollo.useLazyQuery<ContractTemplateDraftSampleQuery, ContractTemplateDraftSampleQueryVariables>(ContractTemplateDraftSampleDocument, baseOptions);
        }
export type ContractTemplateDraftSampleQueryHookResult = ReturnType<typeof useContractTemplateDraftSampleQuery>;
export type ContractTemplateDraftSampleLazyQueryHookResult = ReturnType<typeof useContractTemplateDraftSampleLazyQuery>;
export type ContractTemplateDraftSampleQueryResult = Apollo.QueryResult<ContractTemplateDraftSampleQuery, ContractTemplateDraftSampleQueryVariables>;
export const ContractAnalyticsReportDocument = gql`
    query ContractAnalyticsReport($dateFrom: Date, $dateTo: Date, $sellerId: ID, $sentById: ID, $status: String, $kind: String, $course: String, $granularity: String) {
  contractAnalytics(
    dateFrom: $dateFrom
    dateTo: $dateTo
    sellerId: $sellerId
    sentById: $sentById
    status: $status
    kind: $kind
    course: $course
    granularity: $granularity
  ) {
    funnel {
      created
      sent
      opened
      signed
      enrolled
    }
    statuses {
      status
      count
    }
    tts {
      signedCount
      medianHours
      avgHours
      within24hPct
      within72hPct
    }
    sellers {
      sellerId
      name
      created
      sent
      signed
      signedInPeriod
      conversionPct
      medianHours
      amounts {
        currency
        amount
      }
    }
    courses {
      course
      created
      sent
      signed
      conversionPct
    }
    series {
      period
      created
      sent
      signed
    }
    sms {
      sent
      delivered
      failed
      humanClicks
      contractsClicked
    }
    amountsVisible
  }
}
    `;

/**
 * __useContractAnalyticsReportQuery__
 *
 * To run a query within a React component, call `useContractAnalyticsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractAnalyticsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractAnalyticsReportQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      sellerId: // value for 'sellerId'
 *      sentById: // value for 'sentById'
 *      status: // value for 'status'
 *      kind: // value for 'kind'
 *      course: // value for 'course'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useContractAnalyticsReportQuery(baseOptions?: Apollo.QueryHookOptions<ContractAnalyticsReportQuery, ContractAnalyticsReportQueryVariables>) {
        return Apollo.useQuery<ContractAnalyticsReportQuery, ContractAnalyticsReportQueryVariables>(ContractAnalyticsReportDocument, baseOptions);
      }
export function useContractAnalyticsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractAnalyticsReportQuery, ContractAnalyticsReportQueryVariables>) {
          return Apollo.useLazyQuery<ContractAnalyticsReportQuery, ContractAnalyticsReportQueryVariables>(ContractAnalyticsReportDocument, baseOptions);
        }
export type ContractAnalyticsReportQueryHookResult = ReturnType<typeof useContractAnalyticsReportQuery>;
export type ContractAnalyticsReportLazyQueryHookResult = ReturnType<typeof useContractAnalyticsReportLazyQuery>;
export type ContractAnalyticsReportQueryResult = Apollo.QueryResult<ContractAnalyticsReportQuery, ContractAnalyticsReportQueryVariables>;
export const FakturowniaInvoiceIdsDocument = gql`
    query FakturowniaInvoiceIds($direction: String, $needsLinkOnly: Boolean, $page: Int, $perPage: Int) {
  fakturowniaInvoices(
    direction: $direction
    needsLinkOnly: $needsLinkOnly
    page: $page
    perPage: $perPage
  ) {
    id
  }
}
    `;

/**
 * __useFakturowniaInvoiceIdsQuery__
 *
 * To run a query within a React component, call `useFakturowniaInvoiceIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFakturowniaInvoiceIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFakturowniaInvoiceIdsQuery({
 *   variables: {
 *      direction: // value for 'direction'
 *      needsLinkOnly: // value for 'needsLinkOnly'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useFakturowniaInvoiceIdsQuery(baseOptions?: Apollo.QueryHookOptions<FakturowniaInvoiceIdsQuery, FakturowniaInvoiceIdsQueryVariables>) {
        return Apollo.useQuery<FakturowniaInvoiceIdsQuery, FakturowniaInvoiceIdsQueryVariables>(FakturowniaInvoiceIdsDocument, baseOptions);
      }
export function useFakturowniaInvoiceIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FakturowniaInvoiceIdsQuery, FakturowniaInvoiceIdsQueryVariables>) {
          return Apollo.useLazyQuery<FakturowniaInvoiceIdsQuery, FakturowniaInvoiceIdsQueryVariables>(FakturowniaInvoiceIdsDocument, baseOptions);
        }
export type FakturowniaInvoiceIdsQueryHookResult = ReturnType<typeof useFakturowniaInvoiceIdsQuery>;
export type FakturowniaInvoiceIdsLazyQueryHookResult = ReturnType<typeof useFakturowniaInvoiceIdsLazyQuery>;
export type FakturowniaInvoiceIdsQueryResult = Apollo.QueryResult<FakturowniaInvoiceIdsQuery, FakturowniaInvoiceIdsQueryVariables>;
export const FakturowniaInvoicesDocument = gql`
    query FakturowniaInvoices($direction: String, $status: String, $matchStatus: String, $kind: String, $studentId: ID, $groupId: ID, $agreementId: ID, $dateFrom: Date, $dateTo: Date, $page: Int, $perPage: Int, $search: String, $overdueOnly: Boolean, $parentId: ID, $needsLinkOnly: Boolean, $provisionBlockedOnly: Boolean) {
  fakturowniaInvoices(
    direction: $direction
    status: $status
    matchStatus: $matchStatus
    kind: $kind
    studentId: $studentId
    groupId: $groupId
    agreementId: $agreementId
    dateFrom: $dateFrom
    dateTo: $dateTo
    page: $page
    perPage: $perPage
    search: $search
    overdueOnly: $overdueOnly
    parentId: $parentId
    needsLinkOnly: $needsLinkOnly
    provisionBlockedOnly: $provisionBlockedOnly
  ) {
    id
    pk
    number
    direction
    kind
    status
    issueDate
    paymentTo
    paidDate
    currency
    priceGross
    paid
    outstanding
    buyerEmail
    buyerName
    buyerTaxNo
    matchStatus
    groupMatchSource
    linkedStudent {
      id
      user {
        id
        email
        firstName
        lastName
      }
    }
    linkedGroup {
      id
      name
      course {
        id
        title
      }
    }
    payment {
      id
      date
      amountAgreement
      currency
      agreement {
        id
      }
    }
    contribution {
      id
      date
      amountForeign
      status
    }
    contributionMatchSource
    provisionBlockedReason
    agreement {
      id
      agreementTitle
      student {
        id
        user {
          id
          firstName
          lastName
          email
        }
      }
      group {
        id
        name
      }
    }
    isCorrection
    isAdvance
    isFinal
    isEstimate
    isQuotation
    isProforma
    parentInvoice {
      id
      number
    }
    corrections {
      id
      outstanding
    }
  }
}
    `;

/**
 * __useFakturowniaInvoicesQuery__
 *
 * To run a query within a React component, call `useFakturowniaInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFakturowniaInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFakturowniaInvoicesQuery({
 *   variables: {
 *      direction: // value for 'direction'
 *      status: // value for 'status'
 *      matchStatus: // value for 'matchStatus'
 *      kind: // value for 'kind'
 *      studentId: // value for 'studentId'
 *      groupId: // value for 'groupId'
 *      agreementId: // value for 'agreementId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      overdueOnly: // value for 'overdueOnly'
 *      parentId: // value for 'parentId'
 *      needsLinkOnly: // value for 'needsLinkOnly'
 *      provisionBlockedOnly: // value for 'provisionBlockedOnly'
 *   },
 * });
 */
export function useFakturowniaInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<FakturowniaInvoicesQuery, FakturowniaInvoicesQueryVariables>) {
        return Apollo.useQuery<FakturowniaInvoicesQuery, FakturowniaInvoicesQueryVariables>(FakturowniaInvoicesDocument, baseOptions);
      }
export function useFakturowniaInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FakturowniaInvoicesQuery, FakturowniaInvoicesQueryVariables>) {
          return Apollo.useLazyQuery<FakturowniaInvoicesQuery, FakturowniaInvoicesQueryVariables>(FakturowniaInvoicesDocument, baseOptions);
        }
export type FakturowniaInvoicesQueryHookResult = ReturnType<typeof useFakturowniaInvoicesQuery>;
export type FakturowniaInvoicesLazyQueryHookResult = ReturnType<typeof useFakturowniaInvoicesLazyQuery>;
export type FakturowniaInvoicesQueryResult = Apollo.QueryResult<FakturowniaInvoicesQuery, FakturowniaInvoicesQueryVariables>;
export const FakturowniaInvoiceDocument = gql`
    query FakturowniaInvoice($id: ID!) {
  fakturowniaInvoice(id: $id) {
    id
    pk
    fakturowniaId
    number
    kind
    direction
    status
    issueDate
    sellDate
    paymentTo
    paidDate
    currency
    priceNet
    priceGross
    paid
    outstanding
    buyerEmail
    buyerName
    buyerTaxNo
    sellerName
    correctionReason
    accountingKind
    matchStatus
    groupMatchSource
    linkedAt
    linkedStudent {
      id
      user {
        id
        email
        firstName
        lastName
        phone
      }
    }
    linkedGroup {
      id
      name
      course {
        id
        title
      }
    }
    payment {
      id
      date
      amountAgreement
      currency
      agreement {
        id
        agreementTitle
        student {
          id
          user {
            id
            firstName
            lastName
            email
            phone
          }
        }
        group {
          id
          name
          course {
            id
            title
          }
        }
      }
    }
    agreement {
      id
      agreementTitle
      student {
        id
        user {
          id
          firstName
          lastName
          email
          phone
        }
      }
      group {
        id
        name
        course {
          id
          title
        }
      }
    }
    fakturowniaPayments {
      id
      pk
      fakturowniaId
      paidDate
      price
      currency
      kind
    }
    isCorrection
    isAdvance
    isFinal
    isEstimate
    isQuotation
    parentInvoice {
      id
      number
      issueDate
      priceGross
      status
      currency
    }
    corrections {
      id
      pk
      number
      issueDate
      priceGross
      currency
      correctionReason
      status
      outstanding
    }
    advances {
      id
      pk
      number
      issueDate
      priceGross
      currency
      status
      paid
    }
    finalInvoice {
      id
      pk
      number
      issueDate
      priceGross
      currency
      status
      paid
    }
    rawPayload
  }
}
    `;

/**
 * __useFakturowniaInvoiceQuery__
 *
 * To run a query within a React component, call `useFakturowniaInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFakturowniaInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFakturowniaInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFakturowniaInvoiceQuery(baseOptions: Apollo.QueryHookOptions<FakturowniaInvoiceQuery, FakturowniaInvoiceQueryVariables>) {
        return Apollo.useQuery<FakturowniaInvoiceQuery, FakturowniaInvoiceQueryVariables>(FakturowniaInvoiceDocument, baseOptions);
      }
export function useFakturowniaInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FakturowniaInvoiceQuery, FakturowniaInvoiceQueryVariables>) {
          return Apollo.useLazyQuery<FakturowniaInvoiceQuery, FakturowniaInvoiceQueryVariables>(FakturowniaInvoiceDocument, baseOptions);
        }
export type FakturowniaInvoiceQueryHookResult = ReturnType<typeof useFakturowniaInvoiceQuery>;
export type FakturowniaInvoiceLazyQueryHookResult = ReturnType<typeof useFakturowniaInvoiceLazyQuery>;
export type FakturowniaInvoiceQueryResult = Apollo.QueryResult<FakturowniaInvoiceQuery, FakturowniaInvoiceQueryVariables>;
export const FakturowniaSyncStatusDocument = gql`
    query FakturowniaSyncStatus {
  fakturowniaSyncStatus {
    isRunning
    lastRun {
      startedAt
      finishedAt
      status
      stats
      errorMessage
      taskName
    }
    lastSuccess {
      startedAt
      stats
    }
  }
  fakturowniaUnmatchedCount
}
    `;

/**
 * __useFakturowniaSyncStatusQuery__
 *
 * To run a query within a React component, call `useFakturowniaSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFakturowniaSyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFakturowniaSyncStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useFakturowniaSyncStatusQuery(baseOptions?: Apollo.QueryHookOptions<FakturowniaSyncStatusQuery, FakturowniaSyncStatusQueryVariables>) {
        return Apollo.useQuery<FakturowniaSyncStatusQuery, FakturowniaSyncStatusQueryVariables>(FakturowniaSyncStatusDocument, baseOptions);
      }
export function useFakturowniaSyncStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FakturowniaSyncStatusQuery, FakturowniaSyncStatusQueryVariables>) {
          return Apollo.useLazyQuery<FakturowniaSyncStatusQuery, FakturowniaSyncStatusQueryVariables>(FakturowniaSyncStatusDocument, baseOptions);
        }
export type FakturowniaSyncStatusQueryHookResult = ReturnType<typeof useFakturowniaSyncStatusQuery>;
export type FakturowniaSyncStatusLazyQueryHookResult = ReturnType<typeof useFakturowniaSyncStatusLazyQuery>;
export type FakturowniaSyncStatusQueryResult = Apollo.QueryResult<FakturowniaSyncStatusQuery, FakturowniaSyncStatusQueryVariables>;
export const StudentAgreementsForLinkingDocument = gql`
    query StudentAgreementsForLinking($studentId: ID!) {
  student(id: $studentId) {
    id
    user {
      id
      firstName
      lastName
      email
    }
    agreements {
      id
      agreementTitle
      currency
      terminated
      group {
        id
        name
      }
      contributions(orderByDateFilter: true) {
        edges {
          node {
            id
            date
            amountForeign
            amountByn
            status
            debt
            complete
            remainder
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStudentAgreementsForLinkingQuery__
 *
 * To run a query within a React component, call `useStudentAgreementsForLinkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAgreementsForLinkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAgreementsForLinkingQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentAgreementsForLinkingQuery(baseOptions: Apollo.QueryHookOptions<StudentAgreementsForLinkingQuery, StudentAgreementsForLinkingQueryVariables>) {
        return Apollo.useQuery<StudentAgreementsForLinkingQuery, StudentAgreementsForLinkingQueryVariables>(StudentAgreementsForLinkingDocument, baseOptions);
      }
export function useStudentAgreementsForLinkingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentAgreementsForLinkingQuery, StudentAgreementsForLinkingQueryVariables>) {
          return Apollo.useLazyQuery<StudentAgreementsForLinkingQuery, StudentAgreementsForLinkingQueryVariables>(StudentAgreementsForLinkingDocument, baseOptions);
        }
export type StudentAgreementsForLinkingQueryHookResult = ReturnType<typeof useStudentAgreementsForLinkingQuery>;
export type StudentAgreementsForLinkingLazyQueryHookResult = ReturnType<typeof useStudentAgreementsForLinkingLazyQuery>;
export type StudentAgreementsForLinkingQueryResult = Apollo.QueryResult<StudentAgreementsForLinkingQuery, StudentAgreementsForLinkingQueryVariables>;
export const FakturowniaUnmatchedCountDocument = gql`
    query FakturowniaUnmatchedCount {
  fakturowniaUnmatchedCount
}
    `;

/**
 * __useFakturowniaUnmatchedCountQuery__
 *
 * To run a query within a React component, call `useFakturowniaUnmatchedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFakturowniaUnmatchedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFakturowniaUnmatchedCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFakturowniaUnmatchedCountQuery(baseOptions?: Apollo.QueryHookOptions<FakturowniaUnmatchedCountQuery, FakturowniaUnmatchedCountQueryVariables>) {
        return Apollo.useQuery<FakturowniaUnmatchedCountQuery, FakturowniaUnmatchedCountQueryVariables>(FakturowniaUnmatchedCountDocument, baseOptions);
      }
export function useFakturowniaUnmatchedCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FakturowniaUnmatchedCountQuery, FakturowniaUnmatchedCountQueryVariables>) {
          return Apollo.useLazyQuery<FakturowniaUnmatchedCountQuery, FakturowniaUnmatchedCountQueryVariables>(FakturowniaUnmatchedCountDocument, baseOptions);
        }
export type FakturowniaUnmatchedCountQueryHookResult = ReturnType<typeof useFakturowniaUnmatchedCountQuery>;
export type FakturowniaUnmatchedCountLazyQueryHookResult = ReturnType<typeof useFakturowniaUnmatchedCountLazyQuery>;
export type FakturowniaUnmatchedCountQueryResult = Apollo.QueryResult<FakturowniaUnmatchedCountQuery, FakturowniaUnmatchedCountQueryVariables>;
export const ExpensesDocument = gql`
    query Expenses($dateFrom: Date, $dateTo: Date, $source: String, $categorySlug: String, $recurrence: String, $status: String, $teacherId: ID, $groupId: ID, $legalEntityId: ID, $page: Int, $perPage: Int) {
  expenses(
    dateFrom: $dateFrom
    dateTo: $dateTo
    source: $source
    categorySlug: $categorySlug
    recurrence: $recurrence
    status: $status
    teacherId: $teacherId
    groupId: $groupId
    legalEntityId: $legalEntityId
    page: $page
    perPage: $perPage
  ) {
    id
    pk
    date
    amount
    amountPln
    currency
    description
    counterpartyName
    counterpartyTaxNo
    source
    paidAt
    dueAt
    isOverdue
    documentUrl
    notes
    recurrence
    recurrenceDay
    recurrenceUntil
    status
    isCorrection
    correctionReason
    category {
      id
      name
      slug
    }
    relatedTeacher {
      id
      user {
        id
        firstName
        lastName
      }
    }
    relatedGroup {
      id
      name
    }
    relatedFakturowniaInvoice {
      id
      pk
      number
      kind
      correctionReason
      parentInvoice {
        id
        pk
        number
      }
    }
  }
}
    `;

/**
 * __useExpensesQuery__
 *
 * To run a query within a React component, call `useExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      source: // value for 'source'
 *      categorySlug: // value for 'categorySlug'
 *      recurrence: // value for 'recurrence'
 *      status: // value for 'status'
 *      teacherId: // value for 'teacherId'
 *      groupId: // value for 'groupId'
 *      legalEntityId: // value for 'legalEntityId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useExpensesQuery(baseOptions?: Apollo.QueryHookOptions<ExpensesQuery, ExpensesQueryVariables>) {
        return Apollo.useQuery<ExpensesQuery, ExpensesQueryVariables>(ExpensesDocument, baseOptions);
      }
export function useExpensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpensesQuery, ExpensesQueryVariables>) {
          return Apollo.useLazyQuery<ExpensesQuery, ExpensesQueryVariables>(ExpensesDocument, baseOptions);
        }
export type ExpensesQueryHookResult = ReturnType<typeof useExpensesQuery>;
export type ExpensesLazyQueryHookResult = ReturnType<typeof useExpensesLazyQuery>;
export type ExpensesQueryResult = Apollo.QueryResult<ExpensesQuery, ExpensesQueryVariables>;
export const ExpenseDocument = gql`
    query Expense($id: ID!) {
  expense(id: $id) {
    id
    pk
    date
    amount
    amountPln
    currency
    description
    counterpartyName
    counterpartyTaxNo
    source
    paidAt
    dueAt
    isOverdue
    documentUrl
    notes
    recurrence
    recurrenceDay
    recurrenceUntil
    status
    isCorrection
    correctionReason
    category {
      id
      name
      slug
    }
    relatedTeacher {
      id
      user {
        id
        firstName
        lastName
      }
    }
    relatedGroup {
      id
      name
      course {
        id
        title
      }
    }
    relatedFakturowniaInvoice {
      id
      pk
      number
      kind
      status
      correctionReason
      parentInvoice {
        id
        pk
        number
      }
    }
  }
}
    `;

/**
 * __useExpenseQuery__
 *
 * To run a query within a React component, call `useExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpenseQuery(baseOptions: Apollo.QueryHookOptions<ExpenseQuery, ExpenseQueryVariables>) {
        return Apollo.useQuery<ExpenseQuery, ExpenseQueryVariables>(ExpenseDocument, baseOptions);
      }
export function useExpenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseQuery, ExpenseQueryVariables>) {
          return Apollo.useLazyQuery<ExpenseQuery, ExpenseQueryVariables>(ExpenseDocument, baseOptions);
        }
export type ExpenseQueryHookResult = ReturnType<typeof useExpenseQuery>;
export type ExpenseLazyQueryHookResult = ReturnType<typeof useExpenseLazyQuery>;
export type ExpenseQueryResult = Apollo.QueryResult<ExpenseQuery, ExpenseQueryVariables>;
export const ReceivedInvoicesForExpenseDocument = gql`
    query ReceivedInvoicesForExpense($dateFrom: Date, $dateTo: Date, $unlinkedOnly: Boolean) {
  receivedInvoicesForExpense(
    dateFrom: $dateFrom
    dateTo: $dateTo
    unlinkedOnly: $unlinkedOnly
  ) {
    pk
    number
    issueDate
    paymentTo
    currency
    priceGross
    buyerName
    buyerTaxNo
    accountingKind
    kind
    status
  }
}
    `;

/**
 * __useReceivedInvoicesForExpenseQuery__
 *
 * To run a query within a React component, call `useReceivedInvoicesForExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceivedInvoicesForExpenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceivedInvoicesForExpenseQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      unlinkedOnly: // value for 'unlinkedOnly'
 *   },
 * });
 */
export function useReceivedInvoicesForExpenseQuery(baseOptions?: Apollo.QueryHookOptions<ReceivedInvoicesForExpenseQuery, ReceivedInvoicesForExpenseQueryVariables>) {
        return Apollo.useQuery<ReceivedInvoicesForExpenseQuery, ReceivedInvoicesForExpenseQueryVariables>(ReceivedInvoicesForExpenseDocument, baseOptions);
      }
export function useReceivedInvoicesForExpenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceivedInvoicesForExpenseQuery, ReceivedInvoicesForExpenseQueryVariables>) {
          return Apollo.useLazyQuery<ReceivedInvoicesForExpenseQuery, ReceivedInvoicesForExpenseQueryVariables>(ReceivedInvoicesForExpenseDocument, baseOptions);
        }
export type ReceivedInvoicesForExpenseQueryHookResult = ReturnType<typeof useReceivedInvoicesForExpenseQuery>;
export type ReceivedInvoicesForExpenseLazyQueryHookResult = ReturnType<typeof useReceivedInvoicesForExpenseLazyQuery>;
export type ReceivedInvoicesForExpenseQueryResult = Apollo.QueryResult<ReceivedInvoicesForExpenseQuery, ReceivedInvoicesForExpenseQueryVariables>;
export const ExpenseCategoriesDocument = gql`
    query ExpenseCategories {
  expenseCategories {
    id
    pk
    name
    slug
    isActive
  }
}
    `;

/**
 * __useExpenseCategoriesQuery__
 *
 * To run a query within a React component, call `useExpenseCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpenseCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ExpenseCategoriesQuery, ExpenseCategoriesQueryVariables>) {
        return Apollo.useQuery<ExpenseCategoriesQuery, ExpenseCategoriesQueryVariables>(ExpenseCategoriesDocument, baseOptions);
      }
export function useExpenseCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseCategoriesQuery, ExpenseCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<ExpenseCategoriesQuery, ExpenseCategoriesQueryVariables>(ExpenseCategoriesDocument, baseOptions);
        }
export type ExpenseCategoriesQueryHookResult = ReturnType<typeof useExpenseCategoriesQuery>;
export type ExpenseCategoriesLazyQueryHookResult = ReturnType<typeof useExpenseCategoriesLazyQuery>;
export type ExpenseCategoriesQueryResult = Apollo.QueryResult<ExpenseCategoriesQuery, ExpenseCategoriesQueryVariables>;
export const ExpenseAggregatesDocument = gql`
    query ExpenseAggregates($dateFrom: Date!, $dateTo: Date!, $groupBy: String!, $teacherId: ID) {
  expenseAggregates(
    dateFrom: $dateFrom
    dateTo: $dateTo
    groupBy: $groupBy
    teacherId: $teacherId
  ) {
    group
    total
    count
  }
}
    `;

/**
 * __useExpenseAggregatesQuery__
 *
 * To run a query within a React component, call `useExpenseAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseAggregatesQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      groupBy: // value for 'groupBy'
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useExpenseAggregatesQuery(baseOptions: Apollo.QueryHookOptions<ExpenseAggregatesQuery, ExpenseAggregatesQueryVariables>) {
        return Apollo.useQuery<ExpenseAggregatesQuery, ExpenseAggregatesQueryVariables>(ExpenseAggregatesDocument, baseOptions);
      }
export function useExpenseAggregatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseAggregatesQuery, ExpenseAggregatesQueryVariables>) {
          return Apollo.useLazyQuery<ExpenseAggregatesQuery, ExpenseAggregatesQueryVariables>(ExpenseAggregatesDocument, baseOptions);
        }
export type ExpenseAggregatesQueryHookResult = ReturnType<typeof useExpenseAggregatesQuery>;
export type ExpenseAggregatesLazyQueryHookResult = ReturnType<typeof useExpenseAggregatesLazyQuery>;
export type ExpenseAggregatesQueryResult = Apollo.QueryResult<ExpenseAggregatesQuery, ExpenseAggregatesQueryVariables>;
export const FakturowniaInvoiceAggregatesDocument = gql`
    query FakturowniaInvoiceAggregates($direction: String, $studentId: ID, $groupId: ID, $dateFrom: Date, $dateTo: Date, $groupBy: String!, $currency: String) {
  fakturowniaInvoiceAggregates(
    direction: $direction
    studentId: $studentId
    groupId: $groupId
    dateFrom: $dateFrom
    dateTo: $dateTo
    groupBy: $groupBy
    currency: $currency
  ) {
    group
    totalGross
    totalPaid
    totalOutstanding
    totalExpected
    count
  }
}
    `;

/**
 * __useFakturowniaInvoiceAggregatesQuery__
 *
 * To run a query within a React component, call `useFakturowniaInvoiceAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFakturowniaInvoiceAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFakturowniaInvoiceAggregatesQuery({
 *   variables: {
 *      direction: // value for 'direction'
 *      studentId: // value for 'studentId'
 *      groupId: // value for 'groupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      groupBy: // value for 'groupBy'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useFakturowniaInvoiceAggregatesQuery(baseOptions: Apollo.QueryHookOptions<FakturowniaInvoiceAggregatesQuery, FakturowniaInvoiceAggregatesQueryVariables>) {
        return Apollo.useQuery<FakturowniaInvoiceAggregatesQuery, FakturowniaInvoiceAggregatesQueryVariables>(FakturowniaInvoiceAggregatesDocument, baseOptions);
      }
export function useFakturowniaInvoiceAggregatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FakturowniaInvoiceAggregatesQuery, FakturowniaInvoiceAggregatesQueryVariables>) {
          return Apollo.useLazyQuery<FakturowniaInvoiceAggregatesQuery, FakturowniaInvoiceAggregatesQueryVariables>(FakturowniaInvoiceAggregatesDocument, baseOptions);
        }
export type FakturowniaInvoiceAggregatesQueryHookResult = ReturnType<typeof useFakturowniaInvoiceAggregatesQuery>;
export type FakturowniaInvoiceAggregatesLazyQueryHookResult = ReturnType<typeof useFakturowniaInvoiceAggregatesLazyQuery>;
export type FakturowniaInvoiceAggregatesQueryResult = Apollo.QueryResult<FakturowniaInvoiceAggregatesQuery, FakturowniaInvoiceAggregatesQueryVariables>;
export const InvoiceIssuePreflightDocument = gql`
    query InvoiceIssuePreflight($agreementId: ID!, $contributionId: ID, $kind: String) {
  fakturowniaContributionBillability(
    agreementId: $agreementId
    contributionId: $contributionId
    kind: $kind
  ) {
    billable
    kind
    reason
    agreementId
    contributionId
    studentName
    groupName
    courseName
    amount
    currency
    paymentTo
    positionName
    taxRate
    buyerName
    buyerEmail
    buyerTaxNo
    buyerAddress
    missingFields
  }
}
    `;

/**
 * __useInvoiceIssuePreflightQuery__
 *
 * To run a query within a React component, call `useInvoiceIssuePreflightQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceIssuePreflightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceIssuePreflightQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      contributionId: // value for 'contributionId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useInvoiceIssuePreflightQuery(baseOptions: Apollo.QueryHookOptions<InvoiceIssuePreflightQuery, InvoiceIssuePreflightQueryVariables>) {
        return Apollo.useQuery<InvoiceIssuePreflightQuery, InvoiceIssuePreflightQueryVariables>(InvoiceIssuePreflightDocument, baseOptions);
      }
export function useInvoiceIssuePreflightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceIssuePreflightQuery, InvoiceIssuePreflightQueryVariables>) {
          return Apollo.useLazyQuery<InvoiceIssuePreflightQuery, InvoiceIssuePreflightQueryVariables>(InvoiceIssuePreflightDocument, baseOptions);
        }
export type InvoiceIssuePreflightQueryHookResult = ReturnType<typeof useInvoiceIssuePreflightQuery>;
export type InvoiceIssuePreflightLazyQueryHookResult = ReturnType<typeof useInvoiceIssuePreflightLazyQuery>;
export type InvoiceIssuePreflightQueryResult = Apollo.QueryResult<InvoiceIssuePreflightQuery, InvoiceIssuePreflightQueryVariables>;
export const GroupInvoiceIssuePreflightDocument = gql`
    query GroupInvoiceIssuePreflight($groupId: ID!, $kind: String) {
  fakturowniaGroupBillingPreview(groupId: $groupId, kind: $kind) {
    total
    billableCount
    skippedCount
    rows {
      billable
      reason
      agreementId
      contributionId
      studentName
      groupName
      courseName
      amount
      currency
      paymentTo
      positionName
      taxRate
      buyerName
      buyerEmail
      buyerTaxNo
      buyerAddress
      missingFields
    }
  }
}
    `;

/**
 * __useGroupInvoiceIssuePreflightQuery__
 *
 * To run a query within a React component, call `useGroupInvoiceIssuePreflightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupInvoiceIssuePreflightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupInvoiceIssuePreflightQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useGroupInvoiceIssuePreflightQuery(baseOptions: Apollo.QueryHookOptions<GroupInvoiceIssuePreflightQuery, GroupInvoiceIssuePreflightQueryVariables>) {
        return Apollo.useQuery<GroupInvoiceIssuePreflightQuery, GroupInvoiceIssuePreflightQueryVariables>(GroupInvoiceIssuePreflightDocument, baseOptions);
      }
export function useGroupInvoiceIssuePreflightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupInvoiceIssuePreflightQuery, GroupInvoiceIssuePreflightQueryVariables>) {
          return Apollo.useLazyQuery<GroupInvoiceIssuePreflightQuery, GroupInvoiceIssuePreflightQueryVariables>(GroupInvoiceIssuePreflightDocument, baseOptions);
        }
export type GroupInvoiceIssuePreflightQueryHookResult = ReturnType<typeof useGroupInvoiceIssuePreflightQuery>;
export type GroupInvoiceIssuePreflightLazyQueryHookResult = ReturnType<typeof useGroupInvoiceIssuePreflightLazyQuery>;
export type GroupInvoiceIssuePreflightQueryResult = Apollo.QueryResult<GroupInvoiceIssuePreflightQuery, GroupInvoiceIssuePreflightQueryVariables>;
export const InvoiceIssueJobProgressDocument = gql`
    query InvoiceIssueJobProgress($id: ID!) {
  fakturowniaBillingJob(id: $id) {
    id
    pk
    status
    documentKind
    total
    issuedCount
    skippedCount
    failedCount
    rows {
      pk
      status
      reason
      amount
      currency
      studentName
      invoiceNumber
      viewUrl
    }
  }
}
    `;

/**
 * __useInvoiceIssueJobProgressQuery__
 *
 * To run a query within a React component, call `useInvoiceIssueJobProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceIssueJobProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceIssueJobProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceIssueJobProgressQuery(baseOptions: Apollo.QueryHookOptions<InvoiceIssueJobProgressQuery, InvoiceIssueJobProgressQueryVariables>) {
        return Apollo.useQuery<InvoiceIssueJobProgressQuery, InvoiceIssueJobProgressQueryVariables>(InvoiceIssueJobProgressDocument, baseOptions);
      }
export function useInvoiceIssueJobProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceIssueJobProgressQuery, InvoiceIssueJobProgressQueryVariables>) {
          return Apollo.useLazyQuery<InvoiceIssueJobProgressQuery, InvoiceIssueJobProgressQueryVariables>(InvoiceIssueJobProgressDocument, baseOptions);
        }
export type InvoiceIssueJobProgressQueryHookResult = ReturnType<typeof useInvoiceIssueJobProgressQuery>;
export type InvoiceIssueJobProgressLazyQueryHookResult = ReturnType<typeof useInvoiceIssueJobProgressLazyQuery>;
export type InvoiceIssueJobProgressQueryResult = Apollo.QueryResult<InvoiceIssueJobProgressQuery, InvoiceIssueJobProgressQueryVariables>;
export const StudentProformasDocument = gql`
    query StudentProformas($studentId: ID!) {
  fakturowniaInvoices(
    studentId: $studentId
    kind: "proforma"
    direction: "issued"
    perPage: 200
  ) {
    id
    pk
    number
    kind
    status
    issueDate
    paymentTo
    currency
    priceGross
    paid
    outstanding
    viewUrl
    isProforma
    isOpenProforma
    proformaForContributionId
    vatChild {
      id
      pk
      number
      viewUrl
    }
  }
}
    `;

/**
 * __useStudentProformasQuery__
 *
 * To run a query within a React component, call `useStudentProformasQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentProformasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentProformasQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentProformasQuery(baseOptions: Apollo.QueryHookOptions<StudentProformasQuery, StudentProformasQueryVariables>) {
        return Apollo.useQuery<StudentProformasQuery, StudentProformasQueryVariables>(StudentProformasDocument, baseOptions);
      }
export function useStudentProformasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentProformasQuery, StudentProformasQueryVariables>) {
          return Apollo.useLazyQuery<StudentProformasQuery, StudentProformasQueryVariables>(StudentProformasDocument, baseOptions);
        }
export type StudentProformasQueryHookResult = ReturnType<typeof useStudentProformasQuery>;
export type StudentProformasLazyQueryHookResult = ReturnType<typeof useStudentProformasLazyQuery>;
export type StudentProformasQueryResult = Apollo.QueryResult<StudentProformasQuery, StudentProformasQueryVariables>;
export const PlannedYearContributionsDocument = gql`
    query PlannedYearContributions($year: Int!) {
  financePlan(year: $year) {
    month
    USD
    EUR
    BYN
    RUB
    PLN
  }
  financeBudget(year: $year) {
    month
    USD
    EUR
    BYN
    RUB
    PLN
  }
}
    `;

/**
 * __usePlannedYearContributionsQuery__
 *
 * To run a query within a React component, call `usePlannedYearContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlannedYearContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlannedYearContributionsQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function usePlannedYearContributionsQuery(baseOptions: Apollo.QueryHookOptions<PlannedYearContributionsQuery, PlannedYearContributionsQueryVariables>) {
        return Apollo.useQuery<PlannedYearContributionsQuery, PlannedYearContributionsQueryVariables>(PlannedYearContributionsDocument, baseOptions);
      }
export function usePlannedYearContributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlannedYearContributionsQuery, PlannedYearContributionsQueryVariables>) {
          return Apollo.useLazyQuery<PlannedYearContributionsQuery, PlannedYearContributionsQueryVariables>(PlannedYearContributionsDocument, baseOptions);
        }
export type PlannedYearContributionsQueryHookResult = ReturnType<typeof usePlannedYearContributionsQuery>;
export type PlannedYearContributionsLazyQueryHookResult = ReturnType<typeof usePlannedYearContributionsLazyQuery>;
export type PlannedYearContributionsQueryResult = Apollo.QueryResult<PlannedYearContributionsQuery, PlannedYearContributionsQueryVariables>;
export const PlannedMonthContributionsDocument = gql`
    query PlannedMonthContributions($year: Int!, $month: Int!) {
  financeMonthBudget(year: $year, month: $month) {
    plan {
      week
      USD
      EUR
      BYN
      RUB
      PLN
    }
    budget {
      week
      USD
      EUR
      BYN
      RUB
      PLN
    }
  }
}
    `;

/**
 * __usePlannedMonthContributionsQuery__
 *
 * To run a query within a React component, call `usePlannedMonthContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlannedMonthContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlannedMonthContributionsQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function usePlannedMonthContributionsQuery(baseOptions: Apollo.QueryHookOptions<PlannedMonthContributionsQuery, PlannedMonthContributionsQueryVariables>) {
        return Apollo.useQuery<PlannedMonthContributionsQuery, PlannedMonthContributionsQueryVariables>(PlannedMonthContributionsDocument, baseOptions);
      }
export function usePlannedMonthContributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlannedMonthContributionsQuery, PlannedMonthContributionsQueryVariables>) {
          return Apollo.useLazyQuery<PlannedMonthContributionsQuery, PlannedMonthContributionsQueryVariables>(PlannedMonthContributionsDocument, baseOptions);
        }
export type PlannedMonthContributionsQueryHookResult = ReturnType<typeof usePlannedMonthContributionsQuery>;
export type PlannedMonthContributionsLazyQueryHookResult = ReturnType<typeof usePlannedMonthContributionsLazyQuery>;
export type PlannedMonthContributionsQueryResult = Apollo.QueryResult<PlannedMonthContributionsQuery, PlannedMonthContributionsQueryVariables>;
export const FinanceYearsDocument = gql`
    query FinanceYears {
  financeYears
}
    `;

/**
 * __useFinanceYearsQuery__
 *
 * To run a query within a React component, call `useFinanceYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinanceYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinanceYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinanceYearsQuery(baseOptions?: Apollo.QueryHookOptions<FinanceYearsQuery, FinanceYearsQueryVariables>) {
        return Apollo.useQuery<FinanceYearsQuery, FinanceYearsQueryVariables>(FinanceYearsDocument, baseOptions);
      }
export function useFinanceYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinanceYearsQuery, FinanceYearsQueryVariables>) {
          return Apollo.useLazyQuery<FinanceYearsQuery, FinanceYearsQueryVariables>(FinanceYearsDocument, baseOptions);
        }
export type FinanceYearsQueryHookResult = ReturnType<typeof useFinanceYearsQuery>;
export type FinanceYearsLazyQueryHookResult = ReturnType<typeof useFinanceYearsLazyQuery>;
export type FinanceYearsQueryResult = Apollo.QueryResult<FinanceYearsQuery, FinanceYearsQueryVariables>;
export const PaginatedGroupsDocument = gql`
    query PaginatedGroups($query: String, $first: Int, $after: String, $withStaffFields: Boolean!) {
  allGroups(query: $query, first: $first, after: $after) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        name
        startDate
        lessonsCount
        studentsCount
        classesDays {
          weekDay
        }
        publishedLms
        publishedLmsForTeacher
        publishedLmsForMethodist
        price @include(if: $withStaffFields)
        currency @include(if: $withStaffFields)
        contributionsSum
      }
    }
  }
}
    `;

/**
 * __usePaginatedGroupsQuery__
 *
 * To run a query within a React component, call `usePaginatedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedGroupsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      withStaffFields: // value for 'withStaffFields'
 *   },
 * });
 */
export function usePaginatedGroupsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedGroupsQuery, PaginatedGroupsQueryVariables>) {
        return Apollo.useQuery<PaginatedGroupsQuery, PaginatedGroupsQueryVariables>(PaginatedGroupsDocument, baseOptions);
      }
export function usePaginatedGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedGroupsQuery, PaginatedGroupsQueryVariables>) {
          return Apollo.useLazyQuery<PaginatedGroupsQuery, PaginatedGroupsQueryVariables>(PaginatedGroupsDocument, baseOptions);
        }
export type PaginatedGroupsQueryHookResult = ReturnType<typeof usePaginatedGroupsQuery>;
export type PaginatedGroupsLazyQueryHookResult = ReturnType<typeof usePaginatedGroupsLazyQuery>;
export type PaginatedGroupsQueryResult = Apollo.QueryResult<PaginatedGroupsQuery, PaginatedGroupsQueryVariables>;
export const LoadEditingGroupDocument = gql`
    query loadEditingGroup($groupId: ID!) {
  group(groupId: $groupId) {
    id
    name
    price
    currency
    startDate
    deleteAvailable
    course {
      id
      name
    }
    classesDays {
      id
      weekDay
      startTime
      endTime
    }
    modules {
      id
      name
      lessons {
        edges {
          node {
            id
            name
            lessonNumber
            additional
            date
            lmsDescription
            teacherApplication {
              id
              teacher {
                fullName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLoadEditingGroupQuery__
 *
 * To run a query within a React component, call `useLoadEditingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadEditingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadEditingGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useLoadEditingGroupQuery(baseOptions: Apollo.QueryHookOptions<LoadEditingGroupQuery, LoadEditingGroupQueryVariables>) {
        return Apollo.useQuery<LoadEditingGroupQuery, LoadEditingGroupQueryVariables>(LoadEditingGroupDocument, baseOptions);
      }
export function useLoadEditingGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadEditingGroupQuery, LoadEditingGroupQueryVariables>) {
          return Apollo.useLazyQuery<LoadEditingGroupQuery, LoadEditingGroupQueryVariables>(LoadEditingGroupDocument, baseOptions);
        }
export type LoadEditingGroupQueryHookResult = ReturnType<typeof useLoadEditingGroupQuery>;
export type LoadEditingGroupLazyQueryHookResult = ReturnType<typeof useLoadEditingGroupLazyQuery>;
export type LoadEditingGroupQueryResult = Apollo.QueryResult<LoadEditingGroupQuery, LoadEditingGroupQueryVariables>;
export const GroupJoinLinkInfoDocument = gql`
    query GroupJoinLinkInfo($groupId: ID) {
  group(groupId: $groupId) {
    ...GroupJoinLinkFields
  }
}
    ${GroupJoinLinkFieldsFragmentDoc}`;

/**
 * __useGroupJoinLinkInfoQuery__
 *
 * To run a query within a React component, call `useGroupJoinLinkInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupJoinLinkInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupJoinLinkInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupJoinLinkInfoQuery(baseOptions?: Apollo.QueryHookOptions<GroupJoinLinkInfoQuery, GroupJoinLinkInfoQueryVariables>) {
        return Apollo.useQuery<GroupJoinLinkInfoQuery, GroupJoinLinkInfoQueryVariables>(GroupJoinLinkInfoDocument, baseOptions);
      }
export function useGroupJoinLinkInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupJoinLinkInfoQuery, GroupJoinLinkInfoQueryVariables>) {
          return Apollo.useLazyQuery<GroupJoinLinkInfoQuery, GroupJoinLinkInfoQueryVariables>(GroupJoinLinkInfoDocument, baseOptions);
        }
export type GroupJoinLinkInfoQueryHookResult = ReturnType<typeof useGroupJoinLinkInfoQuery>;
export type GroupJoinLinkInfoLazyQueryHookResult = ReturnType<typeof useGroupJoinLinkInfoLazyQuery>;
export type GroupJoinLinkInfoQueryResult = Apollo.QueryResult<GroupJoinLinkInfoQuery, GroupJoinLinkInfoQueryVariables>;
export const LessonJoinClicksListDocument = gql`
    query LessonJoinClicksList($lessonId: Int!) {
  lessonJoinClicks(lessonId: $lessonId) {
    id
    userName
    role
    clickedAt
    clicksCount
    attendanceState
  }
}
    `;

/**
 * __useLessonJoinClicksListQuery__
 *
 * To run a query within a React component, call `useLessonJoinClicksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonJoinClicksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonJoinClicksListQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useLessonJoinClicksListQuery(baseOptions: Apollo.QueryHookOptions<LessonJoinClicksListQuery, LessonJoinClicksListQueryVariables>) {
        return Apollo.useQuery<LessonJoinClicksListQuery, LessonJoinClicksListQueryVariables>(LessonJoinClicksListDocument, baseOptions);
      }
export function useLessonJoinClicksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonJoinClicksListQuery, LessonJoinClicksListQueryVariables>) {
          return Apollo.useLazyQuery<LessonJoinClicksListQuery, LessonJoinClicksListQueryVariables>(LessonJoinClicksListDocument, baseOptions);
        }
export type LessonJoinClicksListQueryHookResult = ReturnType<typeof useLessonJoinClicksListQuery>;
export type LessonJoinClicksListLazyQueryHookResult = ReturnType<typeof useLessonJoinClicksListLazyQuery>;
export type LessonJoinClicksListQueryResult = Apollo.QueryResult<LessonJoinClicksListQuery, LessonJoinClicksListQueryVariables>;
export const GroupAttendanceSummaryDocument = gql`
    query GroupAttendanceSummary($groupId: ID!) {
  groupAttendanceSummary(groupId: $groupId) {
    groupId
    threshold
    totalLessons
    passedLessons
    unclosedLessons
    averageAttendance
    studentsBelowThresholdCount
    students {
      studentId
      fullName
      expectedLessons
      attended
      missed
      attendanceRate
      belowThreshold
    }
  }
}
    `;

/**
 * __useGroupAttendanceSummaryQuery__
 *
 * To run a query within a React component, call `useGroupAttendanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupAttendanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupAttendanceSummaryQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupAttendanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<GroupAttendanceSummaryQuery, GroupAttendanceSummaryQueryVariables>) {
        return Apollo.useQuery<GroupAttendanceSummaryQuery, GroupAttendanceSummaryQueryVariables>(GroupAttendanceSummaryDocument, baseOptions);
      }
export function useGroupAttendanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupAttendanceSummaryQuery, GroupAttendanceSummaryQueryVariables>) {
          return Apollo.useLazyQuery<GroupAttendanceSummaryQuery, GroupAttendanceSummaryQueryVariables>(GroupAttendanceSummaryDocument, baseOptions);
        }
export type GroupAttendanceSummaryQueryHookResult = ReturnType<typeof useGroupAttendanceSummaryQuery>;
export type GroupAttendanceSummaryLazyQueryHookResult = ReturnType<typeof useGroupAttendanceSummaryLazyQuery>;
export type GroupAttendanceSummaryQueryResult = Apollo.QueryResult<GroupAttendanceSummaryQuery, GroupAttendanceSummaryQueryVariables>;
export const GroupPerformanceSummaryDocument = gql`
    query GroupPerformanceSummary($groupId: ID!) {
  groupPerformanceSummary(groupId: $groupId) {
    groupId
    averageMark
    studentsWithoutMarks
    top {
      studentId
      fullName
      averageMark
      marksCount
    }
    bottom {
      studentId
      fullName
      averageMark
      marksCount
    }
  }
}
    `;

/**
 * __useGroupPerformanceSummaryQuery__
 *
 * To run a query within a React component, call `useGroupPerformanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPerformanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPerformanceSummaryQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupPerformanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<GroupPerformanceSummaryQuery, GroupPerformanceSummaryQueryVariables>) {
        return Apollo.useQuery<GroupPerformanceSummaryQuery, GroupPerformanceSummaryQueryVariables>(GroupPerformanceSummaryDocument, baseOptions);
      }
export function useGroupPerformanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPerformanceSummaryQuery, GroupPerformanceSummaryQueryVariables>) {
          return Apollo.useLazyQuery<GroupPerformanceSummaryQuery, GroupPerformanceSummaryQueryVariables>(GroupPerformanceSummaryDocument, baseOptions);
        }
export type GroupPerformanceSummaryQueryHookResult = ReturnType<typeof useGroupPerformanceSummaryQuery>;
export type GroupPerformanceSummaryLazyQueryHookResult = ReturnType<typeof useGroupPerformanceSummaryLazyQuery>;
export type GroupPerformanceSummaryQueryResult = Apollo.QueryResult<GroupPerformanceSummaryQuery, GroupPerformanceSummaryQueryVariables>;
export const GroupRevenueAggregatesDocument = gql`
    query GroupRevenueAggregates($groupId: ID!) {
  groupRevenueAggregates(groupId: $groupId) {
    groupId
    rows {
      currency
      budget
      paid
      debt
      upcoming
      agreementsActive
      studentsWithDebt
    }
  }
}
    `;

/**
 * __useGroupRevenueAggregatesQuery__
 *
 * To run a query within a React component, call `useGroupRevenueAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupRevenueAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupRevenueAggregatesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupRevenueAggregatesQuery(baseOptions: Apollo.QueryHookOptions<GroupRevenueAggregatesQuery, GroupRevenueAggregatesQueryVariables>) {
        return Apollo.useQuery<GroupRevenueAggregatesQuery, GroupRevenueAggregatesQueryVariables>(GroupRevenueAggregatesDocument, baseOptions);
      }
export function useGroupRevenueAggregatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupRevenueAggregatesQuery, GroupRevenueAggregatesQueryVariables>) {
          return Apollo.useLazyQuery<GroupRevenueAggregatesQuery, GroupRevenueAggregatesQueryVariables>(GroupRevenueAggregatesDocument, baseOptions);
        }
export type GroupRevenueAggregatesQueryHookResult = ReturnType<typeof useGroupRevenueAggregatesQuery>;
export type GroupRevenueAggregatesLazyQueryHookResult = ReturnType<typeof useGroupRevenueAggregatesLazyQuery>;
export type GroupRevenueAggregatesQueryResult = Apollo.QueryResult<GroupRevenueAggregatesQuery, GroupRevenueAggregatesQueryVariables>;
export const GroupLessonsDocument = gql`
    query GroupLessons($id: ID!) {
  group(groupId: $id) {
    id
    classesDays {
      weekDay
      startTime
      endTime
    }
    zoomAccount {
      id
      displayName
    }
    zoomSchedules {
      edges {
        node {
          id
          weekDay
          runTime
          isActive
        }
      }
    }
    lessons {
      id
      name
      number
      lessonNumber
      date
      startTime
      endTime
      startsAt
      endsAt
      finished
      additional
      whiteboardId
      homeworkStats {
        hasAssignment
        assignmentSource
        totalStudents
        submittedCount
        gradedCount
        suspiciousCount
      }
      module {
        id
        name
      }
      teacher {
        id
        fullName
      }
      zoomRecordingMeta {
        ...LessonRecordingFields
      }
    }
  }
}
    ${LessonRecordingFieldsFragmentDoc}`;

/**
 * __useGroupLessonsQuery__
 *
 * To run a query within a React component, call `useGroupLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupLessonsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupLessonsQuery(baseOptions: Apollo.QueryHookOptions<GroupLessonsQuery, GroupLessonsQueryVariables>) {
        return Apollo.useQuery<GroupLessonsQuery, GroupLessonsQueryVariables>(GroupLessonsDocument, baseOptions);
      }
export function useGroupLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupLessonsQuery, GroupLessonsQueryVariables>) {
          return Apollo.useLazyQuery<GroupLessonsQuery, GroupLessonsQueryVariables>(GroupLessonsDocument, baseOptions);
        }
export type GroupLessonsQueryHookResult = ReturnType<typeof useGroupLessonsQuery>;
export type GroupLessonsLazyQueryHookResult = ReturnType<typeof useGroupLessonsLazyQuery>;
export type GroupLessonsQueryResult = Apollo.QueryResult<GroupLessonsQuery, GroupLessonsQueryVariables>;
export const GroupRosterDocument = gql`
    query GroupRoster($groupId: ID!) {
  group(groupId: $groupId) {
    id
    agreements {
      id
      agreementTitle
      currency
      budgetAmount
      paidAmount
      debtAmount
      upcomingAmount
      terminated
      terminatedDate
      date
      student {
        id
        isLmsBlocked
        user {
          id
          firstName
          middleName
          lastName
          email
          phone
        }
      }
      pandadocDocument {
        id
        status
        outcome
      }
      contractDocument {
        id
        number
        status
        fulfilmentStatus
      }
      contributionsCount
      paidContributionsCount
      freeOfCharge
      statePrefinanced
      scheduleContributions {
        id
        date
        amountForeign
        status
        debt
        hasVatInvoice
        invoices {
          id
          number
          kind
          status
          isCorrection
          isAdvance
          isFinal
          isEstimate
          isQuotation
        }
        currencyMismatchInvoices {
          id
          currency
        }
      }
    }
  }
}
    `;

/**
 * __useGroupRosterQuery__
 *
 * To run a query within a React component, call `useGroupRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupRosterQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupRosterQuery(baseOptions: Apollo.QueryHookOptions<GroupRosterQuery, GroupRosterQueryVariables>) {
        return Apollo.useQuery<GroupRosterQuery, GroupRosterQueryVariables>(GroupRosterDocument, baseOptions);
      }
export function useGroupRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupRosterQuery, GroupRosterQueryVariables>) {
          return Apollo.useLazyQuery<GroupRosterQuery, GroupRosterQueryVariables>(GroupRosterDocument, baseOptions);
        }
export type GroupRosterQueryHookResult = ReturnType<typeof useGroupRosterQuery>;
export type GroupRosterLazyQueryHookResult = ReturnType<typeof useGroupRosterLazyQuery>;
export type GroupRosterQueryResult = Apollo.QueryResult<GroupRosterQuery, GroupRosterQueryVariables>;
export const GroupFinanceContributionsDocument = gql`
    query GroupFinanceContributions($groupId: ID!) {
  group(groupId: $groupId) {
    id
    agreements {
      id
      currency
      budgetAmount
      paidAmount
      terminated
      debtAmount
      upcomingAmount
      freeOfCharge
      statePrefinanced
      scheduleContributions {
        id
        date
        amountForeign
        complete
        remainder
        delay
        coveredAmount
        debt
        status
      }
    }
  }
}
    `;

/**
 * __useGroupFinanceContributionsQuery__
 *
 * To run a query within a React component, call `useGroupFinanceContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupFinanceContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupFinanceContributionsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupFinanceContributionsQuery(baseOptions: Apollo.QueryHookOptions<GroupFinanceContributionsQuery, GroupFinanceContributionsQueryVariables>) {
        return Apollo.useQuery<GroupFinanceContributionsQuery, GroupFinanceContributionsQueryVariables>(GroupFinanceContributionsDocument, baseOptions);
      }
export function useGroupFinanceContributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupFinanceContributionsQuery, GroupFinanceContributionsQueryVariables>) {
          return Apollo.useLazyQuery<GroupFinanceContributionsQuery, GroupFinanceContributionsQueryVariables>(GroupFinanceContributionsDocument, baseOptions);
        }
export type GroupFinanceContributionsQueryHookResult = ReturnType<typeof useGroupFinanceContributionsQuery>;
export type GroupFinanceContributionsLazyQueryHookResult = ReturnType<typeof useGroupFinanceContributionsLazyQuery>;
export type GroupFinanceContributionsQueryResult = Apollo.QueryResult<GroupFinanceContributionsQuery, GroupFinanceContributionsQueryVariables>;
export const GroupMaterialsDocument = gql`
    query GroupMaterials($groupId: ID!, $lessonId: ID, $kind: MaterialKindEnum) {
  materials(groupId: $groupId, lessonId: $lessonId, kind: $kind) {
    id
    pk
    kind
    title
    description
    dueDate
    createdAt
    updatedAt
    createdBy {
      id
      firstName
      lastName
      email
    }
    lesson {
      id
      name
      number
      lessonNumber
      date
    }
    attachments {
      id
      pk
      originalName
      contentType
      sizeBytes
      uploadedAt
      url
    }
  }
}
    `;

/**
 * __useGroupMaterialsQuery__
 *
 * To run a query within a React component, call `useGroupMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMaterialsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      lessonId: // value for 'lessonId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useGroupMaterialsQuery(baseOptions: Apollo.QueryHookOptions<GroupMaterialsQuery, GroupMaterialsQueryVariables>) {
        return Apollo.useQuery<GroupMaterialsQuery, GroupMaterialsQueryVariables>(GroupMaterialsDocument, baseOptions);
      }
export function useGroupMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupMaterialsQuery, GroupMaterialsQueryVariables>) {
          return Apollo.useLazyQuery<GroupMaterialsQuery, GroupMaterialsQueryVariables>(GroupMaterialsDocument, baseOptions);
        }
export type GroupMaterialsQueryHookResult = ReturnType<typeof useGroupMaterialsQuery>;
export type GroupMaterialsLazyQueryHookResult = ReturnType<typeof useGroupMaterialsLazyQuery>;
export type GroupMaterialsQueryResult = Apollo.QueryResult<GroupMaterialsQuery, GroupMaterialsQueryVariables>;
export const ErpGroupHomeworkOverviewDocument = gql`
    query ErpGroupHomeworkOverview($groupId: ID!) {
  groupHomeworkOverviewForErp(groupId: $groupId) {
    lessonId
    hasAssignment
    assignmentSource
    assignmentRef
    textbookFileCount
    textbookFileName
    totalStudents
    submittedCount
    gradedCount
    aiDoneCount
    suspiciousCount
  }
}
    `;

/**
 * __useErpGroupHomeworkOverviewQuery__
 *
 * To run a query within a React component, call `useErpGroupHomeworkOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpGroupHomeworkOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpGroupHomeworkOverviewQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useErpGroupHomeworkOverviewQuery(baseOptions: Apollo.QueryHookOptions<ErpGroupHomeworkOverviewQuery, ErpGroupHomeworkOverviewQueryVariables>) {
        return Apollo.useQuery<ErpGroupHomeworkOverviewQuery, ErpGroupHomeworkOverviewQueryVariables>(ErpGroupHomeworkOverviewDocument, baseOptions);
      }
export function useErpGroupHomeworkOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpGroupHomeworkOverviewQuery, ErpGroupHomeworkOverviewQueryVariables>) {
          return Apollo.useLazyQuery<ErpGroupHomeworkOverviewQuery, ErpGroupHomeworkOverviewQueryVariables>(ErpGroupHomeworkOverviewDocument, baseOptions);
        }
export type ErpGroupHomeworkOverviewQueryHookResult = ReturnType<typeof useErpGroupHomeworkOverviewQuery>;
export type ErpGroupHomeworkOverviewLazyQueryHookResult = ReturnType<typeof useErpGroupHomeworkOverviewLazyQuery>;
export type ErpGroupHomeworkOverviewQueryResult = Apollo.QueryResult<ErpGroupHomeworkOverviewQuery, ErpGroupHomeworkOverviewQueryVariables>;
export const ErpLessonHomeworkSubmissionsDocument = gql`
    query ErpLessonHomeworkSubmissions($lessonId: ID!) {
  lessonHomeworkSubmissionsForErp(lessonId: $lessonId) {
    studentId
    studentName
    hwMark
    submission {
      ...HomeworkSubmissionFields
    }
  }
}
    ${HomeworkSubmissionFieldsFragmentDoc}`;

/**
 * __useErpLessonHomeworkSubmissionsQuery__
 *
 * To run a query within a React component, call `useErpLessonHomeworkSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpLessonHomeworkSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpLessonHomeworkSubmissionsQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useErpLessonHomeworkSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<ErpLessonHomeworkSubmissionsQuery, ErpLessonHomeworkSubmissionsQueryVariables>) {
        return Apollo.useQuery<ErpLessonHomeworkSubmissionsQuery, ErpLessonHomeworkSubmissionsQueryVariables>(ErpLessonHomeworkSubmissionsDocument, baseOptions);
      }
export function useErpLessonHomeworkSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpLessonHomeworkSubmissionsQuery, ErpLessonHomeworkSubmissionsQueryVariables>) {
          return Apollo.useLazyQuery<ErpLessonHomeworkSubmissionsQuery, ErpLessonHomeworkSubmissionsQueryVariables>(ErpLessonHomeworkSubmissionsDocument, baseOptions);
        }
export type ErpLessonHomeworkSubmissionsQueryHookResult = ReturnType<typeof useErpLessonHomeworkSubmissionsQuery>;
export type ErpLessonHomeworkSubmissionsLazyQueryHookResult = ReturnType<typeof useErpLessonHomeworkSubmissionsLazyQuery>;
export type ErpLessonHomeworkSubmissionsQueryResult = Apollo.QueryResult<ErpLessonHomeworkSubmissionsQuery, ErpLessonHomeworkSubmissionsQueryVariables>;
export const ErpStudentHomeworkDocument = gql`
    query ErpStudentHomework($studentId: ID!) {
  studentHomeworkForErp(studentId: $studentId) {
    groupId
    groupName
    lessonId
    lessonName
    assignmentTitle
    hwMark
    submission {
      ...HomeworkSubmissionFields
    }
  }
}
    ${HomeworkSubmissionFieldsFragmentDoc}`;

/**
 * __useErpStudentHomeworkQuery__
 *
 * To run a query within a React component, call `useErpStudentHomeworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpStudentHomeworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpStudentHomeworkQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useErpStudentHomeworkQuery(baseOptions: Apollo.QueryHookOptions<ErpStudentHomeworkQuery, ErpStudentHomeworkQueryVariables>) {
        return Apollo.useQuery<ErpStudentHomeworkQuery, ErpStudentHomeworkQueryVariables>(ErpStudentHomeworkDocument, baseOptions);
      }
export function useErpStudentHomeworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpStudentHomeworkQuery, ErpStudentHomeworkQueryVariables>) {
          return Apollo.useLazyQuery<ErpStudentHomeworkQuery, ErpStudentHomeworkQueryVariables>(ErpStudentHomeworkDocument, baseOptions);
        }
export type ErpStudentHomeworkQueryHookResult = ReturnType<typeof useErpStudentHomeworkQuery>;
export type ErpStudentHomeworkLazyQueryHookResult = ReturnType<typeof useErpStudentHomeworkLazyQuery>;
export type ErpStudentHomeworkQueryResult = Apollo.QueryResult<ErpStudentHomeworkQuery, ErpStudentHomeworkQueryVariables>;
export const ErpHomeworkSubmissionDownloadUrlDocument = gql`
    query ErpHomeworkSubmissionDownloadUrl($submissionId: ID!) {
  homeworkSubmissionDownloadUrlForErp(submissionId: $submissionId)
}
    `;

/**
 * __useErpHomeworkSubmissionDownloadUrlQuery__
 *
 * To run a query within a React component, call `useErpHomeworkSubmissionDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpHomeworkSubmissionDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpHomeworkSubmissionDownloadUrlQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useErpHomeworkSubmissionDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<ErpHomeworkSubmissionDownloadUrlQuery, ErpHomeworkSubmissionDownloadUrlQueryVariables>) {
        return Apollo.useQuery<ErpHomeworkSubmissionDownloadUrlQuery, ErpHomeworkSubmissionDownloadUrlQueryVariables>(ErpHomeworkSubmissionDownloadUrlDocument, baseOptions);
      }
export function useErpHomeworkSubmissionDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpHomeworkSubmissionDownloadUrlQuery, ErpHomeworkSubmissionDownloadUrlQueryVariables>) {
          return Apollo.useLazyQuery<ErpHomeworkSubmissionDownloadUrlQuery, ErpHomeworkSubmissionDownloadUrlQueryVariables>(ErpHomeworkSubmissionDownloadUrlDocument, baseOptions);
        }
export type ErpHomeworkSubmissionDownloadUrlQueryHookResult = ReturnType<typeof useErpHomeworkSubmissionDownloadUrlQuery>;
export type ErpHomeworkSubmissionDownloadUrlLazyQueryHookResult = ReturnType<typeof useErpHomeworkSubmissionDownloadUrlLazyQuery>;
export type ErpHomeworkSubmissionDownloadUrlQueryResult = Apollo.QueryResult<ErpHomeworkSubmissionDownloadUrlQuery, ErpHomeworkSubmissionDownloadUrlQueryVariables>;
export const ErpGroupHomeworkMarksDocument = gql`
    query ErpGroupHomeworkMarks($groupId: ID!) {
  groupHomeworkMarksForErp(groupId: $groupId) {
    lessonId
    studentId
    hwMark
    submitted
  }
}
    `;

/**
 * __useErpGroupHomeworkMarksQuery__
 *
 * To run a query within a React component, call `useErpGroupHomeworkMarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpGroupHomeworkMarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpGroupHomeworkMarksQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useErpGroupHomeworkMarksQuery(baseOptions: Apollo.QueryHookOptions<ErpGroupHomeworkMarksQuery, ErpGroupHomeworkMarksQueryVariables>) {
        return Apollo.useQuery<ErpGroupHomeworkMarksQuery, ErpGroupHomeworkMarksQueryVariables>(ErpGroupHomeworkMarksDocument, baseOptions);
      }
export function useErpGroupHomeworkMarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpGroupHomeworkMarksQuery, ErpGroupHomeworkMarksQueryVariables>) {
          return Apollo.useLazyQuery<ErpGroupHomeworkMarksQuery, ErpGroupHomeworkMarksQueryVariables>(ErpGroupHomeworkMarksDocument, baseOptions);
        }
export type ErpGroupHomeworkMarksQueryHookResult = ReturnType<typeof useErpGroupHomeworkMarksQuery>;
export type ErpGroupHomeworkMarksLazyQueryHookResult = ReturnType<typeof useErpGroupHomeworkMarksLazyQuery>;
export type ErpGroupHomeworkMarksQueryResult = Apollo.QueryResult<ErpGroupHomeworkMarksQuery, ErpGroupHomeworkMarksQueryVariables>;
export const PaginatedJournalsDocument = gql`
    query PaginatedJournals($query: String, $first: Int, $after: String, $withStaffFields: Boolean!) {
  allGroups(query: $query, first: $first, after: $after) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        name
        course {
          name
        }
        teachers @include(if: $withStaffFields) {
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __usePaginatedJournalsQuery__
 *
 * To run a query within a React component, call `usePaginatedJournalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedJournalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedJournalsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      withStaffFields: // value for 'withStaffFields'
 *   },
 * });
 */
export function usePaginatedJournalsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedJournalsQuery, PaginatedJournalsQueryVariables>) {
        return Apollo.useQuery<PaginatedJournalsQuery, PaginatedJournalsQueryVariables>(PaginatedJournalsDocument, baseOptions);
      }
export function usePaginatedJournalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedJournalsQuery, PaginatedJournalsQueryVariables>) {
          return Apollo.useLazyQuery<PaginatedJournalsQuery, PaginatedJournalsQueryVariables>(PaginatedJournalsDocument, baseOptions);
        }
export type PaginatedJournalsQueryHookResult = ReturnType<typeof usePaginatedJournalsQuery>;
export type PaginatedJournalsLazyQueryHookResult = ReturnType<typeof usePaginatedJournalsLazyQuery>;
export type PaginatedJournalsQueryResult = Apollo.QueryResult<PaginatedJournalsQuery, PaginatedJournalsQueryVariables>;
export const PaginatedJournalDocument = gql`
    query PaginatedJournal($groupId: ID!) {
  journal(groupId: $groupId) {
    id
    groupName
    comment
    edges {
      node {
        id
        date
        lessonNumber
        whiteboardId
      }
    }
  }
}
    `;

/**
 * __usePaginatedJournalQuery__
 *
 * To run a query within a React component, call `usePaginatedJournalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedJournalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedJournalQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function usePaginatedJournalQuery(baseOptions: Apollo.QueryHookOptions<PaginatedJournalQuery, PaginatedJournalQueryVariables>) {
        return Apollo.useQuery<PaginatedJournalQuery, PaginatedJournalQueryVariables>(PaginatedJournalDocument, baseOptions);
      }
export function usePaginatedJournalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedJournalQuery, PaginatedJournalQueryVariables>) {
          return Apollo.useLazyQuery<PaginatedJournalQuery, PaginatedJournalQueryVariables>(PaginatedJournalDocument, baseOptions);
        }
export type PaginatedJournalQueryHookResult = ReturnType<typeof usePaginatedJournalQuery>;
export type PaginatedJournalLazyQueryHookResult = ReturnType<typeof usePaginatedJournalLazyQuery>;
export type PaginatedJournalQueryResult = Apollo.QueryResult<PaginatedJournalQuery, PaginatedJournalQueryVariables>;
export const StudentsForJournalDocument = gql`
    query studentsForJournal($lessonsId: [Int]!, $first: Int, $after: String, $groupId: Int!) {
  studentsForJournal(
    lessonsId: $lessonsId
    first: $first
    after: $after
    groupId: $groupId
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        agreementIsActive
        user {
          id
          firstName
          lastName
          middleName
        }
        attendances {
          edges {
            node {
              id
              attendance
              source
              markedAt
              markedByName
              lesson {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStudentsForJournalQuery__
 *
 * To run a query within a React component, call `useStudentsForJournalQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsForJournalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsForJournalQuery({
 *   variables: {
 *      lessonsId: // value for 'lessonsId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useStudentsForJournalQuery(baseOptions: Apollo.QueryHookOptions<StudentsForJournalQuery, StudentsForJournalQueryVariables>) {
        return Apollo.useQuery<StudentsForJournalQuery, StudentsForJournalQueryVariables>(StudentsForJournalDocument, baseOptions);
      }
export function useStudentsForJournalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentsForJournalQuery, StudentsForJournalQueryVariables>) {
          return Apollo.useLazyQuery<StudentsForJournalQuery, StudentsForJournalQueryVariables>(StudentsForJournalDocument, baseOptions);
        }
export type StudentsForJournalQueryHookResult = ReturnType<typeof useStudentsForJournalQuery>;
export type StudentsForJournalLazyQueryHookResult = ReturnType<typeof useStudentsForJournalLazyQuery>;
export type StudentsForJournalQueryResult = Apollo.QueryResult<StudentsForJournalQuery, StudentsForJournalQueryVariables>;
export const LoadEditingJournalDocument = gql`
    query loadEditingJournal($groupId: ID!) {
  group(groupId: $groupId) {
    id
    comment
    classesDays {
      id
      weekDay
      startTime
      endTime
    }
    modules {
      id
      name
      lessons {
        edges {
          node {
            id
            name
            lessonNumber
            additional
            date
            lmsDescription
            teacherApplication {
              id
              teacher {
                fullName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLoadEditingJournalQuery__
 *
 * To run a query within a React component, call `useLoadEditingJournalQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadEditingJournalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadEditingJournalQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useLoadEditingJournalQuery(baseOptions: Apollo.QueryHookOptions<LoadEditingJournalQuery, LoadEditingJournalQueryVariables>) {
        return Apollo.useQuery<LoadEditingJournalQuery, LoadEditingJournalQueryVariables>(LoadEditingJournalDocument, baseOptions);
      }
export function useLoadEditingJournalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadEditingJournalQuery, LoadEditingJournalQueryVariables>) {
          return Apollo.useLazyQuery<LoadEditingJournalQuery, LoadEditingJournalQueryVariables>(LoadEditingJournalDocument, baseOptions);
        }
export type LoadEditingJournalQueryHookResult = ReturnType<typeof useLoadEditingJournalQuery>;
export type LoadEditingJournalLazyQueryHookResult = ReturnType<typeof useLoadEditingJournalLazyQuery>;
export type LoadEditingJournalQueryResult = Apollo.QueryResult<LoadEditingJournalQuery, LoadEditingJournalQueryVariables>;
export const LmsBlockSettingsViewDocument = gql`
    query LmsBlockSettingsView {
  lmsBlockSettings {
    robotEnabled
    overdueDays
    mailEnabled
    slackEnabled
    smsEnabled
    suspendedTemplateId
    suspendedTemplateName
    restoredTemplateId
    restoredTemplateName
    updatedAt
    updatedByName
    serverRobotAllowed
    serverMailAllowed
    serverSlackAllowed
    serverSmsAllowed
    canEdit
  }
}
    `;

/**
 * __useLmsBlockSettingsViewQuery__
 *
 * To run a query within a React component, call `useLmsBlockSettingsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsBlockSettingsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsBlockSettingsViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useLmsBlockSettingsViewQuery(baseOptions?: Apollo.QueryHookOptions<LmsBlockSettingsViewQuery, LmsBlockSettingsViewQueryVariables>) {
        return Apollo.useQuery<LmsBlockSettingsViewQuery, LmsBlockSettingsViewQueryVariables>(LmsBlockSettingsViewDocument, baseOptions);
      }
export function useLmsBlockSettingsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsBlockSettingsViewQuery, LmsBlockSettingsViewQueryVariables>) {
          return Apollo.useLazyQuery<LmsBlockSettingsViewQuery, LmsBlockSettingsViewQueryVariables>(LmsBlockSettingsViewDocument, baseOptions);
        }
export type LmsBlockSettingsViewQueryHookResult = ReturnType<typeof useLmsBlockSettingsViewQuery>;
export type LmsBlockSettingsViewLazyQueryHookResult = ReturnType<typeof useLmsBlockSettingsViewLazyQuery>;
export type LmsBlockSettingsViewQueryResult = Apollo.QueryResult<LmsBlockSettingsViewQuery, LmsBlockSettingsViewQueryVariables>;
export const LmsBlockTemplatePickerDocument = gql`
    query LmsBlockTemplatePicker {
  lmsBlockSendgridTemplates {
    success
    templates {
      id
      name
      subject
      versionId
      updatedAt
    }
    customErrors {
      field
      code
      message
    }
  }
}
    `;

/**
 * __useLmsBlockTemplatePickerQuery__
 *
 * To run a query within a React component, call `useLmsBlockTemplatePickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsBlockTemplatePickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsBlockTemplatePickerQuery({
 *   variables: {
 *   },
 * });
 */
export function useLmsBlockTemplatePickerQuery(baseOptions?: Apollo.QueryHookOptions<LmsBlockTemplatePickerQuery, LmsBlockTemplatePickerQueryVariables>) {
        return Apollo.useQuery<LmsBlockTemplatePickerQuery, LmsBlockTemplatePickerQueryVariables>(LmsBlockTemplatePickerDocument, baseOptions);
      }
export function useLmsBlockTemplatePickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsBlockTemplatePickerQuery, LmsBlockTemplatePickerQueryVariables>) {
          return Apollo.useLazyQuery<LmsBlockTemplatePickerQuery, LmsBlockTemplatePickerQueryVariables>(LmsBlockTemplatePickerDocument, baseOptions);
        }
export type LmsBlockTemplatePickerQueryHookResult = ReturnType<typeof useLmsBlockTemplatePickerQuery>;
export type LmsBlockTemplatePickerLazyQueryHookResult = ReturnType<typeof useLmsBlockTemplatePickerLazyQuery>;
export type LmsBlockTemplatePickerQueryResult = Apollo.QueryResult<LmsBlockTemplatePickerQuery, LmsBlockTemplatePickerQueryVariables>;
export const LmsBlockTemplateVariablesListDocument = gql`
    query LmsBlockTemplateVariablesList {
  lmsBlockTemplateVariables {
    name
    type
    descriptionPl
    descriptionRu
    example
    fields {
      name
      type
      descriptionPl
      descriptionRu
      example
    }
  }
}
    `;

/**
 * __useLmsBlockTemplateVariablesListQuery__
 *
 * To run a query within a React component, call `useLmsBlockTemplateVariablesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsBlockTemplateVariablesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsBlockTemplateVariablesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useLmsBlockTemplateVariablesListQuery(baseOptions?: Apollo.QueryHookOptions<LmsBlockTemplateVariablesListQuery, LmsBlockTemplateVariablesListQueryVariables>) {
        return Apollo.useQuery<LmsBlockTemplateVariablesListQuery, LmsBlockTemplateVariablesListQueryVariables>(LmsBlockTemplateVariablesListDocument, baseOptions);
      }
export function useLmsBlockTemplateVariablesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsBlockTemplateVariablesListQuery, LmsBlockTemplateVariablesListQueryVariables>) {
          return Apollo.useLazyQuery<LmsBlockTemplateVariablesListQuery, LmsBlockTemplateVariablesListQueryVariables>(LmsBlockTemplateVariablesListDocument, baseOptions);
        }
export type LmsBlockTemplateVariablesListQueryHookResult = ReturnType<typeof useLmsBlockTemplateVariablesListQuery>;
export type LmsBlockTemplateVariablesListLazyQueryHookResult = ReturnType<typeof useLmsBlockTemplateVariablesListLazyQuery>;
export type LmsBlockTemplateVariablesListQueryResult = Apollo.QueryResult<LmsBlockTemplateVariablesListQuery, LmsBlockTemplateVariablesListQueryVariables>;
export const LmsBlockTemplateExampleDataDocument = gql`
    query LmsBlockTemplateExampleData($kind: String!) {
  lmsBlockTemplateExample(kind: $kind)
}
    `;

/**
 * __useLmsBlockTemplateExampleDataQuery__
 *
 * To run a query within a React component, call `useLmsBlockTemplateExampleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsBlockTemplateExampleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsBlockTemplateExampleDataQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useLmsBlockTemplateExampleDataQuery(baseOptions: Apollo.QueryHookOptions<LmsBlockTemplateExampleDataQuery, LmsBlockTemplateExampleDataQueryVariables>) {
        return Apollo.useQuery<LmsBlockTemplateExampleDataQuery, LmsBlockTemplateExampleDataQueryVariables>(LmsBlockTemplateExampleDataDocument, baseOptions);
      }
export function useLmsBlockTemplateExampleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsBlockTemplateExampleDataQuery, LmsBlockTemplateExampleDataQueryVariables>) {
          return Apollo.useLazyQuery<LmsBlockTemplateExampleDataQuery, LmsBlockTemplateExampleDataQueryVariables>(LmsBlockTemplateExampleDataDocument, baseOptions);
        }
export type LmsBlockTemplateExampleDataQueryHookResult = ReturnType<typeof useLmsBlockTemplateExampleDataQuery>;
export type LmsBlockTemplateExampleDataLazyQueryHookResult = ReturnType<typeof useLmsBlockTemplateExampleDataLazyQuery>;
export type LmsBlockTemplateExampleDataQueryResult = Apollo.QueryResult<LmsBlockTemplateExampleDataQuery, LmsBlockTemplateExampleDataQueryVariables>;
export const MarketingOverviewReportDocument = gql`
    query MarketingOverviewReport($filter: MarketingFilter!, $granularity: MarketingGranularity, $compare: MarketingCompare) {
  marketingOverview(filter: $filter, granularity: $granularity, compare: $compare) {
    current {
      ...MarketingMetricsFields
    }
    previous {
      ...MarketingMetricsFields
    }
    compareInfo {
      ...MarketingCompareInfoFields
    }
    coverage {
      spendComplete
      missingSpendDays
      provisionalFrom
    }
    series {
      period
      dateFrom
      dateTo
      metrics {
        ...MarketingMetricsFields
      }
      previous {
        ...MarketingMetricsFields
      }
      previousPeriod
      previousDateFrom
      previousDateTo
    }
    channels {
      channel
      metrics {
        ...MarketingMetricsFields
      }
    }
    sources {
      ...MarketingSourceStatusFields
    }
    dataVersion
    planFact {
      metric
      target
      fact
      pace
    }
    leadHistoryFrom
  }
}
    ${MarketingMetricsFieldsFragmentDoc}
${MarketingCompareInfoFieldsFragmentDoc}
${MarketingSourceStatusFieldsFragmentDoc}`;

/**
 * __useMarketingOverviewReportQuery__
 *
 * To run a query within a React component, call `useMarketingOverviewReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingOverviewReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingOverviewReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      granularity: // value for 'granularity'
 *      compare: // value for 'compare'
 *   },
 * });
 */
export function useMarketingOverviewReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingOverviewReportQuery, MarketingOverviewReportQueryVariables>) {
        return Apollo.useQuery<MarketingOverviewReportQuery, MarketingOverviewReportQueryVariables>(MarketingOverviewReportDocument, baseOptions);
      }
export function useMarketingOverviewReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingOverviewReportQuery, MarketingOverviewReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingOverviewReportQuery, MarketingOverviewReportQueryVariables>(MarketingOverviewReportDocument, baseOptions);
        }
export type MarketingOverviewReportQueryHookResult = ReturnType<typeof useMarketingOverviewReportQuery>;
export type MarketingOverviewReportLazyQueryHookResult = ReturnType<typeof useMarketingOverviewReportLazyQuery>;
export type MarketingOverviewReportQueryResult = Apollo.QueryResult<MarketingOverviewReportQuery, MarketingOverviewReportQueryVariables>;
export const MarketingDataVersionProbeDocument = gql`
    query MarketingDataVersionProbe($filter: MarketingFilter!) {
  marketingOverview(filter: $filter) {
    dataVersion
  }
}
    `;

/**
 * __useMarketingDataVersionProbeQuery__
 *
 * To run a query within a React component, call `useMarketingDataVersionProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingDataVersionProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingDataVersionProbeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingDataVersionProbeQuery(baseOptions: Apollo.QueryHookOptions<MarketingDataVersionProbeQuery, MarketingDataVersionProbeQueryVariables>) {
        return Apollo.useQuery<MarketingDataVersionProbeQuery, MarketingDataVersionProbeQueryVariables>(MarketingDataVersionProbeDocument, baseOptions);
      }
export function useMarketingDataVersionProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingDataVersionProbeQuery, MarketingDataVersionProbeQueryVariables>) {
          return Apollo.useLazyQuery<MarketingDataVersionProbeQuery, MarketingDataVersionProbeQueryVariables>(MarketingDataVersionProbeDocument, baseOptions);
        }
export type MarketingDataVersionProbeQueryHookResult = ReturnType<typeof useMarketingDataVersionProbeQuery>;
export type MarketingDataVersionProbeLazyQueryHookResult = ReturnType<typeof useMarketingDataVersionProbeLazyQuery>;
export type MarketingDataVersionProbeQueryResult = Apollo.QueryResult<MarketingDataVersionProbeQuery, MarketingDataVersionProbeQueryVariables>;
export const MarketingBreakdownReportDocument = gql`
    query MarketingBreakdownReport($filter: MarketingFilter!, $dimension: MarketingDimension!, $parentKey: String, $withSeries: Boolean, $granularity: MarketingGranularity, $limit: Int, $offset: Int, $orderBy: String, $compare: MarketingCompare, $includeVanished: Boolean, $having: [MarketingRowPredicate!], $minSpendPln: Decimal, $minCrmLeads: Int) {
  marketingBreakdown(
    filter: $filter
    dimension: $dimension
    parentKey: $parentKey
    withSeries: $withSeries
    granularity: $granularity
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    compare: $compare
    includeVanished: $includeVanished
    having: $having
    minSpendPln: $minSpendPln
    minCrmLeads: $minCrmLeads
  ) {
    dimension
    totalCount
    crumbs {
      id
      name
    }
    total {
      ...MarketingMetricsFields
    }
    predicateCounts {
      value
      count
    }
    compareInfo {
      ...MarketingCompareInfoFields
    }
    rows {
      key
      label
      platform
      status
      format
      thumbnailUrl
      salesCoverage
      metrics {
        ...MarketingMetricsFields
      }
      previous {
        ...MarketingMetricsFields
      }
      series {
        period
        dateFrom
        dateTo
        metrics {
          ...MarketingMetricsFields
        }
      }
    }
  }
}
    ${MarketingMetricsFieldsFragmentDoc}
${MarketingCompareInfoFieldsFragmentDoc}`;

/**
 * __useMarketingBreakdownReportQuery__
 *
 * To run a query within a React component, call `useMarketingBreakdownReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingBreakdownReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingBreakdownReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      dimension: // value for 'dimension'
 *      parentKey: // value for 'parentKey'
 *      withSeries: // value for 'withSeries'
 *      granularity: // value for 'granularity'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      compare: // value for 'compare'
 *      includeVanished: // value for 'includeVanished'
 *      having: // value for 'having'
 *      minSpendPln: // value for 'minSpendPln'
 *      minCrmLeads: // value for 'minCrmLeads'
 *   },
 * });
 */
export function useMarketingBreakdownReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingBreakdownReportQuery, MarketingBreakdownReportQueryVariables>) {
        return Apollo.useQuery<MarketingBreakdownReportQuery, MarketingBreakdownReportQueryVariables>(MarketingBreakdownReportDocument, baseOptions);
      }
export function useMarketingBreakdownReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingBreakdownReportQuery, MarketingBreakdownReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingBreakdownReportQuery, MarketingBreakdownReportQueryVariables>(MarketingBreakdownReportDocument, baseOptions);
        }
export type MarketingBreakdownReportQueryHookResult = ReturnType<typeof useMarketingBreakdownReportQuery>;
export type MarketingBreakdownReportLazyQueryHookResult = ReturnType<typeof useMarketingBreakdownReportLazyQuery>;
export type MarketingBreakdownReportQueryResult = Apollo.QueryResult<MarketingBreakdownReportQuery, MarketingBreakdownReportQueryVariables>;
export const MarketingMatrixReportDocument = gql`
    query MarketingMatrixReport($filter: MarketingFilter!, $rows: MarketingDimension, $cols: MarketingDimension, $limit: Int, $orderBy: String) {
  marketingMatrix(
    filter: $filter
    rows: $rows
    cols: $cols
    limit: $limit
    orderBy: $orderBy
  ) {
    rowKey
    rowLabel
    colKey
    colLabel
    metrics {
      ...MarketingMetricsFields
    }
  }
}
    ${MarketingMetricsFieldsFragmentDoc}`;

/**
 * __useMarketingMatrixReportQuery__
 *
 * To run a query within a React component, call `useMarketingMatrixReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingMatrixReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingMatrixReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      rows: // value for 'rows'
 *      cols: // value for 'cols'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMarketingMatrixReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingMatrixReportQuery, MarketingMatrixReportQueryVariables>) {
        return Apollo.useQuery<MarketingMatrixReportQuery, MarketingMatrixReportQueryVariables>(MarketingMatrixReportDocument, baseOptions);
      }
export function useMarketingMatrixReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingMatrixReportQuery, MarketingMatrixReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingMatrixReportQuery, MarketingMatrixReportQueryVariables>(MarketingMatrixReportDocument, baseOptions);
        }
export type MarketingMatrixReportQueryHookResult = ReturnType<typeof useMarketingMatrixReportQuery>;
export type MarketingMatrixReportLazyQueryHookResult = ReturnType<typeof useMarketingMatrixReportLazyQuery>;
export type MarketingMatrixReportQueryResult = Apollo.QueryResult<MarketingMatrixReportQuery, MarketingMatrixReportQueryVariables>;
export const MarketingSeriesReportDocument = gql`
    query MarketingSeriesReport($filter: MarketingFilter!, $granularity: MarketingGranularity, $compare: MarketingCompare) {
  marketingSeries(filter: $filter, granularity: $granularity, compare: $compare) {
    period
    dateFrom
    dateTo
    metrics {
      ...MarketingMetricsFields
    }
    previous {
      ...MarketingMetricsFields
    }
    previousPeriod
    previousDateFrom
    previousDateTo
  }
}
    ${MarketingMetricsFieldsFragmentDoc}`;

/**
 * __useMarketingSeriesReportQuery__
 *
 * To run a query within a React component, call `useMarketingSeriesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeriesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeriesReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      granularity: // value for 'granularity'
 *      compare: // value for 'compare'
 *   },
 * });
 */
export function useMarketingSeriesReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingSeriesReportQuery, MarketingSeriesReportQueryVariables>) {
        return Apollo.useQuery<MarketingSeriesReportQuery, MarketingSeriesReportQueryVariables>(MarketingSeriesReportDocument, baseOptions);
      }
export function useMarketingSeriesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeriesReportQuery, MarketingSeriesReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeriesReportQuery, MarketingSeriesReportQueryVariables>(MarketingSeriesReportDocument, baseOptions);
        }
export type MarketingSeriesReportQueryHookResult = ReturnType<typeof useMarketingSeriesReportQuery>;
export type MarketingSeriesReportLazyQueryHookResult = ReturnType<typeof useMarketingSeriesReportLazyQuery>;
export type MarketingSeriesReportQueryResult = Apollo.QueryResult<MarketingSeriesReportQuery, MarketingSeriesReportQueryVariables>;
export const MarketingSalesReportDocument = gql`
    query MarketingSalesReport($filter: MarketingFilter!, $onlySales: Boolean, $coverage: String, $limit: Int, $offset: Int) {
  marketingSales(
    filter: $filter
    onlySales: $onlySales
    coverage: $coverage
    limit: $limit
    offset: $offset
  ) {
    totalCount
    rows {
      id
      source
      sourceId
      day
      kind
      isSale
      saleReason
      familySlug
      familyName
      pricePln
      cashPln
      emailMasked
      leadKommoId
      coverage
      lastChannel
      lastCampaign
      lastAd
      firstChannel
      leadToSaleDays
      touches {
        at
        pipelineKind
        channel
        campaign
        ad
        matchRule
        isFirst
        isLast
      }
    }
  }
}
    `;

/**
 * __useMarketingSalesReportQuery__
 *
 * To run a query within a React component, call `useMarketingSalesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSalesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSalesReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      onlySales: // value for 'onlySales'
 *      coverage: // value for 'coverage'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMarketingSalesReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingSalesReportQuery, MarketingSalesReportQueryVariables>) {
        return Apollo.useQuery<MarketingSalesReportQuery, MarketingSalesReportQueryVariables>(MarketingSalesReportDocument, baseOptions);
      }
export function useMarketingSalesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSalesReportQuery, MarketingSalesReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSalesReportQuery, MarketingSalesReportQueryVariables>(MarketingSalesReportDocument, baseOptions);
        }
export type MarketingSalesReportQueryHookResult = ReturnType<typeof useMarketingSalesReportQuery>;
export type MarketingSalesReportLazyQueryHookResult = ReturnType<typeof useMarketingSalesReportLazyQuery>;
export type MarketingSalesReportQueryResult = Apollo.QueryResult<MarketingSalesReportQuery, MarketingSalesReportQueryVariables>;
export const MarketingSaleByIdDocument = gql`
    query MarketingSaleById($id: Int!) {
  marketingSale(id: $id) {
    id
    source
    sourceId
    day
    kind
    isSale
    saleReason
    familySlug
    familyName
    pricePln
    cashPln
    emailMasked
    leadKommoId
    coverage
    lastChannel
    lastCampaign
    lastAd
    firstChannel
    leadToSaleDays
    touches {
      at
      pipelineKind
      channel
      campaign
      ad
      matchRule
      isFirst
      isLast
    }
  }
}
    `;

/**
 * __useMarketingSaleByIdQuery__
 *
 * To run a query within a React component, call `useMarketingSaleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSaleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSaleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketingSaleByIdQuery(baseOptions: Apollo.QueryHookOptions<MarketingSaleByIdQuery, MarketingSaleByIdQueryVariables>) {
        return Apollo.useQuery<MarketingSaleByIdQuery, MarketingSaleByIdQueryVariables>(MarketingSaleByIdDocument, baseOptions);
      }
export function useMarketingSaleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSaleByIdQuery, MarketingSaleByIdQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSaleByIdQuery, MarketingSaleByIdQueryVariables>(MarketingSaleByIdDocument, baseOptions);
        }
export type MarketingSaleByIdQueryHookResult = ReturnType<typeof useMarketingSaleByIdQuery>;
export type MarketingSaleByIdLazyQueryHookResult = ReturnType<typeof useMarketingSaleByIdLazyQuery>;
export type MarketingSaleByIdQueryResult = Apollo.QueryResult<MarketingSaleByIdQuery, MarketingSaleByIdQueryVariables>;
export const MarketingDataQualityReportDocument = gql`
    query MarketingDataQualityReport($filter: MarketingFilter!) {
  marketingDataQuality(filter: $filter) {
    salesCoverage {
      level
      count
    }
    metaPlatformLeads
    metaCrmLeads
    metaTouchesAll
    crmLeadsBySource {
      value
      count
    }
    crmLeadsWithoutCourse
    crmLeadsTotal
    salesUnknownCourseRepeats
    unmappedSources {
      field
      value
      count
      platform
      familyMissing
      campaignMissing
    }
    unmappedCampaigns {
      field
      value
      count
      platform
      familyMissing
      campaignMissing
    }
    accountReconciliation {
      platform
      day
      campaignSum
      accountTotal
      diffPct
    }
    sources {
      ...MarketingSourceStatusFields
    }
    siteTracking {
      enabled
      collectingSince
      lastAcceptedAt
      days
      accepted
      events
      dropped {
        value
        count
      }
      queue
      leads
      linkedLeads
      linkedLeadShare
    }
  }
}
    ${MarketingSourceStatusFieldsFragmentDoc}`;

/**
 * __useMarketingDataQualityReportQuery__
 *
 * To run a query within a React component, call `useMarketingDataQualityReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingDataQualityReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingDataQualityReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingDataQualityReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingDataQualityReportQuery, MarketingDataQualityReportQueryVariables>) {
        return Apollo.useQuery<MarketingDataQualityReportQuery, MarketingDataQualityReportQueryVariables>(MarketingDataQualityReportDocument, baseOptions);
      }
export function useMarketingDataQualityReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingDataQualityReportQuery, MarketingDataQualityReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingDataQualityReportQuery, MarketingDataQualityReportQueryVariables>(MarketingDataQualityReportDocument, baseOptions);
        }
export type MarketingDataQualityReportQueryHookResult = ReturnType<typeof useMarketingDataQualityReportQuery>;
export type MarketingDataQualityReportLazyQueryHookResult = ReturnType<typeof useMarketingDataQualityReportLazyQuery>;
export type MarketingDataQualityReportQueryResult = Apollo.QueryResult<MarketingDataQualityReportQuery, MarketingDataQualityReportQueryVariables>;
export const MarketingSourcesStatusDocument = gql`
    query MarketingSourcesStatus {
  marketingSources {
    ...MarketingSourceStatusFields
  }
}
    ${MarketingSourceStatusFieldsFragmentDoc}`;

/**
 * __useMarketingSourcesStatusQuery__
 *
 * To run a query within a React component, call `useMarketingSourcesStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSourcesStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSourcesStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketingSourcesStatusQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSourcesStatusQuery, MarketingSourcesStatusQueryVariables>) {
        return Apollo.useQuery<MarketingSourcesStatusQuery, MarketingSourcesStatusQueryVariables>(MarketingSourcesStatusDocument, baseOptions);
      }
export function useMarketingSourcesStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSourcesStatusQuery, MarketingSourcesStatusQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSourcesStatusQuery, MarketingSourcesStatusQueryVariables>(MarketingSourcesStatusDocument, baseOptions);
        }
export type MarketingSourcesStatusQueryHookResult = ReturnType<typeof useMarketingSourcesStatusQuery>;
export type MarketingSourcesStatusLazyQueryHookResult = ReturnType<typeof useMarketingSourcesStatusLazyQuery>;
export type MarketingSourcesStatusQueryResult = Apollo.QueryResult<MarketingSourcesStatusQuery, MarketingSourcesStatusQueryVariables>;
export const MarketingOfflineConversionsReportDocument = gql`
    query MarketingOfflineConversionsReport($limit: Int) {
  marketingOfflineConversions(limit: $limit) {
    enabled
    googleEnabled
    metaEnabled
    retractEnabled
    since
    lastRun {
      status
      startedAt
      finishedAt
      errorMessage
      stats
    }
    counts7d {
      platform
      event
      status
      count
    }
    counts30d {
      platform
      event
      status
      count
    }
    issues {
      id
      platform
      event
      status
      errorCode
      eventTime
      updatedAt
      saleId
      source
      sourceId
    }
  }
}
    `;

/**
 * __useMarketingOfflineConversionsReportQuery__
 *
 * To run a query within a React component, call `useMarketingOfflineConversionsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingOfflineConversionsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingOfflineConversionsReportQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketingOfflineConversionsReportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingOfflineConversionsReportQuery, MarketingOfflineConversionsReportQueryVariables>) {
        return Apollo.useQuery<MarketingOfflineConversionsReportQuery, MarketingOfflineConversionsReportQueryVariables>(MarketingOfflineConversionsReportDocument, baseOptions);
      }
export function useMarketingOfflineConversionsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingOfflineConversionsReportQuery, MarketingOfflineConversionsReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingOfflineConversionsReportQuery, MarketingOfflineConversionsReportQueryVariables>(MarketingOfflineConversionsReportDocument, baseOptions);
        }
export type MarketingOfflineConversionsReportQueryHookResult = ReturnType<typeof useMarketingOfflineConversionsReportQuery>;
export type MarketingOfflineConversionsReportLazyQueryHookResult = ReturnType<typeof useMarketingOfflineConversionsReportLazyQuery>;
export type MarketingOfflineConversionsReportQueryResult = Apollo.QueryResult<MarketingOfflineConversionsReportQuery, MarketingOfflineConversionsReportQueryVariables>;
export const MarketingTaxonomyReportDocument = gql`
    query MarketingTaxonomyReport {
  marketingTaxonomy {
    channelRules {
      ...MarketingChannelRuleFields
    }
    families {
      id
      slug
      name
      isSold
      sort
      aliases {
        ...MarketingCourseAliasFields
      }
    }
    offerRules {
      ...MarketingOfferRuleFields
    }
    pipelines {
      ...MarketingPipelineFields
    }
    legalEntities {
      id
      name
    }
    courses {
      id
      name
    }
    campaignAliases {
      ...MarketingCampaignAliasFields
    }
    brandRegex
    ga4KeyEvents
    siteHosts
    signalRouting {
      kinds
      minSeverity
      assigneeIds
    }
    staffOptions {
      id
      name
    }
    pageTypeRules {
      type
      regex
    }
    pageTypes
  }
}
    ${MarketingChannelRuleFieldsFragmentDoc}
${MarketingCourseAliasFieldsFragmentDoc}
${MarketingOfferRuleFieldsFragmentDoc}
${MarketingPipelineFieldsFragmentDoc}
${MarketingCampaignAliasFieldsFragmentDoc}`;

/**
 * __useMarketingTaxonomyReportQuery__
 *
 * To run a query within a React component, call `useMarketingTaxonomyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingTaxonomyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingTaxonomyReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketingTaxonomyReportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingTaxonomyReportQuery, MarketingTaxonomyReportQueryVariables>) {
        return Apollo.useQuery<MarketingTaxonomyReportQuery, MarketingTaxonomyReportQueryVariables>(MarketingTaxonomyReportDocument, baseOptions);
      }
export function useMarketingTaxonomyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingTaxonomyReportQuery, MarketingTaxonomyReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingTaxonomyReportQuery, MarketingTaxonomyReportQueryVariables>(MarketingTaxonomyReportDocument, baseOptions);
        }
export type MarketingTaxonomyReportQueryHookResult = ReturnType<typeof useMarketingTaxonomyReportQuery>;
export type MarketingTaxonomyReportLazyQueryHookResult = ReturnType<typeof useMarketingTaxonomyReportLazyQuery>;
export type MarketingTaxonomyReportQueryResult = Apollo.QueryResult<MarketingTaxonomyReportQuery, MarketingTaxonomyReportQueryVariables>;
export const MarketingCreativesReportDocument = gql`
    query MarketingCreativesReport($filter: MarketingFilter!, $fatigueOnly: Boolean, $format: String, $withSeries: Boolean, $orderBy: String, $limit: Int, $offset: Int, $adIds: [ID!], $compare: MarketingCompare, $having: [MarketingRowPredicate!], $minSpendPln: Decimal, $minCrmLeads: Int, $groupBy: String, $search: String) {
  marketingCreatives(
    filter: $filter
    fatigueOnly: $fatigueOnly
    format: $format
    withSeries: $withSeries
    orderBy: $orderBy
    limit: $limit
    offset: $offset
    adIds: $adIds
    compare: $compare
    having: $having
    minSpendPln: $minSpendPln
    minCrmLeads: $minCrmLeads
    groupBy: $groupBy
    search: $search
  ) {
    totalCount
    predicateCounts {
      value
      count
    }
    compareInfo {
      ...MarketingCompareInfoFields
    }
    groups {
      key
      label
      ads
      metrics {
        ...MarketingMetricsFields
      }
    }
    rows {
      id
      platform
      externalId
      name
      level
      crmScope
      campaignId
      campaignName
      adsetName
      format
      thumbnailUrl
      title
      status
      firstDay
      ageDays
      familySlug
      offer
      metrics {
        ...MarketingMetricsFields
      }
      previous {
        ...MarketingMetricsFields
      }
      frequency
      reach28d
      hookRate
      holdRate
      cplPlatformPln
      conversionsPlatform
      fatigue {
        flagged
        reasons
        ctr7d
        ctrBase
        ctrStart
        ctrPrev
        frequency28d
        cpm7d
        cpmPrev
        cpmChangePct
        cpl7d
        cplMedian
        cplRatio
        hookRate
        hookPrev
        holdRate
        holdPrev
      }
      series {
        period
        metrics {
          ...MarketingMetricsFields
        }
      }
    }
    formats {
      format
      familySlug
      offer
      ads
      hookRate
      metrics {
        ...MarketingMetricsFields
      }
    }
  }
}
    ${MarketingCompareInfoFieldsFragmentDoc}
${MarketingMetricsFieldsFragmentDoc}`;

/**
 * __useMarketingCreativesReportQuery__
 *
 * To run a query within a React component, call `useMarketingCreativesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingCreativesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingCreativesReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      fatigueOnly: // value for 'fatigueOnly'
 *      format: // value for 'format'
 *      withSeries: // value for 'withSeries'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      adIds: // value for 'adIds'
 *      compare: // value for 'compare'
 *      having: // value for 'having'
 *      minSpendPln: // value for 'minSpendPln'
 *      minCrmLeads: // value for 'minCrmLeads'
 *      groupBy: // value for 'groupBy'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMarketingCreativesReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingCreativesReportQuery, MarketingCreativesReportQueryVariables>) {
        return Apollo.useQuery<MarketingCreativesReportQuery, MarketingCreativesReportQueryVariables>(MarketingCreativesReportDocument, baseOptions);
      }
export function useMarketingCreativesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingCreativesReportQuery, MarketingCreativesReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingCreativesReportQuery, MarketingCreativesReportQueryVariables>(MarketingCreativesReportDocument, baseOptions);
        }
export type MarketingCreativesReportQueryHookResult = ReturnType<typeof useMarketingCreativesReportQuery>;
export type MarketingCreativesReportLazyQueryHookResult = ReturnType<typeof useMarketingCreativesReportLazyQuery>;
export type MarketingCreativesReportQueryResult = Apollo.QueryResult<MarketingCreativesReportQuery, MarketingCreativesReportQueryVariables>;
export const MarketingAdChoicesDocument = gql`
    query MarketingAdChoices($filter: MarketingFilter!, $search: String, $limit: Int) {
  marketingCreatives(
    filter: $filter
    search: $search
    limit: $limit
    orderBy: "-spendPln"
  ) {
    rows {
      id
      name
      platform
      campaignName
      thumbnailUrl
    }
  }
}
    `;

/**
 * __useMarketingAdChoicesQuery__
 *
 * To run a query within a React component, call `useMarketingAdChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingAdChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingAdChoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketingAdChoicesQuery(baseOptions: Apollo.QueryHookOptions<MarketingAdChoicesQuery, MarketingAdChoicesQueryVariables>) {
        return Apollo.useQuery<MarketingAdChoicesQuery, MarketingAdChoicesQueryVariables>(MarketingAdChoicesDocument, baseOptions);
      }
export function useMarketingAdChoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingAdChoicesQuery, MarketingAdChoicesQueryVariables>) {
          return Apollo.useLazyQuery<MarketingAdChoicesQuery, MarketingAdChoicesQueryVariables>(MarketingAdChoicesDocument, baseOptions);
        }
export type MarketingAdChoicesQueryHookResult = ReturnType<typeof useMarketingAdChoicesQuery>;
export type MarketingAdChoicesLazyQueryHookResult = ReturnType<typeof useMarketingAdChoicesLazyQuery>;
export type MarketingAdChoicesQueryResult = Apollo.QueryResult<MarketingAdChoicesQuery, MarketingAdChoicesQueryVariables>;
export const MarketingCohortsReportDocument = gql`
    query MarketingCohortsReport($filter: MarketingFilter!, $pathKind: String, $granularity: MarketingGranularity, $splitBy: String) {
  marketingCohorts(
    filter: $filter
    pathKind: $pathKind
    granularity: $granularity
    splitBy: $splitBy
  ) {
    cohort
    dateFrom
    dateTo
    split
    splitLabel
    leads
    sales7
    sales14
    sales30
    sales60
    sales90
    revenue90Pln
    mature7
    mature14
    mature30
    mature60
    mature90
  }
}
    `;

/**
 * __useMarketingCohortsReportQuery__
 *
 * To run a query within a React component, call `useMarketingCohortsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingCohortsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingCohortsReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pathKind: // value for 'pathKind'
 *      granularity: // value for 'granularity'
 *      splitBy: // value for 'splitBy'
 *   },
 * });
 */
export function useMarketingCohortsReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingCohortsReportQuery, MarketingCohortsReportQueryVariables>) {
        return Apollo.useQuery<MarketingCohortsReportQuery, MarketingCohortsReportQueryVariables>(MarketingCohortsReportDocument, baseOptions);
      }
export function useMarketingCohortsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingCohortsReportQuery, MarketingCohortsReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingCohortsReportQuery, MarketingCohortsReportQueryVariables>(MarketingCohortsReportDocument, baseOptions);
        }
export type MarketingCohortsReportQueryHookResult = ReturnType<typeof useMarketingCohortsReportQuery>;
export type MarketingCohortsReportLazyQueryHookResult = ReturnType<typeof useMarketingCohortsReportLazyQuery>;
export type MarketingCohortsReportQueryResult = Apollo.QueryResult<MarketingCohortsReportQuery, MarketingCohortsReportQueryVariables>;
export const MarketingLeadDynamicsReportDocument = gql`
    query MarketingLeadDynamicsReport($filter: MarketingFilter!, $granularity: MarketingGranularity, $compare: MarketingCompare, $groupBy: String, $top: Int) {
  marketingLeadDynamics(
    filter: $filter
    granularity: $granularity
    compare: $compare
    groupBy: $groupBy
    top: $top
  ) {
    granularity
    groupBy
    groups {
      key
      label
      crmLeads
      crmLeadsRepeat
      sales
      revenuePln
    }
    points {
      period
      dateFrom
      dateTo
      crmLeads
      crmLeadsRepeat
      sales
      revenuePln
      groups {
        key
        crmLeads
        crmLeadsRepeat
        sales
        revenuePln
      }
      previousPeriod
      previousDateFrom
      previousDateTo
      previousCrmLeads
      previousCrmLeadsRepeat
      previousSales
      previousRevenuePln
    }
    totals {
      crmLeads
      crmLeadsRepeat
      sales
      revenuePln
      previous {
        crmLeads
        crmLeadsRepeat
        sales
        revenuePln
      }
    }
    compareInfo {
      ...MarketingCompareInfoFields
    }
  }
}
    ${MarketingCompareInfoFieldsFragmentDoc}`;

/**
 * __useMarketingLeadDynamicsReportQuery__
 *
 * To run a query within a React component, call `useMarketingLeadDynamicsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingLeadDynamicsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingLeadDynamicsReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      granularity: // value for 'granularity'
 *      compare: // value for 'compare'
 *      groupBy: // value for 'groupBy'
 *      top: // value for 'top'
 *   },
 * });
 */
export function useMarketingLeadDynamicsReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingLeadDynamicsReportQuery, MarketingLeadDynamicsReportQueryVariables>) {
        return Apollo.useQuery<MarketingLeadDynamicsReportQuery, MarketingLeadDynamicsReportQueryVariables>(MarketingLeadDynamicsReportDocument, baseOptions);
      }
export function useMarketingLeadDynamicsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingLeadDynamicsReportQuery, MarketingLeadDynamicsReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingLeadDynamicsReportQuery, MarketingLeadDynamicsReportQueryVariables>(MarketingLeadDynamicsReportDocument, baseOptions);
        }
export type MarketingLeadDynamicsReportQueryHookResult = ReturnType<typeof useMarketingLeadDynamicsReportQuery>;
export type MarketingLeadDynamicsReportLazyQueryHookResult = ReturnType<typeof useMarketingLeadDynamicsReportLazyQuery>;
export type MarketingLeadDynamicsReportQueryResult = Apollo.QueryResult<MarketingLeadDynamicsReportQuery, MarketingLeadDynamicsReportQueryVariables>;
export const MarketingPathCohortsReportDocument = gql`
    query MarketingPathCohortsReport($filter: MarketingFilter!, $groupBy: String) {
  marketingPathCohorts(filter: $filter, groupBy: $groupBy) {
    key
    leads
    sales7
    sales14
    sales30
    sales60
    sales90
    revenue90Pln
    conversion90
    matureShare
  }
}
    `;

/**
 * __useMarketingPathCohortsReportQuery__
 *
 * To run a query within a React component, call `useMarketingPathCohortsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingPathCohortsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingPathCohortsReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useMarketingPathCohortsReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingPathCohortsReportQuery, MarketingPathCohortsReportQueryVariables>) {
        return Apollo.useQuery<MarketingPathCohortsReportQuery, MarketingPathCohortsReportQueryVariables>(MarketingPathCohortsReportDocument, baseOptions);
      }
export function useMarketingPathCohortsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingPathCohortsReportQuery, MarketingPathCohortsReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingPathCohortsReportQuery, MarketingPathCohortsReportQueryVariables>(MarketingPathCohortsReportDocument, baseOptions);
        }
export type MarketingPathCohortsReportQueryHookResult = ReturnType<typeof useMarketingPathCohortsReportQuery>;
export type MarketingPathCohortsReportLazyQueryHookResult = ReturnType<typeof useMarketingPathCohortsReportLazyQuery>;
export type MarketingPathCohortsReportQueryResult = Apollo.QueryResult<MarketingPathCohortsReportQuery, MarketingPathCohortsReportQueryVariables>;
export const MarketingChannelOverlapReportDocument = gql`
    query MarketingChannelOverlapReport($filter: MarketingFilter!) {
  marketingChannelOverlap(filter: $filter) {
    row
    col
    leads
    sales
  }
}
    `;

/**
 * __useMarketingChannelOverlapReportQuery__
 *
 * To run a query within a React component, call `useMarketingChannelOverlapReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingChannelOverlapReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingChannelOverlapReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingChannelOverlapReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingChannelOverlapReportQuery, MarketingChannelOverlapReportQueryVariables>) {
        return Apollo.useQuery<MarketingChannelOverlapReportQuery, MarketingChannelOverlapReportQueryVariables>(MarketingChannelOverlapReportDocument, baseOptions);
      }
export function useMarketingChannelOverlapReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingChannelOverlapReportQuery, MarketingChannelOverlapReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingChannelOverlapReportQuery, MarketingChannelOverlapReportQueryVariables>(MarketingChannelOverlapReportDocument, baseOptions);
        }
export type MarketingChannelOverlapReportQueryHookResult = ReturnType<typeof useMarketingChannelOverlapReportQuery>;
export type MarketingChannelOverlapReportLazyQueryHookResult = ReturnType<typeof useMarketingChannelOverlapReportLazyQuery>;
export type MarketingChannelOverlapReportQueryResult = Apollo.QueryResult<MarketingChannelOverlapReportQuery, MarketingChannelOverlapReportQueryVariables>;
export const MarketingContractsReportDocument = gql`
    query MarketingContractsReport($filter: MarketingFilter!, $granularity: MarketingGranularity, $compare: MarketingCompare) {
  marketingContracts(
    filter: $filter
    granularity: $granularity
    compare: $compare
  ) {
    totals {
      sent
      opened
      signed
      pending
      lost
      signRate
      medianHoursToSign
      medianDaysLeadToContract
      previous {
        sent
        opened
        signed
        pending
        lost
        signRate
        medianHoursToSign
        medianDaysLeadToContract
      }
    }
    series {
      period
      dateFrom
      dateTo
      sent
      signed
      pending
      lost
      previous {
        sent
        signed
        pending
        lost
      }
      previousPeriod
    }
    timeToSign {
      key
      count
    }
    pendingAge {
      key
      count
    }
    byKind {
      kind
      sent
      signed
      pending
      lost
    }
    coverage {
      level
      count
    }
    unknownLegalEntity {
      sent
      signed
      pending
      lost
    }
    compareInfo {
      ...MarketingCompareInfoFields
    }
  }
}
    ${MarketingCompareInfoFieldsFragmentDoc}`;

/**
 * __useMarketingContractsReportQuery__
 *
 * To run a query within a React component, call `useMarketingContractsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingContractsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingContractsReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      granularity: // value for 'granularity'
 *      compare: // value for 'compare'
 *   },
 * });
 */
export function useMarketingContractsReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingContractsReportQuery, MarketingContractsReportQueryVariables>) {
        return Apollo.useQuery<MarketingContractsReportQuery, MarketingContractsReportQueryVariables>(MarketingContractsReportDocument, baseOptions);
      }
export function useMarketingContractsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingContractsReportQuery, MarketingContractsReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingContractsReportQuery, MarketingContractsReportQueryVariables>(MarketingContractsReportDocument, baseOptions);
        }
export type MarketingContractsReportQueryHookResult = ReturnType<typeof useMarketingContractsReportQuery>;
export type MarketingContractsReportLazyQueryHookResult = ReturnType<typeof useMarketingContractsReportLazyQuery>;
export type MarketingContractsReportQueryResult = Apollo.QueryResult<MarketingContractsReportQuery, MarketingContractsReportQueryVariables>;
export const MarketingActionsListDocument = gql`
    query MarketingActionsList($limit: Int) {
  marketingActions(limit: $limit) {
    id
    source
    kind
    severity
    titleKey
    params
    metrics
    valuePlnEst
    valueKind
    valueWindowDays
    familyValuePlnEst
    familyKeywords
    familySlug
    entityId
    entityName
    channel
    inspector
    link
    signalId
    windowFrom
    windowTo
    lastSeen
  }
}
    `;

/**
 * __useMarketingActionsListQuery__
 *
 * To run a query within a React component, call `useMarketingActionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingActionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingActionsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketingActionsListQuery(baseOptions?: Apollo.QueryHookOptions<MarketingActionsListQuery, MarketingActionsListQueryVariables>) {
        return Apollo.useQuery<MarketingActionsListQuery, MarketingActionsListQueryVariables>(MarketingActionsListDocument, baseOptions);
      }
export function useMarketingActionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingActionsListQuery, MarketingActionsListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingActionsListQuery, MarketingActionsListQueryVariables>(MarketingActionsListDocument, baseOptions);
        }
export type MarketingActionsListQueryHookResult = ReturnType<typeof useMarketingActionsListQuery>;
export type MarketingActionsListLazyQueryHookResult = ReturnType<typeof useMarketingActionsListLazyQuery>;
export type MarketingActionsListQueryResult = Apollo.QueryResult<MarketingActionsListQuery, MarketingActionsListQueryVariables>;
export const MarketingJourneyReportDocument = gql`
    query MarketingJourneyReport($filter: MarketingFilter!) {
  marketingJourney(filter: $filter) {
    indirect {
      pipelineKind
      people
      reachedMain
      buyers
    }
    withinMain {
      key
      people
      buyers
    }
    lagSales {
      key
      sales
    }
    speedToLead {
      key
      people
      buyers
    }
    historyFrom
    byDevice {
      device
      crmLeads
      crmLeadsRepeat
      sales
      revenuePln
      conversion
    }
  }
}
    `;

/**
 * __useMarketingJourneyReportQuery__
 *
 * To run a query within a React component, call `useMarketingJourneyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingJourneyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingJourneyReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingJourneyReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingJourneyReportQuery, MarketingJourneyReportQueryVariables>) {
        return Apollo.useQuery<MarketingJourneyReportQuery, MarketingJourneyReportQueryVariables>(MarketingJourneyReportDocument, baseOptions);
      }
export function useMarketingJourneyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingJourneyReportQuery, MarketingJourneyReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingJourneyReportQuery, MarketingJourneyReportQueryVariables>(MarketingJourneyReportDocument, baseOptions);
        }
export type MarketingJourneyReportQueryHookResult = ReturnType<typeof useMarketingJourneyReportQuery>;
export type MarketingJourneyReportLazyQueryHookResult = ReturnType<typeof useMarketingJourneyReportLazyQuery>;
export type MarketingJourneyReportQueryResult = Apollo.QueryResult<MarketingJourneyReportQuery, MarketingJourneyReportQueryVariables>;
export const MarketingTargetsListDocument = gql`
    query MarketingTargetsList($month: Date!) {
  marketingTargets(month: $month) {
    ...MarketingTargetFields
  }
}
    ${MarketingTargetFieldsFragmentDoc}`;

/**
 * __useMarketingTargetsListQuery__
 *
 * To run a query within a React component, call `useMarketingTargetsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingTargetsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingTargetsListQuery({
 *   variables: {
 *      month: // value for 'month'
 *   },
 * });
 */
export function useMarketingTargetsListQuery(baseOptions: Apollo.QueryHookOptions<MarketingTargetsListQuery, MarketingTargetsListQueryVariables>) {
        return Apollo.useQuery<MarketingTargetsListQuery, MarketingTargetsListQueryVariables>(MarketingTargetsListDocument, baseOptions);
      }
export function useMarketingTargetsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingTargetsListQuery, MarketingTargetsListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingTargetsListQuery, MarketingTargetsListQueryVariables>(MarketingTargetsListDocument, baseOptions);
        }
export type MarketingTargetsListQueryHookResult = ReturnType<typeof useMarketingTargetsListQuery>;
export type MarketingTargetsListLazyQueryHookResult = ReturnType<typeof useMarketingTargetsListLazyQuery>;
export type MarketingTargetsListQueryResult = Apollo.QueryResult<MarketingTargetsListQuery, MarketingTargetsListQueryVariables>;
export const MarketingSignalsFeedDocument = gql`
    query MarketingSignalsFeed($status: [String!], $kinds: [String!], $limit: Int) {
  marketingSignals(status: $status, kinds: $kinds, limit: $limit) {
    ...MarketingSignalFields
  }
}
    ${MarketingSignalFieldsFragmentDoc}`;

/**
 * __useMarketingSignalsFeedQuery__
 *
 * To run a query within a React component, call `useMarketingSignalsFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSignalsFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSignalsFeedQuery({
 *   variables: {
 *      status: // value for 'status'
 *      kinds: // value for 'kinds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketingSignalsFeedQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSignalsFeedQuery, MarketingSignalsFeedQueryVariables>) {
        return Apollo.useQuery<MarketingSignalsFeedQuery, MarketingSignalsFeedQueryVariables>(MarketingSignalsFeedDocument, baseOptions);
      }
export function useMarketingSignalsFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSignalsFeedQuery, MarketingSignalsFeedQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSignalsFeedQuery, MarketingSignalsFeedQueryVariables>(MarketingSignalsFeedDocument, baseOptions);
        }
export type MarketingSignalsFeedQueryHookResult = ReturnType<typeof useMarketingSignalsFeedQuery>;
export type MarketingSignalsFeedLazyQueryHookResult = ReturnType<typeof useMarketingSignalsFeedLazyQuery>;
export type MarketingSignalsFeedQueryResult = Apollo.QueryResult<MarketingSignalsFeedQuery, MarketingSignalsFeedQueryVariables>;
export const MarketingCampaignChoicesDocument = gql`
    query MarketingCampaignChoices($platform: String!, $search: String) {
  marketingCampaignOptions(platform: $platform, search: $search) {
    id
    name
  }
}
    `;

/**
 * __useMarketingCampaignChoicesQuery__
 *
 * To run a query within a React component, call `useMarketingCampaignChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingCampaignChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingCampaignChoicesQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMarketingCampaignChoicesQuery(baseOptions: Apollo.QueryHookOptions<MarketingCampaignChoicesQuery, MarketingCampaignChoicesQueryVariables>) {
        return Apollo.useQuery<MarketingCampaignChoicesQuery, MarketingCampaignChoicesQueryVariables>(MarketingCampaignChoicesDocument, baseOptions);
      }
export function useMarketingCampaignChoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingCampaignChoicesQuery, MarketingCampaignChoicesQueryVariables>) {
          return Apollo.useLazyQuery<MarketingCampaignChoicesQuery, MarketingCampaignChoicesQueryVariables>(MarketingCampaignChoicesDocument, baseOptions);
        }
export type MarketingCampaignChoicesQueryHookResult = ReturnType<typeof useMarketingCampaignChoicesQuery>;
export type MarketingCampaignChoicesLazyQueryHookResult = ReturnType<typeof useMarketingCampaignChoicesLazyQuery>;
export type MarketingCampaignChoicesQueryResult = Apollo.QueryResult<MarketingCampaignChoicesQuery, MarketingCampaignChoicesQueryVariables>;
export const MarketingSearchEngineReportDocument = gql`
    query MarketingSearchEngineReport($filter: MarketingFilter!, $engine: String, $dimension: String, $brand: Boolean, $zone: String, $familySlug: String, $search: String, $orderBy: String, $limit: Int, $offset: Int) {
  marketingSearch(
    filter: $filter
    engine: $engine
    dimension: $dimension
    brand: $brand
    zone: $zone
    familySlug: $familySlug
    search: $search
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    engine
    total {
      day
      clicks
      impressions
      position
    }
    series {
      day
      clicks
      impressions
      position
    }
    namedClicksShare
    zones {
      zone
      queries
      impressions
      clicks
    }
    rows {
      ...MarketingSearchRowFields
    }
    totalCount
    provisionalFrom
    snapshotDate
    includesSubdomains
    otherHosts
  }
}
    ${MarketingSearchRowFieldsFragmentDoc}`;

/**
 * __useMarketingSearchEngineReportQuery__
 *
 * To run a query within a React component, call `useMarketingSearchEngineReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSearchEngineReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSearchEngineReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      engine: // value for 'engine'
 *      dimension: // value for 'dimension'
 *      brand: // value for 'brand'
 *      zone: // value for 'zone'
 *      familySlug: // value for 'familySlug'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMarketingSearchEngineReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingSearchEngineReportQuery, MarketingSearchEngineReportQueryVariables>) {
        return Apollo.useQuery<MarketingSearchEngineReportQuery, MarketingSearchEngineReportQueryVariables>(MarketingSearchEngineReportDocument, baseOptions);
      }
export function useMarketingSearchEngineReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSearchEngineReportQuery, MarketingSearchEngineReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSearchEngineReportQuery, MarketingSearchEngineReportQueryVariables>(MarketingSearchEngineReportDocument, baseOptions);
        }
export type MarketingSearchEngineReportQueryHookResult = ReturnType<typeof useMarketingSearchEngineReportQuery>;
export type MarketingSearchEngineReportLazyQueryHookResult = ReturnType<typeof useMarketingSearchEngineReportLazyQuery>;
export type MarketingSearchEngineReportQueryResult = Apollo.QueryResult<MarketingSearchEngineReportQuery, MarketingSearchEngineReportQueryVariables>;
export const MarketingSearchTotalsProbeDocument = gql`
    query MarketingSearchTotalsProbe($filter: MarketingFilter!, $engine: String) {
  marketingSearch(filter: $filter, engine: $engine, limit: 1) {
    engine
    total {
      day
      clicks
      impressions
      position
    }
    series {
      day
    }
  }
}
    `;

/**
 * __useMarketingSearchTotalsProbeQuery__
 *
 * To run a query within a React component, call `useMarketingSearchTotalsProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSearchTotalsProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSearchTotalsProbeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      engine: // value for 'engine'
 *   },
 * });
 */
export function useMarketingSearchTotalsProbeQuery(baseOptions: Apollo.QueryHookOptions<MarketingSearchTotalsProbeQuery, MarketingSearchTotalsProbeQueryVariables>) {
        return Apollo.useQuery<MarketingSearchTotalsProbeQuery, MarketingSearchTotalsProbeQueryVariables>(MarketingSearchTotalsProbeDocument, baseOptions);
      }
export function useMarketingSearchTotalsProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSearchTotalsProbeQuery, MarketingSearchTotalsProbeQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSearchTotalsProbeQuery, MarketingSearchTotalsProbeQueryVariables>(MarketingSearchTotalsProbeDocument, baseOptions);
        }
export type MarketingSearchTotalsProbeQueryHookResult = ReturnType<typeof useMarketingSearchTotalsProbeQuery>;
export type MarketingSearchTotalsProbeLazyQueryHookResult = ReturnType<typeof useMarketingSearchTotalsProbeLazyQuery>;
export type MarketingSearchTotalsProbeQueryResult = Apollo.QueryResult<MarketingSearchTotalsProbeQuery, MarketingSearchTotalsProbeQueryVariables>;
export const MarketingSiteTrafficReportDocument = gql`
    query MarketingSiteTrafficReport($filter: MarketingFilter!, $groupBy: String) {
  marketingTraffic(filter: $filter, groupBy: $groupBy) {
    channelGroup
    source
    medium
    campaign
    sessions
    users
    engaged
    keyEvents
  }
}
    `;

/**
 * __useMarketingSiteTrafficReportQuery__
 *
 * To run a query within a React component, call `useMarketingSiteTrafficReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSiteTrafficReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSiteTrafficReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useMarketingSiteTrafficReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingSiteTrafficReportQuery, MarketingSiteTrafficReportQueryVariables>) {
        return Apollo.useQuery<MarketingSiteTrafficReportQuery, MarketingSiteTrafficReportQueryVariables>(MarketingSiteTrafficReportDocument, baseOptions);
      }
export function useMarketingSiteTrafficReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSiteTrafficReportQuery, MarketingSiteTrafficReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSiteTrafficReportQuery, MarketingSiteTrafficReportQueryVariables>(MarketingSiteTrafficReportDocument, baseOptions);
        }
export type MarketingSiteTrafficReportQueryHookResult = ReturnType<typeof useMarketingSiteTrafficReportQuery>;
export type MarketingSiteTrafficReportLazyQueryHookResult = ReturnType<typeof useMarketingSiteTrafficReportLazyQuery>;
export type MarketingSiteTrafficReportQueryResult = Apollo.QueryResult<MarketingSiteTrafficReportQuery, MarketingSiteTrafficReportQueryVariables>;
export const MarketingAiAssistantsReportDocument = gql`
    query MarketingAiAssistantsReport($filter: MarketingFilter!) {
  marketingAiReferrals(filter: $filter) {
    assistant
    landingPage
    sessions
    engaged
  }
}
    `;

/**
 * __useMarketingAiAssistantsReportQuery__
 *
 * To run a query within a React component, call `useMarketingAiAssistantsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingAiAssistantsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingAiAssistantsReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingAiAssistantsReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingAiAssistantsReportQuery, MarketingAiAssistantsReportQueryVariables>) {
        return Apollo.useQuery<MarketingAiAssistantsReportQuery, MarketingAiAssistantsReportQueryVariables>(MarketingAiAssistantsReportDocument, baseOptions);
      }
export function useMarketingAiAssistantsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingAiAssistantsReportQuery, MarketingAiAssistantsReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingAiAssistantsReportQuery, MarketingAiAssistantsReportQueryVariables>(MarketingAiAssistantsReportDocument, baseOptions);
        }
export type MarketingAiAssistantsReportQueryHookResult = ReturnType<typeof useMarketingAiAssistantsReportQuery>;
export type MarketingAiAssistantsReportLazyQueryHookResult = ReturnType<typeof useMarketingAiAssistantsReportLazyQuery>;
export type MarketingAiAssistantsReportQueryResult = Apollo.QueryResult<MarketingAiAssistantsReportQuery, MarketingAiAssistantsReportQueryVariables>;
export const MarketingSearchDemandReportDocument = gql`
    query MarketingSearchDemandReport($filter: MarketingFilter!) {
  marketingDemand(filter: $filter) {
    familySlug
    familyName
    isSold
    impressions
    prevImpressions
    clicks
    topQueries {
      ...MarketingSearchRowFields
    }
    crmLeads
    sales
    searchVolume
    volumeTrend
    volumeMonths
  }
}
    ${MarketingSearchRowFieldsFragmentDoc}`;

/**
 * __useMarketingSearchDemandReportQuery__
 *
 * To run a query within a React component, call `useMarketingSearchDemandReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSearchDemandReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSearchDemandReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingSearchDemandReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingSearchDemandReportQuery, MarketingSearchDemandReportQueryVariables>) {
        return Apollo.useQuery<MarketingSearchDemandReportQuery, MarketingSearchDemandReportQueryVariables>(MarketingSearchDemandReportDocument, baseOptions);
      }
export function useMarketingSearchDemandReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSearchDemandReportQuery, MarketingSearchDemandReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSearchDemandReportQuery, MarketingSearchDemandReportQueryVariables>(MarketingSearchDemandReportDocument, baseOptions);
        }
export type MarketingSearchDemandReportQueryHookResult = ReturnType<typeof useMarketingSearchDemandReportQuery>;
export type MarketingSearchDemandReportLazyQueryHookResult = ReturnType<typeof useMarketingSearchDemandReportLazyQuery>;
export type MarketingSearchDemandReportQueryResult = Apollo.QueryResult<MarketingSearchDemandReportQuery, MarketingSearchDemandReportQueryVariables>;
export const MarketingAdsSearchTermsReportDocument = gql`
    query MarketingAdsSearchTermsReport($filter: MarketingFilter!, $familySlug: String, $orderBy: String, $limit: Int, $offset: Int) {
  marketingSearchTerms(
    filter: $filter
    familySlug: $familySlug
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    totalCount
    coverageShare
    rows {
      term
      campaign
      adGroup
      impressions
      clicks
      spendPln
      conversions
      familySlug
    }
  }
}
    `;

/**
 * __useMarketingAdsSearchTermsReportQuery__
 *
 * To run a query within a React component, call `useMarketingAdsSearchTermsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingAdsSearchTermsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingAdsSearchTermsReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      familySlug: // value for 'familySlug'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMarketingAdsSearchTermsReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingAdsSearchTermsReportQuery, MarketingAdsSearchTermsReportQueryVariables>) {
        return Apollo.useQuery<MarketingAdsSearchTermsReportQuery, MarketingAdsSearchTermsReportQueryVariables>(MarketingAdsSearchTermsReportDocument, baseOptions);
      }
export function useMarketingAdsSearchTermsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingAdsSearchTermsReportQuery, MarketingAdsSearchTermsReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingAdsSearchTermsReportQuery, MarketingAdsSearchTermsReportQueryVariables>(MarketingAdsSearchTermsReportDocument, baseOptions);
        }
export type MarketingAdsSearchTermsReportQueryHookResult = ReturnType<typeof useMarketingAdsSearchTermsReportQuery>;
export type MarketingAdsSearchTermsReportLazyQueryHookResult = ReturnType<typeof useMarketingAdsSearchTermsReportLazyQuery>;
export type MarketingAdsSearchTermsReportQueryResult = Apollo.QueryResult<MarketingAdsSearchTermsReportQuery, MarketingAdsSearchTermsReportQueryVariables>;
export const MarketingSalesForecastReportDocument = gql`
    query MarketingSalesForecastReport($month: Date, $familySlug: String) {
  marketingForecast(month: $month, familySlug: $familySlug) {
    familySlug
    familyName
    month
    salesMtd
    p10
    p50
    p90
    target
    smallBase
    openLeads {
      stage
      leads
      probability
      basis
      observations
    }
    expectedNewLeads
    leadToSale
    daysLeft
    pace28d
    expectedFromOpenLeads
    expectedFromNewLeads
    groups {
      groupId
      name
      startDate
      seats
      enrolled
      expectedBeforeStart
      fillP50
      risk
    }
  }
}
    `;

/**
 * __useMarketingSalesForecastReportQuery__
 *
 * To run a query within a React component, call `useMarketingSalesForecastReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSalesForecastReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSalesForecastReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      familySlug: // value for 'familySlug'
 *   },
 * });
 */
export function useMarketingSalesForecastReportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSalesForecastReportQuery, MarketingSalesForecastReportQueryVariables>) {
        return Apollo.useQuery<MarketingSalesForecastReportQuery, MarketingSalesForecastReportQueryVariables>(MarketingSalesForecastReportDocument, baseOptions);
      }
export function useMarketingSalesForecastReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSalesForecastReportQuery, MarketingSalesForecastReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSalesForecastReportQuery, MarketingSalesForecastReportQueryVariables>(MarketingSalesForecastReportDocument, baseOptions);
        }
export type MarketingSalesForecastReportQueryHookResult = ReturnType<typeof useMarketingSalesForecastReportQuery>;
export type MarketingSalesForecastReportLazyQueryHookResult = ReturnType<typeof useMarketingSalesForecastReportLazyQuery>;
export type MarketingSalesForecastReportQueryResult = Apollo.QueryResult<MarketingSalesForecastReportQuery, MarketingSalesForecastReportQueryVariables>;
export const MarketingWeeklySnapshotsListDocument = gql`
    query MarketingWeeklySnapshotsList($limit: Int, $isoWeek: String) {
  marketingSnapshots(limit: $limit, isoWeek: $isoWeek) {
    id
    isoWeek
    dateFrom
    dateTo
    frozenAt
    dataVersion
    rebuiltCount
    summary
  }
}
    `;

/**
 * __useMarketingWeeklySnapshotsListQuery__
 *
 * To run a query within a React component, call `useMarketingWeeklySnapshotsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingWeeklySnapshotsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingWeeklySnapshotsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      isoWeek: // value for 'isoWeek'
 *   },
 * });
 */
export function useMarketingWeeklySnapshotsListQuery(baseOptions?: Apollo.QueryHookOptions<MarketingWeeklySnapshotsListQuery, MarketingWeeklySnapshotsListQueryVariables>) {
        return Apollo.useQuery<MarketingWeeklySnapshotsListQuery, MarketingWeeklySnapshotsListQueryVariables>(MarketingWeeklySnapshotsListDocument, baseOptions);
      }
export function useMarketingWeeklySnapshotsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingWeeklySnapshotsListQuery, MarketingWeeklySnapshotsListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingWeeklySnapshotsListQuery, MarketingWeeklySnapshotsListQueryVariables>(MarketingWeeklySnapshotsListDocument, baseOptions);
        }
export type MarketingWeeklySnapshotsListQueryHookResult = ReturnType<typeof useMarketingWeeklySnapshotsListQuery>;
export type MarketingWeeklySnapshotsListLazyQueryHookResult = ReturnType<typeof useMarketingWeeklySnapshotsListLazyQuery>;
export type MarketingWeeklySnapshotsListQueryResult = Apollo.QueryResult<MarketingWeeklySnapshotsListQuery, MarketingWeeklySnapshotsListQueryVariables>;
export const MarketingDigestHistoryListDocument = gql`
    query MarketingDigestHistoryList($limit: Int) {
  marketingDigests(limit: $limit) {
    id
    isoWeek
    status
    model
    factsChecked
    rejectedNumbers
    attempts
    createdAt
    createdBy
    startedAt
    finishedAt
    error
  }
}
    `;

/**
 * __useMarketingDigestHistoryListQuery__
 *
 * To run a query within a React component, call `useMarketingDigestHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingDigestHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingDigestHistoryListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketingDigestHistoryListQuery(baseOptions?: Apollo.QueryHookOptions<MarketingDigestHistoryListQuery, MarketingDigestHistoryListQueryVariables>) {
        return Apollo.useQuery<MarketingDigestHistoryListQuery, MarketingDigestHistoryListQueryVariables>(MarketingDigestHistoryListDocument, baseOptions);
      }
export function useMarketingDigestHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingDigestHistoryListQuery, MarketingDigestHistoryListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingDigestHistoryListQuery, MarketingDigestHistoryListQueryVariables>(MarketingDigestHistoryListDocument, baseOptions);
        }
export type MarketingDigestHistoryListQueryHookResult = ReturnType<typeof useMarketingDigestHistoryListQuery>;
export type MarketingDigestHistoryListLazyQueryHookResult = ReturnType<typeof useMarketingDigestHistoryListLazyQuery>;
export type MarketingDigestHistoryListQueryResult = Apollo.QueryResult<MarketingDigestHistoryListQuery, MarketingDigestHistoryListQueryVariables>;
export const MarketingDigestWeekTextDocument = gql`
    query MarketingDigestWeekText($isoWeek: String!, $limit: Int) {
  marketingDigests(isoWeek: $isoWeek, limit: $limit) {
    id
    isoWeek
    status
    text
    model
    factsChecked
    rejectedNumbers
    attempts
    createdAt
    createdBy
    startedAt
    finishedAt
    error
    inputTokens
    outputTokens
  }
}
    `;

/**
 * __useMarketingDigestWeekTextQuery__
 *
 * To run a query within a React component, call `useMarketingDigestWeekTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingDigestWeekTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingDigestWeekTextQuery({
 *   variables: {
 *      isoWeek: // value for 'isoWeek'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketingDigestWeekTextQuery(baseOptions: Apollo.QueryHookOptions<MarketingDigestWeekTextQuery, MarketingDigestWeekTextQueryVariables>) {
        return Apollo.useQuery<MarketingDigestWeekTextQuery, MarketingDigestWeekTextQueryVariables>(MarketingDigestWeekTextDocument, baseOptions);
      }
export function useMarketingDigestWeekTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingDigestWeekTextQuery, MarketingDigestWeekTextQueryVariables>) {
          return Apollo.useLazyQuery<MarketingDigestWeekTextQuery, MarketingDigestWeekTextQueryVariables>(MarketingDigestWeekTextDocument, baseOptions);
        }
export type MarketingDigestWeekTextQueryHookResult = ReturnType<typeof useMarketingDigestWeekTextQuery>;
export type MarketingDigestWeekTextLazyQueryHookResult = ReturnType<typeof useMarketingDigestWeekTextLazyQuery>;
export type MarketingDigestWeekTextQueryResult = Apollo.QueryResult<MarketingDigestWeekTextQuery, MarketingDigestWeekTextQueryVariables>;
export const MarketingSendgridEmailReportDocument = gql`
    query MarketingSendgridEmailReport($filter: MarketingFilter!) {
  marketingEmail(filter: $filter) {
    sends {
      id
      name
      sentAt
      delivered
      uniqueOpens
      uniqueClicks
      unsubscribes
      bounces
      emailLeads
      emailSales
      categories
    }
    series {
      day
      clicks
      impressions
      position
    }
    delivered
    uniqueOpens
    uniqueClicks
    emailLeads
    emailSales
    account {
      delivered
      uniqueOpens
      uniqueClicks
      requests
    }
    categories {
      name
      delivered
      uniqueOpens
      uniqueClicks
    }
  }
}
    `;

/**
 * __useMarketingSendgridEmailReportQuery__
 *
 * To run a query within a React component, call `useMarketingSendgridEmailReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSendgridEmailReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSendgridEmailReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingSendgridEmailReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingSendgridEmailReportQuery, MarketingSendgridEmailReportQueryVariables>) {
        return Apollo.useQuery<MarketingSendgridEmailReportQuery, MarketingSendgridEmailReportQueryVariables>(MarketingSendgridEmailReportDocument, baseOptions);
      }
export function useMarketingSendgridEmailReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSendgridEmailReportQuery, MarketingSendgridEmailReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSendgridEmailReportQuery, MarketingSendgridEmailReportQueryVariables>(MarketingSendgridEmailReportDocument, baseOptions);
        }
export type MarketingSendgridEmailReportQueryHookResult = ReturnType<typeof useMarketingSendgridEmailReportQuery>;
export type MarketingSendgridEmailReportLazyQueryHookResult = ReturnType<typeof useMarketingSendgridEmailReportLazyQuery>;
export type MarketingSendgridEmailReportQueryResult = Apollo.QueryResult<MarketingSendgridEmailReportQuery, MarketingSendgridEmailReportQueryVariables>;
export const MarketingVisitorJourneyReportDocument = gql`
    query MarketingVisitorJourneyReport($filter: MarketingFilter!, $compare: MarketingCompare, $granularity: MarketingGranularity) {
  marketingVisitorJourney(
    filter: $filter
    compare: $compare
    granularity: $granularity
  ) {
    kpis {
      leads
      linkedLeads
      linkedShare
      visitors
      sessions
      medianVisits
      medianDays
      medianPages
      firstVisitShare
    }
    previous {
      leads
      linkedLeads
      linkedShare
      visitors
      sessions
      medianVisits
      medianDays
      medianPages
      firstVisitShare
    }
    visitsBeforeLead {
      key
      count
      share
      previous
    }
    daysToLead {
      key
      count
      share
      previous
    }
    pagesBeforeLead {
      key
      count
      share
      previous
    }
    channelMatrix {
      firstChannel
      leadChannel
      leads
    }
    typicalPaths {
      types
      count
      share
      medianDays
    }
    collectingSince
    compareInfo {
      ...MarketingCompareInfoFields
    }
  }
}
    ${MarketingCompareInfoFieldsFragmentDoc}`;

/**
 * __useMarketingVisitorJourneyReportQuery__
 *
 * To run a query within a React component, call `useMarketingVisitorJourneyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingVisitorJourneyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingVisitorJourneyReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      compare: // value for 'compare'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useMarketingVisitorJourneyReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingVisitorJourneyReportQuery, MarketingVisitorJourneyReportQueryVariables>) {
        return Apollo.useQuery<MarketingVisitorJourneyReportQuery, MarketingVisitorJourneyReportQueryVariables>(MarketingVisitorJourneyReportDocument, baseOptions);
      }
export function useMarketingVisitorJourneyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingVisitorJourneyReportQuery, MarketingVisitorJourneyReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingVisitorJourneyReportQuery, MarketingVisitorJourneyReportQueryVariables>(MarketingVisitorJourneyReportDocument, baseOptions);
        }
export type MarketingVisitorJourneyReportQueryHookResult = ReturnType<typeof useMarketingVisitorJourneyReportQuery>;
export type MarketingVisitorJourneyReportLazyQueryHookResult = ReturnType<typeof useMarketingVisitorJourneyReportLazyQuery>;
export type MarketingVisitorJourneyReportQueryResult = Apollo.QueryResult<MarketingVisitorJourneyReportQuery, MarketingVisitorJourneyReportQueryVariables>;
export const MarketingVisitorSamplesListDocument = gql`
    query MarketingVisitorSamplesList($filter: MarketingFilter!, $limit: Int, $offset: Int, $onlyLinked: Boolean) {
  marketingVisitors(
    filter: $filter
    limit: $limit
    offset: $offset
    onlyLinked: $onlyLinked
  ) {
    totalCount
    roundedToDay
    rows {
      id
      firstSeenAt
      firstChannel
      sessions
      pageviews
      pages
      leadAt
      leadChannel
      daysToLead
      familySlug
      outcome
    }
  }
}
    `;

/**
 * __useMarketingVisitorSamplesListQuery__
 *
 * To run a query within a React component, call `useMarketingVisitorSamplesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingVisitorSamplesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingVisitorSamplesListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      onlyLinked: // value for 'onlyLinked'
 *   },
 * });
 */
export function useMarketingVisitorSamplesListQuery(baseOptions: Apollo.QueryHookOptions<MarketingVisitorSamplesListQuery, MarketingVisitorSamplesListQueryVariables>) {
        return Apollo.useQuery<MarketingVisitorSamplesListQuery, MarketingVisitorSamplesListQueryVariables>(MarketingVisitorSamplesListDocument, baseOptions);
      }
export function useMarketingVisitorSamplesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingVisitorSamplesListQuery, MarketingVisitorSamplesListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingVisitorSamplesListQuery, MarketingVisitorSamplesListQueryVariables>(MarketingVisitorSamplesListDocument, baseOptions);
        }
export type MarketingVisitorSamplesListQueryHookResult = ReturnType<typeof useMarketingVisitorSamplesListQuery>;
export type MarketingVisitorSamplesListLazyQueryHookResult = ReturnType<typeof useMarketingVisitorSamplesListLazyQuery>;
export type MarketingVisitorSamplesListQueryResult = Apollo.QueryResult<MarketingVisitorSamplesListQuery, MarketingVisitorSamplesListQueryVariables>;
export const MarketingVisitorTimelineCardDocument = gql`
    query MarketingVisitorTimelineCard($id: ID!) {
  marketingVisitor(id: $id) {
    id
    roundedToDay
    firstSeenAt
    lastSeenAt
    sessions
    pageviews
    devices
    device
    events {
      kind
      at
      channel
      subChannel
      landingPath
      pages
      pageviews
      durationS
      formSubmits
      device
      familySlug
      isRepeat
      pageType
      outcome
    }
  }
}
    `;

/**
 * __useMarketingVisitorTimelineCardQuery__
 *
 * To run a query within a React component, call `useMarketingVisitorTimelineCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingVisitorTimelineCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingVisitorTimelineCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketingVisitorTimelineCardQuery(baseOptions: Apollo.QueryHookOptions<MarketingVisitorTimelineCardQuery, MarketingVisitorTimelineCardQueryVariables>) {
        return Apollo.useQuery<MarketingVisitorTimelineCardQuery, MarketingVisitorTimelineCardQueryVariables>(MarketingVisitorTimelineCardDocument, baseOptions);
      }
export function useMarketingVisitorTimelineCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingVisitorTimelineCardQuery, MarketingVisitorTimelineCardQueryVariables>) {
          return Apollo.useLazyQuery<MarketingVisitorTimelineCardQuery, MarketingVisitorTimelineCardQueryVariables>(MarketingVisitorTimelineCardDocument, baseOptions);
        }
export type MarketingVisitorTimelineCardQueryHookResult = ReturnType<typeof useMarketingVisitorTimelineCardQuery>;
export type MarketingVisitorTimelineCardLazyQueryHookResult = ReturnType<typeof useMarketingVisitorTimelineCardLazyQuery>;
export type MarketingVisitorTimelineCardQueryResult = Apollo.QueryResult<MarketingVisitorTimelineCardQuery, MarketingVisitorTimelineCardQueryVariables>;
export const MarketingSitePagesReportDocument = gql`
    query MarketingSitePagesReport($filter: MarketingFilter!, $compare: MarketingCompare, $granularity: MarketingGranularity, $pageTypes: [String!], $familySlug: String, $search: String, $orderBy: String, $limit: Int, $offset: Int) {
  marketingPages(
    filter: $filter
    compare: $compare
    granularity: $granularity
    pageTypes: $pageTypes
    familySlug: $familySlug
    search: $search
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    totalCount
    denominator
    collectingSince
    typeCounts {
      value
      count
    }
    totals {
      ...MarketingPageMetricsFields
    }
    previousTotals {
      ...MarketingPageMetricsFields
    }
    rows {
      path
      pageType
      familySlug
      firstSeen
      metrics {
        ...MarketingPageMetricsFields
      }
      previous {
        ...MarketingPageMetricsFields
      }
    }
    compareInfo {
      ...MarketingCompareInfoFields
    }
  }
}
    ${MarketingPageMetricsFieldsFragmentDoc}
${MarketingCompareInfoFieldsFragmentDoc}`;

/**
 * __useMarketingSitePagesReportQuery__
 *
 * To run a query within a React component, call `useMarketingSitePagesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSitePagesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSitePagesReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      compare: // value for 'compare'
 *      granularity: // value for 'granularity'
 *      pageTypes: // value for 'pageTypes'
 *      familySlug: // value for 'familySlug'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMarketingSitePagesReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingSitePagesReportQuery, MarketingSitePagesReportQueryVariables>) {
        return Apollo.useQuery<MarketingSitePagesReportQuery, MarketingSitePagesReportQueryVariables>(MarketingSitePagesReportDocument, baseOptions);
      }
export function useMarketingSitePagesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSitePagesReportQuery, MarketingSitePagesReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSitePagesReportQuery, MarketingSitePagesReportQueryVariables>(MarketingSitePagesReportDocument, baseOptions);
        }
export type MarketingSitePagesReportQueryHookResult = ReturnType<typeof useMarketingSitePagesReportQuery>;
export type MarketingSitePagesReportLazyQueryHookResult = ReturnType<typeof useMarketingSitePagesReportLazyQuery>;
export type MarketingSitePagesReportQueryResult = Apollo.QueryResult<MarketingSitePagesReportQuery, MarketingSitePagesReportQueryVariables>;
export const MarketingSitePageCardDocument = gql`
    query MarketingSitePageCard($path: String!, $filter: MarketingFilter!, $compare: MarketingCompare, $granularity: MarketingGranularity) {
  marketingPage(
    path: $path
    filter: $filter
    compare: $compare
    granularity: $granularity
  ) {
    path
    pageType
    familySlug
    firstSeen
    known
    denominator
    collectingSince
    metrics {
      ...MarketingPageMetricsFields
    }
    previous {
      ...MarketingPageMetricsFields
    }
    series {
      period
      dateFrom
      dateTo
      previousPeriod
      previousDateFrom
      previousDateTo
      metrics {
        ...MarketingPageMetricsFields
      }
      previous {
        ...MarketingPageMetricsFields
      }
    }
    entrySources {
      source
      key
      sessions
      crmLeads
      keyEvents
    }
    nextPages {
      path
      pageType
      count
      share
    }
    gscQueries {
      query
      clicks
      impressions
      position
    }
    compareInfo {
      ...MarketingCompareInfoFields
    }
  }
}
    ${MarketingPageMetricsFieldsFragmentDoc}
${MarketingCompareInfoFieldsFragmentDoc}`;

/**
 * __useMarketingSitePageCardQuery__
 *
 * To run a query within a React component, call `useMarketingSitePageCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSitePageCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSitePageCardQuery({
 *   variables: {
 *      path: // value for 'path'
 *      filter: // value for 'filter'
 *      compare: // value for 'compare'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useMarketingSitePageCardQuery(baseOptions: Apollo.QueryHookOptions<MarketingSitePageCardQuery, MarketingSitePageCardQueryVariables>) {
        return Apollo.useQuery<MarketingSitePageCardQuery, MarketingSitePageCardQueryVariables>(MarketingSitePageCardDocument, baseOptions);
      }
export function useMarketingSitePageCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSitePageCardQuery, MarketingSitePageCardQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSitePageCardQuery, MarketingSitePageCardQueryVariables>(MarketingSitePageCardDocument, baseOptions);
        }
export type MarketingSitePageCardQueryHookResult = ReturnType<typeof useMarketingSitePageCardQuery>;
export type MarketingSitePageCardLazyQueryHookResult = ReturnType<typeof useMarketingSitePageCardLazyQuery>;
export type MarketingSitePageCardQueryResult = Apollo.QueryResult<MarketingSitePageCardQuery, MarketingSitePageCardQueryVariables>;
export const MarketingSeoWeeksListDocument = gql`
    query MarketingSeoWeeksList($limit: Int) {
  marketingSeoWeeks(limit: $limit) {
    week
    isoWeek
    checkedAt
    keywords
    aiAnswers
    state
    partial
  }
}
    `;

/**
 * __useMarketingSeoWeeksListQuery__
 *
 * To run a query within a React component, call `useMarketingSeoWeeksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoWeeksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoWeeksListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketingSeoWeeksListQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoWeeksListQuery, MarketingSeoWeeksListQueryVariables>) {
        return Apollo.useQuery<MarketingSeoWeeksListQuery, MarketingSeoWeeksListQueryVariables>(MarketingSeoWeeksListDocument, baseOptions);
      }
export function useMarketingSeoWeeksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoWeeksListQuery, MarketingSeoWeeksListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoWeeksListQuery, MarketingSeoWeeksListQueryVariables>(MarketingSeoWeeksListDocument, baseOptions);
        }
export type MarketingSeoWeeksListQueryHookResult = ReturnType<typeof useMarketingSeoWeeksListQuery>;
export type MarketingSeoWeeksListLazyQueryHookResult = ReturnType<typeof useMarketingSeoWeeksListLazyQuery>;
export type MarketingSeoWeeksListQueryResult = Apollo.QueryResult<MarketingSeoWeeksListQuery, MarketingSeoWeeksListQueryVariables>;
export const MarketingSeoOverviewReportDocument = gql`
    query MarketingSeoOverviewReport($week: String, $compareWeek: String, $familySlug: String, $brand: Boolean) {
  marketingSeoOverview(
    week: $week
    compareWeek: $compareWeek
    familySlug: $familySlug
    brand: $brand
  ) {
    week
    compareWeek
    isoWeek
    compareIsoWeek
    ownDomain
    locationCode
    languageCode
    device
    checkedAt
    nextRunAt
    stale
    keywords
    comparableKeywords
    sov
    sovPrev
    top3
    top3Prev
    top10
    top10Prev
    top20
    top20Prev
    avgPosition
    avgPositionPrev
    estClicks
    estClicksPrev
    gscClicks
    gscClicksPrev
    gscImpressions
    gscImpressionsPrev
    gscFrom
    gscTo
    aiAnswers
    aiMentionShare
    aiMentionSharePrev
    aiCitationShare
    aiSmallSample
    referringDomains
    referringDomainsPrev
    domains {
      domain
      label
      isOwn
      sov
      sovPrev
      top3
      top10
      top10Prev
      avgPosition
      estClicks
    }
    movers {
      keywordId
      keyword
      familySlug
      position
      prevPosition
      delta
      change
      volume
    }
    moveCounts {
      new
      lost
      up
      down
    }
    ideas {
      ...MarketingSeoOpportunityFields
    }
    ctrNote
  }
}
    ${MarketingSeoOpportunityFieldsFragmentDoc}`;

/**
 * __useMarketingSeoOverviewReportQuery__
 *
 * To run a query within a React component, call `useMarketingSeoOverviewReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoOverviewReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoOverviewReportQuery({
 *   variables: {
 *      week: // value for 'week'
 *      compareWeek: // value for 'compareWeek'
 *      familySlug: // value for 'familySlug'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useMarketingSeoOverviewReportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoOverviewReportQuery, MarketingSeoOverviewReportQueryVariables>) {
        return Apollo.useQuery<MarketingSeoOverviewReportQuery, MarketingSeoOverviewReportQueryVariables>(MarketingSeoOverviewReportDocument, baseOptions);
      }
export function useMarketingSeoOverviewReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoOverviewReportQuery, MarketingSeoOverviewReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoOverviewReportQuery, MarketingSeoOverviewReportQueryVariables>(MarketingSeoOverviewReportDocument, baseOptions);
        }
export type MarketingSeoOverviewReportQueryHookResult = ReturnType<typeof useMarketingSeoOverviewReportQuery>;
export type MarketingSeoOverviewReportLazyQueryHookResult = ReturnType<typeof useMarketingSeoOverviewReportLazyQuery>;
export type MarketingSeoOverviewReportQueryResult = Apollo.QueryResult<MarketingSeoOverviewReportQuery, MarketingSeoOverviewReportQueryVariables>;
export const MarketingSeoKeywordsListDocument = gql`
    query MarketingSeoKeywordsList($week: String, $compareWeek: String, $familySlug: String, $brand: Boolean, $tracked: Boolean, $change: String, $zone: String, $domain: String, $search: String, $orderBy: String, $limit: Int, $offset: Int) {
  marketingSeoKeywords(
    week: $week
    compareWeek: $compareWeek
    familySlug: $familySlug
    brand: $brand
    tracked: $tracked
    change: $change
    zone: $zone
    domain: $domain
    search: $search
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    week
    compareWeek
    totalCount
    rows {
      ...MarketingSeoKeywordRowFields
    }
    zoneCounts {
      value
      count
    }
    changeCounts {
      value
      count
    }
    zonesByWeek {
      week
      isoWeek
      top3
      pos4to10
      pos11to20
      beyond20
    }
  }
}
    ${MarketingSeoKeywordRowFieldsFragmentDoc}`;

/**
 * __useMarketingSeoKeywordsListQuery__
 *
 * To run a query within a React component, call `useMarketingSeoKeywordsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoKeywordsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoKeywordsListQuery({
 *   variables: {
 *      week: // value for 'week'
 *      compareWeek: // value for 'compareWeek'
 *      familySlug: // value for 'familySlug'
 *      brand: // value for 'brand'
 *      tracked: // value for 'tracked'
 *      change: // value for 'change'
 *      zone: // value for 'zone'
 *      domain: // value for 'domain'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMarketingSeoKeywordsListQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoKeywordsListQuery, MarketingSeoKeywordsListQueryVariables>) {
        return Apollo.useQuery<MarketingSeoKeywordsListQuery, MarketingSeoKeywordsListQueryVariables>(MarketingSeoKeywordsListDocument, baseOptions);
      }
export function useMarketingSeoKeywordsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoKeywordsListQuery, MarketingSeoKeywordsListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoKeywordsListQuery, MarketingSeoKeywordsListQueryVariables>(MarketingSeoKeywordsListDocument, baseOptions);
        }
export type MarketingSeoKeywordsListQueryHookResult = ReturnType<typeof useMarketingSeoKeywordsListQuery>;
export type MarketingSeoKeywordsListLazyQueryHookResult = ReturnType<typeof useMarketingSeoKeywordsListLazyQuery>;
export type MarketingSeoKeywordsListQueryResult = Apollo.QueryResult<MarketingSeoKeywordsListQuery, MarketingSeoKeywordsListQueryVariables>;
export const MarketingSeoKeywordCardDocument = gql`
    query MarketingSeoKeywordCard($id: ID!, $weeks: Int) {
  marketingSeoKeyword(id: $id, weeks: $weeks) {
    keyword {
      ...MarketingSeoKeywordRowFields
    }
    serpWeek
    serp {
      rank
      domain
      url
      title
      isOwn
      isTracked
    }
    features
    hasAiOverview
    aiOverviewRefs
    leaderDomain
    positions {
      week
      isoWeek
      own
      leader
    }
    gsc {
      week
      isoWeek
      clicks
      impressions
      position
    }
    labs {
      domain
      position
      url
      etv
      month
    }
    monthlySearches {
      year
      month
      searchVolume
    }
    opportunities {
      ...MarketingSeoOpportunityFields
    }
  }
}
    ${MarketingSeoKeywordRowFieldsFragmentDoc}
${MarketingSeoOpportunityFieldsFragmentDoc}`;

/**
 * __useMarketingSeoKeywordCardQuery__
 *
 * To run a query within a React component, call `useMarketingSeoKeywordCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoKeywordCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoKeywordCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *      weeks: // value for 'weeks'
 *   },
 * });
 */
export function useMarketingSeoKeywordCardQuery(baseOptions: Apollo.QueryHookOptions<MarketingSeoKeywordCardQuery, MarketingSeoKeywordCardQueryVariables>) {
        return Apollo.useQuery<MarketingSeoKeywordCardQuery, MarketingSeoKeywordCardQueryVariables>(MarketingSeoKeywordCardDocument, baseOptions);
      }
export function useMarketingSeoKeywordCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoKeywordCardQuery, MarketingSeoKeywordCardQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoKeywordCardQuery, MarketingSeoKeywordCardQueryVariables>(MarketingSeoKeywordCardDocument, baseOptions);
        }
export type MarketingSeoKeywordCardQueryHookResult = ReturnType<typeof useMarketingSeoKeywordCardQuery>;
export type MarketingSeoKeywordCardLazyQueryHookResult = ReturnType<typeof useMarketingSeoKeywordCardLazyQuery>;
export type MarketingSeoKeywordCardQueryResult = Apollo.QueryResult<MarketingSeoKeywordCardQuery, MarketingSeoKeywordCardQueryVariables>;
export const MarketingSeoSeriesReportDocument = gql`
    query MarketingSeoSeriesReport($familySlug: String, $brand: Boolean, $weeks: Int) {
  marketingSeoSeries(familySlug: $familySlug, brand: $brand, weeks: $weeks) {
    week
    isoWeek
    ownSov
    top3
    pos4to10
    pos11to20
    beyond20
    domains {
      domain
      label
      isOwn
      sov
      top3
      top10
      avgPosition
      estClicks
    }
  }
}
    `;

/**
 * __useMarketingSeoSeriesReportQuery__
 *
 * To run a query within a React component, call `useMarketingSeoSeriesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoSeriesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoSeriesReportQuery({
 *   variables: {
 *      familySlug: // value for 'familySlug'
 *      brand: // value for 'brand'
 *      weeks: // value for 'weeks'
 *   },
 * });
 */
export function useMarketingSeoSeriesReportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoSeriesReportQuery, MarketingSeoSeriesReportQueryVariables>) {
        return Apollo.useQuery<MarketingSeoSeriesReportQuery, MarketingSeoSeriesReportQueryVariables>(MarketingSeoSeriesReportDocument, baseOptions);
      }
export function useMarketingSeoSeriesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoSeriesReportQuery, MarketingSeoSeriesReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoSeriesReportQuery, MarketingSeoSeriesReportQueryVariables>(MarketingSeoSeriesReportDocument, baseOptions);
        }
export type MarketingSeoSeriesReportQueryHookResult = ReturnType<typeof useMarketingSeoSeriesReportQuery>;
export type MarketingSeoSeriesReportLazyQueryHookResult = ReturnType<typeof useMarketingSeoSeriesReportLazyQuery>;
export type MarketingSeoSeriesReportQueryResult = Apollo.QueryResult<MarketingSeoSeriesReportQuery, MarketingSeoSeriesReportQueryVariables>;
export const MarketingSeoCompetitorsReportDocument = gql`
    query MarketingSeoCompetitorsReport($week: String, $familySlug: String) {
  marketingSeoCompetitors(week: $week, familySlug: $familySlug) {
    week
    month
    aioKeywords
    aiAnswers
    domains {
      domain
      label
      isOwn
      sov
      top3
      top10
      top20
      avgPosition
      estClicks
      labsEtv
      labsKeywords
      labsTop3
      labsTop10
      labsZones {
        value
        count
      }
      referringDomains
      backlinks
      backlinksRank
      aiMentionShare
      aiCitationShare
      aioCitationShare
    }
    matrix {
      familySlug
      familyName
      isSold
      domain
      isOwn
      keywords
      top10
      top10Share
      sov
    }
  }
}
    `;

/**
 * __useMarketingSeoCompetitorsReportQuery__
 *
 * To run a query within a React component, call `useMarketingSeoCompetitorsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoCompetitorsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoCompetitorsReportQuery({
 *   variables: {
 *      week: // value for 'week'
 *      familySlug: // value for 'familySlug'
 *   },
 * });
 */
export function useMarketingSeoCompetitorsReportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoCompetitorsReportQuery, MarketingSeoCompetitorsReportQueryVariables>) {
        return Apollo.useQuery<MarketingSeoCompetitorsReportQuery, MarketingSeoCompetitorsReportQueryVariables>(MarketingSeoCompetitorsReportDocument, baseOptions);
      }
export function useMarketingSeoCompetitorsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoCompetitorsReportQuery, MarketingSeoCompetitorsReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoCompetitorsReportQuery, MarketingSeoCompetitorsReportQueryVariables>(MarketingSeoCompetitorsReportDocument, baseOptions);
        }
export type MarketingSeoCompetitorsReportQueryHookResult = ReturnType<typeof useMarketingSeoCompetitorsReportQuery>;
export type MarketingSeoCompetitorsReportLazyQueryHookResult = ReturnType<typeof useMarketingSeoCompetitorsReportLazyQuery>;
export type MarketingSeoCompetitorsReportQueryResult = Apollo.QueryResult<MarketingSeoCompetitorsReportQuery, MarketingSeoCompetitorsReportQueryVariables>;
export const MarketingSeoIdeasListDocument = gql`
    query MarketingSeoIdeasList($month: String, $familySlug: String, $unmapped: Boolean, $minVolume: Int, $kind: String, $includeNavigational: Boolean, $limit: Int, $offset: Int) {
  marketingSeoGaps(
    month: $month
    familySlug: $familySlug
    unmapped: $unmapped
    minVolume: $minVolume
    kind: $kind
    includeNavigational: $includeNavigational
    limit: $limit
    offset: $offset
  ) {
    month
    totalCount
    rows {
      keywordId
      keyword
      familySlug
      familyName
      isSold
      searchVolume
      intent
      difficulty
      ownPosition
      ownUrl
      competitors {
        domain
        position
        url
      }
      kind
      isQuestion
      opportunityId
      status
      valuePlnEst
    }
    topics {
      key
      label
      familySlug
      hasCourse
      keywords
      searchVolume
      topKeywords
      competitors {
        domain
        keywords
      }
      opportunityId
      status
      intent
      suggestedAction
      score
      courseSearchVolume
    }
    clusters {
      key
      label
      familySlug
      isSold
      keywords
      searchVolume
      kind
      action
      intent
      suggestedAction
      score
      courseSearchVolume
      ownUrl
      kindCounts {
        value
        count
      }
      topKeywords
      competitors {
        domain
        keywords
      }
      opportunityIds
      planned
      valuePlnEst
    }
    kindCounts {
      value
      count
    }
    hiddenCounts {
      value
      count
    }
  }
}
    `;

/**
 * __useMarketingSeoIdeasListQuery__
 *
 * To run a query within a React component, call `useMarketingSeoIdeasListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoIdeasListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoIdeasListQuery({
 *   variables: {
 *      month: // value for 'month'
 *      familySlug: // value for 'familySlug'
 *      unmapped: // value for 'unmapped'
 *      minVolume: // value for 'minVolume'
 *      kind: // value for 'kind'
 *      includeNavigational: // value for 'includeNavigational'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMarketingSeoIdeasListQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoIdeasListQuery, MarketingSeoIdeasListQueryVariables>) {
        return Apollo.useQuery<MarketingSeoIdeasListQuery, MarketingSeoIdeasListQueryVariables>(MarketingSeoIdeasListDocument, baseOptions);
      }
export function useMarketingSeoIdeasListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoIdeasListQuery, MarketingSeoIdeasListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoIdeasListQuery, MarketingSeoIdeasListQueryVariables>(MarketingSeoIdeasListDocument, baseOptions);
        }
export type MarketingSeoIdeasListQueryHookResult = ReturnType<typeof useMarketingSeoIdeasListQuery>;
export type MarketingSeoIdeasListLazyQueryHookResult = ReturnType<typeof useMarketingSeoIdeasListLazyQuery>;
export type MarketingSeoIdeasListQueryResult = Apollo.QueryResult<MarketingSeoIdeasListQuery, MarketingSeoIdeasListQueryVariables>;
export const MarketingAiVisibilityReportDocument = gql`
    query MarketingAiVisibilityReport($week: String, $familySlug: String, $system: String, $group: String) {
  marketingSeoAi(
    week: $week
    familySlug: $familySlug
    system: $system
    group: $group
  ) {
    week
    compareWeek
    isoWeek
    system
    group
    answers
    answersPrev
    smallSample
    mentionShare
    citationShare
    mentionSharePrev
    citationSharePrev
    domains {
      domain
      label
      isOwn
      mentioned
      cited
      mentionShare
      citationShare
      n
    }
    series {
      week
      isoWeek
      system
      n
      mentionShare
      citationShare
    }
    questions {
      id
      text
      group
      familySlug
      answers
      perSystem {
        system
        answers
        mentioned
        cited
      }
      competitors
      citedUrls
    }
    aioKeywords
    aioWithOverview
    aioShare
    aioOwnCited
    aioOwnCitedShare
    aioDomains {
      domain
      keywords
      share
    }
  }
}
    `;

/**
 * __useMarketingAiVisibilityReportQuery__
 *
 * To run a query within a React component, call `useMarketingAiVisibilityReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingAiVisibilityReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingAiVisibilityReportQuery({
 *   variables: {
 *      week: // value for 'week'
 *      familySlug: // value for 'familySlug'
 *      system: // value for 'system'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useMarketingAiVisibilityReportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingAiVisibilityReportQuery, MarketingAiVisibilityReportQueryVariables>) {
        return Apollo.useQuery<MarketingAiVisibilityReportQuery, MarketingAiVisibilityReportQueryVariables>(MarketingAiVisibilityReportDocument, baseOptions);
      }
export function useMarketingAiVisibilityReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingAiVisibilityReportQuery, MarketingAiVisibilityReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingAiVisibilityReportQuery, MarketingAiVisibilityReportQueryVariables>(MarketingAiVisibilityReportDocument, baseOptions);
        }
export type MarketingAiVisibilityReportQueryHookResult = ReturnType<typeof useMarketingAiVisibilityReportQuery>;
export type MarketingAiVisibilityReportLazyQueryHookResult = ReturnType<typeof useMarketingAiVisibilityReportLazyQuery>;
export type MarketingAiVisibilityReportQueryResult = Apollo.QueryResult<MarketingAiVisibilityReportQuery, MarketingAiVisibilityReportQueryVariables>;
export const MarketingAiAnswerCardDocument = gql`
    query MarketingAiAnswerCard($questionId: ID!, $week: String) {
  marketingSeoAiAnswers(questionId: $questionId, week: $week) {
    id
    system
    week
    repeatNo
    model
    answerText
    sources
    fanOut
    mentions {
      domain
      mentioned
      cited
      firstPos
    }
    ownMentioned
    ownCited
    checkedAt
  }
}
    `;

/**
 * __useMarketingAiAnswerCardQuery__
 *
 * To run a query within a React component, call `useMarketingAiAnswerCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingAiAnswerCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingAiAnswerCardQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      week: // value for 'week'
 *   },
 * });
 */
export function useMarketingAiAnswerCardQuery(baseOptions: Apollo.QueryHookOptions<MarketingAiAnswerCardQuery, MarketingAiAnswerCardQueryVariables>) {
        return Apollo.useQuery<MarketingAiAnswerCardQuery, MarketingAiAnswerCardQueryVariables>(MarketingAiAnswerCardDocument, baseOptions);
      }
export function useMarketingAiAnswerCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingAiAnswerCardQuery, MarketingAiAnswerCardQueryVariables>) {
          return Apollo.useLazyQuery<MarketingAiAnswerCardQuery, MarketingAiAnswerCardQueryVariables>(MarketingAiAnswerCardDocument, baseOptions);
        }
export type MarketingAiAnswerCardQueryHookResult = ReturnType<typeof useMarketingAiAnswerCardQuery>;
export type MarketingAiAnswerCardLazyQueryHookResult = ReturnType<typeof useMarketingAiAnswerCardLazyQuery>;
export type MarketingAiAnswerCardQueryResult = Apollo.QueryResult<MarketingAiAnswerCardQuery, MarketingAiAnswerCardQueryVariables>;
export const MarketingSeoLinksReportDocument = gql`
    query MarketingSeoLinksReport($month: String, $limit: Int) {
  marketingSeoBacklinks(month: $month, limit: $limit) {
    month
    prevMonth
    ownNew
    ownLost
    gapTotal
    domains {
      domain
      label
      isOwn
      referringDomains
      referringDomainsPrev
      referringMainDomains
      backlinks
      rank
    }
    gaps {
      refDomain
      rank
      backlinks
      linksTo
      opportunityId
      status
    }
  }
}
    `;

/**
 * __useMarketingSeoLinksReportQuery__
 *
 * To run a query within a React component, call `useMarketingSeoLinksReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoLinksReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoLinksReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketingSeoLinksReportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoLinksReportQuery, MarketingSeoLinksReportQueryVariables>) {
        return Apollo.useQuery<MarketingSeoLinksReportQuery, MarketingSeoLinksReportQueryVariables>(MarketingSeoLinksReportDocument, baseOptions);
      }
export function useMarketingSeoLinksReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoLinksReportQuery, MarketingSeoLinksReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoLinksReportQuery, MarketingSeoLinksReportQueryVariables>(MarketingSeoLinksReportDocument, baseOptions);
        }
export type MarketingSeoLinksReportQueryHookResult = ReturnType<typeof useMarketingSeoLinksReportQuery>;
export type MarketingSeoLinksReportLazyQueryHookResult = ReturnType<typeof useMarketingSeoLinksReportLazyQuery>;
export type MarketingSeoLinksReportQueryResult = Apollo.QueryResult<MarketingSeoLinksReportQuery, MarketingSeoLinksReportQueryVariables>;
export const MarketingSeoFunnelReportDocument = gql`
    query MarketingSeoFunnelReport($filter: MarketingFilter!) {
  marketingSeoFunnel(filter: $filter) {
    familySlug
    familyName
    isSold
    sov
    labsEtv
    searchVolume
    gscClicks
    gscImpressions
    organicEntrances
    crmLeads
    sales
    revenuePln
  }
}
    `;

/**
 * __useMarketingSeoFunnelReportQuery__
 *
 * To run a query within a React component, call `useMarketingSeoFunnelReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoFunnelReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoFunnelReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingSeoFunnelReportQuery(baseOptions: Apollo.QueryHookOptions<MarketingSeoFunnelReportQuery, MarketingSeoFunnelReportQueryVariables>) {
        return Apollo.useQuery<MarketingSeoFunnelReportQuery, MarketingSeoFunnelReportQueryVariables>(MarketingSeoFunnelReportDocument, baseOptions);
      }
export function useMarketingSeoFunnelReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoFunnelReportQuery, MarketingSeoFunnelReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoFunnelReportQuery, MarketingSeoFunnelReportQueryVariables>(MarketingSeoFunnelReportDocument, baseOptions);
        }
export type MarketingSeoFunnelReportQueryHookResult = ReturnType<typeof useMarketingSeoFunnelReportQuery>;
export type MarketingSeoFunnelReportLazyQueryHookResult = ReturnType<typeof useMarketingSeoFunnelReportLazyQuery>;
export type MarketingSeoFunnelReportQueryResult = Apollo.QueryResult<MarketingSeoFunnelReportQuery, MarketingSeoFunnelReportQueryVariables>;
export const MarketingSeoBudgetCardDocument = gql`
    query MarketingSeoBudgetCard {
  marketingSeoBudget {
    month
    capUsd
    envCapUsd
    spentUsd
    reservedUsd
    uncertainUsd
    remainingUsd
    maxRunUsd
    balanceUsd
    balanceAt
    pricesSource
    pricesVerifiedOn
    enabled
    aiEnabled
    offReason
    aiOffReason
    mode
    estimates {
      kind
      estimateUsd
      keywords
      questions
      ai
      upperBound
      refusal
      items {
        endpoint
        requests
        results
        costUsd
      }
    }
    runs {
      id
      kind
      state
      mode
      week
      month
      ai
      estimateUsd
      spentUsd
      createdAt
      finishedAt
      refusal
      error
    }
    history {
      month
      spentUsd
      reservedUsd
      uncertainUsd
      capUsd
    }
  }
}
    `;

/**
 * __useMarketingSeoBudgetCardQuery__
 *
 * To run a query within a React component, call `useMarketingSeoBudgetCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoBudgetCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoBudgetCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketingSeoBudgetCardQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoBudgetCardQuery, MarketingSeoBudgetCardQueryVariables>) {
        return Apollo.useQuery<MarketingSeoBudgetCardQuery, MarketingSeoBudgetCardQueryVariables>(MarketingSeoBudgetCardDocument, baseOptions);
      }
export function useMarketingSeoBudgetCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoBudgetCardQuery, MarketingSeoBudgetCardQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoBudgetCardQuery, MarketingSeoBudgetCardQueryVariables>(MarketingSeoBudgetCardDocument, baseOptions);
        }
export type MarketingSeoBudgetCardQueryHookResult = ReturnType<typeof useMarketingSeoBudgetCardQuery>;
export type MarketingSeoBudgetCardLazyQueryHookResult = ReturnType<typeof useMarketingSeoBudgetCardLazyQuery>;
export type MarketingSeoBudgetCardQueryResult = Apollo.QueryResult<MarketingSeoBudgetCardQuery, MarketingSeoBudgetCardQueryVariables>;
export const MarketingSeoOpportunitiesListDocument = gql`
    query MarketingSeoOpportunitiesList($kinds: [String!], $status: [String!], $familySlug: String, $limit: Int) {
  marketingSeoOpportunities(
    kinds: $kinds
    status: $status
    familySlug: $familySlug
    limit: $limit
  ) {
    ...MarketingSeoOpportunityFields
  }
}
    ${MarketingSeoOpportunityFieldsFragmentDoc}`;

/**
 * __useMarketingSeoOpportunitiesListQuery__
 *
 * To run a query within a React component, call `useMarketingSeoOpportunitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoOpportunitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoOpportunitiesListQuery({
 *   variables: {
 *      kinds: // value for 'kinds'
 *      status: // value for 'status'
 *      familySlug: // value for 'familySlug'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketingSeoOpportunitiesListQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoOpportunitiesListQuery, MarketingSeoOpportunitiesListQueryVariables>) {
        return Apollo.useQuery<MarketingSeoOpportunitiesListQuery, MarketingSeoOpportunitiesListQueryVariables>(MarketingSeoOpportunitiesListDocument, baseOptions);
      }
export function useMarketingSeoOpportunitiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoOpportunitiesListQuery, MarketingSeoOpportunitiesListQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoOpportunitiesListQuery, MarketingSeoOpportunitiesListQueryVariables>(MarketingSeoOpportunitiesListDocument, baseOptions);
        }
export type MarketingSeoOpportunitiesListQueryHookResult = ReturnType<typeof useMarketingSeoOpportunitiesListQuery>;
export type MarketingSeoOpportunitiesListLazyQueryHookResult = ReturnType<typeof useMarketingSeoOpportunitiesListLazyQuery>;
export type MarketingSeoOpportunitiesListQueryResult = Apollo.QueryResult<MarketingSeoOpportunitiesListQuery, MarketingSeoOpportunitiesListQueryVariables>;
export const MarketingSeoTaxonomyReportDocument = gql`
    query MarketingSeoTaxonomyReport {
  marketingTaxonomy {
    seoDomains {
      id
      domain
      label
      isOwn
      active
      source
      brandRegex
      suggestedMetrics
    }
    seoQuestions {
      id
      familySlug
      group
      textPl
      active
      sort
      version
      source
    }
    seoSettings {
      ownDomain
      locationCode
      languageCode
      device
      depth
      maxTracked
      aiRepeats
      minGapVolume
      excludedTopics
      trackedCount
    }
  }
}
    `;

/**
 * __useMarketingSeoTaxonomyReportQuery__
 *
 * To run a query within a React component, call `useMarketingSeoTaxonomyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingSeoTaxonomyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingSeoTaxonomyReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketingSeoTaxonomyReportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingSeoTaxonomyReportQuery, MarketingSeoTaxonomyReportQueryVariables>) {
        return Apollo.useQuery<MarketingSeoTaxonomyReportQuery, MarketingSeoTaxonomyReportQueryVariables>(MarketingSeoTaxonomyReportDocument, baseOptions);
      }
export function useMarketingSeoTaxonomyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingSeoTaxonomyReportQuery, MarketingSeoTaxonomyReportQueryVariables>) {
          return Apollo.useLazyQuery<MarketingSeoTaxonomyReportQuery, MarketingSeoTaxonomyReportQueryVariables>(MarketingSeoTaxonomyReportDocument, baseOptions);
        }
export type MarketingSeoTaxonomyReportQueryHookResult = ReturnType<typeof useMarketingSeoTaxonomyReportQuery>;
export type MarketingSeoTaxonomyReportLazyQueryHookResult = ReturnType<typeof useMarketingSeoTaxonomyReportLazyQuery>;
export type MarketingSeoTaxonomyReportQueryResult = Apollo.QueryResult<MarketingSeoTaxonomyReportQuery, MarketingSeoTaxonomyReportQueryVariables>;
export const GetMyMcpAccessDocument = gql`
    query GetMyMcpAccess {
  myMcpAccess {
    enabled
    endpoint
    blockedReason
    callsLast30Days
    connections {
      id
      application
      scope
      created
      expires
      lastUsed
    }
  }
}
    `;

/**
 * __useGetMyMcpAccessQuery__
 *
 * To run a query within a React component, call `useGetMyMcpAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMcpAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMcpAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyMcpAccessQuery(baseOptions?: Apollo.QueryHookOptions<GetMyMcpAccessQuery, GetMyMcpAccessQueryVariables>) {
        return Apollo.useQuery<GetMyMcpAccessQuery, GetMyMcpAccessQueryVariables>(GetMyMcpAccessDocument, baseOptions);
      }
export function useGetMyMcpAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMcpAccessQuery, GetMyMcpAccessQueryVariables>) {
          return Apollo.useLazyQuery<GetMyMcpAccessQuery, GetMyMcpAccessQueryVariables>(GetMyMcpAccessDocument, baseOptions);
        }
export type GetMyMcpAccessQueryHookResult = ReturnType<typeof useGetMyMcpAccessQuery>;
export type GetMyMcpAccessLazyQueryHookResult = ReturnType<typeof useGetMyMcpAccessLazyQuery>;
export type GetMyMcpAccessQueryResult = Apollo.QueryResult<GetMyMcpAccessQuery, GetMyMcpAccessQueryVariables>;
export const MyCommsCountersDocument = gql`
    query MyCommsCounters {
  myCommsCounters {
    mailUnread
    slackUnread
    unhandled
    overdueTasks
  }
}
    `;

/**
 * __useMyCommsCountersQuery__
 *
 * To run a query within a React component, call `useMyCommsCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCommsCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCommsCountersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCommsCountersQuery(baseOptions?: Apollo.QueryHookOptions<MyCommsCountersQuery, MyCommsCountersQueryVariables>) {
        return Apollo.useQuery<MyCommsCountersQuery, MyCommsCountersQueryVariables>(MyCommsCountersDocument, baseOptions);
      }
export function useMyCommsCountersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCommsCountersQuery, MyCommsCountersQueryVariables>) {
          return Apollo.useLazyQuery<MyCommsCountersQuery, MyCommsCountersQueryVariables>(MyCommsCountersDocument, baseOptions);
        }
export type MyCommsCountersQueryHookResult = ReturnType<typeof useMyCommsCountersQuery>;
export type MyCommsCountersLazyQueryHookResult = ReturnType<typeof useMyCommsCountersLazyQuery>;
export type MyCommsCountersQueryResult = Apollo.QueryResult<MyCommsCountersQuery, MyCommsCountersQueryVariables>;
export const NotificationBadgeDocument = gql`
    query NotificationBadge {
  staffNotificationsSummary {
    unreadCount
    totalCount
    latestId
    latestCreatedAt
    pollSeconds
    soundAlarm {
      active
      taskId
      title
    }
  }
}
    `;

/**
 * __useNotificationBadgeQuery__
 *
 * To run a query within a React component, call `useNotificationBadgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationBadgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationBadgeQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationBadgeQuery(baseOptions?: Apollo.QueryHookOptions<NotificationBadgeQuery, NotificationBadgeQueryVariables>) {
        return Apollo.useQuery<NotificationBadgeQuery, NotificationBadgeQueryVariables>(NotificationBadgeDocument, baseOptions);
      }
export function useNotificationBadgeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationBadgeQuery, NotificationBadgeQueryVariables>) {
          return Apollo.useLazyQuery<NotificationBadgeQuery, NotificationBadgeQueryVariables>(NotificationBadgeDocument, baseOptions);
        }
export type NotificationBadgeQueryHookResult = ReturnType<typeof useNotificationBadgeQuery>;
export type NotificationBadgeLazyQueryHookResult = ReturnType<typeof useNotificationBadgeLazyQuery>;
export type NotificationBadgeQueryResult = Apollo.QueryResult<NotificationBadgeQuery, NotificationBadgeQueryVariables>;
export const NotificationFeedDocument = gql`
    query NotificationFeed($first: Int, $after: String, $unreadOnly: Boolean) {
  staffNotifications(first: $first, after: $after, unreadOnly: $unreadOnly) {
    unreadCount
    hasNextPage
    endCursor
    edges {
      cursor
      node {
        id
        kind
        title
        body
        taskId
        priority
        dueDate
        actorName
        createdAt
        readAt
      }
    }
  }
}
    `;

/**
 * __useNotificationFeedQuery__
 *
 * To run a query within a React component, call `useNotificationFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationFeedQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      unreadOnly: // value for 'unreadOnly'
 *   },
 * });
 */
export function useNotificationFeedQuery(baseOptions?: Apollo.QueryHookOptions<NotificationFeedQuery, NotificationFeedQueryVariables>) {
        return Apollo.useQuery<NotificationFeedQuery, NotificationFeedQueryVariables>(NotificationFeedDocument, baseOptions);
      }
export function useNotificationFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationFeedQuery, NotificationFeedQueryVariables>) {
          return Apollo.useLazyQuery<NotificationFeedQuery, NotificationFeedQueryVariables>(NotificationFeedDocument, baseOptions);
        }
export type NotificationFeedQueryHookResult = ReturnType<typeof useNotificationFeedQuery>;
export type NotificationFeedLazyQueryHookResult = ReturnType<typeof useNotificationFeedLazyQuery>;
export type NotificationFeedQueryResult = Apollo.QueryResult<NotificationFeedQuery, NotificationFeedQueryVariables>;
export const NotificationPrefsDocument = gql`
    query NotificationPrefs {
  staffNotificationSettings {
    soundEnabled
    pollSeconds
    repeatAfterMinutes
    quietFrom
    quietTo
    enabledKinds
    availableKinds {
      key
      label
      enabled
    }
    telegramEnabled
    telegramLinked
    telegramUsername
    telegramLinkedAt
    telegramBlockedAt
    telegramAvailable
    robotRules
    availableRobotRules {
      key
      label
      enabled
      available
    }
  }
}
    `;

/**
 * __useNotificationPrefsQuery__
 *
 * To run a query within a React component, call `useNotificationPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPrefsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationPrefsQuery, NotificationPrefsQueryVariables>) {
        return Apollo.useQuery<NotificationPrefsQuery, NotificationPrefsQueryVariables>(NotificationPrefsDocument, baseOptions);
      }
export function useNotificationPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationPrefsQuery, NotificationPrefsQueryVariables>) {
          return Apollo.useLazyQuery<NotificationPrefsQuery, NotificationPrefsQueryVariables>(NotificationPrefsDocument, baseOptions);
        }
export type NotificationPrefsQueryHookResult = ReturnType<typeof useNotificationPrefsQuery>;
export type NotificationPrefsLazyQueryHookResult = ReturnType<typeof useNotificationPrefsLazyQuery>;
export type NotificationPrefsQueryResult = Apollo.QueryResult<NotificationPrefsQuery, NotificationPrefsQueryVariables>;
export const PandaDocAnalyticsDocument = gql`
    query PandaDocAnalytics($granularity: String, $course: String, $docType: String, $dateFrom: Date, $dateTo: Date, $source: String, $sellerId: ID, $sentById: ID) {
  pandadocAnalytics(
    granularity: $granularity
    course: $course
    docType: $docType
    dateFrom: $dateFrom
    dateTo: $dateTo
    source: $source
    sellerId: $sellerId
    sentById: $sentById
  ) {
    granularity
    course
    window {
      docsLoaded
      totalInDb
      signedCount
      minDate
      maxDate
    }
    volumeKpi {
      total
      students
      trainers
      dofin
      last30
    }
    ttsKpi {
      medianHours
      meanHours
      pct24h
      pct3d
      sample
    }
    conversionKpi {
      sent
      signed
      active
      lost
      signedPct
      activePct
      lostPct
      ratePct
    }
    volumeSeries {
      students {
        labels
        values
      }
      trainers {
        labels
        values
      }
      dofin {
        labels
        values
      }
    }
    ttsHistogram {
      labels
      values
    }
    ttsByCourse {
      course
      avgDays
      sample
    }
    ttsMedianSeries {
      students {
        labels
        values
      }
      trainers {
        labels
        values
      }
      dofin {
        labels
        values
      }
    }
    conversionByCourse {
      course
      signed
      active
      lost
    }
    conversionSeries {
      students {
        labels
        signed
        active
        lost
      }
      dofin {
        labels
        signed
        active
        lost
      }
    }
  }
}
    `;

/**
 * __usePandaDocAnalyticsQuery__
 *
 * To run a query within a React component, call `usePandaDocAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePandaDocAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePandaDocAnalyticsQuery({
 *   variables: {
 *      granularity: // value for 'granularity'
 *      course: // value for 'course'
 *      docType: // value for 'docType'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      source: // value for 'source'
 *      sellerId: // value for 'sellerId'
 *      sentById: // value for 'sentById'
 *   },
 * });
 */
export function usePandaDocAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<PandaDocAnalyticsQuery, PandaDocAnalyticsQueryVariables>) {
        return Apollo.useQuery<PandaDocAnalyticsQuery, PandaDocAnalyticsQueryVariables>(PandaDocAnalyticsDocument, baseOptions);
      }
export function usePandaDocAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PandaDocAnalyticsQuery, PandaDocAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<PandaDocAnalyticsQuery, PandaDocAnalyticsQueryVariables>(PandaDocAnalyticsDocument, baseOptions);
        }
export type PandaDocAnalyticsQueryHookResult = ReturnType<typeof usePandaDocAnalyticsQuery>;
export type PandaDocAnalyticsLazyQueryHookResult = ReturnType<typeof usePandaDocAnalyticsLazyQuery>;
export type PandaDocAnalyticsQueryResult = Apollo.QueryResult<PandaDocAnalyticsQuery, PandaDocAnalyticsQueryVariables>;
export const PandaDocDocumentsDocument = gql`
    query PandaDocDocuments($course: String, $docType: String, $outcome: String, $search: String, $dateFrom: Date, $dateTo: Date, $studentId: ID, $agreementId: ID, $groupId: ID, $studentMatches: Boolean, $first: Int, $after: String) {
  pandadocDocuments(
    course: $course
    docType: $docType
    outcome: $outcome
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    studentId: $studentId
    agreementId: $agreementId
    groupId: $groupId
    studentMatches: $studentMatches
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        id
        pk
        pandadocId
        name
        status
        docType
        course
        outcome
        ttsHours
        dateCreated
        dateModified
        dateSent
        dateCompleted
        provisionedAt
        matchType
        folderName
        recipientEmail
        recipientPhone
        unavailable
        agreement {
          id
          agreementTitle
          student {
            id
            user {
              id
              firstName
              lastName
              email
            }
          }
          group {
            id
            name
          }
          contractDocument {
            id
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePandaDocDocumentsQuery__
 *
 * To run a query within a React component, call `usePandaDocDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePandaDocDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePandaDocDocumentsQuery({
 *   variables: {
 *      course: // value for 'course'
 *      docType: // value for 'docType'
 *      outcome: // value for 'outcome'
 *      search: // value for 'search'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      studentId: // value for 'studentId'
 *      agreementId: // value for 'agreementId'
 *      groupId: // value for 'groupId'
 *      studentMatches: // value for 'studentMatches'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePandaDocDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<PandaDocDocumentsQuery, PandaDocDocumentsQueryVariables>) {
        return Apollo.useQuery<PandaDocDocumentsQuery, PandaDocDocumentsQueryVariables>(PandaDocDocumentsDocument, baseOptions);
      }
export function usePandaDocDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PandaDocDocumentsQuery, PandaDocDocumentsQueryVariables>) {
          return Apollo.useLazyQuery<PandaDocDocumentsQuery, PandaDocDocumentsQueryVariables>(PandaDocDocumentsDocument, baseOptions);
        }
export type PandaDocDocumentsQueryHookResult = ReturnType<typeof usePandaDocDocumentsQuery>;
export type PandaDocDocumentsLazyQueryHookResult = ReturnType<typeof usePandaDocDocumentsLazyQuery>;
export type PandaDocDocumentsQueryResult = Apollo.QueryResult<PandaDocDocumentsQuery, PandaDocDocumentsQueryVariables>;
export const UnlinkedPandaDocSearchDocument = gql`
    query UnlinkedPandaDocSearch($search: String, $docType: String, $first: Int) {
  pandadocDocuments(
    search: $search
    docType: $docType
    unlinked: true
    first: $first
  ) {
    totalCount
    edges {
      node {
        id
        pandadocId
        name
        outcome
        folderName
        dateCompleted
        recipientEmail
        recipientPhone
      }
    }
  }
}
    `;

/**
 * __useUnlinkedPandaDocSearchQuery__
 *
 * To run a query within a React component, call `useUnlinkedPandaDocSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnlinkedPandaDocSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnlinkedPandaDocSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      docType: // value for 'docType'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUnlinkedPandaDocSearchQuery(baseOptions?: Apollo.QueryHookOptions<UnlinkedPandaDocSearchQuery, UnlinkedPandaDocSearchQueryVariables>) {
        return Apollo.useQuery<UnlinkedPandaDocSearchQuery, UnlinkedPandaDocSearchQueryVariables>(UnlinkedPandaDocSearchDocument, baseOptions);
      }
export function useUnlinkedPandaDocSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnlinkedPandaDocSearchQuery, UnlinkedPandaDocSearchQueryVariables>) {
          return Apollo.useLazyQuery<UnlinkedPandaDocSearchQuery, UnlinkedPandaDocSearchQueryVariables>(UnlinkedPandaDocSearchDocument, baseOptions);
        }
export type UnlinkedPandaDocSearchQueryHookResult = ReturnType<typeof useUnlinkedPandaDocSearchQuery>;
export type UnlinkedPandaDocSearchLazyQueryHookResult = ReturnType<typeof useUnlinkedPandaDocSearchLazyQuery>;
export type UnlinkedPandaDocSearchQueryResult = Apollo.QueryResult<UnlinkedPandaDocSearchQuery, UnlinkedPandaDocSearchQueryVariables>;
export const TeacherPandadocDocsDocument = gql`
    query TeacherPandadocDocs($teacherId: ID, $teacherMatches: Boolean, $first: Int, $after: String) {
  pandadocDocuments(
    teacherId: $teacherId
    teacherMatches: $teacherMatches
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        id
        pk
        pandadocId
        name
        status
        outcome
        dateCreated
        dateCompleted
        provisionedAt
        matchType
        recipientEmail
        recipientPhone
        contractUrl
        teacher {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useTeacherPandadocDocsQuery__
 *
 * To run a query within a React component, call `useTeacherPandadocDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherPandadocDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherPandadocDocsQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      teacherMatches: // value for 'teacherMatches'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTeacherPandadocDocsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherPandadocDocsQuery, TeacherPandadocDocsQueryVariables>) {
        return Apollo.useQuery<TeacherPandadocDocsQuery, TeacherPandadocDocsQueryVariables>(TeacherPandadocDocsDocument, baseOptions);
      }
export function useTeacherPandadocDocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherPandadocDocsQuery, TeacherPandadocDocsQueryVariables>) {
          return Apollo.useLazyQuery<TeacherPandadocDocsQuery, TeacherPandadocDocsQueryVariables>(TeacherPandadocDocsDocument, baseOptions);
        }
export type TeacherPandadocDocsQueryHookResult = ReturnType<typeof useTeacherPandadocDocsQuery>;
export type TeacherPandadocDocsLazyQueryHookResult = ReturnType<typeof useTeacherPandadocDocsLazyQuery>;
export type TeacherPandadocDocsQueryResult = Apollo.QueryResult<TeacherPandadocDocsQuery, TeacherPandadocDocsQueryVariables>;
export const PandaDocProvisioningFoldersDocument = gql`
    query PandaDocProvisioningFolders($course: String) {
  pandadocProvisioningFolders(course: $course) {
    folderUuid
    folderName
    detectedCourseId
    detectedCourseName
    existingGroupId
    existingGroupName
    studentDocs {
      pandadocId
      pk
      name
      status
      outcome
      firstName
      lastName
      email
      phone
      contractUrl
      phoneMissing
      userExists
      studentExists
      existingUserId
      alreadyProvisioned
    }
  }
}
    `;

/**
 * __usePandaDocProvisioningFoldersQuery__
 *
 * To run a query within a React component, call `usePandaDocProvisioningFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePandaDocProvisioningFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePandaDocProvisioningFoldersQuery({
 *   variables: {
 *      course: // value for 'course'
 *   },
 * });
 */
export function usePandaDocProvisioningFoldersQuery(baseOptions?: Apollo.QueryHookOptions<PandaDocProvisioningFoldersQuery, PandaDocProvisioningFoldersQueryVariables>) {
        return Apollo.useQuery<PandaDocProvisioningFoldersQuery, PandaDocProvisioningFoldersQueryVariables>(PandaDocProvisioningFoldersDocument, baseOptions);
      }
export function usePandaDocProvisioningFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PandaDocProvisioningFoldersQuery, PandaDocProvisioningFoldersQueryVariables>) {
          return Apollo.useLazyQuery<PandaDocProvisioningFoldersQuery, PandaDocProvisioningFoldersQueryVariables>(PandaDocProvisioningFoldersDocument, baseOptions);
        }
export type PandaDocProvisioningFoldersQueryHookResult = ReturnType<typeof usePandaDocProvisioningFoldersQuery>;
export type PandaDocProvisioningFoldersLazyQueryHookResult = ReturnType<typeof usePandaDocProvisioningFoldersLazyQuery>;
export type PandaDocProvisioningFoldersQueryResult = Apollo.QueryResult<PandaDocProvisioningFoldersQuery, PandaDocProvisioningFoldersQueryVariables>;
export const PandaDocSyncStatusDocument = gql`
    query PandaDocSyncStatus {
  pandadocSyncStatus {
    documentsCount
    detailsPending
    lastListSyncAt
    lastDetailsSyncAt
    newestDocDate
    lastDocumentsPulled
    lastRunStatus
    lastError
    syncRunning
  }
}
    `;

/**
 * __usePandaDocSyncStatusQuery__
 *
 * To run a query within a React component, call `usePandaDocSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePandaDocSyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePandaDocSyncStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePandaDocSyncStatusQuery(baseOptions?: Apollo.QueryHookOptions<PandaDocSyncStatusQuery, PandaDocSyncStatusQueryVariables>) {
        return Apollo.useQuery<PandaDocSyncStatusQuery, PandaDocSyncStatusQueryVariables>(PandaDocSyncStatusDocument, baseOptions);
      }
export function usePandaDocSyncStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PandaDocSyncStatusQuery, PandaDocSyncStatusQueryVariables>) {
          return Apollo.useLazyQuery<PandaDocSyncStatusQuery, PandaDocSyncStatusQueryVariables>(PandaDocSyncStatusDocument, baseOptions);
        }
export type PandaDocSyncStatusQueryHookResult = ReturnType<typeof usePandaDocSyncStatusQuery>;
export type PandaDocSyncStatusLazyQueryHookResult = ReturnType<typeof usePandaDocSyncStatusLazyQuery>;
export type PandaDocSyncStatusQueryResult = Apollo.QueryResult<PandaDocSyncStatusQuery, PandaDocSyncStatusQueryVariables>;
export const ParticipationAgreementListDocument = gql`
    query ParticipationAgreementList($candidateId: ID, $studentId: ID) {
  fundingParticipationAgreements(candidateId: $candidateId, studentId: $studentId) {
    id
    agreementTitle
    studentId
    studentName
    groupId
    groupName
    courseName
    date
    windowFrom
    windowTo
    lessonsCount
    terminated
    terminatedDate
    statePrefinanced
    cofunded
    isCandidateAgreement
  }
}
    `;

/**
 * __useParticipationAgreementListQuery__
 *
 * To run a query within a React component, call `useParticipationAgreementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipationAgreementListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipationAgreementListQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useParticipationAgreementListQuery(baseOptions?: Apollo.QueryHookOptions<ParticipationAgreementListQuery, ParticipationAgreementListQueryVariables>) {
        return Apollo.useQuery<ParticipationAgreementListQuery, ParticipationAgreementListQueryVariables>(ParticipationAgreementListDocument, baseOptions);
      }
export function useParticipationAgreementListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipationAgreementListQuery, ParticipationAgreementListQueryVariables>) {
          return Apollo.useLazyQuery<ParticipationAgreementListQuery, ParticipationAgreementListQueryVariables>(ParticipationAgreementListDocument, baseOptions);
        }
export type ParticipationAgreementListQueryHookResult = ReturnType<typeof useParticipationAgreementListQuery>;
export type ParticipationAgreementListLazyQueryHookResult = ReturnType<typeof useParticipationAgreementListLazyQuery>;
export type ParticipationAgreementListQueryResult = Apollo.QueryResult<ParticipationAgreementListQuery, ParticipationAgreementListQueryVariables>;
export const ParticipationSummaryCardDocument = gql`
    query ParticipationSummaryCard($agreementId: ID!, $dateFrom: Date, $dateTo: Date) {
  fundingParticipationSummary(
    agreementId: $agreementId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    agreementId
    dateFrom
    dateTo
    generatedAt
    minPercent
    supportId
    operatorId
    operatorName
    projectNumber
    lessonsPlanned
    lessonsHeld
    lessonsFuture
    lessonsWithZoomData
    lessonsAttended
    lessonsPartial
    lessonsAbsent
    additionalLessons
    additionalAttended
    minutesInZoom
    minutesPlanned
    minutesAttended
    hoursPercent
    journalPresent
    journalPercent
    lessons {
      lessonId
      number
      date
      name
      startsAt
      endsAt
      additional
      status
      minutesPlanned
      minutesInZoom
      minutesOverlap
      percent
      journal
      sessionsCount
      firstJoin
      lastLeave
    }
    warnings {
      code
      count
      dates
    }
  }
}
    `;

/**
 * __useParticipationSummaryCardQuery__
 *
 * To run a query within a React component, call `useParticipationSummaryCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipationSummaryCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipationSummaryCardQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useParticipationSummaryCardQuery(baseOptions: Apollo.QueryHookOptions<ParticipationSummaryCardQuery, ParticipationSummaryCardQueryVariables>) {
        return Apollo.useQuery<ParticipationSummaryCardQuery, ParticipationSummaryCardQueryVariables>(ParticipationSummaryCardDocument, baseOptions);
      }
export function useParticipationSummaryCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipationSummaryCardQuery, ParticipationSummaryCardQueryVariables>) {
          return Apollo.useLazyQuery<ParticipationSummaryCardQuery, ParticipationSummaryCardQueryVariables>(ParticipationSummaryCardDocument, baseOptions);
        }
export type ParticipationSummaryCardQueryHookResult = ReturnType<typeof useParticipationSummaryCardQuery>;
export type ParticipationSummaryCardLazyQueryHookResult = ReturnType<typeof useParticipationSummaryCardLazyQuery>;
export type ParticipationSummaryCardQueryResult = Apollo.QueryResult<ParticipationSummaryCardQuery, ParticipationSummaryCardQueryVariables>;
export const ParticipationReportFileDocument = gql`
    query ParticipationReportFile($agreementId: ID!, $dateFrom: Date, $dateTo: Date, $format: ParticipationReportFormat!, $language: String) {
  fundingParticipationReport(
    agreementId: $agreementId
    dateFrom: $dateFrom
    dateTo: $dateTo
    format: $format
    language: $language
  ) {
    fileName
    contentType
    contentBase64
  }
}
    `;

/**
 * __useParticipationReportFileQuery__
 *
 * To run a query within a React component, call `useParticipationReportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipationReportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipationReportFileQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      format: // value for 'format'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useParticipationReportFileQuery(baseOptions: Apollo.QueryHookOptions<ParticipationReportFileQuery, ParticipationReportFileQueryVariables>) {
        return Apollo.useQuery<ParticipationReportFileQuery, ParticipationReportFileQueryVariables>(ParticipationReportFileDocument, baseOptions);
      }
export function useParticipationReportFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipationReportFileQuery, ParticipationReportFileQueryVariables>) {
          return Apollo.useLazyQuery<ParticipationReportFileQuery, ParticipationReportFileQueryVariables>(ParticipationReportFileDocument, baseOptions);
        }
export type ParticipationReportFileQueryHookResult = ReturnType<typeof useParticipationReportFileQuery>;
export type ParticipationReportFileLazyQueryHookResult = ReturnType<typeof useParticipationReportFileLazyQuery>;
export type ParticipationReportFileQueryResult = Apollo.QueryResult<ParticipationReportFileQuery, ParticipationReportFileQueryVariables>;
export const GroupParticipationReportFileDocument = gql`
    query GroupParticipationReportFile($groupId: ID!, $dateFrom: Date, $dateTo: Date, $language: String) {
  groupParticipationReport(
    groupId: $groupId
    dateFrom: $dateFrom
    dateTo: $dateTo
    language: $language
  ) {
    fileName
    contentType
    contentBase64
  }
}
    `;

/**
 * __useGroupParticipationReportFileQuery__
 *
 * To run a query within a React component, call `useGroupParticipationReportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupParticipationReportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupParticipationReportFileQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGroupParticipationReportFileQuery(baseOptions: Apollo.QueryHookOptions<GroupParticipationReportFileQuery, GroupParticipationReportFileQueryVariables>) {
        return Apollo.useQuery<GroupParticipationReportFileQuery, GroupParticipationReportFileQueryVariables>(GroupParticipationReportFileDocument, baseOptions);
      }
export function useGroupParticipationReportFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupParticipationReportFileQuery, GroupParticipationReportFileQueryVariables>) {
          return Apollo.useLazyQuery<GroupParticipationReportFileQuery, GroupParticipationReportFileQueryVariables>(GroupParticipationReportFileDocument, baseOptions);
        }
export type GroupParticipationReportFileQueryHookResult = ReturnType<typeof useGroupParticipationReportFileQuery>;
export type GroupParticipationReportFileLazyQueryHookResult = ReturnType<typeof useGroupParticipationReportFileLazyQuery>;
export type GroupParticipationReportFileQueryResult = Apollo.QueryResult<GroupParticipationReportFileQuery, GroupParticipationReportFileQueryVariables>;
export const PaymentCalendarDocument = gql`
    query PaymentCalendar($dateFrom: Date!, $dateTo: Date!, $legalEntityId: ID) {
  paymentCalendar(
    dateFrom: $dateFrom
    dateTo: $dateTo
    legalEntityId: $legalEntityId
  ) {
    dateFrom
    dateTo
    openingBalancePln
    totalIncomePln
    totalExpensePln
    totalReceivedPln
    totalAwaitedPln
    totalOverduePln
    totalToPayPln
    minBalancePln
    hasShortfall
    hasRateMissing
    days {
      date
      incomeTotalPln
      expenseTotalPln
      receivedTotalPln
      openingBalancePln
      endBalancePln
      tone
      hasRateMissing
      incomeRows {
        ...PaymentCalendarRowFields
      }
      expenseRows {
        ...PaymentCalendarRowFields
      }
      receivedRows {
        ...PaymentCalendarRowFields
      }
    }
  }
}
    ${PaymentCalendarRowFieldsFragmentDoc}`;

/**
 * __usePaymentCalendarQuery__
 *
 * To run a query within a React component, call `usePaymentCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCalendarQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function usePaymentCalendarQuery(baseOptions: Apollo.QueryHookOptions<PaymentCalendarQuery, PaymentCalendarQueryVariables>) {
        return Apollo.useQuery<PaymentCalendarQuery, PaymentCalendarQueryVariables>(PaymentCalendarDocument, baseOptions);
      }
export function usePaymentCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentCalendarQuery, PaymentCalendarQueryVariables>) {
          return Apollo.useLazyQuery<PaymentCalendarQuery, PaymentCalendarQueryVariables>(PaymentCalendarDocument, baseOptions);
        }
export type PaymentCalendarQueryHookResult = ReturnType<typeof usePaymentCalendarQuery>;
export type PaymentCalendarLazyQueryHookResult = ReturnType<typeof usePaymentCalendarLazyQuery>;
export type PaymentCalendarQueryResult = Apollo.QueryResult<PaymentCalendarQuery, PaymentCalendarQueryVariables>;
export const PaymentCalendarSettingsDocument = gql`
    query PaymentCalendarSettings($legalEntityId: ID) {
  paymentCalendarSettings(legalEntityId: $legalEntityId) {
    teacherPayoutDay
    incomeOffsetDays
    legalEntityId
  }
  exchangeRates {
    pk
    currency
    rateToPln
    effectiveFrom
  }
  cashBalances(legalEntityId: $legalEntityId) {
    pk
    asOfDate
    amountPln
    legalEntityId
  }
}
    `;

/**
 * __usePaymentCalendarSettingsQuery__
 *
 * To run a query within a React component, call `usePaymentCalendarSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCalendarSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCalendarSettingsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function usePaymentCalendarSettingsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentCalendarSettingsQuery, PaymentCalendarSettingsQueryVariables>) {
        return Apollo.useQuery<PaymentCalendarSettingsQuery, PaymentCalendarSettingsQueryVariables>(PaymentCalendarSettingsDocument, baseOptions);
      }
export function usePaymentCalendarSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentCalendarSettingsQuery, PaymentCalendarSettingsQueryVariables>) {
          return Apollo.useLazyQuery<PaymentCalendarSettingsQuery, PaymentCalendarSettingsQueryVariables>(PaymentCalendarSettingsDocument, baseOptions);
        }
export type PaymentCalendarSettingsQueryHookResult = ReturnType<typeof usePaymentCalendarSettingsQuery>;
export type PaymentCalendarSettingsLazyQueryHookResult = ReturnType<typeof usePaymentCalendarSettingsLazyQuery>;
export type PaymentCalendarSettingsQueryResult = Apollo.QueryResult<PaymentCalendarSettingsQuery, PaymentCalendarSettingsQueryVariables>;
export const PaginatedPerformancesDocument = gql`
    query PaginatedPerformances($query: String, $before: String, $after: String, $first: Int, $last: Int) {
  allStudentsAchievement(
    query: $query
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        student {
          id
          user {
            id
            firstName
            lastName
            middleName
          }
        }
        group {
          id
          name
          course {
            educationForm
          }
        }
        attendancesInfo
        courseWorksAverage
        hwSummary
        graduationProjectMark
      }
    }
  }
}
    `;

/**
 * __usePaginatedPerformancesQuery__
 *
 * To run a query within a React component, call `usePaginatedPerformancesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedPerformancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedPerformancesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePaginatedPerformancesQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedPerformancesQuery, PaginatedPerformancesQueryVariables>) {
        return Apollo.useQuery<PaginatedPerformancesQuery, PaginatedPerformancesQueryVariables>(PaginatedPerformancesDocument, baseOptions);
      }
export function usePaginatedPerformancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedPerformancesQuery, PaginatedPerformancesQueryVariables>) {
          return Apollo.useLazyQuery<PaginatedPerformancesQuery, PaginatedPerformancesQueryVariables>(PaginatedPerformancesDocument, baseOptions);
        }
export type PaginatedPerformancesQueryHookResult = ReturnType<typeof usePaginatedPerformancesQuery>;
export type PaginatedPerformancesLazyQueryHookResult = ReturnType<typeof usePaginatedPerformancesLazyQuery>;
export type PaginatedPerformancesQueryResult = Apollo.QueryResult<PaginatedPerformancesQuery, PaginatedPerformancesQueryVariables>;
export const PnlExportRunsDocument = gql`
    query PnlExportRuns($groupId: ID, $limit: Int) {
  pnlExportRuns(groupId: $groupId, limit: $limit) {
    id
    status
    fileFormat
    language
    monthFrom
    monthTo
    groupId
    groupName
    fileName
    size
    stats
    error
    createdByName
    createdAt
    finishedAt
    isDownloadable
    isFilePurged
  }
}
    `;

/**
 * __usePnlExportRunsQuery__
 *
 * To run a query within a React component, call `usePnlExportRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePnlExportRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePnlExportRunsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePnlExportRunsQuery(baseOptions?: Apollo.QueryHookOptions<PnlExportRunsQuery, PnlExportRunsQueryVariables>) {
        return Apollo.useQuery<PnlExportRunsQuery, PnlExportRunsQueryVariables>(PnlExportRunsDocument, baseOptions);
      }
export function usePnlExportRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PnlExportRunsQuery, PnlExportRunsQueryVariables>) {
          return Apollo.useLazyQuery<PnlExportRunsQuery, PnlExportRunsQueryVariables>(PnlExportRunsDocument, baseOptions);
        }
export type PnlExportRunsQueryHookResult = ReturnType<typeof usePnlExportRunsQuery>;
export type PnlExportRunsLazyQueryHookResult = ReturnType<typeof usePnlExportRunsLazyQuery>;
export type PnlExportRunsQueryResult = Apollo.QueryResult<PnlExportRunsQuery, PnlExportRunsQueryVariables>;
export const PnlExportGroupsDocument = gql`
    query PnlExportGroups {
  pnlExportGroups {
    id
    name
    courseName
    startDate
  }
}
    `;

/**
 * __usePnlExportGroupsQuery__
 *
 * To run a query within a React component, call `usePnlExportGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePnlExportGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePnlExportGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePnlExportGroupsQuery(baseOptions?: Apollo.QueryHookOptions<PnlExportGroupsQuery, PnlExportGroupsQueryVariables>) {
        return Apollo.useQuery<PnlExportGroupsQuery, PnlExportGroupsQueryVariables>(PnlExportGroupsDocument, baseOptions);
      }
export function usePnlExportGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PnlExportGroupsQuery, PnlExportGroupsQueryVariables>) {
          return Apollo.useLazyQuery<PnlExportGroupsQuery, PnlExportGroupsQueryVariables>(PnlExportGroupsDocument, baseOptions);
        }
export type PnlExportGroupsQueryHookResult = ReturnType<typeof usePnlExportGroupsQuery>;
export type PnlExportGroupsLazyQueryHookResult = ReturnType<typeof usePnlExportGroupsLazyQuery>;
export type PnlExportGroupsQueryResult = Apollo.QueryResult<PnlExportGroupsQuery, PnlExportGroupsQueryVariables>;
export const PnlExportFileDocument = gql`
    query PnlExportFile($id: ID!) {
  pnlExportFile(id: $id) {
    fileName
    contentType
    contentBase64
  }
}
    `;

/**
 * __usePnlExportFileQuery__
 *
 * To run a query within a React component, call `usePnlExportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `usePnlExportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePnlExportFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePnlExportFileQuery(baseOptions: Apollo.QueryHookOptions<PnlExportFileQuery, PnlExportFileQueryVariables>) {
        return Apollo.useQuery<PnlExportFileQuery, PnlExportFileQueryVariables>(PnlExportFileDocument, baseOptions);
      }
export function usePnlExportFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PnlExportFileQuery, PnlExportFileQueryVariables>) {
          return Apollo.useLazyQuery<PnlExportFileQuery, PnlExportFileQueryVariables>(PnlExportFileDocument, baseOptions);
        }
export type PnlExportFileQueryHookResult = ReturnType<typeof usePnlExportFileQuery>;
export type PnlExportFileLazyQueryHookResult = ReturnType<typeof usePnlExportFileLazyQuery>;
export type PnlExportFileQueryResult = Apollo.QueryResult<PnlExportFileQuery, PnlExportFileQueryVariables>;
export const MailSignaturesListDocument = gql`
    query MailSignaturesList {
  myMailSignatures {
    id
    mailboxEmail
    html
    source
    importedAt
    updatedAt
  }
}
    `;

/**
 * __useMailSignaturesListQuery__
 *
 * To run a query within a React component, call `useMailSignaturesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailSignaturesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailSignaturesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailSignaturesListQuery(baseOptions?: Apollo.QueryHookOptions<MailSignaturesListQuery, MailSignaturesListQueryVariables>) {
        return Apollo.useQuery<MailSignaturesListQuery, MailSignaturesListQueryVariables>(MailSignaturesListDocument, baseOptions);
      }
export function useMailSignaturesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailSignaturesListQuery, MailSignaturesListQueryVariables>) {
          return Apollo.useLazyQuery<MailSignaturesListQuery, MailSignaturesListQueryVariables>(MailSignaturesListDocument, baseOptions);
        }
export type MailSignaturesListQueryHookResult = ReturnType<typeof useMailSignaturesListQuery>;
export type MailSignaturesListLazyQueryHookResult = ReturnType<typeof useMailSignaturesListLazyQuery>;
export type MailSignaturesListQueryResult = Apollo.QueryResult<MailSignaturesListQuery, MailSignaturesListQueryVariables>;
export const RuntimeSettingsListDocument = gql`
    query RuntimeSettingsList($section: String) {
  runtimeSettings(section: $section) {
    ...RuntimeSettingFields
  }
}
    ${RuntimeSettingFieldsFragmentDoc}`;

/**
 * __useRuntimeSettingsListQuery__
 *
 * To run a query within a React component, call `useRuntimeSettingsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuntimeSettingsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuntimeSettingsListQuery({
 *   variables: {
 *      section: // value for 'section'
 *   },
 * });
 */
export function useRuntimeSettingsListQuery(baseOptions?: Apollo.QueryHookOptions<RuntimeSettingsListQuery, RuntimeSettingsListQueryVariables>) {
        return Apollo.useQuery<RuntimeSettingsListQuery, RuntimeSettingsListQueryVariables>(RuntimeSettingsListDocument, baseOptions);
      }
export function useRuntimeSettingsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuntimeSettingsListQuery, RuntimeSettingsListQueryVariables>) {
          return Apollo.useLazyQuery<RuntimeSettingsListQuery, RuntimeSettingsListQueryVariables>(RuntimeSettingsListDocument, baseOptions);
        }
export type RuntimeSettingsListQueryHookResult = ReturnType<typeof useRuntimeSettingsListQuery>;
export type RuntimeSettingsListLazyQueryHookResult = ReturnType<typeof useRuntimeSettingsListLazyQuery>;
export type RuntimeSettingsListQueryResult = Apollo.QueryResult<RuntimeSettingsListQuery, RuntimeSettingsListQueryVariables>;
export const RuntimeSettingSectionsListDocument = gql`
    query RuntimeSettingSectionsList {
  runtimeSettingSections {
    id
    labelRu
    labelPl
  }
}
    `;

/**
 * __useRuntimeSettingSectionsListQuery__
 *
 * To run a query within a React component, call `useRuntimeSettingSectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuntimeSettingSectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuntimeSettingSectionsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRuntimeSettingSectionsListQuery(baseOptions?: Apollo.QueryHookOptions<RuntimeSettingSectionsListQuery, RuntimeSettingSectionsListQueryVariables>) {
        return Apollo.useQuery<RuntimeSettingSectionsListQuery, RuntimeSettingSectionsListQueryVariables>(RuntimeSettingSectionsListDocument, baseOptions);
      }
export function useRuntimeSettingSectionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuntimeSettingSectionsListQuery, RuntimeSettingSectionsListQueryVariables>) {
          return Apollo.useLazyQuery<RuntimeSettingSectionsListQuery, RuntimeSettingSectionsListQueryVariables>(RuntimeSettingSectionsListDocument, baseOptions);
        }
export type RuntimeSettingSectionsListQueryHookResult = ReturnType<typeof useRuntimeSettingSectionsListQuery>;
export type RuntimeSettingSectionsListLazyQueryHookResult = ReturnType<typeof useRuntimeSettingSectionsListLazyQuery>;
export type RuntimeSettingSectionsListQueryResult = Apollo.QueryResult<RuntimeSettingSectionsListQuery, RuntimeSettingSectionsListQueryVariables>;
export const RuntimeSettingHistoryDocument = gql`
    query RuntimeSettingHistory($key: String, $limit: Int) {
  runtimeSettingChanges(key: $key, limit: $limit) {
    id
    key
    old
    new
    reason
    userName
    createdAt
  }
}
    `;

/**
 * __useRuntimeSettingHistoryQuery__
 *
 * To run a query within a React component, call `useRuntimeSettingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuntimeSettingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuntimeSettingHistoryQuery({
 *   variables: {
 *      key: // value for 'key'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRuntimeSettingHistoryQuery(baseOptions?: Apollo.QueryHookOptions<RuntimeSettingHistoryQuery, RuntimeSettingHistoryQueryVariables>) {
        return Apollo.useQuery<RuntimeSettingHistoryQuery, RuntimeSettingHistoryQueryVariables>(RuntimeSettingHistoryDocument, baseOptions);
      }
export function useRuntimeSettingHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuntimeSettingHistoryQuery, RuntimeSettingHistoryQueryVariables>) {
          return Apollo.useLazyQuery<RuntimeSettingHistoryQuery, RuntimeSettingHistoryQueryVariables>(RuntimeSettingHistoryDocument, baseOptions);
        }
export type RuntimeSettingHistoryQueryHookResult = ReturnType<typeof useRuntimeSettingHistoryQuery>;
export type RuntimeSettingHistoryLazyQueryHookResult = ReturnType<typeof useRuntimeSettingHistoryLazyQuery>;
export type RuntimeSettingHistoryQueryResult = Apollo.QueryResult<RuntimeSettingHistoryQuery, RuntimeSettingHistoryQueryVariables>;
export const ScheduledTasksListDocument = gql`
    query ScheduledTasksList {
  scheduledTasks {
    entries {
      name
      task
      domain
      schedule
      keys
      offKeys
      keyStates {
        key
        on
        source
      }
      effectiveOn
      alwaysOn
      periodicTaskEnabled
      lastRunAt
      totalRunCount
      lastSkippedAt
      lastJournalRun {
        ...ScheduledRunFields
      }
    }
    orphans {
      name
      task
      enabled
      schedule
      lastRunAt
      totalRunCount
    }
  }
}
    ${ScheduledRunFieldsFragmentDoc}`;

/**
 * __useScheduledTasksListQuery__
 *
 * To run a query within a React component, call `useScheduledTasksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledTasksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledTasksListQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduledTasksListQuery(baseOptions?: Apollo.QueryHookOptions<ScheduledTasksListQuery, ScheduledTasksListQueryVariables>) {
        return Apollo.useQuery<ScheduledTasksListQuery, ScheduledTasksListQueryVariables>(ScheduledTasksListDocument, baseOptions);
      }
export function useScheduledTasksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledTasksListQuery, ScheduledTasksListQueryVariables>) {
          return Apollo.useLazyQuery<ScheduledTasksListQuery, ScheduledTasksListQueryVariables>(ScheduledTasksListDocument, baseOptions);
        }
export type ScheduledTasksListQueryHookResult = ReturnType<typeof useScheduledTasksListQuery>;
export type ScheduledTasksListLazyQueryHookResult = ReturnType<typeof useScheduledTasksListLazyQuery>;
export type ScheduledTasksListQueryResult = Apollo.QueryResult<ScheduledTasksListQuery, ScheduledTasksListQueryVariables>;
export const MailTemplatesListDocument = gql`
    query MailTemplatesList {
  sendgridTemplates {
    id
    name
    subject
    versionId
  }
}
    `;

/**
 * __useMailTemplatesListQuery__
 *
 * To run a query within a React component, call `useMailTemplatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailTemplatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailTemplatesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailTemplatesListQuery(baseOptions?: Apollo.QueryHookOptions<MailTemplatesListQuery, MailTemplatesListQueryVariables>) {
        return Apollo.useQuery<MailTemplatesListQuery, MailTemplatesListQueryVariables>(MailTemplatesListDocument, baseOptions);
      }
export function useMailTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailTemplatesListQuery, MailTemplatesListQueryVariables>) {
          return Apollo.useLazyQuery<MailTemplatesListQuery, MailTemplatesListQueryVariables>(MailTemplatesListDocument, baseOptions);
        }
export type MailTemplatesListQueryHookResult = ReturnType<typeof useMailTemplatesListQuery>;
export type MailTemplatesListLazyQueryHookResult = ReturnType<typeof useMailTemplatesListLazyQuery>;
export type MailTemplatesListQueryResult = Apollo.QueryResult<MailTemplatesListQuery, MailTemplatesListQueryVariables>;
export const MailGroupContactListDocument = gql`
    query MailGroupContactList($groupId: ID!) {
  sendgridGroupList(groupId: $groupId) {
    id
    sendgridListId
    name
    contactCount
    lastSyncStatus
    lastSyncedAt
    errorMessage
  }
}
    `;

/**
 * __useMailGroupContactListQuery__
 *
 * To run a query within a React component, call `useMailGroupContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailGroupContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailGroupContactListQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useMailGroupContactListQuery(baseOptions: Apollo.QueryHookOptions<MailGroupContactListQuery, MailGroupContactListQueryVariables>) {
        return Apollo.useQuery<MailGroupContactListQuery, MailGroupContactListQueryVariables>(MailGroupContactListDocument, baseOptions);
      }
export function useMailGroupContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailGroupContactListQuery, MailGroupContactListQueryVariables>) {
          return Apollo.useLazyQuery<MailGroupContactListQuery, MailGroupContactListQueryVariables>(MailGroupContactListDocument, baseOptions);
        }
export type MailGroupContactListQueryHookResult = ReturnType<typeof useMailGroupContactListQuery>;
export type MailGroupContactListLazyQueryHookResult = ReturnType<typeof useMailGroupContactListLazyQuery>;
export type MailGroupContactListQueryResult = Apollo.QueryResult<MailGroupContactListQuery, MailGroupContactListQueryVariables>;
export const MailCandidatesListDocument = gql`
    query MailCandidatesList($groupId: ID!, $mode: String, $includeTerminated: Boolean) {
  groupMailCandidates(
    groupId: $groupId
    mode: $mode
    includeTerminated: $includeTerminated
  ) {
    studentId
    studentName
    email
    agreementTitle
    agreementTerminated
    invoiceId
    invoiceNumber
    invoiceIssueDate
    invoiceDueDate
    invoiceOutstanding
    invoiceCurrency
    invoiceUrl
    isOverdue
    daysOverdue
    lastMailedAt
  }
}
    `;

/**
 * __useMailCandidatesListQuery__
 *
 * To run a query within a React component, call `useMailCandidatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailCandidatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailCandidatesListQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      mode: // value for 'mode'
 *      includeTerminated: // value for 'includeTerminated'
 *   },
 * });
 */
export function useMailCandidatesListQuery(baseOptions: Apollo.QueryHookOptions<MailCandidatesListQuery, MailCandidatesListQueryVariables>) {
        return Apollo.useQuery<MailCandidatesListQuery, MailCandidatesListQueryVariables>(MailCandidatesListDocument, baseOptions);
      }
export function useMailCandidatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailCandidatesListQuery, MailCandidatesListQueryVariables>) {
          return Apollo.useLazyQuery<MailCandidatesListQuery, MailCandidatesListQueryVariables>(MailCandidatesListDocument, baseOptions);
        }
export type MailCandidatesListQueryHookResult = ReturnType<typeof useMailCandidatesListQuery>;
export type MailCandidatesListLazyQueryHookResult = ReturnType<typeof useMailCandidatesListLazyQuery>;
export type MailCandidatesListQueryResult = Apollo.QueryResult<MailCandidatesListQuery, MailCandidatesListQueryVariables>;
export const MailJobProgressDocument = gql`
    query MailJobProgress($id: ID!) {
  mailJob(id: $id) {
    id
    status
    templateName
    total
    sentCount
    failedCount
    deliveredCount
    openedCount
    clickedCount
    bouncedCount
    errorMessage
    createdAt
    finishedAt
    createdByName
    recipients {
      id
      studentName
      email
      status
      reason
      invoiceNumber
      deliveredAt
      firstOpenedAt
      openCount
      firstClickedAt
      clickCount
      lastClickUrl
      bouncedAt
      bounceReason
      droppedAt
      dropReason
      unsubscribedAt
    }
  }
}
    `;

/**
 * __useMailJobProgressQuery__
 *
 * To run a query within a React component, call `useMailJobProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailJobProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailJobProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMailJobProgressQuery(baseOptions: Apollo.QueryHookOptions<MailJobProgressQuery, MailJobProgressQueryVariables>) {
        return Apollo.useQuery<MailJobProgressQuery, MailJobProgressQueryVariables>(MailJobProgressDocument, baseOptions);
      }
export function useMailJobProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailJobProgressQuery, MailJobProgressQueryVariables>) {
          return Apollo.useLazyQuery<MailJobProgressQuery, MailJobProgressQueryVariables>(MailJobProgressDocument, baseOptions);
        }
export type MailJobProgressQueryHookResult = ReturnType<typeof useMailJobProgressQuery>;
export type MailJobProgressLazyQueryHookResult = ReturnType<typeof useMailJobProgressLazyQuery>;
export type MailJobProgressQueryResult = Apollo.QueryResult<MailJobProgressQuery, MailJobProgressQueryVariables>;
export const MailJobsHistoryDocument = gql`
    query MailJobsHistory($groupId: ID!, $limit: Int) {
  mailJobs(groupId: $groupId, limit: $limit) {
    id
    status
    templateName
    total
    sentCount
    failedCount
    deliveredCount
    openedCount
    clickedCount
    bouncedCount
    createdAt
    finishedAt
    createdByName
    recipients {
      id
      studentName
      email
      status
      reason
      deliveredAt
      firstOpenedAt
      openCount
      firstClickedAt
      clickCount
      lastClickUrl
      droppedAt
      dropReason
    }
  }
}
    `;

/**
 * __useMailJobsHistoryQuery__
 *
 * To run a query within a React component, call `useMailJobsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailJobsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailJobsHistoryQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMailJobsHistoryQuery(baseOptions: Apollo.QueryHookOptions<MailJobsHistoryQuery, MailJobsHistoryQueryVariables>) {
        return Apollo.useQuery<MailJobsHistoryQuery, MailJobsHistoryQueryVariables>(MailJobsHistoryDocument, baseOptions);
      }
export function useMailJobsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailJobsHistoryQuery, MailJobsHistoryQueryVariables>) {
          return Apollo.useLazyQuery<MailJobsHistoryQuery, MailJobsHistoryQueryVariables>(MailJobsHistoryDocument, baseOptions);
        }
export type MailJobsHistoryQueryHookResult = ReturnType<typeof useMailJobsHistoryQuery>;
export type MailJobsHistoryLazyQueryHookResult = ReturnType<typeof useMailJobsHistoryLazyQuery>;
export type MailJobsHistoryQueryResult = Apollo.QueryResult<MailJobsHistoryQuery, MailJobsHistoryQueryVariables>;
export const SettingsMetaDocument = gql`
    query settingsMeta($withGroups: Boolean!) {
  metaCourses {
    totalCount
  }
  metaGroups @include(if: $withGroups) {
    totalCount
  }
}
    `;

/**
 * __useSettingsMetaQuery__
 *
 * To run a query within a React component, call `useSettingsMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsMetaQuery({
 *   variables: {
 *      withGroups: // value for 'withGroups'
 *   },
 * });
 */
export function useSettingsMetaQuery(baseOptions: Apollo.QueryHookOptions<SettingsMetaQuery, SettingsMetaQueryVariables>) {
        return Apollo.useQuery<SettingsMetaQuery, SettingsMetaQueryVariables>(SettingsMetaDocument, baseOptions);
      }
export function useSettingsMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsMetaQuery, SettingsMetaQueryVariables>) {
          return Apollo.useLazyQuery<SettingsMetaQuery, SettingsMetaQueryVariables>(SettingsMetaDocument, baseOptions);
        }
export type SettingsMetaQueryHookResult = ReturnType<typeof useSettingsMetaQuery>;
export type SettingsMetaLazyQueryHookResult = ReturnType<typeof useSettingsMetaLazyQuery>;
export type SettingsMetaQueryResult = Apollo.QueryResult<SettingsMetaQuery, SettingsMetaQueryVariables>;
export const ShortLinkSettingsInfoDocument = gql`
    query ShortLinkSettingsInfo {
  shortLinkSettings {
    enabled
    baseUrl
  }
}
    `;

/**
 * __useShortLinkSettingsInfoQuery__
 *
 * To run a query within a React component, call `useShortLinkSettingsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortLinkSettingsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortLinkSettingsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useShortLinkSettingsInfoQuery(baseOptions?: Apollo.QueryHookOptions<ShortLinkSettingsInfoQuery, ShortLinkSettingsInfoQueryVariables>) {
        return Apollo.useQuery<ShortLinkSettingsInfoQuery, ShortLinkSettingsInfoQueryVariables>(ShortLinkSettingsInfoDocument, baseOptions);
      }
export function useShortLinkSettingsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortLinkSettingsInfoQuery, ShortLinkSettingsInfoQueryVariables>) {
          return Apollo.useLazyQuery<ShortLinkSettingsInfoQuery, ShortLinkSettingsInfoQueryVariables>(ShortLinkSettingsInfoDocument, baseOptions);
        }
export type ShortLinkSettingsInfoQueryHookResult = ReturnType<typeof useShortLinkSettingsInfoQuery>;
export type ShortLinkSettingsInfoLazyQueryHookResult = ReturnType<typeof useShortLinkSettingsInfoLazyQuery>;
export type ShortLinkSettingsInfoQueryResult = Apollo.QueryResult<ShortLinkSettingsInfoQuery, ShortLinkSettingsInfoQueryVariables>;
export const ShortLinkListDocument = gql`
    query ShortLinkList($search: String, $kind: String, $state: String, $mine: Boolean, $channel: String, $tag: String, $createdById: ID, $createdFrom: Date, $createdTo: Date, $clicks: String, $orderBy: String, $limit: Int, $offset: Int) {
  shortLinks(
    search: $search
    kind: $kind
    state: $state
    mine: $mine
    channel: $channel
    tag: $tag
    createdById: $createdById
    createdFrom: $createdFrom
    createdTo: $createdTo
    clicks: $clicks
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    ...ShortLinkFields
  }
  shortLinkSummary(
    search: $search
    kind: $kind
    state: $state
    mine: $mine
    channel: $channel
    tag: $tag
    createdById: $createdById
    createdFrom: $createdFrom
    createdTo: $createdTo
    clicks: $clicks
  ) {
    total
    live
    humanClicks
    clicks
  }
}
    ${ShortLinkFieldsFragmentDoc}`;

/**
 * __useShortLinkListQuery__
 *
 * To run a query within a React component, call `useShortLinkListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortLinkListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortLinkListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      kind: // value for 'kind'
 *      state: // value for 'state'
 *      mine: // value for 'mine'
 *      channel: // value for 'channel'
 *      tag: // value for 'tag'
 *      createdById: // value for 'createdById'
 *      createdFrom: // value for 'createdFrom'
 *      createdTo: // value for 'createdTo'
 *      clicks: // value for 'clicks'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useShortLinkListQuery(baseOptions?: Apollo.QueryHookOptions<ShortLinkListQuery, ShortLinkListQueryVariables>) {
        return Apollo.useQuery<ShortLinkListQuery, ShortLinkListQueryVariables>(ShortLinkListDocument, baseOptions);
      }
export function useShortLinkListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortLinkListQuery, ShortLinkListQueryVariables>) {
          return Apollo.useLazyQuery<ShortLinkListQuery, ShortLinkListQueryVariables>(ShortLinkListDocument, baseOptions);
        }
export type ShortLinkListQueryHookResult = ReturnType<typeof useShortLinkListQuery>;
export type ShortLinkListLazyQueryHookResult = ReturnType<typeof useShortLinkListLazyQuery>;
export type ShortLinkListQueryResult = Apollo.QueryResult<ShortLinkListQuery, ShortLinkListQueryVariables>;
export const ShortLinkExportPageDocument = gql`
    query ShortLinkExportPage($search: String, $kind: String, $state: String, $mine: Boolean, $channel: String, $tag: String, $createdById: ID, $createdFrom: Date, $createdTo: Date, $clicks: String, $orderBy: String, $limit: Int, $offset: Int) {
  shortLinks(
    search: $search
    kind: $kind
    state: $state
    mine: $mine
    channel: $channel
    tag: $tag
    createdById: $createdById
    createdFrom: $createdFrom
    createdTo: $createdTo
    clicks: $clicks
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    ...ShortLinkFields
  }
}
    ${ShortLinkFieldsFragmentDoc}`;

/**
 * __useShortLinkExportPageQuery__
 *
 * To run a query within a React component, call `useShortLinkExportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortLinkExportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortLinkExportPageQuery({
 *   variables: {
 *      search: // value for 'search'
 *      kind: // value for 'kind'
 *      state: // value for 'state'
 *      mine: // value for 'mine'
 *      channel: // value for 'channel'
 *      tag: // value for 'tag'
 *      createdById: // value for 'createdById'
 *      createdFrom: // value for 'createdFrom'
 *      createdTo: // value for 'createdTo'
 *      clicks: // value for 'clicks'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useShortLinkExportPageQuery(baseOptions?: Apollo.QueryHookOptions<ShortLinkExportPageQuery, ShortLinkExportPageQueryVariables>) {
        return Apollo.useQuery<ShortLinkExportPageQuery, ShortLinkExportPageQueryVariables>(ShortLinkExportPageDocument, baseOptions);
      }
export function useShortLinkExportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortLinkExportPageQuery, ShortLinkExportPageQueryVariables>) {
          return Apollo.useLazyQuery<ShortLinkExportPageQuery, ShortLinkExportPageQueryVariables>(ShortLinkExportPageDocument, baseOptions);
        }
export type ShortLinkExportPageQueryHookResult = ReturnType<typeof useShortLinkExportPageQuery>;
export type ShortLinkExportPageLazyQueryHookResult = ReturnType<typeof useShortLinkExportPageLazyQuery>;
export type ShortLinkExportPageQueryResult = Apollo.QueryResult<ShortLinkExportPageQuery, ShortLinkExportPageQueryVariables>;
export const ShortLinkFacetListDocument = gql`
    query ShortLinkFacetList {
  shortLinkFacets {
    channels
    tags
    authors {
      id
      name
    }
  }
}
    `;

/**
 * __useShortLinkFacetListQuery__
 *
 * To run a query within a React component, call `useShortLinkFacetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortLinkFacetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortLinkFacetListQuery({
 *   variables: {
 *   },
 * });
 */
export function useShortLinkFacetListQuery(baseOptions?: Apollo.QueryHookOptions<ShortLinkFacetListQuery, ShortLinkFacetListQueryVariables>) {
        return Apollo.useQuery<ShortLinkFacetListQuery, ShortLinkFacetListQueryVariables>(ShortLinkFacetListDocument, baseOptions);
      }
export function useShortLinkFacetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortLinkFacetListQuery, ShortLinkFacetListQueryVariables>) {
          return Apollo.useLazyQuery<ShortLinkFacetListQuery, ShortLinkFacetListQueryVariables>(ShortLinkFacetListDocument, baseOptions);
        }
export type ShortLinkFacetListQueryHookResult = ReturnType<typeof useShortLinkFacetListQuery>;
export type ShortLinkFacetListLazyQueryHookResult = ReturnType<typeof useShortLinkFacetListLazyQuery>;
export type ShortLinkFacetListQueryResult = Apollo.QueryResult<ShortLinkFacetListQuery, ShortLinkFacetListQueryVariables>;
export const ShortLinkCardDocument = gql`
    query ShortLinkCard($id: ID!) {
  shortLink(id: $id) {
    ...ShortLinkFields
  }
}
    ${ShortLinkFieldsFragmentDoc}`;

/**
 * __useShortLinkCardQuery__
 *
 * To run a query within a React component, call `useShortLinkCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortLinkCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortLinkCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShortLinkCardQuery(baseOptions: Apollo.QueryHookOptions<ShortLinkCardQuery, ShortLinkCardQueryVariables>) {
        return Apollo.useQuery<ShortLinkCardQuery, ShortLinkCardQueryVariables>(ShortLinkCardDocument, baseOptions);
      }
export function useShortLinkCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortLinkCardQuery, ShortLinkCardQueryVariables>) {
          return Apollo.useLazyQuery<ShortLinkCardQuery, ShortLinkCardQueryVariables>(ShortLinkCardDocument, baseOptions);
        }
export type ShortLinkCardQueryHookResult = ReturnType<typeof useShortLinkCardQuery>;
export type ShortLinkCardLazyQueryHookResult = ReturnType<typeof useShortLinkCardLazyQuery>;
export type ShortLinkCardQueryResult = Apollo.QueryResult<ShortLinkCardQuery, ShortLinkCardQueryVariables>;
export const ShortLinkDailyClickListDocument = gql`
    query ShortLinkDailyClickList($id: ID!, $days: Int) {
  shortLinkDailyClicks(id: $id, days: $days) {
    date
    human
    total
  }
}
    `;

/**
 * __useShortLinkDailyClickListQuery__
 *
 * To run a query within a React component, call `useShortLinkDailyClickListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortLinkDailyClickListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortLinkDailyClickListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useShortLinkDailyClickListQuery(baseOptions: Apollo.QueryHookOptions<ShortLinkDailyClickListQuery, ShortLinkDailyClickListQueryVariables>) {
        return Apollo.useQuery<ShortLinkDailyClickListQuery, ShortLinkDailyClickListQueryVariables>(ShortLinkDailyClickListDocument, baseOptions);
      }
export function useShortLinkDailyClickListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortLinkDailyClickListQuery, ShortLinkDailyClickListQueryVariables>) {
          return Apollo.useLazyQuery<ShortLinkDailyClickListQuery, ShortLinkDailyClickListQueryVariables>(ShortLinkDailyClickListDocument, baseOptions);
        }
export type ShortLinkDailyClickListQueryHookResult = ReturnType<typeof useShortLinkDailyClickListQuery>;
export type ShortLinkDailyClickListLazyQueryHookResult = ReturnType<typeof useShortLinkDailyClickListLazyQuery>;
export type ShortLinkDailyClickListQueryResult = Apollo.QueryResult<ShortLinkDailyClickListQuery, ShortLinkDailyClickListQueryVariables>;
export const ShortLinkClickListDocument = gql`
    query ShortLinkClickList($id: ID!, $limit: Int) {
  shortLinkClicks(id: $id, limit: $limit) {
    id
    clickedAt
    human
    counted
    isBot
    source
  }
}
    `;

/**
 * __useShortLinkClickListQuery__
 *
 * To run a query within a React component, call `useShortLinkClickListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortLinkClickListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortLinkClickListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useShortLinkClickListQuery(baseOptions: Apollo.QueryHookOptions<ShortLinkClickListQuery, ShortLinkClickListQueryVariables>) {
        return Apollo.useQuery<ShortLinkClickListQuery, ShortLinkClickListQueryVariables>(ShortLinkClickListDocument, baseOptions);
      }
export function useShortLinkClickListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortLinkClickListQuery, ShortLinkClickListQueryVariables>) {
          return Apollo.useLazyQuery<ShortLinkClickListQuery, ShortLinkClickListQueryVariables>(ShortLinkClickListDocument, baseOptions);
        }
export type ShortLinkClickListQueryHookResult = ReturnType<typeof useShortLinkClickListQuery>;
export type ShortLinkClickListLazyQueryHookResult = ReturnType<typeof useShortLinkClickListLazyQuery>;
export type ShortLinkClickListQueryResult = Apollo.QueryResult<ShortLinkClickListQuery, ShortLinkClickListQueryVariables>;
export const SmsJournalPageDocument = gql`
    query SmsJournalPage($topic: String, $status: String, $dlrStatus: String, $studentId: ID, $groupId: ID, $teacherId: ID, $contractId: ID, $campaignId: ID, $createdById: ID, $createdFrom: Date, $createdTo: Date, $phoneTail: String, $search: String, $leadId: ID, $candidateId: ID, $offset: Int, $limit: Int) {
  smsJournal(
    topic: $topic
    status: $status
    dlrStatus: $dlrStatus
    studentId: $studentId
    groupId: $groupId
    teacherId: $teacherId
    contractId: $contractId
    campaignId: $campaignId
    createdById: $createdById
    createdFrom: $createdFrom
    createdTo: $createdTo
    phoneTail: $phoneTail
    search: $search
    leadId: $leadId
    candidateId: $candidateId
    offset: $offset
    limit: $limit
  ) {
    total
    totalCost
    totalSegments
    items {
      ...SmsMessageFields
    }
  }
}
    ${SmsMessageFieldsFragmentDoc}`;

/**
 * __useSmsJournalPageQuery__
 *
 * To run a query within a React component, call `useSmsJournalPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsJournalPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsJournalPageQuery({
 *   variables: {
 *      topic: // value for 'topic'
 *      status: // value for 'status'
 *      dlrStatus: // value for 'dlrStatus'
 *      studentId: // value for 'studentId'
 *      groupId: // value for 'groupId'
 *      teacherId: // value for 'teacherId'
 *      contractId: // value for 'contractId'
 *      campaignId: // value for 'campaignId'
 *      createdById: // value for 'createdById'
 *      createdFrom: // value for 'createdFrom'
 *      createdTo: // value for 'createdTo'
 *      phoneTail: // value for 'phoneTail'
 *      search: // value for 'search'
 *      leadId: // value for 'leadId'
 *      candidateId: // value for 'candidateId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSmsJournalPageQuery(baseOptions?: Apollo.QueryHookOptions<SmsJournalPageQuery, SmsJournalPageQueryVariables>) {
        return Apollo.useQuery<SmsJournalPageQuery, SmsJournalPageQueryVariables>(SmsJournalPageDocument, baseOptions);
      }
export function useSmsJournalPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsJournalPageQuery, SmsJournalPageQueryVariables>) {
          return Apollo.useLazyQuery<SmsJournalPageQuery, SmsJournalPageQueryVariables>(SmsJournalPageDocument, baseOptions);
        }
export type SmsJournalPageQueryHookResult = ReturnType<typeof useSmsJournalPageQuery>;
export type SmsJournalPageLazyQueryHookResult = ReturnType<typeof useSmsJournalPageLazyQuery>;
export type SmsJournalPageQueryResult = Apollo.QueryResult<SmsJournalPageQuery, SmsJournalPageQueryVariables>;
export const SmsJournalFilterOptionsDocument = gql`
    query SmsJournalFilterOptions {
  smsJournalFacets {
    topics
    authors {
      id
      name
    }
    campaigns {
      id
      title
    }
  }
}
    `;

/**
 * __useSmsJournalFilterOptionsQuery__
 *
 * To run a query within a React component, call `useSmsJournalFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsJournalFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsJournalFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSmsJournalFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SmsJournalFilterOptionsQuery, SmsJournalFilterOptionsQueryVariables>) {
        return Apollo.useQuery<SmsJournalFilterOptionsQuery, SmsJournalFilterOptionsQueryVariables>(SmsJournalFilterOptionsDocument, baseOptions);
      }
export function useSmsJournalFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsJournalFilterOptionsQuery, SmsJournalFilterOptionsQueryVariables>) {
          return Apollo.useLazyQuery<SmsJournalFilterOptionsQuery, SmsJournalFilterOptionsQueryVariables>(SmsJournalFilterOptionsDocument, baseOptions);
        }
export type SmsJournalFilterOptionsQueryHookResult = ReturnType<typeof useSmsJournalFilterOptionsQuery>;
export type SmsJournalFilterOptionsLazyQueryHookResult = ReturnType<typeof useSmsJournalFilterOptionsLazyQuery>;
export type SmsJournalFilterOptionsQueryResult = Apollo.QueryResult<SmsJournalFilterOptionsQuery, SmsJournalFilterOptionsQueryVariables>;
export const StudentSmsStateDocument = gql`
    query StudentSmsState($studentId: ID!) {
  studentSms(studentId: $studentId) {
    ...StudentSmsStateFields
  }
}
    ${StudentSmsStateFieldsFragmentDoc}`;

/**
 * __useStudentSmsStateQuery__
 *
 * To run a query within a React component, call `useStudentSmsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSmsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSmsStateQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentSmsStateQuery(baseOptions: Apollo.QueryHookOptions<StudentSmsStateQuery, StudentSmsStateQueryVariables>) {
        return Apollo.useQuery<StudentSmsStateQuery, StudentSmsStateQueryVariables>(StudentSmsStateDocument, baseOptions);
      }
export function useStudentSmsStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentSmsStateQuery, StudentSmsStateQueryVariables>) {
          return Apollo.useLazyQuery<StudentSmsStateQuery, StudentSmsStateQueryVariables>(StudentSmsStateDocument, baseOptions);
        }
export type StudentSmsStateQueryHookResult = ReturnType<typeof useStudentSmsStateQuery>;
export type StudentSmsStateLazyQueryHookResult = ReturnType<typeof useStudentSmsStateLazyQuery>;
export type StudentSmsStateQueryResult = Apollo.QueryResult<StudentSmsStateQuery, StudentSmsStateQueryVariables>;
export const StudentSmsPreviewDocument = gql`
    query StudentSmsPreview($studentId: ID!, $text: String!, $link: SmsLinkInput) {
  previewStudentSms(studentId: $studentId, text: $text, link: $link) {
    ...SmsPreviewFields
  }
}
    ${SmsPreviewFieldsFragmentDoc}`;

/**
 * __useStudentSmsPreviewQuery__
 *
 * To run a query within a React component, call `useStudentSmsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSmsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSmsPreviewQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      text: // value for 'text'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useStudentSmsPreviewQuery(baseOptions: Apollo.QueryHookOptions<StudentSmsPreviewQuery, StudentSmsPreviewQueryVariables>) {
        return Apollo.useQuery<StudentSmsPreviewQuery, StudentSmsPreviewQueryVariables>(StudentSmsPreviewDocument, baseOptions);
      }
export function useStudentSmsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentSmsPreviewQuery, StudentSmsPreviewQueryVariables>) {
          return Apollo.useLazyQuery<StudentSmsPreviewQuery, StudentSmsPreviewQueryVariables>(StudentSmsPreviewDocument, baseOptions);
        }
export type StudentSmsPreviewQueryHookResult = ReturnType<typeof useStudentSmsPreviewQuery>;
export type StudentSmsPreviewLazyQueryHookResult = ReturnType<typeof useStudentSmsPreviewLazyQuery>;
export type StudentSmsPreviewQueryResult = Apollo.QueryResult<StudentSmsPreviewQuery, StudentSmsPreviewQueryVariables>;
export const TeacherSmsStateDocument = gql`
    query TeacherSmsState($teacherId: ID!) {
  teacherSms(teacherId: $teacherId) {
    ...TeacherSmsStateFields
  }
}
    ${TeacherSmsStateFieldsFragmentDoc}`;

/**
 * __useTeacherSmsStateQuery__
 *
 * To run a query within a React component, call `useTeacherSmsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherSmsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherSmsStateQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useTeacherSmsStateQuery(baseOptions: Apollo.QueryHookOptions<TeacherSmsStateQuery, TeacherSmsStateQueryVariables>) {
        return Apollo.useQuery<TeacherSmsStateQuery, TeacherSmsStateQueryVariables>(TeacherSmsStateDocument, baseOptions);
      }
export function useTeacherSmsStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherSmsStateQuery, TeacherSmsStateQueryVariables>) {
          return Apollo.useLazyQuery<TeacherSmsStateQuery, TeacherSmsStateQueryVariables>(TeacherSmsStateDocument, baseOptions);
        }
export type TeacherSmsStateQueryHookResult = ReturnType<typeof useTeacherSmsStateQuery>;
export type TeacherSmsStateLazyQueryHookResult = ReturnType<typeof useTeacherSmsStateLazyQuery>;
export type TeacherSmsStateQueryResult = Apollo.QueryResult<TeacherSmsStateQuery, TeacherSmsStateQueryVariables>;
export const TeacherSmsPreviewDocument = gql`
    query TeacherSmsPreview($teacherId: ID!, $text: String!, $link: TeacherSmsLinkInput) {
  previewTeacherSms(teacherId: $teacherId, text: $text, link: $link) {
    ...SmsPreviewFields
  }
}
    ${SmsPreviewFieldsFragmentDoc}`;

/**
 * __useTeacherSmsPreviewQuery__
 *
 * To run a query within a React component, call `useTeacherSmsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherSmsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherSmsPreviewQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      text: // value for 'text'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useTeacherSmsPreviewQuery(baseOptions: Apollo.QueryHookOptions<TeacherSmsPreviewQuery, TeacherSmsPreviewQueryVariables>) {
        return Apollo.useQuery<TeacherSmsPreviewQuery, TeacherSmsPreviewQueryVariables>(TeacherSmsPreviewDocument, baseOptions);
      }
export function useTeacherSmsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherSmsPreviewQuery, TeacherSmsPreviewQueryVariables>) {
          return Apollo.useLazyQuery<TeacherSmsPreviewQuery, TeacherSmsPreviewQueryVariables>(TeacherSmsPreviewDocument, baseOptions);
        }
export type TeacherSmsPreviewQueryHookResult = ReturnType<typeof useTeacherSmsPreviewQuery>;
export type TeacherSmsPreviewLazyQueryHookResult = ReturnType<typeof useTeacherSmsPreviewLazyQuery>;
export type TeacherSmsPreviewQueryResult = Apollo.QueryResult<TeacherSmsPreviewQuery, TeacherSmsPreviewQueryVariables>;
export const GroupSmsCandidatesDocument = gql`
    query GroupSmsCandidates($groupId: ID!, $mode: String) {
  smsCampaignCandidates(groupId: $groupId, mode: $mode) {
    studentId
    studentName
    phoneMasked
    reason
    invoiceId
    invoiceNumber
    amount
    currency
    dueDate
  }
}
    `;

/**
 * __useGroupSmsCandidatesQuery__
 *
 * To run a query within a React component, call `useGroupSmsCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupSmsCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupSmsCandidatesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useGroupSmsCandidatesQuery(baseOptions: Apollo.QueryHookOptions<GroupSmsCandidatesQuery, GroupSmsCandidatesQueryVariables>) {
        return Apollo.useQuery<GroupSmsCandidatesQuery, GroupSmsCandidatesQueryVariables>(GroupSmsCandidatesDocument, baseOptions);
      }
export function useGroupSmsCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupSmsCandidatesQuery, GroupSmsCandidatesQueryVariables>) {
          return Apollo.useLazyQuery<GroupSmsCandidatesQuery, GroupSmsCandidatesQueryVariables>(GroupSmsCandidatesDocument, baseOptions);
        }
export type GroupSmsCandidatesQueryHookResult = ReturnType<typeof useGroupSmsCandidatesQuery>;
export type GroupSmsCandidatesLazyQueryHookResult = ReturnType<typeof useGroupSmsCandidatesLazyQuery>;
export type GroupSmsCandidatesQueryResult = Apollo.QueryResult<GroupSmsCandidatesQuery, GroupSmsCandidatesQueryVariables>;
export const GroupSmsPreviewDocument = gql`
    query GroupSmsPreview($groupId: ID!, $text: String!, $link: SmsLinkInput, $mode: String, $studentIds: [ID!]) {
  previewSmsCampaign(
    groupId: $groupId
    text: $text
    link: $link
    mode: $mode
    studentIds: $studentIds
  ) {
    sample {
      ...SmsPreviewFields
    }
    recipients
    excluded
    total
    reason
    message
  }
}
    ${SmsPreviewFieldsFragmentDoc}`;

/**
 * __useGroupSmsPreviewQuery__
 *
 * To run a query within a React component, call `useGroupSmsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupSmsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupSmsPreviewQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      text: // value for 'text'
 *      link: // value for 'link'
 *      mode: // value for 'mode'
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useGroupSmsPreviewQuery(baseOptions: Apollo.QueryHookOptions<GroupSmsPreviewQuery, GroupSmsPreviewQueryVariables>) {
        return Apollo.useQuery<GroupSmsPreviewQuery, GroupSmsPreviewQueryVariables>(GroupSmsPreviewDocument, baseOptions);
      }
export function useGroupSmsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupSmsPreviewQuery, GroupSmsPreviewQueryVariables>) {
          return Apollo.useLazyQuery<GroupSmsPreviewQuery, GroupSmsPreviewQueryVariables>(GroupSmsPreviewDocument, baseOptions);
        }
export type GroupSmsPreviewQueryHookResult = ReturnType<typeof useGroupSmsPreviewQuery>;
export type GroupSmsPreviewLazyQueryHookResult = ReturnType<typeof useGroupSmsPreviewLazyQuery>;
export type GroupSmsPreviewQueryResult = Apollo.QueryResult<GroupSmsPreviewQuery, GroupSmsPreviewQueryVariables>;
export const GroupSmsCampaignsDocument = gql`
    query GroupSmsCampaigns($groupId: ID) {
  smsCampaigns(groupId: $groupId) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;

/**
 * __useGroupSmsCampaignsQuery__
 *
 * To run a query within a React component, call `useGroupSmsCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupSmsCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupSmsCampaignsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupSmsCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GroupSmsCampaignsQuery, GroupSmsCampaignsQueryVariables>) {
        return Apollo.useQuery<GroupSmsCampaignsQuery, GroupSmsCampaignsQueryVariables>(GroupSmsCampaignsDocument, baseOptions);
      }
export function useGroupSmsCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupSmsCampaignsQuery, GroupSmsCampaignsQueryVariables>) {
          return Apollo.useLazyQuery<GroupSmsCampaignsQuery, GroupSmsCampaignsQueryVariables>(GroupSmsCampaignsDocument, baseOptions);
        }
export type GroupSmsCampaignsQueryHookResult = ReturnType<typeof useGroupSmsCampaignsQuery>;
export type GroupSmsCampaignsLazyQueryHookResult = ReturnType<typeof useGroupSmsCampaignsLazyQuery>;
export type GroupSmsCampaignsQueryResult = Apollo.QueryResult<GroupSmsCampaignsQuery, GroupSmsCampaignsQueryVariables>;
export const SmsCampaignProgressDocument = gql`
    query SmsCampaignProgress($id: ID!) {
  smsCampaign(id: $id) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;

/**
 * __useSmsCampaignProgressQuery__
 *
 * To run a query within a React component, call `useSmsCampaignProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsCampaignProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsCampaignProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSmsCampaignProgressQuery(baseOptions: Apollo.QueryHookOptions<SmsCampaignProgressQuery, SmsCampaignProgressQueryVariables>) {
        return Apollo.useQuery<SmsCampaignProgressQuery, SmsCampaignProgressQueryVariables>(SmsCampaignProgressDocument, baseOptions);
      }
export function useSmsCampaignProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsCampaignProgressQuery, SmsCampaignProgressQueryVariables>) {
          return Apollo.useLazyQuery<SmsCampaignProgressQuery, SmsCampaignProgressQueryVariables>(SmsCampaignProgressDocument, baseOptions);
        }
export type SmsCampaignProgressQueryHookResult = ReturnType<typeof useSmsCampaignProgressQuery>;
export type SmsCampaignProgressLazyQueryHookResult = ReturnType<typeof useSmsCampaignProgressLazyQuery>;
export type SmsCampaignProgressQueryResult = Apollo.QueryResult<SmsCampaignProgressQuery, SmsCampaignProgressQueryVariables>;
export const SmsSettingsViewDocument = gql`
    query SmsSettingsView {
  smsSettings {
    ...SmsSettingsFields
  }
}
    ${SmsSettingsFieldsFragmentDoc}`;

/**
 * __useSmsSettingsViewQuery__
 *
 * To run a query within a React component, call `useSmsSettingsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsSettingsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsSettingsViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useSmsSettingsViewQuery(baseOptions?: Apollo.QueryHookOptions<SmsSettingsViewQuery, SmsSettingsViewQueryVariables>) {
        return Apollo.useQuery<SmsSettingsViewQuery, SmsSettingsViewQueryVariables>(SmsSettingsViewDocument, baseOptions);
      }
export function useSmsSettingsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsSettingsViewQuery, SmsSettingsViewQueryVariables>) {
          return Apollo.useLazyQuery<SmsSettingsViewQuery, SmsSettingsViewQueryVariables>(SmsSettingsViewDocument, baseOptions);
        }
export type SmsSettingsViewQueryHookResult = ReturnType<typeof useSmsSettingsViewQuery>;
export type SmsSettingsViewLazyQueryHookResult = ReturnType<typeof useSmsSettingsViewLazyQuery>;
export type SmsSettingsViewQueryResult = Apollo.QueryResult<SmsSettingsViewQuery, SmsSettingsViewQueryVariables>;
export const LinkAddressesViewDocument = gql`
    query LinkAddressesView {
  linkAddresses {
    ...LinkAddressesFields
  }
}
    ${LinkAddressesFieldsFragmentDoc}`;

/**
 * __useLinkAddressesViewQuery__
 *
 * To run a query within a React component, call `useLinkAddressesViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkAddressesViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkAddressesViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinkAddressesViewQuery(baseOptions?: Apollo.QueryHookOptions<LinkAddressesViewQuery, LinkAddressesViewQueryVariables>) {
        return Apollo.useQuery<LinkAddressesViewQuery, LinkAddressesViewQueryVariables>(LinkAddressesViewDocument, baseOptions);
      }
export function useLinkAddressesViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkAddressesViewQuery, LinkAddressesViewQueryVariables>) {
          return Apollo.useLazyQuery<LinkAddressesViewQuery, LinkAddressesViewQueryVariables>(LinkAddressesViewDocument, baseOptions);
        }
export type LinkAddressesViewQueryHookResult = ReturnType<typeof useLinkAddressesViewQuery>;
export type LinkAddressesViewLazyQueryHookResult = ReturnType<typeof useLinkAddressesViewLazyQuery>;
export type LinkAddressesViewQueryResult = Apollo.QueryResult<LinkAddressesViewQuery, LinkAddressesViewQueryVariables>;
export const SmsProviderStateDocument = gql`
    query SmsProviderState($refresh: Boolean) {
  smsProviderStatus(refresh: $refresh) {
    ...SmsProviderStatusFields
  }
}
    ${SmsProviderStatusFieldsFragmentDoc}`;

/**
 * __useSmsProviderStateQuery__
 *
 * To run a query within a React component, call `useSmsProviderStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsProviderStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsProviderStateQuery({
 *   variables: {
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useSmsProviderStateQuery(baseOptions?: Apollo.QueryHookOptions<SmsProviderStateQuery, SmsProviderStateQueryVariables>) {
        return Apollo.useQuery<SmsProviderStateQuery, SmsProviderStateQueryVariables>(SmsProviderStateDocument, baseOptions);
      }
export function useSmsProviderStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsProviderStateQuery, SmsProviderStateQueryVariables>) {
          return Apollo.useLazyQuery<SmsProviderStateQuery, SmsProviderStateQueryVariables>(SmsProviderStateDocument, baseOptions);
        }
export type SmsProviderStateQueryHookResult = ReturnType<typeof useSmsProviderStateQuery>;
export type SmsProviderStateLazyQueryHookResult = ReturnType<typeof useSmsProviderStateLazyQuery>;
export type SmsProviderStateQueryResult = Apollo.QueryResult<SmsProviderStateQuery, SmsProviderStateQueryVariables>;
export const SmsReminderPlansDocument = gql`
    query SmsReminderPlans {
  reminderPlans {
    ...SmsReminderPlanFields
  }
}
    ${SmsReminderPlanFieldsFragmentDoc}`;

/**
 * __useSmsReminderPlansQuery__
 *
 * To run a query within a React component, call `useSmsReminderPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsReminderPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsReminderPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useSmsReminderPlansQuery(baseOptions?: Apollo.QueryHookOptions<SmsReminderPlansQuery, SmsReminderPlansQueryVariables>) {
        return Apollo.useQuery<SmsReminderPlansQuery, SmsReminderPlansQueryVariables>(SmsReminderPlansDocument, baseOptions);
      }
export function useSmsReminderPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsReminderPlansQuery, SmsReminderPlansQueryVariables>) {
          return Apollo.useLazyQuery<SmsReminderPlansQuery, SmsReminderPlansQueryVariables>(SmsReminderPlansDocument, baseOptions);
        }
export type SmsReminderPlansQueryHookResult = ReturnType<typeof useSmsReminderPlansQuery>;
export type SmsReminderPlansLazyQueryHookResult = ReturnType<typeof useSmsReminderPlansLazyQuery>;
export type SmsReminderPlansQueryResult = Apollo.QueryResult<SmsReminderPlansQuery, SmsReminderPlansQueryVariables>;
export const SmsReminderDryRunDocument = gql`
    query SmsReminderDryRun($topic: String!, $limit: Int) {
  previewSmsReminders(topic: $topic, limit: $limit) {
    topic
    subjectId
    subjectLabel
    step
    dueAt
    dueNow
    phoneMasked
    reason
    state
    condition
    body
    segments
  }
}
    `;

/**
 * __useSmsReminderDryRunQuery__
 *
 * To run a query within a React component, call `useSmsReminderDryRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsReminderDryRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsReminderDryRunQuery({
 *   variables: {
 *      topic: // value for 'topic'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSmsReminderDryRunQuery(baseOptions: Apollo.QueryHookOptions<SmsReminderDryRunQuery, SmsReminderDryRunQueryVariables>) {
        return Apollo.useQuery<SmsReminderDryRunQuery, SmsReminderDryRunQueryVariables>(SmsReminderDryRunDocument, baseOptions);
      }
export function useSmsReminderDryRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsReminderDryRunQuery, SmsReminderDryRunQueryVariables>) {
          return Apollo.useLazyQuery<SmsReminderDryRunQuery, SmsReminderDryRunQueryVariables>(SmsReminderDryRunDocument, baseOptions);
        }
export type SmsReminderDryRunQueryHookResult = ReturnType<typeof useSmsReminderDryRunQuery>;
export type SmsReminderDryRunLazyQueryHookResult = ReturnType<typeof useSmsReminderDryRunLazyQuery>;
export type SmsReminderDryRunQueryResult = Apollo.QueryResult<SmsReminderDryRunQuery, SmsReminderDryRunQueryVariables>;
export const GetAppStateDocument = gql`
    query GetAppState {
  appState @client {
    bootstrapped
  }
}
    `;

/**
 * __useGetAppStateQuery__
 *
 * To run a query within a React component, call `useGetAppStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppStateQuery(baseOptions?: Apollo.QueryHookOptions<GetAppStateQuery, GetAppStateQueryVariables>) {
        return Apollo.useQuery<GetAppStateQuery, GetAppStateQueryVariables>(GetAppStateDocument, baseOptions);
      }
export function useGetAppStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppStateQuery, GetAppStateQueryVariables>) {
          return Apollo.useLazyQuery<GetAppStateQuery, GetAppStateQueryVariables>(GetAppStateDocument, baseOptions);
        }
export type GetAppStateQueryHookResult = ReturnType<typeof useGetAppStateQuery>;
export type GetAppStateLazyQueryHookResult = ReturnType<typeof useGetAppStateLazyQuery>;
export type GetAppStateQueryResult = Apollo.QueryResult<GetAppStateQuery, GetAppStateQueryVariables>;
export const GetAuthStateDocument = gql`
    query GetAuthState {
  authState @client {
    isLoggedIn
    access_token
  }
}
    `;

/**
 * __useGetAuthStateQuery__
 *
 * To run a query within a React component, call `useGetAuthStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthStateQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthStateQuery, GetAuthStateQueryVariables>) {
        return Apollo.useQuery<GetAuthStateQuery, GetAuthStateQueryVariables>(GetAuthStateDocument, baseOptions);
      }
export function useGetAuthStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthStateQuery, GetAuthStateQueryVariables>) {
          return Apollo.useLazyQuery<GetAuthStateQuery, GetAuthStateQueryVariables>(GetAuthStateDocument, baseOptions);
        }
export type GetAuthStateQueryHookResult = ReturnType<typeof useGetAuthStateQuery>;
export type GetAuthStateLazyQueryHookResult = ReturnType<typeof useGetAuthStateLazyQuery>;
export type GetAuthStateQueryResult = Apollo.QueryResult<GetAuthStateQuery, GetAuthStateQueryVariables>;
export const StudentAcademicDocument = gql`
    query StudentAcademic($id: ID!, $first: Int = 100) {
  student(id: $id) {
    id
    attendancePercent
    averageMark
    lessons(first: $first) {
      totalCount
      edges {
        node {
          id
          date
          lessonNumber
          name
          attended
          mark
        }
      }
    }
  }
}
    `;

/**
 * __useStudentAcademicQuery__
 *
 * To run a query within a React component, call `useStudentAcademicQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useStudentAcademicQuery(baseOptions: Apollo.QueryHookOptions<StudentAcademicQuery, StudentAcademicQueryVariables>) {
        return Apollo.useQuery<StudentAcademicQuery, StudentAcademicQueryVariables>(StudentAcademicDocument, baseOptions);
      }
export function useStudentAcademicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentAcademicQuery, StudentAcademicQueryVariables>) {
          return Apollo.useLazyQuery<StudentAcademicQuery, StudentAcademicQueryVariables>(StudentAcademicDocument, baseOptions);
        }
export type StudentAcademicQueryHookResult = ReturnType<typeof useStudentAcademicQuery>;
export type StudentAcademicLazyQueryHookResult = ReturnType<typeof useStudentAcademicLazyQuery>;
export type StudentAcademicQueryResult = Apollo.QueryResult<StudentAcademicQuery, StudentAcademicQueryVariables>;
export const PaginatedStudentsDocument = gql`
    query PaginatedStudents($query: String, $first: Int, $after: String) {
  allStudents(query: $query, first: $first, after: $after) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        isLmsBlocked
        user {
          id
          lastName
          firstName
          middleName
          phone
          email
        }
        agreements {
          id
          agreementTitle
          currency
          budgetAmount
          paidAmount
          debtAmount
          upcomingAmount
          terminated
          group {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePaginatedStudentsQuery__
 *
 * To run a query within a React component, call `usePaginatedStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedStudentsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaginatedStudentsQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedStudentsQuery, PaginatedStudentsQueryVariables>) {
        return Apollo.useQuery<PaginatedStudentsQuery, PaginatedStudentsQueryVariables>(PaginatedStudentsDocument, baseOptions);
      }
export function usePaginatedStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedStudentsQuery, PaginatedStudentsQueryVariables>) {
          return Apollo.useLazyQuery<PaginatedStudentsQuery, PaginatedStudentsQueryVariables>(PaginatedStudentsDocument, baseOptions);
        }
export type PaginatedStudentsQueryHookResult = ReturnType<typeof usePaginatedStudentsQuery>;
export type PaginatedStudentsLazyQueryHookResult = ReturnType<typeof usePaginatedStudentsLazyQuery>;
export type PaginatedStudentsQueryResult = Apollo.QueryResult<PaginatedStudentsQuery, PaginatedStudentsQueryVariables>;
export const LoadAgreementByIdDocument = gql`
    query loadAgreementById($agreementId: ID!) {
  agreement(agreementId: $agreementId) {
    id
    agreementTitle
    currency
    terminated
    paymentByCompany
    vat
    date
    comment
    budgetAmount
    paidAmount
    debtAmount
    upcomingAmount
    partialAttendance
    terminatedDate
    transferOut
    freeOfCharge
    statePrefinanced
    firstLesson {
      id
      name
      lessonNumber
    }
    lastLesson {
      id
      name
      date
      lessonNumber
    }
    chargeback {
      id
      amountByn
      amountForeign
      currency
    }
    contributions(orderByDateFilter: true) {
      edges {
        node {
          id
          date
          amountForeign
          amountByn
        }
      }
    }
    promocode
    company {
      id
      name
    }
    country {
      id
      title
    }
    resident
    student {
      id
      user {
        id
        firstName
        middleName
        lastName
        phone
        email
      }
    }
    group {
      id
      name
      startDate
      course {
        id
        name
      }
    }
    startAccountsPayable {
      id
      amountByn
      amountForeign
      repaid
    }
    accountsPayable {
      id
      amountForeign
      currency
      startedAgreement {
        id
        agreementTitle
      }
    }
  }
}
    `;

/**
 * __useLoadAgreementByIdQuery__
 *
 * To run a query within a React component, call `useLoadAgreementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAgreementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAgreementByIdQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useLoadAgreementByIdQuery(baseOptions: Apollo.QueryHookOptions<LoadAgreementByIdQuery, LoadAgreementByIdQueryVariables>) {
        return Apollo.useQuery<LoadAgreementByIdQuery, LoadAgreementByIdQueryVariables>(LoadAgreementByIdDocument, baseOptions);
      }
export function useLoadAgreementByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadAgreementByIdQuery, LoadAgreementByIdQueryVariables>) {
          return Apollo.useLazyQuery<LoadAgreementByIdQuery, LoadAgreementByIdQueryVariables>(LoadAgreementByIdDocument, baseOptions);
        }
export type LoadAgreementByIdQueryHookResult = ReturnType<typeof useLoadAgreementByIdQuery>;
export type LoadAgreementByIdLazyQueryHookResult = ReturnType<typeof useLoadAgreementByIdLazyQuery>;
export type LoadAgreementByIdQueryResult = Apollo.QueryResult<LoadAgreementByIdQuery, LoadAgreementByIdQueryVariables>;
export const MetaStudentsDocument = gql`
    query MetaStudents($query: String) {
  metaStudents(query: $query) {
    totalCount
    agreementsCount
  }
}
    `;

/**
 * __useMetaStudentsQuery__
 *
 * To run a query within a React component, call `useMetaStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaStudentsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMetaStudentsQuery(baseOptions?: Apollo.QueryHookOptions<MetaStudentsQuery, MetaStudentsQueryVariables>) {
        return Apollo.useQuery<MetaStudentsQuery, MetaStudentsQueryVariables>(MetaStudentsDocument, baseOptions);
      }
export function useMetaStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaStudentsQuery, MetaStudentsQueryVariables>) {
          return Apollo.useLazyQuery<MetaStudentsQuery, MetaStudentsQueryVariables>(MetaStudentsDocument, baseOptions);
        }
export type MetaStudentsQueryHookResult = ReturnType<typeof useMetaStudentsQuery>;
export type MetaStudentsLazyQueryHookResult = ReturnType<typeof useMetaStudentsLazyQuery>;
export type MetaStudentsQueryResult = Apollo.QueryResult<MetaStudentsQuery, MetaStudentsQueryVariables>;
export const CheckUserExistDocument = gql`
    query CheckUserExist($email: String!, $phone: String!) {
  verifyStudent(email: $email, phone: $phone) {
    student {
      id
      user {
        id
        firstName
        lastName
        middleName
        phone
        email
        roles
      }
    }
    user {
      id
      firstName
      lastName
      middleName
      phone
      email
      roles
    }
    customErrors {
      field
      message
      code
    }
    message
    code
  }
}
    `;

/**
 * __useCheckUserExistQuery__
 *
 * To run a query within a React component, call `useCheckUserExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserExistQuery({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCheckUserExistQuery(baseOptions: Apollo.QueryHookOptions<CheckUserExistQuery, CheckUserExistQueryVariables>) {
        return Apollo.useQuery<CheckUserExistQuery, CheckUserExistQueryVariables>(CheckUserExistDocument, baseOptions);
      }
export function useCheckUserExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserExistQuery, CheckUserExistQueryVariables>) {
          return Apollo.useLazyQuery<CheckUserExistQuery, CheckUserExistQueryVariables>(CheckUserExistDocument, baseOptions);
        }
export type CheckUserExistQueryHookResult = ReturnType<typeof useCheckUserExistQuery>;
export type CheckUserExistLazyQueryHookResult = ReturnType<typeof useCheckUserExistLazyQuery>;
export type CheckUserExistQueryResult = Apollo.QueryResult<CheckUserExistQuery, CheckUserExistQueryVariables>;
export const LoadLessonsOptionsDocument = gql`
    query loadLessonsOptions($groupId: ID!) {
  group(groupId: $groupId) {
    id
    lessons {
      id
      name
      date
      lessonNumber
    }
  }
}
    `;

/**
 * __useLoadLessonsOptionsQuery__
 *
 * To run a query within a React component, call `useLoadLessonsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadLessonsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadLessonsOptionsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useLoadLessonsOptionsQuery(baseOptions: Apollo.QueryHookOptions<LoadLessonsOptionsQuery, LoadLessonsOptionsQueryVariables>) {
        return Apollo.useQuery<LoadLessonsOptionsQuery, LoadLessonsOptionsQueryVariables>(LoadLessonsOptionsDocument, baseOptions);
      }
export function useLoadLessonsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadLessonsOptionsQuery, LoadLessonsOptionsQueryVariables>) {
          return Apollo.useLazyQuery<LoadLessonsOptionsQuery, LoadLessonsOptionsQueryVariables>(LoadLessonsOptionsDocument, baseOptions);
        }
export type LoadLessonsOptionsQueryHookResult = ReturnType<typeof useLoadLessonsOptionsQuery>;
export type LoadLessonsOptionsLazyQueryHookResult = ReturnType<typeof useLoadLessonsOptionsLazyQuery>;
export type LoadLessonsOptionsQueryResult = Apollo.QueryResult<LoadLessonsOptionsQuery, LoadLessonsOptionsQueryVariables>;
export const AccountsPayablesDocument = gql`
    query accountsPayables($id: ID!) {
  student(id: $id) {
    id
    accountsPayables {
      id
      amountForeign
      currency
      repaid
      startedAgreement {
        id
        agreementTitle
      }
    }
  }
}
    `;

/**
 * __useAccountsPayablesQuery__
 *
 * To run a query within a React component, call `useAccountsPayablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsPayablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsPayablesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountsPayablesQuery(baseOptions: Apollo.QueryHookOptions<AccountsPayablesQuery, AccountsPayablesQueryVariables>) {
        return Apollo.useQuery<AccountsPayablesQuery, AccountsPayablesQueryVariables>(AccountsPayablesDocument, baseOptions);
      }
export function useAccountsPayablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsPayablesQuery, AccountsPayablesQueryVariables>) {
          return Apollo.useLazyQuery<AccountsPayablesQuery, AccountsPayablesQueryVariables>(AccountsPayablesDocument, baseOptions);
        }
export type AccountsPayablesQueryHookResult = ReturnType<typeof useAccountsPayablesQuery>;
export type AccountsPayablesLazyQueryHookResult = ReturnType<typeof useAccountsPayablesLazyQuery>;
export type AccountsPayablesQueryResult = Apollo.QueryResult<AccountsPayablesQuery, AccountsPayablesQueryVariables>;
export const StudentLmsBlockDocument = gql`
    query StudentLmsBlock($studentId: ID!) {
  studentAccessBlock(studentId: $studentId) {
    id
    isBlocked
    reason
    overdueInvoiceCount
    maxOverdueDays
    source
    blockedAt
    blockedByName
    unblockedAt
    unblockedByName
    blockingInvoices {
      invoiceId
      fakturowniaId
      number
      amount
      gross
      currency
      paymentTo
      daysOverdue
      paymentUrl
      viewUrl
      isPaid
    }
    amountsDue {
      amount
      currency
    }
  }
}
    `;

/**
 * __useStudentLmsBlockQuery__
 *
 * To run a query within a React component, call `useStudentLmsBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentLmsBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentLmsBlockQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentLmsBlockQuery(baseOptions: Apollo.QueryHookOptions<StudentLmsBlockQuery, StudentLmsBlockQueryVariables>) {
        return Apollo.useQuery<StudentLmsBlockQuery, StudentLmsBlockQueryVariables>(StudentLmsBlockDocument, baseOptions);
      }
export function useStudentLmsBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentLmsBlockQuery, StudentLmsBlockQueryVariables>) {
          return Apollo.useLazyQuery<StudentLmsBlockQuery, StudentLmsBlockQueryVariables>(StudentLmsBlockDocument, baseOptions);
        }
export type StudentLmsBlockQueryHookResult = ReturnType<typeof useStudentLmsBlockQuery>;
export type StudentLmsBlockLazyQueryHookResult = ReturnType<typeof useStudentLmsBlockLazyQuery>;
export type StudentLmsBlockQueryResult = Apollo.QueryResult<StudentLmsBlockQuery, StudentLmsBlockQueryVariables>;
export const StudentLmsBlockHistoryDocument = gql`
    query StudentLmsBlockHistory($studentId: ID!) {
  studentAccessBlockEvents(studentId: $studentId) {
    id
    action
    source
    actorName
    createdAt
    reason
    notifyStudent
    invoices {
      invoiceId
      number
      amount
      currency
      paymentTo
      daysOverdue
      viewUrl
    }
    amountsDue {
      amount
      currency
    }
    notifications {
      id
      channel
      kind
      status
      skipReason
      error
      sentAt
      createdAt
    }
  }
}
    `;

/**
 * __useStudentLmsBlockHistoryQuery__
 *
 * To run a query within a React component, call `useStudentLmsBlockHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentLmsBlockHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentLmsBlockHistoryQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentLmsBlockHistoryQuery(baseOptions: Apollo.QueryHookOptions<StudentLmsBlockHistoryQuery, StudentLmsBlockHistoryQueryVariables>) {
        return Apollo.useQuery<StudentLmsBlockHistoryQuery, StudentLmsBlockHistoryQueryVariables>(StudentLmsBlockHistoryDocument, baseOptions);
      }
export function useStudentLmsBlockHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentLmsBlockHistoryQuery, StudentLmsBlockHistoryQueryVariables>) {
          return Apollo.useLazyQuery<StudentLmsBlockHistoryQuery, StudentLmsBlockHistoryQueryVariables>(StudentLmsBlockHistoryDocument, baseOptions);
        }
export type StudentLmsBlockHistoryQueryHookResult = ReturnType<typeof useStudentLmsBlockHistoryQuery>;
export type StudentLmsBlockHistoryLazyQueryHookResult = ReturnType<typeof useStudentLmsBlockHistoryLazyQuery>;
export type StudentLmsBlockHistoryQueryResult = Apollo.QueryResult<StudentLmsBlockHistoryQuery, StudentLmsBlockHistoryQueryVariables>;
export const LmsSuspensionsPageDocument = gql`
    query LmsSuspensionsPage($status: String, $search: String, $offset: Int, $limit: Int) {
  lmsSuspensions(status: $status, search: $search, offset: $offset, limit: $limit) {
    total
    items {
      status
      studentId
      studentName
      studentEmail
      groups {
        id
        name
      }
      source
      reason
      blockedAt
      blockedByName
      restoredAt
      restoredByName
      restoredSource
      skipReason
      invoices {
        invoiceId
        fakturowniaId
        number
        amount
        gross
        currency
        paymentTo
        daysOverdue
        paymentUrl
        viewUrl
        isPaid
      }
      amountsDue {
        amount
        currency
      }
      notifications {
        id
        channel
        kind
        status
        skipReason
        error
        sentAt
        createdAt
      }
    }
  }
}
    `;

/**
 * __useLmsSuspensionsPageQuery__
 *
 * To run a query within a React component, call `useLmsSuspensionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsSuspensionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsSuspensionsPageQuery({
 *   variables: {
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLmsSuspensionsPageQuery(baseOptions?: Apollo.QueryHookOptions<LmsSuspensionsPageQuery, LmsSuspensionsPageQueryVariables>) {
        return Apollo.useQuery<LmsSuspensionsPageQuery, LmsSuspensionsPageQueryVariables>(LmsSuspensionsPageDocument, baseOptions);
      }
export function useLmsSuspensionsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsSuspensionsPageQuery, LmsSuspensionsPageQueryVariables>) {
          return Apollo.useLazyQuery<LmsSuspensionsPageQuery, LmsSuspensionsPageQueryVariables>(LmsSuspensionsPageDocument, baseOptions);
        }
export type LmsSuspensionsPageQueryHookResult = ReturnType<typeof useLmsSuspensionsPageQuery>;
export type LmsSuspensionsPageLazyQueryHookResult = ReturnType<typeof useLmsSuspensionsPageLazyQuery>;
export type LmsSuspensionsPageQueryResult = Apollo.QueryResult<LmsSuspensionsPageQuery, LmsSuspensionsPageQueryVariables>;
export const LmsBlockRobotLatestRunDocument = gql`
    query LmsBlockRobotLatestRun {
  lmsBlockRobotLastRun {
    id
    taskName
    status
    triggerSource
    startedAt
    finishedAt
    stats
    errorMessage
  }
}
    `;

/**
 * __useLmsBlockRobotLatestRunQuery__
 *
 * To run a query within a React component, call `useLmsBlockRobotLatestRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsBlockRobotLatestRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsBlockRobotLatestRunQuery({
 *   variables: {
 *   },
 * });
 */
export function useLmsBlockRobotLatestRunQuery(baseOptions?: Apollo.QueryHookOptions<LmsBlockRobotLatestRunQuery, LmsBlockRobotLatestRunQueryVariables>) {
        return Apollo.useQuery<LmsBlockRobotLatestRunQuery, LmsBlockRobotLatestRunQueryVariables>(LmsBlockRobotLatestRunDocument, baseOptions);
      }
export function useLmsBlockRobotLatestRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsBlockRobotLatestRunQuery, LmsBlockRobotLatestRunQueryVariables>) {
          return Apollo.useLazyQuery<LmsBlockRobotLatestRunQuery, LmsBlockRobotLatestRunQueryVariables>(LmsBlockRobotLatestRunDocument, baseOptions);
        }
export type LmsBlockRobotLatestRunQueryHookResult = ReturnType<typeof useLmsBlockRobotLatestRunQuery>;
export type LmsBlockRobotLatestRunLazyQueryHookResult = ReturnType<typeof useLmsBlockRobotLatestRunLazyQuery>;
export type LmsBlockRobotLatestRunQueryResult = Apollo.QueryResult<LmsBlockRobotLatestRunQuery, LmsBlockRobotLatestRunQueryVariables>;
export const DebtorCandidatesListDocument = gql`
    query DebtorCandidatesList($groupId: ID) {
  debtorCandidates(groupId: $groupId) {
    student {
      id
      user {
        id
        firstName
        lastName
        middleName
        email
      }
    }
    overdueAmounts {
      amount
      currency
    }
    overdueInvoiceCount
    maxOverdueDays
    currentlyBlocked
  }
}
    `;

/**
 * __useDebtorCandidatesListQuery__
 *
 * To run a query within a React component, call `useDebtorCandidatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebtorCandidatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebtorCandidatesListQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDebtorCandidatesListQuery(baseOptions?: Apollo.QueryHookOptions<DebtorCandidatesListQuery, DebtorCandidatesListQueryVariables>) {
        return Apollo.useQuery<DebtorCandidatesListQuery, DebtorCandidatesListQueryVariables>(DebtorCandidatesListDocument, baseOptions);
      }
export function useDebtorCandidatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebtorCandidatesListQuery, DebtorCandidatesListQueryVariables>) {
          return Apollo.useLazyQuery<DebtorCandidatesListQuery, DebtorCandidatesListQueryVariables>(DebtorCandidatesListDocument, baseOptions);
        }
export type DebtorCandidatesListQueryHookResult = ReturnType<typeof useDebtorCandidatesListQuery>;
export type DebtorCandidatesListLazyQueryHookResult = ReturnType<typeof useDebtorCandidatesListLazyQuery>;
export type DebtorCandidatesListQueryResult = Apollo.QueryResult<DebtorCandidatesListQuery, DebtorCandidatesListQueryVariables>;
export const StudentNotesListDocument = gql`
    query StudentNotesList($studentId: ID!) {
  studentNotes(studentId: $studentId) {
    id
    body
    sentiment
    pinned
    createdAt
    authorName
  }
}
    `;

/**
 * __useStudentNotesListQuery__
 *
 * To run a query within a React component, call `useStudentNotesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNotesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNotesListQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentNotesListQuery(baseOptions: Apollo.QueryHookOptions<StudentNotesListQuery, StudentNotesListQueryVariables>) {
        return Apollo.useQuery<StudentNotesListQuery, StudentNotesListQueryVariables>(StudentNotesListDocument, baseOptions);
      }
export function useStudentNotesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentNotesListQuery, StudentNotesListQueryVariables>) {
          return Apollo.useLazyQuery<StudentNotesListQuery, StudentNotesListQueryVariables>(StudentNotesListDocument, baseOptions);
        }
export type StudentNotesListQueryHookResult = ReturnType<typeof useStudentNotesListQuery>;
export type StudentNotesListLazyQueryHookResult = ReturnType<typeof useStudentNotesListLazyQuery>;
export type StudentNotesListQueryResult = Apollo.QueryResult<StudentNotesListQuery, StudentNotesListQueryVariables>;
export const GroupNotesListDocument = gql`
    query GroupNotesList($groupId: ID!) {
  groupNotes(groupId: $groupId) {
    id
    body
    sentiment
    pinned
    createdAt
    authorName
  }
}
    `;

/**
 * __useGroupNotesListQuery__
 *
 * To run a query within a React component, call `useGroupNotesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupNotesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupNotesListQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupNotesListQuery(baseOptions: Apollo.QueryHookOptions<GroupNotesListQuery, GroupNotesListQueryVariables>) {
        return Apollo.useQuery<GroupNotesListQuery, GroupNotesListQueryVariables>(GroupNotesListDocument, baseOptions);
      }
export function useGroupNotesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupNotesListQuery, GroupNotesListQueryVariables>) {
          return Apollo.useLazyQuery<GroupNotesListQuery, GroupNotesListQueryVariables>(GroupNotesListDocument, baseOptions);
        }
export type GroupNotesListQueryHookResult = ReturnType<typeof useGroupNotesListQuery>;
export type GroupNotesListLazyQueryHookResult = ReturnType<typeof useGroupNotesListLazyQuery>;
export type GroupNotesListQueryResult = Apollo.QueryResult<GroupNotesListQuery, GroupNotesListQueryVariables>;
export const StudentTasksListDocument = gql`
    query StudentTasksList($studentId: ID!, $includeClosed: Boolean) {
  studentTasks(studentId: $studentId, includeClosed: $includeClosed) {
    id
    title
    description
    status
    priority
    dueDate
    completedAt
    createdAt
    assigneeName
    links {
      id
      kind
      objectId
      name
      hint
      missing
      href
    }
  }
}
    `;

/**
 * __useStudentTasksListQuery__
 *
 * To run a query within a React component, call `useStudentTasksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentTasksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentTasksListQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      includeClosed: // value for 'includeClosed'
 *   },
 * });
 */
export function useStudentTasksListQuery(baseOptions: Apollo.QueryHookOptions<StudentTasksListQuery, StudentTasksListQueryVariables>) {
        return Apollo.useQuery<StudentTasksListQuery, StudentTasksListQueryVariables>(StudentTasksListDocument, baseOptions);
      }
export function useStudentTasksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentTasksListQuery, StudentTasksListQueryVariables>) {
          return Apollo.useLazyQuery<StudentTasksListQuery, StudentTasksListQueryVariables>(StudentTasksListDocument, baseOptions);
        }
export type StudentTasksListQueryHookResult = ReturnType<typeof useStudentTasksListQuery>;
export type StudentTasksListLazyQueryHookResult = ReturnType<typeof useStudentTasksListLazyQuery>;
export type StudentTasksListQueryResult = Apollo.QueryResult<StudentTasksListQuery, StudentTasksListQueryVariables>;
export const GroupTasksListDocument = gql`
    query GroupTasksList($groupId: ID!, $includeClosed: Boolean) {
  groupTasks(groupId: $groupId, includeClosed: $includeClosed) {
    id
    title
    description
    status
    priority
    dueDate
    completedAt
    createdAt
    assigneeName
    links {
      id
      kind
      objectId
      name
      hint
      missing
      href
    }
  }
}
    `;

/**
 * __useGroupTasksListQuery__
 *
 * To run a query within a React component, call `useGroupTasksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupTasksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupTasksListQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      includeClosed: // value for 'includeClosed'
 *   },
 * });
 */
export function useGroupTasksListQuery(baseOptions: Apollo.QueryHookOptions<GroupTasksListQuery, GroupTasksListQueryVariables>) {
        return Apollo.useQuery<GroupTasksListQuery, GroupTasksListQueryVariables>(GroupTasksListDocument, baseOptions);
      }
export function useGroupTasksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupTasksListQuery, GroupTasksListQueryVariables>) {
          return Apollo.useLazyQuery<GroupTasksListQuery, GroupTasksListQueryVariables>(GroupTasksListDocument, baseOptions);
        }
export type GroupTasksListQueryHookResult = ReturnType<typeof useGroupTasksListQuery>;
export type GroupTasksListLazyQueryHookResult = ReturnType<typeof useGroupTasksListLazyQuery>;
export type GroupTasksListQueryResult = Apollo.QueryResult<GroupTasksListQuery, GroupTasksListQueryVariables>;
export const AgreementTasksListDocument = gql`
    query AgreementTasksList($agreementId: ID!, $includeClosed: Boolean) {
  agreementTasks(agreementId: $agreementId, includeClosed: $includeClosed) {
    id
    title
    description
    status
    priority
    dueDate
    completedAt
    createdAt
    assigneeName
    links {
      id
      kind
      objectId
      name
      hint
      missing
      href
    }
  }
}
    `;

/**
 * __useAgreementTasksListQuery__
 *
 * To run a query within a React component, call `useAgreementTasksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementTasksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgreementTasksListQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      includeClosed: // value for 'includeClosed'
 *   },
 * });
 */
export function useAgreementTasksListQuery(baseOptions: Apollo.QueryHookOptions<AgreementTasksListQuery, AgreementTasksListQueryVariables>) {
        return Apollo.useQuery<AgreementTasksListQuery, AgreementTasksListQueryVariables>(AgreementTasksListDocument, baseOptions);
      }
export function useAgreementTasksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgreementTasksListQuery, AgreementTasksListQueryVariables>) {
          return Apollo.useLazyQuery<AgreementTasksListQuery, AgreementTasksListQueryVariables>(AgreementTasksListDocument, baseOptions);
        }
export type AgreementTasksListQueryHookResult = ReturnType<typeof useAgreementTasksListQuery>;
export type AgreementTasksListLazyQueryHookResult = ReturnType<typeof useAgreementTasksListLazyQuery>;
export type AgreementTasksListQueryResult = Apollo.QueryResult<AgreementTasksListQuery, AgreementTasksListQueryVariables>;
export const MyTasksListDocument = gql`
    query MyTasksList($includeClosed: Boolean) {
  myTasks(includeClosed: $includeClosed) {
    id
    title
    status
    priority
    dueDate
    assigneeName
    links {
      id
      kind
      objectId
      name
      hint
      missing
      href
    }
  }
}
    `;

/**
 * __useMyTasksListQuery__
 *
 * To run a query within a React component, call `useMyTasksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTasksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTasksListQuery({
 *   variables: {
 *      includeClosed: // value for 'includeClosed'
 *   },
 * });
 */
export function useMyTasksListQuery(baseOptions?: Apollo.QueryHookOptions<MyTasksListQuery, MyTasksListQueryVariables>) {
        return Apollo.useQuery<MyTasksListQuery, MyTasksListQueryVariables>(MyTasksListDocument, baseOptions);
      }
export function useMyTasksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTasksListQuery, MyTasksListQueryVariables>) {
          return Apollo.useLazyQuery<MyTasksListQuery, MyTasksListQueryVariables>(MyTasksListDocument, baseOptions);
        }
export type MyTasksListQueryHookResult = ReturnType<typeof useMyTasksListQuery>;
export type MyTasksListLazyQueryHookResult = ReturnType<typeof useMyTasksListLazyQuery>;
export type MyTasksListQueryResult = Apollo.QueryResult<MyTasksListQuery, MyTasksListQueryVariables>;
export const StaffTasksSummaryDocument = gql`
    query StaffTasksSummary($groupId: ID, $assigneeMe: Boolean, $assigneeIds: [ID]) {
  staffTasksSummary(
    groupId: $groupId
    assigneeMe: $assigneeMe
    assigneeIds: $assigneeIds
  ) {
    openCount
    overdueCount
    todayCount
  }
}
    `;

/**
 * __useStaffTasksSummaryQuery__
 *
 * To run a query within a React component, call `useStaffTasksSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffTasksSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffTasksSummaryQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      assigneeMe: // value for 'assigneeMe'
 *      assigneeIds: // value for 'assigneeIds'
 *   },
 * });
 */
export function useStaffTasksSummaryQuery(baseOptions?: Apollo.QueryHookOptions<StaffTasksSummaryQuery, StaffTasksSummaryQueryVariables>) {
        return Apollo.useQuery<StaffTasksSummaryQuery, StaffTasksSummaryQueryVariables>(StaffTasksSummaryDocument, baseOptions);
      }
export function useStaffTasksSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffTasksSummaryQuery, StaffTasksSummaryQueryVariables>) {
          return Apollo.useLazyQuery<StaffTasksSummaryQuery, StaffTasksSummaryQueryVariables>(StaffTasksSummaryDocument, baseOptions);
        }
export type StaffTasksSummaryQueryHookResult = ReturnType<typeof useStaffTasksSummaryQuery>;
export type StaffTasksSummaryLazyQueryHookResult = ReturnType<typeof useStaffTasksSummaryLazyQuery>;
export type StaffTasksSummaryQueryResult = Apollo.QueryResult<StaffTasksSummaryQuery, StaffTasksSummaryQueryVariables>;
export const StaffTasksListDocument = gql`
    query StaffTasksList($groupId: ID, $studentId: ID, $agreementId: ID, $teacherId: ID, $assigneeMe: Boolean, $assigneeIds: [ID], $statuses: [String], $priorities: [String], $dueFrom: Date, $dueTo: Date, $search: String, $includeClosed: Boolean, $closedWithinDays: Int, $links: [TaskLinkInput]) {
  staffTasks(
    groupId: $groupId
    studentId: $studentId
    agreementId: $agreementId
    teacherId: $teacherId
    assigneeMe: $assigneeMe
    assigneeIds: $assigneeIds
    statuses: $statuses
    priorities: $priorities
    dueFrom: $dueFrom
    dueTo: $dueTo
    search: $search
    includeClosed: $includeClosed
    closedWithinDays: $closedWithinDays
    links: $links
  ) {
    id
    title
    description
    status
    priority
    startDate
    dueDate
    position
    fromMessage
    completedAt
    createdAt
    updatedAt
    assigneeId
    assigneeName
    createdByName
    commentsCount
    attachmentsCount
    coverAttachmentId
    links {
      id
      kind
      objectId
      name
      hint
      missing
      href
    }
  }
}
    `;

/**
 * __useStaffTasksListQuery__
 *
 * To run a query within a React component, call `useStaffTasksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffTasksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffTasksListQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      studentId: // value for 'studentId'
 *      agreementId: // value for 'agreementId'
 *      teacherId: // value for 'teacherId'
 *      assigneeMe: // value for 'assigneeMe'
 *      assigneeIds: // value for 'assigneeIds'
 *      statuses: // value for 'statuses'
 *      priorities: // value for 'priorities'
 *      dueFrom: // value for 'dueFrom'
 *      dueTo: // value for 'dueTo'
 *      search: // value for 'search'
 *      includeClosed: // value for 'includeClosed'
 *      closedWithinDays: // value for 'closedWithinDays'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useStaffTasksListQuery(baseOptions?: Apollo.QueryHookOptions<StaffTasksListQuery, StaffTasksListQueryVariables>) {
        return Apollo.useQuery<StaffTasksListQuery, StaffTasksListQueryVariables>(StaffTasksListDocument, baseOptions);
      }
export function useStaffTasksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffTasksListQuery, StaffTasksListQueryVariables>) {
          return Apollo.useLazyQuery<StaffTasksListQuery, StaffTasksListQueryVariables>(StaffTasksListDocument, baseOptions);
        }
export type StaffTasksListQueryHookResult = ReturnType<typeof useStaffTasksListQuery>;
export type StaffTasksListLazyQueryHookResult = ReturnType<typeof useStaffTasksListLazyQuery>;
export type StaffTasksListQueryResult = Apollo.QueryResult<StaffTasksListQuery, StaffTasksListQueryVariables>;
export const TaskLinkKindsListDocument = gql`
    query TaskLinkKindsList {
  taskLinkKinds {
    key
    label
  }
}
    `;

/**
 * __useTaskLinkKindsListQuery__
 *
 * To run a query within a React component, call `useTaskLinkKindsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskLinkKindsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskLinkKindsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskLinkKindsListQuery(baseOptions?: Apollo.QueryHookOptions<TaskLinkKindsListQuery, TaskLinkKindsListQueryVariables>) {
        return Apollo.useQuery<TaskLinkKindsListQuery, TaskLinkKindsListQueryVariables>(TaskLinkKindsListDocument, baseOptions);
      }
export function useTaskLinkKindsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskLinkKindsListQuery, TaskLinkKindsListQueryVariables>) {
          return Apollo.useLazyQuery<TaskLinkKindsListQuery, TaskLinkKindsListQueryVariables>(TaskLinkKindsListDocument, baseOptions);
        }
export type TaskLinkKindsListQueryHookResult = ReturnType<typeof useTaskLinkKindsListQuery>;
export type TaskLinkKindsListLazyQueryHookResult = ReturnType<typeof useTaskLinkKindsListLazyQuery>;
export type TaskLinkKindsListQueryResult = Apollo.QueryResult<TaskLinkKindsListQuery, TaskLinkKindsListQueryVariables>;
export const TaskLinkSearchListDocument = gql`
    query TaskLinkSearchList($kind: String!, $query: String, $limit: Int) {
  taskLinkSearch(kind: $kind, query: $query, limit: $limit) {
    objectId
    name
    hint
  }
}
    `;

/**
 * __useTaskLinkSearchListQuery__
 *
 * To run a query within a React component, call `useTaskLinkSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskLinkSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskLinkSearchListQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTaskLinkSearchListQuery(baseOptions: Apollo.QueryHookOptions<TaskLinkSearchListQuery, TaskLinkSearchListQueryVariables>) {
        return Apollo.useQuery<TaskLinkSearchListQuery, TaskLinkSearchListQueryVariables>(TaskLinkSearchListDocument, baseOptions);
      }
export function useTaskLinkSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskLinkSearchListQuery, TaskLinkSearchListQueryVariables>) {
          return Apollo.useLazyQuery<TaskLinkSearchListQuery, TaskLinkSearchListQueryVariables>(TaskLinkSearchListDocument, baseOptions);
        }
export type TaskLinkSearchListQueryHookResult = ReturnType<typeof useTaskLinkSearchListQuery>;
export type TaskLinkSearchListLazyQueryHookResult = ReturnType<typeof useTaskLinkSearchListLazyQuery>;
export type TaskLinkSearchListQueryResult = Apollo.QueryResult<TaskLinkSearchListQuery, TaskLinkSearchListQueryVariables>;
export const TaskDetailsCardDocument = gql`
    query TaskDetailsCard($id: ID!) {
  staffTask(id: $id) {
    id
    comments {
      id
      body
      authorName
      createdAt
      editedAt
      canEdit
      attachments {
        id
        originalName
        contentType
        sizeBytes
        isImage
        commentId
        uploadedByName
        createdAt
        canDelete
      }
    }
    links {
      id
      kind
      objectId
      name
      hint
      missing
      href
      createdByName
      createdAt
    }
    attachmentsCount
    attachments {
      id
      originalName
      contentType
      sizeBytes
      isImage
      commentId
      uploadedByName
      createdAt
      canDelete
    }
  }
}
    `;

/**
 * __useTaskDetailsCardQuery__
 *
 * To run a query within a React component, call `useTaskDetailsCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDetailsCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDetailsCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskDetailsCardQuery(baseOptions: Apollo.QueryHookOptions<TaskDetailsCardQuery, TaskDetailsCardQueryVariables>) {
        return Apollo.useQuery<TaskDetailsCardQuery, TaskDetailsCardQueryVariables>(TaskDetailsCardDocument, baseOptions);
      }
export function useTaskDetailsCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDetailsCardQuery, TaskDetailsCardQueryVariables>) {
          return Apollo.useLazyQuery<TaskDetailsCardQuery, TaskDetailsCardQueryVariables>(TaskDetailsCardDocument, baseOptions);
        }
export type TaskDetailsCardQueryHookResult = ReturnType<typeof useTaskDetailsCardQuery>;
export type TaskDetailsCardLazyQueryHookResult = ReturnType<typeof useTaskDetailsCardLazyQuery>;
export type TaskDetailsCardQueryResult = Apollo.QueryResult<TaskDetailsCardQuery, TaskDetailsCardQueryVariables>;
export const TaskAttachmentLinkDocument = gql`
    query TaskAttachmentLink($attachmentId: ID!) {
  staffTaskAttachmentUrl(attachmentId: $attachmentId) {
    url
    expiresAt
    originalName
  }
}
    `;

/**
 * __useTaskAttachmentLinkQuery__
 *
 * To run a query within a React component, call `useTaskAttachmentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskAttachmentLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskAttachmentLinkQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useTaskAttachmentLinkQuery(baseOptions: Apollo.QueryHookOptions<TaskAttachmentLinkQuery, TaskAttachmentLinkQueryVariables>) {
        return Apollo.useQuery<TaskAttachmentLinkQuery, TaskAttachmentLinkQueryVariables>(TaskAttachmentLinkDocument, baseOptions);
      }
export function useTaskAttachmentLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskAttachmentLinkQuery, TaskAttachmentLinkQueryVariables>) {
          return Apollo.useLazyQuery<TaskAttachmentLinkQuery, TaskAttachmentLinkQueryVariables>(TaskAttachmentLinkDocument, baseOptions);
        }
export type TaskAttachmentLinkQueryHookResult = ReturnType<typeof useTaskAttachmentLinkQuery>;
export type TaskAttachmentLinkLazyQueryHookResult = ReturnType<typeof useTaskAttachmentLinkLazyQuery>;
export type TaskAttachmentLinkQueryResult = Apollo.QueryResult<TaskAttachmentLinkQuery, TaskAttachmentLinkQueryVariables>;
export const TaskAttachmentRulesDocument = gql`
    query TaskAttachmentRules {
  taskAttachmentLimits {
    maxBytes
    maxPerTask
    allowedExtensions
    acceptAttribute
  }
}
    `;

/**
 * __useTaskAttachmentRulesQuery__
 *
 * To run a query within a React component, call `useTaskAttachmentRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskAttachmentRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskAttachmentRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskAttachmentRulesQuery(baseOptions?: Apollo.QueryHookOptions<TaskAttachmentRulesQuery, TaskAttachmentRulesQueryVariables>) {
        return Apollo.useQuery<TaskAttachmentRulesQuery, TaskAttachmentRulesQueryVariables>(TaskAttachmentRulesDocument, baseOptions);
      }
export function useTaskAttachmentRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskAttachmentRulesQuery, TaskAttachmentRulesQueryVariables>) {
          return Apollo.useLazyQuery<TaskAttachmentRulesQuery, TaskAttachmentRulesQueryVariables>(TaskAttachmentRulesDocument, baseOptions);
        }
export type TaskAttachmentRulesQueryHookResult = ReturnType<typeof useTaskAttachmentRulesQuery>;
export type TaskAttachmentRulesLazyQueryHookResult = ReturnType<typeof useTaskAttachmentRulesLazyQuery>;
export type TaskAttachmentRulesQueryResult = Apollo.QueryResult<TaskAttachmentRulesQuery, TaskAttachmentRulesQueryVariables>;
export const StaffUsersListDocument = gql`
    query StaffUsersList {
  staffUsers {
    id
    name
    email
  }
}
    `;

/**
 * __useStaffUsersListQuery__
 *
 * To run a query within a React component, call `useStaffUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffUsersListQuery({
 *   variables: {
 *   },
 * });
 */
export function useStaffUsersListQuery(baseOptions?: Apollo.QueryHookOptions<StaffUsersListQuery, StaffUsersListQueryVariables>) {
        return Apollo.useQuery<StaffUsersListQuery, StaffUsersListQueryVariables>(StaffUsersListDocument, baseOptions);
      }
export function useStaffUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffUsersListQuery, StaffUsersListQueryVariables>) {
          return Apollo.useLazyQuery<StaffUsersListQuery, StaffUsersListQueryVariables>(StaffUsersListDocument, baseOptions);
        }
export type StaffUsersListQueryHookResult = ReturnType<typeof useStaffUsersListQuery>;
export type StaffUsersListLazyQueryHookResult = ReturnType<typeof useStaffUsersListLazyQuery>;
export type StaffUsersListQueryResult = Apollo.QueryResult<StaffUsersListQuery, StaffUsersListQueryVariables>;
export const StudentMiniCardViewDocument = gql`
    query StudentMiniCardView($studentId: ID!) {
  studentMiniCard(studentId: $studentId) {
    studentId
    firstName
    lastName
    middleName
    email
    phone
    isLmsBlocked
    groups {
      agreementId
      agreementTitle
      groupId
      groupName
      courseName
      status
      terminatedDate
      freeOfCharge
      statePrefinanced
      paymentByCompany
    }
    finance {
      isDebtor
      overdueAmounts {
        amount
        currency
      }
      overdueInvoiceCount
      maxOverdueDays
      overdueSince
      isBlocked
      blockReason
      totals {
        byCurrency {
          currency
          totalBudget
          totalPaid
          totalDebt
          totalUpcoming
        }
      }
    }
    openTasksCount
    recentTasks {
      id
      title
      status
      priority
      dueDate
      assigneeName
    }
    notesCount
    recentNotes {
      id
      body
      sentiment
      pinned
      createdAt
      authorName
    }
    surveys {
      respondedCount
      pendingCount
      avgScore
      negativeCount
      lastSubmittedAt
      recentSignals {
        responseId
        surveyTitle
        groupName
        lessonNumber
        teacherName
        submittedAt
        score
        sentiment
        excerpt
      }
    }
  }
}
    `;

/**
 * __useStudentMiniCardViewQuery__
 *
 * To run a query within a React component, call `useStudentMiniCardViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMiniCardViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMiniCardViewQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentMiniCardViewQuery(baseOptions: Apollo.QueryHookOptions<StudentMiniCardViewQuery, StudentMiniCardViewQueryVariables>) {
        return Apollo.useQuery<StudentMiniCardViewQuery, StudentMiniCardViewQueryVariables>(StudentMiniCardViewDocument, baseOptions);
      }
export function useStudentMiniCardViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentMiniCardViewQuery, StudentMiniCardViewQueryVariables>) {
          return Apollo.useLazyQuery<StudentMiniCardViewQuery, StudentMiniCardViewQueryVariables>(StudentMiniCardViewDocument, baseOptions);
        }
export type StudentMiniCardViewQueryHookResult = ReturnType<typeof useStudentMiniCardViewQuery>;
export type StudentMiniCardViewLazyQueryHookResult = ReturnType<typeof useStudentMiniCardViewLazyQuery>;
export type StudentMiniCardViewQueryResult = Apollo.QueryResult<StudentMiniCardViewQuery, StudentMiniCardViewQueryVariables>;
export const StudentSlackWorkspacesDocument = gql`
    query StudentSlackWorkspaces($id: ID!) {
  student(id: $id) {
    id
    slackWorkspaces {
      groupId
      groupName
      teamId
      workspaceName
      workspaceUrl
      slackUserId
      displayName
      agreementTerminated
      openWorkspaceUrl
      profileUrl
      appProfileUrl
      adminUrl
    }
  }
}
    `;

/**
 * __useStudentSlackWorkspacesQuery__
 *
 * To run a query within a React component, call `useStudentSlackWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSlackWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSlackWorkspacesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentSlackWorkspacesQuery(baseOptions: Apollo.QueryHookOptions<StudentSlackWorkspacesQuery, StudentSlackWorkspacesQueryVariables>) {
        return Apollo.useQuery<StudentSlackWorkspacesQuery, StudentSlackWorkspacesQueryVariables>(StudentSlackWorkspacesDocument, baseOptions);
      }
export function useStudentSlackWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentSlackWorkspacesQuery, StudentSlackWorkspacesQueryVariables>) {
          return Apollo.useLazyQuery<StudentSlackWorkspacesQuery, StudentSlackWorkspacesQueryVariables>(StudentSlackWorkspacesDocument, baseOptions);
        }
export type StudentSlackWorkspacesQueryHookResult = ReturnType<typeof useStudentSlackWorkspacesQuery>;
export type StudentSlackWorkspacesLazyQueryHookResult = ReturnType<typeof useStudentSlackWorkspacesLazyQuery>;
export type StudentSlackWorkspacesQueryResult = Apollo.QueryResult<StudentSlackWorkspacesQuery, StudentSlackWorkspacesQueryVariables>;
export const TaskSmartLinksDocument = gql`
    query TaskSmartLinks($text: String!) {
  taskSmartLinks(text: $text) {
    kind
    id
    label
    hint
    reason
    confident
  }
}
    `;

/**
 * __useTaskSmartLinksQuery__
 *
 * To run a query within a React component, call `useTaskSmartLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskSmartLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskSmartLinksQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useTaskSmartLinksQuery(baseOptions: Apollo.QueryHookOptions<TaskSmartLinksQuery, TaskSmartLinksQueryVariables>) {
        return Apollo.useQuery<TaskSmartLinksQuery, TaskSmartLinksQueryVariables>(TaskSmartLinksDocument, baseOptions);
      }
export function useTaskSmartLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskSmartLinksQuery, TaskSmartLinksQueryVariables>) {
          return Apollo.useLazyQuery<TaskSmartLinksQuery, TaskSmartLinksQueryVariables>(TaskSmartLinksDocument, baseOptions);
        }
export type TaskSmartLinksQueryHookResult = ReturnType<typeof useTaskSmartLinksQuery>;
export type TaskSmartLinksLazyQueryHookResult = ReturnType<typeof useTaskSmartLinksLazyQuery>;
export type TaskSmartLinksQueryResult = Apollo.QueryResult<TaskSmartLinksQuery, TaskSmartLinksQueryVariables>;
export const TaskImageUrlsDocument = gql`
    query TaskImageUrls($attachmentIds: [ID!]!) {
  staffTaskImageUrls(attachmentIds: $attachmentIds) {
    id
    url
    expiresAt
  }
}
    `;

/**
 * __useTaskImageUrlsQuery__
 *
 * To run a query within a React component, call `useTaskImageUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskImageUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskImageUrlsQuery({
 *   variables: {
 *      attachmentIds: // value for 'attachmentIds'
 *   },
 * });
 */
export function useTaskImageUrlsQuery(baseOptions: Apollo.QueryHookOptions<TaskImageUrlsQuery, TaskImageUrlsQueryVariables>) {
        return Apollo.useQuery<TaskImageUrlsQuery, TaskImageUrlsQueryVariables>(TaskImageUrlsDocument, baseOptions);
      }
export function useTaskImageUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskImageUrlsQuery, TaskImageUrlsQueryVariables>) {
          return Apollo.useLazyQuery<TaskImageUrlsQuery, TaskImageUrlsQueryVariables>(TaskImageUrlsDocument, baseOptions);
        }
export type TaskImageUrlsQueryHookResult = ReturnType<typeof useTaskImageUrlsQuery>;
export type TaskImageUrlsLazyQueryHookResult = ReturnType<typeof useTaskImageUrlsLazyQuery>;
export type TaskImageUrlsQueryResult = Apollo.QueryResult<TaskImageUrlsQuery, TaskImageUrlsQueryVariables>;
export const ErpSurveysListDocument = gql`
    query ErpSurveysList($courseId: ID, $includeArchived: Boolean, $search: String) {
  surveys(courseId: $courseId, includeArchived: $includeArchived, search: $search) {
    id
    title
    courseId
    courseName
    defaultLessonNumber
    isArchived
    hasResponses
    questionsCount
    assignmentsCount
    groupNames
    updatedAt
  }
}
    `;

/**
 * __useErpSurveysListQuery__
 *
 * To run a query within a React component, call `useErpSurveysListQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveysListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveysListQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      includeArchived: // value for 'includeArchived'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpSurveysListQuery(baseOptions?: Apollo.QueryHookOptions<ErpSurveysListQuery, ErpSurveysListQueryVariables>) {
        return Apollo.useQuery<ErpSurveysListQuery, ErpSurveysListQueryVariables>(ErpSurveysListDocument, baseOptions);
      }
export function useErpSurveysListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveysListQuery, ErpSurveysListQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveysListQuery, ErpSurveysListQueryVariables>(ErpSurveysListDocument, baseOptions);
        }
export type ErpSurveysListQueryHookResult = ReturnType<typeof useErpSurveysListQuery>;
export type ErpSurveysListLazyQueryHookResult = ReturnType<typeof useErpSurveysListLazyQuery>;
export type ErpSurveysListQueryResult = Apollo.QueryResult<ErpSurveysListQuery, ErpSurveysListQueryVariables>;
export const ErpSurveyDetailDocument = gql`
    query ErpSurveyDetail($id: ID!) {
  survey(id: $id) {
    id
    title
    description
    courseId
    courseName
    defaultLessonNumber
    isArchived
    hasResponses
    questions {
      id
      number
      text
      questionType
      metric
      required
      options
    }
  }
}
    `;

/**
 * __useErpSurveyDetailQuery__
 *
 * To run a query within a React component, call `useErpSurveyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErpSurveyDetailQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyDetailQuery, ErpSurveyDetailQueryVariables>) {
        return Apollo.useQuery<ErpSurveyDetailQuery, ErpSurveyDetailQueryVariables>(ErpSurveyDetailDocument, baseOptions);
      }
export function useErpSurveyDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyDetailQuery, ErpSurveyDetailQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyDetailQuery, ErpSurveyDetailQueryVariables>(ErpSurveyDetailDocument, baseOptions);
        }
export type ErpSurveyDetailQueryHookResult = ReturnType<typeof useErpSurveyDetailQuery>;
export type ErpSurveyDetailLazyQueryHookResult = ReturnType<typeof useErpSurveyDetailLazyQuery>;
export type ErpSurveyDetailQueryResult = Apollo.QueryResult<ErpSurveyDetailQuery, ErpSurveyDetailQueryVariables>;
export const ErpGroupSurveyAssignmentsDocument = gql`
    query ErpGroupSurveyAssignments($groupId: ID!) {
  groupSurveyAssignments(groupId: $groupId) {
    id
    surveyId
    surveyTitle
    lessonId
    lessonName
    lessonNumber
    lessonDate
    isActive
    origin
    planId
    respondedCount
    eligibleCount
  }
}
    `;

/**
 * __useErpGroupSurveyAssignmentsQuery__
 *
 * To run a query within a React component, call `useErpGroupSurveyAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpGroupSurveyAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpGroupSurveyAssignmentsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useErpGroupSurveyAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<ErpGroupSurveyAssignmentsQuery, ErpGroupSurveyAssignmentsQueryVariables>) {
        return Apollo.useQuery<ErpGroupSurveyAssignmentsQuery, ErpGroupSurveyAssignmentsQueryVariables>(ErpGroupSurveyAssignmentsDocument, baseOptions);
      }
export function useErpGroupSurveyAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpGroupSurveyAssignmentsQuery, ErpGroupSurveyAssignmentsQueryVariables>) {
          return Apollo.useLazyQuery<ErpGroupSurveyAssignmentsQuery, ErpGroupSurveyAssignmentsQueryVariables>(ErpGroupSurveyAssignmentsDocument, baseOptions);
        }
export type ErpGroupSurveyAssignmentsQueryHookResult = ReturnType<typeof useErpGroupSurveyAssignmentsQuery>;
export type ErpGroupSurveyAssignmentsLazyQueryHookResult = ReturnType<typeof useErpGroupSurveyAssignmentsLazyQuery>;
export type ErpGroupSurveyAssignmentsQueryResult = Apollo.QueryResult<ErpGroupSurveyAssignmentsQuery, ErpGroupSurveyAssignmentsQueryVariables>;
export const ErpSurveyTargetingDocument = gql`
    query ErpSurveyTargeting($surveyId: ID!) {
  surveyTargeting(surveyId: $surveyId) {
    plans {
      id
      scope
      courseId
      courseName
      onlyActiveGroups
      triggerKind
      triggerLessonNumber
      skipPastLessons
      isActive
      assignmentsCount
      respondedCount
      hasResponses
      groups {
        groupId
        groupName
      }
    }
  }
}
    `;

/**
 * __useErpSurveyTargetingQuery__
 *
 * To run a query within a React component, call `useErpSurveyTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyTargetingQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useErpSurveyTargetingQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyTargetingQuery, ErpSurveyTargetingQueryVariables>) {
        return Apollo.useQuery<ErpSurveyTargetingQuery, ErpSurveyTargetingQueryVariables>(ErpSurveyTargetingDocument, baseOptions);
      }
export function useErpSurveyTargetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyTargetingQuery, ErpSurveyTargetingQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyTargetingQuery, ErpSurveyTargetingQueryVariables>(ErpSurveyTargetingDocument, baseOptions);
        }
export type ErpSurveyTargetingQueryHookResult = ReturnType<typeof useErpSurveyTargetingQuery>;
export type ErpSurveyTargetingLazyQueryHookResult = ReturnType<typeof useErpSurveyTargetingLazyQuery>;
export type ErpSurveyTargetingQueryResult = Apollo.QueryResult<ErpSurveyTargetingQuery, ErpSurveyTargetingQueryVariables>;
export const ErpSurveyTargetGroupsDocument = gql`
    query ErpSurveyTargetGroups($surveyId: ID, $courseId: ID, $search: String, $onlyActive: Boolean, $triggerKind: String, $triggerLessonNumber: Int) {
  surveyTargetGroups(
    surveyId: $surveyId
    courseId: $courseId
    search: $search
    onlyActive: $onlyActive
    triggerKind: $triggerKind
    triggerLessonNumber: $triggerLessonNumber
  ) {
    groupId
    groupName
    courseId
    courseName
    startDate
    lessonsCount
    isActive
    resolvedLessonId
    resolvedLessonName
    resolvedLessonNumber
    resolvedLessonDate
    resolvedLessonIsOver
    skipReason
    alreadyAttached
  }
}
    `;

/**
 * __useErpSurveyTargetGroupsQuery__
 *
 * To run a query within a React component, call `useErpSurveyTargetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyTargetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyTargetGroupsQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      courseId: // value for 'courseId'
 *      search: // value for 'search'
 *      onlyActive: // value for 'onlyActive'
 *      triggerKind: // value for 'triggerKind'
 *      triggerLessonNumber: // value for 'triggerLessonNumber'
 *   },
 * });
 */
export function useErpSurveyTargetGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ErpSurveyTargetGroupsQuery, ErpSurveyTargetGroupsQueryVariables>) {
        return Apollo.useQuery<ErpSurveyTargetGroupsQuery, ErpSurveyTargetGroupsQueryVariables>(ErpSurveyTargetGroupsDocument, baseOptions);
      }
export function useErpSurveyTargetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyTargetGroupsQuery, ErpSurveyTargetGroupsQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyTargetGroupsQuery, ErpSurveyTargetGroupsQueryVariables>(ErpSurveyTargetGroupsDocument, baseOptions);
        }
export type ErpSurveyTargetGroupsQueryHookResult = ReturnType<typeof useErpSurveyTargetGroupsQuery>;
export type ErpSurveyTargetGroupsLazyQueryHookResult = ReturnType<typeof useErpSurveyTargetGroupsLazyQuery>;
export type ErpSurveyTargetGroupsQueryResult = Apollo.QueryResult<ErpSurveyTargetGroupsQuery, ErpSurveyTargetGroupsQueryVariables>;
export const ErpSurveySummaryDocument = gql`
    query ErpSurveySummary($surveyId: ID!, $groupIds: [ID!], $planId: ID, $dateFrom: Date, $dateTo: Date) {
  surveySummary(
    surveyId: $surveyId
    groupIds: $groupIds
    planId: $planId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    survey {
      id
      title
      courseName
    }
    assignmentsCount
    groupsCount
    respondedCount
    eligibleCount
    responseRate
    questionResults {
      question {
        id
        number
        text
        questionType
        metric
        required
        options
      }
      answersCount
      average
      distribution {
        key
        label
        count
      }
    }
    groupBreakdown {
      assignmentId
      groupId
      groupName
      lessonName
      lessonNumber
      lessonDate
      isActive
      origin
      respondedCount
      eligibleCount
      responseRate
      averageRating
    }
  }
}
    `;

/**
 * __useErpSurveySummaryQuery__
 *
 * To run a query within a React component, call `useErpSurveySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveySummaryQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      groupIds: // value for 'groupIds'
 *      planId: // value for 'planId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useErpSurveySummaryQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveySummaryQuery, ErpSurveySummaryQueryVariables>) {
        return Apollo.useQuery<ErpSurveySummaryQuery, ErpSurveySummaryQueryVariables>(ErpSurveySummaryDocument, baseOptions);
      }
export function useErpSurveySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveySummaryQuery, ErpSurveySummaryQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveySummaryQuery, ErpSurveySummaryQueryVariables>(ErpSurveySummaryDocument, baseOptions);
        }
export type ErpSurveySummaryQueryHookResult = ReturnType<typeof useErpSurveySummaryQuery>;
export type ErpSurveySummaryLazyQueryHookResult = ReturnType<typeof useErpSurveySummaryLazyQuery>;
export type ErpSurveySummaryQueryResult = Apollo.QueryResult<ErpSurveySummaryQuery, ErpSurveySummaryQueryVariables>;
export const ErpTeacherSurveyFeedbackDocument = gql`
    query ErpTeacherSurveyFeedback($teacherId: ID!, $courseId: ID, $groupId: ID, $dateFrom: Date, $dateTo: Date, $bucket: String) {
  teacherSurveyFeedback(
    teacherId: $teacherId
    courseId: $courseId
    groupId: $groupId
    dateFrom: $dateFrom
    dateTo: $dateTo
    bucket: $bucket
  ) {
    teacherId
    teacherName
    average
    ratingsCount
    commentsCount
    trend {
      period
      average
      count
    }
    byCourse {
      id
      name
      average
      count
    }
    byGroup {
      id
      name
      average
      count
    }
    comments {
      studentName
      comment
      createdAt
      courseName
      groupName
    }
  }
}
    `;

/**
 * __useErpTeacherSurveyFeedbackQuery__
 *
 * To run a query within a React component, call `useErpTeacherSurveyFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherSurveyFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherSurveyFeedbackQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      courseId: // value for 'courseId'
 *      groupId: // value for 'groupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      bucket: // value for 'bucket'
 *   },
 * });
 */
export function useErpTeacherSurveyFeedbackQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherSurveyFeedbackQuery, ErpTeacherSurveyFeedbackQueryVariables>) {
        return Apollo.useQuery<ErpTeacherSurveyFeedbackQuery, ErpTeacherSurveyFeedbackQueryVariables>(ErpTeacherSurveyFeedbackDocument, baseOptions);
      }
export function useErpTeacherSurveyFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherSurveyFeedbackQuery, ErpTeacherSurveyFeedbackQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherSurveyFeedbackQuery, ErpTeacherSurveyFeedbackQueryVariables>(ErpTeacherSurveyFeedbackDocument, baseOptions);
        }
export type ErpTeacherSurveyFeedbackQueryHookResult = ReturnType<typeof useErpTeacherSurveyFeedbackQuery>;
export type ErpTeacherSurveyFeedbackLazyQueryHookResult = ReturnType<typeof useErpTeacherSurveyFeedbackLazyQuery>;
export type ErpTeacherSurveyFeedbackQueryResult = Apollo.QueryResult<ErpTeacherSurveyFeedbackQuery, ErpTeacherSurveyFeedbackQueryVariables>;
export const ErpTeacherSurveyLeaderboardDocument = gql`
    query ErpTeacherSurveyLeaderboard($courseId: ID, $dateFrom: Date, $dateTo: Date, $minResponses: Int) {
  teacherSurveyLeaderboard(
    courseId: $courseId
    dateFrom: $dateFrom
    dateTo: $dateTo
    minResponses: $minResponses
  ) {
    teacherId
    teacherName
    average
    ratingsCount
    commentsCount
    coursesCount
    enoughData
  }
}
    `;

/**
 * __useErpTeacherSurveyLeaderboardQuery__
 *
 * To run a query within a React component, call `useErpTeacherSurveyLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherSurveyLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherSurveyLeaderboardQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      minResponses: // value for 'minResponses'
 *   },
 * });
 */
export function useErpTeacherSurveyLeaderboardQuery(baseOptions?: Apollo.QueryHookOptions<ErpTeacherSurveyLeaderboardQuery, ErpTeacherSurveyLeaderboardQueryVariables>) {
        return Apollo.useQuery<ErpTeacherSurveyLeaderboardQuery, ErpTeacherSurveyLeaderboardQueryVariables>(ErpTeacherSurveyLeaderboardDocument, baseOptions);
      }
export function useErpTeacherSurveyLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherSurveyLeaderboardQuery, ErpTeacherSurveyLeaderboardQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherSurveyLeaderboardQuery, ErpTeacherSurveyLeaderboardQueryVariables>(ErpTeacherSurveyLeaderboardDocument, baseOptions);
        }
export type ErpTeacherSurveyLeaderboardQueryHookResult = ReturnType<typeof useErpTeacherSurveyLeaderboardQuery>;
export type ErpTeacherSurveyLeaderboardLazyQueryHookResult = ReturnType<typeof useErpTeacherSurveyLeaderboardLazyQuery>;
export type ErpTeacherSurveyLeaderboardQueryResult = Apollo.QueryResult<ErpTeacherSurveyLeaderboardQuery, ErpTeacherSurveyLeaderboardQueryVariables>;
export const ErpSurveyAssignmentResultsDocument = gql`
    query ErpSurveyAssignmentResults($assignmentId: ID!) {
  surveyAssignmentResults(assignmentId: $assignmentId) {
    assignment {
      id
      surveyTitle
      groupId
      groupName
      lessonName
      lessonNumber
      respondedCount
      eligibleCount
    }
    respondents {
      studentId
      fullName
      email
      responded
      submittedAt
      responseId
    }
    questionResults {
      question {
        id
        number
        text
        questionType
        metric
        required
        options
      }
      answersCount
      average
      distribution {
        key
        label
        count
      }
    }
  }
}
    `;

/**
 * __useErpSurveyAssignmentResultsQuery__
 *
 * To run a query within a React component, call `useErpSurveyAssignmentResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyAssignmentResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyAssignmentResultsQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useErpSurveyAssignmentResultsQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyAssignmentResultsQuery, ErpSurveyAssignmentResultsQueryVariables>) {
        return Apollo.useQuery<ErpSurveyAssignmentResultsQuery, ErpSurveyAssignmentResultsQueryVariables>(ErpSurveyAssignmentResultsDocument, baseOptions);
      }
export function useErpSurveyAssignmentResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyAssignmentResultsQuery, ErpSurveyAssignmentResultsQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyAssignmentResultsQuery, ErpSurveyAssignmentResultsQueryVariables>(ErpSurveyAssignmentResultsDocument, baseOptions);
        }
export type ErpSurveyAssignmentResultsQueryHookResult = ReturnType<typeof useErpSurveyAssignmentResultsQuery>;
export type ErpSurveyAssignmentResultsLazyQueryHookResult = ReturnType<typeof useErpSurveyAssignmentResultsLazyQuery>;
export type ErpSurveyAssignmentResultsQueryResult = Apollo.QueryResult<ErpSurveyAssignmentResultsQuery, ErpSurveyAssignmentResultsQueryVariables>;
export const ErpSurveyResponseDetailDocument = gql`
    query ErpSurveyResponseDetail($responseId: ID!) {
  surveyResponseDetail(responseId: $responseId) {
    responseId
    studentId
    fullName
    submittedAt
    answers {
      questionId
      value
    }
  }
}
    `;

/**
 * __useErpSurveyResponseDetailQuery__
 *
 * To run a query within a React component, call `useErpSurveyResponseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyResponseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyResponseDetailQuery({
 *   variables: {
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useErpSurveyResponseDetailQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyResponseDetailQuery, ErpSurveyResponseDetailQueryVariables>) {
        return Apollo.useQuery<ErpSurveyResponseDetailQuery, ErpSurveyResponseDetailQueryVariables>(ErpSurveyResponseDetailDocument, baseOptions);
      }
export function useErpSurveyResponseDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyResponseDetailQuery, ErpSurveyResponseDetailQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyResponseDetailQuery, ErpSurveyResponseDetailQueryVariables>(ErpSurveyResponseDetailDocument, baseOptions);
        }
export type ErpSurveyResponseDetailQueryHookResult = ReturnType<typeof useErpSurveyResponseDetailQuery>;
export type ErpSurveyResponseDetailLazyQueryHookResult = ReturnType<typeof useErpSurveyResponseDetailLazyQuery>;
export type ErpSurveyResponseDetailQueryResult = Apollo.QueryResult<ErpSurveyResponseDetailQuery, ErpSurveyResponseDetailQueryVariables>;
export const ErpSurveyAnalyticsDocument = gql`
    query ErpSurveyAnalytics($dimension: String!, $filter: SurveyAnalyticsFilter) {
  surveyAnalytics(dimension: $dimension, filter: $filter) {
    key
    label
    sortKey
    assignmentsCount
    surveysCount
    responsesCount
    studentsCount
    answersCount
    eligibleCount
    responseRate
    avgScore
    negativeShare
    avgRating
    avgNps
    avgTeacherRating
    yesShare
    lowAnswersShare
  }
}
    `;

/**
 * __useErpSurveyAnalyticsQuery__
 *
 * To run a query within a React component, call `useErpSurveyAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyAnalyticsQuery({
 *   variables: {
 *      dimension: // value for 'dimension'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useErpSurveyAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyAnalyticsQuery, ErpSurveyAnalyticsQueryVariables>) {
        return Apollo.useQuery<ErpSurveyAnalyticsQuery, ErpSurveyAnalyticsQueryVariables>(ErpSurveyAnalyticsDocument, baseOptions);
      }
export function useErpSurveyAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyAnalyticsQuery, ErpSurveyAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyAnalyticsQuery, ErpSurveyAnalyticsQueryVariables>(ErpSurveyAnalyticsDocument, baseOptions);
        }
export type ErpSurveyAnalyticsQueryHookResult = ReturnType<typeof useErpSurveyAnalyticsQuery>;
export type ErpSurveyAnalyticsLazyQueryHookResult = ReturnType<typeof useErpSurveyAnalyticsLazyQuery>;
export type ErpSurveyAnalyticsQueryResult = Apollo.QueryResult<ErpSurveyAnalyticsQuery, ErpSurveyAnalyticsQueryVariables>;
export const ErpSurveySignalsDocument = gql`
    query ErpSurveySignals($dimensions: [String!], $minSample: Int, $limit: Int, $filter: SurveyAnalyticsFilter) {
  surveySignals(
    dimensions: $dimensions
    minSample: $minSample
    limit: $limit
    filter: $filter
  ) {
    kind
    dimension
    key
    label
    value
    previousValue
    delta
    sampleSize
    severity
  }
}
    `;

/**
 * __useErpSurveySignalsQuery__
 *
 * To run a query within a React component, call `useErpSurveySignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveySignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveySignalsQuery({
 *   variables: {
 *      dimensions: // value for 'dimensions'
 *      minSample: // value for 'minSample'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useErpSurveySignalsQuery(baseOptions?: Apollo.QueryHookOptions<ErpSurveySignalsQuery, ErpSurveySignalsQueryVariables>) {
        return Apollo.useQuery<ErpSurveySignalsQuery, ErpSurveySignalsQueryVariables>(ErpSurveySignalsDocument, baseOptions);
      }
export function useErpSurveySignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveySignalsQuery, ErpSurveySignalsQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveySignalsQuery, ErpSurveySignalsQueryVariables>(ErpSurveySignalsDocument, baseOptions);
        }
export type ErpSurveySignalsQueryHookResult = ReturnType<typeof useErpSurveySignalsQuery>;
export type ErpSurveySignalsLazyQueryHookResult = ReturnType<typeof useErpSurveySignalsLazyQuery>;
export type ErpSurveySignalsQueryResult = Apollo.QueryResult<ErpSurveySignalsQuery, ErpSurveySignalsQueryVariables>;
export const ErpSurveyQuestionBreakdownDocument = gql`
    query ErpSurveyQuestionBreakdown($surveyId: ID!, $questionId: ID!, $dimension: String!, $filter: SurveyAnalyticsFilter) {
  surveyQuestionBreakdown(
    surveyId: $surveyId
    questionId: $questionId
    dimension: $dimension
    filter: $filter
  ) {
    dimension
    question {
      id
      number
      text
      questionType
      metric
      required
      options
    }
    total {
      answersCount
      average
      distribution {
        key
        label
        count
      }
    }
    slices {
      key
      label
      sortKey
      responsesCount
      result {
        answersCount
        average
        distribution {
          key
          label
          count
        }
      }
    }
  }
}
    `;

/**
 * __useErpSurveyQuestionBreakdownQuery__
 *
 * To run a query within a React component, call `useErpSurveyQuestionBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyQuestionBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyQuestionBreakdownQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      questionId: // value for 'questionId'
 *      dimension: // value for 'dimension'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useErpSurveyQuestionBreakdownQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyQuestionBreakdownQuery, ErpSurveyQuestionBreakdownQueryVariables>) {
        return Apollo.useQuery<ErpSurveyQuestionBreakdownQuery, ErpSurveyQuestionBreakdownQueryVariables>(ErpSurveyQuestionBreakdownDocument, baseOptions);
      }
export function useErpSurveyQuestionBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyQuestionBreakdownQuery, ErpSurveyQuestionBreakdownQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyQuestionBreakdownQuery, ErpSurveyQuestionBreakdownQueryVariables>(ErpSurveyQuestionBreakdownDocument, baseOptions);
        }
export type ErpSurveyQuestionBreakdownQueryHookResult = ReturnType<typeof useErpSurveyQuestionBreakdownQuery>;
export type ErpSurveyQuestionBreakdownLazyQueryHookResult = ReturnType<typeof useErpSurveyQuestionBreakdownLazyQuery>;
export type ErpSurveyQuestionBreakdownQueryResult = Apollo.QueryResult<ErpSurveyQuestionBreakdownQuery, ErpSurveyQuestionBreakdownQueryVariables>;
export const ErpSurveyCommentsDocument = gql`
    query ErpSurveyComments($filter: SurveyAnalyticsFilter, $search: String, $sentiment: String, $first: Int, $after: String, $problemOnly: Boolean) {
  surveyComments(
    filter: $filter
    search: $search
    sentiment: $sentiment
    first: $first
    after: $after
    problemOnly: $problemOnly
  ) {
    hasNext
    cursor
    items {
      answerId
      responseId
      questionId
      questionText
      metric
      text
      studentId
      studentName
      groupId
      groupName
      courseName
      surveyId
      surveyTitle
      lessonNumber
      lessonDate
      teacherId
      teacherName
      submittedAt
      score
      sentiment
      insight {
        lang
        textRu
        textPl
        sentiment
        isProblem
        topic
        summary
      }
    }
  }
}
    `;

/**
 * __useErpSurveyCommentsQuery__
 *
 * To run a query within a React component, call `useErpSurveyCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyCommentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      sentiment: // value for 'sentiment'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      problemOnly: // value for 'problemOnly'
 *   },
 * });
 */
export function useErpSurveyCommentsQuery(baseOptions?: Apollo.QueryHookOptions<ErpSurveyCommentsQuery, ErpSurveyCommentsQueryVariables>) {
        return Apollo.useQuery<ErpSurveyCommentsQuery, ErpSurveyCommentsQueryVariables>(ErpSurveyCommentsDocument, baseOptions);
      }
export function useErpSurveyCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyCommentsQuery, ErpSurveyCommentsQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyCommentsQuery, ErpSurveyCommentsQueryVariables>(ErpSurveyCommentsDocument, baseOptions);
        }
export type ErpSurveyCommentsQueryHookResult = ReturnType<typeof useErpSurveyCommentsQuery>;
export type ErpSurveyCommentsLazyQueryHookResult = ReturnType<typeof useErpSurveyCommentsLazyQuery>;
export type ErpSurveyCommentsQueryResult = Apollo.QueryResult<ErpSurveyCommentsQuery, ErpSurveyCommentsQueryVariables>;
export const ErpSurveyAssignmentsDocument = gql`
    query ErpSurveyAssignments($surveyId: ID!, $groupIds: [ID!], $planId: ID, $onlyActive: Boolean, $origin: String, $search: String) {
  surveyAssignments(
    surveyId: $surveyId
    groupIds: $groupIds
    planId: $planId
    onlyActive: $onlyActive
    origin: $origin
    search: $search
  ) {
    assignmentId
    surveyId
    surveyTitle
    groupId
    groupName
    courseId
    courseName
    lessonId
    lessonName
    lessonNumber
    lessonDate
    teacherId
    teacherName
    isActive
    origin
    planId
    createdAt
    respondedCount
    eligibleCount
    responseRate
    averageRating
    avgScore
    negativeShare
  }
}
    `;

/**
 * __useErpSurveyAssignmentsQuery__
 *
 * To run a query within a React component, call `useErpSurveyAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyAssignmentsQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      groupIds: // value for 'groupIds'
 *      planId: // value for 'planId'
 *      onlyActive: // value for 'onlyActive'
 *      origin: // value for 'origin'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpSurveyAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyAssignmentsQuery, ErpSurveyAssignmentsQueryVariables>) {
        return Apollo.useQuery<ErpSurveyAssignmentsQuery, ErpSurveyAssignmentsQueryVariables>(ErpSurveyAssignmentsDocument, baseOptions);
      }
export function useErpSurveyAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyAssignmentsQuery, ErpSurveyAssignmentsQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyAssignmentsQuery, ErpSurveyAssignmentsQueryVariables>(ErpSurveyAssignmentsDocument, baseOptions);
        }
export type ErpSurveyAssignmentsQueryHookResult = ReturnType<typeof useErpSurveyAssignmentsQuery>;
export type ErpSurveyAssignmentsLazyQueryHookResult = ReturnType<typeof useErpSurveyAssignmentsLazyQuery>;
export type ErpSurveyAssignmentsQueryResult = Apollo.QueryResult<ErpSurveyAssignmentsQuery, ErpSurveyAssignmentsQueryVariables>;
export const ErpStudentSurveyResponsesDocument = gql`
    query ErpStudentSurveyResponses($studentId: ID!, $surveyId: ID, $groupId: ID, $includePending: Boolean) {
  studentSurveyResponses(
    studentId: $studentId
    surveyId: $surveyId
    groupId: $groupId
    includePending: $includePending
  ) {
    studentId
    fullName
    respondedCount
    pendingCount
    avgScore
    negativeCount
    responses {
      responseId
      assignmentId
      surveyId
      surveyTitle
      groupId
      groupName
      courseName
      lessonId
      lessonName
      lessonNumber
      lessonDate
      teacherId
      teacherName
      submittedAt
      score
      minScore
      scoredAnswersCount
      sentiment
      excerpt
      questions {
        id
        number
        text
        questionType
        metric
        required
        options
      }
      answers {
        questionId
        value
      }
    }
    pending {
      assignmentId
      surveyId
      surveyTitle
      groupId
      groupName
      lessonId
      lessonName
      lessonNumber
      lessonDate
      teacherName
    }
  }
}
    `;

/**
 * __useErpStudentSurveyResponsesQuery__
 *
 * To run a query within a React component, call `useErpStudentSurveyResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpStudentSurveyResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpStudentSurveyResponsesQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      surveyId: // value for 'surveyId'
 *      groupId: // value for 'groupId'
 *      includePending: // value for 'includePending'
 *   },
 * });
 */
export function useErpStudentSurveyResponsesQuery(baseOptions: Apollo.QueryHookOptions<ErpStudentSurveyResponsesQuery, ErpStudentSurveyResponsesQueryVariables>) {
        return Apollo.useQuery<ErpStudentSurveyResponsesQuery, ErpStudentSurveyResponsesQueryVariables>(ErpStudentSurveyResponsesDocument, baseOptions);
      }
export function useErpStudentSurveyResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpStudentSurveyResponsesQuery, ErpStudentSurveyResponsesQueryVariables>) {
          return Apollo.useLazyQuery<ErpStudentSurveyResponsesQuery, ErpStudentSurveyResponsesQueryVariables>(ErpStudentSurveyResponsesDocument, baseOptions);
        }
export type ErpStudentSurveyResponsesQueryHookResult = ReturnType<typeof useErpStudentSurveyResponsesQuery>;
export type ErpStudentSurveyResponsesLazyQueryHookResult = ReturnType<typeof useErpStudentSurveyResponsesLazyQuery>;
export type ErpStudentSurveyResponsesQueryResult = Apollo.QueryResult<ErpStudentSurveyResponsesQuery, ErpStudentSurveyResponsesQueryVariables>;
export const ErpSurveyQuestionTagsDocument = gql`
    query ErpSurveyQuestionTags($onlyUntagged: Boolean, $courseId: ID, $search: String) {
  surveyQuestionTags(
    onlyUntagged: $onlyUntagged
    courseId: $courseId
    search: $search
  ) {
    questionId
    surveyId
    surveyTitle
    courseName
    number
    text
    questionType
    metric
    suggestedMetric
  }
}
    `;

/**
 * __useErpSurveyQuestionTagsQuery__
 *
 * To run a query within a React component, call `useErpSurveyQuestionTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyQuestionTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyQuestionTagsQuery({
 *   variables: {
 *      onlyUntagged: // value for 'onlyUntagged'
 *      courseId: // value for 'courseId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpSurveyQuestionTagsQuery(baseOptions?: Apollo.QueryHookOptions<ErpSurveyQuestionTagsQuery, ErpSurveyQuestionTagsQueryVariables>) {
        return Apollo.useQuery<ErpSurveyQuestionTagsQuery, ErpSurveyQuestionTagsQueryVariables>(ErpSurveyQuestionTagsDocument, baseOptions);
      }
export function useErpSurveyQuestionTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyQuestionTagsQuery, ErpSurveyQuestionTagsQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyQuestionTagsQuery, ErpSurveyQuestionTagsQueryVariables>(ErpSurveyQuestionTagsDocument, baseOptions);
        }
export type ErpSurveyQuestionTagsQueryHookResult = ReturnType<typeof useErpSurveyQuestionTagsQuery>;
export type ErpSurveyQuestionTagsLazyQueryHookResult = ReturnType<typeof useErpSurveyQuestionTagsLazyQuery>;
export type ErpSurveyQuestionTagsQueryResult = Apollo.QueryResult<ErpSurveyQuestionTagsQuery, ErpSurveyQuestionTagsQueryVariables>;
export const ErpSurveyUntaggedCountDocument = gql`
    query ErpSurveyUntaggedCount {
  surveyUntaggedCount
}
    `;

/**
 * __useErpSurveyUntaggedCountQuery__
 *
 * To run a query within a React component, call `useErpSurveyUntaggedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyUntaggedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyUntaggedCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpSurveyUntaggedCountQuery(baseOptions?: Apollo.QueryHookOptions<ErpSurveyUntaggedCountQuery, ErpSurveyUntaggedCountQueryVariables>) {
        return Apollo.useQuery<ErpSurveyUntaggedCountQuery, ErpSurveyUntaggedCountQueryVariables>(ErpSurveyUntaggedCountDocument, baseOptions);
      }
export function useErpSurveyUntaggedCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyUntaggedCountQuery, ErpSurveyUntaggedCountQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyUntaggedCountQuery, ErpSurveyUntaggedCountQueryVariables>(ErpSurveyUntaggedCountDocument, baseOptions);
        }
export type ErpSurveyUntaggedCountQueryHookResult = ReturnType<typeof useErpSurveyUntaggedCountQuery>;
export type ErpSurveyUntaggedCountLazyQueryHookResult = ReturnType<typeof useErpSurveyUntaggedCountLazyQuery>;
export type ErpSurveyUntaggedCountQueryResult = Apollo.QueryResult<ErpSurveyUntaggedCountQuery, ErpSurveyUntaggedCountQueryVariables>;
export const ErpSurveyResponseMatrixDocument = gql`
    query ErpSurveyResponseMatrix($surveyId: ID!, $groupIds: [ID!]) {
  surveyResponseMatrix(surveyId: $surveyId, groupIds: $groupIds) {
    survey {
      id
      title
    }
    questions {
      id
      number
      text
      questionType
      metric
      required
      options
    }
    rows {
      responseId
      studentId
      fullName
      groupId
      groupName
      lessonNumber
      submittedAt
      score
      sentiment
      answers {
        questionId
        value
      }
    }
  }
}
    `;

/**
 * __useErpSurveyResponseMatrixQuery__
 *
 * To run a query within a React component, call `useErpSurveyResponseMatrixQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyResponseMatrixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyResponseMatrixQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useErpSurveyResponseMatrixQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyResponseMatrixQuery, ErpSurveyResponseMatrixQueryVariables>) {
        return Apollo.useQuery<ErpSurveyResponseMatrixQuery, ErpSurveyResponseMatrixQueryVariables>(ErpSurveyResponseMatrixDocument, baseOptions);
      }
export function useErpSurveyResponseMatrixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyResponseMatrixQuery, ErpSurveyResponseMatrixQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyResponseMatrixQuery, ErpSurveyResponseMatrixQueryVariables>(ErpSurveyResponseMatrixDocument, baseOptions);
        }
export type ErpSurveyResponseMatrixQueryHookResult = ReturnType<typeof useErpSurveyResponseMatrixQuery>;
export type ErpSurveyResponseMatrixLazyQueryHookResult = ReturnType<typeof useErpSurveyResponseMatrixLazyQuery>;
export type ErpSurveyResponseMatrixQueryResult = Apollo.QueryResult<ErpSurveyResponseMatrixQuery, ErpSurveyResponseMatrixQueryVariables>;
export const ErpSurveyGroupHistoryDocument = gql`
    query ErpSurveyGroupHistory($groupId: ID!) {
  surveyGroupTimeline(groupId: $groupId) {
    rows {
      assignmentId
      surveyId
      surveyTitle
      lessonNumber
      lessonDate
      eligible
      responded
      avgScore
      negativeShare
      avgRating
      avgNps
    }
    metrics {
      metric
      avgScore
      answers
    }
  }
}
    `;

/**
 * __useErpSurveyGroupHistoryQuery__
 *
 * To run a query within a React component, call `useErpSurveyGroupHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyGroupHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyGroupHistoryQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useErpSurveyGroupHistoryQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyGroupHistoryQuery, ErpSurveyGroupHistoryQueryVariables>) {
        return Apollo.useQuery<ErpSurveyGroupHistoryQuery, ErpSurveyGroupHistoryQueryVariables>(ErpSurveyGroupHistoryDocument, baseOptions);
      }
export function useErpSurveyGroupHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyGroupHistoryQuery, ErpSurveyGroupHistoryQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyGroupHistoryQuery, ErpSurveyGroupHistoryQueryVariables>(ErpSurveyGroupHistoryDocument, baseOptions);
        }
export type ErpSurveyGroupHistoryQueryHookResult = ReturnType<typeof useErpSurveyGroupHistoryQuery>;
export type ErpSurveyGroupHistoryLazyQueryHookResult = ReturnType<typeof useErpSurveyGroupHistoryLazyQuery>;
export type ErpSurveyGroupHistoryQueryResult = Apollo.QueryResult<ErpSurveyGroupHistoryQuery, ErpSurveyGroupHistoryQueryVariables>;
export const ErpSurveyGroupStudentsDocument = gql`
    query ErpSurveyGroupStudents($groupId: ID!) {
  surveyGroupStudents(groupId: $groupId) {
    studentId
    studentName
    eligible
    responded
    avgScore
    negativeCount
    lastAnsweredAt
    lastComment
    lastCommentAt
    lastCommentInsight {
      lang
      textRu
      textPl
      sentiment
      isProblem
      topic
      summary
    }
  }
}
    `;

/**
 * __useErpSurveyGroupStudentsQuery__
 *
 * To run a query within a React component, call `useErpSurveyGroupStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyGroupStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyGroupStudentsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useErpSurveyGroupStudentsQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyGroupStudentsQuery, ErpSurveyGroupStudentsQueryVariables>) {
        return Apollo.useQuery<ErpSurveyGroupStudentsQuery, ErpSurveyGroupStudentsQueryVariables>(ErpSurveyGroupStudentsDocument, baseOptions);
      }
export function useErpSurveyGroupStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyGroupStudentsQuery, ErpSurveyGroupStudentsQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyGroupStudentsQuery, ErpSurveyGroupStudentsQueryVariables>(ErpSurveyGroupStudentsDocument, baseOptions);
        }
export type ErpSurveyGroupStudentsQueryHookResult = ReturnType<typeof useErpSurveyGroupStudentsQuery>;
export type ErpSurveyGroupStudentsLazyQueryHookResult = ReturnType<typeof useErpSurveyGroupStudentsLazyQuery>;
export type ErpSurveyGroupStudentsQueryResult = Apollo.QueryResult<ErpSurveyGroupStudentsQuery, ErpSurveyGroupStudentsQueryVariables>;
export const ErpSurveyDigestListDocument = gql`
    query ErpSurveyDigestList($scope: String!, $scopeId: ID!, $limit: Int) {
  surveyDigests(scope: $scope, scopeId: $scopeId, limit: $limit) {
    id
    scope
    scopeId
    status
    textRu
    textPl
    model
    error
    createdAt
    finishedAt
    byName
  }
}
    `;

/**
 * __useErpSurveyDigestListQuery__
 *
 * To run a query within a React component, call `useErpSurveyDigestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpSurveyDigestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpSurveyDigestListQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      scopeId: // value for 'scopeId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useErpSurveyDigestListQuery(baseOptions: Apollo.QueryHookOptions<ErpSurveyDigestListQuery, ErpSurveyDigestListQueryVariables>) {
        return Apollo.useQuery<ErpSurveyDigestListQuery, ErpSurveyDigestListQueryVariables>(ErpSurveyDigestListDocument, baseOptions);
      }
export function useErpSurveyDigestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpSurveyDigestListQuery, ErpSurveyDigestListQueryVariables>) {
          return Apollo.useLazyQuery<ErpSurveyDigestListQuery, ErpSurveyDigestListQueryVariables>(ErpSurveyDigestListDocument, baseOptions);
        }
export type ErpSurveyDigestListQueryHookResult = ReturnType<typeof useErpSurveyDigestListQuery>;
export type ErpSurveyDigestListLazyQueryHookResult = ReturnType<typeof useErpSurveyDigestListLazyQuery>;
export type ErpSurveyDigestListQueryResult = Apollo.QueryResult<ErpSurveyDigestListQuery, ErpSurveyDigestListQueryVariables>;
export const ErpTeacherAiProfileDocument = gql`
    query ErpTeacherAiProfile($teacherId: ID!) {
  teacherAiProfile(teacherId: $teacherId) {
    teacherId
    status
    summary {
      sourceKind
      text
    }
    communication {
      sourceKind
      text
    }
    teachingExperience {
      sourceKind
      text
    }
    yearsExperienceTotal
    yearsExperienceTeaching
    communicationScore
    teachingScore
    skills {
      name
      category
      claimedLevel
      assessedLevel
      evidence
      sourceKinds
    }
    languages {
      language
      level
      basis
    }
    strengths
    redFlags
    provenance {
      field
      runId
      sourceKind
    }
    suspicious
    suspicionNotes
    aiModel
    promptVersion
    errorMessage
    analyzedAt
    suggestions {
      id
      courseId
      courseName
      confidence
      rationale
      sourceKind
      status
      decidedByName
      decidedAt
      alreadyQualified
    }
    runs {
      id
      sourceKind
      status
      interviewId
      aiModel
      promptVersion
      errorMessage
      droppedCourseIds
      createdAt
      analyzedAt
    }
  }
}
    `;

/**
 * __useErpTeacherAiProfileQuery__
 *
 * To run a query within a React component, call `useErpTeacherAiProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherAiProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherAiProfileQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useErpTeacherAiProfileQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherAiProfileQuery, ErpTeacherAiProfileQueryVariables>) {
        return Apollo.useQuery<ErpTeacherAiProfileQuery, ErpTeacherAiProfileQueryVariables>(ErpTeacherAiProfileDocument, baseOptions);
      }
export function useErpTeacherAiProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherAiProfileQuery, ErpTeacherAiProfileQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherAiProfileQuery, ErpTeacherAiProfileQueryVariables>(ErpTeacherAiProfileDocument, baseOptions);
        }
export type ErpTeacherAiProfileQueryHookResult = ReturnType<typeof useErpTeacherAiProfileQuery>;
export type ErpTeacherAiProfileLazyQueryHookResult = ReturnType<typeof useErpTeacherAiProfileLazyQuery>;
export type ErpTeacherAiProfileQueryResult = Apollo.QueryResult<ErpTeacherAiProfileQuery, ErpTeacherAiProfileQueryVariables>;
export const TeacherBillingEntitiesListDocument = gql`
    query TeacherBillingEntitiesList($teacherId: ID!, $includeInactive: Boolean) {
  teacherBillingEntities(teacherId: $teacherId, includeInactive: $includeInactive) {
    id
    teacherId
    kind
    legalName
    nip
    vatMode
    vatRate
    isDefault
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useTeacherBillingEntitiesListQuery__
 *
 * To run a query within a React component, call `useTeacherBillingEntitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherBillingEntitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherBillingEntitiesListQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useTeacherBillingEntitiesListQuery(baseOptions: Apollo.QueryHookOptions<TeacherBillingEntitiesListQuery, TeacherBillingEntitiesListQueryVariables>) {
        return Apollo.useQuery<TeacherBillingEntitiesListQuery, TeacherBillingEntitiesListQueryVariables>(TeacherBillingEntitiesListDocument, baseOptions);
      }
export function useTeacherBillingEntitiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherBillingEntitiesListQuery, TeacherBillingEntitiesListQueryVariables>) {
          return Apollo.useLazyQuery<TeacherBillingEntitiesListQuery, TeacherBillingEntitiesListQueryVariables>(TeacherBillingEntitiesListDocument, baseOptions);
        }
export type TeacherBillingEntitiesListQueryHookResult = ReturnType<typeof useTeacherBillingEntitiesListQuery>;
export type TeacherBillingEntitiesListLazyQueryHookResult = ReturnType<typeof useTeacherBillingEntitiesListLazyQuery>;
export type TeacherBillingEntitiesListQueryResult = Apollo.QueryResult<TeacherBillingEntitiesListQuery, TeacherBillingEntitiesListQueryVariables>;
export const GroupTeacherTermsDocument = gql`
    query GroupTeacherTerms($groupId: ID!) {
  groupTeacherApplications(groupId: $groupId) {
    id
    title
    date
    lessonsCount
    servicePrice
    currency
    isTerminated
    rateUnit
    rateIsGross
    termsMissing
    teacher {
      id
      fullName
    }
    billingEntity {
      id
      teacherId
      kind
      legalName
      nip
      vatMode
      vatRate
      isDefault
      isActive
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGroupTeacherTermsQuery__
 *
 * To run a query within a React component, call `useGroupTeacherTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupTeacherTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupTeacherTermsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupTeacherTermsQuery(baseOptions: Apollo.QueryHookOptions<GroupTeacherTermsQuery, GroupTeacherTermsQueryVariables>) {
        return Apollo.useQuery<GroupTeacherTermsQuery, GroupTeacherTermsQueryVariables>(GroupTeacherTermsDocument, baseOptions);
      }
export function useGroupTeacherTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupTeacherTermsQuery, GroupTeacherTermsQueryVariables>) {
          return Apollo.useLazyQuery<GroupTeacherTermsQuery, GroupTeacherTermsQueryVariables>(GroupTeacherTermsDocument, baseOptions);
        }
export type GroupTeacherTermsQueryHookResult = ReturnType<typeof useGroupTeacherTermsQuery>;
export type GroupTeacherTermsLazyQueryHookResult = ReturnType<typeof useGroupTeacherTermsLazyQuery>;
export type GroupTeacherTermsQueryResult = Apollo.QueryResult<GroupTeacherTermsQuery, GroupTeacherTermsQueryVariables>;
export const ErpTeacherDocumentsDocument = gql`
    query ErpTeacherDocuments($teacherId: ID!, $kind: String) {
  teacherDocuments(teacherId: $teacherId, kind: $kind) {
    id
    teacherId
    kind
    version
    originalName
    contentType
    sizeBytes
    extractionStatus
    hasText
    textChars
    isCurrent
    uploadedAt
    uploadedByName
  }
}
    `;

/**
 * __useErpTeacherDocumentsQuery__
 *
 * To run a query within a React component, call `useErpTeacherDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherDocumentsQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useErpTeacherDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherDocumentsQuery, ErpTeacherDocumentsQueryVariables>) {
        return Apollo.useQuery<ErpTeacherDocumentsQuery, ErpTeacherDocumentsQueryVariables>(ErpTeacherDocumentsDocument, baseOptions);
      }
export function useErpTeacherDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherDocumentsQuery, ErpTeacherDocumentsQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherDocumentsQuery, ErpTeacherDocumentsQueryVariables>(ErpTeacherDocumentsDocument, baseOptions);
        }
export type ErpTeacherDocumentsQueryHookResult = ReturnType<typeof useErpTeacherDocumentsQuery>;
export type ErpTeacherDocumentsLazyQueryHookResult = ReturnType<typeof useErpTeacherDocumentsLazyQuery>;
export type ErpTeacherDocumentsQueryResult = Apollo.QueryResult<ErpTeacherDocumentsQuery, ErpTeacherDocumentsQueryVariables>;
export const ErpTeacherDocumentTextDocument = gql`
    query ErpTeacherDocumentText($documentId: ID!) {
  teacherDocumentText(documentId: $documentId) {
    documentId
    extractionStatus
    text
  }
}
    `;

/**
 * __useErpTeacherDocumentTextQuery__
 *
 * To run a query within a React component, call `useErpTeacherDocumentTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherDocumentTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherDocumentTextQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useErpTeacherDocumentTextQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherDocumentTextQuery, ErpTeacherDocumentTextQueryVariables>) {
        return Apollo.useQuery<ErpTeacherDocumentTextQuery, ErpTeacherDocumentTextQueryVariables>(ErpTeacherDocumentTextDocument, baseOptions);
      }
export function useErpTeacherDocumentTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherDocumentTextQuery, ErpTeacherDocumentTextQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherDocumentTextQuery, ErpTeacherDocumentTextQueryVariables>(ErpTeacherDocumentTextDocument, baseOptions);
        }
export type ErpTeacherDocumentTextQueryHookResult = ReturnType<typeof useErpTeacherDocumentTextQuery>;
export type ErpTeacherDocumentTextLazyQueryHookResult = ReturnType<typeof useErpTeacherDocumentTextLazyQuery>;
export type ErpTeacherDocumentTextQueryResult = Apollo.QueryResult<ErpTeacherDocumentTextQuery, ErpTeacherDocumentTextQueryVariables>;
export const ErpTeacherDocumentDownloadUrlDocument = gql`
    query ErpTeacherDocumentDownloadUrl($documentId: ID!) {
  teacherDocumentDownloadUrl(documentId: $documentId)
}
    `;

/**
 * __useErpTeacherDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useErpTeacherDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherDocumentDownloadUrlQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useErpTeacherDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherDocumentDownloadUrlQuery, ErpTeacherDocumentDownloadUrlQueryVariables>) {
        return Apollo.useQuery<ErpTeacherDocumentDownloadUrlQuery, ErpTeacherDocumentDownloadUrlQueryVariables>(ErpTeacherDocumentDownloadUrlDocument, baseOptions);
      }
export function useErpTeacherDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherDocumentDownloadUrlQuery, ErpTeacherDocumentDownloadUrlQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherDocumentDownloadUrlQuery, ErpTeacherDocumentDownloadUrlQueryVariables>(ErpTeacherDocumentDownloadUrlDocument, baseOptions);
        }
export type ErpTeacherDocumentDownloadUrlQueryHookResult = ReturnType<typeof useErpTeacherDocumentDownloadUrlQuery>;
export type ErpTeacherDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useErpTeacherDocumentDownloadUrlLazyQuery>;
export type ErpTeacherDocumentDownloadUrlQueryResult = Apollo.QueryResult<ErpTeacherDocumentDownloadUrlQuery, ErpTeacherDocumentDownloadUrlQueryVariables>;
export const ErpTeacherInterviewsDocument = gql`
    query ErpTeacherInterviews($teacherId: ID!) {
  teacherInterviews(teacherId: $teacherId) {
    id
    teacherId
    source
    title
    recordedAt
    durationMinutes
    status
    errorMessage
    retryCount
    externalUrl
    hasVideo
    sizeBytes
    hasTranscript
    transcriptSource
    transcriptChars
    zoomRecordingId
    zoomTopic
    zoomAccountEmail
    createdAt
    createdByName
  }
}
    `;

/**
 * __useErpTeacherInterviewsQuery__
 *
 * To run a query within a React component, call `useErpTeacherInterviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherInterviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherInterviewsQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useErpTeacherInterviewsQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherInterviewsQuery, ErpTeacherInterviewsQueryVariables>) {
        return Apollo.useQuery<ErpTeacherInterviewsQuery, ErpTeacherInterviewsQueryVariables>(ErpTeacherInterviewsDocument, baseOptions);
      }
export function useErpTeacherInterviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherInterviewsQuery, ErpTeacherInterviewsQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherInterviewsQuery, ErpTeacherInterviewsQueryVariables>(ErpTeacherInterviewsDocument, baseOptions);
        }
export type ErpTeacherInterviewsQueryHookResult = ReturnType<typeof useErpTeacherInterviewsQuery>;
export type ErpTeacherInterviewsLazyQueryHookResult = ReturnType<typeof useErpTeacherInterviewsLazyQuery>;
export type ErpTeacherInterviewsQueryResult = Apollo.QueryResult<ErpTeacherInterviewsQuery, ErpTeacherInterviewsQueryVariables>;
export const ErpTeacherInterviewTranscriptDocument = gql`
    query ErpTeacherInterviewTranscript($interviewId: ID!) {
  teacherInterviewTranscript(interviewId: $interviewId) {
    interviewId
    transcriptSource
    text
  }
}
    `;

/**
 * __useErpTeacherInterviewTranscriptQuery__
 *
 * To run a query within a React component, call `useErpTeacherInterviewTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherInterviewTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherInterviewTranscriptQuery({
 *   variables: {
 *      interviewId: // value for 'interviewId'
 *   },
 * });
 */
export function useErpTeacherInterviewTranscriptQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherInterviewTranscriptQuery, ErpTeacherInterviewTranscriptQueryVariables>) {
        return Apollo.useQuery<ErpTeacherInterviewTranscriptQuery, ErpTeacherInterviewTranscriptQueryVariables>(ErpTeacherInterviewTranscriptDocument, baseOptions);
      }
export function useErpTeacherInterviewTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherInterviewTranscriptQuery, ErpTeacherInterviewTranscriptQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherInterviewTranscriptQuery, ErpTeacherInterviewTranscriptQueryVariables>(ErpTeacherInterviewTranscriptDocument, baseOptions);
        }
export type ErpTeacherInterviewTranscriptQueryHookResult = ReturnType<typeof useErpTeacherInterviewTranscriptQuery>;
export type ErpTeacherInterviewTranscriptLazyQueryHookResult = ReturnType<typeof useErpTeacherInterviewTranscriptLazyQuery>;
export type ErpTeacherInterviewTranscriptQueryResult = Apollo.QueryResult<ErpTeacherInterviewTranscriptQuery, ErpTeacherInterviewTranscriptQueryVariables>;
export const ErpTeacherInterviewVideoUrlDocument = gql`
    query ErpTeacherInterviewVideoUrl($interviewId: ID!) {
  teacherInterviewVideoUrl(interviewId: $interviewId)
}
    `;

/**
 * __useErpTeacherInterviewVideoUrlQuery__
 *
 * To run a query within a React component, call `useErpTeacherInterviewVideoUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherInterviewVideoUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherInterviewVideoUrlQuery({
 *   variables: {
 *      interviewId: // value for 'interviewId'
 *   },
 * });
 */
export function useErpTeacherInterviewVideoUrlQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherInterviewVideoUrlQuery, ErpTeacherInterviewVideoUrlQueryVariables>) {
        return Apollo.useQuery<ErpTeacherInterviewVideoUrlQuery, ErpTeacherInterviewVideoUrlQueryVariables>(ErpTeacherInterviewVideoUrlDocument, baseOptions);
      }
export function useErpTeacherInterviewVideoUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherInterviewVideoUrlQuery, ErpTeacherInterviewVideoUrlQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherInterviewVideoUrlQuery, ErpTeacherInterviewVideoUrlQueryVariables>(ErpTeacherInterviewVideoUrlDocument, baseOptions);
        }
export type ErpTeacherInterviewVideoUrlQueryHookResult = ReturnType<typeof useErpTeacherInterviewVideoUrlQuery>;
export type ErpTeacherInterviewVideoUrlLazyQueryHookResult = ReturnType<typeof useErpTeacherInterviewVideoUrlLazyQuery>;
export type ErpTeacherInterviewVideoUrlQueryResult = Apollo.QueryResult<ErpTeacherInterviewVideoUrlQuery, ErpTeacherInterviewVideoUrlQueryVariables>;
export const ErpInterviewZoomCandidatesDocument = gql`
    query ErpInterviewZoomCandidates($dateFrom: Date, $dateTo: Date, $accountId: ID, $search: String) {
  interviewZoomCandidates(
    dateFrom: $dateFrom
    dateTo: $dateTo
    accountId: $accountId
    search: $search
  ) {
    id
    topic
    startTime
    durationMinutes
    totalSizeBytes
    accountId
    accountEmail
    hasVideo
    hasTranscript
    isAlreadyAttached
    retentionWarning
  }
}
    `;

/**
 * __useErpInterviewZoomCandidatesQuery__
 *
 * To run a query within a React component, call `useErpInterviewZoomCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpInterviewZoomCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpInterviewZoomCandidatesQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      accountId: // value for 'accountId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useErpInterviewZoomCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<ErpInterviewZoomCandidatesQuery, ErpInterviewZoomCandidatesQueryVariables>) {
        return Apollo.useQuery<ErpInterviewZoomCandidatesQuery, ErpInterviewZoomCandidatesQueryVariables>(ErpInterviewZoomCandidatesDocument, baseOptions);
      }
export function useErpInterviewZoomCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpInterviewZoomCandidatesQuery, ErpInterviewZoomCandidatesQueryVariables>) {
          return Apollo.useLazyQuery<ErpInterviewZoomCandidatesQuery, ErpInterviewZoomCandidatesQueryVariables>(ErpInterviewZoomCandidatesDocument, baseOptions);
        }
export type ErpInterviewZoomCandidatesQueryHookResult = ReturnType<typeof useErpInterviewZoomCandidatesQuery>;
export type ErpInterviewZoomCandidatesLazyQueryHookResult = ReturnType<typeof useErpInterviewZoomCandidatesLazyQuery>;
export type ErpInterviewZoomCandidatesQueryResult = Apollo.QueryResult<ErpInterviewZoomCandidatesQuery, ErpInterviewZoomCandidatesQueryVariables>;
export const ErpInterviewZoomDefaultAccountDocument = gql`
    query ErpInterviewZoomDefaultAccount {
  interviewZoomDefaultAccountId
}
    `;

/**
 * __useErpInterviewZoomDefaultAccountQuery__
 *
 * To run a query within a React component, call `useErpInterviewZoomDefaultAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpInterviewZoomDefaultAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpInterviewZoomDefaultAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useErpInterviewZoomDefaultAccountQuery(baseOptions?: Apollo.QueryHookOptions<ErpInterviewZoomDefaultAccountQuery, ErpInterviewZoomDefaultAccountQueryVariables>) {
        return Apollo.useQuery<ErpInterviewZoomDefaultAccountQuery, ErpInterviewZoomDefaultAccountQueryVariables>(ErpInterviewZoomDefaultAccountDocument, baseOptions);
      }
export function useErpInterviewZoomDefaultAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpInterviewZoomDefaultAccountQuery, ErpInterviewZoomDefaultAccountQueryVariables>) {
          return Apollo.useLazyQuery<ErpInterviewZoomDefaultAccountQuery, ErpInterviewZoomDefaultAccountQueryVariables>(ErpInterviewZoomDefaultAccountDocument, baseOptions);
        }
export type ErpInterviewZoomDefaultAccountQueryHookResult = ReturnType<typeof useErpInterviewZoomDefaultAccountQuery>;
export type ErpInterviewZoomDefaultAccountLazyQueryHookResult = ReturnType<typeof useErpInterviewZoomDefaultAccountLazyQuery>;
export type ErpInterviewZoomDefaultAccountQueryResult = Apollo.QueryResult<ErpInterviewZoomDefaultAccountQuery, ErpInterviewZoomDefaultAccountQueryVariables>;
export const AllTeachersDocument = gql`
    query allTeachers($query: String, $before: String, $after: String, $first: Int, $last: Int, $course: Decimal, $minRating: Decimal, $availability: String) {
  allTeachers(
    query: $query
    before: $before
    after: $after
    first: $first
    last: $last
    course: $course
    minRating: $minRating
    availability: $availability
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        accessToLms
        fullName
        isDismissed
        rating
        availability
        user {
          id
          phone
          email
        }
        courses
      }
    }
  }
}
    `;

/**
 * __useAllTeachersQuery__
 *
 * To run a query within a React component, call `useAllTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTeachersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      course: // value for 'course'
 *      minRating: // value for 'minRating'
 *      availability: // value for 'availability'
 *   },
 * });
 */
export function useAllTeachersQuery(baseOptions?: Apollo.QueryHookOptions<AllTeachersQuery, AllTeachersQueryVariables>) {
        return Apollo.useQuery<AllTeachersQuery, AllTeachersQueryVariables>(AllTeachersDocument, baseOptions);
      }
export function useAllTeachersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTeachersQuery, AllTeachersQueryVariables>) {
          return Apollo.useLazyQuery<AllTeachersQuery, AllTeachersQueryVariables>(AllTeachersDocument, baseOptions);
        }
export type AllTeachersQueryHookResult = ReturnType<typeof useAllTeachersQuery>;
export type AllTeachersLazyQueryHookResult = ReturnType<typeof useAllTeachersLazyQuery>;
export type AllTeachersQueryResult = Apollo.QueryResult<AllTeachersQuery, AllTeachersQueryVariables>;
export const VerifyTeacherDocument = gql`
    query verifyTeacher($firstName: String!, $middleName: String, $lastName: String!, $phone: String!, $email: String!) {
  verifyTeacher(
    teacherInput: {firstName: $firstName, middleName: $middleName, lastName: $lastName, phone: $phone, email: $email}
  ) {
    code
    customErrors {
      field
      message
      code
    }
    user {
      id
      firstName
      middleName
      lastName
      phone
      email
      roles
    }
    teacher {
      id
      user {
        id
        firstName
        middleName
        lastName
        phone
        email
      }
    }
  }
}
    `;

/**
 * __useVerifyTeacherQuery__
 *
 * To run a query within a React component, call `useVerifyTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyTeacherQuery({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      middleName: // value for 'middleName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useVerifyTeacherQuery(baseOptions: Apollo.QueryHookOptions<VerifyTeacherQuery, VerifyTeacherQueryVariables>) {
        return Apollo.useQuery<VerifyTeacherQuery, VerifyTeacherQueryVariables>(VerifyTeacherDocument, baseOptions);
      }
export function useVerifyTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyTeacherQuery, VerifyTeacherQueryVariables>) {
          return Apollo.useLazyQuery<VerifyTeacherQuery, VerifyTeacherQueryVariables>(VerifyTeacherDocument, baseOptions);
        }
export type VerifyTeacherQueryHookResult = ReturnType<typeof useVerifyTeacherQuery>;
export type VerifyTeacherLazyQueryHookResult = ReturnType<typeof useVerifyTeacherLazyQuery>;
export type VerifyTeacherQueryResult = Apollo.QueryResult<VerifyTeacherQuery, VerifyTeacherQueryVariables>;
export const GetTeacherDataDocument = gql`
    query getTeacherData($teacherId: ID) {
  teacher(teacherId: $teacherId) {
    employmentTypes {
      __typename
    }
  }
}
    `;

/**
 * __useGetTeacherDataQuery__
 *
 * To run a query within a React component, call `useGetTeacherDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherDataQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetTeacherDataQuery(baseOptions?: Apollo.QueryHookOptions<GetTeacherDataQuery, GetTeacherDataQueryVariables>) {
        return Apollo.useQuery<GetTeacherDataQuery, GetTeacherDataQueryVariables>(GetTeacherDataDocument, baseOptions);
      }
export function useGetTeacherDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherDataQuery, GetTeacherDataQueryVariables>) {
          return Apollo.useLazyQuery<GetTeacherDataQuery, GetTeacherDataQueryVariables>(GetTeacherDataDocument, baseOptions);
        }
export type GetTeacherDataQueryHookResult = ReturnType<typeof useGetTeacherDataQuery>;
export type GetTeacherDataLazyQueryHookResult = ReturnType<typeof useGetTeacherDataLazyQuery>;
export type GetTeacherDataQueryResult = Apollo.QueryResult<GetTeacherDataQuery, GetTeacherDataQueryVariables>;
export const GetTeacherTypesDocument = gql`
    query GetTeacherTypes($teacherId: ID!) {
  teacher(teacherId: $teacherId) {
    employmentTypes {
      ... on IndividualEntrepreneurType {
        __typename
        id
        registrationAddress
        accountNumber
        bankTitle
        bic
        inn
      }
      ... on LegalEntityType {
        __typename
        id
        registrationAddress
        accountNumber
        bankTitle
        bic
        tittle
        inn
      }
      ... on SelfEmployedType {
        __typename
        id
        registrationAddress
        accountNumber
        bankTitle
        bic
        nationality {
          id
          title
        }
        passportNumber
        inn
      }
      ... on NaturalPersonType {
        __typename
        id
        registrationAddress
        accountNumber
        bankTitle
        bic
        nationality {
          id
          title
        }
        passportNumber
      }
    }
  }
}
    `;

/**
 * __useGetTeacherTypesQuery__
 *
 * To run a query within a React component, call `useGetTeacherTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherTypesQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetTeacherTypesQuery(baseOptions: Apollo.QueryHookOptions<GetTeacherTypesQuery, GetTeacherTypesQueryVariables>) {
        return Apollo.useQuery<GetTeacherTypesQuery, GetTeacherTypesQueryVariables>(GetTeacherTypesDocument, baseOptions);
      }
export function useGetTeacherTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherTypesQuery, GetTeacherTypesQueryVariables>) {
          return Apollo.useLazyQuery<GetTeacherTypesQuery, GetTeacherTypesQueryVariables>(GetTeacherTypesDocument, baseOptions);
        }
export type GetTeacherTypesQueryHookResult = ReturnType<typeof useGetTeacherTypesQuery>;
export type GetTeacherTypesLazyQueryHookResult = ReturnType<typeof useGetTeacherTypesLazyQuery>;
export type GetTeacherTypesQueryResult = Apollo.QueryResult<GetTeacherTypesQuery, GetTeacherTypesQueryVariables>;
export const GetEditTeacherDocument = gql`
    query GetEditTeacher($teacherId: ID!) {
  teacher(teacherId: $teacherId) {
    id
    user {
      id
      firstName
      lastName
      middleName
      email
      phone
    }
    accessToLms
    siteDisplay
    employmentTypes {
      ... on IndividualEntrepreneurType {
        __typename
        id
        registrationAddress
        accountNumber
        bankTitle
        bic
        inn
      }
      ... on LegalEntityType {
        __typename
        id
        registrationAddress
        accountNumber
        bankTitle
        bic
        tittle
        inn
      }
      ... on SelfEmployedType {
        __typename
        id
        registrationAddress
        accountNumber
        bankTitle
        bic
        nationality {
          id
          title
        }
        passportNumber
        inn
      }
      ... on NaturalPersonType {
        __typename
        id
        registrationAddress
        accountNumber
        bankTitle
        bic
        nationality {
          id
          title
        }
        passportNumber
      }
    }
  }
}
    `;

/**
 * __useGetEditTeacherQuery__
 *
 * To run a query within a React component, call `useGetEditTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditTeacherQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetEditTeacherQuery(baseOptions: Apollo.QueryHookOptions<GetEditTeacherQuery, GetEditTeacherQueryVariables>) {
        return Apollo.useQuery<GetEditTeacherQuery, GetEditTeacherQueryVariables>(GetEditTeacherDocument, baseOptions);
      }
export function useGetEditTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditTeacherQuery, GetEditTeacherQueryVariables>) {
          return Apollo.useLazyQuery<GetEditTeacherQuery, GetEditTeacherQueryVariables>(GetEditTeacherDocument, baseOptions);
        }
export type GetEditTeacherQueryHookResult = ReturnType<typeof useGetEditTeacherQuery>;
export type GetEditTeacherLazyQueryHookResult = ReturnType<typeof useGetEditTeacherLazyQuery>;
export type GetEditTeacherQueryResult = Apollo.QueryResult<GetEditTeacherQuery, GetEditTeacherQueryVariables>;
export const ErpTeacherLoadDocument = gql`
    query ErpTeacherLoad($teacherId: ID!, $horizonDays: Int) {
  teacherLoad(teacherId: $teacherId, horizonDays: $horizonDays) {
    activeGroups
    activeApplications
    nextLessonDate
    lessonsNext30Days
    hoursNext30Days
    hoursPerWeek
    loadBand
    horizonDays
    weeks {
      weekStart
      lessons
      minutes
      groups
    }
    applications {
      applicationId
      title
      groupId
      groupName
      contractedLessons
      scheduledLessons
      unscheduledLessons
      remainingLessons
      lastLessonDate
    }
  }
}
    `;

/**
 * __useErpTeacherLoadQuery__
 *
 * To run a query within a React component, call `useErpTeacherLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherLoadQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      horizonDays: // value for 'horizonDays'
 *   },
 * });
 */
export function useErpTeacherLoadQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherLoadQuery, ErpTeacherLoadQueryVariables>) {
        return Apollo.useQuery<ErpTeacherLoadQuery, ErpTeacherLoadQueryVariables>(ErpTeacherLoadDocument, baseOptions);
      }
export function useErpTeacherLoadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherLoadQuery, ErpTeacherLoadQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherLoadQuery, ErpTeacherLoadQueryVariables>(ErpTeacherLoadDocument, baseOptions);
        }
export type ErpTeacherLoadQueryHookResult = ReturnType<typeof useErpTeacherLoadQuery>;
export type ErpTeacherLoadLazyQueryHookResult = ReturnType<typeof useErpTeacherLoadLazyQuery>;
export type ErpTeacherLoadQueryResult = Apollo.QueryResult<ErpTeacherLoadQuery, ErpTeacherLoadQueryVariables>;
export const ErpTeacherCandidateGroupsDocument = gql`
    query ErpTeacherCandidateGroups($teacherId: ID!) {
  teacherCandidateGroups(teacherId: $teacherId) {
    groupId
    groupName
    courseId
    courseName
    startDate
    openLessons
    nextOpenDate
  }
}
    `;

/**
 * __useErpTeacherCandidateGroupsQuery__
 *
 * To run a query within a React component, call `useErpTeacherCandidateGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErpTeacherCandidateGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErpTeacherCandidateGroupsQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useErpTeacherCandidateGroupsQuery(baseOptions: Apollo.QueryHookOptions<ErpTeacherCandidateGroupsQuery, ErpTeacherCandidateGroupsQueryVariables>) {
        return Apollo.useQuery<ErpTeacherCandidateGroupsQuery, ErpTeacherCandidateGroupsQueryVariables>(ErpTeacherCandidateGroupsDocument, baseOptions);
      }
export function useErpTeacherCandidateGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErpTeacherCandidateGroupsQuery, ErpTeacherCandidateGroupsQueryVariables>) {
          return Apollo.useLazyQuery<ErpTeacherCandidateGroupsQuery, ErpTeacherCandidateGroupsQueryVariables>(ErpTeacherCandidateGroupsDocument, baseOptions);
        }
export type ErpTeacherCandidateGroupsQueryHookResult = ReturnType<typeof useErpTeacherCandidateGroupsQuery>;
export type ErpTeacherCandidateGroupsLazyQueryHookResult = ReturnType<typeof useErpTeacherCandidateGroupsLazyQuery>;
export type ErpTeacherCandidateGroupsQueryResult = Apollo.QueryResult<ErpTeacherCandidateGroupsQuery, ErpTeacherCandidateGroupsQueryVariables>;
export const TeachersMetaDocument = gql`
    query teachersMeta($query: String) {
  metaTeachers(query: $query) {
    totalCount
    applicationsCount
  }
}
    `;

/**
 * __useTeachersMetaQuery__
 *
 * To run a query within a React component, call `useTeachersMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeachersMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeachersMetaQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTeachersMetaQuery(baseOptions?: Apollo.QueryHookOptions<TeachersMetaQuery, TeachersMetaQueryVariables>) {
        return Apollo.useQuery<TeachersMetaQuery, TeachersMetaQueryVariables>(TeachersMetaDocument, baseOptions);
      }
export function useTeachersMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeachersMetaQuery, TeachersMetaQueryVariables>) {
          return Apollo.useLazyQuery<TeachersMetaQuery, TeachersMetaQueryVariables>(TeachersMetaDocument, baseOptions);
        }
export type TeachersMetaQueryHookResult = ReturnType<typeof useTeachersMetaQuery>;
export type TeachersMetaLazyQueryHookResult = ReturnType<typeof useTeachersMetaLazyQuery>;
export type TeachersMetaQueryResult = Apollo.QueryResult<TeachersMetaQuery, TeachersMetaQueryVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($userId: ID!) {
  user(id: $userId) {
    pk
    firstName
    middleName
    lastName
    email
    phone
    roles
    workspaceMailbox {
      email
      enabled
    }
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, baseOptions);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, baseOptions);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const FindUserDataDocument = gql`
    query findUserData($email: String, $phone: String) {
  users(email_Icontains: $email, phone: $phone) {
    edges {
      node {
        pk
        roles
        email
        phone
        firstName
        lastName
        middleName
        student {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useFindUserDataQuery__
 *
 * To run a query within a React component, call `useFindUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUserDataQuery({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useFindUserDataQuery(baseOptions?: Apollo.QueryHookOptions<FindUserDataQuery, FindUserDataQueryVariables>) {
        return Apollo.useQuery<FindUserDataQuery, FindUserDataQueryVariables>(FindUserDataDocument, baseOptions);
      }
export function useFindUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUserDataQuery, FindUserDataQueryVariables>) {
          return Apollo.useLazyQuery<FindUserDataQuery, FindUserDataQueryVariables>(FindUserDataDocument, baseOptions);
        }
export type FindUserDataQueryHookResult = ReturnType<typeof useFindUserDataQuery>;
export type FindUserDataLazyQueryHookResult = ReturnType<typeof useFindUserDataLazyQuery>;
export type FindUserDataQueryResult = Apollo.QueryResult<FindUserDataQuery, FindUserDataQueryVariables>;
export const PaginatedUsersSettingsDocument = gql`
    query PaginatedUsersSettings($query: String, $first: Int, $after: String) {
  allUsersSettings(first: $first, query: $query, after: $after) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...UserFields
        workspaceMailbox {
          email
          displayName
          enabled
          scope
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __usePaginatedUsersSettingsQuery__
 *
 * To run a query within a React component, call `usePaginatedUsersSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedUsersSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedUsersSettingsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaginatedUsersSettingsQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedUsersSettingsQuery, PaginatedUsersSettingsQueryVariables>) {
        return Apollo.useQuery<PaginatedUsersSettingsQuery, PaginatedUsersSettingsQueryVariables>(PaginatedUsersSettingsDocument, baseOptions);
      }
export function usePaginatedUsersSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedUsersSettingsQuery, PaginatedUsersSettingsQueryVariables>) {
          return Apollo.useLazyQuery<PaginatedUsersSettingsQuery, PaginatedUsersSettingsQueryVariables>(PaginatedUsersSettingsDocument, baseOptions);
        }
export type PaginatedUsersSettingsQueryHookResult = ReturnType<typeof usePaginatedUsersSettingsQuery>;
export type PaginatedUsersSettingsLazyQueryHookResult = ReturnType<typeof usePaginatedUsersSettingsLazyQuery>;
export type PaginatedUsersSettingsQueryResult = Apollo.QueryResult<PaginatedUsersSettingsQuery, PaginatedUsersSettingsQueryVariables>;
export const MyWorkspaceProfileDocument = gql`
    query MyWorkspaceProfile {
  me {
    id
    pk
    firstName
    lastName
    email
    roles
    workspaceMailbox {
      email
      displayName
      enabled
      scope
    }
  }
  staffMailboxSettings {
    domains
  }
}
    `;

/**
 * __useMyWorkspaceProfileQuery__
 *
 * To run a query within a React component, call `useMyWorkspaceProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWorkspaceProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWorkspaceProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyWorkspaceProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyWorkspaceProfileQuery, MyWorkspaceProfileQueryVariables>) {
        return Apollo.useQuery<MyWorkspaceProfileQuery, MyWorkspaceProfileQueryVariables>(MyWorkspaceProfileDocument, baseOptions);
      }
export function useMyWorkspaceProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyWorkspaceProfileQuery, MyWorkspaceProfileQueryVariables>) {
          return Apollo.useLazyQuery<MyWorkspaceProfileQuery, MyWorkspaceProfileQueryVariables>(MyWorkspaceProfileDocument, baseOptions);
        }
export type MyWorkspaceProfileQueryHookResult = ReturnType<typeof useMyWorkspaceProfileQuery>;
export type MyWorkspaceProfileLazyQueryHookResult = ReturnType<typeof useMyWorkspaceProfileLazyQuery>;
export type MyWorkspaceProfileQueryResult = Apollo.QueryResult<MyWorkspaceProfileQuery, MyWorkspaceProfileQueryVariables>;
export const StaffMailboxDomainsDocument = gql`
    query StaffMailboxDomains {
  staffMailboxSettings {
    domains
  }
}
    `;

/**
 * __useStaffMailboxDomainsQuery__
 *
 * To run a query within a React component, call `useStaffMailboxDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffMailboxDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffMailboxDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStaffMailboxDomainsQuery(baseOptions?: Apollo.QueryHookOptions<StaffMailboxDomainsQuery, StaffMailboxDomainsQueryVariables>) {
        return Apollo.useQuery<StaffMailboxDomainsQuery, StaffMailboxDomainsQueryVariables>(StaffMailboxDomainsDocument, baseOptions);
      }
export function useStaffMailboxDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffMailboxDomainsQuery, StaffMailboxDomainsQueryVariables>) {
          return Apollo.useLazyQuery<StaffMailboxDomainsQuery, StaffMailboxDomainsQueryVariables>(StaffMailboxDomainsDocument, baseOptions);
        }
export type StaffMailboxDomainsQueryHookResult = ReturnType<typeof useStaffMailboxDomainsQuery>;
export type StaffMailboxDomainsLazyQueryHookResult = ReturnType<typeof useStaffMailboxDomainsLazyQuery>;
export type StaffMailboxDomainsQueryResult = Apollo.QueryResult<StaffMailboxDomainsQuery, StaffMailboxDomainsQueryVariables>;
export const GetLessonWhiteboardErpDocument = gql`
    query GetLessonWhiteboardErp($lessonId: ID!) {
  lessonWhiteboardForErp(lessonId: $lessonId) {
    id
    name
    sceneJson
    sceneVersion
    updatedAt
    files {
      fileId
      mimeType
      url
    }
    lessons {
      lessonId
      lessonName
      lessonNumber
      lessonDate
    }
  }
}
    `;

/**
 * __useGetLessonWhiteboardErpQuery__
 *
 * To run a query within a React component, call `useGetLessonWhiteboardErpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonWhiteboardErpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonWhiteboardErpQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useGetLessonWhiteboardErpQuery(baseOptions: Apollo.QueryHookOptions<GetLessonWhiteboardErpQuery, GetLessonWhiteboardErpQueryVariables>) {
        return Apollo.useQuery<GetLessonWhiteboardErpQuery, GetLessonWhiteboardErpQueryVariables>(GetLessonWhiteboardErpDocument, baseOptions);
      }
export function useGetLessonWhiteboardErpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonWhiteboardErpQuery, GetLessonWhiteboardErpQueryVariables>) {
          return Apollo.useLazyQuery<GetLessonWhiteboardErpQuery, GetLessonWhiteboardErpQueryVariables>(GetLessonWhiteboardErpDocument, baseOptions);
        }
export type GetLessonWhiteboardErpQueryHookResult = ReturnType<typeof useGetLessonWhiteboardErpQuery>;
export type GetLessonWhiteboardErpLazyQueryHookResult = ReturnType<typeof useGetLessonWhiteboardErpLazyQuery>;
export type GetLessonWhiteboardErpQueryResult = Apollo.QueryResult<GetLessonWhiteboardErpQuery, GetLessonWhiteboardErpQueryVariables>;
export const LessonHeaderForWhiteboardDocument = gql`
    query LessonHeaderForWhiteboard($groupLessonId: ID!) {
  zoomLesson(groupLessonId: $groupLessonId) {
    id
    name
    date
    startTime
    endTime
    lessonNumber
    whiteboardId
    module {
      id
      group {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useLessonHeaderForWhiteboardQuery__
 *
 * To run a query within a React component, call `useLessonHeaderForWhiteboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonHeaderForWhiteboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonHeaderForWhiteboardQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useLessonHeaderForWhiteboardQuery(baseOptions: Apollo.QueryHookOptions<LessonHeaderForWhiteboardQuery, LessonHeaderForWhiteboardQueryVariables>) {
        return Apollo.useQuery<LessonHeaderForWhiteboardQuery, LessonHeaderForWhiteboardQueryVariables>(LessonHeaderForWhiteboardDocument, baseOptions);
      }
export function useLessonHeaderForWhiteboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonHeaderForWhiteboardQuery, LessonHeaderForWhiteboardQueryVariables>) {
          return Apollo.useLazyQuery<LessonHeaderForWhiteboardQuery, LessonHeaderForWhiteboardQueryVariables>(LessonHeaderForWhiteboardDocument, baseOptions);
        }
export type LessonHeaderForWhiteboardQueryHookResult = ReturnType<typeof useLessonHeaderForWhiteboardQuery>;
export type LessonHeaderForWhiteboardLazyQueryHookResult = ReturnType<typeof useLessonHeaderForWhiteboardLazyQuery>;
export type LessonHeaderForWhiteboardQueryResult = Apollo.QueryResult<LessonHeaderForWhiteboardQuery, LessonHeaderForWhiteboardQueryVariables>;
export const ZoomDashboardDocument = gql`
    query ZoomDashboard($dateFrom: Date!, $dateTo: Date!) {
  zoomDashboard(dateFrom: $dateFrom, dateTo: $dateTo) {
    dateFrom
    dateTo
    lessonsTotal
    lessonsMatched
    lessonsMissing
    lessonsSkipped
    recordingsTotal
    recordingsOrphan
    pipeline {
      downloading
      uploaded
      aiProcessing
      aiCompleted
      published
      failed
    }
  }
}
    `;

/**
 * __useZoomDashboardQuery__
 *
 * To run a query within a React component, call `useZoomDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomDashboardQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useZoomDashboardQuery(baseOptions: Apollo.QueryHookOptions<ZoomDashboardQuery, ZoomDashboardQueryVariables>) {
        return Apollo.useQuery<ZoomDashboardQuery, ZoomDashboardQueryVariables>(ZoomDashboardDocument, baseOptions);
      }
export function useZoomDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomDashboardQuery, ZoomDashboardQueryVariables>) {
          return Apollo.useLazyQuery<ZoomDashboardQuery, ZoomDashboardQueryVariables>(ZoomDashboardDocument, baseOptions);
        }
export type ZoomDashboardQueryHookResult = ReturnType<typeof useZoomDashboardQuery>;
export type ZoomDashboardLazyQueryHookResult = ReturnType<typeof useZoomDashboardLazyQuery>;
export type ZoomDashboardQueryResult = Apollo.QueryResult<ZoomDashboardQuery, ZoomDashboardQueryVariables>;
export const AllZoomLessonsDocument = gql`
    query AllZoomLessons($dateFrom: Date!, $dateTo: Date!, $groupId: ID, $courseId: ID, $status: String, $first: Int = 50, $after: String) {
  allZoomLessons(
    dateFrom: $dateFrom
    dateTo: $dateTo
    groupId: $groupId
    courseId: $courseId
    status: $status
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...ZoomLessonFields
      }
    }
  }
}
    ${ZoomLessonFieldsFragmentDoc}`;

/**
 * __useAllZoomLessonsQuery__
 *
 * To run a query within a React component, call `useAllZoomLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllZoomLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllZoomLessonsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      groupId: // value for 'groupId'
 *      courseId: // value for 'courseId'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAllZoomLessonsQuery(baseOptions: Apollo.QueryHookOptions<AllZoomLessonsQuery, AllZoomLessonsQueryVariables>) {
        return Apollo.useQuery<AllZoomLessonsQuery, AllZoomLessonsQueryVariables>(AllZoomLessonsDocument, baseOptions);
      }
export function useAllZoomLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllZoomLessonsQuery, AllZoomLessonsQueryVariables>) {
          return Apollo.useLazyQuery<AllZoomLessonsQuery, AllZoomLessonsQueryVariables>(AllZoomLessonsDocument, baseOptions);
        }
export type AllZoomLessonsQueryHookResult = ReturnType<typeof useAllZoomLessonsQuery>;
export type AllZoomLessonsLazyQueryHookResult = ReturnType<typeof useAllZoomLessonsLazyQuery>;
export type AllZoomLessonsQueryResult = Apollo.QueryResult<AllZoomLessonsQuery, AllZoomLessonsQueryVariables>;
export const LessonRecordingByLessonDocument = gql`
    query LessonRecordingByLesson($groupLessonId: ID!) {
  zoomLesson(groupLessonId: $groupLessonId) {
    ...GroupLessonForZoomFields
    zoomRecordingMeta {
      ...LessonRecordingFields
    }
  }
}
    ${GroupLessonForZoomFieldsFragmentDoc}
${LessonRecordingFieldsFragmentDoc}`;

/**
 * __useLessonRecordingByLessonQuery__
 *
 * To run a query within a React component, call `useLessonRecordingByLessonQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonRecordingByLessonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonRecordingByLessonQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useLessonRecordingByLessonQuery(baseOptions: Apollo.QueryHookOptions<LessonRecordingByLessonQuery, LessonRecordingByLessonQueryVariables>) {
        return Apollo.useQuery<LessonRecordingByLessonQuery, LessonRecordingByLessonQueryVariables>(LessonRecordingByLessonDocument, baseOptions);
      }
export function useLessonRecordingByLessonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonRecordingByLessonQuery, LessonRecordingByLessonQueryVariables>) {
          return Apollo.useLazyQuery<LessonRecordingByLessonQuery, LessonRecordingByLessonQueryVariables>(LessonRecordingByLessonDocument, baseOptions);
        }
export type LessonRecordingByLessonQueryHookResult = ReturnType<typeof useLessonRecordingByLessonQuery>;
export type LessonRecordingByLessonLazyQueryHookResult = ReturnType<typeof useLessonRecordingByLessonLazyQuery>;
export type LessonRecordingByLessonQueryResult = Apollo.QueryResult<LessonRecordingByLessonQuery, LessonRecordingByLessonQueryVariables>;
export const AllZoomRecordingsDocument = gql`
    query AllZoomRecordings($dateFrom: Date, $dateTo: Date, $accountId: ID, $groupId: ID, $orphanOnly: Boolean, $tooShort: Boolean, $showDeleted: Boolean, $first: Int = 50, $after: String) {
  allZoomRecordings(
    dateFrom: $dateFrom
    dateTo: $dateTo
    accountId: $accountId
    groupId: $groupId
    orphanOnly: $orphanOnly
    tooShort: $tooShort
    showDeleted: $showDeleted
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...ZoomRecordingFields
        lessonRecordings {
          id
          status
          lesson {
            id
            name
            module {
              group {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    ${ZoomRecordingFieldsFragmentDoc}`;

/**
 * __useAllZoomRecordingsQuery__
 *
 * To run a query within a React component, call `useAllZoomRecordingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllZoomRecordingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllZoomRecordingsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      accountId: // value for 'accountId'
 *      groupId: // value for 'groupId'
 *      orphanOnly: // value for 'orphanOnly'
 *      tooShort: // value for 'tooShort'
 *      showDeleted: // value for 'showDeleted'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAllZoomRecordingsQuery(baseOptions?: Apollo.QueryHookOptions<AllZoomRecordingsQuery, AllZoomRecordingsQueryVariables>) {
        return Apollo.useQuery<AllZoomRecordingsQuery, AllZoomRecordingsQueryVariables>(AllZoomRecordingsDocument, baseOptions);
      }
export function useAllZoomRecordingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllZoomRecordingsQuery, AllZoomRecordingsQueryVariables>) {
          return Apollo.useLazyQuery<AllZoomRecordingsQuery, AllZoomRecordingsQueryVariables>(AllZoomRecordingsDocument, baseOptions);
        }
export type AllZoomRecordingsQueryHookResult = ReturnType<typeof useAllZoomRecordingsQuery>;
export type AllZoomRecordingsLazyQueryHookResult = ReturnType<typeof useAllZoomRecordingsLazyQuery>;
export type AllZoomRecordingsQueryResult = Apollo.QueryResult<AllZoomRecordingsQuery, AllZoomRecordingsQueryVariables>;
export const RecentlyMatchedDocument = gql`
    query RecentlyMatched($limit: Int = 20, $mine: Boolean = false) {
  recentlyMatchedLessonRecordings(limit: $limit, mine: $mine) {
    ...LessonRecordingFields
  }
}
    ${LessonRecordingFieldsFragmentDoc}`;

/**
 * __useRecentlyMatchedQuery__
 *
 * To run a query within a React component, call `useRecentlyMatchedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyMatchedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyMatchedQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      mine: // value for 'mine'
 *   },
 * });
 */
export function useRecentlyMatchedQuery(baseOptions?: Apollo.QueryHookOptions<RecentlyMatchedQuery, RecentlyMatchedQueryVariables>) {
        return Apollo.useQuery<RecentlyMatchedQuery, RecentlyMatchedQueryVariables>(RecentlyMatchedDocument, baseOptions);
      }
export function useRecentlyMatchedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyMatchedQuery, RecentlyMatchedQueryVariables>) {
          return Apollo.useLazyQuery<RecentlyMatchedQuery, RecentlyMatchedQueryVariables>(RecentlyMatchedDocument, baseOptions);
        }
export type RecentlyMatchedQueryHookResult = ReturnType<typeof useRecentlyMatchedQuery>;
export type RecentlyMatchedLazyQueryHookResult = ReturnType<typeof useRecentlyMatchedLazyQuery>;
export type RecentlyMatchedQueryResult = Apollo.QueryResult<RecentlyMatchedQuery, RecentlyMatchedQueryVariables>;
export const ZoomAccountUsageDocument = gql`
    query ZoomAccountUsage {
  zoomAccountUsage {
    ...ZoomAccountUsageFields
  }
}
    ${ZoomAccountUsageFieldsFragmentDoc}`;

/**
 * __useZoomAccountUsageQuery__
 *
 * To run a query within a React component, call `useZoomAccountUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomAccountUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomAccountUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useZoomAccountUsageQuery(baseOptions?: Apollo.QueryHookOptions<ZoomAccountUsageQuery, ZoomAccountUsageQueryVariables>) {
        return Apollo.useQuery<ZoomAccountUsageQuery, ZoomAccountUsageQueryVariables>(ZoomAccountUsageDocument, baseOptions);
      }
export function useZoomAccountUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomAccountUsageQuery, ZoomAccountUsageQueryVariables>) {
          return Apollo.useLazyQuery<ZoomAccountUsageQuery, ZoomAccountUsageQueryVariables>(ZoomAccountUsageDocument, baseOptions);
        }
export type ZoomAccountUsageQueryHookResult = ReturnType<typeof useZoomAccountUsageQuery>;
export type ZoomAccountUsageLazyQueryHookResult = ReturnType<typeof useZoomAccountUsageLazyQuery>;
export type ZoomAccountUsageQueryResult = Apollo.QueryResult<ZoomAccountUsageQuery, ZoomAccountUsageQueryVariables>;
export const ZoomTooShortCountDocument = gql`
    query ZoomTooShortCount {
  allZoomRecordings(tooShort: true, first: 1) {
    totalCount
  }
}
    `;

/**
 * __useZoomTooShortCountQuery__
 *
 * To run a query within a React component, call `useZoomTooShortCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomTooShortCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomTooShortCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useZoomTooShortCountQuery(baseOptions?: Apollo.QueryHookOptions<ZoomTooShortCountQuery, ZoomTooShortCountQueryVariables>) {
        return Apollo.useQuery<ZoomTooShortCountQuery, ZoomTooShortCountQueryVariables>(ZoomTooShortCountDocument, baseOptions);
      }
export function useZoomTooShortCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomTooShortCountQuery, ZoomTooShortCountQueryVariables>) {
          return Apollo.useLazyQuery<ZoomTooShortCountQuery, ZoomTooShortCountQueryVariables>(ZoomTooShortCountDocument, baseOptions);
        }
export type ZoomTooShortCountQueryHookResult = ReturnType<typeof useZoomTooShortCountQuery>;
export type ZoomTooShortCountLazyQueryHookResult = ReturnType<typeof useZoomTooShortCountLazyQuery>;
export type ZoomTooShortCountQueryResult = Apollo.QueryResult<ZoomTooShortCountQuery, ZoomTooShortCountQueryVariables>;
export const AllZoomAccountsDocument = gql`
    query AllZoomAccounts($isActive: Boolean, $first: Int = 100) {
  allZoomAccounts(isActive: $isActive, first: $first) {
    edges {
      node {
        ...ZoomAccountFields
      }
    }
  }
}
    ${ZoomAccountFieldsFragmentDoc}`;

/**
 * __useAllZoomAccountsQuery__
 *
 * To run a query within a React component, call `useAllZoomAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllZoomAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllZoomAccountsQuery({
 *   variables: {
 *      isActive: // value for 'isActive'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllZoomAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AllZoomAccountsQuery, AllZoomAccountsQueryVariables>) {
        return Apollo.useQuery<AllZoomAccountsQuery, AllZoomAccountsQueryVariables>(AllZoomAccountsDocument, baseOptions);
      }
export function useAllZoomAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllZoomAccountsQuery, AllZoomAccountsQueryVariables>) {
          return Apollo.useLazyQuery<AllZoomAccountsQuery, AllZoomAccountsQueryVariables>(AllZoomAccountsDocument, baseOptions);
        }
export type AllZoomAccountsQueryHookResult = ReturnType<typeof useAllZoomAccountsQuery>;
export type AllZoomAccountsLazyQueryHookResult = ReturnType<typeof useAllZoomAccountsLazyQuery>;
export type AllZoomAccountsQueryResult = Apollo.QueryResult<AllZoomAccountsQuery, AllZoomAccountsQueryVariables>;
export const ZoomAssignedGroupsDocument = gql`
    query ZoomAssignedGroups($first: Int = 200) {
  allGroups(hasZoomAccount: true, first: $first) {
    edges {
      node {
        id
        name
        startDate
        zoomAccount {
          id
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useZoomAssignedGroupsQuery__
 *
 * To run a query within a React component, call `useZoomAssignedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomAssignedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomAssignedGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useZoomAssignedGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ZoomAssignedGroupsQuery, ZoomAssignedGroupsQueryVariables>) {
        return Apollo.useQuery<ZoomAssignedGroupsQuery, ZoomAssignedGroupsQueryVariables>(ZoomAssignedGroupsDocument, baseOptions);
      }
export function useZoomAssignedGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomAssignedGroupsQuery, ZoomAssignedGroupsQueryVariables>) {
          return Apollo.useLazyQuery<ZoomAssignedGroupsQuery, ZoomAssignedGroupsQueryVariables>(ZoomAssignedGroupsDocument, baseOptions);
        }
export type ZoomAssignedGroupsQueryHookResult = ReturnType<typeof useZoomAssignedGroupsQuery>;
export type ZoomAssignedGroupsLazyQueryHookResult = ReturnType<typeof useZoomAssignedGroupsLazyQuery>;
export type ZoomAssignedGroupsQueryResult = Apollo.QueryResult<ZoomAssignedGroupsQuery, ZoomAssignedGroupsQueryVariables>;
export const ZoomUnassignedGroupsDocument = gql`
    query ZoomUnassignedGroups($query: String, $first: Int = 50) {
  allGroups(hasZoomAccount: false, query: $query, first: $first) {
    edges {
      node {
        id
        name
        startDate
      }
    }
  }
}
    `;

/**
 * __useZoomUnassignedGroupsQuery__
 *
 * To run a query within a React component, call `useZoomUnassignedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomUnassignedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomUnassignedGroupsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useZoomUnassignedGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ZoomUnassignedGroupsQuery, ZoomUnassignedGroupsQueryVariables>) {
        return Apollo.useQuery<ZoomUnassignedGroupsQuery, ZoomUnassignedGroupsQueryVariables>(ZoomUnassignedGroupsDocument, baseOptions);
      }
export function useZoomUnassignedGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomUnassignedGroupsQuery, ZoomUnassignedGroupsQueryVariables>) {
          return Apollo.useLazyQuery<ZoomUnassignedGroupsQuery, ZoomUnassignedGroupsQueryVariables>(ZoomUnassignedGroupsDocument, baseOptions);
        }
export type ZoomUnassignedGroupsQueryHookResult = ReturnType<typeof useZoomUnassignedGroupsQuery>;
export type ZoomUnassignedGroupsLazyQueryHookResult = ReturnType<typeof useZoomUnassignedGroupsLazyQuery>;
export type ZoomUnassignedGroupsQueryResult = Apollo.QueryResult<ZoomUnassignedGroupsQuery, ZoomUnassignedGroupsQueryVariables>;
export const AllGroupZoomSchedulesDocument = gql`
    query AllGroupZoomSchedules($first: Int = 500) {
  allGroupZoomSchedules(first: $first) {
    edges {
      node {
        ...GroupZoomScheduleFields
      }
    }
  }
}
    ${GroupZoomScheduleFieldsFragmentDoc}`;

/**
 * __useAllGroupZoomSchedulesQuery__
 *
 * To run a query within a React component, call `useAllGroupZoomSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGroupZoomSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGroupZoomSchedulesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllGroupZoomSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<AllGroupZoomSchedulesQuery, AllGroupZoomSchedulesQueryVariables>) {
        return Apollo.useQuery<AllGroupZoomSchedulesQuery, AllGroupZoomSchedulesQueryVariables>(AllGroupZoomSchedulesDocument, baseOptions);
      }
export function useAllGroupZoomSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGroupZoomSchedulesQuery, AllGroupZoomSchedulesQueryVariables>) {
          return Apollo.useLazyQuery<AllGroupZoomSchedulesQuery, AllGroupZoomSchedulesQueryVariables>(AllGroupZoomSchedulesDocument, baseOptions);
        }
export type AllGroupZoomSchedulesQueryHookResult = ReturnType<typeof useAllGroupZoomSchedulesQuery>;
export type AllGroupZoomSchedulesLazyQueryHookResult = ReturnType<typeof useAllGroupZoomSchedulesLazyQuery>;
export type AllGroupZoomSchedulesQueryResult = Apollo.QueryResult<AllGroupZoomSchedulesQuery, AllGroupZoomSchedulesQueryVariables>;
export const AllZoomProcessingLogDocument = gql`
    query AllZoomProcessingLog($lessonId: ID, $level: String, $step: String, $first: Int = 200) {
  allZoomProcessingLog(
    lessonId: $lessonId
    level: $level
    step: $step
    first: $first
  ) {
    totalCount
    edges {
      node {
        ...ZoomProcessingLogFields
      }
    }
  }
}
    ${ZoomProcessingLogFieldsFragmentDoc}`;

/**
 * __useAllZoomProcessingLogQuery__
 *
 * To run a query within a React component, call `useAllZoomProcessingLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllZoomProcessingLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllZoomProcessingLogQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      level: // value for 'level'
 *      step: // value for 'step'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllZoomProcessingLogQuery(baseOptions?: Apollo.QueryHookOptions<AllZoomProcessingLogQuery, AllZoomProcessingLogQueryVariables>) {
        return Apollo.useQuery<AllZoomProcessingLogQuery, AllZoomProcessingLogQueryVariables>(AllZoomProcessingLogDocument, baseOptions);
      }
export function useAllZoomProcessingLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllZoomProcessingLogQuery, AllZoomProcessingLogQueryVariables>) {
          return Apollo.useLazyQuery<AllZoomProcessingLogQuery, AllZoomProcessingLogQueryVariables>(AllZoomProcessingLogDocument, baseOptions);
        }
export type AllZoomProcessingLogQueryHookResult = ReturnType<typeof useAllZoomProcessingLogQuery>;
export type AllZoomProcessingLogLazyQueryHookResult = ReturnType<typeof useAllZoomProcessingLogLazyQuery>;
export type AllZoomProcessingLogQueryResult = Apollo.QueryResult<AllZoomProcessingLogQuery, AllZoomProcessingLogQueryVariables>;
export const ZoomAuditLogDocument = gql`
    query ZoomAuditLog($action: String, $userId: ID, $targetKind: String, $dateFrom: Date, $dateTo: Date, $first: Int = 50, $after: String) {
  zoomAuditLog(
    action: $action
    userId: $userId
    targetKind: $targetKind
    dateFrom: $dateFrom
    dateTo: $dateTo
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...ZoomAuditEntryFields
      }
    }
  }
}
    ${ZoomAuditEntryFieldsFragmentDoc}`;

/**
 * __useZoomAuditLogQuery__
 *
 * To run a query within a React component, call `useZoomAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomAuditLogQuery({
 *   variables: {
 *      action: // value for 'action'
 *      userId: // value for 'userId'
 *      targetKind: // value for 'targetKind'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useZoomAuditLogQuery(baseOptions?: Apollo.QueryHookOptions<ZoomAuditLogQuery, ZoomAuditLogQueryVariables>) {
        return Apollo.useQuery<ZoomAuditLogQuery, ZoomAuditLogQueryVariables>(ZoomAuditLogDocument, baseOptions);
      }
export function useZoomAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomAuditLogQuery, ZoomAuditLogQueryVariables>) {
          return Apollo.useLazyQuery<ZoomAuditLogQuery, ZoomAuditLogQueryVariables>(ZoomAuditLogDocument, baseOptions);
        }
export type ZoomAuditLogQueryHookResult = ReturnType<typeof useZoomAuditLogQuery>;
export type ZoomAuditLogLazyQueryHookResult = ReturnType<typeof useZoomAuditLogLazyQuery>;
export type ZoomAuditLogQueryResult = Apollo.QueryResult<ZoomAuditLogQuery, ZoomAuditLogQueryVariables>;
export const ZoomParticipantsCoverageListDocument = gql`
    query ZoomParticipantsCoverageList($groupId: ID!, $dateFrom: Date, $dateTo: Date) {
  zoomParticipantsCoverage(
    groupId: $groupId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    lessonId
    lessonName
    date
    startsAt
    endsAt
    additional
    status
    rule
    instances {
      id
      uuid
      meetingId
      topic
      startTime
      endTime
      durationMinutes
      participantsCount
      lessonId
      lessonRule
      lessonAmbiguous
      lessonLocked
      participantsStatus
      participantsFetchedAt
      participantsError
    }
    candidateInstances {
      id
      uuid
      meetingId
      topic
      startTime
      endTime
      durationMinutes
      participantsCount
      lessonId
      lessonRule
      lessonAmbiguous
      lessonLocked
      participantsStatus
      participantsFetchedAt
      participantsError
    }
    sessionsCount
    matchedCount
    unmatchedCount
    suggestedCount
    staffCount
    ignoredCount
  }
}
    `;

/**
 * __useZoomParticipantsCoverageListQuery__
 *
 * To run a query within a React component, call `useZoomParticipantsCoverageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomParticipantsCoverageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomParticipantsCoverageListQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useZoomParticipantsCoverageListQuery(baseOptions: Apollo.QueryHookOptions<ZoomParticipantsCoverageListQuery, ZoomParticipantsCoverageListQueryVariables>) {
        return Apollo.useQuery<ZoomParticipantsCoverageListQuery, ZoomParticipantsCoverageListQueryVariables>(ZoomParticipantsCoverageListDocument, baseOptions);
      }
export function useZoomParticipantsCoverageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomParticipantsCoverageListQuery, ZoomParticipantsCoverageListQueryVariables>) {
          return Apollo.useLazyQuery<ZoomParticipantsCoverageListQuery, ZoomParticipantsCoverageListQueryVariables>(ZoomParticipantsCoverageListDocument, baseOptions);
        }
export type ZoomParticipantsCoverageListQueryHookResult = ReturnType<typeof useZoomParticipantsCoverageListQuery>;
export type ZoomParticipantsCoverageListLazyQueryHookResult = ReturnType<typeof useZoomParticipantsCoverageListLazyQuery>;
export type ZoomParticipantsCoverageListQueryResult = Apollo.QueryResult<ZoomParticipantsCoverageListQuery, ZoomParticipantsCoverageListQueryVariables>;
export const ZoomLessonParticipantListDocument = gql`
    query ZoomLessonParticipantList($lessonId: ID!) {
  zoomLessonParticipants(lessonId: $lessonId) {
    id
    instanceId
    name
    email
    joinTime
    leaveTime
    durationSeconds
    status
    failover
    identityKey
    matchStatus
    matchRule
    offRoster
    matchedUserId
    matchedUserName
    matchedStudentId
    matchedByName
    matchedAt
  }
}
    `;

/**
 * __useZoomLessonParticipantListQuery__
 *
 * To run a query within a React component, call `useZoomLessonParticipantListQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomLessonParticipantListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomLessonParticipantListQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useZoomLessonParticipantListQuery(baseOptions: Apollo.QueryHookOptions<ZoomLessonParticipantListQuery, ZoomLessonParticipantListQueryVariables>) {
        return Apollo.useQuery<ZoomLessonParticipantListQuery, ZoomLessonParticipantListQueryVariables>(ZoomLessonParticipantListDocument, baseOptions);
      }
export function useZoomLessonParticipantListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomLessonParticipantListQuery, ZoomLessonParticipantListQueryVariables>) {
          return Apollo.useLazyQuery<ZoomLessonParticipantListQuery, ZoomLessonParticipantListQueryVariables>(ZoomLessonParticipantListDocument, baseOptions);
        }
export type ZoomLessonParticipantListQueryHookResult = ReturnType<typeof useZoomLessonParticipantListQuery>;
export type ZoomLessonParticipantListLazyQueryHookResult = ReturnType<typeof useZoomLessonParticipantListLazyQuery>;
export type ZoomLessonParticipantListQueryResult = Apollo.QueryResult<ZoomLessonParticipantListQuery, ZoomLessonParticipantListQueryVariables>;
export const ZoomLessonRosterListDocument = gql`
    query ZoomLessonRosterList($lessonId: ID!) {
  zoomLessonRoster(lessonId: $lessonId) {
    userId
    studentId
    fullName
  }
}
    `;

/**
 * __useZoomLessonRosterListQuery__
 *
 * To run a query within a React component, call `useZoomLessonRosterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomLessonRosterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomLessonRosterListQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useZoomLessonRosterListQuery(baseOptions: Apollo.QueryHookOptions<ZoomLessonRosterListQuery, ZoomLessonRosterListQueryVariables>) {
        return Apollo.useQuery<ZoomLessonRosterListQuery, ZoomLessonRosterListQueryVariables>(ZoomLessonRosterListDocument, baseOptions);
      }
export function useZoomLessonRosterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomLessonRosterListQuery, ZoomLessonRosterListQueryVariables>) {
          return Apollo.useLazyQuery<ZoomLessonRosterListQuery, ZoomLessonRosterListQueryVariables>(ZoomLessonRosterListDocument, baseOptions);
        }
export type ZoomLessonRosterListQueryHookResult = ReturnType<typeof useZoomLessonRosterListQuery>;
export type ZoomLessonRosterListLazyQueryHookResult = ReturnType<typeof useZoomLessonRosterListLazyQuery>;
export type ZoomLessonRosterListQueryResult = Apollo.QueryResult<ZoomLessonRosterListQuery, ZoomLessonRosterListQueryVariables>;